(function () {
  'use strict';

  angular
  .module('nvc', [
    'ngAnimate',
    'ngCookies',
    'ngTouch',
    'ngSanitize',
    'ngMessages',
    'ngAria',
    'ngResource',
    'ui.router',
    'ui.bootstrap',
    'ui.bootstrap.modal',
    'pascalprecht.translate',
    'tmh.dynamicLocale',
    'LocalStorageModule',
    'localytics.directives',
    'ngImgCrop',
    'ui.select',
    'ui.footable',
    'oitozero.ngSweetAlert',
    'perfect_scrollbar',
    'bc.TelephoneFilter',
    'ui.checkbox',
    'duScroll',
    'cgNotify',
    'ui.utils.masks',
    'angular-ladda',
    'dragAndDrop',
    'chart.js',
    'textAngular',
    'angularUUID2'
  ]);
})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .controller('ViewCommentController', ViewCommentController);

  /** @ngInject */
  function ViewCommentController($filter, comment, review, SessionManager, AssetRoleToUserRole) {
    var vm = this;

    vm.comment = comment;
    vm.users = review.comments.users;
    vm.history = [];
    vm.versions = false;

    vm.commentsTitle = {
      General: $filter('translate')('DISCUSSION.LATERAL_BAR.GENERAL'),
      Argus: $filter('translate')('DISCUSSION.LATERAL_BAR.ARGUS'),
      ValuationReport: $filter('translate')('DISCUSSION.LATERAL_BAR.VALUATION_REPORT'),
      ExecutiveSummary: $filter('translate')('DISCUSSION.LATERAL_BAR.EXECUTIVE_SUMMARY')
    };

    vm.sortReplies = function(item){
      return item.originalCommentTime || item.submittedOn || item.createdOn;
    };

    vm.displayNames = function (name, role) {
      var currentRole = SessionManager.getRoleName();
      var visibilityRules = {
        Admin: ['Administrator', 'Admin', 'Audit', 'AssetManagement', 'AssetAppraisal', 'AssetReview'],
        Audit: ['Administrator', 'Admin', 'Audit', 'AssetManagement', 'AssetAppraisal', 'AssetReview'],
        AssetManagement: ['Administrator', 'Admin', 'Audit', 'AssetManagement', 'AssetReview'],
        AssetManagerReadOnly: ['Administrator', 'Admin', 'Audit', 'AssetManagement', 'AssetReview'],
        AssetAppraisal: ['AssetAppraisal'],
        AssetReview: ['Administrator', 'Admin', 'Audit', 'AssetManagement', 'AssetAppraisal', 'AssetReview']
      };
      return visibilityRules[currentRole].indexOf(AssetRoleToUserRole[role]) !== -1;
    };

    if (comment.history) {
      setHistory(vm.history, comment.history, comment);
    }
    function setHistory(history, amendedComment, amendingComment) {
      var formatComment = angular.copy(amendedComment);
      formatComment.amendingReason = amendingComment.amendingReason;
      formatComment.modifiedDate = amendingComment.createdOn;
      formatComment.byUserId = amendingComment.userId;
      history.push(formatComment);
      if (amendedComment.history) {
        setHistory(history, amendedComment.history, amendedComment);
      }
    }

    if (comment.replies) {
      for (var i = 0; i < comment.replies.length; i++) {
        if (comment.replies[i].history) {
          vm.versions = true;
          comment.replies[i].repliesHistory = [];
          setReplyHistory(comment.replies[i].history, comment.replies[i]);
        }
      }
    }
    function setReplyHistory(amendedReply, amendingReply, baseReply) {
      var formatReply = angular.copy(amendedReply);
      formatReply.amendingReason = amendingReply.amendingReason;
      formatReply.modifiedDate = amendingReply.createdOn;
      if (baseReply) {
        if (!baseReply.repliesHistory) {
          baseReply.repliesHistory = [];
        }
        baseReply.repliesHistory.push(formatReply);
      } else {
        amendingReply.repliesHistory.push(formatReply);
      }
      if (amendedReply.history) {
        if(baseReply) {
          setReplyHistory(amendedReply.history, amendedReply, baseReply);
        } else {
          setReplyHistory(amendedReply.history, amendedReply, amendingReply);
        }
      }
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .controller('ReplyCommentController', ReplyCommentController);

  /** @ngInject */
  function ReplyCommentController ($state, $scope, $filter, comment, LoaderHelper, ReviewFactory, review,
                                   SessionManager, AssetRoleToUserRole) {
    var vm = this;

    vm.comment = comment;
    vm.users = review.comments.users;
    vm.reply = {};
    vm.validComment = false;
    vm.touchedComment = false;

    vm.commentsTitle = {
      General: $filter('translate')('DISCUSSION.LATERAL_BAR.GENERAL'),
      Argus: $filter('translate')('DISCUSSION.LATERAL_BAR.ARGUS'),
      ValuationReport: $filter('translate')('DISCUSSION.LATERAL_BAR.VALUATION_REPORT'),
      ExecutiveSummary: $filter('translate')('DISCUSSION.LATERAL_BAR.EXECUTIVE_SUMMARY')
    };

    vm.sortReplies = function(item){
      return item.originalCommentTime || item.submittedOn || item.createdOn;
    };

    vm.displayNames = function (name, role) {
      var currentRole = SessionManager.getRoleName();
      var visibilityRules = {
        Admin: ['Administrator', 'Admin', 'Audit', 'AssetManagement', 'AssetAppraisal', 'AssetReview'],
        Audit: ['Administrator', 'Admin', 'Audit', 'AssetManagement', 'AssetAppraisal', 'AssetReview'],
        AssetManagement: ['Administrator', 'Admin', 'Audit', 'AssetManagement', 'AssetReview'],
        AssetManagerReadOnly: ['Administrator', 'Admin', 'Audit', 'AssetManagement', 'AssetReview'],
        AssetAppraisal: ['AssetAppraisal'],
        AssetReview: ['Administrator', 'Admin', 'Audit', 'AssetManagement', 'AssetAppraisal', 'AssetReview']
      };
      return visibilityRules[currentRole].indexOf(AssetRoleToUserRole[role]) !== -1;
    };

    vm.replyComment = function(comment, reply) {
      LoaderHelper.open(true);
      reply.userCompanyId = SessionManager.getCompanyId();
      ReviewFactory.addReplyToComment(review, comment, reply).then(function(updatedReview){
        review = updatedReview;
        $state.go('app.review.discussion.comments', {}, {reload: true})
      }, function(){
        $state.go('app.review.discussion.comments', {}, {reload: true});
      });
    };

    var commentWatch = $scope.$watch('replyCommentCtrl.reply.body', function () {
      if (vm.reply.body) {
        vm.touchedComment = true;
        var newComment = angular.copy(vm.reply.body);
        var match = newComment.search(/(<([^>]+)>)/);
        while (match != -1) {
          newComment = newComment.replace(/(<([^>]+)>)/, '');
          match = newComment.search(/(<([^>]+)>)/);
        }

        newComment.length > 3000 ? vm.validComment = false : vm.validComment = true;
      } else {
        vm.validComment = false;
      }
    });

    $scope.$on('$destroy', function () {
      commentWatch();
    });

  }

})();

(function () {
  'use strict';

  angular
  .module('nvc')
  .controller('EditCommentController', EditCommentController);

  /** @ngInject */
  function EditCommentController($scope, $filter, $state, notify, SweetAlert, LoaderHelper, ReviewFactory, RoleFactory,
                                 SessionManager, comment, review) {
    var vm = this;

    vm.validComment = false;
    vm.touchedComment = false;

    vm.comment = angular.copy(comment);
    vm.users = review.comments.users;

    vm.currentUserId = SessionManager.getUser().id;
    vm.currentRole = RoleFactory.companyTypeToRole(SessionManager.getRoleName());

    vm.commentsTitle = {
      General: $filter('translate')('DISCUSSION.LATERAL_BAR.GENERAL'),
      Argus: $filter('translate')('DISCUSSION.LATERAL_BAR.ARGUS'),
      ValuationReport: $filter('translate')('DISCUSSION.LATERAL_BAR.VALUATION_REPORT'),
      ExecutiveSummary: $filter('translate')('DISCUSSION.LATERAL_BAR.EXECUTIVE_SUMMARY')
    };

    vm.needReason = !!vm.comment.replies || (vm.comment.status != 'Draft' &&
    (vm.comment.originalUserId != vm.currentUserId &&
    (!vm.comment.originalUserId && vm.comment.userId != vm.currentUserId) &&
    vm.comment.originalUserRole != vm.currentRole &&
    (!vm.comment.originalUserRole && vm.comment.userRole != vm.currentRole)));

    vm.editComment = function (comment, reason) {
      if (comment.status != 'Draft') {
        LoaderHelper.open(true);
        comment.userCompanyId = SessionManager.getCompanyId();
        ReviewFactory.updateComment(review, comment, reason).then(function (updatedReview) {
          review = updatedReview;
          notify({
            message: $filter('translate')('COMMENT_STATES.EDIT_COMMENT.EDITED'),
            duration: 4000,
            templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
            classes: 'alert-info',
            position: 'center'
          });
          $state.go('app.review.discussion.comments', {}, {reload: true});
        }, function(){
          $state.go('app.review.discussion.comments', {}, {reload: true});
        });
      } else {
        LoaderHelper.open(true);
        ReviewFactory.updateDraftComment(review, comment).then(function (updatedReview) {
          review = updatedReview;
          notify({
            message: $filter('translate')('COMMENT_STATES.EDIT_COMMENT.EDITED'),
            duration: 4000,
            templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
            classes: 'alert-info',
            position: 'center'
          });
          $state.go('app.review.discussion.comments', {}, {reload: true});
        }, function () {
          $state.go('app.review.discussion.comments', {}, {reload: true});
        });
      }
    };

    vm.deleteComment = function (comment) {
      SweetAlert.swal({
        title: $filter('translate')('COMMONS.LEAVE_PAGE_MODAL_TITLE'),
        text: $filter('translate')('COMMENT_STATES.EDIT_COMMENT.DELETE_COMMENT_TEXT'),
        showCancelButton: true,
        cancelButtonText: $filter('translate')('COMMENT_STATES.EDIT_COMMENT.YES_DELETE'),
        confirmButtonColor: '#2c3d4e',
        confirmButtonText: $filter('translate')('COMMONS.LEAVE_PAGE_CANCEL_BUTTON'),
        closeOnConfirm: true,
        closeOnCancel: false
      },
      function (isConfirm) {
        if (!isConfirm) {
          SweetAlert.swal({
            html: true,
            templateUrl: 'app/states/valuations/review/discussion/comment-states/delete-comment-reason-popup.html',
            title: $filter('translate')('COMMENT_STATES.DELETE_REASON'),
            type: 'input',
            confirmButtonColor: '#2c3d4e',
            confirmButtonText: $filter('translate')('COMMENT_STATES.EDIT_COMMENT.DELETE'),
            showCancelButton: false,
            closeOnConfirm: false,
            inputPlaceholder: ''
          },
          function (inputValue) {
            if (false === inputValue) {
              return false;
            }
            if ('' === inputValue) {
              swal.showInputError($filter('translate')('COMMENT_STATES.REASON_IS_MANDATORY'));
              return false;
            }
            LoaderHelper.open(true);
            ReviewFactory.removeComment(review, comment, inputValue).then(function (updatedReview) {
              review = updatedReview;
              swal.close();
              notify({
                message: $filter('translate')('COMMENT_STATES.DELETED'),
                duration: 4000,
                templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
                classes: 'alert-info',
                position: 'center'
              });
              $state.go('app.review.discussion.comments', {}, {reload: true});
            }, function () {
              $state.go('app.review.discussion.comments', {}, {reload: true});
            });
          });
        }
      }
      );
    };

    vm.deleteDraftComment = function (comment) {
      SweetAlert.swal({
        title: $filter('translate')('COMMONS.LEAVE_PAGE_MODAL_TITLE'),
        text: $filter('translate')('COMMENT_STATES.EDIT_COMMENT.DELETE_COMMENT_TEXT'),
        showCancelButton: true,
        cancelButtonText: $filter('translate')('COMMENT_STATES.EDIT_COMMENT.YES_DELETE'),
        confirmButtonColor: '#2c3d4e',
        confirmButtonText: $filter('translate')('COMMONS.LEAVE_PAGE_CANCEL_BUTTON'),
        closeOnConfirm: true,
        closeOnCancel: false
      },
      function (isConfirm) {
        if (!isConfirm) {
          LoaderHelper.open(true);
          ReviewFactory.removeComment(review, comment).then(function (updatedReview) {
            review = updatedReview;
            swal.close();
            notify({
              message: $filter('translate')('COMMENT_STATES.DELETED'),
              duration: 4000,
              templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
              classes: 'alert-info',
              position: 'center'
            });
            $state.go('app.review.discussion.comments', {}, {reload: true});
          }, function(){
            $state.go('app.review.discussion.comments', {}, {reload: true});
          });
        }
      }
      );
    };

    var commentWatch = $scope.$watch('editCommentCtrl.comment.body', function () {
      if (vm.comment.body) {
        vm.touchedComment = true;
        var newComment = angular.copy(vm.comment.body);
        var match = newComment.search(/(<([^>]+)>)/);
        while (match != -1) {
          newComment = newComment.replace(/(<([^>]+)>)/, '');
          match = newComment.search(/(<([^>]+)>)/);
        }

        newComment.length > 3000 ? vm.validComment = false : vm.validComment = true;
      } else {
        vm.validComment = false;
      }
    });

    $scope.$on('$destroy', function () {
      commentWatch();
    });
  }
})();

(function () {
  'use strict';

  angular
  .module('nvc')
  .controller('AddCommentController', AddCommentController);

  /** @ngInject */
  function AddCommentController($scope, $state, $filter, notify, LoaderHelper, ReviewFactory, review, SessionManager) {
    var vm = this;

    vm.comment = {};
    vm.comment.type = $scope.$parent.commentsCtrl.filter || 'General';
    vm.validComment = false;
    vm.touchedComment = false;

    vm.createComment = function (comment) {
      comment.userCompanyId = SessionManager.getCompanyId();
      LoaderHelper.open();
      ReviewFactory.addComment(review, comment).then(function (updatedReview) {
        review = updatedReview;
        notify({
          message: $filter('translate')('COMMENT_STATES.NEW_COMMENT.ADDED'),
          duration: 4000,
          templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
          classes: 'alert-info',
          position: 'center'
        });
        $state.go('app.review.discussion.comments', {}, {reload: true});
      }, function () {
        $state.go($state.current, {}, {reload: true});
      });
    };

    var commentWatch = $scope.$watch('addCommentCtrl.comment.body', function () {
      if (vm.comment.body) {
        vm.touchedComment = true;
        var newComment = angular.copy(vm.comment.body);
        var match = newComment.search(/(<([^>]+)>)/);
        while (match != -1) {
          newComment = newComment.replace(/(<([^>]+)>)/, '');
          match = newComment.search(/(<([^>]+)>)/);
        }

        newComment.length > 3000 ? vm.validComment = false : vm.validComment = true;
      } else {
        vm.validComment = false;
      }
    });

    $scope.$on('$destroy', function () {
      commentWatch();
    });

  }

})();

(function () {
  'use strict';

  angular
  .module('nvc')
  .controller('AllCommentsController', AllCommentsController);

  /** @ngInject */
  function AllCommentsController($scope, $state, $filter, $timeout, notify, LoaderHelper, SweetAlert, ReviewFactory,
                                 SessionManager, AssetRoleToUserRole, CommentsNotificationService, RoleFactory, review, ValuationService) {
    var vm = this;
    vm.review = review;
    vm.repliesInDraft = false;
    vm.currentUserId = SessionManager.getUser().id;
    vm.currentRole = RoleFactory.companyTypeToRole(SessionManager.getRoleName());

    vm.commentsTitle = {
      '': $filter('translate')('DISCUSSION.LATERAL_BAR.ALL_COMMENTS'),
      General: $filter('translate')('DISCUSSION.LATERAL_BAR.GENERAL'),
      Argus: $filter('translate')('DISCUSSION.LATERAL_BAR.ARGUS'),
      ValuationReport: $filter('translate')('DISCUSSION.LATERAL_BAR.VALUATION_REPORT'),
      ExecutiveSummary: $filter('translate')('DISCUSSION.LATERAL_BAR.EXECUTIVE_SUMMARY')
    };

    vm.rwCanApprove = review.statusChangedFrom == 'ReviewerApproveValuation';

    findDraftReplies();
    findDraftComments();
    findReviewComments();
    findReviewReplies();
    validateRwApprove();

    vm.sortReplies = function (item) {
      return item.originalCommentTime || item.submittedOn || item.createdOn;
    };

    vm.displayNames = function (name, role) {
      var currentRole = SessionManager.getRoleName();
      var visibilityRules = {
        Admin: ['Administrator', 'Admin', 'Audit', 'AssetManagement', 'AssetAppraisal', 'AssetReview'],
        Audit: ['Administrator', 'Admin', 'Audit', 'AssetManagement', 'AssetAppraisal', 'AssetReview'],
        AssetManagement: ['Administrator', 'Admin', 'Audit', 'AssetManagement', 'AssetReview'],
        AssetManagerReadOnly: ['Administrator', 'Admin', 'Audit', 'AssetManagement', 'AssetReview'],
        AssetAppraisal: ['AssetAppraisal'],
        AssetReview: ['Administrator', 'Admin', 'Audit', 'AssetManagement', 'AssetAppraisal', 'AssetReview']
      };
      return visibilityRules[currentRole] ? visibilityRules[currentRole].indexOf(AssetRoleToUserRole[role]) !== -1 : false;
    };

    vm.reviewerSubmitToManager = function () {
      if (review.transition('RW_Comment')) {
        LoaderHelper.open(true);
        ReviewFactory.reviewComments(review).then(function (updatedReview) {
          review = updatedReview;
          $state.go($state.current, {}, {reload: true});
        }, function (response) {
          if (response.reviewNotificationError) {
            ReviewFactory.invalidTransitionNotification();
          }
          $state.go($state.current, {}, {reload: true});
        });
      }
    };

    vm.reviewerSubmitToAppraiser = function (enforce) {
      if (review.transition('RW_SubmitToAppraiser')) {
        LoaderHelper.open(true);
        ReviewFactory.submitComments(review).then(function (updatedReview) {
          review = updatedReview;
          $state.go($state.current, {}, {reload: true});
        }, function (response) {
          if (response.reviewNotificationError) {
            ReviewFactory.invalidTransitionNotification();
          } else if (enforce && response === 'no comments to update') {
            return ReviewFactory.saveReview(review).then(function (updatedReview) {
              review = updatedReview;
              $state.go($state.current, {}, {reload: true});
            }, function (response) {
              if (response.reviewNotificationError) {
                ReviewFactory.invalidTransitionNotification();
              }
              $state.go($state.current, {}, {reload: true});
            });
          }
          $state.go($state.current, {}, {reload: true});
        });
      }
    };

    vm.reviewerReSubmitToAppraiser = function () {
      if (review.transition('RW_SubmitToAppraiser')) {
        LoaderHelper.open(true);
        ReviewFactory.saveReview(review).then(function (updatedReview) {
          review = updatedReview;
          $state.go($state.current, {}, {reload: true});
        }, function (response) {
          if (response.reviewNotificationError) {
            ReviewFactory.invalidTransitionNotification();
          }
          $state.go($state.current, {}, {reload: true});
        });
      }
    };

    vm.reviewerRetract = function () {
      SweetAlert.swal({
        title: $filter('translate')('COMMENT_STATES.RETRACT.TITLE'),
        text: $filter('translate')('COMMENT_STATES.RETRACT.TEXT'),
        showCancelButton: true,
        cancelButtonText: $filter('translate')('COMMENT_STATES.RETRACT.YES_RETRACT'),
        confirmButtonColor: '#2c3d4e',
        confirmButtonText: $filter('translate')('COMMENT_STATES.RETRACT.NO_TAKE_BACK'),
        closeOnConfirm: true,
        closeOnCancel: true
      },
      function (isConfirm) {
        if (!isConfirm) {
          if (review.transition('RW_Retract')) {
            review.statusChangedWithAction = 'RW_Retract';
            LoaderHelper.open(true);
            ReviewFactory.saveReview(review).then(function (updatedReview) {
              review = updatedReview;
              $state.go($state.current, {}, {reload: true});
            }, function (response) {
              if (response.reviewNotificationError) {
                ReviewFactory.invalidTransitionNotification();
              }
              $state.go($state.current, {}, {reload: true});
            });
          }
        }
      });
    };

    vm.reviewerApprove = function () {
      if (review.transition('RW_Approve')) {
        LoaderHelper.open(true);
        var repliesEdited = false;
        for (var i = 0; i < review.comments.comments.length; i++) {
          if (review.comments.comments[i].replies && review.comments.comments[i].replies.length > 0) {
            if ($filter('filter')(review.comments.comments[i].replies, {status: 'Draft'}).length > 0) {
              repliesEdited = true;
              break;
            }
          }
        }
        if (repliesEdited) {
          ReviewFactory.submitComments(review).then(function (updatedReview) {
            review = updatedReview;
            ReviewFactory.saveReview(review).then(function (updatedReview) {
              review = updatedReview;
              $state.go($state.current, {}, {reload: true});
            }, function (response) {
              if (response.reviewNotificationError) {
                ReviewFactory.invalidTransitionNotification();
              }
              $state.go($state.current, {}, {reload: true});
            });

          });
        } else {
          ReviewFactory.saveReview(review).then(function (updatedReview) {
            review = updatedReview;
            $state.go($state.current, {}, {reload: true});
          }, function (response) {
            if (response.reviewNotificationError) {
              ReviewFactory.invalidTransitionNotification();
            }
            $state.go($state.current, {}, {reload: true});
          });
        }
      }
    };

    vm.leadReviewerSignOff = function () {
      if (review.transition('LRW_Approve')) {
        LoaderHelper.open(true);
        ReviewFactory.saveReview(review).then(function (updatedReview) {
          review = updatedReview;
          if (review.comments.comments.length === 0) {
            vm.updateDocumentAsFinal();
          } else {
            $state.go($state.current, {}, {reload: true});  
          }
        }, function (response) {
          if (response.reviewNotificationError) {
            ReviewFactory.invalidTransitionNotification();
          }
          $state.go($state.current, {}, {reload: true});
        });
      }
    };

    vm.updateDocumentAsFinal = function () {
      if(review.transition('AP_UploadFinalDocuments')) {
        var document = review.documents.assetDocuments.find(function (doc) {
          return doc.version == '1' && doc.userRole.toLowerCase() == 'appraiser';
        })
        // LoaderHelper.open(true);
        ReviewFactory.saveReview(review).then(function (updatedReview) { 
          review = updatedReview
          ValuationService.documentUpdate(document.id, 'Final').then(function () {
            if(review.transition('AP_FillFinalForm')) {
              ReviewFactory.saveReview(review).then(function (updatedReview) {
                review = updatedReview
                $state.go('app.review.documentsHistory', {valuationId: review.id}, {reload: true});
               });
            }
          })
        })
        

      }
     
    }

    vm.leadReviewerSubmitToAppraiser = function () {
      if (review.transition('LRW_Comment')) {
        LoaderHelper.open(true);
        ReviewFactory.submitComments(review).then(function (updatedReview) {
          review = updatedReview;
          $state.go($state.current, {}, {reload: true});
        }, function (response) {
          if (response.reviewNotificationError) {
            ReviewFactory.invalidTransitionNotification();
          }
          $state.go($state.current, {}, {reload: true});
        });
      }
    };

    vm.managerSubmitToReviewer = function () {
      if (review.transition('AM_Comment')) {
        LoaderHelper.open(true);
        ReviewFactory.reviewComments(review).then(function (updatedReview) {
          review = updatedReview;
          $state.go($state.current, {}, {reload: true});
        }, function (response) {
          if (response.reviewNotificationError) {
            ReviewFactory.invalidTransitionNotification();
          }
          $state.go($state.current, {}, {reload: true});
        });
      }
    };

    vm.managerAcknowledgeToReviewer = function () {
      if (review.transition('AM_Comment')) {
        LoaderHelper.open(true);
        ReviewFactory.saveReview(review).then(function (updatedReview) {
          review = updatedReview;
          $state.go($state.current, {}, {reload: true});
        }, function (response) {
          if (response.reviewNotificationError) {
            ReviewFactory.invalidTransitionNotification();
          }
          $state.go($state.current, {}, {reload: true});
        });
      }
    };

    vm.managerApprove = function () {
      if (review.transition('AM_Approve')) {
        LoaderHelper.open(true);
        ReviewFactory.saveReview(review).then(function (updatedReview) {
          review = updatedReview;
          $state.go($state.current, {}, {reload: true});
        }, function (response) {
          if (response.reviewNotificationError) {
            ReviewFactory.invalidTransitionNotification();
          }
          $state.go($state.current, {}, {reload: true});
        });
      }
    };

    vm.appraiserSubmitToReviewer = function () {
      var $doc = angular.element(document);
      SweetAlert.swal({
        title: $filter('translate')('COMMENT_STATES.UPDATE_DOCUMENTS'),
        text: $filter('translate')('COMMENT_STATES.BEFORE_MOVING'),
        showCancelButton: true,
        cancelButtonText: $filter('translate')('COMMENT_STATES.NO_SEND_TO_REVIEWER'),
        confirmButtonColor: '#2c3d4e',
        confirmButtonText: $filter('translate')('COMMENT_STATES.YES_UPDATE'),
        closeOnConfirm: true,
        closeOnCancel: true,
        allowEscapeKey: false
      },
      function (isConfirm) {
        if (review.transition('AP_Reply')) {
          LoaderHelper.open(true);
          ReviewFactory.saveReview(review).then(function (updatedReview) {
            review = updatedReview;
            if (!isConfirm) {
              if (review.transition('AP_Submit')) {
                ReviewFactory.submitComments(review).then(function (updatedReview) {
                  review = updatedReview;
                  $state.go($state.current, {}, {reload: true});
                }, function () {
                  $state.go($state.current, {}, {reload: true});
                });
              }
            } else {
              $state.go('app.review.documentsUpload', {}, {reload: true});
            }
          }, function () {
            if ('SubmitedToAppraiser' != review.status) {
              ReviewFactory.loadReview(review.assetId, review.id).then(function (updatedReview) {
                review = updatedReview;
                findDraftReplies();
                if (vm.repliesInDraft) {
                  for (var i = 0; i < review.comments.comments.length; i++) {
                    for (var j = 0; j < review.comments.comments[i].replies.length; j++) {
                      var reply = review.comments.comments[i].replies[j];
                      if ('Draft' === reply.status) {
                        ReviewFactory.removeComment(review, reply).then(function (updatedReview) {
                          review = updatedReview;
                          findDraftReplies();
                        });
                      }
                    }
                  }
                  $state.go($state.current, {}, {reload: true});
                }
                if ('RW_Retract' == review.statusChangedWithAction) {
                  SweetAlert.swal({
                    title: $filter('translate')('COMMENT_STATES.SORRY'),
                    text: $filter('translate')('COMMENT_STATES.RETRACT_BODY'),
                    confirmButtonColor: '#2c3d4e',
                    confirmButtonText: $filter('translate')('COMMENT_STATES.OK'),
                    closeOnConfirm: true
                  },
                  function (isConfirm) {
                    if (isConfirm) {
                      $state.go($state.current, {}, {reload: true});
                    }
                  });
                } else {
                  SweetAlert.swal({
                    title: $filter('translate')('COMMENT_STATES.SORRY'),
                    text: $filter('translate')('COMMENT_STATES.INVALID_TRANSITION'),
                    confirmButtonColor: '#2c3d4e',
                    confirmButtonText: $filter('translate')('COMMENT_STATES.OK'),
                    closeOnConfirm: true
                  },
                  function (isConfirm) {
                    if (isConfirm) {
                      $state.go($state.current, {}, {reload: true});
                    }
                  });
                }
              });
            }
          });
        }
        $doc.off('keydown');
      });

      $doc.on('keydown', function (event) {
        if (event.keyCode == 27) {
          SweetAlert.close();
          $doc.off('keydown');
        }
      });
    };

    vm.appraiserReSubmitToReviewer = function () {
      var $doc = angular.element(document);
      SweetAlert.swal({
        title: $filter('translate')('COMMENT_STATES.UPDATE_DOCUMENTS'),
        text: $filter('translate')('COMMENT_STATES.BEFORE_MOVING'),
        showCancelButton: true,
        cancelButtonText: $filter('translate')('COMMENT_STATES.NO_SEND_TO_REVIEWER'),
        confirmButtonColor: '#2c3d4e',
        confirmButtonText: $filter('translate')('COMMENT_STATES.YES_UPDATE'),
        closeOnConfirm: true,
        closeOnCancel: true,
        allowEscapeKey: false
      },
      function (isConfirm) {
        LoaderHelper.open(true);
        if (!isConfirm) {
          if (review.transition('AP_Submit')) {
            var request;
            if (!vm.repliesInDraft) {
              request = ReviewFactory.saveReview(review);
            } else {
              request = ReviewFactory.submitComments(review);
            }
            request.then(function (updatedReview) {
              review = updatedReview;
              $state.go($state.current, {}, {reload: true});
            }, function () {
              if ('SubmitedToAppraiser' != review.status) {
                ReviewFactory.loadReview(review.assetId, review.id).then(function (updatedReview) {
                  review = updatedReview;
                  findDraftReplies();
                  if (vm.repliesInDraft) {
                    for (var i = 0; i < review.comments.comments.length; i++) {
                      for (var j = 0; j < review.comments.comments[i].replies.length; j++) {
                        var reply = review.comments.comments[i].replies[j];
                        if ('Draft' === reply.status) {
                          ReviewFactory.removeComment(review, reply).then(function (updatedReview) {
                            review = updatedReview;
                            findDraftReplies();
                          });
                        }
                      }
                    }
                    $state.go($state.current, {}, {reload: true});
                  }
                  if ('RW_Retract' == review.statusChangedWithAction) {
                    SweetAlert.swal({
                      title: $filter('translate')('COMMENT_STATES.SORRY'),
                      text: $filter('translate')('COMMENT_STATES.RETRACT_BODY'),
                      confirmButtonColor: '#2c3d4e',
                      confirmButtonText: $filter('translate')('COMMENT_STATES.OK'),
                      closeOnConfirm: true
                    },
                    function (isConfirm) {
                      if (isConfirm) {
                        $state.go($state.current, {}, {reload: true});
                      }
                    });
                  } else {
                    SweetAlert.swal({
                      title: $filter('translate')('COMMENT_STATES.SORRY'),
                      text: $filter('translate')('COMMENT_STATES.INVALID_TRANSITION'),
                      confirmButtonColor: '#2c3d4e',
                      confirmButtonText: $filter('translate')('COMMENT_STATES.OK'),
                      closeOnConfirm: true
                    },
                    function (isConfirm) {
                      if (isConfirm) {
                        $state.go($state.current, {}, {reload: true});
                      }
                    });
                  }
                });
              }
            });
          }
        } else {
          $state.go('app.review.documentsUpload', {}, {reload: true});
        }
        $doc.off('keydown');
      });

      $doc.on('keydown', function (event) {
        if (event.keyCode == 27) {
          SweetAlert.close();
          $doc.off('keydown');
        }
      });
    };

    vm.editComment = function (event, comment) {
      event.stopPropagation();
      $state.go('app.review.discussion.editComment', {commentId: comment.id, comment: comment});
    };

    vm.deleteComment = function (event, comment) {
      event.stopPropagation();
      SweetAlert.swal({
        title: $filter('translate')('COMMONS.LEAVE_PAGE_MODAL_TITLE'),
        text: $filter('translate')('COMMENT_STATES.EDIT_COMMENT.DELETE_COMMENT_TEXT'),
        showCancelButton: true,
        cancelButtonText: $filter('translate')('COMMENT_STATES.EDIT_COMMENT.YES_DELETE'),
        confirmButtonColor: '#2c3d4e',
        confirmButtonText: $filter('translate')('COMMONS.LEAVE_PAGE_CANCEL_BUTTON'),
        closeOnConfirm: true,
        closeOnCancel: false
      },
      function (isConfirm) {
        if (!isConfirm) {
          SweetAlert.swal({
            html: true,
            templateUrl: 'app/states/valuations/review/discussion/comment-states/delete-comment-reason-popup.html',
            title: $filter('translate')('COMMENT_STATES.DELETE_REASON'),
            type: 'input',
            confirmButtonColor: '#2c3d4e',
            confirmButtonText: $filter('translate')('COMMENT_STATES.EDIT_COMMENT.DELETE'),
            showCancelButton: true,
            cancelButtonText: $filter('translate')('COMMONS.CANCEL'),
            closeOnConfirm: false,
            closeOnCancel: true,
            inputPlaceholder: ''
          },
          function (inputValue) {
            if (false === inputValue) {
              return false;
            }
            if ('' === inputValue) {
              swal.showInputError($filter('translate')('COMMENT_STATES.REASON_IS_MANDATORY'));
              return false;
            }
            LoaderHelper.open(true);
            ReviewFactory.removeComment(review, comment, inputValue).then(function (updatedReview) {
              review = updatedReview;
              findDraftReplies();
              findDraftComments();
              findReviewComments();
              findReviewReplies();
              validateRwApprove();
              swal.close();
              LoaderHelper.close();
              notify({
                message: $filter('translate')('COMMENT_STATES.DELETED'),
                duration: 4000,
                templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
                classes: 'alert-info',
                position: 'center'
              });
            }, function () {
              $state.go($state.current, {}, {reload: true});
            });
          });
        }
      });
    };

    vm.deleteDraftComment = function (event, comment) {
      event.stopPropagation();
      SweetAlert.swal({
        title: $filter('translate')('COMMONS.LEAVE_PAGE_MODAL_TITLE'),
        text: $filter('translate')('COMMENT_STATES.EDIT_COMMENT.DELETE_COMMENT_TEXT'),
        showCancelButton: true,
        cancelButtonText: $filter('translate')('COMMENT_STATES.EDIT_COMMENT.YES_DELETE'),
        confirmButtonColor: '#2c3d4e',
        confirmButtonText: $filter('translate')('COMMONS.LEAVE_PAGE_CANCEL_BUTTON'),
        closeOnConfirm: true,
        closeOnCancel: false
      },
      function (isConfirm) {
        if (!isConfirm) {
          LoaderHelper.open(true);
          ReviewFactory.removeComment(review, comment).then(function (updatedReview) {
            review = updatedReview;
            findDraftReplies();
            findDraftComments();
            findReviewComments();
            findReviewReplies();
            validateRwApprove();
            swal.close();
            LoaderHelper.close();
            notify({
              message: $filter('translate')('COMMENT_STATES.DELETED'),
              duration: 4000,
              templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
              classes: 'alert-info',
              position: 'center'
            });
          }, function () {
            $state.go($state.current, {}, {reload: true});
          });
        }
      }
      );
    };

    vm.reply = function (event, comment) {
      event.stopPropagation();
      $state.go('app.review.discussion.replyComment', {
        commentId: comment.id,
        comment: comment
      }, {reload: true});
    };

    function findDraftReplies() {
      if (SessionManager.isInRole('AssetAppraisal')) {
        var repliedInAllComments = true;
        if (!vm.review.comments.comments.length) {
          repliedInAllComments = false;
        }
        for (var i = 0; i < vm.review.comments.comments.length; i++) {
          if (vm.review.comments.comments[i].replies && vm.review.comments.comments[i].replies.length > 0) {
            var replies = $filter('orderBy')(vm.review.comments.comments[i].replies, '-nms');
            var userId = replies[0].originalUserId ? replies[0].originalUserId : replies[0].userId;
            if (!vm.review.asset.users[userId] || (vm.review.asset.users[userId].type !== 'PrimaryAssetAppraiser'
            && vm.review.asset.users[userId].type !== 'SecondaryAssetAppraiser')) {
              repliedInAllComments = false;
              // break;
            } else {
              repliedInAllComments = true;
            }
          } else {
            repliedInAllComments = false;
            // break;
          }
        }
        vm.repliesInDraft = repliedInAllComments;
      } else {
        var validateReplies = false;
        if (vm.review.comments && vm.review.comments.comments.length > 0) {
          for (var i = 0; i < vm.review.comments.comments.length; i++) {
            if (vm.review.comments.comments[i].replies && vm.review.comments.comments[i].replies.length > 0) {
              validateReplies = true;
              var replies = vm.review.comments.comments[i].replies;
              for (var j = 0; j < replies.length; j++) {
                if (replies[j].status == 'Draft' && !(vm.review.status == 'ValuationUpdated' && replies[j].originalUserRole == 'Appraiser')) {
                  vm.repliesInDraft = true;
                  return;
                }
              }
            } else {
              validateReplies = false;
              break;
            }
          }
          vm.repliesInDraft = false;
        }
      }
    }

    function findDraftComments() {
      vm.commentsInDraft = $filter('filter')(vm.review.comments.comments, {status: 'Draft'}).length > 0;
    }

    function findReviewComments() {
      vm.commentsInReview = $filter('filter')(vm.review.comments.comments, {status: 'Review'}).length > 0;
    }

    function findReviewReplies() {
      if (SessionManager.isInAnyRole(['Admin', 'AssetReview'])) {
        for (var i = 0; i < vm.review.comments.comments.length; i++) {
          if (vm.review.comments.comments[i].replies && vm.review.comments.comments[i].replies.length > 0) {
            if ($filter('filter')(vm.review.comments.comments[i].replies, {status: 'Review'}).length > 0) {
              vm.repliesInReview = true;
              return;
            }
          }
        }
        vm.repliesInReview = false;
      }
    }

    function validateRwApprove() {
      vm.rwCanApprove = !vm.commentsInDraft && !vm.repliesInDraft && !vm.commentsInReview && !vm.repliesInReview;
      if (vm.rwCanApprove) {
        if (review.comments.comments && review.comments.comments.length > 0) {
          for (var i = 0; i < review.comments.comments.length; i++) {
            var comment = review.comments.comments[i];
            if (comment.replies && comment.replies.length > 0) {
              var reply = $filter('orderBy')(comment.replies, vm.sortReplies)[comment.replies.length - 1],
              role = reply.originalUserRole || reply.userRole;
              if (!(role === 'Administrator' || role === 'Appraiser' || role === 'Reviewer')) {
                vm.rwCanApprove = false;
                break;
              }
            } else {
              vm.rwCanApprove = false;
              break;
            }
          }
        }
      }
    }

    CommentsNotificationService.listenOnValuation(review.id);
    $scope.$on('commentAdded', function (event, data) {
      if (data && data.commentsUpdatedOn) {
        $timeout(function () {
          notify({
            message: $filter('translate')('COMMENT_STATES.INFO_UPDATED'),
            duration: 4000,
            templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
            classes: 'alert-info',
            position: 'center'
          });
          $state.go('app.review', undefined, {reload: true});
        }, 1000);
      }
    });

    $scope.$on('$destroy', function () {
      var $doc = angular.element(document);
      $doc.off('keydown');
      SweetAlert.close();
    })
  }

})();

(function () {
  'use strict';

  angular
  .module('nvc')
  .config(routeConfig);

  function routeConfig($stateProvider) {
    $stateProvider.state('app.review.discussion.comments', {
      url: '/comments',
      views: {
        'commentState@app.review.discussion': {
          templateUrl: 'app/states/valuations/review/discussion/comment-states/all-comments/all-comments.html',
          controller: 'AllCommentsController',
          controllerAs: 'allCommentsCtrl'
        }
      },
      data: {
        viewClass: 'discussion'
      }
    })

    .state('app.review.discussion.editComment', {
      url: '/comments/:commentId/edit',
      views: {
        'commentState@app.review.discussion': {
          templateUrl: 'app/states/valuations/review/discussion/comment-states/edit-comment/edit-comment.html',
          controller: 'EditCommentController',
          controllerAs: 'editCommentCtrl'
        }
      },
      data: {
        viewClass: 'discussion',
        roles: ['Admin', 'AssetReview', 'AssetManagement', 'AssetAppraisal', 'AssetManagerReadOnly']
      },
      params: {
        commentId: '',
        comment: null
      },
      resolve: {
        /** @ngInject */
        comment: function ($stateParams, review) {
          if ($stateParams.comment) {
            return $stateParams.comment;
          }
          for (var i = 0; i < review.comments.comments.length; i++) {
            if (review.comments.comments[i].id == $stateParams.commentId) {
              return review.comments.comments[i];
            }
            if(review.comments.comments[i].replies){
              for(var j = 0; j < review.comments.comments[i].replies.length; j++){
                if (review.comments.comments[i].replies[j].id == $stateParams.commentId) {
                  return review.comments.comments[i].replies[j];
                }
              }
            }
          }
        }
      }
    })

    .state('app.review.discussion.newComment', {
      url: '/add-comment',
      views: {
        'commentState@app.review.discussion': {
          templateUrl: 'app/states/valuations/review/discussion/comment-states/create-new-comment/create-new-comment.html',
          controller: 'AddCommentController',
          controllerAs: 'addCommentCtrl'
        }
      },
      data: {
        viewClass: 'discussion',
        roles: ['Admin', 'AssetManagement', 'AssetReview', 'AssetManagerReadOnly']
      }
    })

    .state('app.review.discussion.viewComment', {
      url: '/comments/:commentId/details',
      views: {
        'commentState@app.review.discussion': {
          templateUrl: 'app/states/valuations/review/discussion/comment-states/view-comment/view-comment.html',
          controller: 'ViewCommentController',
          controllerAs: 'viewCommentCtrl'
        }
      },
      data: {
        viewClass: 'discussion'
      },
      params: {
        commentId: '',
        comment: null
      },
      resolve: {
        /** @ngInject */
        comment: function ($stateParams, review) {
          if ($stateParams.comment) {
            return $stateParams.comment;
          }
          for (var i = 0; i < review.comments.comments.length; i++) {
            if (review.comments.comments[i].id == $stateParams.commentId) {
              return review.comments.comments[i];
            }
          }
        }
      }
    })

    .state('app.review.discussion.replyComment', {
      url: 'comments/:commentId/reply',
      views: {
        'commentState@app.review.discussion': {
          templateUrl: 'app/states/valuations/review/discussion/comment-states/reply-comment/reply-comment.html',
          controller: 'ReplyCommentController',
          controllerAs: 'replyCommentCtrl'
        }
      },
      data: {
        viewClass: 'discussion',
        roles: ['Admin', 'AssetAppraisal', 'AssetReview', 'AssetManagement', 'AssetManagerReadOnly']
      },
      params: {
        commentId: '',
        comment: null
      },
      resolve: {
        /** @ngInject */
        comment: function ($stateParams, review) {
          if ($stateParams.comment) {
            return $stateParams.comment;
          }
          for (var i = 0; i < review.comments.comments.length; i++) {
            if (review.comments.comments[i].id == $stateParams.commentId) {
              return review.comments.comments[i];
            }
          }
        }
      }
    });
  }

})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .controller('GeneralErrorModalController', GeneralErrorModalController);

  function GeneralErrorModalController ($scope, $uibModalInstance) {
    $scope.closePopUpGeneralError = function () {
      $uibModalInstance.close();
    };
  }

})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .config(routeConfig);

  function routeConfig($stateProvider) {
    $stateProvider.state('app.review.property', {
      url: '/property',
      views: {
        '': {
          templateUrl: 'app/states/assets/asset-details/asset-details.html',
          controller: 'AssetDetailsController',
          controllerAs: 'assetDetailsCtrl'
        }
      },
      data: {
        pageTitle: 'Asset details',
        viewClass: 'assetDetails'
      },
      params: {
        assetId: '',
        asset: null,
        noPadding: true
      },
      resolve: {
        /** @ngInject */
        assetUsers: function ($state, $stateParams, AssetService, asset) {
          if ($stateParams.assetId) {
            return AssetService.getAssetUsersList($stateParams.assetId).then(function(assetUsers){
              assetUsers.forEach(function(assetUser){
                for (var i = 0; i < assetUser.periods.length; i++){
                  var tempPeriod = assetUser.periods[i];
                  if(tempPeriod.active && tempPeriod.isPrimary && tempPeriod.quarter == asset.valuation.quarter && tempPeriod.year == asset.valuation.year){
                    switch (assetUser.userCompanyType){
                      case 'AssetReview':
                        assetUser.type = 'PrimaryAssetReviewer';
                        break;
                      case 'AssetManagement':
                        assetUser.type = 'PrimaryAssetManager';
                        break;
                    }
                    break;
                  }
                }
              });
              return assetUsers;
            });
          }
          else {
            $state.go('app.review.discussion');
          }
        },
        /** @ngInject */
        asset: function (review) {
          return review.asset;
        },
        subtypesByPropertyTypes: function (StaticDataService) {
          return StaticDataService.getSubtypesByPropertyTypes();
        },
        /** @ngInject */
        ownershipTypes: function (StaticDataService) {
          return StaticDataService.getOwnershipTypes();
        },
        /** @ngInject */
        ncreifs: function (StaticDataService) {
          return StaticDataService.getNcreifs();
        },
        /**@ngInject*/
        documents: function ($stateParams, AssetService) {
          return AssetService.documentList($stateParams.assetId).then(function (documents) {
            var latestDocuments = [],
              indexedDocumentNames = [];
            for (var i = 0; i < documents.assetDocuments.length; i++) {
              var document = documents.assetDocuments[i];
              if (indexedDocumentNames.indexOf(document.fileName) == -1) {
                var latestDocument = document;
                indexedDocumentNames.push(document.fileName);
                for (var j = i; j < documents.assetDocuments.length; j++) {
                  var document2 = documents.assetDocuments[j];
                  if (latestDocument.fileName === document2.fileName) {
                    if (isNaN(latestDocument.version)
                      || (!isNaN(document2.version) && latestDocument.version < document2.version)) {
                      latestDocument = document2
                    }
                  }
                }
                latestDocuments.push(latestDocument)
              }
            }
            return latestDocuments;
          });
        },
        /**@ngInject*/
        propertyTypes: function (StaticDataService) {
          return StaticDataService.getPropertyTypes();
        },
        /**@ngInject*/
        valuationFrequencies: function (StaticDataService) {
          return StaticDataService.getValuationFrequencies();
        }

      }
    })
  }

})();


(function () {
  'use strict';

  angular
  .module('nvc')
  .config(routeConfig);

  function routeConfig($stateProvider) {
    $stateProvider.state('app.review.documentsUpload', {
      url: '/documents-upload',
      views:{
        '':{
          templateUrl: 'app/states/valuations/review/documents-upload/documents-upload.html',
          controller: 'DocumentsUploadController',
          controllerAs: 'documentsUploadCtrl'
        }
      },
      data:{
        viewClass: 'documentsUpload',
        roles:['Admin', 'AssetAppraisal', 'AssetReview']
      },
      params: {
        selectedQuarter: null,
        selectedYear: null,
        selectedValuation: null,
      },
      resolve: {
        /** @ngInject */
        premiseOptions: function (StaticDataService) {
          return StaticDataService.getPremiseOptions();
        }
      }
    })
  }

})();


(function () {
  'use strict';

  angular
    .module('nvc')
    .controller('DocumentsUploadController', DocumentsUploadController);

  /** @ngInject */
  function DocumentsUploadController($state, $filter, SweetAlert, LoaderHelper, ReviewFactory, SessionManager, premiseOptions, review) {
    var vm = this;

    vm.review = review;
    vm.premiseoptions = premiseOptions.items;
    vm.selectedpremiseoptions = [];
    vm.errors = [];
    vm.submittedFiles = false;
    vm.missingpremise = false;
    vm.duplicatepremise = false;
    vm.role = SessionManager.getCompanyId();
    vm.isAdmin = SessionManager.getRoleName().toLowerCase() === 'admin';
    vm.roleName = SessionManager.getRoleName();
    vm.selectedQuarter = $state.params.selectedQuarter ? $state.params.selectedQuarter : review.quarter ;
    vm.selectedYear = $state.params.selectedYear ? $state.params.selectedYear : review.year;
    vm.selectedValuation = $state.params.selectedValuation ? $state.params.selectedValuation : review;

    vm.upload = function () {
      vm.submittedFiles = true;
      var $translate = $filter('translate');
      vm.errors = [];

      // ARGUS model is optional now
      //if ((!vm.argusFile || vm.argusFile.length <= 0) && vm.review.asset.type !== 'Land' && vm.review.asset.type !== 'Hotel' && vm.review.asset.type !== 'Other') {
      //  vm.errors.push($translate('REVIEW.DOCUMENT_ERROR1'));
      //}
      vm.missingpremise = missingPremiseSelection(vm.argusFile, vm.selectedpremiseoptions);
      if (vm.missingpremise) {
        vm.errors.push($translate('REVIEW.DOCUMENT_ERROR1A'));
      }

      vm.duplicatepremise = hasDuplicatePremiseSelection(vm.argusFile, vm.selectedpremiseoptions);
      if (vm.duplicatepremise) {
        vm.errors.push($translate('REVIEW.DOCUMENT_ERROR1C'));
      }
      if ( vm.valuationReportFile.length == 0 && vm.argusFile.length == 0) {
        vm.errors.push($translate('REVIEW.DOCUMENT_ERROR4'));
      }

      if (!vm.errors.length) {
        setUserRole(vm.role);
        if (vm.argusFile && vm.argusFile.length > 0) {
          var argusVersion = null;
          for (var i = 0; i < vm.argusFile.length; i++) {
            var version = vm.selectedValuation.setArgusFile(vm.argusFile[i], 'Draft', getPremise(vm.argusFile[i], vm.selectedpremiseoptions), argusVersion, vm.selectedQuarter, vm.selectedYear, vm.selectedValuation);
            if (!argusVersion) {
              argusVersion = version;
            }
          }
        }

        if(vm.valuationReportFile.length > 0 ){
          vm.selectedValuation.setValuationReport(vm.valuationReportFile[0], 'Draft', vm.selectedQuarter, vm.selectedYear, vm.selectedValuation);
        }

        if (vm.argusExtractFile && vm.argusExtractFile.length == 1) {
          vm.selectedValuation.setArgusExtract(vm.argusExtractFile[0], 'Draft', vm.selectedQuarter, vm.selectedYear, vm.selectedValuation);
        }
        
        if (vm.otherFiles && vm.otherFiles.length != 0) {
          vm.selectedValuation.setOthers(vm.otherFiles, 'Draft', vm.selectedQuarter, vm.selectedYear, vm.selectedValuation);
        }
        LoaderHelper.open();
        // review.transition('AP_UploadDocuments');
        // $state.go('app.review.documents', review, {reload: true});
        $state.go('app.review.documents',{selectedQuarter: vm.selectedQuarter, selectedYear: vm.selectedYear, selectedValuation: vm.selectedValuation}, {reload: false});
      } else {
        showErrors(vm.errors);
      }
    };

    vm.updateDocument = function (status) {
      var newDocuments = false;
      var $translate = $filter('translate');

      vm.errors = [];
      vm.missingpremise = missingPremiseSelection(vm.argusFile, vm.selectedpremiseoptions);
      if (vm.missingpremise) {
        vm.errors.push($translate('REVIEW.DOCUMENT_ERROR1A'));
      }

      vm.duplicatepremise = hasDuplicatePremiseSelection(vm.argusFile, vm.selectedpremiseoptions);
      if (vm.duplicatepremise) {
        vm.errors.push($translate('REVIEW.DOCUMENT_ERROR1C'));
      }

      if ( vm.errors.length > 0 && vm.valuationReportFile.length != 1 || vm.valuationReportFile.length == 0 && vm.argusFile.length == 0) {
        vm.errors.push($translate('REVIEW.DOCUMENT_ERROR4'));
      }

      if (vm.errors && vm.errors.length > 0 ) {
        showErrors(vm.errors);
        return;
      }

      setUserRole(vm.role);
      if (vm.argusFile && vm.argusFile.length > 0) {
          var argusVersion = null;
          for (var i = 0; i < vm.argusFile.length; i++) {
            var version = vm.selectedValuation.setArgusFile(vm.argusFile[i], status, getPremise(vm.argusFile[i], vm.selectedpremiseoptions), argusVersion, vm.selectedQuarter, vm.selectedYear, vm.selectedValuation);
            if (!argusVersion) {
              argusVersion = version;
            }
          }
        newDocuments = true;
      }
      if (vm.valuationReportFile[0]) {
        vm.selectedValuation.setValuationReport(vm.valuationReportFile[0], status, vm.selectedQuarter, vm.selectedYear, vm.selectedValuation);
        newDocuments = true;
      }
      if (vm.argusExtractFile && vm.argusExtractFile.length == 1) {
        vm.selectedValuation.setArgusExtract(vm.argusExtractFile[0], status, vm.selectedQuarter, vm.selectedYear, vm.selectedValuation);
        newDocuments = true;
      }
      if (vm.otherFiles && vm.otherFiles.length != 0) {
        vm.selectedValuation.setOthers(vm.otherFiles, status, vm.selectedQuarter, vm.selectedYear, vm.selectedValuation);
        newDocuments = true;
      }

      if (newDocuments) {
        LoaderHelper.open();
          $state.go('app.review.documents',{selectedQuarter: vm.selectedQuarter, selectedYear: vm.selectedYear, selectedValuation: vm.selectedValuation}, {reload: false});

        // ReviewFactory.saveQuarterDocuments(review, vm.selectedQuarter, vm.selectedYear, vm.selectedValuation.id).then(function (newReview) {
        //   review = newReview;
        //   // review.transition('AP_UploadDocuments');
        //   $state.go('app.review.documents',{selectedQuarter: vm.selectedQuarter, selectedYear: vm.selectedYear, selectedValuation: vm.selectedValuation}, {reload: true});
        // }, function (response) {
        //   if (response.reviewNotificationError) {
        //     ReviewFactory.invalidTransitionNotification();
        //   }
        //   $state.go('app.review', $state.params, {reload: true});
        // });
      } else {
        $state.go('app.review.discussion.comments');
      }
    };
    
    vm.amendUpdate = function (status) {
      var newDocuments = false;

      var $translate = $filter('translate');

      vm.errors = [];
      vm.missingpremise = missingPremiseSelection(vm.argusFile, vm.selectedpremiseoptions);
      if (vm.missingpremise) {
        vm.errors.push($translate('REVIEW.DOCUMENT_ERROR1A'));
      }

      vm.duplicatepremise = hasDuplicatePremiseSelection(vm.argusFile, vm.selectedpremiseoptions);
      if (vm.duplicatepremise) {
        vm.errors.push($translate('REVIEW.DOCUMENT_ERROR1C'));
      }

      if ( vm.errors.length > 0 && vm.valuationReportFile.length != 1 || vm.valuationReportFile.length == 0 && vm.argusFile.length == 0) {
        vm.errors.push($translate('REVIEW.DOCUMENT_ERROR4'));
      }

      if (vm.errors && vm.errors.length > 0 ) {
        showErrors(vm.errors);
        return;
      }

      setUserRole(vm.role);
      if (vm.argusFile && vm.argusFile.length > 0) {
          var argusVersion = null;
          for (var i = 0; i < vm.argusFile.length; i++) {
            var version = review.setArgusFile(vm.argusFile[i], status, getPremise(vm.argusFile[i], vm.selectedpremiseoptions), argusVersion, vm.selectedQuarter, vm.selectedYear, vm.selectedValuation);
            if (!argusVersion) {
              argusVersion = version;
            }
          }
        newDocuments = true;
      }
      if (vm.valuationReportFile[0]) {
        review.setValuationReport(vm.valuationReportFile[0], status, vm.selectedQuarter, vm.selectedYear, vm.selectedValuation);
        newDocuments = true;
      }
      if (vm.argusExtractFile && vm.argusExtractFile.length == 1) {
        review.setArgusExtract(vm.argusExtractFile[0], status, vm.selectedQuarter, vm.selectedYear, vm.selectedValuation);
        newDocuments = true;
      }
      if (vm.otherFiles && vm.otherFiles.length != 0) {
        review.setOthers(vm.otherFiles, status, vm.selectedQuarter, vm.selectedYear, vm.selectedValuation);
        newDocuments = true;
      }
      if (newDocuments) {
        LoaderHelper.open();
        ReviewFactory.saveQuarterDocuments(review, vm.selectedQuarter, vm.selectedYear).then(function (newReview) {
          review = newReview;
          review.transition('AP_UploadDocuments');
          $state.go('app.review.discussion.comments', {}, {reload: true});
        }, function (response) {
          if (response.reviewNotificationError) {
            ReviewFactory.invalidTransitionNotification();
          }
          $state.go('app.review', $state.params, {reload: true});
        });
      } else {
        $state.go('app.review.discussion.comments');
      }
    };

    vm.updateDocuments = function () {
      var newDocuments = false;

      var $translate = $filter('translate');
      vm.errors = [];

      vm.missingpremise = missingPremiseSelection(vm.argusFile, vm.selectedpremiseoptions);
      if (vm.missingpremise) {
        vm.errors.push($translate('REVIEW.DOCUMENT_ERROR1A'));
      }

      vm.duplicatepremise = hasDuplicatePremiseSelection(vm.argusFile, vm.selectedpremiseoptions);
      if (vm.duplicatepremise) {
        vm.errors.push($translate('REVIEW.DOCUMENT_ERROR1C'));
      }

      if ( vm.errors.length > 0 && vm.valuationReportFile.length != 1 || vm.valuationReportFile.length == 0 && vm.argusFile.length == 0) {
        vm.errors.push($translate('REVIEW.DOCUMENT_ERROR4'));
      }

      if (vm.errors && vm.errors.length > 0 ) {
        showErrors(vm.errors);
        return;
      }

      setUserRole(vm.role);
      if (vm.argusFile && vm.argusFile.length > 0) {
        var argusVersion = null;
        for (var i = 0; i < vm.argusFile.length; i++) {
          var version = review.setArgusFile(vm.argusFile[i], 'Draft', getPremise(vm.argusFile[i], vm.selectedpremiseoptions), argusVersion, vm.selectedQuarter, vm.selectedYear, vm.selectedValuation);
          if (!argusVersion) {
            argusVersion = version;
          }
        }
        newDocuments = true;
      }
      /*
      if (vm.argusFile && vm.argusFile.length > 0 && vm.argusFile[0]) {
        review.setArgusFile(vm.argusFile[0], 'Draft');
        newDocuments = true;
      }
      */
      if (vm.valuationReportFile[0]) {
        review.setValuationReport(vm.valuationReportFile[0], 'Draft', vm.selectedQuarter, vm.selectedYear, vm.selectedValuation);
        newDocuments = true;
      }
      if (vm.argusExtractFile && vm.argusExtractFile.length == 1) {
        review.setArgusExtract(vm.argusExtractFile[0], 'Draft', vm.selectedQuarter, vm.selectedYear, vm.selectedValuation);
        newDocuments = true;
      }
      if (vm.otherFiles && vm.otherFiles.length != 0) {
        review.setOthers(vm.otherFiles, 'Draft', vm.selectedQuarter, vm.selectedYear, vm.selectedValuation);
        newDocuments = true;
      }
      if (newDocuments) {
        LoaderHelper.open();
        review.transition('RW_UploadDocuments');
        $state.go('app.review.documents');
      } else if (review.transition('AP_UploadDocuments')) {
        LoaderHelper.open(true);
        ReviewFactory.saveReview(review).then(function (updatedReview) {
          review = updatedReview;
          $state.go('app.review.documents', {}, {reload: true});
        }, function (response) {
          if (response.reviewNotificationError) {
            ReviewFactory.invalidTransitionNotification();
          }
          $state.go('app.review', $state.params, {reload: true});
        });
      }

    };

    vm.uploadFinalDocuments = function () {
      vm.submittedFiles = true;
      var $translate = $filter('translate');
      vm.errors = [];
      //if ((!vm.argusFile || vm.argusFile.length <= 0) && vm.review.asset.type !== 'Land' && vm.review.asset.type !== 'Hotel' && vm.review.asset.type !== 'Other') {
      //  vm.errors.push($translate('REVIEW.DOCUMENT_ERROR1'));
      //}
      // if (vm.valuationReportFile.length != 1) {
      //   vm.errors.push($translate('REVIEW.DOCUMENT_ERROR2'));
      // }
      vm.missingpremise = missingPremiseSelection(vm.argusFile, vm.selectedpremiseoptions);
      if (vm.missingpremise) {
        vm.errors.push($translate('REVIEW.DOCUMENT_ERROR1A'));
      }

      vm.duplicatepremise = hasDuplicatePremiseSelection(vm.argusFile, vm.selectedpremiseoptions);
      if (vm.duplicatepremise) {
        vm.errors.push($translate('REVIEW.DOCUMENT_ERROR1C'));
      }

      if ( vm.errors.length > 0 && vm.valuationReportFile.length != 1 || vm.valuationReportFile.length == 0 && vm.argusFile.length == 0) {
        vm.errors.push($translate('REVIEW.DOCUMENT_ERROR4'));
      }

      if (!vm.errors.length) {
        setUserRole(vm.role);

        if (vm.argusFile && vm.argusFile.length > 0) {
          var argusVersion = null;
          for (var i = 0; i < vm.argusFile.length; i++) {
            var version = review.setArgusFile(vm.argusFile[i], 'Final', getPremise(vm.argusFile[i], vm.selectedpremiseoptions), argusVersion, vm.selectedQuarter, vm.selectedYear, vm.selectedValuation);
            if (!argusVersion) {
              argusVersion = version;
            }
          }
        };
        /*
        if (vm.argusFile && vm.argusFile.length > 0) {
          review.setArgusFile(vm.argusFile[0], 'Final');
        }
        */
        if(vm.valuationReportFile.length > 0) {
          vm.selectedValuation.setValuationReport(vm.valuationReportFile[0], 'Final', vm.selectedQuarter, vm.selectedYear, vm.selectedValuation);
        }
       
        if (vm.argusExtractFile && vm.argusExtractFile.length == 1) {
          vm.selectedValuation.setArgusExtract(vm.argusExtractFile[0], 'Final', vm.selectedQuarter, vm.selectedYear, vm.selectedValuation);
        }
        if (vm.otherFiles && vm.otherFiles.length != 0) {
          vm.selectedValuation.setOthers(vm.otherFiles, 'Final', vm.selectedQuarter, vm.selectedYear, vm.selectedValuation);
        }
        LoaderHelper.open();

        if (review.statusChangedWithAction === 'LRW_Approve') {
          if (!review.transition('AP_UploadFinalDocuments')) {
            return;
          }
        } else if (!review.transition('AP_ReUploadFinalDocuments')) {
          return;
        }
        // $state.go('app.review.documents', $state.params);
        $state.go('app.review.documents', {selectedQuarter: vm.selectedQuarter, selectedYear: vm.selectedYear, selectedValuation: vm.selectedValuation}, {reload: false});
      } else {
        showErrors(vm.errors);
      }
    };

    vm.adminAmend = function () {
      if (review.status == 'ValuationSignedOff' || review.status == 'FinalDocumentsUploaded'
        || review.status == 'FinalFormFilled' || review.status == 'Finished') {
        vm.amendUpdate('Final');
      } else {
        vm.amendUpdate('Draft');
      }
    };

    function setUserRole(role) {
      if(vm.argusFile && vm.argusFile.length > 0) {
        for (var i = 0; i < vm.argusFile.length; i++) {
          if (vm.argusFile[i]) {
            vm.argusFile[i].userCompanyId = role;
          }
        }
      }
      if(vm.valuationReportFile[0]) {
      vm.valuationReportFile[0].userCompanyId = role;
      }
      if (vm.argusExtractFile && vm.argusExtractFile.length == 1) {
        vm.argusExtractFile[0].userCompanyId = role;
      }
      if (vm.otherFiles && vm.otherFiles.length != 0) {
        for (var i = 0; i < vm.otherFiles.length; i++) {
          vm.otherFiles[i].userCompanyId = role;
        }
      }
    }

    function getPremise(argusFile, selectedpremiseoptions) {
      var premise = null;
      if (selectedpremiseoptions && selectedpremiseoptions.length > 0) {
        for (var j = 0; j < selectedpremiseoptions.length; j++) {
          if (selectedpremiseoptions[j].fileName === argusFile.name) {
            premise = selectedpremiseoptions[j].selectedpremiseoption;
            break;
          }
        }
      }
      return premise;
    }

    function missingPremiseSelection(argusFiles, selectedpremiseoptions) {
      var missingpremise = false;
      if (argusFiles && argusFiles.length > 0 ) {
        for (var i = 0; i < argusFiles.length; i++) {
          if (!getPremise(argusFiles[i], selectedpremiseoptions)) {
            missingpremise = true;
            break;
          }
        }
      }
      return missingpremise;
    }

    function hasDuplicatePremiseSelection(argusFiles, selectedpremiseoptions) {
      var hasDuplicates = false;
      var valuesSoFar = [];
      if (argusFiles && argusFiles.length > 0 ) {
        for (var i = 0; i < argusFiles.length; ++i) {
          var premise = getPremise(argusFiles[i], selectedpremiseoptions)
          if (premise && valuesSoFar.indexOf(premise) !== -1) {
            hasDuplicates = true;
            break;
          }
          valuesSoFar.push(premise);
        }
      }
      return hasDuplicates;
  }

    function showErrors(errors) {
      //if (errors[1] == undefined) {
      //  errors[1] = '';
      //}

      var textDisplay = errors[0];
      for (i = 1; i < errors.length; i++) {
        if (errors[i]) {
          textDisplay = textDisplay + '\n' + errors[i];
        }
      }

      SweetAlert.swal({
        title: $filter('translate')('DOCUMENTS_UPLOAD.SORRY_CANT_PROCEED'),
        text: textDisplay,
        showCancelButton: false,
        confirmButtonColor: '#2c3d4e',
        confirmButtonText: $filter('translate')('DOCUMENTS_UPLOAD.OK_TAKE_ME_BACK'),
        closeOnConfirm: true
      });
    };
  };
})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .config(routeConfig);

  function routeConfig($stateProvider) {
    $stateProvider.state('app.review.documentsHistory', {
      url: '/documents-history',
      views: {
        '': {
          templateUrl: 'app/states/valuations/review/documents-history/documents-history.html',
          controller: 'DocumentsHistoryController',
          controllerAs: 'documentsHistoryCtrl'
        }
      },
      data: {
        viewClass: 'documentsHistory',
        roles: ['Admin', 'Audit', 'AssetManagement', 'AssetAppraisal', 'AssetReview', 'AssetManagerReadOnly']
      },
      resolve: {
        /**@ngInject*/
        assetDocuments: function (AssetService, review) {
          return AssetService.documentList(review.asset.id).then(function (documents) {

            for (var i = 0; i < review.documents.users.length; i++) {
              var isInUsers = false;
              for (var j in review.asset.users) {
                if (review.documents.users[i].id == j) {
                  isInUsers = true;
                  if(review.asset.users[j].user.userCompanyRoles && review.asset.users[j].user.userCompanyRoles.length > 1) {
                    review.asset.users[j].type = 'Admin';
                  }
                  break;
                }
              }
              if (!isInUsers) {
                review.asset.users[review.documents.users[i].id] = {};
                review.asset.users[review.documents.users[i].id].user = review.documents.users[i];
                if(review.documents.users[i].userCompanyRoles.length > 1 || review.documents.users[i].userCompanyRoles[0] === 'Administrator') {
                  review.asset.users[review.documents.users[i].id].type = 'Admin';
                } else {
                  review.asset.users[review.documents.users[i].id].type = 'PrimaryAssetAppraiser';
                }
              }
            }

            for (var i = 0; i < documents.users.length; i++) {
              var isInUsers = false;
              for (var j in review.asset.users) {
                if (documents.users[i].id == j) {
                  isInUsers = true;
                  break;
                }
              }
              if (!isInUsers) {
                review.asset.users[documents.users[i].id] = {};
                review.asset.users[documents.users[i].id].user = documents.users[i];
                for (var k = 0; k < documents.users[i].userCompanyRoles.length; k++) {
                  if ('Administrator' == documents.users[i].userCompanyRoles[k]) {
                    review.asset.users[documents.users[i].id].type = 'Admin';
                    break;
                  } else if ('AssetManager' == documents.users[i].userCompanyRoles[k]) {
                    review.asset.users[documents.users[i].id].type = 'PrimaryAssetManager';
                  } else {
                    review.asset.users[documents.users[i].id].type = 'PrimaryAssetReviewer';
                  }
                }
              }
            }
            var latestDocuments = [],
              indexedDocumentNames = [];
            for (var i = 0; i < documents.assetDocuments.length; i++) {
              var document = documents.assetDocuments[i];
              if (indexedDocumentNames.indexOf(document.fileName) == -1) {
                var latestDocument = document;
                indexedDocumentNames.push(document.fileName);
                for (var j = i; j < documents.assetDocuments.length; j++) {
                  var document2 = documents.assetDocuments[j];
                  if (latestDocument.fileName === document2.fileName) {
                    if (isNaN(latestDocument.version)
                      || (!isNaN(document2.version) && latestDocument.version < document2.version)) {
                      latestDocument = document2
                    }
                  }
                }
                latestDocuments.push(latestDocument)
              }
            }
            return latestDocuments;
          });
        },
        /**@ngInject*/
        periods: function (AssetService, SessionManager, review) {
          return AssetService.getAssetUsersList(review.asset.id).then(function (users) {
            var periods = [], loggedUser = SessionManager.getUser();
            for(var i = 0; i < users.length; i++) {
              if(users[i].userCompanyId == loggedUser.userCompanyId || loggedUser.userCompanyId === 14405) {
                // 14405 is Internal Appraiser CompanyId
                for (var j = 0; j < users[i].periods.length; j++) {
                  periods.push(users[i].periods[j]);
                }
              }
            }
            return periods;
          });
        },
        /**@ngInject*/
        company: function(CompanyService, review){
          return CompanyService.getCompany(review.asset.companyId);
        },
        prevValuationsObj: function (ReviewFactory, review) {
          return ReviewFactory.loadPrevValuationsData(review.asset.id, review);
        },
        /** @ngInject */
        premiseOptions: function (StaticDataService) {
          return StaticDataService.getPremiseOptions();
        }
      }
    });
  }

})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .controller('DocumentsHistoryController', DocumentsHistoryController);

  /** @ngInject */
  function DocumentsHistoryController($scope, $state, $window, $filter, $q, LoaderHelper, SessionManager, AssetService,
    ValuationService, CompanyService, ReviewFactory, SweetAlert, notify, review, assetDocuments,
    AssetRoleToUserRole, PDFGenerator, periods, company, premiseOptions, prevValuationsObj) {
    var vm = this;
    $window.scrollTo(0, 0);

    vm.review = review;
    vm.assetDocuments = assetDocuments;
    vm.role = SessionManager.getRoleName();
    vm.isFromHistory = $state.current.data.isFromHistory;
    vm.companyId = SessionManager.getCompanyId();
    vm.reviews = [];
    vm.showHistory = {
      quarter: review.quarter,
      year: review.year
    }
    /*
    vm.mainDocumentsOld = [
      {
        name: 'ARGUS Model',
        last: review.getLastArgusFile(),
        old: review.getOldArgusFiles(),
        opened: false
      },
      {
        name: 'Valuation Report',
        last: review.getLastValuationReport(),
        old: review.getOldValuationReport(),
        opened: false
      }
    ];
    */
    vm.mainDocuments = [];
    //var argusDocumentList = review.getLastArgusFileListDoNotUse();

    var angusHeaderAdded = false;
    for (var p = 0; p < premiseOptions.items.length; p++) {
      var lastArgusByPremise = review.getLastArgusFileByPremise(premiseOptions.items[p].value);
      if (lastArgusByPremise) {
        if (!angusHeaderAdded) {
          vm.mainDocuments.push({
            name: 'ARGUS Model',
            last: { name: "", createdOn: "", version: "" },
            old: [],
            opened: false
          });
          angusHeaderAdded = true;
        }
        vm.mainDocuments.push({
          name: premiseOptions.items[p].name,
          last: lastArgusByPremise,
          old: review.getOldArgusFilesByPremise(premiseOptions.items[p].value, vm.showHistory.quarter, vm.showHistory.year),
          typePadding: '25px',
          opened: false
        });
      }
    }

    // Valuation Report is always mandatory
    vm.mainDocuments.push({
      name: 'Valuation Report',
      last: review.getLastValuationReport(vm.showHistory.quarter, vm.showHistory.year),
      old: review.getOldValuationReport(vm.showHistory.quarter, vm.showHistory.year),
      opened: false
    });

    var lastExtract = review.getLastArgusExtract(vm.showHistory.quarter, vm.showHistory.year);
    var user = SessionManager.getUser();
    if (lastExtract) {
      vm.mainDocuments.push({
        name: 'ARGUS Extract',
        last: lastExtract,
        old: review.getOldArgusExtract(vm.showHistory.quarter, vm.showHistory.year),
        opened: false
      })
    }
    // vm.lastSourceDocuments = review.getLastDocuments('SourceDocument',vm.showHistory.quarter, vm.showHistory.year);
    // vm.oldSourceDocumentsByName = review.getOldDocumentsByName('SourceDocument', vm.showHistory.quarter, vm.showHistory.year);
    // vm.lastOtherDocuments = review.getLastDocuments('Other',vm.showHistory.quarter, vm.showHistory.year);
    // vm.oldOtherDocumentsByName = review.getOldDocumentsByName('Other',vm.showHistory.quarter, vm.showHistory.year);
    vm.applyAdminRwModifiedValuesSecurity = false;
    vm.applyAppraiserPrevValuesSecurity = false;
    vm.modifiedByAdminOrReviewerFields = [];
    vm.valuationFrequency = vm.review.asset.valuationFrequency;
    var localPrevValuationsObj = prevValuationsObj;

    if ('AssetAppraisal' === vm.role){
      if ((!localPrevValuationsObj.previousQuarterlyValuation ||
        (1 === review.quarterOfCycle && review.valuationCycle !== 1 &&
          localPrevValuationsObj.previousQuarterlyValuation && localPrevValuationsObj.previousQuarterlyValuation.appraiserCompanyId !== SessionManager.getCompanyId()) ||
        (1 !== review.quarterOfCycle && localPrevValuationsObj.previousQuarterlyValuation &&
          (localPrevValuationsObj.previousQuarterlyValuation.appraiserCompanyId &&
            localPrevValuationsObj.previousQuarterlyValuation.appraiserCompanyId !== SessionManager.getCompanyId())))) {

        // if (review.status !== 'DocumentsUploaded') {
        //   if (review.modifiedByAdminOrReviewerFields) {
        //     vm.modifiedByAdminOrReviewerFields = review.modifiedByAdminOrReviewerFields.split(',');
        //     if (vm.modifiedByAdminOrReviewerFields[0] !== '') {
        //       vm.applyAdminRwModifiedValuesSecurity = true;
        //       for (var i = 0; i < vm.modifiedByAdminOrReviewerFields.length; i++) {
        //         if(vm.modifiedByAdminOrReviewerFields[i] !== 'stabilizedValue' && vm.modifiedByAdminOrReviewerFields[i] != 'stabilizedValueSf') {
        //           vm.review[vm.modifiedByAdminOrReviewerFields[i]] = undefined;
        //         }                
        //       }
        //     }
        //   }
        // }
        vm.applyAppraiserPrevValuesSecurity = true;
        removePreviousValuationFields();
      }
    }

    var loggedInUserRoleName = SessionManager.getRoleName();
    var loggedInUserCompanyId = SessionManager.getCompanyId();

    ReviewFactory.loadAllAssetReviews(review.asset, loggedInUserRoleName, loggedInUserCompanyId).then(function (reviews) {
      vm.showHistory = {
        year: review.year + '',
        quarter: review.quarter
      };
      vm.reviews = reviews
      vm.lastSourceDocuments = review.getLastDocuments('SourceDocument');
      vm.oldSourceDocumentsByName = review.getOldDocumentsByName('SourceDocument');
      vm.lastOtherDocuments = review.getLastDocuments('Other');
      vm.oldOtherDocumentsByName = review.getOldDocumentsByName('Other');
      vm.reviewHistory = {};
      if (user.userCompanyRoles[0] == 'Appraiser') {
        getHistoricalDocuments(reviews, true);
      } else {
        getHistoricalDocuments(reviews, false)
      }
    });

    vm.uploadSourceDocument = function (files) {
      var promises = [];
      for (var i = 0; i < files.length; i++) {
        var file = files[i];
        promises.push(ValuationService.documentCreate(review.id, file, file.name, 'SourceDocument', 'final',
          review.calculateNextSourceDocumentVersion(file.name), SessionManager.getCompanyId()).then(function (response) {
            return response;
          }));
      }

      $q.allSettled(promises).then(function () {
        $state.go($state.current, {}, { reload: true });
        notify({
          message: $filter('translate')('ALL_REQUESTS.DOCUMENT_UPLOADED'),
          duration: 4000,
          templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
          classes: 'alert-info',
          position: 'center'
        });
      });
    };

    vm.uploadHistorySourceDocument = function (files) {
      var promises = [];
      var historicalReview = vm.reviewHistory[vm.showHistory.year][vm.showHistory.quarter].review;
      for (var i = 0; i < files.length; i++) {
        var file = files[i];
        promises.push(ValuationService.documentCreate(historicalReview.id, file, file.name, 'SourceDocument', 'final',
          historicalReview.calculateNextSourceDocumentVersion(file.name), SessionManager.getCompanyId()).then(function (response) {
            return response;
          }));
      }

      $q.allSettled(promises).then(function () {
        $state.go($state.current, {}, { reload: true });
        notify({
          message: $filter('translate')('ALL_REQUESTS.DOCUMENT_UPLOADED'),
          duration: 4000,
          templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
          classes: 'alert-info',
          position: 'center'
        });
      });
    };

    vm.downloadValuationDocument = function (document) {
      ValuationService.documentDownload(document.id).then(function (downloadData) {
        $window.open(downloadData, '_blank');
      });
    };

    vm.downloadAssetDocument = function (document) {
      AssetService.documentDownload(document.id).then(function (downloadData) {
        $window.open(downloadData, '_blank');
      });
    };

    vm.reject = function () {
      SweetAlert.swal({
        title: $filter('translate')('COMMONS.LEAVE_PAGE_MODAL_TITLE'),
        text: $filter('translate')('DOCUMENTS_HISTORY.CONFIRM_REJECT'),
        showCancelButton: true,
        cancelButtonText: $filter('translate')('DOCUMENTS_HISTORY.YES'),
        confirmButtonColor: '#2c3d4e',
        confirmButtonText: $filter('translate')('COMMONS.LEAVE_PAGE_CANCEL_BUTTON'),
        closeOnConfirm: true,
        closeOnCancel: false
      },
        function (isConfirm) {
          if (!isConfirm) {
            SweetAlert.swal({
                html: true,
                title: $filter('translate')('DOCUMENTS_HISTORY.REJECT_REASON'),
                text: "<textarea rows='5' id='rejectReason'></textarea>",
                confirmButtonColor: '#2c3d4e',
                confirmButtonText: $filter('translate')('DOCUMENTS_HISTORY.REJECT'),
                showCancelButton: true,
                cancelButtonText: $filter('translate')('COMMONS.CANCEL'),
                closeOnConfirm: false,
                closeOnCancel: true,
                inputPlaceholder: ''
              },
              function (inputValue) {
                if (false === inputValue) {
                  return false;
                }
                if ('' === document.getElementById('rejectReason').value) {
                  swal.showInputError($filter('translate')('COMMENT_STATES.REASON_IS_MANDATORY'));
                  return false;
                }
                swal.close();
                if (review.transition('RW_Reject')) {
                  LoaderHelper.open(true);
                  var rejectValue = document.getElementById('rejectReason').value;
                  rejectValue = rejectValue.replace(/(\r\n|\r|\n)/g, '<br>');
                  ReviewFactory.saveReview(review, rejectValue).then(function () {
                    var comment = {};
                    comment.type = 'General';
                    comment.title= 'Final Files Rejected';
                    comment.body= rejectValue;
                    comment.userCompanyId = SessionManager.getCompanyId();


                    ReviewFactory.addComment(review, comment).then(function (updatedComment) {
                        ReviewFactory.submitComments(review).then(function (updatedReview) {
                          $state.go($state.current, {}, {reload: true});
                          notify({
                            message: $filter('translate')('DOCUMENTS_HISTORY.REJECTED'),
                            duration: 4000,
                            templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
                            classes: 'alert-info',
                            position: 'center'
                          });
                        }, function (response) {
                          if (response.reviewNotificationError) {
                            ReviewFactory.invalidTransitionNotification();
                          } else if (response === 'no comments to update') {
                            return ReviewFactory.saveReview(review).then(function (updatedReview) {
                              review = updatedReview;
                              $state.go($state.current, {}, {reload: true});
                            }, function (response) {
                              if (response.reviewNotificationError) {
                                ReviewFactory.invalidTransitionNotification();
                              }
                              $state.go($state.current, {}, {reload: true});
                            });
                          }
                          $state.go($state.current, {}, {reload: true});
                        });
                    });
                  }, function (response) {
                    if (response.reviewNotificationError) {
                      ReviewFactory.invalidTransitionNotification();
                    }
                    $state.go($state.current, {}, { reload: true });
                  });
                }
              });
          }
        });
    };

    vm.archive = function () {
      if (review.transition('RW_ArchiveDocuments')) {
        LoaderHelper.open(true);
        ReviewFactory.saveReview(review).then(function () {
          $state.go($state.current, {}, { reload: true });
          notify({
            message: $filter('translate')('DOCUMENTS_HISTORY.ARCHIVED'),
            duration: 4000,
            templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
            classes: 'alert-info',
            position: 'center'
          });
        }, function (response) {
          if (response.reviewNotificationError) {
            ReviewFactory.invalidTransitionNotification();
          }
          $state.go($state.current, {}, { reload: true });
        });
      }
    };

    vm.sanitizedAssetName = function (name) {
      if (name) {
        return name.replace(/[^a-z0-9]/gi, '').toLowerCase();
      }
      return '';
    };

    vm.exportReviewForm = function (review) {
      var promises = [];
      if (review.asset.primaryAssetAppraiser && review.asset.primaryAssetAppraiser.userCompanyId) {
        promises.push(CompanyService.getCompany(review.asset.primaryAssetAppraiser.userCompanyId).then(function (company) {
          return company.name;
        }));
      } else {
        promises.push($q.resolve(''));
      }
      if (review.asset.primaryAssetReviewer && review.asset.primaryAssetReviewer.userCompanyId) {
        promises.push(CompanyService.getCompany(review.asset.primaryAssetReviewer.userCompanyId).then(function (company) {
          return company.name;
        }));
      } else {
        promises.push($q.resolve(''));
      }

      $q.all(promises).then(function (responses) {
        var pdf = PDFGenerator.generateReviewForm(review, company.name, responses[0], responses[1]);
        pdf.download(review.asset.propertyRef + vm.sanitizedAssetName(review.asset.name) + 'Q' + review.quarter + review.year + 'ReviewForm.pdf')
      });
    };

    vm.exportExecutiveSummary = function (review) {
      var pdf = PDFGenerator.generateExecutiveSummary(review, company.name);
      pdf.download(review.asset.propertyRef + vm.sanitizedAssetName(review.asset.name) + 'Q' + review.quarter + review.year + 'ExecutiveSummary.pdf');
    };

    vm.displayNames = function (role) {
      var currentRole = SessionManager.getRoleName();
      var visibilityRules = {
        Admin: ['Administrator', 'Admin', 'Audit', 'AssetManagement', 'AssetAppraisal', 'AssetReview'],
        Audit: ['Administrator', 'Admin', 'Audit', 'AssetManagement', 'AssetAppraisal', 'AssetReview'],
        AssetManagement: ['Administrator', 'Admin', 'Audit', 'AssetManagement', 'AssetReview'],
        AssetManagerReadOnly: ['Administrator', 'Admin', 'Audit', 'AssetManagement', 'AssetReview'],
        AssetAppraisal: ['AssetAppraisal', 'AssetReview'],
        AssetReview: ['Administrator', 'Admin', 'Audit', 'AssetManagement', 'AssetAppraisal', 'AssetReview']
      };
      return  visibilityRules[currentRole] ? visibilityRules[currentRole].indexOf(AssetRoleToUserRole[role]) !== -1 : false;
    };

    vm.gotoUpload = function(quarter, year) {
      var asset = vm.reviews.find(function(review) {
        return review.quarter == quarter && review.year == year
      });
      $state.go('app.review.documentsUpload', {selectedQuarter: quarter, selectedYear: year, selectedValuation: asset}, {reload: true});
    }
    vm.isQuarterVisible = function (quarterData) {
      return (quarterData && vm.companyId != 14405 && vm.role == 'AssetAppraisal') ||
      (vm.companyId == 14405 && vm.role == 'AssetAppraisal') || vm.role == 'Admin' || vm.role == 'AssetReview' || vm.role == 'AssetManagement' || vm.role == 'AssetManagerReadOnly';
    }
    function getHistoricalDocuments(reviews, isAppraiser) {
      // if (isAppraiser) {
      if (false) {
        reviews.forEach(function (review) {
          for (var i = 0; i < periods.length; i++) {
            if (periods[i].year == review.year && periods[i].quarter == review.quarter) {
              if (!vm.reviewHistory[review.year]) {
                vm.reviewHistory[review.year] = {};
              }

              var mainFilesList = [];
              var angusHeaderAdded = false;
              for (var p = 0; p < premiseOptions.items.length; p++) {
                var lastArgusByPremise = review.getLastArgusFileByPremise(premiseOptions.items[p].value);
                if (lastArgusByPremise) {
                  if (!angusHeaderAdded) {
                    mainFilesList.push({
                      name: 'ARGUS Model',
                      last: {name: "", createdOn: "", version: ""},
                      old: [],
                      opened: false
                    });
                    angusHeaderAdded = true; 
                  }
                  mainFilesList.push({
                    name: premiseOptions.items[p].name,
                    last: lastArgusByPremise,
                    old: review.getOldArgusFilesByPremise(premiseOptions.items[p].value),
                    typePadding: '25px',
                    opened: false
                  });
                }
              }

              mainFilesList.push({
                name: 'Valuation Report',
                last: review.getLastValuationReport(),
                old: review.getOldValuationReport(),
                opened: false
              });

              vm.reviewHistory[review.year][review.quarter] = {
                mainFiles: mainFilesList,
                review: review
              };
              var lastExtract = review.getLastArgusExtract();
              if (lastExtract) {
                vm.reviewHistory[review.year][review.quarter].mainFiles.push({
                  name: 'ARGUS Extract',
                  last: lastExtract,
                  old: review.getOldArgusExtract(),
                  opened: false
                })
              }
              vm.reviewHistory[review.year][review.quarter].otherFiles = {
                last: review.getLastDocuments('Other'),
                old: review.getOldDocumentsByName('Other')
              };
              vm.reviewHistory[review.year][review.quarter].sourceFiles = {
                last: review.getLastDocuments('SourceDocument'),
                old: review.getOldDocumentsByName('SourceDocument')
              };
            }
          }
        });
      } else {
        reviews.forEach(function (review) {
          if (!vm.reviewHistory[review.year]) {
            vm.reviewHistory[review.year] = {};
          }

          var mainFilesList = [];
          var angusHeaderAdded = false;
          for (var p = 0; p < premiseOptions.items.length; p++) {
            var lastArgusByPremise = review.getLastArgusFileByPremise(premiseOptions.items[p].value);
            if (lastArgusByPremise) {
              if (!angusHeaderAdded) {
                mainFilesList.push({
                  name: 'ARGUS Model',
                  last: {name: "", createdOn: "", version: ""},
                  old: [],
                  opened: false
                });
                angusHeaderAdded = true;
              }
              mainFilesList.push({
                name: premiseOptions.items[p].name,
                last: lastArgusByPremise,
                old: review.getOldArgusFilesByPremise(premiseOptions.items[p].value),
                typePadding: '25px',
                opened: false
              });
            }
          }

          mainFilesList.push({
            name: 'Valuation Report',
            last: review.getLastValuationReport(),
            old: review.getOldValuationReport(),
            opened: false
          });
          vm.reviewHistory[review.year][review.quarter] = {
            mainFiles: mainFilesList,
            review: review
          };
          var lastExtract = review.getLastArgusExtract();
          if (lastExtract) {
            vm.reviewHistory[review.year][review.quarter].mainFiles.push({
              name: 'ARGUS Extract',
              last: lastExtract,
              old: review.getOldArgusExtract(),
              opened: false
            })
          }
          vm.reviewHistory[review.year][review.quarter].otherFiles = {
            last: review.getLastDocuments('Other'),
            old: review.getOldDocumentsByName('Other')
          };
          vm.reviewHistory[review.year][review.quarter].sourceFiles = {
            last: review.getLastDocuments('SourceDocument'),
            old: review.getOldDocumentsByName('SourceDocument')
          };
        });
      }
    }

    var yearSelectorWatch = $scope.$watch('documentsHistoryCtrl.showHistory.year', function (newValue, oldValue)  {
      if (vm.showHistory) {
        if( vm.reviewHistory && vm.reviewHistory[oldValue][vm.showHistory.quarter] ) {
          vm.reviewHistory[oldValue] = {};
        }
        vm.showHistory.year =  newValue.toString().trim();
        if (user.userCompanyRoles[0] == 'Appraiser') {
          getHistoricalDocuments(vm.reviews, true);
        } else {
          getHistoricalDocuments(vm.reviews, false)
        }
      }
    });
    var quarterSelectorWatch = $scope.$watch('documentsHistoryCtrl.showHistory.quarter', function (newValue, oldValue) {
      if (vm.showHistory) {
        if( vm.reviewHistory && vm.reviewHistory[vm.showHistory.year][oldValue] ) {
          vm.reviewHistory[vm.showHistory.year] = {};
        }
        vm.showHistory.quarter = newValue.toString().trim();
        if (user.userCompanyRoles[0] == 'Appraiser') {
          getHistoricalDocuments(vm.reviews, true);
        } else {
          getHistoricalDocuments(vm.reviews, false)
        }
      }
    });

    var stateChange = $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
      var users = {};
      for (var i = 0; i < Object.keys(review.asset.users).length; i++) {
        var key = Object.keys(review.asset.users)[i];
        if (review.asset.users[key].type !== 'Admin') {
          users[key] = review.asset.users[key];
        }
      }
      review.asset.users = users;
    });

    vm.isHistoricValuationDisabled = function(quarter) {
      var user = SessionManager.getUser();

      if(user.userCompanyRoles[0] === 'Reviewer'){
        var periods = review.asset.primaryAssetReviewer.periods.filter(function (single) {
          return single.quarter == quarter && single.year == vm.showHistory.year;
        });

        return periods.length === 0
      }
    }

    function removePreviousValuationFields() {
      vm.review.appraisalPrevious = undefined;
      //p/y value to current value
      vm.review.appraisalPeriodDelta = undefined;
      vm.review.appraisalPeriodDeltaValue = undefined;
      vm.review.appraisalYearlyDelta = undefined;
      vm.review.appraisalYearlyDeltaValue = undefined;
      //p/p y/y deltas
      vm.review.stabilizedCapRatePeriodDelta = undefined;
      vm.review.stabilizedCapRateYearlyDelta = undefined;
      vm.review.terminalRatePeriodDelta = undefined;
      vm.review.terminalRateYearlyDelta = undefined;
      vm.review.discountRatePeriodDelta = undefined;
      vm.review.discountRateYearlyDelta = undefined;
      vm.review.impliedCapRatePeriodDelta = undefined;
      vm.review.impliedCapRateYearlyDelta = undefined;
      //deltas
      vm.review.deltaDiscountRate = undefined;
      vm.review.deltaTerminalCapRate = undefined;
      vm.review.deltaAvgMarketRentGrowth = undefined;
      vm.review.deltaMarketRents = undefined;
      vm.review.deltaContractRents = undefined;
      vm.review.deltaVacancyAndCollectionLoss = undefined;
      vm.review.deltaDowntimeAndRenewalProbability = undefined;
      vm.review.deltaExpenses = undefined;
      vm.review.deltaRealEstateTaxes = undefined;
      vm.review.deltaBuildingCapital = undefined;
      vm.review.deltaLeasingCapital = undefined;
      vm.review.deltaOther = undefined;
      vm.review.totalChange = undefined;
      // explanations
      // vm.review.ppValueChangeExplanation = undefined;
      // vm.review.yyValueChangeExplanation = undefined;
    }

    /*
    function getArgusFilesByPremise(allFiles, premise) {
      var argusFilesByPremise = [];
      for (var i = 0; i < allFiles.length; i++) {
        if (allFiles[i].type !== 'ArgusFile') {
          continue;
        }
        var curPrem = 'AsIs'; //default
        if (allFiles[i].premise) {
          curPrem = allFiles[i].premise;
        }
        if (curPrem === premise) {
          argusFilesByPremise.push(allFiles[i]);
        }
      }
      return argusFilesByPremise;
    }
    */

    $scope.$on('$destroy', function () {
      stateChange();
      yearSelectorWatch();
    });
  }

})();

(function () {
  'use strict';

  angular
  .module('nvc')
  .config(routeConfig);

  function routeConfig($stateProvider) {
    $stateProvider.state('app.review.documents', {
      url: '/documents',
      views: {
        '': {
          templateUrl: 'app/states/valuations/review/documents/documents.html',
          controller: 'DocumentsController',
          controllerAs: 'documentsCtrl'
        }
      },
      data: {
        viewClass: 'documents',
        roles: ['Admin', 'Audit', 'AssetAppraisal', 'AssetManagement', 'AssetReview', 'AssetManagerReadOnly']
      },
      params: {
        selectedQuarter: '',
        selectedYear: '',
        selectedValuation: null
      },
      resolve: {
        /**@ngInject*/
        prevValuationsObj: function ($stateParams, ReviewFactory, review) {
          var selectedReview = $stateParams.selectedValuation ? $stateParams.selectedValuation : review
          return ReviewFactory.loadPrevValuationsData($stateParams.assetId, selectedReview);
        }
      }
    })
  }

})();


(function () {
  'use strict';

  angular
    .module('nvc')
    .controller('DocumentsController', DocumentsController);

  /** @ngInject */
  function DocumentsController($state, $scope, ReviewFactory, review, LoaderHelper, SessionManager, prevValuationsObj) {
    var vm = this;
    review = $state.params.selectedValuation ? $state.params.selectedValuation : review;
    vm.review = review;
    vm.role = SessionManager.getRoleName();
    vm.validPPNotes = false;
    vm.touchedPPNotes = false;
    vm.validYYNotes = false;
    vm.touchedYYNotes = false;
    vm.valuations = prevValuationsObj.valuations;
    vm.factorValues = {};
    vm.invalidTotalChange = false;
    vm.newDocuments = false;
    vm.isPreviousValue = !!review.appraisalPrevious;
    vm.appraisalPreviousInitialValue = vm.isPreviousValue;
    vm.applyAppraiserPrevValuesSecurity = false;
    vm.applyAdminRwModifiedValuesSecurity = false;
    vm.disableStabilizedValueSf = true; 
    vm.AdminRwModifiedFields = [];
    var previousQuarterlyValuation = prevValuationsObj.previousQuarterlyValuation,
      previousYearlyValuation = prevValuationsObj.previousYearlyValuation,
      reviewSecurityCopy;

      vm.selectedQuarter = $state.params.selectedQuarter ? $state.params.selectedQuarter : review.quarter;
      vm.selectedYear = $state.params.selectedYear ? $state.params.selectedYear : review.year;
    for (var i = 0; i < review.documents.assetDocuments.length; i++) {
      if (!review.documents.assetDocuments[i].id) {
        vm.newDocuments = true;
        break;
      }
    }

    if (review.appraisalFinal === 0) {
      review.appraisalFinal = undefined;
    }
    if (review.status === 'ValuationSignedOff' || review.status === 'FinalDocumentsUploaded' && !review.appraisalFinal) {
      review.appraisalFinal = review.appraisalDraft;
    }

    var apprPeriodDeltaInited = false,
      apprYearlyDeltaInited = !!review.appraisalYearlyDelta,
      capRateInited = !!review.stabilizedCapRate,
      terRateInited = !!review.terminalRate,
      disRateInited = !!review.discountRate,
      impRateInited = !!review.impliedCapRate,
      stabilizedValueInited = !!review.stabilizedValueSf;

    apprPeriodDeltaInited = review.appraisalPeriodDelta && review.appraisalPeriodDelta !== 'N/A';
    apprYearlyDeltaInited = review.appraisalYearlyDelta && review.appraisalYearlyDelta !== 'N/A';

    verifyPreviousValuationsAmount();
    appraiserSecurity(vm.review);
    getFactorValues();
    if (review.status !== 'Created' && review.appraisalDraft) { // means not the first time fill
      review.landAndOtherAdj = review.landAndOtherAdj ? review.landAndOtherAdj : review.landAndOtherAdj === 0 ? 0 : 'N/A';
      review.discountedCashFlowAnalysis = review.discountedCashFlowAnalysis ? review.discountedCashFlowAnalysis : review.discountedCashFlowAnalysis === 0 ? 0 : 'N/A';
      review.directCapitalizationAnalysis = review.directCapitalizationAnalysis ? review.directCapitalizationAnalysis : review.directCapitalizationAnalysis === 0 ? 0 : 'N/A';
      review.stabilizedValue = review.stabilizedValue ? review.stabilizedValue : review.stabilizedValue === 0 ? 0 : 'N/A';
      review.stabilizedValueSf = review.stabilizedValueSf ? review.stabilizedValueSf : review.stabilizedValueSf === 0 ? 0 : 'N/A';
      review.absorptionPeriod = review.absorptionPeriod ? review.absorptionPeriod : review.absorptionPeriod === 0 ? 0 : 'N/A';
      review.salesComparisonApproach = review.salesComparisonApproach ? review.salesComparisonApproach : review.salesComparisonApproach === 0 ? 0 : 'N/A';
      review.costApproach = review.costApproach ? review.costApproach : review.costApproach === 0 ? 0 : 'N/A';
      review.insurableValue = review.insurableValue ? review.insurableValue : review.insurableValue === 0 ? 0 : 'N/A';
      review.stabilizedCapRate = review.stabilizedCapRate ? review.stabilizedCapRate : review.stabilizedCapRate === 0 ? 0 : 'N/A';
      review.terminalRate = review.terminalRate ? review.terminalRate : review.terminalRate === 0 ? 0 : 'N/A';
      review.discountRate = review.discountRate ? review.discountRate : review.discountRate === 0 ? 0 : 'N/A';
      review.impliedCapRate = review.impliedCapRate ? review.impliedCapRate : review.impliedCapRate === 0 ? 0 : 'N/A';
      review.avgContractRent = review.avgContractRent ? review.avgContractRent : review.avgContractRent === 0 ? 0 : 'N/A';
      review.avgRentGrowth = review.avgRentGrowth ? review.avgRentGrowth : review.avgRentGrowth === 0 ? 0 : 'N/A';
      review.avgMarketRent = review.avgMarketRent ? review.avgMarketRent : review.avgMarketRent === 0 ? 0 : 'N/A';
      review.ppValueChangeExplanation = review.ppValueChangeExplanation ? review.ppValueChangeExplanation : review.ppValueChangeExplanation === 0 ? 0 : 'N/A';
      review.yyValueChangeExplanation = review.yyValueChangeExplanation ? review.yyValueChangeExplanation : review.yyValueChangeExplanation === 0 ? 0 : 'N/A';
      review.appraisalPeriodDelta = review.appraisalPeriodDelta ? review.appraisalPeriodDelta : review.appraisalPeriodDelta === 0 ? 0 : 'N/A';
      review.appraisalYearlyDelta = review.appraisalYearlyDelta ? review.appraisalYearlyDelta : review.appraisalYearlyDelta === 0 ? 0 : 'N/A';
      review.appraisalYearlyDeltaValue = review.appraisalYearlyDeltaValue ? review.appraisalYearlyDeltaValue : review.appraisalYearlyDeltaValue === 0 ? 0 : 'N/A';
      review.stabilizedCapRatePeriodDelta = review.stabilizedCapRatePeriodDelta ? review.stabilizedCapRatePeriodDelta : review.stabilizedCapRatePeriodDelta === 0 ? 0 : 'N/A';
      review.stabilizedCapRateYearlyDelta = review.stabilizedCapRateYearlyDelta ? review.stabilizedCapRateYearlyDelta : review.stabilizedCapRateYearlyDelta === 0 ? 0 : 'N/A';
      review.terminalRatePeriodDelta = review.terminalRatePeriodDelta ? review.terminalRatePeriodDelta : review.terminalRatePeriodDelta === 0 ? 0 : 'N/A';
      review.terminalRateYearlyDelta = review.terminalRateYearlyDelta ? review.terminalRateYearlyDelta : review.terminalRateYearlyDelta === 0 ? 0 : 'N/A';
      review.discountRatePeriodDelta = review.discountRatePeriodDelta ? review.discountRatePeriodDelta : review.discountRatePeriodDelta === 0 ? 0 : 'N/A';
      review.discountRateYearlyDelta = review.discountRateYearlyDelta ? review.discountRateYearlyDelta : review.discountRateYearlyDelta === 0 ? 0 : 'N/A';
      review.impliedCapRatePeriodDelta = review.impliedCapRatePeriodDelta ? review.impliedCapRatePeriodDelta : review.impliedCapRatePeriodDelta === 0 ? 0 : 'N/A';
      review.impliedCapRateYearlyDelta = review.impliedCapRateYearlyDelta ? review.impliedCapRateYearlyDelta : review.impliedCapRateYearlyDelta === 0 ? 0 : 'N/A';

      if (!review.stabilizedValueSf && review.stabilizedValueSf != 0) {
        vm.disableStabilizedValueSf = false;
      }
    }

    vm.submitReview = function () {
      //cleanOptionalValues();
      setFactorValues();
      if (vm.applyAppraiserPrevValuesSecurity) {
        rollBackNoModifiedFieldsByAPSecurity();
      }

      if (!review.appraisalFinal) {
        review.appraisalFinal = 0;
      }
      review.ppValueChangeExplanation = vm.review.ppValueChangeExplanation;
      review.yyValueChangeExplanation = vm.review.yyValueChangeExplanation;

      var previousStatus = review.status;
      if (review.status === 'Created' ||  review.status === 'DocumentsUploaded' || review.status === 'DocumentsUpdated' ||
        review.status === 'FinalDocumentsUploaded' || review.status === 'Finished' || review.status === 'FormFilled' ||
        review.status === 'ReviewerCommented' || review.status === 'ManagerCommented' || review.status === 'SubmittedToAppraiser' ||
        review.status === 'CommentsAnswered' || review.status === 'ValuationUpdated' || review.status === 'ReviewerApproveValuation' 
        || review.status === 'ManagerApproveValuation') {
        LoaderHelper.open(true);
        ReviewFactory.saveQuarterDocuments(review, vm.selectedQuarter, vm.selectedYear).then(function (newReview) {
          review = newReview;
          review.transition('AP_UploadDocuments') 
          //cleanOptionalValues();
          ReviewFactory.saveReview(review).then(function (newReview) {
            review = newReview;
            if (review.transition('AP_Submit')  || review.transition('RW_Submit') ||  review.transition('AP_UploadDocuments') ||
            review.transition('AP_Reply') || review.transition('RW_Retract')   || review.transition('AP_FillFinalForm') || 
            review.transition('RW_Comment') || review.transition('ADMIN_UpdateDocuments')) {
              ReviewFactory.saveReview(review).then(function (newReview) {  
                review = newReview;
                if (previousStatus === 'DocumentsUploaded') {
                  review.transition('AP_UploadDocuments')
                  $state.go('app.review');
                } else {
                  if(review.status !== 'ManagerCommented') {
                    ReviewFactory.submitComments(review).then(function (updatedReview) {
                      review = updatedReview;
                      review.transition('AP_Submit')
                      $state.go('app.review.discussion', {}, {reload: true});
                    }, function (response) {
                      if (response.reviewNotificationError) {
                        ReviewFactory.invalidTransitionNotification();
                      }
                      $state.go('app.review.discussion', {}, {reload: true});
                    });
                  } else {
                    if(SessionManager.getRoleName() == 'AssetAppraisal') {
                      review.transition('AP_Submit')
                    } else if(SessionManager.getRoleName() == 'AssetReview'){
                      review.transition('RW_Submit')
                    }
                    $state.go('app.review.discussion', {}, {reload: true});
                  }
                }
              }, function (response) {
                if (response.reviewNotificationError) {
                  ReviewFactory.invalidTransitionNotification();
                }
                $state.go('app.valuations');
              });
            } else if (review.transition('AP_FillFinalForm')) {
              LoaderHelper.open(true);
              ReviewFactory.saveReview(review).then(function (newReview) {
                review = newReview;
                $state.go('app.valuations');
              }, function (response) {
                if (response.reviewNotificationError) {
                  ReviewFactory.invalidTransitionNotification();
                }
                $state.go($state.current, {}, {reload: true});
              });
            }
          });
        }, function (response) {
          if (response.reviewNotificationError) {
            ReviewFactory.invalidTransitionNotification();
          }
          $state.go('app.review', $state.params, {reload: true});
        });
      } else if (vm.role === 'Admin' ) {
        LoaderHelper.open(true);
        ReviewFactory.saveReview(review).then(function (newReview) {
          review = newReview;
          $state.go('app.review.discussion.comments', {}, {reload: true});
        }, function (response) {
          if (response.reviewNotificationError) {
            ReviewFactory.invalidTransitionNotification();
          }
          $state.go($state.current, {}, {reload: true});
        });
      }
    };

    vm.goBack = function (review) {
      if (review.status === 'FormFilled' || review.status === 'FinalDocumentsUploaded' || review.status === 'DocumentsUploaded' || review.status === 'DocumentsUpdated') {
        $state.go('app.review.documentsUpload', {}, {reload: true});
      } else if (vm.executiveSummaryForm.$dirty) {
        ReviewFactory.loadReview(review.assetId, review.id).then(function (loadedReview) {
          Object.keys(loadedReview).forEach(function (key) {
            review[key] = loadedReview[key];
          });
          $state.go('app.review.discussion.comments', {}, {reload: true});
        });
      } else {
        $state.go('app.review.discussion.comments', {}, {reload: true});
      }
    };

    function getFactorValues() {
      vm.factorValues.deltaDiscountRate = review.deltaDiscountRate || 0;
      vm.factorValues.deltaTerminalCapRate = review.deltaTerminalCapRate || 0;
      vm.factorValues.deltaAvgMarketRentGrowth = review.deltaAvgMarketRentGrowth || 0;
      vm.factorValues.deltaMarketRents = review.deltaMarketRents || 0;
      vm.factorValues.deltaContractRents = review.deltaContractRents || 0;
      vm.factorValues.deltaVacancyAndCollectionLoss = review.deltaVacancyAndCollectionLoss || 0;
      vm.factorValues.deltaDowntimeAndRenewalProbability = review.deltaDowntimeAndRenewalProbability || 0;
      vm.factorValues.deltaExpenses = review.deltaExpenses || 0;
      vm.factorValues.deltaRealEstateTaxes = review.deltaRealEstateTaxes || 0;
      vm.factorValues.deltaBuildingCapital = review.deltaBuildingCapital || 0;
      vm.factorValues.deltaLeasingCapital = review.deltaLeasingCapital || 0;
      vm.factorValues.deltaOther = review.deltaOther || 0;
    }

    function setFactorValues() {
      review.deltaDiscountRate = vm.applyAppraiserPrevValuesSecurity ? reviewSecurityCopy.deltaDiscountRate : vm.factorValues.deltaDiscountRate || 0;
      review.deltaTerminalCapRate = vm.applyAppraiserPrevValuesSecurity ? reviewSecurityCopy.deltaTerminalCapRate : vm.factorValues.deltaTerminalCapRate || 0;
      review.deltaAvgMarketRentGrowth = vm.applyAppraiserPrevValuesSecurity ? reviewSecurityCopy.deltaAvgMarketRentGrowth : vm.factorValues.deltaAvgMarketRentGrowth || 0;
      review.deltaMarketRents = vm.applyAppraiserPrevValuesSecurity ? reviewSecurityCopy.deltaMarketRents : vm.factorValues.deltaMarketRents || 0;
      review.deltaContractRents = vm.applyAppraiserPrevValuesSecurity ? reviewSecurityCopy.deltaContractRents : vm.factorValues.deltaContractRents || 0;
      review.deltaVacancyAndCollectionLoss = vm.applyAppraiserPrevValuesSecurity ? reviewSecurityCopy.deltaVacancyAndCollectionLoss : vm.factorValues.deltaVacancyAndCollectionLoss || 0;
      review.deltaDowntimeAndRenewalProbability = vm.applyAppraiserPrevValuesSecurity ? reviewSecurityCopy.deltaDowntimeAndRenewalProbability : vm.factorValues.deltaDowntimeAndRenewalProbability || 0;
      review.deltaExpenses = vm.applyAppraiserPrevValuesSecurity ? reviewSecurityCopy.deltaExpenses : vm.factorValues.deltaExpenses || 0;
      review.deltaRealEstateTaxes = vm.applyAppraiserPrevValuesSecurity ? reviewSecurityCopy.deltaRealEstateTaxes : vm.factorValues.deltaRealEstateTaxes || 0;
      review.deltaBuildingCapital = vm.applyAppraiserPrevValuesSecurity ? reviewSecurityCopy.deltaBuildingCapital : vm.factorValues.deltaBuildingCapital || 0;
      review.deltaLeasingCapital = vm.applyAppraiserPrevValuesSecurity ? reviewSecurityCopy.deltaLeasingCapital : vm.factorValues.deltaLeasingCapital || 0;
      review.deltaOther = vm.applyAppraiserPrevValuesSecurity ? reviewSecurityCopy.deltaOther : vm.factorValues.deltaOther || 0;
    }

    function cleanOptionalValues() {
      // previously mandatory fields, now accepting N/A
      review.landAndOtherAdj = cleanOptional(review.landAndOtherAdj);
      review.discountedCashFlowAnalysis = cleanOptional(review.discountedCashFlowAnalysis);
      review.directCapitalizationAnalysis = cleanOptional(review.directCapitalizationAnalysis);
      review.stabilizedValue = cleanOptional(review.stabilizedValue);
      review.stabilizedValueSf = cleanOptional(review.stabilizedValueSf);
      review.absorptionPeriod = cleanOptional(review.absorptionPeriod);
      review.salesComparisonApproach = cleanOptional(review.salesComparisonApproach);
      review.costApproach = cleanOptional(review.costApproach);
      review.insurableValue = cleanOptional(review.insurableValue);
      review.stabilizedCapRate = cleanOptional(review.stabilizedCapRate);
      review.terminalRate = cleanOptional(review.terminalRate);
      review.discountRate = cleanOptional(review.discountRate);
      review.impliedCapRate = cleanOptional(review.impliedCapRate);
      review.avgContractRent = cleanOptional(review.avgContractRent);
      review.avgMarketRent = cleanOptional(review.avgMarketRent);
      review.avgRentGrowth = cleanOptional(review.avgRentGrowth);
    }

    function cleanOptional(val) {
      if (val || val === 0) {
      } else {
        val = undefined;
      }
      if (val && val === 'N/A') {
        val = undefined;
      }
      return val;
    }

    function verifyPreviousValuationsAmount() {
      vm.previousValuation = !!previousQuarterlyValuation;
      vm.previousYearlyValuation = !!previousYearlyValuation;

      if(vm.previousValuation) {
        review.stabilizedCapRatePeriodDelta = Math.round((review.stabilizedCapRate - previousQuarterlyValuation.stabilizedCapRate / 100) * 100);
        review.terminalRatePeriodDelta = Math.round((review.terminalRate - previousQuarterlyValuation.terminalRate / 100) * 100);
        review.discountRatePeriodDelta = Math.round((review.discountRate - previousQuarterlyValuation.discountRate / 100) * 100);
        review.impliedCapRatePeriodDelta = Math.round((review.impliedCapRate - previousQuarterlyValuation.impliedCapRate / 100) * 100);

      } else {
        review.appraisalPeriodDelta = review.appraisalPeriodDelta ? review.appraisalPeriodDelta : review.appraisalPeriodDelta === 0 ? 0 : 'N/A';
        review.appraisalPeriodDeltaValue = review.appraisalPeriodDeltaValue ? review.appraisalPeriodDeltaValue : review.appraisalPeriodDeltaValue === 0 ? 0 : 'N/A';
        review.stabilizedCapRatePeriodDelta = review.stabilizedCapRatePeriodDelta ? review.stabilizedCapRatePeriodDelta : review.stabilizedCapRatePeriodDelta === 0 ? 0 : 'N/A';
        review.terminalRatePeriodDelta = review.terminalRatePeriodDelta ? review.terminalRatePeriodDelta : review.terminalRatePeriodDelta === 0 ? 0 : 'N/A';
        review.discountRatePeriodDelta = review.discountRatePeriodDelta ? review.discountRatePeriodDelta : review.discountRatePeriodDelta === 0 ? 0 : 'N/A';
        review.impliedCapRatePeriodDelta = review.impliedCapRatePeriodDelta ? review.impliedCapRatePeriodDelta : review.impliedCapRatePeriodDelta === 0 ? 0 : 'N/A';
      }

      if(vm.previousYearlyValuation) {
        review.stabilizedCapRateYearlyDelta = Math.round((review.stabilizedCapRate - previousYearlyValuation.stabilizedCapRate / 100) * 100);
        review.terminalRateYearlyDelta = Math.round((review.terminalRate - previousYearlyValuation.terminalRate / 100) * 100);
        review.discountRateYearlyDelta = Math.round((review.discountRate - previousYearlyValuation.discountRate / 100) * 100);
        review.impliedCapRateYearlyDelta = Math.round((review.impliedCapRate - previousYearlyValuation.impliedCapRate / 100) * 100);

      } else {
        review.appraisalYearlyDelta = review.appraisalYearlyDelta ? review.appraisalYearlyDelta : review.appraisalYearlyDelta === 0 ? 0 : 'N/A';
        review.appraisalYearlyDeltaValue = review.appraisalYearlyDeltaValue ? review.appraisalYearlyDeltaValue : review.appraisalYearlyDeltaValue === 0 ? 0 : 'N/A';
        review.stabilizedCapRateYearlyDelta = review.stabilizedCapRateYearlyDelta ? review.stabilizedCapRateYearlyDelta : review.stabilizedCapRateYearlyDelta === 0 ? 0 : 'N/A';
        review.terminalRateYearlyDelta = review.terminalRateYearlyDelta ? review.terminalRateYearlyDelta : review.terminalRateYearlyDelta === 0 ? 0 : 'N/A';
        review.discountRateYearlyDelta = review.discountRateYearlyDelta ? review.discountRateYearlyDelta : review.discountRateYearlyDelta === 0 ? 0 : 'N/A';
        review.impliedCapRateYearlyDelta = review.impliedCapRateYearlyDelta ? review.impliedCapRateYearlyDelta : review.impliedCapRateYearlyDelta === 0 ? 0 : 'N/A';
      }
    }

    function appraiserSecurity(currentValuation) {
      // Have to revisit this. For now, not doing the data hiding for AssetAppraisal alone
      if (false && 'AssetAppraisal' === SessionManager.getRoleName()) {
        reviewSecurityCopy = angular.copy(review);
        if (!previousQuarterlyValuation ||
          (1 === currentValuation.quarterOfCycle && currentValuation.valuationCycle !== 1 &&
          previousQuarterlyValuation && previousQuarterlyValuation.appraiserCompanyId !== SessionManager.getCompanyId()) ||
          (1 !== currentValuation.quarterOfCycle && previousQuarterlyValuation &&
          (previousQuarterlyValuation.appraiserCompanyId &&
          previousQuarterlyValuation.appraiserCompanyId !== SessionManager.getCompanyId()))) {

          if (currentValuation.status !== 'DocumentsUploaded') {
            if (currentValuation.modifiedByAdminOrReviewerFields) {
              vm.AdminRwModifiedFields = currentValuation.modifiedByAdminOrReviewerFields.split(',');
              if (vm.AdminRwModifiedFields[0] !== '') {
                vm.applyAdminRwModifiedValuesSecurity = true;
                removeAdminRwModifiedFields();
              }
            }
          }
          vm.applyAppraiserPrevValuesSecurity = true;
          removePreviousValuationFields();
        }
      }
      previousValueSecurity();
    }

    function removePreviousValuationFields() {
      vm.review.appraisalPrevious = undefined;
      //p/y value to current value
      vm.review.appraisalPeriodDelta = undefined;
      vm.review.appraisalPeriodDeltaValue = undefined;
      vm.review.appraisalYearlyDelta = undefined;
      vm.review.appraisalYearlyDeltaValue = undefined;
      //p/p y/y deltas
      vm.review.stabilizedCapRatePeriodDelta = undefined;
      vm.review.stabilizedCapRateYearlyDelta = undefined;
      vm.review.terminalRatePeriodDelta = undefined;
      vm.review.terminalRateYearlyDelta = undefined;
      vm.review.discountRatePeriodDelta = undefined;
      vm.review.discountRateYearlyDelta = undefined;
      vm.review.impliedCapRatePeriodDelta = undefined;
      vm.review.impliedCapRateYearlyDelta = undefined;
      //deltas
      vm.review.deltaDiscountRate = undefined;
      vm.review.deltaTerminalCapRate = undefined;
      vm.review.deltaAvgMarketRentGrowth = undefined;
      vm.review.deltaMarketRents = undefined;
      vm.review.deltaContractRents = undefined;
      vm.review.deltaVacancyAndCollectionLoss = undefined;
      vm.review.deltaDowntimeAndRenewalProbability = undefined;
      vm.review.deltaExpenses = undefined;
      vm.review.deltaRealEstateTaxes = undefined;
      vm.review.deltaBuildingCapital = undefined;
      vm.review.deltaLeasingCapital = undefined;
      vm.review.deltaOther = undefined;
      vm.review.totalChange = undefined;
      // explanations
      vm.review.ppValueChangeExplanation = undefined;
      vm.review.yyValueChangeExplanation = undefined;
    }

    function removeAdminRwModifiedFields() {
      for (var i = 0; i < vm.AdminRwModifiedFields.length; i++) {
        vm.review[vm.AdminRwModifiedFields[i]] = undefined;
      }
    }

    function rollBackNoModifiedFieldsByAPSecurity() {
      review.appraisalPrevious = reviewSecurityCopy.appraisalPrevious;
      //p/y value to current value
      review.appraisalPeriodDelta = reviewSecurityCopy.appraisalPeriodDelta;
      review.appraisalPeriodDeltaValue = reviewSecurityCopy.appraisalPeriodDeltaValue;
      review.appraisalYearlyDelta = reviewSecurityCopy.appraisalYearlyDelta;
      review.appraisalYearlyDeltaValue = reviewSecurityCopy.appraisalYearlyDeltaValue;
      //p/p y/y deltas
      review.stabilizedCapRatePeriodDelta = reviewSecurityCopy.stabilizedCapRatePeriodDelta;
      review.stabilizedCapRateYearlyDelta = reviewSecurityCopy.stabilizedCapRateYearlyDelta;
      review.terminalRatePeriodDelta = reviewSecurityCopy.terminalRatePeriodDelta;
      review.terminalRateYearlyDelta = reviewSecurityCopy.terminalRateYearlyDelta;
      review.discountRatePeriodDelta = reviewSecurityCopy.discountRatePeriodDelta;
      review.discountRateYearlyDelta = reviewSecurityCopy.discountRateYearlyDelta;
      review.impliedCapRatePeriodDelta = reviewSecurityCopy.impliedCapRatePeriodDelta;
      review.impliedCapRateYearlyDelta = reviewSecurityCopy.impliedCapRateYearlyDelta;
      // explanations
      review.ppValueChangeExplanation = reviewSecurityCopy.ppValueChangeExplanation;
      review.yyValueChangeExplanation = reviewSecurityCopy.yyValueChangeExplanation;
    }

    function priorPeriodValidations() {
      if (!review.appraisalDraft && !review.appraisalFinal && !vm.previousValuation && !apprPeriodDeltaInited) {
        review.appraisalPeriodDelta = 'N/A';
        review.appraisalPeriodDeltaValue = 'N/A';
        apprPeriodDeltaInited = false;
        vm.invalidTotalChange = vm.applyAppraiserPrevValuesSecurity || (review.appraisalPrevious && (review.appraisalDraft || review.appraisalFinal)) ? false : true;
      } else if (!review.appraisalDraft && !review.appraisalFinal && vm.previousValuation && apprPeriodDeltaInited) {
        review.appraisalPeriodDelta = '';
        review.appraisalPeriodDeltaValue = '';
        apprPeriodDeltaInited = false;
        vm.invalidTotalChange = vm.applyAppraiserPrevValuesSecurity || (review.appraisalPrevious && (review.appraisalDraft || review.appraisalFinal)) ? false : true;
      } else if (!review.appraisalDraft && !review.appraisalFinal && vm.previousValuation && !apprPeriodDeltaInited) {
        review.appraisalPeriodDelta = '';
        review.appraisalPeriodDeltaValue = '';
        vm.invalidTotalChange = vm.applyAppraiserPrevValuesSecurity || (review.appraisalPrevious && (review.appraisalDraft || review.appraisalFinal)) ? false : true;
      }
    }

    function previousValueSecurity() {
      if (!review.appraisalPrevious) {
        if (vm.applyAppraiserPrevValuesSecurity ||
          (vm.applyAdminRwModifiedValuesSecurity && -1 !== vm.AdminRwModifiedFields.indexOf('appraisalPrevious')) ) {
          review.appraisalPrevious = undefined;
        } else if((previousQuarterlyValuation)) {
          if(previousQuarterlyValuation.appraisalFinal) {
            review.appraisalPrevious = previousQuarterlyValuation.appraisalFinal !== 0 ?
                previousQuarterlyValuation.appraisalFinal : previousQuarterlyValuation.appraisalDraft;
          }else if (previousQuarterlyValuation.appraisalDraft) {
            review.appraisalPrevious = previousQuarterlyValuation.appraisalDraft;
          } else {
            review.appraisalPrevious = undefined;
          }
        } else {
          review.appraisalPrevious = undefined;
        }
      }
    }

    var previousValueWatch = $scope.$watch('documentsCtrl.review.appraisalPrevious', function () {
      if (review.appraisalPrevious) {
        vm.isPreviousValue = true;
      }
      if (0 == review.appraisalPrevious) {
        review.appraisalPrevious = '';
        if (review.totalChange && !vm.applyAppraiserPrevValuesSecurity) {
          vm.invalidTotalChange = true;
        } else if (!review.totalChange) {
          review.totalChange = '';
          vm.invalidTotalChange = false;
        }
        vm.isPreviousValue = false;
      }

      if (!review.appraisalPrevious && !vm.previousValuation && !apprPeriodDeltaInited) {
        review.appraisalPeriodDelta = 'N/A';
        review.appraisalPeriodDeltaValue = 'N/A';
        vm.isPreviousValue = false;
        apprPeriodDeltaInited = false;
      } else if (!review.appraisalPrevious && vm.previousValuation && apprPeriodDeltaInited) {
        review.appraisalPeriodDelta = '';
        review.appraisalPeriodDeltaValue = '';
        vm.isPreviousValue = false;
        apprPeriodDeltaInited = false;
      } else if (!review.appraisalPrevious && vm.previousValuation && !apprPeriodDeltaInited) {
        review.appraisalPeriodDelta = '';
        review.appraisalPeriodDeltaValue = '';
        vm.isPreviousValue = false;
      }
      if (review.appraisalPrevious && review.appraisalDraft && !review.appraisalFinal) {
        if (apprPeriodDeltaInited) {
          return;
        } else {
          review.appraisalPeriodDelta = parseFloat(((review.appraisalDraft - review.appraisalPrevious) / review.appraisalPrevious) * 100).toFixed(2);
          review.appraisalPeriodDeltaValue = review.appraisalDraft - review.appraisalPrevious;
          if (vm.applyAppraiserPrevValuesSecurity || (review.totalChange && review.appraisalPeriodDeltaValue == review.totalChange)) {
            vm.invalidTotalChange = false;
          }
        }
      } else if (review.appraisalPrevious && review.appraisalFinal) {
        if (apprPeriodDeltaInited) {
          return;
        } else {
          review.appraisalPeriodDelta = parseFloat(((review.appraisalFinal - review.appraisalPrevious) / review.appraisalPrevious) * 100).toFixed(2);
          review.appraisalPeriodDeltaValue = review.appraisalFinal - review.appraisalPrevious;
          if (vm.applyAppraiserPrevValuesSecurity || (review.totalChange && review.appraisalPeriodDeltaValue == review.totalChange)) {
            vm.invalidTotalChange = false;
          }
        }
      }
    });

    var draftValueWatch = $scope.$watch('documentsCtrl.review.appraisalDraft', function () {
      if (0 == review.appraisalDraft) {
        review.appraisalDraft = '';
        vm.invalidTotalChange = false;
      }
      priorPeriodValidations();
      if (vm.valuations && review.appraisalYearlyDelta && (!review.appraisalDraft && !review.appraisalFinal)) {
        review.appraisalYearlyDelta = 'N/A';
        review.appraisalYearlyDeltaValue = 'N/A';
      }
      if (review.appraisalPrevious && review.appraisalDraft && !review.appraisalFinal) {
        if (apprPeriodDeltaInited) {
          return;
        } else {
          review.appraisalPeriodDelta = parseFloat(((review.appraisalDraft - review.appraisalPrevious) / review.appraisalPrevious) * 100).toFixed(2);
          review.appraisalPeriodDeltaValue = review.appraisalDraft - review.appraisalPrevious;
        }
      } else if (review.appraisalPrevious && review.appraisalFinal) {
        if (apprPeriodDeltaInited) {
          return;
        } else {
          review.appraisalPeriodDelta = parseFloat(((review.appraisalFinal - review.appraisalPrevious) / review.appraisalPrevious) * 100).toFixed(2);
          review.appraisalPeriodDeltaValue = review.appraisalFinal - review.appraisalPrevious;
        }
      }

      if (previousYearlyValuation && review.appraisalDraft && !review.appraisalFinal) {
        if (apprYearlyDeltaInited) {
          return;
        } else if (!vm.applyAppraiserPrevValuesSecurity && previousYearlyValuation.appraisalFinal) {
          review.appraisalYearlyDelta = parseFloat(((review.appraisalDraft - previousYearlyValuation.appraisalFinal) / previousYearlyValuation.appraisalFinal) * 100).toFixed(2);
          review.appraisalYearlyDeltaValue = review.appraisalDraft - previousYearlyValuation.appraisalFinal;
        } else {
          review.appraisalYearlyDelta = '';
          review.appraisalYearlyDeltaValue = undefined;
        }
      } else if (previousYearlyValuation && review.appraisalFinal) {
        if (apprYearlyDeltaInited) {
          return;
        } else if (!vm.applyAppraiserPrevValuesSecurity && previousYearlyValuation.appraisalFinal) {
          review.appraisalYearlyDelta = parseFloat(((review.appraisalFinal - previousYearlyValuation.appraisalFinal) / previousYearlyValuation.appraisalFinal) * 100).toFixed(2);
          review.appraisalYearlyDeltaValue = review.appraisalFinal - previousYearlyValuation.appraisalFinal;
        } else {
          review.appraisalYearlyDelta = '';
          review.appraisalYearlyDeltaValue = undefined;
        }
      }

      review.appraisalYearlyDelta = review.appraisalYearlyDelta ? review.appraisalYearlyDelta : review.appraisalYearlyDelta === 0 ? 0 : 'N/A';
      review.appraisalYearlyDeltaValue = review.appraisalYearlyDeltaValue ? review.appraisalYearlyDeltaValue : review.appraisalYearlyDeltaValue === 0 ? 0 : 'N/A';
    });

    var finalValueWatch = $scope.$watch('documentsCtrl.review.appraisalFinal', function () {
      if (0 == review.appraisalFinal && !apprPeriodDeltaInited) {
        review.appraisalFinal = '';
      }
      priorPeriodValidations();
      if (vm.valuations && review.appraisalYearlyDelta && (!review.appraisalDraft && !review.appraisalFinal)) {
        review.appraisalYearlyDelta = 'N/A';
        review.appraisalYearlyDeltaValue = 'N/A';
      }

      if (review.appraisalPrevious && review.appraisalDraft && !review.appraisalFinal) {
        if (apprPeriodDeltaInited) {
          apprPeriodDeltaInited = false;
          if (apprYearlyDeltaInited) {
            apprYearlyDeltaInited = false;
          }
          return;
        } else {
          review.appraisalPeriodDelta = parseFloat(((review.appraisalDraft - review.appraisalPrevious) / review.appraisalPrevious) * 100).toFixed(2);
          review.appraisalPeriodDeltaValue = review.appraisalDraft - review.appraisalPrevious;
        }
      } else if (review.appraisalPrevious && review.appraisalFinal) {
        if (apprPeriodDeltaInited) {
          apprPeriodDeltaInited = false;
          if (apprYearlyDeltaInited) {
            apprYearlyDeltaInited = false;
          }
          return;
        } else {
          review.appraisalPeriodDelta = parseFloat(((review.appraisalFinal - review.appraisalPrevious) / review.appraisalPrevious) * 100).toFixed(2);
          review.appraisalPeriodDeltaValue = review.appraisalFinal - review.appraisalPrevious;
        }
      }

      if (previousYearlyValuation && review.appraisalDraft && !review.appraisalFinal) {
        if (apprYearlyDeltaInited) {
          apprYearlyDeltaInited = false;
          return;
        } else if (!vm.applyAppraiserPrevValuesSecurity && previousYearlyValuation.appraisalFinal) {
          review.appraisalYearlyDelta = parseFloat(((review.appraisalDraft - previousYearlyValuation.appraisalFinal) / previousYearlyValuation.appraisalFinal) * 100).toFixed(2);
          review.appraisalYearlyDeltaValue = review.appraisalDraft - previousYearlyValuation.appraisalFinal;
        } else {
          review.appraisalYearlyDelta = '';
          review.appraisalYearlyDeltaValue = undefined;
        }

      } else if (previousYearlyValuation && review.appraisalFinal) {
        if (apprYearlyDeltaInited) {
          apprYearlyDeltaInited = false;
          return;
        } else if (!vm.applyAppraiserPrevValuesSecurity && previousYearlyValuation.appraisalFinal) {
          review.appraisalYearlyDelta = parseFloat(((review.appraisalFinal - previousYearlyValuation.appraisalFinal) / previousYearlyValuation.appraisalFinal) * 100).toFixed(2);
          review.appraisalYearlyDeltaValue = review.appraisalFinal - previousYearlyValuation.appraisalFinal;
        } else {
          review.appraisalYearlyDelta = '';
          review.appraisalYearlyDeltaValue = undefined;
        }
      }
      apprPeriodDeltaInited = false;
      apprYearlyDeltaInited = false;

      review.appraisalYearlyDelta = review.appraisalYearlyDelta ? review.appraisalYearlyDelta : review.appraisalYearlyDelta === 0 ? 0 : 'N/A';
      review.appraisalYearlyDeltaValue = review.appraisalYearlyDeltaValue ? review.appraisalYearlyDeltaValue : review.appraisalYearlyDeltaValue === 0 ? 0 : 'N/A';

    });

    var periodPercentageWatch = $scope.$watch('documentsCtrl.review.appraisalPeriodDelta', function (newValue) {
      review.appraisalPeriodDelta = newValue;
    });

    var periodDollarWatch = $scope.$watch('documentsCtrl.review.appraisalPeriodDeltaValue', function (newValue) {
      review.appraisalPeriodDeltaValue = newValue;
      if (review.appraisalPeriodDeltaValue) {
        if (review.appraisalPeriodDeltaValue !== 'N/A' && review.appraisalPeriodDeltaValue != review.totalChange) {
          vm.invalidTotalChange = true;
        } else if (review.appraisalPeriodDeltaValue === 'N/A' && review.totalChange) {
          vm.invalidTotalChange = true;
        } else {
          vm.invalidTotalChange = false;
        }
      } else {
        apprPeriodDeltaInited = false;
        if (!review.totalChange) {
          review.totalChange = '';
          vm.invalidTotalChange = false;
        }
      }
      if ((review.appraisalPeriodDeltaValue != vm.review.totalChange) && (review.appraisalPeriodDeltaValue !== 'N/A' && vm.review.totalChange !== 0)) {
        vm.invalidTotalChange = true;
      } else if (review.appraisalPeriodDeltaValue == vm.review.totalChange) {
        vm.invalidTotalChange = false;
      }
    });

    var yearPercentageWatch = $scope.$watch('documentsCtrl.review.appraisalYearlyDelta', function (newValue) {
      review.appraisalYearlyDelta = newValue;
    });

    var yearDollarWatch = $scope.$watch('documentsCtrl.review.appraisalYearlyDeltaValue', function (newValue) {
      review.appraisalYearlyDeltaValue = newValue;
    });

    var currentCapRateWatch = $scope.$watch('documentsCtrl.review.stabilizedCapRate', function (newValue) {
      if (capRateInited) {
        capRateInited = false;
        return;
      } else if (previousQuarterlyValuation && !vm.applyAppraiserPrevValuesSecurity &&
        -1 === vm.AdminRwModifiedFields.indexOf('stabilizedCapRatePeriodDelta') && review.stabilizedCapRate && !isNaN(review.stabilizedCapRate)) {
        review.stabilizedCapRatePeriodDelta = Math.round((review.stabilizedCapRate - previousQuarterlyValuation.stabilizedCapRate / 100) * 100);
      }
      if (previousYearlyValuation && !vm.applyAppraiserPrevValuesSecurity &&
        -1 === vm.AdminRwModifiedFields.indexOf('stabilizedCapRateYearlyDelta') && review.stabilizedCapRate && !isNaN(review.stabilizedCapRate)) {
        review.stabilizedCapRateYearlyDelta = Math.round((review.stabilizedCapRate - previousYearlyValuation.stabilizedCapRate / 100) * 100);
      }

      if ((newValue && newValue === 'N/A') || newValue == "") {
        review.stabilizedCapRatePeriodDelta = 'N/A';
        review.stabilizedCapRateYearlyDelta = 'N/A';
      }
      if (newValue != undefined && !review.stabilizedCapRatePeriodDelta && review.stabilizedCapRatePeriodDelta != 0) {
        review.stabilizedCapRatePeriodDelta = 'N/A';
      }
      if (newValue != undefined && !review.stabilizedCapRateYearlyDelta && review.stabilizedCapRateYearlyDelta != 0) {
        review.stabilizedCapRateYearlyDelta = 'N/A';
      }
    });

    var capRatePeriodWatch = $scope.$watch('documentsCtrl.review.stabilizedCapRatePeriodDelta', function (newValue) {
      review.stabilizedCapRatePeriodDelta = newValue;
    });

    var capRateYearWatch = $scope.$watch('documentsCtrl.review.stabilizedCapRateYearlyDelta', function (newValue) {
      review.stabilizedCapRateYearlyDelta = newValue;
    });

    var currentTerminalRateWatch = $scope.$watch('documentsCtrl.review.terminalRate', function (newValue) {
      if (terRateInited) {
        terRateInited = false;
        return;
      } else if (previousQuarterlyValuation && !vm.applyAppraiserPrevValuesSecurity &&
        -1 === vm.AdminRwModifiedFields.indexOf('terminalRatePeriodDelta') && review.terminalRate && !isNaN(review.terminalRate)) {
        review.terminalRatePeriodDelta = Math.round((review.terminalRate - previousQuarterlyValuation.terminalRate / 100) * 100);
      }
      if (previousYearlyValuation && !vm.applyAppraiserPrevValuesSecurity &&
        -1 === vm.AdminRwModifiedFields.indexOf('terminalRateYearlyDelta') && review.terminalRate && !isNaN(review.terminalRate)) {
        review.terminalRateYearlyDelta = Math.round((review.terminalRate - previousYearlyValuation.terminalRate / 100) * 100);
      }

      if ((newValue && newValue === 'N/A') || newValue == "") {
        review.terminalRatePeriodDelta = 'N/A';
        review.terminalRateYearlyDelta = 'N/A';
      }
      if (newValue != undefined && !review.terminalRatePeriodDelta && review.terminalRatePeriodDelta != 0) {
        review.terminalRatePeriodDelta = 'N/A';
      }
      if (newValue != undefined && !review.terminalRateYearlyDelta && review.terminalRateYearlyDelta != 0) {
        review.terminalRateYearlyDelta = 'N/A';
      }
    });

    var terminalRatePeriodWatch = $scope.$watch('documentsCtrl.review.terminalRatePeriodDelta', function (newValue) {
      review.terminalRatePeriodDelta = newValue;
    });

    var terminalRateYearWatch = $scope.$watch('documentsCtrl.review.terminalRateYearlyDelta', function (newValue) {
      review.terminalRateYearlyDelta = newValue;
    });

    var currentDiscountRateWatch = $scope.$watch('documentsCtrl.review.discountRate', function (newValue) {
      if (disRateInited) {
        disRateInited = false;
        return;
      } else if (previousQuarterlyValuation && !vm.applyAppraiserPrevValuesSecurity &&
        -1 === vm.AdminRwModifiedFields.indexOf('discountRatePeriodDelta') && review.discountRate && !isNaN(review.discountRate)) {
        review.discountRatePeriodDelta = Math.round((review.discountRate - previousQuarterlyValuation.discountRate / 100) * 100);
      }
      if (previousYearlyValuation && !vm.applyAppraiserPrevValuesSecurity &&
        -1 === vm.AdminRwModifiedFields.indexOf('discountRateYearlyDelta') && review.discountRate && !isNaN(review.discountRate)) {
        review.discountRateYearlyDelta = Math.round((review.discountRate - previousYearlyValuation.discountRate / 100) * 100);
      }

      if ((newValue && newValue === 'N/A') || newValue == "") {
        review.discountRatePeriodDelta = 'N/A';
        review.discountRateYearlyDelta = 'N/A';
      }
      if (newValue != undefined && !review.discountRatePeriodDelta && review.discountRatePeriodDelta != 0) {
        review.discountRatePeriodDelta = 'N/A';
      }
      if (newValue != undefined && !review.discountRateYearlyDelta && review.discountRateYearlyDelta != 0) {
        review.discountRateYearlyDelta = 'N/A';
      }
    });

    var discountRatePeriodWatch = $scope.$watch('documentsCtrl.review.discountRatePeriodDelta', function (newValue) {
      review.discountRatePeriodDelta = newValue;
    });

    var discountRateYearWatch = $scope.$watch('documentsCtrl.review.discountRateYearlyDelta', function (newValue) {
      review.discountRateYearlyDelta = newValue;
    });

    var currentImpliedRateWatch = $scope.$watch('documentsCtrl.review.impliedCapRate', function (newValue) {
      if (impRateInited) {
        impRateInited = false;
        return;
      } else if (previousQuarterlyValuation && !vm.applyAppraiserPrevValuesSecurity &&
        -1 === vm.AdminRwModifiedFields.indexOf('impliedCapRatePeriodDelta')  && review.impliedCapRate && !isNaN(review.impliedCapRate)) {
        review.impliedCapRatePeriodDelta = Math.round((review.impliedCapRate - previousQuarterlyValuation.impliedCapRate / 100) * 100);
      }
      if (previousYearlyValuation && !vm.applyAppraiserPrevValuesSecurity &&
        -1 === vm.AdminRwModifiedFields.indexOf('impliedCapRateYearlyDelta') && review.impliedCapRate && !isNaN(review.impliedCapRate)) {
        review.impliedCapRateYearlyDelta = Math.round((review.impliedCapRate - previousYearlyValuation.impliedCapRate / 100) * 100);
      }

      if ((newValue && newValue === 'N/A') || newValue == "") {
        review.impliedCapRatePeriodDelta = 'N/A';
        review.impliedCapRateYearlyDelta = 'N/A';
      }
      if (newValue != undefined && !review.impliedCapRatePeriodDelta && review.impliedCapRatePeriodDelta != 0) {
        review.impliedCapRatePeriodDelta = 'N/A';
      }
      if (newValue != undefined && !review.impliedCapRateYearlyDelta && review.impliedCapRateYearlyDelta != 0) {
        review.impliedCapRateYearlyDelta = 'N/A';
      }
    });

    var impliedRatePeriodWatch = $scope.$watch('documentsCtrl.review.impliedCapRatePeriodDelta', function (newValue) {
      review.impliedCapRatePeriodDelta = newValue;
    });

    var impliedRateYearWatch = $scope.$watch('documentsCtrl.review.impliedCapRateYearlyDelta', function (newValue) {
      review.impliedCapRateYearlyDelta = newValue;
    });

    var stabilizedValueWatch = $scope.$watch('documentsCtrl.review.stabilizedValue', function (newValue) {
      if (stabilizedValueInited) {
        stabilizedValueInited = false;
        return;
      } else if (review.asset.leasableArea && review.stabilizedValue && !isNaN(review.stabilizedValue)) {
        review.stabilizedValueSf = review.stabilizedValue / review.asset.leasableArea;
      } else {
        review.stabilizedValueSf = undefined;
      }
      if ((newValue && newValue === 'N/A') || newValue == "") {
        review.stabilizedValueSf = 'N/A';
      }
      if (newValue != undefined && !review.stabilizedValueSf && review.stabilizedValueSf != 0) {
        //vm.disableStabilizedValueSf = false;
        review.stabilizedValueSf = 'N/A';
      }
    });

    var stabilizedSFValueWatch = $scope.$watch('documentsCtrl.review.stabilizedValueSf', function (newValue) {
      review.stabilizedValueSf = newValue;
    });

    var ppExplanationWatch = $scope.$watch('documentsCtrl.review.ppValueChangeExplanation', function () {
      if (review.ppValueChangeExplanation) {
        vm.touchedPPNotes = true;
        review.ppValueChangeExplanation.length > 800 ? vm.validPPNotes = false : vm.validPPNotes = true;
      } else if (vm.applyAppraiserPrevValuesSecurity || vm.applyAdminRwModifiedValuesSecurity) {
        vm.validPPNotes = true;
      } else {
        vm.validPPNotes = false;
      }
    });

    var yyExplanationWatch = $scope.$watch('documentsCtrl.review.yyValueChangeExplanation', function () {
      if (review.yyValueChangeExplanation) {
        vm.touchedYYNotes = true;
        review.yyValueChangeExplanation.length > 800 ? vm.validYYNotes = false : vm.validYYNotes = true;
      } else if (vm.applyAppraiserPrevValuesSecurity || vm.applyAdminRwModifiedValuesSecurity) {
        vm.validYYNotes = true;
      } else {
        vm.validYYNotes = false;
      }
    });

    var factorValuesWatch = $scope.$watch('documentsCtrl.factorValues', function () {
      review.totalChange = parseFloat(vm.factorValues.deltaDiscountRate || 0) + parseFloat(vm.factorValues.deltaTerminalCapRate || 0) + parseFloat(vm.factorValues.deltaAvgMarketRentGrowth || 0)
        + parseFloat(vm.factorValues.deltaMarketRents || 0) + parseFloat(vm.factorValues.deltaContractRents || 0) + parseFloat(vm.factorValues.deltaVacancyAndCollectionLoss || 0)
        + parseFloat(vm.factorValues.deltaDowntimeAndRenewalProbability || 0) + parseFloat(vm.factorValues.deltaExpenses || 0) + parseFloat(vm.factorValues.deltaRealEstateTaxes || 0)
        + parseFloat(vm.factorValues.deltaBuildingCapital || 0) + parseFloat(vm.factorValues.deltaLeasingCapital || 0) + parseFloat(vm.factorValues.deltaOther || 0);
      if (!vm.applyAppraiserPrevValuesSecurity && (review.appraisalPrevious && review.appraisalPeriodDeltaValue !== 'N/A' && review.appraisalPeriodDeltaValue != vm.review.totalChange)) {
        vm.invalidTotalChange = true;
      } else if ((review.appraisalPeriodDeltaValue == vm.review.totalChange) || (review.appraisalPeriodDeltaValue !== 'N/A' && !vm.review.totalChange)) {
        vm.invalidTotalChange = false;
      }
    }, true);

    var totalChangeWatch = $scope.$watch('documentsCtrl.executiveSummaryForm.$submitted', function () {
      if ((!vm.applyAppraiserPrevValuesSecurity && !review.appraisalPeriodDeltaValue && 0 !== review.totalChange) ||
        (!vm.applyAppraiserPrevValuesSecurity && review.appraisalPrevious && review.appraisalPeriodDeltaValue != vm.review.totalChange)) {
        vm.invalidTotalChange = true;
      } else if (vm.applyAppraiserPrevValuesSecurity || (review.appraisalPeriodDeltaValue == vm.review.totalChange) ||
        (!review.appraisalPeriodDeltaValue && 0 === review.totalChange) ||
        (vm.applyAppraiserPrevValuesSecurity && review.appraisalPeriodDeltaValue !== 'N/A' && !vm.review.totalChange)) {
        vm.invalidTotalChange = false;
      }
    }, true);

    $scope.$on('$destroy', function () {
      previousValueWatch();
      draftValueWatch();
      finalValueWatch();
      periodPercentageWatch();
      periodDollarWatch();
      yearPercentageWatch();
      yearDollarWatch();
      currentCapRateWatch();
      capRatePeriodWatch();
      capRateYearWatch();
      currentTerminalRateWatch();
      terminalRatePeriodWatch();
      terminalRateYearWatch();
      currentDiscountRateWatch();
      discountRatePeriodWatch();
      discountRateYearWatch();
      currentImpliedRateWatch();
      impliedRatePeriodWatch();
      impliedRateYearWatch();
      stabilizedValueWatch();
      stabilizedSFValueWatch();
      ppExplanationWatch();
      yyExplanationWatch();
      factorValuesWatch();
      totalChangeWatch();
    });
  }

})();

(function () {
  'use strict';

  angular
  .module('nvc')
  .controller('SummaryController', SummaryController);

  /**@ngInject*/
  function SummaryController($window, UserService, review, SessionManager, ValuationFactory, subtypesByPropertyTypes,
                             prevValuationsObj){
    var vm = this;

    vm.superSummeryOpened = false;
    vm.review = review;
    vm.subtypesByPropertyTypes = subtypesByPropertyTypes[vm.review.asset.type];
    vm.user = null;
    vm.role = SessionManager.getRoleName();
    vm.applyAdminRwModifiedValuesSecurity = false;
    vm.applyAppraiserPrevValuesSecurity = false;
    vm.modifiedByAdminOrReviewerFields = [];
    var localPrevValuationsObj = prevValuationsObj;

    if (review.status !== 'Created' && review.appraisalDraft) { // means not the first time fill
      review.landAndOtherAdj = review.landAndOtherAdj ? review.landAndOtherAdj : review.landAndOtherAdj === 0 ? 0 : 'N/A';
      review.discountedCashFlowAnalysis = review.discountedCashFlowAnalysis ? review.discountedCashFlowAnalysis : review.discountedCashFlowAnalysis === 0 ? 0 : 'N/A';
      review.directCapitalizationAnalysis = review.directCapitalizationAnalysis ? review.directCapitalizationAnalysis : review.directCapitalizationAnalysis === 0 ? 0 : 'N/A';
      review.stabilizedValue = review.stabilizedValue ? review.stabilizedValue : review.stabilizedValue === 0 ? 0 : 'N/A';
      review.stabilizedValueSf = review.stabilizedValueSf ? review.stabilizedValueSf : review.stabilizedValueSf === 0 ? 0 : 'N/A';
      review.absorptionPeriod = review.absorptionPeriod ? review.absorptionPeriod : review.absorptionPeriod === 0 ? 0 : 'N/A';
      review.salesComparisonApproach = review.salesComparisonApproach ? review.salesComparisonApproach : review.salesComparisonApproach === 0 ? 0 : 'N/A';
      review.costApproach = review.costApproach ? review.costApproach : review.costApproach === 0 ? 0 : 'N/A';
      review.insurableValue = review.insurableValue ? review.insurableValue : review.insurableValue === 0 ? 0 : 'N/A';
      review.stabilizedCapRate = review.stabilizedCapRate ? review.stabilizedCapRate : review.stabilizedCapRate === 0 ? 0 : 'N/A';
      review.terminalRate = review.terminalRate ? review.terminalRate : review.terminalRate === 0 ? 0 : 'N/A';
      review.discountRate = review.discountRate ? review.discountRate : review.discountRate === 0 ? 0 : 'N/A';
      review.impliedCapRate = review.impliedCapRate ? review.impliedCapRate : review.impliedCapRate === 0 ? 0 : 'N/A';
      review.avgContractRent = review.avgContractRent ? review.avgContractRent : review.avgContractRent === 0 ? 0 : 'N/A';
      review.avgRentGrowth = review.avgRentGrowth ? review.avgRentGrowth : review.avgRentGrowth === 0 ? 0 : 'N/A';
      review.avgMarketRent = review.avgMarketRent ? review.avgMarketRent : review.avgMarketRent === 0 ? 0 : 'N/A';
      review.ppValueChangeExplanation = review.ppValueChangeExplanation ? review.ppValueChangeExplanation : review.ppValueChangeExplanation === 0 ? 0 : 'N/A';
      review.yyValueChangeExplanation = review.yyValueChangeExplanation ? review.yyValueChangeExplanation : review.yyValueChangeExplanation === 0 ? 0 : 'N/A';
      review.appraisalPeriodDelta = review.appraisalPeriodDelta ? review.appraisalPeriodDelta : review.appraisalPeriodDelta === 0 ? 0 : 'N/A';
      review.appraisalYearlyDelta = review.appraisalYearlyDelta ? review.appraisalYearlyDelta : review.appraisalYearlyDelta === 0 ? 0 : 'N/A';
      review.appraisalYearlyDeltaValue = review.appraisalYearlyDeltaValue ? review.appraisalYearlyDeltaValue : review.appraisalYearlyDeltaValue === 0 ? 0 : 'N/A';
      review.stabilizedCapRatePeriodDelta = review.stabilizedCapRatePeriodDelta ? review.stabilizedCapRatePeriodDelta : review.stabilizedCapRatePeriodDelta === 0 ? 0 : 'N/A';
      review.stabilizedCapRateYearlyDelta = review.stabilizedCapRateYearlyDelta ? review.stabilizedCapRateYearlyDelta : review.stabilizedCapRateYearlyDelta === 0 ? 0 : 'N/A';
      review.terminalRatePeriodDelta = review.terminalRatePeriodDelta ? review.terminalRatePeriodDelta : review.terminalRatePeriodDelta === 0 ? 0 : 'N/A';
      review.terminalRateYearlyDelta = review.terminalRateYearlyDelta ? review.terminalRateYearlyDelta : review.terminalRateYearlyDelta === 0 ? 0 : 'N/A';
      review.discountRatePeriodDelta = review.discountRatePeriodDelta ? review.discountRatePeriodDelta : review.discountRatePeriodDelta === 0 ? 0 : 'N/A';
      review.discountRateYearlyDelta = review.discountRateYearlyDelta ? review.discountRateYearlyDelta : review.discountRateYearlyDelta === 0 ? 0 : 'N/A';
      review.impliedCapRatePeriodDelta = review.impliedCapRatePeriodDelta ? review.impliedCapRatePeriodDelta : review.impliedCapRatePeriodDelta === 0 ? 0 : 'N/A';
      review.impliedCapRateYearlyDelta = review.impliedCapRateYearlyDelta ? review.impliedCapRateYearlyDelta : review.impliedCapRateYearlyDelta === 0 ? 0 : 'N/A';
    }

    if('AssetAppraisal' === vm.role) {

      if((!localPrevValuationsObj.previousQuarterlyValuation ||
        (1 === review.quarterOfCycle && review.valuationCycle !== 1 &&
        localPrevValuationsObj.previousQuarterlyValuation && localPrevValuationsObj.previousQuarterlyValuation.appraiserCompanyId !== SessionManager.getCompanyId()) ||
        (1 !== review.quarterOfCycle && localPrevValuationsObj.previousQuarterlyValuation &&
        (localPrevValuationsObj.previousQuarterlyValuation.appraiserCompanyId &&
        localPrevValuationsObj.previousQuarterlyValuation.appraiserCompanyId !== SessionManager.getCompanyId())))){

        // if (review.status !== 'DocumentsUploaded') {
        //   if (review.modifiedByAdminOrReviewerFields) {
        //     vm.modifiedByAdminOrReviewerFields = review.modifiedByAdminOrReviewerFields.split(',');
        //     if (vm.modifiedByAdminOrReviewerFields[0] !== '') {
        //       vm.applyAdminRwModifiedValuesSecurity = true;
        //     }
        //   }
        // }
        vm.applyAppraiserPrevValuesSecurity = true;
        removePreviousValuationFields();
      }
    }

    if(review.status == 'ValuationSignedOff' || review.status == 'FinalDocumentsUploaded' && !review.appraisalFinal) {
      review.appraisalFinal = review.appraisalDraft;
    }

    UserService.getUser().then(function (user) {
      vm.user = user;
      if (review.status === 'ManagerApproveValuation' && (SessionManager.isInRole('Admin') || (vm.user
        && vm.user.id === review.asset.primaryAssetReviewer.user.id))) {
        vm.superSummeryOpened = true;
      }
    });

    for (var i = 0; i < vm.subtypesByPropertyTypes.length; i++) {
      if(vm.review.asset.subType == vm.subtypesByPropertyTypes[i].type) {
        vm.review.asset.subType = vm.subtypesByPropertyTypes[i].name;
        break;
      }
    }

    vm.downloadValuation = function(){
      ValuationFactory.getDocumentDownloadData(review.getLastValuationReport()).then(function(downloadData){
        $window.open(downloadData, '_blank');
      });
    };

    function removePreviousValuationFields() {
      vm.review.appraisalPrevious = undefined;
      //p/y value to current value
      vm.review.appraisalPeriodDelta = undefined;
      vm.review.appraisalPeriodDeltaValue = undefined;
      vm.review.appraisalYearlyDelta = undefined;
      vm.review.appraisalYearlyDeltaValue = undefined;
      //p/p y/y deltas
      vm.review.stabilizedCapRatePeriodDelta = undefined;
      vm.review.stabilizedCapRateYearlyDelta = undefined;
      vm.review.terminalRatePeriodDelta = undefined;
      vm.review.terminalRateYearlyDelta = undefined;
      vm.review.discountRatePeriodDelta = undefined;
      vm.review.discountRateYearlyDelta = undefined;
      vm.review.impliedCapRatePeriodDelta = undefined;
      vm.review.impliedCapRateYearlyDelta = undefined;
      //deltas
      vm.review.deltaDiscountRate = undefined;
      vm.review.deltaTerminalCapRate = undefined;
      vm.review.deltaAvgMarketRentGrowth = undefined;
      vm.review.deltaMarketRents = undefined;
      vm.review.deltaContractRents = undefined;
      vm.review.deltaVacancyAndCollectionLoss = undefined;
      vm.review.deltaDowntimeAndRenewalProbability = undefined;
      vm.review.deltaExpenses = undefined;
      vm.review.deltaRealEstateTaxes = undefined;
      vm.review.deltaBuildingCapital = undefined;
      vm.review.deltaLeasingCapital = undefined;
      vm.review.deltaOther = undefined;
      vm.review.totalChange = undefined;
      // explanations
      //vm.review.ppValueChangeExplanation = undefined;
      //vm.review.yyValueChangeExplanation = undefined;
    }
  }

})();

(function () {
  'use strict';

  angular
  .module('nvc')
  .config(routeConfig);

  function routeConfig($stateProvider) {
    $stateProvider.state('app.review.discussion', {
      url: '/review',
      views:{
        '':{
          templateUrl: 'app/states/valuations/review/discussion/discussion.html',
          controller: 'DiscussionController',
          controllerAs: 'discussionCtrl'
        },
        'summary@app.review.discussion': {
          templateUrl: 'app/states/valuations/review/discussion/summary.html',
          controller: 'SummaryController',
          controllerAs: 'summaryCtrl'
        },
        'comments@app.review.discussion':{
          templateUrl: 'app/states/valuations/review/discussion/comments.html',
          controller: 'CommentsController',
          controllerAs: 'commentsCtrl'
        }
      },
      data:{
        viewClass: 'discussion',
        roles:['Admin', 'Audit', 'AssetManagement', 'AssetAppraisal', 'AssetReview', 'AssetManagerReadOnly']
      },
      resolve: {
        /** @ngInject */
        subtypesByPropertyTypes: function (StaticDataService) {
          return StaticDataService.getSubtypesByPropertyTypes();
        }
      }
    })
  }

})();


(function () {
  'use strict';

  angular
  .module('nvc')
  .controller('DiscussionController', DiscussionController);

  /**@ngInject*/
  function DiscussionController($state){
    var vm = this;
    if($state.current.name === 'app.review.discussion'){
      $state.go('app.review.discussion.comments', {}, {location:'replace'});
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .controller('CommentsController', CommentsController);

  /**@ngInject*/
  function CommentsController(review) {
    var vm = this;
    vm.review = review;
    vm.filter = '';
  }
})();

(function () {
  'use strict';

  angular
  .module('nvc')
  .config(routeConfig);

  function routeConfig($stateProvider) {
    $stateProvider.state('app.manage.users.details', {
      url: '/details/:companyId/:id',
      views: {
        '@app': {
          templateUrl: 'app/states/manage/users/user-details/user-details.html',
          controller: 'UserDetailsController',
          controllerAs: 'userDetailsCtrl'
        }
      },
      data: {
        pageTitle: 'User Detail',
        viewClass: 'user-details',
        roles: ['Admin', 'Audit', 'AssetManagement', 'AssetAppraisal', 'AssetReview', 'AssetManagerReadOnly']
      },
      params: {
        id: '',
        companyId: '',
        user: null
      },
      resolve: {
        /** @ngInject */
        user: function ($q, $stateParams, UserService, CompanyService, SessionManager) {
          if (!$stateParams.id) {
            return $q.reject({
              error: 'invalidTransition',
              fallback: 'app.manage.users'
            });
          }
          if ($stateParams.user) {
            return $stateParams.user;
          }
          var usersPromise;
          if(SessionManager.getCompanyId() == $stateParams.companyId){
            usersPromise = UserService.getUsersByCompanyId($stateParams.companyId, true);
          }else{
            usersPromise = UserService.getRelatedUsersByCompanyId($stateParams.companyId, true);
          }
          return usersPromise.then(function (users) {
            for (var i = 0; i < users.length; i++) {
              if (users[i].user.id == $stateParams.id) {
                return CompanyService.getCompany($stateParams.companyId).then(function (company) {
                  users[i].account = users[i].userAccount;
                  return angular.merge(users[i], {company: company});
                });
              }
            }
          });
        },
        /** @ngInject */
        states: function (StaticDataService) {
          return StaticDataService.getAllStates()
        },
        /** @ngInject */
        propertyTypes: function (StaticDataService) {
          return StaticDataService.getPropertyTypes()
        }
      }
    });
  }

})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .controller('UserDetailsController', EditUserController);

  /** @ngInject */
  function EditUserController($filter, user, states, propertyTypes) {
    var vm = this;

    vm.user = user;
    vm.user.user.readOnlyAssetManager = false;
    vm.statesByCountry = states;
    vm.propertyTypes = propertyTypes.items;
    vm.countries = [
      'United States',
      'Mexico'
    ];

    vm.certifications = {
      mai: false,
      cre: false,
      frics: false,
      cpa: false,
      cfa: false,
      mrics: false
    };

    if (vm.user.user.assetTypeSpecialties && vm.user.user.assetTypeSpecialties.length > 0) {
      for (var i = 0; i < vm.propertyTypes.length; i++) {
        for (var j = 0; j < vm.user.user.assetTypeSpecialties.length; j++) {
          if (vm.propertyTypes[i].type == vm.user.user.assetTypeSpecialties[j]) {
            vm.user.user.assetTypeSpecialties[j] = vm.propertyTypes[i];
          }
        }
      }
    }

    if (vm.user.user.certifications && vm.user.user.certifications.length > 0) {
      for (i = 0; i < vm.user.user.certifications.length; i++) {
        angular.forEach(vm.certifications, function (value, key) {
          if (key == vm.user.user.certifications[i]) {
            vm.certifications[key] = true;
          }
        });
      }
    }

    if(vm.user.user.userCompanyRoles && vm.user.user.userCompanyRoles.length > 1) {
      for(var i = 0; i < vm.user.user.userCompanyRoles.length; i ++) {
        if(vm.user.user.userCompanyRoles[i] == 'AssetManagerReadOnly') {
          vm.user.user.readOnlyAssetManager = true;
          break;
        }
      }
    } else if(vm.user.user.userCompanyRoles && vm.user.user.userCompanyRoles[0] == 'AssetManagerReadOnly') {
      vm.user.user.readOnlyAssetManager = true;
    }

    vm.user.user.certifications = [];
    vm.editUserView = true;
    vm.companyName = 'companyName';
    vm.title = $filter('translate')('USER_DETAIL.USER_TITLE');

    if (!vm.user.user.active || !vm.user.company.active) {
      vm.title = $filter('translate')(vm.user.user.name) + ' (' + $filter('translate')('COMMONS.INACTIVATED') + ')';
    }

    vm.breadcrumbs = [
      {
        label: $filter('translate')('USERS.MANAGE'),
        value: 'app.manage.users'
      },
      {
        label: $filter('translate')('USERS.USERS'),
        value: 'app.manage.users'
      },
      {
        label: $filter('translate')('USER_DETAIL.USER_TITLE'),
        value: 'app.manage.users.details'
      }
    ];

  }

})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .config(routeConfig);

  function routeConfig($stateProvider) {
    $stateProvider.state('app.manage.users.editUser', {
      url: '/edit-user/:companyId/:id',
      views: {
        '@app': {
          templateUrl: 'app/states/manage/users/edit-user/edit-user.html',
          controller: 'EditUserController',
          controllerAs: 'editUser'
        }
      },
      data: {
        pageTitle: 'Edit User',
        viewClass: 'edit-user',
        roles: ['Admin']
      },
      params: {
        id: '',
        companyId: '',
        userCompanyRelationshipId: '',
        user: null
      },
      resolve: {
        /** @ngInject */
        user: function ($q, $stateParams, UserService, UserAccountService, CompanyService) {
          if (!$stateParams.id) {
            return $q.reject({
              error: 'invalidTransition',
              fallback: 'app.manage.users'
            });
          }
          return UserService.getUser($stateParams.id).then(function (user) {
            if ($stateParams.userCompanyRelationshipId) {
              user.userCompanyRelationshipId = $stateParams.userCompanyRelationshipId;
              return UserAccountService.getAccount(user.userAccountId).then(function (account) {
                return CompanyService.getCompany($stateParams.companyId).then(function (company) {
                  return {user: user, account: account, company: company};
                });
              });
            } else {
              return UserService.getUsersByCompanyId($stateParams.companyId).then(function (users) {
                users.forEach(function (companyUser) {
                  if(companyUser.user.id == user.id) {
                    user.userCompanyRelationshipId = companyUser.id;
                  }
                });
                return UserAccountService.getAccount(user.userAccountId).then(function (account) {
                  return CompanyService.getCompany($stateParams.companyId).then(function (company) {
                    return {user: user, account: account, company: company};
                  });
                });
              });
            }
          });
        },
        /** @ngInject */
        states: function (StaticDataService) {
          return StaticDataService.getAllStates()
        },
        /** @ngInject */
        propertyTypes: function (StaticDataService) {
          return StaticDataService.getPropertyTypes()
        }
      }
    });
  }

})();

(function() {
  'use strict';

  angular
    .module('nvc')
    .controller('EditUserController', EditUserController);

  /** @ngInject */
  function EditUserController($q, $scope, $state, $filter, notify, LoaderHelper, UserService, UserAccountService, user, states, propertyTypes) {
    var vm = this;

    vm.user = user;
    vm.user.user.readOnlyAssetManager = false;
    vm.statesByCountry = states;
    vm.allStatesByCountry = 'All';
    vm.propertyTypes = propertyTypes.items;
    vm.countries = [
      'United States',
      'Mexico'
    ];
    vm.selectedCountry = vm.user.user.workedOnCountries && vm.user.user.workedOnCountries.length > 0 ? vm.user.user.workedOnCountries[0] : undefined;

    for(var i = 0; i < vm.countries.length; i++){
      vm.statesByCountry[vm.countries[i]].unshift(vm.allStatesByCountry);
    }

    vm.certifications = {
      mai: false,
      cre: false,
      frics: false,
      cpa: false,
      cfa: false,
      mrics: false
    };

    if(vm.user.user.assetTypeSpecialties && vm.user.user.assetTypeSpecialties.length > 0) {
      for(i = 0; i < vm.propertyTypes.length; i++) {
        for(var j = 0; j < vm.user.user.assetTypeSpecialties.length; j++) {
          if(vm.propertyTypes[i].type == vm.user.user.assetTypeSpecialties[j]) {
            vm.user.user.assetTypeSpecialties[j] = vm.propertyTypes[i];
          }
        }
      }
    }

    if(vm.user.user.certifications && vm.user.user.certifications.length > 0) {
      for(i = 0; i < vm.user.user.certifications.length; i++) {
        angular.forEach(vm.certifications, function (value, key) {
          if(key == vm.user.user.certifications[i]) {
            vm.certifications[key] = true;
          }
        });
      }
    }

    if(vm.user.user.userCompanyRoles && vm.user.user.userCompanyRoles.length > 1) {
      for(var i = 0; i < vm.user.user.userCompanyRoles.length; i ++) {
        if(vm.user.user.userCompanyRoles[i] == 'AssetManagerReadOnly') {
          vm.user.user.readOnlyAssetManager = true;
          break;
        }
      }
    } else if(vm.user.user.userCompanyRoles && vm.user.user.userCompanyRoles[0] == 'AssetManagerReadOnly') {
      vm.user.user.readOnlyAssetManager = true;
    }

    vm.user.user.certifications = [];
    vm.editUserView = true;
    vm.companyName = 'companyName';

    if (!vm.user.user.active || !vm.user.company.active) {
      vm.title = $filter('translate')(vm.user.user.name) + ' (' + $filter('translate')('COMMONS.INACTIVATED') + ')';
    } else {
      vm.title = $filter('translate')('EDIT_USER.EDIT_USER_TITLE');
    }

    vm.breadcrumbs = [
      {
        label: $filter('translate')('USERS.MANAGE'),
        value: 'app.manage.users'
      },
      {
        label: $filter('translate')('USERS.USERS'),
        value: 'app.manage.users'
      },
      {
        label: $filter('translate')('USERS.EDIT_USER'),
        value: 'app.manage.users.editUser'
      }
    ];

    vm.resendOnboardingEmail = function(user) {
      var userDTO = angular.copy(user);
      UserAccountService.resendOnboardingEmail(userDTO.account).then(function(){
        notify({
          message: $filter('translate')('COMMONS.RESEND_ONBOARD_EMAIL'),
          duration: 4000,
          templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
          classes: 'alert-info',
          position: 'center'
        });
        //$state.go('login');
      },function(response){
        LoaderHelper.close();
        if(response.status === 400 && response.statusText === "Bad Request"){
          SweetAlert.swal({
            title: $filter('translate')('FORGOT_PASSWORD.WRONG_EMAIL'),
            text: $filter('translate')('FORGOT_PASSWORD.WRONG_EMAIL_TEXT'),
            type: "warning",
            confirmButtonColor: '#2c3d4e',
            confirmButtonText: $filter('translate')('COMMONS.OK'),
            closeOnConfirm: true,
            closeOnCancel: true
          });
        }
      });
    };

    vm.saveUser = function(user) {
      var promiseArray = [];
      var userDTO = angular.copy(user);
      LoaderHelper.open();
      if(userDTO.user.assetTypeSpecialties) {
        for (var i = 0; i < userDTO.user.assetTypeSpecialties.length; i++) {
          userDTO.user.assetTypeSpecialties[i] = userDTO.user.assetTypeSpecialties[i].type;
        }
        userDTO.user.assetTypeSpecialties.toString();
      }
      userDTO.user.workedOnCountries = [];
      userDTO.user.workedOnCountries.push(vm.selectedCountry);
      promiseArray.push(UserService.updateUser(userDTO.user));
      promiseArray.push(UserAccountService.updateAccount(userDTO.account));
      if(userDTO.user.userCompanyRoles.length == 1 &&
        ('AssetManagerReadOnly' == userDTO.user.userCompanyRoles[0] || 'AssetManager' == userDTO.user.userCompanyRoles[0])) {
        var userCompanyDTO = {id: userDTO.user.userCompanyRelationshipId, readOnlyAssetManager: userDTO.user.readOnlyAssetManager};
        promiseArray.push(UserService.updateAMUser(userCompanyDTO));
      }
      return $q.all(promiseArray).then(function() {
        notify({
          message: $filter('translate')('COMMONS.USER_UPDATED'),
          duration: 4000,
          templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
          classes: 'alert-info',
          position: 'center'
        });
        $state.go('app.manage.users', {}, { reload: true });
      }, function () {
        LoaderHelper.close();
        vm.editUserForm.$submitted = false;
      });
    };

    var certificationsWatch = $scope.$watchCollection('editUser.certifications', function() {
      vm.user.user.certifications = [];
      angular.forEach(vm.certifications, function (value, key) {
        if (value) {
          vm.user.user.certifications.push(key);
        }
      });
    }, true);

    var stateChangedEvent = $scope.$watch('editUser.user.user.workedOnStates', function(newValue){
      if(newValue){
        var statesCopy = angular.copy(vm.statesByCountry);
        for (var i = 0; i < vm.user.user.workedOnStates.length; i++) {
          if (vm.user.user.workedOnStates[i] == "All") {
            vm.user.user.workedOnStates = statesCopy[vm.selectedCountry];
            vm.user.user.workedOnStates.splice(0,1);
          }
        }
      }
    });

    $scope.$on('$destroy', function() {
      stateChangedEvent();
      certificationsWatch();
    });
  }
  
})();

(function(){
  'use strict';

  angular
  .module('nvc')
  .config(routeConfig);

  function routeConfig($stateProvider){
    $stateProvider.state('app.manage.users.addUser', {
      url: '/add-user',
      views: {
        '@app': {
          templateUrl: 'app/states/manage/users/add-user/add-user.html',
          controller: 'AddUserController',
          controllerAs: 'addUserCtrl'
        }
      },
      data: {
        pageTitle: 'Add User',
        viewClass: 'add-user',
        roles: ['Admin']
      },
      resolve: {
        /** @ngInject */
        companies: function (CompanyService) {
          return CompanyService.getAllCompanies(true, true);
        },
        /** @ngInject */
        states: function (StaticDataService) {
          return StaticDataService.getAllStates()
        },
        /** @ngInject */
        propertyTypes: function (StaticDataService) {
          return StaticDataService.getPropertyTypes()
        }
      }
    });
  }
  
})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .controller('AddUserController', AddUserController);

  /** @ngInject */
  function AddUserController($filter, $scope, $state, notify, LoaderHelper, UserService, companies, states, propertyTypes) {
    var vm = this;

    vm.title = $filter('translate')('NEW_USER.NEW_USER_TITLE');
    vm.breadcrumbs = [
      {
        label: $filter('translate')('USERS.MANAGE'),
        value: 'app.manage.users'
      },
      {
        label: $filter('translate')('USERS.USERS'),
        value: 'app.manage.users'
      },
      {
        label: $filter('translate')('USERS.NEW_USER'),
        value: 'app.manage.users.addUser'
      }
    ];
    vm.companies = companies;
    vm.allStatesByCountry = 'All';
    vm.statesByCountry = states;
    vm.propertyTypes = propertyTypes.items;
    vm.countries = [
      'United States',
      'Mexico'
    ];

    for(var i = 0; i < vm.countries.length; i++){
      vm.statesByCountry[vm.countries[i]].unshift(vm.allStatesByCountry);
    }

    vm.certifications = {
      mai: false,
      cre: false,
      frics: false,
      cpa: false,
      cfa: false,
      mrics: false
    };

    vm.newUser = {
      name: '',
      companyId: null,
      email: '',
      mobilePhone: '',
      officePhone: '',
      workedOnCountries: [],
      workedOnStates: [],
      assetTypeSpecialties: [],
      certifications: [],
      readOnlyAssetManager: false
    };

    vm.createUser = function (user) {
      var userDTO = angular.copy(user);
      userDTO.companyId = userDTO.companyId.id;
      for (var i = 0; i < userDTO.assetTypeSpecialties.length; i++) {
        userDTO.assetTypeSpecialties[i] = userDTO.assetTypeSpecialties[i].type;
      }
      userDTO.workedOnCountries = [];
      userDTO.workedOnCountries.push(vm.selectedCountry);
      userDTO.assetTypeSpecialties.toString();
      userDTO.certifications.toString();
      LoaderHelper.open();
      UserService.createUser(userDTO).then(function () {
        notify({
          message: $filter('translate')('COMMONS.NEW_USER_CREATED'),
          duration: 4000,
          templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
          classes: 'alert-info',
          position: 'center'
        });
        $state.go('app.manage.users', {}, { reload: true });
      }, function () {
        LoaderHelper.close();
        vm.addUserForm.$submitted = false;
      });
    };

    var certificationsWatch = $scope.$watchCollection('addUserCtrl.certifications', function() {
      vm.newUser.certifications = [];
      angular.forEach(vm.certifications, function (value, key) {
        if (value) {
          vm.newUser.certifications.push(key);
        }
      });
    }, true);

    var stateChangedEvent = $scope.$watch('addUserCtrl.newUser.workedOnStates', function(newValue){
      if (newValue) {
        var statesCopy = angular.copy(vm.statesByCountry);
        for (var i = 0; i < vm.newUser.workedOnStates.length; i++) {
          if (vm.newUser.workedOnStates[i] == "All") {
            vm.newUser.workedOnStates = statesCopy[vm.selectedCountry];
            vm.newUser.workedOnStates.splice(0, 1);
          }
        }
      }
    });

    $scope.$on('$destroy', function() {
      stateChangedEvent();
      certificationsWatch();
    });
  }
})();

(function () {
  'use strict';

  angular
  .module('nvc')
  .config(routeConfig);

  function routeConfig($stateProvider) {
    $stateProvider.state('app.manage.reviewers.newReviewer', {
      url: '/new-reviewers-firm',
      views: {
        '@app': {
          templateUrl: 'app/states/manage/reviewers/new-reviewer/new-reviewer.html',
          controller: 'AddReviewerController',
          controllerAs: 'addReviewerCtrl'
        }
      },
      data: {
        pageTitle: 'New Reviewer',
        viewClass: 'new-reviewer'
      }
    });
  }

})();
(function () {
  'use strict';

  angular
  .module('nvc')
  .controller('AddReviewerController', AddReviewerController);

  /** @ngInject */
  function AddReviewerController($filter, $state, notify, LoaderHelper, CompanyService) {

    var vm = this;

    //Breadcrums
    //-------------------------------------
    vm.title = $filter('translate')('NEW_REVIEWER.MAIN_TITLE');
    vm.breadcrumbs = [
      {
        label: $filter('translate')('COMMONS.MANAGE'),
        value: 'app.manage.reviewers'
      },
      {
        label: $filter('translate')('COMPANIES.MAIN_TITLE_REVIEWERS_FIRMS'),
        value: 'app.manage.reviewers'
      },
      {
        label: $filter('translate')('NEW_REVIEWER.MAIN_TITLE'),
        value: 'app.manage.reviewers.newReviewer'
      }
    ];

    //Save Form
    //-------------------------------------
    vm.reviewer = {};

    vm.createReviewer = function () {
      LoaderHelper.open();
      CompanyService.createReviewerCompany(vm.reviewer).then(function () {
        notify({
          message: $filter('translate')('COMMONS.NEW_REVIEWER_CREATED'),
          duration: 4000,
          templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
          classes: 'alert-info',
          position: 'center'
        });
        $state.go('app.manage.reviewers', {}, {reload: true});
      }, function () {
        LoaderHelper.close();
        vm.addNewReviewer.$submitted = false;
      });
    };

  }

})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .config(routeConfig);

  function routeConfig($stateProvider) {
    $stateProvider.state('app.manage.reviewers.editReviewer', {
      url: '/edit-reviewers-firm/:companyId',
      views: {
        '@app': {
          templateUrl: 'app/states/manage/reviewers/edit-reviewer/edit-reviewer.html',
          controller: 'EditReviewerController',
          controllerAs: 'editReviewerCtrl'
        }
      },
      data: {
        pageTitle: 'Edit Reviewers Firm',
        viewClass: 'edit-reviewer',
        roles: ['Admin']
      },
      params: {
        companyId: ''
      },
      resolve: {
        /** @ngInject */
        reviewerCompany: function($q, $stateParams, CompanyService) {
          if (!$stateParams.companyId) {
            return $q.reject({
              error: 'invalidTransition',
              fallback: 'app.manage.reviewers'
            });
          }
          return CompanyService.getCompany($stateParams.companyId);
        }
      }
    });
  }

})();
(function () {
  'use strict';

  angular
    .module('nvc')
    .controller('EditReviewerController', EditReviewerController);

  /** @ngInject*/
  function EditReviewerController($state, $filter, notify, LoaderHelper, CompanyService, reviewerCompany) {
    var vm = this;

    vm.reviewerCompany = reviewerCompany;
    vm.editReviewer = {};

    //Breadcrums
    //-------------------------------------
    vm.title = $filter('translate')('COMMONS.EDIT_REVIEWER_FIRM');
    vm.breadcrumbs = [
      {
        label: $filter('translate')('COMMONS.MANAGE'),
        value: 'app.manage.reviewers'
      },
      {
        label: $filter('translate')('COMPANIES.MAIN_TITLE_REVIEWERS_FIRMS'),
        value: 'app.manage.reviewers'
      },
      {
        label: $filter('translate')('COMMONS.EDIT_REVIEWER_FIRM'),
        value: 'app.manage.reviewers.editReviewer'
      }
    ];

    //Save Form
    //-------------------------------------
    vm.updateReviewer = function (reviewer) {
      var reviewerDTO = angular.copy(reviewer);
      reviewerDTO.address = reviewer.address.address;
      LoaderHelper.open();
      CompanyService.updateReviewerCompany(reviewerDTO).then(function () {
        notify({
          message: $filter('translate')('COMMONS.REVIEWER_UPDATED'),
          duration: 4000,
          templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
          classes: 'alert-info',
          position: 'center'
        });
        $state.go('app.manage.reviewers', {}, {reload: true});
      }, function () {
        LoaderHelper.close();
        vm.editReviewer.$submitted = false;
      });
    };

  }
})();
(function () {
  'use strict';

  angular
  .module('nvc')
  .config(routeConfig);

  function routeConfig($stateProvider) {
    $stateProvider.state('app.manage.clients.newClient', {
      url: '/new-asset-management-firm',
      views: {
        '@app': {
          templateUrl: 'app/states/manage/clients/new-client/new-client.html',
          controller: 'AddClientController',
          controllerAs: 'addClient'
        }
      },
      data: {
        pageTitle: 'New Asset Management Firm',
        viewClass: 'new-client'
      }
    });
  }

})();
(function () {
  'use strict';

  angular
  .module('nvc')
  .controller('AddClientController', AddClientController);

  /** @ngInject */
  function AddClientController($filter, $state, notify, LoaderHelper, CompanyService) {

    var vm = this;

    //Breadcrums
    //-------------------------------------
    vm.title = $filter('translate')('NEW_CLIENT.MAIN_TITLE');
    vm.breadcrumbs = [
      {
        label: $filter('translate')('COMMONS.MANAGE'),
        value: 'app.manage.clients'
      },
      {
        label: $filter('translate')('COMPANIES.MAIN_TITLE_ASSET_MANAGEMENT_FIRMS'),
        value: 'app.manage.clients'
      },
      {
        label: $filter('translate')('NEW_CLIENT.MAIN_TITLE'),
        value: 'app.manage.clients.newclient'
      }
    ];

    //Save Form
    //-------------------------------------
    vm.client = {};

    vm.createClient = function () {
      LoaderHelper.open();
      CompanyService.createClientCompany(vm.client).then(function () {
        notify({
          message: $filter('translate')('COMMONS.NEW_CLIENT_CREATED'),
          duration: 4000,
          templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
          classes: 'alert-info',
          position: 'center'
        });
        $state.go('app.manage.clients', {}, {reload: true});
      }, function () {
        LoaderHelper.close();
        vm.addNewClient.$submitted = false;
      });
    };

  }

})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .config(routeConfig);

  function routeConfig($stateProvider) {
    $stateProvider.state('app.manage.clients.editClient', {
      url: '/edit-client/:companyId',
      views: {
        '@app': {
          templateUrl: 'app/states/manage/clients/edit-client/edit-client.html',
          controller: 'EditClientController',
          controllerAs: 'editClientCtrl'
        }
      },
      data: {
        pageTitle: 'Edit Client',
        viewClass: 'edit-client',
        roles: ['Admin']
      },
      params: {
        companyId: ''
      },
      resolve: {
        /** @ngInject */
        clientCompany: function($q, $stateParams, CompanyService) {
          if (!$stateParams.companyId) {
            return $q.reject({
              error: 'invalidTransition',
              fallback: 'app.manage.clients'
            });
          }
          return CompanyService.getCompany($stateParams.companyId);
        }
      }
    });
  }

})();
(function () {
  'use strict';

  angular
    .module('nvc')
    .controller('EditClientController', EditClientController);

  /** @ngInject*/
  function EditClientController($state, $filter, notify, LoaderHelper, CompanyService, clientCompany) {
    var vm = this;

    vm.clientCompany = clientCompany;
    vm.editClient = {};

    //Breadcrums
    //-------------------------------------
    vm.title = $filter('translate')('COMMONS.EDIT_ASSET_MANAGEMENT_FIRM');
    vm.breadcrumbs = [
      {
        label: $filter('translate')('COMMONS.MANAGE'),
        value: 'app.manage.clients'
      },
      {
        label: $filter('translate')('COMPANIES.MAIN_TITLE_ASSET_MANAGEMENT_FIRMS'),
        value: 'app.manage.clients'
      },
      {
        label: $filter('translate')('COMMONS.EDIT_ASSET_MANAGEMENT_FIRM'),
        value: 'app.manage.clients.editClient'
      }
    ];

    //Save Form
    //-------------------------------------
    vm.updateClient = function (client) {
      var clientDTO = angular.copy(client);
      clientDTO.address = client.address.address;
      LoaderHelper.open();
      CompanyService.updateClientCompany(clientDTO).then(function () {
        notify({
          message: $filter('translate')('COMMONS.CLIENT_UPDATED'),
          duration: 4000,
          templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
          classes: 'alert-info',
          position: 'center'
        });
        $state.go('app.manage.clients', {}, {reload: true});
      }, function () {
        LoaderHelper.close();
        vm.editClient.$submitted = false;
      });
    };

  }
})();
(function () {
  'use strict';

  angular
  .module('nvc')
  .config(routeConfig);

  function routeConfig($stateProvider) {
    $stateProvider.state('app.manage.auditors.newAuditor', {
      url: '/new-audit-firm',
      views: {
        '@app': {
          templateUrl: 'app/states/manage/auditors/new-auditor/new-auditor.html',
          controller: 'AddAuditorController',
          controllerAs: 'newAuditorCtrl'
        }
      },
      data: {
        pageTitle: 'New Audit Firm',
        viewClass: 'new-auditor'
      }
    });
  }

})();
(function () {
  'use strict';

  angular
  .module('nvc')
  .controller('AddAuditorController', AddAuditorController);

  /** @ngInject */
  function AddAuditorController($filter, $state, notify, LoaderHelper, CompanyService) {

    var vm = this;
    vm.auditor = {};

    //Breadcrums
    //-------------------------------------
    vm.title = $filter('translate')('NEW_AUDITOR.MAIN_TITLE');
    vm.breadcrumbs = [
      {
        label: $filter('translate')('COMMONS.MANAGE'),
        value: 'app.manage.auditors'
      },
      {
        label: $filter('translate')('COMPANIES.MAIN_TITLE_AUDIT_FIRMS'),
        value: 'app.manage.auditors'
      },
      {
        label: $filter('translate')('NEW_AUDITOR.MAIN_TITLE'),
        value: 'app.manage.auditors.newAuditor'
      }
    ];

    //Save Form
    //-------------------------------------

    vm.createAuditor = function (auditor) {
      LoaderHelper.open();
      CompanyService.createAuditorCompany(auditor).then(function () {
        notify({
          message: $filter('translate')('COMMONS.NEW_AUDITOR_CREATED'),
          duration: 4000,
          templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
          classes: 'alert-info',
          position: 'center'
        });
        $state.go('app.manage.auditors', {}, {reload: true});
      }, function () {
        vm.newAuditorForm.$submitted = false;
        LoaderHelper.close();
      });
    };

  }

})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .config(routeConfig);

  function routeConfig($stateProvider) {
    $stateProvider.state('app.manage.auditors.editAuditor', {
      url: '/edit-audit-firm/:companyId',
      views: {
        '@app': {
          templateUrl: 'app/states/manage/auditors/edit-auditor/edit-auditor.html',
          controller: 'EditAuditorController',
          controllerAs: 'editAuditorCtrl'
        }
      },
      data: {
        pageTitle: 'Edit Audit Firm',
        viewClass: 'edit-auditor',
        roles: ['Admin', 'Audit']
      },
      params: {
        companyId: ''
      },
      resolve: {
        /** @ngInject */
        auditorCompany: function($q, $stateParams, CompanyService) {
          if (!$stateParams.companyId) {
            return $q.reject({
              error: 'invalidTransition',
              fallback: 'app.manage.clients'
            });
          }
          return CompanyService.getCompany($stateParams.companyId);
        }
      }
    });
  }

})();
(function () {
  'use strict';

  angular
    .module('nvc')
    .controller('EditAuditorController', EditAuditorController);

  /** @ngInject */
  function EditAuditorController($state, $filter, notify, LoaderHelper, CompanyService, auditorCompany) {
    var vm = this;

    vm.auditorCompany = auditorCompany;

    vm.editAuditor = {};

    //Breadcrums
    //-------------------------------------
    vm.title = $filter('translate')('COMMONS.EDIT_AUDIT_FIRM');
    if (!vm.auditorCompany.active) {
      vm.title = $filter('translate')(vm.auditorCompany.name) + ' (' + $filter('translate')('COMMONS.INACTIVATED') + ')';
    }
    vm.breadcrumbs = [
      {
        label: $filter('translate')('COMMONS.MANAGE'),
        value: 'app.manage.auditors'
      },
      {
        label: $filter('translate')('COMPANIES.MAIN_TITLE_AUDIT_FIRMS'),
        value: 'app.manage.auditors'
      },
      {
        label: $filter('translate')('COMMONS.EDIT_AUDIT_FIRM'),
        value: 'app.manage.auditors.editAuditors'
      }
    ];

    //Save Form
    //-------------------------------------
    vm.updateAuditor = function (auditor) {
      var auditorDTO = angular.copy(auditor);
      auditorDTO.address = auditor.address.address;
      LoaderHelper.open();
      CompanyService.updateAuditorCompany(auditorDTO).then(function () {
        notify({
          message: $filter('translate')('COMMONS.AUDITOR_UPDATED'),
          duration: 4000,
          templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
          classes: 'alert-info',
          position: 'center'
        });
        $state.go('app.manage.auditors', {}, {reload: true});
      }, function () {
        LoaderHelper.close();
        vm.editClient.$submitted = false;
      });
    };

  }
})();
(function () {
  'use strict';

  angular
  .module('nvc')
  .config(routeConfig);

  function routeConfig($stateProvider) {
    $stateProvider.state('app.manage.appraisers.newAppraiser', {
      url: '/new-appraiser',
      views: {
        '@app': {
          templateUrl: 'app/states/manage/appraisers/new-appraiser/new-appraiser.html',
          controller: 'AddAppraiserController',
          controllerAs: 'addAppraiser'
        }
      },
      inherit: false,
      data: {
        pageTitle: 'New Appraiser',
        roles: ['Admin'],
        viewClass: 'new-appraiser'
      }
    });
  }

})();

(function () {
  'use strict';

  angular
  .module('nvc')
  .controller('AddAppraiserController', AddAppraiserController);

  /** @ngInject */
  function AddAppraiserController($filter, $state, notify, LoaderHelper, CompanyService) {

    var vm = this;

    //Breadcrums
    //-------------------------------------
    vm.title = $filter('translate')('NEW_APPRAISAL_FIRM.MAIN_TITLE');
    vm.breadcrumbs = [
      {
        label: $filter('translate')('COMMONS.MANAGE'),
        value: 'app.manage.appraisers'
      },
      {
        label: $filter('translate')('COMPANIES.MAIN_TITLE_APPRAISAL_FIRMS'),
        value: 'app.manage.appraisers'
      },
      {
        label: $filter('translate')('NEW_APPRAISAL_FIRM.MAIN_TITLE'),
        value: 'app.manage.appraisers.newAppraiser'
      }
    ];

    //Save Form
    //-------------------------------------
    vm.appraiser = {};

    vm.createAppraiser = function () {
      LoaderHelper.open();
      CompanyService.createAppraisalCompany(vm.appraiser).then(function () {
        notify({
          message: $filter('translate')('COMMONS.NEW_APPRAISAL_CREATED'),
          duration: 4000,
          templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
          classes: 'alert-info',
          position: 'center'
        });
        $state.go('app.manage.appraisers', {}, {reload: true});
      }, function () {
        LoaderHelper.close();
        vm.addNewAppraiser.$submitted = false;
      });
    };

  }

})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .config(routeConfig);

  function routeConfig($stateProvider) {
    $stateProvider.state('app.manage.appraisers.editAppraiser', {
      url: '/edit-appraiser/:companyId',
      views: {
        '@app': {
          templateUrl: 'app/states/manage/appraisers/edit-appraiser/edit-appraiser.html',
          controller: 'EditAppraiserController',
          controllerAs: 'editAppraiserCtrl'
        }
      },
      data: {
        pageTitle: 'Edit Appraiser',
        viewClass: 'edit-appraiser',
        roles: ['Admin']
      },
      params: {
        companyId: ''
      },
      resolve: {
        /** @ngInject */
        appraiserCompany: function($q, $stateParams, CompanyService) {
          if (!$stateParams.companyId) {
            return $q.reject({
              error: 'invalidTransition',
              fallback: 'app.manage.clients'
            });
          }
          return CompanyService.getCompany($stateParams.companyId);
        }
      }
    });
  }

})();
(function () {
  'use strict';

  angular
    .module('nvc')
    .controller('EditAppraiserController', EditAppraiserController);

  /** @ngInject */
  function EditAppraiserController($state, $filter, notify, LoaderHelper, CompanyService, appraiserCompany) {
    var vm = this;

    vm.appraiserCompany = appraiserCompany;

    vm.editAppraiser = {};

    //Breadcrums
    //-------------------------------------
    vm.title = $filter('translate')('COMMONS.EDIT_APPRAISAL_FIRM');
    if (!vm.appraiserCompany.active) {
      vm.title = $filter('translate')(vm.appraiserCompany.name) + ' (' + $filter('translate')('COMMONS.INACTIVATED') + ')';
    }
    vm.breadcrumbs = [
      {
        label: $filter('translate')('COMMONS.MANAGE'),
        value: 'app.manage.appraisers'
      },
      {
        label: $filter('translate')('COMPANIES.MAIN_TITLE_APPRAISAL_FIRMS'),
        value: 'app.manage.appraisers'
      },
      {
        label: $filter('translate')('COMMONS.EDIT_APPRAISAL_FIRM'),
        value: 'app.manage.clients.editAppraiser'
      }
    ];

    //Save Form
    //-------------------------------------
    vm.updateAppraiser = function (appraiser) {
      var appraiserDTO = angular.copy(appraiser);
      appraiserDTO.address = appraiser.address.address;
      LoaderHelper.open();
      CompanyService.updateAppraiserCompany(appraiserDTO).then(function () {
        notify({
          message: $filter('translate')('COMMONS.APPRAISER_UPDATED'),
          duration: 4000,
          templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
          classes: 'alert-info',
          position: 'center'
        });
        $state.go('app.manage.appraisers', {}, {reload: true});
      }, function () {
        LoaderHelper.close();
        vm.editClient.$submitted = false;
      });
    };

  }
})();
(function () {
  'use strict';

  angular
    .module('nvc')
    .config(routeConfig);

  function routeConfig($stateProvider) {
    $stateProvider.state('app.bidEngagement.addRfp.selectAssets', {
      url: '/select-assets',
      views: {
        'rfpWizard@app.bidEngagement.addRfp': {
          templateUrl: 'app/states/bid-engagement/add-rfp/select-assets/select-assets.html',
          controller: 'SelectAssetsController',
          controllerAs: 'selectAssetsCtrl'
        }
      },
      params: {
        requestForm: undefined
      },
      data: {
        pageTitle: 'Select Assets',
        viewClass: 'select-assets'
      }
    });
  }

})();
(function () {
  'use strict';

  angular
    .module('nvc')
    .controller('SelectAssetsController', SelectAssetsController);

  /** @ngInject */
  function SelectAssetsController($scope, $state, $filter, CompanySelectorFactory, BidGroupService, AssetService,
    propertyTypes, companies, states, ArrayHelper, UtcDateConverter) {
    var vm = this,
      watchers = [],
      selectedAssets = {};
    vm.searchQuery = '';
    vm.searchQueryFilter = '';
    vm.searchQueryStates = '';
    vm.bidGroups = [];
    vm.assets = [];
    vm.years = [];
    vm.searchResults = [];
    vm.selectedBid = false;
    vm.showFilters = true;
    vm.allSelected = false;
    vm.allPropertyTypesSelected = false;
    vm.allCountriesSelected = false;
    vm.allStatesSelected = false;
    vm.propertyTypes = propertyTypes.items;
    vm.selectedBidGroups = [];
    vm.selectedQuarters = {
      all: false,
      quarters: {
        q1: false,
        q2: false,
        q3: false,
        q4: false
      },
      list: []
    };
    vm.selectedPropertyTypes = [];
    vm.countries = [
      {
        name: 'United States'
      },
      {
        name: 'Mexico'
      }
    ];

    vm.frequenciesByValues = {
      'Annually': 'Annual',
      'SemiAnnually': 'Semi-Annual',
      'Quarterly': 'Quarterly'
    };

    vm.selectedStates = { 'United States': [], 'Mexico': [] };
    vm.statesByCountry = {
      "United States": [],
      "Mexico": []
    };

    vm.selectAssetsSort = [
      {
        tag: 'PropertyRef',
        selected: true,
        flag: true,
        order: 'Ascending'
      },
      {
        tag: 'Name',
        selected: false,
        flag: false,
        order: 'Ascending'
      },
      {
        tag: 'Location',
        selected: false,
        flag: false,
        order: 'Ascending'
      },
      {
        tag: 'Type',
        selected: false,
        flag: false,
        order: 'Ascending'
      },
      {
        tag: 'SubType',
        selected: false,
        flag: false,
        order: 'Ascending'
      },
      {
        tag: 'GMV',
        selected: false,
        flag: false,
        order: 'Ascending'
      },
      {
        tag: 'ValuationFrequency',
        selected: false,
        flag: false,
        order: 'Ascending'
      },
      {
        tag: 'RollOverDate',
        selected: false,
        flag: false,
        order: 'Ascending'
      }
    ];
    vm.selectAssetsSelectedSort = vm.selectAssetsSort[0];
    vm.perPage = 14;
    vm.maxPaginationSize = 5;

    states["United States"].forEach(function (state) {
      vm.statesByCountry['United States'].push({ name: state })
    });
    states["Mexico"].forEach(function (state) {
      vm.statesByCountry['Mexico'].push({ name: state })
    });

    var currentFilters = {};

    //SEARCH FUNCTION
    //------------------------------------------
    vm.searchAssets = function () {
      if (vm.searchQuery.length > 2 || !vm.searchQuery) {
        loadAssets();
      }
    };

    //SORTING
    //------------------------------------------
    vm.sorting = function (sort, target) {
      ArrayHelper.beSort(sort, target, vm.selectAssetsSort, vm);
      loadAssets();
    };

    //GET YEARS
    //------------------------------------------
    var currentTime = new moment();
    var yearObj = { year: currentTime.year(), date: moment(currentTime) };

    for (var i = 1; i < 11; i++) {
      vm.years.push(yearObj);
      yearObj = {
        year: currentTime.year() + i,
        date: moment(currentTime).add(i, 'year')
      };
    }

    vm.clearFilters = function () {
      vm.bidGroups.forEach(function (bidGroup) {
        bidGroup.selected = false;
      });
      vm.selectedQuarters.quarters.q1 = false;
      vm.selectedQuarters.quarters.q2 = false;
      vm.selectedQuarters.quarters.q3 = false;
      vm.selectedQuarters.quarters.q4 = false;
      vm.selectedQuarters.all = false;
      vm.selectedQuarters.list = [];
      vm.years.forEach(function (year) {
        year.selected = false;
      });
      vm.propertyTypes.forEach(function (propertyType) {
        propertyType.selected = false;
      });
      vm.allPropertyTypesSelected = false;
      vm.countries.forEach(function (country) {
        country.selected = false;
        vm.statesByCountry[country.name].forEach(function (state) {
          state.selected = false;
        });
      });
      vm.allCountriesSelected = false;
      vm.allStatesSelected = false;
    };

    //SEARCH
    //------------------------------------------
    vm.search = function () {
      selectedAssets = {};
      vm.currentPage = 1;
      loadAssets(false, true);
    };

    function loadAssets(load, toggleFilters) {
      if (load) {
        LoaderHelper.open();
      } else {
        $('.paginator-loader').addClass('sk-loading');
      }

      var bidGroupsIds = [],
        types = [],
        states = [],
        ranges = [];
      vm.bidGroups.forEach(function (bidGroup) {
        if (bidGroup.selected) {
          bidGroupsIds.push(bidGroup.id);
        }
      });

      if (!vm.allPropertyTypesSelected) {
        vm.propertyTypes.forEach(function (type) {
          if (type.selected) {
            types.push(type.type);
          }
        });
      }

      vm.selectedCountries.forEach(function (country) {
        vm.selectedStates[country].forEach(function (state) {
          states.push(state);
        });
      });
      var quarterSelected = false;
      Object.keys(vm.selectedQuarters.quarters).forEach(function (key) {
        if (vm.selectedQuarters.quarters[key]) {
          quarterSelected = true;
        }
      });
      quarterSelected = quarterSelected || vm.selectedQuarters.all;
      var yearSelected = false;
      vm.years.forEach(function (year) {
        if (year.selected) {
          yearSelected = true;
          if (!vm.selectedQuarters.all) {
            var range;
            if (vm.selectedQuarters.quarters.q1) {
              range = ReviewModel.getQuarterRangeByQuarter(1);
              range.from.year(year.date.year());
              range.to.year(year.date.year());
              range.to.add(1, 'day');
              range.from = new Date(range.from.toISOString()).getTime();
              range.to = new Date(range.to.toISOString()).getTime();
              ranges.push(range);
            }
            if (vm.selectedQuarters.quarters.q2) {
              range = ReviewModel.getQuarterRangeByQuarter(2);
              range.from.year(year.date.year());
              range.to.year(year.date.year());
              range.to.add(1, 'day');
              range.from = new Date(range.from.toISOString()).getTime();
              range.to = new Date(range.to.toISOString()).getTime();
              ranges.push(range);
            }
            if (vm.selectedQuarters.quarters.q3) {
              range = ReviewModel.getQuarterRangeByQuarter(3);
              range.from.year(year.date.year());
              range.to.year(year.date.year());
              range.to.add(1, 'day');
              range.from = new Date(range.from.toISOString()).getTime();
              range.to = new Date(range.to.toISOString()).getTime();
              ranges.push(range);
            }
            if (vm.selectedQuarters.quarters.q4) {
              range = ReviewModel.getQuarterRangeByQuarter(4);
              range.from.year(year.date.year());
              range.to.year(year.date.year());
              range.to.add(1, 'day');
              range.from = new Date(range.from.toISOString()).getTime();
              range.to.subtract(1, 'seconds');
              range.to = new Date(range.to.toISOString()).getTime();
              ranges.push(range);
            }
          } else {
            var from = moment(year.date);
            var to = moment(year.date);
            from.month(0);
            from.date(1);
            to.month(11);
            to.date(31);
            to.add(1, 'day');
            ranges.push({ from: new Date(from.toISOString()).getTime(), to: new Date(to.toISOString()).getTime() });
          }
          if (!quarterSelected) {
            from = moment(year.date);
            to = moment(year.date);
            from.month(0);
            from.date(1);
            to.month(11);
            to.date(31);
            to.add(1, 'day');
            ranges.push({ from: new Date(from.toISOString()).getTime(), to: new Date(to.toISOString()).getTime() });
          }
        }
      });
      if (!yearSelected && quarterSelected) {
        vm.errorMessage = 'ADD_RFP.RANGE_ERROR';
        return; //if a a quarter is selected year is mandatory;
      }
      vm.errorMessage = '';
      AssetService.listForRFP(vm.selectedCompany.id, bidGroupsIds, ranges, types, vm.selectedCountries, states, true, vm.currentPage - 1, vm.perPage, vm.searchQuery,
        vm.selectAssetsSelectedSort.tag, vm.selectAssetsSelectedSort.order).then(function (response) {
          vm.assets = response.assets;
          vm.assetsCount = response.pageInfo.count;
          if (toggleFilters) {
            vm.showFilters = !vm.showFilters;
          }
          if ($state.params.requestForm && $state.params.requestForm.assets) {
            setPreviousAssets();
          }
          vm.searched = true;
          vm.currentFilters = {
            bidGroups: angular.copy(vm.bidGroups),
            propertyTypes: angular.copy(vm.propertyTypes),
            allPropertyTypesSelected: angular.copy(vm.allPropertyTypesSelected),
            selectedCountries: angular.copy(vm.selectedCountries),
            selectedStates: angular.copy(vm.selectedStates),
            years: angular.copy(vm.years),
            selectedQuarters: angular.copy(vm.selectedQuarters)
          };
          vm.assets.forEach(function (asset) {
            if (asset.rollOverDate) {
              asset.rollOverDate = UtcDateConverter.getDateFromUTC(asset.rollOverDate);
            }
            if (asset.type) {
              asset.type = asset.type.replace(/([A-Z])/g, ' $1');
            }
            if (asset.subType) {
              asset.subType = asset.subType.replace(/([A-Z])/g, ' $1');
            }
            asset.cycle = $filter('cycle')(asset);
            if (selectedAssets[asset.id]) {
              asset.selected = true;
            }
          });
          if (load) {
            LoaderHelper.close();
          } else {
            $('.paginator-loader').removeClass('sk-loading');
          }
        });
    }

    vm.changePage = function () {
      loadAssets();
    };

    vm.changeFilter = function () {
      vm.showFilters = !vm.showFilters;
    };

    //aT ALL
    //------------------------------------------
    vm.selectAllAssets = function () {
      vm.allSelected = !vm.allSelected;
      vm.assets.forEach(function (asset) {
        asset.selected = vm.allSelected;
        vm.assetSelectedToggle(asset);
      });
    };

    vm.next = function () {

      var selectedAssetsArray = [],
        bidGroups = {},
        bidGroupsIds = [],
        bidGroupNames = [],
        types = [],
        typeNames = [],
        years = [];

      Object.keys(selectedAssets).forEach(function (key) {
        var asset = selectedAssets[key];
        selectedAssetsArray.push(asset);
        for (var i = 0; i < vm.bidGroups.length; i++) {
          if (asset.bidGroupId == vm.bidGroups[i].id) {
            bidGroups[vm.bidGroups[i].id] = vm.bidGroups[i].name;
            break;
          }
        }
      });

      vm.currentFilters.bidGroups.forEach(function (bidGroup) {
        if (bidGroup.selected) {
          bidGroupsIds.push(bidGroup.id);
          bidGroupNames.push(bidGroup.name);
        }
      });

      if (!vm.currentFilters.allPropertyTypesSelected) {
        vm.currentFilters.propertyTypes.forEach(function (type) {
          if (type.selected) {
            types.push(type.type);
            typeNames.push(type.type);
          }
        });
      } else {
        vm.currentFilters.propertyTypes.forEach(function (type) {
          typeNames.push(type.type);
        });
      }

      vm.currentFilters.years.forEach(function (year) {
        if (year.selected) {
          years.push(year.year);
        }
      });

      if (selectedAssetsArray.length > 0) {
        var requestForm = angular.copy($state.params.requestForm) || {};
        requestForm.assets = selectedAssetsArray;
        requestForm.filters = {
          bidGroupsIds: bidGroupsIds,
          bidGroupNames: bidGroupNames,
          bidGroups: bidGroups,
          types: types,
          allPropertyTypesSelected: vm.currentFilters.allPropertyTypesSelected,
          typeNames: typeNames,
          countries: vm.currentFilters.selectedCountries,
          states: vm.currentFilters.selectedStates,
          allStatesSelected: vm.allStatesSelected,
          years: years,
          selectedQuarters: vm.currentFilters.selectedQuarters
        };
        requestForm.company = vm.selectedCompany;
        $state.go('app.bidEngagement.addRfp.selectAppraisers', { requestForm: requestForm });
      }
    };

    function setPreviousFilters() {
      var filters = $state.params.requestForm.filters;
      filters.bidGroupsIds.forEach(function (BFId) {
        vm.bidGroups.forEach(function (bidGroup) {
          if (bidGroup.id == BFId) {
            bidGroup.selected = true;
          }
        });
      });


      if (!filters.allPropertyTypesSelected) {
        filters.types.forEach(function (selectedType) {
          vm.propertyTypes.forEach(function (type) {
            if (type.type === selectedType) {
              type.selected = true;
              vm.selectedPropertyTypes.push(type.name);
            }
          });
        });
      } else {
        vm.allPropertyTypesSelected = filters.allPropertyTypesSelected
      }
      filters.countries.forEach(function (countryName) {
        vm.countries.forEach(function (country) {
          if (country.name === countryName) {
            country.selected = true;
          }
        });
        filters.states[countryName].forEach(function (stateName) {
          vm.statesByCountry[countryName].forEach(function (state) {
            if (state.name === stateName) {
              state.selected = true;
            }
          });
        });
      });
      if (filters.selectedQuarters) {
        vm.selectedQuarters.all = filters.selectedQuarters.all;
        vm.selectedQuarters.quarters.q1 = filters.selectedQuarters.quarters.q1;
        vm.selectedQuarters.quarters.q2 = filters.selectedQuarters.quarters.q2;
        vm.selectedQuarters.quarters.q3 = filters.selectedQuarters.quarters.q3;
        vm.selectedQuarters.quarters.q4 = filters.selectedQuarters.quarters.q4;
        vm.selectedQuarters.list = filters.selectedQuarters.list;
      }
      filters.years.forEach(function (selectedYear) {
        vm.years.forEach(function (year) {
          if (year.year === selectedYear) {
            year.selected = true;
          }
        });
      });
      vm.search();
      $state.params.requestForm.filters = undefined;
    }

    function setPreviousAssets() {
      $state.params.requestForm.assets.forEach(function (selectedAsset) {
        vm.assets.forEach(function (asset) {
          if (selectedAsset.id === asset.id) {
            asset.selected = true;
            selectedAssets[asset.id] = asset;
          }
        });
      });
      $state.params.states = undefined;
    }

    CompanySelectorFactory.showCompanies(companies);
    var companyListener = $scope.$on('companyChanged', function (event, selectedCompany) {
      vm.selectedCompany = selectedCompany;
      CompanySelectorFactory.executeOnValidState('app.bidEngagement.addRfp.selectAssets', function () {
        BidGroupService.list(vm.selectedCompany.id).then(function (bidGroups) {
          vm.bidGroups = bidGroups;
          if ($state.params.requestForm && $state.params.requestForm.filters) {
            setPreviousFilters();
          } else {
            vm.clearFilters();
            vm.assets = [];
            vm.searched = false;
            vm.showFilters = true;
          }
        });
      });
    });


    vm.arrayToFormattedString = function (array, separator) {
      if (array) {
        var uniqueArray = array.filter(function (item, pos) {
          return array.indexOf(item) == pos;
        });
        return uniqueArray.toString().replace(/\,/g, separator);
      } else {
        return '';
      }
    };

    vm.getSelectedStates = function () {
      if (vm.selectedCountries) {
        var selectedStates = '';
        vm.selectedCountries.forEach(function (country) {
          if (selectedStates.length > 0) {
            selectedStates += ' - ';
          }
          selectedStates += vm.arrayToFormattedString(vm.selectedStates[country], ', ');
        });
        return selectedStates;
      } else {
        return '';
      }
    };

    vm.assetSelectedToggle = function (asset) {
      if (asset.selected) {
        selectedAssets[asset.id] = asset;
      } else {
        delete selectedAssets[asset.id];
      }
    };

    vm.canContinue = function () {
      return Object.keys(selectedAssets).length == 0;
    };

    //BID GROUP SELECTOR WATCHERS
    //------------------------------------------
    watchers.push($scope.$watch('selectAssetsCtrl.bidGroups', function () {
      for (var i = 0; i < vm.bidGroups.length; i++) {
        if (vm.bidGroups[i].selected) {
          vm.selectedBidGroups = [];
          break;
        }
      }
      for (i = 0; i < vm.bidGroups.length; i++) {
        if (vm.bidGroups[i].selected) {
          vm.selectedBidGroups.push(vm.bidGroups[i].name);
        } else if (vm.selectedBidGroups.indexOf(vm.bidGroups[i].name) != -1) {
          vm.selectedBidGroups.splice(vm.selectedBidGroups.indexOf(vm.bidGroups[i].name), 1);
        }
      }
    }, true));

    //QUARTERS SELECTOR WATCHERS
    //------------------------------------------
    watchers.push($scope.$watch('selectAssetsCtrl.selectedQuarters.quarters', function () {
      for (var i = 0; i < Object.keys(vm.selectedQuarters.quarters).length; i++) {
        if (vm.selectedQuarters.quarters[Object.keys(vm.selectedQuarters.quarters)[i]]) {
          vm.selectedQuarters.list = [];
          vm.selectedQuarters.all = false;
          break;
        }
      }

      Object.keys(vm.selectedQuarters.quarters).forEach(function (key) {
        if (vm.selectedQuarters.quarters[key]) {
          vm.selectedQuarters.list.push(key.toUpperCase());
        } else if (!vm.selectedQuarters.all && vm.selectedQuarters.list.indexOf(key.toUpperCase()) != -1) {
          vm.selectedQuarters.list.splice(vm.selectedQuarters.list.indexOf(key.toUpperCase()), 1);
        }

      });

      for (i = 0; i < vm.bidGroups.length; i++) {
        if (vm.bidGroups[i].selected) {
          vm.selectedBidGroups.push(vm.bidGroups[i].name);
        } else if (vm.selectedBidGroups.indexOf(vm.bidGroups[i].name) != -1) {
          vm.selectedBidGroups.splice(vm.selectedBidGroups.indexOf(vm.bidGroups[i].name), 1);
        }
      }
    }, true));

    watchers.push($scope.$watch('selectAssetsCtrl.selectedQuarters.all', function () {
      if (vm.selectedQuarters.all) {
        vm.selectedQuarters.list = [];
        Object.keys(vm.selectedQuarters.quarters).forEach(function (key) {
          vm.selectedQuarters.quarters[key] = false;
          vm.selectedQuarters.list.push(key.toUpperCase());
        });
      } else {
        var quarterSelected = false;
        Object.keys(vm.selectedQuarters.quarters).forEach(function (key) {
          if (vm.selectedQuarters.quarters[key]) {
            quarterSelected = true;
          }
        });
        if (!quarterSelected) {
          vm.selectedQuarters.list = [];
        }
      }
    }));

    //YEARS SELECTOR WATCHER
    //------------------------------------------
    watchers.push($scope.$watch('selectAssetsCtrl.years', function () {
      vm.selectedYears = [];
      for (i = 0; i < vm.years.length; i++) {
        if (vm.years[i].selected) {
          vm.selectedYears.push(vm.years[i].year);
        }
      }
    }, true));

    //PROPERTY TYPE SELECTOR WATCHERS
    //------------------------------------------
    watchers.push($scope.$watch('selectAssetsCtrl.propertyTypes', function () {
      for (var i = 0; i < vm.propertyTypes.length; i++) {
        if (vm.propertyTypes[i].selected) {
          vm.selectedPropertyTypes = [];
          vm.allPropertyTypesSelected = false;
          break;
        }
      }
      for (i = 0; i < vm.propertyTypes.length; i++) {
        if (vm.propertyTypes[i].selected) {
          vm.selectedPropertyTypes.push(vm.propertyTypes[i].name);
        } else if (!vm.allPropertyTypesSelected && vm.selectedPropertyTypes.indexOf(vm.propertyTypes[i].name) != -1) {
          vm.selectedPropertyTypes.splice(vm.selectedPropertyTypes.indexOf(vm.propertyTypes[i].name), 1);
        }
      }
    }, true));

    watchers.push($scope.$watch('selectAssetsCtrl.allPropertyTypesSelected', function () {

      if (vm.allPropertyTypesSelected) {
        vm.selectedPropertyTypes = [];
        vm.propertyTypes.forEach(function (group) {
          group.selected = false;
          vm.selectedPropertyTypes.push(group.name);
        });
      } else {
        vm.selectedPropertyTypes = [];
        for (var i = 0; i < vm.propertyTypes.length; i++) {
          if (vm.propertyTypes[i].selected) {
            vm.selectedPropertyTypes.push(vm.propertyTypes[i].name);
          }
        }
      }
    }, true));


    //COUNTRIES SELECTOR WATCHERS
    //------------------------------------------
    watchers.push($scope.$watch('selectAssetsCtrl.countries', function () {
      var selectedCountries = [];

      for (var i = 0; i < vm.countries.length; i++) {
        if (vm.countries[i].selected) {
          selectedCountries.push(vm.countries[i].name);
        }
      }
      if (selectedCountries.length != 0) {
        vm.allCountriesSelected = false;
        vm.selectedCountries = selectedCountries;
      } else if (!vm.allCountriesSelected) {
        vm.selectedCountries = selectedCountries;
      }
    }, true));

    watchers.push($scope.$watch('selectAssetsCtrl.allCountriesSelected', function () {
      if (vm.allCountriesSelected) {
        vm.selectedCountries = [];
        vm.countries.forEach(function (country) {
          country.selected = false;
          vm.selectedCountries.push(country.name);
        });
      } else {
        vm.selectedCountries = [];
        for (var i = 0; i < vm.countries.length; i++) {
          if (vm.countries[i].selected) {
            vm.selectedCountries.push(vm.countries[i].name);
          }
        }
      }
    }, true));

    //STATES SELECTOR WATCHERS
    //------------------------------------------
    watchers.push($scope.$watch('selectAssetsCtrl.statesByCountry', function () {
      var selectedStates = { 'United States': [], 'Mexico': [] };

      Object.keys(vm.selectedStates).forEach(function (country) {
        for (var i = 0; i < vm.statesByCountry[country].length; i++) {
          if (vm.statesByCountry[country][i].selected) {
            selectedStates[country].push(vm.statesByCountry[country][i].name);
          }
        }
        if (selectedStates[country].length != 0) {
          vm.allStatesSelected = false;
          vm.selectedStates[country] = selectedStates[country];
        } else if (!vm.allStatesSelected) {
          vm.selectedStates[country] = selectedStates[country];
        }
      });
    }, true));

    watchers.push($scope.$watch('selectAssetsCtrl.allStatesSelected', function () {
      Object.keys(vm.selectedStates).forEach(function (country) {
        if (vm.allStatesSelected) {
          vm.selectedStates[country] = [];
          vm.statesByCountry[country].forEach(function (state) {
            state.selected = false;
            vm.selectedStates[country].push(state.name);
          });
        } else {
          vm.selectedStates[country] = [];
          for (var i = 0; i < vm.statesByCountry[country].length; i++) {
            if (vm.statesByCountry[country][i].selected) {
              vm.selectedStates[country].push(vm.statesByCountry[country][i].name);
            }
          }
        }
      });
    }, true));

    watchers.push($scope.$watch('selectAssetsCtrl.assets', function () {
      vm.assetSelected = false;
      for (var i = 0; i < vm.assets.length; i++) {
        if (vm.assets[i].selected) {
          vm.assetSelected = true;
          break;
        }
      }
    }, true));


    $scope.$on('$destroy', function () {
      watchers.forEach(function (watcher) {
        watcher();
      });
      companyListener();
    });
  }

})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .config(routeConfig);

  function routeConfig($stateProvider) {
    $stateProvider.state('app.bidEngagement.addRfp.selectAppraisers', {
      url: '/select-appraisers',
      views: {
        'rfpWizard@app.bidEngagement.addRfp': {
          templateUrl: 'app/states/bid-engagement/add-rfp/select-appraisers/select-appraisers.html',
          controller: 'SelectAppraisersController',
          controllerAs: 'selectAppraisersCtrl'
        }
      },
      params: {
        requestForm: undefined
      },
      data: {
        pageTitle: 'Select Appraisers',
        viewClass: 'select-appraisers',
        validPreviousStates: [
          'app.bidEngagement.addRfp.selectAssets',
          'app.bidEngagement.addRfp.bidAssignments'
        ],
        fallBackState: 'app.bidEngagement.addRfp.selectAssets'
      },
      resolve: {
        /** @ngInject */
        searchCriteria: function ($stateParams) {
          var searchCriteria = {};
          if ($stateParams.requestForm && $stateParams.requestForm.assets) {
            searchCriteria.types = {};
            searchCriteria.states = {};
            searchCriteria.typesArray = [];
            searchCriteria.statesArray = [];
            searchCriteria.bidGroups = [];
            searchCriteria.states['United States'] = [];
            searchCriteria.states['Mexico'] = [];
            $stateParams.requestForm.assets.forEach(function (asset) {
              searchCriteria.types[asset.type] = asset.type.replace(/\s+/g, '');
              if (asset.address.country == 'United States' && searchCriteria.states['United States'].indexOf(asset.address.state) === -1) {
                searchCriteria.states['United States'].push(asset.address.state);
              } else if (asset.address.country == 'Mexico' && searchCriteria.states['Mexico'].indexOf(asset.address.state) === -1) {
                searchCriteria.states['Mexico'].push(asset.address.state);
              }
            });
            Object.keys(searchCriteria.types).forEach(function (key) {
              searchCriteria.typesArray.push(searchCriteria.types[key]);
            });
            searchCriteria.types = searchCriteria.typesArray;
            searchCriteria.typesArray = [];
            searchCriteria.types.forEach(function (type) {
              searchCriteria.typesArray.push(type.replace(/([A-Z])/g, ' $1'));
            });
            Object.keys($stateParams.requestForm.filters.bidGroups).forEach(function (key) {
              searchCriteria.bidGroups.push($stateParams.requestForm.filters.bidGroups[key]);
            });
            if (searchCriteria.states['United States'].length > 0) {
              searchCriteria.states['United States'].forEach(function (state) {
                searchCriteria.statesArray.push(state);
              });
            }
            if (searchCriteria.states['Mexico'].length > 0) {
              searchCriteria.states['Mexico'].forEach(function (state) {
                searchCriteria.statesArray.push(state);
              });
            }
          }
          return searchCriteria;
        },
        /** @ngInject */
        appraisers: function ($q, UserService, CompanyService, $stateParams, searchCriteria) {
          if (!$stateParams.requestForm) {
            return $q.reject({error: 'invalidTransition'});
          }
          return UserService.getUsersByType('Appraiser', true).then(function (appraisers) {
            return CompanyService.getAppraisalCompanies(true, true).then(function (companies) {
              appraisers.forEach(function (appraiser) {
                for (var i = 0; i < companies.length; i++) {
                  if (appraiser.companyId === companies[i].id) {
                    appraiser.companyName = companies[i].name;
                    break;
                  }
                }
                if (appraiser.user.assetTypeSpecialties) {
                  appraiser.user.specialties = appraiser.user.assetTypeSpecialties.toString().replace(/([A-Z])/g, ' $1');
                }
                if (appraiser.user.workedOnStates) {
                  appraiser.user.states = appraiser.user.workedOnStates.toString().replace(/\,/g, ', ');
                }
              });
                for (var i = 0; i < appraisers.length; i++) {
                  var appraiser = appraisers[i];
                  var typeMatch = false;
                  if (appraiser.user.assetTypeSpecialties) {
                    for (var j = 0; j < appraiser.user.assetTypeSpecialties.length; j++) {
                      if (searchCriteria.types.indexOf(appraiser.user.assetTypeSpecialties[j]) != -1) {
                        typeMatch = true;
                        break;
                      }
                    }
                  }
                  var matchingStates = [];
                  if (appraiser.user.workedOnStates) {
                    for (j = 0; j < appraiser.user.workedOnStates.length; j++) {
                      if (searchCriteria.states['United States'].indexOf(appraiser.user.workedOnStates[j]) != -1
                        || searchCriteria.states['Mexico'].indexOf(appraiser.user.workedOnStates[j]) != -1) {
                        matchingStates.push(appraiser.user.workedOnStates[j]);
                      }
                    }
                    if (matchingStates.length > 0) {
                      appraiser.user.states = matchingStates.toString().replace(/\,/g, ', ');
                    }
                  }
                  if (typeMatch && (matchingStates && matchingStates.length > 0)) {
                    appraiser.matching = true;
                  }
                }

              return appraisers;
            });
          });
        }
      }
    });
  }

})();
(function () {
  'use strict';

  angular
  .module('nvc')
  .controller('SelectAppraisersController', SelectAppraisersController);

  /** @ngInject */
  function SelectAppraisersController($state, CompanySelectorFactory, appraisers, ArrayHelper, searchCriteria) {
    var vm = this;

    vm.searchQuery = '';
    vm.appraisers = [];
    vm.appraisersSelected = [];
    vm.filters = $state.params.requestForm.filters;
    vm.assets = $state.params.requestForm.assets;
    vm.searchCriteria = searchCriteria;
    vm.previewOpened = false;
    vm.hideList = true;
    vm.hideApp = true;
    vm.isHoverList = false;
    vm.isHoverApp = false;
    vm.appraisersSort = [
      {
        sort: 'user.name',
        tag: 'user.name',
        flag: false,
        selected: false
      },
      {
        sort: 'companyName',
        tag: 'companyName',
        flag: false,
        selected: false
      },
      {
        sort: 'user.states',
        tag: 'user.states',
        flag: false,
        selected: false
      },
      {
        sort: 'user.specialties',
        tag: 'user.specialties',
        flag: false,
        selected: false
      },
      {
        sort: '-matching',
        tag: '-matching',
        flag: true,
        selected: true
      }
    ];
    vm.appraisersSelectedSort = vm.appraisersSort[4];
    vm.appraisersAddedSort = [
      {
        sort: 'user.name',
        tag: 'user.name',
        flag: false,
        selected: false
      },
      {
        sort: 'companyName',
        tag: 'companyName',
        flag: false,
        selected: false
      },
      {
        sort: 'user.states',
        tag: 'user.states',
        flag: false,
        selected: false
      },
      {
        sort: 'user.specialties',
        tag: 'user.specialties',
        flag: false,
        selected: false
      },
      {
        sort: '-matching',
        tag: '-matching',
        flag: true,
        selected: true
      }
    ];
    vm.appraisersAddedSelectedSort = vm.appraisersAddedSort[4];

    vm.appraisers = appraisers;

    CompanySelectorFactory.showDisabledCompanies();

    vm.addAll = function () {
      var appraisers = angular.copy(vm.appraisers);
      appraisers.forEach(function (appraiser) {
        vm.addAppraiser(appraiser);
      })
    };

    vm.removeAll = function () {
      var appraisers = angular.copy(vm.appraisersSelected);
      appraisers.forEach(function (appraiser) {
        vm.removeAppraiser(appraiser);
      })
    };

    //SORTING
    //------------------------------------------
    vm.shiftAppraiserSort = function (sort, target) {
      ArrayHelper.sort(sort, target, vm.appraisersSort, vm);
    };

    vm.shiftAppraiserAddedSort = function (sort, target) {
      ArrayHelper.sort(sort, target, vm.appraisersAddedSort, vm);
    };

    //SEARCH FUNCTION
    //------------------------------------------
    vm.searchAppraisers = function () {
      ArrayHelper.searchScroll();
    };

    //NEW APPRAISER LIST FOR APPRAISERS GROUP
    //------------------------------------------
    vm.addAppraiser = function (appraiser) {
      for (var i = 0; i < vm.appraisers.length; i++) {
        if (appraiser.id == vm.appraisers[i].id) {
          vm.appraisers.splice(i, 1);
          vm.appraisersSelected.push(appraiser);
          break;
        }
      }
    };

    vm.removeAppraiser = function (appraiser) {
      for (var i = 0; i < vm.appraisersSelected.length; i++) {
        if (appraiser.id == vm.appraisersSelected[i].id) {
          vm.appraisersSelected.splice(i, 1);
          vm.appraisers.push(appraiser);
          break;
        }
      }
    };

    //DRAG 'N DROP
    //------------------------------------------
    vm.moveToApp = function (appraiser) {
      for (var i = 0; i < vm.appraisers.length; i++) {
        if (appraiser.id == vm.appraisers[i].id) {
          vm.appraisers.splice(i, 1);
          vm.appraisersSelected.push(appraiser);
          break;
        }
      }
      vm.hideApp = true;
      vm.isHoverApp = false;
    };

    vm.moveToList = function (appraiser) {
      for (var i = 0; i < vm.appraisersSelected.length; i++) {
        if (appraiser.id == vm.appraisersSelected[i].id) {
          vm.appraisersSelected.splice(i, 1);
          vm.appraisers.push(appraiser);
          break;
        }
      }
      vm.hideList = true;
      vm.isHoverList = false;
    };

    vm.showDropZoneList = function () {
      vm.hideList = false;
      vm.isHoverList = true;
    };

    vm.showDropZoneApp = function () {
      vm.hideApp = false;
      vm.isHoverApp = true;
    };

    vm.next = function () {
      var requestForm = angular.copy($state.params.requestForm);
      requestForm.appraisersSelected = vm.appraisersSelected;
      $state.go('app.bidEngagement.addRfp.bidAssignments', {requestForm: requestForm});
    };

    if ($state.params.requestForm.appraisersSelected) {
      $state.params.requestForm.appraisersSelected.forEach(function (appraiser) {
        vm.moveToApp(appraiser);
      });
    }

    vm.orderComparator = function (tag, flag, appraisers) {
      return function (v1, v2) {
        var first = -1,
        later = 1;
        if (flag) {
          first = 1;
          later = -1;
        }
        if (tag === "-matching") {
          return v1.value ? first : v2.value ? later : (v1.index < v2.index) ? first : later;
        } else if (appraisers[v1.index].matching && !appraisers[v2.index].matching) {
          return -1
        } else if (!appraisers[v1.index].matching && appraisers[v2.index].matching) {
          return 1
        }
        if (v1.type !== 'string' || v2.type !== 'string') {
          return (v1.index < v2.index) ? first : later;
        }
        return v1.value.localeCompare(v2.value) == -1 ? first : v1.value.localeCompare(v2.value) == 1 ? later : 0;
      }
    };
  }

})
();

(function () {
  'use strict';

  angular
    .module('nvc')
    .config(routeConfig);

  function routeConfig($stateProvider) {
    $stateProvider.state('app.bidEngagement.addRfp.bidAssignments', {
      url: '/bid-assignments',
      views: {
        'rfpWizard@app.bidEngagement.addRfp': {
          templateUrl: 'app/states/bid-engagement/add-rfp/bid-assignment/bid-assignment.html',
          controller: 'BidAssignmentsController',
          controllerAs: 'bidAssignmentsCtrl'
        }
      },
      params: {
        requestForm: undefined
      },
      data: {
        pageTitle: 'Bid Assignments',
        viewClass: 'bid-assignments',
        validPreviousStates: [
          'app.bidEngagement.addRfp.selectAssets',
          'app.bidEngagement.addRfp.selectAppraisers'
        ],
        fallBackState: 'app.bidEngagement.addRfp.selectAssets'
      },
      resolve: {
        /** @ngInject*/
        requestForm: function ($q, $stateParams) {
          if ($stateParams.requestForm) {
            return $stateParams.requestForm;
          } else {
            return $q.reject({error: 'invalidTransition'});
          }
        }
      }
    });
  }

})();
(function () {
  'use strict';

  angular
  .module('nvc')
  .controller('BidAssignmentsController', BidAssignmentsController);

  /** @ngInject */
  function BidAssignmentsController($scope, $state, $filter, notify, BidRequestService, AssetService,
                                    CompanySelectorFactory, ArrayHelper, requestForm, UtcDateConverter) {
    var vm = this;
    vm.assets = requestForm.assets;
    vm.appraisers = requestForm.appraisersSelected;
    vm.selectedUsersByAsset = {};
    vm.userSelectedCount = {};
    vm.assets.forEach(function (asset) {
      vm.selectedUsersByAsset[asset.id] = {
        allSelected: false,
        usersIds: {},
        count: 0
      };
      vm.appraisers.forEach(function (appraiser) {
        if(appraiser.user.assetTypeSpecialties){
          appraiser.user.specialties = appraiser.user.assetTypeSpecialties.toString().replace(/([A-Z])/g, ' $1');
        }
        if(appraiser.user.workedOnStates){
          appraiser.user.states = appraiser.user.workedOnStates.toString().replace(/\,/g, ', ');
        }
        vm.selectedUsersByAsset[asset.id].usersIds[appraiser.user.id] = false;
        appraiser.assetRelation = {};
      });
      AssetService.listUsers(asset.id, true).then(function(users){
        vm.appraisers.forEach(function (appraiser) {
          appraiser.assetRelation[asset.id] = {
            workedInAsset: false,
            workedLastQuarter: false
          };
          for(var i = 0; i < users.length; i++){
            var user = users[i];
            if(appraiser.user.id === user.user.id){
              appraiser.assetRelation[asset.id].workedInAsset = true;
            }

            if(user.userCompanyId === appraiser.companyId){
              for(var j = 0; j < user.periods.length; j++){
                var period = user.periods[j];
                if(asset.valuation && period.active && period.quarter == asset.valuation.quarter && period.year == asset.valuation.year){
                  appraiser.assetRelation[asset.id].workedLastQuarter = true;
                  break;
                }
              }
            }
          }
        });
        vm.selectAllUsersForAsset(asset);
      });

    });
    vm.appraisers.forEach(function (appraiser) {
      vm.userSelectedCount[appraiser.id] = [];
    });
    vm.appraisersSort = [
      {
        sort: 'propertyRef',
        tag: 'propertyRef',
        selected: true,
        flag: true
      },
      {
        sort: 'name',
        tag: 'name',
        selected: false,
        flag: false
      }
    ];
    vm.appraisersSelectedSort = vm.appraisersSort[0];

    //SORTING
    //------------------------------------------
    vm.sorting = function (sort, target) {
      ArrayHelper.sort(sort, target, vm.appraisersSort, vm);
    };

    //DATEPICKER
    //------------------------------------------------------
    vm.bidDuePicker = {
      opened: false
    };

    vm.dateOptions = {
      startingDay: 1,
      showWeeks: false
    };

    vm.modelOptions = {
      debounce: {
        default: 500,
        blur: 250
      },
      getterSetter: true
    };

    CompanySelectorFactory.showDisabledCompanies();

    //GET ASSET DETAIL
    //------------------------------------------
    vm.getAssetDetail = function (selectedAsset) {
      vm.assets.forEach(function (asset) {
        asset.displaying = false;
      });
      vm.selectedAsset = selectedAsset;
      selectedAsset.displaying = true;
    };
    vm.getAssetDetail(vm.assets[0]);

    //SELECT ALL
    //------------------------------------------
    vm.selectAllUsersForAsset = function (asset) {
      vm.selectedUsersByAsset[asset.id].allSelected = !vm.selectedUsersByAsset[asset.id].allSelected;
      if (vm.selectedUsersByAsset[asset.id].allSelected) {
        vm.selectedUsersByAsset[asset.id].count = 0;
        vm.appraisers.forEach(function (appraiser) {
          if(appraiser.assetRelation[asset.id] && !appraiser.assetRelation[asset.id].workedLastQuarter) {
            vm.selectedUsersByAsset[asset.id].count ++;
            vm.selectedUsersByAsset[asset.id].usersIds[appraiser.user.id] = true;
            if (vm.userSelectedCount[appraiser.id].indexOf(asset.id) === -1) {
              vm.userSelectedCount[appraiser.id].push(asset.id);
            }
          }
        });
      } else {
        vm.appraisers.forEach(function (appraiser) {
          if(!appraiser.assetRelation[asset.id].workedLastQuarter){
            vm.selectedUsersByAsset[asset.id].usersIds[appraiser.user.id] = false;
            vm.selectedUsersByAsset[asset.id].count = 0;
            if (vm.userSelectedCount[appraiser.id].indexOf(asset.id) !== -1) {
              vm.userSelectedCount[appraiser.id].splice(vm.userSelectedCount[appraiser.id].indexOf(asset.id), 1);
            }
          }
        });
      }
    };

    vm.userSelectedForAssetChanged = function (user) {
      if (vm.selectedUsersByAsset[vm.selectedAsset.id].usersIds[user.user.id]) {
        vm.selectedUsersByAsset[vm.selectedAsset.id].count++;
        vm.userSelectedCount[user.id].push(vm.selectedAsset.id);
      } else {
        vm.selectedUsersByAsset[vm.selectedAsset.id].count--;
        vm.userSelectedCount[user.id].splice(vm.userSelectedCount[user.id].indexOf(vm.selectedAsset.id), 1);
      }
    };

    vm.openBidDuePicker = function () {
      vm.bidDuePicker.opened = true;
    };

    vm.saveRFP = function(){
      if(vm.requestForm.$invalid){
        return;
      }
      var appraisersIdsByAssetIds = {};
      for(var i = 0; i < vm.assets.length ;i ++){
        if(vm.selectedUsersByAsset[vm.assets[i].id].count === 0){
          notify({
            message: $filter('translate')('ADD_RFP.MISSING_APPRAISER'),
            duration: 4000,
            templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
            classes: 'alert-danger',
            position: 'center'
          });
          return; //display an error, all assets must have at least 1 appraiser
        }else{
          appraisersIdsByAssetIds[vm.assets[i].id] = [];
          Object.keys(vm.selectedUsersByAsset[vm.assets[i].id].usersIds).forEach(function(key){
            var user = vm.selectedUsersByAsset[vm.assets[i].id].usersIds[key];
            if(user){
              appraisersIdsByAssetIds[vm.assets[i].id].push(parseInt(key));
            }
          });

        }
      }
      vm.bidOverDate = UtcDateConverter.setDateToUTC(vm.bidOverDate);

      BidRequestService.create(requestForm.company.id, vm.requestName, vm.bidOverDate, appraisersIdsByAssetIds).then(function(){
        $scope.$parent.finished = true;
        notify({
          message: $filter('translate')('ADD_RFP.SENT'),
          duration: 4000,
          templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
          classes: 'alert-info',
          position: 'center'
        });
        $state.go('app.bidEngagement.bidEngagementList');
      });
    };

  }

})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .config(routeConfig);

  function routeConfig($stateProvider) {
    $stateProvider.state('app.asset.bidGroups.editBidGroup', {
      url: '/edit-bid-group/:companyId/:id',
      views: {
        "@app": {
          templateUrl: 'app/states/assets/bid-groups/edit-bid-group/edit-bid-group.html',
          controller: 'EditBidGroupController',
          controllerAs: 'editBidGroupCtrl'
        }
      },
      data: {
        pageTitle: 'Edit Bid Group',
        viewClass: 'newBidGroup',
        roles: ['Admin']
      },
      params: {
        id: '',
        companyId: '',
        bidGroup: null
      },
      resolve: {
        /** @ngInject */
        company: function ($q, $stateParams, CompanyService) {
          if (!$stateParams.companyId && !$stateParams.bidGroup) {
            return $q.reject({
              error: 'invalidTransition',
              fallback: 'app.asset.bidGroups'
            });
          }
          if(!$stateParams.companyId) {
            return CompanyService.getCompany($stateParams.bidGroup.companyId);
          }
          return CompanyService.getCompany($stateParams.companyId);
        },
        /** @ngInject */
        bidGroup: function ($q, $stateParams, BidGroupService) {
          if (!$stateParams.id) {
            return $q.reject({
              error: 'invalidTransition',
              fallback: 'app.asset.bidGroups'
            });
          }
          if ($stateParams.bidGroup) {
            return $stateParams.bidGroup;
          }
          return BidGroupService.get($stateParams.id);
        },
        /** @ngInject */
        propertyTypes: function (StaticDataService) {
          return StaticDataService.getPropertyTypes();
        },
        /** @ngInject */
        subtypesByPropertyTypes: function (StaticDataService) {
          return StaticDataService.getSubtypesByPropertyTypes();
        }
      }
    });
  }

})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .controller('EditBidGroupController', EditBidGroupController);

  /**@ngInject*/
  function EditBidGroupController ($q, $filter, $state, $scope, notify, LoaderHelper, BidGroupService, AssetService,
                                   company, bidGroup, propertyTypes, subtypesByPropertyTypes, ArrayHelper, CompanySelectorFactory) {
    var vm = this;

    vm.company = company;
    vm.searchQuery = '';
    vm.assets = [];
    vm.bidGroup = bidGroup;
    vm.bidGroupAssets = [];
    vm.hideList = true;
    vm.hideBid = true;
    vm.isHoverList = false;
    vm.isHoverBid = false;
    vm.propertyTypes = propertyTypes.items;
    vm.subtypesByPropertyTypes = subtypesByPropertyTypes;
    vm.assetSort = [
      {
        sort: 'name',
        tag: 'name',
        selected: true,
        flag: true
      }
    ];
    vm.assetSelectedSort = vm.assetSort[0];
    vm.bidGroupAssetSort = [
      {
        sort: 'name',
        tag: 'name',
        selected: true,
        flag: true
      }
    ];
    vm.bidGroupAssetSelectedSort = vm.bidGroupAssetSort[0];

    CompanySelectorFactory.showDisabledCompanies();
    AssetService.getAssetsByCompany(company.id, true).then(function (assets) {
      vm.assets = [];
      for (var i = 0; i < assets.length; i++) {
        if (!assets[i].bidGroupId) {
          vm.assets.push(assets[i]);
        }
      }
      vm.assets = castPropertyTypes(vm.assets);
    });

    AssetService.getAssetsByBidGroup(bidGroup.id).then(function (assets) {
      bidGroup.assets = castPropertyTypes(assets);
    });

    //BREADCRUMS
    //-------------------------------------------------------
    vm.title = vm.bidGroup.name;
    vm.breadcrumbs = [
      {
        label: $filter('translate')('ASSETS.TITLE'),
        value: 'app.asset.bidGroups'
      },
      {
        label: $filter('translate')('BID_GROUPS.TITLE'),
        value: 'app.asset.bidGroups'
      },
      {
        label: $filter('translate')('EDIT_BID_GROUP.TITLE'),
        value: 'app.asset.bidGroups.editBidGroup'
      }
    ];

    //SORTING
    //------------------------------------------
    vm.sorting = function (sort, target) {
      ArrayHelper.sort(sort, target, vm.assetSort, vm);
    };

    vm.sortingBidGroupAssets = function (sort, target) {
      ArrayHelper.sort(sort, target, vm.bidGroupAssetSort, vm);
    };

    //SEARCH FUNCTION
    //------------------------------------------
    vm.searchAssets = function () {
      ArrayHelper.searchScroll();
    };

    //SAVE BID GROUP
    //------------------------------------------
    vm.submitForm = function (bidGroup) {
      var assetsIds = [],
        removedAssetsId = [],
        promises = [],
        bidGroupDTO = {};
      bidGroupDTO.id = bidGroup.id;
      bidGroupDTO.name = bidGroup.name;
      LoaderHelper.open();
      for (var i = 0; i < bidGroup.assets.length; i++) {
        if (!bidGroup.assets[i].bidGroupId) {
          assetsIds.push(bidGroup.assets[i].id);
        }
      }
      for (i = 0; i < vm.assets.length; i++) {
        var asset = vm.assets[i];
        if (asset.bidGroupId) {
          removedAssetsId.push(asset.id);
        }
      }
      promises.push(BidGroupService.assignAssets(bidGroup.id, assetsIds, removedAssetsId));

      promises.push(BidGroupService.update(bidGroupDTO));

      $q.all(promises).then(function () {
        notify({
          message: $filter('translate')('COMMONS.EDIT_BID_GROUP'),
          duration: 4000,
          templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
          classes: 'alert-info',
          position: 'center'
        });
        $state.go('app.asset.bidGroups');
      }, function () {
        LoaderHelper.close();
      });
    };

    //NEW ASSETS LIST FOR BID GROUP
    //------------------------------------------
    vm.addBidGroupAsset = function (asset) {
      vm.bidGroup.assets.push(asset);
      var assets = vm.assets;
      vm.assets = [];
      for (var i = 0; i < assets.length; i++) {
        if (asset.id != assets[i].id) {
          vm.assets.push(assets[i]);
        }
      }
    };

    vm.removeBidGroupAsset = function (asset) {
      vm.assets.push(asset);
      var assets = vm.bidGroup.assets;
      vm.bidGroup.assets = [];
      for (var i = 0; i < assets.length; i++) {
        if (asset.id != assets[i].id) {
          vm.bidGroup.assets.push(assets[i]);
        }
      }
    };

    //DRAG 'N DROP
    //------------------------------------------
    vm.moveToBid = function (asset) {
      for (var i = 0; i < vm.assets.length; i++) {
        if (asset.id == vm.assets[i].id) {
          vm.assets.splice(i, 1);
          vm.bidGroup.assets.push(asset);
          break;
        }
      }
      vm.hideBid = true;
      vm.isHoverBid = false;
    };

    vm.moveToList = function (asset) {
      for (var i = 0; i < vm.bidGroup.assets.length; i++) {
        if (asset.id == vm.bidGroup.assets[i].id) {
          vm.bidGroup.assets.splice(i, 1);
          vm.assets.push(asset);
          break;
        }
      }
      vm.hideList = true;
      vm.isHoverList = false;
    };

    vm.showDropZoneList = function () {
      vm.hideList = false;
      vm.isHoverList = true;
    };

    vm.showDropZoneBid = function () {
      vm.hideBid = false;
      vm.isHoverBid = true;
    };

    function castPropertyTypes (assets) {
      for (var i = 0; i < assets.length; i++) {
        vm.subtypesByPropertyTypes = subtypesByPropertyTypes[assets[i].type];
        for (var j = 0; j < vm.propertyTypes.length; j++) {
          if (assets[i].type == vm.propertyTypes[j].type) {
            assets[i].type = vm.propertyTypes[j].name;
            for (var k = 0; k < vm.subtypesByPropertyTypes.length; k++) {
              if (assets[i].subType == vm.subtypesByPropertyTypes[k].type) {
                assets[i].subType = vm.subtypesByPropertyTypes[k].name;
                break;
              }
            }
            break;
          }
        }
      }
      return assets;
    }

    var assetsLoaded = false;
    var bidGroupListWatcher = $scope.$watch('editBidGroupCtrl.bidGroup.assets', function (newValue) {
      if (assetsLoaded) {
        if (newValue) {
          vm.addBidGroupForm.$dirty = true;
        }
      } else {
        assetsLoaded = true;
      }
    }, true);

    $scope.$on('$destroy', function () {
      bidGroupListWatcher();
    });

  }

})();
(function () {
  'use strict';

  angular
    .module('nvc')
    .config(routeConfig);

  function routeConfig($stateProvider) {
    $stateProvider.state('app.asset.bidGroups.addBidGroup', {
      url: '/new-bid-group',
      views: {
        "@app": {
          templateUrl: 'app/states/assets/bid-groups/add-bid-group/add-bid-group.html',
          controller: 'AddBidGroupController',
          controllerAs: 'addBidGroupCtrl'
        }
      },
      data: {
        pageTitle: 'New Bid Group',
        viewClass: 'newBidGroup',
        roles: ['Admin']
      },
      resolve: {
        /** @ngInject */
        companies: function ($q, CompanyService) {
          return CompanyService.getClientCompanies(true, true);
        },
        /** @ngInject */
        propertyTypes: function (StaticDataService) {
          return StaticDataService.getPropertyTypes();
        },
        /** @ngInject */
        subtypesByPropertyTypes: function (StaticDataService) {
          return StaticDataService.getSubtypesByPropertyTypes();
        }
      }
    });
  }

})();

(function () {
  'use strict';

  angular
  .module('nvc')
  .controller('AddBidGroupController', AddBidGroupController);

  /** @ngInject */
  function AddBidGroupController($state, $scope, $filter, notify, LoaderHelper, CompanySelectorFactory, AssetService,
                                 BidGroupService, companies, propertyTypes, subtypesByPropertyTypes, ArrayHelper) {
    var vm = this;

    vm.searchQuery = '';
    vm.assets = [];
    vm.newBidGroup = {};
    vm.bidGroupAssets = [];
    vm.hideList = true;
    vm.hideBid = true;
    vm.isHoverList = false;
    vm.isHoverBid = false;
    vm.propertyTypes = propertyTypes.items;
    vm.subtypesByPropertyTypes = [];
    vm.assetSort = [
      {
        sort: 'name',
        tag: 'name',
        selected: true,
        flag: true
      }
    ];
    vm.assetSelectedSort = vm.assetSort[0];
    vm.bidGroupAssetSort = [
      {
        sort: 'name',
        tag: 'name',
        selected: true,
        flag: true
      }
    ];
    vm.bidGroupAssetSelectedSort = vm.bidGroupAssetSort[0];

    //BREADCRUMS
    //-------------------------------------------------------
    vm.title = $filter('translate')('ADD_BID_GROUP.TITLE');
    vm.breadcrumbs = [
      {
        label: $filter('translate')('ASSETS.TITLE'),
        value: 'app.asset.bidGroups'
      },
      {
        label: $filter('translate')('BID_GROUPS.TITLE'),
        value: 'app.asset.bidGroups'
      },
      {
        label: $filter('translate')('ADD_BID_GROUP.TITLE'),
        value: 'app.asset.bidGroups.addBidGroup'
      }
    ];

    //SORTING
    //------------------------------------------
    vm.sorting = function (sort, target) {
      ArrayHelper.sort(sort, target, vm.assetSort, vm);
    };

    vm.sortingBidGroupAssets = function (sort, target) {
      ArrayHelper.sort(sort, target, vm.bidGroupAssetSort, vm);
    };

    //SEARCH FUNCTION
    //------------------------------------------
    vm.searchAssets = function () {
      ArrayHelper.searchScroll();
    };

    //GET ASSETS BY COMPANY
    //------------------------------------------
    CompanySelectorFactory.showCompanies(companies);
    var companyListener = $scope.$on('companyChanged', function (event, selectedCompany) {
      CompanySelectorFactory.executeOnValidState('app.asset.bidGroups.addBidGroup', function () {
        AssetService.getAssetsByCompany(selectedCompany.id, true).then(function (assets) {
          vm.assets = [];
          for (var i = 0; i < assets.length; i++) {
            if (!assets[i].bidGroupId) {
              vm.assets.push(assets[i]);
            }
          }
          for (var i = 0; i < vm.assets.length; i++) {
            vm.subtypesByPropertyTypes = subtypesByPropertyTypes[vm.assets[i].type];
            for (var j = 0; j < vm.propertyTypes.length; j++) {
              if (vm.assets[i].type == vm.propertyTypes[j].type) {
                vm.assets[i].type = vm.propertyTypes[j].name;
                for (var k = 0; k < vm.subtypesByPropertyTypes.length; k++) {
                  if (vm.assets[i].subType == vm.subtypesByPropertyTypes[k].type) {
                    vm.assets[i].subType = vm.subtypesByPropertyTypes[k].name;
                    break;
                  }
                }
                break;
              }
            }
          }
          vm.bidGroupAssets = [];
          vm.newBidGroup.companyId = selectedCompany.id;
        });
      });
    });

    //SAVE NEW BID GROUP
    //------------------------------------------
    vm.submitForm = function (newBidGroup) {
      LoaderHelper.open();
      BidGroupService.create(newBidGroup).then(function (bidGroup) {
        var assetsIds = [];
        for (var i = 0; i < vm.bidGroupAssets.length; i++) {
          assetsIds.push(vm.bidGroupAssets[i].id);
        }

        BidGroupService.assignAssets(bidGroup.id, assetsIds).then(function () {
          notify({
            message: $filter('translate')('COMMONS.NEW_BID_GROUP'),
            duration: 4000,
            templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
            classes: 'alert-info',
            position: 'center'
          });
          $state.go('app.asset.bidGroups');
        }, function () {
          LoaderHelper.close();
          $state.go('app.asset.bidGroups', {}, {reload: true});
        });
      }, function () {
        LoaderHelper.close();
      });
    };

    //NEW ASSETS LIST FOR BID GROUP
    //------------------------------------------
    vm.addBidGroupAsset = function (asset) {
      vm.bidGroupAssets.push(asset);
      var assets = vm.assets;
      vm.assets = [];
      for (var i = 0; i < assets.length; i++) {
        if (asset.id != assets[i].id) {
          vm.assets.push(assets[i]);
        }
      }
    };

    vm.removeBidGroupAsset = function (asset) {
      vm.assets.push(asset);
      var assets = vm.bidGroupAssets;
      vm.bidGroupAssets = [];
      for (var i = 0; i < assets.length; i++) {
        if (asset.id != assets[i].id) {
          vm.bidGroupAssets.push(assets[i]);
        }
      }
    };

    //DRAG 'N DROP
    //------------------------------------------
    vm.moveToBid = function (asset) {
      for (var i = 0; i < vm.assets.length; i++) {
        if (asset.id == vm.assets[i].id) {
          vm.assets.splice(i, 1);
          vm.bidGroupAssets.push(asset);
          break;
        }
      }
      vm.hideBid = true;
      vm.isHoverBid = false;
    };

    vm.moveToList = function (asset) {
      for (var i = 0; i < vm.bidGroupAssets.length; i++) {
        if (asset.id == vm.bidGroupAssets[i].id) {
          vm.bidGroupAssets.splice(i, 1);
          vm.assets.push(asset);
          break;
        }
      }
      vm.hideList = true;
      vm.isHoverList = false;
    };

    vm.showDropZoneList = function () {
      vm.hideList = false;
      vm.isHoverList = true;
    };

    vm.showDropZoneBid = function () {
      vm.hideBid = false;
      vm.isHoverBid = true;
    };

    var bidGroupListWatcher = $scope.$watch('addBidGroupCtrl.bidGroupAssets', function () {
      if (0 == vm.bidGroupAssets.length) {
        vm.addBidGroupForm.$invalid = true;
        vm.addBidGroupForm.$valid = false;
        vm.addBidGroupForm.$dirty = false;
      } else {
        vm.addBidGroupForm.$dirty = true;
      }
    }, true);

    $scope.$on('$destroy', function () {
      companyListener();
      bidGroupListWatcher();
    });
  }

})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .controller('CropImageModalController', CropImageModalController);

  function CropImageModalController($uibModalInstance, $scope, selectedPhoto) {
    $scope.selectedPhoto = selectedPhoto;
    $scope.croppedPhoto = '';
    $scope.selectCroppedImage = selectCroppedImage;
    $scope.cancel = cancel;

    function selectCroppedImage() {
      $uibModalInstance.close($scope.croppedPhoto);
    }

    function cancel() {
      $uibModalInstance.dismiss('cancel');
    }
  }

})();
(function () {
  'use strict';

  angular
    .module('nvc')
    .config(routeConfig);

  function routeConfig($stateProvider) {
    $stateProvider.state('app.review', {
      url: '/asset/:assetId/review/:valuationId',
      views: {
        '@app': {
          templateUrl: 'app/states/valuations/review/review.html',
          controller: 'ReviewController',
          controllerAs: 'reviewCtrl'
        }
      },
      data: {
        viewClass: 'review',
        roles: ['Admin', 'Audit', 'AssetManagement', 'AssetAppraisal', 'AssetReview', 'AssetManagerReadOnly']
      },
      params: {
        assetId: '',
        valuationId: ''
      },
      resolve: {
        /** @ngInject */
        review: function ($stateParams, ReviewFactory) {
          return ReviewFactory.loadReview($stateParams.assetId, $stateParams.valuationId);
        },
        readOnly: function (SessionManager, review) {
          if(SessionManager.isInRole('Admin') || SessionManager.isInRole('AssetReview')){
            return false;
          }
          var currentUser = review.asset.users[SessionManager.getUser().id];
          if (currentUser) {
            for (var i = 0; i < currentUser.periods.length; i++) {
              var period = currentUser.periods[i];
              if (period.active && period.year == review.year && period.quarter == review.quarter) {
                return false;
              }
            }
          }
          return true;
        },
        prevValuationsObj: function ($stateParams, ReviewFactory, review) {
          return ReviewFactory.loadPrevValuationsData($stateParams.assetId, review);
        }
      }
    });
  }

})();

(function () {
  'use strict';

  angular
  .module('nvc')
  .controller('ReviewController', ReviewController);

  /**@ngInject*/
  function ReviewController($scope, $state, $filter, ReviewStatusHelper, review, readOnly, prevValuationsObj){

    var vm = this;
    vm.review = review;
    vm.readOnly = readOnly;
    vm.prevValuationsObj = prevValuationsObj;
    if($state.current.name === 'app.review'){
      $state.go(ReviewStatusHelper.getInitialView(vm.review), {}, {location:'replace'});
    }

    vm.title = $filter('translate')(vm.review.asset.name);

    //BREADCRUMS
    //------------------------------------------
    vm.breadcrumbs = [
      {
        label: $filter('translate')('COMMONS.VALUATIONS'),
        value: 'app.valuations'
      }
    ];

    var stateChangeEvent = $scope.$on('$stateChangeSuccess', function(event, state){
      if(state.name.indexOf('app.review.discussion') != -1){
        vm.breadcrumbs[1] ={
          label: $filter('translate')('REVIEW.REVIEW'),
          value: 'app.review.discussion.comments'
        };
        if(state.name ==='app.review.discussion'){
          $state.go('app.review.discussion.comments')
        }
      }else if(state.name === 'app.review.documentsUpload'){
        vm.breadcrumbs[1] ={
          label: $filter('translate')('REVIEW.DOCUMENTS'),
          value: 'app.review.documentsUpload'
        }
      }else if(state.name === 'app.review.documents'){
        vm.breadcrumbs[1] ={
          label: $filter('translate')('REVIEW.DOCUMENTS'),
          value: 'app.review.documents'
        }
      }else if(state.name === 'app.review.property'){
        vm.breadcrumbs[1] ={
          label: $filter('translate')('REVIEW.PROPERTY'),
          value: 'app.review.property'
        }
      }
    });

    $scope.$on('$destroy', function(){
      stateChangeEvent()
    });

  }

})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .factory('ReviewStatusHelper', ReviewStatusHelper);

  /**ngInject*/
  function ReviewStatusHelper($q, SessionManager, UserService) {

    var discussionState = 'app.review.discussion';
    var rolesInitialState = {
      Admin: {
        Created: 'app.review.documentsUpload',
        DocumentsUploaded: 'app.review.documents',
        FormFilled: discussionState,
        ReviewerCommented: discussionState,
        ManagerCommented: discussionState,
        SubmittedToAppraiser: discussionState,
        CommentsAnswered: 'app.review.documentsUpload',
        DocumentsUpdated: 'app.review.documents',
        ValuationUpdated: discussionState,
        ReviewerApproveValuation: discussionState,
        ManagerApproveValuation: discussionState,
        ValuationSignedOff: 'app.review.documentsUpload',
        FinalDocumentsUploaded: 'app.review.documents',
        FinalFormFilled: 'app.review.documentsHistory',
        Finished: 'app.review.documentsHistory'
      },
      AssetManagement: {
        Created: discussionState,
        DocumentsUploaded: discussionState,
        FormFilled: discussionState,
        ReviewerCommented: discussionState,
        ManagerCommented: discussionState,
        SubmittedToAppraiser: discussionState,
        CommentsAnswered: discussionState,
        DocumentsUpdated: discussionState,
        ValuationUpdated: discussionState,
        ReviewerApproveValuation: discussionState,
        ManagerApproveValuation: discussionState,
        ValuationSignedOff: discussionState,
        FinalDocumentsUploaded: discussionState,
        FinalFormFilled: discussionState,
        Finished: 'app.review.documentsHistory'
      },
      AssetManagerReadOnly: {
        Created: discussionState,
        DocumentsUploaded: discussionState,
        FormFilled: discussionState,
        ReviewerCommented: discussionState,
        ManagerCommented: discussionState,
        SubmittedToAppraiser: discussionState,
        CommentsAnswered: discussionState,
        DocumentsUpdated: discussionState,
        ValuationUpdated: discussionState,
        ReviewerApproveValuation: discussionState,
        ManagerApproveValuation: discussionState,
        ValuationSignedOff: discussionState,
        FinalDocumentsUploaded: discussionState,
        FinalFormFilled: discussionState,
        Finished: 'app.review.documentsHistory'
      },
      AssetAppraisal: {
        Created: 'app.review.documentsUpload',
        DocumentsUploaded: 'app.review.documents',
        FormFilled: discussionState,
        ReviewerCommented: discussionState,
        ManagerCommented: discussionState,
        SubmittedToAppraiser: discussionState,
        CommentsAnswered: 'app.review.documentsUpload',
        DocumentsUpdated: 'app.review.documents',
        ValuationUpdated: discussionState,
        ReviewerApproveValuation: discussionState,
        ManagerApproveValuation: discussionState,
        ValuationSignedOff: 'app.review.documentsUpload',
        FinalDocumentsUploaded: 'app.review.documents',
        FinalFormFilled: discussionState,
        Finished: 'app.review.documentsHistory'
      },
      AssetReview: {
        Created: discussionState,
        DocumentsUploaded: discussionState,
        FormFilled: discussionState,
        ReviewerCommented: discussionState,
        ManagerCommented: discussionState,
        SubmittedToAppraiser: discussionState,
        CommentsAnswered: discussionState,
        DocumentsUpdated: discussionState,
        ValuationUpdated: discussionState,
        ReviewerApproveValuation: discussionState,
        ManagerApproveValuation: discussionState,
        ValuationSignedOff: discussionState,
        FinalDocumentsUploaded: discussionState,
        FinalFormFilled: 'app.review.documentsHistory',
        Finished: 'app.review.documentsHistory'
      },
      Audit: {
        Created: discussionState,
        DocumentsUploaded: discussionState,
        FormFilled: discussionState,
        ReviewerCommented: discussionState,
        ManagerCommented: discussionState,
        SubmittedToAppraiser: discussionState,
        CommentsAnswered: discussionState,
        DocumentsUpdated: discussionState,
        ValuationUpdated: discussionState,
        ReviewerApproveValuation: discussionState,
        ManagerApproveValuation: discussionState,
        ValuationSignedOff: discussionState,
        FinalDocumentsUploaded: discussionState,
        FinalFormFilled: discussionState,
        Finished: 'app.review.documentsHistory'
      }
    };
    var actionRules = {
      Created: {
        AP_UploadDocuments: ['AssetAppraisal', 'Admin'],
        AP_Submit: ['AssetAppraisal'],
        RW_Submit: ['AssetReview', 'Admin'],
      },
      DocumentsUploaded: {
        AP_Submit: ['AssetAppraisal', 'Admin'],
        RW_Submit: ['AssetReview', 'Admin']
      },
      FormFilled: { //status = FormFilled
        AM_Comment: ['AssetManagement', 'Admin', 'AssetManagerReadOnly'],
        RW_Comment: ['AssetReview', 'Admin'],
        RW_Approve: ['AssetReview', 'Admin'],
        AP_Submit: ['AssetAppraisal'],
        RW_Submit: ['AssetReview', 'Admin'],
        RW_SubmitToAppraiser: ['AssetReview']
      },
      ReviewerCommented: { //status = Reviewer commented to AM
        AM_Comment: ['AssetManagement', 'Admin', 'AssetManagerReadOnly'],
        AP_Submit: ['AssetAppraisal'],
        RW_Submit: ['AssetReview', 'Admin'],
        RW_Comment: ['AssetReview']
      },
      ManagerCommented: {
        RW_Submit: ['AssetReview', 'Admin'],
        RW_Approve: ['AssetReview', 'Admin'],
        AP_Submit: ['AssetAppraisal'],
        RW_SubmitToAppraiser: ['AssetReview', 'Admin'],
      },
      SubmittedToAppraiser: { //status = submitted to AP
        AP_Reply: ['AssetAppraisal', 'Admin'],
        RW_Retract: ['AssetReview', 'Admin'],
        AP_Submit: ['AssetAppraisal'],
        RW_Submit: ['AssetReview', 'Admin'],
        LRW_Comment: ['AssetReview'],
        RW_SubmitToAppraiser: ['AssetReview']
      },
      CommentsAnswered: {
        AP_Submit: ['AssetAppraisal', 'Admin'],
        AP_UploadDocuments: ['AssetAppraisal', 'Admin'],
        RW_Retract: ['AssetReview', 'Admin'],
        RW_Submit: ['AssetReview', 'Admin'],
        LRW_Comment: ['AssetReview'],
        RW_SubmitToAppraiser: ['AssetReview']
      },
      DocumentsUpdated: {
        AP_Submit: ['AssetAppraisal', 'Admin'],
        RW_Retract: ['AssetReview', 'Admin'],
        RW_Submit: ['AssetReview', 'Admin'],
        LRW_Comment: ['AssetReview'],
        RW_SubmitToAppraiser: ['AssetReview']
      },
      ValuationUpdated: {
        AM_Comment: ['AssetManagement', 'Admin', 'AssetManagerReadOnly'],
        RW_Submit: ['AssetReview', 'Admin'],
        RW_Approve: ['AssetReview', 'Admin'],
        AP_Submit: ['AssetAppraisal', 'Admin'],
        RW_SubmitToAppraiser: ['AssetReview', 'Admin']
      },
      ReviewerApproveValuation: {
        AM_Comment: ['AssetManagement', 'Admin', 'AssetManagerReadOnly'],
        AM_Approve: ['AssetManagement', 'Admin','AssetManagerReadOnly'],
        RW_Submit: ['AssetReview', 'Admin'],
        AP_Submit: ['AssetAppraisal', 'Admin'],
        LRW_Comment: ['AssetReview'],
        RW_SubmitToAppraiser: ['AssetReview']
      },
      ManagerApproveValuation: {
        LRW_Comment: ['AssetReview', 'Admin'],
        LRW_Approve: ['AssetReview', 'Admin'],
        RW_Submit: ['AssetReview', 'Admin'],
        AP_Submit: ['AssetAppraisal', 'Admin'],
        RW_SubmitToAppraiser: ['AssetReview']
      },
      ValuationSignedOff: {  //Status = Final value approved
        AP_UploadFinalDocuments: ['AssetAppraisal', 'Admin'],
        LRW_Comment: ['AssetReview'],
        RW_SubmitToAppraiser: ['AssetReview']
      },
      FinalDocumentsUploaded: {
        AP_FillFinalForm: ['AssetAppraisal', 'Admin'],
        LRW_Comment: ['AssetReview'],
        RW_SubmitToAppraiser: ['AssetReview']
      },
      FinalFormFilled: {
        RW_ArchiveDocuments: ['AssetReview', 'Admin'],
        RW_Reject: ['AssetReview', 'Admin']
      },
      Finished: {
        ADMIN_UpdateDocuments: ['Admin']
      }
    };
    /**
     *
     * @type object that describe the status name to be displayed depending of the current status, user, previous action or the past status.
     * 1) if any given value is a string then that is the value to be displayed
     * 2) if the key is an object that means that the status to be displayed is different between users
     *  2.1) if the value is a string then that is the name to be displayed
     *  2.2) if the value is an object and the keys for that object is a string then that string means that the name to be displayed depends of the action that was taken to get to this state
     *  2.3) if the value is an object and the keys for that object is a number N:
     *     then the value should be an array with 2 entries where the first one is an object and the second one a string (which will be the fallback)
     *    if the status N, status ago is equal to any of the keys in the object then the value is the name to be displayed
     *    if no status match then the second entry of the array is the name to be displayed
     */
    var statesToNames = {
      Created: 'Draft Not Submitted',
      DocumentsUploaded: 'Draft Not Submitted',
      FormFilled: 'Draft Submitted',
      ReviewerCommented: {
        Others: 'RV Commented to AM',
        AssetAppraisal: 'Draft Submitted'
      },
      ManagerCommented: {
        Others: 'AM Commented',
        AssetAppraisal: 'Draft Submitted'
      },
      SubmittedToAppraiser: 'Submitted to AP',
      CommentsAnswered: 'Submitted to AP',
      DocumentsUpdated: 'Submitted to AP',
      ValuationUpdated: 'AP Responded',
      ReviewerApproveValuation: {
        Others: 'RV Approved',
        AssetAppraisal: { 1: [{ FormFilled: 'Draft Submitted', ManagerCommented: 'Draft Submitted', ValuationUpdated: 'AP Responded' }, 'AP Responded'] }
      },
      ManagerApproveValuation: {
        Others: 'AM Approved',
        AssetAppraisal: { 2: [{ FormFilled: 'Draft Submitted', ManagerCommented: 'Draft Submitted', ValuationUpdated: 'AP Responded' }, 'AP Responded'] }
      },
      ValuationSignedOff: {
        Others: {
          'LRW_Approve': 'Final Value Approved',
          'RW_Reject': 'Final Files Rejected'
        },
        AssetAppraisal: {
          'LRW_Approve': 'Final Value Approved',
          'RW_Reject': 'Final Files Rejected'
        }
      },
      FinalDocumentsUploaded: {
        Others: {
          AP_UploadFinalDocuments: 'Final Value Approved',
          AP_ReUploadFinalDocuments: 'Final Files Rejected'
        },
        AssetAppraisal: {
          AP_UploadFinalDocuments: 'Final Value Approved',
          AP_ReUploadFinalDocuments: 'Final Files Rejected'
        }
      },
      FinalFormFilled: 'Final Files Submitted',
      Finished: 'Completed'
    };

    return {
      getInitialView: getInitialView,
      validateAction: validateAction,
      getCurrentAction: getCurrentAction,
      getLatestAction: getLatestAction
    };

    function getLatestAction(statusDescription, review) {
      if (statusDescription) {
        return statusDescription;
      }
      else if (review instanceof ReviewModel && review.status) {
        var currentDate = moment();
        var diff = currentDate.diff(review.nextDraftDueDate, 'days');

        if (diff > 0 && (review.status == 'Created' || review.status == 'DocumentsUploaded')) {
          return diff + ' Days Overdue';
        }
        else if (review.status == 'Finished') {
          return 'Completed';
        }
        else {
          return getCurrentAction(review);
        }
      }
      else {
        return 'Not Started';
      }
    }

    function getInitialView(review, role) {
      role = role ? role : SessionManager.getRoleName();
      return rolesInitialState[role][review.getCurrentStatus()];
    }

    function validateAction(review, action, role) {
      var status = review.getCurrentStatus();
      if (status === 'ManagerApproveValuation' && SessionManager.getRoleName() !== 'Admin') {
        return UserService.getUser().then(function (user) {
          // if (review.asset.users[user.id].type === 'PrimaryAssetReviewer') {
            return validateRoleAction(status, role, action);
          // }
          // return $q.reject(false);
        });
      }
      return validateRoleAction(status, role, action);
    }

    function validateRoleAction(status, role, action) {
      role = role ? role : SessionManager.getRoleName();
      var roles = actionRules[status][action];
      if (roles && roles.indexOf(role) !== -1) {
        return $q.resolve(true);
      }
      return $q.reject(false);
    }

    function getCurrentAction(review) {
      var nameByStatus = statesToNames[review.status];
      if (typeof nameByStatus === 'string') {
        return nameByStatus;
      } else {
        var userType = getUserType(nameByStatus, SessionManager.getRoleName());
        var nameByUserType = nameByStatus[userType];
        if (typeof nameByUserType === 'string') {
          return nameByUserType;
        } else {
          if (isNaN(Object.keys(nameByUserType)[0])) {
            if (!review.statusChangedWithAction) {
              return nameByUserType[Object.keys(nameByUserType)[0]];
            }
            return nameByUserType[review.statusChangedWithAction];
          } else {
            var nameByStatusAgoOptions = nameByUserType[Object.keys(nameByUserType)[0]],
              nameByStatusAgo;
            if (review.statusHistory && review.statusHistory.length - 1 - Object.keys(nameByUserType)[0] >= 0) {
              nameByStatusAgo = nameByStatusAgoOptions[0][review.statusHistory[review.statusHistory.length - 1 - Object.keys(nameByUserType)[0]].status];
            }
            if (!nameByStatusAgo) {
              return nameByStatusAgoOptions[1];
            } else {
              return nameByStatusAgo;
            }
          }
        }
      }
    }

    function getUserType(namesByUserType, userType) {
      if (Object.keys(namesByUserType).indexOf(userType) != -1) {
        return userType;
      }
      return 'Others';
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .controller('AdvancedFiltersController', AdvancedFiltersController);

  /** @ngInject */
  function AdvancedFiltersController($scope, $uibModalInstance, SessionManager, propertyTypes,
    subtypesByPropertyTypes, msaByStates, ncreifs, states, citiesByStates,
    ownershipTypes, ranges, localStorageService, $rootScope) {
    var vm = this;
    var watchers = [],
      otherPropType = false;
    vm.utils = {};

    var noAppraiserStatusOptions = [
      { name: 'Draft Not Submitted', value: ['Created', 'DocumentsUploaded'] },
      { name: 'Draft Submitted', value: ['FormFilled'] },
      { name: 'RV Commented to AM', value: ['ReviewerCommented'] },
      { name: 'AM Commented', value: ['ManagerCommented'] },
      { name: 'Submitted to AP', value: ['SubmittedToAppraiser', 'CommentsAnswered', 'DocumentsUpdated'] },
      { name: 'AP Responded', value: ['ValuationUpdated'] },
      { name: 'RV Approved', value: ['ReviewerApproveValuation'] },
      { name: 'AM Approved', value: ['ManagerApproveValuation'] },
      { name: 'Final Value Approved', value: ['ValuationSignedOff', 'FinalDocumentsUploaded'] },
      { name: 'Final Files Rejected', value: ['FinalFilesRejected'] },
      { name: 'Final Files Submitted', value: ['FinalFormFilled'] },
      { name: 'Completed', value: ['Finished'] }
    ];

    var appraiserStatusOptions = [
      { name: 'Draft Not Submitted', value: ['Created', 'DocumentsUploaded'] },
      { name: 'Draft Submitted', value: ['FormFilled', 'ReviewerCommented', 'ManagerCommented'] },
      { name: 'Submitted to AP', value: ['SubmittedToAppraiser', 'CommentsAnswered', 'DocumentsUpdated'] },
      { name: 'AP Responded', value: ['ValuationUpdated', 'ReviewerApproveValuation', 'ManagerApproveValuation'] },
      { name: 'Final Value Approved', value: ['ValuationSignedOff', 'FinalDocumentsUploaded'] },
      { name: 'Final Files Submitted', value: ['FinalFormFilled'] },
      { name: 'Final Files Rejected', value: ['FinalFilesRejected'] },
      { name: 'Completed', value: ['Finished'] }
    ];

    vm.quartersOptions = [
      { name: 'Q1', value: 1 },
      { name: 'Q2', value: 2 },
      { name: 'Q3', value: 3 },
      { name: 'Q4', value: 4 },
    ];

    var yearsOptions = function () {
      var max = new Date().getFullYear();
      var years = [];

      for (var i = max + 5; i >= max - 5; i--) {
        years.push(i);
      }
      return years;
    }
    vm.yearsOptions = yearsOptions()

    vm.statusFilterOptions = 'AssetAppraisal' === SessionManager.getRoleName() ?
      appraiserStatusOptions : noAppraiserStatusOptions;

    vm.propertyTypes = propertyTypes.items;
    vm.propertySubTypesOptions = subtypesByPropertyTypes;
    vm.enabledPropertySubTypesOptions = [];
    vm.MSAFilterOptions = msaByStates;
    vm.NCREIFFilterOptions = ncreifs.items;
    vm.CityFilterOptions = citiesByStates;
    vm.CountryFilterOptions = [{ name: 'United States' }, { name: 'Mexico' }];
    vm.enabledStates = [];
    vm.statesByCountry = {
      "United States": [],
      "Mexico": []
    };
    states["United States"].forEach(function (state) {
      vm.statesByCountry['United States'].push({ name: state })
    });
    states["Mexico"].forEach(function (state) {
      vm.statesByCountry['Mexico'].push({ name: state })
    });
    vm.OwnershipTypeFilterOptions = ownershipTypes;
    vm.NetRentableAreaFilterMinOptions = ranges.minLeaseRange;
    vm.NetRentableAreaFilterMaxOptions = ranges.maxLeaseRange;
    vm.ValueFilterMinOptions = ranges.minValueRange;
    vm.ValueFilterMaxOptions = ranges.maxValueRange;
    vm.NetRentableAreaFilterMin = '';
    vm.NetRentableAreaFilterMax = '';
    vm.ValueFilterMin = '';
    vm.ValueFilterMax = '';

    //FILTERS MODEL VARIABLE
    vm.valuationFilters = {
      CityFilter: [],
      CountryFilter: [],
      LeadAMFilter: '',
      LeadReviewerFilter: '',
      LeadAppraiserFilter: '',
      MSAFilter: [],
      NCREIFFilter: [],
      NetRentableAreaFilter: '',
      OwnershipTypeFilter: [],
      PortfolioFilter: '',
      PropertySubTypeFilter: [],
      PropertyTypeFilter: [],
      StateFilter: [],
      StatusFilter: [],
      ValueFilter: '',
      QuarterFilter: [],
      YearFilter: []
    };

    (function () {
      var filters = $rootScope.filters;
      if (filters != null) {
        vm.valuationFilters = filters.valuationFilters || vm.valuationFilters;
        vm.NetRentableAreaFilterMin = filters.NetRentableAreaFilterMin || vm.NetRentableAreaFilterMin;
        vm.NetRentableAreaFilterMax = filters.NetRentableAreaFilterMax || vm.NetRentableAreaFilterMax;
        vm.ValueFilterMin = filters.ValueFilterMin || vm.ValueFilterMin;
        vm.ValueFilterMax = filters.ValueFilterMax || vm.ValueFilterMax;
        vm.enabledPropertySubTypesOptions = filters.enabledPropertySubTypesOptions || vm.enabledPropertySubTypesOptions;
        vm.enabledStates = filters.enabledStates || vm.enabledStates;
        vm.propertyTypes = filters.propertyTypes || vm.propertyTypes;
        vm.OwnershipTypeFilterOptions = filters.OwnershipTypeFilterOptions || vm.OwnershipTypeFilterOptions;
        vm.CountryFilterOptions = filters.CountryFilterOptions || vm.CountryFilterOptions;

        var NCREIFFilterCopy = angular.copy(filters.valuationFilters.NCREIFFilter),
          StateFilterCopy = angular.copy(filters.valuationFilters.StateFilter),
          StatusFilterCopy = angular.copy(filters.valuationFilters.StatusFilter),
          PropertySubTypeFilterCopy = angular.copy(filters.valuationFilters.PropertySubTypeFilter),
          QuarterFilterCopy = angular.copy(filters.valuationFilters.QuarterFilter);

        // Reset arrays
        filters.valuationFilters.NCREIFFilter = [];
        filters.valuationFilters.StateFilter = [];
        filters.valuationFilters.StatusFilter = [];
        filters.valuationFilters.QuarterFilter = [];
        filters.valuationFilters.PropertySubTypeFilter = [];

        NCREIFFilterCopy.forEach(function (ncreif) {
          vm.NCREIFFilterOptions.forEach(function (ncreifOption) {
            if (ncreifOption.type === ncreif) {
              vm.valuationFilters.NCREIFFilter.push(ncreifOption);
            }
          });
        });
        StateFilterCopy.forEach(function (state) {
          vm.enabledStates.forEach(function (enabledState) {
            if (enabledState.name === state) {
              vm.valuationFilters.StateFilter.push(enabledState);
            }
          });
        });
        StatusFilterCopy.forEach(function (status) {
          vm.statusFilterOptions.forEach(function (statusFilter) {
            if (statusFilter.value.toString() === status) {
              vm.valuationFilters.StatusFilter.push(statusFilter);
            }
          });
        });
        QuarterFilterCopy.forEach(function (quarter) {
          if( typeof quarter !== 'string'){
            vm.valuationFilters.QuarterFilter.push(vm.quartersOptions.filter(function (quarterFilter) { return quarterFilter.value.toString() === quarter.value.toString() })[0]);
          } else {
            vm.valuationFilters.QuarterFilter.push(vm.quartersOptions.filter(function (quarterFilter) { return quarterFilter.value.toString() === quarter})[0]);
          }
          
        });
        
        PropertySubTypeFilterCopy.forEach(function (subType) {
          vm.enabledPropertySubTypesOptions.forEach(function (enabledSubType) {
            if (enabledSubType.type === subType) {
              vm.valuationFilters.PropertySubTypeFilter.push(enabledSubType);
            }
          });
        });
      }
    })();

    //End FILTERS VARIABLES
    //------------------------------------------

    vm.clearFilter = function (filter) {
      vm.valuationFilters[filter] = [];
    };

    vm.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    vm.clearAllFilters = function () {
      vm.valuationFilters = {
        CityFilter: [],
        CountryFilter: [],
        LeadAMFilter: '',
        LeadReviewerFilter: '',
        LeadAppraiserFilter: "",
        MSAFilter: [],
        NCREIFFilter: [],
        NetRentableAreaFilter: '',
        OwnershipTypeFilter: [],
        PortfolioFilter: "",
        PropertyTypeFilter: [],
        PropertySubTypeFilter: [],
        StateFilter: [],
        StatusFilter: [],
        ValueFilter: '',
        QuarterFilter: [],
        YearFilter: []
      };
      vm.NetRentableAreaFilterMin = Number(ranges.minLeaseRange);
      vm.NetRentableAreaFilterMax = Number(ranges.maxLeaseRange);
      vm.ValueFilterMin = Number(ranges.minValueRange);
      vm.ValueFilterMax = Number(ranges.maxValueRange);
      vm.enabledPropertySubTypesOptions = [];
      vm.enabledStates = [];
      for (var i = 0; i < vm.propertyTypes.length; i++) {
        vm.propertyTypes[i].selected = false;
      }
      for (i = 0; i < vm.OwnershipTypeFilterOptions.length; i++) {
        vm.OwnershipTypeFilterOptions[i].selected = false;
      }
      for (i = 0; i < vm.CountryFilterOptions.length; i++) {
        vm.CountryFilterOptions[i].selected = false;
      }
    };

    vm.applyFilters = function () {
      (function () {
        var filters = {};
        filters.valuationFilters = angular.copy(vm.valuationFilters);
        filters.NetRentableAreaFilterMin = vm.NetRentableAreaFilterMin;
        filters.NetRentableAreaFilterMax = vm.NetRentableAreaFilterMax;
        filters.ValueFilterMin = vm.ValueFilterMin;
        filters.ValueFilterMax = vm.ValueFilterMax;
        filters.enabledPropertySubTypesOptions = angular.copy(vm.enabledPropertySubTypesOptions);
        filters.enabledStates = angular.copy(vm.enabledStates);
        filters.propertyTypes = angular.copy(vm.propertyTypes);
        filters.OwnershipTypeFilterOptions = angular.copy(vm.OwnershipTypeFilterOptions);
        filters.CountryFilterOptions = angular.copy(vm.CountryFilterOptions);

        filters.valuationFilters.NCREIFFilter = filters.valuationFilters.NCREIFFilter.map(function (ncreif) {
          return ncreif.type;
        });
        filters.valuationFilters.StateFilter = filters.valuationFilters.StateFilter.map(function (state) {
          return state.name;
        });
        filters.valuationFilters.StatusFilter = filters.valuationFilters.StatusFilter.map(function (status) {
          return status.value.toString();
        });
        filters.valuationFilters.PropertySubTypeFilter = filters.valuationFilters.PropertySubTypeFilter.map(function (subType) {
          return subType.type;
        });
        filters.valuationFilters.QuarterFilter = filters.valuationFilters.QuarterFilter.map(function (quarter) {
          return quarter.value.toString();
        });
        filters.valuationFilters.YearFilter = filters.valuationFilters.YearFilter.map(function (year) {
          return year.toString();
        });
        $rootScope.filters = filters;
      })();
      var statusArray = [],
        statusFilterValues = '',
        quarterFilterValues = '',
        yearFilterValues = '';
      vm.valuationFilters.NetRentableAreaFilter = vm.NetRentableAreaFilterMin + '-' + vm.NetRentableAreaFilterMax;
      vm.valuationFilters.ValueFilter = vm.ValueFilterMin + '-' + vm.ValueFilterMax;
      for (var i = 0; i < vm.valuationFilters.NCREIFFilter.length; i++) {
        vm.valuationFilters.NCREIFFilter[i] = vm.valuationFilters.NCREIFFilter[i].type;
      }
      for (i = 0; i < vm.valuationFilters.OwnershipTypeFilter.length; i++) {
        vm.valuationFilters.OwnershipTypeFilter[i] =
          vm.valuationFilters.OwnershipTypeFilter[i] === 'Joint Venture' ? 'JointVenture' : 'WhollyOwned';
      }
      for (i = 0; i < vm.valuationFilters.PropertySubTypeFilter.length; i++) {
        vm.valuationFilters.PropertySubTypeFilter[i] = vm.valuationFilters.PropertySubTypeFilter[i].type;
      }
      for (i = 0; i < vm.valuationFilters.StateFilter.length; i++) {
        vm.valuationFilters.StateFilter[i] = vm.valuationFilters.StateFilter[i].name;
      }
      for (i = 0; i < vm.valuationFilters.StatusFilter.length; i++) {
        var status = vm.valuationFilters.StatusFilter[i];
        if (status.value.toString() === 'FinalFilesRejected') {
          vm.valuationFilters.FinalFormFilledFilter = 'applied';
        } else {
          statusArray.push(status.value.toString());
        }
      }
      vm.valuationFilters.StatusFilter = statusArray;
      for (i = 0; i < vm.valuationFilters.StatusFilter.length; i++) {
        if (i !== vm.valuationFilters.StatusFilter.length - 1) {
          statusFilterValues += vm.valuationFilters.StatusFilter[i];
          statusFilterValues += ',';
        } else {
          statusFilterValues += vm.valuationFilters.StatusFilter[i];
        }
      }

      for (var i = 0; i < vm.valuationFilters.QuarterFilter.length; i++) {
        quarterFilterValues += i !== vm.valuationFilters.QuarterFilter.length - 1 ? vm.valuationFilters.QuarterFilter[i].value + ',' : vm.valuationFilters.QuarterFilter[i].value;
      }
      for (var i = 0; i < vm.valuationFilters.YearFilter.length; i++) {
        yearFilterValues += i !== vm.valuationFilters.YearFilter.length - 1 ? vm.valuationFilters.YearFilter[i] + ',' : vm.valuationFilters.YearFilter[i];
      }
      // Restrict LeadReviewerFilter, LeadAppraiserFilter, LeadAMFilter to minimum 3 characters
      vm.valuationFilters.LeadReviewerFilter = (
        vm.valuationFilters.LeadReviewerFilter && vm.valuationFilters.LeadReviewerFilter.length >= 3 ? vm.valuationFilters.LeadReviewerFilter : ''
      );
      vm.valuationFilters.LeadAppraiserFilter = (
        vm.valuationFilters.LeadAppraiserFilter && vm.valuationFilters.LeadAppraiserFilter.length >= 3 ? vm.valuationFilters.LeadAppraiserFilter : ''
      );
      vm.valuationFilters.LeadAMFilter = (
        vm.valuationFilters.LeadAMFilter && vm.valuationFilters.LeadAMFilter.length >= 3 ? vm.valuationFilters.LeadAMFilter : ''
      );

      // show leadAMFilter when user has permisson
      if (!SessionManager.isInAnyRole(['Admin', 'Audit', 'AssetReview', 'AssetManagement', 'AssetManagerReadOnly'])) {
        delete vm.valuationFilters.LeadAMFilter;
      }
      // show leadAppraiserFilter when user has permission
      if (!SessionManager.isInAnyRole(['Admin', 'Audit', 'AssetReview', 'AssetAppraisal'])) {
        delete vm.valuationFilters.LeadAppraiserFilter;
      }

      vm.valuationFilters.StatusFilter = statusFilterValues;
      vm.valuationFilters.CityFilter = vm.valuationFilters.CityFilter.toString();
      vm.valuationFilters.CountryFilter = vm.valuationFilters.CountryFilter.toString();
      vm.valuationFilters.MSAFilter = vm.valuationFilters.MSAFilter.toString();
      vm.valuationFilters.OwnershipTypeFilter = vm.valuationFilters.OwnershipTypeFilter.toString();
      vm.valuationFilters.PropertySubTypeFilter = vm.valuationFilters.PropertySubTypeFilter.toString();
      vm.valuationFilters.PropertyTypeFilter = vm.valuationFilters.PropertyTypeFilter.toString();
      vm.valuationFilters.StateFilter = vm.valuationFilters.StateFilter.toString();
      vm.valuationFilters.StatusFilter = vm.valuationFilters.StatusFilter.toString();
      vm.valuationFilters.QuarterFilter = quarterFilterValues;
      vm.valuationFilters.YearFilter = yearFilterValues;

      // Remove untouched props from valuationFilters
      var filtersCopy = angular.copy(vm.valuationFilters);
      // toString NCREIF for API
      filtersCopy.NCREIFFilter = filtersCopy.NCREIFFilter.toString();
      [
        'CityFilter',
        'CountryFilter',
        'LeadAMFilter',
        'LeadReviewerFilter',
        'LeadAppraiserFilter',
        'MSAFilter',
        'NCREIFFilter',
        'OwnershipTypeFilter',
        'PortfolioFilter',
        'PropertySubTypeFilter',
        'PropertyTypeFilter',
        'StateFilter',
        'StatusFilter',
        'YearFilter',
        'QuarterFilter'
      ].forEach(function (prop) {
        var filter = filtersCopy[prop];
        if (filter !== undefined && filter.length === 0) {
          delete filtersCopy[prop];
        }
      });

      // Remove slider values only if it's both sides are untouched
      if (
        (vm.NetRentableAreaFilterMin === parseInt(ranges.minLeaseRange, 10)) &&
        (vm.NetRentableAreaFilterMax === parseInt(ranges.maxLeaseRange, 10))
      ) {
        delete filtersCopy.NetRentableAreaFilter;
      }
      if (
        (vm.ValueFilterMax === parseInt(ranges.maxValueRange)) &&
        (vm.ValueFilterMin === parseInt(ranges.minValueRange))
      ) {
        delete filtersCopy.ValueFilter;
      }

      // Rename NCREIF to RegionFilter
      if (filtersCopy.NCREIFFilter) {
        filtersCopy.RegionFilter = filtersCopy.NCREIFFilter;
      }
      delete filtersCopy.NCREIFFilter;

      $uibModalInstance.close(JSON.stringify(filtersCopy));
    };

    //PROPERTY TYPE SELECTOR WATCHERS
    //------------------------------------------
    vm.utils.pushPropertySubTypes = pushPropertySubTypes;
    function pushPropertySubTypes(typeName, subTypesOptions) {
      var resultArr = [];
      if (subTypesOptions[typeName]) {
        for (var i = 0; i < subTypesOptions[typeName].length; i++) {
          var option = subTypesOptions[typeName][i];
          if (option.type === 'Other' && !otherPropType) {
            otherPropType = true;
            resultArr.push({ name: "Other", type: "Other", parent: "General" });
          } else if (option.type !== 'Other') {
            option.parent = typeName;
            resultArr.push(option);
          }
        }
      }
      return resultArr;
    }

    vm.utils.splicePropertySubTypes = splicePropertySubTypes;
    function splicePropertySubTypes(parentTypeName, propSubTypesArr, propertyTypesAmount) {
      var resultArr = [];
      for (var i = 0; i < propSubTypesArr.length; i++) {
        if (propSubTypesArr[i].parent !== parentTypeName || propSubTypesArr[i].parent === 'General') {
          resultArr.push(propSubTypesArr[i]);
        }
      }
      if (resultArr.length === 1 && resultArr[0].parent === 'General' &&
        propertyTypesAmount === 0) {
        otherPropType = false;
        return [];
      }
      return resultArr;
    }

    watchers.push($scope.$watch('advancedFiltersCtrl.propertyTypes', function () {
      for (i = 0; i < vm.propertyTypes.length; i++) {
        if (vm.propertyTypes[i].selected &&
          vm.valuationFilters.PropertyTypeFilter.indexOf(vm.propertyTypes[i].type) === -1) {
          vm.valuationFilters.PropertyTypeFilter.push(vm.propertyTypes[i].type);
          vm.enabledPropertySubTypesOptions = vm.enabledPropertySubTypesOptions.concat(pushPropertySubTypes(vm.propertyTypes[i].type, vm.propertySubTypesOptions));
        } else if (!vm.propertyTypes[i].selected &&
          vm.valuationFilters.PropertyTypeFilter.indexOf(vm.propertyTypes[i].type) !== -1) {
          vm.valuationFilters.PropertyTypeFilter.splice(vm.valuationFilters.PropertyTypeFilter.indexOf(vm.propertyTypes[i].type), 1);
          vm.enabledPropertySubTypesOptions = splicePropertySubTypes(vm.propertyTypes[i].type, vm.enabledPropertySubTypesOptions, vm.valuationFilters.PropertyTypeFilter.length);
        }
      }
    }, true));

    watchers.push($scope.$watch('advancedFiltersCtrl.OwnershipTypeFilterOptions', function () {
      for (i = 0; i < vm.OwnershipTypeFilterOptions.length; i++) {
        if (vm.OwnershipTypeFilterOptions[i].selected &&
          vm.valuationFilters.OwnershipTypeFilter.indexOf(vm.OwnershipTypeFilterOptions[i].name) === -1) {
          vm.valuationFilters.OwnershipTypeFilter.push(vm.OwnershipTypeFilterOptions[i].name);
        } else if (!vm.OwnershipTypeFilterOptions[i].selected &&
          vm.valuationFilters.OwnershipTypeFilter.indexOf(vm.OwnershipTypeFilterOptions[i].name) !== -1) {
          vm.valuationFilters.OwnershipTypeFilter.splice(vm.valuationFilters.OwnershipTypeFilter.indexOf(vm.OwnershipTypeFilterOptions[i].name), 1);
        }
      }
    }, true));

    watchers.push($scope.$watch('advancedFiltersCtrl.CountryFilterOptions', function () {
      for (var i = 0; i < vm.CountryFilterOptions.length; i++) {
        if (vm.CountryFilterOptions[i].selected &&
          vm.valuationFilters.CountryFilter.indexOf(vm.CountryFilterOptions[i].name) === -1) {
          vm.valuationFilters.CountryFilter.push(vm.CountryFilterOptions[i].name);
          vm.enabledStates = vm.enabledStates.concat(pushPropertySubTypes(vm.CountryFilterOptions[i].name, vm.statesByCountry));
        } else if (!vm.CountryFilterOptions[i].selected &&
          vm.valuationFilters.CountryFilter.indexOf(vm.CountryFilterOptions[i].name) !== -1) {
          vm.valuationFilters.CountryFilter.splice(vm.valuationFilters.CountryFilter.indexOf(vm.CountryFilterOptions[i].name), 1);
          vm.enabledStates = splicePropertySubTypes(vm.CountryFilterOptions[i].name, vm.enabledStates);
        }
      }
    }, true));

    watchers.push($scope.$watch('advancedFiltersCtrl.valuationFilters.StateFilter', function () {
      vm.enabledCities = [];
      vm.enabledMSAOptions = [];
      vm.enableMSA = false;
      for (var i = 0; i < vm.valuationFilters.StateFilter.length; i++) {
        vm.enabledCities = vm.enabledCities.concat(vm.CityFilterOptions[vm.valuationFilters.StateFilter[i].name]);
        if (vm.valuationFilters.StateFilter[i].parent === 'United States' &&
          vm.MSAFilterOptions[vm.valuationFilters.StateFilter[i].name]) {
          vm.enableMSA = true;
          vm.enabledMSAOptions = vm.enabledMSAOptions.concat(vm.MSAFilterOptions[vm.valuationFilters.StateFilter[i].name]);
        }
      }
    }, true));

    $scope.$on('$destroy', function () {
      watchers.forEach(function (watcher) {
        watcher();
      });
    });
  }

})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .config(routeConfig);
  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider.state('app.requests.responseSummary', {
      url: '/response-summary/:rfpId',
      views: {
        '@app': {
          templateUrl: 'app/states/requests/response-summary/response-summary.html',
          controller: 'ResponseSummaryController',
          controllerAs: 'responseSummaryCtrl'
        }
      },
      data: {
        pageTitle: 'Response Summary',
        roles: ['AssetAppraisal'],
        viewClass: 'response-summary'
      },
      params: {
        rfpId: ''
      },
      resolve: {
        /** @ngInject */
        rfp: function ($stateParams, BidRequestService) {
          return BidRequestService.get($stateParams.rfpId);
        },
        /** @ngInject */
        rfpAssets: function ($stateParams, BidResponseService, SessionManager, AssetService) {
          return AssetService.listByBidRequestId($stateParams.rfpId).then(function (rfpAssets) {
            return BidResponseService.listByAppraiserId(SessionManager.getUser().id).then(function (responses) {
              rfpAssets.forEach(function (asset) {
                asset.response = {};
                responses.forEach(function (response) {
                  if (asset.id == response.assetId && response.bidRequestId == $stateParams.rfpId) {
                    asset.response = response;
                  }
                });
              });
              return rfpAssets;
            });
          });
        }
      }
    });
  }

})();
(function () {
  'use strict';

  angular
    .module('nvc')
    .controller('ResponseSummaryController', ResponseSummaryController);

  /** @ngInject */
  function ResponseSummaryController($filter, $state, $q, rfp, rfpAssets, BidRequestService, BidResponseService,
    LoaderHelper, notify, SweetAlert, ArrayHelper, CSVService, PDFGenerator, SessionManager) {

    var vm = this;
    vm.rfp = rfp;
    vm.rfpAssets = rfpAssets;
    vm.totals = [0, 0, 0, 0, 0, 0, 0, 0];
    vm.editBidNote = false;
    vm.currentUserId = SessionManager.getUser().id
    vm.summarySort = [
      {
        sort: 'name',
        tag: 'name',
        selected: true,
        flag: true
      },
      {
        sort: 'response.yearOne',
        tag: 'response.yearOne',
        selected: false,
        flag: false
      },
      {
        sort: 'response.yearOneDiscount',
        tag: 'response.yearOneDiscount',
        selected: false,
        flag: false
      },
      {
        sort: 'response.yearsTwoThree',
        tag: 'response.yearsTwoThree',
        selected: false,
        flag: false
      },
      {
        sort: 'response.yearsTwoThreeDiscount',
        tag: 'response.yearsTwoThreeDiscount',
        selected: false,
        flag: false
      },
      {
        sort: 'response.quarterly',
        tag: 'response.quarterly',
        selected: false,
        flag: false
      },
      {
        sort: 'response.quarterlyDiscount',
        tag: 'response.quarterlyDiscount',
        selected: false,
        flag: false
      },
      {
        sort: 'response.totalFee',
        tag: 'response.totalFee',
        selected: false,
        flag: false
      },
      {
        sort: 'response.totalFeeDiscount',
        tag: 'response.totalFeeDiscount',
        selected: false,
        flag: false
      }
    ];
    vm.summarySelectedSort = vm.summarySort[0];

    vm.showQuarterly = true;
    if (vm.rfpAssets) {
      var quarterlyAssets = vm.rfpAssets.filter(function (asset) {
        return asset.valuationFrequency !== 'Annually' && asset.requiredAppraisers !== 'InternalAndExternal';
      });
      if (!quarterlyAssets.length) {
        vm.showQuarterly = false;
      }
    }

    vm.downloadLoading = false;

    vm.downloadCsv = function () {
      vm.downloadLoading = true;
      CSVService.generateResponseSummaryCsv(vm.rfp, vm.rfpAssets, vm.totals, vm.summarySelectedSort)
        .then(function () {
          vm.downloadLoading = false;
        })
        .catch(function (err) {
          vm.downloadLoading = false;
        });
    };
    vm.downloadPdf = function () {
      vm.downloadLoading = true;
      PDFGenerator.generateResponseSummaryPdf(vm.rfp, vm.rfpAssets, vm.totals, vm.summarySelectedSort)
        .then(function (values) {
          vm.downloadLoading = false;
          values.pdf.download('response-summary-' + values.rfp.name + '.pdf');
        })
        .catch(function (error) {
          vm.downloadLoading = false;
          notify({
            message: $filter('translate')('COMMONS.EXPORT_FAILURE'),
            duration: 5000,
            templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
            classes: 'alert-danger',
            position: 'center'
          });
        });
    };

    //BREADCRUMS
    //------------------------------------------
    vm.title = $filter('translate')('RESPONSE_SUMMARY.MAIN_TITLE');
    vm.breadcrumbs = [
      {
        label: $filter('translate')('ALL_REQUESTS.REQUESTS'),
        value: 'app.requests.allRequests'
      },
      {
        label: $filter('translate')('RESPONSE_SUMMARY.MAIN_TITLE'),
        value: 'app.requests.responseSummary'
      }
    ];

    //ASSIGN TOTALS
    //-------------------------------------------------------
    vm.rfpAssets.forEach(function (asset) {
      var quarterly = asset.response.quarterly ? asset.response.quarterly : 0;
      var quarterlyDiscount = asset.response.quarterlyDiscount ? asset.response.quarterlyDiscount : 0;

      asset.response.totalFee = asset.response.yearOne + (2 * asset.response.yearsTwoThree);
      if (asset.valuationFrequency === 'Quarterly') {
        asset.response.totalFee += (9 * quarterly);
      }
      else if (asset.valuationFrequency === 'SemiAnnually') {
        asset.response.totalFee += (3 * quarterly);
      }
      asset.response.totalFeeDiscount = asset.response.yearOneDiscount + (2 * asset.response.yearsTwoThreeDiscount);
      if (asset.valuationFrequency === 'Quarterly') {
        asset.response.totalFeeDiscount += (9 * quarterlyDiscount);
      }
      if (asset.valuationFrequency === 'SemiAnnually') {
        asset.response.totalFeeDiscount += (3 * quarterlyDiscount);
      }
      vm.totals[0] += asset.response.yearOne ? asset.response.yearOne : 0;
      vm.totals[1] += asset.response.yearOneDiscount ? asset.response.yearOneDiscount : 0;
      vm.totals[2] += asset.response.yearsTwoThree ? asset.response.yearsTwoThree : 0;
      vm.totals[3] += asset.response.yearsTwoThreeDiscount ? asset.response.yearsTwoThreeDiscount : 0;
      vm.totals[4] += asset.response.quarterly ? asset.response.quarterly : 0;
      vm.totals[5] += asset.response.quarterlyDiscount ? asset.response.quarterlyDiscount : 0;
      vm.totals[6] += asset.response.totalFee ? asset.response.totalFee : 0;
      vm.totals[7] += asset.response.totalFeeDiscount ? asset.response.totalFeeDiscount : 0;
    });

    //OPEN APPRAISER NOTES
    //-------------------------------------------------------
    vm.openAppNotes = function (asset) {
      for (var i = 0; i < vm.rfpAssets.length; i++) {
        vm.rfpAssets[i].openedAppNotes = false;
      }
      asset.openedAppNotes = true;
    };

    //CLOSE APPRAISER NOTES
    //-------------------------------------------------------
    vm.closeAppNotes = function (event, asset) {
      event.stopPropagation();
      asset.openedAppNotes = false;
      vm.editBidNote = false;
    };

    //OPEN EDIT NOTES
    //-------------------------------------------------------
    vm.editNotes = function (asset) {
      vm.editBidNote = true;
      vm.bidNotes = asset.response.bidNotes;
    };

    //SAVE APPRAISER NOTES
    //-------------------------------------------------------
    vm.saveNotes = function (asset) {
      var bidResponseDTO = {};
      bidResponseDTO.id = asset.response.id;
      bidResponseDTO.bidNotesOld = asset.response.bidNotes !== asset.response.bidNotesOld ? asset.response.bidNotes : asset.response.bidNotesOld;
      asset.response.bidNotes = vm.bidNotes;
      bidResponseDTO.bidNotes = vm.bidNotes;
      BidResponseService.updateBidResponse(bidResponseDTO).then(function () {
        notify({
          message: $filter('translate')('BID_SUMMARY.NOTE_ADDED'),
          duration: 4000,
          templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
          classes: 'alert-info',
          position: 'center'
        });
        asset.openedAppNotes = false;
        vm.editBidNote = false;
      });
    };

    //EDIT RESPONSES
    //-------------------------------------------------------
    vm.editResponse = function (asset) {
      $state.go('app.requests.response', { assetId: asset.id, rfpId: vm.rfp.id, rfpAssets: vm.rfpAssets }, { reload: true });
    };

    //SORTING
    //------------------------------------------
    vm.sorting = function (sort, target) {
      ArrayHelper.sort(sort, target, vm.summarySort, vm);
    };

    //SUBMIT RESPONSE
    //------------------------------------------
    vm.submitResponse = function (rfpId) {
      var promises = [];
      var canSubmit = false;
      for (var i = 0; i < vm.rfpAssets.length; i++) {
        if (vm.rfpAssets[i].response.yearOne || vm.rfpAssets[i].response.yearOne == 0) {
          canSubmit = true;
          break;
        }
      }
      if (canSubmit) {
        LoaderHelper.open();
        var isResubmittedBid = false;
        var bidResponseIds = [];
        vm.rfpAssets.forEach(function (asset) {
          if (!asset.response.isValueSynced && asset.response.isSubmittedToAdmin) {
            isResubmittedBid = !asset.response.isValueSynced && asset.response.isSubmittedToAdmin;
            bidResponseIds.push(asset.response.id);
          }
        });
        BidRequestService.sendEmailToAdmin(rfpId, isResubmittedBid, bidResponseIds).then(function () {
          vm.rfpAssets.forEach(function (asset) {
            asset.response.isSubmittedToAdmin = true;
            asset.response.isValueSynced = true;
            promises.push(BidResponseService.updateBidResponse(asset.response));
          });
          $q.all(promises).then(function () {
            notify({
              message: $filter('translate')('RESPONSE_SUMMARY.RESPONSES_SUBMITTED'),
              duration: 4000,
              templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
              classes: 'alert-info',
              position: 'center'
            });
            $state.go('app.requests.allRequests', {}, { reload: true });
          }, function () {
            LoaderHelper.close();
          });
        });
      } else {
        SweetAlert.swal({
          title: $filter('translate')('RESPONSE_SUMMARY.RESPONSES_TITLE'),
          text: $filter('translate')('RESPONSE_SUMMARY.RESPONSES_NOT_SUBMITTED'),
          showCancelButton: false,
          confirmButtonColor: '#2c3d4e',
          confirmButtonText: $filter('translate')('DOCUMENTS_UPLOAD.OK_TAKE_ME_BACK'),
          closeOnConfirm: true
        });
      }
    };

    //IS SUBMITTED FUNCTION
    //------------------------------------------
    vm.isSubmitted = function () {
      var isHidden = false
      for (var i = 0; i < vm.rfpAssets.length; i++) {
        if (!vm.rfpAssets[i].response.isAwarded) {
          if ((vm.rfpAssets[i].response.isSubmittedToAdmin || vm.rfpAssets[i].response.isAwarded) && vm.rfpAssets[i].response.isValueSynced) {
            isHidden = true;
          } else {
            return false
          }
        } else {
          isHidden = true;
        }
      }
      return isHidden && isHidden;
    };
    vm.isAwarded = function () {
      for (var i = 0; i < vm.rfpAssets.length; i++) {
        // if (vm.rfpAssets[i].response.isAwarded) {
        //   return true;
        // }
        if (vm.rfpAssets[i].primaryAssetAppraiser || vm.rfpAssets[i].response.isAwarded || vm.rfpAssets[i].response.isNotAwarded) {
          return true;
        }
      }
    };

  }

})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .config(routeConfig);

  function getAsset($stateParams, AssetService) {
    if ($stateParams.asset) {
      return $stateParams.asset;
    }
    if ($stateParams.bidRequestId) {
      return AssetService.getAssetByBidRequestId(
        $stateParams.assetId,
        $stateParams.bidRequestId
      );
    } else {
      return AssetService.getAsset($stateParams.assetId);
    }
  }

  function routeConfig($stateProvider) {
    $stateProvider.state('app.requests.response-details', {
      url: '/response-details/:assetId?bidRequestId&bidResponseId&status',
      views: {
        "@app": {
          templateUrl: 'app/states/requests/response-details/response-details-index.html',
          controller: 'ResponseDetailsController',
          controllerAs: 'responseDetailsCtrl'
        },
        'asset-details@app.requests.response-details': {
          templateUrl: 'app/states/assets/asset-details/asset-details-bidding.html',
          controller: 'AssetDetailsController',
          controllerAs: 'assetDetailsCtrl'
        },
        'response-details@app.requests.response-details': {
          templateUrl: 'app/states/requests/response-details/response-details.html'
        }
      },
      data: {
        pageTitle: 'Asset details',
        viewClass: 'assetDetails',
        roles: ['Admin', 'Audit', 'AssetManagement', 'AssetReview', 'AssetAppraisal', 'AssetManagerReadOnly']
      },
      params: {
        assetId: '',
        bidRequestId: null,
        bidResponseId: null,
        status: null,
        noPadding: false
      },
      resolve: {
        /** @ngInject */
        asset: function ($stateParams, AssetService) {
          return getAsset($stateParams, AssetService);
        },
        /** @ngInject */
        assetUsers: function ($stateParams, AssetService, BidRequestService, asset) {
          if ($stateParams.bidRequestId) {
            return BidRequestService.listUsersByBidRequestId($stateParams.assetId, $stateParams.bidRequestId, true).then(function (assetUsers) {
              assetUsers.forEach(function (assetUser) {
                for (var i = 0; i < assetUser.periods.length; i++) {
                  var tempPeriod = assetUser.periods[i];
                  if (asset.valuation && tempPeriod.active && tempPeriod.isPrimary && tempPeriod.quarter == asset.valuation.quarter && tempPeriod.year == asset.valuation.year) {
                    switch (assetUser.userCompanyType) {
                      case 'AssetReview':
                        assetUser.type = 'PrimaryAssetReviewer';
                        break;
                      case 'AssetManagement':
                        assetUser.type = 'PrimaryAssetManager';
                        break;
                    }
                    break;
                  }
                }
              });
              return assetUsers;
            });
          } else {
            return AssetService.getAssetUsersList($stateParams.assetId, true).then(function (assetUsers) {
              assetUsers.forEach(function (assetUser) {
                for (var i = 0; i < assetUser.periods.length; i++) {
                  var tempPeriod = assetUser.periods[i];
                  if (asset.valuation && tempPeriod.active && tempPeriod.isPrimary && tempPeriod.quarter == asset.valuation.quarter && tempPeriod.year == asset.valuation.year) {
                    switch (assetUser.userCompanyType) {
                      case 'AssetReview':
                        assetUser.type = 'PrimaryAssetReviewer';
                        break;
                      case 'AssetManagement':
                        assetUser.type = 'PrimaryAssetManager';
                        break;
                    }
                    break;
                  }
                }
              });
              return assetUsers;
            });
          }

        },
        /** @ngInject */
        propertyTypes: function (StaticDataService) {
          return StaticDataService.getPropertyTypes();
        },
        /** @ngInject */
        subtypesByPropertyTypes: function (StaticDataService) {
          return StaticDataService.getSubtypesByPropertyTypes();
        },
        /** @ngInject */
        ownershipTypes: function (StaticDataService) {
          return StaticDataService.getOwnershipTypes();
        },
        /** @ngInject */
        ncreifs: function (StaticDataService) {
          return StaticDataService.getNcreifs();
        },
        /**@ngInject*/
        documents: function ($stateParams, AssetService) {
          if ($stateParams.bidRequestId) {
            return AssetService.documentListByBidRequest($stateParams.assetId, $stateParams.bidRequestId).then(function (documents) {
              var latestDocuments = [],
                indexedDocumentNames = [];
              for (var i = 0; i < documents.assetDocuments.length; i++) {
                var document = documents.assetDocuments[i];
                if (indexedDocumentNames.indexOf(document.fileName) == -1) {
                  var latestDocument = document;
                  indexedDocumentNames.push(document.fileName);
                  for (var j = i; j < documents.assetDocuments.length; j++) {
                    var document2 = documents.assetDocuments[j];
                    if (latestDocument.fileName === document2.fileName) {
                      if (isNaN(latestDocument.version)
                        || (!isNaN(document2.version) && latestDocument.version < document2.version)) {
                        latestDocument = document2;
                      }
                    }
                  }
                  latestDocuments.push(latestDocument);
                }
              }
              return latestDocuments;
            });
          } else {
            return AssetService.documentList($stateParams.assetId).then(function (documents) {
              var latestDocuments = [],
                indexedDocumentNames = [];
              for (var i = 0; i < documents.assetDocuments.length; i++) {
                var document = documents.assetDocuments[i];
                if (indexedDocumentNames.indexOf(document.fileName) == -1) {
                  var latestDocument = document;
                  indexedDocumentNames.push(document.fileName);
                  for (var j = i; j < documents.assetDocuments.length; j++) {
                    var document2 = documents.assetDocuments[j];
                    if (latestDocument.fileName === document2.fileName) {
                      if (isNaN(latestDocument.version)
                        || (!isNaN(document2.version) && latestDocument.version < document2.version)) {
                        latestDocument = document2;
                      }
                    }
                  }
                  latestDocuments.push(latestDocument);
                }
              }
              return latestDocuments;
            });
          }
        },
        /**@ngInject*/
        bidResponse: function ($stateParams, BidResponseService, AssetService) {
          if ($stateParams.bidResponseId) {
            return BidResponseService.get($stateParams.bidResponseId).then(function (bidResponse) {
              getAsset($stateParams, AssetService)
                .then(function (asset) {
                  bidResponse.totalFee = 0;
                  bidResponse.totalFeeDiscount = 0;
                  var quarterly = bidResponse.quarterly ? bidResponse.quarterly : 0;
                  var quarterlyDiscount = bidResponse.quarterlyDiscount ? bidResponse.quarterlyDiscount : 0;
                  switch (asset.valuationFrequency) {
                    case 'Quarterly':
                    default:
                      bidResponse.totalFee = bidResponse.yearOne + (2 * bidResponse.yearsTwoThree) + (9 * quarterly);
                      bidResponse.totalFeeDiscount = bidResponse.yearOneDiscount + (2 * bidResponse.yearsTwoThreeDiscount) + (9 * quarterlyDiscount);
                      break;
                    case 'SemiAnnually':
                      bidResponse.totalFee = bidResponse.yearOne + (2 * bidResponse.yearsTwoThree) + (3 * quarterly);
                      bidResponse.totalFeeDiscount = bidResponse.yearOneDiscount + (2 * bidResponse.yearsTwoThreeDiscount) + (3 * quarterlyDiscount);
                      break;
                    case 'Annually':
                      bidResponse.totalFee = bidResponse.yearOne + (2 * bidResponse.yearsTwoThree);
                      bidResponse.totalFeeDiscount = bidResponse.yearOneDiscount + (2 * bidResponse.yearsTwoThreeDiscount);
                      break;
                  }
                });
              return bidResponse;
            });
          }
        },
        /**@ngInject*/
        valuationFrequencies: function (StaticDataService) {
          return StaticDataService.getValuationFrequencies();
        }
      }
    });
  }

})();

(function() {
  'use strict';

  angular
    .module('nvc')
    .controller('ResponseDetailsController', ResponseDetailsController);

  /** @ngInject */
  function ResponseDetailsController($filter, $stateParams, asset, bidResponse, valuationFrequencies) {

    var vm = this;
    vm.asset = asset;
    vm.bidResponse = bidResponse;
    vm.assetStatus = $stateParams.status;
    vm.valuationFrequencies = valuationFrequencies.items;

    //Dynamic label
    vm.labels = {
      update: vm.asset.valuationFrequency === 'SemiAnnually' ? $filter('translate')('RESPONSE.SEMIANNUAL_UPDATE') : $filter('translate')('RESPONSE.QUARTERLY_UPDATE'),
      updateDiscount: vm.asset.valuationFrequency === 'SemiAnnually' ? $filter('translate')('RESPONSE.SEMIANNUAL_DISCOUNT_UPDATE') : $filter('translate')('RESPONSE.QUARTERLY_DISCOUNT_UPDATE')
    };

    vm.breadcrumbs = [
      {
        label: $filter('translate')('ASSETS.TITLE'),
        value: 'app.asset.all'
      },
      {
        label: $filter('translate')('ASSET_DETAILS.BREADCRUMB'),
        value: 'app.asset.assetDetails'
      }
    ];

  }

})();
(function () {
  'use strict';

  angular
    .module('nvc')
    .config(routeConfig);

  function routeConfig($stateProvider) {
    $stateProvider.state('app.requests.response', {
      url: '/response/:rfpId/:assetId',
      views: {
        '@app': {
          templateUrl: 'app/states/requests/response/response.html',
          controller: 'ResponseController',
          controllerAs: 'responseCtrl'
        },
        'assetCounter@app.requests.response': {
          templateUrl: 'app/states/requests/response/response-index.html'
        },
        'assetDetails@app.requests.response': {
          templateUrl: 'app/states/assets/asset-details/asset-details-bidding.html',
          controller: 'AssetDetailsController',
          controllerAs: 'assetDetailsCtrl'
        },
        'assetFee@app.requests.response': {
          templateUrl: 'app/states/requests/response/response-fee.html'
        }
      },
      data: {
        pageTitle: 'Response',
        viewClass: 'response',
        roles: ['AssetAppraisal']
      },
      params: {
        assetId: '',
        rfpId: '',
        rfpAssets: undefined
      },
      resolve: {
        /** @ngInject */
        asset: function ($stateParams, AssetService) {
          return AssetService.getAssetByBidRequestId($stateParams.assetId, $stateParams.rfpId).then(function (asset) {
            asset.bidding = true;
            return asset;
          });
        },
        /** @ngInject */
        assetUsers: function ($stateParams, BidRequestService) {
          return BidRequestService.listUsersByBidRequestId($stateParams.assetId, $stateParams.rfpId, true);
        },
        /** @ngInject */
        propertyTypes: function (StaticDataService) {
          return StaticDataService.getPropertyTypes();
        },
        /** @ngInject */
        subtypesByPropertyTypes: function (StaticDataService) {
          return StaticDataService.getSubtypesByPropertyTypes();
        },
        /** @ngInject */
        ownershipTypes: function (StaticDataService) {
          return StaticDataService.getOwnershipTypes();
        },
        /** @ngInject */
        ncreifs: function (StaticDataService) {
          return StaticDataService.getNcreifs();
        },
        /**@ngInject*/
        documents: function ($stateParams, AssetService) {
          return AssetService.documentListByBidRequest($stateParams.assetId, $stateParams.rfpId).then(function (documents) {
            var latestDocuments = [],
              indexedDocumentNames = [];
            for (var i = 0; i < documents.assetDocuments.length; i++) {
              var document = documents.assetDocuments[i];
              if (indexedDocumentNames.indexOf(document.fileName) == -1) {
                var latestDocument = document;
                indexedDocumentNames.push(document.fileName);
                for (var j = i; j < documents.assetDocuments.length; j++) {
                  var document2 = documents.assetDocuments[j];
                  if (latestDocument.fileName === document2.fileName) {
                    if (isNaN(latestDocument.version)
                      || (!isNaN(document2.version) && latestDocument.version < document2.version)) {
                      latestDocument = document2
                    }
                  }
                }
                latestDocuments.push(latestDocument)
              }
            }
            return latestDocuments;
          });
        },
        /** @ngInject */
        rfpAssets: function ($stateParams, BidResponseService, SessionManager, AssetService) {
          if($stateParams.rfpAssets) {
            return $stateParams.rfpAssets;
          } else {
              return AssetService.listByBidRequestId($stateParams.rfpId).then(function (rfpAssets) {
                return BidResponseService.listByAppraiserId(SessionManager.getUser().id).then(function(responses) {
                  rfpAssets.forEach(function (asset) {
                    asset.response = {};
                    responses.forEach(function (response) {
                      if(asset.id == response.assetId && response.bidRequestId == $stateParams.rfpId) {
                        asset.response = response;
                      }
                    });
                  });
                  return rfpAssets;
                });
              });
          }
        },
        /** @ngInject */
        rfp: function ($stateParams, BidRequestService) {
          return BidRequestService.get($stateParams.rfpId);
        },
        /** @ngInject */
        valuationFrequencies: function (StaticDataService) {
          return StaticDataService.getValuationFrequencies();
        }
      }
    });
  }

})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .controller('ResponseController', ResponseController);

  /** @ngInject*/
  function ResponseController($q, $filter, $scope, $state, $window, ReviewFactory, BidGroupService, BidResponseService,
    asset, assetUsers, subtypesByPropertyTypes, ownershipTypes, ncreifs, documents, rfpAssets,
    rfp, SweetAlert, LoaderHelper, notify, valuationFrequencies) {

    var vm = this,
      isConfirmed = false,
      previousBidded = false;
    vm.asset = asset;
    vm.rfp = rfp;
    vm.rfpAssets = Object.assign(rfpAssets);
    asset.review = ReviewFactory.assetToReview(new AssetModel(asset));
    vm.assetUsers = assetUsers;
    vm.subtypesByPropertyTypes = subtypesByPropertyTypes[vm.asset.type];
    vm.ownershipTypes = ownershipTypes;
    vm.ncreifs = ncreifs['items'];
    vm.documents = documents;
    vm.valuationFrequencies = valuationFrequencies.items;
    vm.rfpAssestResponses = angular.copy(rfpAssets);

    for (var i = 0; i < vm.rfpAssets.length; i++) {
      var asset = vm.rfpAssets[i];
      if (vm.asset.id == asset.id) {
        vm.asset.response = asset.response;
        vm.asset.response.yearOne = parseInt(asset.response.yearOne) || undefined;
        vm.asset.response.yearsTwoThree = parseInt(asset.response.yearsTwoThree) || undefined;
        vm.asset.response.quarterly = parseInt(asset.response.quarterly) || undefined;
        vm.asset.response.quarterlyDiscount = parseInt(asset.response.quarterlyDiscount) || undefined;
        if (asset.response.bidNotes) {
          vm.asset.response.bidNotes = asset.response.bidNotes;
        }
      }
      if (vm.rfpAssets[i].bidded) {
        previousBidded = true;
      }
    }

    vm.isRequired = false;
    vm.totalFee = 0;
    vm.totalFeeDiscount = 0;

    for (i = 0; i < vm.subtypesByPropertyTypes.length; i++) {
      if (vm.asset.subType == vm.subtypesByPropertyTypes[i].type) {
        vm.asset.subType = vm.subtypesByPropertyTypes[i].name;
        break;
      }
    }

    for (i = 0; i < vm.ownershipTypes.length; i++) {
      if (vm.asset.ownership == vm.ownershipTypes[i].type) {
        vm.asset.ownership = vm.ownershipTypes[i].name;
        break;
      }
    }

    for (i = 0; i < vm.ncreifs.length; i++) {
      if (vm.asset.region == vm.ncreifs[i].type) {
        vm.asset.region = vm.ncreifs[i].name;
        break;
      }
    }

    for (i = 0; i < vm.valuationFrequencies.length; i++) {
      if (vm.asset.valuationFrequency === vm.valuationFrequencies[i].value) {
        vm.asset.valuationFrequency = vm.valuationFrequencies[i].name;
        break;
      }
    }

    if (vm.asset.bidGroupId) {
      BidGroupService.get(vm.asset.bidGroupId).then(function (bidGroup) {
        vm.asset.bidGroup = bidGroup;
      });
    }

    //Dynamic label
    vm.labels = {
      update: vm.asset.valuationFrequency === 'Semi-Annual' ? $filter('translate')('RESPONSE.SEMIANNUAL_UPDATE') : $filter('translate')('RESPONSE.QUARTERLY_UPDATE'),
      updateDiscount: vm.asset.valuationFrequency === 'Semi-Annual' ? $filter('translate')('RESPONSE.SEMIANNUAL_DISCOUNT_UPDATE') : $filter('translate')('RESPONSE.QUARTERLY_DISCOUNT_UPDATE')
    };

    //BREADCRUMS
    //------------------------------------------
    vm.title = $filter('translate')('RESPONSE.MAIN_TITLE');
    vm.breadcrumbs = [
      {
        label: $filter('translate')('ALL_REQUESTS.REQUESTS'),
        value: 'app.requests.allRequests'
      },
      {
        label: $filter('translate')('RESPONSE.MAIN_TITLE'),
        value: 'app.requests.response'
      }
    ];

    //GET ASSET INDEX
    //------------------------------------------
    vm.getIndex = function (assetId) {
      for (i = 0; i < vm.rfpAssets.length; i++) {
        if (assetId == vm.rfpAssets[i].id) {
          return i + 1;
        }
      }
    };

    //GO PREVIOUS ASSET
    //------------------------------------------
    vm.previousAsset = function (assetId) {
      for (i = 0; i < vm.rfpAssets.length; i++) {
        if (assetId == vm.rfpAssets[i].id && i > 0) {
          if (vm.assetFee.$dirty) {
            vm.rfpAssets[i] = parseValues(vm.rfpAssets[i], vm.asset);
            vm.rfpAssets[i].bidded = true;
            vm.rfpAssets[i].response.isValueSynced = false;
            if(vm.rfpAssestResponses && vm.rfpAssestResponses.length>0 && vm.rfpAssestResponses[i].response.isValueSynced){
              vm.rfpAssets[i].response.yearOneOld = vm.rfpAssestResponses[i].response.yearOne !== vm.rfpAssets[i].response.yearOne ? vm.rfpAssestResponses[i].response.yearOne : vm.rfpAssestResponses[i].response.yearOneOld; 
            vm.rfpAssets[i].response.yearsTwoThreeOld = vm.rfpAssestResponses[i].response.yearsTwoThree !== vm.rfpAssets[i].response.yearsTwoThree ? vm.rfpAssestResponses[i].response.yearsTwoThree : vm.rfpAssestResponses[i].response.yearsTwoThreeOld;
            vm.rfpAssets[i].response.quarterlyOld = vm.rfpAssestResponses[i].response.quarterly !== vm.rfpAssets[i].response.quarterly ? vm.rfpAssestResponses[i].response.quarterly : vm.rfpAssestResponses[i].response.quarterlyOld;
            vm.rfpAssets[i].response.bidNotesOld = vm.rfpAssestResponses[i].response.bidNotes !== vm.rfpAssets[i].response.bidNotes ? vm.rfpAssestResponses[i].response.bidNotes :vm.rfpAssestResponses[i].response.bidNotesOld;
            }
          }
          if (vm.assetFee.$valid) {
            vm.assetFee.$submitted = true;
            $state.go('app.requests.response', { assetId: vm.rfpAssets[i - 1].id, rfpId: vm.rfp.id, rfpAssets: vm.rfpAssets }, { reload: true });
          }
        }
      }
    };

    //GO NEXT ASSET
    //------------------------------------------
    vm.nextAsset = function (assetId) {
      for (i = 0; i < vm.rfpAssets.length; i++) {
        if (assetId == vm.rfpAssets[i].id && i < vm.rfpAssets.length - 1) {
          if (vm.assetFee.$dirty) {
            vm.rfpAssets[i] = parseValues(vm.rfpAssets[i], vm.asset);
            vm.rfpAssets[i].bidded = true;
            vm.rfpAssets[i].response.isValueSynced = false;
            if(vm.rfpAssestResponses && vm.rfpAssestResponses.length>0 && vm.rfpAssestResponses[i].response.isValueSynced){
              vm.rfpAssets[i].response.yearOneOld = vm.rfpAssestResponses[i].response.yearOne !== vm.rfpAssets[i].response.yearOne ? vm.rfpAssestResponses[i].response.yearOne : vm.rfpAssestResponses[i].response.yearOneOld; 
            vm.rfpAssets[i].response.yearsTwoThreeOld = vm.rfpAssestResponses[i].response.yearsTwoThree !== vm.rfpAssets[i].response.yearsTwoThree ? vm.rfpAssestResponses[i].response.yearsTwoThree : vm.rfpAssestResponses[i].response.yearsTwoThreeOld;
            vm.rfpAssets[i].response.quarterlyOld = vm.rfpAssestResponses[i].response.quarterly !== vm.rfpAssets[i].response.quarterly ? vm.rfpAssestResponses[i].response.quarterly : vm.rfpAssestResponses[i].response.quarterlyOld;
            vm.rfpAssets[i].response.bidNotesOld = vm.rfpAssestResponses[i].response.bidNotes !== vm.rfpAssets[i].response.bidNotes ? vm.rfpAssestResponses[i].response.bidNotes :vm.rfpAssestResponses[i].response.bidNotesOld;
            }
          }
          if (vm.assetFee.$valid) {
            vm.assetFee.$submitted = true;
            $state.go('app.requests.response', { assetId: vm.rfpAssets[i + 1].id, rfpId: vm.rfp.id, rfpAssets: vm.rfpAssets }, { reload: true });
          }
        }
      }
    };

    //SAVE RESPONSE
    //------------------------------------------
    vm.saveResponse = function (assetId) {
      var promises = [];
      var date = new Date().getTime();
      for (i = 0; i < vm.rfpAssets.length; i++) {
        vm.rfpAssets[i].response.respondedOn = date;
        if (assetId == vm.rfpAssets[i].id) {
          if (vm.assetFee.$dirty) {
            vm.rfpAssets[i] = parseValues(vm.rfpAssets[i], vm.asset);
            vm.rfpAssets[i].bidded = true;
            vm.rfpAssets[i].response.isValueSynced = false;
            if(vm.rfpAssestResponses && vm.rfpAssestResponses.length>0 && vm.rfpAssestResponses[i].response.isValueSynced){
              vm.rfpAssets[i].response.yearOneOld = vm.rfpAssestResponses[i].response.yearOne !== vm.rfpAssets[i].response.yearOne ? vm.rfpAssestResponses[i].response.yearOne : vm.rfpAssestResponses[i].response.yearOneOld; 
            vm.rfpAssets[i].response.yearsTwoThreeOld = vm.rfpAssestResponses[i].response.yearsTwoThree !== vm.rfpAssets[i].response.yearsTwoThree ? vm.rfpAssestResponses[i].response.yearsTwoThree : vm.rfpAssestResponses[i].response.yearsTwoThreeOld;
            vm.rfpAssets[i].response.quarterlyOld = vm.rfpAssestResponses[i].response.quarterly !== vm.rfpAssets[i].response.quarterly ? vm.rfpAssestResponses[i].response.quarterly : vm.rfpAssestResponses[i].response.quarterlyOld;
            vm.rfpAssets[i].response.bidNotesOld = vm.rfpAssestResponses[i].response.bidNotes !== vm.rfpAssets[i].response.bidNotes ? vm.rfpAssestResponses[i].response.bidNotes :vm.rfpAssestResponses[i].response.bidNotesOld;
            }
           
          }
        }
        if (vm.assetFee.$valid) {
          promises.push(BidResponseService.updateBidResponse(vm.rfpAssets[i].response));
        }
      }
      if (promises.length > 0) {
        $q.all(promises).then(function () {
          notify({
            message: $filter('translate')('RESPONSE.BID_SAVED'),
            duration: 4000,
            templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
            classes: 'alert-info',
            position: 'center'
          });
          $state.go('app.requests.responseSummary', { rfpId: vm.rfp.id}, { reload: true });
        }, function () {
          vm.uiLoading = false;
          LoaderHelper.close();
        });
      }
    };

    //CANCEL RESPONSE
    //------------------------------------------
    vm.cancelResponse = function () {
      $state.go('app.requests.allRequests');
    };

    //PARSE VALUES
    //------------------------------------------
    function parseValues(rfpAsset, asset) {
      var rfpAssetClone = angular.copy(rfpAsset);
      rfpAssetClone.response = asset.response;
      rfpAssetClone.response.yearOne = parseInt(asset.response.yearOne);
      rfpAssetClone.response.yearsTwoThree = parseInt(asset.response.yearsTwoThree);
      if (asset.valuationFrequency !== 'Annual') {
        if (asset.response.quarterly) {
          rfpAssetClone.response.quarterly = parseInt(asset.response.quarterly);
        } else {
          delete rfpAssetClone.response.quarterly;
        }
        if (asset.response.quarterlyDiscount) {
          rfpAssetClone.response.quarterlyDiscount = parseInt(asset.response.quarterlyDiscount);
        } else {
          delete rfpAssetClone.response.quarterlyDiscount;
        }
      }
      else {
        delete rfpAssetClone.response.quarterly;
        delete rfpAssetClone.response.quarterlyDiscount;
      }
      if (asset.response.bidNotes) {
        rfpAssetClone.response.bidNotes = asset.response.bidNotes;
      } else {
        delete rfpAssetClone.response.bidNotes;
      }
      return rfpAssetClone;
    }

    //FORMS VALIDATIONS
    //------------------------------------------
    $window.onbeforeunload = function (event) {
      var event = event || $window.event;

      if (event && (vm.assetFee.$dirty || previousBidded)) {
        return event.returnValue = 'Are you sure you want to leave this form?';
      }
      else {
        return null;
      }
    };

    var stateAlert = $scope.$on('$stateChangeStart', function (event, toState) {
      if (((vm.assetFee.$dirty && !vm.assetFee.$submitted) || (vm.assetFee.$dirty && vm.assetFee.$submitted && vm.assetFee.$invalid) || (previousBidded && !vm.assetFee.$submitted)) && !isConfirmed) {
        event.preventDefault();
        SweetAlert.swal({
          title: $filter('translate')('COMMONS.LEAVE_PAGE_MODAL_TITLE'),
          text: $filter('translate')('COMMONS.LEAVE_PAGE_MODAL_TEXT'),
          showCancelButton: true,
          cancelButtonText: $filter('translate')('COMMONS.LEAVE_PAGE_CONFIRM_BUTTON'),
          confirmButtonColor: '#2c3d4e',
          confirmButtonText: $filter('translate')('COMMONS.LEAVE_PAGE_CANCEL_BUTTON'),
          closeOnConfirm: true,
          closeOnCancel: true
        },
          function (isConfirm) {
            if (!isConfirm) {
              isConfirmed = true;
              $state.go(toState.name);
            }
            else {
              LoaderHelper.close();
            }
          }
        );
      }
    });

    //TOTAL FEE WATCHER
    //------------------------------------------
    var totalFeeWatch = $scope.$watch('responseCtrl.asset.response', function () {
      vm.totalFee = 0;
      vm.totalFeeDiscount = 0;
      var quarterly = vm.asset.response.quarterly ? vm.asset.response.quarterly : 0;
      var quarterlyDiscount = vm.asset.response.quarterlyDiscount ? vm.asset.response.quarterlyDiscount : 0;

      if (vm.asset.response.yearOne) {
        vm.totalFee += parseInt(vm.asset.response.yearOne);
      }
      if (vm.asset.response.yearsTwoThree) {
        vm.totalFee += 2 * parseInt(vm.asset.response.yearsTwoThree);
      }
      if (vm.asset.valuationFrequency !== 'Annual' && quarterly) {
        switch (vm.asset.valuationFrequency) {
          case 'Quarterly':
          default:
            vm.totalFee += 9 * parseInt(quarterly);
            break;
          case 'Semi-Annual':
            vm.totalFee += 3 * parseInt(quarterly);
            break;
        }
      }

      if (vm.asset.valuationFrequency !== 'Annual' && quarterlyDiscount) {
        switch (vm.asset.valuationFrequency) {
          case 'Quarterly':
          default:
            vm.totalFeeDiscount += 9 * parseInt(quarterlyDiscount);
            break;
          case 'Semi-Annual':
            vm.totalFeeDiscount += 3 * parseInt(quarterlyDiscount);
        }
      }
      if (!vm.totalFee && !vm.totalFeeDiscount) {
        vm.isRequired = false;
      } else if (vm.totalFee || vm.totalFeeDiscount) {
        vm.isRequired = true;
      }
    }, true);

    $scope.$on('$destroy', function () {
      totalFeeWatch();
      stateAlert();
    });
  }

})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .config(routeConfig);
  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider.state('app.requests.engagementLetters', {
      url: '/engagement-letters',
      views: {
        '@app': {
          templateUrl: 'app/states/requests/engagement-letters/engagement-letters.html',
          controller: 'EngagementLettersController',
          controllerAs: 'engagementLettersCtrl'
        }
      },
      data: {
        pageTitle: 'Engagement Letter Repository',
        roles: ['AssetAppraisal', 'AssetManagement', 'AssetManagerReadOnly'],
        viewClass: 'engagement-letters'
      },
      resolve:{
        /** @ngInject */
        propertyTypes: function (StaticDataService) {
          return StaticDataService.getPropertyTypes();
        },
        /** @ngInject */
        bidRequests: function ($q, BidRequestService, AssetService, SessionManager) {
          return BidRequestService.listByUserId(SessionManager.getUser().id).then(function(bidRequests){
            var promises = [],
            formattedBidRequests = {};
            bidRequests.forEach(function(bidRequest){
              AssetService.listByBidRequestId(bidRequest.id).then(function(assets){
                bidRequest.assets = assets;
                formattedBidRequests[bidRequest.id] = bidRequest;
              });
            });
            return $q.all(promises).then(function(){
              return formattedBidRequests;
            });
          });
        }
      }
    });
  }

})();
(function () {
  'use strict';

  angular
    .module('nvc')
    .controller('EngagementLettersController', EngagementLettersController);

  /** @ngInject */
  function EngagementLettersController($scope, $window, $filter, BidRequestService, propertyTypes, bidRequests,
                                       ArrayHelper, UtcDateConverter, SessionManager) {

    var vm = this;
    vm.letters = [];
    vm.showFilters = true;
    vm.allPropertyTypesSelected = false;
    vm.searchQueryPropertyType = '';
    vm.propertyTypes = propertyTypes.items;
    vm.selectedPropertyTypes = [];
    vm.selectedAppraisers = [];
    vm.searchQuery = '';
    vm.lettersSort = [
      {
        sort: 'fileName',
        tag: 'fileName',
        selected: true,
        flag: true
      }
    ];
    vm.lettersSelectedSort = vm.lettersSort[0];

    //BREADCRUMS
    //------------------------------------------
    vm.title = $filter('translate')('ENGAGEMENT_LETTERS.MAIN_TITLE');
    vm.breadcrumbs = [
      {
        label: $filter('translate')('COMMONS.REQUESTS'),
        value: 'app.requests.allRequests'
      },
      {
        label: $filter('translate')('ENGAGEMENT_LETTERS.MAIN_TITLE'),
        value: 'app.requests.engagementLetters'
      }
    ];

    //SORTING
    //------------------------------------------
    vm.sorting = function (sort, target) {
      ArrayHelper.sort(sort, target, vm.lettersSort, vm);
    };

    //SEARCH FUNCTION
    //------------------------------------------
    vm.searchLetters = function () {
      ArrayHelper.searchScroll();
    };

    vm.search = function(){
      var types = [],
      time;
      var userRole = SessionManager.getRoleName();
      var companyId = null

      if(userRole == 'AssetManagement' || userRole == 'AssetManagerReadOnly') {
        companyId = SessionManager.getCompanyId();
      }
      if (!vm.allPropertyTypesSelected) {
        vm.propertyTypes.forEach(function (type) {
          if (type.selected) {
            types.push(type.type);
          }
        });
      }
      if(vm.filterDate){
        time = UtcDateConverter.setDateToUTC(vm.filterDate);
      }
      BidRequestService.listBidRequestLetters(null, types, time, companyId).then(function(letters){
        letters.forEach(function(letter){
          letter.createdOn = UtcDateConverter.getDateFromUTC(letter.createdOn);
          letter.bidRequest = bidRequests[letter.bidRequestId];
        });
        vm.letters = letters;
      });
      vm.showFilters = false;
      vm.searched = true;
    };

    vm.arrayToFormattedString = function (array, separator) {
      if (array) {
        return array.toString().replace(/\,/g, separator);
      } else {
        return '';
      }
    };

    vm.downloadLetter = function(letter){
      BidRequestService.downloadEngagementLetter(letter.id).then(function (downloadData) {
        $window.open(downloadData, '_blank');
      });
    };

    vm.clearFilters = function(){
      vm.propertyTypes.forEach(function(propertyType){
        propertyType.selected = false;
      });
      delete vm.filterDate;
      vm.allPropertyTypesSelected = false;
    };

    //DATEPICKER
    //-------------------------------------------
    vm.filterPicker = {
      opened: false
    };

    vm.openFilterPicker = function () {
      vm.filterPicker.opened = true;
    };

    vm.filterDateOptions = {
      startingDay: 1,
      showWeeks: false,
      minMode: 'month'
    };

    vm.filterModelOptions = {
      debounce: {
        default: 500,
        blur: 250
      },
      getterSetter: true
    };


    var watchers = [];

    //PROPERTY TYPE SELECTOR WATCHERS
    //------------------------------------------
    watchers.push($scope.$watch('engagementLettersCtrl.propertyTypes', function () {
      for (var i = 0; i < vm.propertyTypes.length; i++) {
        if (vm.propertyTypes[i].selected) {
          vm.selectedPropertyTypes = [];
          vm.allPropertyTypesSelected = false;
          break;
        }
      }
      for (i = 0; i < vm.propertyTypes.length; i++) {
        if (vm.propertyTypes[i].selected) {
          vm.selectedPropertyTypes.push(vm.propertyTypes[i].name);
        } else if (!vm.allPropertyTypesSelected && vm.selectedPropertyTypes.indexOf(vm.propertyTypes[i].name) != -1) {
          vm.selectedPropertyTypes.splice(vm.selectedPropertyTypes.indexOf(vm.propertyTypes[i].name), 1);
        }
      }
    }, true));

    watchers.push($scope.$watch('engagementLettersCtrl.allPropertyTypesSelected', function () {

      if (vm.allPropertyTypesSelected) {
        vm.selectedPropertyTypes = [];
        vm.propertyTypes.forEach(function (group) {
          group.selected = false;
          vm.selectedPropertyTypes.push(group.name);
        });
      } else {
        vm.selectedPropertyTypes = [];
        for (var i = 0; i < vm.propertyTypes.length; i++) {
          if (vm.propertyTypes[i].selected) {
            vm.selectedPropertyTypes.push(vm.propertyTypes[i].name);
          }
        }
      }
    }, true));

    $scope.$on('$destroy', function () {
      watchers.forEach(function (watcher) {
        watcher();
      });
    });

  }

})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .config(routeConfig);
  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider.state('app.requests.allRequests', {
      url: '/all-requests?rfpId',
      views: {
        '@app': {
          templateUrl: 'app/states/requests/all-requests/all-requests.html',
          controller: 'AllRequestsController',
          controllerAs: 'allRequestsCtrl'
        }
      },
      data: {
        pageTitle: 'Request Status',
        roles: ['AssetAppraisal'],
        viewClass: 'all-requests'
      },
      params: {
        rfpId: null
      },
      resolve: {
        /** @ngInject */
        bidList: function ($q, BidRequestService, BidResponseService, UserService, AssetService, SessionManager,
                           $stateParams, UtcDateConverter) {
          var user = SessionManager.getUser();
          var responsesPromises = [];
          responsesPromises.push(BidResponseService.listByAppraiserId(user.id));
          responsesPromises.push(BidRequestService.listByUserIdPage(user.id, 0, 20, '', 'Name', 'Ascending'));

          return $q.all(responsesPromises).then(function (responses) {
            var bidResponses = responses[0];
            var promises = [];
            var returnData = {
              pageInfo: responses[1].pageInfo,
              bids: responses[1].bids
            };
            returnData.bids.forEach(function (requestForProposal) {
              requestForProposal.dueDate = UtcDateConverter.getDateFromUTC(requestForProposal.dueDate);
              if($stateParams.rfpId && requestForProposal.id === $stateParams.rfpId) {
                requestForProposal.displaying = true;
              }
              promises.push(AssetService.listByBidRequestId(requestForProposal.id).then(function (assetsList) {
                var responded, awarded = false, declined = false;
                requestForProposal.assets = assetsList;
                requestForProposal.responses = [];
                requestForProposal.statusCounters = {
                  assetsAwarded: 0,
                  assetsResponded: 0,
                  assetsNotAwarded: 0
                };
                bidResponses.forEach(function (bidResponse) {
                  if (bidResponse.bidRequestId === requestForProposal.id) {
                    bidResponse.status = '';
                    if (!declined && bidResponse.isAwarded && (bidResponse.yearOne || bidResponse.yearOne === 0)) {
                      awarded = true;
                      responded = true;
                      bidResponse.status = 'Awarded';
                      requestForProposal.status = 'Awarded';
                      requestForProposal.statusCounters.assetsAwarded++;
                    } else if (!declined && bidResponse.respondedOn && (bidResponse.yearOne || bidResponse.yearOne === 0)
                      && !awarded && !bidResponse.isDeclined && bidResponse.isSubmittedToAdmin && !bidResponse.isNotAwarded) {
                      responded = true;
                      bidResponse.status = 'Responded';
                      requestForProposal.status = 'Responded';
                      requestForProposal.statusCounters.assetsResponded++;
                    } else if (!declined && !bidResponse.isSubmittedToAdmin && !bidResponse.isDeclined && !responded &&
                      !bidResponse.isAwarded && !bidResponse.isNotAwarded) {
                      bidResponse.status = 'NeedsResponse';
                      requestForProposal.status = 'NeedsResponse';
                    } else if (bidResponse.isDeclined) {
                      responded = true;
                      declined = true;
                      bidResponse.status = 'Declined';
                      requestForProposal.status = 'Declined';
                    } else if(!bidResponse.isDeclined && !bidResponse.isAwarded && bidResponse.isNotAwarded){
                      bidResponse.status = 'NotAwarded';
                      requestForProposal.statusCounters.assetsNotAwarded++;
                    }
                    requestForProposal.responses.push(bidResponse);
                  }
                  for (var k = 0; k < requestForProposal.assets.length; k++) {
                    if (bidResponse.assetId === requestForProposal.assets[k].id) {
                      requestForProposal.assets[k].status = bidResponse.status;
                      requestForProposal.assets[k].bidResponseId = bidResponse.id;
                    }
                  }
                });
                if(requestForProposal.assets.length === requestForProposal.statusCounters.assetsNotAwarded) {
                  requestForProposal.status = 'NotAwarded';
                  for (var i = 0; i < requestForProposal.assets.length; i++) {
                    requestForProposal.assets[i].status = 'NotAwarded';
                  }
                }
                return requestForProposal;
              }));
            });
            return $q.all(promises).then(function(requests) {
              return {requests: requests, bidResponses: bidResponses, pageInfo: returnData.pageInfo};
            });
          });
        }
      }
    });
  }

})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .controller('AllRequestsController', AllRequestsController);

  /** @ngInject */
  function AllRequestsController($q, $filter, bidList, ArrayHelper, SessionManager, BidRequestService, AssetService,
                                 CSVService, PDFGenerator, notify, UtcDateConverter) {

    var vm = this;
    vm.bidList = bidList.requests;
    vm.searchQuery = '';
    vm.allRequestSort = [
      {
        tag: 'Name',
        selected: true,
        flag: true,
        order: 'Ascending'
      },
      {
        tag: 'Assets',
        selected: false,
        flag: false,
        order: 'Ascending'
      },
      {
        tag: 'DueDate',
        selected: false,
        flag: false,
        order: 'Ascending'
      },
      {
        tag: 'Status',
        selected: false,
        flag: false,
        order: 'Ascending'
      }
    ];
    vm.perPage = 20;
    vm.maxPaginationSize = 5;
    vm.allRequestSelectedSort = vm.allRequestSort[0];
    vm.currentPage = 1;
    vm.requestsCount = bidList.pageInfo.count;

    var user = SessionManager.getUser();
    var bidResponses = bidList.bidResponses;

    vm.downloadLoading = false;

    vm.downloadCsv = function () {
      vm.downloadLoading = true;
      CSVService.generateRequestStatusCsv(bidList, user.id, vm.requestsCount, vm.searchQuery, vm.allRequestSelectedSort.tag, vm.allRequestSelectedSort.order)
        .then(function () {
          vm.downloadLoading = false;
        })
        .catch(function () {
          vm.downloadLoading = false;
        })
    };

    vm.downloadPdf = function () {
      vm.downloadLoading = true;
      PDFGenerator.generateRequestStatusPdf(bidList, user.id, vm.requestsCount, vm.searchQuery, vm.allRequestSelectedSort.tag, vm.allRequestSelectedSort.order)
        .then(function (pdf) {
          vm.downloadLoading = false;
          var currentUser = SessionManager.getUser();
          pdf.download('request-status-' + currentUser.name + '.pdf');
        })
        .catch(function () {
          vm.downloadLoading = false;
          notify({
            message: $filter('translate')('COMMONS.EXPORT_FAILURE'),
            duration: 5000,
            templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
            classes: 'alert-danger',
            position: 'center'
          });
        });
    };

    //BREADCRUMS
    //------------------------------------------
    vm.title = $filter('translate')('ALL_REQUESTS.MAIN_TITLE');
    vm.breadcrumbs = [
      {
        label: $filter('translate')('ALL_REQUESTS.REQUESTS'),
        value: 'app.requests.allRequest'
      }
    ];

    //SEARCH FUNCTION
    //------------------------------------------
    vm.searchRequests = function () {
      if (vm.searchQuery.length > 2 || !vm.searchQuery) {
        loadRequests();
      }
    };

    //CHANGE PAGE FUNCTION
    //------------------------------------------
    vm.changePage = function () {
      loadRequests();
    };

    //SORTING
    //------------------------------------------
    vm.sorting = function (sort, target) {
      ArrayHelper.beSort(sort, target, vm.allRequestSort, vm);
      loadRequests();
    };

    //LATERAL BAR CONFIG
    //------------------------------------------
    vm.lateralBarConfig = {
      templateUrl: 'app/states/requests/all-requests/all-requests-lateral-content.html',
      controller: 'AllRequestLateralController',
      icons: [
        {
          class: 'icon-ic-assetinfo info',
          anchor: 'rfp-info'
        }
      ]
    };

    vm.bidList.forEach(function (bid) {
      if (bid.displaying) {
        vm.openDetails = true;
        vm.selectedRFP = bid;
        vm.lateralBarConfig.locals = {
          RFP: vm.selectedRFP
        };
      }
    });

    //LATERAL BAR OPEN
    //------------------------------------------
    vm.getDetails = function (selectedRFP) {
      vm.openDetails = true;
      vm.bidList.forEach(function (RFP) {
        selectedRFP.id === RFP.id ? RFP.displaying = true : RFP.displaying = false;
      });

      vm.selectedRFP = selectedRFP;
      vm.lateralBarConfig.locals = {
        RFP: vm.selectedRFP
      };
    };

    //LATERAL BAR CLOSE
    //------------------------------------------
    vm.closeDetails = function (RFP) {
      vm.openDetails = false;
      if (RFP) {
        RFP.displaying = false;
      }
      vm.selectedRFP.displaying = false;
      vm.selectedRFP = undefined;
    };

    function loadRequests() {
      $('.paginator-loader').addClass('sk-loading');
      BidRequestService.listByUserIdPage(user.id, vm.currentPage - 1, vm.perPage, vm.searchQuery,
        vm.allRequestSelectedSort.tag, vm.allRequestSelectedSort.order)
        .then(function (responses) {
          var promises = [];
          var returnData = {
            pageInfo: responses.pageInfo,
            bids: responses.bids
          };
          vm.requestsCount = responses.pageInfo.count;
          returnData.bids.forEach(function (requestForProposal) {
            requestForProposal.dueDate = UtcDateConverter.getDateFromUTC(requestForProposal.dueDate);
            promises.push(AssetService.listByBidRequestId(requestForProposal.id).then(function (assetsList) {
              var responded, awarded = false, declined = false;
              requestForProposal.assets = assetsList;
              requestForProposal.responses = [];
              requestForProposal.statusCounters = {
                assetsAwarded: 0,
                assetsResponded: 0,
                assetsNotAwarded: 0
              };
              bidResponses.forEach(function (bidResponse) {
                if (bidResponse.bidRequestId === requestForProposal.id) {
                  bidResponse.status = '';
                  if (!declined && bidResponse.isAwarded && (bidResponse.yearOne || bidResponse.yearOne === 0)) {
                    awarded = true;
                    responded = true;
                    bidResponse.status = 'Awarded';
                    requestForProposal.status = 'Awarded';
                    requestForProposal.statusCounters.assetsAwarded++;
                  } else if (!declined && bidResponse.respondedOn && (bidResponse.yearOne || bidResponse.yearOne === 0)
                    && !awarded && !bidResponse.isDeclined && bidResponse.isSubmittedToAdmin && !bidResponse.isNotAwarded) {
                    responded = true;
                    bidResponse.status = 'Responded';
                    requestForProposal.status = 'Responded';
                    requestForProposal.statusCounters.assetsResponded++;
                  } else if (!declined && !bidResponse.isSubmittedToAdmin && !bidResponse.isDeclined && !responded &&
                    !bidResponse.isAwarded && !bidResponse.isNotAwarded) {
                    bidResponse.status = 'NeedsResponse';
                    requestForProposal.status = 'NeedsResponse';
                  } else if (bidResponse.isDeclined) {
                    responded = true;
                    declined = true;
                    bidResponse.status = 'Declined';
                    requestForProposal.status = 'Declined';
                  } else if (!bidResponse.isDeclined && !bidResponse.isAwarded && bidResponse.isNotAwarded) {
                    bidResponse.status = 'NotAwarded';
                    requestForProposal.statusCounters.assetsNotAwarded++;
                  }
                  requestForProposal.responses.push(bidResponse);
                }
                for (var k = 0; k < requestForProposal.assets.length; k++) {
                  if (bidResponse.assetId === requestForProposal.assets[k].id) {
                    requestForProposal.assets[k].status = bidResponse.status;
                    requestForProposal.assets[k].bidResponseId = bidResponse.id;
                  }
                }
              });
              if (requestForProposal.assets.length === requestForProposal.statusCounters.assetsNotAwarded) {
                requestForProposal.status = 'NotAwarded';
                for (var i = 0; i < requestForProposal.assets.length; i++) {
                  requestForProposal.assets[i].status = 'NotAwarded';
                }
              }

              return requestForProposal;

            }));
          });
          return $q.all(promises).then(function (bidList) {
            vm.bidList = bidList;
            ArrayHelper.searchScroll();
            $('.paginator-loader').removeClass('sk-loading');
          });
        });
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .controller('AllRequestLateralController', AllRequestLateralController);

  /** @ngInject */
  function AllRequestLateralController($filter, $scope, $state, $window, LoaderHelper, SessionManager, BidRequestService,
                                       notify, SweetAlert, RFP) {

    $scope.RFP = RFP;
    $scope.fileToUpload = null;
    var user = SessionManager.getUser();
    BidRequestService.getLastBidRequestLetterByUserId($scope.RFP.id, user.id).then(function (letters) {
      $scope.documents = letters;
    });

    $scope.declineBidRequest = function (rfp) {
      SweetAlert.swal({
          title: $filter('translate')('COMMENT_STATES.RETRACT.TITLE'),
          text: $filter('translate')('ALL_REQUESTS.DECLINE_RFP_CONFIRMATION'),
          showCancelButton: true,
          cancelButtonText: $filter('translate')('ALL_REQUESTS.YES_DECLINE'),
          confirmButtonColor: '#2c3d4e',
          confirmButtonText: $filter('translate')('COMMENT_STATES.RETRACT.NO_TAKE_BACK'),
          closeOnConfirm: true,
          closeOnCancel: true
        },
        function (isConfirm) {
          if (!isConfirm) {
            LoaderHelper.open();
            BidRequestService.declineBidRequest(rfp.id).then(function () {
              notify({
                message: $filter('translate')('ALL_REQUESTS.RFP_DECLINED'),
                duration: 4000,
                templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
                classes: 'alert-info',
                position: 'center'
              });
              $state.go($state.current, {}, {reload: true});
            }, function () {
              LoaderHelper.close();
              notify({
                message: $filter('translate')('ALL_REQUESTS.RFP_DECLINED_FAILS'),
                duration: 4000,
                templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
                classes: 'alert-danger',
                position: 'center'
              });
            });
          }
        });
    };

    $scope.uploadDocument = function (file) {
      BidRequestService.uploadAppraiserLetter($scope.RFP.id, file[0]).then(function () {
        notify({
          message: $filter('translate')('ALL_REQUESTS.DOCUMENT_UPLOADED'),
          duration: 4000,
          templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
          classes: 'alert-info',
          position: 'center'
        });
        BidRequestService.getLastBidRequestLetterByUserId($scope.RFP.id, user.id).then(function (letters) {
          $scope.documents = letters;
        });
      });
    };

    $scope.downloadLetter = function (letterId) {
      BidRequestService.downloadEngagementLetter(letterId, false).then(function (downloadData) {
        $window.open(downloadData, '_blank');
      });
    };

    $scope.deleteLetter = function (letterId) {
      BidRequestService.deleteEngagementLetter(letterId).then(function (deletedLetter) {
        notify({
          message: $filter('translate')('ALL_REQUESTS.DOCUMENT_DELETED'),
          duration: 4000,
          templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
          classes: 'alert-info',
          position: 'center'
        });
        BidRequestService.getLastBidRequestLetterByUserId($scope.RFP.id, user.id).then(function (letters) {
          $scope.documents = letters;
        });
      });
    };

    //IS SUBMITTED FUNCTION
    //------------------------------------------
    $scope.isBidded = function () {
      for (var i = 0; i < $scope.RFP.responses.length; i++) {
        if ($scope.RFP.responses[i].yearOne || $scope.RFP.responses[i].yearOne == 0) {
          return true;
        }
      }
    };
  }

})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .config(routeConfig);

  function routeConfig($stateProvider) {
    $stateProvider.state('app.manage.users', {
      url: '/users',
      views: {
        '@app': {
          templateUrl: 'app/states/manage/users/users.html',
          controller: 'UsersController',
          controllerAs: 'users'
        }
      },
      data: {
        pageTitle: 'Users',
        viewClass: 'users',
        roles: ['Admin', 'Audit', 'AssetManagement', 'AssetAppraisal', 'AssetReview', 'AssetManagerReadOnly']
      },
      resolve: {
        /** @ngInject */
        companies: function (CompanyService, SessionManager) {
          return CompanyService.getAllCompanies(true, true).then(function (companies) {
            if (SessionManager.isInRole('Admin')) {
              return companies;
            } else if (SessionManager.isInRole('AssetAppraisal')) {
              return filterByRole(companies, 'AssetAppraisal', 'AssetManagement', SessionManager.getCompanyId());
            } else if (SessionManager.isInRole('AssetManagement')) {
              return filterByRole(companies, 'AssetManagement', 'AssetAppraisal', SessionManager.getCompanyId());
            } else if (SessionManager.isInRole('Audit')) {
            return filterByRole(companies, 'Audit', 'None', SessionManager.getCompanyId());
            } else if (SessionManager.isInRole('AssetReview')) {
              return filterByRole(companies, 'AssetReview', 'None', SessionManager.getCompanyId());
            }
          });
        }
      }
    });
  }

  function filterByRole (array, currentRole, canNotSee, companyId) {
    var relateCompanies = [];
    array.forEach(function (element) {
      if (element.type != canNotSee && element.type != 'Admin' && (element.type != currentRole ||
        (element.type == currentRole && element.id == companyId))) {
        relateCompanies.push(element);
      }
    });
    return relateCompanies;
  }

})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .controller('UsersController', UsersController);

  /** @ngInject */
  function UsersController($scope, $q, $filter, SessionManager, CompanySelectorFactory, LoaderHelper, ArrayHelper,
                           UserService, companies, notify, CSVService) {
    var vm = this,
      company = {};
    vm.users = [];
    vm.searchQuery = '';
    vm.selectedUsers = 0;
    vm.isAdmin = true;
    vm.usersSort = [
      {
        tag: 'UserName',
        selected: true,
        flag: true,
        order: 'Ascending'
      },
      {
        tag: 'Email',
        selected: false,
        flag: false,
        order: 'Ascending'
      }
    ];
    vm.perPage = 17;
    vm.maxPaginationSize = 5;
    vm.usersSelectedSort = vm.usersSort[0];

    if (!SessionManager.isInRole('Admin')) {
      vm.isAdmin = false;
    }

    //Exports
    //-------------------------------------------------------
    vm.downloadLoading = false;
    vm.downloadCsv = function() {
      vm.downloadLoading = true;

      CSVService.generateUsersListCsv(SessionManager.getCompanyId(), company, vm.usersCount, vm.searchQuery, vm.usersSelectedSort.tag, vm.usersSelectedSort.order)
        .then(function() {
          vm.downloadLoading = false;
        })
        .catch(function() {
          vm.downloadLoading = false;
        });
    };

    //BREADCRUMS
    //-------------------------------------------------------
    vm.title = $filter('translate')('USERS.USERS');
    vm.breadcrumbs = [
      {
        label: $filter('translate')('USERS.MANAGE'),
        value: 'app.manage.users'
      },
      {
        label: $filter('translate')('USERS.USERS'),
        value: 'app.manage.users'
      }
    ];

    //SORTING
    //------------------------------------------
    vm.sorting = function (sort, target) {
      ArrayHelper.beSort(sort, target, vm.usersSort, vm);
      loadUsers();
    };

    //SEARCH FUNCTION
    //------------------------------------------
    vm.searchUsers = function () {
      if (vm.searchQuery.length > 2 || !vm.searchQuery) {
        loadUsers();
      }
    };

    //ACTIVATE USER
    //-------------------------------------------------------
    vm.activateUser = function () {
      var promises = [];
      vm.users.forEach(function (user) {
        if (user.user.selected && !user.active) {
          var userDTO = {};
          userDTO.companyId = user.companyId;
          userDTO.email = user.userAccount.email;
          userDTO.name = user.user.name;
          userDTO.mobilePhone = user.userAccount.mobilePhone;
          userDTO.officePhone = user.userAccount.officePhone;
          userDTO.readOnlyAssetManager = user.role == 'AssetManagerReadOnly';
          userDTO.assetTypeSpecialties =
            user.user.assetTypeSpecialties ? user.user.assetTypeSpecialties.toString() : [];
          userDTO.certifications = user.user.certifications ? user.user.certifications.toString() : [];
          userDTO.workedOnStates = user.user.workedOnStates ? user.user.workedOnStates.toString() : [];
          userDTO.workedOnCountries = user.user.workedOnCountries ? user.user.workedOnCountries.toString() : [];
          promises.push(UserService.createUser(userDTO).then(function (userResponse) {
            UserService.cleanUserCache(user.user.id);
            user.user.selected = false;
            user.user.active = true;
            user.active = true;
            return userResponse;
          }));
        }
      });
      if (promises.length > 0) {
        notifyResults('active', promises);
      }
    };

    //INACTIVATE USER
    //-------------------------------------------------------
    vm.inactivateUser = function () {
      var promises = [];
      var selectedUsers = Array.isArray(vm.users) && vm.users.filter(function(user) {
        return user.user.selected && user.active;
      });

      // Reject when no user is selected
      if (!Array.isArray(selectedUsers)) {
        return;
      }
      
      promises = [
        UserService.inactivateUser({
          ids: selectedUsers.map(function(user) {
            user.user.selected = false;
            return user.user.id;
          }).toString()
        }).then(function(updatedUsers) {
          updatedUsers.forEach(function(updatedUser) {
            UserService.cleanUserCache(updatedUser.id);
            var user = findItemInArray(vm.users, function(user) {
              return user.user.id === updatedUser.id;
            });
            user.active = false;
            user.user.active = false;
            return user;
          });
        })
      ];

      if (promises.length > 0) {
        notifyResults('inactive', promises);
      }
    };

    //DELETE USER
    //-------------------------------------------------------
    vm.deleteUser = function () {
      var promises = [];
      var selectedUsers = Array.isArray(vm.users) && vm.users.filter(function(user) {
        return user.user.selected;
      });

      // Reject when no user is selected
      if (!Array.isArray(selectedUsers)) {
        return;
      }

      promises = [
        UserService.deleteUser(
          selectedUsers
            .map(function(user) {
              user.user.selected = false;
              user.user.active = false;
              return user.user.id;
            })
            .toString()
        ).then(function(removedUsers) {
          removedUsers.forEach(function(removedUser) {
            UserService.cleanUserCache(removedUser.id);
            var user = findItemInArray(vm.users, function(user) {
              return user.user.id === removedUser.id;
            });
            var index = vm.users.indexOf(user);
            vm.users.splice(index, 1);
          });
        })
      ];

      if (promises.length > 0) {
        notifyResults('delete', promises);
      }
    };

    //NOTIFY ACTIONS
    //-------------------------------------------------------
    function notifyResults(action, promises) {
      $q.all(promises).then(function () {
        var message = '';
        if (action == 'active') {
          message = $filter('translate')('USERS.USER_ACTIVATED');
        } else if (action == 'inactive') {
          message = $filter('translate')('USERS.USER_INACTIVATED');
        } else if (action == 'delete') {
          message = $filter('translate')('USERS.USER_DELETED');
        }

        notify({
          message: message,
          duration: 4000,
          templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
          classes: 'alert-info',
          position: 'center'
        });
      });
    }

    //GET USERS BY COMPANY
    //-------------------------------------------------------
    CompanySelectorFactory.showCompanies(companies);
    var companyListener = $scope.$on('companyChanged', function (event, selectedCompany) {
      CompanySelectorFactory.executeOnValidState('app.manage.users', function () {
        vm.currentPage = 1;
        company = selectedCompany;
        loadUsers(true);
      });
    });

    vm.changePage = function () {
      loadUsers();
    };

    function loadUsers(load) {
      if (load) {
        LoaderHelper.open();
      } else {
        $('.paginator-loader').addClass('sk-loading');
      }
      if (SessionManager.isInRole('Admin')) {
        return getUserByCompany(false, load);
      } else if (SessionManager.getCompanyId() === company.id) {
        return getUserByCompany(true, load);
      } else {
        return UserService.getRelatedUsersByCompanyIdPage(company.id, true, vm.currentPage - 1, vm.perPage,
          vm.searchQuery,
          vm.usersSelectedSort.tag, vm.usersSelectedSort.order).then(function (data) {
          vm.users = data.users;
          vm.users.forEach(function (user) {
            user.companyId = company.id;
          });
          vm.usersCount = data.pageInfo.count;
          ArrayHelper.searchScroll();
          if (load) {
            LoaderHelper.close();
          } else {
            $('.paginator-loader').removeClass('sk-loading');
          }
        });
      }
    }

    function getUserByCompany(all, load) {
      return UserService.getUsersByCompanyIdPage(company.id, all, vm.currentPage - 1, vm.perPage, vm.searchQuery,
        vm.usersSelectedSort.tag, vm.usersSelectedSort.order).then(function (data) {
        vm.users = data.users;
        vm.usersCount = data.pageInfo.count;
        ArrayHelper.searchScroll();
        if (load) {
          LoaderHelper.close();
        } else {
          $('.paginator-loader').removeClass('sk-loading');
        }

      });
    }

    // Simple polyfill for Array.prototype.find on a single object
    function findItemInArray(array, callback) {
      if (array === null) {
        throw new TypeError('Array.prototype.find called on null or undefined');
      } else if (typeof callback !== 'function') {
        throw new TypeError('callback must be a function');
      }
      var list = Object(array);
      // Makes sures is always has an positive integer as length.
      var length = list.length >>> 0;
      var thisArg = arguments[1];
      for (var i = 0; i < length; i++) {
        var element = list[i];
        if ( callback.call(thisArg, element, i, list) ) {
          return element;
        }
      }
    }

    var selectedUsersWatch = $scope.$watch('users.users', function () {
      vm.selectedUsers = 0;
      vm.users.forEach(function (user) {
        if (user.user.selected) {
          vm.selectedUsers++;
        }
      });
    }, true);

    $scope.$on('$destroy', function () {
      companyListener();
      selectedUsersWatch();
    });
  }
})();

(function(){
  'use strict';

  angular
  .module('nvc')
  .config(routeConfig);

  function routeConfig($stateProvider){
    $stateProvider.state('app.manage.roles',{
      url: "/roles",
      views: {
        '@app': {
          templateUrl: "app/states/manage/roles/roles.html",
          controller: 'RolesController',
          controllerAs: 'roles'
        }
      },
      data: {
        pageTitle: 'Roles',
        viewClass: 'roles',
        roles: ['Admin']
      }
    });
  }

})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .controller('RolesController', RolesController);

  /**@ngInject*/
  function RolesController($filter, CSVService, PDFGenerator, SessionManager, notify) {
    var vm = this;
    vm.tableHeaders = [
      "ROLES.CAPTIONS.PERMISSIONS",
      "ROLES.CAPTIONS.ADMINISTRATOR",
      "ROLES.CAPTIONS.SECONDARY_REVIEWER",
      "ROLES.CAPTIONS.LEAD_REVIEWER",
      "ROLES.CAPTIONS.SECONDARY_APPRAISER",
      "ROLES.CAPTIONS.LEAD_APPRAISER",
      "ROLES.CAPTIONS.SECONDARY_ASSET_MANAGER",
      "ROLES.CAPTIONS.LEAD_ASSET_MANAGER",
      "ROLES.CAPTIONS.READ_ONLY"
    ];
    vm.pdfHeaders = [
      "ROLES.PDF_CAPTIONS.PERMISSIONS",
      "ROLES.PDF_CAPTIONS.ADMINISTRATOR",
      "ROLES.PDF_CAPTIONS.SECONDARY_REVIEWER",
      "ROLES.PDF_CAPTIONS.LEAD_REVIEWER",
      "ROLES.PDF_CAPTIONS.SECONDARY_APPRAISER",
      "ROLES.PDF_CAPTIONS.LEAD_APPRAISER",
      "ROLES.PDF_CAPTIONS.SECONDARY_ASSET_MANAGER",
      "ROLES.PDF_CAPTIONS.LEAD_ASSET_MANAGER",
      "ROLES.PDF_CAPTIONS.READ_ONLY"
    ];
    vm.tableRows = [
      ["ROLES.PERMISSIONS.ADD_NEW_USER", true, false, false, false, false, false, false, false],
      ["ROLES.PERMISSIONS.AMEND_EXISTING_USER", true, false, false, false, false, false, false, false],
      ["ROLES.PERMISSIONS.ADD_NEW_COMPANY", true, false, false, false, false, false, false, false],
      ["ROLES.PERMISSIONS.VIEW_LIST_OF_ALL_COMPANIES", true, true, true, false, false, false, false, true],
      ["ROLES.PERMISSIONS.AMEND_EXISTING_COMPANY", true, false, false, false, false, false, false, false],
      ["ROLES.PERMISSIONS.VIEW_COMPANY_DETAILS", true, true, true, false, false, false, false, true],
      ["ROLES.PERMISSIONS.ADD_NEW_CONTACT", true, false, false, false, false, false, false, false],
      ["ROLES.PERMISSIONS.VIEW_LIST_OF_ALL_USERS", true, true, true, false, false, false, false, true],
      ["ROLES.PERMISSIONS.AMEND_EXISTING_CONTACT", true, false, false, false, false, false, false, false],
      ["ROLES.PERMISSIONS.VIEW_CONTACT_DETAILS", true, true, true, false, false, false, false, true],
      ["ROLES.PERMISSIONS.VIEW_ROLE_DETAILS", true, false, false, false, false, false, false, false],
      ["ROLES.PERMISSIONS.ADD_NEW_ASSET", true, false, false, false, false, true, true, false],
      ["ROLES.PERMISSIONS.UPLOAD_ASSET_SOURCE_DOCS", true, true, true, true, true, true, true, false],
      ["ROLES.PERMISSIONS.VIEW_ASSET_SOURCE_DOCUMENTS", true, true, true, true, true, true, true, true],
      ["ROLES.PERMISSIONS.VIEW_LIST_OF_ASSETS", true, true, true, true, true, true, true, true],
      ["ROLES.PERMISSIONS.VIEW_ASSET_DETAILS", true, true, true, true, true, true, true, true],
      ["ROLES.PERMISSIONS.ASSIGN_ENGAGEMENTS_TO_SECONDARY_PERSON", true, false, true, true, true, true, true, false],
      ["ROLES.PERMISSIONS.VIEW_ASSIGNED_PROPERTIES", true, true, true, true, true, true, true, true],
      ["ROLES.PERMISSIONS.VIEW_ALL_ASSETS_FOR_OWN_COMPANY", true, true, true, true, true, true, true, false],
      ["ROLES.PERMISSIONS.CREATE_NEW_RFP", true, false, false, false, false, false, false, false],
      ["ROLES.PERMISSIONS.SELECT_APPRAISERS", true, false, false, false, false, false, false, false],
      ["ROLES.PERMISSIONS.SEND_BID_ENGAGEMENT_TO_APPRAISERS", true, false, false, false, false, false, false, false],
      ["ROLES.PERMISSIONS.LIST_OF_SENT_RFPS", true, false, false, false, false, false, false, false],
      ["ROLES.PERMISSIONS.VIEW_BIDS", true, false, false, false, false, false, false, false],
      ["ROLES.PERMISSIONS.ASSIGN_BID_TO_APPRAISER", true, false, false, false, false, false, false, false],
      ["ROLES.PERMISSIONS.RESPOND_TO_RFP", true, false, false, false, true, false, false, false],
      ["ROLES.PERMISSIONS.APPRAISER_REQUESTS_LIST", true, false, false, false, true, false, false, false],
      ["ROLES.PERMISSIONS.SEND_BID_FOR_ASSIGNED_ASSET", true, false, false, false, true, false, false, false],
      ["ROLES.PERMISSIONS.RESPONSE_SUMMARY_PAGE", true, false, false, false, true, false, false, false],
      ["ROLES.PERMISSIONS.UPLOAD_VALUATION_FILES", true, true, true, true, true, false, false, false],
      ["ROLES.PERMISSIONS.FILL_AND_SUBMIT_EXECUTIVE_SUMMARY", true, true, true, true, true, false, false, false],
      ["ROLES.PERMISSIONS.VIEW_FILES", true, true, true, true, true, true, true, true],
      ["ROLES.PERMISSIONS.ARCHIVE_FILES", true, true, true, false, false, false, false, false],
      ["ROLES.PERMISSIONS.ADD_COMMENTS", true, true, true, false, false, true, true, false],
      ["ROLES.PERMISSIONS.SUBMIT_COMMENTS_TO_ASSET_MANAGER", true, true, true, false, false, false, false, false],
      ["ROLES.PERMISSIONS.SUBMIT_COMMENTS/ACKNOWLEDGMENTS_TO_REVIEWER", true, false, false, false, false, true, true, false],
      ["ROLES.PERMISSIONS.EDIT_COMMENTS", true, true, true, false, false, false, false, false],
      ["ROLES.PERMISSIONS.DELETE_COMMENTS", true, true, true, false, false, false, false, false],
      ["ROLES.PERMISSIONS.SUBMIT_COMMENTS_TO_APPRAISER", true, true, true, false, false, false, false, false],
      ["ROLES.PERMISSIONS.SUBMIT_RESPONSE_TO_COMMENT", true, false, false, true, true, false, false, false],
      ["ROLES.PERMISSIONS.REVIEWER_SIGNOFF_AND_SUBMIT_TO_AM_FOR_APPROVAL", false, true, true, false, false, false, false, false],
      ["ROLES.PERMISSIONS.AM'S_ACKNOWLEDGE_VALUATION", false, false, false, false, false, true, true, false],
      ["ROLES.PERMISSIONS.LEAD_SIGNOFF_ON_FINAL_VALUATION", true, false, true, false, false, false, false, false],
      ["ROLES.PERMISSIONS.VIEW_REVIEW_FORM", true, true, true, true, true, true, true, true],
      ["ROLES.PERMISSIONS.VIEW_HISTORICAL_VALUATIONS_AND_SOURCE_DOCS", true, true, true, true, true, true, true, true],
      ["ROLES.PERMISSIONS.APPRAISAL_TEAM", true, true, true, true, true, false, false, false],
      ["ROLES.PERMISSIONS.REVIEW_TEAM", true, true, true, true, true, true, true, true],
      ["ROLES.PERMISSIONS.CLIENT", true, true, true, false, false, true, true, true],
      ["ROLES.PERMISSIONS.AMEND_PROPERTY_DETAILS", true, true, true, false, false, true, true, false],
      ["ROLES.PERMISSIONS.OVERWRITE_CAPABILITY", true, false, false, false, false, false, false, false]
    ];

    vm.title = $filter('translate')('COMMONS.ROLES');
    vm.breadcrumbs = [
      {
        label: $filter('translate')('COMMONS.MANAGE'),
        value: 'app.manage.roles'
      },
      {
        label: $filter('translate')('COMMONS.ROLES'),
        value: 'app.manage.roles'
      }
    ];

    // Download/Export
    vm.downloadLoading = false;
    vm.downloadCsv = function () {
      vm.downloadLoading = true;
      CSVService.generateRolesCsv(vm.tableHeaders, vm.tableRows)
        .then(function () {
          vm.downloadLoading = false;
        })
        .catch(function () {
          vm.downloadLoading = false;
        });
    };

    vm.downloadPdf = function () {
      vm.downloadLoading = true;
      PDFGenerator.generateRolesPdf(vm.pdfHeaders, vm.tableRows)
        .then(function (pdf) {
          vm.downloadLoading = false;
          var currentUser = SessionManager.getUser();
          pdf.download('roles-' + currentUser.name + '.pdf');
        })
        .catch(function (error) {
          vm.downloadLoading = false;
          notify({
            message: $filter('translate')('COMMONS.EXPORT_FAILURE'),
            duration: 5000,
            templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
            classes: 'alert-danger',
            position: 'center'
          });
        });
    };
  }

})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .config(routeConfig);

  function routeConfig($stateProvider) {
    $stateProvider.state('app.manage.reviewers', {
      url: '/reviewers-firms',
      views: {
        '@app': {
          templateUrl: 'app/states/manage/companies/companies.html',
          controller: 'CompaniesController',
          controllerAs: 'companies'
        }
      },
      data: {
        pageTitle: 'Reviewers',
        viewClass: 'companies',
        roles: ['Admin', 'Audit', 'AssetManagement', 'AssetReview', 'AssetManagerReadOnly']
      },
      params: {
        type: 'reviewers'
      },
      resolve: {
        /** @ngInject */
        companies: function ($q, CompanyService, SessionManager) {
          if(SessionManager.isInRole('Admin')) {
            return CompanyService.getReviewerCompaniesPage(true, false, 0, 10, '', 'Name', 'Ascending');
          } else if (SessionManager.isInRole('AssetReview')) {
            return CompanyService.getReviewerCompaniesPage(false, false, 0, 10, '', 'Name', 'Ascending');
          }
          return CompanyService.getReviewerCompaniesPage(true, true, 0, 10, '', 'Name', 'Ascending');
        }
      }
    });
  }

})();
(function () {
  'use strict';

  angular
    .module('nvc')
    .config(routeConfig);

  function routeConfig($stateProvider) {
    $stateProvider.state('app.manage.editContact', {
      url: '/edit-contact/:contactId',
      views: {
        '@app': {
          templateUrl: 'app/states/manage/edit-contact/edit-contact.html',
          controller: 'EditContactController',
          controllerAs: 'EditContactCtrl'
        }
      },
      data: {
        pageTitle: 'Edit Contact',
        viewClass: 'edit-contact',
        roles: ['Admin']
      },
      params: {
        contactId: '',
        companyId: null,
        company: null
      },
      resolve: {
        /**@ngInject*/
        contact: function ($q, $stateParams, ContactService) {
          if (!$stateParams.contactId || !$stateParams.company) {
            return $q.reject('invalid transition');
          }
          return ContactService.getContact($stateParams.contactId);
        },
        company: function ($q, $stateParams, CompanyService) {
          if (!$stateParams.companyId) {
            return $q.reject('invalid transition');
          }
          if(!$stateParams.company) {
            return CompanyService.getCompany($stateParams.companyId);
          }
          else {
            return $stateParams.company;
          }
        }
      }
    })

  }
})();

(function () {
  'use strict';

  angular
  .module('nvc')
  .controller('EditContactController', EditContactController);

  /** @ngInject */
  function EditContactController($filter, $state, notify, ContactService, LoaderHelper, contact, company) {
    var vm = this;

    vm.contact = contact;
    vm.editContact = {};
    //Breadcrums
    //-------------------------------------
    vm.title = $filter('translate')('ADD_CONTACT.MAIN_TITLE_EDIT') + ' ' + company.name;
    vm.breadcrumbs = [
      {
        label: $filter('translate')('COMMONS.MANAGE'),
        value: 'app.manage.clients'
      },
      getBreadcrumb(company.type),
      {
        label: $filter('translate')('COMMONS.EDIT_CONTACT'),
        value: 'app.manage.editContact'
      }
    ];

    vm.updateContact = function (contact) {
      LoaderHelper.open();
      ContactService.updateContact(contact).then(function () {
        notify({
          message: $filter('translate')('COMMONS.CONTACT_UPDATED'),
          duration: 4000,
          templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
          classes: 'alert-info',
          position: 'center'
        });
        $state.go(getPreviousState(company.type), {}, {reload: true});
      }, function () {
        LoaderHelper.close();
      });
    };

    function getPreviousState(type) {
      switch (type) {
        case 'AssetManagement':
          return 'app.manage.clients';
        case 'AssetReview':
          return 'app.manage.reviewers';
        case 'AssetAppraisal':
          return 'app.manage.appraisers';
        case 'Audit':
          return 'app.manage.auditors';
        default :
          return 'app.valuations';
      }
    }

    function getBreadcrumb(type) {
      switch (type) {
        case 'AssetReview':
          return {label: $filter('translate')('COMPANIES.MAIN_TITLE_REVIEWERS_FIRMS'), value: 'app.manage.reviewers'};
        case 'AssetAppraisal':
          return {label: $filter('translate')('COMPANIES.MAIN_TITLE_APPRAISAL_FIRMS'), value: 'app.manage.appraisers'};
        case 'Audit':
          return {label: $filter('translate')('COMPANIES.MAIN_TITLE_AUDIT_FIRMS'), value: 'app.manage.auditors'};
        default :
          return {label: $filter('translate')('COMPANIES.MAIN_TITLE_ASSET_MANAGEMENT_FIRMS'), value: 'app.manage.clients'};
      }
    }

  }
})();
(function () {
  'use strict';

  angular
    .module('nvc')
    .controller('CompaniesController', CompanyController);

  /** @ngInject */
  function CompanyController($filter, $stateParams, SweetAlert, SessionManager, companies, ContactService, AssetService,
                             CompanyService, notify, ArrayHelper) {

    var vm = this;

    vm.searchQuery = '';
    vm.companies = companies.companies;
    vm.selectedCompany = {};
    vm.showPhones = true;
    vm.userRole = SessionManager.getRoleName();
    vm.companiesCount = companies.pageInfo.count;
    vm.currentPage = 1;
    vm.maxPaginationSize = 5;
    vm.perPage = 10;

    vm.config = {
      templateUrl: '/app/states/manage/companies/company-lateral-content.html',
      controller: 'CompanyLateralController',
      icons: [
        {
          class: 'icon-ic-alert-circle-outline info',
          anchor: 'content'
        }
      ]
    };

    var assetsByCompany = {};

    var companyType = $stateParams.type;

    //BREADCRUMS
    //------------------------------------------
    if ($stateParams.type == 'clients') {
      vm.editCompany = 'app.manage.clients.editClient({companyId:company.id})';
      vm.newCompany = 'app.manage.clients.newClient';
      vm.newContact = 'app.manage.clients.addContact({companyId:company.id, company:company})';
      vm.newCompanies = $filter('translate')('COMPANIES.NEW_ASSET_MANAGEMENT_FIRM');
      //Clients Breadcrums
      //-------------------------------------
      vm.title = $filter('translate')('COMPANIES.MAIN_TITLE_ASSET_MANAGEMENT_FIRMS');
      vm.breadcrumbs = [
        {
          label: $filter('translate')('COMMONS.MANAGE'),
          value: 'app.manage.clients'
        },
        {
          label: $filter('translate')('COMPANIES.MAIN_TITLE_ASSET_MANAGEMENT_FIRMS'),
          value: 'app.manage.clients'
        }
      ];
    } else if ($stateParams.type == 'reviewers') {
      vm.editCompany = 'app.manage.reviewers.editReviewer({companyId:company.id})';
      vm.newCompany = 'app.manage.reviewers.newReviewer';
      vm.newContact = 'app.manage.reviewers.addContact({companyId:company.id, company:company})';
      vm.newCompanies = $filter('translate')('COMPANIES.NEW_REVIEWERS_FIRM');
      //Reviewers Breadcrums
      //-------------------------------------
      vm.title = $filter('translate')('COMPANIES.MAIN_TITLE_REVIEWERS_FIRMS');
      vm.breadcrumbs = [
        {
          label: $filter('translate')('COMMONS.MANAGE'),
          value: 'app.manage.reviewers'
        },
        {
          label: $filter('translate')('COMPANIES.MAIN_TITLE_REVIEWERS_FIRMS'),
          value: 'app.manage.reviewers'
        }
      ];
    } else if ($stateParams.type == 'appraisers') {
      vm.editCompany = 'app.manage.appraisers.editAppraiser({companyId:company.id})';
      vm.newCompany = 'app.manage.appraisers.newAppraiser';
      vm.newContact = 'app.manage.appraisers.addContact({companyId:company.id, company:company})';
      vm.newCompanies = $filter('translate')('COMPANIES.NEW_APPRAISAL_FIRM');
      //appraiser Breadcrums
      //-------------------------------------
      vm.title = $filter('translate')('COMPANIES.MAIN_TITLE_APPRAISAL_FIRMS');
      vm.breadcrumbs = [
        {
          label: $filter('translate')('COMMONS.MANAGE'),
          value: 'app.manage.appraisers'
        },
        {
          label: $filter('translate')('COMPANIES.MAIN_TITLE_APPRAISAL_FIRMS'),
          value: 'app.manage.appraisers'
        }
      ];
    } else if ($stateParams.type == 'auditors') {
      vm.editCompany = 'app.manage.auditors.editAuditor({companyId:company.id})';
      vm.newCompany = 'app.manage.auditors.newAuditor';
      vm.newContact = 'app.manage.auditors.addContact({companyId:company.id, company:company})';
      vm.newCompanies = $filter('translate')('COMPANIES.NEW_AUDIT_FIRM');
      //auditor Breadcrums
      //-------------------------------------
      vm.title = $filter('translate')('COMPANIES.MAIN_TITLE_AUDIT_FIRMS');
      vm.breadcrumbs = [
        {
          label: $filter('translate')('COMMONS.MANAGE'),
          value: 'app.manage.auditors'
        },
        {
          label: $filter('translate')('COMPANIES.MAIN_TITLE_AUDIT_FIRMS'),
          value: 'app.manage.auditors'
        }
      ];
    }

    //IS LEAD FUNCTION
    //------------------------------------------
    vm.toggleLead = function (contact) {
      contact.type = contact.type == 'PrimaryContact' ? 'SecondaryContact' : 'PrimaryContact';
      ContactService.updateContact(contact);
    };

    //SEARCH FUNCTION
    //------------------------------------------
    vm.searchCompanies = function () {
      if (vm.searchQuery.length > 2 || !vm.searchQuery) {
        vm.currentPage = 1;
        loadCompanies();
      }
    };

    vm.changePage = function () {
      loadCompanies();
    };

    //GET COMPANY DETAILS
    //------------------------------------------
    vm.getCompanyDetails = function (selectedCompany) {
      vm.showDetails = true;
      vm.showPhones = false;
      vm.companies.forEach(function (company) {
        selectedCompany.id == company.id ? company.displaying = true : company.displaying = false;
      });

      if (!assetsByCompany[selectedCompany.id]) {
        AssetService.getAssetsByCompany(selectedCompany.id).then(function (assets) {
          vm.selectedCompany = selectedCompany;
          vm.selectedCompany.assets = assets;
          vm.config.locals = {
            company: vm.selectedCompany
          };
          assetsByCompany[selectedCompany.id] = assets;

        });
      } else {
        vm.selectedCompany = selectedCompany;
        vm.selectedCompany.assets = assetsByCompany[selectedCompany.id];
        vm.config.locals = {
          company: vm.selectedCompany
        };
      }
    };

    //CLOSE DETAILS
    //-------------------------------------------------------
    vm.closeDetails = function (company) {
      vm.showDetails = false;
      vm.showPhones = true;
      if (company) {
        company.displaying = false;
      }
      vm.selectedCompany.displaying = false;
      vm.selectedCompany = undefined;
    };

    //ACTIVATE COMPANY
    //-------------------------------------------------------
    vm.activateCompany = function (selectedCompany) {
      selectedCompany.active = true;
      var companyDTO = {};
      companyDTO.id = selectedCompany.id;
      companyDTO.name = selectedCompany.name;
      companyDTO.address = selectedCompany.address.address;
      companyDTO.type = selectedCompany.type;
      companyDTO.active = selectedCompany.active;
      CompanyService.updateCompany(companyDTO).then(function () {
        AssetService.getAssetsByCompany(selectedCompany.id).then(function (assets) {
          assets.forEach(function (asset) {
            asset.active = true;
            var assetDTO = {};
            assetDTO.id = asset.id;
            assetDTO.active = asset.active;
            AssetService.updateAsset(assetDTO);
          });
        });
        notifyResults("active");
      });
      selectedCompany.tools = false;
    };

    //INACTIVATE COMPANY
    //-------------------------------------------------------
    vm.inactivateCompany = function (selectedCompany) {
      selectedCompany.active = false;
      var companyDTO = {};
      companyDTO.id = selectedCompany.id;
      companyDTO.name = selectedCompany.name;
      companyDTO.address = selectedCompany.address.address;
      companyDTO.type = selectedCompany.type;
      companyDTO.active = selectedCompany.active;
      CompanyService.updateCompany(companyDTO).then(function () {
        AssetService.getAssetsByCompany(selectedCompany.id).then(function (assets) {
          assets.forEach(function (asset) {
            asset.active = false;
            var assetDTO = {};
            assetDTO.id = asset.id;
            assetDTO.active = asset.active;
            assetDTO.bidGroupId = null;
            AssetService.updateAsset(assetDTO);
          });
        });
        notifyResults("inactive");
      });
      selectedCompany.tools = false;
    };

    //DELETE COMPANY
    //-------------------------------------------------------
    vm.deleteCompany = function (selectedCompany) {
      SweetAlert.swal({
        title: $filter('translate')('COMPANIES.ARE_YOU_SURE'),
        text: $filter('translate')('COMPANIES.YOU_ARE_ABOUT_TO_DELETE') + selectedCompany.name,
        showCancelButton: true,
        cancelButtonText: $filter('translate')('COMPANIES.CANCEL'),
        confirmButtonColor: '#2c3d4e',
        confirmButtonText: $filter('translate')('COMPANIES.YES_DELETE'),
        closeOnConfirm: true,
        closeOnCancel: true,
        allowEscapeKey: false
      }, function (isConfirm) {
        if (isConfirm) {
          CompanyService.deleteCompany(selectedCompany.id).then(function () {
            notifyResults("delete");
            vm.companies.splice(vm.companies.indexOf(selectedCompany), 1);
          });
        }
      });
    };

    //NOTIFY ACTIONS
    //-------------------------------------------------------
    function notifyResults(action) {
      var message = "";

      if (action == "active") {
        message = $filter('translate')('COMPANIES.COMPANY_ACTIVATED');
      } else if (action == "inactive") {
        message = $filter('translate')('COMPANIES.COMPANY_INACTIVATED');
      } else {
        message = $filter('translate')('COMPANIES.COMPANY_DELETED');
      }

      notify({
        message: message,
        duration: 4000,
        templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
        classes: 'alert-info',
        position: 'center'
      });
    }

    //SHOW TOOLS
    //-------------------------------------------------------
    vm.showTools = function (selectedCompany) {
      if (selectedCompany.tools) {
        selectedCompany.tools = false;
      } else {
        vm.companies.forEach(function (company) {
          company.tools = false;
        });
        selectedCompany.tools = true;
      }
    };

    function scrollLoader(load) {
      ArrayHelper.searchScroll();
      if (load) {
        LoaderHelper.close();
      } else {
        $('.paginator-loader').removeClass('sk-loading');
      }
    }

    //LOAD COMPANIES
    //-------------------------------------------------------
    function loadCompanies(load) {
      if (load) {
        LoaderHelper.open();
      } else {
        $('.paginator-loader').addClass('sk-loading');
      }
      var activeOnly = !SessionManager.isInRole('Admin');
      var promise;
      switch (companyType) {
        case 'clients':
          promise = CompanyService.getClientCompaniesPage(true, activeOnly, vm.currentPage - 1, vm.perPage, vm.searchQuery, 'Name', 'Ascending');
          break;
        case 'appraisers':
          promise = CompanyService.getAppraisalCompaniesPage(true, activeOnly, vm.currentPage - 1, vm.perPage, vm.searchQuery, 'Name', 'Ascending');
          break;
        case 'auditors':
          promise = CompanyService.getAuditorCompaniesPage(true, activeOnly, vm.currentPage - 1, vm.perPage, vm.searchQuery, 'Name', 'Ascending');
          break;
        case 'reviewers':
        default:
          promise = CompanyService.getReviewerCompaniesPage(true, activeOnly, vm.currentPage - 1, vm.perPage, vm.searchQuery, 'Name', 'Ascending');
          break;
      }
      promise.then(function (data) {
        vm.companies = data.companies;
        vm.companiesCount = data.pageInfo.count;
        scrollLoader(load);
      });
    }
  }
})();

(function(){
  'use strict';

  angular
  .module('nvc')
  .controller('CompanyLateralController', CompanyLateralController);

  function CompanyLateralController($scope, company){
    $scope.company = company;
  }

})();
(function () {
  'use strict';

  angular
  .module('nvc')
  .config(routeConfig);

  function routeConfig($stateProvider) {
    $stateProvider.state('app.manage.clients', {
      url: '/asset-management-firms',
      views: {
        '@app': {
          templateUrl: 'app/states/manage/companies/companies.html',
          controller: 'CompaniesController',
          controllerAs: 'companies'
        }
      },
      data: {
        pageTitle: 'Asset Management Firms',
        viewClass: 'companies',
        roles: ['Admin', 'Audit', 'AssetManagement', 'AssetReview', 'AssetManagerReadOnly']
      },
      params: {
        type: 'clients'
      },
      resolve: {
        /** @ngInject */
        companies: function ($q, CompanyService, SessionManager) {
          if(SessionManager.isInRole('Admin')) {
            return CompanyService.getClientCompaniesPage(true, false, 0, 10, '', 'Name', 'Ascending');
          } else if (SessionManager.isInRole('AssetManagement')) {
            return CompanyService.getClientCompaniesPage(false, false, 0, 10, '', 'Name', 'Ascending');
          }
          return CompanyService.getClientCompaniesPage(true, true, 0, 10, '', 'Name', 'Ascending');
        }
      }
    });
  }

})();
(function () {
  'use strict';

  angular
  .module('nvc')
  .config(routeConfig);

  function routeConfig($stateProvider) {
    $stateProvider.state('app.manage.auditors', {
      url: '/audit-firms',
      views: {
        '@app': {
          templateUrl: 'app/states/manage/companies/companies.html',
          controller: 'CompaniesController',
          controllerAs: 'companies'
        }
      },
      data: {
        pageTitle: 'Audit Firm',
        viewClass: 'companies',
        roles: ['Admin', 'Audit', 'AssetReview', 'AssetManagement', 'AssetManagerReadOnly']
      },
      params: {
        type: 'auditors'
      },
      resolve: {
        /** @ngInject */
        companies: function ($q, CompanyService, SessionManager) {
          if(SessionManager.isInRole('Admin')) {
            return CompanyService.getAuditorCompaniesPage(true, false, 0, 10, '', 'Name', 'Ascending');
          } else if (SessionManager.isInRole('Audit')) {
            return CompanyService.getAuditorCompaniesPage(false, false, 0, 10, '', 'Name', 'Ascending');
          }
          return CompanyService.getAuditorCompaniesPage(true, true, 0, 10, '', 'Name', 'Ascending');
        }
      }
    });
  }

})();
(function () {
  'use strict';

  angular
  .module('nvc')
  .config(routeConfig);

  function routeConfig($stateProvider) {
    $stateProvider.state('app.manage.clients.addContact', {
      url: '/add-contact/:companyId',
      views: {
        '@app': {
          templateUrl: 'app/states/manage/add-contact/add-contact.html',
          controller: 'AddContactController',
          controllerAs: 'addContact'
        }
      },
      data: {
        pageTitle: 'Add Contact',
        viewClass: 'add-contact'
      },
      params: {
        company: null,
        companyId: null
      },
      resolve: {
        company: function ($q, $stateParams, CompanyService) {
          if (!$stateParams.companyId) {
            return $q.reject('invalid transition');
          }
          if ($stateParams.company && $stateParams.company.id == $stateParams.companyId) {
            return $q.resolve($stateParams.company);
          }
          return CompanyService.getCompany($stateParams.companyId);
        }
      }
    })

      .state('app.manage.reviewers.addContact', {
        url: '/add-contact/:companyId',
        views: {
          '@app': {
            templateUrl: 'app/states/manage/add-contact/add-contact.html',
            controller: 'AddContactController',
            controllerAs: 'addContact'
          }
        },
        data: {
          pageTitle: 'Add Contact',
          viewClass: 'add-contact'
        },
        params: {
          company: null,
          companyId: null
        },
        resolve: {
          company: function ($q, $stateParams, CompanyService) {
            if (!$stateParams.companyId) {
              return $q.reject('invalid transition');
            }
            if ($stateParams.company && $stateParams.company.id == $stateParams.companyId) {
              return $q.resolve($stateParams.company);
            }
            return CompanyService.getCompany($stateParams.companyId);
          }
        }
      })

    .state('app.manage.appraisers.addContact', {
      url: '/add-contact/:companyId',
      views: {
        '@app': {
          templateUrl: 'app/states/manage/add-contact/add-contact.html',
          controller: 'AddContactController',
          controllerAs: 'addContact'
        }
      },
      data: {
        pageTitle: 'Add Contact',
        viewClass: 'add-contact'
      },
      params: {
        company: null,
        companyId: null
      },
      resolve: {
        company: function ($q, $stateParams, CompanyService) {
          if (!$stateParams.companyId) {
            return $q.reject('invalid transition');
          }
          if ($stateParams.company && $stateParams.company.id == $stateParams.companyId) {
            return $q.resolve($stateParams.company);
          }
          return CompanyService.getCompany($stateParams.companyId);
        }
      }
    })

      .state('app.manage.auditors.addContact', {
        url: '/add-contact/:companyId',
        views: {
          '@app': {
            templateUrl: 'app/states/manage/add-contact/add-contact.html',
            controller: 'AddContactController',
            controllerAs: 'addContact'
          }
        },
        data: {
          pageTitle: 'Add Contact',
          viewClass: 'add-contact'
        },
        params: {
          company: null,
          companyId: null
        },
        resolve: {
          company: function ($q, $stateParams, CompanyService) {
            if (!$stateParams.companyId) {
              return $q.reject('invalid transition');
            }
            if ($stateParams.company && $stateParams.company.id == $stateParams.companyId) {
              return $q.resolve($stateParams.company);
            }
            return CompanyService.getCompany($stateParams.companyId);
          }
        }
      });
  }

})();

(function () {
  'use strict';

  angular
  .module('nvc')
  .controller('AddContactController', AddContactController);

  /** @ngInject */
  function AddContactController($filter, $state, LoaderHelper, notify, ContactService, company) {

    var vm = this;
    vm.company = company;
    //Breadcrums
    //-------------------------------------
    vm.title = $filter('translate')('ADD_CONTACT.MAIN_TITLE') + ' ' + company.name;
    vm.breadcrumbs = [
      {
        label: $filter('translate')('COMMONS.MANAGE'),
        value: 'app.manage.clients'
      },
      getBreadcrum(company.type),
      {
        label: $filter('translate')('COMMONS.ADD_CONTACT'),
        value: 'app.manage.clients.addContact'
      }
    ];

    //Form
    //-------------------------------------
    vm.rolesArray = [
      {value: '', name: $filter('translate')('ADD_CONTACT.SELECT_ROLE')},
      {value: 'Admin', name: $filter('translate')('ADD_CONTACT.ADMIN')},
      {value: 'User', name: $filter('translate')('ADD_CONTACT.USER')},
      {value: 'Read Only', name: $filter('translate')('ADD_CONTACT.READ_ONLY')}
    ];

    vm.contact = {};

    vm.createContact = function () {
      vm.contact.companyId = company.id;
      LoaderHelper.open();
      ContactService.createContact(vm.contact).then(function () {
        notify({
          message: $filter('translate')('COMMONS.NEW_CONTACT_CREATED'),
          duration: 4000,
          templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
          classes: 'alert-info',
          position: 'center'
        });
        $state.go(getPreviousState(company.type), {}, { reload: true });
      }, function () {
        LoaderHelper.close();
        vm.addNewContact.$submitted = false;
      });
    };

    function getPreviousState(type){
      switch (type){
        case 'AssetManagement':
          return 'app.manage.clients';
        case 'AssetReview':
          return 'app.manage.reviewers';
        case 'AssetAppraisal':
          return 'app.manage.appraisers';
        case 'Audit':
          return 'app.manage.auditors';
        default :
          return 'app.valuations';
      }
    }

    function getBreadcrum(type) {
      switch (type){
        case 'AssetAppraisal':
          return {label: $filter('translate')('COMPANIES.MAIN_TITLE_APPRAISAL_FIRMS'), value: 'app.manage.appraisers' };
        case 'AssetReview':
          return {label: $filter('translate')('COMPANIES.MAIN_TITLE_REVIEWERS_FIRMS'), value: 'app.manage.reviewers' };
        case 'Audit':
          return {label: $filter('translate')('COMPANIES.MAIN_TITLE_AUDIT_FIRMS'), value: 'app.manage.auditors' };
        default :
          return {label: $filter('translate')('COMPANIES.MAIN_TITLE_ASSET_MANAGEMENT_FIRMS') , value: 'app.manage.clients' };
      }
    }

  }

})();

(function () {
  'use strict';

  angular
  .module('nvc')
  .config(routeConfig);

  function routeConfig($stateProvider) {
    $stateProvider.state('app.manage.appraisers', {
      url: '/appraisers',
      views: {
        '@app': {
          templateUrl: 'app/states/manage/companies/companies.html',
          controller: 'CompaniesController',
          controllerAs: 'companies'
        }
      },
      data: {
        pageTitle: 'Appraisers',
        viewClass: 'companies',
        roles: ['Admin', 'Audit', 'AssetManagement', 'AssetAppraisal', 'AssetReview']
      },
      params: {
        type: 'appraisers'
      },
      resolve: {
        /** @ngInject */
        companies: function (CompanyService, SessionManager) {
          if(SessionManager.isInRole('Admin')) {
            return CompanyService.getAppraisalCompaniesPage(true, false, 0, 10, '', 'Name', 'Ascending');
          } else if (SessionManager.isInRole('AssetAppraisal')) {
            return CompanyService.getAppraisalCompaniesPage(false, false, 0, 10, '', 'Name', 'Ascending');
          }
          return CompanyService.getAppraisalCompaniesPage(true, true, 0, 10, '', 'Name', 'Ascending');
        }
      }
    });
  }

})();

(function () {
  'use strict';

  angular
  .module('nvc')
  .config(routeConfig);
  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider.state('app.bidEngagement.engagementLetters', {
      url: '/engagement-letters',
      views: {
        '@app': {
          templateUrl: 'app/states/bid-engagement/engagement-letters/admin-engagement-letters.html',
          controller: 'AdminEngagementLettersController',
          controllerAs: 'adminEngagementLettersCtrl'
        }
      },
      data: {
        pageTitle: 'Engagement Letter Repository',
        roles: ['Admin'],
        viewClass: 'engagement-letters'
      },
      resolve: {
        /** @ngInject */
        propertyTypes: function (StaticDataService) {
          return StaticDataService.getPropertyTypes();
        },
        /** @ngInject */
        companies: function (CompanyService) {
          return CompanyService.getClientCompanies(true);
        },
        /** @ngInject */
        appraisers: function (UserService) {
          return UserService.getUsersByType('Appraiser');
        },
        /** @ngInject */
        admins: function (UserService) {
          return UserService.getUsersByType('Administrator').then(function (admins) {
            return admins.reduce(function (map, obj) {
              map[obj.user.id] = obj;
              return map;
            }, {});
          });
        }
      }
    });
  }

})();
(function () {
  'use strict';

  angular
  .module('nvc')
  .controller('AdminEngagementLettersController', AdminEngagementLettersController);

  /** @ngInject */
  function AdminEngagementLettersController($scope, $q, $window, $filter, BidRequestService, AssetService, UserService,
                                            CompanySelectorFactory, propertyTypes, companies, appraisers, admins,
                                            ArrayHelper, UtcDateConverter) {

    var vm = this,
    selectedCompanyId,
    bidRequests = {};
    vm.appraisers = appraisers;
    appraisers = appraisers.reduce(function (map, obj) {
      map[obj.user.id] = obj;
      return map;
    }, {});
    vm.searchQuery = '';
    vm.letters = [];
    vm.showFilters = true;
    vm.allPropertyTypesSelected = false;
    vm.searchQueryPropertyType = '';
    vm.propertyTypes = propertyTypes.items;
    vm.selectedPropertyTypes = [];
    vm.selectedAppraisers = [];
    vm.lettersSort = [
      {
        sort: 'fileName',
        tag: 'fileName',
        selected: true,
        flag: true
      }
    ];
    vm.lettersSelectedSort = vm.lettersSort[0];

    //BREADCRUMS
    //------------------------------------------
    vm.title = $filter('translate')('ENGAGEMENT_LETTERS.MAIN_TITLE');
    vm.breadcrumbs = [
      {
        label: $filter('translate')('COMMONS.BID_ENGAGEMENT'),
        value: 'app.bidEngagement.bidEngagementList'
      },
      {
        label: $filter('translate')('ENGAGEMENT_LETTERS.MAIN_TITLE'),
        value: 'app.bidEngagement.engagementLetters'
      }
    ];

    //SORTING
    //------------------------------------------
    vm.sorting = function (sort, target) {
      ArrayHelper.sort(sort, target, vm.lettersSort, vm);
    };

    //SEARCH FUNCTION
    //------------------------------------------
    vm.searchLetters = function () {
      ArrayHelper.searchScroll();
    };

    CompanySelectorFactory.showCompanies(companies);
    var companyListener = $scope.$on('companyChanged', function (event, selectedCompany) {
      selectedCompanyId = selectedCompany.id;

      return BidRequestService.listByCompanyId(selectedCompanyId).then(function (bidRequestsResponses) {
        var promises = [],
        formattedBidRequests = {};
        bidRequestsResponses.forEach(function (bidRequest) {
          formattedBidRequests[bidRequest.id] = bidRequest;
          AssetService.listByBidRequestId(bidRequest.id).then(function (assets) {
            bidRequest.assets = assets;
          });
        });
        return $q.all(promises).then(function () {
          bidRequests = formattedBidRequests;
          if (vm.searched) {
            vm.search();
          }
        });
      });
    });

    vm.search = function () {
      var userIds = [],
      types = [],
      time;
      if (vm.selectedAppraisers && vm.selectedAppraisers.length !== 0) {
        userIds = vm.selectedAppraisers.map(function (item) {
          return item.user.id;
        });
      }
      if (!vm.allPropertyTypesSelected) {
        vm.propertyTypes.forEach(function (type) {
          if (type.selected) {
            types.push(type.type);
          }
        });
      }
      if (vm.filterDate) {
        time = UtcDateConverter.setDateToUTC(vm.filterDate);
      }
      BidRequestService.listBidRequestLettersByIds(userIds, types, time, selectedCompanyId).then(function (letters) {
        var missingUserPromises = [];
        letters.forEach(function (letter) {
          letter.createdOn = UtcDateConverter.getDateFromUTC(letter.createdOn);
          if (appraisers[letter.userId]) {
            letter.appraiser = appraisers[letter.userId];
            if (appraisers[letter.ownerId]) {
              letter.owner = appraisers[letter.ownerId];
              letter.bidRequest = bidRequests[letter.bidRequestId];
            } else if (admins[letter.ownerId]) {
              letter.owner = admins[letter.ownerId];
              letter.bidRequest = bidRequests[letter.bidRequestId];
            } else {
              missingUserPromises.push(UserService.getUser(letter.ownerId).then(function (user) {
                var formattedUser = {user: user, role: user.userCompanyRoles[0]};
                if(user.userCompanyRoles[0] === 'Administrator') {
                  admins[user.id] = formattedUser;
                } else {
                  appraisers[user.id] = formattedUser;
                }
                letter.owner = formattedUser;
                letter.bidRequest = bidRequests[letter.bidRequestId];
              }));
            }
          } else {
            missingUserPromises.push(UserService.getUser(letter.userId).then(function (appraiser) {
              appraisers[appraiser.id] = {user: appraiser, role: 'Appraiser'};
              letter.appraiser = appraisers[letter.userId];
              if (letter.userId === letter.ownerId && appraisers[letter.ownerId]) {
                letter.owner = appraisers[letter.ownerId];
              } else if (admins[letter.ownerId]) {
                  letter.owner = admins[letter.ownerId];
              } else {
                return UserService.getUser(letter.ownerId).then(function (user) {
                  var formattedUser = {user: user, role: user.userCompanyRoles[0]};
                  if(user.userCompanyRoles[0] === 'Administrator') {
                    admins[user.id] = formattedUser;
                  } else {
                    appraisers[user.id] = formattedUser;
                  }
                  letter.owner = formattedUser;
                  letter.bidRequest = bidRequests[letter.bidRequestId];
                });
              }
            }));
          }
        });
        if (missingUserPromises.length) {
          $q.all(missingUserPromises).then(function () {
            vm.letters = letters;
          });
        } else {
          vm.letters = letters;
        }
      });
      vm.showFilters = false;
      vm.searched = true;
    };

    vm.arrayToFormattedString = function (array, separator) {
      if (array) {
        return array.toString().replace(/\,/g, separator);
      } else {
        return '';
      }
    };

    vm.userArrayToFormattedString = function (array, separator) {
      if (array) {
        var namesArray = array.map(function (item) {
          return item.user.name;
        });
        return namesArray.toString().replace(/\,/g, separator);
      } else {
        return '';
      }
    };

    vm.downloadLetter = function (letter) {
      BidRequestService.downloadEngagementLetter(letter.id).then(function (downloadData) {
        $window.open(downloadData, '_blank');
      });
    };

    vm.clearFilters = function () {
      vm.propertyTypes.forEach(function (propertyType) {
        propertyType.selected = false;
      });
      delete vm.filterDate;
      vm.allPropertyTypesSelected = false;
      var selectedAppraisers = angular.copy(vm.selectedAppraisers);
      selectedAppraisers.forEach(function (selectedAppraiser) {
        vm.deselectAppraiser(selectedAppraiser);
      });
    };

    //DATEPICKER
    //-------------------------------------------
    vm.filterPicker = {
      opened: false
    };

    vm.openFilterPicker = function () {
      vm.filterPicker.opened = true;
    };

    vm.filterDateOptions = {
      startingDay: 1,
      showWeeks: false,
      minMode: 'month'
    };

    vm.filterModelOptions = {
      debounce: {
        default: 500,
        blur: 250
      },
      getterSetter: true
    };

    vm.deselectAppraiser = function (selectedAppraiser) {
      vm.appraisers.push(selectedAppraiser);
      for (var i = 0; i < vm.selectedAppraisers.length; i++) {
        if (selectedAppraiser.id == vm.selectedAppraisers[i].id) {
          vm.selectedAppraisers.splice(i, 1);
          break;
        }
      }
    };

    var watchers = [];

    //PROPERTY TYPE SELECTOR WATCHERS
    //------------------------------------------
    watchers.push($scope.$watch('adminEngagementLettersCtrl.propertyTypes', function () {
      for (var i = 0; i < vm.propertyTypes.length; i++) {
        if (vm.propertyTypes[i].selected) {
          vm.selectedPropertyTypes = [];
          vm.allPropertyTypesSelected = false;
          break;
        }
      }
      for (i = 0; i < vm.propertyTypes.length; i++) {
        if (vm.propertyTypes[i].selected) {
          vm.selectedPropertyTypes.push(vm.propertyTypes[i].name);
        } else if (!vm.allPropertyTypesSelected && vm.selectedPropertyTypes.indexOf(vm.propertyTypes[i].name) !== -1) {
          vm.selectedPropertyTypes.splice(vm.selectedPropertyTypes.indexOf(vm.propertyTypes[i].name), 1);
        }
      }
    }, true));

    watchers.push($scope.$watch('adminEngagementLettersCtrl.allPropertyTypesSelected', function () {

      if (vm.allPropertyTypesSelected) {
        vm.selectedPropertyTypes = [];
        vm.propertyTypes.forEach(function (group) {
          group.selected = false;
          vm.selectedPropertyTypes.push(group.name);
        });
      } else {
        vm.selectedPropertyTypes = [];
        for (var i = 0; i < vm.propertyTypes.length; i++) {
          if (vm.propertyTypes[i].selected) {
            vm.selectedPropertyTypes.push(vm.propertyTypes[i].name);
          }
        }
      }
    }, true));

    //APPRAISER SELECTOR WATCHER
    //------------------------------------------
    watchers.push($scope.$watch('adminEngagementLettersCtrl.appraiser', function () {
      if (vm.appraiser) {
        vm.selectedAppraisers.push(vm.appraiser);
        for (var i = 0; i < vm.appraisers.length; i++) {
          if (vm.appraiser.id === vm.appraisers[i].id) {
            vm.appraisers.splice(i, 1);
            break;
          }
        }
        vm.appraiser = undefined;
      }
    }));

    $scope.$on('$destroy', function () {
      watchers.forEach(function (watcher) {
        watcher();
      });
      companyListener();
    });
  }

})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .config(routeConfig);

  function routeConfig($stateProvider) {
    $stateProvider.state('app.bidEngagement.bidSummary', {
      url: '/bid-summary/:bidId',
      views: {
        '@app': {
          templateUrl: 'app/states/bid-engagement/bid-summary/bid-summary.html',
          controller: 'BidSummaryController',
          controllerAs: 'bidSummaryCtrl'
        }
      },
      data: {
        pageTitle: 'Bid Summary',
        viewClass: 'bid-summary',
        roles: ['Admin']
      },
      params: {
        bidId: ''
      },
      resolve: {
        company: function (CompanyService, CompanySelectorFactory, bid) {
          CompanyService.getCompany(bid.companyId).then(function (company) {
            CompanySelectorFactory.showCompanies([company], true);
          });
          return true;
        },
        /** @ngInject */
        bid: function ($q, $filter, $stateParams, BidRequestService, BidResponseService, AssetService, UserService) {
          if (!$stateParams.bidId) {
            return $q.reject({
              error: 'invalidTransition',
              fallback: 'app.bidEngagement.bidEngagementList'
            });
          }
          return BidRequestService.get($stateParams.bidId).then(function (bid) {
            var assetsArray = [],
              appraisersArray = [];
            bid.assets = {};
            bid.appraisers = {};
            bid.responses = 0;
            bid.awarded = 0;
            bid.company = [];

            return UserService.getUsersByType('Appraiser', true).then(function (appraisers) {
              appraisers.forEach(function (appraiser) {
                appraiser.responseBid = false;
              });

              return AssetService.getAssetsByCompany(bid.companyId).then(function (assets) {
                assets.forEach(function (asset) {
                  asset.awarded = false;
                  asset.bidResponses = [];
                });

                return BidResponseService.listByBidRequestId(bid.id).then(function (bidResponses) {
                  for (var i = 0; i < assets.length; i++) {
                    var asset = angular.copy(assets[i]);
                    bidResponses.forEach(function (response) {
                      if (response.assetId == asset.id) {
                        response.totalFee = 0;
                        response.totalFeeDiscount = 0;
                        var quarterly = response.quarterly ? response.quarterly : 0;
                        var quarterlyOld = response.quarterlyOld ? response.quarterlyOld : 0;
                        var quarterlyDiscount = response.quarterlyDiscount ? response.quarterlyDiscount : 0;
                        switch (asset.valuationFrequency) {
                          case 'Quarterly':
                          default:
                            if(response.isValueSynced || response.isValueSynced == undefined || response.isValueSynced == null) {
                              response.totalFee = response.yearOne + (2 * response.yearsTwoThree) + (9 * quarterly);
                            } else {
                              response.totalFee = response.yearOneOld + (2 * response.yearsTwoThreeOld) + (9 * quarterlyOld);
                            }
                            response.totalFeeDiscount = response.yearOneDiscount + (2 * response.yearsTwoThreeDiscount) + (9 * quarterlyDiscount);
                            break;
                          case 'SemiAnnually':
                            if(response.isValueSynced || response.isValueSynced == undefined || response.isValueSynced == null) {
                              response.totalFee = response.yearOne + (2 * response.yearsTwoThree) + (3 * quarterly);
                            }else {
                              response.totalFee = response.yearOneOld + (2 * response.yearsTwoThreeOld) + (3 * quarterlyOld);
                            }
                            response.totalFeeDiscount = response.yearOneDiscount + (2 * response.yearsTwoThreeDiscount) + (3 * quarterlyDiscount);
                            break;
                          case 'Annually':
                            if(response.isValueSynced || response.isValueSynced == undefined || response.isValueSynced == null) {
                              response.totalFee = response.yearOne + (2 * response.yearsTwoThree);
                            }else {
                              response.totalFee = response.yearOneOld + (2 * response.yearsTwoThreeOld);
                            }
                            response.totalFeeDiscount = response.yearOneDiscount + (2 * response.yearsTwoThreeDiscount);
                            break;
                        }
                        for (var j = 0; j < appraisers.length; j++) {
                          if (response.userId == appraisers[j].user.id) {
                            if (response.respondedOn && response.isSubmittedToAdmin && (response.yearOne || response.yearOne == 0)) {
                              appraisers[j].responseBid = true;
                              asset.bidResponses.push(response);
                            }
                            var appraiser = angular.copy(appraisers[j]);
                            response.appraiser = appraiser;
                            bid.appraisers[appraiser.id] = appraiser;
                          }
                        }
                        bid.assets[asset.id] = asset;
                      }
                    });
                  }

                  Object.keys(bid.assets).forEach(function (key) {
                    assetsArray.push(bid.assets[key]);
                  });
                  bid.assets = assetsArray;
                  bid.assets = $filter('orderBy')(bid.assets, 'name');
                  bid.assets.forEach(function (asset) {
                    asset.bidResponses.forEach(function (response) {
                      if (response.isAwarded) {
                        asset.awarded = true;
                      }
                    });
                    if (asset.awarded) {
                      bid.awarded++;
                    }
                  });

                  Object.keys(bid.appraisers).forEach(function (key) {
                    appraisersArray.push(bid.appraisers[key]);
                  });
                  bid.appraisers = appraisersArray;
                  bid.appraisers.forEach(function (appraiser) {
                    if (appraiser.responseBid) {
                      bid.responses++;
                    }
                  });
                  return bid;
                });
              });
            });
          });
        }
      }
    });
  }

})();
(function () {
  'use strict';

  angular
    .module('nvc')
    .controller('BidSummaryController', BidSummaryController);

  /** @ngInject */
  function BidSummaryController($filter, $q, $state, bid, BidResponseService, LoaderHelper, notify, SweetAlert, CSVService, PDFGenerator) {
    var vm = this;

    vm.bid = bid;
    // Only hide quarterly column when all assets have frequency other than Quarterly
    vm.showQuarterly = true;
    if (vm.bid.assets) {
      var quarterlyAssets = vm.bid.assets.filter(function (asset) {
        return asset.valuationFrequency !== 'Annually';
      });
      if (!quarterlyAssets.length) {
        vm.showQuarterly = false;
      }
    }
    vm.addBidNote = '';
    vm.searchQuery = '';

    vm.assetSort = {
      tag: 'name',
      selected: true,
      flag: true
    };
    vm.summarySort = [
      {
        sort: 'yearOne',
        tag: 'yearOne',
        selected: false,
        flag: false
      },
      {
        sort: 'yearOneDiscount',
        tag: 'yearOneDiscount',
        selected: false,
        flag: false
      },
      {
        sort: 'yearsTwoThree',
        tag: 'yearsTwoThree',
        selected: false,
        flag: false
      },
      {
        sort: 'yearsTwoThreeDiscount',
        tag: 'yearsTwoThreeDiscount',
        selected: false,
        flag: false
      },
      {
        sort: 'quarterly',
        tag: 'quarterly',
        selected: false,
        flag: false
      },
      {
        sort: 'quarterlyDiscount',
        tag: 'quarterlyDiscount',
        selected: false,
        flag: false
      },
      {
        sort: 'totalFee',
        tag: 'totalFee',
        selected: false,
        flag: false
      },
      {
        sort: 'totalFeeDiscount',
        tag: 'totalFeeDiscount',
        selected: false,
        flag: false
      }
    ];
    vm.summarySelectedSort = {};

    //Export/Download
    //-------------------------------------------------------
    vm.downloadLoading = false;

    vm.downloadCsv = function () {
      vm.downloadLoading = true;
      CSVService.generateBidSummaryCsv(vm.bid)
        .then(function () {
          vm.downloadLoading = false;
        })
        .catch(function(err) {
          vm.downloadLoading = false;
        });
    };

    vm.downloadPdf = function () {
      vm.downloadLoading = true;
      PDFGenerator.generateBidSummaryPdf(vm.bid)
        .then(function (values) {
          vm.downloadLoading = false;
          values.pdf.download('bid-summary-' + values.bid.name + '.pdf');
        })
        .catch(function (error) {
          vm.downloadLoading = false;
          notify({
            message: $filter('translate')('COMMONS.EXPORT_FAILURE'),
            duration: 5000,
            templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
            classes: 'alert-danger',
            position: 'center'
          });
        });
    };

    //BREADCRUMS
    //-------------------------------------------------------
    vm.title = $filter('translate')('BID_SUMMARY.TITLE');
    vm.breadcrumbs = [
      {
        label: $filter('translate')('COMMONS.BID_ENGAGEMENT'),
        value: 'app.bidEngagement.bidEngagementList'
      },
      {
        label: $filter('translate')('BID_SUMMARY.TITLE'),
        value: 'app.bidEngagement.bidSummary'
      }
    ];

    //SORTING
    //------------------------------------------
    vm.assetsSort = function () {
      vm.bid.assets = $filter('orderBy')(vm.bid.assets, vm.assetSort.tag, vm.assetSort.flag);
      vm.assetSort.flag = !vm.assetSort.flag;
      vm.assetSort.selected = true;
      vm.summarySort.forEach(function (summary) {
        summary.selected = false;
        summary.flag = false;
      });
    };

    vm.sorting = function (sort, target) {
      sort.sort = sort.flag ? '-' + sort.tag : sort.tag;
      sort.flag = !sort.flag;
      vm[target] = sort;
      vm.assetSort.selected = false;
      vm.assetSort.flag = false;
      vm.summarySort.forEach(function (summary) {
        summary.selected = summary.sort == sort.sort;
        if (!summary.selected) {
          summary.flag = false;
        }
      });
    };

    //SEARCH
    //------------------------------------------
    vm.search = function (asset) {
      if ((asset.name).toLowerCase().indexOf(vm.searchQuery.toLowerCase()) != -1) {
        return true;
      }
      if ($filter('filter')(asset.bidResponses, vm.searchQuery).length > 0) {
        return true;
      }
      return false;
    };

    //FEE AND DISCOUNT SINGLE CHECKBOX
    //-------------------------------------------------------
    vm.selectFee = function (asset, bidResponse) {
      asset.bidResponses.forEach(function (response) {
        if (bidResponse.id != response.id) {
          response.isSelectedDiscount = false;
          response.isSelectedFee = false;
        }
      });
      if (bidResponse.isSelectedDiscount) {
        bidResponse.isSelectedDiscount = false;
      }
    };

    vm.selectDiscount = function (asset, bidResponse) {
      asset.bidResponses.forEach(function (response) {
        if (bidResponse.id != response.id) {
          response.isSelectedDiscount = false;
          response.isSelectedFee = false;
        }
      });
      if (bidResponse.isSelectedFee) {
        bidResponse.isSelectedFee = false;
      }
    };

    //OPEN APPRAISER NOTES
    //-------------------------------------------------------
    vm.openAppNotes = function (bidResponse) {
      for (var i = 0; i < vm.bid.assets.length; i++) {
        if (vm.bid.assets[i].bidResponses) {
          for (var j = 0; j < vm.bid.assets[i].bidResponses.length; j++) {
            vm.bid.assets[i].bidResponses[j].openedAppNotes = false;
            vm.bid.assets[i].bidResponses[j].openedAdminNotes = false;
            vm.bid.assets[i].bidResponses[j].openedAddNotes = false;
          }
        }
      }
      bidResponse.openedAdminNotes = false;
      bidResponse.openedAddNotes = false;
      bidResponse.openedAppNotes = true;
    };

    //CLOSE APPRAISER NOTES
    //-------------------------------------------------------
    vm.closeAppNotes = function (event, bidResponse) {
      event.stopPropagation();
      bidResponse.openedAppNotes = false;
    };

    //OPEN ADMIN NOTES
    //-------------------------------------------------------
    vm.openAdminNotes = function (bidResponse) {
      for (var i = 0; i < vm.bid.assets.length; i++) {
        if (vm.bid.assets[i].bidResponses) {
          for (var j = 0; j < vm.bid.assets[i].bidResponses.length; j++) {
            vm.bid.assets[i].bidResponses[j].openedAppNotes = false;
            vm.bid.assets[i].bidResponses[j].openedAdminNotes = false;
            vm.bid.assets[i].bidResponses[j].openedAddNotes = false;
          }
        }
      }
      bidResponse.openedAppNotes = false;
      bidResponse.openedAddNotes = false;
      bidResponse.openedAdminNotes = true;
    };

    //CLOSE ADMIN NOTES
    //-------------------------------------------------------
    vm.closeAdminNotes = function (event, bidResponse) {
      event.stopPropagation();
      bidResponse.openedAdminNotes = false;
    };

    //OPEN ADD NOTES
    //-------------------------------------------------------
    vm.openAddNotes = function (bidResponse) {
      for (var i = 0; i < vm.bid.assets.length; i++) {
        if (vm.bid.assets[i].bidResponses) {
          for (var j = 0; j < vm.bid.assets[i].bidResponses.length; j++) {
            vm.bid.assets[i].bidResponses[j].openedAppNotes = false;
            vm.bid.assets[i].bidResponses[j].openedAdminNotes = false;
            vm.bid.assets[i].bidResponses[j].openedAddNotes = false;
          }
        }
      }
      bidResponse.openedAdminNotes = false;
      bidResponse.openedAppNotes = false;
      bidResponse.openedAddNotes = true;
    };

    //CLOSE ADD NOTES
    //-------------------------------------------------------
    vm.closeAddNotes = function (event, bidResponse) {
      event.stopPropagation();
      bidResponse.openedAddNotes = false;
    };

    //SAVE ADD NOTES
    //-------------------------------------------------------
    vm.saveNotes = function (bidResponse, assetId) {
      var bidResponseDTO = {};
      bidResponseDTO.id = bidResponse.id;
      bidResponseDTO.bidNotesAdmin = angular.copy(vm.addBidNote);
      BidResponseService.updateBidResponse(bidResponseDTO).then(function () {
        notify({
          message: $filter('translate')('BID_SUMMARY.NOTE_ADDED'),
          duration: 4000,
          templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
          classes: 'alert-info',
          position: 'center'
        });
        for (var i = 0; i < vm.bid.assets.length; i++) {
          var asset = vm.bid.assets[i];
          if (asset.id == assetId) {
            for (var j = 0; j < asset.bidResponses.length; j++) {
              if (asset.bidResponses[j].id == bidResponse.id) {
                asset.bidResponses[j].openedAddNotes = false;
                asset.bidResponses[j].bidNotesAdmin = vm.addBidNote;
                vm.addBidNote = '';
                break;
              }
            }
            break;
          }
        }
      });
    };

    //SAVE PROGRESS
    //-------------------------------------------------------
    vm.saveProgress = function () {
      var promises = [];
      vm.bid.assets.forEach(function (asset) {
        asset.bidResponses.forEach(function (bidResponse) {
          var bidResponseDTO = {};
          bidResponseDTO.id = bidResponse.id;
          bidResponseDTO.isSelectedFee = bidResponse.isSelectedFee;
          bidResponseDTO.isSelectedDiscount = bidResponse.isSelectedDiscount;
          promises.push(BidResponseService.updateBidResponse(bidResponseDTO));
        });
      });
      $q.all(promises).then(function () {
        notify({
          message: $filter('translate')('BID_SUMMARY.SUMMARY_SAVED'),
          duration: 4000,
          templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
          classes: 'alert-info',
          position: 'center'
        });
      });
    };

    //SUBMIT BID SUMMARY
    //-------------------------------------------------------
    vm.submitBidSummary = function () {
      var promises = [],
        canSubmit = false;
      vm.bid.assets.forEach(function (asset) {
        asset.bidResponses.forEach(function (bidResponse) {
          var bidResponseDTO = {};
          bidResponseDTO.isSelectedFee = bidResponse.isSelectedFee;
          bidResponseDTO.isSelectedDiscount = bidResponse.isSelectedDiscount;
          bidResponseDTO.id = bidResponse.id;
          promises.push(BidResponseService.updateBidResponse(bidResponseDTO));
          if ((bidResponseDTO.isSelectedFee || bidResponseDTO.isSelectedDiscount) && !bidResponse.isAwarded) {
            canSubmit = true;
          }
        });
      });
      if (canSubmit) {
        LoaderHelper.open();
        $q.all(promises).then(function () {
          $state.go('app.bidEngagement.assignmentSummary', { bidId: vm.bid.id }, { reload: true });
        }, function () {
          LoaderHelper.close();
        });
      } else {
        SweetAlert.swal({
          title: $filter('translate')('BID_SUMMARY.SUMMARY_TITLE'),
          text: $filter('translate')('BID_SUMMARY.SUMMARY_NOT_SUBMITTED'),
          showCancelButton: false,
          confirmButtonColor: '#2c3d4e',
          confirmButtonText: $filter('translate')('DOCUMENTS_UPLOAD.OK_TAKE_ME_BACK'),
          closeOnConfirm: true
        });
      }
    };
  }

})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .controller('BidEngagementListLateralController', BidEngagementListLateralController);

  function BidEngagementListLateralController($scope, $rootScope, bid, $filter, SweetAlert, BidRequestService, notify) {
    $scope.bid = bid;
    $scope.onCancelRFP = function () {
      SweetAlert.swal({
        title: $filter('translate')('BID_ENGAGEMENT_LIST.ARE_YOU_SURE_CANCEL_RFP'),
        text: '',
        showCancelButton: true,
        cancelButtonText: $filter('translate')('BID_ENGAGEMENT_LIST.TAKE_ME_BACK'),
        confirmButtonColor: '#2c3d4e',
        confirmButtonText: $filter('translate')('BID_ENGAGEMENT_LIST.YES'),
        closeOnConfirm: true,
        closeOnCancel: true,
        allowEscapeKey: false
      }, function (isConfirm) {
        if (isConfirm) {
          BidRequestService.cancelBidRequest($scope.bid.id).then(function (res) {
            notify({
              message: 'RFP cancelled',
              duration: 4000,
              templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
              classes: 'alert-info',
              position: 'center'
            });
            $scope.bid.isCancelled = true;
            $rootScope.$emit('onCancelled', $scope.bid.id);
          });
        }
      })
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .config(routeConfig);

  function routeConfig($stateProvider) {
    $stateProvider.state('app.bidEngagement.bidEngagementList', {
      url: '/bid-engagement-list',
      views: {
        '@app': {
          templateUrl: 'app/states/bid-engagement/bid-engagement-list/bid-engagement-list.html',
          controller: 'BidEngagementListController',
          controllerAs: 'bidEngagementListCtrl'
        }
      },
      data: {
        pageTitle: 'Bid Engagement List',
        viewClass: 'bid-engagement-list',
        roles: ['Admin']
      },
      resolve: {
        /** @ngInject */
        companies: function ($q, CompanyService) {
          return CompanyService.getClientCompanies(true, true);
        },
        /** @ngInject */
        appraisers: function (UserService, CompanyService) {
          return UserService.getUsersByType('Appraiser', true).then(function (appraisers) {
            return CompanyService.getAppraisalCompanies(true, true).then(function(companies){
              appraisers.forEach(function(appraiser){
                for(var i = 0; i < companies.length; i++){
                  if(appraiser.companyId === companies[i].id) {
                    appraiser.companyName = companies[i].name;
                    break;
                  }
                }
                if(appraiser.user.assetTypeSpecialties){
                  appraiser.user.specialties = appraiser.user.assetTypeSpecialties.toString().replace(/([A-Z])/g, ' $1');
                }
                if(appraiser.user.workedOnStates){
                  appraiser.user.states = appraiser.user.workedOnStates.toString().replace(/\,/g, ', ');
                }
                appraiser.responseBid = false;
                appraiser.declineBid = false;
                appraiser.pendingBid = false;
              });
              return appraisers;
            });
          });
        }
      }
    });
  }

})();
(function () {
  'use strict';

  angular
    .module('nvc')
    .controller('BidEngagementListController', BidEngagementListController);

  /** @ngInject */
  function BidEngagementListController($scope, $q, $filter, LoaderHelper, ArrayHelper, BidRequestService,
                                       BidResponseService, AssetService, CompanySelectorFactory, companies, appraisers,
                                       CSVService, PDFGenerator, SessionManager, notify, UtcDateConverter,
                                       $rootScope) {
    var vm = this;
    vm.searchQuery = '';
    vm.bidList = [];
    vm.assets = [];
    vm.appraisers = appraisers;
    vm.bidSort = [
      {
        tag: 'Name',
        selected: true,
        flag: true,
        order: 'Ascending'
      },

      {
        tag: 'AssetsAwarded',
        selected: false,
        flag: false,
        order: 'Ascending'
      },
      {
        tag: 'Responses',
        selected: false,
        flag: false,
        order: 'Ascending'
      },
      {
        tag: 'DueDate',
        selected: false,
        flag: false,
        order: 'Ascending'
      }
    ];
    vm.bidSelectedSort = vm.bidSort[0];
    vm.perPage = 17;
    vm.maxPaginationSize = 5;

    vm.downloadLoading = false;

    vm.downloadCsv = function () {
      vm.downloadLoading = true;
      CSVService.generateBidEngagementListCsv(vm.assets, vm.appraisers, vm.selectedCompany, vm.bidsCount,
        vm.searchQuery, vm.bidSelectedSort.tag, vm.bidSelectedSort.order)
        .then(function () {
          vm.downloadLoading = false;
        })
        .catch(function () {
          vm.downloadLoading = false;
        });
    };

    vm.downloadPdf = function () {
      vm.downloadLoading = true;
      PDFGenerator.generateBidEngagementListPdf(vm.assets, vm.appraisers, vm.selectedCompany, vm.bidsCount,
        vm.searchQuery, vm.bidSelectedSort.tag, vm.bidSelectedSort.order)
        .then(function (pdf) {
          vm.downloadLoading = false;
          var currentUser = SessionManager.getUser();
          pdf.download('bid-engagement-list-' + currentUser.name + '.pdf');
        })
        .catch(function (error) {
          vm.downloadLoading = false;
          notify({
            message: $filter('translate')('COMMONS.EXPORT_FAILURE'),
            duration: 5000,
            templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
            classes: 'alert-danger',
            position: 'center'
          });
        });
    };

    //BREADCRUMS
    //-------------------------------------------------------
    vm.title = $filter('translate')('BID_ENGAGEMENT_LIST.TITLE');
    vm.breadcrumbs = [
      {
        label: $filter('translate')('COMMONS.BID_ENGAGEMENT'),
        value: 'app.bidEngagement.bidEngagementList'
      },
      {
        label: $filter('translate')('BID_ENGAGEMENT_LIST.TITLE'),
        value: 'app.bidEngagement.bidEngagementList'
      }
    ];

    //SEARCH FUNCTION
    //------------------------------------------
    vm.searchBids = function () {
      loadBids();
    };

    //SORTING
    //------------------------------------------
    vm.sorting = function (sort, target) {
      ArrayHelper.beSort(sort, target, vm.bidSort, vm);
      loadBids();
    };

    //GET BIDS BY COMPANY
    //------------------------------------------
    CompanySelectorFactory.showCompanies(companies);
    var companyListener = $scope.$on('companyChanged', function (event, selectedCompany) {
      CompanySelectorFactory.executeOnValidState('app.bidEngagement.bidEngagementList', function () {
        LoaderHelper.open();
        vm.selectedCompany = selectedCompany.id;
        vm.currentPage = 1;
        var promises = [AssetService.getAssetsByCompany(vm.selectedCompany),
        BidRequestService.listByCompanyIdPage(vm.selectedCompany, vm.currentPage - 1, vm.perPage, vm.searchQuery,
          vm.bidSelectedSort.tag, vm.bidSelectedSort.order)];
        $q.all(promises).then(function (responses) {
          var bidList = responses[1].bids;
          vm.bidsCount = responses[1].pageInfo.count;
          vm.currentPageStart = responses[1].pageInfo.currentStart;
          vm.currentPageEnd = responses[1].pageInfo.currentEnd;
          vm.assets = responses[0];
          vm.assets.forEach(function (asset) {
            asset.awarded = false;
          });
          vm.bidList = bidList;
          bidList.forEach(function (bid) {
            bid.dueDate = UtcDateConverter.getDateFromUTC(bid.dueDate);
            BidResponseService.listByBidRequestId(bid.id).then(function (bidResponseList) {
              var assetsArray = [],
                appraisersArray = [];
              bid.bidResponses = bidResponseList;
              bid.assets = {};
              bid.appraisers = {};
              bid.responses = 0;
              bid.declines = 0;
              bid.pending = 0;
              bid.awarded = 0;
              for (var i = 0; i < bid.bidResponses.length; i++) {
                for (var j = 0; j < vm.assets.length; j++) {
                  if (bid.bidResponses[i].assetId === vm.assets[j].id) {
                    var asset = angular.copy(vm.assets[j]);
                    bid.assets[asset.id] = asset;
                    break;
                  }
                }
                for (j = 0; j < vm.appraisers.length; j++) {
                  if (bid.bidResponses[i].userId === vm.appraisers[j].user.id) {
                    var appraiser = angular.copy(vm.appraisers[j]);
                    if (bid.bidResponses[i].respondedOn && bid.bidResponses[i].isSubmittedToAdmin) {
                      appraiser.responseBid = true;
                    }
                    if (bid.bidResponses[i].isDeclined) {
                      appraiser.declineBid = true;
                    }
                    if (!bid.appraisers[appraiser.id]) {
                      bid.appraisers[appraiser.id] = appraiser;
                    }
                    if (!bid.appraisers[appraiser.id].responseBid) {
                      bid.appraisers[appraiser.id].responseBid = appraiser.responseBid;
                    }
                    if (!bid.appraisers[appraiser.id].declineBid) {
                      bid.appraisers[appraiser.id].declineBid = appraiser.declineBid;
                    }
                    break;
                  }
                }
              }
              Object.keys(bid.assets).forEach(function (key) {
                assetsArray.push(bid.assets[key]);
              });
              bid.assets = assetsArray;
              bid.assets.forEach(function (asset) {
                bid.bidResponses.forEach(function (response) {
                  if (response.isAwarded && response.assetId === asset.id) {
                    asset.awarded = true;
                  }
                });
                if (asset.awarded) {
                  bid.awarded++;
                }
              });

              Object.keys(bid.appraisers).forEach(function (key) {
                appraisersArray.push(bid.appraisers[key]);
              });
              bid.appraisers = appraisersArray;
              bid.appraisers.forEach(function (appraiser) {
                if (appraiser.responseBid) {
                  bid.responses++;
                } else if (appraiser.declineBid) {
                  bid.declines++;
                } else {
                  bid.pending++;
                }
              });
              ArrayHelper.searchScroll();
              LoaderHelper.close();
            });
          });
        });
      });
      vm.showDetails = false;
    });

    //LATERAL BAR CONFIG
    //------------------------------------------
    vm.lateralBarConfig = {
      templateUrl: 'app/states/bid-engagement/bid-engagement-list/big-engagement-list-lateral-content.html',
      controller: 'BidEngagementListLateralController',
      icons: [
        {
          class: 'icon-ic-comment info',
          anchor: 'bid-info'
        },
        {
          class: 'icon-ic-asset-info info',
          anchor: 'bid-assets-list'
        }
      ]
    };

    //LATERAL BAR OPEN
    //------------------------------------------
    vm.getBidDetails = function (selectedBid) {
      vm.showDetails = true;
      vm.bidList.forEach(function (bid) {
        selectedBid.id === bid.id ? bid.displaying = true : bid.displaying = false;
      });

      vm.selectedBid = selectedBid;
      vm.lateralBarConfig.locals = {
        bid: vm.selectedBid
      };
    };

    //LATERAL BAR CLOSE
    //------------------------------------------
    vm.closeDetails = function (bid) {
      vm.showDetails = false;
      if (bid) {
        bid.displaying = false;
      }
      vm.selectedBid.displaying = false;
      vm.selectedBid = undefined;
    };

    $scope.$on('$destroy', function () {
      companyListener();
    });

    vm.changePage = function () {
      loadBids()
    };

    var onCancelledEvent = $rootScope.$on('onCancelled', function(event, id) {
      var ind = vm.bidList.findIndex(function(single) {
        return single.id == id
      });
      if (ind > -1) {
        vm.bidList[ind].isCancelled = true;
      }       
    });
    function loadBids() {
      $('.paginator-loader').addClass('sk-loading');
      BidRequestService.listByCompanyIdPage(vm.selectedCompany, vm.currentPage - 1, vm.perPage, vm.searchQuery,
        vm.bidSelectedSort.tag, vm.bidSelectedSort.order).then(function (response) {
        var bidList = response.bids;
        vm.bidsCount = response.pageInfo.count;
        vm.currentPageStart = response.pageInfo.currentStart;
        vm.currentPageEnd = response.pageInfo.currentEnd;
        vm.bidList = bidList;
        var requestPromises = [];
        bidList.forEach(function (bid) {
          requestPromises.push(BidResponseService.listByBidRequestId(bid.id).then(function (bidResponseList) {
            var assetsArray = [],
              appraisersArray = [];
            bid.bidResponses = bidResponseList;
            bid.assets = {};
            bid.appraisers = {};
            bid.responses = 0;
            bid.declines = 0;
            bid.pending = 0;
            bid.awarded = 0;
            for (var i = 0; i < bid.bidResponses.length; i++) {
              for (var j = 0; j < vm.assets.length; j++) {
                if (bid.bidResponses[i].assetId === vm.assets[j].id) {
                  var asset = angular.copy(vm.assets[j]);
                  bid.assets[asset.id] = asset;
                  break;
                }
              }
              for (j = 0; j < vm.appraisers.length; j++) {
                if (bid.bidResponses[i].userId === vm.appraisers[j].user.id) {
                  var appraiser = angular.copy(vm.appraisers[j]);
                  if (bid.bidResponses[i].respondedOn && bid.bidResponses[i].isSubmittedToAdmin) {
                    appraiser.responseBid = true;
                  }
                  if (bid.bidResponses[i].isDeclined) {
                    appraiser.declineBid = true;
                  }
                  if (!bid.appraisers[appraiser.id]) {
                    bid.appraisers[appraiser.id] = appraiser;
                  }
                  if (!bid.appraisers[appraiser.id].responseBid) {
                    bid.appraisers[appraiser.id].responseBid = appraiser.responseBid;
                  }
                  if (!bid.appraisers[appraiser.id].declineBid) {
                    bid.appraisers[appraiser.id].declineBid = appraiser.declineBid;
                  }
                  break;
                }
              }
            }
            Object.keys(bid.assets).forEach(function (key) {
              assetsArray.push(bid.assets[key]);
            });
            bid.assets = assetsArray;
            bid.assets.forEach(function (asset) {
              bid.bidResponses.forEach(function (response) {
                if (response.isAwarded && response.assetId === asset.id) {
                  asset.awarded = true;
                }
              });
              if (asset.awarded) {
                bid.awarded++;
              }
            });

            Object.keys(bid.appraisers).forEach(function (key) {
              appraisersArray.push(bid.appraisers[key]);
            });
            bid.appraisers = appraisersArray;
            bid.appraisers.forEach(function (appraiser) {
              if (appraiser.responseBid) {
                bid.responses++;
              } else if (appraiser.declineBid) {
                bid.declines++;
              } else {
                bid.pending++;
              }
            });
          }));
        });
        $q.all(requestPromises).then(function () {
          ArrayHelper.searchScroll();
          $('.paginator-loader').removeClass('sk-loading');
        })
      });
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .config(routeConfig);

  function routeConfig($stateProvider) {
    $stateProvider.state('app.bidEngagement.assignmentSummary', {
      url: '/assignment-summary/:bidId',
      views: {
        '@app': {
          templateUrl: 'app/states/bid-engagement/assignment-summary/assignment-summary.html',
          controller: 'AssignmentSummaryController',
          controllerAs: 'assignmentSummaryCtrl'
        }
      },
      data: {
        pageTitle: 'Assignment Summary',
        viewClass: 'assignment-summary',
        roles: ['Admin']
      },
      params: {
        bidId: ''
      },
      resolve: {
        /** @ngInject */
        bid: function ($q, $filter, $stateParams, BidRequestService, BidResponseService, AssetService, UserService,
          CompanyService) {
          if (!$stateParams.bidId) {
            return $q.reject({
              error: 'invalidTransition',
              fallback: 'app.bidEngagement.bidEngagementList'
            });
          }
          return BidRequestService.get($stateParams.bidId).then(function (bid) {
            var appraisersArray = [];
            var allAppraisers = [];
            bid.appraisers = {};
            bid.allAppraisers = {};
            bid.assets = {};
            return CompanyService.getAppraisalCompanies(true, true).then(function (appraisalCompanies) {
              return UserService.getUsersByType('Appraiser', true).then(function (appraisers) {
                appraisers.forEach(function (appraiser) {
                  appraiser.assets = [];
                  appraiser.assetsRollOverDates = [];
                  appraiser.assetsNotAwarded = [];
                  appraiser.statistics = [];
                  appraiser.letters = [];
                  appraiser.companyName = undefined;
                  for (var i = 0; i < appraisalCompanies.length; i++) {
                    if (appraiser.companyId === appraisalCompanies[i].id) {
                      appraiser.companyName = appraisalCompanies[i].name;
                      break;
                    }
                  }
                });
                return AssetService.getAssetsByCompany(bid.companyId).then(function (assets) {
                  assets.forEach(function (asset) {
                    asset.bidResponse = {};
                    asset.responses = [];
                  });
                  return BidResponseService.listByBidRequestId(bid.id).then(function (responses) {
                    var statisticsPromises = [];
                    for (var i = 0; i < responses.length; i++) {
                      var response = responses[i];
                      for (var j = 0; j < assets.length; j++) {
                        if (response.assetId === assets[j].id) {
                          assets[j].responses.push(response);
                          bid.assets[assets[j].id] = assets[j];
                        }
                      }
                    }
                    for (i = 0; i < appraisers.length; i++) {
                      var appraiser = angular.copy(appraisers[i]);
                      responses.forEach(function (response) {
                        assets.forEach(function (asset) {
                          if (asset.id === response.assetId) {
                            response.totalFee = 0;
                            response.totalFeeDiscount = 0;
                            var quarterly = response.quarterly ? response.quarterly : 0;
                            var quarterlyOld = response.quarterlyOld ? response.quarterlyOld : 0;
                            var quarterlyDiscount = response.quarterlyDiscount ? response.quarterlyDiscount : 0;
                            switch (asset.valuationFrequency) {
                              case 'Quarterly':
                              default:
                                if(response.isValueSynced) {
                                  response.totalFee =
                                  response.yearOne + (2 * response.yearsTwoThree) + (9 * quarterly);
                                } else {
                                  response.totalFee =
                                  response.yearOneOld + (2 * response.yearsTwoThreeOld) + (9 * quarterlyOld);
                                }
                                response.totalFeeDiscount =
                                  response.yearOneDiscount + (2 * response.yearsTwoThreeDiscount) + (9 * quarterlyDiscount);
                                break;
                              case 'SemiAnnually':
                                if(response.isValueSynced) {
                                  response.totalFee =
                                  response.yearOne + (2 * response.yearsTwoThree) + (3 * quarterly);
                                } else {
                                  response.totalFee =
                                  response.yearOne + (2 * response.yearsTwoThreeOld) + (3 * quarterlyOld);
                                }
                                response.totalFeeDiscount =
                                  response.yearOneDiscount + (2 * response.yearsTwoThreeDiscount) + (3 * quarterlyDiscount);
                                break;
                              case 'Annually':
                                if(response.isValueSynced) {
                                  response.totalFee =
                                  response.yearOne + (2 * response.yearsTwoThree);
                                } else {
                                  response.totalFee =
                                  response.yearOneOld + (2 * response.yearsTwoThreeOld);
                                }
                                response.totalFee =
                                  response.yearOne + (2 * response.yearsTwoThree);
                                response.totalFeeDiscount =
                                  response.yearOneDiscount + (2 * response.yearsTwoThreeDiscount);
                                break;
                            }
                          }
                        });
                        if ((response.isSelectedFee || response.isSelectedDiscount) && !response.isAwarded &&
                          response.userId === appraisers[i].user.id) {
                          for (j = 0; j < assets.length; j++) {
                            if (response.assetId === assets[j].id) {
                              var asset = angular.copy(assets[j]);
                              asset.bidResponse = response;
                              appraiser.assets.push(asset);
                              asset.nextRollOverDate ?
                                appraiser.assetsRollOverDates.push(asset.nextRollOverDate) :
                                appraiser.assetsRollOverDates.push(asset.rollOverDate);
                              bid.appraisers[appraiser.id] = appraiser;
                            }
                          }
                        }
                        else if ((!response.isSelectedFee && !response.isSelectedDiscount) && !response.isAwarded &&
                          response.userId === appraisers[i].user.id) {
                          response.isNotAwarded = true;
                          response.isAwarded = false;
                          for (j = 0; j < assets.length; j++) {
                            if (response.assetId === assets[j].id) {
                              var asset = angular.copy(assets[j]);
                              asset.bidResponse = response;
                              appraiser.assetsNotAwarded.push(asset);
                              if (!bid.allAppraisers[appraiser.id]) {
                                bid.allAppraisers[appraiser.id] = {};
                              }
                              bid.allAppraisers[appraiser.id] = appraiser;
                            }
                          }
                        }
                      });
                    }
                    Object.keys(bid.appraisers).forEach(function (key) {
                      appraisersArray.push(bid.appraisers[key]);
                    });
                    Object.keys(bid.allAppraisers).forEach(function (key) {
                      allAppraisers.push(bid.allAppraisers[key]);
                    });

                    appraisersArray.forEach(function (appraiser) {
                      statisticsPromises.push(AssetService.getAppraiserStatistic(appraiser.user.id)
                        .then(function (appraiserStatistic) {
                        appraiser.statistics = appraiserStatistic;
                      }));
                    });
                    return $q.all(statisticsPromises).then(function () {
                      bid.appraisers = appraisersArray;
                      bid.allAppraisers = allAppraisers;
                      return bid;
                    });
                  });
                });
              });
            });
          });
        }
      }
    });
  }
})();
(function () {
  'use strict';

  angular
    .module('nvc')
    .controller('AssignmentSummaryController', AssignmentSummaryController);

  /** @ngInject */
  function AssignmentSummaryController($filter, $state, $scope, $q, bid, AssetService, BidRequestService,
    BidResponseService, ValuationService, notify, LoaderHelper, ArrayHelper, UtcDateConverter) {
    var vm = this;
    var originalRollDates = {};
    Object.keys(bid.assets).forEach(function (key) {
      originalRollDates[key] = new moment(UtcDateConverter.getDateFromUTC(bid.assets[key].rollOverDate));
    });
    vm.bid = bid;
    vm.appraisersSort = [
      {
        sort: 'user.name',
        tag: 'user.name',
        selected: false,
        flag: false
      },
      {
        sort: 'assetsAssigned',
        tag: 'assetsAssigned',
        selected: false,
        flag: false
      }
    ];
    vm.assetsSort = [
      {
        sort: 'name',
        tag: 'name',
        selected: true,
        flag: true
      },
      {
        sort: 'bidResponse.yearOneSelected',
        tag: 'bidResponse.yearOneSelected',
        selected: false,
        flag: false
      },
      {
        sort: 'bidResponse.yearsTwoThreeSelected',
        tag: 'bidResponse.yearsTwoThreeSelected',
        selected: false,
        flag: false
      },
      {
        sort: 'bidResponse.quarterlySelected',
        tag: 'bidResponse.quarterlySelected',
        selected: false,
        flag: false
      },
      {
        sort: 'bidResponse.totalSelected',
        tag: 'bidResponse.totalSelected',
        selected: false,
        flag: false
      },
      {
        sort: 'rollOverDate',
        tag: 'rollOverDate',
        selected: false,
        flag: false
      }
    ];
    vm.invitesSort = [
      {
        sort: 'year',
        tag: 'year',
        selected: true,
        flag: true
      }
    ];
    vm.assetsSelectedSort = vm.assetsSort[0];
    vm.invitesSelectedSort = vm.invitesSort[0];
    vm.appraisersSelectedSort = {};
    vm.validRollOverDate = true;

    vm.canSubmit = false;

    vm.bid.appraisers.forEach(function (appraiser) {
      appraiser.assetsAssigned = appraiser.assets.length;
    });

    //GET ALL ASSET USERS
    //------------------------------------------
    var allAssetUsers = {};
    vm.bid.appraisers.forEach(function (appraiser) {
      appraiser.assets.forEach(function (asset) {
        asset.rollOverDate = asset.nextRollOverDate ? UtcDateConverter.getDateFromUTC(asset.nextRollOverDate) :
          UtcDateConverter.getDateFromUTC(asset.rollOverDate);
        AssetService.getAssetUsersList(asset.id).then(function (users) {
          users.forEach(function (user) {
            allAssetUsers[user.user.id] = user;
          });
        });
      });
    });

    //FUNCTIONS
    //-------------------------------------------------------
    function canSubmit() {
      var count = 0;
      for (var i = 0; i < vm.bid.appraisers.length; i++) {
        if (vm.bid.appraisers[i].letters.length > 0) {
          count++;
        }
      }
      return vm.bid.appraisers.length === count;
    }

    function isLastSubmission() {
      var assetsResponded = 0,
        assets = 0;
      Object.keys(vm.bid.assets).forEach(function (key) {
        assets++;
        var asset = vm.bid.assets[key];
        for (var i = 0; i < asset.responses.length; i++) {
          if (asset.responses[i].isSelectedFee || asset.responses[i].isSelectedDiscount) {
            assetsResponded++;
            break;
          }
        }
      });
      return assetsResponded === assets;
    }

    //BREADCRUMS
    //-------------------------------------------------------
    vm.title = $filter('translate')('ASSIGNMENT_SUMMARY.TITLE');
    vm.breadcrumbs = [
      {
        label: $filter('translate')('COMMONS.BID_ENGAGEMENT'),
        value: 'app.bidEngagement.bidEngagementList'
      },
      {
        label: $filter('translate')('ASSIGNMENT_SUMMARY.TITLE'),
        value: 'app.bidEngagement.bidEngagementList.assignmentSummary'
      }
    ];

    //SORTING
    //-------------------------------------------------------
    vm.sorting = function (sort, target) {
      ArrayHelper.sort(sort, target, vm.appraisersSort, vm);
    };

    vm.sortingAssets = function (sort, target) {
      ArrayHelper.sort(sort, target, vm.assetsSort, vm);
    };

    vm.sortingInvites = function (sort, target) {
      ArrayHelper.sort(sort, target, vm.invitesSort, vm);
    };

    //DATEPICKER
    //------------------------------------------------------
    vm.openDueDatePicker = function (asset) {
      asset.datePickerOpened = true;
    };

    vm.dateOptions = {
      startingDay: 1,
      showWeeks: false
    };

    vm.modelOptions = {
      debounce: {
        default: 2000,
        blur: 250
      },
      getterSetter: true
    };

    //GET APPRAISER DETAIL
    //------------------------------------------
    vm.getAppraiserDetail = function (selectedAppraiser) {
      if (vm.selectedAppraiser) {
        vm.selectedAppraiser.displaying = false;
      }
      vm.selectedAppraiser = selectedAppraiser;
      vm.selectedAppraiser.displaying = true;
      vm.selectedAppraiser.reset = true;
      selectedAppraiser.assets.forEach(function (asset) {
        asset.bidResponse.yearOneSelected = asset.bidResponse.isValueSynced == false ? asset.bidResponse.yearOneOld : asset.bidResponse.yearOne;
        asset.bidResponse.yearsTwoThreeSelected =asset.bidResponse.isValueSynced == false ? asset.bidResponse.yearsTwoThreeOld : asset.bidResponse.yearsTwoThree;
        asset.bidResponse.quarterlySelected =asset.bidResponse.isValueSynced == false ? asset.bidResponse.quarterlyOld : asset.bidResponse.quarterly;
        asset.bidResponse.totalSelected = asset.bidResponse.totalFee;
        // asset.bidResponse.totalSelected = asset.bidResponse.bidResponse.isValueSynced == false  ? asset.bidResponse.totalFee : '';
        // asset.bidResponse.yearOneSelected = asset.bidResponse.isSelectedFee ? asset.bidResponse.yearOne : asset.bidResponse.yearOneDiscount;
        // asset.bidResponse.yearsTwoThreeSelected = asset.bidResponse.isSelectedFee ? asset.bidResponse.yearsTwoThree : asset.bidResponse.yearsTwoThreeDiscount;
        // asset.bidResponse.quarterlySelected = asset.bidResponse.isSelectedFee ? asset.bidResponse.quarterly : asset.bidResponse.quarterlyDiscount;
        // asset.bidResponse.totalSelected = asset.bidResponse.isSelectedFee ? asset.bidResponse.totalFee : asset.bidResponse.totalFeeDiscount;
      });
    };

    //SELECT FIRST APPRAISER
    //------------------------------------------
    vm.getAppraiserDetail(vm.bid.appraisers[0]);

    //OPEN ROLLOVER DATE PICKER
    //------------------------------------------
    vm.editRollOver = function (asset) {
      asset.editingDate = !asset.editingDate;
    };

    //UPDATE ROLLOVER DATE
    //------------------------------------------
    vm.setRollOver = function (asset) {
      if (asset.rollOverDate && UtcDateConverter.setDateToUTC(asset.rollOverDate) !==
        UtcDateConverter.setDateToUTC(originalRollDates[asset.id])) {
        if (asset.valuationFrequency && 'Annually' === asset.valuationFrequency) {
          vm.validRollOverDate = validateRollOverDate('Annually', asset.scheduleQ1, undefined, asset.rollOverDate);
          if (!vm.validRollOverDate) {
            notify({
              message: $filter('translate')('ADD_ASSET.INVALID_ANNUAL_ROLL_OVER_DATE'),
              duration: 5000,
              templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
              classes: 'alert-danger',
              position: 'center'
            });
            return;
          }
        } else if (asset.valuationFrequency && 'SemiAnnually' === asset.valuationFrequency) {
          vm.validRollOverDate = validateRollOverDate('SemiAnnually', asset.scheduleQ1, asset.scheduleQ2,
            asset.rollOverDate);
          if (!vm.validRollOverDate) {
            notify({
              message: $filter('translate')('ADD_ASSET.INVALID_SEMI_ROLL_OVER_DATE'),
              duration: 5000,
              templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
              classes: 'alert-danger',
              position: 'center'
            });
            return;
          }
        }
        asset.editingDate = !asset.editingDate;
        asset.notUpdated = false;
        asset.nextRollOverDate = UtcDateConverter.setDateToUTC(asset.rollOverDate);
      } else {
        asset.editingDate = !asset.editingDate;
        asset.notUpdated = false;
      }
    };

    function updateRollOverDate(asset) {
      var assetDTO = {};
      assetDTO.id = asset.id;
      assetDTO.nextRollOverDate = UtcDateConverter.setDateToUTC(asset.rollOverDate);
      AssetService.updateAsset(assetDTO).then(function () {
      }, function () {
        console.error('something went wrong')
      });
    }

    function validateRollOverDate(valuationFrequency, firstDraft, secondDraft, rollOverDate) {
      if('Annually' === valuationFrequency) {
        return ReviewModel.getQuarterByDate(UtcDateConverter.getDateFromUTC(firstDraft)) ===
          ReviewModel.getQuarterByDate(UtcDateConverter.getDateFromUTC(rollOverDate));
      } else if('SemiAnnually' === valuationFrequency) {
        return ReviewModel.getQuarterByDate(UtcDateConverter.getDateFromUTC(firstDraft)) ===
          ReviewModel.getQuarterByDate(UtcDateConverter.getDateFromUTC(rollOverDate)) ||
          ReviewModel.getQuarterByDate(UtcDateConverter.getDateFromUTC(secondDraft)) ===
          ReviewModel.getQuarterByDate(UtcDateConverter.getDateFromUTC(rollOverDate));
      }
    }

    //SET PRIMARY
    //------------------------------------------
    function addPrimary(asset, user, year, quarter, latestValuation) {
      setUpOtherUsers(asset, user, year, quarter, latestValuation);
      if (allAssetUsers[user.user.id]) {
        return AssetService.addUserPeriod({
          id: allAssetUsers[user.user.id].id,
          year: year,
          quarter: quarter,
          isPrimary: true
        }).then(function (userWithPeriod) {
          allAssetUsers[user.user.id] = userWithPeriod;
        }, function () {
          var bidResponseRollBackDTO = {};
          bidResponseRollBackDTO.id = asset.bidResponse.id;
          bidResponseRollBackDTO.isAwarded = false;
          BidResponseService.updateBidResponse(bidResponseRollBackDTO);
          for (var i = 0; i < user.letters.length; i++) {
            BidRequestService.deleteEngagementLetter(user.letters[i].id);
          }
        });
      } else {
        return AssetService.addUser(asset.id, user.user.id).then(function (user) {
          return AssetService.addUserPeriod({
            id: user.id,
            year: year,
            quarter: quarter,
            isPrimary: true
          }).then(function (userWithPeriod) {
            allAssetUsers[user.user.id] = userWithPeriod;
          }, function () {
            var bidResponseRollBackDTO = {};
            bidResponseRollBackDTO.id = asset.bidResponse.id;
            bidResponseRollBackDTO.isAwarded = false;
            BidResponseService.updateBidResponse(bidResponseRollBackDTO);
            for (var i = 0; i < user.letters.length; i++) {
              BidRequestService.deleteEngagementLetter(user.letters[i].id);
            }
          });
        });
      }
    }

    function setUpOtherUsers(asset, user, year, quarter, latestValuation) {
      if (latestValuation) {
        AssetService.listUsers(asset.id).then(function (userAssetRelationships) {
          userAssetRelationships.forEach(function (userAssetRelationship) {
            var i = 0, period = null, periodDTO = null;
            if (quarter === ReviewModel.getQuarterByDate(new moment()) && year === (new moment()).get('year')) {
              for (i = 0; i < userAssetRelationship.periods.length; i++) {
                period = userAssetRelationship.periods[i];
                if (period.year === year && period.quarter === quarter &&
                  userAssetRelationship.user.id !== user.user.id &&
                  userAssetRelationship.userCompanyType === 'AssetAppraisal') {
                  periodDTO = {
                    id: period.id,
                    active: false
                  };
                  AssetService.updateUserPeriod(periodDTO);
                  break;
                }
              }
            } else {
              for (i = 0; i < userAssetRelationship.periods.length; i++) {
                period = userAssetRelationship.periods[i];
                if (period.year === latestValuation.year && period.quarter === latestValuation.quarter &&
                  userAssetRelationship.user.id !== user.user.id &&
                  userAssetRelationship.userCompanyType !== 'AssetAppraisal') {
                  periodDTO = {
                    id: userAssetRelationship.id,
                    active: true,
                    quarter: quarter,
                    year: year,
                    isPrimary: period.isPrimary
                  };
                  AssetService.addUserPeriod(periodDTO);
                  break;
                }
              }
            }
          });
        });
      }
    }

    //ASSIGN BID
    //------------------------------------------
    vm.assignBid = function () {
      var submitBid = true;
      if (!vm.validRollOverDate) {
        return;
      }

      for (var i = 0; i < vm.bid.appraisers.length; i++) {
        for (var j = 0; j < vm.bid.appraisers[i].assetsRollOverDates.length; j++) {

          var appraiserRollOver = new moment(UtcDateConverter.getDateFromUTC(vm.bid.appraisers[i].assetsRollOverDates[j]));
          var assetRollOver = new moment(vm.bid.appraisers[i].assets[j].rollOverDate);

          if(appraiserRollOver.get('month') === assetRollOver.get('month') &&
            appraiserRollOver.get('year') === assetRollOver.get('year')) {
            vm.bid.appraisers[i].assets[j].notUpdated = true;
            submitBid = false;
          }
        }
      }

      if (!submitBid) {
        notify({
          message: $filter('translate')('ASSIGNMENT_SUMMARY.ROLL_OVER_DATE_ERROR'),
          duration: 4000,
          templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
          classes: 'alert-danger',
          position: 'center'
        });
        return;
      }

      LoaderHelper.open();
      vm.bid.appraisers.forEach(function (appraiser) {
        if (appraiser.letters) {
          var promisesLetters = [];
          appraiser.letters.forEach(function (letter) {
            promisesLetters.push(BidRequestService.createEngagementLetter(vm.bid.id, appraiser.user.id, letter,
              letter.name).then(function (response) {
                return response;
              }, function (error) {
              }));
          });

          $q.allSettled(promisesLetters).then(function () {
            var promisesResponses = [];
            var promisesAssignments = [];
            appraiser.assets.forEach(function (asset) {
              updateRollOverDate(asset);
              var bidResponseDTO = {};
              bidResponseDTO.id = asset.bidResponse.id;
              bidResponseDTO.isAwarded = true;
              promisesResponses.push(BidResponseService.updateBidResponse(bidResponseDTO).then(function () {
                setUpValuation(asset, appraiser, promisesAssignments);
              }));
            });

            $q.allSettled(promisesResponses).then(function () {
              $q.all(promisesAssignments).then(function () {
                BidRequestService.sendEmailToAppraiser(vm.bid.id, appraiser.user.id).then(function () {
                  notify({
                    message: $filter('translate')('ASSIGNMENT_SUMMARY.BID_ENGAGEMENT_LETTERS')
                    + appraiser.user.name + ' ' + $filter('translate')('ASSIGNMENT_SUMMARY.LETTERS_SUCCESS'),
                    duration: 4000,
                    templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
                    classes: 'alert-info',
                    position: 'center'
                  });
                  if (isLastSubmission()) {
                    vm.bid.allAppraisers.forEach(function (appraiserNotAwarded) {
                      if (appraiserNotAwarded.assets.length === 0) {
                        appraiserNotAwarded.assetsNotAwarded.forEach(function (asset) {
                          var bidResponseDTO = {};
                          bidResponseDTO.id = asset.bidResponse.id;
                          bidResponseDTO.isAwarded = false;
                          bidResponseDTO.isNotAwarded = true;
                          BidResponseService.updateBidResponse(bidResponseDTO);
                        });
                      }
                    });
                  }
                });
              });
            }, function (responses) {
              responses.forEach(function (error) {
                if (error.id) {
                  var bidResponseRollBackDTO = {};
                  bidResponseRollBackDTO.id = error.data.id;
                  bidResponseRollBackDTO.isAwarded = false;
                  BidResponseService.updateBidResponse(bidResponseRollBackDTO);
                }
                for (var i = 0; i < appraiser.letters.length; i++) {
                  BidRequestService.deleteEngagementLetter(appraiser.letters[i].id);
                }
              });
              notify({
                message: $filter('translate')('ASSIGNMENT_SUMMARY.BID_NOT_SUCCESSFUL'),
                duration: 4000,
                templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
                classes: 'alert-info',
                position: 'center'
              });
            });
          }, function (responses) {
            responses.forEach(function (letter) {
              if (letter.id) {
                BidRequestService.deleteEngagementLetter(letter.id);
              }
            });
            notify({
              message: $filter('translate')('ASSIGNMENT_SUMMARY.BID_ENGAGEMENT_LETTERS') + appraiser.name +
                $filter('translate')('ASSIGNMENT_SUMMARY.LETTERS_FAILED'),
              duration: 4000,
              templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
              classes: 'alert-info',
              position: 'center'
            });
          });
        }
      });
      if (submitBid) {
        $state.go('app.bidEngagement.bidEngagementList', {}, { reload: true });
      }
    };

    function setUpValuation(asset, appraiser, promisesAssignments) {
      promisesAssignments.push(ValuationService.listValuationsByAssetId(asset.id).then(function (valuations) {
        var latestValuation = valuations && valuations.length > 0 ? valuations[0] : undefined;
        for (var i = 0; i < valuations.length; i++) {
          if ('Annually' === asset.valuationFrequency && valuations[i].year >= latestValuation.year) {
            latestValuation = valuations[i];
          } else if ('Annually' !== asset.valuationFrequency && valuations[i].year >= latestValuation.year &&
            valuations[i].quarter > latestValuation.quarter) {
            latestValuation = valuations[i];
          }
        }
        var nextCycle = latestValuation && latestValuation.valuationCycle ? latestValuation.valuationCycle + 1 : 1;
        var rollOverYear = originalRollDates[asset.id].get('year'),
          rollOverQuarter = null,
          currentYear = (new moment()).get('year'),
          currentQuarter = ReviewModel.getQuarterByDate(new moment()),
          nextDraftDueDate,
          nextQuarterDate;
        if ('Annually' === asset.valuationFrequency) {
          rollOverQuarter = ReviewModel.getQuarterByDate(UtcDateConverter.getDateFromUTC(asset.scheduleQ1));
          nextQuarterDate = 1;
        } else if ('Quarterly' === asset.valuationFrequency) {
          if (asset.requiredAppraisers.toLowerCase() == 'externalonly') {
            rollOverQuarter = ReviewModel.getQuarterByDate(UtcDateConverter.getDateFromUTC(originalRollDates[asset.id]));
          } else {
            rollOverQuarter = ReviewModel.getQuarterByDate(UtcDateConverter.getDateFromUTC(moment(asset['scheduleQ' + asset.scheduleOption])));
          }
          nextQuarterDate = rollOverQuarter;
        } else {
          var rollOverDate = originalRollDates[asset.id],
            firstDraftQuarter = ReviewModel.getQuarterByDate(UtcDateConverter.getDateFromUTC(asset.scheduleQ1)),
            secondDraftQuarter = ReviewModel.getQuarterByDate(UtcDateConverter.getDateFromUTC(asset.scheduleQ2));
          if (asset.requiredAppraisers.toLowerCase() == 'externalonly') {
            rollOverQuarter = ReviewModel.getQuarterByDate(UtcDateConverter.getDateFromUTC(rollOverDate));
          } else {
            rollOverQuarter = ReviewModel.getQuarterByDate(UtcDateConverter.getDateFromUTC(moment(asset['scheduleQ' + asset.scheduleOption])));
          }

          if (rollOverQuarter === firstDraftQuarter) {
            nextQuarterDate = 1;
          } else if (rollOverQuarter === secondDraftQuarter) {
            nextQuarterDate = 2;
          }
        }
        if (rollOverYear > currentYear || (rollOverYear === currentYear && rollOverQuarter > currentQuarter)) {
          nextDraftDueDate = moment(UtcDateConverter.getDateFromUTC(asset['scheduleQ' + nextQuarterDate]));
          nextDraftDueDate.set('year', rollOverYear);
          return ValuationService.createValuation({
            assetId: asset.id,
            year: rollOverYear,
            quarter: rollOverQuarter,
            yearOfCycle: 1,
            quarterOfCycle: 1,
            valuationCycle: nextCycle,
            nextDraftDueDate: UtcDateConverter.setDateToUTC(nextDraftDueDate)
          }).then(function () {
            return addPrimary(asset, appraiser, rollOverYear, rollOverQuarter, latestValuation);
          });
        } else if (latestValuation) {
          var valuationDTO = {
            id: latestValuation.id,
            yearOfCycle: 1,
            quarterOfCycle: 1,
            valuationCycle: nextCycle
          };
          return ValuationService.updateValuation(valuationDTO).then(function () {
            if (asset.requiredAppraisers.toLowerCase() == 'externalonly') {
              return addPrimary(asset, appraiser, latestValuation.year, latestValuation.quarter, latestValuation);
            } else {
              return addPrimary(asset, appraiser, latestValuation.year, rollOverQuarter, latestValuation);
            }
          });
        } else {
          var firstQuarter = new moment(UtcDateConverter.getDateFromUTC(AssetModel.getFirstSchedule(asset)));
          nextQuarterDate = ReviewModel.getQuarterByDate(firstQuarter);
          if (firstQuarter.get('year') < currentYear || (firstQuarter.get('year') === currentYear &&
            ReviewModel.getQuarterByDate(firstQuarter) <= currentQuarter)) {
            nextDraftDueDate = moment(asset['scheduleQ' + nextQuarterDate]);
            nextDraftDueDate.set('year', rollOverYear);
            return ValuationService.createValuation({
              assetId: asset.id,
              year: rollOverYear,
              quarter: rollOverQuarter,
              yearOfCycle: 1,
              quarterOfCycle: 1,
              valuationCycle: nextCycle,
              nextDraftDueDate: UtcDateConverter.setDateToUTC(nextDraftDueDate)
            }).then(function () {
              return addPrimary(asset, appraiser, rollOverYear, rollOverQuarter);
            });
          } else {
            nextDraftDueDate = firstQuarter;
            return ValuationService.createValuation({
              assetId: asset.id,
              year: firstQuarter.get('year'),
              quarter: ReviewModel.getQuarterByDate(UtcDateConverter.getDateFromUTC(firstQuarter)),
              yearOfCycle: 1,
              quarterOfCycle: 1,
              valuationCycle: nextCycle,
              nextDraftDueDate:  UtcDateConverter.setDateToUTC(nextDraftDueDate)
            }).then(function () {
              return addPrimary(asset, appraiser, firstQuarter.get('year'),
                ReviewModel.getQuarterByDate(UtcDateConverter.getDateFromUTC(firstQuarter)));
            });
          }
        }
      }));
    }

    vm.arrayToFormattedString = function (array, separator) {
      if (array) {
        return array.toString().replace(/\,/g, separator);
      } else {
        return '';
      }
    };

    //WATCHERS
    //------------------------------------------
    var appraisersWatch = $scope.$watchCollection('assignmentSummaryCtrl.selectedAppraiser.letters', function () {
      vm.canSubmit = canSubmit();
    });

    $scope.$on('$destroy', function () {
      appraisersWatch();
    });
  }

})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .config(routeConfig);

  function routeConfig($stateProvider) {
    $stateProvider.state('app.bidEngagement.addRfp', {
      abstract: true,
      url: '/create-new-rfp',
      views: {
        '@app': {
          templateUrl: 'app/states/bid-engagement/add-rfp/add-rfp.html',
          controller: 'AddRfpController',
          controllerAs: 'addRfpCtrl'
        }
      },
      data: {
        pageTitle: 'Create New RFP',
        viewClass: 'add-rfp',
        roles: ['Admin']
      },
      resolve: {
        /** @ngInject */
        companies: function (CompanyService) {
          return CompanyService.getClientCompanies(true, true);
        },
        /** @ngInject */
        propertyTypes: function (StaticDataService) {
          return StaticDataService.getPropertyTypes()
        },
        /** @ngInject */
        states: function (StaticDataService) {
          return StaticDataService.getAllStates()
        }
      }
    });
  }

})();
(function () {
  'use strict';

  angular
    .module('nvc')
    .controller('AddRfpController', AddRfpController);

  /** @ngInject */
  function AddRfpController($scope, $state, $filter, SweetAlert, LoaderHelper) {
    var vm = this;

    //BREADCRUMS
    //-------------------------------------------------------
    vm.title = $filter('translate')('ADD_RFP.TITLE');
    vm.breadcrumbs = [
      {
        label: $filter('translate')('COMMONS.BID_ENGAGEMENT'),
        value: 'app.bidEngagement.bidEngagementList'
      },
      {
        label: $filter('translate')('ADD_RFP.TITLE'),
        value: 'app.bidEngagement.addRfp.selectAssets'
      }
    ];

    vm.state = $state.current.name;
    $scope.finished = false;
    var isConfirmed = false;

    var changeSuccess = $scope.$on('$stateChangeSuccess', function (event, toState) {
      vm.state = $state.current.name;
      vm.params = $state.params;
    });

    var stateAlert = $scope.$on('$stateChangeStart', function (event, toState, toParams) {
      if (((toState.name != 'app.bidEngagement.addRfp.selectAssets'
        && toState.name != 'app.bidEngagement.addRfp.selectAppraisers'
        && toState.name != 'app.bidEngagement.addRfp.bidAssignments' ) || !toParams.requestForm) && !isConfirmed && !$scope.finished) {
        event.preventDefault();
        SweetAlert.swal({
            title: $filter('translate')('COMMONS.LEAVE_PAGE_MODAL_TITLE'),
            text: $filter('translate')('COMMONS.LEAVE_PAGE_MODAL_TEXT'),
            showCancelButton: true,
            cancelButtonText: $filter('translate')('COMMONS.LEAVE_PAGE_CONFIRM_BUTTON'),
            confirmButtonColor: '#2c3d4e',
            confirmButtonText: $filter('translate')('COMMONS.LEAVE_PAGE_CANCEL_BUTTON'),
            closeOnConfirm: true,
            closeOnCancel: true
          },
          function (isConfirm) {
            if (!isConfirm) {
              isConfirmed = true;
              if (toState.name == 'app.bidEngagement.addRfp.selectAppraisers' || toState.name == 'app.bidEngagement.addRfp.bidAssignments') {
                $state.go('app.bidEngagement.addRfp.selectAssets');
              } else {
                $state.go(toState.name, toParams);
              }
            } else {
              LoaderHelper.close();
            }
          }
        );
      }
    });


    $scope.$on('$destroy', function () {
      changeSuccess();
      stateAlert();
    });
  }

})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .controller('UploadAssetsController', UploadAssetsController);

  function UploadAssetsController($state, $filter, $uibModalInstance, LoaderHelper, notify, AssetService,
                                  selectedCompanyId) {
    var vm = this;
    vm.assetFile = [];
    vm.valuationsFile = [];

    // Close upload modal
    vm.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    // Upload both assets and valuations
    vm.uploadFromCsv = function () {
      var assetFile = vm.assetsFile[0],
        valuationFile = vm.valuationsFile[0];

      if (!assetFile || !valuationFile) {
        notify({
          message: $filter('translate')('ASSETS.UPLOAD_MANDATORY_ERROR'),
          duration: 5000,
          templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
          classes: 'alert-danger',
          position: 'center'
        });
        return;
      }

      LoaderHelper.open();
      uploadAssetsFromCsv({'assetsDocument': assetFile, 'valuationsDocument': valuationFile}, selectedCompanyId)
        .then(function () {
          LoaderHelper.close();
          notify({
            message: $filter('translate')('ASSETS.UPLOAD_ASSETS_VALUATIONS_SUCCESS'),
            duration: 5000,
            templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
            classes: 'alert-info',
            position: 'center'
          });
          $uibModalInstance.close();
        })
        .catch(function (err) {
          LoaderHelper.close();
          $uibModalInstance.close();
        });
    };

    // Upload assets
    function uploadAssetsFromCsv(files, selectedCompanyId) {
      return AssetService.loadAssetsFromCsv(files, selectedCompanyId);
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('nvc')
    .config(routeConfig);

  function routeConfig($stateProvider) {
    $stateProvider.state('app.asset.editAsset', {
      url: '/edit/:companyId/:assetId',
      views: {
        "@app": {
          templateUrl: 'app/states/assets/edit-asset/edit-asset.html',
          controller: 'EditAssetController',
          controllerAs: 'editAsset'
        }
      },
      data: {
        pageTitle: 'Edit Asset',
        viewClass: 'edit-asset',
        roles: ['Admin', 'AssetManagement', 'AssetReview']
      },
      params: {
        companyId: '',
        assetId: '',
        asset: null
      },
      resolve: {
        /** @ngInject */
        states: function (StaticDataService) {
          return StaticDataService.getAllStates()
        },
        /** @ngInject */
        citiesByStates: function (StaticDataService) {
          return StaticDataService.getCitiesByStates()
        },
        /** @ngInject */
        ncreifRegionByStates: function (StaticDataService) {
          return StaticDataService.getNCREIFRegionByStates();
        },
        /** @ngInject */
        propertyTypes: function (StaticDataService) {
          return StaticDataService.getPropertyTypes()
        },
        /** @ngInject */
        subtypesByPropertyTypes: function (StaticDataService) {
          return StaticDataService.getSubtypesByPropertyTypes()
        },
        /** @ngInject */
        msaByStates: function (StaticDataService) {
          return StaticDataService.getMsaByStates()
        },
        /** @ngInject */
        ownershipTypes: function (StaticDataService) {
          return StaticDataService.getOwnershipTypes()
        },
        /** @ngInject */
        ncreifs: function (StaticDataService) {
          return StaticDataService.getNcreifs()
        },
        /** @ngInject */
        assetCompanyUsers: function ($stateParams, UserService, SessionManager) {
          if (SessionManager.isInRole('AssetReview')) {
            return [];
          }
          return UserService.getUsersByCompanyId($stateParams.companyId, true).then(function (users) {
            var assetUsers = [];
            for (var i = 0; i < users.length; i++) {
              if (users[i].user.userCompanyRoles) {
                if (users[i].user.userCompanyRoles.length > 1) {
                  for (var j = 0; j < users[i].user.userCompanyRoles.length; j++) {
                    if ('AssetManager' == users[i].user.userCompanyRoles[j] || 'AssetManagerReadOnly' == users[i].user.userCompanyRoles[j]) {
                      assetUsers.push(users[i]);
                      break;
                    }
                  }
                } else if ('AssetManager' == users[i].user.userCompanyRoles[0] || 'AssetManagerReadOnly' == users[i].user.userCompanyRoles[0]) {
                  assetUsers.push(users[i]);
                }
              }
            }
            return assetUsers;
          });
        },
        /** @ngInject */
        assetUsers: function ($stateParams, AssetService) {
          return AssetService.getAssetUsersList($stateParams.assetId, true);
        },
        /** @ngInject */
        asset: function ($stateParams, AssetService) {
          if ($stateParams.asset) {
            return $stateParams.asset;
          }
          return AssetService.getAsset($stateParams.assetId);
        },
        valuations: function ($stateParams, ValuationService) {
          if ($stateParams.asset && $stateParams.asset.valuations) {
            return $stateParams.asset.valuations;
          }
          return ValuationService.listValuationsByAssetId($stateParams.assetId);
        },
        /** @ngInject */
        reviewers: function ($q, CompanyService, UserService, SessionManager) {
          if (SessionManager.isInAnyRole(['AssetManagement', 'AssetReview'])) {
            return [];
          }
          return CompanyService.getReviewerCompanies(true, true).then(function (rCompanies) {
            var promises = [];
            rCompanies.forEach(function (rCompany) {
              promises.push(UserService.getUsersByCompanyId(rCompany.id, true));
            });
            return $q.all(promises).then(function (responses) {
              var reviewers = [];
              responses.forEach(function (response) {
                reviewers = reviewers.concat(response);
              });
              return reviewers;
            });
          });
        },
        /** @ngInject */
        internalAppraisers: function ($q, CompanyService, UserService, SessionManager) {
          return CompanyService.getAppraisalCompanies(true, true).then(function (aCompanies) {
            var promises = [];
            aCompanies.forEach(function (aCompany) {
              if (aCompany.name === 'National Valuation Consultants, Inc.') {
                // Interested only in Internal Appraisers
                promises.push(UserService.getUsersByCompanyId(aCompany.id, true));
              }
            });
            return $q.all(promises).then(function (responses) {
              var internalAppraisers = [];
              responses.forEach(function (response) {
                internalAppraisers = internalAppraisers.concat(response);
              });
              return internalAppraisers;
            });
          });

         },
        /** @ngInject */
        requiredAppraisers: function (StaticDataService) {
          return StaticDataService.getRequiredAppraisers();
        },
        /** @ngInject */
        documents: function ($stateParams, AssetService){
          return AssetService.documentList($stateParams.assetId);
        },
        /** @ngInject */
        valuationFrequencies: function (StaticDataService) {
          return StaticDataService.getValuationFrequencies();
        },       
          /** @ngInject */
        assetInternalAppraisers: function ($stateParams, AssetService) {
          var assetInternalAppraisers = [];
          AssetService.getAssetUsersList($stateParams.assetId, true).then(function (userAssets) {
            for (var i = 0; i < userAssets.length; i++) {
              if (userAssets[i].user.userCompanyId == 14405) {
                assetInternalAppraisers.push(userAssets[i]);
              }
            }
          })
          return assetInternalAppraisers;

        }
      }
    });
  }

})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .controller('EditAssetController', EditAssetController);

  /** @ngInject */
  function EditAssetController($q, $scope, $state, $filter, $timeout, LoaderHelper, AssetService, UserAccountService,
    BidGroupService, states, citiesByStates, ncreifRegionByStates, propertyTypes, subtypesByPropertyTypes,
    notify, msaByStates, ownershipTypes, ncreifs, assetCompanyUsers, asset, assetUsers,
    reviewers, SessionManager, documents, valuations, GROUNDLEASED, ASSETCOUNTRIES, ASSETREQUIREDAPPRAISERS,
    internalAppraisers, requiredAppraisers, SecurityManager, valuationFrequencies, ValuationService, UtcDateConverter, assetInternalAppraisers) {

    var vm = this;
    var watchers = [],
      originalSchedule = {};
    (function init() {

      asset.valuations = valuations;
      asset.scheduleOption = !asset.scheduleOption ? 1 : asset.scheduleOption;
      if ('Annually' === asset.valuationFrequency) {
        delete asset.scheduleQ2;
        delete asset.scheduleQ3;
        delete asset.scheduleQ4;
      } else if ('SemiAnnually' === asset.valuationFrequency) {
        delete asset.scheduleQ3;
        delete asset.scheduleQ4;
      }
      asset.valuationFrequency = asset.valuationFrequency ?
        valuationFrequencies.items.filter(function (freq) { return freq.value === asset.valuationFrequency; })[0] :
        {};

      asset.requiredAppraisers = asset.requiredAppraisers ?
        requiredAppraisers.items.filter(function (ra) { return ra.value === asset.requiredAppraisers; })[0] :
        requiredAppraisers.items[0]; // Default to first which is ExternalOnly

      // Convert asset groundleased from (true/false) to (Yes/No)
      var groundLeasedDictionary = {
        true: GROUNDLEASED[0],
        false: GROUNDLEASED[1]
      };
      asset.groundLeased = $filter('booleanToString')(asset.groundLeased, groundLeasedDictionary);
      // Only admin or asset manager can edit portfolio name
      vm.canUserEdit = SecurityManager.isCurrentUserAdmin() || SecurityManager.isCurrentUserAssetManager();
      vm.isAM = !SessionManager.isInRole('Admin');
      vm.disableManager = !SessionManager.isInRole('Admin');
      vm.asset = asset;
      vm.isReviewer = SessionManager.isInRole('AssetReview');
      vm.statesByCountry = states;
      vm.citiesByStates = citiesByStates;
      vm.ncreifRegionByStates = ncreifRegionByStates;
      vm.propertyTypes = propertyTypes.items;
      vm.msaByStates = msaByStates;
      vm.ownershipTypes = ownershipTypes;
      vm.ncreifs = ncreifs.items;
      vm.groundLeasedTypes = GROUNDLEASED;
      vm.countries = ASSETCOUNTRIES;
      vm.requiredAppraisers = ASSETREQUIREDAPPRAISERS
      vm.biddingGroups = [];
      vm.picture = vm.asset.picture;
      vm.assetManagers = assetCompanyUsers;
      vm.reviewers = reviewers;
      vm.internalAppraisers = internalAppraisers;
      vm.assetUsers = assetUsers;
      vm.documents = documents;
      vm.documentsToUpload = [];
      vm.valuationFrequency = valuationFrequencies.items;
      vm.validRollOverDate = true;
      vm.requiredAppraisers = requiredAppraisers.items;
      vm.asset.internalAppraisers = []; //to be populated from assetUsers
      vm.selectedInternalAppraisers = [];
      vm.newInternalAppraisers = [];
      vm.assetInternalAppraisers = assetInternalAppraisers;
      vm.selectedScheduleOption = vm.asset.scheduleOption;
      BidGroupService.list(vm.asset.companyId).then(function (bidGroups) {
        vm.biddingGroups = bidGroups;
        if (vm.asset.bidGroupId) {
          for (var i = 0; i < vm.biddingGroups.length; i++) {
            if (vm.biddingGroups[i].id === vm.asset.bidGroupId) {
              vm.asset.bidGroupId = vm.biddingGroups[i];
              break;
            }
          }
        }
      });

      for (var i = 0; i < vm.ncreifs.length; i++) {
        if (vm.asset.region === vm.ncreifs[i].type) {
          vm.asset.region = vm.ncreifs[i];
          break;
        }
      }

      for (i = 0; i < vm.propertyTypes.length; i++) {
        if (vm.propertyTypes[i].type === vm.asset.type) {
          vm.asset.type = vm.propertyTypes[i];
          break;
        }
      }

      vm.subtypesByPropertyTypes = subtypesByPropertyTypes;

      for (i = 0; i < vm.subtypesByPropertyTypes[vm.asset.type.type].length; i++) {
        if (vm.asset.subType && vm.subtypesByPropertyTypes[vm.asset.type.type][i].type === vm.asset.subType) {
          vm.asset.subType = vm.subtypesByPropertyTypes[vm.asset.type.type][i];
          break;
        }
      }

      var currentQuarterIPA = 0;
      var currentYearIPA = 0;
      var currentQuarterISA = 0;
      var currentYearISA = 0;
      var currentAUserIPA = null;
      var currentAUserISA = null;
      var ipaFromDb = null;
      var isaFromDb = null;
      vm.assetUsers.forEach(function (aUser) {
        var isInternalAppraiser = false;
        for (var j = 0; j < vm.internalAppraisers.length; j++) {
          if (aUser.user.id === vm.internalAppraisers[j].user.id) {
            isInternalAppraiser = true;
          }
        }
        for (var i = 0; aUser.active !== false && i < aUser.periods.length; i++) {
          var tempPeriod = aUser.periods[i];
          if (aUser.type === 'PrimaryAssetAppraiser') {
            ipaFromDb = aUser;
          }
          if (aUser.type === 'SecondaryAssetAppraiser') {
            isaFromDb = aUser;
          }
          if (tempPeriod.active && vm.asset.valuation && tempPeriod.quarter >= vm.asset.valuation.quarter && tempPeriod.year >= vm.asset.valuation.year) {
            switch (aUser.userCompanyType) {
              case 'AssetReview':
                if (tempPeriod.isPrimary) {
                  aUser.type = 'PrimaryAssetReviewer';
                } else {
                  aUser.type = 'SecondaryAssetReviewer';
                }
                break;
              case 'AssetManagement':
                if (tempPeriod.isPrimary) {
                  aUser.type = 'PrimaryAssetManager';
                } else {
                  aUser.type = 'SecondaryAssetManager';
                }
                break;
              case 'AssetAppraisal':
                if (tempPeriod.isPrimary && isInternalAppraiser) {
                  if ((currentYearIPA < tempPeriod.year) ||
                    (currentYearIPA === tempPeriod.year && currentQuarterIPA < tempPeriod.quarter)) {
                    currentQuarterIPA = tempPeriod.year;
                    currentYearIPA = tempPeriod.quarter;
                    aUser.type = 'PrimaryAssetAppraiser';
                    if (currentAUserIPA) {
                      currentAUserIPA.type = null;
                    }
                    currentAUserIPA = aUser;
                  }
                } else if (isInternalAppraiser) {
                  if ((currentYearISA < tempPeriod.year) ||
                    (currentYearISA === tempPeriod.year && currentQuarterISA < tempPeriod.quarter)) {
                    currentQuarterISA = tempPeriod.year;
                    currentYearISA = tempPeriod.quarter;
                    aUser.type = 'SecondaryAssetAppraiser';
                    if (currentAUserISA) {
                      currentAUserISA.type = null;
                    }
                    currentAUserISA = aUser;
                  }
                }
                break;
            }
            break;
          }
        }
      });
      if (ipaFromDb) {
        if (currentAUserIPA) {
          currentAUserIPA.type = null;
        }
        ipaFromDb.type = 'PrimaryAssetAppraiser';
      }
      if (isaFromDb) {
        if (currentAUserISA) {
          currentAUserISA.type = null;
        }
        isaFromDb.type = 'SecondaryAssetAppraiser';
      }

      var primaryInternalAppraiser = null;
      var secondaryInternalAppraiser = null;
      var userAssetPrimary = null;
      var userAssetSec = null;
      if(vm.assetInternalAppraisers.length>0){
        userAssetPrimary = vm.assetInternalAppraisers[0];
        if(vm.assetInternalAppraisers.length>1){
          userAssetSec = vm.assetInternalAppraisers[1];
        }
      }
      for (var i = 0; i < vm.internalAppraisers.length; i++) {
             if(userAssetPrimary!=null){
              if(userAssetPrimary.user.id==vm.internalAppraisers[i].user.id){
                primaryInternalAppraiser = vm.internalAppraisers[i];
                primaryInternalAppraiser.relationId = userAssetPrimary.id;
              }  
             }
             if(userAssetSec!=null){
              if(userAssetSec.user.id==vm.internalAppraisers[i].user.id){
                secondaryInternalAppraiser = vm.internalAppraisers[i];
                secondaryInternalAppraiser.relationId = userAssetSec.id;
              }  
             }
      }
      if (primaryInternalAppraiser) {
        vm.asset.internalAppraisers.push(primaryInternalAppraiser);
        vm.selectedInternalAppraisers[0] = primaryInternalAppraiser;
      }
      if (secondaryInternalAppraiser) {
        vm.asset.internalAppraisers.push(secondaryInternalAppraiser);
        vm.selectedInternalAppraisers[1] = secondaryInternalAppraiser;
      }

      if (asset.requiredAppraisers && asset.requiredAppraisers.value !== 'ExternalOnly' &&
        vm.asset.internalAppraisers && vm.asset.internalAppraisers.length > 1) {
        var pSelIndex = -1;
        var sSelIndex = -1;
        for (i = 0; i < vm.internalAppraisers.length; i++) {
          if (primaryInternalAppraiser.user.id === vm.internalAppraisers[i].user.id) {
            pSelIndex = i;
          }
          if (secondaryInternalAppraiser && secondaryInternalAppraiser.user.id === vm.internalAppraisers[i].user.id) {
            sSelIndex = i;
          }
        }
        // To preserve the order in selected display, swap positions
        if (pSelIndex !== -1 && sSelIndex !== -1 && sSelIndex < pSelIndex) {
          var temp = vm.internalAppraisers[pSelIndex];
          vm.internalAppraisers[pSelIndex] = vm.internalAppraisers[sSelIndex];
          vm.internalAppraisers[sSelIndex] = temp;
        }
      }

      for (i = 0; i < vm.assetUsers.length; i++) {
        if ('PrimaryAssetManager' === vm.assetUsers[i].type && vm.assetUsers[i].periods.length > 0 && vm.assetUsers[i].isPrimary == true) {
          vm.leadAssetManager = vm.assetUsers[i];
          break;
        }
      }

      for (i = 0; i < vm.assetUsers.length; i++) {
        if ('PrimaryAssetReviewer' === vm.assetUsers[i].type && vm.assetUsers[i].periods.length > 0 && vm.assetUsers[i].isPrimary == true) {
          vm.leadReviewer = vm.assetUsers[i];
          break;
        }
      }

      /*
      if (vm.asset.internalAppraisers && vm.asset.internalAppraisers.length > 0) {
        vm.selectedInternalAppraisers[0] = vm.asset.internalAppraisers[0];
      }

      if (vm.asset.internalAppraisers && vm.asset.internalAppraisers.length > 1) {
        vm.selectedInternalAppraisers[1] = vm.asset.internalAppraisers[1];
      }
      */

      if (vm.leadAssetManager) {
        vm.selectedLeadAsset = vm.leadAssetManager;
        if (!SessionManager.isInRole('AssetReview')) {
          UserAccountService.getAccount(vm.leadAssetManager.user.userAccountId).then(function (response) {
            vm.leadAssetManager.userAccount = response;
          });
        }
      }

      if (vm.leadReviewer) {
        vm.selectedLeadReviewer = vm.leadReviewer;
        if (SessionManager.isInRole('Admin')) {
          UserAccountService.getAccount(vm.leadReviewer.user.userAccountId).then(function (response) {
            vm.leadReviewer.userAccount = response;
          });
        }
      }

      if (vm.leadAssetManager) {
        for (i = 0; i < vm.assetManagers.length; i++) {
          if (vm.assetManagers[i].user.id === vm.leadAssetManager.user.id) {
            vm.leadAssetManager = vm.assetManagers[i];
            break;
          }
        }
      }

      if (vm.leadReviewer) {
        for (i = 0; i < vm.reviewers.length; i++) {
          if (vm.reviewers[i].user.id === vm.leadReviewer.user.id) {
            vm.leadReviewer = vm.reviewers[i];
            break;
          }
        }
      }

      for (i = 0; i < vm.ownershipTypes.length; i++) {
        if (vm.asset.ownership && vm.ownershipTypes[i].type === vm.asset.ownership) {
          vm.asset.ownership = vm.ownershipTypes[i];
          break;
        }
      }

      vm.asset.scheduleQ1 = UtcDateConverter.getDateFromUTC(vm.asset.scheduleQ1);
      vm.asset.scheduleQ2 = vm.asset.scheduleQ2 ? UtcDateConverter.getDateFromUTC(vm.asset.scheduleQ2) : undefined;
      vm.asset.scheduleQ3 = vm.asset.scheduleQ3 ? UtcDateConverter.getDateFromUTC(vm.asset.scheduleQ3) : undefined;
      vm.asset.scheduleQ4 = vm.asset.scheduleQ4 ? UtcDateConverter.getDateFromUTC(vm.asset.scheduleQ4) : undefined;

      originalSchedule.scheduleQ1 = new moment(vm.asset.scheduleQ1);
      originalSchedule.scheduleQ2 = vm.asset.valuationFrequency !== 'Annually' && vm.asset.scheduleQ2 ?
        new moment(vm.asset.scheduleQ2) : undefined;
      originalSchedule.scheduleQ3 = vm.asset.valuationFrequency === 'Quarterly' && vm.asset.scheduleQ3 ?
        new moment(vm.asset.scheduleQ3) : undefined;
      originalSchedule.scheduleQ4 = vm.asset.valuationFrequency === 'Quarterly' && vm.asset.scheduleQ4 ?
        new moment(vm.asset.scheduleQ4) : undefined;

      if (vm.asset.rollOverDate) {
        vm.asset.rollOverDate = UtcDateConverter.getDateFromUTC(vm.asset.rollOverDate);
      }

      vm.editAssetForm = {};
      vm.submitted = false;
      vm.duplicateId = false;

      vm.title = $filter('translate')('ADD_ASSET.EDIT_ASSET');

      if (!vm.asset.active) {
        vm.title = $filter('translate')(vm.asset.name) + ' (' + $filter('translate')('COMMONS.INACTIVATED') + ')';
      }

      vm.breadcrumbs = [
        {
          label: $filter('translate')('ASSETS.TITLE'),
          value: 'app.asset.all'
        },
        {
          label: $filter('translate')('ADD_ASSET.EDIT_ASSET'),
          value: 'app.asset.editAsset'
        }
      ];
    })();

    vm.isDisableActioner = function () {
      if (vm.asset.valuations.length > 0) {
        var currentYear = new moment().get('year'),
          currentQuarter = ReviewModel.getQuarterByDate(moment());
        for (i = 0; i < vm.asset.valuations.length; i++) {
          if (vm.asset.valuations[i].year === currentYear &&
            vm.asset.valuations[i].quarter === currentQuarter && vm.asset.valuations[i].status === 'Finished') {
            return true;
          }
        }
        return false;
      }
    }

    vm.submitForm = function () {
      vm.submitted = true;

      var deletedReviewer, deletedAssetManager;
      if (vm.asset.valuationFrequency.value === 'Annually' && !checkValidDates()) {
        return;
      }
      // Make image optional
      if (vm.editAssetForm.$invalid /*|| vm.picture === '/assets/images/dragBg.png' ||
        vm.picture === '/assets/images/ic_ErrorFile.png' */) {
        return;
      }
      if (!checkFrequencies() || !vm.validRollOverDate) {
        return;
      }

      // Remove Valuations which their due dates has been changed on the Asset
      var scheduleDates = [],
        valuationRemovalPromises = [];

      if (vm.asset.valuationFrequency.value === 'Annually') {
        scheduleDates = [vm.asset.scheduleQ1];
      }
      else if (vm.asset.valuationFrequency.value === 'SemiAnnually') {
        scheduleDates = [
          vm.asset.scheduleQ1,
          vm.asset.scheduleQ2
        ];
      }

      if (vm.asset.valuationFrequency.value !== 'Quarterly' && vm.asset.valuations) {
        var mustDelete = true;
        for (var i = 0; i < vm.asset.valuations.length; i++) {
          var valuation = vm.asset.valuations[i];
          if (valuation.year === moment().get('year') &&
            valuation.quarter === ReviewModel.getQuarterByDate(moment())) {
            for (var j = 0; j < scheduleDates.length; j++) {
              if (ReviewModel.getQuarterByDate(scheduleDates[j]) === valuation.quarter) {
                mustDelete = false;
                break;
              }
            }
            if (mustDelete) {
              valuationRemovalPromises.push(ValuationService.deleteValuation(valuation.id));
            }
            break;
          }
        }
      }

      $q.all(valuationRemovalPromises);

      LoaderHelper.open();
      vm.uiLoading = true;

      var currentValuation = false,
        currentYear = new moment().get('year'),
        currentQuarter = ReviewModel.getQuarterByDate(moment());

      if (vm.asset.valuations.length > 0) {
        for (i = 0; i < vm.asset.valuations.length; i++) {
          if (vm.asset.valuations[i].year === currentYear &&
            vm.asset.valuations[i].quarter === currentQuarter) {
            currentValuation = true;
            break;
          }
        }
      }

      if (!currentValuation) {
        var newValuationPromises = [];
        var newPeriod = {},
          newValuationYear = null,
          newValuationQuarter = null,
          nextDraftDate = null;

        if ('Annually' === vm.asset.valuationFrequency.value
          && (ReviewModel.getQuarterByDate(vm.asset.scheduleQ1) === currentQuarter)
          && (new moment(vm.asset.scheduleQ1).get('year') <= currentYear)) {
          newValuationQuarter = ReviewModel.getQuarterByDate(vm.asset.scheduleQ1);
          newValuationYear = currentYear;
          nextDraftDate = new moment(vm.asset.scheduleQ1);
          nextDraftDate.set('year', currentYear);
          newPeriod = {
            id: undefined,
            year: newValuationYear,
            quarter: newValuationQuarter,
            isPrimary: true
          };

        } else if ('SemiAnnually' === vm.asset.valuationFrequency.value) {
          if ((ReviewModel.getQuarterByDate(vm.asset.scheduleQ1) === currentQuarter)
            && (new moment(vm.asset.scheduleQ1).get('year') <= currentYear)) {
            newValuationQuarter = ReviewModel.getQuarterByDate(vm.asset.scheduleQ1);
            newValuationYear = currentYear;
            nextDraftDate = new moment(vm.asset.scheduleQ1);
            nextDraftDate.set('year', currentYear);
            newPeriod = {
              id: undefined,
              year: newValuationYear,
              quarter: newValuationQuarter,
              isPrimary: true
            };

          } else if ((ReviewModel.getQuarterByDate(vm.asset.scheduleQ2) === currentQuarter)
            && (new moment(vm.asset.scheduleQ2).get('year') <= currentYear)) {
            newValuationQuarter = ReviewModel.getQuarterByDate(vm.asset.scheduleQ2);
            newValuationYear = currentYear;
            nextDraftDate = new moment(vm.asset.scheduleQ2);
            nextDraftDate.set('year', currentYear);
            newPeriod = {
              id: undefined,
              year: newValuationYear,
              quarter: newValuationQuarter,
              isPrimary: true
            };
          }
        } else if ('Quarterly' === vm.asset.valuationFrequency.value) {
          newValuationQuarter = currentQuarter;
          newValuationYear = currentYear;
          nextDraftDate = new moment(vm.asset['scheduleQ' + currentQuarter]);
          nextDraftDate.set('year', currentYear);
          newPeriod = {
            id: undefined,
            year: newValuationYear,
            quarter: newValuationQuarter,
            isPrimary: true
          };
        }
        if (vm.asset.primaryAssetAppraiser) {
          newValuationPromises.push(AssetService.addUserPeriod(
            {
              id: vm.asset.primaryAssetAppraiser.id,
              year: newPeriod.year,
              quarter: newPeriod.quarter,
              isPrimary: newPeriod.isPrimary
            }));
        } else {
          var appraisers = vm.assetUsers.filter(function (user) {
            return user.userCompanyType == "AssetAppraisal"
          });
          appraisers.forEach(function (appraiser) {
            var currentPeriod = appraiser.periods.find(function (period) {
              period.year == newPeriod.year && period.quarter == newPeriod.quarter
            });
            var valuationPeriod = appraiser.periods.find(function (period) {
              return vm.asset.valuation && vm.asset.valuation.quarter == period.quarter &&
                vm.asset.valuation.year == period.year
            })
            if (!currentPeriod && valuationPeriod) {
              newValuationPromises.push(AssetService.addUserPeriod(
                {
                  id: appraiser.id,
                  year: newPeriod.year,
                  quarter: newPeriod.quarter,
                  isPrimary: valuationPeriod.isPrimary
                }));
            }
          });
        }
        if (vm.asset.primaryAssetReviewer) {
          var currentPriod = vm.asset.primaryAssetReviewer.periods.find(function (period) {
            return newValuationQuarter == period.quarter &&
              newValuationYear == period.year && period.isPrimary
          })

          if (!currentPriod) {
            newValuationPromises.push(AssetService.addUserPeriod(
              {
                id: vm.asset.primaryAssetReviewer.id,
                year: newPeriod.year,
                quarter: newPeriod.quarter,
                isPrimary: newPeriod.isPrimary
              }));
          }
        } else if (vm.selectedLeadReviewer && vm.selectedLeadReviewer.user.id != vm.leadReviewer.user.id) {
          deletedReviewer = vm.selectedLeadReviewer.id;
          newValuationPromises.push(AssetService.removeUser(vm.selectedLeadReviewer.id).then(function () {
            return AssetService.addPrimaryUserWithType(asset.id, vm.leadReviewer.user.id, 'PrimaryAssetReviewer', true).then(function (user) {
              AssetService.addUserPeriod({ id: user.id, quarter: newPeriod.quarter, year: newPeriod.year, isPrimary: newPeriod.isPrimary })
            });
          }));
        } else if (vm.selectedLeadReviewer && vm.selectedLeadReviewer.user.id == vm.leadReviewer.user.id) {
          var currentPriod = vm.selectedLeadReviewer.periods.find(function (period) {
            return newValuationQuarter == period.quarter &&
              newValuationYear == period.year && period.isPrimary
          })

          if (!currentPriod) {
            newValuationPromises.push(AssetService.addUserPeriod({ id: vm.selectedLeadReviewer.id, quarter: newPeriod.quarter, year: newPeriod.year, isPrimary: newPeriod.isPrimary }))
          }
        } else if (vm.leadReviewer && !vm.selectedLeadReviewer) {
          AssetService.addPrimaryUserWithType(asset.id, vm.leadReviewer.user.id, 'PrimaryAssetReviewer', true).then(function (user) {
            AssetService.addUserPeriod({ id: user.id, quarter: newPeriod.quarter, year: newPeriod.year, isPrimary: newPeriod.isPrimary })
          });
        }
        if (vm.asset.primaryAssetManager) {
          var currentPriod = vm.asset.primaryAssetManager.periods.find(function (period) {
            return newValuationQuarter == period.quarter &&
              newValuationYear == period.year && period.isPrimary
          })

          if (!currentPriod) {
            newValuationPromises.push(AssetService.addUserPeriod(
              {
                id: vm.asset.primaryAssetManager.id,
                year: newPeriod.year,
                quarter: newPeriod.quarter,
                isPrimary: newPeriod.isPrimary
              }
            ));
          }
        } else if (vm.selectedLeadAsset && vm.selectedLeadAsset.user.id != vm.leadAssetManager.user.id) {
          deletedAssetManager = vm.selectedLeadAsset.id;
          newValuationPromises.push(AssetService.removeUser(vm.selectedLeadAsset.id).then(function () {
            return AssetService.addPrimaryUserWithType(asset.id, vm.leadAssetManager.user.id, 'PrimaryAssetManager', true).then(function (user) {
              AssetService.addUserPeriod({ id: user.id, quarter: newPeriod.quarter, year: newPeriod.year, isPrimary: newPeriod.isPrimary })
            });
          }));

        } else if (vm.selectedLeadAsset && vm.selectedLeadAsset.user.id == vm.leadAssetManager.user.id) {
          var currentPriod = vm.selectedLeadAsset.periods.find(function (period) {
            return newValuationQuarter == period.quarter &&
              newValuationYear == period.year && period.isPrimary
          })

          if (!currentPriod) {
            newValuationPromises.push(AssetService.addUserPeriod({ id: vm.selectedLeadAsset.id, quarter: newPeriod.quarter, year: newPeriod.year, isPrimary: newPeriod.isPrimary }))
          }
        } else if (vm.leadAssetManager && !vm.selectedLeadAsset) {
          AssetService.addPrimaryUserWithType(asset.id, vm.leadAssetManager.user.id, 'PrimaryAssetManager', true).then(function (user) {
            AssetService.addUserPeriod({ id: user.id, quarter: newPeriod.quarter, year: newPeriod.year, isPrimary: newPeriod.isPrimary })
          });
        }

        var yearOfCycle = 1,
          quarterOfCycle = 1,
          recentQuarterDate,
          quarter,
          quarterYear,
          oldestQuarterDate = vm.asset.scheduleQ1;

        if (vm.asset.valuations.length > 0 && vm.asset.valuations[0].valuationCycle > 1) {
          var firstQuarter,
            firstYear;
          for (i = 0; i < vm.asset.valuations.length; i++) {
            var previousValuation = vm.asset.valuations[i];
            // if(previousValuation.valuationCycle === vm.asset.valuation.valuationCycle &&
            //   1 === previousValuation.quarterOfCycle) {
            if (previousValuation.valuationCycle === vm.asset.valuation.valuationCycle) {
              firstQuarter = previousValuation.quarter;
              firstYear = previousValuation.year;
              break;
            }
          }
          quarter = currentQuarter;
          yearOfCycle = currentYear - firstYear;
          if ('Annually' === vm.asset.valuationFrequency.value) {
            yearOfCycle++;
            quarterOfCycle = yearOfCycle;
          } else if ('SemiAnnually' === vm.asset.valuationFrequency.value) {
            quarterOfCycle = yearOfCycle * 2;
            oldestQuarter = firstQuarter;
            recentQuarter = currentQuarter;
            if (oldestQuarter <= quarter && recentQuarter <= quarter) {
              quarterOfCycle += 2;
            } else if ((oldestQuarter <= quarter && recentQuarter > quarter) ||
              (oldestQuarter > quarter && recentQuarter <= quarter)) {
              quarterOfCycle += 1;
            }
          } else if ('Quarterly' === vm.asset.valuationFrequency.value) {
            quarterOfCycle = yearOfCycle * 4;
            quarterOfCycle += quarter - firstQuarter + 1;
          }

        } else {
          if ('SemiAnnually' === vm.asset.valuationFrequency.value) {
            recentQuarterDate = vm.asset.scheduleQ2;
            if (oldestQuarterDate > vm.asset.scheduleQ2) {
              oldestQuarterDate = vm.asset.scheduleQ2;
              recentQuarterDate = vm.asset.scheduleQ1;
            }
          } else if ('Quarterly' === vm.asset.valuationFrequency.value) {
            if (oldestQuarterDate > vm.asset.scheduleQ2) {
              oldestQuarterDate = vm.asset.scheduleQ2;
            }
            if (oldestQuarterDate > vm.asset.scheduleQ3) {
              oldestQuarterDate = vm.asset.scheduleQ3;
            }
            if (oldestQuarterDate > vm.asset.scheduleQ4) {
              oldestQuarterDate = vm.asset.scheduleQ4;
            }
          }

          oldestQuarterDate = new moment(oldestQuarterDate);
          quarter = currentQuarter;
          var oldestQuarterMomentDate = moment(oldestQuarterDate);
          yearOfCycle = currentYear - oldestQuarterMomentDate.get('year');
          if ('Annually' === vm.asset.valuationFrequency.value) {
            yearOfCycle++;
            quarterOfCycle = yearOfCycle;
            quarter = ReviewModel.getQuarterByDate(vm.asset.scheduleQ1);
          } else if ('SemiAnnually' === vm.asset.valuationFrequency.value) {
            quarterOfCycle = yearOfCycle * 2;
            var oldestQuarter = ReviewModel.getQuarterByDate(oldestQuarterDate),
              recentQuarter = ReviewModel.getQuarterByDate(recentQuarterDate);
            if (oldestQuarter <= quarter && recentQuarter <= quarter) {
              quarterOfCycle += 2;
            } else if ((oldestQuarter <= quarter && recentQuarter > quarter) ||
              (oldestQuarter > quarter && recentQuarter <= quarter)) {
              quarterOfCycle += 1;
            }
          } else if ('Quarterly' === vm.asset.valuationFrequency.value) {
            quarterOfCycle = yearOfCycle * 4;
            quarterOfCycle += quarter -
              ReviewModel.getQuarterByDate(oldestQuarterMomentDate) + 1;
          }
          if ('Annually' !== vm.asset.valuationFrequency.value &&
            quarter >= ReviewModel.getQuarterByDate(oldestQuarterMomentDate)) {
            yearOfCycle++;
          }
        }

        newValuationPromises.push(ValuationService.createValuation({
          assetId: vm.asset.id,
          year: newValuationYear,
          quarter: newValuationQuarter,
          yearOfCycle: yearOfCycle == 0 ? 1 : yearOfCycle,
          quarterOfCycle: quarterOfCycle,
          valuationCycle: vm.asset.valuation && vm.asset.valuation.valuationCycle ? vm.asset.valuation.valuationCycle : 1,
          nextDraftDueDate: UtcDateConverter.setDateToUTC(nextDraftDate)
        }));

        $q.all(newValuationPromises);
      }

      var assetDTO = {};
      angular.copy(vm.asset, assetDTO);
      delete assetDTO.picture;
      if (vm.asset.bidGroupId) {
        assetDTO.bidGroupId = vm.asset.bidGroupId.id;
      }
      assetDTO.type = vm.asset.type.type;
      if (vm.asset.subType) {
        assetDTO.subType = vm.asset.subType.type;
      }
      if (vm.asset.ownership) {
        assetDTO.ownership = vm.asset.ownership.type;
      }
      assetDTO.region = vm.asset.region ? vm.asset.region.type : undefined;
      assetDTO.address = vm.asset.address.address;
      assetDTO.city = vm.asset.address.city;
      assetDTO.country = vm.asset.address.country;
      assetDTO.state = vm.asset.address.state;
      assetDTO.zip = vm.asset.address.zip;
      assetDTO.newInternalAppraisers = vm.newInternalAppraisers;
      // GroundLeased (Yes/No) convert to (true/false)
      var groundLeasedDictionary = {};
      groundLeasedDictionary[GROUNDLEASED[0]] = true;
      groundLeasedDictionary[GROUNDLEASED[1]] = false;
      assetDTO.groundLeased = $filter('stringToBoolean')(groundLeasedDictionary, vm.asset.groundLeased);
      if (vm.asset.rollOverDate && !vm.isAM) {
        assetDTO.rollOverDate = scheduleDateParser(vm.asset.rollOverDate);
      } else {
        delete assetDTO.rollOverDate;
        delete assetDTO.nextRollOverDate;
      }
      assetDTO.scheduleOption = parseInt(assetDTO.scheduleOption);
      assetDTO.valuationFrequency = vm.asset.valuationFrequency.value;
      assetDTO.requiredAppraisers = vm.asset.requiredAppraisers.value;

      if ('Annually' === assetDTO.valuationFrequency) {
        assetDTO.scheduleQ1 = scheduleDateParser(vm.asset.scheduleQ1);
        delete assetDTO.scheduleQ2;
        delete assetDTO.scheduleQ3;
        delete assetDTO.scheduleQ4;
      }
      else if ('SemiAnnually' === assetDTO.valuationFrequency) {
        assetDTO.scheduleQ1 = scheduleDateParser(vm.asset.scheduleQ1);
        assetDTO.scheduleQ2 = scheduleDateParser(vm.asset.scheduleQ2);
        delete assetDTO.scheduleQ3;
        delete assetDTO.scheduleQ4;
      }
      else if ('Quarterly' === assetDTO.valuationFrequency) {
        assetDTO.scheduleQ1 = scheduleDateParser(vm.asset.scheduleQ1);
        assetDTO.scheduleQ2 = scheduleDateParser(vm.asset.scheduleQ2);
        assetDTO.scheduleQ3 = scheduleDateParser(vm.asset.scheduleQ3);
        assetDTO.scheduleQ4 = scheduleDateParser(vm.asset.scheduleQ4);
      }

      // Update Asset
      var promises = [];
      
      assetDTO.internalAppraisers = vm.asset.internalAppraisers;

      var isAnyValuationIsFinished = vm.asset.valuations.findIndex(function (valuation) {
        return valuation.status.toLowerCase() !== 'finished';
      });

      if (isAnyValuationIsFinished > -1 && vm.selectedLeadAsset && vm.selectedLeadAsset.user.id != vm.leadAssetManager.user.id && vm.selectedLeadAsset.id != deletedAssetManager) {
        vm.selectedLeadAsset.periods.forEach(function (sPeriod) {
          var sValuation = vm.asset.valuations.find(function (val) {
            return val.quarter == sPeriod.quarter && val.year == sPeriod.year && sPeriod.isPrimary;
          });
          sValuation && sValuation.status.toLowerCase() != 'finished' && AssetService.deletePeriod(sPeriod.id);
        });


        AssetService.addPrimaryUserWithType(asset.id, vm.leadAssetManager.user.id, 'PrimaryAssetManager', true).then(function (user) {
          vm.asset.valuations.forEach(function (valuation) {
            if (valuation.status.toLowerCase() !== 'finished') {
              AssetService.addUserPeriod({ id: user.id, quarter: valuation.quarter, year: valuation.year, isPrimary: true })
            }
          });
        });

      } else if (vm.selectedLeadAsset && vm.selectedLeadAsset && vm.selectedLeadAsset.user.id != vm.leadAssetManager.user.id && vm.selectedLeadAsset.id != deletedAssetManager && vm.asset.valuation.status !== 'Finished') {
        promises.push(AssetService.removeUser(vm.selectedLeadAsset.id).then(function () {
          // return AssetService.addPrimaryAssetManager(asset.id, vm.leadAssetManager.user.id);
          return AssetService.addPrimaryUserWithType(asset.id, vm.leadAssetManager.user.id, 'PrimaryAssetManager', true).then(function (user) {
            vm.asset.valuations.forEach(function (valuation) {
              if (valuation.status.toLowerCase() !== 'finished') {
                AssetService.addUserPeriod({ id: user.id, quarter: valuation.quarter, year: valuation.year, isPrimary: true })
              }
            })
          });
        }));
      } else if (vm.leadAssetManager && !vm.selectedLeadAsset && vm.asset.valuation && vm.asset.valuation.status !== 'Finished') {
        // promises.push(AssetService.addPrimaryAssetManager(asset.id, vm.leadAssetManager.user.id));
        promises.push(AssetService.addPrimaryUserWithType(asset.id, vm.leadAssetManager.user.id, 'PrimaryAssetManager', true).then(function (user) {
          vm.asset.valuations.forEach(function (valuation) {
            if (valuation.status.toLowerCase() !== 'finished') {
              AssetService.addUserPeriod({ id: user.id, quarter: valuation.quarter, year: valuation.year, isPrimary: true })
            }
          })
        }));
      }



      if (isAnyValuationIsFinished > -1 && vm.selectedLeadReviewer && vm.selectedLeadReviewer.user.id != vm.leadReviewer.user.id && vm.selectedLeadReviewer.id != deletedReviewer) {
        vm.selectedLeadReviewer.periods.forEach(function (sPeriod) {
          var sValuation = vm.asset.valuations.find(function (val) {
            return val.quarter == sPeriod.quarter && val.year == sPeriod.year && sPeriod.isPrimary;
          });
          sValuation && sValuation.status.toLowerCase() != 'finished' && AssetService.deletePeriod(sPeriod.id);
        });


        AssetService.addPrimaryUserWithType(asset.id, vm.leadReviewer.user.id, 'PrimaryAssetReviewer', true).then(function (user) {
          vm.asset.valuations.forEach(function (valuation) {
            if (valuation.status.toLowerCase() !== 'finished') {
              AssetService.addUserPeriod({ id: user.id, quarter: valuation.quarter, year: valuation.year, isPrimary: true })
            }
          });
        });
      } else if (vm.selectedLeadReviewer && vm.selectedLeadReviewer.user.id != vm.leadReviewer.user.id && vm.selectedLeadReviewer.id != deletedReviewer && vm.asset.valuation.status !== 'Finished') {
        promises.push(AssetService.removeUser(vm.selectedLeadReviewer.id).then(function () {
          // return AssetService.addPrimaryReviewer(asset.id, vm.leadReviewer.user.id);
          return AssetService.addPrimaryUserWithType(asset.id, vm.leadReviewer.user.id, 'PrimaryAssetReviewer', true).then(function (user) {
            vm.asset.valuations.forEach(function (valuation) {
              if (valuation.status.toLowerCase() !== 'finished') {
                AssetService.addUserPeriod({ id: user.id, quarter: valuation.quarter, year: valuation.year, isPrimary: true })
              }
            })
          });
        }));
      } else if (vm.leadReviewer && !vm.selectedLeadReviewer && vm.asset.valuation && vm.asset.valuation.status !== 'Finished') {
        promises.push(AssetService.addPrimaryUserWithType(asset.id, vm.leadReviewer.user.id, 'PrimaryAssetReviewer', true).then(function (user) {
          vm.asset.valuations.forEach(function (valuation) {
            if (valuation.status.toLowerCase() !== 'finished') {
              AssetService.addUserPeriod({ id: user.id, quarter: valuation.quarter, year: valuation.year, isPrimary: true })
            }
          })
        }));
        // promises.push(AssetService.addPrimaryReviewer(asset.id, vm.leadReviewer.user.id));
      }

      // Update Image
      if (vm.picture !== vm.asset.picture && vm.picture !== '/assets/images/dragBg.png' && vm.picture !== '/assets/images/ic_ErrorFile.png') {
        promises.push(AssetService.updateImage(asset.id, vm.picture));
      }

      // Update Documents
      vm.documentsToUpload.forEach(function (file) {
        var fileVersion = 1;
        vm.documents.assetDocuments.forEach(function (document) {
          if (document.name === file.name) {
            fileVersion++;
          }
        });
        promises.push(AssetService.documentCreate(asset.id, file, file.name, 'Other', undefined, fileVersion.toString()));
      });

      // Deal with internalAppraisers

      var removeOldInternalAppraisersPromises = [];
      var addPrimaryInternalAppraiser = false;
      var addSecondaryInternalAppraiser = false;
      var removeOldPrimary = false;
      var removeOldSecondary = false;
      var scheduleOprionChanged = false;

      if (!vm.selectedInternalAppraisers || (vm.selectedInternalAppraisers && vm.selectedInternalAppraisers.length > 0
        && vm.asset.internalAppraisers && vm.asset.internalAppraisers.length > 0)) {
        if (!vm.selectedInternalAppraisers || vm.selectedInternalAppraisers[0].user.id !== vm.asset.internalAppraisers[0].user.id) {
          addPrimaryInternalAppraiser = true;
          if (vm.asset.internalAppraisers.length === 1 || (vm.asset.internalAppraisers.length > 1
            && vm.selectedInternalAppraisers[0].user.id !== vm.asset.internalAppraisers[1].user.id)) {
            removeOldPrimary = true;
          }
        }
      } else if (vm.selectedInternalAppraisers && vm.selectedInternalAppraisers.length > 0) {
        // Dont remove the user in userasset relationship for now. Does not harm to leave them alone
        //removeOldInternalAppraisersPromises.push(AssetService.removeUser(vm.selectedInternalAppraisers[0].relationId))
        //removeOldInternalAppraisersPromises.push(AssetService.updateUser({id: vm.selectedInternalAppraisers[0].relationId, userId: vm.selectedInternalAppraisers[0].user.id, active: false}));

      }

      if (vm.asset.scheduleOption != vm.selectedScheduleOption) {
        scheduleOprionChanged = true;
      }

      if (vm.asset.internalAppraisers && vm.asset.internalAppraisers.length > 1)
        if (vm.selectedInternalAppraisers.length <= 1
          || vm.selectedInternalAppraisers[1].user.id !== vm.asset.internalAppraisers[1].user.id) {
          addSecondaryInternalAppraiser = true;
          if (vm.selectedInternalAppraisers.length > 1 && vm.selectedInternalAppraisers[1].user.id !== vm.asset.internalAppraisers[0].user.id) {
            removeOldSecondary = true;
          }
        } else if (vm.selectedInternalAppraisers && vm.selectedInternalAppraisers.length > 1) {
          //removeOldInternalAppraisersPromises.push(AssetService.updateUser({id: vm.selectedInternalAppraisers[1].relationId, userId: vm.selectedInternalAppraisers[1].user.id, active: false}));

          // Dont remove the user in userasset relationship for now. Does not harm to leave them alone
          /*
          // see if the user can be removed
          var removeUser = true;
          for(var i = 0; vm.asset.valuation && i < vm.asset.valuations.length; i++) {
            var valuation = vm.asset.valuations[i];
            if (valuation.status === 'Finished') {
              vm.assetUsers.forEach(function (aUser) {
                for (var j = 0; aUser.user.id === vm.selectedInternalAppraisers[1].user.id &&  j < aUser.periods.length; i++) {
                  var tempPeriod = aUser.periods[j];
                  if (tempPeriod.quarter === valuation.quarter && tempPeriod.year === valuation.year) {
                      removeUser = false; // this user is involved in a Finshed valuation
                  }
                }
              })
            }
          }
          if (removeUser) {
            removeOldInternalAppraisersPromises.push(AssetService.removeUser(vm.selectedInternalAppraisers[1].relationId));
          }
          */
        }
      promises.push($q.all(removeOldInternalAppraisersPromises).then(function (user) {
        if ('InternalAndExternal' === vm.asset.requiredAppraisers.value && 'Annually' !== assetDTO.valuationFrequency && vm.asset.internalAppraisers && vm.asset.internalAppraisers.length > 0) {
          var primaryInternalAppraiserUserId = vm.asset.internalAppraisers[0].user.id;
          var secondaryInternalAppraiserUserId = null;
          if (vm.asset.internalAppraisers.length > 1) {
            secondaryInternalAppraiserUserId = vm.asset.internalAppraisers[1].user.id;
          }
          var periodsForInternalAppraisers = [];
          var periodForExtrenalAppraiser = [];
          var years = [];

          vm.asset.valuations.forEach(function (valuation) {
            var ind = years.indexOf(valuation.year);
            if (ind == -1) {
              years.push(valuation.year);
            }
          });

          for (var i = 0; i < years.length; i++) {
            var single = years[i]
            if (vm.asset.scheduleQ1 && vm.asset.scheduleOption != 1) {
              // if scheduleOption is 1 then Q1 should go to external
              var firstDraftDate = moment(vm.asset.scheduleQ1);
              // var q1Year = firstDraftDate.get('year');
              var q1Quarter = ReviewModel.getQuarterByDate(firstDraftDate);
              periodsForInternalAppraisers.push({ year: single, quarter: q1Quarter });
            } else {
              var firstDraftDate = moment(vm.asset.scheduleQ1);
              // var q1Year = firstDraftDate.get('year');
              var q1Quarter = ReviewModel.getQuarterByDate(firstDraftDate);
              periodForExtrenalAppraiser.push({ year: single, quarter: q1Quarter });
            }
            if (vm.asset.scheduleQ2 && vm.asset.scheduleOption != 2) {
              // if scheduleOption is 2 then Q2 should go to external
              var secondDraftDate = moment(vm.asset.scheduleQ2);
              // var q2Year = secondDraftDate.get('year');
              var q2Quarter = ReviewModel.getQuarterByDate(secondDraftDate);
              periodsForInternalAppraisers.push({ year: single, quarter: q2Quarter });
            } else {
              var secondDraftDate = moment(vm.asset.scheduleQ2);
              // var q2Year = secondDraftDate.get('year');
              var q2Quarter = ReviewModel.getQuarterByDate(secondDraftDate);
              periodForExtrenalAppraiser.push({ year: single, quarter: q2Quarter });
            }
            if (vm.asset.scheduleQ3 && vm.asset.scheduleOption != 3) {
              // if scheduleOption is 3 then Q3 should go to external
              var thirdDraftDate = moment(vm.asset.scheduleQ3);
              // var q3Year = thirdDraftDate.get('year');
              var q3Quarter = ReviewModel.getQuarterByDate(thirdDraftDate);
              periodsForInternalAppraisers.push({ year: single, quarter: q3Quarter });
            } else {
              var thirdDraftDate = moment(vm.asset.scheduleQ3);
              // var q3Year = thirdDraftDate.get('year');
              var q3Quarter = ReviewModel.getQuarterByDate(thirdDraftDate);
              periodForExtrenalAppraiser.push({ year: single, quarter: q3Quarter });
            }
            if (vm.asset.scheduleQ4 && vm.asset.scheduleOption != 4) {
              // if scheduleOption is 4 then Q4 should go to external
              var fourthDraftDate = moment(vm.asset.scheduleQ4);
              // var q4Year = fourthDraftDate.get('year');
              var q4Quarter = ReviewModel.getQuarterByDate(fourthDraftDate);
              periodsForInternalAppraisers.push({ year: single, quarter: q4Quarter });
            } else {
              var fourthDraftDate = moment(vm.asset.scheduleQ4);
              // var q4Year = fourthDraftDate.get('year');
              var q4Quarter = ReviewModel.getQuarterByDate(fourthDraftDate);
              periodForExtrenalAppraiser.push({ year: single, quarter: q4Quarter });
            }
          }
          var addInternalAppraisersPromises = [];
          if ((primaryInternalAppraiserUserId && addPrimaryInternalAppraiser) || (primaryInternalAppraiserUserId && scheduleOprionChanged)) {
            updateInternalAppraiser(primaryInternalAppraiserUserId, addInternalAppraisersPromises, periodsForInternalAppraisers, true, removeOldPrimary);
          }

          if (secondaryInternalAppraiserUserId && addSecondaryInternalAppraiser || (secondaryInternalAppraiserUserId && scheduleOprionChanged)) {
            updateInternalAppraiser(secondaryInternalAppraiserUserId, addInternalAppraisersPromises, periodsForInternalAppraisers, false, removeOldSecondary);
          } else {
            //check if it a case of secondary existed but now removed
            // remove periods if not Finished
            if (vm.asset.internalAppraisers.length === 1 && vm.selectedInternalAppraisers.length > 1) {
              if (vm.selectedInternalAppraisers[1].user.id !== primaryInternalAppraiserUserId) {
                addInternalAppraisersPromises.push(AssetService.updateUser({ id: vm.selectedInternalAppraisers[1].relationId, userId: vm.selectedInternalAppraisers[1].user.id, active: false }));
                vm.assetUsers.forEach(function (aUser) {
                  if (aUser.user.id === secondaryInternalAppraiserUserId) {

                    periodsForInternalAppraisers.forEach(function (period) {
                      // check if period exists for old primary user 
                      var oldPeriodId = getPeriodForUserForQuarterIfExists(vm.selectedInternalAppraisers[1].user.id, period.year, period.quarter);

                      if (getValuationStatusForQuarterIfExists(period.year, period.quarter) !== 'Finished') {
                        if (oldPeriodId !== -1) {
                          // Delete old if exists
                          addInternalAppraisersPromises.push(AssetService.deletePeriod(oldPeriodId));
                        }
                      }
                    });
                  }
                });
              }
            }
          }

          vm.assetUsers.forEach(function (aUser) {
            if (aUser.userCompanyType == "AssetAppraisal" & aUser.userCompanyId !== 14405) {
              var isPrimary = aUser.isPrimary;
              aUser.periods.forEach(function (period) {
                isPrimary = period.isPrimary;
                var valuation = asset.valuations.find(function (valuation) {
                  return valuation.quarter == period.quarter && valuation.year == period.year
                })
                if (valuation && valuation.status !== 'Finished') {
                  addInternalAppraisersPromises.push(AssetService.deletePeriod(period.id).then(function () {
                  }));
                }
              });
              if (aUser.periods.length > 0) {
                periodForExtrenalAppraiser.forEach(function (ap) {
                  var valuation2 = asset.valuations.find(function (valuation) {
                    return valuation.quarter == ap.quarter && valuation.year == ap.year
                  });
                  if ((valuation2 && valuation2.status !== 'Finished') || !valuation2) {
                    addInternalAppraisersPromises.push(AssetService.addUserPeriod({ id: aUser.id, year: ap.year, quarter: ap.quarter, isPrimary: isPrimary }));
                  }
                });
              }
            }
          });
          return $q.all(addInternalAppraisersPromises);
        }
      }));

      $q.all(promises).then(function () {
        if (vm.editAssetForm.$dirty) {
            AssetService.updateAsset(assetDTO).then(function () {
                notify({
                    message: $filter('translate')('ASSETS.ASSET_UPDATED'),
                    duration: 4000,
                    templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
                    classes: 'alert-info',
                    position: 'center'
                });
                $state.go('app.asset.all', {}, { reload: true });
            });
        } else {
            notify({
                message: $filter('translate')('ASSETS.ASSET_UPDATED'),
                duration: 4000,
                templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
                classes: 'alert-info',
                position: 'center'
            });
            $state.go('app.asset.all', {}, { reload: true });
        }
    }, function () {
        vm.uiLoading = false;
        LoaderHelper.close();
    });

    };

    function updateInternalAppraiser(internalAppraiserUserId, addInternalAppraisersPromises, periodsForInternalAppraisers, primary, removeOldAppraiser) {
      var oldAppraiser = vm.selectedInternalAppraisers[0].user.id;
      var oldAppraiserRelationId = vm.selectedInternalAppraisers[0].relationId;
      if (!primary && vm.selectedInternalAppraisers.length > 1) {
        oldAppraiser = vm.selectedInternalAppraisers[1].user.id;
        oldAppraiserRelationId = vm.selectedInternalAppraisers[1].relationId;
      }
      var userAssetRelationshipType = 'PrimaryAssetAppraiser';
      if (!primary) {
        userAssetRelationshipType = 'SecondaryAssetAppraiser';
      }
      if (getUserAssetRelationIfExists(internalAppraiserUserId) === -1) {
        addInternalAppraisersPromises.push(AssetService.addUser(asset.id, internalAppraiserUserId, userAssetRelationshipType).then(function (user) {
          var addPriodPromises = [];
          periodsForInternalAppraisers.forEach(function (period) {
            var oldPeriodId = getPeriodForUserForQuarterIfExists(oldAppraiser, period.year, period.quarter);
            var newPeriodId = getPeriodForUserForQuarterIfExists(internalAppraiserUserId, period.year, period.quarter);

            if (getValuationStatusForQuarterIfExists(period.year, period.quarter) !== 'Finished') {
              if (oldPeriodId !== -1) {
                // Delete old if exists
                addPriodPromises.push(AssetService.deletePeriod(oldPeriodId));
              }
              if (newPeriodId === -1) {
                // Add new if not exists
                addPriodPromises.push(AssetService.addUserPeriod({ id: user.id, quarter: period.quarter, year: period.year, isPrimary: primary }));
              } else {
                // Period exists for new user for some reason. Just make sure it is primary or secondary as applicable
                addPriodPromises.push(AssetService.updateUserPeriod({ id: newPeriodId, active: true, isPrimary: primary }));
              }
            }
          });
          return $q.all(addPriodPromises);
        }));
      } else {
        // Relationship exists. Could be a case of swap.
        // Add periods if not exist. Or make it primary if exists
        vm.assetUsers.forEach(function (aUser) {
          if (aUser.user.id === internalAppraiserUserId) {

            // addInternalAppraisersPromises.push(AssetService.updateUser({id: aUser.id, userId: internalAppraiserUserId, active: true, type: userAssetRelationshipType}));

            // periodsForInternalAppraisers.forEach(function (period) {
            //   // check if period exists for old primary user 
            //   var oldPeriodId = getPeriodForUserForQuarterIfExists(oldAppraiser, period.year, period.quarter);
            //   // check if period exists for new primary user 
            //   var newPeriodId = getPeriodForUserForQuarterIfExists(internalAppraiserUserId, period.year, period.quarter);

            //   if (getValuationStatusForQuarterIfExists(period.year, period.quarter) !== 'Finished') {
            //     if (oldPeriodId !== -1) {
            //       // Delete old if exists
            //       addInternalAppraisersPromises.push(AssetService.deletePeriod(oldPeriodId));
            //     }
            //     if (newPeriodId === -1) {
            //       // Add new if not exists
            //       addInternalAppraisersPromises.push(AssetService.addUserPeriod({ id: aUser.id, quarter: period.quarter, year: period.year, isPrimary: primary }));
            //     } else {
            //       // Period exists for new user for some reason. Just make sure it is primary or secondary as applicable
            //       addInternalAppraisersPromises.push(AssetService.updateUserPeriod({ id: newPeriodId, active: true, isPrimary: primary }));
            //     }
            //   }
            // });

            aUser.periods.forEach(function (period) {
              var periodValuation = asset.valuations.find(function (valuation) {
                return valuation.quarter == period.quarter && valuation.year == period.year
              });
              var existedPeriod = periodsForInternalAppraisers.find(function (iPeriod) {
                return iPeriod.quarter == period.quarter && iPeriod.year == period.year
              });

              if (periodValuation && periodValuation.status !== 'Finished' && !existedPeriod) {
                AssetService.deletePeriod(period.id);
              } else if (!periodValuation) {
                AssetService.deletePeriod(period.id);
              }
            });
            periodsForInternalAppraisers.forEach(function (period) {
              var periodValuation = asset.valuations.find(function (valuation) {
                return valuation.quarter == period.quarter && valuation.year == period.year
              });

              if (periodValuation && periodValuation.status !== 'Finished') {
                addInternalAppraisersPromises.push(AssetService.addUserPeriod({ id: aUser.id, quarter: period.quarter, year: period.year, isPrimary: primary }));
              }
            })

            // addInternalAppraisersPromises.push(AssetService.removeUser(aUser.id).then(function (deletedUser) {
            //   addInternalAppraisersPromises.push(AssetService.addUser(asset.id, internalAppraiserUserId, userAssetRelationshipType).then(function (user) {
            //     periodsForInternalAppraisers.forEach(function (period) {
            //       addInternalAppraisersPromises.push(AssetService.addUserPeriod({ id: user.id, quarter: period.quarter, year: period.year, isPrimary: primary }));
            //     })
            //    }));
            // }));


          }
        });
      }

      if (removeOldAppraiser) {
        //addInternalAppraisersPromises.push(AssetService.removeUser(oldAppraiserRelationId));
        //} else {
        addInternalAppraisersPromises.push(AssetService.updateUser({ id: oldAppraiserRelationId, userId: oldAppraiser, active: false }));
      }
    }

    function getUserAssetRelationIfExists(userId) {
      var assetUserRelationId = -1;
      vm.assetUsers.forEach(function (aUser) {
        if (userId === aUser.user.id) {
          assetUserRelationId = aUser.id; // relationId
        }
      });
      return assetUserRelationId;
    }

    function getPeriodForUserForQuarterIfExists(userId, year, quarter) {
      var periodId = -1;
      vm.assetUsers.forEach(function (aUser) {
        for (var j = 0; aUser.user.id === userId && j < aUser.periods.length; j++) {
          var tempPeriod = aUser.periods[j];
          if (tempPeriod.quarter === quarter && tempPeriod.year === year) {
            periodId = tempPeriod.id;
          }
        }
      });
      return periodId;
    }

    function getValuationStatusForQuarterIfExists(year, quarter) {
      var valuationStatus = 'NA'; // NA = Valuation does not exist

      for (var i = 0; vm.asset.valuation && i < vm.asset.valuations.length; i++) {
        var valuation = vm.asset.valuations[i];
        if (valuation.year === year && valuation.quarter === quarter) {
          valuationStatus = valuation.status;
        }
      }
      return valuationStatus;
    }

    var editCountry = $scope.$watch('editAsset.country', function () {
      vm.state = undefined;
    });

    var editState = $scope.$watch('editAsset.state', function () {
      vm.city = undefined;
      vm.msa = undefined;
    });

    var editCountryNew = $scope.$watch('editAsset.asset.address.state', function (newValue) {
      if (newValue) {
        vm.asset.region = undefined;
      }
    });

    var editStateNew = $scope.$watch('editAsset.asset.address.state', function (newValue) {
      if (newValue) {
        vm.asset.region = undefined;
        if (vm.ncreifRegionByStates[newValue]) {
          for (i = 0; i < vm.ncreifs.length; i++) {
            if (vm.ncreifs[i].type === vm.ncreifRegionByStates[newValue]) {
              vm.asset.region = vm.ncreifs[i];
              break;
            }
          }
          //var found = vm.ncreifs.find(element => element.type === vm.ncreifRegionByStates[newValue]);
        }
      }
    });

    var editType = $scope.$watch('editAsset.type', function () {
      vm.subType = undefined;
    });

    //DATEPICKER
    //------------------------------------------------------
    vm.overDuePicker = {
      opened: false
    };
    vm.q1Picker = {
      opened: false
    };
    vm.q2Picker = {
      opened: false
    };
    vm.q3Picker = {
      opened: false
    };
    vm.q4Picker = {
      opened: false
    };

    vm.openDueDatePicker = function () {
      vm.overDuePicker.opened = true;
    };

    vm.openQ1Picker = function () {
      vm.q1Picker.opened = true;
    };

    vm.openQ2Picker = function () {
      vm.q2Picker.opened = true;
    };

    vm.openQ3Picker = function () {
      vm.q3Picker.opened = true;
    };

    vm.openQ4Picker = function () {
      vm.q4Picker.opened = true;
    };

    vm.dateOptions = {
      startingDay: 1,
      showWeeks: false
    };

    vm.modelOptions = {
      debounce: {
        default: 500,
        blur: 250
      },
      getterSetter: true
    };

    function checkFrequencies() {
      var validSchedule = null;
      if ('Annually' === vm.asset.valuationFrequency.value) return true;
      if ('SemiAnnually' === vm.asset.valuationFrequency.value) {
        var firstDraftDate = moment(vm.asset.scheduleQ1),
          secondDraftDate = moment(vm.asset.scheduleQ2),
          q1Year = firstDraftDate.get('year'),
          q2Year = secondDraftDate.get('year'),
          q1Quarter = ReviewModel.getQuarterByDate(firstDraftDate),
          q2Quarter = ReviewModel.getQuarterByDate(secondDraftDate);

        validSchedule = !((q1Quarter === q2Quarter && q1Year === q2Year) ||
          (Math.abs(firstDraftDate.diff(secondDraftDate, 'months')) > 11));

        if (!validSchedule) {
          notify({
            message: $filter('translate')('ADD_ASSET.INVALID_SEMI_ANNUAL_SCHEDULE'),
            duration: 4000,
            templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
            classes: 'alert-danger',
            position: 'center'
          });
        }
        return validSchedule;

      } else if ('Quarterly' === vm.asset.valuationFrequency.value) {
        var quartersYear = [];
        for (var i = 1; i <= 4; i++) {
          quartersYear.push((new moment(vm.asset['scheduleQ' + i]).get('year')));
        }
        validSchedule = (quartersYear[0] === quartersYear[1] && quartersYear[1] === quartersYear[2] && quartersYear[2] === quartersYear[3]) ||
          (quartersYear[0] === quartersYear[1] + 1 && quartersYear[1] === quartersYear[2] && quartersYear[2] === quartersYear[3]) ||
          (quartersYear[0] === quartersYear[1] && quartersYear[1] === quartersYear[2] + 1 && quartersYear[2] === quartersYear[3]) ||
          (quartersYear[0] === quartersYear[1] && quartersYear[1] === quartersYear[2] && quartersYear[2] === quartersYear[3] + 1);
        if (!validSchedule) {
          notify({
            message: $filter('translate')('ADD_ASSET.INVALID_SCHEDULE'),
            duration: 4000,
            templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
            classes: 'alert-danger',
            position: 'center'
          });
        }
        return validSchedule;
      }
    }

    function checkValidDates() {
      var schedule1 = (new moment(vm.asset.scheduleQ1)).get('year'),
        schedule2 = (new moment(vm.asset.scheduleQ2)).get('year'),
        schedule3 = (new moment(vm.asset.scheduleQ3)).get('year'),
        schedule4 = (new moment(vm.asset.scheduleQ4)).get('year');

      if ('Quarterly' === vm.asset.valuationFrequency.value) {
        if (schedule1 !== originalSchedule.scheduleQ1.get('year') || (originalSchedule.scheduleQ2 && schedule2 !== originalSchedule.scheduleQ2.get('year'))
          && (originalSchedule.scheduleQ3 && schedule3 !== originalSchedule.scheduleQ3.get('year')) ||
          (originalSchedule.scheduleQ4.get('year') && schedule4 !== originalSchedule.scheduleQ4.get('year'))) {

          var validSchedule = (schedule1 === schedule2 && schedule2 === schedule3 && schedule3 === schedule4) ||
            (schedule1 === schedule2 + 1 && schedule2 === schedule3 && schedule3 === schedule4) ||
            (schedule1 === schedule2 && schedule2 === schedule3 + 1 && schedule3 === schedule4) ||
            (schedule1 === schedule2 && schedule2 === schedule3 && schedule3 === schedule4 + 1);
          return validSchedule;
        } else {
          return true;
        }
      } else {
        return true;
      }

    }

    function scheduleDateParser(date) {
      var myDate = date instanceof Date ? date : new Date(date);
      return UtcDateConverter.setDateToUTC(myDate);
    }

    function checkScheduleDate(schedule) {
      var founded = false,
        rollOverDate = new moment(vm.asset.rollOverDate),
        rollOverQuarter = ReviewModel.getQuarterByDate(rollOverDate),
        rollOverYear = rollOverDate.get('year'),
        newMomentDate = new moment(vm.asset['scheduleQ' + schedule]);

      if (vm.asset.valuations) {
        for (var i = 0; i < vm.asset.valuations.length; i++) {
          if (vm.asset.valuations[i].year === rollOverYear && vm.asset.valuations[i].quarter === rollOverQuarter) {
            founded = true;
            break;
          }
        }
      }
      if (originalSchedule['scheduleQ' + schedule] &&
        newMomentDate.get('year') > originalSchedule['scheduleQ' + schedule].get('year')) {
        if (!founded) {
          newMomentDate.set('year', originalSchedule['scheduleQ' + schedule].get('year'));
          // vm.asset['scheduleQ' + schedule] = newMomentDate.toDate();
          vm['invalidQuarter' + schedule] = 'You can not modify the year';
          $timeout(function () {
            vm['invalidQuarter' + schedule] = ''
          }, 6000);
        }
      } else if (originalSchedule['scheduleQ' + schedule] &&
        newMomentDate.get('year') < originalSchedule['scheduleQ' + schedule].get('year')) {
        newMomentDate.set('year', originalSchedule['scheduleQ' + schedule].get('year'));
        // vm.asset['scheduleQ' + schedule] = newMomentDate.toDate();
        vm['invalidQuarter' + schedule] = 'You can not modify the year';
        $timeout(function () {
          vm['invalidQuarter' + schedule] = ''
        }, 6000);
      }
    }
// TODO: Validate the conditions
    function validateRollOverDate(valuationFrequency, firstDraft, secondDraft, rollOverDate) {
      if ('Annually' === valuationFrequency) {
        return ReviewModel.getQuarterByDate(firstDraft) === ReviewModel.getQuarterByDate(rollOverDate);
      } else if ('SemiAnnually' === valuationFrequency) {
        return ReviewModel.getQuarterByDate(firstDraft) === ReviewModel.getQuarterByDate(rollOverDate) ||
          ReviewModel.getQuarterByDate(secondDraft) === ReviewModel.getQuarterByDate(rollOverDate);
      }
    }

    watchers.push($scope.$watch('editAsset.asset.scheduleQ1', function () {
      checkScheduleDate(1);
    }));
    watchers.push($scope.$watch('editAsset.asset.scheduleQ2', function () {
      checkScheduleDate(2);
    }));
    watchers.push($scope.$watch('editAsset.asset.scheduleQ3', function () {
      if ('Quarterly' === vm.asset.valuationFrequency.value) checkScheduleDate(3);

    }));
    watchers.push($scope.$watch('editAsset.asset.scheduleQ4', function () {
      if ('Quarterly' === vm.asset.valuationFrequency.value) checkScheduleDate(4);
    }));

    var frequencyWatch = $scope.$watch('editAsset.asset.valuationFrequency', function (newValue, oldValue) {
      if (!angular.equals(newValue, oldValue)) {
        if (newValue) {
          // vm.asset.rollOverDate = undefined;
        }
        if (newValue && 'Annually' === newValue.value) {

          if (vm.asset.requiredAppraisers && vm.asset.requiredAppraisers.value !== 'ExternalOnly') {
            //vm.asset.requiredAppraisers = undefined;
            //vm.asset.requiredAppraisers = requiredAppraisers.items[0]; // Default to first which is ExternalOnly
          }
          if (oldValue.value === 'Quarterly') {
            if (vm.asset.scheduleOption == 1) {
              vm.asset.scheduleQ1 = vm.asset.scheduleQ1;
            } else if (vm.asset.scheduleOption == 2) {
              vm.asset.scheduleQ1 = vm.asset.scheduleQ2;
            } else if (vm.asset.scheduleOption == 3) {
              vm.asset.scheduleQ1 = vm.asset.scheduleQ3;
            } else {
              vm.asset.scheduleQ1 = vm.asset.scheduleQ4;
            }
          } else {
            if (vm.asset.scheduleOption == 1) {
              vm.asset.scheduleQ1 = vm.asset.scheduleQ1;
            } else if (vm.asset.scheduleOption == 2) {
              vm.asset.scheduleQ1 = vm.asset.scheduleQ2;
            }
          }
          vm.asset.scheduleOption = 1;
          vm.asset.scheduleQ2 = null;
          vm.asset.scheduleQ3 = null;
          vm.asset.scheduleQ4 = null;
          if (vm.asset.scheduleQ1 && vm.asset.rollOverDate) {
            vm.validRollOverDate = validateRollOverDate('Annually', vm.asset.scheduleQ1, undefined, vm.asset.rollOverDate);
            if(!vm.validRollOverDate) {
              notify({
                message: $filter('translate')('ADD_ASSET.INVALID_ANNUAL_ROLL_OVER_DATE'),
                duration: 5000,
                templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
                classes: 'alert-danger',
                position: 'center'
              });
            }

          }
        } else if (newValue && 'SemiAnnually' === newValue.value) {
          if (oldValue.value === 'Annually') {
            var quarter = ReviewModel.getQuarterByDate(vm.asset.scheduleQ1);
            if (quarter == 1 || quarter == 2) {
              vm.asset.scheduleOption = 1
              vm.asset.scheduleQ2 = null;
            }
            else {
              vm.asset.scheduleOption = 2;
              vm.asset.scheduleQ2 = vm.asset.scheduleQ1;
              vm.asset.scheduleQ1 = null;
            }
          } else {
            if (vm.asset.scheduleOption == 1) {
              vm.asset.scheduleQ2 = null;
              vm.asset.scheduleQ3 = null;
              vm.asset.scheduleQ4 = null;
            } else if (vm.asset.scheduleOption == 2) {
              vm.asset.scheduleOption = 1
              vm.asset.scheduleQ1 = vm.asset.scheduleQ2;
              vm.asset.scheduleQ2 = null;
              vm.asset.scheduleQ3 = null;
              vm.asset.scheduleQ4 = null;
            } else if (vm.asset.scheduleOption == 3) {
              vm.asset.scheduleOption = 2
              vm.asset.scheduleQ1 = null;
              vm.asset.scheduleQ2 = vm.asset.scheduleQ3;
              vm.asset.scheduleQ3 = null;
              vm.asset.scheduleQ4 = null;
            } else {
              vm.asset.scheduleOption = 2
              vm.asset.scheduleQ1 = null;
              vm.asset.scheduleQ2 = vm.asset.scheduleQ4;
              vm.asset.scheduleQ3 = null;
              vm.asset.scheduleQ4 = null;
            }
            vm.asset.scheduleQ3 = null;
            vm.asset.scheduleQ4 = null;
          }
          if (vm.asset.scheduleQ1 && vm.asset.scheduleQ2 && vm.asset.rollOverDate) {
            vm.validRollOverDate = validateRollOverDate('SemiAnnually', vm.asset.scheduleQ1, vm.asset.scheduleQ2,
              vm.asset.rollOverDate);
            if(!vm.validRollOverDate) {
              notify({
                message: $filter('translate')('ADD_ASSET.INVALID_SEMI_ROLL_OVER_DATE'),
                duration: 5000,
                templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
                classes: 'alert-danger',
                position: 'center'
              });
            }
          }
        } else if (newValue && 'Quarterly' === newValue.value) {
          if (oldValue.value === 'SemiAnnually') {
            if (vm.asset.scheduleOption == 1) {
              vm.asset.scheduleOption = ReviewModel.getQuarterByDate(vm.asset.scheduleQ1);
              if (vm.asset.scheduleOption == 2) {
                vm.asset.scheduleQ2 = vm.asset.scheduleQ1;
                vm.asset.scheduleQ1 = null;
                vm.asset.scheduleQ3 = null;
                vm.asset.scheduleQ4 = null;
              }
            } else {
              vm.asset.scheduleOption = ReviewModel.getQuarterByDate(vm.asset.scheduleQ2);
              if (vm.asset.scheduleOption == 3) {
                vm.asset.scheduleQ3 = vm.asset.scheduleQ2;
                vm.asset.scheduleQ1 = null;
                vm.asset.scheduleQ2 = null;
                vm.asset.scheduleQ4 = null
              } else {
                vm.asset.scheduleQ4 = vm.asset.scheduleQ2;
                vm.asset.scheduleQ1 = null;
                vm.asset.scheduleQ2 = null;
                vm.asset.scheduleQ3 = null
              }
            }
          } else {
            vm.asset.scheduleOption = ReviewModel.getQuarterByDate(vm.asset.scheduleQ1);
            if (vm.asset.scheduleOption == 1) {
              vm.asset.scheduleQ2 = null;
              vm.asset.scheduleQ3 = null;
              vm.asset.scheduleQ4 = null;
            } else if (vm.asset.scheduleOption == 2) {
              vm.asset.scheduleQ2 = vm.asset.scheduleQ1;
              vm.asset.scheduleQ1 = null;
              vm.asset.scheduleQ3 = null;
              vm.asset.scheduleQ4 = null;
            } else if (vm.asset.scheduleOption == 3) {
              vm.asset.scheduleQ3 = vm.asset.scheduleQ1;
              vm.asset.scheduleQ1 = null;
              vm.asset.scheduleQ2 = null;
              vm.asset.scheduleQ4 = null;
            } else {
              vm.asset.scheduleQ4 = vm.asset.scheduleQ1;
              vm.asset.scheduleQ1 = null;
              vm.asset.scheduleQ3 = null;
              vm.asset.scheduleQ2 = null;
            }
          }
        }
      }
    });

    var semiAnnualFirstQWatch = $scope.$watch('editAsset.asset.scheduleQ1', function (newValue, oldValue) {
      if (!angular.equals(newValue, oldValue)) {
        if (vm.asset.valuationFrequency && 'Annually' === vm.asset.valuationFrequency.value && newValue) {
          vm.asset.scheduleOption = 1;
          if(vm.asset.rollOverDate) {
            vm.validRollOverDate = validateRollOverDate('Annually', vm.asset.scheduleQ1, undefined,
              vm.asset.rollOverDate);
            if(!vm.validRollOverDate) {
              notify({
                message: $filter('translate')('ADD_ASSET.INVALID_ANNUAL_ROLL_OVER_DATE'),
                duration: 5000,
                templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
                classes: 'alert-danger',
                position: 'center'
              });
            }
          }
        }
        if (vm.asset.valuationFrequency && 'SemiAnnually' === vm.asset.valuationFrequency.value && newValue &&
          vm.asset.scheduleQ2) {
          var firstDraftDate = moment(vm.asset.scheduleQ1),
            secondDraftDate = moment(vm.asset.scheduleQ2),
            q1Year = firstDraftDate.get('year'),
            q2Year = secondDraftDate.get('year'),
            q1Quarter = ReviewModel.getQuarterByDate(firstDraftDate),
            q2Quarter = ReviewModel.getQuarterByDate(secondDraftDate);

          if ((q1Quarter === q2Quarter && q1Year === q2Year) ||
            (Math.abs(firstDraftDate.diff(secondDraftDate, 'months')) > 11)) {
            // vm.asset.scheduleQ1 = oldValue;
          } else if(vm.asset.rollOverDate) {
            vm.validRollOverDate = validateRollOverDate('SemiAnnually', newValue, vm.asset.scheduleQ2,
              vm.asset.rollOverDate);
            if(!vm.validRollOverDate) {
              notify({
                message: $filter('translate')('ADD_ASSET.INVALID_SEMI_ROLL_OVER_DATE'),
                duration: 5000,
                templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
                classes: 'alert-danger',
                position: 'center'
              });
            }
          }
        }
      }
    });

    var semiAnnualSecondQWatch = $scope.$watch('editAsset.asset.scheduleQ2', function (newValue, oldValue) {
      if (!angular.equals(newValue, oldValue)) {
        if (vm.asset.valuationFrequency && 'SemiAnnually' === vm.asset.valuationFrequency.value && newValue &&
          vm.asset.scheduleQ1) {
          var firstDraftDate = moment(vm.asset.scheduleQ1),
            secondDraftDate = moment(vm.asset.scheduleQ2),
            q1Year = firstDraftDate.get('year'),
            q2Year = secondDraftDate.get('year'),
            q1Quarter = ReviewModel.getQuarterByDate(firstDraftDate),
            q2Quarter = ReviewModel.getQuarterByDate(secondDraftDate);

          if ((q1Quarter === q2Quarter && q1Year === q2Year) ||
            (Math.abs(firstDraftDate.diff(secondDraftDate, 'months')) > 11)) {
            // vm.asset.scheduleQ2 = oldValue;
          } else if(vm.asset.rollOverDate) {
            vm.validRollOverDate = validateRollOverDate('SemiAnnually', vm.asset.scheduleQ1, newValue,
              vm.asset.rollOverDate);
            if(!vm.validRollOverDate) {
              notify({
                message: $filter('translate')('ADD_ASSET.INVALID_SEMI_ROLL_OVER_DATE'),
                duration: 5000,
                templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
                classes: 'alert-danger',
                position: 'center'
              });
            }
          }
        }
      }
    });

    var rollOverDateWatch = $scope.$watch('editAsset.asset.rollOverDate', function (newValue, oldValue){
      if(vm.asset.valuationFrequency && 'Annually' === vm.asset.valuationFrequency.value && vm.asset.scheduleQ1) {
        if(!vm.editAssetForm.rolloverDate.$dirty)vm.editAssetForm.rolloverDate.$setDirty();
        vm.validRollOverDate = validateRollOverDate('Annually', vm.asset.scheduleQ1, undefined, newValue);
        if(!vm.validRollOverDate) {
          notify({
            message: $filter('translate')('ADD_ASSET.INVALID_ANNUAL_ROLL_OVER_DATE'),
            duration: 5000,
            templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
            classes: 'alert-danger',
            position: 'center'
          });
        }
      } else if(vm.asset.valuationFrequency && 'SemiAnnually' === vm.asset.valuationFrequency.value &&
        vm.asset.scheduleQ1 && vm.asset.scheduleQ2) {
        if(!vm.editAssetForm.rolloverDate.$dirty)vm.editAssetForm.rolloverDate.$setDirty();
        vm.validRollOverDate = validateRollOverDate('SemiAnnually', vm.asset.scheduleQ1, vm.asset.scheduleQ2, newValue);
        if(!vm.validRollOverDate) {
          notify({
            message: $filter('translate')('ADD_ASSET.INVALID_SEMI_ROLL_OVER_DATE'),
            duration: 5000,
            templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
            classes: 'alert-danger',
            position: 'center'
          });
        }
      }
    });

    var internalAppraisersWatch = $scope.$watch('editAsset.asset.internalAppraisers', function (newValue, oldValue) {
      var primaryInternalAppraiser = null;
      var secondaryInternalAppraiser = null;
      if (newValue && newValue.length === 2 && oldValue && oldValue.length === 1) {
        primaryInternalAppraiser = oldValue[0];

        if (newValue[0].user.id === oldValue[0].user.id) {
          secondaryInternalAppraiser = newValue[1];
        } else {
          secondaryInternalAppraiser = newValue[0];
        }
        var pSelIndex = -1;
        var sSelIndex = -1;
        for (i = 0; i < vm.internalAppraisers.length; i++) {
          if (primaryInternalAppraiser.user.id === vm.internalAppraisers[i].user.id) {
            pSelIndex = i;
          }
          if (secondaryInternalAppraiser.user.id === vm.internalAppraisers[i].user.id) {
            sSelIndex = i;
          }
        }
        // To preserve the order in selected display, swap positions
        if (pSelIndex !== -1 && sSelIndex !== -1 && sSelIndex < pSelIndex) {
            var temp = vm.internalAppraisers[pSelIndex];
            vm.internalAppraisers[pSelIndex] = vm.internalAppraisers[sSelIndex];
            vm.internalAppraisers[sSelIndex] = temp;
        }
        vm.selectedInternalAppraisers[0] = primaryInternalAppraiser;
        vm.selectedInternalAppraisers[1] = secondaryInternalAppraiser;
      } else if(newValue && newValue.length === 1 && oldValue && oldValue.length === 0){
        primaryInternalAppraiser = newValue[0];
        secondaryInternalAppraiser = null;
        vm.selectedInternalAppraisers[0] = primaryInternalAppraiser;
      }
      else if(newValue && newValue.length === 1 && oldValue && oldValue.length === 2){
        primaryInternalAppraiser = newValue[0];
        secondaryInternalAppraiser = null;
        vm.selectedInternalAppraisers[0] = primaryInternalAppraiser;
      }
      else if(newValue && newValue.length === 0 && oldValue && oldValue.length === 1){
        primaryInternalAppraiser = null;
        secondaryInternalAppraiser = null;
      }
      else if(newValue && newValue.length === 2 && oldValue && oldValue.length === 2){
        primaryInternalAppraiser = newValue[0];
        secondaryInternalAppraiser = newValue[1];
      }
      else if(newValue && newValue.length === 1 && oldValue && oldValue.length === 1){
        primaryInternalAppraiser = newValue[0];
        secondaryInternalAppraiser = null;
      }

      if(primaryInternalAppraiser!=null && secondaryInternalAppraiser!=null){
        vm.newInternalAppraisers[0] = primaryInternalAppraiser.id;
        vm.newInternalAppraisers[1] = secondaryInternalAppraiser.id;
      }else if(primaryInternalAppraiser!=null && secondaryInternalAppraiser==null){
        vm.newInternalAppraisers[0] = primaryInternalAppraiser.id;
        vm.newInternalAppraisers[1] = null;
      }else if(primaryInternalAppraiser==null && secondaryInternalAppraiser==null){
        vm.newInternalAppraisers[0] = null;
        vm.newInternalAppraisers[1] = null;
      }
    });

    $scope.$on('$destroy', function () {
      editCountry();
      editCountryNew();
      editState();
      editStateNew();
      editType();
      frequencyWatch();
      semiAnnualFirstQWatch();
      semiAnnualSecondQWatch();
      rollOverDateWatch();
      internalAppraisersWatch();
      watchers.forEach(function (watcher) {
        watcher();
      });
    });

  }
})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .config(routeConfig);

  function routeConfig($stateProvider) {
    $stateProvider.state('app.asset.assetDetails.documentsHistory', {
      url: '/documents-history/:valuationId',
      views: {
        "@app": {
          templateUrl: 'app/states/assets/asset-details/asset-details-view.html',
          controller: 'AssetDetailsController',
          controllerAs: 'assetDetailsCtrl'
        },
        '@app.asset.assetDetails.documentsHistory': {
          templateUrl: 'app/states/valuations/review/documents-history/documents-history.html',
          controller: 'DocumentsHistoryController',
          controllerAs: 'documentsHistoryCtrl'
        }
      },
      data: {
        viewClass: 'documentsHistory',
        roles: ['Admin', 'Audit', 'AssetManagement', 'AssetAppraisal', 'AssetReview', 'AssetManagerReadOnly'],
        isFromHistory: true
      },
      params:{
        valuationId: ''
      },
      resolve: {
        /**@ngInject*/
        review: function ($stateParams, ReviewFactory) {
          return ReviewFactory.loadReview($stateParams.assetId, $stateParams.valuationId);
        },
        assetDocuments: function (AssetService, review) {
          return AssetService.documentList(review.asset.id).then(function (documents) {

            for (var i = 0; i < review.documents.users.length; i++) {
              var isInUsers = false;
              for (var j in review.asset.users) {
                if (review.documents.users[i].id == j) {
                  isInUsers = true;
                  if(review.asset.users[j].user.userCompanyRoles && review.asset.users[j].user.userCompanyRoles.length > 1) {
                    review.asset.users[j].type = 'Admin';
                  }
                  break;
                }
              }
              if (!isInUsers) {
                review.asset.users[review.documents.users[i].id] = {};
                review.asset.users[review.documents.users[i].id].user = review.documents.users[i];
                if(review.documents.users[i].userCompanyRoles.length > 1 || review.documents.users[i].userCompanyRoles[0] === 'Administrator') {
                  review.asset.users[review.documents.users[i].id].type = 'Admin';
                } else {
                  review.asset.users[review.documents.users[i].id].type = 'PrimaryAssetAppraiser';
                }
              }
            }

            for (var i = 0; i < documents.users.length; i++) {
              var isInUsers = false;
              for (var j in review.asset.users) {
                if (documents.users[i].id == j) {
                  isInUsers = true;
                  break;
                }
              }
              if (!isInUsers) {
                review.asset.users[documents.users[i].id] = {};
                review.asset.users[documents.users[i].id].user = documents.users[i];
                for (var k = 0; k < documents.users[i].userCompanyRoles.length; k++) {
                  if ('Administrator' == documents.users[i].userCompanyRoles[k]) {
                    review.asset.users[documents.users[i].id].type = 'Admin';
                    break;
                  } else if ('AssetManager' == documents.users[i].userCompanyRoles[k]) {
                    review.asset.users[documents.users[i].id].type = 'PrimaryAssetManager';
                  } else {
                    review.asset.users[documents.users[i].id].type = 'PrimaryAssetReviewer';
                  }
                }
              }
            }
            var latestDocuments = [],
              indexedDocumentNames = [];
            for (var i = 0; i < documents.assetDocuments.length; i++) {
              var document = documents.assetDocuments[i];
              if (indexedDocumentNames.indexOf(document.fileName) == -1) {
                var latestDocument = document;
                indexedDocumentNames.push(document.fileName);
                for (var j = i; j < documents.assetDocuments.length; j++) {
                  var document2 = documents.assetDocuments[j];
                  if (latestDocument.fileName === document2.fileName) {
                    if (isNaN(latestDocument.version)
                      || (!isNaN(document2.version) && latestDocument.version < document2.version)) {
                      latestDocument = document2
                    }
                  }
                }
                latestDocuments.push(latestDocument)
              }
            }
            return latestDocuments;
          });
        },
        /**@ngInject*/
        periods: function (AssetService, SessionManager, review) {
          return AssetService.getAssetUsersList(review.asset.id).then(function (users) {
            var periods = [], loggedUser = SessionManager.getUser();
            for(var i = 0; i < users.length; i++) {
              if(users[i].userCompanyId == loggedUser.userCompanyId || loggedUser.userCompanyId === 14405) {
                // 14405 is Internal Appraiser CompanyId
                for (var j = 0; j < users[i].periods.length; j++) {
                  periods.push(users[i].periods[j]);
                }
              }
            }
            return periods;
          });
        },
        /**@ngInject*/
        company: function(CompanyService, review){
          return CompanyService.getCompany(review.asset.companyId);
        },
        prevValuationsObj: function (ReviewFactory, review) {
          return ReviewFactory.loadPrevValuationsData(review.asset.id, review);
        },
        /** @ngInject */
        premiseOptions: function (StaticDataService) {
          return StaticDataService.getPremiseOptions();
        }
      }
    });
  }
})();

(function () {
  'use strict';

  angular
  .module('nvc')
  .config(routeConfig);

  function routeConfig($stateProvider) {
    $stateProvider.state('app.asset.assetDetails', {
      url: '/details/:assetId',
      views: {
        "@app": {
          templateUrl: 'app/states/assets/asset-details/asset-details-view.html',
          controller: 'AssetDetailsController',
          controllerAs: 'assetDetailsCtrl'
        },
        '@app.asset.assetDetails': {
          templateUrl: 'app/states/assets/asset-details/asset-details.html'
        }
      },
      data: {
        pageTitle: 'Asset details',
        viewClass: 'assetDetails',
        roles: ['Admin', 'Audit', 'AssetManagement', 'AssetReview', 'AssetAppraisal', 'AssetManagerReadOnly']
      },
      params: {
        assetId: '',
        valuationId: '',
        noPadding: false
      },
      resolve: {
        /** @ngInject */
        asset: function ($q, $stateParams, AssetService, ValuationService) {
          if ($stateParams.asset) {
            return $stateParams.asset;
          }
          var promises = [AssetService.getAsset($stateParams.assetId), ValuationService.listValuationsByAssetId($stateParams.assetId)];
          return $q.all(promises).then(function (responses) {
            var asset = responses[0],
            valuations = responses[1],
            currentQuarter = ReviewModel.getQuarterByDate(new moment()),
            currentYear = (new moment()).get('year');
            var valuationQuarter = asset.valuation.quarter;
            var valuationYear = asset.valuation.year;
            
            if ((asset.valuation && (asset.valuation.year != currentYear || asset.valuation.quarter != currentQuarter)) || !asset.valuation) {
              asset.valuation = undefined;
              for (var i = 0; i < valuations.length; i++) {
                var valuation = valuations[i];
                if (valuation.year == valuationYear && valuation.quarter == valuationQuarter) {
                  asset.valuation = valuation;
                }
              }
            }
            return asset;
          })
        },
        /** @ngInject */
        assetUsers: function ($stateParams, AssetService, asset) {
          return AssetService.getAssetUsersList($stateParams.assetId, true).then(function (assetUsers) {
            assetUsers.forEach(function (assetUser) {
              for (var i = 0; i < assetUser.periods.length; i++) {
                var tempPeriod = assetUser.periods[i];
                if (tempPeriod.active && tempPeriod.isPrimary && asset.valuation && tempPeriod.quarter == asset.valuation.quarter && tempPeriod.year == asset.valuation.year) {
                  switch (assetUser.userCompanyType) {
                    case 'AssetReview':
                      assetUser.type = 'PrimaryAssetReviewer';
                      break;
                    case 'AssetManagement':
                      assetUser.type = 'PrimaryAssetManager';
                      break;
                    case 'AssetAppraisal':
                        assetUser.type = 'PrimaryAssetAppraiser';
                    break;
                  }
                  break;
                }
              }
            });
            return assetUsers;
          });
        },
        /** @ngInject */
        propertyTypes: function (StaticDataService) {
          return StaticDataService.getPropertyTypes();
        },
        /** @ngInject */
        subtypesByPropertyTypes: function (StaticDataService) {
          return StaticDataService.getSubtypesByPropertyTypes();
        },
        /** @ngInject */
        ownershipTypes: function (StaticDataService) {
          return StaticDataService.getOwnershipTypes();
        },
        /** @ngInject */
        ncreifs: function (StaticDataService) {
          return StaticDataService.getNcreifs();
        },
        /**@ngInject*/
        documents: function ($stateParams, AssetService) {
          return AssetService.documentList($stateParams.assetId).then(function (documents) {
            var latestDocuments = [],
            indexedDocumentNames = [];
            for (var i = 0; i < documents.assetDocuments.length; i++) {
              var document = documents.assetDocuments[i];
              if (indexedDocumentNames.indexOf(document.fileName) == -1) {
                var latestDocument = document;
                indexedDocumentNames.push(document.fileName);
                for (var j = i; j < documents.assetDocuments.length; j++) {
                  var document2 = documents.assetDocuments[j];
                  if (latestDocument.fileName === document2.fileName) {
                    if (isNaN(latestDocument.version)
                    || (!isNaN(document2.version) && latestDocument.version < document2.version)) {
                      latestDocument = document2;
                    }
                  }
                }
                latestDocuments.push(latestDocument);
              }
            }
            return latestDocuments;
          });
        },
        /**@ngInject*/
        valuationFrequencies: function (StaticDataService) {
          return StaticDataService.getValuationFrequencies();
        }
      }
    });
  }

})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .controller('AssetDetailsController', AssetDetailsController);

  /** @ngInject*/
  function AssetDetailsController($q, $stateParams, $timeout, $filter, $uibModal, $window,$state, CompanyService, asset, assetUsers, propertyTypes,
    subtypesByPropertyTypes, ownershipTypes, ncreifs, ReviewFactory, BidGroupService, SessionManager,
    AssetService, documents, $sce, PDFGenerator, GROUNDLEASED, valuationFrequencies, notify, UtcDateConverter, SweetAlert) {
    var vm = this;

    // Convert asset groundleased from (true/false) to (Yes/No)
    var groundLeasedDictionary = {
      true: GROUNDLEASED[0],
      false: GROUNDLEASED[1]
    };
    vm.isAsset = $state.current.name === 'app.asset.assetDetails.documentsHistory';
    asset.groundLeased = $filter('booleanToString')(asset.groundLeased, groundLeasedDictionary);
    vm.asset = asset;
    asset.review = ReviewFactory.assetToReview(new AssetModel(asset));
    vm.assetUsers = assetUsers;
    vm.noPadding = $stateParams.noPadding;
    vm.propertyTypes = propertyTypes.items;
    vm.subtypesByPropertyTypes = subtypesByPropertyTypes[vm.asset.type];
    vm.ownershipTypes = ownershipTypes;
    vm.ncreifs = ncreifs['items'];
    vm.documents = documents;
    vm.currentValuation = vm.asset.vperiod;
    vm.downloadLoading = false;
    vm.isExternalAppraiser = false;
    vm.nextDraftDueDateExternal = "";
    vm.valuationFrequencies = valuationFrequencies.items;
    vm.asset.scheduleQ1 = UtcDateConverter.getDateFromUTC(vm.asset.scheduleQ1);
    vm.asset.scheduleQ2 = vm.asset.scheduleQ2 ? UtcDateConverter.getDateFromUTC(vm.asset.scheduleQ2) : undefined;
    vm.asset.scheduleQ3 = vm.asset.scheduleQ3 ? UtcDateConverter.getDateFromUTC(vm.asset.scheduleQ3) : undefined;
    vm.asset.scheduleQ4 = vm.asset.scheduleQ4 ? UtcDateConverter.getDateFromUTC(vm.asset.scheduleQ4) : undefined;
    if (vm.asset.rollOverDate) {
      vm.asset.rollOverDate = UtcDateConverter.getDateFromUTC(vm.asset.rollOverDate);
    }
    vm.isAllViewer = false;
    vm.isAdmin = SessionManager.getRoleName().toLowerCase() === 'admin';

    for (var i = 0; i < vm.propertyTypes.length; i++) {
      if (vm.asset.type == vm.propertyTypes[i].type) {
        vm.asset.typeName = vm.propertyTypes[i].name;
        break;
      }
    }

    for (i = 0; i < vm.subtypesByPropertyTypes.length; i++) {
      if (vm.asset.subType == vm.subtypesByPropertyTypes[i].type) {
        vm.asset.subType = vm.subtypesByPropertyTypes[i].name;
        break;
      }
    }

    for (i = 0; i < vm.ownershipTypes.length; i++) {
      if (vm.asset.ownership == vm.ownershipTypes[i].type) {
        vm.asset.ownership = vm.ownershipTypes[i].name;
        break;
      }
    }

    for (i = 0; i < vm.ncreifs.length; i++) {
      if (vm.asset.region == vm.ncreifs[i].type) {
        vm.asset.region = vm.ncreifs[i].name;
        break;
      }
    }

    for (i = 0; i < vm.assetUsers.length; i++) {
      if ('PrimaryAssetManager' == vm.assetUsers[i].type) {
        vm.leadAssetManager = vm.assetUsers[i];
        getCompanyId(vm.leadAssetManager);
        break;
      }
    }

    for (i = 0; i < vm.assetUsers.length; i++) {
      if ('PrimaryAssetReviewer' == vm.assetUsers[i].type) {
        vm.leadReviewer = vm.assetUsers[i];
        getCompanyId(vm.leadReviewer);
        break;
      }
    }

    for (i = 0; i < vm.valuationFrequencies.length; i++) {
      if (vm.asset.valuationFrequency === vm.valuationFrequencies[i].value) {
        vm.asset.valuationFrequency = vm.valuationFrequencies[i].name;
        break;
      }
    }

    if (vm.asset.bidGroupId) {
      BidGroupService.get(vm.asset.bidGroupId).then(function (bidGroup) {
        vm.asset.bidGroup = bidGroup;
      });
    }

    vm.title = $sce.trustAsHtml($filter('translate')(vm.asset.name));

    if (!vm.asset.active) {
      vm.title += ' (' + $filter('translate')('COMMONS.INACTIVATED') + ')';
    }

    if(vm.isAsset) {
      vm.breadcrumbs = [
        {
          label: $filter('translate')('ASSETS.TITLE'),
          value: 'app.asset.all'
        },
        {
          label: $filter('translate')('ASSET_DETAILS.BREADCRUMB'),
          value: 'app.asset.assetDetails'
        },
        {
          label: $filter('translate')('ASSET_DETAILS.ASSET_BREADCRUMB'),
          value: 'app.asset.assetDetails.documentsHistory'
        },
    ];
  } else {
    vm.breadcrumbs = [
      {
        label: $filter('translate')('ASSETS.TITLE'),
        value: 'app.asset.all'
      },
      {
        label: $filter('translate')('ASSET_DETAILS.BREADCRUMB'),
        value: 'app.asset.assetDetails'
      }
  ];
  }

    if (SessionManager.getRoleName().toLowerCase() === 'admin' || SessionManager.getRoleName().toLowerCase() === 'assetreview'
    || SessionManager.getRoleName().toLowerCase() === 'assetmanagement' || SessionManager.getRoleName().toLowerCase() === 'auditor') {
      vm.isAllViewer = true;
    }
    if ('AssetAppraisal' === SessionManager.getRoleName() && SessionManager.getCompanyId() !== 14405) {
      vm.isExternalAppraiser = true;
      if (vm.asset.requiredAppraisers === 'InternalAndExternal' && vm.asset.valuationFrequency !== 'Annually') {
        if (vm.asset.scheduleOption == 1) {
          vm.nextDraftDueDateExternal = vm.asset.scheduleQ1;
        } else if (vm.asset.scheduleOption == 2) {
          vm.nextDraftDueDateExternal = vm.asset.scheduleQ2;
        } else if (vm.asset.scheduleOption == 3) {
          vm.nextDraftDueDateExternal = vm.asset.scheduleQ3;
        } else if (vm.asset.scheduleOption == 4) {
          vm.nextDraftDueDateExternal = vm.asset.scheduleQ4;
        }
      }
    }

    vm.expandImage = function (image) {
      $uibModal.open({
        templateUrl: '/app/components/commons/expand-image-modal/expand-image-modal.html',
        controller: 'ExpandImageController',
        controllerAs: 'expandImageModal',
        resolve: {
          asset: function () {
            return $q(function (resolve) {
              $timeout(function () {
                var asset = {};
                asset.name = vm.asset.name;
                asset.picture = vm.asset.picture;
                resolve(asset);
              });
            })
          }
        }
      });
    };

    function getCompanyId(user) {
      CompanyService.getCompaniesByUserId(user.user.id, true).then(function (companies) {
        for (var i = 0; i < companies.length; i++) {
          if ('PrimaryAssetReviewer' == user.type) {
            if (companies[i].role == 'Reviewer') {
              vm.leadReviewer.companyId = companies[i].companyId;
              return;
            }
          } else if ('PrimaryAssetManager' == user.type) {
            if (companies[i].role == 'AssetManager') {
              vm.leadAssetManager.companyId = companies[i].companyId;
              return;
            }
          }
        }
      });
    }

    vm.downloadAssetDocument = function (document) {
      AssetService.documentDownload(document.id).then(function (downloadData) {
        $window.open(downloadData, '_blank');
      });
    };

    vm.deleteDocument = function (document) {
      var text = $filter('translate')('ASSETS.YOU_ARE_ABOUT_TO_DELETE');  
      SweetAlert.swal({
        title: $filter('translate')('ASSETS.ARE_YOU_SURE'),
        text: text,
        showCancelButton: true,
        cancelButtonText: $filter('translate')('ASSETS.CANCEL'),
        confirmButtonColor: '#2c3d4e',
        confirmButtonText: $filter('translate')('ASSETS.YES_DELETE'),
        closeOnConfirm: true,
        closeOnCancel: true,
        allowEscapeKey: false
      }, function (isConfirm) {
        if (isConfirm) {
          AssetService.documentDelete(document.id).then(function (bidGroup) {
            vm.documents.splice(vm.documents.indexOf(document),1);
            notifyResults('delete');
          });
        }
      })
    }

    vm.downloadPdf = function () {
      vm.downloadLoading = true;
      PDFGenerator.generateAssetDetailsPage(vm.asset, vm.documents, vm.leadAssetManager, vm.leadReviewer)
        .then(function (values) {
          vm.downloadLoading = false;
          values.pdf.download('Asset ' + values.asset.name + '.pdf');
        })
        .catch(function (error) {
          vm.downloadLoading = false;
          notify({
            message: $filter('translate')('COMMONS.EXPORT_FAILURE'),
            duration: 5000,
            templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
            classes: 'alert-danger',
            position: 'center'
          });
        });
    };
    vm.isDraftDueHidden = function (scheduleOption) {
      return (vm.isExternalAppraiser &&
        vm.asset.requiredAppraisers === 'InternalAndExternal' &&
        vm.asset.valuationFrequency !== 'Annually' &&
        vm.asset.scheduleOption != scheduleOption)
        ||
        (!vm.isExternalAppraiser && !vm.isAllViewer &&
          vm.asset.requiredAppraisers === 'InternalAndExternal' &&
          vm.asset.valuationFrequency !== 'Annually' &&
          vm.asset.scheduleOption == scheduleOption)
    }

    vm.gotoReview = function () {
      $state.go('app.asset.assetDetails.documentsHistory', { valuationId: vm.asset.review.id })
      .then(function () {
      });
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .config(routeConfig);

  function routeConfig($stateProvider) {
    $stateProvider.state('app.asset.bidGroups', {
      url: '/bid-groups',
      views: {
        "@app": {
          templateUrl: 'app/states/assets/bid-groups/bid-groups.html',
          controller: 'BidGroupsController',
          controllerAs: 'bidGroupsCtrl'
        }
      },
      data: {
        pageTitle: 'Bid Groups',
        viewClass: 'bidGroups',
        roles: ['Admin']
      },
      resolve: {
        /** @ngInject */
        companies: function ($q, CompanyService) {
          return CompanyService.getClientCompanies(true, true);
        }
      }
    });
  }

})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .controller('BidGroupsController', BidGroupsController);

  /** @ngInject */
  function BidGroupsController($scope, $filter, $q, LoaderHelper, ArrayHelper, CompanySelectorFactory, BidGroupService, AssetService, companies, CSVService, PDFGenerator, SessionManager, notify) {

    var vm = this;

    vm.searchQuery = '';
    vm.bidGroups = [];
    vm.bidGroupsSort = [
      {
        tag: 'Name',
        selected: true,
        flag: true,
        order: 'Ascending'
      },
      {
        tag: 'NumberOfAssets',
        selected: false,
        flag: false,
        order: 'Ascending'
      }
    ];
    vm.bidGroupsSelectedSort = vm.bidGroupsSort[0];
    vm.perPage = 17;
    vm.maxPaginationSize = 5;

    vm.downloadLoading = false;

    vm.downloadCsv = function () {
      vm.downloadLoading = true;
      CSVService.generateBidGroupsCsv(vm.selectedCompany, vm.bidGroupsCount, vm.searchQuery, vm.bidGroupsSelectedSort.tag, vm.bidGroupsSelectedSort.order)
        .then(function () {
          vm.downloadLoading = false;
        })
        .catch(function () {
          vm.downloadLoading = false;
        });
    };

    vm.downloadPdf = function () {
      vm.downloadLoading = true;
      PDFGenerator.generateBidGroupsPdf(vm.selectedCompany, vm.bidGroupsCount, vm.searchQuery, vm.bidGroupsSelectedSort.tag, vm.bidGroupsSelectedSort.order)
        .then(function (pdf) {
          vm.downloadLoading = false;
          var currentUser = SessionManager.getUser();
          pdf.download('bid-groups-' + currentUser.name + '.pdf');
        })
        .catch(function () {
          vm.downloadLoading = false;
          notify({
            message: $filter('translate')('COMMONS.EXPORT_FAILURE'),
            duration: 5000,
            templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
            classes: 'alert-danger',
            position: 'center'
          });
        });
    };

    //BREADCRUMS
    //-------------------------------------------------------
    vm.title = $filter('translate')('BID_GROUPS.TITLE');
    vm.breadcrumbs = [
      {
        label: $filter('translate')('ASSETS.TITLE'),
        value: 'app.asset.bidGroups'
      },
      {
        label: $filter('translate')('BID_GROUPS.TITLE'),
        value: 'app.asset.bidGroups'
      }
    ];

    //SORTING
    //------------------------------------------
    vm.sorting = function (sort, target) {
      ArrayHelper.beSort(sort, target, vm.bidGroupsSort, vm);
      loadBidGroups();
    };

    //SEARCH FUNCTION
    //------------------------------------------
    vm.searchBidGroups = function () {
      if (vm.searchQuery.length > 2 || !vm.searchQuery) {
        loadBidGroups();
      }
    };

    vm.changePage = function () {
      loadBidGroups();
    };

    //LATERAL BAR CONFIG
    //------------------------------------------
    vm.lateralBarConfig = {
      templateUrl: 'app/states/assets/bid-groups/bid-groups-lateral-content.html',
      controller: 'BigGroupsLateralController',
      icons: [
        {
          class: 'icon-ic-asset-info info',
          anchor: 'asset-list'
        }
      ]
    };


    //LATERAL BAR CLOSE
    //------------------------------------------
    vm.closeDetails = function (group) {
      vm.showDetails = false;
      if (group) {
        group.displaying = false;
      }
      vm.selectedBidGroup.displaying = false;
      vm.selectedBidGroup = undefined;
    };

    //GET BID GROUPS BY COMPANY
    //------------------------------------------
    CompanySelectorFactory.showCompanies(companies);
    var companyListener = $scope.$on('companyChanged', function (event, selectedCompany) {
      vm.selectedCompany = selectedCompany.id;
      CompanySelectorFactory.executeOnValidState('app.asset.bidGroups', function () {
        vm.currentPage = 1;
        loadBidGroups(true);
      });
      vm.showDetails = false;
    });

    function loadBidGroups(load) {
      if (load) {
        LoaderHelper.open();
      } else {
        $('.paginator-loader').addClass('sk-loading');
      }

      BidGroupService.listPage(vm.selectedCompany, vm.currentPage - 1, vm.perPage, vm.searchQuery,
        vm.bidGroupsSelectedSort.tag, vm.bidGroupsSelectedSort.order).then(function (response) {
          vm.bidGroups = response.bidGroups;
          vm.bidGroupsCount = response.pageInfo.count;
          if (vm.bidGroups.length === 0) {
            ArrayHelper.searchScroll();
            if (load) {
              LoaderHelper.close();
            } else {
              $('.paginator-loader').removeClass('sk-loading');
            }
          }
          ArrayHelper.searchScroll();
          if (load) {
            LoaderHelper.close();
          } else {
            $('.paginator-loader').removeClass('sk-loading');
          }
        });
    }


    //OPEN BID GROUP DETAIL
    //------------------------------------------
    vm.getBidGroupDetails = function (selectedBidGroup) {

      if (selectedBidGroup.assets) {
        vm.showDetails = true;
        vm.bidGroups.forEach(function (group) {
          selectedBidGroup.id == group.id ? group.displaying = true : group.displaying = false;
        });
        vm.selectedBidGroup = selectedBidGroup;
        vm.lateralBarConfig.locals = {
          group: vm.selectedBidGroup
        };
      } else {
        AssetService.getAssetsByBidGroup(selectedBidGroup.id).then(function (assetList) {
          selectedBidGroup.assets = assetList;
          vm.showDetails = true;
          vm.bidGroups.forEach(function (group) {
            selectedBidGroup.id == group.id ? group.displaying = true : group.displaying = false;
          });
          vm.selectedBidGroup = selectedBidGroup;
          vm.lateralBarConfig.locals = {
            group: vm.selectedBidGroup
          };
        });
      }


    };

    $scope.$on('$destroy', function () {
      companyListener();
    });
  }

})();

(function () {
  'use strict';

  angular
  .module('nvc')
  .controller('BigGroupsLateralController', BigGroupsLateralController);

  function BigGroupsLateralController($filter, $state, $scope, group, notify, SweetAlert, LoaderHelper, BidGroupService) {
    $scope.group = group;

    $scope.deleteBidGroup = function (bidGroup) {
      LoaderHelper.open();
      SweetAlert.swal({
        title: $filter('translate')('COMMONS.LEAVE_PAGE_MODAL_TITLE'),
        text: $filter('translate')('BID_GROUPS.CONFIRM_MODAL_TEXT'),
        showCancelButton: true,
        cancelButtonText: $filter('translate')('BID_GROUPS.YES_BUTTON'),
        confirmButtonColor: '#2c3d4e',
        confirmButtonText: $filter('translate')('COMMONS.LEAVE_PAGE_CANCEL_BUTTON'),
        closeOnConfirm: true,
        closeOnCancel: true
      },
      function (isConfirm) {
        if (!isConfirm) {
          var bidGroupDTO = {};
          bidGroupDTO.id = bidGroup.id;
          BidGroupService.deleteBidGroup(bidGroupDTO).then(function () {
            notify({
              message: $filter('translate')('COMMONS.BID_GROUP_DELETED'),
              duration: 4000,
              templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
              classes: 'alert-info',
              position: 'center'
            });
            $state.go($state.current, {}, {reload: true});
          });
        } else {
          LoaderHelper.close();
        }
      });
    };

  }

})();

(function(){
  'use strict';

  angular
    .module('nvc')
    .config(routeConfig);

  function routeConfig($stateProvider){
    $stateProvider.state('app.asset.addAsset', {
      url: '/add-asset',
      views: {
        "@app": {
          templateUrl: 'app/states/assets/add-asset/add-asset.html',
          controller: 'AddAssetController',
          controllerAs: 'addAsset'
        }
      },
      resolve: {
        /** @ngInject */
        states: function (StaticDataService) {
          return StaticDataService.getAllStates();
        },
        /** @ngInject */
        citiesByStates: function (StaticDataService) {
          return StaticDataService.getCitiesByStates();
        },
        /** @ngInject */
        ncreifRegionByStates: function (StaticDataService) {
          return StaticDataService.getNCREIFRegionByStates();
        },
        /** @ngInject */
        propertyTypes: function (StaticDataService) {
          return StaticDataService.getPropertyTypes();
        },
        /** @ngInject */
        subtypesByPropertyTypes: function (StaticDataService) {
          return StaticDataService.getSubtypesByPropertyTypes();
        },
        /** @ngInject */
        msaByStates: function (StaticDataService) {
          return StaticDataService.getMsaByStates()
        },
        /** @ngInject */
        ownershipTypes: function (StaticDataService) {
          return StaticDataService.getOwnershipTypes();
        },
        /** @ngInject */
        ncreifs: function (StaticDataService) {
          return StaticDataService.getNcreifs();
        },
        /** @ngInject */
        companies: function (CompanyService) {
          return CompanyService.getClientCompanies(true, true);
        },
        /** @ngInject */
        valuationFrequencies: function (StaticDataService) {
          return StaticDataService.getValuationFrequencies();
        },
        /** @ngInject */
        requiredAppraisers: function (StaticDataService) {
          return StaticDataService.getRequiredAppraisers();
        }
      },
      data: {
        pageTitle: 'Add Asset',
        viewClass: 'add-asset',
        roles: ['Admin', 'AssetManagement']
      }
    });
  }

})();

(function () {
  'use strict';

  angular.module('nvc')
    .controller('AddAssetController', AddAssetController);

  /** @Inject*/
  function AddAssetController($q, $scope, $state, $filter, SessionManager, states, citiesByStates, ncreifRegionByStates, propertyTypes,
                              subtypesByPropertyTypes, notify, msaByStates, ownershipTypes, ncreifs, LoaderHelper,
                              AssetService, ValuationService, UserService, CompanyService, CompanySelectorFactory,
                              BidGroupService, companies, GROUNDLEASED, ASSETCOUNTRIES, ASSETREQUIREDAPPRAISERS, valuationFrequencies,
                              requiredAppraisers, UtcDateConverter) {
    var vm = this;
    var company;

    vm.statesByCountry = states;
    vm.citiesByStates = citiesByStates;
    vm.ncreifRegionByStates = ncreifRegionByStates;
    vm.propertyTypes = propertyTypes.items;
    vm.subtypesByPropertyTypes = subtypesByPropertyTypes;
    vm.msaByStates = msaByStates;
    vm.ownershipTypes = ownershipTypes;
    vm.groundLeasedTypes = GROUNDLEASED;
    vm.ncreifs = ncreifs.items;
    vm.countries = ASSETCOUNTRIES;
    vm.requiredAppraisers = ASSETREQUIREDAPPRAISERS;
    vm.isAM = !SessionManager.isInRole('Admin');
    vm.assetsManagers = [];
    vm.biddingGroups = [];
    vm.valuationFrequency = valuationFrequencies.items;
    vm.requiredAppraisers = requiredAppraisers.items;

    vm.asset = {scheduleOption: 1};
    vm.addAssetForm = {};
    vm.submitted = false;
    vm.duplicateId = false;

    vm.documents = [];
    vm.documentsToUpload = [];
    vm.documentsToDelete = [];
    vm.validRollOverDate = true;

    vm.title = $filter('translate')('ADD_ASSET.ADD_ASSET');
    vm.breadcrumbs = [
      {
        label: $filter('translate')('ASSETS.TITLE'),
        value: 'app.asset.all'
      },
      {
        label: $filter('translate')('ADD_ASSET.ADD_NEW_ASSET'),
        value: 'app.asset.addAsset'
      }
    ];

    CompanySelectorFactory.showCompanies(companies);
    if (!SessionManager.isInRole('AssetManagement')) {
      CompanyService.getReviewerCompanies(true, true).then(function (rCompanies) {
        var promises = [];
        rCompanies.forEach(function (rCompany) {
          promises.push(UserService.getUsersByCompanyId(rCompany.id, true));
        });
        $q.all(promises).then(function (responses) {
          vm.reviewers = [];
          responses.forEach(function (response) {
            vm.reviewers = vm.reviewers.concat(response);
          })
        });
      });
    }

    CompanyService.getAppraisalCompanies(true, true).then(function (aCompanies) {
      var promises = [];
      aCompanies.forEach(function (aCompany) {
        if (aCompany.name === 'National Valuation Consultants, Inc.') {
          // Interested only in Internal Appraisers
          promises.push(UserService.getUsersByCompanyId(aCompany.id, true));
        }
      });
      $q.all(promises).then(function (responses) {
        vm.internalAppraisers = [];
        responses.forEach(function (response) {
          vm.internalAppraisers = vm.internalAppraisers.concat(response);
        })
      });
    });

    function formIsValid() {
      var validForm = !(vm.addAssetForm.$invalid /*|| vm.picture === '/assets/images/dragBg.png' ||
      vm.picture === '/assets/images/ic_ErrorFile.png' */ || !company.id);

      if (validForm) {
        var validSchedule = null;
        if ('Annually' === vm.asset.valuationFrequency.value) return true;
        if ('SemiAnnually' === vm.asset.valuationFrequency.value) {
          var firstDraftDate = moment(vm.asset.scheduleQ1),
            secondDraftDate = moment(vm.asset.scheduleQ2),
            q1Year = firstDraftDate.get('year'),
            q2Year = secondDraftDate.get('year'),
            q1Quarter = ReviewModel.getQuarterByDate(firstDraftDate),
            q2Quarter = ReviewModel.getQuarterByDate(secondDraftDate);

          validSchedule = !((q1Quarter === q2Quarter && q1Year === q2Year) ||
          (Math.abs(firstDraftDate.diff(secondDraftDate, 'months')) > 11));

          if (!validSchedule) {
            notify({
              message: $filter('translate')('ADD_ASSET.INVALID_SEMI_ANNUAL_SCHEDULE'),
              duration: 4000,
              templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
              classes: 'alert-danger',
              position: 'center'
            });
          }
          return validSchedule;

        } else if ('Quarterly' === vm.asset.valuationFrequency.value) {
          var quartersYear = [];
          for (var i = 1; i <= 4; i++) {
            quartersYear.push((new moment(vm.asset['scheduleQ' + i]).get('year')));
          }
          validSchedule = (quartersYear[0] === quartersYear[1] && quartersYear[1] === quartersYear[2] && quartersYear[2] === quartersYear[3]) ||
            (quartersYear[0] === quartersYear[1] + 1 && quartersYear[1] === quartersYear[2] && quartersYear[2] === quartersYear[3]) ||
            (quartersYear[0] === quartersYear[1] && quartersYear[1] === quartersYear[2] + 1 && quartersYear[2] === quartersYear[3]) ||
            (quartersYear[0] === quartersYear[1] && quartersYear[1] === quartersYear[2] && quartersYear[2] === quartersYear[3] + 1);
          if (!validSchedule) {
            notify({
              message: $filter('translate')('ADD_ASSET.INVALID_SCHEDULE'),
              duration: 4000,
              templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
              classes: 'alert-danger',
              position: 'center'
            });
          }
          return validSchedule;
        }
      }

      return false;
    }

    vm.submitForm = function () {
      vm.submitted = true;

      if (!formIsValid() || !vm.validRollOverDate) {
        return;
      }

      LoaderHelper.open();
      vm.uiLoading = true;
      var assetDTO = {};

      vm.asset.companyId = company.id;
      angular.copy(vm.asset, assetDTO);
      if (vm.asset.bidGroupId) {
        assetDTO.bidGroupId = vm.asset.bidGroupId.id;
      }
      if(vm.asset.subType) {
        assetDTO.subType = vm.asset.subType.type;
      }
      assetDTO.type = vm.asset.type.type;
      if (vm.asset.ownership) {
         assetDTO.ownership = vm.asset.ownership.type;
      }
      // GroundLeased (Yes/No) convert to (true/false)
      var groundLeasedDictionary = {};
      groundLeasedDictionary[GROUNDLEASED[0]] = true;
      groundLeasedDictionary[GROUNDLEASED[1]] = false;
      assetDTO.groundLeased = $filter('stringToBoolean')(groundLeasedDictionary, assetDTO.groundLeased);
      assetDTO.region = vm.asset.region ? vm.asset.region.type : undefined;
      assetDTO.requiredAppraisers = vm.asset.requiredAppraisers.value;

      if (vm.asset.rollOverDate) {
        assetDTO.rollOverDate = vm.asset.rollOverDate;
      }
      assetDTO.scheduleOption = parseInt(assetDTO.scheduleOption);
      assetDTO.valuationFrequency = vm.asset.valuationFrequency.value;

      var oldestQuarterDate = vm.asset.scheduleQ1,
        recentQuarterDate,
        quarter,
        quarterYear,
        quarterOfCycle,
        yearOfCycle;

      if (vm.asset.valuationFrequency) {
      if ('Annually' === assetDTO.valuationFrequency) {
        assetDTO.scheduleQ1 = vm.asset.scheduleQ1;
        delete assetDTO.scheduleQ2;
        delete assetDTO.scheduleQ3;
        delete assetDTO.scheduleQ4;
      } else if ('SemiAnnually' === assetDTO.valuationFrequency) {
        assetDTO.scheduleQ1 = vm.asset.scheduleQ1;
        assetDTO.scheduleQ2 = vm.asset.scheduleQ2;
        recentQuarterDate = assetDTO.scheduleQ2;
        delete assetDTO.scheduleQ3;
        delete assetDTO.scheduleQ4;
        if (oldestQuarterDate > assetDTO.scheduleQ2) {
          oldestQuarterDate = assetDTO.scheduleQ2;
          recentQuarterDate = assetDTO.scheduleQ1;
        }
      } else if ('Quarterly' === assetDTO.valuationFrequency) {
        assetDTO.scheduleQ1 = vm.asset.scheduleQ1;
        assetDTO.scheduleQ2 = vm.asset.scheduleQ2;
        assetDTO.scheduleQ3 = vm.asset.scheduleQ3;
        assetDTO.scheduleQ4 = vm.asset.scheduleQ4;
        if (oldestQuarterDate > assetDTO.scheduleQ2) {
          oldestQuarterDate = assetDTO.scheduleQ2;
        }
        if (oldestQuarterDate > assetDTO.scheduleQ3) {
          oldestQuarterDate = assetDTO.scheduleQ3;
        }
        if (oldestQuarterDate > assetDTO.scheduleQ4) {
          oldestQuarterDate = assetDTO.scheduleQ4;
        }
      }
      }

      if (oldestQuarterDate < new Date()) {
        var currentDate = new moment();
        quarterYear = currentDate.get('year');
        oldestQuarterDate = new moment(oldestQuarterDate);
        quarter = ReviewModel.getQuarterByDate(currentDate);
        var oldestQuarterMomentDate = moment(oldestQuarterDate);
        yearOfCycle = quarterYear - oldestQuarterMomentDate.get('year');
        if ('Annually' === assetDTO.valuationFrequency) {
          yearOfCycle++;
          quarterOfCycle = yearOfCycle;
          quarter = ReviewModel.getQuarterByDate(assetDTO.scheduleQ1);
        } else if ('SemiAnnually' === assetDTO.valuationFrequency) {
          quarterOfCycle = yearOfCycle * 2;
          var oldestQuarter = ReviewModel.getQuarterByDate(oldestQuarterDate),
            recentQuarter = ReviewModel.getQuarterByDate(recentQuarterDate);
          if(oldestQuarter <= quarter && recentQuarter <= quarter) {
            quarterOfCycle += 2;
          } else if((oldestQuarter <= quarter && recentQuarter > quarter) ||
            (oldestQuarter > quarter && recentQuarter <= quarter)) {
            quarterOfCycle += 1;
          }
        } else if ('Quarterly' === assetDTO.valuationFrequency) {
          quarterOfCycle = yearOfCycle * 4;
          quarterOfCycle += quarter -
            ReviewModel.getQuarterByDate(oldestQuarterMomentDate) + 1;
        }
        if ('Annually' !== assetDTO.valuationFrequency &&
          quarter >= ReviewModel.getQuarterByDate(oldestQuarterMomentDate)) {
          yearOfCycle++;
          if ('SemiAnnually' === assetDTO.valuationFrequency) {
            if (recentQuarter <= ReviewModel.getQuarterByDate(currentDate)) {
              quarter = ReviewModel.getQuarterByDate(recentQuarterDate);
            } else if (ReviewModel.getQuarterByDate(oldestQuarterDate) <= ReviewModel.getQuarterByDate(currentDate)) {
              quarter = ReviewModel.getQuarterByDate(oldestQuarterDate);
            }
          }
        }

      } else {
        quarterYear = new moment(oldestQuarterDate).get('year');
        quarterOfCycle = 1;
        yearOfCycle = 1;
        quarter = ReviewModel.getQuarterByDate(oldestQuarterDate);
      }

      if (vm.asset.rollOverDate) {
        assetDTO.rollOverDate = UtcDateConverter.setDateToUTC(assetDTO.rollOverDate);
      }
      if ('Annually' === assetDTO.valuationFrequency) {
        assetDTO.scheduleQ1 = UtcDateConverter.setDateToUTC(vm.asset.scheduleQ1);
        delete assetDTO.scheduleQ2;
        delete assetDTO.scheduleQ3;
        delete assetDTO.scheduleQ4;
      } else if ('SemiAnnually' === assetDTO.valuationFrequency) {
        assetDTO.scheduleQ1 = UtcDateConverter.setDateToUTC(vm.asset.scheduleQ1);
        assetDTO.scheduleQ2 = UtcDateConverter.setDateToUTC(vm.asset.scheduleQ2);
        recentQuarterDate = assetDTO.scheduleQ2;
        delete assetDTO.scheduleQ3;
        delete assetDTO.scheduleQ4;
      } else if ('Quarterly' === assetDTO.valuationFrequency) {
        assetDTO.scheduleQ1 = UtcDateConverter.setDateToUTC(vm.asset.scheduleQ1);
        assetDTO.scheduleQ2 = UtcDateConverter.setDateToUTC(vm.asset.scheduleQ2);
        assetDTO.scheduleQ3 = UtcDateConverter.setDateToUTC(vm.asset.scheduleQ3);
        assetDTO.scheduleQ4 = UtcDateConverter.setDateToUTC(vm.asset.scheduleQ4);
      }

      AssetService.createAsset(assetDTO).then(function (asset) {
        var promises = [];

        // Update Image
        if (vm.picture && vm.picture !== '/assets/images/dragBg.png' && vm.picture !== '/assets/images/ic_ErrorFile.png') {
          promises.push(AssetService.updateImage(asset.id, vm.picture));
        }

        // Update AssetManager
        if (vm.leadAssetManager) {
          promises.push(AssetService.addPrimary(asset.id, vm.leadAssetManager.user.id, quarter, quarterYear));
        }

        // Update Reviewer
        if (vm.leadReviewer) {
          promises.push(AssetService.addPrimary(asset.id, vm.leadReviewer.user.id, quarter, quarterYear));
        }

        // Deal with Internal Appraisers
        if ('Annually' === assetDTO.valuationFrequency && 'InternalAndExternal' === assetDTO.requiredAppraisers) {
          // Same as external
          assetDTO.requiredAppraisers = 'ExternalOnly';
        }

        if ('InternalAndExternal' === assetDTO.requiredAppraisers && 'Annually' !== assetDTO.valuationFrequency && vm.asset.internalAppraisers && vm.asset.internalAppraisers.length > 0) {
          var primaryInternalAppraiserUserId = vm.asset.internalAppraisers[0].user.id;;
          var secondaryInternalAppraiserUserId = null;
          if (vm.asset.internalAppraisers.length > 1) {
            secondaryInternalAppraiserUserId = vm.asset.internalAppraisers[1].user.id;
          }
          var periodsForInternalAppraisers = [];

          if (vm.asset.scheduleQ1 && vm.asset.scheduleOption != 1) {
            // if scheduleOption is 1 then Q1 should go to external
            var firstDraftDate = moment(vm.asset.scheduleQ1);
            var q1Year = firstDraftDate.get('year');
            var q1Quarter = ReviewModel.getQuarterByDate(firstDraftDate);
            periodsForInternalAppraisers.push({year: q1Year, quarter: q1Quarter});
          }
          if (vm.asset.scheduleQ2 && vm.asset.scheduleOption != 2) {
            // if scheduleOption is 2 then Q2 should go to external
            var secondDraftDate = moment(vm.asset.scheduleQ2);
            var q2Year = secondDraftDate.get('year');
            var q2Quarter = ReviewModel.getQuarterByDate(secondDraftDate);
            periodsForInternalAppraisers.push({year: q2Year, quarter: q2Quarter});
          }
          if (vm.asset.scheduleQ3 && vm.asset.scheduleOption != 3) {
            // if scheduleOption is 3 then Q3 should go to external
            var thirdDraftDate = moment(vm.asset.scheduleQ3);
            var q3Year = thirdDraftDate.get('year');
            var q3Quarter = ReviewModel.getQuarterByDate(thirdDraftDate);
            periodsForInternalAppraisers.push({year: q3Year, quarter: q3Quarter});
          }
          if (vm.asset.scheduleQ4 && vm.asset.scheduleOption != 4) {
            // if scheduleOption is 4 then Q4 should go to external
            var fourthDraftDate = moment(vm.asset.scheduleQ4);
            var q4Year = fourthDraftDate.get('year');
            var q4Quarter = ReviewModel.getQuarterByDate(fourthDraftDate);
            periodsForInternalAppraisers.push({year: q4Year, quarter: q4Quarter});
          }
          if (primaryInternalAppraiserUserId) {
            promises.push(AssetService.addUser(asset.id, primaryInternalAppraiserUserId).then(function (user) {
              var addPriodPromises = [];
              periodsForInternalAppraisers.forEach(function (period) {
                //promises.push(AssetService.addUserPeriod({id: user.id, quarter: period.quarter, year: period.year, isPrimary: true}));
                addPriodPromises.push(AssetService.addUserPeriod({id: user.id, quarter: period.quarter, year: period.year, isPrimary: true}));
              } // end forEach
              ); // end forEach
              return $q.all(addPriodPromises);
            } // end then function
            ) // end addUser then
            ); // end promises push
          }

          if (secondaryInternalAppraiserUserId) {
            promises.push(AssetService.addUser(asset.id, secondaryInternalAppraiserUserId).then(function (user) {
              var addPriodPromisesSecondary = [];
              periodsForInternalAppraisers.forEach(function (period) {
                //promises.push(AssetService.addUserPeriod({id: user.id, quarter: period.quarter, year: period.year, isPrimary: false}));
                addPriodPromisesSecondary.push(AssetService.addUserPeriod({id: user.id, quarter: period.quarter, year: period.year, isPrimary: false}));
              });
              return $q.all(addPriodPromisesSecondary);
            }));
          }
        }

        var currentDate = new moment();
        var nextDraftDueDate = null;
        var currentQuarter = ReviewModel.getQuarterByDate(currentDate);


        if (quarterYear <= currentDate.get('year') && quarter === currentQuarter) {
          if ('Annually' === assetDTO.valuationFrequency) {
            nextDraftDueDate = moment(UtcDateConverter.getDateFromUTC(assetDTO['scheduleQ1']));
            nextDraftDueDate.set('year', quarterYear);
          } else if ('SemiAnnually' === assetDTO.valuationFrequency) {
            if (ReviewModel.getQuarterByDate(recentQuarterDate) === ReviewModel.getQuarterByDate(currentDate)) {
              nextDraftDueDate = moment(recentQuarterDate);
              nextDraftDueDate.set('year', quarterYear);
            } else if (ReviewModel.getQuarterByDate(oldestQuarterDate) === ReviewModel.getQuarterByDate(currentDate)) {
              nextDraftDueDate = moment(oldestQuarterDate);
              nextDraftDueDate.set('year', quarterYear);
            }
          } else if ('Quarterly' === assetDTO.valuationFrequency) {
            nextDraftDueDate = moment(UtcDateConverter.getDateFromUTC(assetDTO['scheduleQ' + currentQuarter]));
            nextDraftDueDate.set('year', quarterYear);
          }
          promises.push(ValuationService.createValuation({
            assetId: asset.id,
            year: quarterYear,
            quarter: quarter,
            yearOfCycle: yearOfCycle,
            quarterOfCycle: quarterOfCycle,
            nextDraftDueDate: UtcDateConverter.setDateToUTC(nextDraftDueDate),
            valuationCycle: 1
          }));
        }

        // Update Documents
        vm.documentsToUpload.forEach(function (file) {
          promises.push(AssetService.documentCreate(asset.id, file, file.name, 'Other'));
        });

        $q.all(promises).then(function () {
          notify({
            message: $filter('translate')('ASSETS.NEW_ASSET_CREATED'),
            duration: 4000,
            templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
            classes: 'alert-info',
            position: 'center'
          });
          $state.go('app.asset.all');
        }, function () {
          vm.uiLoading = false;
          LoaderHelper.close();
        });
      }, function () {
        vm.uiLoading = false;
        LoaderHelper.close();
      });
    };

    //DATEPICKER
    //------------------------------------------------------
    vm.overDuePicker = {
      opened: false
    };
    vm.q1Picker = {
      opened: false
    };
    vm.q2Picker = {
      opened: false
    };
    vm.q3Picker = {
      opened: false
    };
    vm.q4Picker = {
      opened: false
    };

    vm.openDueDatePicker = function () {
      vm.overDuePicker.opened = true;
    };

    vm.openQ1Picker = function () {
      vm.q1Picker.opened = true;
    };

    vm.openQ2Picker = function () {
      vm.q2Picker.opened = true;
    };

    vm.openQ3Picker = function () {
      vm.q3Picker.opened = true;
    };

    vm.openQ4Picker = function () {
      vm.q4Picker.opened = true;
    };

    vm.dateOptions = {
      startingDay: 1,
      showWeeks: false
    };

    vm.modelOptions = {
      debounce: {
        default: 500,
        blur: 250
      },
      getterSetter: true
    };

    function validateRollOverDate(valuationFrequency, firstDraft, secondDraft, rollOverDate) {
      if('Annually' === valuationFrequency) {
        return ReviewModel.getQuarterByDate(firstDraft) === ReviewModel.getQuarterByDate(rollOverDate);
      } else if('SemiAnnually' === valuationFrequency) {
        return ReviewModel.getQuarterByDate(firstDraft) === ReviewModel.getQuarterByDate(rollOverDate) ||
          ReviewModel.getQuarterByDate(secondDraft) === ReviewModel.getQuarterByDate(rollOverDate);
      }
    }

    var companyListener = $scope.$on('companyChanged', function (event, selectedCompany) {
      CompanySelectorFactory.executeOnValidState('app.asset.addAsset', function () {
        company = selectedCompany;
        vm.assetsManagers = [];
        UserService.getUsersByCompanyId(company.id, true).then(function (users) {
          if (users.length > 0) {
            for (var i = 0; i < users.length; i++) {
              if (users[i].user.userCompanyRoles) {
                if (users[i].user.userCompanyRoles.length > 1) {
                  for (var j = 0; j < users[i].user.userCompanyRoles.length; j++) {
                    if ('AssetManager' === users[i].user.userCompanyRoles[j] || 'AssetManagerReadOnly' === users[i].user.userCompanyRoles[j]) {
                      vm.assetsManagers.push(users[i]);
                      break;
                    }
                  }
                } else if ('AssetManager' === users[i].user.userCompanyRoles[0] || 'AssetManagerReadOnly' === users[i].user.userCompanyRoles[0]) {
                  vm.assetsManagers.push(users[i]);
                }
              }
            }
          }
        });
        BidGroupService.list(company.id).then(function (bidGroups) {
          vm.biddingGroups = bidGroups;
        });
      });
    });

    var countryWatch = $scope.$watch('addAsset.country', function () {
      vm.state = undefined;
    });

    var stateWatch = $scope.$watch('addAsset.state', function () {
      vm.city = undefined;
    });

    var countryWatchNew = $scope.$watch('addAsset.asset.country', function (newValue) {
      if (newValue) {
        vm.asset.region = undefined;
      }
    });
  
    var stateWatchNew = $scope.$watch('addAsset.asset.state', function (newValue) {
      if (newValue) {
        vm.asset.region = undefined;
        if (vm.ncreifRegionByStates[newValue]) {
          for (i = 0; i < vm.ncreifs.length; i++) {
            if (vm.ncreifs[i].type === vm.ncreifRegionByStates[newValue]) {
              vm.asset.region = vm.ncreifs[i];
              break;
            }
          }
          //var found = vm.ncreifs.find(element => element.type === vm.ncreifRegionByStates[newValue]);
        }
      }
    });

    var assetTypeWatch = $scope.$watch('addAsset.type', function () {
      vm.subType = undefined;
    });

    var frequencyWatch = $scope.$watch('addAsset.asset.valuationFrequency', function (newValue) {
      if (newValue && 'Annually' === newValue.value) {
        if (vm.asset.requiredAppraisers && vm.asset.requiredAppraisers.value !== 'ExternalOnly') {
          vm.asset.requiredAppraisers = undefined;
        }
        vm.asset.scheduleOption = 1;
        vm.asset.scheduleQ2 = undefined;
        vm.asset.scheduleQ3 = undefined;
        vm.asset.scheduleQ4 = undefined;
        if(vm.asset.scheduleQ1 && vm.asset.rollOverDate) {
          vm.validRollOverDate = validateRollOverDate('Annually', vm.asset.scheduleQ1, undefined, vm.asset.rollOverDate);
          if(!vm.validRollOverDate) {
            notify({
              message: $filter('translate')('ADD_ASSET.INVALID_ANNUAL_ROLL_OVER_DATE'),
              duration: 5000,
              templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
              classes: 'alert-danger',
              position: 'center'
            });
          }
        }
      } else if (newValue && 'SemiAnnually' === newValue.value) {
        if ('3' === vm.asset.scheduleOption || '4' === vm.asset.scheduleOption) {
          vm.asset.scheduleOption = 1;
        }
        vm.asset.scheduleQ3 = undefined;
        vm.asset.scheduleQ4 = undefined;
        if(vm.asset.scheduleQ1 && vm.asset.scheduleQ2 && vm.asset.rollOverDate) {
          vm.validRollOverDate = validateRollOverDate('SemiAnnually', vm.asset.scheduleQ1, vm.asset.scheduleQ2, vm.asset.rollOverDate);
          if(!vm.validRollOverDate) {
            notify({
              message: $filter('translate')('ADD_ASSET.INVALID_SEMI_ROLL_OVER_DATE'),
              duration: 5000,
              templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
              classes: 'alert-danger',
              position: 'center'
            });
          }
        }
      } else if (newValue && 'Quarterly' === newValue.value) {
        vm.validRollOverDate = true;
        vm.asset.scheduleQ1 = undefined;
        vm.asset.scheduleQ2 = undefined;
        vm.asset.scheduleQ3 = undefined;
        vm.asset.scheduleQ4 = undefined;
      }
    });

    var semiAnnualFirstQWatch = $scope.$watch('addAsset.asset.scheduleQ1', function (newValue, oldValue) {
      if (vm.asset.valuationFrequency && 'Annually' === vm.asset.valuationFrequency.value && newValue) {
        vm.asset.scheduleOption = 1;
        if(vm.asset.rollOverDate) {
          vm.validRollOverDate = validateRollOverDate('Annually', vm.asset.scheduleQ1, undefined, vm.asset.rollOverDate);
          if(!vm.validRollOverDate) {
            notify({
              message: $filter('translate')('ADD_ASSET.INVALID_ANNUAL_ROLL_OVER_DATE'),
              duration: 5000,
              templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
              classes: 'alert-danger',
              position: 'center'
            });
          }
        }
      }
      if (vm.asset.valuationFrequency && 'SemiAnnually' === vm.asset.valuationFrequency.value && newValue && vm.asset.scheduleQ2) {
        var firstDraftDate = moment(vm.asset.scheduleQ1),
          secondDraftDate = moment(vm.asset.scheduleQ2),
          q1Year = firstDraftDate.get('year'),
          q2Year = secondDraftDate.get('year'),
          q1Quarter = ReviewModel.getQuarterByDate(firstDraftDate),
          q2Quarter = ReviewModel.getQuarterByDate(secondDraftDate);

        if ((q1Quarter === q2Quarter && q1Year === q2Year) ||
          (Math.abs(firstDraftDate.diff(secondDraftDate, 'months')) > 11)) {
          vm.asset.scheduleQ1 = oldValue;
        } else if(vm.asset.rollOverDate) {
          vm.validRollOverDate = validateRollOverDate('SemiAnnually', newValue, vm.asset.scheduleQ2, vm.asset.rollOverDate);
          if(!vm.validRollOverDate) {
            notify({
              message: $filter('translate')('ADD_ASSET.INVALID_SEMI_ROLL_OVER_DATE'),
              duration: 5000,
              templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
              classes: 'alert-danger',
              position: 'center'
            });
          }
        }
      }
    });

    var semiAnnualSecondQWatch = $scope.$watch('addAsset.asset.scheduleQ2', function (newValue, oldValue) {
      if (vm.asset.valuationFrequency && 'SemiAnnually' === vm.asset.valuationFrequency.value && newValue &&
        vm.asset.scheduleQ1) {
        var firstDraftDate = moment(vm.asset.scheduleQ1),
          secondDraftDate = moment(vm.asset.scheduleQ2),
          q1Year = firstDraftDate.get('year'),
          q2Year = secondDraftDate.get('year'),
          q1Quarter = ReviewModel.getQuarterByDate(firstDraftDate),
          q2Quarter = ReviewModel.getQuarterByDate(secondDraftDate);

        if ((q1Quarter === q2Quarter && q1Year === q2Year) ||
          (Math.abs(firstDraftDate.diff(secondDraftDate, 'months')) > 11)) {
          vm.asset.scheduleQ2 = oldValue;
        } else if(vm.asset.rollOverDate) {
          vm.validRollOverDate = validateRollOverDate('SemiAnnually', vm.asset.scheduleQ1, newValue,
            vm.asset.rollOverDate);
          if(!vm.validRollOverDate) {
            notify({
              message: $filter('translate')('ADD_ASSET.INVALID_SEMI_ROLL_OVER_DATE'),
              duration: 5000,
              templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
              classes: 'alert-danger',
              position: 'center'
            });
          }
        }
      }
    });

    var rollOverDateWatch = $scope.$watch('addAsset.asset.rollOverDate', function (newValue, oldValue){
      if(vm.asset.valuationFrequency && 'Annually' === vm.asset.valuationFrequency.value && vm.asset.scheduleQ1) {
        vm.validRollOverDate = validateRollOverDate('Annually', vm.asset.scheduleQ1, undefined, newValue);
        if(!vm.validRollOverDate) {
          notify({
            message: $filter('translate')('ADD_ASSET.INVALID_ANNUAL_ROLL_OVER_DATE'),
            duration: 5000,
            templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
            classes: 'alert-danger',
            position: 'center'
          });
        }
      } else if(vm.asset.valuationFrequency && 'SemiAnnually' === vm.asset.valuationFrequency.value &&
        vm.asset.scheduleQ1 && vm.asset.scheduleQ2) {
        vm.validRollOverDate = validateRollOverDate('SemiAnnually', vm.asset.scheduleQ1, vm.asset.scheduleQ2, newValue);
        if(!vm.validRollOverDate) {
          notify({
            message: $filter('translate')('ADD_ASSET.INVALID_SEMI_ROLL_OVER_DATE'),
            duration: 5000,
            templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
            classes: 'alert-danger',
            position: 'center'
          });
        }
      }
    });

    var internalAppraisersWatch = $scope.$watch('addAsset.asset.internalAppraisers', function (newValue, oldValue) {
      var primaryInternalAppraiser = null;
      var secondaryInternalAppraiser = null;
      if (newValue && newValue.length === 2 && oldValue && oldValue.length === 1) {
        primaryInternalAppraiser = oldValue[0];

        if (newValue[0].user.id === oldValue[0].user.id) {
          secondaryInternalAppraiser = newValue[1];
        } else {
          secondaryInternalAppraiser = newValue[0];
        }
        var pSelIndex = -1;
        var sSelIndex = -1;
        for (i = 0; i < vm.internalAppraisers.length; i++) {
          if (primaryInternalAppraiser.user.id === vm.internalAppraisers[i].user.id) {
            pSelIndex = i;
          }
          if (secondaryInternalAppraiser.user.id === vm.internalAppraisers[i].user.id) {
            sSelIndex = i;
          }
        }
        // To preserve the order in selected display, swap positions
        if (pSelIndex !== -1 && sSelIndex !== -1 && sSelIndex < pSelIndex) {
            var temp = vm.internalAppraisers[pSelIndex];
            vm.internalAppraisers[pSelIndex] = vm.internalAppraisers[sSelIndex];
            vm.internalAppraisers[sSelIndex] = temp;
        }
      }
    });

    $scope.$on('$destroy', function () {
      companyListener();
      countryWatch();
      stateWatch();
      countryWatchNew();
      stateWatchNew();
      assetTypeWatch();
      frequencyWatch();
      semiAnnualFirstQWatch();
      semiAnnualSecondQWatch();
      internalAppraisersWatch();
      rollOverDateWatch();
    });

  }

})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .factory('UtcDateConverter', UtcDateConverter);

  /**@ngInject*/
  function UtcDateConverter() {

    return {
      setDateToUTC: setDateToUTC,
      getDateFromUTC: getDateFromUTC,
      getMillisecondsFromUTC: getMillisecondsFromUTC
    };

    function setDateToUTC(dateToParse) {
      dateToParse = dateToParse instanceof Date ? dateToParse : new Date(dateToParse);
      var year, month, day;
      dateToParse.setHours(0);
      dateToParse.setMinutes(0);
      dateToParse.setSeconds(0);
      year = dateToParse.getFullYear();
      month = dateToParse.getMonth();
      day = dateToParse.getDate();

      var timeZoneDate = new Date(year, month, day);
      var milliseconds = timeZoneDate.getTime();
      var offset = timeZoneDate.getTimezoneOffset() * 60000;

      return milliseconds - offset;
    }

    function getDateFromUTC(epoch) {
      var lDate = new Date(epoch);
      return new Date(epoch - (lDate.getTimezoneOffset() * 60 * 1000 *-1));
    }

    function getMillisecondsFromUTC(epoch) {
      return epoch - (new Date().getTimezoneOffset() * 60 * 1000 *-1);
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .factory('StateTransitionValidator', StateTransitionValidator);

  /**@ngInject*/
  function StateTransitionValidator ($state, LoaderHelper) {
    return {
      validateTransition: function(event, toState, toParams, fromState) {
        if(toState.data && toState.data.validPreviousStates) {
          if(fromState.name == '') {
            $state.go(toState.data.fallBackState || 'app.valuations');
          }
          for(var i = 0; i < toState.data.validPreviousStates.length; i++) {
            if(fromState.name == toState.data.validPreviousStates[i]) {
              return;
            }
          }
          if(toState.data.fallBackState){
            $state.go(toState.data.fallBackState || 'app.valuations');
          }else{
            LoaderHelper.close();
          }
          event.preventDefault();
        }
      }
    }
  }

})();

(function () {
  'use strict';

  angular.module('nvc').factory('SessionManager', SessionManager);

  /**@ngInject*/
  function SessionManager($q, $timeout, $window, localStorageService) {
    var _identity, i,
    _authenticated = false;

    return {
      isIdentityResolved: function () {
        return angular.isDefined(_identity);
      },
      isAuthenticated: function () {
        return _authenticated;
      },
      isInRole: function (role) {
        if (!_authenticated || !_identity || !_identity.role) {
          return false;
        }

        if('AssetManagement' == _identity.role) {
          if(_identity.user.userCompanyRoles && _identity.user.userCompanyRoles.length > 1) {
            for(var i = 0; i < _identity.user.userCompanyRoles.length; i ++) {
              if(_identity.user.userCompanyRoles[i] == 'AssetManagerReadOnly') {
                _identity.role = 'AssetManagerReadOnly';
                break;
              }
            }
          } else if(_identity.user.userCompanyRoles && _identity.user.userCompanyRoles[0] == 'AssetManagerReadOnly') {
            _identity.role = 'AssetManagerReadOnly';
          }
        }
        return _identity.role == role;
      },
      isInAnyRole: function (roles) {
        if (!_authenticated && !roles[0]) {//if it isn´t in a role and no role is required
          return true;
        }

        if (!_authenticated || !_identity.role) {
          return false;
        }

        for (i = 0; i < roles.length; i++) {
          if (this.isInRole(roles[i])) {
            return true;
          }
        }

        return false;
      },
      getRoleName: function () {
        if (!_authenticated || !_identity || !_identity.role) {
          return undefined;
        }

        return _identity.role;
      },
      getName: function () {
        if (!_authenticated || !_identity || !_identity.role) {
          return undefined;
        }

        return _identity.name;
      },
      getCompanyId: function () {
        if (_identity.availableRoles.length === 1) {
          return _identity.availableRoles[0].id;
        }
        var companyName = _identity.company.name;
        for (var i = 0; i < _identity.availableRoles.length; i++) {
          if (companyName === _identity.availableRoles[i].name) {
            return _identity.availableRoles[i].id;
          }
        }
        /*
        var role = _identity.role;
        for (var i = 0; i < _identity.availableRoles.length; i++) {
          if (role === _identity.availableRoles[i].type) {
            return _identity.availableRoles[i].id;
          }
        }
        */
      },
      authenticate: function (identity) {
        _identity = identity;
        _authenticated = null !== identity;
        if (identity) {
          localStorageService.set("identity", angular.toJson(identity));
        } else {
          localStorageService.remove("identity");
        }
      },
      identity: function (force) {
        var deferred = $q.defer();

        if (true === force) {
          _identity = undefined;
        }

        // check and see if we have retrieved the identity data from the server.
        // if we have, reuse it by immediately resolving
        if (angular.isDefined(_identity)) {
          deferred.resolve(_identity);
          return deferred.promise;
        }

        var self = this;
        _identity = angular.fromJson(localStorageService.get("identity"));
        self.authenticate(_identity);
        $timeout(function () {
          deferred.resolve(_identity);
        }, 500);
        return deferred.promise;
      },
      getUser : function(){
        if (angular.isDefined(_identity)) {
          return _identity.user;
        }
      },
      getUserId : function(){
        if (angular.isDefined(_identity)) {
          return _identity.user.id;
        }
      },
      availableRoles: function () {
        return _identity.availableRoles;
      },
      changeRole: function (role, companyName) {
        var currentIdentity = angular.fromJson(localStorageService.get("identity"));
        var prevCompanyName = currentIdentity.company.name;

        /*
        if (currentIdentity && currentIdentity.companies) {
          for (i = 0; i < currentIdentity.companies.length; i++) {
            if (currentIdentity.companies[i].type === role) {
              currentIdentity.user.userCompanyId = currentIdentity.companies[i].id;
            }
          }
        }
        */
        if (currentIdentity && currentIdentity.companies) {
          for (i = 0; i < currentIdentity.companies.length; i++) {
            if (currentIdentity.companies[i].name === companyName) {
              currentIdentity.company = currentIdentity.companies[i];
              break;
            }
          }
        }

        if (currentIdentity && currentIdentity.relatedUsers) {
          for (i = 0; i < currentIdentity.relatedUsers.length; i++) {
            if (currentIdentity.relatedUsers[i].userCompanyId === currentIdentity.company.id
              || (currentIdentity.company.type === 'Admin' && currentIdentity.relatedUsers[i].userCompanyRoles && currentIdentity.relatedUsers[i].userCompanyRoles.includes('Administrator'))
              || (currentIdentity.relatedUsers[i].adminCompany && currentIdentity.relatedUsers[i].adminCompany.id ===  currentIdentity.company.id)) {
              currentIdentity.user = currentIdentity.relatedUsers[i];
              break;
            }
          }
        }
        if (currentIdentity.user && currentIdentity.user.id) {
          var tokenCookieKey = 'session_token' + currentIdentity.user.id;
          var newSessionToken = localStorageService.cookie.get('session_token' + currentIdentity.user.id);
          if (newSessionToken) {
            localStorageService.cookie.set('session_token', newSessionToken);
          }
        }

        if (-1 !== currentIdentity.availableRoles.map(function (e) {
          return e.name;
        }).indexOf(companyName) && companyName != prevCompanyName) {
          this.authenticate({
            role: role,
            company: currentIdentity.company,
            name: currentIdentity.user.name,
            user: currentIdentity.user,
            availableRoles: currentIdentity.availableRoles,
            companies: currentIdentity.companies,
            relatedUsers: currentIdentity.relatedUsers
          });
          $window.location.reload();
        }
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .factory('SecurityManager', SecurityManager);

  /**@ngInject*/
  function SecurityManager(SessionManager) {

    return {
      canSeeUser: canSeeUser,
      isAdmin: isAdmin,
      isCurrentUserAdmin: isCurrentUserAdmin,
      isAssetManager: isAssetManager,
      isCurrentUserAssetManager: isCurrentUserAssetManager,
      isAppraiser: isAppraiser,
      isCurrentUserAppraiser: isCurrentUserAppraiser,
      isReviewer: isReviewer,
      isCurrentUserReviewer: isCurrentUserReviewer
    };

    function isCurrentUserAdmin() {
      var currentRole = SessionManager.getRoleName();
      return isAdmin(currentRole);
    }

    function isCurrentUserAssetManager() {
      var currentRole = SessionManager.getRoleName();
      return isAssetManager(currentRole);
    }

    function isCurrentUserAppraiser() {
      var currentRole = SessionManager.getRoleName();
      return isAppraiser(currentRole);
    }

    function isCurrentUserReviewer() {
      var currentRole = SessionManager.getRoleName();
      return isReviewer(currentRole);
    }

    function isAdmin(userRole) {
      return ['Admin', 'Administrator'].indexOf(userRole) !== -1;
    }

    function isAssetManager(userRole) {
      return ['AssetManagement', 'AssetManager', 'AssetManagerReadOnly'].indexOf(userRole) !== -1;
    }

    function isAppraiser(userRole) {
      return ['AssetAppraisal', 'Appraiser'].indexOf(userRole) !== -1;
    }

    function isReviewer(userRole) {
      return ['AssetReview', 'Reviewer'].indexOf(userRole) !== -1;
    }

    function canSeeUser(role) {
      var currentRole = SessionManager.getRoleName();
      var visibilityRules = {
        Admin: ['Administrator', 'Admin', 'Audit', 'AssetManagement', 'AssetManager', 'AssetAppraisal', 'Appraiser', 'AssetReview', 'Reviewer'],
        Audit: ['Administrator', 'Admin', 'Audit', 'AssetManagement', 'AssetManager', 'AssetAppraisal', 'Appraiser', 'AssetReview', 'Reviewer'],
        AssetManagement: ['Administrator', 'Admin', 'Audit', 'AssetManagement', 'AssetManager', 'AssetReview', 'Reviewer'],
        AssetManagerReadOnly: ['Administrator', 'Admin', 'Audit', 'AssetManagement', 'AssetManager', 'AssetReview', 'Reviewer'],
        AssetAppraisal: ['AssetAppraisal', 'Appraiser'],
        AssetReview: ['Administrator', 'Admin', 'Audit', 'AssetManagement', 'AssetManager', 'AssetAppraisal', 'Appraiser', 'AssetReview', 'Reviewer']
      };
      return visibilityRules[currentRole].indexOf(role) !== -1;
    }
  }

})();

(function () {
  'use strict';

  angular
  .module('nvc')
  .factory('RoleFactory', RoleFactory);

  /**@ngInject*/
  function RoleFactory() {

    var colorsByRole = {
      Administrator: '#e57a43',
      Admin: '#e57a43',
      Reviewer: '#3b5da3',
      AssetManager: '#a254a1',
      Appraiser: '#22b6e3',
      Auditor: '#00b2b2'
    };

    return {
      companyTypeToRole: companyTypeToRole,
      companyTypesToRoles: companyTypesToRoles,
      htmlClass: htmlClass,
      getColor: getColor,
      valuationRoleToCompanyRole: valuationRoleToCompanyRole
    };

    function companyTypeToRole(type) {
      switch (type) {
        case 'Admin':
          return 'Administrator';
        case 'AssetManagement':
          return 'Asset Manager';
        case 'AssetManagerReadOnly':
          return 'Asset Manager';
        case 'AssetAppraisal':
          return 'Appraiser';
        case 'AssetReview':
          return 'Reviewer';
        case 'Audit':
          return 'Auditor';
        default:
          return '';
      }
    }

    function companyTypesToRoles(types) {
      var returnArray = [];
      for (var i = 0; i < types.length; i++) {
        returnArray.push(companyTypeToRole(types[i]));
      }
      return returnArray;
    }

    function htmlClass(role) {
      if (role) {
        return role.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
      }
    }

    function getColor(role){
      return colorsByRole[role]
    }

    function valuationRoleToCompanyRole(ValuationRole){
      return {
        PrimaryAssetManager: 'AssetManagement',
        SecondaryAssetManager: 'AssetManagement',
        PrimaryAssetAppraiser: 'AssetAppraisal',
        SecondaryAssetAppraiser: 'AssetAppraisal',
        PrimaryAssetReviewer: 'AssetReview',
        SecondaryAssetReviewer: 'AssetReview',
        PrimaryAssetAuditor: 'Audit'
      }[ValuationRole];
    }
  }
  
})();

(function() {
  angular.module("nvc").factory("PDFGenerator", PDFGenerator);

  function PDFGenerator(
    $filter,
    $q,
    ReviewStatusHelper,
    RoleFactory,
    BidRequestService,
    BidResponseService,
    BidGroupService,
    AssetService,
    Base64Factory,
    SecurityManager,
    PDF_HEADERS,
    UtcDateConverter
  ) {
    return {
      generateAssetDetailsPage: generateAssetDetailsPage,
      generateAssetsListPdf: generateAssetsListPdf,
      generateBidEngagementListPdf: generateBidEngagementListPdf,
      generateBidGroupsPdf: generateBidGroupsPdf,
      generateBidSummaryPdf: generateBidSummaryPdf,
      generateExecutiveSummary: generateExecutiveSummary,
      generateRequestStatusPdf: generateRequestStatusPdf,
      generateResponseSummaryPdf: generateResponseSummaryPdf,
      generateReviewForm: generateReviewForm,
      generateRolesPdf: generateRolesPdf
    };

    function generateAssetDetailsPage(
      asset,
      documents,
      leadAssetManager,
      leadReviewer
    ) {
      return $q(function(resolve, reject) {
        Base64Factory.base64FromImageUrl(asset.picture).then(function(
          base64Url
        ) {
          var docDefinition = {
            pageMargins: [25, 81, 25, 20],
            pageSize: { width: 650, height: 1000 },
            header: {
              image: PDF_HEADERS._assetDetailsPageHeader,
              width: 600,
              margin: [25, 10, 25, 0]
            },
            footer: function(currentPage, pageCount) {
              return {
                text: currentPage.toString() + "/" + pageCount,
                fontSize: 9.6,
                lineHeight: 1.145, // 11px
                alignment: "center",
                color: "#222"
              };
            },
            content: [
              {
                columns: [
                  {
                    width: 240,
                    fillColor: "#eee",
                    stack: [
                      {
                        image: base64Url,
                        width: 224
                      }
                    ]
                  },
                  {
                    width: "*",
                    alignment: "left",
                    stack: [
                      {
                        style: "h1",
                        text: $filter("translate")(
                          "ASSET_DETAILS.PROPERTY_DETAIL"
                        )
                      },
                      {
                        canvas: [
                          {
                            type: "line",
                            x1: 0,
                            y1: 10,
                            x2: 360,
                            y2: 10,
                            lineWidth: 1,
                            lineColor: "#E7EAEC"
                          }
                        ]
                      },
                      {
                        columns: [
                          {
                            width: "65%",
                            stack: [
                              {
                                text: $filter("translate")(
                                  "ASSET_DETAILS.NAME"
                                ),
                                style: "label"
                              },
                              {
                                text: asset.name || "N/A",
                                style: "h2"
                              }
                            ]
                          },
                          {
                            stack: [
                              {
                                text: $filter("translate")("ASSET_DETAILS.ID"),
                                style: "label"
                              },
                              {
                                text: asset.propertyRef || "N/A",
                                style: "h2"
                              }
                            ]
                          }
                        ]
                      },
                      {
                        canvas: [
                          {
                            type: "line",
                            x1: 0,
                            y1: 10,
                            x2: 360,
                            y2: 10,
                            lineWidth: 1,
                            lineColor: "#E7EAEC"
                          }
                        ]
                      },
                      {
                        columns: [
                          {
                            width: "50%",
                            stack: [
                              {
                                text: $filter("translate")(
                                  "ASSET_DETAILS.PROPERTY_TYPE"
                                ),
                                style: "label"
                              },
                              {
                                text: asset.typeName || "N/A",
                                style: "h2"
                              }
                            ]
                          },
                          {
                            stack: [
                              {
                                text: $filter("translate")(
                                  "ASSET_DETAILS.SUBTYPE"
                                ),
                                style: "label"
                              },
                              {
                                text: asset.subType || "N/A",
                                style: "h2"
                              }
                            ]
                          }
                        ]
                      },
                      {
                        canvas: [
                          {
                            type: "line",
                            x1: 0,
                            y1: 10,
                            x2: 360,
                            y2: 10,
                            lineWidth: 1,
                            lineColor: "#E7EAEC"
                          }
                        ]
                      },
                      {
                        columns: [
                          {
                            width: "100%",
                            stack: [
                              {
                                text: $filter("translate")(
                                  "ASSET_DETAILS.ADDRESS"
                                ),
                                style: "label"
                              },
                              {
                                text: asset.address.address || "",
                                style: "h2"
                              }
                            ]
                          }
                        ]
                      },
                      {
                        canvas: [
                          {
                            type: "line",
                            x1: 0,
                            y1: 10,
                            x2: 360,
                            y2: 10,
                            lineWidth: 1,
                            lineColor: "#E7EAEC"
                          }
                        ]
                      },
                      {
                        columns: [
                          {
                            width: "35%",
                            stack: [
                              {
                                text: $filter("translate")(
                                  "ASSET_DETAILS.COUNTRY"
                                ),
                                style: "label"
                              },
                              {
                                text: asset.address.country || "",
                                style: "h2"
                              }
                            ]
                          },
                          {
                            width: "15%",
                            stack: [
                              {
                                text: $filter("translate")(
                                  "ASSET_DETAILS.STATE"
                                ),
                                style: "label"
                              },
                              {
                                text: asset.address.state || "",
                                style: "h2"
                              }
                            ]
                          },
                          {
                            width: "30%",
                            stack: [
                              {
                                text: $filter("translate")(
                                  "ASSET_DETAILS.CITY"
                                ),
                                style: "label"
                              },
                              {
                                text: asset.address.city || "",
                                style: "h2"
                              }
                            ]
                          },
                          {
                            width: "35%",
                            stack: [
                              {
                                text: $filter("translate")(
                                  "ASSET_DETAILS.ZIPCODE"
                                ),
                                style: "label"
                              },
                              {
                                text: asset.address.zip || "",
                                style: "h2"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                canvas: [
                  {
                    type: "line",
                    x1: 0,
                    y1: 20,
                    x2: 600,
                    y2: 20,
                    lineWidth: 1,
                    lineColor: "#E7EAEC"
                  }
                ]
              },
              {
                columns: [
                  {
                    width: "20%",
                    stack: [
                      {
                        text: $filter("translate")("ADD_ASSET.GROSS_AREA"),
                        style: "label"
                      },
                      {
                        text: $filter("number")(asset.grossArea) + " SF",
                        style: "h2"
                      }
                    ]
                  },
                  {
                    width: "20%",
                    stack: [
                      {
                        text: $filter("translate")("ADD_ASSET.LEASABLE_AREA"),
                        style: "label"
                      },
                      {
                        text: $filter("number")(asset.leasableArea) + " SF",
                        style: "h2"
                      }
                    ]
                  },
                  {
                    width: "20%",
                    stack: [
                      {
                        text: $filter("translate")("ADD_ASSET.GROUND_LEASED"),
                        style: "label"
                      },
                      {
                        text: asset.groundLeased,
                        style: "h2"
                      }
                    ]
                  },
                  {
                    width: "20%",
                    stack: [
                      {
                        text: $filter("translate")("ASSET_DETAILS.LAND_SIZE"),
                        style: "label"
                      },
                      {
                        text: $filter("number")(asset.landsize) + " Acres",
                        style: "h2"
                      }
                    ]
                  },
                  {
                    width: "20%",
                    stack: [
                      {
                        text: $filter("translate")(
                          "ASSET_DETAILS.GARAGE_PARKING"
                        ),
                        style: "label"
                      },
                      {
                        text: $filter("number")(asset.garageParkingSpaces),
                        style: "h2"
                      }
                    ]
                  }
                ]
              },
              {
                canvas: [
                  {
                    type: "line",
                    x1: 0,
                    y1: 20,
                    x2: 600,
                    y2: 20,
                    lineWidth: 1,
                    lineColor: "#E7EAEC"
                  }
                ]
              },
              {
                columns: [
                  {
                    width: "20%",
                    stack: [
                      {
                        text: $filter("translate")("ADD_ASSET.SURFACE_PARKING"),
                        style: "label"
                      },
                      {
                        text: $filter("number")(asset.surfaceParkingSpaces),
                        style: "h2"
                      }
                    ]
                  },
                  {
                    width: "20%",
                    stack: [
                      {
                        text: $filter("translate")("ADD_ASSET.TENANTS"),
                        style: "label"
                      },
                      {
                        text: asset.numberOfTenants,
                        style: "h2"
                      }
                    ]
                  },
                  {
                    width: "20%",
                    stack: [
                      {
                        text: $filter("translate")("ADD_ASSET.STORIES"),
                        style: "label"
                      },
                      {
                        text: asset.numberOfStories,
                        style: "h2"
                      }
                    ]
                  },
                  {
                    width: "20%",
                    stack: [
                      {
                        text: $filter("translate")("ADD_ASSET.UNITS"),
                        style: "label"
                      },
                      {
                        text: $filter("number")(asset.numberOfUnits),
                        style: "h2"
                      }
                    ]
                  },
                  {
                    width: "20%",
                    stack: [
                      {
                        text: $filter("translate")(
                          "ADD_ASSET.NUMBER_OF_BUILDINGS"
                        ),
                        style: "label"
                      },
                      {
                        text: $filter("number")(asset.numberOfBuildings),
                        style: "h2"
                      }
                    ]
                  }
                ]
              },
              {
                canvas: [
                  {
                    type: "line",
                    x1: 0,
                    y1: 20,
                    x2: 600,
                    y2: 20,
                    lineWidth: 1,
                    lineColor: "#E7EAEC"
                  }
                ]
              },
              {
                columns: [
                  {
                    width: "20%",
                    stack: [
                      {
                        text: $filter("translate")("ADD_ASSET.YEAR_BUILT"),
                        style: "label"
                      },
                      {
                        text: asset.yearBuilt || "",
                        style: "h2"
                      }
                    ]
                  },
                  {
                    width: "20%",
                    stack: [
                      {
                        text: $filter("translate")("ADD_ASSET.YEAR_RENOVATED"),
                        style: "label"
                      },
                      {
                        text: asset.yearRenovated || "",
                        style: "h2"
                      }
                    ]
                  },
                  {
                    width: "20%",
                    stack: [
                      {
                        text: $filter("translate")("ADD_ASSET.OWNERSHIP_TYPE"),
                        style: "label"
                      },
                      {
                        text: asset.ownership || "",
                        style: "h2"
                      }
                    ]
                  },
                  {
                    width: "20%",
                    stack: [
                      {
                        text: $filter("translate")(
                          "ADD_ASSET.LEED_CERTIFICATION"
                        ),
                        style: "label"
                      },
                      {
                        text: asset.leedCertification || "",
                        style: "h2"
                      }
                    ]
                  },
                  {
                    width: "20%",
                    stack: [
                      {
                        text: $filter("translate")("ADD_ASSET.MSA"),
                        style: "label"
                      },
                      {
                        text: asset.msa || "",
                        style: "h2"
                      }
                    ]
                  }
                ]
              },
              {
                canvas: [
                  {
                    type: "line",
                    x1: 0,
                    y1: 20,
                    x2: 600,
                    y2: 20,
                    lineWidth: 1,
                    lineColor: "#E7EAEC"
                  }
                ]
              },
              {
                columns: [
                  {
                    width: "40%",
                    stack: [
                      {
                        text: $filter("translate")("ADD_ASSET.NCREIF"),
                        style: "label"
                      },
                      {
                        text: asset.region || "",
                        style: "h2"
                      }
                    ]
                  },
                  {
                    width: "60%",
                    stack: [
                      {
                        text: $filter("translate")("ADD_ASSET.PORTFOLIO_NAME"),
                        style: "label"
                      },
                      {
                        text: asset.portfolioName || "N/A",
                        style: "h2"
                      }
                    ]
                  }
                ]
              },
              {
                text: $filter("translate")("ASSET_DETAILS.VALUATION_DETAILS"),
                style: "h1",
                margin: [0, 30, 0, 0]
              },
              {
                canvas: [
                  {
                    type: "line",
                    x1: 0,
                    y1: 10,
                    x2: 600,
                    y2: 10,
                    lineWidth: 1,
                    lineColor: "#E7EAEC"
                  }
                ]
              },
              {
                columns: [
                  {
                    width: "20%",
                    stack: [
                      {
                        text: $filter("translate")("ASSET_DETAILS.BID_GROUP"),
                        style: "label"
                      },
                      {
                        text: asset.bidGroup ? asset.bidGroup.name : "N/A",
                        style: "h2"
                      }
                    ]
                  },
                  {
                    width: "20%",
                    stack: [
                      {
                        text: $filter("translate")(
                          "ASSET_DETAILS.CURRENT_VALUATION"
                        ),
                        style: "label"
                      },
                      {
                        text: asset.vperiod || "",
                        style: "h2"
                      }
                    ]
                  },
                  {
                    width: "20%",
                    stack: [
                      {
                        text: $filter("translate")(
                          "ASSET_DETAILS.DRAFT_DUE_DATE"
                        ),
                        style: "label"
                      },
                      {
                        text: asset.review.getDraftDueDate()
                          ? $filter("date", "MMM dd")(
                              asset.review.getDraftDueDate()
                            )
                          : "N/A",
                        style: "h2"
                      }
                    ]
                  },
                  {
                    width: "40%",
                    stack: [
                      {
                        text: $filter("translate")(
                          "ASSET_DETAILS.CURRENT_STATUS"
                        ),
                        style: "label"
                      },
                      {
                        text: ReviewStatusHelper.getLatestAction(
                          null,
                          asset.review
                        ),
                        style: "h2"
                      }
                    ]
                  }
                ]
              },
              {
                margin: [0, 10, 0, 0],
                layout: "noBorders",
                table: {
                  widths: ["17%", "17%", "17%", "17%", "14%", "18%"],
                  body: [
                    [
                      {
                        margin: [13, 0, 0, 0],
                        fillColor: "#f9f9f9",
                        stack: [
                          {
                            text: $filter("translate")("ADD_ASSET.QUARTER1"),
                            style: "label",
                            margin: [0, 8.5, 0, 5]
                          },
                          {
                            text: $filter("date", "MMM dd")(asset.scheduleQ1),
                            style: "h2",
                            margin: [0, 0, 0, 13]
                          }
                        ]
                      },
                      {
                        margin: [0, 0, 0, 0],
                        fillColor: "#f7f7f7",
                        stack: [
                          {
                            text: $filter("translate")("ADD_ASSET.QUARTER2"),
                            style: "label",
                            margin: [0, 8.5, 0, 5]
                          },
                          {
                            text: asset.scheduleQ2
                              ? $filter("date", "MMM dd")(asset.scheduleQ2)
                              : "N/A",
                            style: "h2",
                            margin: [0, 0, 0, 13]
                          }
                        ]
                      },
                      {
                        margin: [0, 0, 0, 0],
                        fillColor: "#f7f7f7",
                        stack: [
                          {
                            text: $filter("translate")("ADD_ASSET.QUARTER3"),
                            style: "label",
                            margin: [0, 8.5, 0, 5]
                          },
                          {
                            text: asset.scheduleQ3
                              ? $filter("date", "MMM dd")(asset.scheduleQ3)
                              : "N/A",
                            style: "h2",
                            margin: [0, 0, 0, 13]
                          }
                        ]
                      },
                      {
                        margin: [0, 0, 0, 0],
                        fillColor: "#f7f7f7",
                        stack: [
                          {
                            text: $filter("translate")("ADD_ASSET.QUARTER4"),
                            style: "label",
                            margin: [0, 8.5, 0, 5]
                          },
                          {
                            text: asset.scheduleQ4
                              ? $filter("date", "MMM dd")(asset.scheduleQ4)
                              : "N/A",
                            style: "h2",
                            margin: [0, 0, 0, 13]
                          }
                        ]
                      },
                      {
                        margin: [0, 0, 0, 0],
                        fillColor: "#f7f7f7",
                        stack: [
                          {
                            text: $filter("translate")(
                              "ASSET_DETAILS.ROLLING_OVER_DATE"
                            ),
                            style: "label",
                            margin: [0, 8.5, 0, 5]
                          },
                          {
                            text: asset.rollOverDate
                              ? $filter("date", "MMM dd")(asset.rollOverDate)
                              : "N/A",
                            style: "h2",
                            margin: [0, 0, 0, 13]
                          }
                        ]
                      },
                      {
                        margin: [0, 0, 0, 0],
                        fillColor: "#f7f7f7",
                        stack: [
                          {
                            text: $filter("translate")(
                              "ASSET_DETAILS.VALUATION_FREQUENCY"
                            ),
                            style: "label",
                            margin: [0, 8.5, 0, 5]
                          },
                          {
                            text: asset.valuationFrequency || "",
                            style: "h2",
                            margin: [0, 0, 0, 13]
                          }
                        ]
                      }
                    ]
                  ]
                }
              },
              {
                text: $filter("translate")("ASSET_DETAILS.ASSIGNED_PERSONNEL"),
                style: "h1",
                margin: [0, 30, 0, 0]
              },
              {
                canvas: [
                  {
                    type: "line",
                    x1: 0,
                    y1: 10,
                    x2: 600,
                    y2: 10,
                    lineWidth: 1,
                    lineColor: "#E7EAEC"
                  }
                ]
              },
              {
                columns: [
                  {
                    width: "40%",
                    stack: [
                      {
                        text: $filter("translate")(
                          "ASSET_DETAILS.PRIMARY_ASSET_MANAGER"
                        ),
                        style: "label"
                      },
                      {
                        text:
                          asset.primaryAssetManager &&
                          asset.primaryAssetManager.user &&
                          asset.primaryAssetManager.user.name
                            ? asset.primaryAssetManager.user.name
                            : "N/A",
                        style: "h2"
                      }
                    ]
                  },
                  {
                    width: "20%",
                    stack: [
                      {
                        text: $filter("translate")("ASSET_DETAILS.PHONE"),
                        style: "label"
                      },
                      {
                        text:
                          asset.primaryAssetManager &&
                          asset.primaryAssetManager.userAccount &&
                          asset.primaryAssetManager.userAccount.officePhone
                            ? asset.primaryAssetManager.userAccount.officePhone
                            : "N/A",
                        style: "h2"
                      }
                    ]
                  },
                  {
                    width: "40%",
                    stack: [
                      {
                        text: $filter("translate")("ASSET_DETAILS.EMAIL"),
                        style: "label"
                      },
                      {
                        text:
                          asset.primaryAssetManager &&
                          asset.primaryAssetManager.userAccount &&
                          asset.primaryAssetManager.userAccount.email
                            ? asset.primaryAssetManager.userAccount.email
                            : "N/A",
                        style: "h2"
                      }
                    ]
                  }
                ]
              },
              {
                canvas: [
                  {
                    type: "line",
                    x1: 0,
                    y1: 10,
                    x2: 600,
                    y2: 10,
                    lineWidth: 1,
                    lineColor: "#E7EAEC"
                  }
                ]
              },
              {
                columns: [
                  {
                    width: "40%",
                    stack: [
                      {
                        text: $filter("translate")(
                          "ASSET_DETAILS.PRIMARY_REVIEWER"
                        ),
                        style: "label"
                      },
                      {
                        text:
                          asset.primaryAssetReviewer &&
                          asset.primaryAssetReviewer.user &&
                          asset.primaryAssetReviewer.user.name
                            ? asset.primaryAssetReviewer.user.name
                            : "N/A",
                        style: "h2"
                      }
                    ]
                  },
                  {
                    width: "20%",
                    stack: [
                      {
                        text: $filter("translate")("ASSET_DETAILS.PHONE"),
                        style: "label"
                      },
                      {
                        text:
                          asset.primaryAssetReviewer &&
                          asset.primaryAssetReviewer.userAccount &&
                          asset.primaryAssetReviewer.userAccount.officePhone
                            ? asset.primaryAssetReviewer.userAccount.officePhone
                            : "N/A",
                        style: "h2"
                      }
                    ]
                  },
                  {
                    width: "40%",
                    stack: [
                      {
                        text: $filter("translate")("ASSET_DETAILS.EMAIL"),
                        style: "label"
                      },
                      {
                        text:
                          asset.primaryAssetReviewer &&
                          asset.primaryAssetReviewer.userAccount &&
                          asset.primaryAssetReviewer.userAccount.email
                            ? asset.primaryAssetReviewer.userAccount.email
                            : "N/A",
                        style: "h2"
                      }
                    ]
                  }
                ]
              }
            ],
            styles: {
              h1: {
                margin: [0, 0, 0, 0],
                fontSize: 14.4,
                color: "#464646",
                lineHeight: 1.21, // 17px
                bold: true
              },
              h2: {
                fontSize: 10.8,
                color: "#464646",
                margin: [0, 5, 0, 0]
              },
              label: {
                margin: [0, 15, 0, 0],
                fontSize: 9.12,
                lineHeight: 1.11, // 10px
                color: "#afafaf"
              }
            }
          };

          if (asset.notes) {
            docDefinition.content.push(
              {
                text: $filter("translate")("ASSET_DETAILS.NOTES"),
                margin: [0, 82, 0, 0],
                style: "h1"
              },
              {
                layout: "noBorders",
                margin: [0, 10, 0, 0],
                table: {
                  widths: ["100%"],
                  height: 1000,
                  body: [
                    [
                      {
                        text: asset.notes || "",
                        lineHeight: 1.15,
                        margin: [15, 15, 15, 15],
                        fontSize: 12,
                        color: "#464646",
                        fillColor: "#f9f9f9"
                      }
                    ]
                  ]
                }
              }
            );
          }

          if (documents && documents.length) {
            docDefinition.content.push(
              {
                text: $filter("translate")("ASSET_DETAILS.DOCUMENTS"),
                margin: [0, 20, 0, 0],
                style: "h1"
              },
              {
                layout: {
                  fillColor: function(i, node) {
                    return i % 2 === 0 ? "#fff" : "#f9f9f9";
                  },
                  hLineWidth: function(i, node) {
                    if (i === 0 || i === node.table.body.length) {
                      return 1;
                    }
                    return i === node.table.headerRows ? 1 : 1;
                  },
                  hLineColor: function(i, node) {
                    return i === 0 || i === node.table.body.length
                      ? "#E7EAEC"
                      : "#E7EAEC";
                  },
                  vLineWidth: function(i, node) {
                    return i === 0 || i === node.table.widths.length ? 0 : 0;
                  },
                  vLineColor: function(i, node) {
                    return i === 0 || i === node.table.widths.length
                      ? "#FFFFFF"
                      : "#FFFFFF";
                  }
                },
                margin: [0, 12, 0, 0],
                table: {
                  widths: [12, "*"],
                  body: (documents || []).map(function(doc) {
                    return [
                      {
                        image: PDF_HEADERS._documentsIcon,
                        margin: [10, 8, 10, 8],
                        width: 12
                      },
                      {
                        text: doc.name || doc.fileName || "",
                        margin: [22, 10, 10, 10],
                        color: "#464646",
                        fontSize: 11
                      }
                    ];
                  })
                }
              }
            );
          }

          var pdf = pdfMake.createPdf(docDefinition);
          return resolve({
            pdf: pdf,
            asset: asset
          });
        });
      });
    }

    function generateAssetsListPdf(
      companyId,
      assetsCount,
      searchQuery,
      sortTag,
      sortOrder,
      propertyTypes
    ) {
      return $q(function(resolve, reject) {
        BidGroupService.list(companyId).then(function(bidGroups) {
          var bidGroupNamesById = {};

          bidGroups.forEach(function(bidGroup) {
            bidGroupNamesById[bidGroup.id] = bidGroup.name;
          });

          AssetService.getAssetsByCompanyPage(
            companyId,
            undefined,
            0,
            assetsCount,
            searchQuery,
            sortTag,
            sortOrder
          )
            .then(function(assets) {
              // Add bidGroupName to asset
              assets.assets.forEach(function(asset) {
                asset.bidGroupName = bidGroupNamesById[asset.bidGroupId];
                for (var i = 0; i < propertyTypes.length; i++) {
                  if (asset.type === propertyTypes[i].type) {
                    asset.type = propertyTypes[i].name;
                    break;
                  }
                }
              });

              /* PDF HEADER */
              var pdfHeader = [
                {
                  text: $filter("translate")("ASSETS.PDF_PROPERTY_NAME"),
                  bold: true,
                  alignment: "left",
                  margin: [10, 22, 0, 10],
                  fillColor: "#FFFFFF",
                  style: { color: "#AFAFAF", fontSize: 9 }
                },
                {
                  text: $filter("translate")("ASSETS.ID"),
                  bold: true,
                  alignment: "left",
                  margin: [0, 22, 0, 10],
                  fillColor: "#FFFFFF",
                  style: { color: "#AFAFAF", fontSize: 9 }
                },
                {
                  text: $filter("translate")("ASSETS.LOCATION"),
                  bold: true,
                  alignment: "left",
                  margin: [0, 22, 0, 10],
                  fillColor: "#FFFFFF",
                  style: { color: "#AFAFAF", fontSize: 9 }
                }
              ];

              // Security for asset manager column
              if (SecurityManager.canSeeUser("AssetManagement")) {
                pdfHeader.push({
                  text: $filter("translate")("ASSETS.PDF_ASSET_MANAGER"),
                  bold: true,
                  alignment: "left",
                  margin: [0, 22, 0, 10],
                  fillColor: "#FFFFFF",
                  style: { color: "#AFAFAF", fontSize: 9 }
                });
              }

              pdfHeader.push({
                text: $filter("translate")("ASSETS.V_PERIOD"),
                bold: true,
                alignment: "left",
                margin: [0, 22, 0, 10],
                fillColor: "#FFFFFF",
                style: { color: "#AFAFAF", fontSize: 9 }
              });

              if (!SecurityManager.isCurrentUserAssetManager()) {
                pdfHeader.push({
                  text: $filter("translate")("ASSETS.BIDDING_GROUP"),
                  bold: true,
                  alignment: "left",
                  margin: [0, 22, 0, 10],
                  fillColor: "#FFFFFF",
                  style: { color: "#AFAFAF", fontSize: 9 }
                });
              }

              pdfHeader = pdfHeader.concat([
                {
                  text: $filter("translate")("ASSETS.PROPERTY_TYPE"),
                  bold: true,
                  alignment: "left",
                  margin: [0, 22, 0, 10],
                  fillColor: "#FFFFFF",
                  style: { color: "#AFAFAF", fontSize: 9 }
                },
                {
                  text: $filter("translate")("COMMONS.STATUS"),
                  bold: true,
                  alignment: "left",
                  margin: [0, 22, 0, 10],
                  fillColor: "#FFFFFF",
                  style: { color: "#AFAFAF", fontSize: 9 }
                }
              ]);

              var pdfBody = assets.assets.map(function(asset) {
                return {
                  propertyName: asset.name || "",
                  id: asset.propertyRef || "",
                  location: [asset.address.city, asset.address.state].join(
                    ", "
                  ),
                  assetManager: asset.primaryManagerName || "",
                  vperiod: asset.vperiod,
                  biddingGroup: asset.bidGroupName || "N/A",
                  propertyType: asset.type || "",
                  active: asset.active
                    ? $filter("translate")("COMMONS.ACTIVE")
                    : $filter("translate")("COMMONS.INACTIVE")
                };
              });

              pdfBody = pdfBody.map(function(item) {
                var mainBody = [
                  {
                    text: item.propertyName,
                    bold: true,
                    margin: [10, 6, 0, 6],
                    alignment: "left",
                    style: { color: "#464646", fontSize: 9 }
                  },
                  {
                    text: item.id,
                    margin: [0, 6, 0, 6],
                    alignment: "left",
                    style: { color: "#464646", fontSize: 9 }
                  },
                  {
                    text: item.location,
                    margin: [0, 6, 0, 6],
                    style: { color: "#676767", fontSize: 9 }
                  }
                ];

                // Hide asset manager from appraisers
                if (SecurityManager.canSeeUser("AssetManagement")) {
                  mainBody.push({
                    text: item.assetManager,
                    margin: [0, 6, 0, 6],
                    style: { color: "#676767", fontSize: 9 }
                  });
                }

                mainBody.push({
                  text: item.vperiod || "",
                  margin: [0, 6, 0, 6],
                  style: { color: "#464646", fontSize: 9 }
                });

                // Hide biddingGroup from asset managers
                if (!SecurityManager.isCurrentUserAssetManager()) {
                  mainBody.push({
                    text: item.biddingGroup,
                    margin: [0, 6, 0, 6],
                    style: { color: "#676767", fontSize: 9 }
                  });
                }

                mainBody = mainBody.concat([
                  {
                    text: item.propertyType,
                    margin: [0, 6, 0, 6],
                    alignment: "left",
                    style: { color: "#464646", fontSize: 9 }
                  },
                  {
                    text: item.active,
                    margin: [0, 6, 0, 6],
                    alignment: "left",
                    style: { color: "#676767", fontSize: 9 }
                  }
                ]);

                return mainBody;
              });

              var docDefinition = {
                pageMargins: [25, 81, 25, 20],
                pageSize: "LETTER",
                header: {
                  image: PDF_HEADERS._assetsListHeader,
                  margin: [25, 10, 25, 0],
                  width: 560
                },
                footer: function(currentPage, pageCount) {
                  return {
                    text: currentPage.toString() + "/" + pageCount,
                    alignment: "center",
                    style: {
                      color: "#222222",
                      fontSize: 9.6
                    }
                  };
                },
                content: [
                  {
                    text: $filter("translate")("COMMONS.TOTAL_ITEMS"),
                    width: "100%",
                    alignment: "left",
                    margin: [12, 10, 25, 0],
                    style: { bold: true, fontSize: 9, color: "#AFAFAF" }
                  },
                  {
                    text: assetsCount,
                    margin: [13, 10, 0, 8],
                    style: { color: "#464646", fontSize: 10.8 }
                  },
                  {
                    text:
                      "_____________________________________________________________________________________________" +
                      "______________________",
                    margin: [0, 0, 0, 0],
                    style: { color: "#E7EAEC", fontSize: 10.8 }
                  },
                  {
                    table: {
                      headerRows: 1,
                      dontBreakRows: true,
                      widths:
                        pdfHeader.length === 6
                          ? ["25%", "15%", "15%", "15%", "20%", "10%"]
                          : pdfHeader.length === 7 &&
                            SecurityManager.isCurrentUserAssetManager()
                            ? ["20%", "15%", "15%", "20%", "10%", "10%", "10%"]
                            : pdfHeader.length === 7 &&
                              !SecurityManager.isCurrentUserAssetManager()
                              ? [
                                  "20%",
                                  "13%",
                                  "12%",
                                  "10%",
                                  "25%",
                                  "10%",
                                  "10%"
                                ]
                              : [
                                  "20%",
                                  "10%",
                                  "10%",
                                  "15%",
                                  "10%",
                                  "15%",
                                  "12%",
                                  "8%"
                                ],
                      style: {
                        alignment: "justify"
                      },
                      body: [pdfHeader].concat(pdfBody)
                    },
                    layout: {
                      fillColor: function(i, node) {
                        return i % 2 === 0 ? "#f7f7f7" : null;
                      },
                      hLineWidth: function(i, node) {
                        if (i === 0 || i === node.table.body.length) {
                          return 0;
                        }
                        return i === node.table.headerRows ? 1 : 1;
                      },
                      hLineColor: function(i, node) {
                        return i + 1 === 0 || i === node.table.body.length
                          ? "#E7EAEC"
                          : "#E7EAEC";
                      },
                      vLineWidth: function(i, node) {
                        return i + 1 === 0 || i === node.table.widths.length
                          ? 0
                          : 0;
                      },
                      vLineColor: function(i, node) {
                        return i + 1 === 0 || i === node.table.widths.length
                          ? "#FFFFFF"
                          : "#FFFFFF";
                      }
                    }
                  }
                ]
              };

              var pdf = pdfMake.createPdf(docDefinition);

              return resolve(pdf);
            })
            .catch(function(err) {
              return reject(err);
            });
        });
      });
    }

    function generateBidEngagementListPdf(
      assets,
      appraisers,
      companyId,
      bidsCount,
      searchQuery,
      sortTag,
      sortOrder
    ) {
      return $q(function(resolve, reject) {
        BidRequestService.listByCompanyIdPage(
          companyId,
          0,
          bidsCount,
          searchQuery,
          sortTag,
          sortOrder
        )
          .then(function(bidEngs) {
            var bids = bidEngs.bids;

            // var requestPromises = [];
            var promises = bids.map(function(bid) {
              return BidResponseService.listByBidRequestId(bid.id).then(
                function(bidResponseList) {
                  var assetsArray = [],
                    appraisersArray = [];
                  bid.bidResponses = bidResponseList;
                  bid.assets = {};
                  bid.appraisers = {};
                  bid.responses = 0;
                  bid.declines = 0;
                  bid.pending = 0;
                  bid.awarded = 0;
                  for (var i = 0; i < bid.bidResponses.length; i++) {
                    for (var j = 0; j < assets.length; j++) {
                      if (bid.bidResponses[i].assetId === assets[j].id) {
                        var asset = angular.copy(assets[j]);
                        bid.assets[asset.id] = asset;
                        break;
                      }
                    }
                    for (j = 0; j < appraisers.length; j++) {
                      if (
                        bid.bidResponses[i].userId === appraisers[j].user.id
                      ) {
                        var appraiser = angular.copy(appraisers[j]);
                        if (
                          bid.bidResponses[i].respondedOn &&
                          bid.bidResponses[i].isSubmittedToAdmin
                        ) {
                          appraiser.responseBid = true;
                        }
                        if (bid.bidResponses[i].isDeclined) {
                          appraiser.declineBid = true;
                        }
                        if (!bid.appraisers[appraiser.id]) {
                          bid.appraisers[appraiser.id] = appraiser;
                        }
                        if (!bid.appraisers[appraiser.id].responseBid) {
                          bid.appraisers[appraiser.id].responseBid =
                            appraiser.responseBid;
                        }
                        if (!bid.appraisers[appraiser.id].declineBid) {
                          bid.appraisers[appraiser.id].declineBid =
                            appraiser.declineBid;
                        }
                        break;
                      }
                    }
                  }
                  Object.keys(bid.assets).forEach(function(key) {
                    assetsArray.push(bid.assets[key]);
                  });
                  bid.assets = assetsArray;
                  bid.assets.forEach(function(asset) {
                    bid.bidResponses.forEach(function(response) {
                      if (response.isAwarded && response.assetId === asset.id) {
                        asset.awarded = true;
                      }
                    });
                    if (asset.awarded) {
                      bid.awarded++;
                    }
                  });

                  Object.keys(bid.appraisers).forEach(function(key) {
                    appraisersArray.push(bid.appraisers[key]);
                  });
                  bid.appraisers = appraisersArray;
                  bid.appraisers.forEach(function(appraiser) {
                    if (appraiser.responseBid) {
                      bid.responses++;
                    } else if (appraiser.declineBid) {
                      bid.declines++;
                    } else {
                      bid.pending++;
                    }
                  });

                  return bid;
                }
              );
            });

            $q.all(promises).then(function(data) {
              var pdfBody = data.map(function(bid) {
                return {
                  rfpName: bid.name,
                  assetsAwarded:
                    (bid.awarded || 0) +
                    "/" +
                    (bid.assets ? bid.assets.length : 0),
                  responses:
                    (bid.responses || 0) +
                    "/" +
                    (bid.appraisers ? bid.appraisers.length : 0),
                  bidDueDate: $filter("date")(UtcDateConverter.getDateFromUTC(bid.dueDate), "MMM dd, yyyy")
                };
              });

              var docDefinition = {
                pageMargins: [25, 81, 25, 20],
                pageSize: "LETTER",
                header: {
                  image: PDF_HEADERS._bidEngagementListHeader,
                  margin: [25, 10, 25, 0],
                  width: 560
                },
                footer: function(currentPage, pageCount) {
                  return {
                    text: currentPage.toString() + "/" + pageCount,
                    alignment: "center",
                    style: {
                      color: "#222222",
                      fontSize: 9.6
                    }
                  };
                },
                content: [
                  {
                    text: $filter("translate")("COMMONS.TOTAL_ITEMS"),
                    width: "100%",
                    alignment: "left",
                    margin: [12, 10, 25, 0],
                    style: { bold: true, fontSize: 9.12, color: "#AFAFAF" }
                  },
                  {
                    text: bidsCount,
                    margin: [13, 10, 0, 8],
                    style: { color: "#464646", fontSize: 10.8 }
                  },
                  {
                    text:
                      "_____________________________________________________________________________________________" +
                      "______________________",
                    margin: [0, 0, 0, 0],
                    style: { color: "#E7EAEC", fontSize: 10.8 }
                  },
                  {
                    table: {
                      headerRows: 1,
                      dontBreakRows: true,
                      style: {
                        alignment: "justify"
                      },
                      widths: ["40%", "20%", "20%", "20%"],
                      body: [
                        [
                          {
                            text: $filter("translate")(
                              "BID_ENGAGEMENT_LIST.RFP_NAME"
                            ),
                            width: "40%",
                            bold: true,
                            margin: [10, 18, 0, 10],
                            fillColor: "#FFFFFF",
                            style: { color: "#AFAFAF", fontSize: 9.12 }
                          },
                          {
                            text: $filter("translate")(
                              "BID_ENGAGEMENT_LIST.ASSETS_AWARDED"
                            ),
                            width: "20%",
                            bold: true,
                            margin: [0, 18, 0, 10],
                            fillColor: "#FFFFFF",
                            style: { color: "#AFAFAF", fontSize: 9.12 }
                          },
                          {
                            text: $filter("translate")(
                              "BID_ENGAGEMENT_LIST.RESPONSES"
                            ),
                            width: "20%",
                            bold: true,
                            margin: [0, 18, 0, 10],
                            fillColor: "#FFFFFF",
                            style: { color: "#AFAFAF", fontSize: 9.12 }
                          },
                          {
                            text: $filter("translate")(
                              "BID_ENGAGEMENT_LIST.BID_DUE_DATE"
                            ),
                            width: "20%",
                            bold: true,
                            margin: [0, 18, 0, 10],
                            fillColor: "#FFFFFF",
                            style: { color: "#AFAFAF", fontSize: 9.12 }
                          }
                        ]
                      ].concat(
                        pdfBody.map(function(item) {
                          return [
                            {
                              text: item.rfpName,
                              width: "40%",
                              margin: [10, 6, 0, 6],
                              style: { color: "#464646", fontSize: 10.8 }
                            },
                            {
                              text: item.assetsAwarded,
                              width: "20%",
                              margin: [0, 6, 0, 6],
                              style: { color: "#464646", fontSize: 10.8 }
                            },
                            {
                              text: item.responses,
                              width: "20%",
                              margin: [0, 6, 0, 6],
                              style: { color: "#464646", fontSize: 10.8 }
                            },
                            {
                              text: item.bidDueDate,
                              width: "20%",
                              margin: [0, 6, 0, 6],
                              style: { color: "#464646", fontSize: 10.8 }
                            }
                          ];
                        })
                      )
                    },
                    layout: {
                      fillColor: function(i, node) {
                        return i % 2 === 0 ? "#f7f7f7" : null;
                      },
                      hLineWidth: function(i, node) {
                        if (i === 0 || i === node.table.body.length) {
                          return 0;
                        }
                        return i === node.table.headerRows ? 1 : 1;
                      },
                      hLineColor: function(i, node) {
                        return i + 1 === 0 || i === node.table.body.length
                          ? "#E7EAEC"
                          : "#E7EAEC";
                      },
                      vLineWidth: function(i, node) {
                        return i + 1 === 0 || i === node.table.widths.length
                          ? 0
                          : 0;
                      },
                      vLineColor: function(i, node) {
                        return i + 1 === 0 || i === node.table.widths.length
                          ? "#FFFFFF"
                          : "#FFFFFF";
                      }
                    }
                  }
                ]
              };

              var pdf = pdfMake.createPdf(docDefinition);

              return resolve(pdf);
            });
          })
          .catch(function(err) {
            return reject(err);
          });
      });
    }

    function generateBidGroupsPdf(
      companyId,
      bidGroupsCount,
      searchQuery,
      sortTag,
      sortOrder
    ) {
      return $q(function(resolve, reject) {
        BidGroupService.listPage(
          companyId,
          0,
          bidGroupsCount,
          searchQuery,
          sortTag,
          sortOrder
        )
          .then(function(bidGroups) {
            var pdfBody = bidGroups.bidGroups.map(function(group) {
              return {
                name: group.name,
                assets: group.numberOfAssets
              };
            });

            var docDefinition = {
              pageMargins: [25, 81, 25, 20],
              pageSize: "LETTER",
              header: {
                image: PDF_HEADERS._bidGroupsListHeader,
                margin: [25, 10, 25, 0],
                width: 560
              },
              footer: function(currentPage, pageCount) {
                return {
                  text: currentPage.toString() + "/" + pageCount,
                  alignment: "center",
                  style: {
                    color: "#222222",
                    fontSize: 9.6
                  }
                };
              },
              content: [
                {
                  text: $filter("translate")("COMMONS.TOTAL_ITEMS"),
                  width: "100%",
                  alignment: "left",
                  margin: [12, 10, 25, 0],
                  style: { bold: true, fontSize: 9.12, color: "#AFAFAF" }
                },
                {
                  text: bidGroupsCount,
                  margin: [13, 10, 0, 8],
                  style: { color: "#464646", fontSize: 10.8 }
                },
                {
                  text:
                    "_____________________________________________________________________________________________" +
                    "______________________",
                  margin: [0, 0, 0, 0],
                  style: { color: "#E7EAEC", fontSize: 10.8 }
                },
                {
                  table: {
                    headerRows: 1,
                    dontBreakRows: true,
                    widths: ["60%", "40%"],
                    style: {
                      alignment: "justify"
                    },
                    body: [
                      [
                        {
                          text: $filter("translate")("BID_GROUPS.NAME"),
                          width: "60%",
                          bold: true,
                          margin: [10, 22, 0, 10],
                          fillColor: "#FFFFFF",
                          style: { color: "#AFAFAF", fontSize: 9.12 }
                        },
                        {
                          text: $filter("translate")("BID_GROUPS.ASSETS"),
                          width: "40%",
                          bold: true,
                          margin: [0, 22, 0, 10],
                          fillColor: "#FFFFFF",
                          style: { color: "#AFAFAF", fontSize: 9.12 }
                        }
                      ]
                    ].concat(
                      pdfBody.map(function(item) {
                        return [
                          {
                            text: item.name,
                            width: "40%",
                            margin: [10, 6, 0, 6],
                            style: { color: "#464646", fontSize: 10.8 }
                          },
                          {
                            text: item.assets,
                            width: "20%",
                            margin: [0, 6, 0, 6],
                            style: { color: "#464646", fontSize: 10.8 }
                          }
                        ];
                      })
                    )
                  },
                  layout: {
                    fillColor: function(i, node) {
                      return i % 2 === 0 ? "#f7f7f7" : null;
                    },
                    hLineWidth: function(i, node) {
                      if (i === 0 || i === node.table.body.length) {
                        return 0;
                      }
                      return i === node.table.headerRows ? 1 : 1;
                    },
                    hLineColor: function(i, node) {
                      return i + 1 === 0 || i === node.table.body.length
                        ? "#E7EAEC"
                        : "#E7EAEC";
                    },
                    vLineWidth: function(i, node) {
                      return i + 1 === 0 || i === node.table.widths.length
                        ? 0
                        : 0;
                    },
                    vLineColor: function(i, node) {
                      return i + 1 === 0 || i === node.table.widths.length
                        ? "#FFFFFF"
                        : "#FFFFFF";
                    }
                  }
                }
              ]
            };

            var pdf = pdfMake.createPdf(docDefinition);

            return resolve(pdf);
          })
          .catch(function(err) {
            return reject(err);
          });
      });
    }

    function generateBidSummaryPdf(bid) {
      return $q(function(resolve, reject) {
        var notes = [],
          responsesCount = 0,
          showNotes = false;

        var mainBody = [];

        bid.assets.forEach(function(asset) {
          var pdfBody = [],
            assetResponses = [];
          responsesCount = responsesCount + asset.bidResponses.length;
          pdfBody.push({
            isAsset: true,
            asset: asset.name,
            year1: "",
            discount1: "",
            year23: "",
            discount2: "",
            quarterly: "",
            discount3: "",
            totalFee: "",
            discount4: ""
          });

          for (var i = 0; i < asset.bidResponses.length; i++) {
            var bidResp = asset.bidResponses[i];
            // bidNotes: coming from Appraiser, bidNotesAdmin: coming from Admin
            if (bidResp.bidNotes || bidResp.bidNotesAdmin) {
              showNotes = true;
              assetResponses.push({
                name: asset.name,
                appraiser: {
                  note: bidResp.bidNotes,
                  user: bidResp.appraiser.user.name
                },
                admin: {
                  note: bidResp.bidNotesAdmin,
                  user: "Admin"
                }
              });
            }
            pdfBody.push({
              asset: bidResp.appraiser.user.name,
              year1: $filter("currency")(bidResp.yearOne),
              discount1: $filter("currency")(bidResp.yearOneDiscount),
              year23: $filter("currency")(bidResp.yearsTwoThree),
              discount2: $filter("currency")(bidResp.yearsTwoThreeDiscount),
              quarterly: $filter("currency")(bidResp.quarterly),
              discount3: $filter("currency")(bidResp.quarterlyDiscount),
              totalFee: $filter("currency")(bidResp.totalFee),
              discount4: $filter("currency")(bidResp.totalFeeDiscount),
              isSelectedFee: bidResp.isSelectedFee,
              isSelectedDiscount: bidResp.isSelectedDiscount
            });
          }
          notes.push({ assetName: asset.name, notes: assetResponses });
          mainBody.push(pdfBody);
        });

        var docDefinition = {
          pageMargins: [25, 81, 25, 20],
          pageSize: "LETTER",
          pageOrientation: "landscape",
          header: {
            image: PDF_HEADERS._bidSummaryHeader,
            margin: [25, 0, 25, 20],
            width: 740
          },
          footer: function(currentPage, pageCount) {
            return {
              text: currentPage.toString() + "/" + pageCount,
              alignment: "center",
              style: {
                color: "#222222",
                fontSize: 9.6
              }
            };
          },
          content: [
            {
              table: {
                headerRows: 1,
                dontBreakRows: true,
                widths: ["55%", "45%"],
                style: {
                  alignment: "left"
                },
                body: [
                  [
                    {
                      text: bid.name,
                      margin: [0, 0, 0, 0],
                      style: { bold: true, fontSize: 9.12, color: "#AFAFAF" }
                    },
                    {
                      text: $filter("translate")("COMMONS.TOTAL_ITEMS"),
                      margin: [0, 0, 0, 0],
                      style: { bold: true, fontSize: 9.12, color: "#AFAFAF" }
                    }
                  ],
                  [
                    {
                      text:
                        $filter("translate")("BID_SUMMARY.ASSETS_AWARDED") +
                        " (" +
                        bid.awarded +
                        "/" +
                        bid.assets.length +
                        ")" +
                        "                              " +
                        $filter("translate")(
                          "BID_SUMMARY.APPRAISERS_RESPONSES"
                        ) +
                        " (" +
                        bid.responses +
                        "/" +
                        bid.appraisers.length +
                        ")",
                      margin: [0, 0, 0, 0],
                      style: { fontSize: 10.8, color: "#464646" }
                    },
                    {
                      text: responsesCount,
                      style: { fontSize: 10.8, color: "#464646" }
                    }
                  ]
                ]
              },
              layout: "noBorders"
            },
            {
              text:
                "_____________________________________________________________________________________________" +
                "___________________________________________________________",
              margin: [0, 8, 0, 0],
              width: "100%",
              style: { color: "#E7EAEC", fontSize: 10.8 }
            },
            mainBody.map(function(pdfBody) {
              return {
                width: "100%",
                table: {
                  headerRows: 1,
                  dontBreakRows: true,
                  widths: [
                    "20%",
                    "10%",
                    "10%",
                    "10%",
                    "10%",
                    "10%",
                    "10%",
                    "10%",
                    "10%"
                  ],
                  style: {
                    alignment: "left"
                  },
                  body: [
                    [
                      {
                        text: $filter("translate")("BID_SUMMARY.ASSET"),
                        width: "20%",
                        margin: [10, 20, 0, 10],
                        bold: true,
                        fillColor: "#FFFFFF",
                        alignment: "left",
                        style: { color: "#AFAFAF", fontSize: 9.12 }
                      },
                      {
                        text: $filter("translate")("BID_SUMMARY.YEAR_1"),
                        width: "10%",
                        margin: [0, 20, 0, 10],
                        bold: true,
                        fillColor: "#FFFFFF",
                        alignment: "left",
                        style: { color: "#AFAFAF", fontSize: 9.12 }
                      },
                      {
                        text: $filter("translate")("BID_SUMMARY.DISCOUNT"),
                        width: "10%",
                        margin: [0, 20, 0, 10],
                        bold: true,
                        fillColor: "#FFFFFF",
                        alignment: "left",
                        style: { color: "#AFAFAF", fontSize: 9.12 }
                      },
                      {
                        text: $filter("ampToAnd")(
                          $filter("translate")("BID_SUMMARY.YEAR_2&3")
                        ),
                        width: "10%",
                        margin: [0, 20, 0, 10],
                        bold: true,
                        fillColor: "#FFFFFF",
                        alignment: "left",
                        style: { color: "#AFAFAF", fontSize: 9.12 }
                      },
                      {
                        text: $filter("translate")("BID_SUMMARY.DISCOUNT"),
                        width: "10%",
                        margin: [0, 20, 0, 10],
                        bold: true,
                        fillColor: "#FFFFFF",
                        alignment: "left",
                        style: { color: "#AFAFAF", fontSize: 9.12 }
                      },
                      {
                        text: $filter("translate")("BID_SUMMARY.UPDATE"),
                        width: "10%",
                        margin: [0, 20, 0, 10],
                        bold: true,
                        fillColor: "#FFFFFF",
                        alignment: "left",
                        style: { color: "#AFAFAF", fontSize: 9.12 }
                      },
                      {
                        text: $filter("translate")("BID_SUMMARY.DISCOUNT"),
                        width: "10%",
                        margin: [0, 20, 0, 10],
                        bold: true,
                        fillColor: "#FFFFFF",
                        alignment: "left",
                        style: { color: "#AFAFAF", fontSize: 9.12 }
                      },
                      {
                        text: $filter("translate")("BID_SUMMARY.TOTAL_FEE"),
                        width: "10%",
                        margin: [0, 20, 0, 10],
                        bold: true,
                        fillColor: "#FFFFFF",
                        alignment: "left",
                        style: { color: "#AFAFAF", fontSize: 9.12 }
                      },
                      {
                        text: $filter("translate")("BID_SUMMARY.DISCOUNT"),
                        width: "10%",
                        margin: [0, 20, 0, 10],
                        bold: true,
                        fillColor: "#FFFFFF",
                        alignment: "left",
                        style: { color: "#AFAFAF", fontSize: 9.12 }
                      }
                    ]
                  ].concat(
                    pdfBody.map(function(item) {
                      return [
                        {
                          text: item.asset,
                          width: "20%",
                          alignment: "left",
                          margin: [10, 10, 0, 10],
                          style: item.isAsset
                            ? { bold: true, color: "#464646", fontSize: 8.16 }
                            : {
                                fontSize: 8.16,
                                bold: false,
                                color: "#464646"
                              }
                        },
                        {
                          text: item.year1 || "",
                          alignment: "left",
                          margin: [0, 10, 0, 10],
                          width: "10%",
                          style: {
                            fontSize: 8.16,
                            color: "#464646",
                            bold: true
                          }
                        },
                        {
                          text: item.discount1 || "",
                          alignment: "left",
                          margin: [0, 10, 0, 10],
                          width: "10%",
                          style: { fontSize: 8.16, color: "#464646" }
                        },
                        {
                          text: item.year23 || "",
                          alignment: "left",
                          margin: [0, 10, 0, 10],
                          width: "10%",
                          style: {
                            fontSize: 8.16,
                            color: "#464646",
                            bold: true
                          }
                        },
                        {
                          text: item.discount2 || "",
                          alignment: "left",
                          margin: [0, 10, 0, 10],
                          width: "10%",
                          style: { fontSize: 8.16, color: "#464646" }
                        },
                        {
                          text: item.quarterly || "",
                          alignment: "left",
                          margin: [0, 10, 0, 10],
                          width: "10%",
                          style: { fontSize: 8.16, color: "#464646" }
                        },
                        {
                          text: item.discount3 || "",
                          alignment: "left",
                          margin: [0, 10, 0, 10],
                          width: "10%",
                          style: { fontSize: 8.16, color: "#464646" }
                        },
                        {
                          text: item.totalFee || "",
                          alignment: "left",
                          margin: [0, 10, 0, 10],
                          width: "10%",
                          style: {
                            fontSize: 8.16,
                            bold: true,
                            color:
                              !item.isAsset && item.isSelectedFee
                                ? "#339fb7"
                                : "#464646"
                          }
                        },
                        {
                          text: item.discount4 || "",
                          alignment: "left",
                          margin: [0, 10, 0, 10],
                          width: "10%",
                          style: {
                            fontSize: 8.16,
                            color:
                              !item.isAsset && item.isSelectedDiscount
                                ? "#339fb7"
                                : "#464646"
                          }
                        }
                      ];
                    })
                  )
                },
                layout: {
                  fillColor: function(i, node) {
                    return i % 2 === 0 ? "#f7f7f7" : "#ffffff";
                  },
                  hLineWidth: function(i, node) {
                    if (i === 0 || i === node.table.body.length) {
                      return 0;
                    }
                    return i === node.table.headerRows ? 1 : 1;
                  },
                  hLineColor: function(i, node) {
                    return i === 0 || i === node.table.body.length
                      ? "#E7EAEC"
                      : "#E7EAEC";
                  },
                  vLineWidth: function(i, node) {
                    return i === 0 || i === node.table.widths.length ? 0 : 0;
                  },
                  vLineColor: function(i, node) {
                    return i === 0 || i === node.table.widths.length
                      ? "#FFFFFF"
                      : "#FFFFFF";
                  }
                }
              };
            })
          ]
            .concat([
              {
                text: "",
                pageBreak: showNotes ? "after" : ""
              },
              {
                text: showNotes
                  ? $filter("translate")("BID_SUMMARY.PDF_BID_NOTES")
                  : "",
                width: "100%",
                alignment: "left",
                bold: true,
                margin: [0, 20, 0, 20],
                style: { fontSize: 14.4, color: "#464646" }
              }
            ])
            .concat(
              notes.map(function(asset) {
                if (asset.notes.length > 0) {
                  return [
                    {
                      text: asset.assetName,
                      width: "100%",
                      bold: true,
                      margin: [10, 10, 0, 5],
                      style: {
                        color: "#464646",
                        fontSize: 9.6
                      }
                    },
                    {
                      table: {
                        dontBreakRows: true,
                        widths: ["50%", "50%"],
                        margin: [10, 0, 0, 10],
                        body:
                          asset.notes.length > 0
                            ? asset.notes.map(function(asset) {
                                if (asset.admin.note) {
                                  if (asset.appraiser.note) {
                                    return [
                                      {
                                        text: "Admin" + "\n" + asset.admin.note,
                                        width: "100%",
                                        margin: [10, 10, 20, 5],
                                        lineHeight: 1.15,
                                        style: {
                                          color: "#464646",
                                          fontSize: 9.6
                                        }
                                      },
                                      {
                                        text:
                                          asset.appraiser.user +
                                          "\n" +
                                          asset.appraiser.note,
                                        width: "100%",
                                        lineHeight: 1.15,
                                        margin: [10, 10, 20, 5],
                                        style: {
                                          color: "#464646",
                                          fontSize: 9.6
                                        }
                                      }
                                    ];
                                  }
                                  return [
                                    {
                                      text: "Admin" + "\n" + asset.admin.note,
                                      margin: [10, 10, 20, 5],
                                      width: "100%",
                                      style: {
                                        color: "#464646",
                                        fontSize: 9.6
                                      }
                                    },
                                    { text: "" }
                                  ];
                                } else if (asset.appraiser.note) {
                                  return [
                                    {
                                      text:
                                        asset.appraiser.user +
                                        "\n" +
                                        asset.appraiser.note,
                                      width: "100%",
                                      margin: [10, 10, 20, 5],
                                      style: {
                                        color: "#464646",
                                        fontSize: 9.6
                                      }
                                    },
                                    { text: "" }
                                  ];
                                } else {
                                  return {};
                                }
                              })
                            : []
                      },
                      layout: {
                        fillColor: function(i, node) {
                          return i % 2 === 0 ? "#f7f7f7" : "#FFFFFF";
                        },
                        hLineWidth: function(i, node) {
                          return i === 0 || i === node.table.widths.length
                            ? 0
                            : 0;
                        },
                        hLineColor: function(i, node) {
                          return i === 0 || i === node.table.body.length
                            ? "#E7EAEC"
                            : "#E7EAEC";
                        },
                        vLineWidth: function(i, node) {
                          return i === 0 || i === node.table.widths.length
                            ? 0
                            : 0;
                        },
                        vLineColor: function(i, node) {
                          return i === 0 || i === node.table.widths.length
                            ? "#FFFFFF"
                            : "#FFFFFF";
                        }
                      }
                    },
                    { text: "\n" + "\n" + "\n" }
                  ];
                } else {
                  return {};
                }
              })
            )
        };

        var pdf = pdfMake.createPdf(docDefinition);

        return resolve({
          pdf: pdf,
          bid: bid
        });
      });
    }

    function generateExecutiveSummary(review, companyName) {
      var latestAction = "Not Started";
      if (review instanceof ReviewModel && review.status) {
        latestAction = ReviewStatusHelper.getCurrentAction(review);
        if (
          review.status === "ValuationSignedOff" ||
          (review.status === "FinalDocumentsUploaded" && !review.appraisalFinal)
        ) {
          review.appraisalFinal = review.appraisalDraft;
        }
      }
      
      var docDefinition = {
        pageMargins: [25, 81, 25, 20],
        pageSize: "LETTER",
        header: {
          image: PDF_HEADERS._executiveSummaryHeader,
          margin: [25, 10, 25, 0],
          width: 560
        },
        footer: function(currentPage, pageCount) {
          return {
            text: currentPage.toString() + "/" + pageCount,
            alignment: "center",
            style: { background: "#E6E6E6" }
          };
        },
        content: [
          // header
          {
            alignment: "justify",
            columns: [
              [
                {
                  text: companyName,
                  style: { background: "#E6E6E6" },
                  color: "#777777",
                  margin: [0, 0, 0, 5]
                },
                {
                  text: review.asset.name,
                  fontSize: 24,
                  color: "#676a6d",
                  bold: true,
                  margin: [0, 0, 0, 5]
                },
                {
                  text: review.asset.address.address,
                  fontSize: 11,
                  color: "#8f9599"
                },
                {
                  text: review.asset.type + " / " + review.asset.subType,
                  fontSize: 11,
                  color: "#8f9599"
                }
              ],
              [
                {
                  text: $filter("formatDate")(review.nms, "MMM DD, YYYY"),
                  alignment: "right",
                  fontSize: 9,
                  color: "#6b6b6b",
                  margin: [0, 20, 0, 5]
                },
                {
                  text: latestAction,
                  color: "#777777",
                  style: { background: "#E6E6E6" },
                  alignment: "right"
                }
              ]
            ]
          },
          {
            canvas: [
              {
                type: "line",
                x1: 0,
                y1: 3,
                x2: 560 - 2 * 40 + 80,
                y2: 3,
                lineWidth: 1,
                lineColor: "#cdcdcd"
              }
            ],
            margin: [0, 12, 0, 0]
          },
          //first row
          {
            margin: [0, 40, 0, 0],
            text: [
              {
                alignment: "justify",
                text: "Value Conclusion",
                decoration: "underline",
                color: "#696262",
                fontSize: 14,
                bold: true
              },
              {
                text: "\t"
              },
              {
                alignment: "justify",
                text: $filter("formatDate")(review.createdOn, "MMM DD-YYYY"),
                color: "#676a6c",
                fontSize: 10
              }
            ]
          },
          {
            margin: [0, 20, 0, 0],
            alignment: "justify",
            columns: [
              [
                {
                  text: "Previous Value",
                  fontSize: 10,
                  color: "#676a6c"
                },
                {
                  text:
                    $filter("currency")(
                      review.appraisalPrevious,
                      undefined,
                      0
                    ) || " ",
                  fontSize: 13,
                  bold: true,
                  color: "#545759"
                }
              ],
              [
                {
                  text: "Draft Value",
                  fontSize: 10,
                  color: "#676a6c"
                },
                {
                  text:
                    $filter("currency")(review.appraisalDraft, undefined, 0) ||
                    " ",
                  fontSize: 13,
                  bold: true,
                  color: "#545759"
                }
              ],
              [
                {
                  text: "Revised/Final Value",
                  fontSize: 10,
                  color: "#676a6c"
                },
                {
                  text:
                    $filter("currency")(review.appraisalFinal, undefined, 0) ||
                    " ",
                  fontSize: 13,
                  bold: true,
                  color: "#545759"
                }
              ]
            ]
          },
          {
            margin: [0, 20, 0, 0],
            alignment: "justify",
            columns: [
              [
                {
                  text: "Land & Other Adj.",
                  fontSize: 10,
                  color: "#676a6c"
                },
                {
                  text:
                    $filter("currency")(review.landAndOtherAdj, undefined, 0) ||
                    " ",
                  fontSize: 13,
                  bold: true,
                  color: "#545759"
                }
              ],
              [
                {
                  text: "Discounted Cash Flow Analysis",
                  fontSize: 10,
                  color: "#676a6c"
                },
                {
                  text:
                    $filter("currency")(
                      review.discountedCashFlowAnalysis,
                      undefined,
                      0
                    ) || " ",
                  fontSize: 13,
                  bold: true,
                  color: "#545759"
                }
              ],
              [
                {
                  text: "Direct Capitalization Analysis",
                  fontSize: 10,
                  color: "#676a6c"
                },
                {
                  text:
                    $filter("currency")(
                      review.directCapitalizationAnalysis,
                      undefined,
                      0
                    ) || " ",
                  fontSize: 13,
                  bold: true,
                  color: "#545759"
                }
              ]
            ]
          },
          {
            margin: [0, 20, 0, 0],
            alignment: "justify",
            columns: [
              [
                {
                  text: "Stabilized Value",
                  fontSize: 10,
                  color: "#676a6c"
                },
                {
                  text:
                    $filter("currency")(review.stabilizedValue, undefined, 0) ||
                    " ",
                  fontSize: 13,
                  bold: true,
                  color: "#545759"
                }
              ],
              [
                {
                  text: "Stabilized Value $/SF",
                  fontSize: 10,
                  color: "#676a6c"
                },
                {
                  text:
                    $filter("currency")(
                      review.stabilizedValueSf,
                      undefined,
                      2
                    ) || " ",
                  fontSize: 13,
                  bold: true,
                  color: "#545759"
                }
              ],
              [
                {
                  text: "Sales Comparison Approach",
                  fontSize: 10,
                  color: "#676a6c"
                },
                {
                  text:
                    $filter("currency")(
                      review.salesComparisonApproach,
                      undefined,
                      0
                    ) || " ",
                  fontSize: 13,
                  bold: true,
                  color: "#545759"
                }
              ]
            ]
          },
          {
            margin: [0, 20, 0, 0],
            alignment: "justify",
            columns: [
              [
                {
                  text: "Absorption Period",
                  fontSize: 10,
                  color: "#676a6c"
                },
                {
                  text: review.absorptionPeriod || " ",
                  fontSize: 13,
                  bold: true,
                  color: "#545759"
                }
              ],
              [
                {
                  text: "Cost Approach",
                  fontSize: 10,
                  color: "#676a6c"
                },
                {
                  text:
                    $filter("currency")(review.costApproach, undefined, 0) ||
                    " ",
                  fontSize: 13,
                  bold: true,
                  color: "#545759"
                }
              ],
              [
                {
                  text: "Insurable Value",
                  fontSize: 10,
                  color: "#676a6c"
                },
                {
                  text:
                    $filter("currency")(review.insurableValue, undefined, 0) ||
                    "N/A",
                  fontSize: 13,
                  bold: true,
                  color: "#545759"
                }
              ]
            ]
          },
          {
            margin: [0, 30, 0, 0],
            alignment: "justify",
            columns: [
              [
                {
                  text: "Prior Period Value to Current Value",
                  decoration: "underline",
                  color: "#696262",
                  fontSize: 14,
                  bold: true
                },
                {
                  margin: [0, 20, 0, 0],
                  columns: [
                    [
                      {
                        margin: [0, 10, 0, 0],
                        alignment: "justify",
                        text: "Percentage Change",
                        fontSize: 10,
                        color: "#676a6c"
                      },
                      {
                        text:
                          typeof review.appraisalPeriodDelta != "undefined" &&
                          review.appraisalPeriodDelta != "N/A"
                            ? $filter("percentage")(
                                $filter("number")(
                                  review.appraisalPeriodDelta,
                                  2
                                ),
                                undefined,
                                2
                              )
                            : "N/A",
                        fontSize: 13,
                        bold: true,
                        color: "#545759"
                      }
                    ],
                    [
                      {
                        margin: [0, 10, 0, 0],
                        alignment: "justify",
                        text: "Actual Dollar Change",
                        fontSize: 10,
                        color: "#676a6c"
                      },
                      {
                        text:
                          $filter("currency")(
                            review.appraisalPeriodDeltaValue,
                            undefined,
                            0
                          ) || "N/A",
                        fontSize: 13,
                        bold: true,
                        color: "#545759"
                      }
                    ]
                  ]
                }
              ],
              [
                {
                  text: "Prior Year Value to Current Value",
                  decoration: "underline",
                  color: "#696262",
                  fontSize: 14,
                  bold: true
                },
                {
                  margin: [0, 20, 0, 0],
                  columns: [
                    [
                      {
                        margin: [0, 10, 0, 0],
                        alignment: "justify",
                        text: "Percentage Change",
                        fontSize: 10,
                        color: "#676a6c"
                      },
                      {
                        text:
                          typeof review.appraisalYearlyDelta != "undefined" &&
                          review.appraisalYearlyDelta != "N/A"
                            ? $filter("percentage")(
                                $filter("number")(
                                  review.appraisalYearlyDelta,
                                  2
                                ),
                                undefined,
                                2
                              )
                            : "N/A",
                        fontSize: 13,
                        bold: true,
                        color: "#545759"
                      }
                    ],
                    [
                      {
                        margin: [0, 10, 0, 0],
                        alignment: "justify",
                        text: "Actual Dollar Change",
                        fontSize: 10,
                        color: "#676a6c"
                      },
                      {
                        text:
                          $filter("currency")(
                            review.appraisalYearlyDeltaValue,
                            undefined,
                            0
                          ) || "N/A",
                        fontSize: 13,
                        bold: true,
                        color: "#545759"
                      }
                    ]
                  ]
                }
              ]
            ]
          },
          {
            canvas: [
              {
                type: "line",
                x1: 0,
                y1: 3,
                x2: 560 - 2 * 40 + 80,
                y2: 3,
                lineWidth: 1,
                lineColor: "#cdcdcd"
              }
            ],
            margin: [0, 40, 0, 0]
          },
          {
            margin: [-40, 30, -40, 0],
            alignment: "justify",
            table: {
              widths: [35, "*", "*", "*", "*", "*", 35],
              headerRows: 1,
              body: [
                [
                  "",
                  "",
                  { text: "Stabilized Cap Rate", style: "tableHeader" },
                  { text: "Terminal Rate", style: "tableHeader" },
                  { text: "Discount Rate", style: "tableHeader" },
                  { text: "Implied Cap Rate", style: "tableHeader" },
                  ""
                ],
                [
                  { text: "", fillColor: "#ebebeb" },
                  {
                    text: "Current Rate",
                    style: "tableHeader",
                    fillColor: "#ebebeb"
                  },
                  {
                    text:
                      typeof review.stabilizedCapRate != "undefined"
                        ? $filter("percentage")(
                            $filter("number")(review.stabilizedCapRate, 2),
                            undefined,
                            2
                          )
                        : " ",
                    style: "tableContent",
                    fillColor: "#ebebeb"
                  },
                  {
                    text:
                      typeof review.terminalRate != "undefined"
                        ? $filter("percentage")(
                            $filter("number")(review.terminalRate, 2),
                            undefined,
                            2
                          )
                        : " ",
                    style: "tableContent",
                    fillColor: "#ebebeb"
                  },
                  {
                    text:
                      typeof review.discountRate != "undefined"
                        ? $filter("percentage")(
                            $filter("number")(review.discountRate, 2),
                            undefined,
                            2
                          )
                        : " ",
                    style: "tableContent",
                    fillColor: "#ebebeb"
                  },
                  {
                    text:
                      typeof review.impliedCapRate != "undefined"
                        ? $filter("percentage")(
                            $filter("number")(review.impliedCapRate, 2),
                            undefined,
                            2
                          )
                        : " ",
                    style: "tableContent",
                    fillColor: "#ebebeb"
                  },
                  { text: "", fillColor: "#ebebeb" }
                ],
                [
                  "",
                  { text: "P/P Δ", style: "tableHeader" },
                  {
                    text:
                      (typeof review.stabilizedCapRatePeriodDelta != "undefined"
                        ? review.stabilizedCapRatePeriodDelta
                        : "N/A") + "",
                    style: "tableContent"
                  },
                  {
                    text:
                      (typeof review.terminalRatePeriodDelta != "undefined"
                        ? review.terminalRatePeriodDelta
                        : "N/A") + "",
                    style: "tableContent"
                  },
                  {
                    text:
                      (typeof review.discountRatePeriodDelta != "undefined"
                        ? review.discountRatePeriodDelta
                        : "N/A") + "",
                    style: "tableContent"
                  },
                  {
                    text:
                      (typeof review.impliedCapRatePeriodDelta != "undefined"
                        ? review.impliedCapRatePeriodDelta
                        : "N/A") + "",
                    style: "tableContent"
                  },
                  ""
                ],
                [
                  { text: "", fillColor: "#ebebeb" },
                  {
                    text: "Y/Y Δ",
                    style: "tableHeader",
                    fillColor: "#ebebeb"
                  },
                  {
                    text:
                      (typeof review.stabilizedCapRateYearlyDelta != "undefined"
                        ? review.stabilizedCapRateYearlyDelta
                        : "N/A") + "",
                    style: "tableContent",
                    fillColor: "#ebebeb"
                  },
                  {
                    text:
                      (typeof review.terminalRateYearlyDelta != "undefined"
                        ? review.terminalRateYearlyDelta
                        : "N/A") + "",
                    style: "tableContent",
                    fillColor: "#ebebeb"
                  },
                  {
                    text:
                      (typeof review.discountRateYearlyDelta != "undefined"
                        ? review.discountRateYearlyDelta
                        : "N/A") + "",
                    style: "tableContent",
                    fillColor: "#ebebeb"
                  },
                  {
                    text:
                      (typeof review.impliedCapRateYearlyDelta != "undefined"
                        ? review.impliedCapRateYearlyDelta
                        : "N/A") + "",
                    style: "tableContent",
                    fillColor: "#ebebeb"
                  },
                  { text: "", fillColor: "#ebebeb" }
                ]
              ]
            },
            layout: {
              hLineWidth: function() {
                return 0;
              },
              vLineWidth: function() {
                return 0;
              },
              paddingTop: function() {
                return 7;
              },
              paddingBottom: function() {
                return 7;
              }
            }
          },
          {
            pageBreak: "after",
            margin: [0, 30, 0, 0],
            alignment: "justify",
            columns: [
              [
                {
                  text: "Average Contract Rent",
                  fontSize: 10,
                  color: "#676a6c"
                },
                {
                  text:
                    $filter("currency")(review.avgContractRent, undefined, 2) ||
                    " ",
                  fontSize: 13,
                  bold: true,
                  color: "#545759"
                }
              ],
              [
                {
                  text: "Average Market Rent",
                  fontSize: 10,
                  color: "#676a6c"
                },
                {
                  text:
                    $filter("currency")(review.avgMarketRent, undefined, 2) ||
                    " ",
                  fontSize: 13,
                  bold: true,
                  color: "#545759"
                }
              ],
              [
                {
                  text: "Average Rent Growth",
                  fontSize: 10,
                  color: "#676a6c"
                },
                {
                  text:
                    $filter("percentage")(
                      $filter("number")(review.avgRentGrowth, 2),
                      undefined,
                      2
                    ) || " ",
                  fontSize: 13,
                  bold: true,
                  color: "#545759"
                }
              ]
            ]
          },
          {
            margin: [0, 30, 0, 0],
            text: "Factors for Value Change from Prior Period",
            decoration: "underline",
            color: "#696262",
            fontSize: 14,
            bold: true
          },
          {
            margin: [0, 20, 0, 0],
            alignment: "left",
            widths: [144, 107, 150, 150],
            columns: [
              [
                {
                  text: "Discount Rate",
                  fontSize: 8,
                  color: "#676a6c"
                },
                {
                  margin: [0, 3, 0, 0],
                  text:
                    $filter("currency")(
                      review.deltaDiscountRate,
                      undefined,
                      0
                    ) || " ",
                  fontSize: 13,
                  bold: true,
                  color: "#545759"
                },
                {
                  margin: [0, 10, 0, 0],
                  text: "Real Estate Taxes",
                  fontSize: 8,
                  color: "#676a6c"
                },
                {
                  margin: [0, 3, 0, 0],
                  text:
                    $filter("currency")(
                      review.deltaRealEstateTaxes,
                      undefined,
                      0
                    ) || " ",
                  fontSize: 13,
                  bold: true,
                  color: "#545759"
                },
                {
                  margin: [0, 10, 0, 0],
                  text: "Vacancy & Collection Loss",
                  fontSize: 8,
                  color: "#676a6c"
                },
                {
                  margin: [0, 3, 0, 0],
                  text:
                    $filter("currency")(
                      review.deltaVacancyAndCollectionLoss,
                      undefined,
                      0
                    ) || " ",
                  fontSize: 13,
                  bold: true,
                  color: "#545759"
                }
              ],
              [
                {
                  text: "Terminal Cap Rate",
                  fontSize: 8,
                  color: "#676a6c"
                },
                {
                  margin: [0, 3, 0, 0],
                  text:
                    $filter("currency")(
                      review.deltaTerminalCapRate,
                      undefined,
                      0
                    ) || " ",
                  fontSize: 13,
                  bold: true,
                  color: "#545759"
                },
                {
                  margin: [0, 10, 0, 0],
                  text: "Leasing Capital",
                  fontSize: 8,
                  color: "#676a6c"
                },
                {
                  margin: [0, 3, 0, 0],
                  text:
                    $filter("currency")(
                      review.deltaLeasingCapital,
                      undefined,
                      0
                    ) || " ",
                  fontSize: 13,
                  bold: true,
                  color: "#545759"
                },
                {
                  margin: [0, 10, 0, 0],
                  text: "Expenses",
                  fontSize: 8,
                  color: "#676a6c"
                },
                {
                  margin: [0, 3, 0, 0],
                  text:
                    $filter("currency")(review.deltaExpenses, undefined, 0) ||
                    " ",
                  fontSize: 13,
                  bold: true,
                  color: "#545759"
                }
              ],
              [
                {
                  text: "Average Market Rent Growth",
                  fontSize: 8,
                  color: "#676a6c"
                },
                {
                  margin: [0, 3, 0, 0],
                  text:
                    $filter("currency")(
                      review.deltaAvgMarketRentGrowth,
                      undefined,
                      0
                    ) || " ",
                  fontSize: 13,
                  bold: true,
                  color: "#545759"
                },
                {
                  margin: [0, 10, 0, 0],
                  text: "Market Rents",
                  fontSize: 8,
                  color: "#676a6c"
                },
                {
                  margin: [0, 3, 0, 0],
                  text:
                    $filter("currency")(
                      review.deltaMarketRents,
                      undefined,
                      0
                    ) || " ",
                  fontSize: 13,
                  bold: true,
                  color: "#545759"
                },
                {
                  margin: [0, 10, 0, 0],
                  text: "Building Capital",
                  fontSize: 8,
                  color: "#676a6c"
                },
                {
                  margin: [0, 3, 0, 0],
                  text:
                    $filter("currency")(
                      review.deltaBuildingCapital,
                      undefined,
                      0
                    ) || " ",
                  fontSize: 13,
                  bold: true,
                  color: "#545759"
                }
              ],
              [
                {
                  text: "Downtime & Renewal Probability",
                  fontSize: 8,
                  color: "#676a6c"
                },
                {
                  margin: [0, 3, 0, 0],
                  text:
                    $filter("currency")(
                      review.deltaDowntimeAndRenewalProbability,
                      undefined,
                      0
                    ) || " ",
                  fontSize: 13,
                  bold: true,
                  color: "#545759"
                },
                {
                  margin: [0, 10, 0, 0],
                  text: "Contract Rents",
                  fontSize: 8,
                  color: "#676a6c"
                },
                {
                  margin: [0, 3, 0, 0],
                  text:
                    $filter("currency")(
                      review.deltaContractRents,
                      undefined,
                      0
                    ) || " ",
                  fontSize: 13,
                  bold: true,
                  color: "#545759"
                },
                {
                  margin: [0, 10, 0, 0],
                  text: "Other",
                  fontSize: 8,
                  color: "#676a6c"
                },
                {
                  margin: [0, 3, 0, 0],
                  text:
                    $filter("currency")(review.deltaOther, undefined, 0) || " ",
                  fontSize: 13,
                  bold: true,
                  color: "#545759"
                }
              ]
            ]
          },
          {
            margin: [0, 15, 0, 0],
            layout: {
              hLineWidth: function() {
                return 0;
              },
              vLineWidth: function() {
                return 0;
              }
            },
            table: {
              body: [
                [
                  {
                    text: "Total Change",
                    fontSize: 8,
                    color: "#676a6c",
                    fillColor: "#ededed"
                  }
                ],
                [
                  {
                    text: $filter("currency")(
                      review.totalChange || 0,
                      undefined,
                      0
                    ),
                    fontSize: 13,
                    bold: true,
                    color: "#545759",
                    fillColor: "#ededed"
                  }
                ]
              ]
            }
          },
          {
            canvas: [
              {
                type: "line",
                x1: 0,
                y1: 3,
                x2: 560 - 2 * 40 + 80,
                y2: 3,
                lineWidth: 1,
                lineColor: "#cdcdcd"
              }
            ],
            margin: [0, 40, 0, 0]
          },
          {
            margin: [0, 40, 0, 0],
            alignment: "justify",
            text: "P/P Value Change Explanation",
            decoration: "underline",
            color: "#696262",
            fontSize: 14,
            bold: true
          },
          {
            margin: [0, 10, 0, 0],
            text: review.ppValueChangeExplanation || " ",
            color: "#545759",
            fontSize: 11
          },
          {
            margin: [0, 30, 0, 0],
            text: "Y/Y Value Change Explanation",
            decoration: "underline",
            color: "#696262",
            fontSize: 14,
            bold: true
          },
          {
            margin: [0, 10, 0, 0],
            text: review.yyValueChangeExplanation || " ",
            color: "#545759",
            fontSize: 11
          }
        ],
        styles: {
          tableHeader: {
            color: "#676a6c",
            fontSize: 10
          },
          tableContent: {
            color: "#545759",
            fontSize: 13,
            bold: true
          }
        }
      };

      return pdfMake.createPdf(docDefinition);
    }

    function generateRequestStatusPdf(
      bidList,
      userId,
      requestsCount,
      searchQuery,
      sortTag,
      sortOrder
    ) {
      return $q(function(resolve, reject) {
        BidRequestService.listByUserIdPage(
          userId,
          0,
          requestsCount,
          searchQuery,
          sortTag,
          sortOrder
        )
          .then(function(responses) {
            var pdfBody = [];

            var promises = responses.bids.map(function(requestForProposal) {
              return AssetService.listByBidRequestId(
                requestForProposal.id
              ).then(function(assetsList) {
                var responded,
                  awarded = false,
                  declined = false;
                requestForProposal.assets = assetsList;
                requestForProposal.responses = [];
                requestForProposal.statusCounters = {
                  assetsAwarded: 0,
                  assetsResponded: 0,
                  assetsNotAwarded: 0
                };
                bidList.bidResponses.forEach(function(bidResponse) {
                  if (bidResponse.bidRequestId === requestForProposal.id) {
                    bidResponse.status = "";
                    if (
                      !declined &&
                      bidResponse.isAwarded &&
                      (bidResponse.yearOne || bidResponse.yearOne === 0)
                    ) {
                      awarded = true;
                      responded = true;
                      bidResponse.status = "Awarded";
                      requestForProposal.status = "Awarded";
                      requestForProposal.statusCounters.assetsAwarded++;
                    } else if (
                      !declined &&
                      bidResponse.respondedOn &&
                      (bidResponse.yearOne || bidResponse.yearOne === 0) &&
                      !awarded &&
                      !bidResponse.isDeclined &&
                      bidResponse.isSubmittedToAdmin &&
                      !bidResponse.isNotAwarded
                    ) {
                      responded = true;
                      bidResponse.status = "Responded";
                      requestForProposal.status = "Responded";
                      requestForProposal.statusCounters.assetsResponded++;
                    } else if (
                      !declined &&
                      !bidResponse.isSubmittedToAdmin &&
                      !bidResponse.isDeclined &&
                      !responded &&
                      !bidResponse.isAwarded &&
                      !bidResponse.isNotAwarded
                    ) {
                      bidResponse.status = "NeedsResponse";
                      requestForProposal.status = "NeedsResponse";
                    } else if (bidResponse.isDeclined) {
                      responded = true;
                      declined = true;
                      bidResponse.status = "Declined";
                      requestForProposal.status = "Declined";
                    } else if (
                      !bidResponse.isDeclined &&
                      !bidResponse.isAwarded &&
                      bidResponse.isNotAwarded
                    ) {
                      bidResponse.status = "NotAwarded";
                      requestForProposal.statusCounters.assetsNotAwarded++;
                    }
                    requestForProposal.responses.push(bidResponse);
                  }
                  for (var k = 0; k < requestForProposal.assets.length; k++) {
                    if (
                      bidResponse.assetId === requestForProposal.assets[k].id
                    ) {
                      requestForProposal.assets[k].status = bidResponse.status;
                      requestForProposal.assets[k].bidResponseId =
                        bidResponse.id;
                    }
                  }
                });
                if (
                  requestForProposal.assets.length ===
                  requestForProposal.statusCounters.assetsNotAwarded
                ) {
                  requestForProposal.status = "NotAwarded";
                  for (var i = 0; i < requestForProposal.assets.length; i++) {
                    requestForProposal.assets[i].status = "NotAwarded";
                  }
                }

                return requestForProposal;
              });
            });
            $q.all(promises).then(function(data) {
              pdfBody = data.map(function(bid) {
                return {
                  rfpName: bid.name,
                  assets: bid.assets.length,
                  bidDueDate: $filter("date")(UtcDateConverter.getDateFromUTC(bid.dueDate), "MMM dd, yyyy"),
                  status: $filter("bidRequestStatus")(bid)
                };
              });

              var docDefinition = {
                pageMargins: [25, 81, 25, 20],
                pageSize: "LETTER",
                header: {
                  image: PDF_HEADERS._requestStatusHeader,
                  margin: [25, 10, 25, 0],
                  width: 560
                },
                footer: function(currentPage, pageCount) {
                  return {
                    text: currentPage.toString() + "/" + pageCount,
                    alignment: "center",
                    bold: false,
                    style: {
                      color: "#222222",
                      fontSize: 9.6
                    }
                  };
                },
                content: [
                  {
                    text: $filter("translate")("COMMONS.TOTAL_ITEMS"),
                    width: "100%",
                    alignment: "left",
                    margin: [12, 10, 25, 0],
                    style: { bold: true, fontSize: 9.12, color: "#AFAFAF" }
                  },
                  {
                    text: requestsCount,
                    margin: [13, 10, 0, 8],
                    style: { color: "#464646", fontSize: 10.8 }
                  },
                  {
                    text:
                      "_____________________________________________________________________________________________" +
                      "______________________",
                    margin: [0, 0, 0, 0],
                    style: { color: "#E7EAEC", fontSize: 10.8 }
                  },
                  {
                    table: {
                      headerRows: 1,
                      dontBreakRows: true,
                      widths: ["40%", "15%", "22%", "23%"],
                      style: {
                        alignment: "justify"
                      },
                      body: [
                        [
                          {
                            text: $filter("translate")("ALL_REQUESTS.RFP_NAME"),
                            width: "40%",
                            margin: [10, 22, 0, 10],
                            fillColor: "#FFFFFF",
                            bold: true,
                            style: { color: "#AFAFAF", fontSize: 9.12 }
                          },
                          {
                            text: $filter("translate")("ALL_REQUESTS.ASSETS"),
                            width: "15%",
                            margin: [0, 22, 0, 10],
                            fillColor: "#FFFFFF",
                            bold: true,
                            style: { color: "#AFAFAF", fontSize: 9.12 }
                          },
                          {
                            text: $filter("translate")(
                              "ALL_REQUESTS.BID_DUE_DATE"
                            ),
                            width: "22%",
                            margin: [0, 22, 0, 10],
                            fillColor: "#FFFFFF",
                            bold: true,
                            style: { color: "#AFAFAF", fontSize: 9.12 }
                          },
                          {
                            text: $filter("translate")("ALL_REQUESTS.STATUS"),
                            width: "23%",
                            margin: [0, 22, 0, 10],
                            fillColor: "#FFFFFF",
                            bold: true,
                            style: { color: "#AFAFAF", fontSize: 9.12 }
                          }
                        ]
                      ].concat(
                        pdfBody.map(function(item) {
                          return [
                            {
                              text: item.rfpName,
                              width: "40%",
                              margin: [10, 6, 0, 6],
                              style: { color: "#464646", fontSize: 10.8 }
                            },
                            {
                              text: item.assets,
                              width: "15%",
                              margin: [0, 6, 0, 6],
                              style: { color: "#464646", fontSize: 10.8 }
                            },
                            {
                              text: item.bidDueDate,
                              width: "22%",
                              margin: [0, 6, 0, 6],
                              style: { color: "#464646", fontSize: 10.8 }
                            },
                            {
                              text: item.status,
                              width: "23%",
                              margin: [0, 6, 0, 6],
                              style: { color: "#464646", fontSize: 10.8 }
                            }
                          ];
                        })
                      )
                    },
                    layout: {
                      fillColor: function(i, node) {
                        return i % 2 === 0 ? "#f7f7f7" : null;
                      },
                      hLineWidth: function(i, node) {
                        if (i === 0 || i === node.table.body.length) {
                          return 0;
                        }
                        return i === node.table.headerRows ? 1 : 1;
                      },
                      hLineColor: function(i, node) {
                        return i + 1 === 0 || i === node.table.body.length
                          ? "#E7EAEC"
                          : "#E7EAEC";
                      },
                      vLineWidth: function(i, node) {
                        return i + 1 === 0 || i === node.table.widths.length
                          ? 0
                          : 0;
                      },
                      vLineColor: function(i, node) {
                        return i + 1 === 0 || i === node.table.widths.length
                          ? "#FFFFFF"
                          : "#FFFFFF";
                      }
                    }
                  }
                ]
              };

              var pdf = pdfMake.createPdf(docDefinition);

              return resolve(pdf);
            });
          })
          .catch(function(err) {
            return reject(err);
          });
      });
    }

    function generateResponseSummaryPdf(rfp, rfpAssets, totals, summarySort) {
      return $q(function(resolve) {
        var pdfBody = $filter("orderBy")(rfpAssets, summarySort.sort);
        var notes = [],
          showNotes = false;
        pdfBody = pdfBody.map(function(asset) {
          if (asset.response.bidNotes) {
            showNotes = true;
            notes.push({
              id: asset.name,
              text: asset.response.bidNotes
            });
          }
          return {
            asset: asset.name,
            year1: $filter("currency")(asset.response.yearOne),
            discount1: $filter("currency")(asset.response.yearOneDiscount),
            year23: $filter("currency")(asset.response.yearsTwoThree),
            discount2: $filter("currency")(
              asset.response.yearsTwoThreeDiscount
            ),
            quarterly: $filter("currency")(asset.response.quarterly),
            discount3: $filter("currency")(asset.response.quarterlyDiscount),
            totalFee: $filter("currency")(asset.response.totalFee),
            discount4: $filter("currency")(asset.response.totalFeeDiscount)
          };
        });

        // Add totals to the end of csvBody
        pdfBody.push({
          isTotal: true,
          asset: "Total",
          year1: $filter("currency")(totals[0]),
          discount1: $filter("currency")(totals[1]),
          year23: $filter("currency")(totals[2]),
          discount2: $filter("currency")(totals[3]),
          quarterly: $filter("currency")(totals[4]),
          discount3: $filter("currency")(totals[5]),
          totalFee: $filter("currency")(totals[6]),
          discount4: $filter("currency")(totals[7])
        });

        var docDefinition = {
          pageMargins: [25, 80, 25, 20],
          pageSize: "LETTER",
          pageOrientation: "landscape",
          header: {
            image: PDF_HEADERS._responseSummaryLandscapeHeader,
            margin: [25, 0, 25, 0],
            width: 740
          },
          footer: function(currentPage, pageCount) {
            return {
              text: currentPage.toString() + "/" + pageCount,
              alignment: "center",
              style: {
                color: "#222222",
                fontSize: 9.6
              }
            };
          },
          content: [
            {
              table: {
                headerRows: 1,
                dontBreakRows: true,
                widths: ["50%", "60%"],
                style: {
                  alignment: "left"
                },
                body: [
                  [
                    {
                      text: "Name",
                      margin: [12, 0, 0, 0],
                      style: { bold: true, fontSize: 9.12, color: "#AFAFAF" }
                    },
                    {
                      text: $filter("translate")("COMMONS.TOTAL_ITEMS"),
                      margin: [0, 0, 0, 0],
                      style: { bold: true, fontSize: 9.12, color: "#AFAFAF" }
                    }
                  ],
                  [
                    {
                      text: rfp.name,
                      margin: [12, 0, 0, 0],
                      style: { fontSize: 10.8, color: "#464646" }
                    },
                    {
                      text: rfpAssets.length,
                      style: { fontSize: 10.8, color: "#464646" }
                    }
                  ]
                ]
              },
              layout: "noBorders"
            },
            {
              text:
                "_____________________________________________________________________________________________" +
                "___________________________________________________________",
              margin: [0, 8, 0, 0],
              width: "100%",
              style: { color: "#E7EAEC", fontSize: 10.8 }
            },
            {
              table: {
                headerRows: 1,
                dontBreakRows: true,
                widths: [
                  "20%",
                  "10%",
                  "10%",
                  "10%",
                  "10%",
                  "10%",
                  "10%",
                  "10%",
                  "10%"
                ],
                style: {
                  alignment: "left"
                },
                body: [
                  [
                    {
                      text: $filter("translate")("RESPONSE_SUMMARY.ASSET"),
                      width: "17%",
                      margin: [10, 10, 0, 10],
                      bold: true,
                      fillColor: "#FFFFFF",
                      alignment: "left",
                      style: { color: "#AFAFAF", fontSize: 9.12 }
                    },
                    {
                      text: $filter("translate")("RESPONSE_SUMMARY.YEAR_1"),
                      width: "10%",
                      margin: [0, 10, 0, 10],
                      bold: true,
                      fillColor: "#FFFFFF",
                      alignment: "left",
                      style: { color: "#AFAFAF", fontSize: 9.12 }
                    },
                    {
                      text: $filter("translate")("RESPONSE_SUMMARY.DISCOUNT"),
                      width: "10%",
                      margin: [0, 10, 0, 10],
                      bold: true,
                      fillColor: "#FFFFFF",
                      alignment: "left",
                      style: { color: "#AFAFAF", fontSize: 9.12 }
                    },
                    {
                      text: $filter("ampToAnd")(
                        $filter("translate")("RESPONSE_SUMMARY.YEAR_2_3")
                      ),
                      width: "10%",
                      margin: [0, 10, 0, 10],
                      bold: true,
                      fillColor: "#FFFFFF",
                      alignment: "left",
                      style: { color: "#AFAFAF", fontSize: 9.12 }
                    },
                    {
                      text: $filter("translate")("RESPONSE_SUMMARY.DISCOUNT"),
                      width: "10%",
                      margin: [0, 10, 0, 10],
                      bold: true,
                      fillColor: "#FFFFFF",
                      alignment: "left",
                      style: { color: "#AFAFAF", fontSize: 9.12 }
                    },
                    {
                      text: $filter("translate")("RESPONSE_SUMMARY.UPDATE"),
                      width: "10%",
                      margin: [0, 10, 0, 10],
                      bold: true,
                      fillColor: "#FFFFFF",
                      alignment: "left",
                      style: { color: "#AFAFAF", fontSize: 9.12 }
                    },
                    {
                      text: $filter("translate")("RESPONSE_SUMMARY.DISCOUNT"),
                      width: "10%",
                      margin: [0, 10, 0, 10],
                      bold: true,
                      fillColor: "#FFFFFF",
                      alignment: "left",
                      style: { color: "#AFAFAF", fontSize: 9.12 }
                    },
                    {
                      text: $filter("translate")("RESPONSE_SUMMARY.TOTAL_FEE"),
                      width: "10%",
                      margin: [0, 10, 0, 10],
                      bold: true,
                      fillColor: "#FFFFFF",
                      alignment: "left",
                      style: { color: "#AFAFAF", fontSize: 9.12 }
                    },
                    {
                      text: $filter("translate")("RESPONSE_SUMMARY.DISCOUNT"),
                      width: "10%",
                      margin: [0, 10, 0, 10],
                      bold: true,
                      fillColor: "#FFFFFF",
                      alignment: "left",
                      style: { color: "#AFAFAF", fontSize: 9.12 }
                    }
                  ]
                ].concat(
                  pdfBody.map(function(item) {
                    return [
                      {
                        text: item.asset,
                        width: "20%",
                        margin: [10, 10, 0, 10],
                        alignment: "left",
                        style: {
                          fontSize: 8.16,
                          color: "#464646",
                          bold: item.isTotal
                        }
                      },
                      {
                        text: item.year1 || "",
                        margin: [0, 10, 0, 10],
                        width: "10%",
                        alignment: "left",
                        style: { fontSize: 8.16, color: "#464646", bold: true }
                      },
                      {
                        text: item.discount1 || "",
                        margin: [0, 10, 0, 10],
                        width: "10%",
                        alignment: "left",
                        style: {
                          fontSize: 8.16,
                          color: "#464646",
                          bold: item.isTotal
                        }
                      },
                      {
                        text: item.year23 || "",
                        margin: [0, 10, 0, 10],
                        width: "10%",
                        alignment: "left",
                        style: { fontSize: 8.16, color: "#464646", bold: true }
                      },
                      {
                        text: item.discount2 || "",
                        margin: [0, 10, 0, 10],
                        width: "10%",
                        alignment: "left",
                        style: {
                          fontSize: 8.16,
                          color: "#464646",
                          bold: item.isTotal
                        }
                      },
                      {
                        text: item.quarterly || "",
                        margin: [0, 10, 0, 10],
                        width: "10%",
                        alignment: "left",
                        style: {
                          fontSize: 8.16,
                          color: "#464646",
                          bold: item.isTotal
                        }
                      },
                      {
                        text: item.discount3 || "",
                        margin: [0, 10, 0, 10],
                        width: "10%",
                        alignment: "left",
                        style: {
                          fontSize: 8.16,
                          color: "#464646",
                          bold: item.isTotal
                        }
                      },
                      {
                        text: item.totalFee || "",
                        margin: [0, 10, 0, 10],
                        width: "10%",
                        alignment: "left",
                        style: { fontSize: 8.16, color: "#464646", bold: true }
                      },
                      {
                        text: item.discount4 || "",
                        margin: [0, 10, 0, 10],
                        width: "10%",
                        alignment: "left",
                        style: {
                          fontSize: 8.16,
                          color: "#464646",
                          bold: item.isTotal
                        }
                      }
                    ];
                  })
                )
              },
              layout: {
                fillColor: function(i, node) {
                  return i % 2 === 0 ? "#f7f7f7" : "#ffffff";
                },
                hLineWidth: function(i, node) {
                  if (i === 0 || i === node.table.body.length) {
                    return 0;
                  }
                  return i === node.table.headerRows ? 1 : 1;
                },
                hLineColor: function(i, node) {
                  return i === 0 || i === node.table.body.length
                    ? "#E7EAEC"
                    : "#E7EAEC";
                },
                vLineWidth: function(i, node) {
                  return i === 0 || i === node.table.widths.length ? 0 : 0;
                },
                vLineColor: function(i, node) {
                  return i === 0 || i === node.table.widths.length
                    ? "#FFFFFF"
                    : "#FFFFFF";
                }
              }
            }
          ]
            .concat([
              {
                text: "",
                pageBreak: showNotes ? "after" : ""
              },
              {
                text: showNotes
                  ? $filter("translate")("BID_SUMMARY.PDF_BID_NOTES")
                  : "",
                width: "100%",
                alignment: "left",
                bold: true,
                margin: [0, 20, 0, 20],
                style: { fontSize: 14.4, color: "#464646" }
              }
            ])
            .concat(
              notes.map(function(note, index) {
                return {
                  table: {
                    dontBreakRows: true,
                    widths: ["100%"],
                    style: {
                      alignment: "left"
                    },
                    body: [
                      [
                        {
                          text: note.id + "\n" + "\n" + note.text,
                          width: "100%",
                          lineHeight: 1.15,
                          margin: [10, 10, 0, 10],
                          fillColor: index % 2 === 0 ? "#FFFFFF" : "#f7f7f7",
                          style: {
                            fontSize: 9.6,
                            color: "#464646"
                          }
                        }
                      ]
                    ]
                  },
                  layout: {
                    hLineWidth: function(i, node) {
                      return i === 0 || i === node.table.body.length ? 0 : 1;
                    },
                    hLineColor: function(i, node) {
                      return i === 0 || i === node.table.body.length
                        ? "#E7EAEC"
                        : "#E7EAEC";
                    },
                    vLineWidth: function(i, node) {
                      return i === 0 || i === node.table.widths.length ? 0 : 0;
                    },
                    vLineColor: function(i, node) {
                      return i === 0 || i === node.table.widths.length
                        ? "#FFFFFF"
                        : "#FFFFFF";
                    }
                  }
                };
              })
            )
        };

        var pdf = pdfMake.createPdf(docDefinition);
        return resolve({
          pdf: pdf,
          rfp: rfp
        });
      });
    }

    function generateReviewForm(
      review,
      companyName,
      appraiserCompanyName,
      reviewerCompanyName
    ) {
      var latestAction = "Not Started";
      if (review instanceof ReviewModel && review.status) {
        latestAction = ReviewStatusHelper.getCurrentAction(review);
        if (
          review.status === "ValuationSignedOff" ||
          (review.status === "FinalDocumentsUploaded" && !review.appraisalFinal)
        ) {
          review.appraisalFinal = review.appraisalDraft;
        }
      }

      var docDefinition = {
        pageMargins: [25, 81, 25, 20],
        pageSize: "LETTER",
        header: {
          image: PDF_HEADERS._reviewFormHeader,
          margin: [25, 10, 25, 0],
          width: 560
        },

        footer: function(currentPage, pageCount) {
          return {
            text: currentPage.toString() + "/" + pageCount,
            alignment: "center",
            style: { background: "#E6E6E6" }
          };
        },

        content: [
          {
            alignment: "justify",
            columns: [
              [
                {
                  text: companyName,
                  style: { background: "#E6E6E6" },
                  color: "#777777",
                  margin: [0, 0, 0, 5]
                },
                {
                  text: review.asset.name,
                  fontSize: 24,
                  color: "#676a6d",
                  bold: true,
                  margin: [0, 0, 0, 5]
                },
                {
                  text: review.asset.address.address,
                  fontSize: 11,
                  color: "#8f9599"
                },
                {
                  text: review.asset.type + " / " + review.asset.subType,
                  fontSize: 11,
                  color: "#8f9599"
                }
              ],
              [
                {
                  text: $filter("formatDate")(review.nms, "MMM DD, YYYY"),
                  alignment: "right",
                  fontSize: 9,
                  color: "#6b6b6b",
                  margin: [0, 20, 0, 5]
                },
                {
                  text: latestAction,
                  color: "#777777",
                  style: { background: "#E6E6E6" },
                  alignment: "right"
                }
              ]
            ]
          },
          {
            canvas: [
              {
                type: "line",
                x1: 0,
                y1: 3,
                x2: 560 - 2 * 40 + 80,
                y2: 3,
                lineWidth: 1,
                lineColor: "#cdcdcd"
              }
            ],
            margin: [0, 12, 0, 0]
          },
          //first row
          {
            margin: [0, 30, 0, 0],
            alignment: "justify",
            columns: [
              {
                width: 210,
                text: [
                  {
                    text: "From:",
                    fontSize: 10,
                    color: "#676a6c"
                  },
                  "\n",
                  {
                    text: SecurityManager.canSeeUser("AssetAppraisal")
                      ? typeof review.asset.primaryAssetAppraiser != "undefined"
                        ? review.asset.primaryAssetAppraiser.user.name.substring(
                            0,
                            20
                          ) +
                          (review.asset.primaryAssetAppraiser.user.name.length >
                          20
                            ? "..."
                            : "")
                        : " "
                      : "",
                    fontSize: 13,
                    bold: true,
                    color: "#545759"
                  },
                  "\n",
                  {
                    text: SecurityManager.canSeeUser("AssetAppraisal")
                      ? appraiserCompanyName.substring(0, 25) +
                          (appraiserCompanyName.length > 25 ? "..." : "") || ""
                      : "",
                    fontSize: 10,
                    color: "#a0a6aa"
                  },
                  "\n",
                  {
                    margin: [0, 10, 0, 0],
                    text: "To:",
                    fontSize: 10,
                    color: "#676a6c"
                  },
                  "\n",
                  {
                    text:
                      typeof review.asset.primaryAssetReviewer != "undefined"
                        ? review.asset.primaryAssetReviewer.user.name.substring(
                            0,
                            20
                          ) +
                          (review.asset.primaryAssetReviewer.user.name.length >
                          20
                            ? "..."
                            : "")
                        : " ",
                    fontSize: 13,
                    bold: true,
                    color: "#545759"
                  },
                  "\n",
                  {
                    text:
                      reviewerCompanyName.substring(0, 25) +
                        (reviewerCompanyName.length > 25 ? "..." : "") || "",
                    fontSize: 10,
                    color: "#a0a6aa"
                  }
                ]
              },
              {
                canvas: [
                  {
                    type: "line",
                    x1: 0,
                    y1: 8,
                    x2: 0,
                    y2: 88,
                    lineWidth: 1,
                    lineColor: "#a7a7a7"
                  }
                ],
                width: 1,
                margin: [-40, 0, 0, 0]
              },
              [
                {
                  margin: [0, 8, 0, 0],
                  text: "Previous Value",
                  fontSize: 10,
                  color: "#676a6c"
                },
                {
                  text:
                    $filter("currency")(
                      review.appraisalPrevious,
                      undefined,
                      0
                    ) || " ",
                  fontSize: 13,
                  bold: true,
                  color: "#545759"
                },
                {
                  margin: [0, 18, 0, 0],
                  text: "Draft Value",
                  fontSize: 10,
                  color: "#676a6c"
                },
                {
                  text:
                    $filter("currency")(review.appraisalDraft, undefined, 0) ||
                    " ",
                  fontSize: 13,
                  bold: true,
                  color: "#545759"
                }
              ],
              {
                canvas: [
                  {
                    type: "line",
                    x1: 0,
                    y1: 8,
                    x2: 0,
                    y2: 88,
                    lineWidth: 1,
                    lineColor: "#a7a7a7"
                  }
                ],
                width: 1,
                margin: [-40, 0, 0, 0]
              },
              [
                {
                  margin: [0, 8, 0, 0],
                  text: "Revised/Final Value",
                  fontSize: 10,
                  color: "#676a6c"
                },
                {
                  text:
                    $filter("currency")(review.appraisalFinal, undefined, 0) ||
                    " ",
                  fontSize: 13,
                  bold: true,
                  color: "#545759"
                },
                {
                  margin: [0, 18, 0, 0],
                  text: "Date Submitted Review",
                  fontSize: 10,
                  color: "#676a6c"
                },
                {
                  text: $filter("formatDate")(review.nms, "MMM DD"),
                  fontSize: 13,
                  bold: true,
                  color: "#545759"
                }
              ]
            ]
          },
          {
            margin: [0, 30, 0, 0],
            alignment: "justify",
            columns: [
              [
                {
                  text: "Land & Other Adj.",
                  fontSize: 10,
                  color: "#676a6c"
                },
                {
                  text:
                    $filter("currency")(review.landAndOtherAdj, undefined, 0) ||
                    " ",
                  fontSize: 13,
                  bold: true,
                  color: "#545759"
                }
              ],
              [
                {
                  text: "Discounted Cash Flow Analysis",
                  fontSize: 10,
                  color: "#676a6c"
                },
                {
                  text:
                    $filter("currency")(
                      review.discountedCashFlowAnalysis,
                      undefined,
                      0
                    ) || " ",
                  fontSize: 13,
                  bold: true,
                  color: "#545759"
                }
              ],
              [
                {
                  text: "Direct Capitalization Analysis",
                  fontSize: 10,
                  color: "#676a6c"
                },
                {
                  text:
                    $filter("currency")(
                      review.directCapitalizationAnalysis,
                      undefined,
                      0
                    ) || " ",
                  fontSize: 13,
                  bold: true,
                  color: "#545759"
                }
              ]
            ]
          },
          {
            margin: [0, 20, 0, 0],
            alignment: "justify",
            columns: [
              [
                {
                  text: "Stabilized Value",
                  fontSize: 10,
                  color: "#676a6c"
                },
                {
                  text:
                    $filter("currency")(review.stabilizedValue, undefined, 0) ||
                    " ",
                  fontSize: 13,
                  bold: true,
                  color: "#545759"
                }
              ],
              [
                {
                  text: "Stabilized Value $/SF",
                  fontSize: 10,
                  color: "#676a6c"
                },
                {
                  text:
                    $filter("currency")(
                      review.stabilizedValueSf,
                      undefined,
                      2
                    ) || " ",
                  fontSize: 13,
                  bold: true,
                  color: "#545759"
                }
              ],
              [
                {
                  text: "Sales Comparison Approach",
                  fontSize: 10,
                  color: "#676a6c"
                },
                {
                  text:
                    $filter("currency")(
                      review.salesComparisonApproach,
                      undefined,
                      0
                    ) || " ",
                  fontSize: 13,
                  bold: true,
                  color: "#545759"
                }
              ]
            ]
          },
          {
            margin: [0, 20, 0, 0],
            alignment: "justify",
            columns: [
              [
                {
                  text: "Absorption Period",
                  fontSize: 10,
                  color: "#676a6c"
                },
                {
                  text: review.absorptionPeriod || " ",
                  fontSize: 13,
                  bold: true,
                  color: "#545759"
                }
              ],
              [
                {
                  text: "Cost Approach",
                  fontSize: 10,
                  color: "#676a6c"
                },
                {
                  text:
                    $filter("currency")(review.costApproach, undefined, 0) ||
                    " ",
                  fontSize: 13,
                  bold: true,
                  color: "#545759"
                }
              ],
              [
                {
                  text: "Insurable Value",
                  fontSize: 10,
                  color: "#676a6c"
                },
                {
                  text:
                    $filter("currency")(review.insurableValue, undefined, 0) ||
                    "N/A",
                  fontSize: 13,
                  bold: true,
                  color: "#545759"
                }
              ]
            ]
          },
          {
            margin: [0, 30, 0, 0],
            alignment: "justify",
            columns: [
              [
                {
                  text: "Prior Period Value to Current Value",
                  decoration: "underline",
                  color: "#696262",
                  fontSize: 14,
                  bold: true
                },
                {
                  margin: [0, 20, 0, 0],
                  columns: [
                    [
                      {
                        margin: [0, 10, 0, 0],
                        alignment: "justify",
                        text: "Percentage Change",
                        fontSize: 10,
                        color: "#676a6c"
                      },
                      {
                        text:
                          typeof review.appraisalPeriodDelta != "undefined" &&
                          review.appraisalPeriodDelta != "N/A"
                            ? $filter("percentage")(
                                $filter("number")(
                                  review.appraisalPeriodDelta,
                                  2
                                ),
                                undefined,
                                2
                              )
                            : "N/A",
                        fontSize: 13,
                        bold: true,
                        color: "#545759"
                      }
                    ],
                    [
                      {
                        margin: [0, 10, 0, 0],
                        alignment: "justify",
                        text: "Actual Dollar Change",
                        fontSize: 10,
                        color: "#676a6c"
                      },
                      {
                        text:
                          $filter("currency")(
                            review.appraisalPeriodDeltaValue,
                            undefined,
                            0
                          ) || "N/A",
                        fontSize: 13,
                        bold: true,
                        color: "#545759"
                      }
                    ]
                  ]
                }
              ],
              [
                {
                  text: "Prior Year Value to Current Value",
                  decoration: "underline",
                  color: "#696262",
                  fontSize: 14,
                  bold: true
                },
                {
                  margin: [0, 20, 0, 0],
                  columns: [
                    [
                      {
                        margin: [0, 10, 0, 0],
                        alignment: "justify",
                        text: "Percentage Change",
                        fontSize: 10,
                        color: "#676a6c"
                      },
                      {
                        text:
                          typeof review.appraisalYearlyDelta != "undefined" &&
                          review.appraisalYearlyDelta != "N/A"
                            ? $filter("percentage")(
                                $filter("number")(
                                  review.appraisalYearlyDelta,
                                  2
                                ),
                                undefined,
                                2
                              )
                            : "N/A",
                        fontSize: 13,
                        bold: true,
                        color: "#545759"
                      }
                    ],
                    [
                      {
                        margin: [0, 10, 0, 0],
                        alignment: "justify",
                        text: "Actual Dollar Change",
                        fontSize: 10,
                        color: "#676a6c"
                      },
                      {
                        text:
                          $filter("currency")(
                            review.appraisalYearlyDeltaValue,
                            undefined,
                            0
                          ) || "N/A",
                        fontSize: 13,
                        bold: true,
                        color: "#545759"
                      }
                    ]
                  ]
                }
              ]
            ]
          },
          {
            canvas: [
              {
                type: "line",
                x1: 0,
                y1: 3,
                x2: 560 - 2 * 40 + 80,
                y2: 3,
                lineWidth: 1,
                lineColor: "#cdcdcd"
              }
            ],
            margin: [0, 30, 0, 0]
          },
          {
            margin: [-40, 30, -40, 0],
            alignment: "justify",
            table: {
              widths: [35, "*", "*", "*", "*", "*", 35],
              headerRows: 1,
              body: [
                [
                  "",
                  "",
                  { text: "Stabilized Cap Rate", style: "tableHeader" },
                  { text: "Terminal Rate", style: "tableHeader" },
                  { text: "Discount Rate", style: "tableHeader" },
                  { text: "Implied Cap Rate", style: "tableHeader" },
                  ""
                ],
                [
                  { text: "", fillColor: "#ebebeb" },
                  {
                    text: "Current Rate",
                    style: "tableHeader",
                    fillColor: "#ebebeb"
                  },
                  {
                    text:
                      typeof review.stabilizedCapRate != "undefined"
                        ? $filter("percentage")(
                            $filter("number")(review.stabilizedCapRate, 2),
                            undefined,
                            2
                          )
                        : " ",
                    style: "tableContent",
                    fillColor: "#ebebeb"
                  },
                  {
                    text:
                      typeof review.terminalRate != "undefined"
                        ? $filter("percentage")(
                            $filter("number")(review.terminalRate, 2),
                            undefined,
                            2
                          )
                        : " ",
                    style: "tableContent",
                    fillColor: "#ebebeb"
                  },
                  {
                    text:
                      typeof review.discountRate != "undefined"
                        ? $filter("percentage")(
                            $filter("number")(review.discountRate, 2),
                            undefined,
                            2
                          )
                        : " ",
                    style: "tableContent",
                    fillColor: "#ebebeb"
                  },
                  {
                    text:
                      typeof review.impliedCapRate != "undefined"
                        ? $filter("percentage")(
                            $filter("number")(review.impliedCapRate, 2),
                            undefined,
                            2
                          )
                        : " ",
                    style: "tableContent",
                    fillColor: "#ebebeb"
                  },
                  { text: "", fillColor: "#ebebeb" }
                ],
                [
                  "",
                  { text: "P/P Δ", style: "tableHeader" },
                  {
                    text:
                      (typeof review.stabilizedCapRatePeriodDelta != "undefined"
                        ? review.stabilizedCapRatePeriodDelta
                        : "N/A") + "",
                    style: "tableContent"
                  },
                  {
                    text:
                      (typeof review.terminalRatePeriodDelta != "undefined"
                        ? review.terminalRatePeriodDelta
                        : "N/A") + "",
                    style: "tableContent"
                  },
                  {
                    text:
                      (typeof review.discountRatePeriodDelta != "undefined"
                        ? review.discountRatePeriodDelta
                        : "N/A") + "",
                    style: "tableContent"
                  },
                  {
                    text:
                      (typeof review.impliedCapRatePeriodDelta != "undefined"
                        ? review.impliedCapRatePeriodDelta
                        : "N/A") + "",
                    style: "tableContent"
                  },
                  ""
                ],
                [
                  { text: "", fillColor: "#ebebeb" },
                  {
                    text: "Y/Y Δ",
                    style: "tableHeader",
                    fillColor: "#ebebeb"
                  },
                  {
                    text:
                      (typeof review.stabilizedCapRateYearlyDelta != "undefined"
                        ? review.stabilizedCapRateYearlyDelta
                        : "N/A") + "",
                    style: "tableContent",
                    fillColor: "#ebebeb"
                  },
                  {
                    text:
                      (typeof review.terminalRateYearlyDelta != "undefined"
                        ? review.terminalRateYearlyDelta
                        : "N/A") + "",
                    style: "tableContent",
                    fillColor: "#ebebeb"
                  },
                  {
                    text:
                      (typeof review.discountRateYearlyDelta != "undefined"
                        ? review.discountRateYearlyDelta
                        : "N/A") + "",
                    style: "tableContent",
                    fillColor: "#ebebeb"
                  },
                  {
                    text:
                      (typeof review.impliedCapRateYearlyDelta != "undefined"
                        ? review.impliedCapRateYearlyDelta
                        : "N/A") + "",
                    style: "tableContent",
                    fillColor: "#ebebeb"
                  },
                  { text: "", fillColor: "#ebebeb" }
                ]
              ]
            },
            layout: {
              hLineWidth: function() {
                return 0;
              },
              vLineWidth: function() {
                return 0;
              },
              paddingTop: function() {
                return 7;
              },
              paddingBottom: function() {
                return 7;
              }
            }
          },
          {
            pageBreak: "after",
            margin: [0, 30, 0, 0],
            alignment: "justify",
            columns: [
              [
                {
                  text: "Average Contract Rent",
                  fontSize: 10,
                  color: "#676a6c"
                },
                {
                  text:
                    $filter("currency")(review.avgContractRent, undefined, 2) ||
                    " ",
                  fontSize: 13,
                  bold: true,
                  color: "#545759"
                }
              ],
              [
                {
                  text: "Average Market Rent",
                  fontSize: 10,
                  color: "#676a6c"
                },
                {
                  text:
                    $filter("currency")(review.avgMarketRent, undefined, 2) ||
                    " ",
                  fontSize: 13,
                  bold: true,
                  color: "#545759"
                }
              ],
              [
                {
                  text: "Average Rent Growth",
                  fontSize: 10,
                  color: "#676a6c"
                },
                {
                  text:
                    $filter("percentage")(
                      $filter("number")(review.avgRentGrowth, 2),
                      undefined,
                      2
                    ) || " ",
                  fontSize: 13,
                  bold: true,
                  color: "#545759"
                }
              ]
            ]
          },
          {
            margin: [0, 30, 0, 0],
            text: "Factors for Value Change from Prior Period",
            decoration: "underline",
            color: "#696262",
            fontSize: 14,
            bold: true
          },
          {
            margin: [0, 20, 0, 0],
            alignment: "left",
            widths: [144, 107, 150, 150],
            columns: [
              [
                {
                  text: "Discount Rate",
                  fontSize: 8,
                  color: "#676a6c"
                },
                {
                  margin: [0, 3, 0, 0],
                  text:
                    $filter("currency")(
                      review.deltaDiscountRate,
                      undefined,
                      0
                    ) || " ",
                  fontSize: 13,
                  bold: true,
                  color: "#545759"
                },
                {
                  margin: [0, 10, 0, 0],
                  text: "Real Estate Taxes",
                  fontSize: 8,
                  color: "#676a6c"
                },
                {
                  margin: [0, 3, 0, 0],
                  text:
                    $filter("currency")(
                      review.deltaRealEstateTaxes,
                      undefined,
                      0
                    ) || " ",
                  fontSize: 13,
                  bold: true,
                  color: "#545759"
                },
                {
                  margin: [0, 10, 0, 0],
                  text: "Vacancy & Collection Loss",
                  fontSize: 8,
                  color: "#676a6c"
                },
                {
                  margin: [0, 3, 0, 0],
                  text:
                    $filter("currency")(
                      review.deltaVacancyAndCollectionLoss,
                      undefined,
                      0
                    ) || " ",
                  fontSize: 13,
                  bold: true,
                  color: "#545759"
                }
              ],
              [
                {
                  text: "Terminal Cap Rate",
                  fontSize: 8,
                  color: "#676a6c"
                },
                {
                  margin: [0, 3, 0, 0],
                  text:
                    $filter("currency")(
                      review.deltaTerminalCapRate,
                      undefined,
                      0
                    ) || " ",
                  fontSize: 13,
                  bold: true,
                  color: "#545759"
                },
                {
                  margin: [0, 10, 0, 0],
                  text: "Leasing Capital",
                  fontSize: 8,
                  color: "#676a6c"
                },
                {
                  margin: [0, 3, 0, 0],
                  text:
                    $filter("currency")(
                      review.deltaLeasingCapital,
                      undefined,
                      0
                    ) || " ",
                  fontSize: 13,
                  bold: true,
                  color: "#545759"
                },
                {
                  margin: [0, 10, 0, 0],
                  text: "Expenses",
                  fontSize: 8,
                  color: "#676a6c"
                },
                {
                  margin: [0, 3, 0, 0],
                  text:
                    $filter("currency")(review.deltaExpenses, undefined, 0) ||
                    " ",
                  fontSize: 13,
                  bold: true,
                  color: "#545759"
                }
              ],
              [
                {
                  text: "Average Market Rent Growth",
                  fontSize: 8,
                  color: "#676a6c"
                },
                {
                  margin: [0, 3, 0, 0],
                  text:
                    $filter("currency")(
                      review.deltaAvgMarketRentGrowth,
                      undefined,
                      0
                    ) || " ",
                  fontSize: 13,
                  bold: true,
                  color: "#545759"
                },
                {
                  margin: [0, 10, 0, 0],
                  text: "Market Rents",
                  fontSize: 8,
                  color: "#676a6c"
                },
                {
                  margin: [0, 3, 0, 0],
                  text:
                    $filter("currency")(
                      review.deltaMarketRents,
                      undefined,
                      0
                    ) || " ",
                  fontSize: 13,
                  bold: true,
                  color: "#545759"
                },
                {
                  margin: [0, 10, 0, 0],
                  text: "Building Capital",
                  fontSize: 8,
                  color: "#676a6c"
                },
                {
                  margin: [0, 3, 0, 0],
                  text:
                    $filter("currency")(
                      review.deltaBuildingCapital,
                      undefined,
                      0
                    ) || " ",
                  fontSize: 13,
                  bold: true,
                  color: "#545759"
                }
              ],
              [
                {
                  text: "Downtime & Renewal Probability",
                  fontSize: 8,
                  color: "#676a6c"
                },
                {
                  margin: [0, 3, 0, 0],
                  text:
                    $filter("currency")(
                      review.deltaDowntimeAndRenewalProbability,
                      undefined,
                      0
                    ) || " ",
                  fontSize: 13,
                  bold: true,
                  color: "#545759"
                },
                {
                  margin: [0, 10, 0, 0],
                  text: "Contract Rents",
                  fontSize: 8,
                  color: "#676a6c"
                },
                {
                  margin: [0, 3, 0, 0],
                  text:
                    $filter("currency")(
                      review.deltaContractRents,
                      undefined,
                      0
                    ) || " ",
                  fontSize: 13,
                  bold: true,
                  color: "#545759"
                },
                {
                  margin: [0, 10, 0, 0],
                  text: "Other",
                  fontSize: 8,
                  color: "#676a6c"
                },
                {
                  margin: [0, 3, 0, 0],
                  text:
                    $filter("currency")(review.deltaOther, undefined, 0) || " ",
                  fontSize: 13,
                  bold: true,
                  color: "#545759"
                }
              ]
            ]
          },
          {
            margin: [0, 15, 0, 0],
            layout: {
              hLineWidth: function() {
                return 0;
              },
              vLineWidth: function() {
                return 0;
              }
            },
            table: {
              body: [
                [
                  {
                    text: "Total Change",
                    fontSize: 8,
                    color: "#676a6c",
                    fillColor: "#ededed"
                  }
                ],
                [
                  {
                    text: $filter("currency")(
                      review.totalChange || 0,
                      undefined,
                      0
                    ),
                    fontSize: 13,
                    bold: true,
                    color: "#545759",
                    fillColor: "#ededed"
                  }
                ]
              ]
            }
          },
          {
            canvas: [
              {
                type: "line",
                x1: 0,
                y1: 3,
                x2: 560 - 2 * 40 + 80,
                y2: 3,
                lineWidth: 1,
                lineColor: "#cdcdcd"
              }
            ],
            margin: [0, 40, 0, 0]
          },
          {
            margin: [0, 40, 0, 0],
            alignment: "justify",
            text: "P/P Value Change Explanation",
            decoration: "underline",
            color: "#696262",
            fontSize: 14,
            bold: true
          },
          {
            margin: [0, 10, 0, 0],
            text: review.ppValueChangeExplanation || " ",
            color: "#545759",
            fontSize: 11
          },
          {
            margin: [0, 30, 0, 0],
            text: "Y/Y Value Change Explanation",
            decoration: "underline",
            color: "#696262",
            fontSize: 14,
            bold: true
          },
          {
            pageBreak: "after",
            margin: [0, 10, 0, 0],
            text: review.yyValueChangeExplanation || " ",
            color: "#545759",
            fontSize: 11
          }
        ],
        styles: {
          tableHeader: {
            color: "#676a6c",
            fontSize: 10
          },
          tableContent: {
            color: "#545759",
            fontSize: 13,
            bold: true
          }
        }
      };
      if (review.comments) {
        var commentsSection = [
          {
            text: "All Comments",
            decoration: "underline",
            color: "#696262",
            fontSize: 14,
            bold: true
          }
        ];
        var commentBlock = [];
        review.comments.comments.forEach(function(comment) {
          var user = review.comments.users[comment.userId];
          var avatar = SecurityManager.canSeeUser(comment.userRole)
            ? generateAvatarImage(
                $filter("initials")(user.name),
                RoleFactory.getColor(comment.userRole)
              )
            : generateAvatarImage($filter("initials")("U"), "#c2c2c2");
          commentBlock.push([
            //coment
            {
              canvas: [
                {
                  type: "line",
                  x1: 0,
                  y1: 0,
                  x2: 560 - 2 * 40 + 80,
                  y2: 0,
                  lineWidth: 1,
                  lineColor: "#cdcdcd"
                }
              ],
              margin: [0, 20, 0, 0]
            },
            {
              columns: [
                {
                  margin: [0, 33, 0, 0],
                  image: avatar,
                  width: 25,
                  height: 25
                },
                [
                  {
                    margin: [15, 15, 0, 0],
                    text: comment.title,
                    fontSize: 14,
                    bold: true,
                    color: "#66696b"
                  },
                  {
                    margin: [15, 7, 0, 0],
                    text: [
                      {
                        text:
                          review.comments.users[comment.userId] &&
                          SecurityManager.canSeeUser(comment.userRole)
                            ? review.comments.users[comment.userId].name + "  "
                            : "Unknown User  ",
                        fontSize: 12,
                        bold: true,
                        color: "#93989c"
                      },
                      {
                        text: $filter("formatDate")(
                          comment.nms,
                          "MMM DD - h:mm a"
                        ),
                        fontSize: 10,
                        color: "#a8a8a8"
                      }
                    ]
                  },
                  {
                    margin: [15, 13, 0, 0],
                    text: decodeEntities(
                      comment.body
                        .replace(/<\/p>/g, "\n")
                        .replace(/<\/?[^>]+(>|$)/g, "")
                    ),
                    fontSize: 12,
                    color: "#545759"
                  }
                ]
              ]
            }
            //replies
          ]);
          if (comment.replies) {
            var repliesBlock = [];
            repliesBlock.push({
              canvas: [
                {
                  type: "line",
                  x1: 0,
                  y1: 0,
                  x2: 560 - 2 * 40 + 80,
                  y2: 0,
                  lineWidth: 1,
                  lineColor: "#cdcdcd"
                }
              ],
              margin: [0, 20, 0, 0]
            });
            comment.replies.forEach(function(reply, index) {
              var replyUser = review.comments.users[reply.userId];
              var replyAvatar = SecurityManager.canSeeUser(reply.userRole)
                ? generateAvatarImage(
                    $filter("initials")(replyUser.name),
                    RoleFactory.getColor(reply.userRole)
                  )
                : generateAvatarImage($filter("initials")("U"), "#c2c2c2");
              if (index != 0) {
                repliesBlock.push({
                  canvas: [
                    {
                      type: "line",
                      x1: 0,
                      y1: 0,
                      x2: 560 - 2 * 40 + 80,
                      y2: 0,
                      lineWidth: 1,
                      lineColor: "#cdcdcd"
                    }
                  ],
                  margin: [0, 20, 0, 0]
                });
              }
              repliesBlock.push([
                {
                  margin: [50, 0, 0, 0],
                  columns: [
                    {
                      margin: [0, 20, 0, 0],
                      image: replyAvatar,
                      width: 25,
                      height: 25
                    },
                    [
                      {
                        margin: [15, 20, 0, 0],
                        text: [
                          {
                            text:
                              review.comments.users[reply.userId] &&
                              SecurityManager.canSeeUser(reply.userRole)
                                ? review.comments.users[reply.userId].name +
                                  "  "
                                : "Unknown User  ",
                            fontSize: 12,
                            bold: true,
                            color: "#93989c"
                          },
                          {
                            text: $filter("formatDate")(
                              reply.nms,
                              "MMM DD - h:mm a"
                            ),
                            fontSize: 10,
                            color: "#a8a8a8"
                          }
                        ]
                      },
                      {
                        margin: [15, 7, 40, 0],
                        text: decodeEntities(
                          reply.body
                            .replace(/<\/p>/g, "\n")
                            .replace(/<\/?[^>]+(>|$)/g, "")
                        ),
                        fontSize: 12,
                        color: "#3d3f41"
                      }
                    ]
                  ]
                }
              ]);
            });
            commentBlock.push(repliesBlock);
          }
        });
        commentsSection.push(commentBlock);
        docDefinition.content.push(commentsSection);
      }

      return pdfMake.createPdf(docDefinition);
    }

    function generateRolesPdf(headers, rows) {
      return $q(function(resolve, reject) {
        var pdfBody = rows.map(function(row) {
          return [
            {
              text: $filter("translate")(row[0]),
              alignment: "left",
              width: "20%",
              fontSize: 9,
              margin: [10, 7, 0, 7],
              bold: false,
              style: {
                alignment: "left",
                fontSize: 11,
                color: "#676767"
              }
            },
            {
              text: row[1] ? "Y" : "N",
              alignment: "left",
              fontSize: 9,
              width: "8%",
              margin: [0, 7, 0, 7],
              bold: !!row[1],
              style: {
                alignment: "left",
                color: row[1] ? "#000000" : "#676767"
              }
            },
            {
              text: row[2] ? "Y" : "N",
              alignment: "left",
              fontSize: 9,
              width: "11%",
              margin: [0, 7, 0, 7],
              bold: !!row[2],
              style: {
                alignment: "left",
                color: row[2] ? "#000000" : "#676767"
              }
            },
            {
              text: row[3] ? "Y" : "N",
              alignment: "left",
              fontSize: 9,
              width: "11%",
              margin: [0, 7, 0, 7],
              bold: !!row[3],
              style: {
                alignment: "left",
                color: row[3] ? "#000000" : "#676767"
              }
            },
            {
              text: row[4] ? "Y" : "N",
              alignment: "left",
              fontSize: 9,
              width: "11%",
              margin: [0, 7, 0, 7],
              bold: !!row[4],
              style: {
                alignment: "left",
                color: row[4] ? "#000000" : "#676767"
              }
            },
            {
              text: row[5] ? "Y" : "N",
              alignment: "left",
              fontSize: 9,
              width: "11%",
              margin: [0, 7, 0, 7],
              bold: !!row[5],
              style: {
                alignment: "left",
                color: row[5] ? "#000000" : "#676767"
              }
            },
            {
              text: row[6] ? "Y" : "N",
              alignment: "left",
              fontSize: 9,
              width: "11%",
              margin: [0, 7, 0, 7],
              bold: !!row[6],
              style: {
                alignment: "left",
                color: row[6] ? "#000000" : "#676767"
              }
            },
            {
              text: row[7] ? "Y" : "N",
              alignment: "left",
              fontSize: 9,
              width: "10%",
              margin: [0, 7, 0, 7],
              bold: !!row[7],
              style: {
                alignment: "left",
                color: row[7] ? "#000000" : "#676767"
              }
            },
            {
              text: row[8] ? "Y" : "N",
              alignment: "left",
              fontSize: 9,
              width: "7%",
              margin: [0, 7, 0, 7],
              bold: !!row[8],
              style: {
                alignment: "left",
                color: row[8] ? "#000000" : "#676767"
              }
            }
          ];
        });
        var docDefinition = {
          pageMargins: [20, 81, 15, 20],
          pageSize: "LETTER",
          header: {
            image: PDF_HEADERS._rolesHeader,
            width: 570,
            margin: [20, 10, 25, 0]
          },
          footer: function(currentPage, pageCount) {
            return {
              text: currentPage.toString() + "/" + pageCount + "",
              alignment: "center",
              bold: false,
              style: {
                color: "#676767",
                fontSize: 11
              }
            };
          },
          content: [
            {
              table: {
                headerRows: 1,
                dontBreakRows: true,
                widths: [
                  "20%",
                  "8%",
                  "11%",
                  "11%",
                  "11%",
                  "11%",
                  "11%",
                  "10%",
                  "7%"
                ],
                alignment: "left",
                style: {
                  alignment: "left"
                },
                body: [
                  headers.map(function(translateItem) {
                    if (translateItem === "ROLES.PDF_CAPTIONS.PERMISSIONS") {
                      return {
                        text: $filter("translate")(translateItem),
                        fillColor: "#ffffff",
                        margin: [10, 10, 0, 10],
                        alignment: "left",
                        bold: true,
                        style: {
                          fontSize: 9,
                          alignment: "left",
                          verticalAlign: "bottom",
                          color: "#afafaf"
                        }
                      };
                    }
                    return {
                      text: $filter("translate")(translateItem),
                      fillColor: "#ffffff",
                      margin: [0, 10, 0, 10],
                      alignment: "left",
                      bold: true,
                      style: {
                        fontSize: 9,
                        alignment: "left",
                        verticalAlign: "bottom",
                        color: "#afafaf"
                      }
                    };
                  })
                ].concat(pdfBody)
              },
              layout: {
                fillColor: function(i, node) {
                  return i % 2 === 0 ? "#f7f7f7" : null;
                },
                hLineWidth: function(i, node) {
                  return i === 0 || i === node.table.body.length ? 0 : 1;
                },
                hLineColor: function(i, node) {
                  return i === 0 || i === node.table.body.length
                    ? "#E7EAEC"
                    : "#E7EAEC";
                },
                vLineWidth: function(i, node) {
                  return i === 0 || i === node.table.widths.length ? 0 : 0;
                },
                vLineColor: function(i, node) {
                  return i === 0 || i === node.table.widths.length
                    ? "#FFFFFF"
                    : "#FFFFFF";
                }
              }
            }
          ]
        };

        var pdf = pdfMake.createPdf(docDefinition);

        return resolve(pdf);
      });
    }

    function generateAvatarImage(text, color) {
      var canvas = document.createElement("canvas");
      // I am using predefined dimensions so either make this part of the arguments or change at will
      var context = canvas.getContext("2d");
      context.fillStyle = color;
      context.beginPath();
      var radius = 20; // for example
      context.arc(20, 20, radius, 0, Math.PI * 2);
      context.closePath();
      context.fill();
      context.fillStyle = "white"; // font color to write the text with
      context.font = "normal 15px arial,sans-serif";
      context.textBaseline = "top";
      context.fillText(
        text,
        radius - context.measureText(text).width / 2,
        radius - 8
      ); //(radius / 2)

      return cropImageFromCanvas(context, canvas);
    }

    function cropImageFromCanvas(ctx, canvas) {
      var w = canvas.width,
        h = canvas.height,
        pix = { x: [], y: [] },
        imageData = ctx.getImageData(0, 0, canvas.width, canvas.height),
        x,
        y,
        index;

      for (y = 0; y < h; y++) {
        for (x = 0; x < w; x++) {
          index = (y * w + x) * 4;
          if (imageData.data[index + 3] > 0) {
            pix.x.push(x);
            pix.y.push(y);
          }
        }
      }
      pix.x.sort(function(a, b) {
        return a - b;
      });
      pix.y.sort(function(a, b) {
        return a - b;
      });
      var n = pix.x.length - 1;

      w = pix.x[n] - pix.x[0] + 2;
      h = pix.y[n] - pix.y[0] + 2;
      var cut = ctx.getImageData(pix.x[0], pix.y[0], w, h);

      canvas.width = w;
      canvas.height = h;
      ctx.putImageData(cut, 0, 0);

      return canvas.toDataURL();
    }
  }

  var hiddenPre = document.createElement("pre");

  /**
   * decodes all entities into regular string
   * @param value
   * @returns {string} A string with decoded entities.
   */
  function decodeEntities(value) {
    if (!value) {
      return "";
    }

    hiddenPre.innerHTML = value.replace(/</g, "&lt;");
    return hiddenPre.textContent;
  }
})();

(function () {
  'use strict';

  angular
  .module('nvc')
  .service('LocaleService', LocaleService);

  /** @Inject*/
  function LocaleService($translate, LOCALES, $rootScope, tmhDynamicLocale, $log, $document) {

    // PREPARING LOCALES INFO
    var localesObj = LOCALES.locales;

    // locales and locales display names
    var _LOCALES = Object.keys(localesObj);
    if (!_LOCALES || 0 === _LOCALES.length ) {
      $log.error('There are no _LOCALES provided');
    }
    var _LOCALES_DISPLAY_NAMES = [];
    _LOCALES.forEach(function (locale) {
      _LOCALES_DISPLAY_NAMES.push(localesObj[locale]);
    });

    // STORING CURRENT LOCALE
    var currentLocale = $translate.proposedLanguage();// because of async loading
    if (!currentLocale) {
      currentLocale = localStorage.NG_TRANSLATE_LANG_KEY;
    }

    // METHODS
    var checkLocaleIsValid = function (locale) {
      return -1 !== _LOCALES.indexOf(locale);
    };

    var setLocale = function (locale) {
      if (!checkLocaleIsValid(locale)) {
        $log.error('Locale name "' + locale + '" is invalid');
        return;
      }
      currentLocale = locale;// updating current locale

      // asking angular-translate to load and apply proper translations
      $translate.use(locale);
    };

    // EVENTS
    // on successful applying translations by angular-translate
    var destroyHandler = $rootScope.$on('$translateChangeSuccess', function (event, data) {
      $document[0].lang = data.language;// sets "lang" attribute to html

      // asking angular-dynamic-locale to load and apply proper AngularJS $locale setting
      tmhDynamicLocale.set(data.language.toLowerCase().replace(/_/g, '-'));
    });

    $rootScope.$on('$destroy', destroyHandler);

    return {
      getLocaleDisplayName: function () {
        return localesObj[currentLocale];
      },
      setLocaleByDisplayName: function (localeDisplayName) {
        setLocale(
        _LOCALES[
        _LOCALES_DISPLAY_NAMES.indexOf(localeDisplayName)// get locale index
        ]
        );
      },
      getLocalesDisplayNames: function () {
        return _LOCALES_DISPLAY_NAMES;
      }
    };


  }
})();

(function () {

  angular.module('nvc').factory('httpInterceptor', httpInterceptor);

  /** @Inject*/
  function httpInterceptor($q, $injector, $rootScope, $filter, localStorageService, SweetAlert) {

    return {
      'request': function (config) {
        if (!config.data || (config.data && !config.data.append)) {
          var options;
          options = {};

          options.headers = {
            "Content-Type": 'application/x-www-form-urlencoded; charset=UTF-8'
          };
          options.transformRequest = function (obj) {
            var str = [];
            for (var p in obj)
              str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            return str.join("&");
          };
          setSessionParameter(options, config);
          return angular.merge({}, config, options);
        }
        return config;
      },
      'requestError': function (rejection) {
        return $q.reject(rejection);
      },
      'response': function (response) {
        return response;
      },
      'responseError': function (response) {
        if (419 === response.status) {
          localStorageService.cookie.remove('session_token');
          localStorageService.cookie.remove('refresh_data');
          $injector.get('SessionManager').authenticate(null);
          $injector.get('$state').transitionTo('login');
          $rootScope.$broadcast('loggedOut');
        } else if(400 === response.status && response.data.error === "Could not mutate to this asset valuation status."){
          response.reviewNotificationError = true;
          return $q.reject(response);
        } else if (401 === response.status ) {
          console.log('error in the interceptor');
          console.log(response.data);
          console.log('error in the interceptor');
        } else if (500 > response.status && (response.data && response.data.error && response.data.error != 'Invalid Request')) {
          SweetAlert.swal({
            title: $filter('translate')('COMMONS.ERROR'),
            text: response.data.error,
            type: "warning",
            confirmButtonColor: '#2c3d4e',
            confirmButtonText: $filter('translate')('COMMONS.OK'),
            closeOnConfirm: true,
            closeOnCancel: true
          });
        } else if (500 <= response.status) {
          SweetAlert.swal({
            title: $filter('translate')('COMMONS.ERROR'),
            text: $filter('translate')('COMMONS.500_GENERAL_MSG'),
            type: "warning",
            confirmButtonColor: '#2c3d4e',
            confirmButtonText: $filter('translate')('COMMONS.OK'),
            closeOnConfirm: true,
            closeOnCancel: true
          });
        }
        return $q.reject(response);
      }
    };

    function setSessionParameter(options, config) {
      var token = localStorageService.cookie.get('session_token');
      if (config.url.indexOf('v1') == -1) {
        return;
      }
      if (token) {
        if (config.method == 'POST') {//add any other methods that have body
          options.data = {
            session: token
          }
        } else {
          options.params = {
            session: token
          }
        }
      }
    }
  }
})();


(function () {
  angular
    .module('nvc')
    .factory('CSVService', CSVService);

  /** @ngInject */
  function CSVService($filter, $q, ReviewFactory, BidResponseService, AssetService, BidGroupService, BidRequestService, SessionManager, SecurityManager, UserService) {
    return {
      generateValuationsCSV: generateValuationsCSV,
      generateValuationsConclusionsCSV: generateValuationsConclusionsCSV,
      generateExecutiveSummaryCSV: generateExecutiveSummaryCSV,
      generateBidSummaryCsv: generateBidSummaryCsv,
      generateAssetsListCsv: generateAssetsListCsv,
      generateBidGroupsCsv: generateBidGroupsCsv,
      generateBidEngagementListCsv: generateBidEngagementListCsv,
      generateRequestStatusCsv: generateRequestStatusCsv,
      generateResponseSummaryCsv: generateResponseSummaryCsv,
      generateRolesCsv: generateRolesCsv,
      generateUsersListCsv: generateUsersListCsv
    };



    function ObjectValus(obj) {
      return Object.keys(obj).map(function (key) {
        return obj[key];
      });
    }

    // Handle CSV download
    function downloadWithContent(content, fileName) {
      var $a = angular.element('<a></a>');
      $a.attr('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent('\uFEFF') + encodeURIComponent(content));
      $a.attr('download', fileName + '.csv');
      angular.element('body').append($a);
      $a[0].click();
      $a.remove();
    }

    // Makes sure no comma conflict would occure inside CSV body
    function escapeCommas(csvBody) {
      return csvBody.map(function (obj) {
        return ObjectValus(obj).map(function (item) {
          if (String(item).indexOf(',') !== -1) {
            item = '"' + item + '"';
          }
          return item;
        }).join(',');
      }).join('\n');
    }

    /*
      ============
      Roles
      ============
    */
    function generateRolesCsv(headers, rows) {
      return $q(function (resolve, reject) {
        var csvHeader = headers.map(function (translateItem) {
          return $filter('translate')(translateItem);
        });

        var csvBody = rows.map(function (row) {
          return {
            permission: $filter('translate')(row[0]),
            admin: row[1] ? '\u2714' : 'x',
            secondaryReviewer: row[2] ? '\u2714' : 'x',
            leadReviewer: row[3] ? '\u2714' : 'x',
            secondaryAppraiser: row[4] ? '\u2714' : 'x',
            leadAppraiser: row[5] ? '\u2714' : 'x',
            secondaryAssetManager: row[6] ? '\u2714' : 'x',
            leadAssetManager: row[7] ? '\u2714' : 'x',
            readonly: row[8] ? '\u2714' : 'x',
          }
        });

        csvHeader = csvHeader.toString() + '\n';

        csvBody = escapeCommas(csvBody);

        var currentUser = SessionManager.getUser();
        downloadWithContent(csvHeader + csvBody, 'roles-list-' + currentUser.name);

        resolve();
      })
        .catch(function (err) {
          reject(err);
        });
    }

    /*
    ============
      Users
    ============
    */
    function generateUsersListCsv(userCompanyId, company, usersCount, searchQuery, sortKey, sortOrder) {
      return $q(function (resolve, reject) {
        getUsersList()
          .then(function (data) {
            var users = data.users;

            var csvHeader = [
              $filter('translate')('USERS.USER_NAME'),
              $filter('translate')('USERS.EMAIL_ADDRESS'),
              $filter('translate')('USERS.USER_OFFICE_NUMBER'),
              $filter('translate')('USERS.USER_MOBILE_NUMBER'),
              $filter('translate')('USERS.ACTIVE'),
            ];

            var csvBody = users.map(function (user) {
              return {
                name: user.user.name,
                email: user.userAccount.email,
                officePhone: $filter('bcTelephone')(user.userAccount.officePhone, 'format'),
                mobilePhone: $filter('bcTelephone')(user.userAccount.mobilePhone, 'format'),
                status: user.active ? '\u2714' : 'x'
              }
            });

            csvHeader = csvHeader.toString() + '\n';

            csvBody = escapeCommas(csvBody);

            var currentUser = SessionManager.getUser();
            downloadWithContent(csvHeader + csvBody, 'users-list-' + currentUser.name);

            resolve();

          })
          .catch(function (err) {
            reject(err);
          })
      });

      function getUsersList() {
        if (SessionManager.isInRole('Admin')) {
          return UserService.getUsersByCompanyIdPage(company.id, false, 0, usersCount, searchQuery, sortKey, sortOrder);
        }
        else if (userCompanyId === company.id) {
          return UserService.getUsersByCompanyIdPage(company.id, true, 0, usersCount, searchQuery, sortKey, sortOrder);
        }
        else {
          return UserService.getRelatedUsersByCompanyIdPage(company.id, true, 0, usersCount, searchQuery,
            sortKey, sortOrder);
        }
      }
    }

    /*
      ============
      Valuations
      ============
    */
    function generateValuationsCSV(selectedCompany, numberOfValuations, searchQuery, sortKey, sortSize, abbrTypes, advancedFilters, isStatusView, myValuationsOnly) {
      return $q(function (resolve, reject) {
        ReviewFactory.loadAllReviewsByCompany(selectedCompany, 0, numberOfValuations, searchQuery, sortKey, sortSize, myValuationsOnly, advancedFilters)
          .then(function (reviews) {
            var data = reviews.reviews;
            var csvHeader = [];
            var csvBody = [];
            if (isStatusView) {
              /* === CSV Header === */
              csvHeader = [
                $filter('translate')('VALUATIONS.PROPERTY_NAME'),
                $filter('translate')('VALUATIONS.LOCATION'),
                $filter('translate')('VALUATIONS.V_PERIOD'),
                $filter('translate')('VALUATIONS.DRAFT_SUBMITTED_BY_APR'),
                $filter('translate')('VALUATIONS.COMMENTS_SUBMITTED_BY_REV_TO_AM'),
                $filter('translate')('VALUATIONS.COMMENTS_SUBMITTED_BY_AM'),
                $filter('translate')('VALUATIONS.COMMENTS_SUBMITTED_TO_APR'),
                $filter('translate')('VALUATIONS.RESPONSES_SUBMITTED_BY_APR'),
                $filter('translate')('VALUATIONS.VALUATION_APPROVED_BY_REV'),
                $filter('translate')('VALUATIONS.VALUATION_APPROVED_BY_AM'),
                $filter('translate')('VALUATIONS.VALUATION_SIGNED_OFF'),
                $filter('translate')('VALUATIONS.FINAL_DOCUMENTS_SUBMITTED'),
                $filter('translate')('VALUATIONS.FINAL_DOCUMENTS_REJECTED'),
                $filter('translate')('VALUATIONS.DOCUMENTS_SIGNED_OFF')
              ];
              /* === /CSV Header === */

              csvBody = data.map(function (rev) {
                // Take initials of the name and uppercase it
                var mainBody = {
                  name: rev.name,
                  type: abbrTypes(rev.asset.type) || 'N/A',
                  vPeriod: rev.vPeriod,
                  FormFilled: rev.formFilledDate ? moment(rev.formFilledDate).format('MM/DD/YYYY') : '',
                  ReviewerCommented: rev.reviewerCommentedDate ? moment(rev.reviewerCommentedDate).format('MM/DD/YYYY') : '',
                  ManagerCommented: rev.managerCommentedDate ? moment(rev.managerCommentedDate).format('MM/DD/YYYY') : '',
                  SubmittedToAppraiser: rev.submittedToAppraiserDate ? moment(rev.submittedToAppraiserDate).format('MM/DD/YYYY') : '',
                  ValuationUpdated: rev.valuationUpdatedDate ? moment(rev.valuationUpdatedDate).format('MM/DD/YYYY') : '',
                  ReviewerApproveValuation: rev.reviewerApproveValuationDate ? moment(rev.reviewerApproveValuationDate).format('MM/DD/YYYY') : '',
                  ManagerApproveValuation: rev.managerApproveValuationDate ? moment(rev.managerApproveValuationDate).format('MM/DD/YYYY') : '',
                  ValuationSignedOff: rev.valuationSignedOffDate ? moment(rev.valuationSignedOffDate).format('MM/DD/YYYY') : '',
                  FinalFormFilled: rev.finalFormFilledDate ? moment(rev.finalFormFilledDate).format('MM/DD/YYYY') : '',
                  FinalFilesRejected: rev.finalFilesRejectedDate ? moment(rev.finalFilesRejectedDate).format('MM/DD/YYYY') : '',
                  Finished: rev.finishedDate ? moment(rev.finishedDate).format('MM/DD/YYYY') : '',
                };
                return mainBody;
              });
            } else {
              /* === CSV Header === */
              csvHeader = [
                $filter('translate')('VALUATIONS.PROPERTY_NAME'),
                $filter('translate')('VALUATIONS.LOCATION'),
                $filter('translate')('VALUATIONS.PROPERTY_TYPE')
              ];

              // Add AssetManager column if user is allowed to see that
              if (SecurityManager.canSeeUser('AssetManagement')) {
                csvHeader.push($filter('translate')('VALUATIONS.ASSET_MANAGER'));
              }

              csvHeader = csvHeader.concat([
                $filter('translate')('VALUATIONS.REVIEWER'),
                $filter('translate')('VALUATIONS.CURRENT_VALUE'),
                $filter('translate')('VALUATIONS.V_PERIOD'),
                $filter('translate')('VALUATIONS.STATUS'),
                $filter('translate')('VALUATIONS.NEXT')
              ]);

              /* === /CSV Header === */

              csvBody = data.map(function (rev) {
                // Take initials of the name and uppercase it
                var nextName = rev.nextUserTakingActionName ?
                  rev.nextUserTakingActionName.split(' ').map(function (char) { return char[0].toUpperCase() }).join('')
                  : '';

                var mainBody = {
                  name: rev.name,
                  location: rev.location,
                  type: abbrTypes(rev.asset.type) || 'N/A'
                };

                // Only add assetManager if user can see it
                if (SecurityManager.canSeeUser('AssetManagement')) {
                  mainBody.assetManager = rev.primaryManagerName || 'N/A';
                }

                mainBody = Object.assign({}, mainBody, {
                  reviewer: rev.primaryReviewerName || 'N/A',
                  currentValue: rev.presentValue ? $filter('currency')(rev.presentValue) : '',
                  vPeriod: rev.vPeriod,
                  status: rev.statusDescription,
                  next: rev.nextUserTakingActionName || 'N/A'
                });

                return mainBody;
              });
            }

            csvHeader = csvHeader.toString() + '\n';

            csvBody = escapeCommas(csvBody);

            downloadWithContent(csvHeader + csvBody, 'valuations');

            resolve();

          })
          .catch(function (err) {
            reject(err);
          });
      });
    }

    function generateValuationsConclusionsCSV(
      selectedCompany, numberOfValuations, searchQuery, sortKey, sortSize,
      abbrTypes, advancedFilters, myValuationsOnly
    ) {
      return $q(function (resolve, reject) {
        ReviewFactory.loadAllReviewsByCompany(
          selectedCompany, 0, numberOfValuations, searchQuery,
          sortKey, sortSize, myValuationsOnly, advancedFilters
        ).then(function (reviews) {
          var data = reviews.reviews;
          var csvHeader = [
            $filter('translate')('VALUATIONS.PROPERTY_NAME'),
            $filter('translate')('VALUATIONS.CITY'),
            $filter('translate')('VALUATIONS.STATE'),
            $filter('translate')('VALUATIONS.PROPERTY_TYPE'),
            $filter('translate')('VALUATIONS.SF'),
            $filter('translate')('VALUATIONS.UNITS'),
            $filter('translate')('VALUATIONS.V_PERIOD'),
            $filter('translate')('VALUATIONS.CURRENT_VALUE'),
            $filter('translate')('VALUATIONS.VALUE_PER_SF'),
            $filter('translate')('VALUATIONS.AVERAGE_CONTRACT_RENT'),
            $filter('translate')('VALUATIONS.AVERAGE_MARKET_RENT'),
            $filter('translate')('VALUATIONS.STABILIZED_CAP_RATE'),
            $filter('translate')('VALUATIONS.IMPLIED_CAP_RATE'),
            $filter('translate')('VALUATIONS.TERMINAL_RATE'),
            $filter('translate')('VALUATIONS.DISCOUNT_RATE')
          ];

          var csvBodyPromise = data.map(function (rev) {
            return ReviewFactory.loadReview(rev.asset.id, rev.id)
              .then(function (assetReview) {
                return {
                  PropertyName: rev.name || '',
                  City: rev.city || '',
                  State: rev.state || '',
                  PropertyType: abbrTypes(rev.asset.type) || '',
                  SF: rev.netRentableArea || '',
                  Units: rev.asset.numberOfUnits || '',
                  vPeriod: rev.vPeriod,
                  CurrentValue: rev.presentValue ? $filter('currency')(rev.presentValue) : '',
                  ValuePerSF: rev.netRentableArea ? $filter('currency')((rev.presentValue/rev.netRentableArea)) : '',
                  AverageContractRent: assetReview.avgContractRent ? $filter('currency')(assetReview.avgContractRent) : '',
                  AverageMarketRent: assetReview.avgMarketRent ? $filter('currency')(assetReview.avgMarketRent) : '',
                  StabilizedCapRate: assetReview.stabilizedCapRate ? $filter('percentage')(assetReview.stabilizedCapRate) : '',
                  ImpliedCapRate: assetReview.impliedCapRate ? $filter('percentage')(assetReview.impliedCapRate) : '',
                  TerminalRate: assetReview.terminalRate ? $filter('percentage')((assetReview.terminalRate)) : '',
                  DiscountRate: assetReview.discountRate ? $filter('percentage')(assetReview.discountRate) : '',
                };
              });
          });

          Promise.all(csvBodyPromise)
            .then(function (csvBody) {
              // Convert csvBody to CSV format
              csvHeader = csvHeader.toString() + '\n';

              csvBody = escapeCommas(csvBody);

              downloadWithContent(csvHeader + csvBody, 'valuation-conclusions');

              resolve();
            })
            .catch(function (err) {
              reject(err);
            });
        })
          .catch(function (err) {
            reject(err);
          });
      });
    }

    function generateExecutiveSummaryCSV(
      selectedCompany, numberOfValuations, searchQuery, sortKey, sortSize,
      abbrTypes, advancedFilters, myValuationsOnly
    ) {
      return $q(function (resolve, reject) {
        ReviewFactory.loadAllReviewsByCompany(
          selectedCompany, 0, numberOfValuations, searchQuery,
          sortKey, sortSize, myValuationsOnly, advancedFilters
        ).then(function (reviews) {
          var data = reviews.reviews;
          var csvHeader = [
            $filter('translate')('VALUATIONS.PROPERTY_NAME'),
            $filter('translate')('VALUATIONS.CITY'),
            $filter('translate')('VALUATIONS.STATE'),
            $filter('translate')('VALUATIONS.PROPERTY_TYPE'),
            $filter('translate')('VALUATIONS.UNITS'),
            $filter('translate')('VALUATIONS.V_PERIOD'),

            $filter('translate')('DOCUMENTS.PREVIOUS_VALUE'),
            $filter('translate')('DOCUMENTS.DRAFT_VALUE'),
            $filter('translate')('DOCUMENTS.FINAL_VALUE'),
            $filter('translate')('DOCUMENTS.LAND') + ' ' + $filter('translate')('DOCUMENTS.OTHER_ADJ'),
            $filter('translate')('DOCUMENTS.DISCOUNTED_CASH_FLOW'),
            $filter('translate')('DOCUMENTS.DIRECT_CAPITALIZATION'),
            $filter('translate')('DOCUMENTS.STABILIZED_VALUE'),
            $filter('translate')('DOCUMENTS.STABILIZED_VALUE_SF'),
            $filter('translate')('DOCUMENTS.SALES_COMPARISON_APPROACH'),
            $filter('translate')('DOCUMENTS.ABSORPTION_PERIOD'),
            $filter('translate')('DOCUMENTS.COST_APPROACH'),            
            $filter('translate')('DOCUMENTS.INSURABLE_VALUE'),
            $filter('translate')('DOCUMENTS.PRIOR_PERIOD_TO_CURRENT')  + ' ' + $filter('translate')('DOCUMENTS.PERCENTAGE_CHANGE'),
            $filter('translate')('DOCUMENTS.PRIOR_PERIOD_TO_CURRENT')  + ' ' + $filter('translate')('DOCUMENTS.ACTUAL_DOLLAR_CHANGE'),
            $filter('translate')('DOCUMENTS.PRIOR_YEAR_TO_CURRENT')  + ' ' + $filter('translate')('DOCUMENTS.PERCENTAGE_CHANGE'),
            $filter('translate')('DOCUMENTS.PRIOR_YEAR_TO_CURRENT')  + ' ' + $filter('translate')('DOCUMENTS.ACTUAL_DOLLAR_CHANGE'),
            $filter('translate')('DOCUMENTS.STABILIZED_CAP_RATE')  + ' ' + $filter('translate')('DOCUMENTS.CURRENT_RATE'),
            $filter('translate')('DOCUMENTS.STABILIZED_CAP_RATE')  + ' P/P Δ',
            $filter('translate')('DOCUMENTS.STABILIZED_CAP_RATE')  + ' Y/Y Δ',
            $filter('translate')('DOCUMENTS.TERMINAL_RATE')  + ' ' + $filter('translate')('DOCUMENTS.CURRENT_RATE'),
            $filter('translate')('DOCUMENTS.TERMINAL_RATE')  + ' P/P Δ',
            $filter('translate')('DOCUMENTS.TERMINAL_RATE')  + ' Y/Y Δ',
            $filter('translate')('DOCUMENTS.DISCOUNT_RATE')  + ' ' + $filter('translate')('DOCUMENTS.CURRENT_RATE'),
            $filter('translate')('DOCUMENTS.DISCOUNT_RATE')  + ' P/P Δ',
            $filter('translate')('DOCUMENTS.DISCOUNT_RATE')  + ' Y/Y Δ',
            $filter('translate')('DOCUMENTS.IMPLIED_CAP_RATE')  + ' ' + $filter('translate')('DOCUMENTS.CURRENT_RATE'),
            $filter('translate')('DOCUMENTS.IMPLIED_CAP_RATE')  + ' P/P Δ',
            $filter('translate')('DOCUMENTS.IMPLIED_CAP_RATE')  + ' Y/Y Δ',
            $filter('translate')('DOCUMENTS.AVERAGE_CONTRACT_RENT'),
            $filter('translate')('DOCUMENTS.AVERAGE_MARKET_RENT'),
            $filter('translate')('DOCUMENTS.AVERAGE_RENT_GROWTH'),

            $filter('translate')('DOCUMENTS.FACTOR_FOR_VALUE_CHANGE')  + ' ' + $filter('translate')('DOCUMENTS.DISCOUNT_RATE'),
            $filter('translate')('DOCUMENTS.FACTOR_FOR_VALUE_CHANGE')  + ' ' + $filter('translate')('DOCUMENTS.TERMINAL_CAP_RATE'),
            $filter('translate')('DOCUMENTS.FACTOR_FOR_VALUE_CHANGE')  + ' ' + $filter('translate')('DOCUMENTS.AVERAGE_MARKET_RENT_GROWTH'),
            $filter('translate')('DOCUMENTS.FACTOR_FOR_VALUE_CHANGE')  + ' ' + $filter('translate')('DOCUMENTS.DOWNTIME_AND_RENEWAL2'),
            $filter('translate')('DOCUMENTS.FACTOR_FOR_VALUE_CHANGE')  + ' ' + $filter('translate')('DOCUMENTS.REAL_ESTATE_TAXES'),
            $filter('translate')('DOCUMENTS.FACTOR_FOR_VALUE_CHANGE')  + ' ' + $filter('translate')('DOCUMENTS.LEASING_CAPITAL'),
            $filter('translate')('DOCUMENTS.FACTOR_FOR_VALUE_CHANGE')  + ' ' + $filter('translate')('DOCUMENTS.MARKET_RENTS'),
            $filter('translate')('DOCUMENTS.FACTOR_FOR_VALUE_CHANGE')  + ' ' + $filter('translate')('DOCUMENTS.CONTRACT_RENTS'),
            $filter('translate')('DOCUMENTS.FACTOR_FOR_VALUE_CHANGE')  + ' ' + $filter('translate')('DOCUMENTS.VACANCY_AND_COLLECTION_LOSS2'),
            $filter('translate')('DOCUMENTS.FACTOR_FOR_VALUE_CHANGE')  + ' ' + $filter('translate')('DOCUMENTS.EXPENSES'),
            $filter('translate')('DOCUMENTS.FACTOR_FOR_VALUE_CHANGE')  + ' ' + $filter('translate')('DOCUMENTS.BUILDING_CAPITAL'),
            $filter('translate')('DOCUMENTS.FACTOR_FOR_VALUE_CHANGE')  + ' ' + $filter('translate')('DOCUMENTS.OTHER'),
            $filter('translate')('DOCUMENTS.FACTOR_FOR_VALUE_CHANGE')  + ' ' + $filter('translate')('DOCUMENTS.TOTAL_CHANGE'),

            'P/P ' + $filter('translate')('DOCUMENTS.VALUE_CHANGE_EXPLANATION'),
            'Y/Y ' + $filter('translate')('DOCUMENTS.VALUE_CHANGE_EXPLANATION'),

          ];

          var csvBodyPromise = data.map(function (rev) {
            return ReviewFactory.loadReview(rev.asset.id, rev.id)
              .then(function (assetReview) {
                return {
                  PropertyName: rev.name || '',
                  City: rev.city || '',
                  State: rev.state || '',
                  PropertyType: abbrTypes(rev.asset.type) || '',
                  Units: rev.asset.numberOfUnits || '',
                  vPeriod: rev.vPeriod,

                  PreviousValue:  (assetReview.asset && assetReview.asset.valuation && assetReview.asset.valuation.appraisalPrevious) ? $filter('currency')(assetReview.asset.valuation.appraisalPrevious) : '',
                  DraftValue: (assetReview.asset && assetReview.asset.valuation && assetReview.asset.valuation.appraisalDraft) ? $filter('currency')(assetReview.asset.valuation.appraisalDraft) : '',
                  FinalValue:  (assetReview.asset && assetReview.asset.valuation && assetReview.asset.valuation.appraisalFinal) ? $filter('currency')(assetReview.asset.valuation.appraisalFinal) : '',
                  LandAndOtherAdj:  (assetReview.asset && assetReview.asset.valuation && assetReview.asset.valuation.landAndOtherAdj) ? $filter('currency')(assetReview.asset.valuation.landAndOtherAdj) : '',
                  DiscountedCashFlow: (assetReview.asset && assetReview.asset.valuation && assetReview.asset.valuation.discountedCashFlowAnalysis) ? $filter('currency')(assetReview.asset.valuation.discountedCashFlowAnalysis) : '',
                  DirectCapitalizationAnalysis: (assetReview.asset && assetReview.asset.valuation && assetReview.asset.valuation.directCapitalizationAnalysis) ? $filter('currency')(assetReview.asset.valuation.directCapitalizationAnalysis) : '',
                  StabilizedValue: (assetReview.asset && assetReview.asset.valuation && assetReview.asset.valuation.stabilizedValue) ? $filter('currency')(assetReview.asset.valuation.stabilizedValue) : '',
                  StabilizedValueSf: (assetReview.asset && assetReview.asset.valuation && assetReview.asset.valuation.stabilizedValueSf) ? $filter('currency')(assetReview.asset.valuation.stabilizedValueSf) : '',
                  SalesComparisonApproach: (assetReview.asset && assetReview.asset.valuation && assetReview.asset.valuation.salesComparisonApproach) ? $filter('currency')(assetReview.asset.valuation.salesComparisonApproach) : '',
                  AbsorptionPeriod: (assetReview.asset && assetReview.asset.valuation && assetReview.asset.valuation.absorptionPeriod) ? (assetReview.asset.valuation.absorptionPeriod) : '',
                  CostApproach: (assetReview.asset && assetReview.asset.valuation && assetReview.asset.valuation.costApproach) ? $filter('currency')(assetReview.asset.valuation.costApproach) : '',   
                  InsurableValue: (assetReview.asset && assetReview.asset.valuation && assetReview.asset.valuation.insurableValue) ? $filter('currency')(assetReview.asset.valuation.insurableValue) : '',
                  AppraisalPeriodDelta: (assetReview.asset && assetReview.asset.valuation && assetReview.asset.valuation.appraisalPeriodDelta) ? $filter('percentage')(assetReview.asset.valuation.appraisalPeriodDelta) : '',   
                  AppraisalPeriodDeltaValue: (assetReview.asset && assetReview.asset.valuation && assetReview.asset.valuation.appraisalPeriodDeltaValue) ? $filter('currency')(assetReview.asset.valuation.appraisalPeriodDeltaValue) : '',   
                  AppraisalYearlyDelta: (assetReview.asset && assetReview.asset.valuation && assetReview.asset.valuation.appraisalYearlyDelta) ? $filter('percentage')(assetReview.asset.valuation.appraisalYearlyDelta) : '',   
                  AppraisalYearlyDeltaValue: (assetReview.asset && assetReview.asset.valuation && assetReview.asset.valuation.appraisalYearlyDeltaValue) ? $filter('currency')(assetReview.asset.valuation.appraisalYearlyDeltaValue) : '',   
                  StabilizedCapRate: (assetReview.asset && assetReview.asset.valuation && assetReview.asset.valuation.stabilizedCapRate) ? $filter('percentage')(assetReview.asset.valuation.stabilizedCapRate) : '',   
                  StabilizedCapRatePeriodDelta: (assetReview.asset && assetReview.asset.valuation && assetReview.asset.valuation.stabilizedCapRatePeriodDelta) ? $filter('number')(assetReview.asset.valuation.stabilizedCapRatePeriodDelta) : '',   
                  StabilizedCapRateYearlyDelta: (assetReview.asset && assetReview.asset.valuation && assetReview.asset.valuation.stabilizedCapRateYearlyDelta) ? $filter('number')(assetReview.asset.valuation.stabilizedCapRateYearlyDelta) : '',   
                  TerminalRate: (assetReview.asset && assetReview.asset.valuation && assetReview.asset.valuation.terminalRate) ? $filter('percentage')(assetReview.asset.valuation.terminalRate) : '',   
                  TerminalRatePeriodDelta: (assetReview.asset && assetReview.asset.valuation && assetReview.asset.valuation.terminalRatePeriodDelta) ? $filter('number')(assetReview.asset.valuation.terminalRatePeriodDelta) : '',   
                  TerminalRateYearlyDelta: (assetReview.asset && assetReview.asset.valuation && assetReview.asset.valuation.terminalRateYearlyDelta) ? $filter('number')(assetReview.asset.valuation.terminalRateYearlyDelta) : '',  
                  DiscountRate: (assetReview.asset && assetReview.asset.valuation && assetReview.asset.valuation.discountRate) ? $filter('percentage')(assetReview.asset.valuation.discountRate) : '',   
                  DiscountRatePeriodDelta: (assetReview.asset && assetReview.asset.valuation && assetReview.asset.valuation.discountRatePeriodDelta) ? $filter('number')(assetReview.asset.valuation.discountRatePeriodDelta) : '',   
                  DiscountRateYearlyDelta: (assetReview.asset && assetReview.asset.valuation && assetReview.asset.valuation.discountRateYearlyDelta) ? $filter('number')(assetReview.asset.valuation.discountRateYearlyDelta) : '',   
                  ImpliedCapRate: (assetReview.asset && assetReview.asset.valuation && assetReview.asset.valuation.impliedCapRate) ? $filter('percentage')(assetReview.asset.valuation.impliedCapRate) : '',   
                  ImpliedCapRatePeriodDelta: (assetReview.asset && assetReview.asset.valuation && assetReview.asset.valuation.impliedCapRatePeriodDelta) ? $filter('number')(assetReview.asset.valuation.impliedCapRatePeriodDelta) : '',   
                  ImpliedCapRateYearlyDelta: (assetReview.asset && assetReview.asset.valuation && assetReview.asset.valuation.impliedCapRateYearlyDelta) ? $filter('number')(assetReview.asset.valuation.impliedCapRateYearlyDelta) : '',   
                  AvgContractRent: (assetReview.asset && assetReview.asset.valuation && assetReview.asset.valuation.avgContractRent) ? $filter('currency')(assetReview.asset.valuation.avgContractRent) : '',   
                  AvgMarketRent: (assetReview.asset && assetReview.asset.valuation && assetReview.asset.valuation.avgMarketRent) ? $filter('currency')(assetReview.asset.valuation.avgMarketRent) : '',   
                  AvgRentGrowth: (assetReview.asset && assetReview.asset.valuation && assetReview.asset.valuation.avgRentGrowth) ? $filter('percentage')(assetReview.asset.valuation.avgRentGrowth) : '',   

                  DeltaDiscountRate: (assetReview.asset && assetReview.asset.valuation && assetReview.asset.valuation.deltaDiscountRate) ? $filter('currency')(assetReview.asset.valuation.deltaDiscountRate) : '',   
                  DeltaTerminalCapRate: (assetReview.asset && assetReview.asset.valuation && assetReview.asset.valuation.deltaTerminalCapRate) ? $filter('currency')(assetReview.asset.valuation.deltaTerminalCapRate) : '',   
                  DeltaAvgMarketRentGrowth: (assetReview.asset && assetReview.asset.valuation && assetReview.asset.valuation.deltaAvgMarketRentGrowth) ? $filter('currency')(assetReview.asset.valuation.deltaAvgMarketRentGrowth) : '',   
                  DeltaDowntimeAndRenewalProbability: (assetReview.asset && assetReview.asset.valuation && assetReview.asset.valuation.deltaDowntimeAndRenewalProbability) ? $filter('currency')(assetReview.asset.valuation.deltaDowntimeAndRenewalProbability) : '',   
                  DeltaRealEstateTaxes: (assetReview.asset && assetReview.asset.valuation && assetReview.asset.valuation.deltaRealEstateTaxes) ? $filter('currency')(assetReview.asset.valuation.deltaRealEstateTaxes) : '',   
                  DeltaLeasingCapital: (assetReview.asset && assetReview.asset.valuation && assetReview.asset.valuation.deltaLeasingCapital) ? $filter('currency')(assetReview.asset.valuation.deltaLeasingCapital) : '',   
                  DeltaMarketRents: (assetReview.asset && assetReview.asset.valuation && assetReview.asset.valuation.deltaMarketRents) ? $filter('currency')(assetReview.asset.valuation.deltaMarketRents) : '',   
                  DeltaContractRents: (assetReview.asset && assetReview.asset.valuation && assetReview.asset.valuation.deltaContractRents) ? $filter('currency')(assetReview.asset.valuation.deltaContractRents) : '',   
                  DeltaVacancyAndCollectionLoss: (assetReview.asset && assetReview.asset.valuation && assetReview.asset.valuation.deltaVacancyAndCollectionLoss) ? $filter('currency')(assetReview.asset.valuation.deltaVacancyAndCollectionLoss) : '',   
                  DeltaExpenses: (assetReview.asset && assetReview.asset.valuation && assetReview.asset.valuation.deltaExpenses) ? $filter('currency')(assetReview.asset.valuation.deltaExpenses) : '',   
                  DeltaBuildingCapital: (assetReview.asset && assetReview.asset.valuation && assetReview.asset.valuation.deltaBuildingCapital) ? $filter('currency')(assetReview.asset.valuation.deltaBuildingCapital) : '',   
                  deltaOther: (assetReview.asset && assetReview.asset.valuation && assetReview.asset.valuation.deltaOther) ? $filter('currency')(assetReview.asset.valuation.deltaOther) : '',   
                  TotalChange: (assetReview.asset && assetReview.asset.valuation && assetReview.asset.valuation.totalChange) ? $filter('currency')(assetReview.asset.valuation.totalChange) : '',   

                  PpValueChangeExplanation: (assetReview.asset && assetReview.asset.valuation && assetReview.asset.valuation.ppValueChangeExplanation) ? (assetReview.asset.valuation.ppValueChangeExplanation) : '',   
                  YyValueChangeExplanation: (assetReview.asset && assetReview.asset.valuation && assetReview.asset.valuation.yyValueChangeExplanation) ? (assetReview.asset.valuation.yyValueChangeExplanation) : '',   
                };
              });
          });

          Promise.all(csvBodyPromise)
            .then(function (csvBody) {
              // Convert csvBody to CSV format
              csvHeader = csvHeader.toString() + '\n';

              csvBody = escapeCommas(csvBody);

              downloadWithContent(csvHeader + csvBody, 'executive-summary');

              resolve();
            })
            .catch(function (err) {
              reject(err);
            });
        })
          .catch(function (err) {
            reject(err);
          });
      });
    }
    /*
      ============
      Bid Summary
      ============
    */
    function generateBidSummaryCsv(bid) {
      var assets = bid.assets;
      return $q(function (resolve, reject) {
        var csvHeader = [
          $filter('translate')('BID_SUMMARY.ASSET'),
          $filter('translate')('BID_SUMMARY.YEAR_1'),
          $filter('translate')('BID_SUMMARY.DISCOUNT'),
          $filter('ampToAnd')($filter('translate')('BID_SUMMARY.YEAR_2&3')),
          $filter('translate')('BID_SUMMARY.DISCOUNT'),
          $filter('translate')('BID_SUMMARY.UPDATE'),
          $filter('translate')('BID_SUMMARY.DISCOUNT'),
          $filter('translate')('BID_SUMMARY.TOTAL_FEE'),
          $filter('translate')('BID_SUMMARY.DISCOUNT'),
          $filter('translate')('BID_SUMMARY.BID_NOTES'),
        ];
        var csvBody = [];

        assets.forEach(function (asset) {
          csvBody.push({
            asset: asset.name,
            year1: '',
            discount1: '',
            year23: '',
            discount2: '',
            quarterly: '',
            discount3: '',
            totalFee: '',
            discount4: '',
            bidNote: ''
          })
          asset.bidResponses.forEach(function (bidResp) {
            csvBody.push({
              asset: bidResp.appraiser.user.name,
              year1: $filter('currency')(bidResp.yearOne),
              discount1: $filter('currency')(bidResp.yearOneDiscount),
              year23: $filter('currency')(bidResp.yearsTwoThree),
              discount2: $filter('currency')(bidResp.yearsTwoThreeDiscount),
              quarterly: $filter('currency')(bidResp.quarterly),
              discount3: $filter('currency')(bidResp.quarterlyDiscount),
              totalFee: $filter('totalFeeCheckmark')($filter('currency')(bidResp.totalFee), bidResp),
              discount4: $filter('discountCheckmark')($filter('currency')(bidResp.totalFeeDiscount), bidResp),
              bidNote: (
                bidResp.bidNotesAdmin ? bidResp.bidNotesAdmin + ' | ' : ''
              ) + (
                  bidResp.bidNotes ? (bidResp.bidNotes) : ''
                )
            });
          });
        });

        csvHeader = csvHeader.toString() + '\n';

        csvBody = escapeCommas(csvBody);

        downloadWithContent(csvHeader + csvBody, 'bid-summary-' + bid.name);

        resolve();
      });
    }

    /*
      ============
      Assets List
      ============
    */
    function generateAssetsListCsv(companyId, assetsCount, searchQuery, sortTag, sortOrder, propertyTypes) {

      return $q(function (resolve, reject) {
        BidGroupService.list(companyId)
          .then(function (bidGroups) {
            var bidGroupNamesById = {};

            bidGroups.forEach(function (bidGroup) {
              bidGroupNamesById[bidGroup.id] = bidGroup.name;
            });

            AssetService.getAssetsByCompanyPage(companyId, undefined, 0, assetsCount, searchQuery, sortTag, sortOrder)
              .then(function (assets) {

                // Add bidGroupName to asset
                assets.assets.forEach(function (asset) {
                  asset.bidGroupName = bidGroupNamesById[asset.bidGroupId];
                  for (var i = 0; i < propertyTypes.length; i++) {
                    if (asset.type === propertyTypes[i].type) {
                      asset.type = propertyTypes[i].name;
                      break;
                    }
                  }
                });

                // CSV Header
                var csvHeader = [
                  $filter('translate')('ASSETS.PROPERTY_NAME'),
                  $filter('translate')('ASSETS.ID'),
                  $filter('translate')('ASSETS.LOCATION')
                ];
                // Add Asset Manager if user has permission
                if (SecurityManager.canSeeUser('AssetManagement')) {
                  csvHeader.push(
                    $filter('translate')('ASSETS.ASSET_MANAGER')
                  )
                }
                csvHeader.push($filter('translate')('ASSETS.V_PERIOD'));
                // Hide bidding group from asset managers
                if (!SecurityManager.isCurrentUserAssetManager()) {
                  csvHeader.push($filter('translate')('ASSETS.BIDDING_GROUP'));
                }
                csvHeader = csvHeader.concat([
                  $filter('translate')('ASSETS.PROPERTY_TYPE'),
                  $filter('translate')('COMMONS.ACTIVE')
                ]);

                // CSV Body

                var csvBody = assets.assets.map(function (asset) {
                  var mainBody = {
                    propertyName: asset.name,
                    id: asset.propertyRef,
                    location: [asset.address.city, asset.address.state].join(', ')
                  };

                  if (SecurityManager.canSeeUser('AssetManagement')) {
                    mainBody.assetManager = asset.primaryManagerName;
                  }

                  mainBody.vperiod = asset.vperiod || '';

                  // Hide biddingGroup from asset managers
                  if (!SecurityManager.isCurrentUserAssetManager()) {
                    mainBody.biddingGroup = asset.bidGroupName || 'N/A';
                  }

                  mainBody = Object.assign({}, mainBody, {
                    propertyType: asset.type,
                    active: asset.active ? '\u2714' : 'x'
                  });

                  return mainBody;
                });

                csvHeader = csvHeader.toString() + '\n';

                csvBody = escapeCommas(csvBody);

                var currentUser = SessionManager.getUser();
                downloadWithContent(csvHeader + csvBody, 'assets-list-' + currentUser.name);

                resolve();

              })
              .catch(function (err) {
                reject(err);
              });
          })
          .catch(function (err) {
            reject(err);
          });
      });
    }

    /*
      ============
      Bid Groups
      ============
    */
    function generateBidGroupsCsv(companyId, bidGroupsCount, searchQuery,
      sortTag, sortOrder) {
      return $q(function (resolve, reject) {
        BidGroupService.listPage(companyId, 0, bidGroupsCount, searchQuery, sortTag, sortOrder)
          .then(function (bidGroups) {

            var csvHeader = [
              $filter('translate')('BID_GROUPS.NAME'),
              $filter('translate')('BID_GROUPS.ASSETS'),
            ];
            var csvBody = bidGroups.bidGroups.map(function (group) {
              return {
                name: group.name,
                assets: group.numberOfAssets
              }
            })

            csvHeader = csvHeader.toString() + '\n';

            csvBody = escapeCommas(csvBody);

            var currentUser = SessionManager.getUser();
            downloadWithContent(csvHeader + csvBody, 'bid-groups-' + currentUser.name);

            resolve();
          })
          .catch(function (err) {
            reject();
          });
      });
    }

    /*
      ============
      Bid Engagement List
      ============
    */
    function generateBidEngagementListCsv(assets, appraisers, companyId, bidsCount, searchQuery,
      sortTag, sortOrder) {

      return $q(function (resolve, reject) {
        BidRequestService.listByCompanyIdPage(companyId, 0, bidsCount, searchQuery, sortTag, sortOrder)
          .then(function (bidEngs) {

            var bids = bidEngs.bids;

            var csvHeader = [
              $filter('translate')('BID_ENGAGEMENT_LIST.RFP_NAME'),
              $filter('translate')('BID_ENGAGEMENT_LIST.ASSETS_AWARDED'),
              $filter('translate')('BID_ENGAGEMENT_LIST.RESPONSES'),
              $filter('translate')('BID_ENGAGEMENT_LIST.BID_DUE_DATE'),
            ];

            var csvBody = [];

            // var requestPromises = [];
            var promises = bids.map(function (bid) {
              return BidResponseService.listByBidRequestId(bid.id).then(function (bidResponseList) {
                var assetsArray = [],
                  appraisersArray = [];
                bid.bidResponses = bidResponseList;
                bid.assets = {};
                bid.appraisers = {};
                bid.responses = 0;
                bid.declines = 0;
                bid.pending = 0;
                bid.awarded = 0;
                for (var i = 0; i < bid.bidResponses.length; i++) {
                  for (var j = 0; j < assets.length; j++) {
                    if (bid.bidResponses[i].assetId == assets[j].id) {
                      var asset = angular.copy(assets[j]);
                      bid.assets[asset.id] = asset;
                      break;
                    }
                  }
                  for (j = 0; j < appraisers.length; j++) {
                    if (bid.bidResponses[i].userId == appraisers[j].user.id) {
                      var appraiser = angular.copy(appraisers[j]);
                      if (bid.bidResponses[i].respondedOn && bid.bidResponses[i].isSubmittedToAdmin) {
                        appraiser.responseBid = true;
                      }
                      if (bid.bidResponses[i].isDeclined) {
                        appraiser.declineBid = true;
                      }
                      if (!bid.appraisers[appraiser.id]) {
                        bid.appraisers[appraiser.id] = appraiser;
                      }
                      if (!bid.appraisers[appraiser.id].responseBid) {
                        bid.appraisers[appraiser.id].responseBid = appraiser.responseBid;
                      }
                      if (!bid.appraisers[appraiser.id].declineBid) {
                        bid.appraisers[appraiser.id].declineBid = appraiser.declineBid;
                      }
                      break;
                    }
                  }
                }
                Object.keys(bid.assets).forEach(function (key) {
                  assetsArray.push(bid.assets[key]);
                });
                bid.assets = assetsArray;
                bid.assets.forEach(function (asset) {
                  bid.bidResponses.forEach(function (response) {
                    if (response.isAwarded && response.assetId == asset.id) {
                      asset.awarded = true;
                    }
                  });
                  if (asset.awarded) {
                    bid.awarded++;
                  }
                });

                Object.keys(bid.appraisers).forEach(function (key) {
                  appraisersArray.push(bid.appraisers[key]);
                });
                bid.appraisers = appraisersArray;
                bid.appraisers.forEach(function (appraiser) {
                  if (appraiser.responseBid) {
                    bid.responses++;
                  } else if (appraiser.declineBid) {
                    bid.declines++;
                  } else {
                    bid.pending++;
                  }
                });

                return bid;
              });
            });

            $q.all(promises).then(function (data) {
              csvBody = data.map(function (bid) {
                return {
                  rfpName: bid.name,
                  assetsAwarded: (bid.awarded || 0) + ' of ' + (bid.assets ? bid.assets.length : 0),
                  responses: (bid.responses || 0) + ' of ' + (bid.appraisers ? bid.appraisers.length : 0),
                  bidDueDate: $filter('date')(bid.dueDate, 'MMM dd, yyyy')
                }
              });

              csvHeader = csvHeader.toString() + '\n';

              csvBody = escapeCommas(csvBody);

              var currentUser = SessionManager.getUser();
              downloadWithContent(csvHeader + csvBody, 'bid-engagement-list-' + currentUser.name);
            });

            resolve();

          })
          .catch(function (err) {
            reject(err);
          });
      });

    }

    /*
      ============
      Request Status
      ============
    */
    function generateRequestStatusCsv(bidList, userId, requestsCount, searchQuery, sortTag, sortOrder) {

      return $q(function (resolve, reject) {
        BidRequestService.listByUserIdPage(userId, 0, requestsCount, searchQuery, sortTag, sortOrder)
          .then(function (responses) {

            var csvHeader = [
              $filter('translate')('ALL_REQUESTS.RFP_NAME'),
              $filter('translate')('ALL_REQUESTS.ASSETS'),
              $filter('translate')('ALL_REQUESTS.BID_DUE_DATE'),
              $filter('translate')('ALL_REQUESTS.STATUS')
            ];
            var csvBody = [];

            var promises = responses.bids.map(function (requestForProposal) {
              return AssetService.listByBidRequestId(requestForProposal.id)
                .then(function (assetsList) {
                  var responded, awarded = false, declined = false;
                  requestForProposal.assets = assetsList;
                  requestForProposal.responses = [];
                  requestForProposal.statusCounters = {
                    assetsAwarded: 0,
                    assetsResponded: 0,
                    assetsNotAwarded: 0
                  };
                  bidList.bidResponses.forEach(function (bidResponse) {
                    if (bidResponse.bidRequestId == requestForProposal.id) {
                      bidResponse.status = '';
                      if (!declined && bidResponse.isAwarded && (bidResponse.yearOne || bidResponse.yearOne == 0)) {
                        awarded = true;
                        responded = true;
                        bidResponse.status = 'Awarded';
                        requestForProposal.status = 'Awarded';
                        requestForProposal.statusCounters.assetsAwarded++;
                      } else if (!declined && bidResponse.respondedOn && (bidResponse.yearOne || bidResponse.yearOne == 0)
                        && !awarded && !bidResponse.isDeclined && bidResponse.isSubmittedToAdmin && !bidResponse.isNotAwarded) {
                        responded = true;
                        bidResponse.status = 'Responded';
                        requestForProposal.status = 'Responded';
                        requestForProposal.statusCounters.assetsResponded++;
                      } else if (!declined && !bidResponse.isSubmittedToAdmin && !bidResponse.isDeclined && !responded && !bidResponse.isAwarded && !bidResponse.isNotAwarded) {
                        bidResponse.status = 'NeedsResponse';
                        requestForProposal.status = 'NeedsResponse';
                      } else if (bidResponse.isDeclined) {
                        responded = true;
                        declined = true;
                        bidResponse.status = 'Declined';
                        requestForProposal.status = 'Declined';
                      } else if (!bidResponse.isDeclined && !bidResponse.isAwarded && bidResponse.isNotAwarded) {
                        bidResponse.status = 'NotAwarded';
                        requestForProposal.statusCounters.assetsNotAwarded++;
                      }
                      requestForProposal.responses.push(bidResponse);
                    }
                    for (var k = 0; k < requestForProposal.assets.length; k++) {
                      if (bidResponse.assetId == requestForProposal.assets[k].id) {
                        requestForProposal.assets[k].status = bidResponse.status;
                        requestForProposal.assets[k].bidResponseId = bidResponse.id;
                      }
                    }
                  });
                  if (requestForProposal.assets.length == requestForProposal.statusCounters.assetsNotAwarded) {
                    requestForProposal.status = 'NotAwarded';
                    for (var i = 0; i < requestForProposal.assets.length; i++) {
                      requestForProposal.assets[i].status = 'NotAwarded';
                    }
                  }

                  return requestForProposal;
                })
            });
            $q.all(promises).then(function (data) {
              csvBody = data.map(function (bid) {
                return {
                  rfpName: bid.name,
                  assets: bid.assets.length,
                  bidDueDate: $filter('date')(bid.dueDate, 'MMM dd, yyyy'),
                  status: $filter('bidRequestStatus')(bid)
                }
              });

              csvHeader = csvHeader.toString() + '\n';

              csvBody = escapeCommas(csvBody);

              var currentUser = SessionManager.getUser();
              downloadWithContent(csvHeader + csvBody, 'request-status-' + currentUser.name);

              resolve();
            });
          })
          .catch(function (err) {
            reject(err);
          })
      });
    }

    /*
      ============
      Response Summary
      ============
    */
    function generateResponseSummaryCsv(rfp, rfpAssets, totals, summarySort) {
      return $q(function (resolve) {
        var csvHeader = [
          $filter('translate')('RESPONSE_SUMMARY.ASSET'),
          $filter('translate')('RESPONSE_SUMMARY.YEAR_1'),
          $filter('translate')('RESPONSE_SUMMARY.DISCOUNT'),
          $filter('ampToAnd')($filter('translate')('RESPONSE_SUMMARY.YEAR_2_3')),
          $filter('translate')('RESPONSE_SUMMARY.DISCOUNT'),
          $filter('translate')('RESPONSE_SUMMARY.UPDATE'),
          $filter('translate')('RESPONSE_SUMMARY.DISCOUNT'),
          $filter('translate')('RESPONSE_SUMMARY.TOTAL_FEE'),
          $filter('translate')('RESPONSE_SUMMARY.DISCOUNT'),
        ];
        var csvBody = $filter('orderBy')(rfpAssets, summarySort.sort);
        csvBody = csvBody.map(function (asset) {
          return {
            asset: asset.name,
            year1: $filter('currency')(asset.response.yearOne),
            discount1: $filter('currency')(asset.response.yearOneDiscount),
            year23: $filter('currency')(asset.response.yearsTwoThree),
            discount2: $filter('currency')(asset.response.yearsTwoThreeDiscount),
            quarterly: $filter('currency')(asset.response.quarterly),
            discount3: $filter('currency')(asset.response.quarterlyDiscount),
            totalFee: $filter('currency')(asset.response.totalFee),
            discount4: $filter('currency')(asset.response.totalFeeDiscount)
          }
        });

        // Add totals to the end of csvBody
        csvBody.push({
          asset: 'Total',
          year1: $filter('currency')(totals[0]),
          discount1: $filter('currency')(totals[1]),
          year23: $filter('currency')(totals[2]),
          discount2: $filter('currency')(totals[3]),
          quarterly: $filter('currency')(totals[4]),
          discount3: $filter('currency')(totals[5]),
          totalFee: $filter('currency')(totals[6]),
          discount4: $filter('currency')(totals[7])
        });

        csvHeader = csvHeader.toString() + '\n';

        csvBody = escapeCommas(csvBody);

        downloadWithContent(csvHeader + csvBody, 'response-summary-' + rfp.name);

        resolve();
      });
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .factory('Base64Factory', Base64Factory);

  /**@ngInject*/
  function Base64Factory($q, uuid2) {

    return {
      base64FromImageUrl: base64FromImageUrl
    };

    function base64FromImageUrl(url) {
      return $q(function (resolve, reject) {
        var img = new Image();

        img.setAttribute('crossOrigin', 'anonymous');

        img.onload = function () {
          var canvas = document.createElement("canvas");
          canvas.width = this.width;
          canvas.height = this.height;

          var ctx = canvas.getContext("2d");
          ctx.drawImage(this, 0, 0);

          var dataURL = canvas.toDataURL("image/png");

          resolve(dataURL);
        };

        img.onerror = function(err) {
          reject(err);
        };
        var hash = uuid2.newuuid();
        img.src = url ? url + '?dummy=' + hash : window.origin + '/assets/images/blank.png';
      });
    }
  }

})();

(function () {
  'use strict';

  angular.module('nvc').factory('authorization', authorization);

  /** @Inject*/
  function authorization($rootScope, $state, SessionManager) {
    return {
      authorize: function (force) {
        return SessionManager.identity(force).then(function () {
          var isAuthenticated = SessionManager.isAuthenticated();
          if ($rootScope.toState.data.roles && !SessionManager.isInAnyRole($rootScope.toState.data.roles)) {
            if (isAuthenticated) {
              $state.go('app.valuations');
            } else {
              $rootScope.returnToState = $rootScope.toState;
              $rootScope.returnToStateParams = $rootScope.toStateParams;
              if($rootScope.toState.name!='login'){
                $state.go('login');
              }
            }
          }
        });
      }
    };
  }
})();

(function () {
  'use strict';

  angular
  .module('nvc')
  .factory('ArrayHelper', ArrayHelper);

  /**@ngInject*/
  function ArrayHelper() {

    return {
      sort: sort,
      beSort: beSort,
      searchScroll: searchScroll,
      filterByProperties: filterByProperties
    };

    function sort(sort, target, array, vm) {
      sort.sort = sort.flag ? '-' + sort.tag : sort.tag;
      sort.flag = !sort.flag;
      vm[target] = sort;
      array.forEach(function (element) {
        element.selected = element.sort == sort.sort;
        if (!element.selected) {
          element.flag = false;
        }
      });
    }

    function beSort(sort, target, array, vm) {
      sort.flag = !sort.flag;
      sort.order = sort.flag ? 'Ascending': 'Descending';
      vm[target] = sort;
      array.forEach(function (element) {
        element.selected = element.tag == sort.tag;
        if (!element.selected) {
          element.flag = false;
        }
      });
    }

    function searchScroll() {
      var perfectScroll = angular.element('.ps-container');
      perfectScroll.scrollTop(0);
    }

    function filterByProperties(item, query, properties) {
      for (var i = 0; i < properties.length; i++) {
        try{
          var value = getPropertyValue(item, properties[i]);
        }catch(exception){
          continue;
        }
        if(value){
          if (angular.lowercase(value).indexOf(angular.lowercase(query) || '') !== -1) {
            return true;
          }
        }
      }
      return false;
    }

    /**
     * throws error can´t find property <property> of undefined
     * @param item
     * @param key
     * @returns {*}
     */
    function getPropertyValue(item, key){
      var splitKey = key.split('.');
      var value = item;
      for (var i = 0; i < splitKey.length; i++){
        if(value){
          value = value[splitKey[i]];
        }
      }
      return value;
    }
  }

})();

function filterObject(obj, keys){
  var filteredObj = {};
  if(obj){
    keys.forEach(function(key){
      if(typeof obj[key] != 'undefined'){
        filteredObj[key] = obj[key];
      }
    });
  }
  return filteredObj;
}


function ReviewModel(review) {
  var self = this;
  var statesRules = {
    Created: {
      AP_UploadDocuments: 'DocumentsUploaded',
    },
    DocumentsUploaded: {
      AP_Submit: 'FormFilled',
      AP_UploadDocuments: 'FormFilled'
    },
    FormFilled: {
      RW_Approve: 'ReviewerApproveValuation',
      AM_Comment: 'ManagerCommented',
      RW_Comment: 'ReviewerCommented',
      RW_SubmitToAppraiser: 'SubmittedToAppraiser',
      AP_Submit: 'FormFilled',
      RW_Submit: 'FormFilled',
      RW_UploadDocuments: 'ReviewerApproveValuation'
    },
    ReviewerCommented: {
      AM_Comment: 'ManagerCommented',
      RW_Comment: 'ReviewerCommented',
      RW_SubmitToAppraiser: 'SubmitedToAppraiser'
    },
    ManagerCommented: {
      RW_Submit: 'ManagerCommented',
      RW_SubmitToAppraiser: 'SubmittedToAppraiser',
      RW_Approve: 'ReviewerApproveValuation'
    },
    SubmittedToAppraiser: {
      AP_Reply: 'CommentsAnswered',
      RW_Retract: 'ValuationUpdated',
      RW_Submit: 'SubmittedToAppraiser',
      LRW_Comment: 'SubmittedToAppraiser'
    },
    CommentsAnswered: {
      AP_Submit: 'ValuationUpdated',
      AP_UploadDocuments: 'DocumentsUpdated',
      RW_Retract: 'ValuationUpdated'
    },
    DocumentsUpdated: {
      AP_Submit: 'ValuationUpdated',
      RW_Retract: 'ValuationUpdated'
    },
    ValuationUpdated: {
      RW_SubmitToAppraiser: 'SubmittedToAppraiser',
      AM_Comment: 'ManagerCommented',
      RW_Approve: 'ReviewerApproveValuation',
      AP_Submit: 'ValuationUpdated'
    },
    ReviewerApproveValuation: {
      AM_Comment: 'ManagerCommented',
      AM_Approve: 'ManagerApproveValuation',
      RW_Submit: 'ReviewerApproveValuation',
      AP_Submit: 'ReviewerApproveValuation',
      LRW_Comment: 'ReviewerApproveValuation'
    },
    ManagerApproveValuation: {
      LRW_Comment: 'SubmittedToAppraiser',
      LRW_Approve: 'ValuationSignedOff',
      RW_Submit: 'ManagerApproveValuation',
      AP_Submit: 'ManagerApproveValuation',
    },
    ValuationSignedOff: {
      AP_UploadFinalDocuments: 'FinalDocumentsUploaded',
      AP_ReUploadFinalDocuments: 'FinalDocumentsUploaded',
      AP_UploadDocuments:'FinalFilesRejected'
    },
    FinalDocumentsUploaded: {
      AP_FillFinalForm: 'FinalFormFilled',
      LRW_Comment: 'SubmittedToAppraiser'
    },
    FinalFormFilled: {
      RW_ArchiveDocuments: 'Finished',
      RW_Reject: 'ValuationSignedOff',
      LRW_Comment: 'SubmittedToAppraiser',
    },
    Finished: {
      ADMIN_UpdateDocuments: 'Finished'
    }
  };
  var selectedValuation=null;
  angular.merge(self, review);

  var valuationStatus = self.status;
  if (!valuationStatus) {
    valuationStatus = 'Created';
  }

  // Documents section
  //
  self.getFilteredDocuments = function () {
    return ReviewModel.filterDocumentsByType(self.documents.assetDocuments);
  };

  self.calculateDocumentVersion = function (type) {
    var version;
    if(selectedValuation && selectedValuation.documents) {
        selectedValuation.documents.assetDocuments.forEach(function (document) {
          if(document.type && document.type == type && (!version || parseFloat(document.version) > version)) {
            version = parseFloat(document.version);
          }
        });
    } else if (self.documents) {
      self.documents.assetDocuments.forEach(function (document) {
        if (document.type == type && (!version || parseFloat(document.version) > version)) {
          version = parseFloat(document.version);
        }
      });
    }
    return version;
  };

  self.calculateNextDocumentVersion = function (type) {
    var versionIncrement = self.config.fileVersionIncrement || 1.00;
    var currentVersion = self.calculateDocumentVersion(type);
    if (!currentVersion) {
      return self.config.fileVersionStarts;
    }
    return currentVersion + versionIncrement;
  };

  self.calculateSourceDocumentVersion = function (documentName) {
    var version = 0;
    if(selectedValuation && selectedValuation.documents) {
      for(var i = 0; i < selectedValuation.documents.assetDocuments.length; i++) {
        var file = selectedValuation.assetDocuments[i];
        if(file.type && file.type == 'SourceDocument' && documentName == file.name) {
          version++;
        }
      }
    } else if (self.documents) {
      for(var i = 0; i < self.documents.assetDocuments.length; i++) {
        var file = self.documents.assetDocuments[i];
        if(file.type && file.type == 'SourceDocument' && documentName == file.name) {
          version++;
        }
      }
    }
    return version;
  };

  self.calculateNextSourceDocumentVersion = function (documentName) {
    var versionIncrement = 1.00;
    var currentVersion = self.calculateSourceDocumentVersion(documentName);
    if(!currentVersion) {
      return versionIncrement;
    }
    return currentVersion + versionIncrement;
  };


  self.setArgusFile = function (file, status, premise, version, quarter, year, valuation) {
    selectedValuation = valuation;
    var type = 'ArgusFile';
    if (!version) {
      version = self.calculateNextDocumentVersion(type);
    }
    // var name = ReviewModel.calculateDocumentName(self.asset.propertyRef, type, self.asset.name, file.name, self.quarter, self.year, status, version);
    var name = ReviewModel.calculateDocumentName(self.asset.propertyRef, type, self.asset.name, file.name, quarter ? quarter : self.quarter, year ? year : self.year, status, version);
    if (premise) {
      addDocument(file, name, type, version, status, premise);
    } else {
      addDocument(file, name, type, version, status);
    }
    return version;
  };

  self.setValuationReport = function (file, status, quarter, year, valuation) {
    selectedValuation = valuation;
    var type = 'ValuationReport';
    var version = self.calculateNextDocumentVersion(type);
    var name = ReviewModel.calculateDocumentName(self.asset.propertyRef, type, self.asset.name, file.name, quarter ? quarter : self.quarter, year ? year : self.year, status, version);
    // var name = ReviewModel.calculateDocumentName(self.asset.propertyRef, type, self.asset.name, file.name, self.quarter, self.year, status, version);
    addDocument(file, name, type, version, status);
  };

  self.setArgusExtract = function (file, status, quarter, year, valuation) {
    selectedValuation = valuation;
    var type = 'ArgusExtract';
    var version = self.calculateNextDocumentVersion(type);
    var name = ReviewModel.calculateDocumentName(self.asset.propertyRef, type, self.asset.name, file.name, quarter ? quarter : self.quarter, year ? year : self.year, status, version);
    // var name = ReviewModel.calculateDocumentName(self.asset.propertyRef, type, self.asset.name, file.name, self.quarter, self.year, status, version);
    addDocument(file, name, type, version, status);
  };

  self.setOthers = function (files, status, quarter, year, valuation) {
    selectedValuation = valuation;
    var type = 'Other';
    var version = self.calculateNextDocumentVersion(type);
    files.forEach(function (file) {
      var name = ReviewModel.calculateDocumentName(self.asset.propertyRef, type, self.asset.name, file.name, quarter ? quarter : self.quarter, year ? year : self.year, status, version);
      // var name = ReviewModel.calculateDocumentName(self.asset.propertyRef, type, self.asset.name, file.name, self.quarter, self.year, status, version);
      addDocument(file, name, type, version, status);
    });
  };

  function addDocument(file, name, type, version, status, premise) {
    var document = {
      assetValuationId: self.id,
      $document: file,
      name: name,
      type: type,
      version: version,
      status: status
    };
    if (premise) {
      document.premise = premise;
    }
    self.documents.assetDocuments.push(document);
  }

  /// Workflow section
  //
  self.transition = function (action) {
    var nextState = statesRules[valuationStatus][action];
    if (nextState) {
      valuationStatus = nextState;
      self.status = nextState;
      self.action = action;
      return true;
    }
    return false;
  };

  self.getCurrentStatus = function () {
    return valuationStatus
  };

  self.getPrimaryUserByAction = function (action, currentRole) {
    var users = action != 'AM_Comment' || self.status != "FormFilled" ? action.match(/[A-Z]+/) : ['RW'];
    if (users && users.length > 0) {
      switch (users[0]) {
        case 'AP':
          if (self.asset.primaryAssetAppraiser && currentRole !== 'AssetManagement') {
            return self.asset.primaryAssetAppraiser;
          } else {
            return self.asset.primaryAssetReviewer;
          }
          break;
        case 'AM':
          if (self.asset.primaryAssetManager && currentRole !== 'AssetAppraisal') {
            return self.asset.primaryAssetManager;
          } else {
            return self.asset.primaryAssetReviewer;
          }
          break;
        case 'RW':
        case 'LRW':
          if (self.asset.primaryAssetReviewer) {
            return self.asset.primaryAssetReviewer;
          }
          break;
      }
    }
    return {};
  };

  self.getCurrentAction = function () {
    var currentState = statesRules[valuationStatus];
    for (var keyAction in currentState) {
      return keyAction;
    }
    return '';
  };

  // More documents section
  // Argus Files can be more than one
  self.getLastArgusFileListDoNotUse = function () {
    var documentsByType = getDocumentsByType('ArgusFile');
    //var document = documentsByType;
    var documentList = [];
    var latestVersion = 0;
    for (var i = 0; i < documentsByType.length; i++) {
      if (documentsByType[i].version > latestVersion) {
        latestVersion = documentsByType[i].version;
      }
    }
    for (var i = 0; i < documentsByType.length; i++) {
      if (documentsByType[i].version == latestVersion) {
        var doc = documentsByType[i];
        doc.version = parseFloat(latestVersion);
        documentList.push(doc);
      }
    }
    return documentList;
  };

  self.getLastArgusFileByPremise = function (premise) {
    return getLatestDocumentByTypeAndPremise('ArgusFile', premise);
  };

  self.getLastArgusFile = function () {
    return getLatestDocumentByType('ArgusFile');
  };

  self.getOldArgusFileListByPremiseDoNotUse = function (premise, lastDocumentList) {
    var documentsByType = getDocumentsByType('ArgusFile');
    var len = documentsByType.length;
    for (var i = len - 1; i >= 0; i--) {
      //if (documentsByType[i].premise !== premise || lastDocumentList.find(e => e.id == documentsByType[i].id)) {
        if (documentsByType[i].premise !== premise || findIfDocumentIdFound(lastDocumentList, documentsByType[i].id)) {
        documentsByType.splice(i, 1);
      }
    }
    return documentsByType;
  };

  self.getOldArgusFilesByPremise = function (premise) {
    return getOldDocumentsByTypeAndPremise('ArgusFile', premise);
  };

  self.getOldArgusFiles = function () {
    return getOldDocumentsByType('ArgusFile');
  };

  self.getLastValuationReport = function () {
    return getLatestDocumentByType('ValuationReport');
  };

  self.getOldValuationReport = function () {
    return getOldDocumentsByType('ValuationReport');
  };

  self.getLastArgusExtract = function () {
    return getLatestDocumentByType('ArgusExtract');
  };

  self.getOldArgusExtract = function () {
    return getOldDocumentsByType('ArgusExtract');
  };

  self.getLastDocuments = function (documentType) {
    var otherDocuments = getDocumentsByType(documentType);
    var latestByName = {};
    for (var i = 0; i < otherDocuments.length; i++) {
      if (!latestByName[otherDocuments[i].name]) {
        latestByName[otherDocuments[i].name] = otherDocuments[i];
      } else if (latestByName[otherDocuments[i].name].version < otherDocuments[i].version) {
        latestByName[otherDocuments[i].name] = otherDocuments[i];
      }
    }
    var latestOtherDocuments = [];
    for (i = 0; i < Object.keys(latestByName).length; i++) {
      latestOtherDocuments.push(latestByName[Object.keys(latestByName)[i]]);
    }
    return latestOtherDocuments;
  };

  self.getOldDocumentsByName = function (documentType) {
    var otherDocuments = getDocumentsByType(documentType);
    var lastOtherDocuments = self.getLastDocuments(documentType);

    var oldByName = {};
    for (var i = 0; i < otherDocuments.length; i++) {
      var last = false;
      for (var j = 0; j < lastOtherDocuments.length; j++) {
        if (otherDocuments[i].id === lastOtherDocuments[j].id) {
          last = true;
          break;
        }
      }
      if (last) {
        continue;
      }
      if (!oldByName[otherDocuments[i].name]) {
        oldByName[otherDocuments[i].name] = [otherDocuments[i]];
      } else {
        oldByName[otherDocuments[i].name].push(otherDocuments[i]);
      }
    }
    return oldByName;
  };

  function getLatestDocumentByType(documentType) {
    var documentsByType = getDocumentsByType(documentType);
    var document = documentsByType[0];
    for (var i = 1; i < documentsByType.length; i++) {
      if (documentsByType[i].version > document.version) {
        document = documentsByType[i];
        document.version = parseFloat(document.version);
      }
    }
    return document;
  }

  function getLatestDocumentByTypeAndPremise(documentType, premise) {
    var documentsByType = getDocumentsByTypeAndPremise(documentType, premise);
    var document = null;
    if (documentsByType && documentsByType.length > 0) {
      document = documentsByType[0];
    } else {
      return document;
    }

    for (var i = 1; premise && i < documentsByType.length; i++) {
      if (documentsByType[i].version > document.version) {
        document = documentsByType[i];
        document.version = parseFloat(document.version);
      }
    }
    return document;
  }

  function getOldDocumentsByTypeAndPremise(documentType, premise) {
    var documentsByType = getDocumentsByTypeAndPremise(documentType, premise);
    var lastDocument = getLatestDocumentByTypeAndPremise(documentType, premise);
    for (var i = 0; premise && i < documentsByType.length; i++) {
      if (documentsByType[i].id === lastDocument.id) {
        documentsByType.splice(i, 1);
      }
    }
    return documentsByType;
  }

  function getOldDocumentsByType(documentType) {
    var documentsByType = getDocumentsByType(documentType);
    var lastDocument = getLatestDocumentByType(documentType);
    if(lastDocument){
      for (var i = 0; i < documentsByType.length; i++) {
        if (documentsByType[i].id === lastDocument.id) {
          documentsByType.splice(i, 1);
        }
      }
    }
    return documentsByType;
  }

  function getDocumentsByType(documentType) {
    var documents = [];
    for (var i = 0; i < self.documents.assetDocuments.length; i++) {
      if (self.documents.assetDocuments[i].type === documentType) {
        self.documents.assetDocuments[i].version = parseFloat(self.documents.assetDocuments[i].version);
        documents.push(self.documents.assetDocuments[i]);
      }
    }
    return documents;
  }

  function getDocumentsByTypeAndPremise(documentType, premise) {
    var documents = [];
    for (var i = 0; premise && i < self.documents.assetDocuments.length; i++) {
      if (self.documents.assetDocuments[i].type === 'ArgusFile' && !self.documents.assetDocuments[i].premise) {
        self.documents.assetDocuments[i].premise = 'AsIs';
      }
      if (self.documents.assetDocuments[i].type === documentType && self.documents.assetDocuments[i].premise === premise) {
        self.documents.assetDocuments[i].version = parseFloat(self.documents.assetDocuments[i].version);
        documents.push(self.documents.assetDocuments[i]);
      }
    }
    return documents;
  }

  function findIfDocumentIdFound(lastDocumentList, id) {
    for (i = 0; i< lastDocumentList.length; i++) {
      if (lastDocumentList[i].id == id) {
        return true;
      }
    }
    return false;
  }

  // Schedule section
  //
  self.setDraftDueDate = function (date) {
    date = moment(date);
    var nextDraftDueDate = moment(self.nextDraftDueDate);
    var currentQuarter = ReviewModel.getQuarterByDate(self.nextDraftDueDate),
      newDateQuarter = ReviewModel.getQuarterByDate(date);

    if (newDateQuarter != currentQuarter || nextDraftDueDate.get('year') !== date.get('year')) {
      return false;
    }

    if (currentQuarter == 1) {
      self.nextDraftDueDate = date;
      return true;
    }
    else if (currentQuarter == 2) {
      self.nextDraftDueDate = date;
      return true;
    }
    else if (currentQuarter == 3) {
      self.nextDraftDueDate = date;
      return true;
    }
    else if (currentQuarter == 4) {
      self.nextDraftDueDate = date;
      return true;
    }
    return false;
  };

  self.getDraftDueDate = function () {
    if (!self.nextDraftDueDate) {
      if (self.quarter && self.year) {
        var date = moment(self.asset['scheduleQ' + self.quarter]);
        date.year(self.year);
        self.nextDraftDueDate = date.valueOf();
        return date.valueOf();
      }
      return 'N/A'
    } else {
      return self.nextDraftDueDate;
    }
  };
  self.getDraftDueDateCurrentQuarter = function () {
    if(self.asset.valuationFrequency == 'SemiAnnually') {
      var date = null
      if(self.quarter ==1 || self.quarter ==2) {
        date = moment(self.asset['scheduleQ1']);
      } else {
        date = moment(self.asset['scheduleQ2']);
      }
        date.year(self.year);
        self.nextDraftDueDate = date.valueOf();
        return date.valueOf();
    } else if(self.asset.valuationFrequency == 'Quarterly') {
      if (self.quarter && self.year) {
        var date = moment(self.asset['scheduleQ' + self.quarter]);
        date.year(self.year);
        self.nextDraftDueDate = date.valueOf();
        return date.valueOf();
      } else {
        if(self.asset.vperiod) {
          self.quarter = self.asset.vperiod.substring(0,1);
          var year = self.asset.vperiod.substring(2,4)
          var date = moment(self.asset['scheduleQ' + self.quarter]);
          date.year(year);
          self.nextDraftDueDate = date.valueOf();
          return date.valueOf();
        }
        return self.nextDraftDueDate;
      }
    } else {
      var date = moment(self.asset['scheduleQ1']);
      date.year(self.year);
      self.nextDraftDueDate = date.valueOf();
      return date.valueOf();
    }
  };
  // Init
  //
  if (!this.asset) {
    throw 'Wrong ReviewModel initialization.'
  }
  self.nextDraftDueDate = self.getDraftDueDate();
}

//'static' functions
(function () {
  Object.defineProperties(ReviewModel, {
    filterDocumentsByType: {
      value: filterDocumentsByType
    },
    calculateDocumentName: {
      value: calculateDocumentName
    },
    calculateDraftDueDate: {
      value: calculateDraftDueDate
    },
    getQuarterByDate: {
      value: getQuarterByDate
    },
    getQuarterRange: {
      value: getQuarterRange
    },
    getQuarterRangeByQuarter: {
      value: getQuarterRangeByQuarter
    },

    states: {
      value: [
        'Created',
        'DocumentsUploaded',
        'FormFilled',
        'ReviewerCommented',
        'ManagerCommented',
        'SubmittedToAppraiser',
        'CommentsAnswered',
        'DocumentsUpdated',
        'ValuationUpdated',
        'ReviewerApproveValuation',
        'ManagerApproveValuation',
        'ValuationSignedOff',
        'FinalDocumentsUploaded',
        'FinalFormFilled',
        'Finished'
      ]
    },
    actions: {
      value: [
        'AP_UploadDocuments',
        'RW_UploadDocuments',
        'AP_Submit',
        'AM_Comment',
        'RW_Comment',
        'RW_Submit',
        'AP_Reply',
        'RW_Retract',
        'AP_Submit',
        'RW_Approve',
        'AM_Approve',
        'LRW_Comment',
        'LRW_Approves',
        'AP_UploadFinalDocuments',
        'AP_FillFinalForm',
        'LRW_ArchiveDocuments',
        'RW_Reject'
      ]
    }
  });

  function filterDocumentsByType(documents) {
    var filteredDocuments = {
      'ArgusFile': [],
      'ArgusExtract': [],
      'ValuationReport': [],
      'ExecutionSummary': [],
      'RentRoll': [],
      'CapexSchedule': [],
      'Other': []
    };

    if (documents) {
      documents.forEach(function (document) {
        if (document.type) {
          filteredDocuments[document.type].push(document);
        }
      });
    }

    return filteredDocuments;
  }

  function calculateDocumentName(id, type, assetName, originalFileName, quarter, year, status, version) {

    var sanitizedFileName = originalFileName.match(/(.*)\.[^.]+$/)[1];
    var sanitizedAssetName = assetName.replace(/[^a-z0-9]/gi, '').toLowerCase();
    var extension = /(?:\.([^.]+))?$/.exec(originalFileName)[0];
    version = parseInt(version);
    var fileName = '';

    switch (type) {
      case 'ArgusFile':
        fileName += status ? id + '_' + sanitizedAssetName + '_' + quarter  + 'Q' + year + '_' + status + extension :
        id + '_' + sanitizedAssetName + '_' + quarter  + 'Q' + year + extension;
        break;
      case 'ArgusExtract':
        fileName += status ? id + '_' + sanitizedAssetName + '_' + quarter  + 'Q' + year + '_' + status + extension :
        id + '_' + sanitizedAssetName + '_' + quarter  + 'Q' + year + extension;
        break;
      case 'ValuationReport':        
      fileName += status ? id + '_'  + sanitizedAssetName + '_' + quarter + 'Q' + year + '_' + status + extension :
      id + '_'  + sanitizedAssetName + '_' + quarter + 'Q' + year + extension;
        break;
      default:
        fileName += sanitizedFileName + extension;
        break;
    }
    return fileName;
  }

  var quarter1From = moment('01-01', 'MM-DD'),
    quarter1To = moment('03-31', 'MM-DD'),
    quarter2From = moment('04-01', 'MM-DD'),
    quarter2To = moment('06-30', 'MM-DD'),
    quarter3From = moment('07-01', 'MM-DD'),
    quarter3To = moment('09-30', 'MM-DD'),
    quarter4From = moment('10-01', 'MM-DD'),
    quarter4To = moment('12-31', 'MM-DD');

  function getQuarterByDate(date) {
    date = moment(date).startOf('day');
    date = date.year(quarter1From.year());
    if (quarter1From <= date && date <= quarter1To) {
      return 1;
    }
    else if (quarter2From <= date && date <= quarter2To) {
      return 2;
    }
    else if (quarter3From <= date && date <= quarter3To) {
      return 3;
    }
    else if (quarter4From <= date && date <= quarter4To) {
      return 4;
    }
  }

  function getQuarterRange(date) {
    var quarter = getQuarterByDate(date);
    var result = {};
    if (quarter == 1) {
      result = {from: new moment(quarter1From), to: new moment(quarter1To)};
    }
    else if (quarter == 2) {
      result = {from: new moment(quarter2From), to: new moment(quarter2To)};
    }
    else if (quarter == 3) {
      result = {from: new moment(quarter3From), to: new moment(quarter3To)};
    }
    else if (quarter == 4) {
      result = {from: new moment(quarter4From), to: new moment(quarter4To)};
    }
    return result;
  }

  function getQuarterRangeByQuarter(quarter) {
    if (quarter == 1) {
      result = {from: new moment(quarter1From), to: new moment(quarter1To)};
    }
    else if (quarter == 2) {
      result = {from: new moment(quarter2From), to: new moment(quarter2To)};
    }
    else if (quarter == 3) {
      result = {from: new moment(quarter3From), to: new moment(quarter3To)};
    }
    else if (quarter == 4) {
      result = {from: new moment(quarter4From), to: new moment(quarter4To)};
    }
    return result;
  }

  function calculateDraftDueDate(draftDueDate, quarter1, quarter2, quarter3, quarter4) {
    if (draftDueDate) {
      return moment(draftDueDate);
    }

    var currentDate = new Date(),
      q1 = new Date(quarter1),
      q2 = new Date(quarter2),
      q3 = new Date(quarter3),
      q4 = new Date(quarter4);

    q1.setFullYear(currentDate.getFullYear());
    q2.setFullYear(currentDate.getFullYear());
    q3.setFullYear(currentDate.getFullYear());
    q4.setFullYear(currentDate.getFullYear());

    if (q1 > q2) {
      q2.setFullYear(currentDate.getFullYear() + 1);
    }

    if (q2 > q3) {
      q3.setFullYear(currentDate.getFullYear() + 1);
    }

    if (q3 > q4) {
      q4.setFullYear(currentDate.getFullYear() + 1);
    }

    if (currentDate < q1) {
      currentDate = q1;
    } else if (currentDate < q2) {
      currentDate = q2;
    } else if (currentDate < q3) {
      currentDate = q3;
    } else if (currentDate < q4) {
      currentDate = q4;
    } else {
      currentDate = angular.copy(q1).setFullYear(q1.getFullYear() + 1)
    }
    return moment(currentDate);
  }

})();

function AssetModel(asset) {
  var self = this;
  angular.merge(self, asset);

  self.periodData = AssetModel.periodCalculation(self);

  self.getCurrentValuation = function() {
    return self.valuation;
  }
}

(function() {

  Object.defineProperties(AssetModel, {
    periodCalculation: {
      value: periodCalculation
    },
    calculateScheduleDate: {
      value: calculateScheduleDate
    },
    getFirstSchedule: {
      value: getFirstSchedule
    },
    getFirstQuarter: {
      value: getFirstQuarter
    }
  });

  function periodCalculation(asset, dateToCompare) {
    // Arguments can be date objects, UNIX time, or strings in format of MM-DD-YYYY
    var quarter1 = asset.scheduleQ1,
      quarter2 = asset.scheduleQ2,
      quarter3 = asset.scheduleQ3,
      quarter4 = asset.scheduleQ4,
      appraiserAssignedDate = '',
      scheduleOption = asset.scheduleOption ? asset.scheduleOption : 1;

    if (asset.appraiserAddedOn) {
      appraiserAssignedDate = asset.appraiserAddedOn;
    } else if (asset.primaryAssetAppraiser) {
      appraiserAssignedDate = asset.primaryAssetAppraiser.createdOn;
    }

    if(!quarter1 || !quarter2 || !quarter3 || !quarter4 || !appraiserAssignedDate) {
      return {};
    }

    var dateFormat = 'MM-DD-YYYY';
    var now = !dateToCompare ?
      moment() :
      angular.isNumber(dateToCompare) ? moment(dateToCompare) : moment(dateToCompare, dateFormat);

    appraiserAssignedDate = !appraiserAssignedDate ?
      moment() :
      angular.isNumber(appraiserAssignedDate) ? moment(appraiserAssignedDate) : moment(appraiserAssignedDate, dateFormat);

    var y1q1 = angular.isNumber(quarter1) ? moment(quarter1) : moment(quarter1, dateFormat);
    var y1q2 = angular.isNumber(quarter2) ? moment(quarter2) : moment(quarter2, dateFormat);
    var y1q3 = angular.isNumber(quarter3) ? moment(quarter3) : moment(quarter3, dateFormat);
    var y1q4 = angular.isNumber(quarter4) ? moment(quarter4) : moment(quarter4, dateFormat);

    var y2q1 = moment(y1q1).add(1, 'years');
    var y2q2 = moment(y1q2).add(1, 'years');
    var y2q3 = moment(y1q3).add(1, 'years');
    var y2q4 = moment(y1q4).add(1, 'years');

    var y3q1 = moment(y2q1).add(1, 'years');
    var y3q2 = moment(y2q2).add(1, 'years');
    var y3q3 = moment(y2q3).add(1, 'years');
    var y3q4 = moment(y2q4).add(1, 'years');

    var allQuarters = [
      [y1q1, y1q2, y1q3, y1q4],
      [y2q1, y2q2, y2q3, y2q4],
      [y3q1, y3q2, y3q3, y3q4]
    ];

    var minDate = moment(y1q4).add(-1, 'years');
    var maxDate = moment(y3q1).add(1, 'years');

    var quarter, year, type, yearOfCycle, yearFull;
    var quarterOfCycle = 0;
    for (var y = 0; y < 3 && !yearOfCycle; y++) {
      for (var q = 0; q < 4 && !quarter; q++) {
        var currentQuarter = allQuarters[y][q];
        if (now.isAfter(minDate) && now.isBefore(maxDate) && (now.isSame(appraiserAssignedDate) || now.isAfter(appraiserAssignedDate)) && now.isBefore(currentQuarter)) {
          year = parseInt(currentQuarter.format('YY'));
          yearFull = parseInt(currentQuarter.format('YYYY'));
          quarter = q + 1;
          yearOfCycle = y + 1;
        }
        if (appraiserAssignedDate.isBefore(currentQuarter)) {
          ++quarterOfCycle;
        }
      }
    }
    type = quarter == scheduleOption ? 'A' : 'U';

    return {
      quarter: !year ? 'N/A' : quarter,
      year: year,
      yearFull: yearFull,
      type: type,
      yearOfCycle: yearOfCycle,
      quarterOfCycle: quarterOfCycle
    };

  }

  function calculateScheduleDate(date, schedule1, schedule2, schedule3, schedule4) {
    date = moment(date).startOf('day');
    schedule1 = moment(schedule1).startOf('day');
    schedule2 = moment(schedule2).startOf('day');
    schedule3 = moment(schedule3).startOf('day');
    schedule4 = moment(schedule4).startOf('day');

    var found = false;
    while(!found) {
      if(date <= schedule1) {
        found = schedule1;
      }
      else if(date <= schedule2) {
        found = schedule2;
      }
      else if(date <= schedule3) {
        found = schedule3;
      }
      else if(date <= schedule4) {
        found = schedule4;
      }
      else {
        schedule1.add(1, 'year');
        schedule2.add(1, 'year');
        schedule3.add(1, 'year');
        schedule4.add(1, 'year');
      }
    }
    return found;
  }

  function getFirstSchedule(asset){
    var oldestQuarterDate = asset.scheduleQ1;
    if(oldestQuarterDate > asset.scheduleQ2){
      oldestQuarterDate = asset.scheduleQ2;
    }
    if(oldestQuarterDate > asset.scheduleQ3){
      oldestQuarterDate = asset.scheduleQ3;
    }
    if(oldestQuarterDate > asset.scheduleQ4) {
      oldestQuarterDate = asset.scheduleQ3;
    }
    return oldestQuarterDate;
  }

  function getFirstQuarter(asset){
    var quarter = 1;
    var oldestQuarterDate = asset.scheduleQ1;
    if(oldestQuarterDate > asset.scheduleQ2){
      oldestQuarterDate = asset.scheduleQ2;
      quarter = 2;
    }
    if(oldestQuarterDate > asset.scheduleQ3){
      oldestQuarterDate = asset.scheduleQ3;
      quarter = 3;
    }
    if(oldestQuarterDate > asset.scheduleQ4) {
      quarter = 4;
    }
    return quarter;
  }

})();

(function(){

  'use strict';

  angular
  .module('nvc')
  .filter('percentage', percentage);

  function percentage(){
    return function(number){
      if(typeof number === 'number' ||  !isNaN(parseFloat(number))){
        return number + '%';
      }
      return '';
    }
  }
  
})();

(function() {
  'use strict';

  angular
    .module('nvc')
    .filter('increaseDateBy', increaseDateBy);

  /**@ngInject*/
  function increaseDateBy () {
    return function (currentDate, days) {

      if(!days) {
        days = 0;
      }

      if(currentDate) {
        var newDate = moment(currentDate).add(days, 'days').utc();
        return newDate._d;
      }
    };

  }

})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .filter('formatDate',formatDate);

  /** @ngInject */
  function formatDate() {
    return function(date, format) {
      return moment(date).format(format);
    }
  }

})();
(function () {
  'use strict';

  angular
  .module('nvc')
  .filter('cycle', cycle);

  /** @ngInject */
  function cycle() {
    return function(asset) {
      if(!asset || !asset.valuation){
        return 'N/A';
      }
      return asset.scheduleOption === asset.valuation.quarter ? 'Annual' : 'Quarterly'
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .filter('totalFeeCheckmark', totalFeeCheckmark);

  /** @ngInject */
  function totalFeeCheckmark() {
    return function (totalFee, bidResp) {
      if (bidResp.isSelectedFee) {
        return '\u2714 ' + totalFee;
      }
      return totalFee;
    }
  }

})();
(function () {
  'use strict';

  angular
    .module('nvc')
    .filter('discountCheckmark', discountCheckmark);

  /** @ngInject */
  function discountCheckmark() {
    return function (discount, bidResp) {
      if (bidResp.isSelectedDiscount) {
        return '\u2714 ' + discount;
      }
      return discount;
    }
  }

})();
(function () {
  'use strict';

  angular
    .module('nvc')
    .filter('bidRequestStatus', bidRequestStatus);

  /** @ngInject */
  function bidRequestStatus($filter) {
    return function (RFP) {
      switch (RFP.status) {

        case 'Awarded':
          return $filter('translate')('ALL_REQUESTS.AWARDED') + ' (' + RFP.statusCounters.assetsAwarded + ' of ' + RFP.assets.length + ')';

        case 'Responded':
          return $filter('translate')('ALL_REQUESTS.RESPONDED') + ' (' + RFP.statusCounters.assetsResponded + ' of ' + RFP.assets.length + ')';

        case 'NotAwarded':
          return $filter('translate')('ALL_REQUESTS.NOT_AWARDED') + ' (' + 0 + ' of ' + RFP.assets.length + ')';

        case 'NeedsResponse':
          return $filter('translate')('ALL_REQUESTS.NEEDS_RESPONSE');

        default:
          return '';
      }
    }
  }

})();
(function () {
  'use strict';

  angular
    .module('nvc')
    .filter('ampToAnd', ampToAnd);

  /** @ngInject */
  function ampToAnd() {
    return function (proto) {
      return proto.replace(/&amp;/g, ' and ');
    }
  }

})();
(function () {
  'use strict';

  angular
  .module('nvc')
  .filter('camelCaseToHuman',formatDate);

  /** @ngInject */
  function formatDate() {
    return function(input) {
      if (typeof input !== "string") {
        return input;
      }

      return input.replace(/([A-Z])/g, ' $1');
    }
  }

})();
(function () {
  'use strict';

  angular
    .module('nvc')
    .filter('stringToBoolean', stringToBoolean);

  /**@ngInject*/
  function stringToBoolean() {
    return function (stringDictionary, boolean) {
      return stringDictionary[boolean];
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .filter('booleanToString', booleanToString);

  /**@ngInject*/
  function booleanToString() {
    return function (boolean, stringDictionary) {
      return boolean ? stringDictionary.true : stringDictionary.false;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('nvc')
    .filter('initials', initials);

  /**@ngInject*/
  function initials () {
    return function (name) {
      name = name || '';
      return name.split(' ').map(function (s) { 
        return s.charAt(0).toUpperCase(); }).slice(0, 2).join('');
    }
  }
})();
(function () {
  'use strict';

  angular
    .module('nvc')
    .directive('version', version);

  /** @ngInject */
  function version(VERSION, $filter) {
    return (function () {
      var counter = 1;
      return {
        restrict: 'A',
        scope: {
          clicks: '='
        },
        link: function (scope, element, attr, ctrl) {
          element.bind('click', function (evt) {
            if (counter == scope.clicks) {
              alert($filter('translate')('COMMONS.SYSTEM_VERSION') + ': ' + VERSION);
              counter = 1;
            }
            else {
              counter++;
            }
          });
        }
      }
    })();
  }

})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .directive('tdSecurity', tdSecurity);

  /**@ngInject*/
  function tdSecurity(SessionManager) {
    return {
      restrict: 'A',
      priority: 1,
      scope: {
        tdSecurity: '=',
        action: '@'
      },
      require: '?ngModel',
      link: function (scope, element, attr, ctrl) {
        var disable = 'disable',
          none = 'display-none',
          hidden = 'hidden';
        if (!SessionManager.isInAnyRole(scope.tdSecurity)) {
          modify();
        }

        function modify() {
          if (element.attr('required') || element.attr('ng-required')) {
            attr.required = false;
            attr.ngRequired = false;
            ctrl.$validators.required = function(modelValue, viewValue) {
              return !attr.required || !ctrl.$isEmpty(viewValue);
            };
          }
          switch (scope.action) {
            case disable:
              element.attr('disabled', '');
              break;
            case none:
              element.addClass('td-security-display-none');
              break;
            case hidden:
            default:
              element.addClass('td-security-hidden');
          }
        }
      }
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .directive('tdMonthRangeValidation', tdMonthRangeValidation);

  /**@ngInject*/
  function tdMonthRangeValidation() {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function (scope, element, attr, ngModel) {

        ngModel.$validators.tdMonthRangeValidation = function(modelValue, viewValue) {
          if(viewValue == '') {
            return true;
          }

          var dateFrom = attr.dateFrom,
            dateTo = attr.dateTo,
            ignoreYear = attr.ignoreYear,
            dateFormat = attr.dateFormat || "YYYY-MM-DD",
            ignoreYear = attr.ignoreYear !== undefined || false;

          var date = moment(viewValue, dateFormat),
            dateFrom = moment(dateFrom, dateFormat),
            dateTo = moment(dateTo, dateFormat);

          if(!date.isValid() || !dateFrom.isValid() || !dateTo.isValid()) {
            return false;
          }

          if(ignoreYear) {
            dateFrom.year(date.year());
            dateTo.year(date.year());
          }

          // TODO: upgrade moment > 2.13 to use isBetween inclusive
          if(dateFrom <= date && date <= dateTo) {
            return true;
          }

          return false;
        }
      }
    };
  }

})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .directive('tdImageUpload', TDImageUpload);

  /**@ngInject*/
  function TDImageUpload($uibModal, $timeout, $q, $translate) {
    /**
     * croppedPhotoData: this will be filled with the cropped photo file data (base64)
     * You can use file-types and max-file-size-mb attributes as well
     */
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'app/components/directives/td-image-upload/td-image-upload.html',
      scope: {
        croppedPhotoData: '=?croppedPhotoData',
        validTypes: '=?',
        maxBytesSize: '=?'
      },
      link: function (scope, element, attrs) {
        scope.selectedPhotoName = '';
        scope.selectedPhotoFile = {},
          scope.selectedPhotoData = '',
          scope.croppedPhotoData = scope.croppedPhotoData || '/assets/images/dragBg.png',
          scope.validTypes = scope.validTypes || ['image/png', 'image/jpeg', 'image/gif'],
          scope.maxBytesSize = scope.maxBytesSize || 10485760,
          scope.errors = [];

        scope.openCropDlg = function () {
          var modalInstance = $uibModal.open({
            templateUrl: '/app/components/directives/td-image-upload/crop-image-modal/crop-image-modal.html',
            controller: 'CropImageModalController',
            controllerAs: 'cropImageModal',
            resolve: {
              selectedPhoto: function () {
                return $q(function (resolve) {
                  $timeout(function () {
                    resolve(scope.selectedPhotoData);
                  });
                })
              }
            }
          });
          modalInstance.result.then(function (data) {
            scope.croppedPhotoData = data;
            element.removeClass('invalid');
          }, function () {
            fileInput[0].value = null;
          });
        };

        var fileInput = element.find('input[type=file]');
        var form = element.closest('form');

        function uiShowDropzone(event) {
          if (event != null) {
            event.preventDefault();
          }
          element.find('.dropzone').addClass('display');
          return false;
        }

        function processDragEnter(event) {
          if (event != null) {
            event.preventDefault();
          }
          element.addClass('dropping');
          return false;
        }

        function processDragLeave(event) {
          if (event != null) {
            event.preventDefault();
          }
          element.removeClass('dropping');
          return false;
        }

        function processDragOver(event) {
          if (event != null) {
            event.preventDefault();
          }
          if (!event.originalEvent) {
            // Phantom compatibility
            event.dataTransfer.dropEffect = "copy";
          } else {
            // Chrome
            event.originalEvent.dataTransfer.dropEffect = "copy";
          }

          return false;
        }

        function processDrop(event) {
          element.removeClass('dropping');
          element.find('.dropzone').removeClass('display');
          if (event != null) {
            event.preventDefault();
          }
          var files = [];
          if (!event.originalEvent) {
            // Phantom compatibility
            files = event.dataTransfer.files;
          } else {
            // Chrome
            files = event.originalEvent.dataTransfer.files;
          }
          handleFileSelect(files[0]);
          return false;
        }

        function checkSize(name, size) {
          if (scope.maxBytesSize === (void 0) || scope.maxBytesSize === '' || size < scope.maxBytesSize) {
            return true;
          } else {
            var error = $translate.instant('TD_IMAGE_UPLOAD.INVALID_SIZE', { fileName: name });
            scope.errors.push(error);
            return false;
          }
        }

        function isTypeValid(name, type) {
          if (scope.validTypes === (void 0) || scope.validTypes === '' || scope.validTypes.indexOf(type) > -1) {
            return true;
          } else {
            var error = $translate.instant('TD_IMAGE_UPLOAD.INVALID_TYPE', { fileName: name });
            scope.errors.push(error);
            return false;
          }
        }

        function handleFileSelect(file) {
          var reader = new FileReader();
          reader.onload = function (evt) {
            scope.errors = [];
            if (checkSize(file.name, file.size) && isTypeValid(file.name, file.type)) {
              scope.$apply(function () {
                scope.selectedPhotoData = evt.target.result;
                if (angular.isString(scope.selectedPhotoName)) {
                  scope.selectedPhotoName = file.name;
                }
                if (angular.isFunction(scope.openCropDlg)) {
                  scope.openCropDlg(scope.selectedPhotoData);
                }
              });
            }
            else {
              if (scope.errors.length != 0) {
                element.addClass('invalid');
                scope.croppedPhotoData = '/assets/images/ic_ErrorFile.png';
              }
              scope.$apply();
            }
          };
          reader.readAsDataURL(file);
        }

        element.on('dragenter', uiShowDropzone);
        element.on('dragenter', processDragEnter);
        element.on('dragleave', processDragLeave);
        element.on('dragover', processDragOver);
        element.on('drop', processDrop);
        // Necessaru since browser didn't popup the crop modal when choosing the same file.
        // NOTE: same file means same filename so it wouldn't trigger `change` event.
        fileInput.bind('click', function (event) {
          this.value = null;
        });
        fileInput.bind("change", function (event) {
          if (event != null) {
            event.preventDefault();
          }
          handleFileSelect(event.currentTarget.files[0]);
          return false;
        });
      }
    };
  }

})();
(function () {
  'use strict';

  angular
    .module('nvc')
    .directive('tdFileUpload', TDFileUpload);

  /**@ngInject*/
  function TDFileUpload($translate) {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'app/components/directives/td-file-upload/td-file-upload.html',
      scope: {
        files: '=',
        filesToUpload: '=',
        filesToDelete: '=?',
        onDelete: '=?',
        onDrop: '=?',
        validTypes: '=?',
        maxBytesSize: '=?',
        maxNumberFiles: '=?',
        premiseoptions: '=?',
        selectedpremiseoptions: '=?',
        reset: '=?'
      },
      link: function (scope, element, attrs) {
        scope.files = scope.files || [],
          scope.onDelete = scope.onDelete || function () { },
          scope.onDrop = scope.onDrop || function () { },
          scope.validTypes = scope.validTypes,
          scope.maxBytesSize = scope.maxBytesSize || 26214400,
          scope.errors = [],
          scope.filesToUpload = [],
          scope.filesToDelete = [],
          scope.premiseoptions = scope.premiseoptions || [],
          scope.selectedpremiseoptions =[],
          scope.maxNumberFiles = parseInt(scope.maxNumberFiles || 999);

        scope.files.splice(scope.maxNumberFiles);

        function uiShowDropzone(event) {
          if (event != null) {
            event.preventDefault();
          }
          element.find('.dropzone').addClass('display');
          return false;
        }

        function uiProcessDragEnter(event) {
          if (event != null) {
            event.preventDefault();
          }
          element.addClass('dropping');
          return false;
        }

        function uiProcessDragLeave(event) {
          if (event != null) {
            event.preventDefault();
          }
          element.removeClass('dropping');
          return false;
        }

        function uiProcessDragOver(event) {
          if (event != null) {
            event.preventDefault();
          }
          return false;
        }

        function uiProcessDrop(event) {
          element.removeClass('dropping');
          element.find('.dropzone').removeClass('display');
          if (event != null) {
            event.preventDefault();
          }
          var files = [];
          if (!event.originalEvent) {
            // Phantom compatibility
            files = event.dataTransfer.files;
          } else {
            // Chrome
            files = event.originalEvent.dataTransfer.files;
          }
          scope.onDrop(scope.files, files);
          createFiles(files);
          if (scope.files.length != 0 || scope.errors.length != 0) {
            element.addClass('dirty');
          }
          event.target.value = '';
          scope.$apply();
          return false;
        }

        scope.uiDelete = function (index) {
          deleteFile(index);
          scope.onDelete(scope.files, index);
          if (scope.files.length == 0 && scope.errors.length == 0) {
            element.removeClass('dirty');
          }
          return false;
        };

        scope.premiseselection = function(index, selectedpremiseoption) {
          var fileName = scope.filesToUpload[index].name;
          var found = false;
          for (var i = 0; i < scope.selectedpremiseoptions.length; i++) {
            if (scope.selectedpremiseoptions[i].fileName === fileName) {
              scope.selectedpremiseoptions[i].selectedpremiseoption = selectedpremiseoption.value;
              found = true;
              break;
            }
          }
          if (!found) {
            scope.selectedpremiseoptions.push({"fileName" : fileName, "selectedpremiseoption": selectedpremiseoption.value});
          }
        }

        scope.uiDeleteError = function (index) {
          scope.errors.splice(index, 1);
          if (scope.files.length === 0 && scope.errors.length === 0) {
            element.removeClass('dirty');
          }
          return false;
        };

        function uiInputChaged(event) {
          if (event != null) {
            event.preventDefault();
          }
          scope.onDrop(scope.files, event.target.files);
          createFiles(event.target.files);
          event.target.value = '';
          if (scope.files.length != 0 || scope.errors.length != 0) {
            element.addClass('dirty');
          }
          scope.$apply();
          return false;
        }

        function validate(files) {
          scope.errors = [];
          for (var i = files.length - 1; i >= 0; i--) {
            var file = files[i];
            if (!checkSize(file.size)) {
              files.splice(i, 1);
              var error = $translate.instant('TD_FILE_UPLOAD.INVALID_SIZE', {fileName: file.name});
              scope.errors.push(error);
            } else if (!isTypeValid(file.name, file.type)) {
              files.splice(i, 1);
              var error = $translate.instant('TD_FILE_UPLOAD.INVALID_TYPE', {fileName: file.name});
              scope.errors.push(error);
            }
          }
          return files;
        }

        function checkSize(size) {
          if (scope.maxBytesSize === (void 0) || scope.maxBytesSize === '' || size < scope.maxBytesSize) {
            return true;
          }
          return false;
        }

        function isTypeValid(name, type) {
          var valid = false;

          if (type) {
            if (scope.validTypes === (void 0) || scope.validTypes === '' || scope.validTypes.indexOf(type) > -1) {
              return true;
            }
          }

          var extension = name.match(/\.[0-9a-z]{1,5}$/i);
          if (extension) {
            if (scope.validTypes === (void 0) || scope.validTypes === '' || scope.validTypes.indexOf(extension[0]) > -1) {
              return true;
            }
          }

          return valid;
        }

        function createFiles(files) {
          var newFiles = [];
          angular.forEach(files, function (file) {
            newFiles.push(file)
          });
          newFiles = validate(newFiles);
          newFiles.forEach(function (file) {
            // FIFO Queue logic
            if (scope.files.length == scope.maxNumberFiles) {
              deleteFile(0);
            }
            if (scope.files.length <= scope.maxNumberFiles) {
              scope.filesToUpload.push(file);
              scope.files.push(file);
            }
          });
        }

        function deleteFile(index) {
          var file = scope.files[index];
          if (!(scope.files[index] instanceof File) && !(scope.files[index] instanceof Blob)) {
            scope.filesToDelete.push(file);
          } else {
            scope.filesToUpload.splice(scope.filesToUpload.indexOf(file), 1);
          }
          scope.files.splice(index, 1);
        }

        element.on('dragenter', uiShowDropzone);
        element.find('.dropzone').on('dragenter', uiProcessDragEnter);
        element.find('.dropzone').on('dragleave', uiProcessDragLeave);
        element.find('.dropzone').on('dragover', uiProcessDragOver);
        element.find('.dropzone').on('drop', uiProcessDrop);

        var fileInput = element.find('input[type=file]');
        fileInput.get(0).addEventListener('change', uiInputChaged);

        if (scope.files.length != 0) {
          element.addClass('dirty');
        }

        var resetInput = scope.$watch('reset', function(){
          if(scope.reset){
            if(scope.files.length == 0){
              element.removeClass('dirty');
            }else{
              element.addClass('dirty');
            }
            scope.reset = false;
          }
        });

        scope.$on('$destroy', function () {
          resetInput();
        });
      }
    };

  }

})();
(function () {
  'use strict';

  angular
    .module('nvc')
    .directive('fileRead', fileRead);

  /** @ngInject */
  function fileRead() {
    return {
      scope: {
        fileRead: '&'
      },
      link: function (scope, element) {
        $(element)[0].addEventListener("change", function (changeEvent) {
          if(changeEvent.target.files && changeEvent.target.files.length > 1) {
            scope.fileRead()(changeEvent.target.files);
          } else {
            scope.fileRead()([changeEvent.target.files[0]]);
          }
        });
      }
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .directive('sliderRange', sliderRange);

  /**@ngInject*/
  function sliderRange($document) {
    // Move slider handle and range line
    var moveHandle = function (handle, elem, posX) {
      $(elem).find('.handle.' + handle).css("left", posX + '%');
    };
    var moveRange = function (elem, posMin, posMax) {
      $(elem).find('.range').css("left", posMin + '%');
      $(elem).find('.range').css("width", posMax - posMin + '%');
    };
    function setZIndex(container, type) {
      if (['min', 'max'].indexOf(type) === -1) return;
      if (type === 'min') {
        $(container).find('.handle.min').css('z-index', 3);
        $(container).find('.handle.max').css('z-index', 2);
      }
      else if (type === 'max') {
        $(container).find('.handle.min').css('z-index', 2);
        $(container).find('.handle.max').css('z-index', 3);
      }
    }

    return {
      template: '<div class="slider-wp">' +
      '<div class="values-wp">' +
      '<span class="min-value">{{unit}} {{valueMin | number}}</span>' +
      '<span class="max-value">{{unit}} {{valueMax  | number}}</span>' +
      '</div>' +
      '<div class="slider horizontal">' +
      '<div class="slider-wp">' +
      '<div class="range"></div>' +
      '<a class="handle min" ng-mousedown="mouseDownMin($event)"></a>' +
      '<a class="handle max" ng-mousedown="mouseDownMax($event)"></a>' +
      '</div>' +
      '</div>' +
      '</div>',
      replace: true,
      restrict: 'E',
      scope: {
        valueMin: "=",
        valueMax: "=",
        unit: "="
      },
      link: function postLink(scope, element, attrs) {
        // Initilization
        var dragging = false;
        var startPointXMin = 0;
        var startPointXMax = 0;
        var xPosMin = 0;
        var xPosMax = 0;
        var settings = {
          "min": (typeof (attrs.min) !== "undefined" ? parseInt(attrs.min, 10) : 0),
          "max": (typeof (attrs.max) !== "undefined" ? parseInt(attrs.max, 10) : 100),
          "step": (typeof (attrs.step) !== "undefined" ? parseInt(attrs.step, 10) : 1)
        };
        if (typeof (scope.valueMin) == "undefined" || scope.valueMin === '')
          scope.valueMin = settings.min;

        if (typeof (scope.valueMax) == "undefined" || scope.valueMax === '')
          scope.valueMax = settings.max;

        scope.unit = attrs.unit;

        // Track changes only from the outside of the directive
        scope.$watch('valueMin', function () {
          if (dragging) return;
          xPosMin = (scope.valueMin - settings.min) / (settings.max - settings.min) * 100;
          if (xPosMin < 0) {
            xPosMin = 0;
          } else if (xPosMin > 100 || isNaN(xPosMin)) {
            xPosMin = 100;
          }
          moveHandle("min", element, xPosMin);
          moveRange(element, xPosMin, xPosMax);
        });

        scope.$watch('valueMax', function () {
          if (dragging) return;
          xPosMax = (scope.valueMax - settings.min) / (settings.max - settings.min) * 100;
          if (xPosMax < 0) {
            xPosMax = 0;
          } else if (xPosMax > 100 || isNaN(xPosMax)) {
            xPosMax = 100;
          }
          moveHandle("max", element, xPosMax);
          moveRange(element, xPosMin, xPosMax);
        });

        // Real action control is here
        scope.mouseDownMin = function ($event) {
          dragging = true;
          startPointXMin = $event.pageX;

          // Bind to full document, to make move easiery (not to lose focus on y axis)
          $document.on('mousemove', function ($event) {
            if (!dragging) return;

            //Calculate handle position
            var moveDelta = $event.pageX - startPointXMin;

            xPosMin = xPosMin + ((moveDelta / element.outerWidth()) * 100);
            if (xPosMin < 0) {
              xPosMin = 0;
            } else if (xPosMin > xPosMax) {
              xPosMin = xPosMax;
            } else {
              // Prevent generating "lag" if moving outside window
              startPointXMin = $event.pageX;
            }
            scope.valueMin = Math.round((((settings.max - settings.min) * (xPosMin / 100)) + settings.min) / settings.step) * settings.step;
            scope.$apply();

            // Move the Handle
            moveHandle("min", element, xPosMin);
            moveRange(element, xPosMin, xPosMax);
            setZIndex(element, 'min');
          });
          $document.mouseup(function () {
            dragging = false;
            $document.unbind('mousemove');
            $document.unbind('mousemove');
          });
        };

        scope.mouseDownMax = function ($event) {
          dragging = true;
          startPointXMax = $event.pageX;

          // Bind to full document, to make move easiery (not to lose focus on y axis)
          $document.on('mousemove', function ($event) {
            if (!dragging) return;

            //Calculate handle position
            var moveDelta = $event.pageX - startPointXMax;

            xPosMax = xPosMax + ((moveDelta / element.outerWidth()) * 100);
            if (xPosMax > 100) {
              xPosMax = 100;
            } else if (xPosMax < xPosMin) {
              xPosMax = xPosMin;
            } else {
              // Prevent generating "lag" if moving outside window
              startPointXMax = $event.pageX;
            }
            scope.valueMax = Math.round((((settings.max - settings.min) * (xPosMax / 100)) + settings.min) / settings.step) * settings.step;
            scope.$apply();

            // Move the Handle
            moveHandle("max", element, xPosMax);
            moveRange(element, xPosMin, xPosMax);
            setZIndex(element, 'max');
          });

          $document.mouseup(function () {
            dragging = false;
            $document.unbind('mousemove');
            $document.unbind('mousemove');
          });
        };
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .directive('percentageValues', percentageValues);

  /** @ngInject */
  function percentageValues($filter) {
    return {
      restrict: 'A',
      require: '?ngModel',
      link: function (scope, element, attr, ctrl) {
        if (!ctrl) return;

        if(attr.percentageOptions){
          var options = angular.fromJson(attr.percentageOptions);
          var negatives = options.negatives || false,
            nullable = options.nullable || false,
            integer = options.integer || false;
        }

        ctrl.$formatters.unshift(function (a) {
          if (isNaN(a) || !a) return a;
          var prevValue;
          prevValue = parseFloat(a.replace(/[!,]/g, ''));
          if(!negatives) {
            prevValue = prevValue < 0 ? prevValue * -1 : prevValue;
          }
          return $filter(attr.format)(prevValue.toFixed(2));
        });

        element.bind('blur', function () {
          var plainNumber;
          if(element.val() == 'N/A') return;
          plainNumber = parseFloat(element.val().replace(/[!%,]/g, '')).toFixed(2);
          if (!negatives) {
            plainNumber = plainNumber < 0 ? (parseFloat(plainNumber) * -1).toFixed(2).toString() : (plainNumber).toString();
          }
          if (!plainNumber || isNaN(plainNumber)) {
            if (nullable) {
              ctrl.$setViewValue(undefined);
              element.val("N/A");
            } else {
              element.val("");
            }
          } if(integer) {
            plainNumber = parseInt(plainNumber);
            element.val($filter(attr.format)(plainNumber));
            ctrl.$setViewValue(plainNumber)
          } else {
            element.val($filter(attr.format)(plainNumber));
            ctrl.$setViewValue(plainNumber)
          }
        });

        element.on('focus', function () {
          if(element.val() == 'N/A' && nullable) {
            element.val("");
          }
        });
      }

    }
  }
  
})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .directive('nvcLatestAction', NvcLatestAction);

  function NvcLatestAction() {
    return {
      templateUrl: 'app/components/directives/nvc-latest-action/nvc-latest-action.html',
      restrict: 'A',
      replace: false,
      controller: latestActionCtrl,
      controllerAs: 'latestActionCtrl',
      scope: {
        review: '=',
        statusName: '=?status',
        statusDescription: '=?description'
      }
    };

    /**@ngInject*/
    function latestActionCtrl($scope, ReviewStatusHelper) {
      var vm = this;
      var review = $scope.review;
      $scope.$watch('review', function () {
        var status = ReviewStatusHelper.getLatestAction($scope.statusDescription, review);
        vm.overdue = false;
        vm.completed = false;
        vm.latestAction = status;
        if ($scope.statusDescription) {
          if ($scope.statusDescription.indexOf('Days Overdue') != -1) {
            vm.overdue = true;
          } else if ($scope.statusDescription == 'Completed') {
            vm.completed = true;
          }
        } else if (review instanceof ReviewModel && review.status) {
          var currentDate = moment();
          var diff = currentDate.diff(review.nextDraftDueDate, 'days');
          if (diff > 0 && (review.status == 'Created' || review.status == 'DocumentsUploaded')) {
            vm.overdue = true;
            $scope.review.overdue = true;
          } else if (review.status == 'Finished') {
            vm.completed = true;
            $scope.review.completed = true;
          }
        }
        $scope.statusName = vm.latestAction;
      }, true);
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .directive('nvcCurrentAction', NvcCurrentAction);

  function NvcCurrentAction() {
    return {
      templateUrl: 'app/components/directives/nvc-current-action/nvc-current-action.html',
      restrict: 'A',
      replace: false,
      controller: currentActionCtrl,
      controllerAs: 'currentActionCtrl',
      scope: {
        review: '=',
        highlightMine: '=',
        nextName: '=?name'
      }
    };

    /**@ngInject*/
    function currentActionCtrl($scope, RoleFactory, SessionManager) {
      var vm = this;
      var review = $scope.review;
      if(review instanceof ReviewModel) {
        var primaryUser = review.getPrimaryUserByAction(review.getCurrentAction(), SessionManager.getRoleName());
        if (primaryUser && primaryUser.type) {
          vm.name = primaryUser.user.name;
          $scope.nextName = vm.name;
          vm.avatarClass = 'avatar-' + RoleFactory.htmlClass(primaryUser.type);
          if($scope.highlightMine &&
            RoleFactory.valuationRoleToCompanyRole(primaryUser.type) === SessionManager.getRoleName() &&
            primaryUser.user.id === SessionManager.getUser().id){
            vm.avatarClass += ' highlight'
          }
        }
      }
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .directive('avatar', avatar);
  /**
   *
   * allows roles as in company or as in the role within the asset
   */
  /** @ngInject */
  function avatar(SessionManager, AssetRoleToUserRole) {
    return {
      templateUrl: 'app/components/directives/nvc-avatar/avatar.html',
      restrict: 'A',
      replace: false,
      controller: AvatarDirectiveCtrl,
      controllerAs: 'avatarDirectiveCtrl',
      scope: {
        name: '=avatar',
        role: '='
      },
      link: function(scope, element){
        var currentRole = SessionManager.getRoleName();
        var visibilityRules = {
          Admin: ['Administrator', 'Admin', 'Audit', 'AssetManagement', 'AssetAppraisal', 'AssetReview'],
          Audit: ['Administrator', 'Admin', 'Audit', 'AssetManagement', 'AssetAppraisal', 'AssetReview'],
          AssetManagement: ['Administrator', 'Admin', 'Audit', 'AssetManagement', 'AssetReview'],
          AssetManagerReadOnly: ['Administrator', 'Admin', 'Audit', 'AssetManagement', 'AssetReview'],
          AssetAppraisal: ['AssetAppraisal'],
          AssetReview: ['Administrator', 'Admin', 'Audit', 'AssetManagement', 'AssetAppraisal', 'AssetReview']
        };
        if(visibilityRules[currentRole].indexOf(AssetRoleToUserRole[scope.role]) === -1){
          element.find('div').addClass('avatar-generic');
          element.find('div').find('span').remove();
        }
      }
    };

    /**@ngInject*/
    function AvatarDirectiveCtrl($scope, RoleFactory) {
      var vm = this;
      vm.name = $scope.name;
      vm.avatarClass = 'avatar-' + RoleFactory.htmlClass($scope.role);
    }

  }
  
})();

(function() {
  'use strict';

  angular
    .module('nvc')
    .value('duScrollBottomSpy', true)
    .directive('lateralBar', lateralBar);

  /**@ngInject*/
  function lateralBar ($templateRequest, $compile, $controller, $rootScope, $timeout) {
    /**
     * config: an object containing templateUrl<string>, icons<[{class<string>, anchor<string>}]> and locals<object> to be bind to the template
     * show: boolean or object if evaluate to true the lateral bar will be shown
     * onClose: function to be called when the 'X' is clicked
     * contentSelector: jquery selector of the object to be shrink
     */
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'app/components/directives/lateral-bar/lateral-bar.html',
      scope: {
        config: '=',
        show: '=',
        onClose: '=',
        contentSelector: '='
      },
      controller: LateralBarController,
      controllerAs: 'lateral',
      link: function (scope, element) {

        var objectList = angular.element(scope.contentSelector);

        scope.$watch('show',function(){
          if (scope.show && (!(typeof scope.show == 'object')|| Object.keys(scope.show).length > 0)) {
            element.animate({ right: 0 }, 200);
            objectList.animate({ width: "66.6667%" },200);
          }else{
            element.animate({ right: "-33.3333%" }, 200);
            objectList.animate({width: "100%"},200);
          }
        });

        scope.$watch('config', function () {
          scope.icons = [];
          $timeout(function(){
            scope.icons = scope.config.icons;
          });
          if(scope.show){
            $templateRequest(scope.config.templateUrl).then(function(template){
              if(scope.childScope){
                scope.cleanChild();
              }
              var locals = angular.copy(scope.config.locals);
              if(locals){
                locals.$scope = $rootScope.$new();
              }else{
                locals = {$scope: $rootScope.$new()};
              }
              scope.childScope = locals.$scope;
              var ctrl = $controller(scope.config.controller, locals);
              var content = element.find('.lateral-container');
              content.html(template);
              $compile(content)(locals.$scope, undefined, {transcludeControllers: ctrl});
            });
          }
        }, true);
      }
    };

    function LateralBarController ($scope){
      $scope.close = function(){
        $scope.onClose();
        $scope.cleanChild();
      };

      $scope.cleanChild = function(){
        $scope.childScope.$destroy();
        delete $scope.childScope;
      };
    }
  }

})();
(function () {
  'use strict';

  angular
    .module('nvc')
    .directive('decimalValues', decimalValues);

  /** @ngInject */
  function decimalValues($filter) {
    return {
      restrict: 'A',
      require: '?ngModel',
      link: function (scope, element, attr, ctrl) {
        if (!ctrl) return;
        var previousValue = null;

        if(attr.decimalOptions){
          var options = angular.fromJson(attr.decimalOptions);
          var decimals = options.decimals || 3,
            negatives = options.negatives || false,
            clearValue = options.cleanable || false,
            nullable = options.nullable || false;
        }

        ctrl.$formatters.unshift(function (a) {
          if (isNaN(a) || !a) return a;
          var prevValue;
          if (negatives) {
            prevValue = a.replace(/[^\d|\-+|\.+]/g, '');
          } else {
            prevValue = Math.abs(a.replace(/[^\d|\-+|\.+]/g, ''));
          }
            return $filter(attr.format)(prevValue);

        });

        element.bind('blur', function () {
          var plainNumber;
          if(element.val() == 'N/A') return;
          if (negatives) {
            plainNumber = parseFloat(element.val().replace(/[^\d|\-+|\.+]/g, '')).toFixed(decimals);
          } else {
            plainNumber = Math.abs(parseFloat(element.val().replace(/[^\d|\-+|\.+]/g, '')).toFixed(decimals));
          }
          if (!plainNumber || isNaN(plainNumber)) {
            if(clearValue) {
              ctrl.$setViewValue(0);
              element.val("0");
            } else if (nullable) {
              if (previousValue == '0') {
                element.val("0");
              } else {
                element.val("N/A");
              }
            } else {
              element.val(0);
            }
          } else {
            element.val($filter(attr.format)(plainNumber));
            ctrl.$setViewValue(plainNumber);
          }
        });

        element.on('focus', function () {
          if((element.val() == '0' || element.val() == 'N/A') && (clearValue || nullable)) {
            previousValue = element.val();
            element.val("");
          }
        });

        ctrl.$parsers.unshift(function () {
          return element.val().replace(/[^\d|\-+|\.+]/g, '');
        });
      }

    }
  }

})();

(function() {
  'use strict';

  angular
    .module('nvc')
    .directive('confirmLeave', confirmLeave);

  /** @ngInject */
  function confirmLeave() {
    return {
      restrict: 'A',
      scope: {
        name: '=',
        extraCheck:'=?'
      },
      controller: ConfirmLeaveController
    };

    /** @ngInject */
      function ConfirmLeaveController($scope, $filter, $state, SweetAlert, $window, LoaderHelper) {

      var isconfirmed = false;

      $window.onbeforeunload = function(event) {
        var event = event || $window.event;

        if(event && $scope.name.$dirty) {
          return event.returnValue = 'Are you sure you want to leave this form?';
        }
        else {
          return null;
        }
      };

      var stateAlert = $scope.$on('$stateChangeStart', function(event, toState) {
        if((($scope.extraCheck && !$scope.name.$submitted)|| (($scope.name.$dirty && !$scope.name.$submitted) || $scope.name.$dirty && $scope.name.$submitted && $scope.name.$invalid)) && !isconfirmed) {
          event.preventDefault();
          SweetAlert.swal({
            title: $filter('translate')('COMMONS.LEAVE_PAGE_MODAL_TITLE'),
            text: $filter('translate')('COMMONS.LEAVE_PAGE_MODAL_TEXT'),
            showCancelButton: true,
            cancelButtonText: $filter('translate')('COMMONS.LEAVE_PAGE_CONFIRM_BUTTON'),
            confirmButtonColor: '#2c3d4e',
            confirmButtonText: $filter('translate')('COMMONS.LEAVE_PAGE_CANCEL_BUTTON'),
            closeOnConfirm: true,
            closeOnCancel: true
            },
            function (isConfirm) {
              if (!isConfirm) {
                isconfirmed = true;
                $state.go(toState.name, {}, {reload: true});
              }
              else {
                LoaderHelper.close();
              }
            }
          );
        }
      });

      $scope.$on('$destroy', function() {
        stateAlert();
        $window.onbeforeunload = null;
      });
    }

  }

})();

(function () {

  angular
  .module('nvc')
  .directive('formatDate', formatDate);

  function formatDate() {
    return {
      require: '?ngModel',
      restrict: 'A',
      link: function (scope, element, attr, ngModel) {
        var dateField = element.on('change', function () {
          element.attr("data-date", moment(element.val(), "YYYY-MM-DD").format(attr.dateFormat))
        });
        var dateModel = scope.$watch(ngModel, function(){
          var val = element.val();
          if(val){
            element.attr("data-date", moment(element.val(), "YYYY-MM-DD").format(attr.dateFormat));
          }else{
            element.removeAttr("data-date");
          }
        });

        scope.$on('destroy', function(){
          dateField();
          dateModel();
        });
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .directive('currencyValues', currencyValues);

  /** @ngInject */
  function currencyValues($filter) {
    return {
      restrict: 'A',
      require: '?ngModel',
      link: function (scope, element, attr, ctrl) {
        if (!ctrl) return;
        var previousValue = null;

        if(attr.currencyOptions){
          var options = angular.fromJson(attr.currencyOptions);
          var decimals = options.decimals || false,
            negatives = options.negatives || false,
            clearValue = options.cleanable || false,
            nullable = options.nullable || false;
        }

        ctrl.$formatters.unshift(function (a) {
          if (isNaN(a) || !a) return a;
          var prevValue;
          if (decimals) {
            if (negatives) {
              prevValue = a.replace(/[^\d|\-+|\.+]/g, '');
            } else {
              prevValue = Math.abs(a.replace(/[^\d|\-+|\.+]/g, ''));
            }
            return $filter(attr.format)(prevValue);
          } else {
            if (negatives) {
              prevValue = a.split('.')[0].replace(/[^\d|\-+]/g, '');
            } else {
              prevValue = Math.abs(a.split('.')[0].replace(/[^\d|\-+]/g, ''));
            }

            return $filter(attr.format)(prevValue, undefined, 0);
          }
        });

        element.bind('blur', function () {
          var plainNumber;
          if(element.val() == 'N/A') return;
          if (decimals) {
            if (negatives) {
              plainNumber = parseFloat(element.val().replace(/[^\d|\-+|\.+]/g, '')).toFixed(2);
            } else {
              plainNumber = Math.abs(parseFloat(element.val().replace(/[^\d|\-+|\.+]/g, '')).toFixed(2));
            }
            if (!plainNumber || isNaN(plainNumber)) {
              if(clearValue) {
                ctrl.$setViewValue(0);
                element.val("$0");
              } else if (nullable) {
                if (previousValue == '$0') {
                  element.val("$0");
                } else {
                  element.val("N/A");
                }
              } else {
                element.val(0);
              }
            } else {
              element.val($filter(attr.format)(plainNumber));
              ctrl.$setViewValue(plainNumber);
            }
          } else {
            if (negatives) {
              plainNumber = parseFloat(element.val().split('.')[0].replace(/[^\d|\-+]/g, '')).toFixed(2);
            } else {
              plainNumber = Math.abs(parseFloat(element.val().split('.')[0].replace(/[^\d|\-+]/g, '')).toFixed(2));
            }
            if (!plainNumber || isNaN(plainNumber)) {
              if(clearValue) {
                ctrl.$setViewValue(0);
                element.val("$0");
              } else if (nullable) {
                if (previousValue == '$0') {
                  element.val("$0");
                } else {
                  element.val("N/A");
                }
              } else {
                element.val("");
              }
            } else {
              element.val($filter(attr.format)(plainNumber, undefined, 0));
              ctrl.$setViewValue(plainNumber);
            }
          }
        });

        element.on('focus', function () {
          if((element.val() == '$0' || element.val() == 'N/A') && (clearValue || nullable)) {
            previousValue = element.val();
            element.val("");
          }
        });

        ctrl.$parsers.unshift(function () {
          return element.val().replace(/[^\d|\-+|\.+]/g, '');
        });
      }

    }
  }

})();

(function(){

  'use strict';

  angular.module('nvc')
  .controller('NavigationController', NavigationController);


  /** @ngInject */
  function NavigationController($scope, $state, navigationHelper, SessionManager, UserAccountService, RoleFactory) {
    
    var vm = this,
    originalRole = SessionManager.getRoleName();
    vm.availableRoles = SessionManager.availableRoles();
    vm.currentState = $state.current.name;
    vm.userName = SessionManager.getName();
    vm.userRoleClass = RoleFactory.htmlClass(originalRole);
    vm.userRole = RoleFactory.companyTypeToRole(originalRole);
    vm.availableRolesTypes = RoleFactory.companyTypesToRoles(vm.availableRoles.map(function(r){return r.type}));
    vm.companyNames = vm.availableRoles.map(function(r){return r.name});
    vm.states = navigationHelper.getStatesConfig();

    $scope.$on('$stateChangeStart',
      function(event, toState){
        vm.currentState = toState.name;
      }
    );

    vm.logout = function(){
      UserAccountService.logout().then(function(){
        $state.go('login');
      });
    };

    vm.changeRole = function(role, companyName){
      SessionManager.changeRole(role.type, companyName)
    };

    vm.isChildActive = function(children){
      for(var i = 0; i < children.length; i++){
        if(children[i].state === vm.currentState){
          return true;
        }
      }
      return false;
    }
  }
})();
(function() {

  'use strict';

  angular.module('nvc')
  .service('navigationHelper', navigationHelper);

  function navigationHelper() {

    /**
     *
     * stateConfiguration {object}
     * {
     *    state: <state>, //if has children this has to be the parent state
     *    name: <name to be displayed>,
     *    iconClass: <the icon to be displayed on the left of the name>,//fontawesome at the momment
     *    allow: <array of string representing the roles that should be able to enter this page>
     *    children: <array of stateConfiguration>, //optional if set clicking the state on the list wont produce a state change
     *                                            //at the moment children cant have deeper states nor icon
     * }
     */

    /**
     * @type {Array}
     * An array of stateConfiguration to be displayed on the sidenav
     */
    var navigationStatesConfig = [];

    this.init = function (navigationStates){
      navigationStatesConfig = navigationStates
    };

    this.getStatesConfig = function(){
      return navigationStatesConfig;
    };
  }

})();
(function(){

  'use strict';

  angular.module('nvc')
  .controller('TopnavbarController', NavigationController);

  /** @ngInject */
  function NavigationController($scope, $rootScope, $timeout, $state, UserAccountService, localStorageService) {
    var vm = this;

    vm.logout = logout;
    vm.displayCompanies = false;
    vm.companies = [];
    vm.company = {};

    function logout(){
      UserAccountService.logout().then(function(){
        $state.go('login');
      });
    }

    var hideCompaniesEvent = $rootScope.$on('hideCompanyDropDown', function(){
      vm.displayCompanies = false;
    });

    var displaySame = $rootScope.$on('displaySameCompanyDropDown', function(){
      vm.displayCompanies = true;
    });

    var displayCompaniesEvent = $rootScope.$on('displayCompanyDropDown', function(event, data){
      vm.companiesDropdownDisabled = data.disable;
      vm.displayCompanies = data.display;
      vm.companies = data.companies;
      if(!vm.company || Object.keys(vm.company) == 0){
        vm.company = angular.fromJson(localStorageService.get("selectedCompany"));
      }
      if(vm.company){
        for( var i = 0; i < vm.companies.length; i++){
          if(vm.companies[i].id === vm.company.id){
            vm.company = angular.copy(vm.companies[i]);
            return;
          }
        }
      }
      vm.company = data.companies[0];
    });

    var displayCompaniesDisabledEvent = $rootScope.$on('displayCompanyDropDownDisabled', function(event, data){
      vm.displayCompanies = true;
      vm.companiesDropdownDisabled = true;
      if(Object.keys(vm.company).length === 0){
        vm.company = angular.fromJson(localStorageService.get("selectedCompany"));
      }
      if(vm.companies.length === 0){
        vm.companies.push(vm.company);
      }
    });

    var companyChangedEvent = $scope.$watch('topnavbar.company', function(newValue){
      if(newValue && Object.keys(newValue).length > 0){
        $rootScope.$broadcast('companyChanged', vm.company);
        $timeout(function(){
          localStorageService.set('selectedCompany', angular.toJson(newValue));
        });
      }
    });

    $scope.$on('$destroy', function(){
      hideCompaniesEvent();
      displaySame();
      displayCompaniesEvent();
      displayCompaniesDisabledEvent();
      companyChangedEvent();
    });
  }
})();

(function(){
  angular
  .module('nvc')
  .service('LoaderHelper', LoaderHelper);

  function LoaderHelper($uibModal, $timeout, $http){

    var TIME_OUT_LIMIT = 1500;
    var timeOut;
    var modal;
    var confirmClose = false;
    var opened = false;
    return{
      open: open,
      close: close
    };

    function open(short) {
      confirmClose  = false;
      if(!opened){
        if(timeOut){
          $timeout.cancel(timeOut);
          timeOut = undefined;
        }
        if(short){
          modal = $uibModal.open({
            animation: false,
            templateUrl: 'app/components/commons/loader/loader-short.template.html',
            windowClass: 'loading-modal',
            keyboard: false,
            backdrop: 'static',
            appendTo: angular.element('#page-wrapper')
          });
        }else{
          modal = $uibModal.open({
            animation: false,
            templateUrl: 'app/components/commons/loader/loader.template.html',
            windowClass: 'loading-modal',
            keyboard: false,
            backdrop: 'static',
            appendTo: angular.element('#page-wrapper')
          });
        }
        opened = true;
        setLoaderTimeout(TIME_OUT_LIMIT);
      }
    }

    function setLoaderTimeout(timeOutLimit){
      timeOut = $timeout(function(){
        if($http.pendingRequests.length == 0 && modal){
          close();
        }else if(modal){
          if(timeOutLimit < 500){
            setLoaderTimeout(500);
          }else{
            setLoaderTimeout(timeOutLimit/2);
          }
        }
      }, timeOutLimit);
    }

    function close(){
      if(modal){
        confirmClose = true;
        $timeout(function(){
          if(confirmClose){
            modal.close();
            opened = false;
          }
        });
      }
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('nvc')
    .directive('headerSection', headerSection);

  /**@ngInject*/
  function headerSection() {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        breadcrumbTitle: '=',
        breadcrumbs: '=',
        assetId: '=',
        valuationId: '=',
        isAsset:'='
      },
      templateUrl: 'app/components/commons/header-section/header-section.html'
    }
  }
})();
(function() {
  'use strict';

  angular
    .module('nvc')
    .controller('ExpandImageController', ExpandImageController);

  /** @ngInject */
  function ExpandImageController($uibModalInstance, $scope, asset) {
    $scope.asset = asset;

    $scope.close = function() {
      $uibModalInstance.dismiss('cancel');
    }
  }

})();
(function () {
  'use strict';

  angular
  .module('nvc')
  .config(routeConfig);
  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider.state('app.valuations', {
      url: '/valuations',
      views: {
        '@app': {
          templateUrl: 'app/states/valuations/valuations.html',
          controller: 'ValuationsController',
          controllerAs: 'valuations'
        }
      },
      data: {
        pageTitle: 'Valuations Dashboard',
        roles: ['Admin', 'Audit', 'AssetManagement', 'AssetAppraisal', 'AssetReview', 'AssetManagerReadOnly'],
        viewClass: 'valuations'
      },
      resolve: {
        /** @ngInject */
        companies: function (CompanyService) {
          return CompanyService.getClientCompanies(true, true);
        },
        /** @ngInject */
        propertyTypes: function (StaticDataService) {
          return StaticDataService.getPropertyTypes();
        },
        /** @ngInject */
        states: function (StaticDataService) {
          return StaticDataService.getAllStates()
        },
        /** @ngInject */
        citiesByStates: function (StaticDataService) {
          return StaticDataService.getCitiesByStates()
        },
        /** @ngInject */
        subtypesByPropertyTypes: function (StaticDataService) {
          return StaticDataService.getSubtypesByPropertyTypes()
        },
        /** @ngInject */
        msaByStates: function (StaticDataService) {
          return StaticDataService.getMsaByStates()
        },
        /** @ngInject */
        ownershipTypes: function (StaticDataService) {
          return StaticDataService.getOwnershipTypes()
        },
        /** @ngInject */
        ncreifs: function (StaticDataService) {
          return StaticDataService.getNcreifs()
        }
      }
    });
  }

})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .controller('ValuationsController', ValuationsController);

  /** @ngInject */
  function ValuationsController($rootScope, $scope, $filter, $q, $window, LoaderHelper, CompanySelectorFactory, CompanyService,
    UserService, SessionManager, companies, ReviewFactory, ValuationService, propertyTypes,
    ArrayHelper, CSVService, states, $uibModal, UtcDateConverter, EnvironmentConfig) {

    var vm = this;
    var statistics,
      allStatistics,
      myStatistics,
      myNumberOfValuations,
      allNumberOfValuations,
      allOverdueValuations = [],
      myOverdueValuations = [],
      allAverages = {},
      myAverages = {},
      currentUser;
    vm.reviews = [];
    vm.allReviews = [];
    vm.searchQuery = '';
    vm.generalRoles = ['Admin', 'Audit', 'AssetManagement', 'AssetReview', 'AssetManagerReadOnly'];
    vm.title = $filter('translate')('VALUATIONS.MAIN_TITLE');
    vm.selectedCompany = null;
    vm.propertyTypes = propertyTypes.items;
    vm.isAppraiser = true;
    vm.downloadLoading = false;
    vm.mapRangesToProps = {};
    vm.overdueSort = [
      {
        sort: 'name',
        tag: 'name',
        selected: false,
        flag: false
      },
      {
        sort: '-nextDraftDueDate',
        tag: 'nextDraftDueDate',
        selected: true,
        flag: false
      }
    ];
    vm.valuationSort = [
      {
        tag: 'AssetName',
        selected: true,
        flag: true,
        order: 'Ascending'
      },
      {
        tag: 'Location',
        selected: false,
        flag: false,
        order: 'Ascending'
      },
      {
        tag: 'Type',
        selected: false,
        flag: false,
        order: 'Ascending'
      },
      {
        tag: 'PrimaryManagerName',
        selected: false,
        flag: false,
        order: 'Ascending'
      },
      {
        tag: 'PrimaryReviewerName',
        selected: false,
        flag: false,
        order: 'Ascending'
      },
      {
        tag: 'Value',
        selected: false,
        flag: false,
        order: 'Ascending'
      },
      {
        tag: 'VPeriod',
        selected: false,
        flag: false,
        order: 'Ascending'
      },
      {
        tag: 'StatusDescription',
        selected: false,
        flag: false,
        order: 'Ascending'
      },
      {
        tag: 'NextUserTakingActionName',
        selected: false,
        flag: false,
        order: 'Ascending'
      }
    ];
    vm.valuationStatusSort = [
      {
        tag: 'ValuationName',
        selected: true,
        flag: true,
        order: 'Ascending'
      },
      {
        tag: 'Type',
        selected: false,
        flag: false,
        order: 'Ascending'
      },
      {
        tag: 'VPeriod',
        selected: false,
        flag: false,
        order: 'Ascending'
      },
      {
        tag: 'FormFilledDate',
        selected: false,
        flag: false,
        order: 'Ascending'
      },
      {
        tag: 'ReviewerCommentedDate',
        selected: false,
        flag: false,
        order: 'Ascending'
      },
      {
        tag: 'ManagerCommentedDate',
        selected: false,
        flag: false,
        order: 'Ascending'
      },
      {
        tag: 'SubmittedToAppraiserDate',
        selected: false,
        flag: false,
        order: 'Ascending'
      },
      {
        tag: 'CommentsAnsweredDate',
        selected: false,
        flag: false,
        order: 'Ascending'
      },
      {
        tag: 'DocumentsUpdatedDate',
        selected: false,
        flag: false,
        order: 'Ascending'
      },
      {
        tag: 'ValuationUpdatedDate',
        selected: false,
        flag: false,
        order: 'Ascending'
      },
      {
        tag: 'ReviewerApproveValuationDate',
        selected: false,
        flag: false,
        order: 'Ascending'
      },
      {
        tag: 'ManagerApproveValuationDate',
        selected: false,
        flag: false,
        order: 'Ascending'
      },
      {
        tag: 'ValuationSignedOffDate',
        selected: false,
        flag: false,
        order: 'Ascending'
      },
      {
        tag: 'FinalDocumentsUploadedDate',
        selected: false,
        flag: false,
        order: 'Ascending'
      },
      {
        tag: 'FinalFormFilledDate',
        selected: false,
        flag: false,
        order: 'Ascending'
      },
      {
        tag: 'FinishedDate',
        selected: false,
        flag: false,
        order: 'Ascending'
      },
      {
        tag: 'FinalFilesRejectedDate',
        selected: false,
        flag: false,
        order: 'Ascending'
      },
    ];
    vm.overdueSelectedSort = vm.overdueSort[1];
    vm.valuationSelectedSort = vm.valuationSort[0];
    vm.perPage = 17;
    vm.maxPaginationSize = 5;
    vm.ranges = {};
    vm.advancedSearchFilters = null;
    vm.canBringFutureValuations = EnvironmentConfig.FUTURE_VALUATIONS;
    vm.futureValuations = false;
    vm.isStatusView = false;
    vm.valuationStatusSelectedSort = vm.valuationStatusSort[0];

    //Advanced Filters
    //------------------------------------------
    vm.isFiltersApplied = !!$rootScope.filters;
    vm.numberOfFiltersApplied = 0;
    vm.isToggleDownloadActive = false;
    vm.clearAllFilters = function () {
      $rootScope.filters = null;
      vm.isFiltersApplied = false;
      vm.numberOfFiltersApplied = 0;
      vm.advancedSearchFilters = null;
      loadReviews();
    };

    $rootScope.$watch('filters', function (newVal, oldVal) {
      if (!angular.equals(oldVal, newVal)) {
        vm.isFiltersApplied = !areFiltersCleared(newVal);
        vm.numberOfFiltersApplied = calculateAppliedFilters(newVal);
      }
    });

    function ObjectValues(obj) {
      return Object.keys(obj).map(function (key) {
        return obj[key];
      });
    }

    function calculateAppliedFilters(filters) {
      if (!filters) return 0;

      var count = 0;
      ['NetRentableAreaFilterMin', 'NetRentableAreaFilterMax', 'ValueFilterMin', 'ValueFilterMax'].forEach(function (prop) {
        if (filters[prop] !== vm.mapRangesToProps[prop]) {
          count++;
        }
      });
      ObjectValues(filters.valuationFilters).forEach(function (val, i) {
        if (val.length > 0) {
          count++;
        }
      });
      return count;
    }

    function areFiltersCleared(filters) {
      if (!filters) return true;
      var applied = false;

      ['NetRentableAreaFilterMin', 'NetRentableAreaFilterMax', 'ValueFilterMin', 'ValueFilterMax'].forEach(function (prop) {
        if (filters[prop] !== vm.mapRangesToProps[prop]) {
          applied = true;
        }
      });

      if (applied) return false;

      for (var key in filters.valuationFilters) {
        if (filters.valuationFilters.hasOwnProperty(key)) {
          if (filters.valuationFilters[key].length > 0) {
            return false;
          }
        }
      }

      return true;
    }

    //DOWNLOAD CSV
    //------------------------------------------
    vm.downloadCsv = function () {
      vm.downloadLoading = true;
      CSVService.generateValuationsCSV(vm.selectedCompany, vm.reviewCount, vm.searchQuery,
        vm.valuationSelectedSort.tag, vm.valuationSelectedSort.order, vm.abbrTypes, vm.advancedSearchFilters, vm.isStatusView, !vm.allReviewSelected).then(function () {
          vm.downloadLoading = false;
          vm.isToggleDownloadActive = false;
        });
    };

    vm.downloadValuationConclusionsCsv = function () {
      vm.downloadLoading = true;
      CSVService.generateValuationsConclusionsCSV(vm.selectedCompany, vm.reviewCount, vm.searchQuery,
        vm.valuationSelectedSort.tag, vm.valuationSelectedSort.order, vm.abbrTypes, vm.advancedSearchFilters, !vm.allReviewSelected).then(function () {
          vm.downloadLoading = false;
          vm.isToggleDownloadActive = false;
        });
    };

    vm.downloadExecutiveSummaryCsv = function () {
      vm.downloadLoading = true;
      CSVService.generateExecutiveSummaryCSV(vm.selectedCompany, vm.reviewCount, vm.searchQuery,
        vm.valuationSelectedSort.tag, vm.valuationSelectedSort.order, vm.abbrTypes, vm.advancedSearchFilters, !vm.allReviewSelected).then(function () {
          vm.downloadLoading = false;
          vm.isToggleDownloadActive = false;
        });
    };

    vm.downloadAEModels = function (downloadType) {
      vm.downloadLoading = true;
      var idList = [];
      ValuationService.listSummary(vm.selectedCompany, 0, vm.reviewCount, vm.searchQuery, vm.valuationSelectedSort.tag, vm.valuationSelectedSort.order, !vm.allReviewSelected, vm.advancedSearchFilters, false).then(function (data) {
        data.data.valuationSummaries.forEach(function (valuationSummary) {
          idList.push(valuationSummary.id);
        })
        ValuationService.getAEDocumentsByAssetId(idList, downloadType).then(function (response) {
          vm.downloadLoading = false;
          vm.isToggleDownloadActive = false;
          var reader = new FileReader();
          var blob = new Blob([response.data], { type: 'application/zip' });
          reader.readAsDataURL(blob);
          reader.onload = function (e) {
            var url = window.URL.createObjectURL(blob);
            var a = document.createElement('a');
            a.href = url;
            if (response.config.data.downloadType === ($filter('translate')('VALUATIONS.ARGUS_FILE'))) {
              a.download = 'consolidated-aedocuments.zip';
            } else {
              a.download = 'consolidated-valuationreportdocuments.zip';
            }
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
          };
        });
      });
    }
    var excludedDiv = document.getElementById('valuationsDownloadButton');
    
    function eventHandler(event) {
      if (excludedDiv && excludedDiv.contains(event.target)) {
        return;
      }
      if (vm.isToggleDownloadActive == true) {
        excludedDiv.click();
      }
    }
    $window.addEventListener('click', eventHandler);

    vm.toggleDownload = function () {
      vm.isToggleDownloadActive = !vm.isToggleDownloadActive;
    };

    function multipleSearch(query) {
      vm.advancedSearchFilters = query;
      loadReviews();
    }
    //ADVANCE FILTERS
    //------------------------------------------
    vm.openAdvanceFilters = function () {
      var modalInstance = $uibModal.open({
        animation: true,
        ariaLabelledBy: 'modal-title',
        ariaDescribedBy: 'modal-body',
        templateUrl: 'advanced-filters.html',
        controller: 'AdvancedFiltersController',
        controllerAs: 'advancedFiltersCtrl',
        size: 'lg',
        resolve: {
          /** @ngInject */
          propertyTypes: function (StaticDataService) {
            return StaticDataService.getPropertyTypes();
          },
          /** @ngInject */
          states: function (StaticDataService) {
            return StaticDataService.getAllStates()
          },
          /** @ngInject */
          citiesByStates: function (StaticDataService) {
            return StaticDataService.getCitiesByStates()
          },
          /** @ngInject */
          subtypesByPropertyTypes: function (StaticDataService) {
            return StaticDataService.getSubtypesByPropertyTypes()
          },
          /** @ngInject */
          msaByStates: function (StaticDataService) {
            return StaticDataService.getMsaByStates()
          },
          /** @ngInject */
          ownershipTypes: function (StaticDataService) {
            return StaticDataService.getOwnershipTypes()
          },
          /** @ngInject */
          ncreifs: function (StaticDataService) {
            return StaticDataService.getNcreifs()
          },
          ranges: vm.ranges
        }
      });
      modalInstance.result.then(function (queryObj) {
        multipleSearch(queryObj);
      });
    };


    vm.abbrTypes = function (type) {
      switch (type) {
        case 'Office':
          return 'OFF';
          break;
        case 'Retail':
          return 'RET';
          break;
        case 'Industrial':
          return 'IND';
          break;
        case 'Apartment':
          return 'APT';
          break;
        case 'Hotel':
          return 'HOT';
          break;
        case 'MixedUse':
          return 'MIX';
          break;
        case 'Land':
          return 'LND';
          break;
        case 'Other':
          return 'OTH';
          break;
      }
    };

    //SEARCH FUNCTION
    //------------------------------------------
    vm.searchValuations = function () {
      if (vm.searchQuery.length > 2 || !vm.searchQuery) {
        loadReviews();
      }
    };

    //SORTING
    //------------------------------------------
    vm.sorting = function (sort, target) {
      ArrayHelper.sort(sort, target, vm.overdueSort, vm);
    };

    vm.sortingValuations = function (sort, target) {
      if (vm.isStatusView) {
        ArrayHelper.beSort(sort, target, vm.valuationStatusSort, vm);
      } else {
        ArrayHelper.beSort(sort, target, vm.valuationSort, vm);
      }
      loadReviews();
    };

    //BREADCRUMS
    //------------------------------------------
    vm.breadcrumbs = [
      {
        label: $filter('translate')('COMMONS.HOME'),
        value: 'app.valuations'
      },
      {
        label: $filter('translate')('COMMONS.DASHBOARD'),
        value: 'app.valuations'
      }
    ];

    //LATERAL BAR CONFIG
    //------------------------------------------
    vm.lateralBarConfig = {
      templateUrl: 'app/states/valuations/valuation-lateral-content.html',
      controller: 'ValuationLateralController',
      icons: [
        {
          class: 'icon-ic-asset-info info',
          anchor: 'asset-info'
        },
        {
          class: 'icon-ic-team info',
          anchor: 'people'
        }
      ]
    };

    if (!SessionManager.isInRole('AssetAppraisal')) {
      vm.lateralBarConfig.icons.push({ class: 'icon-ic-auditor info', anchor: 'auditor' });
      vm.isAppraiser = false;
    }

    //BAR CHART CONFIG
    //------------------------------------------
    var currentDate = new moment();
    var currentQuarter = ReviewModel.getQuarterByDate(currentDate);
    vm.labelsAverage = [];
    for (var i = 0; i < 4; i++) {
      if (i + 1 <= currentQuarter) {
        vm.labelsAverage[i] = 'Q' + (i + 1) + ' \'' + currentDate.format('YY');
      } else {
        vm.labelsAverage[i] = 'Q' + (i + 1) + ' \'' + moment().set('year', moment().get('year') - 1).format('YY');
      }
    }
    vm.barSeries = ['q1'];

    vm.optionsAverage = {
      tooltips: {
        callbacks: {
          label: function (tooltipItem, data) {
            if (vm.factor.name === "Average Contract Rent" || vm.factor.name === "Average Market Rent") {
              return $filter('currency')(tooltipItem.yLabel, undefined, 2);
            }
            return $filter('percentage')($filter('number')(tooltipItem.yLabel, 2), undefined, 2);
          }
        },
        display: true,
        backgroundColor: 'rgba(255,255,255,1)',
        titleFontColor: '#000000',
        titleFontSize: 10,
        bodyFontColor: '#000000',
        bodyFontSize: 10
      },
      scales: {
        yAxes: [
          {
            ticks: {
              min: 0,
              display: true
            },
            gridLines: {
              zeroLineColor: "rgba(172, 172, 172, 0)",
              display: true,
              borderDash: [4, 4]
            }
          }
        ],
        xAxes: [
          {
            ticks: {
              fontFamily: 'Roboto',
              fontStyle: 'normal',
              fontSize: 10
            },
            gridLines: {
              zeroLineColor: "rgba(172, 172, 172, 0)",
              display: false,
              borderDash: [4, 4]
            }
          }
        ]
      }
    };
    vm.colorsAverage = ['#025d84', '#3c7188', '#667b84', '#7c7c7c'];

    vm.factorValues = [
      { name: $filter('translate')('VALUATIONS.AVERAGE_TERMINAL_RATE'), value: 'Average Terminal Rate' },
      { name: $filter('translate')('VALUATIONS.AVERAGE_DISCOUNT_RATE'), value: 'Average Discount Rate' },
      { name: $filter('translate')('VALUATIONS.AVERAGE_CONTRACT_RENT'), value: 'Average Contract Rent' },
      { name: $filter('translate')('VALUATIONS.AVERAGE_MARKET_RENT'), value: 'Average Market Rent' },
      { name: $filter('translate')('VALUATIONS.AVERAGE_RENT_GROWTH'), value: 'Average Rent Growth' },
      { name: $filter('translate')('VALUATIONS.AVERAGE_STAB_CAP_RATE'), value: 'Average Stab. Cap Rate' },
      { name: $filter('translate')('VALUATIONS.AVERAGE_IMPLIED_CAP_RATE'), value: 'Average Implied Cap Rate' },
      { name: $filter('translate')('VALUATIONS.PP_VALUE_CHANGE'), value: 'Average Appraisal Period Delta' },
      { name: $filter('translate')('VALUATIONS.YY_VALUE_CHANGE'), value: 'Average Appraisal Yearly Delta' }
    ];

    //DOUGHNUT CHART CONFIG
    //------------------------------------------
    if (SessionManager.getRoleName() !== 'AssetAppraisal') {
      vm.propertyStatus = [
        {
          name: $filter('translate')('VALUATIONS.DRAFT_NOT_SUBMITTED_BY_APP'),
          status: ['Created', 'DocumentsUploaded']
        },
        {
          name: $filter('translate')('VALUATIONS.DRAFT_SUBMITTED_BY_APR'),
          status: ['FormFilled']
        },
        {
          name: $filter('translate')('VALUATIONS.COMMENTS_SUBMITTED_BY_REV_TO_AM'),
          status: ['ReviewerCommented']
        },
        {
          name: $filter('translate')('VALUATIONS.COMMENTS_SUBMITTED_BY_AM'),
          status: ['ManagerCommented']
        },
        {
          name: $filter('translate')('VALUATIONS.COMMENTS_SUBMITTED_TO_APR'),
          status: ['SubmittedToAppraiser', 'CommentsAnswered', 'DocumentsUpdated']
        },
        {
          name: $filter('translate')('VALUATIONS.RESPONSES_SUBMITTED_BY_APR'),
          status: ['ValuationUpdated']
        },
        {
          name: $filter('translate')('VALUATIONS.VALUATION_APPROVED_BY_REV'),
          status: ['ReviewerApproveValuation']
        },
        {
          name: $filter('translate')('VALUATIONS.VALUATION_APPROVED_BY_AM'),
          status: ['ManagerApproveValuation']
        },
        {
          name: $filter('translate')('VALUATIONS.VALUATION_SIGNED_OFF'),
          status: ['ValuationSignedOff', 'FinalDocumentsUploaded']
        },
        {
          name: $filter('translate')('VALUATIONS.FINAL_DOCUMENTS_SUBMITTED'),
          status: ['FinalFormFilled']
        },
        {
          name: $filter('translate')('VALUATIONS.FINAL_DOCUMENTS_REJECTED'),
          status: ['FinalDocumentsRejected']
        },
        {
          name: $filter('translate')('VALUATIONS.DOCUMENTS_SIGNED_OFF'),
          status: ['Finished']
        }
      ];
    } else {
      vm.propertyStatus = [
        {
          name: $filter('translate')('VALUATIONS.DRAFT_NOT_SUBMITTED_BY_APP'),
          status: ['Created', 'DocumentsUploaded']
        },
        {
          name: $filter('translate')('VALUATIONS.DRAFT_SUBMITTED_BY_APR'),
          status: ['FormFilled', 'ReviewerCommented', 'ManagerCommented']
        },
        {
          name: $filter('translate')('VALUATIONS.COMMENTS_SUBMITTED_TO_APR'),
          status: ['SubmittedToAppraiser', 'CommentsAnswered', 'DocumentsUpdated']
        },
        {
          name: $filter('translate')('VALUATIONS.RESPONSES_SUBMITTED_BY_APR'),
          status: ['ValuationUpdated', 'ReviewerApproveValuation', 'ManagerApproveValuation']
        },
        {
          name: $filter('translate')('VALUATIONS.VALUATION_SIGNED_OFF'),
          status: ['ValuationSignedOff', 'FinalDocumentsUploaded']
        },
        {
          name: $filter('translate')('VALUATIONS.FINAL_DOCUMENTS_SUBMITTED'),
          status: ['FinalFormFilled']
        },
        {
          name: $filter('translate')('VALUATIONS.FINAL_DOCUMENTS_REJECTED'),
          status: ['FinalDocumentsRejected']
        },
        {
          name: $filter('translate')('VALUATIONS.DOCUMENTS_SIGNED_OFF'),
          status: ['Finished']
        }
      ];
    }
    vm.optionsOverall = {
      tooltips: {
        enabled: true,
        backgroundColor: 'rgba(255,255,255,1)',
        titleFontColor: '#000000',
        titleFontSize: 10,
        bodyFontColor: '#000000',
        bodyFontSize: 10
      },
      cutoutPercentage: 67
    };

    vm.labelsOverall = [vm.propertyStatus[0].name, "Remaining"];

    vm.optionsOverall = {
      tooltips: {
        enabled: true,
        backgroundColor: 'rgba(255,255,255,1)',
        titleFontColor: '#000000',
        titleFontSize: 10,
        bodyFontColor: '#000000',
        bodyFontSize: 10
      },
      cutoutPercentage: 67
    };

    vm.colorsOverall = ['#025d84', '#aeaeae'];

    //GET ASSETS BY COMPANY
    //------------------------------------------
    CompanySelectorFactory.showCompanies(companies);
    var companyListener = $scope.$on('companyChanged', function (event, selectedCompany) {
      $rootScope.filters = null;
      vm.advancedSearchFilters = null;
      vm.selectedCompany = selectedCompany.id;
      vm.allReviewSelected = SessionManager.isInAnyRole(['Admin', 'AssetManagerReadOnly']);
      CompanySelectorFactory.executeOnValidState('app.valuations', function () {
        vm.currentPage = 1;
        loadReviews(true);
        if (SessionManager.isInAnyRole(['Admin', 'AssetManagement'])) {
          vm.assetManagers = [];
          UserService.getUsersByCompanyId(selectedCompany.id, true).then(function (assetManagers) {
            for (var i = 0; i < assetManagers.length; i++) {
              if (assetManagers[i].user.userCompanyRoles) {
                if (assetManagers[i].user.userCompanyRoles.length > 1) {
                  for (var j = 0; j < assetManagers[i].user.userCompanyRoles.length; j++) {
                    if ('AssetManager' === assetManagers[i].user.userCompanyRoles[j] || 'AssetManagerReadOnly' === assetManagers[i].user.userCompanyRoles[j]) {
                      vm.assetManagers.push(assetManagers[i]);
                      break;
                    }
                  }
                } else if ('AssetManager' === assetManagers[i].user.userCompanyRoles[0] || 'AssetManagerReadOnly' === assetManagers[i].user.userCompanyRoles[0]) {
                  vm.assetManagers.push(assetManagers[i]);
                }
              }
            }
          });
        }

        //widget 1
        ValuationService.getValuationsStatistic(selectedCompany.id).then(function (rawStatistics) {
          if (SessionManager.isInAnyRole(['Admin', 'AssetManagerReadOnly'])) {
            statistics = rawStatistics.totalStatistic;
            vm.numberOfValuations = rawStatistics.numberOfValuationSummary;
          } else {
            myStatistics = rawStatistics.currentUserStatistic;
            allStatistics = rawStatistics.totalStatistic;
            statistics = myStatistics;
            myNumberOfValuations = rawStatistics.numberOfCurrentUserValuationSummary;
            allNumberOfValuations = rawStatistics.numberOfValuationSummary;
            vm.numberOfValuations = myNumberOfValuations;
          }
          vm.status = vm.propertyStatus[0];
        });
        vm.companyAverages = {};
        //widget 2
        CompanyService.getValuationsAverage(selectedCompany.id, false).then(function (averagesRelation) {
          var averages = averagesRelation.averageData;
          averages.forEach(function (average) {
            for (var i = 0; i < average.avgQuarters.length; i++) {
              average.avgQuarters[i] = average.avgQuarters[i] / 100;
            }
            if (SessionManager.isInAnyRole(['Admin', 'AssetManagerReadOnly'])) {
              vm.companyAverages[average.avgName] = average.avgQuarters;
            } else {
              allAverages[average.avgName] = average.avgQuarters;
            }
          });
          vm.factor = vm.factorValues[7];
        });

        //widget 3
        ValuationService.listOverdueSummary(selectedCompany.id, false).then(function (valuations) {
          if (SessionManager.isInAnyRole(['Admin', 'AssetManagerReadOnly'])) {
            vm.overdueValuations = valuations.map(function (valuation) {
              valuation.nextDraftDueDate = UtcDateConverter.getMillisecondsFromUTC(valuation.nextDraftDueDate);
              return valuation;
            });
          } else {
            allOverdueValuations = valuations.map(function (valuation) {
              valuation.nextDraftDueDate = UtcDateConverter.getMillisecondsFromUTC(valuation.nextDraftDueDate);
              return valuation;
            });
          }
        });
        if (!SessionManager.isInAnyRole(['Admin', 'AssetManagerReadOnly'])) {
          //widget 2
          CompanyService.getValuationsAverage(selectedCompany.id, true).then(function (averagesRelation) {
            var averages = averagesRelation.averageData;
            averages.forEach(function (average) {
              for (var i = 0; i < average.avgQuarters.length; i++) {
                average.avgQuarters[i] = average.avgQuarters[i] / 100;
              }
              myAverages[average.avgName] = average.avgQuarters;
            });
            vm.companyAverages = myAverages;
            vm.factor = vm.factorValues[7];
          });
          //widget 3
          ValuationService.listOverdueSummary(selectedCompany.id, true).then(function (valuations) {
            myOverdueValuations = valuations.map(function (valuation) {
              valuation.nextDraftDueDate = UtcDateConverter.getMillisecondsFromUTC(valuation.nextDraftDueDate);
              return valuation;
            });
            vm.overdueValuations = myOverdueValuations;
          });
        }
      });
      vm.lateralBarOpen = false;
    });

    //GET CURRENT USER
    //------------------------------------------
    currentUser = SessionManager.getUser();
    currentUser.role = SessionManager.getRoleName();

    //GET REVIEWERS LIST
    //------------------------------------------
    if (SessionManager.isInRole('Admin')) {
      CompanyService.getReviewerCompanies(true, true).then(function (rCompanies) {
        var promises = [];
        rCompanies.forEach(function (rCompany) {
          promises.push(UserService.getUsersByCompanyId(rCompany.id, true));
        });
        $q.all(promises).then(function (responses) {
          vm.reviewers = [];
          responses.forEach(function (response) {
            vm.reviewers = vm.reviewers.concat(response);
          })
        });
      });
    }

    if (SessionManager.isInRole('AssetReview')) {
      CompanyService.getReviewerCompanies(true, true).then(function (aCompanies) {
        aCompanies.forEach(function (aCompany) {
          UserService.getUsersByCompanyId(SessionManager.getCompanyId(), true).then(function (reviewers) {
            vm.reviewers = reviewers;
          })
        });
      });
    }

    //GET APPRAISERS LIST
    //------------------------------------------
    if (SessionManager.isInRole('Admin')) {
      CompanyService.getAppraisalCompanies(true, true).then(function (aCompanies) {
        var promises = [];
        aCompanies.forEach(function (aCompany) {
          promises.push(UserService.getUsersByCompanyId(aCompany.id, true));
        });
        $q.all(promises).then(function (responses) {
          vm.appraisers = [];
          responses.forEach(function (response) {
            vm.appraisers = vm.appraisers.concat(response);
          })
        });
      });
    } else if (SessionManager.isInRole('AssetAppraisal')) {
      CompanyService.getAppraisalCompanies(false, true).then(function (aCompanies) {
        var promises = [];
        aCompanies.forEach(function (aCompany) {
          promises.push(UserService.getUsersByCompanyId(aCompany.id, true));
        });
        $q.all(promises).then(function (responses) {
          vm.appraisers = [];
          responses.forEach(function (response) {
            vm.appraisers = vm.appraisers.concat(response);
          })
        });
      });
    }

    //GET AUDITORS LIST
    //------------------------------------------
    if (SessionManager.isInAnyRole(['Admin', 'Audit'])) {
      CompanyService.getAuditorCompanies(true, true).then(function (adCompanies) {
        var promises = [];
        adCompanies.forEach(function (adCompany) {
          promises.push(UserService.getUsersByCompanyId(adCompany.id, true));
        });
        $q.all(promises).then(function (responses) {
          vm.auditors = [];
          responses.forEach(function (response) {
            vm.auditors = vm.auditors.concat(response);
          })
        });
      });
    }

    //GET ASSET DETAIL
    //------------------------------------------
    vm.getReviewDetails = function (selectedReview) {
      $('.paginator-loader').addClass('fixed-height');
      vm.selectedReview = selectedReview;
      var secondaryAppraisers = [];
      var secondaryReviewers = [];
      var secondaryAssetManagers = [];
      vm.lateralBarOpen = true;
      vm.selectedReview = selectedReview;

      Object.keys(selectedReview.asset.users).forEach(function (key) {
        var user = selectedReview.asset.users[key];
        var period;
        for (var i = 0; i < user.periods.length; i++) {
          var tempPeriod = user.periods[i];
          if (tempPeriod.year === selectedReview.year && tempPeriod.quarter === selectedReview.quarter) {
            period = tempPeriod;
            break;
          }
        }
        if (period && period.active) {
          switch (user.type) {
            case "SecondaryAssetAppraiser":
              secondaryAppraisers.push(user);
              break;

            case "SecondaryAssetReviewer":
              secondaryReviewers.push(user);
              break;

            case "SecondaryAssetManager":
              secondaryAssetManagers.push(user);
              break;
          }
        }
      });

      vm.reviews.forEach(function (review) {
        selectedReview.id === review.id ? review.displaying = true : review.displaying = false;
      });

      vm.lateralBarConfig.locals = {
        review: vm.selectedReview,
        reviewers: vm.reviewers,
        secondaryReviewers: secondaryReviewers,
        appraisers: vm.appraisers,
        secondaryAppraisers: secondaryAppraisers,
        assetManagers: vm.assetManagers,
        secondaryAssetManagers: secondaryAssetManagers,
        auditors: vm.auditors,
        toggleButton: vm.toggleButton,
        currentUser: currentUser
      };
    };

    //VALUATION LATERAL REVIEW CHANGED
    //------------------------------------------
    var lateralEventListener = $rootScope.$on('valuationLateralReviewChanged', function (event, oldReview) {
      ReviewFactory.loadReview(oldReview.asset.id, oldReview.id).then(function (review) {
        review.vPeriod = oldReview.vPeriod;
        for (var i = 0; i < vm.reviews.length; i++) {
          if (vm.reviews[i].id === review.id) {
            if (review.appraisalFinal && review.appraisalFinal !== 0) {
              review.presentValue = review.appraisalFinal;
            } else {
              review.presentValue = review.appraisalDraft;
            }
            vm.reviews[i] = review;
            break;
          }
        }
      });
    });
    var lateralEventListener = $rootScope.$on('valuationUserChanged', function (event, oldReview) {
      loadReviews();
    })

    //MY VALUATIONS
    //------------------------------------------
    vm.myValuations = function () {
      if (vm.allReviewSelected) {
        vm.companyAverages = myAverages;
        vm.overdueValuations = myOverdueValuations;
        statistics = myStatistics;
        vm.numberOfValuations = myNumberOfValuations;
      } else {
        vm.companyAverages = allAverages;
        vm.overdueValuations = allOverdueValuations;
        statistics = allStatistics;
        vm.numberOfValuations = allNumberOfValuations;
      }
      vm.allReviewSelected = !vm.allReviewSelected;
      loadReviews();
      vm.recalculateOverall();
      if (vm.lateralBarOpen) {
        vm.closeDetails();
      }
      ArrayHelper.searchScroll();
    };

    //CLOSE DETAILS
    //------------------------------------------
    vm.closeDetails = function () {
      $('.paginator-loader').removeClass('fixed-height');
      vm.selectedReview.displaying = false;
      vm.lateralBarOpen = false;
    };

    //RECALCULATE OVERALL WIDGET
    //------------------------------------------
    vm.recalculateOverall = function () {
      if (vm.status && statistics) {
        vm.percentageOverall = 0;
        vm.dataOverall = [0, 0];
        vm.status.status.forEach(function (status) {
          if (statistics[status].percentage !== 'NaN') {
            vm.percentageOverall += statistics[status].percentage;
          }
          vm.dataOverall[0] += statistics[status].valuations;
        });
        vm.dataOverall[1] = vm.numberOfValuations - vm.dataOverall[0];
        vm.labelsOverall = [vm.status.name, "Remaining"];
        if (vm.numberOfValuations === 0) {
          vm.dataOverall = [0, 1];
          vm.percentageOverall = 0;
          vm.optionsOverall = {
            tooltips: {
              enabled: false
            },
            cutoutPercentage: 67
          };
        }
      }
    };

    function loadReviews(load) {
      if (load) {
        LoaderHelper.open(true);
      } else {
        $('.paginator-loader').addClass('sk-loading');
      }
      ReviewFactory.loadAllReviewsByCompany(vm.selectedCompany, vm.currentPage - 1, vm.perPage, vm.searchQuery,
        vm.valuationSelectedSort.tag, vm.valuationSelectedSort.order,
        !SessionManager.isInAnyRole(['Admin', 'AssetManagerReadOnly']) && !vm.allReviewSelected,
        vm.advancedSearchFilters, vm.futureValuations).then(function (reviews) {
          vm.reviews = reviews.reviews;
          vm.reviewCount = reviews.pageInfo.count;
          vm.numberOfValuations = reviews.pageInfo.total;
          vm.ranges = {
            maxLeaseRange: reviews.pageInfo.maxLeaseRange,
            minLeaseRange: reviews.pageInfo.minLeaseRange,
            maxValueRange: reviews.pageInfo.maxValueRange,
            minValueRange: reviews.pageInfo.minValueRange
          };
          vm.mapRangesToProps = {
            NetRentableAreaFilterMin: Number(vm.ranges.minLeaseRange),
            NetRentableAreaFilterMax: Number(vm.ranges.maxLeaseRange),
            ValueFilterMin: Number(vm.ranges.minValueRange),
            ValueFilterMax: Number(vm.ranges.maxValueRange)
          };
          ArrayHelper.searchScroll();
          if (load) {
            LoaderHelper.close();
            vm.recalculateOverall();
          } else {
            $('.paginator-loader').removeClass('sk-loading');
          }
        });
    }

    vm.changePage = function () {
      if (vm.lateralBarOpen) {
        vm.closeDetails();
      }
      loadReviews();
    };

    vm.loadFutureValuations = function () {
      loadReviews();
    };

    vm.toggleStatus = function () {
      vm.isStatusView = !vm.isStatusView;
    }

    vm.getstatus = function (list, status) {
      var status = list.find(function (single) {
        if (status == 'ValuationSignedOff')
          return single.status === 'ValuationSignedOff' || single.status === 'FinalDocumentsUploaded';
        else if (status == 'SubmittedToAppraiser') {
          return single.status === 'SubmittedToAppraiser' || single.status === 'CommentsAnswered' || single.status === 'DocumentsUpdated';
        } else {
          return single.status === status;
        }
      });
      return status ? moment(status.updatedOn).format('MM/DD/YYYY') : '';
    }
    //STATUS WATCHER
    //------------------------------------------
    var statusWatch = $scope.$watch('valuations.status', function (newValue) {
      vm.status = newValue;
      vm.recalculateOverall();
    });

    $scope.$on('$destroy', function () {
      companyListener();
      lateralEventListener();
      statusWatch();
      $window.removeEventListener('click', eventHandler);
      $rootScope.filters = null;
    });
  }

})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .controller('ValuationLateralController', ValuationLateralController);

  function ValuationLateralController($rootScope, $scope, $filter, LoaderHelper, AssetService, ReviewFactory,
    notify, review, reviewers, secondaryReviewers, appraisers, secondaryAppraisers,
    assetManagers, secondaryAssetManagers, auditors, currentUser, $state,
    UtcDateConverter) {

    $scope.review = ReviewFactory.copy(review);

    var notifyChange = false;
    $scope.reviewers = reviewers;
    $scope.secondaryReviewers = secondaryReviewers;
    $scope.appraisers = appraisers;
    $scope.secondaryAppraisers = secondaryAppraisers;
    $scope.assetManagers = assetManagers;
    $scope.auditors = auditors;
    $scope.secondaryAssetManagers = secondaryAssetManagers;
    $scope.addingAp = secondaryAppraisers.length === 0;
    $scope.addingAm = secondaryAssetManagers.length === 0;
    $scope.addingR = secondaryReviewers.length === 0;
    $scope.generalRoles = ['Admin', 'Audit', 'AssetManagement', 'AssetReview', 'AssetManagerReadOnly'];
    $scope.uiEditDueDate = false;
    $scope.userIsAllowed = false;
    $scope.isAssetManager = false;
    $scope.currentUser = currentUser;
    $scope.draftDueDate = UtcDateConverter.getDateFromUTC($scope.review.getDraftDueDate());
    $scope.allReviews = []
    var previousDraft = angular.copy($scope.draftDueDate);

    if ($scope.currentUser) {
      console.log($scope.currentUser)
      getAllAssetReviews();
      verifyUser($scope.currentUser);
    }

    var allAssetUsers = {};
    AssetService.getAssetUsersList(review.asset.id, true).then(function (users) {
      users.forEach(function (user) {
        allAssetUsers[user.user.id] = user;
      })
    });

    function getQuarter(str) {
      switch (str) {
        case '1Q':
          return UtcDateConverter.getDateFromUTC(review.asset.scheduleQ1);
        case '2Q':
          return UtcDateConverter.getDateFromUTC(review.asset.scheduleQ2);
        case '3Q':
          return UtcDateConverter.getDateFromUTC(review.asset.scheduleQ3);
        case '4Q':
          return UtcDateConverter.getDateFromUTC(review.asset.scheduleQ4);
      }
    }

    function verifyUser(user) {
      switch (user.role) {
        case 'AssetManagement':
          $scope.isAssetManager = true;
          if (review.asset.primaryAssetManager && review.asset.primaryAssetManager.user.id === user.id) {
            $scope.userIsAllowed = true;
          } else {
            $scope.userIsAllowed = isUserInList(user, $scope.secondaryAssetManagers);
          }
          break;
        case 'AssetAppraisal':
          if (review.asset.primaryAssetAppraiser && review.asset.primaryAssetAppraiser.user.id === user.id) {
            $scope.userIsAllowed = true;
          } else {
            $scope.userIsAllowed = isUserInList(user, $scope.secondaryAppraisers);
          }
          if (user.userCompanyId !== 14405) {
            $scope.draftDueDate = UtcDateConverter.getDateFromUTC(review.asset['scheduleQ' + review.asset.scheduleOption]);
            if(review.asset.valuationFrequency == 'Quarterly') {
              $scope.draftDueDate = getQuarter(review.vPeriod.substring(0, 2))
            }  else if(review.asset.valuationFrequency == 'SemiAnnually') {
              if(review.quarter == 1 || review.quarter == 2) {
                $scope.draftDueDate = UtcDateConverter.getDateFromUTC(review.asset.scheduleQ1);
              } else {
                $scope.draftDueDate = UtcDateConverter.getDateFromUTC(review.asset.scheduleQ2);
              }
            }
          } else {
            if (review.status.toLowerCase() !== 'finished') {
              if(review.asset.valuationFrequency == 'Quarterly') {
                $scope.draftDueDate = getQuarter(review.vPeriod.substring(0, 2))
              }  else if(review.asset.valuationFrequency == 'SemiAnnually') {
                if(review.quarter == 1 || review.quarter == 2) {
                  $scope.draftDueDate = UtcDateConverter.getDateFromUTC(review.asset.scheduleQ1);
                } else {
                  $scope.draftDueDate = UtcDateConverter.getDateFromUTC(review.asset.scheduleQ2);
                }
              }
            }
          }
          break;
        case 'AssetReview':
          if (review.asset.primaryAssetReviewer && review.asset.primaryAssetReviewer.user.id === user.id) {
            $scope.userIsAllowed = true;
          } else {
            $scope.userIsAllowed = isUserInList(user, $scope.secondaryReviewers);
          }
          break;
        case 'Audit':
          if (review.asset.primaryAssetAuditor && review.asset.primaryAssetAuditor.user.id === user.id) {
            $scope.userIsAllowed = true;
          }
          break;
        case 'Admin':
          $scope.userIsAllowed = true;
          if(review.asset.valuationFrequency == 'Quarterly') {
            $scope.draftDueDate = getQuarter(review.vPeriod.substring(0, 2))
          } else if(review.asset.valuationFrequency == 'SemiAnnually') {
            if(review.quarter == 1 || review.quarter == 2) {
              $scope.draftDueDate = UtcDateConverter.getDateFromUTC(review.asset.scheduleQ1);
            } else {
              $scope.draftDueDate = UtcDateConverter.getDateFromUTC(review.asset.scheduleQ2);
            }
          }
          break;
        default:
          $scope.userIsAllowed = false;
          $scope.isAssetManager = false;
      }
    }

    function isUserInList(user, list) {
      for (var i = 0; i < list.length; i++) {
        if (user.id === list[i].user.id) {
          return true;
        }
      }
      return false;
    }

    function getPeriod(user) {
      for (var i = 0; i < allAssetUsers[user.user.id].periods.length; i++) {
        var tempPeriod = allAssetUsers[user.user.id].periods[i];
        if (tempPeriod.year === $scope.review.year && tempPeriod.quarter === $scope.review.quarter) {
          return tempPeriod;
        }
      }
    }

    function getPeriodIndex(user) {
      for (var i = 0; i < allAssetUsers[user.user.id].periods.length; i++) {
        var tempPeriod = allAssetUsers[user.user.id].periods[i];
        if (tempPeriod.year === $scope.review.year && tempPeriod.quarter === $scope.review.quarter) {
          return i;
        }
      }
    }

    //ADD LEAD USER
    //------------------------------------------
    $scope.addPrimary = function (assetId, user) {
      if (!allAssetUsers[user.user.id]) {
        var type = ''
        switch(user.role) {
          case 'Appraiser':
            type = 'PrimaryAssetAppraiser';
            break;
          case 'AssetManager':
            type = 'PrimaryAssetManager'
            break;
          case 'Reviewer':
            type = 'PrimaryAssetReviewer'
            break;
          case 'Auditor':
            type = 'PrimaryAssetAuditor'
            break;
          default:
            type = '';
            break;
        }

        AssetService.addUser(assetId, user.user.id, type ? type : null, true).then(function (user) {
          $scope.allReviews.forEach(function (valuation) {
            if(valuation.status.toLowerCase() !== 'finished') {
              AssetService.addUserPeriod({
                id: user.id,
                year: valuation.year,
                quarter: valuation.quarter,
                isPrimary: true
              }).then(function (userWithPeriod) {
                allAssetUsers[user.user.id] = userWithPeriod;
                setPrimaryUser(userWithPeriod);
                notifyChanges();
                $rootScope.$emit('valuationUserChanged', $scope.review);
              });
            }
          })
        });
      } else {
        var period = getPeriod(user);
        if (!period) {
          //addPeriod
          $scope.allReviews.forEach(function (valuation) {
            if(valuation.status.toLowerCase() !== 'finished') {
              AssetService.addUserPeriod({
                id: allAssetUsers[user.user.id].id, year: valuation.year, quarter: valuation.quarter,
                isPrimary: true
              }).then(function (userWithPeriod) {
                allAssetUsers[user.user.id] = userWithPeriod;
                setPrimaryUser(userWithPeriod);
                notifyChanges();
                $rootScope.$emit('valuationUserChanged', $scope.review);
              });
            }
          });
        } else if (!period.active) {
          //activatePeriod
          AssetService.updateUserPeriod({ id: period.id, active: true, isPrimary: true }).then(function (updatedPeriod) {
            var i = getPeriodIndex(user);
            allAssetUsers[user.user.id].periods[i] = updatedPeriod;
            setPrimaryUser(allAssetUsers[user.user.id]);
            notifyChanges();
          });
        } else {
          notify({
            message: $filter('translate')('VALUATIONS.USER_VALUATION_ERROR'),
            duration: 4000,
            templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
            classes: 'alert-danger',
            position: 'center'
          });
        }
      }
      $scope.selectedPrimaryAssetManager = "";
    };

    function setPrimaryUser(user) {
      switch (user.userCompanyType) {
        case 'AssetManagement':
          user.type = 'PrimaryAssetManager';
          $scope.selectedAssetManager = "";
          $scope.review.asset.primaryAssetManager = user;
          break;
        case 'AssetAppraisal':
          user.type = 'PrimaryAssetAppraiser';
          $scope.selectedPrimaryAssetAppraiser = "";
          $scope.review.asset.primaryAssetAppraiser = user;
          break;
        case 'AssetReview':
          user.type = 'PrimaryAssetReviewer';
          $scope.selectedPrimaryAssetReviewer = "";
          $scope.review.asset.primaryAssetReviewer = user;
          break;
        case 'Audit':
          user.type = 'PrimaryAssetAuditor';
          $scope.selectedPrimaryAssetAuditor = "";
          $scope.review.asset.primaryAssetAuditor = user;
          break;
        default:
          console.error('no user company type');
      }
    }

    //ADD SECONDARY USER
    //------------------------------------------
    $scope.addSecondary = function (assetId, user) {
      if (!allAssetUsers[user.user.id]) {
        AssetService.addUser(assetId, user.user.id).then(function (user) {
          $scope.allReviews.forEach(function (valuation) {
            if (valuation.status.toLowerCase() !== 'finished') {
              AssetService.addUserPeriod({
                id: user.id,
                year: valuation.year,
                quarter: valuation.quarter,
                isPrimary: false
              }).then(function (userWithPeriod) {
                allAssetUsers[user.user.id] = userWithPeriod;
                addSecondaryUser(user);
                notifyChanges();
                $rootScope.$emit('valuationUserChanged', $scope.review);
              });
            }
          });
        });
      } else {
        var period = getPeriod(user);
        if (!period) {
          //addPeriod
          $scope.allReviews.forEach(function (valuation) {
            if(valuation.status.toLowerCase() !== 'finished') {
              AssetService.addUserPeriod({
                id: allAssetUsers[user.user.id].id,
                year: valuation.year,
                quarter: valuation.quarter,
                isPrimary: false
              }).then(function (userWithPeriod) {
                allAssetUsers[userWithPeriod.user.id] = userWithPeriod;
                userWithPeriod.periods.forEach(function (period) {
                  if(period.quarter == review.quarter && period.year == review.year) {
                    addSecondaryUser(userWithPeriod);
                  }
                });
                notifyChanges();
                $rootScope.$emit('valuationUserChanged', $scope.review);
              });
            }
          });
        } else if (!period.active) {
          //activatePeriod
          AssetService.updateUserPeriod({ id: period.id, active: true }).then(function (updatedPeriod) {
            var i = getPeriodIndex(user);
            allAssetUsers[user.user.id].periods[i] = updatedPeriod;
            addSecondaryUser(allAssetUsers[user.user.id]);
            notifyChanges();
          });
        } else {
          errorSecondaryUser(user);
          notify({
            message: $filter('translate')('VALUATIONS.USER_VALUATION_ERROR'),
            duration: 4000,
            templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
            classes: 'alert-danger',
            position: 'center'
          });
        }
      }
      $scope.addingAp = false;
      $scope.selectedSecondaryAssetManager = "";
    };

    function addSecondaryUser(user) {
      switch (user.userCompanyType) {
        case 'AssetManagement':
          $scope.addingAm = false;
          user.type = 'SecondaryAssetManager';
          $scope.secondaryAssetManagers.push(user);
          $scope.selectedSecondaryAssetManager = "";
          break;
        case 'AssetAppraisal':
          $scope.addingAp = false;
          user.type = 'SecondaryAssetAppraiser';
          $scope.secondaryAppraisers.push(user);
          $scope.selectedSecondaryAppraiser = "";
          break;
        case 'AssetReview':
          $scope.addingR = false;
          user.type = 'SecondaryAssetReviewer';
          $scope.secondaryReviewers.push(user);
          $scope.selectedSecondaryReviewer = "";
          break;
        default:
          console.error('no user company type');
      }
    }

    function errorSecondaryUser(user) {
      switch (user.role) {
        case 'AssetManager':
          $scope.addingAm = false;
          $scope.selectedSecondaryAssetManager = "";
          break;
        case 'Appraiser':
          $scope.addingAp = false;
          $scope.selectedSecondaryAppraiser = "";
          break;
        case 'Reviewer':
          $scope.addingR = false;
          $scope.selectedSecondaryReviewer = "";
          break;
        default:
          console.error('no user company type');
      }
    }

    //REMOVE USER
    //------------------------------------------
    $scope.removeUser = function (user) {
      var period;
      for (var i = 0; i < allAssetUsers[user.user.id].periods.length; i++) {
        var tempPeriod = allAssetUsers[user.user.id].periods[i];
        // if (tempPeriod.year === $scope.review.year && tempPeriod.quarter === $scope.review.quarter) {
        //   period = tempPeriod;
        // }

        var periodReview = $scope.allReviews.find(function(review) {
          return review.year == tempPeriod.year && review.quarter == tempPeriod.quarter
        });
          
          if(periodReview && periodReview.status.toLowerCase() !== 'finished') {
            AssetService.deletePeriod(tempPeriod.id).then(function () {
              allAssetUsers[user.user.id].periods.splice(i-1, 1);
              notifyChanges();
              $rootScope.$emit('valuationUserChanged', $scope.review);
              switch (user.type) {
                case "PrimaryAssetAppraiser":
                  $scope.review.asset.primaryAssetAppraiser = undefined;
                  break;
                case "PrimaryAssetReviewer":
                  $scope.review.asset.primaryAssetReviewer = undefined;
                  break;
                case "PrimaryAssetManager":
                  $scope.review.asset.primaryAssetManager = undefined;
                  break;
                case "PrimaryAssetAuditor":
                  $scope.review.asset.primaryAssetAuditor = undefined;
                  break;
                case "SecondaryAssetAppraiser":
                  $scope.secondaryAppraisers.splice($scope.secondaryAppraisers.indexOf(user), 1);
                  break;
                case "SecondaryAssetReviewer":
                  $scope.secondaryReviewers.splice($scope.secondaryReviewers.indexOf(user), 1);
                  break;
                case "SecondaryAssetManager":
                  $scope.secondaryAssetManagers.splice($scope.secondaryAssetManagers.indexOf(user), 1);
                  break;
              }
            });
          }
      }

      // AssetService.deletePeriod(period.id).then(function () {
      //   var i = getPeriodIndex(user);
      //   allAssetUsers[user.user.id].periods.splice(i, 1);
      //   switch (user.type) {
      //     case "PrimaryAssetAppraiser":
      //       $scope.review.asset.primaryAssetAppraiser = undefined;
      //       break;
      //     case "PrimaryAssetReviewer":
      //       $scope.review.asset.primaryAssetReviewer = undefined;
      //       break;
      //     case "PrimaryAssetManager":
      //       $scope.review.asset.primaryAssetManager = undefined;
      //       break;
      //     case "PrimaryAssetAuditor":
      //       $scope.review.asset.primaryAssetAuditor = undefined;
      //       break;
      //     case "SecondaryAssetAppraiser":
      //       $scope.secondaryAppraisers.splice($scope.secondaryAppraisers.indexOf(user), 1);
      //       break;
      //     case "SecondaryAssetReviewer":
      //       $scope.secondaryReviewers.splice($scope.secondaryReviewers.indexOf(user), 1);
      //       break;
      //     case "SecondaryAssetManager":
      //       $scope.secondaryAssetManagers.splice($scope.secondaryAssetManagers.indexOf(user), 1);
      //       break;
      //   }
      //   if(allAssetUsers[user.user.id].periods.length === 0){
      //     delete allAssetUsers[user.user.id];
      //     AssetService.removeUser(user.id);
      //   }
      //   notifyChanges();
      // });
    };

    //TOGGLE APPRAISER BUTTON
    //------------------------------------------
    $scope.toggleButtonAp = function () {
      $scope.addingAp = true;
    };

    //TOGGLE ASSET MANAGER BUTTON
    //------------------------------------------
    $scope.toggleButtonAm = function () {
      $scope.addingAm = true;
    };

    //TOGGLE REVIEWER BUTTON
    //------------------------------------------
    $scope.toggleButtonR = function () {
      $scope.addingR = true;
    };

    function notifyChanges() {
      notifyChange = true;
    }

    //DRAFT DUE DATE
    //------------------------------------------
    $scope.uiDueDatePicker = {
      opened: false,
      options: {
        startingDay: 1,
        showWeeks: false
      },
      modelOptions: {
        updateOn: 'focusout',
        getterSetter: true,
        debounce: { 'default': 500, 'blur': 0 }
      },
      toggleCalendar: function () {
        $scope.uiDueDatePicker.opened = true;
      },
      uiEditDueDate: false,
      toggleEdit: function () {
        $scope.uiDueDatePicker.uiEditDueDate = !$scope.uiDueDatePicker.uiEditDueDate;
        $scope.uiDueDatePicker.error = false;
        $scope.draftDueDate = angular.copy(previousDraft);
      }
    };


    $scope.saveDueDate = function () {
      if (validateDraft($scope.draftDueDate, $scope.review)) {
        $scope.review.nextDraftDueDate = UtcDateConverter.setDateToUTC($scope.draftDueDate);
        $scope.uiDueDatePicker.error = '';
        ReviewFactory.saveDraftDueDate($scope.review).then(function () {
          notifyChanges();
          $scope.uiDueDatePicker.uiEditDueDate = false;
          $scope.draftDueDate = UtcDateConverter.getDateFromUTC($scope.review.getDraftDueDate());
          previousDraft = $scope.draftDueDate;
          notify({
            message: $filter('translate')('VALUATIONS.DRAFT_DUE_DATE_SAVED'),
            duration: 4000,
            templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
            classes: 'alert-info',
            position: 'center'
          });
        });
      }
      else {
        $scope.uiDueDatePicker.error = true;
      }
    };

    $scope.goToReview = function (assetId, valuationId) {
      $state.go('app.review', { assetId: assetId, valuationId: valuationId }).then(function () {
      }, function (err) {
        var message = $filter('translate')('VALUATIONS.ERROR_START');
        var showMsg = true;
        if (err.code === 'valuation_created') {
          LoaderHelper.open(true);
          $state.go('app.review', { assetId: assetId, valuationId: err.valuation.id });
          showMsg = false;
        } else if (err.code === 'not_appraiser_assigned') {
          message = $filter('translate')('VALUATIONS.ERROR_NOT_APPRAISER');
        } else if (err.code === 'not_in_schedule') {
          message = $filter('translate')('VALUATIONS.ERROR_NOT_DATE');
        }
        if (showMsg) {
          notify({
            message: message,
            duration: 4000,
            templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
            classes: 'alert-danger',
            position: 'center'
          });
        }
      });
    };

    function getAllAssetReviews () {
      ReviewFactory.loadAllAssetReviews(review.asset, $scope.currentUser.role, $scope.currentUser.userCompanyId).then(function (reviews) {
        $scope.allReviews = reviews
      });
    }

    function validateDraft(date, review) {
      date = moment(date);
      var nextDraftDueDate = moment(UtcDateConverter.getDateFromUTC(review.nextDraftDueDate));
      var currentQuarter = ReviewModel.getQuarterByDate(UtcDateConverter.getDateFromUTC(review.nextDraftDueDate)),
        newDateQuarter = ReviewModel.getQuarterByDate(date);

      return !(newDateQuarter !== currentQuarter || nextDraftDueDate.get('year') !== date.get('year'));
    }

    $scope.$on('$destroy', function () {
      if (notifyChange) {
        $rootScope.$emit('valuationLateralReviewChanged', $scope.review);
      }
    });
  }

})();

(function(){
  'use strict';

  angular
  .module('nvc')
  .config(routeConfig);

  function routeConfig($stateProvider){
    $stateProvider.state('reset-password', {
      url: '/reset-password?token&email',
      views: {
        'content@': {
          templateUrl: 'app/states/reset-password/reset-password.html',
          controller: 'ResetPasswordController',
          controllerAs: 'resetPassword'
        },
        'topnavbar@': {
          templateUrl: 'app/states/reset-password/topnavbar.html'
        }
      },
      data: {
        pageTitle: 'Reset Password',
        roles: [],
        viewClass:'reset-password'
      },
      params: {
        token: undefined,
        email: undefined
      },
      resolve: {
        /** @ngInject */
        credentials: function ($q, $stateParams) {
          if (!$stateParams.token || !$stateParams.email) {
            return $q.reject({
              error: 'invalidTransition',
              fallback: 'login'
            });
          }
          return {
            email: $stateParams.email,
            token: $stateParams.token
          }
        }
      }
    });
  }

})();
(function(){

  'use strict';

  angular.module('nvc')
  .controller('ResetPasswordController', ResetPasswordController);

  function ResetPasswordController($state, $filter, notify, credentials, LoaderHelper, UserAccountService) {
    var vm = this;
    vm.formData = {};
    vm.resetPasswordForm = {};
    vm.submitted = false;
    vm.submitForm = submitForm;
    vm.successful = false;
    vm.failed = false;

    function submitForm() {
      vm.submitted = true;
      if (vm.resetPasswordForm.$invalid) {
        return;
      }
      LoaderHelper.open();
      UserAccountService.resetPassword(angular.merge({},{password:vm.formData.password},credentials)).then(function(){
        notify({
          message: $filter('translate')('COMMONS.RESET_PASSWORD'),
          duration: 4000,
          templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
          classes: 'alert-info',
          position: 'center'
        });
        $state.go('login');
      }, function() {
        LoaderHelper.close();
      });
    }
  }

})();
(function () {
  'use strict';

  angular
    .module('nvc')
    .config(routeConfig);

  function routeConfig($stateProvider) {
    $stateProvider.state('app.requests', {
      abstract: true,
      url: '/requests',
      data: {
        pageTitle: 'Requests',
        roles: ['AssetAppraisal']
      }
    });
  }

})();
(function(){
  'use strict';

  angular
  .module('nvc')
  .config(routeConfig);

  function routeConfig($stateProvider){
    $stateProvider.state('app.minor', {
      url: '/minor',
      templateUrl: 'app/states/minor/minor.html',
      data: {
        pageTitle: 'Example view',
        roles: []
      }
    });
  }

})();
(function () {
  'use strict';

  angular
  .module('nvc')
  .config(routeConfig);

  function routeConfig($stateProvider) {
    $stateProvider.state('app.manage', {
      abstract: true,
      url: '/manage',
      data: {
        pageTitle: 'Manage',
        roles: ['Admin']
      }
    });
  }

})();
(function () {
  'use strict';

  angular
  .module('nvc')
  .config(routeConfig);

  function routeConfig($stateProvider) {
    $stateProvider.state('app.main', {
      url: '/main',
      templateUrl: 'app/states/main/main.html',
      controller: 'MainController',
      controllerAs: 'main',
      data: {
        pageTitle: 'Example view',
        roles: ['Admin', 'Audit', 'AssetManagement', 'AssetAppraisal', 'AssetReview', 'AssetManagerReadOnly']
      }
    });
  }

})();
(function() {
'use strict';

angular.module('nvc')
  .controller('MainController', MainController);

  function MainController ($scope, $filter, SweetAlert, $uibModal) {

    var vm = this;

    vm.userName = 'Example user';
    vm.helloText = 'Welcome in INSPINIA Gulp SeedProject';
    vm.descriptionText = 'It is an application skeleton for a typical AngularJS web app. You can use it to quickly bootstrap your angular webapp projects.';
    console.log('main');

    //SWEET ALERT
    //----------------------------------------------

    $scope.openSweetGeneralError = function () {
      SweetAlert.swal({
        title: $filter('translate')('GENERAL_ERROR.MAIN_TITLE'),
        text: 'The server encountered an internal error. Please try again later.',
        type: 'error',
        confirmButtonColor: '#283848',
        confirmButtonText: 'Close'
      });
    };

    //MODAL
    //----------------------------------------------

    $scope.openModalGeneralError = function () {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/components/commons/messages/pop-up/general-error/general-error-pop-up.html',
        controller: 'GeneralErrorModalController'
      });
    };

  }
  
})();

(function () {
  'use strict';

  angular
  .module('nvc')
  .config(routeConfig);

  function routeConfig($stateProvider) {
    $stateProvider.state('login', {
      url: '/login',
      views: {
        'content@': {
          templateUrl: 'app/states/login/login.html',
          controller: 'LoginController',
          controllerAs: 'login'
        }
      },
      data: {
        pageTitle: 'Login',
        roles: [],
        viewClass: 'login'
      }
    });
  }

})();

(function (){
'use strict';

angular.module('nvc')
  .controller('LoginController', LoginController);

  /** @Inject*/
  function LoginController ($state, $filter, LoaderHelper, UserAccountService, SweetAlert) {
    var vm = this;
    vm.formData = {
      rememberMe: true
    };
    vm.submitted = false;
    vm.submitForm = submitForm;

    vm.loginForm = {};

    function submitForm() {
      vm.submitted = true;
      if (vm.loginForm.$invalid) {
        return;
      }

      UserAccountService.login(vm.formData).then(function(){
        LoaderHelper.open();
        $state.go('app.valuations');
      }, function(response){
        if(response.status == 400 && response.data.error == 'Invalid Request') {
          SweetAlert.swal({
            title: $filter('translate')('LOGIN.WRONG_CREDENTIALS'),
            text: $filter('translate')('LOGIN.WRONG_CREDENTIALS_TEXT'),
            type: "warning",
            confirmButtonColor: '#2c3d4e',
            confirmButtonText: $filter('translate')('COMMONS.OK'),
            closeOnConfirm: true,
            closeOnCancel: true
          });
        }
      });

    }
  }

})();

(function () {
  'use strict';

  angular
  .module('nvc')
  .config(routeConfig);

  function routeConfig($stateProvider) {
    $stateProvider.state('forgotPassword', {
      url: '/forgot-password',
      views: {
        'content@': {
          templateUrl: 'app/states/forgot-password/forgot-password.html',
          controller: 'ForgotPasswordController',
          controllerAs: 'forgotPassword'
        }
      },
      data: {
        pageTitle: 'Forgot Password',
        roles: [],
        viewClass: 'forgot-password'
      }
    });
  }

})();
(function (){
'use strict';

angular.module('nvc')
  .controller('ForgotPasswordController', ForgotPasswordController);

  /** @Inject*/
  function ForgotPasswordController ($state, $filter, LoaderHelper, UserAccountService, notify, SweetAlert) {
    var vm = this;
    vm.formData = {};
    vm.submitted = false;
    vm.submitForm = submitForm;

    vm.forgotPasswordForm = {};

    function submitForm() {
      vm.submitted = true;

      if (vm.forgotPasswordForm.$invalid) {
          return;
      }

      LoaderHelper.open();

      UserAccountService.forgotPassword(vm.formData).then(function(){
        notify({
          message: $filter('translate')('COMMONS.FORGOT_PASSWORD_REQUEST'),
          duration: 4000,
          templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
          classes: 'alert-info',
          position: 'center'
        });
        $state.go('login');
      },function(response){
        LoaderHelper.close();
        if(response.status === 400 && response.statusText === "Bad Request"){
          SweetAlert.swal({
            title: $filter('translate')('FORGOT_PASSWORD.WRONG_EMAIL'),
            text: $filter('translate')('FORGOT_PASSWORD.WRONG_EMAIL_TEXT'),
            type: "warning",
            confirmButtonColor: '#2c3d4e',
            confirmButtonText: $filter('translate')('COMMONS.OK'),
            closeOnConfirm: true,
            closeOnCancel: true
          });
        }
      });
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .config(routeConfig);

  function routeConfig($stateProvider) {
    $stateProvider.state('app.bidEngagement', {
      abstract: true,
      url: '/bid-engagement',
      data: {
        pageTitle: 'Bid Engagement',
        roles: ['Admin']
      }
    });
  }

})();
(function () {
  'use strict';

  angular
  .module('nvc')
  .config(routeConfig);

  function routeConfig($stateProvider) {
    $stateProvider.state('app.asset', {
      abstract: true,
      url: '/asset',
      data: {
        pageTitle: 'Manage',
        roles: ['Admin']
      }
    })

    .state('app.asset.all', {
      url: '/list',
      views: {
        "@app": {
          templateUrl: 'app/states/assets/assets.html',
          controller: 'AssetsController',
          controllerAs: 'assets'
        }
      },
      data: {
        pageTitle: 'Assets',
        roles: ['Admin', 'Audit', 'AssetManagement', 'AssetReview', 'AssetAppraisal', 'AssetManagerReadOnly']
      },
      resolve: {
        /** @ngInject */
        companies: function (CompanyService) {
          return CompanyService.getClientCompanies(true, true);
        },
        /** @ngInject */
        propertyTypes: function (StaticDataService) {
          return StaticDataService.getPropertyTypes();
        }
      }
    });
  }

})();
(function () {
  'use strict';

  angular
    .module('nvc')
    .controller('AssetsController', AssetsController);

  /** @ngInject */
  function AssetsController($scope, $q, $filter, $state, SweetAlert, CompanySelectorFactory, ValuationService, AssetService,
    BidGroupService, UserService, LoaderHelper, companies, propertyTypes, notify,
    SessionManager, ArrayHelper, CSVService, PDFGenerator, $uibModal, UtcDateConverter, EnvironmentConfig) {
    var vm = this;
    var promises = [];
    var selectedCompanyId;
    vm.allAssetsSelected = false;
    vm.searchQuery = '';
    vm.propertyTypes = propertyTypes.items;
    vm.selectedAssets = 0;
    vm.isAppraiser = false;
    vm.isReadOnly = false;
    vm.isAssetManager = false;
    vm.isAudit = false;
    vm.isReviewer = false;
    vm.selectedAll = false;
    vm.futureValuations = false;
    vm.onceNotification = false;
    vm.canBringFutureValuations = EnvironmentConfig.FUTURE_VALUATIONS;

    vm.assetsSort = [
      {
        tag: 'Name',
        selected: true,
        flag: true,
        order: 'Ascending'
      },
      {
        tag: 'PropertyRef',
        selected: false,
        flag: false,
        order: 'Ascending'
      },
      {
        tag: 'Location',
        selected: false,
        flag: false,
        order: 'Ascending'
      },
      {
        tag: 'Manager',
        selected: false,
        flag: false,
        order: 'Ascending'
      },
      {
        tag: 'Period',
        selected: false,
        flag: false,
        order: 'Ascending'
      },
      {
        tag: 'BidGroup',
        selected: false,
        flag: false,
        order: 'Ascending'
      },
      {
        tag: 'Type',
        selected: false,
        flag: false,
        order: 'Ascending'
      },
      {
        tag: 'Active',
        selected: false,
        flag: false,
        order: 'Ascending'
      }
    ];
    vm.assetsSelectedSort = vm.assetsSort[0];

    vm.perPage = 17;
    vm.maxPaginationSize = 7;

    var role = SessionManager.getRoleName();

    switch (role) {
      case 'AssetAppraisal':
        vm.isAppraiser = true;
        break;
      case 'AssetManagerReadOnly':
        vm.isReadOnly = true;
        break;
      case 'AssetManagement':
        vm.isAssetManager = true;
        break;
      case 'Audit':
        vm.isAudit = true;
        break;
      case 'AssetReview':
        vm.isReviewer = true;
        break;
      default:
        break;
    }

    //BREADCRUMS
    //-------------------------------------------------------
    vm.title = $filter('translate')('ASSETS.TITLE');
    vm.breadcrumbs = [
      {
        label: $filter('translate')('ASSETS.TITLE'),
        value: 'app.asset.all'
      },
      {
        label: $filter('translate')('ASSETS.ASSETS_LIST'),
        value: 'app.asset.all'
      }
    ];

    //SORTING
    //------------------------------------------
    vm.sorting = function (sort, target) {
      ArrayHelper.beSort(sort, target, vm.assetsSort, vm);
      loadAssets();
    };

    //SEARCH FUNCTION
    //------------------------------------------
    vm.searchAssets = function () {
      if (vm.searchQuery.length > 2 || !vm.searchQuery) {
        loadAssets();
      }
    };

    vm.searchAsset = function (item) {
      return ArrayHelper.filterByProperties(item, vm.searchQuery, ['propertyRef', 'name', 'address.city',
        'address.state', 'primaryAssetManager.user.name', 'vperiod', 'bidGroupName', 'typeName']);
      /*  property type*/
    };

    //ACTIVATE ASSET
    //-------------------------------------------------------
    vm.activateAsset = function () {
      promises = [];
      vm.assets.forEach(function (asset) {
        if (asset.selected && !asset.active) {
          asset.active = true;
          var assetDTO = {};
          assetDTO.id = asset.id;
          assetDTO.active = asset.active;
          promises.push(AssetService.updateAsset(assetDTO).then(function () {
            var currentDate = new moment();
            var quarter = 1;
            var oldestQuarterDate = asset.scheduleQ1;
            if (oldestQuarterDate > asset.scheduleQ2) {
              oldestQuarterDate = asset.scheduleQ2;
              quarter = 2;
            }
            if (oldestQuarterDate > asset.scheduleQ3) {
              oldestQuarterDate = asset.scheduleQ3;
              quarter = 3;
            }
            if (oldestQuarterDate > asset.scheduleQ4) {
              oldestQuarterDate = asset.scheduleQ4;
              quarter = 4;
            }
            if (oldestQuarterDate < (new Date).getTime()) {

              ValuationService.listValuationsByAssetId(asset.id).then(function (valuations) {
                var oldestValuation = valuations && valuations.length > 0 ? valuations[0] : undefined;
                for (var i = 0; i < valuations.length; i++) {
                  if (valuations[i].year === currentDate.get('year') && valuations[i].quarter === ReviewModel.getQuarterByDate(currentDate)) {
                    return;
                  }
                  if (valuations[i].year >= oldestValuation.year && valuations[i].quarter > oldestValuation.quarter) {
                    oldestValuation = valuations[i];
                  }
                }
                var currentQuarter = ReviewModel.getQuarterByDate(currentDate),
                  quarterOfCycle,
                  yearOfCycle,
                  nextDraftDueDate = moment(asset['scheduleQ' + currentQuarter]);
                nextDraftDueDate.set('year', currentDate.get('year'));
                var currentYear = currentDate.get('year');
                if (!oldestValuation || Object.keys(oldestValuation).length == 0) {
                  var latestQuarterMomentDate = new moment(oldestQuarterDate);
                  yearOfCycle = currentYear - latestQuarterMomentDate.get('year');
                  quarterOfCycle = yearOfCycle * 4;
                  quarter = ReviewModel.getQuarterByDate(currentDate);
                  quarterOfCycle += quarter - ReviewModel.getQuarterByDate(latestQuarterMomentDate) + 1;
                  if (quarter >= ReviewModel.getQuarterByDate(latestQuarterMomentDate)) {
                    yearOfCycle++;
                  }
                  ValuationService.createValuation({
                    assetId: asset.id,
                    year: currentYear,
                    quarter: currentQuarter,
                    yearOfCycle: yearOfCycle,
                    quarterOfCycle: quarterOfCycle,
                    nextDraftDueDate: nextDraftDueDate.valueOf()
                  });
                } else {
                  quarterOfCycle = oldestValuation.quarterOfCycle + 1;
                  yearOfCycle = Math.ceil(quarterOfCycle / 4);
                  ValuationService.createValuation({
                    assetId: asset.id,
                    year: currentYear,
                    quarter: currentQuarter,
                    yearOfCycle: yearOfCycle,
                    quarterOfCycle: quarterOfCycle,
                    nextDraftDueDate: nextDraftDueDate.valueOf()
                  });
                  UserService.getUsersByValuationId(oldestValuation.id, asset.id).then(function (users) {
                    replicateUsers(users, currentQuarter, currentYear);
                  });
                }
              });
            }
          }));
          asset.selected = false;
        }
      });
      if (promises.length > 0) {
        $q.all(promises).then(function () {
          notifyResults('active');
        });
      }
    };

    function replicateUsers(users, quarter, year) {
      users.forEach(function (user) {
        var periodDTO = { quarter: quarter, year: year, id: user.id, isPrimary: user.period.isPrimary };
        AssetService.addUserPeriod(periodDTO);
      });
    }

    //INACTIVATE ASSET
    //-------------------------------------------------------
    vm.inactivateAsset = function () {
      promises = [];
      vm.assets.forEach(function (asset) {
        if (asset.selected && asset.active) {
          asset.active = false;
          var assetDTO = {};
          assetDTO.id = asset.id;
          assetDTO.active = asset.active;
          assetDTO.bidGroupId = null;
          promises.push(AssetService.updateAsset(assetDTO));
          asset.selected = false;
        }
      });
      if (promises.length > 0) {
        $q.all(promises).then(function () {
          notifyResults('inactive');
        });
      }
    };

    //DELETE ASSET
    //-------------------------------------------------------
    vm.deleteAsset = function () {
      var assetsToDelete = [];
      var text = $filter('translate')('ASSETS.YOU_ARE_ABOUT_TO_DELETE');
      vm.assets.forEach(function (asset) {
        if (asset.selected) {
          assetsToDelete.push(asset);
          text += '\n' + asset.name;
        }
      });
      if (assetsToDelete.length > 0) {

        SweetAlert.swal({
          title: $filter('translate')('ASSETS.ARE_YOU_SURE'),
          text: text,
          showCancelButton: true,
          cancelButtonText: $filter('translate')('ASSETS.CANCEL'),
          confirmButtonColor: '#2c3d4e',
          confirmButtonText: $filter('translate')('ASSETS.YES_DELETE'),
          closeOnConfirm: true,
          closeOnCancel: true,
          allowEscapeKey: false
        }, function (isConfirm) {
          if (isConfirm) {
            promises = [];
            assetsToDelete.forEach(function (asset) {
              promises.push(AssetService.deleteAsset(asset.id));
            });
            if (promises.length > 0) {
              $q.all(promises).then(function () {
                assetsToDelete.forEach(function (asset) {
                  vm.assets.splice(vm.assets.indexOf(asset), 1);
                });
                notifyResults('delete');
              });
            }
          }
        })
      }
    };

    //ACTIVATE VALUATIONS
    //-------------------------------------------------------
    vm.activateValuations = function () {
      promises = [];
      var currentDate = new moment();
      var currentQuarter = ReviewModel.getQuarterByDate(currentDate), currentYear = currentDate.get('year');

      var newValuationPromises = [];
      var isAnyValuationToActivate = false;

      var selected = vm.assets.filter(function (asset) {
        return asset.selected == true
      })

      if (selected.length > 0) {
        SweetAlert.swal({
          title: $filter('translate')('ASSETS.ACTIVATE_VALUATIONS'),
          text: $filter('translate')('ASSETS.ARE_YOU_SURE_TO_ACTIVATE'),
          showCancelButton: true,
          cancelButtonText: $filter('translate')('ASSETS.YES'),
          confirmButtonColor: '#2c3d4e',
          confirmButtonText: $filter('translate')('ASSETS.CANCEL'),
          closeOnConfirm: true,
          closeOnCancel: true
        },
          function (isConfirm) {
            if (!isConfirm) {
              vm.assets.forEach(function (asset) {
                if (asset.selected && asset.valuation && (asset.valuation.year != currentYear || asset.valuation.quarter != currentQuarter) && asset.active) {

                  var newPeriod = null,
                    newValuationYear = null,
                    newValuationQuarter = null,
                    nextDraftDate = null;

                  if ('Annually' === asset.valuationFrequency
                    && (ReviewModel.getQuarterByDate(asset.scheduleQ1) === currentQuarter)
                    && (new moment(asset.scheduleQ1).get('year') <= currentYear)) {
                    newValuationQuarter = ReviewModel.getQuarterByDate(asset.scheduleQ1);
                    newValuationYear = currentYear;
                    nextDraftDate = new moment(asset.scheduleQ1);
                    nextDraftDate.set('year', currentYear);
                    newPeriod = {
                      id: undefined,
                      year: newValuationYear,
                      quarter: newValuationQuarter,
                      isPrimary: true
                    };
                  } else if ('SemiAnnually' === asset.valuationFrequency) {
                    if ((ReviewModel.getQuarterByDate(asset.scheduleQ1) === currentQuarter)
                      && (new moment(asset.scheduleQ1).get('year') <= currentYear)) {
                      newValuationQuarter = ReviewModel.getQuarterByDate(asset.scheduleQ1);
                      newValuationYear = currentYear;
                      nextDraftDate = new moment(asset.scheduleQ1);
                      nextDraftDate.set('year', currentYear);
                      newPeriod = {
                        id: undefined,
                        year: newValuationYear,
                        quarter: newValuationQuarter,
                        isPrimary: true
                      };

                    } else if ((ReviewModel.getQuarterByDate(asset.scheduleQ2) === currentQuarter)
                      && (new moment(asset.scheduleQ2).get('year') <= currentYear)) {
                      newValuationQuarter = ReviewModel.getQuarterByDate(asset.scheduleQ2);
                      newValuationYear = currentYear;
                      nextDraftDate = new moment(asset.scheduleQ2);
                      nextDraftDate.set('year', currentYear);
                      newPeriod = {
                        id: undefined,
                        year: newValuationYear,
                        quarter: newValuationQuarter,
                        isPrimary: true
                      };
                    }
                  } else if ('Quarterly' === asset.valuationFrequency) {
                    newValuationQuarter = currentQuarter;
                    newValuationYear = currentYear;
                    nextDraftDate = new moment(asset['scheduleQ' + currentQuarter]);
                    nextDraftDate.set('year', currentYear);
                    newPeriod = {
                      id: undefined,
                      year: newValuationYear,
                      quarter: newValuationQuarter,
                      isPrimary: true
                    };
                  }

                  if (newPeriod) {
                    isAnyValuationToActivate = true;
                    AssetService.getAssetUsersList(asset.id).then(function (usersArray) {
                      var users = {};
                      if (asset.primaryAssetReviewer) {
                        var primaryReviewerPeriod = asset.primaryAssetReviewer.periods.find(function (period) {
                          return newPeriod.quarter == period.quarter &&
                            newPeriod.year == period.year && period.isPrimary
                        });

                        if (!primaryReviewerPeriod) {
                          newValuationPromises.push(AssetService.addUserPeriod(
                            {
                              id: asset.primaryAssetReviewer.id,
                              year: newPeriod.year,
                              quarter: newPeriod.quarter,
                              isPrimary: newPeriod.isPrimary
                            }));
                        }
                      } else {
                        var reviewer = usersArray.find(function (user) { return user.userCompanyType == "AssetReview" });
                        if (reviewer) {
                          var reviewerPeriod = reviewer.periods.find(function (period) {
                            return asset.valuation.quarter == period.quarter &&
                              asset.valuation.year == period.year && period.isPrimary
                          })
                          var currentPriod = reviewer.periods.find(function (period) {
                            return newPeriod.quarter == period.quarter &&
                              newPeriod.year == period.year && period.isPrimary
                          });
                        }

                        if (reviewerPeriod && !currentPriod) {
                          newValuationPromises.push(AssetService.addUserPeriod(
                            {
                              id: reviewer.id,
                              year: newPeriod.year,
                              quarter: newPeriod.quarter,
                              isPrimary: newPeriod.isPrimary
                            }));
                        }
                      }
                      if (asset.primaryAssetManager) {
                        var currentPrimaryManagerPriod = asset.primaryAssetManager.periods.find(function (period) {
                          return newPeriod.quarter == period.quarter &&
                            newPeriod.year == period.year && period.isPrimary
                        });
                        if (!currentPrimaryManagerPriod) {
                          newValuationPromises.push(AssetService.addUserPeriod(
                            {
                              id: asset.primaryAssetManager.id,
                              year: newPeriod.year,
                              quarter: newPeriod.quarter,
                              isPrimary: newPeriod.isPrimary
                            }
                          ));
                        }

                      } else {
                        var assetManager = usersArray.find(function (user) { return user.userCompanyType == "AssetManagement" });
                        if (assetManager) {
                          var period = assetManager.periods.find(function (period) {
                            return asset.valuation.quarter == period.quarter &&
                              asset.valuation.year == period.year && period.isPrimary
                          });
                          var currentManagerPriod = assetManager.periods.find(function (period) {
                            return newPeriod.quarter == period.quarter &&
                              newPeriod.year == period.year && period.isPrimary
                          });
                        }

                        if (period && !currentManagerPriod) {
                          newValuationPromises.push(AssetService.addUserPeriod(
                            {
                              id: assetManager.id,
                              year: newPeriod.year,
                              quarter: newPeriod.quarter,
                              isPrimary: newPeriod.isPrimary
                            }));
                        }
                      }
                      asset.users = users;
                      var yearOfCycle = 1,
                        quarterOfCycle = 1,
                        quarter = currentQuarter,
                        firstQuarter = asset.valuation.quarter,
                        firstYear = asset.valuation.year,
                        oldestQuarter = ReviewModel.getQuarterByDate(asset.scheduleQ1)

                      yearOfCycle = currentYear - firstYear;

                      if ('Annually' === asset.valuationFrequency) {
                        yearOfCycle++;
                        quarterOfCycle = yearOfCycle;
                      } else if ('SemiAnnually' === asset.valuationFrequency) {
                        quarterOfCycle = yearOfCycle * 2;
                        oldestQuarter = firstQuarter;
                        var recentQuarter = currentQuarter;
                        if (oldestQuarter <= quarter && recentQuarter <= quarter) {
                          quarterOfCycle += 2;
                        } else if ((oldestQuarter <= quarter && recentQuarter > quarter) ||
                          (oldestQuarter > quarter && recentQuarter <= quarter)) {
                          quarterOfCycle += 1;
                        }
                      } else if ('Quarterly' === asset.valuationFrequency) {
                        quarterOfCycle = yearOfCycle * 4;
                        quarterOfCycle += quarter - firstQuarter + 1;
                      }

                      newValuationPromises.push(ValuationService.createValuation({
                        assetId: asset.id,
                        year: newValuationYear,
                        quarter: newValuationQuarter,
                        yearOfCycle: yearOfCycle == 0 ? 1 : yearOfCycle,
                        quarterOfCycle: quarterOfCycle,
                        valuationCycle: asset.valuation && asset.valuation.valuationCycle ? asset.valuation.valuationCycle : 1,
                        nextDraftDueDate: UtcDateConverter.setDateToUTC(nextDraftDate)
                      }));
                    });
                  }

                }
              });
              if (isAnyValuationToActivate) {
                $q.all(newValuationPromises).then(function () {
                  $state.go($state.current, {}, { reload: true });
                  notifyResults('activeValuations')
                }, function () {
                  vm.uiLoading = false;
                  LoaderHelper.close();
                });
              } else {
                notifyResults('noValuations')
              }
            }
            else {
              LoaderHelper.close();
            }
          }
        );
      }
    }

    function activateValuationForFutureValuationsHelper(asset, currentQuarter, currentYear, newValuationPromises, isAnyValuationToActivate) {

      var newPeriod = null,
        newValuationYear = null,
        newValuationQuarter = null,
        nextDraftDate = null;

      if ('Annually' === asset.valuationFrequency
        && (ReviewModel.getQuarterByDate(asset.scheduleQ1) === currentQuarter)
        && (new moment(asset.scheduleQ1).get('year') <= currentYear)) {
        newValuationQuarter = ReviewModel.getQuarterByDate(asset.scheduleQ1);
        newValuationYear = currentYear;
        nextDraftDate = new moment(asset.scheduleQ1);
        nextDraftDate.set('year', currentYear);
        newPeriod = {
          id: undefined,
          year: newValuationYear,
          quarter: newValuationQuarter,
          isPrimary: true
        };
      } else if ('SemiAnnually' === asset.valuationFrequency) {
        if ((ReviewModel.getQuarterByDate(asset.scheduleQ1) === currentQuarter)
          && (new moment(asset.scheduleQ1).get('year') <= currentYear)) {
          newValuationQuarter = ReviewModel.getQuarterByDate(asset.scheduleQ1);
          newValuationYear = currentYear;
          nextDraftDate = new moment(asset.scheduleQ1);
          nextDraftDate.set('year', currentYear);
          newPeriod = {
            id: undefined,
            year: newValuationYear,
            quarter: newValuationQuarter,
            isPrimary: true
          };

        } else if ((ReviewModel.getQuarterByDate(asset.scheduleQ2) === currentQuarter)
          && (new moment(asset.scheduleQ2).get('year') <= currentYear)) {
          newValuationQuarter = ReviewModel.getQuarterByDate(asset.scheduleQ2);
          newValuationYear = currentYear;
          nextDraftDate = new moment(asset.scheduleQ2);
          nextDraftDate.set('year', currentYear);
          newPeriod = {
            id: undefined,
            year: newValuationYear,
            quarter: newValuationQuarter,
            isPrimary: true
          };
        }
      } else if ('Quarterly' === asset.valuationFrequency) {
        newValuationQuarter = currentQuarter;
        newValuationYear = currentYear;
        nextDraftDate = new moment(asset['scheduleQ' + currentQuarter]);
        nextDraftDate.set('year', currentYear);
        newPeriod = {
          id: undefined,
          year: newValuationYear,
          quarter: newValuationQuarter,
          isPrimary: true
        };
      }

      if (newPeriod) {
        isAnyValuationToActivate = true;
        AssetService.getAssetUsersList(asset.id).then(function (usersArray) {
          var users = {};
          if (asset.primaryAssetReviewer) {
            var primaryReviewerPeriod = asset.primaryAssetReviewer.periods.find(function (period) {
              return newPeriod.quarter == period.quarter &&
                newPeriod.year == period.year && period.isPrimary
            });

            if (!primaryReviewerPeriod) {
              newValuationPromises.push(AssetService.addUserPeriod(
                {
                  id: asset.primaryAssetReviewer.id,
                  year: newPeriod.year,
                  quarter: newPeriod.quarter,
                  isPrimary: newPeriod.isPrimary
                }));
            }
          } else {
            var reviewer = usersArray.find(function (user) { return user.userCompanyType == "AssetReview" });
            if (reviewer) {
              var reviewerPeriod = reviewer.periods.find(function (period) {
                return asset.valuation.quarter == period.quarter &&
                  asset.valuation.year == period.year && period.isPrimary
              })
              var currentPriod = reviewer.periods.find(function (period) {
                return newPeriod.quarter == period.quarter &&
                  newPeriod.year == period.year && period.isPrimary
              });
            }

            if (reviewerPeriod && !currentPriod) {
              newValuationPromises.push(AssetService.addUserPeriod(
                {
                  id: reviewer.id,
                  year: newPeriod.year,
                  quarter: newPeriod.quarter,
                  isPrimary: newPeriod.isPrimary
                }));
            }
          }
          if (asset.primaryAssetManager) {
            var currentPrimaryManagerPriod = asset.primaryAssetManager.periods.find(function (period) {
              return newPeriod.quarter == period.quarter &&
                newPeriod.year == period.year && period.isPrimary
            });
            if (!currentPrimaryManagerPriod) {
              newValuationPromises.push(AssetService.addUserPeriod(
                {
                  id: asset.primaryAssetManager.id,
                  year: newPeriod.year,
                  quarter: newPeriod.quarter,
                  isPrimary: newPeriod.isPrimary
                }
              ));
            }

          } else {
            var assetManager = usersArray.find(function (user) { return user.userCompanyType == "AssetManagement" });
            if (assetManager) {
              var period = assetManager.periods.find(function (period) {
                return asset.valuation.quarter == period.quarter &&
                  asset.valuation.year == period.year && period.isPrimary
              });
              var currentManagerPriod = assetManager.periods.find(function (period) {
                return newPeriod.quarter == period.quarter &&
                  newPeriod.year == period.year && period.isPrimary
              });
            }

            if (period && !currentManagerPriod) {
              newValuationPromises.push(AssetService.addUserPeriod(
                {
                  id: assetManager.id,
                  year: newPeriod.year,
                  quarter: newPeriod.quarter,
                  isPrimary: newPeriod.isPrimary
                }));
            }
          }

          if (asset.requiredAppraisers === "InternalAndExternal") {
            if (asset.valuationFrequency === "SemiAnnually") {
              if (asset.scheduleOption == 1 && asset.valuation.quarter != 1) {
                assignInternalAppraisers(asset, newPeriod, newValuationPromises);
              } else if (asset.scheduleOption == 2 && asset.valuation.quarter != 2) {
                assignInternalAppraisers(asset, newPeriod, newValuationPromises);
              }
            } else if (asset.valuationFrequency === "Quarterly") {
              if (asset.scheduleOption == 1 && asset.valuation.quarter != 1) {
                assignInternalAppraisers(asset, newPeriod, newValuationPromises);
              } else if (asset.scheduleOption == 2 && asset.valuation.quarter != 2) {
                assignInternalAppraisers(asset, newPeriod, newValuationPromises);
              } else if (asset.scheduleOption == 3 && asset.valuation.quarter != 3) {
                assignInternalAppraisers(asset, newPeriod, newValuationPromises);
              } else if (asset.scheduleOption == 4 && asset.valuation.quarter != 4) {
                assignInternalAppraisers(asset, newPeriod, newValuationPromises);
              }
            }

          }

          asset.users = users;
          var yearOfCycle = 1,
            quarterOfCycle = 1,
            quarter = currentQuarter,
            firstQuarter = asset.valuation.quarter,
            firstYear = asset.valuation.year,
            oldestQuarter = ReviewModel.getQuarterByDate(asset.scheduleQ1)

          yearOfCycle = currentYear - firstYear;

          if ('Annually' === asset.valuationFrequency) {
            yearOfCycle++;
            quarterOfCycle = yearOfCycle;
          } else if ('SemiAnnually' === asset.valuationFrequency) {
            quarterOfCycle = yearOfCycle * 2;
            oldestQuarter = firstQuarter;
            var recentQuarter = currentQuarter;
            if (oldestQuarter <= quarter && recentQuarter <= quarter) {
              quarterOfCycle += 2;
            } else if ((oldestQuarter <= quarter && recentQuarter > quarter) ||
              (oldestQuarter > quarter && recentQuarter <= quarter)) {
              quarterOfCycle += 1;
            }
          } else if ('Quarterly' === asset.valuationFrequency) {
            quarterOfCycle = yearOfCycle * 4;
            quarterOfCycle += quarter - firstQuarter + 1;
          }

          newValuationPromises.push(ValuationService.createValuation({
            assetId: asset.id,
            year: newValuationYear,
            quarter: newValuationQuarter,
            yearOfCycle: yearOfCycle == 0 ? 1 : yearOfCycle,
            quarterOfCycle: quarterOfCycle,
            valuationCycle: asset.valuation && asset.valuation.valuationCycle ? asset.valuation.valuationCycle : 1,
            nextDraftDueDate: UtcDateConverter.setDateToUTC(nextDraftDate)
          }).then(function () {
            if (vm.onceNotification == false) {
              notifyResults('activeValuations')
              vm.onceNotification = true
            }
          }));
        });
      }
      return isAnyValuationToActivate;
    }

    vm.activateValuationForFutureValuations = function () {
      promises = [];
      var currentDate = new moment();
      var newValuationPromises = [];
      var isAnyValuationToActivate = false;

      var selected = vm.assets.filter(function (asset) {
        return asset.selected == true
      })

      if (selected.length > 0) {
        SweetAlert.swal({
          title: $filter('translate')('ASSETS.ACTIVATE_VALUATIONS'),
          text: $filter('translate')('ASSETS.ARE_YOU_SURE_TO_ACTIVATE'),
          showCancelButton: true,
          cancelButtonText: $filter('translate')('ASSETS.YES'),
          confirmButtonColor: '#2c3d4e',
          confirmButtonText: $filter('translate')('ASSETS.CANCEL'),
          closeOnConfirm: true,
          closeOnCancel: true
        },
          function (isConfirm) {
            if (!isConfirm) {
              vm.assets.forEach(function (asset) {
                var tempRollOverDate = new Date(asset.rollOverDate);
                var tempRollOverYear = tempRollOverDate.getFullYear();
                var differenceYear = tempRollOverYear - currentDate.get('year')
                for (var i = 0; i < differenceYear; i++) {
                  var currentYear = currentDate.get('year') + i;
                  var currentQuarter = ReviewModel.getQuarterByDate(currentDate);
                  if ('Quarterly' === asset.valuationFrequency || 'SemiAnnually' === asset.valuationFrequency) {
                    var tempCurrentQuarter = currentQuarter;
                    vm.onceNotification = false;
                    for (var j = 0; j < 4; j++) {
                      if (tempCurrentQuarter < 4) {
                        tempCurrentQuarter = currentQuarter + j
                      } else {
                        tempCurrentQuarter = 1;
                      }

                      if (asset.selected && asset.valuation && (asset.valuation.year != currentYear || asset.valuation.quarter != tempCurrentQuarter) && asset.active) {
                        isAnyValuationToActivate = activateValuationForFutureValuationsHelper(asset, tempCurrentQuarter, currentYear, newValuationPromises, isAnyValuationToActivate);
                      }
                    }
                  }
                  else {
                    if (asset.selected && asset.valuation && (asset.valuation.year != currentYear || asset.valuation.quarter != currentQuarter) && asset.active) {
                      isAnyValuationToActivate = activateValuationForFutureValuationsHelper(asset, currentQuarter, currentYear, newValuationPromises, isAnyValuationToActivate);
                    }
                  }
                }
              });
              if (isAnyValuationToActivate) {
                $q.all(newValuationPromises).then(function () {
                  // notifyResults('activeValuations')
                  $state.go($state.current, {}, { reload: true });
                }, function () {
                  vm.uiLoading = false;
                  LoaderHelper.close();
                });
              } else {
                notifyResults('noValuations')
              }
            } else {
              LoaderHelper.close();
            }
          }
        )
      }
    }

    function assignInternalAppraisers(asset, newPeriod, newValuationPromises) {
      AssetService.getAssetUsersList(asset.id, true).then(function (usersList) {
        var latestPrimaryAppraiser = null;
        var latestSecondaryAppraiser = null;

        usersList.forEach(function (user) {
          if (user.type == "PrimaryAssetAppraiser") {
            if (latestPrimaryAppraiser === null || new Date(user.user.createdOn) < new Date(latestPrimaryAppraiser.user.createdOn)) {
              latestPrimaryAppraiser = user;
            }
          } else if (user.type == "SecondaryAssetAppraiser") {
            if (latestSecondaryAppraiser === null || new Date(user.user.createdOn) < new Date(latestSecondaryAppraiser.user.createdOn)) {
              latestSecondaryAppraiser = user;
            }
          }
        })

        //If both latestPrimaryAppraiser and are null
        if (latestPrimaryAppraiser == null && latestSecondaryAppraiser == null) {
          var filteredUsersList = usersList.filter(function (user) {
            return user.userCompanyId == 14405;
          });
          latestPrimaryAppraiser = filteredUsersList[0];
          if (latestPrimaryAppraiser != null) {
            newValuationPromises.push(AssetService.addUserPeriod({
              id: latestPrimaryAppraiser.id,
              year: newPeriod.year,
              quarter: newPeriod.quarter,
              isPrimary: newPeriod.isPrimary
            }))
          }

          if (latestSecondaryAppraiser != null) {
            newValuationPromises.push(AssetService.addUserPeriod({
              id: latestSecondaryAppraiser.id,
              year: newPeriod.year,
              quarter: newPeriod.quarter,
              isPrimary: newPeriod.isPrimary
            }))
          }
        }
      });
    }

    //NOTIFY ACTIONS
    //-------------------------------------------------------
    function notifyResults(action) {
      $q.all(promises).then(function () {
        var message = "";
        if (action == "active") {
          message = $filter('translate')('ASSETS.ASSET_ACTIVATED');
        } else if (action == "inactive") {
          message = $filter('translate')('ASSETS.ASSET_INACTIVATED');
        } else if (action == "activeValuations") {
          message = $filter('translate')('ASSETS.VALUATIONS_ACTIVATED')
        } else if (action == 'noValuations') {
          message = $filter('translate')('ASSETS.NO_VALUATIONS_ACTIVATED')
        } else {
          message = $filter('translate')('ASSETS.ASSET_DELETED');
        }
        notify({
          message: message,
          duration: 4000,
          templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
          classes: 'alert-info',
          position: 'center'
        });
      });
    }

    vm.changePage = function () {
      loadAssets();
    };

    vm.downloadCsv = function () {
      vm.downloadLoading = true;
      CSVService.generateAssetsListCsv(selectedCompanyId, vm.assetsCount, vm.searchQuery,
        vm.assetsSelectedSort.tag, vm.assetsSelectedSort.order, vm.propertyTypes)
        .then(function () {
          vm.downloadLoading = false;
        })
        .catch(function () {
          vm.downloadLoading = false;
        });
    };

    vm.downloadPdf = function () {
      vm.downloadLoading = true;
      PDFGenerator.generateAssetsListPdf(selectedCompanyId, vm.assetsCount, vm.searchQuery,
        vm.assetsSelectedSort.tag, vm.assetsSelectedSort.order, vm.propertyTypes)
        .then(function (pdf) {
          vm.downloadLoading = false;
          var currentUser = SessionManager.getUser();
          pdf.download('assets-list-' + currentUser.name + '.pdf');
        })
        .catch(function () {
          vm.downloadLoading = false;
          notify({
            message: $filter('translate')('COMMONS.EXPORT_FAILURE'),
            duration: 5000,
            templateUrl: 'app/components/commons/messages/fe-notifications/fe-notifications.html',
            classes: 'alert-danger',
            position: 'center'
          });
        });
    };

    vm.openUploadModal = function () {
      var modalInstance = $uibModal.open({
        animation: true,
        ariaLabelledBy: 'modal-title',
        ariaDescribedBy: 'modal-body',
        templateUrl: 'upload-assets.html',
        controller: 'UploadAssetsController',
        controllerAs: 'uploadAssetsCtrl',
        size: 'lg',
        resolve: {
          selectedCompanyId: selectedCompanyId
        }
      });
      modalInstance.result.then(function () {
        loadAssets();
      });
    };

    vm.setAllSelected = function () {
      vm.assets.forEach(function (asset) {
        asset.selected = vm.selectedAll;
      })
    }
    vm.onSelectionChange = function () {
      var isAllSelected = vm.assets.filter(function (asset) {
        return asset.selected == false
      })
      if (isAllSelected.length > 0) {
        vm.selectedAll = false;
      } else {
        vm.selectedAll = true;
      }
    }

    //GET ASSETS BY COMPANY BY USER
    //-------------------------------------------------------
    CompanySelectorFactory.showCompanies(companies);
    var companyListener = $scope.$on('companyChanged', function (event, selectedCompany) {
      CompanySelectorFactory.executeOnValidState('app.asset.all', function () {
        selectedCompanyId = selectedCompany.id;
        LoaderHelper.open();
        vm.currentPage = 1;
        vm.selectedCompany = selectedCompany.id;
        vm.assets = [];
        var promises = [];
        vm.bidGroupNamesById = {};
        promises.push(loadAssets(true));
        promises.push(BidGroupService.list(selectedCompany.id));
        $q.all(promises).then(function (responses) {
          var bidGroups = responses[1];
          bidGroups.forEach(function (bidGroup) {
            vm.bidGroupNamesById[bidGroup.id] = bidGroup.name;
          });
          setAssetsBidGroupNames();
        });
      });
    });

    function loadAssets(load) {
      if (load) {
        LoaderHelper.open();
      } else {
        $('.paginator-loader').addClass('sk-loading');
      }

      return AssetService.getAssetsByCompanyPage(selectedCompanyId, undefined, vm.currentPage - 1, vm.perPage, vm.searchQuery,
        vm.assetsSelectedSort.tag, vm.assetsSelectedSort.order).then(function (response) {
          vm.assets = response.assets;
          vm.assetsCount = response.pageInfo.count;
          ArrayHelper.searchScroll();
          setAssetsBidGroupNames();
          if (load) {
            LoaderHelper.close();
          } else {
            $('.paginator-loader').removeClass('sk-loading');
          }
        });
    }

    function setAssetsBidGroupNames() {
      if (vm.bidGroupNamesById && Object.keys(vm.bidGroupNamesById).length > 0 && vm.assets) {
        vm.assets.forEach(function (asset) {
          asset.bidGroupName = vm.bidGroupNamesById[asset.bidGroupId];
        });
      }
    }

    var selectedAssetsWatch = $scope.$watch('assets.assets', function () {
      vm.selectedAssets = 0;
      vm.assets && vm.assets.forEach(function (asset) {
        if (asset.selected) {
          vm.selectedAssets++;
        }
      });
    }, true);
    $scope.$on('$destroy', function () {
      companyListener();
      selectedAssetsWatch();
    });
  }

})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .service('ValuationService', ValuationService);

  function ValuationService($q, $http, EnvironmentConfig, localStorageService) {

    var host = EnvironmentConfig.API_BASE;
    var resourceEnd = 'asset/valuation/';
    var baseUrl = host + resourceEnd;

    return {
      createValuation: createValuation,
      updateValuation: updateValuation,
      getById: getById,
      listValuationsByAssetId: listValuationsByAssetId,
      listValuationsByCompanyId: listValuationsByCompanyId,
      deleteValuation: deleteValuation,
      documentList: documentList,
      documentCreate: documentCreate,
      documentDelete: documentDelete,
      documentDownload: documentDownload,
      listSummary: listSummary,
      listOverdueSummary: listOverdueSummary,
      getValuationsStatistic: getValuationsStatistic,
      loadValuationsFromCsv: loadValuationsFromCsv,
      documentUpdate: documentUpdate,
      getAEDocumentsByAssetId: getAEDocumentsByAssetId
    };

    /**
     * Creates a valuation
     * @param valuation have to have at least assetId, year, yearOfCycle, quarter, quarterOfCycle properties, for a full list
     * refer to the api
     */
    function createValuation(valuation) {
      if (!valuation || !valuation.assetId || !valuation.year || !valuation.yearOfCycle || !valuation.quarter ||
        !valuation.quarterOfCycle || !valuation.valuationCycle) {
        return $q.reject('Invalid arguments');
      }
      valuation.type = valuation.type === 'A' ? 'Annual' : 'Quarterly';
      return $http.post(baseUrl + 'create', valuation).then(function (response) {
        return response.data.data;
      });
    }

    function getById(valuationId) {
      if (!valuationId) {
        return $q.reject('Invalid arguments');
      }

      var params = {
        id: valuationId
      };

      return $http.get(baseUrl + 'get', { params: params }).then(function (response) {
        return response.data.data;
      });
    }

    function listValuationsByAssetId(assetId, loggedInUserRoleName, loggedInUserCompanyId) {
      if (!assetId) {
        return $q.reject('Invalid arguments');
      }

      var params = {
        assetId: assetId
      };
      if (loggedInUserCompanyId) {
        params.loggedInUserCompanyId = loggedInUserCompanyId;
      }
      if (loggedInUserRoleName) {
        params.loggedInUserRoleName = loggedInUserRoleName;
      }
      //var config = {
      //  transformRequest: angular.identity,
      //  headers: {
      //    'Content-Type': undefined
      //  }
      //};
      //var roleName = SessionManager.getRoleName()
      //var userId = SessionManager.getUser();
      //var companyId = SessionManager.getCompanyId();

      return $http.get(baseUrl + 'list', { params: params }).then(function (response) {
        return response.data.data;
      });
    }

    function listValuationsByCompanyId(companyId) {
      if (!companyId) {
        return $q.reject('Invalid arguments');
      }

      var params = {
        companyId: companyId
      };

      return $http.get(baseUrl + 'listByCompany', { params: params }).then(function (response) {
        return response.data.data;
      });
    }

    function updateValuation(valuation, reason) {
      if (!valuation || !valuation.id) {
        return $q.reject('Invalid arguments');
      }
      if (reason) {
        valuation.reason = reason;
      }
      if (valuation.nextDraftDueDate && !(typeof valuation.nextDraftDueDate == 'number')) {
        valuation.nextDraftDueDate = Date.parse(valuation.nextDraftDueDate);
      }
      return $http.post(baseUrl + 'update', valuation).then(function (response) {
        return response.data.data;
      });
    }

    function deleteValuation(id) {
      if (!id) {
        return $q.reject('Invalid arguments');
      }
      return $http.post(baseUrl + 'delete', { id: id }).then(function (response) {
        return response.data.data;
      });
    }

    function documentList(assetValuationId) {
      if (!assetValuationId) {
        return $q.reject('id required');
      }
      return $http.get(baseUrl + 'document/list', { params: { assetValuationId: assetValuationId } }).then(function (response) {
        return response.data.data;
      });
    }

    function documentCreate(assetValuationId, file, fileName, type, status, version, userCompanyId, premise, quarter, year) {
      if (!assetValuationId || !fileName || !file) {
        return $q.reject('invalid parameters');
      }
      var formData = new FormData();
      formData.append('session', localStorageService.cookie.get('session_token'));
      formData.append('assetValuationId', assetValuationId);
      formData.append('name', fileName);
      formData.append('type', type);
      formData.append('status', status);
      formData.append('version', version);
      formData.append('document', file);
      if (premise) {
        formData.append('premise', premise);
      }
      formData.append('userCompanyId', userCompanyId);

      if (quarter) {
        formData.append('quarter', parseInt(quarter));
      }
      if (year) {
        formData.append('year', parseInt(year));
      }
      var config = {
        transformRequest: angular.identity,
        headers: {
          'Content-Type': undefined
        }
      };

      return $http.post(baseUrl + 'document/create', formData, config).then(function (response) {
        return response.data.data;
      });
    }

    function documentDelete(documentId) {
      if (!documentId) {
        return $q.reject('invalid parameters');
      }
      return $http.post(baseUrl + 'document/delete', { id: documentId }).then(function (response) {
        return true;
      });
    }

    function documentDownload(documentId) {
      if (!documentId) {
        return $q.reject('invalid parameters');
      }
      return $http.get(baseUrl + 'document/download', { params: { id: documentId } }).then(function (response) {
        return response.data.data;
      });
    }

    function documentUpdate(documentId, status) {
      if (!documentId) {
        return $q.reject('invalid parameters');
      }
      return $http.post(baseUrl + 'document/update', { id: documentId, status: status }).then(function (response) {
        return true;
      });
    }

    function listSummary(companyId, page, pageSize, searchQuery, sortKey, sortOrder, myValuations, valuationFilters, futureValuations) {
      if (!companyId) {
        return $q.reject('invalid parameters');
      }
      var params = {
        companyId: companyId,
        page: page,
        pageSize: pageSize,
        search: searchQuery,
        sortKey: sortKey,
        sortOrder: sortOrder,
        myValuationOnly: myValuations,
        filters: valuationFilters
      };
      if (futureValuations) {
        params.overrideCurrentYear = 2050;
        params.overrideCurrentQuarter = 4;
      }
      return $http.get(baseUrl + 'listSummary', { params: params }).then(function (response) {
        var formatResponse = {},
          range = response.headers()['content-range'],
          leaseRange = response.headers()['leaseablerange'] ? response.headers()['leaseablerange'] : '0-1000000',
          valueRange = response.headers()['valuationrange'] ? response.headers()['valuationrange'] : '0-1000000';
        formatResponse.data = response.data.data;
        var pageInfo = {};
        pageInfo.total = parseInt(response.headers()['totalitems']);
        pageInfo.count = parseInt(range.substring(range.indexOf('/') + 1));
        pageInfo.current = range.substring(range.indexOf(' ') + 1, range.indexOf('/'));
        pageInfo.currentStart = parseInt(pageInfo.current.substring(0, pageInfo.current.indexOf('-')));
        pageInfo.currentEnd = parseInt(pageInfo.current.substring(pageInfo.current.indexOf('-') + 1));

        pageInfo.minLeaseRange = leaseRange.split('-')[0];
        pageInfo.maxLeaseRange = leaseRange.split('-')[1];
        pageInfo.minValueRange = valueRange.split('-')[0];
        pageInfo.maxValueRange = valueRange.split('-')[1];

        formatResponse.pageInfo = pageInfo;
        return formatResponse;
      });
    }

    function listOverdueSummary(companyId, myValuationOnly) {
      if (!companyId) {
        return $q.reject('invalid parameters');
      }
      var params = {
        companyId: companyId,
        myValuationOnly: myValuationOnly
      };
      return $http.get(baseUrl + 'listOverdueSummary', { params: params }).then(function (response) {
        return response.data.data;
      });
    }

    function getValuationsStatistic(companyId) {
      if (!companyId) {
        return $q.reject('invalid parameters');
      }
      var params = {
        companyId: companyId
      };
      return $http.get(baseUrl + 'getValuationsStatistic', { params: params }).then(function (response) {
        return response.data.data;
      });
    }

    function loadValuationsFromCsv(file) {
      if (!file) {
        return $q.reject('Invalid parameters');
      }
      var formData = new FormData();
      formData.append('session', localStorageService.cookie.get('session_token'));
      formData.append('name', file.name);
      formData.append('document', file);
      var config = {
        transformRequest: angular.identity,
        headers: {
          'Content-Type': undefined
        }
      };
      return $http.post(baseUrl + 'import', formData, config).then(function (response) {
        return response.data.data;
      });
    }

    function getAEDocumentsByAssetId(assetIdList, downloadType) {
      if (!assetIdList) {
        return $q.reject('invalid parameters');
      }
      return $http.post(
        baseUrl + 'getAEDocumentsByAssetId', { assetIdList: assetIdList, downloadType: downloadType },
        {
          responseType: 'blob'
        }).then(function (response) {
          return (response);
        });
    }
  }

})();

(function () {
  'use strict';

  angular
  .module('nvc')
  .service('ValuationCommentsService', ValuationCommentsService);

  function ValuationCommentsService($q, $http, EnvironmentConfig, SessionManager) {

    var host = EnvironmentConfig.API_BASE;
    var resourceEnd = 'asset/valuation/comment/';
    var baseUrl = host + resourceEnd;
    var isAdmin = SessionManager.isInRole('Admin');

    return {
      createComment: createComment,
      createReply: createReply,
      deleteComment: deleteComment,
      listValuationComments: listValuationComments,
      submitComments: submitComments,
      amendComment: amendComment,
      updateComment: updateComment,
      reviewComments: reviewComments
    };

    function createComment(comment) {
      if (!comment || !comment.assetValuationId || !comment.title || !comment.body || !comment.type) {
        return $q.reject('invalid arguments');
      }

      return $http.post(baseUrl + 'create', comment).then(function (response) {
        return response.data.data;
      });
    }

    function createReply(reply) {
      if (!reply || !reply.parentCommentId || !reply.body) {
        return $q.reject('invalid arguments');
      }

      return $http.post(baseUrl + 'create', reply).then(function (response) {
        return response.data.data;
      });
    }

    function deleteComment(comment) {
      if (!comment || !comment.id) {
        return $q.reject('invalid arguments');
      }

      return $http.post(baseUrl + 'delete', comment).then(function (response) {
        return response.data.data;
      });
    }

    function listValuationComments(valuationId) {
      if (!valuationId) {
        return $q.reject('invalid arguments');
      }

      return $http.get(baseUrl + 'list', {params: {assetValuationId: valuationId, isAdminRoleSelected: isAdmin}}).then(function (response) {
        return response.data.data;
      });
    }

    function submitComments(ids) {
      if (!ids) {
        return $q.reject('invalid arguments');
      }

      return $http.get(baseUrl + 'submit', {params:{ids: ids}}).then(function (response) {
        return response.data.data;
      });
    }

    function reviewComments(ids){
      if (!ids) {
        return $q.reject('invalid arguments');
      }

      return $http.get(baseUrl + 'submitForReview', {params:{ids: ids}}).then(function (response) {
        return response.data.data;
      });
    }

    function amendComment(comment){
      if(!comment || !comment.amendingCommentId || !comment.body){
        return $q.reject('invalid arguments');
      }

      return $http.post(baseUrl + 'create', comment).then(function (response) {
        return response.data.data;
      });
    }

    function updateComment(comment) {
      if (!comment || !comment.id) {
        return $q.reject('invalid arguments');
      }

      return $http.post(baseUrl + 'update', comment).then(function (response) {
        return response.data.data;
      });
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .service('UserService', UserService);

  /** @ngInject */
  function UserService($rootScope, $q, $http, EnvironmentConfig) {

    var host = EnvironmentConfig.API_BASE;
    var resourceEnd = 'user/';
    var baseUrl = host + resourceEnd;

    var user = {};
    var getUserDeferrals = {};

    $rootScope.$on('loggedOut', function () {
      user = {};
    });

    return {
      getUser: getUser,
      cleanUserCache: cleanUserCache,
      createUser: createUser,
      updateUser: updateUser,
      getUsersByCompanyId: getUsersByCompanyId,
      getUsersByCompanyIdPage: getUsersByCompanyIdPage,
      getUsersByType: getUsersByType,
      getRelatedUsersByCompanyId: getRelatedUsersByCompanyId,
      getRelatedUsersByCompanyIdPage: getRelatedUsersByCompanyIdPage,
      getUsersByValuationId: getUsersByValuationId,
      inactivateUser: inactivateUser,
      deleteUser: deleteUser,
      updateAMUser: updateAMUser
    };

    function getUser(userId) {
      var options = {
        params: {
          id: userId
        }
      };
      if (!user[userId]) {
        var deferred = $q.defer();
        if (!getUserDeferrals[userId]) {
          getUserDeferrals[userId] = [];
          $http.get(baseUrl + 'get', options).then(function (response) {
            user[userId] = response.data.data;
            getUserDeferrals[userId].forEach(function (deferred) {
              deferred.resolve(angular.copy(user[userId]));
            });
            delete getUserDeferrals[userId];
          });
        }
        getUserDeferrals[userId].push(deferred);
        return deferred.promise;
      } else {
        return $q.resolve(user[userId]);
      }
    }

    function cleanUserCache(userId){
      delete user[userId];
    }

    function createUser(user) {
      return $http.post(host + 'company/user/create', user).then(function (response) {
        return response.data.data;
      });
    }

    function updateUser(updateUser) {
      return $http.post(baseUrl + 'update', updateUser).then(function (response) {
        delete user[updateUser.id];
        return response.data.data;
      });
    }

    function getUsersByCompanyId(companyId, activeOnly) {
      var options = {
        params: {
          companyId: companyId,
          activeOnly: activeOnly
        }
      };
      return $http.get(host + 'company/user/list', options).then(function (response) {
        return response.data.data;
      });
    }

    function getUsersByCompanyIdPage(companyId, activeOnly, page, pageSize, searchQuery, sortKey, sortOrder) {
      var options = {
        params: {
          companyId: companyId,
          activeOnly: activeOnly,
          page: page,
          pageSize: pageSize,
          search: searchQuery,
          sortKey: sortKey,
          sortOrder: sortOrder
        }
      };
      return $http.get(host + 'company/user/list', options).then(function (response) {
        var formatResponse = {},
        range = response.headers()['content-range'];
        formatResponse.users = response.data.data;
        var pageInfo = {};
        pageInfo.count = parseInt(range.substring(range.indexOf('/')+1));
        pageInfo.current = range.substring(range.indexOf(' ')+1, range.indexOf('/'));
        pageInfo.currentStart = parseInt(pageInfo.current.substring(0, pageInfo.current.indexOf('-')));
        pageInfo.currentEnd = parseInt(pageInfo.current.substring(pageInfo.current.indexOf('-')+1));
        formatResponse.pageInfo = pageInfo;
        return formatResponse;
      });
    }

    function getUsersByType(type, activeOnly) {
      if (!type) {
        return $q.reject('invalid parameters');
      }
      var options = {
        params: {
          role: type,
          activeOnly: activeOnly
        }
      };
      return $http.get(host + 'company/user/list', options).then(function (response) {
        return response.data.data;
      });
    }

    function getRelatedUsersByCompanyId(companyId, activeOnly) {
      var options = {
        params: {
          userCompanyId: companyId,
          activeOnly: activeOnly
        }
      };
      return $http.get(baseUrl + 'listRelated', options).then(function (response) {
        return response.data.data;
      });
    }

    function getRelatedUsersByCompanyIdPage(companyId, activeOnly, page, pageSize, searchQuery, sortKey, sortOrder) {
      var options = {
        params: {
          userCompanyId: companyId,
          activeOnly: activeOnly,
          page: page,
          pageSize: pageSize,
          search: searchQuery,
          sortKey: sortKey,
          sortOrder: sortOrder
        }
      };
      return $http.get(baseUrl + 'listRelated', options).then(function (response) {
        var formatResponse = {},
        range = response.headers()['content-range'];
        formatResponse.users = response.data.data;
        var pageInfo = {};
        pageInfo.count = parseInt(range.substring(range.indexOf('/')+1));
        pageInfo.current = range.substring(range.indexOf(' ')+1, range.indexOf('/'));
        pageInfo.currentStart = parseInt(pageInfo.current.substring(0, pageInfo.current.indexOf('-')));
        pageInfo.currentEnd = parseInt(pageInfo.current.substring(pageInfo.current.indexOf('-')+1));
        formatResponse.pageInfo = pageInfo;
        return formatResponse;
      });
    }

    function getUsersByValuationId(valuationId, assetId){
      if(!valuationId || !assetId) {
        return $q.reject('invalid parameters');
      }
      var promises = [];
      promises.push($http.get(host + 'asset/user/list', {params: {assetId: assetId, activeOnly: true}}).then(function (response){
        return response.data.data;
      }));
      promises.push($http.get(host + 'asset/valuation/get', {params: {id: valuationId}}).then(function(response){
        return response.data.data;
      }));

      return $q.all(promises).then(function(responses){
        var users = responses[0],
        valuation = responses[1],
        valuationUsers = [];

        users.forEach(function(user){
          for(var i = 0; i < user.periods.length; i++){
            var period = user.periods[i];
            if(period.active && period.year == valuation.year && period.quarter == valuation.quarter){
              delete user.periods;
              user.period = period;
              valuationUsers.push(user);
              break;
            }
          }
        });
        return valuationUsers;
      });
    }

    function inactivateUser(userIds){
      if(!userIds.ids) {
        return $q.reject('invalid parameters');
      }
      return $http.post(baseUrl + 'inactivate', userIds).then(function (response) {
        return response.data.data;
      });
    }

    function deleteUser(userIdsArray) {
      if(!userIdsArray) {
        return $q.reject('invalid parameters');
      }
      return $http.post(baseUrl + 'delete', {userIds: userIdsArray}).then(function (response) {
        return response.data.data;
      });
    }

    function updateAMUser(user) {
      if(!user.id) {
        return $q.reject('invalid parameters');
      }
      return $http.post(host + 'company/user/update', user).then(function (response) {
        return response.data.data;
      });
    }

  }

})();

(function () {
  'use strict';

  angular.module('nvc').service('UserAccountService', UserAccountService);

  /** @Inject*/
  function UserAccountService($q, $http, $rootScope, localStorageService, EnvironmentConfig, SessionManager) {


    var host = EnvironmentConfig.API_BASE;
    var resourceEnd = 'useraccount/';
    var baseUrl = host + resourceEnd;

    return {
      getAccount: getAccount,
      updateAccount: updateAccount,
      login: login,
      refreshToken: refreshToken,
      logout: logout,
      forgotPassword: forgotPassword,
      resendOnboardingEmail: resendOnboardingEmail,
      resetPassword: resetPassword
    };

    function getAccount(id) {
      var options = {
        params: {
          id: id
        }
      };
      return $http.get(baseUrl + 'get', options).then(function (response) {
        return response.data.data;
      });
    }

    function updateAccount(account) {
      return $http.post(baseUrl + 'update', account).then(function (response) {
        return response.data.data;
      });
    }

    function login(credentials) {

      if (!credentials || !credentials.password || !credentials.email) {
        return $q.reject(false);
      }

      if (credentials.rememberMe) {
        credentials = {
          password: credentials.password,
          email: credentials.email,
          longevity: 2592000000 // one month (3600000*24*30)
        }
      }

      return $http.post(baseUrl + 'login', credentials).then(function (response) {
        if (credentials.longevity) {
          localStorageService.cookie.set('refresh_data', response.data.data.session.expiresOn);
        }
        onLogin(response);
      });
    }

    function refreshToken() {
      var body = {
        token: localStorageService.cookie.get('session_token'),
        longevity: 2592000000 // one month (3600000*24*30)
      };
      return $http.post(baseUrl + 'login', body).then(function (response) {
        localStorageService.cookie.set('refresh_data', response.data.data.session.expiresOn);
        onLogin(response);
      });
    }

    function onLogin(response) {
      response = response.data;
      localStorageService.cookie.set('session_token', response.data.session.token);
      var activeRole = undefined;
      var activeUser = response.data.user;
      var activeCompany = response.data.companies[0];
      for (var i = 0; i < response.data.companies.length; i++){
        if(response.data.companies[i].type === 'Admin'){
          activeRole = 'Admin';
          activeCompany = response.data.companies[i];
          break;
        }
      }
      if(!activeRole){
        activeRole = response.data.companies[0].type
      }

      for (var r = 0; r < response.data.relatedUsers.length; r++) {
        if (response.data.userIdSessionMap && response.data.userIdSessionMap[response.data.relatedUsers[r].id] && response.data.userIdSessionMap[response.data.relatedUsers[r].id].token) {
          var tokenCookieKey = 'session_token' + response.data.relatedUsers[r].id;
          var tokenCookieValue = response.data.userIdSessionMap[response.data.relatedUsers[r].id].token;
          localStorageService.cookie.set(tokenCookieKey, tokenCookieValue);
        }
        if (response.data.relatedUsers[r].userCompanyId === activeCompany.id 
          || (activeRole === 'Admin' && response.data.relatedUsers[r].userCompanyRoles && response.data.relatedUsers[r].userCompanyRoles.includes('Administrator'))
          || (response.data.relatedUsers[r].adminCompany && response.data.relatedUsers[r].adminCompany.id === activeCompany.id)) {
          activeRole = activeCompany.type; // is this correct?
          activeUser = response.data.relatedUsers[r];
        }
      }

      if (response.data.userIdSessionMap && response.data.userIdSessionMap[activeUser.id] && response.data.userIdSessionMap[activeUser.id].token) {
        localStorageService.cookie.set('session_token', response.data.userIdSessionMap[activeUser.id].token);
      }

      SessionManager.authenticate({
        role: activeRole,
        company: activeCompany,
        name: activeUser.name,
        availableRoles: response.data.companies.map(function(c) { return {type: c.type, name: c.name, id: c.id}}),
        user: activeUser,
        companies: response.data.companies,
        relatedUsers: response.data.relatedUsers
      });
      $rootScope.$broadcast('loggedIn');
      return response;
    }

    function logout() {
      return $http.post(baseUrl + 'logout', {session: localStorageService.cookie.get('access_token')}).then(function () {
        $rootScope.$broadcast('loggedOut');
        localStorageService.cookie.remove('session_token');
        SessionManager.authenticate(null);
      });
    }

    function forgotPassword(credentials) {
      if (!credentials || !credentials.email) {
        return $q.reject(false);
      }

      return $http.post(baseUrl + 'resetPassword', credentials);

    }

    function resendOnboardingEmail(credentials) {
      console.log("From forgotPassword" + credentials.email);
      if (!credentials || !credentials.email) {
        return $q.reject(false);
      }

      return $http.post(baseUrl + 'resendNewUserOnboard', credentials);

    }

    /**
     *
     * @param credentials with fields password, email and token
     * @returns {Promise} containing false if credentials are bad or the result of the request
     */
    function resetPassword(credentials) {
      if (!credentials || !credentials.password || !credentials.email || !credentials.token) {
        return $q.reject(false);
      }

      return $http.post(baseUrl + 'resetPassword', credentials);

    }
  }

})();

(function () {
  'use strict';

  angular.module('nvc').service('StaticDataService', staticDataService);

  /** @Inject*/
  function staticDataService($http) {

    var baseUrl = "/assets/data/";

    return {
      getAllStates: getAllStates,
      getCitiesByStates: getCitiesByStates,
      getPropertyTypes: getPropertyTypes,
      getSubtypesByPropertyTypes: getSubtypesByPropertyTypes,
      getMsaByStates: getMsaByStates,
      getNcreifs: getNcreifs,
      getNCREIFRegionByStates: getNCREIFRegionByStates,
      getOwnershipTypes: getOwnershipTypes,
      getValuationFrequencies: getValuationFrequencies,
      getRequiredAppraisers: getRequiredAppraisers,
      getPremiseOptions: getPremiseOptions
    };

    function getAllStates() {
      return $http.get(baseUrl + "states.json").then(function(response){
        return response.data;
      });
    } 

    function getCitiesByStates() {
      return $http.get(baseUrl + "cities-by-states.json").then(function(response){
        return response.data;
      });
    } 

    function getNCREIFRegionByStates() {
      return $http.get(baseUrl + "ncreif-region-by-state.json").then(function(response){
        return response.data;
      });
    }

    function getPropertyTypes() {
      return $http.get(baseUrl + "property-types.json").then(function(response){
        return response.data;
      });
    }

    function getSubtypesByPropertyTypes() {
      return $http.get(baseUrl + "property-subtypes-by-types.json").then(function(response){
        return response.data;
      });
    } 

    function getMsaByStates() {
      return $http.get(baseUrl + "msa-by-states.json").then(function(response){
        return response.data;
      });
    } 

    function getNcreifs() {
      return $http.get(baseUrl + "ncreifs.json").then(function(response){
        return response.data
      });
    }

    function getOwnershipTypes(){
      return $http.get(baseUrl + "ownership-types.json").then(function(response){
        return response.data
      });
    }

    function getValuationFrequencies() {
      return $http.get(baseUrl + "valuation-frequencies.json").then(function(response){
        return response.data
      });
    }

    function getRequiredAppraisers() {
      return $http.get(baseUrl + "required-appraisers.json").then(function(response){
        return response.data
      });
    }

    function getPremiseOptions() {
      return $http.get(baseUrl + "premise-options.json").then(function(response){
        return response.data
      });
    }
  }

})();

(function () {
  angular
    .module('nvc')
    .service('ntlmConnectionService', ntlmConnectionService);

  /** @ngInject */
  function ntlmConnectionService($q, $http, EnvironmentConfig) {

    var host = EnvironmentConfig.API_BASE;
    var resourceEnd = 'report/';
    var baseUrl = host + resourceEnd;

    return {
      getData: getData,
      getAuthenticate: getAuthenticate
    };

    function getData(reportType) {
      if (!reportType) {
        return $q.reject('id required');
      }
      return $http.get(baseUrl + 'data', {params: {type: reportType}}).then(function (response) {
        return response.data.data
      });
    }

    function getAuthenticate(ntlm, url) {
      if (!ntlm || !url) {
        return $q.reject('missing data')
      }
      return $http.get(url, {withCredentials: true, headers: {'Authorization': 'Basic ' + btoa( "talos" + ':' + "Y(/d_6>^)fDAh?.")}}).success(function (response, status, headers) {
        return response.data.data
      })
      // .error(function (error, status, headers) {
      //   console.log('error in the service');
      //   console.log(headers('WWW-Authenticate'));
      //   console.log(error);
      //   console.log('error in the service');
      // });
    }

  }
})();

(function () {
  angular
  .module('nvc')
  .service('ContactService', ContactService);

  /** @ngInject */
  function ContactService($q, $http, EnvironmentConfig) {

    var host = EnvironmentConfig.API_BASE;
    var resourceEnd = 'company/contact/';
    var baseUrl = host + resourceEnd;

    return {
      getContactsByCompany: getContactsByCompany,
      getContact: getContact,
      createContact: createContact,
      updateContact: updateContact
    };

    function getContactsByCompany(companyId) {
      if(!companyId){
        return $q.reject('id required');
      }
      return $http.get(baseUrl + 'list', {params:{companyId: companyId}}).then(function(response){
        return response.data.data
      });
    }

    function getContact(contactId) {
      if(!contactId) {
        return $q.reject('contact id required');
      }
      return $http.get(baseUrl + 'get', {params: {id: contactId}}).then(function(response) {
        return response.data.data;
      });
    }

    function createContact(contact) {
      if(!contact || !contact.name || !contact.email || !contact.officePhone){
        return $q.reject('invalid params')
      }
      return $http.post(baseUrl + 'create', contact).then(function(response){
        return response.data.data;
      });
    }

    function updateContact(contact){
      return $http.post(baseUrl + 'update', contact).then(function(response){
        return response.data.data;
      });
    }


  }
})();

(function () {
  'use strict';

  angular
  .module('nvc')
  .service('CompanyService', CompanyService);

  /** @ngInject*/
  function CompanyService($http, $q, EnvironmentConfig, SessionManager) {

    var host = EnvironmentConfig.API_BASE;
    var resourceEnd = 'company/';
    var baseUrl = host + resourceEnd;
    return {
      getCompany: getCompany,
      getAllCompanies: getAllCompanies,
      getAdminCompanies: getAdminCompanies,
      getAuditorCompanies: getAuditorCompanies,
      getClientCompanies: getClientCompanies,
      getAppraisalCompanies: getAppraisalCompanies,
      getReviewerCompanies: getReviewerCompanies,
      getCompaniesByUserId: getCompaniesByUserId,
      createAdminCompany: createAdminCompany,
      createAuditorCompany: createAuditorCompany,
      createClientCompany: createClientCompany,
      createAppraisalCompany: createAppraisalCompany,
      createReviewerCompany: createReviewerCompany,
      updateCompany: updateCompany,
      updateClientCompany: updateClientCompany,
      updateReviewerCompany: updateReviewerCompany,
      updateAppraiserCompany: updateAppraiserCompany,
      updateAuditorCompany: updateAuditorCompany,
      deleteCompany: deleteCompany,
      getValuationsAverage: getValuationsAverage,
      getClientCompaniesPage: getClientCompaniesPage,
      getAppraisalCompaniesPage: getAppraisalCompaniesPage,
      getAuditorCompaniesPage: getAuditorCompaniesPage,
      getReviewerCompaniesPage: getReviewerCompaniesPage
    };
    
    function getCompany(companyId) {
      return $http.get(baseUrl + 'get', {params: {id: companyId}}).then(function (response) {
        return response.data.data;
      });
    }

    function getAllCompanies(all, activeOnly) {
      return getCompanies({all: all, activeOnly: activeOnly});
    }

    function getAdminCompanies(all, activeOnly) {
      return getCompanies({type: 'Admin', all: all, activeOnly: activeOnly});
    }

    function getClientCompanies(all, activeOnly) {
      return getCompanies({type: 'AssetManagement', all: all, activeOnly: activeOnly});
    }

    function getClientCompaniesPage(all, activeOnly, page, pageSize, searchQuery, sortKey, sortOrder) {
      return getCompaniesPage({type: 'AssetManagement', all: all, activeOnly: activeOnly, page: page, pageSize: pageSize, search: searchQuery, sortKey: sortKey, sortOrder: sortOrder});
    }

    function getAppraisalCompanies(all, activeOnly) {
      return getCompanies({type: 'AssetAppraisal', all: all, activeOnly: activeOnly});
    }

    function getAppraisalCompaniesPage(all, activeOnly, page, pageSize, searchQuery, sortKey,  sortOrder) {
      return getCompaniesPage({type: 'AssetAppraisal', all: all, activeOnly: activeOnly, page: page, pageSize: pageSize, search: searchQuery, sortKey: sortKey,  sortOrder: sortOrder});
    }

    function getAuditorCompanies(all, activeOnly) {
      return getCompanies({type: 'Audit', all: all, activeOnly: activeOnly});
    }

    function getAuditorCompaniesPage(all, activeOnly, page, pageSize, searchQuery, sortKey,  sortOrder) {
      return getCompaniesPage({type: 'Audit', all: all, activeOnly: activeOnly, page: page, pageSize: pageSize, search: searchQuery, sortKey: sortKey,  sortOrder: sortOrder});
    }

    function getReviewerCompanies(all, activeOnly) {
      return getCompanies({type: 'AssetReview', all: all, activeOnly: activeOnly});
    }

    function getReviewerCompaniesPage(all, activeOnly, page, pageSize, searchQuery, sortKey, sortOrder) {
      return getCompaniesPage({type: 'AssetReview', all: all, activeOnly: activeOnly, page: page, pageSize: pageSize, search: searchQuery, sortKey: sortKey, sortOrder: sortOrder});
    }

    function getCompaniesByUserId(userId, activeOnly) {
      return $http.get(baseUrl + 'listByUser', {params: {userId: userId, activeOnly: activeOnly}}).then(function (response) {
        return response.data.data;
      });
    }

    function getCompanies(params) {
      if (params.all && SessionManager.isInRole('Admin')) {
        delete params.all;
        if(params.activeOnly) {
          params.active = true;
        }
        return search(params);
      }
      return $http.get(baseUrl + 'list', {params: params}).then(function (response) {
        return response.data.data;
      });
    }

    function getCompaniesPage(params) {
      if(params.all && SessionManager.isInRole('Admin')) {
        delete params.all;
        if(params.activeOnly) {
          params.active = true;
        }
        return searchPerPage(params);
      }
      return $http.get(baseUrl + 'list', {params: params}).then(function (response) {
        var formatResponse = {},
          range = response.headers()['content-range'];
        formatResponse.companies = response.data.data;
        var pageInfo = {};
        pageInfo.count = parseInt(range.substring(range.indexOf('/')+1));
        pageInfo.current = range.substring(range.indexOf(' ')+1, range.indexOf('/'));
        pageInfo.currentStart = parseInt(pageInfo.current.substring(0, pageInfo.current.indexOf('-')));
        pageInfo.currentEnd = parseInt(pageInfo.current.substring(pageInfo.current.indexOf('-')+1));
        formatResponse.pageInfo = pageInfo;
        return formatResponse;
      });
    }

    /**
     * restricted to admin
     * @returns promise
     */
    function search(params){
      return $http.get(baseUrl + 'search', {params: params}).then(function (response) {
        return response.data.data;
      });
    }

    function searchPerPage(params) {
      return $http.get(baseUrl + 'search', {params: params}).then(function (response) {
        var formatResponse = {},
          range = response.headers()['content-range'];
        formatResponse.companies = response.data.data;
        var pageInfo = {};
        pageInfo.count = parseInt(range.substring(range.indexOf('/')+1));
        pageInfo.current = range.substring(range.indexOf(' ')+1, range.indexOf('/'));
        pageInfo.currentStart = parseInt(pageInfo.current.substring(0, pageInfo.current.indexOf('-')));
        pageInfo.currentEnd = parseInt(pageInfo.current.substring(pageInfo.current.indexOf('-')+1));
        formatResponse.pageInfo = pageInfo;
        return formatResponse;
      });
    }

    function createAdminCompany(company) {
      company.type = 'Admin';
      return createCompany(company);
    }

    function createClientCompany(company) {
      company.type = 'AssetManagement';
      return createCompany(company);
    }

    function createAppraisalCompany(company) {
      company.type = 'AssetAppraisal';
      return createCompany(company);
    }

    function createAuditorCompany(company) {
      company.type = 'Audit';
      return createCompany(company);
    }

    function createReviewerCompany(company) {
      company.type = 'AssetReview';
      return createCompany(company);
    }

    function createCompany(company) {
      if (!company || !company.address || !company.name || isValidCompanyType(company.type)) {
        return $q.reject({message: 'invalid arguments'});
      }
      return $http.post(baseUrl + 'create', company).then(function (response) {
        return response.data.data;
      });
    }

    function updateCompany(company) {
      if(!company || !company.address || !company.name || isValidCompanyType(company.type)) {
        return $q.reject({message: 'invalid arguments'});
      }
      return $http.post(baseUrl + 'update', company).then(function (response) {
        return response.data.data
      });
    }

    function updateClientCompany(company) {
      company.type = 'AssetManagement';
      return updateCompany(company);
    }

    function updateReviewerCompany(company) {
      company.type = 'AssetReview';
      return updateCompany(company);
    }

    function updateAppraiserCompany(company) {
      company.type = 'AssetAppraisal';
      return updateCompany(company);
    }

    function updateAuditorCompany(company) {
      company.type = 'Audit';
      return updateCompany(company);
    }

    function isValidCompanyType(type) {
      var validTypes = [
        'Admin',
        'Audit',
        'AssetManagement',
        'AssetAppraisal',
        'AssetReview'
      ];
      return (!type || validTypes.indexOf(type) == -1);
    }

    function deleteCompany(companyId) {
      if (!companyId) {
        return $q.reject({message: 'invalid arguments'});
      }
      return $http.post(baseUrl + 'delete', {id: companyId}).then(function (response) {
        return response.data.data;
      });
    }

    function getValuationsAverage(companyId, currentUserOnly){
      if(!companyId){
        return $q.reject('invalid arguments');
      }
      var params = {
        companyId: companyId,
        currentUserOnly: currentUserOnly
      };
      return $http.get(baseUrl + 'getValuationsAverage', {params: params}).then(function (response) {
        return response.data.data;
      });
    }

  }
})();
(function () {

  angular
  .module('nvc')
  .factory('CompanySelectorFactory', CompanySelectorFactory);

  /** @Inject*/
  function CompanySelectorFactory($rootScope, $state) {

    var companies, errorEvent;

    $rootScope.$on('$stateChangeStart', function () {
      if (companies) {
        $rootScope.$emit('hideCompanyDropDown');
        var companiesCopy = angular.copy(companies);
        companies = undefined;

        errorEvent = $rootScope.$on('$stateChangeError', function () {
          companies = companiesCopy;
          $rootScope.$emit('displaySameCompanyDropDown');
          errorEvent();
          errorEvent = undefined;
        });
      }
    });

    $rootScope.$on('$stateChangeSuccess', function () {
      if(errorEvent){
        errorEvent();
        errorEvent = undefined;
      }
    });

    return {
      showCompanies: showCompanies,
      showDisabledCompanies: showDisabledCompanies,
      getCompanies: getCompanies,
      executeOnValidState: executeOnValidState
    };

    function showCompanies(companiesToShow, disable) {
      if (companiesToShow) {
        companies = companiesToShow;
        $rootScope.$emit('displayCompanyDropDown', {companies: companies, display: true, disable: disable || false});
      }
    }

    function showDisabledCompanies() {
      $rootScope.$emit('displayCompanyDropDownDisabled');
    }


    function getCompanies() {
      return companies;
    }

    /**
     * everything that is going to be executed on companyChanged should be done trough this function
     * @param stateName the state on which the action is valid
     * @param execute function to be executed
     * @returns {boolean}
     */
    function executeOnValidState(stateName, execute) {
      if ($state.current.name === stateName) {
        execute();
        return true;
      }
      return false;
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .service('BidResponseService', BidResponseService);

  /** @ngInject */
  function BidResponseService($q, $http, EnvironmentConfig) {

    var host = EnvironmentConfig.API_BASE;
    var resourceEnd = 'bidresponse/';
    var baseUrl = host + resourceEnd;

    return {
      get: get,
      listByAssetId: listByAssetId,
      listByAppraiserId: listByAppraiserId,
      listByBidRequestId: listByBidRequestId,
      updateBidResponse: updateBidResponse,
      deleteBidResponse: deleteBidResponse
    };

    function get(bidResponseId) {
      if (!bidResponseId) {
        return $q.reject();
      }
      return $http.get(baseUrl + 'get', {params: {id: bidResponseId}}).then(function (response) {
        return response.data.data;
      });
    }

    function listByAssetId(assetId) {
      if (!assetId) {
        return $q.reject('invalid parameters');
      }
      return $http.get(baseUrl + 'list', {params: {assetId: assetId}}).then(function(response) {
        return response.data.data;
      });
    }

    function listByAppraiserId(appraiserId) {
      if (!appraiserId) {
        return $q.reject('invalid parameters');
      }
      return $http.get(baseUrl + 'list', {params: {appraiserId: appraiserId}}).then(function(response) {
        return response.data.data;
      });
    }

    function listByBidRequestId(bidRequestId) {
      if (!bidRequestId) {
        return $q.reject('invalid parameters');
      }
      return $http.get(baseUrl + 'list', {params: {bidRequestId: bidRequestId}}).then(function(response) {
        return response.data.data;
      });
    }

    function updateBidResponse(bidResponse) {
      if (!bidResponse || !bidResponse.id) {
        return $q.reject('invalid parameters');
      }
      return $http.post(baseUrl + 'update', bidResponse).then(function (response) {
        return response.data.data;
      });
    }

    function deleteBidResponse(bidResponseId) {
      if (!bidResponseId) {
        return $q.reject('invalid parameters');
      }
      return $http.post(baseUrl + 'delete', bidResponseId).then(function (response) {
        return response.data.data;
      });
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .service('BidRequestService', BidRequestService);

  /** @ngInject */
  function BidRequestService($q, $http, EnvironmentConfig, localStorageService) {

    var host = EnvironmentConfig.API_BASE;
    var resourceEnd = 'bidrequest/';
    var baseUrl = host + resourceEnd;

    return {
      create: create,
      get: get,
      listByCompanyId: listByCompanyId,
      listByCompanyIdPage: listByCompanyIdPage,
      listUsersByBidRequestId: listUsersByBidRequestId,
      listByUserId: listByUserId,
      listByUserIdPage: listByUserIdPage,
      declineBidRequest: declineBidRequest,
      sendEmailToAdmin: sendEmailToAdmin,
      sendEmailToAppraiser: sendEmailToAppraiser,
      createEngagementLetter: createEngagementLetter,
      uploadAppraiserLetter: uploadAppraiserLetter,
      listBidRequestLetters: listBidRequestLetters,
      listBidRequestLettersByIds: listBidRequestLettersByIds,
      getLastBidRequestLetterByUserId: getLastBidRequestLetterByUserId,
      downloadEngagementLetter: downloadEngagementLetter,
      deleteEngagementLetter: deleteEngagementLetter,
      cancelBidRequest: cancelBidRequest
    };

    function create(companyId, name, dueDate, appraisersIdsByAssetIds) {
      if (!companyId || !name || !dueDate || !appraisersIdsByAssetIds) {
        return $q.reject('invalid arguments');
      }

      var params = {
        companyId: companyId,
        name: name,
        dueDate: dueDate,
        session: localStorageService.cookie.get('session_token'),
        relations: JSON.stringify(appraisersIdsByAssetIds)
      };

      return $http.post(baseUrl + 'create', params).then(function (response) {
        return response.data.data;
      });
    }

    function createEngagementLetter(bidRequestId, userId, letter, fileName) {
      if (!bidRequestId || !userId || !fileName || !letter ) {
        return $q.reject('invalid parameters');
      }
      var formData = new FormData();
      formData.append('session', localStorageService.cookie.get('session_token'));
      formData.append('bidRequestId', bidRequestId);
      formData.append('name', fileName);
      formData.append('userId', userId);
      formData.append('letter', letter);

      var config = {
        transformRequest: angular.identity,
        headers: {
          'Content-Type': undefined
        }
      };

      return $http.post(baseUrl + 'engagementletter/create', formData, config).then(function (response) {
        return response.data.data;
      });
    }

    function get(id) {
      if (!id) {
        return $q.reject('Missing required params');
      }
      return $http.get(baseUrl + 'get', {params: {id: id}}).then(function(response){
        return response.data.data;
      });
    }

    function listByCompanyIdPage(companyId, page, pageSize, searchQuery, sortKey, sortOrder) {
      if (!companyId) {
        return $q.reject('Missing required params');
      }

      var params = {
        companyId: companyId,
        page: page,
        pageSize: pageSize,
        search: searchQuery,
        sortKey: sortKey,
        sortOrder: sortOrder
      };

      return $http.get(baseUrl + 'list', {params: params}).then(function (response) {
        var formatResponse = {},
        range = response.headers()['content-range'];
        formatResponse.bids = response.data.data;
        var pageInfo = {};
        pageInfo.count = parseInt(range.substring(range.indexOf('/')+1));
        pageInfo.current = range.substring(range.indexOf(' ')+1, range.indexOf('/'));
        pageInfo.currentStart = parseInt(pageInfo.current.substring(0, pageInfo.current.indexOf('-')));
        pageInfo.currentEnd = parseInt(pageInfo.current.substring(pageInfo.current.indexOf('-')+1));
        formatResponse.pageInfo = pageInfo;
        return formatResponse;
      });
    }

    function listByCompanyId(companyId) {
      if (!companyId) {
        return $q.reject('Missing required params');
      }
      return $http.get(baseUrl + 'list', {params: {companyId: companyId}}).then(function (response) {
        return response.data.data;
      });
    }

    function listUsersByBidRequestId(assetId, bidRequestId, activeOnly) {
      if (!assetId || !bidRequestId) {
        return $q.reject('invalid parameters');
      }
      return $http.get(host + 'asset/user/list', {params: {assetId: assetId, bidRequestId: bidRequestId, activeOnly: activeOnly}}).then(function (response) {
        return response.data.data;
      });
    }

    function listByUserId(userId) {
      if (!userId) {
        return $q.reject('Missing required params');
      }
      return $http.get(baseUrl + 'listByUser', {params: {userId: userId}}).then(function (response) {
        return response.data.data;
      });
    }

    function listByUserIdPage(userId, page, pageSize, searchQuery, sortKey, sortOrder) {
      if (!userId) {
        return $q.reject('Missing required params');
      }

      var options = {
        params: {
          userId: userId,
          page: page,
          pageSize: pageSize,
          search: searchQuery,
          sortKey: sortKey,
          sortOrder: sortOrder
        }
      };

      return $http.get(baseUrl + 'listByUser', options).then(function (response) {
        var formatResponse = {},
          range = response.headers()['content-range'];
        formatResponse.bids = response.data.data;
        var pageInfo = {};
        pageInfo.count = parseInt(range.substring(range.indexOf('/')+1));
        pageInfo.current = range.substring(range.indexOf(' ')+1, range.indexOf('/'));
        pageInfo.currentStart = parseInt(pageInfo.current.substring(0, pageInfo.current.indexOf('-')));
        pageInfo.currentEnd = parseInt(pageInfo.current.substring(pageInfo.current.indexOf('-')+1));
        formatResponse.pageInfo = pageInfo;
        return formatResponse;
      });
    }

    function declineBidRequest(rfpId) {
      if(!rfpId) {
        return $q.reject('Missing required params');
      }
      return $http.post(baseUrl + 'decline', {id: rfpId}).then(function (response) {
        return response.data.data;
      });
    }

    function sendEmailToAdmin(rfpId, isResubmitted,bidResponseIds) {
      if(!rfpId) {
        return $q.reject('Missing required params');
      }
      return $http.post(baseUrl + 'submitByAppraiser', {id: rfpId, isResubmitted: isResubmitted, bidResponseIds: bidResponseIds}).then(function (response) {
        return response.data.data;
      });
    }

    function sendEmailToAppraiser(rfpId, userId) {
      if(!rfpId || !userId) {
        return $q.reject('Missing required params');
      }
      return $http.post(baseUrl + 'assignByAdmin', {id: rfpId, userId: userId}).then(function (response) {
        return response.data.data;
      });
    }

    function uploadAppraiserLetter(rfpId, letter) {
      if(!rfpId || !letter) {
        return $q.reject('invalid parameters');
      }

      var formData = new FormData();
      formData.append('session', localStorageService.cookie.get('session_token'));
      formData.append('bidRequestId', rfpId);
      formData.append('letter', letter);

      var config = {
        transformRequest: angular.identity,
        headers: {
          'Content-Type': undefined
        }
      };

      return $http.post(baseUrl + 'engagementletter/create', formData, config).then(function (response) {
        return response.data.data;
      });

    }

    function listBidRequestLetters(userId, assetTypes, date, companyId){
      var params = {};
      if(userId){
        params.userId = userId;
      }
      if(companyId) {
        params.companyId = companyId
      }
      if(assetTypes && assetTypes.length > 0){
        params.assetTypes = assetTypes.toString();
      }
      if(date){
        params.date = date;
      }
      return $http.get(baseUrl + 'engagementletter/list', {params: params}).then(function (response) {
        return response.data.data;
      });
    }

    function listBidRequestLettersByIds(userIds, assetTypes, date, managementCompanyId){
      var params = {};
      if(userIds && userIds.length > 0){
        params.userIds = userIds.toString();
      }
      if(assetTypes && assetTypes.length > 0){
        params.assetTypes = assetTypes.toString();
      }
      if(date){
        params.date = date;
      }
      if(managementCompanyId){
        params.companyId = managementCompanyId;
      }
      return $http.get(baseUrl + 'engagementletter/list', {params: params}).then(function (response) {
        return response.data.data;
      });
    }

    function listBidRequestLettersByUserId(bidRequestId, userId) {
      if(!bidRequestId || !userId) {
        return $q.reject('invalid parameters');
      }
      var params = {
        bidRequestId: bidRequestId,
        userId: userId
      };
      return $http.get(baseUrl + 'engagementletter/list', {params: params}).then(function (response) {
        return response.data.data;
      });
    }

    function getLastBidRequestLetterByUserId(bidRequestId, userId) {
      return listBidRequestLettersByUserId(bidRequestId, userId).then(function (response){
        var letters = response, uniques = [];

        for (var i = 0; i < letters.length; i++) {
          var letter = letters[i], founded = false;
          for (var j = 0; j < uniques.length; j++) {
            if(letter.fileName == uniques[j].fileName) {
              founded = true;
              break;
            }
          }

          if(!founded) {
            uniques.push(letter);
          }
          for(j = 0; j < letters.length; j++) {
            var letter2 = letters[j];
            if(letter2.fileName == letter.fileName && letter2.createdOn > letter.createdOn) {
              for(var k = 0; k < uniques.length; k++) {
                if(uniques[k].fileName == letter2.fileName) {
                  uniques[k] = letter2;
                }
              }
            }
          }
        }
        return uniques;
      });
    }

    function downloadEngagementLetter(letterId, redirect) {
      if(!letterId) {
        return $q.reject('invalid parameters');
      }
      var params = {
        id: letterId,
        redirect: redirect
      };
      return $http.get(baseUrl + 'engagementletter/download', {params: params}).then(function (response) {
        return response.data.data;
      });
    }

    function deleteEngagementLetter(letterId) {
      if(!letterId) {
        return $q.reject('invalid parameters');
      }
      return $http.post(baseUrl + 'engagementletter/delete', {id: letterId}).then(function (response) {
        return response.data.data;
      });
    }

    function cancelBidRequest(bidRequestId) {
      if(!bidRequestId) {
        return $q.reject('invalid parameters');
      }
      return $http.post(baseUrl + 'update', {id: bidRequestId, isCancelled: true}).then(function (response) {
        return response.data.data;
      });
    }
  }

})();

(function () {
  'use strict';

  angular
  .module('nvc')
  .service('BidGroupService', BidGroupService);

  /** @ngInject */
  function BidGroupService($q, $http, EnvironmentConfig) {

    var host = EnvironmentConfig.API_BASE;
    var resourceEnd = 'bidgroup/';
    var baseUrl = host + resourceEnd;

    return {
      create: create,
      assignAssets: assignAssets,
      get: get,
      list: list,
      listPage: listPage,
      update: update,
      deleteBidGroup: deleteBidGroup
    };

    function create(bidGroup){
      if (!bidGroup.companyId || !bidGroup.name) {
        return $q.reject('Missing required params');
      }
      return $http.post(baseUrl + 'create', bidGroup).then(function(response){
        return response.data.data;
      });
    }

    function assignAssets(bidGroupId, assetIds, removeAssetsIds){
      if (!bidGroupId || !assetIds || !Array.isArray(assetIds)) {
        return $q.reject('Missing required params');
      }

      var params = {id: bidGroupId, assetIds: assetIds.toString()};
      if(removeAssetsIds && removeAssetsIds.length > 0){
        params.removeAssetIds = removeAssetsIds;
      }

      return $http.post(baseUrl + 'assign', params).then(function(response){
        return response.data.data;
      });
    }

    function get(bidGroupId){
      if (!bidGroupId) {
        return $q.reject('Missing required params');
      }
      return $http.get(baseUrl + 'get', {params: {id: bidGroupId}}).then(function(response){
        return response.data.data;
      });
    }

    function list(companyId){
      if (!companyId) {
        return $q.reject('Missing required params');
      }
      return $http.get(baseUrl + 'list', {params: {companyId: companyId}}).then(function(response){
        return response.data.data;
      });
    }

    function listPage(companyId, page, pageSize, searchQuery, sortKey, sortOrder){
      var options = {
        params: {
          companyId: companyId,
          page: page,
          pageSize: pageSize,
          search: searchQuery,
          sortKey: sortKey,
          sortOrder: sortOrder
        }
      };

      return $http.get(baseUrl + 'list', options).then(function(response){
        var formatResponse = {},
        range = response.headers()['content-range'];
        formatResponse.bidGroups = response.data.data;
        var pageInfo = {};
        pageInfo.count = parseInt(range.substring(range.indexOf('/')+1));
        pageInfo.current = range.substring(range.indexOf(' ')+1, range.indexOf('/'));
        pageInfo.currentStart = parseInt(pageInfo.current.substring(0, pageInfo.current.indexOf('-')));
        pageInfo.currentEnd = parseInt(pageInfo.current.substring(pageInfo.current.indexOf('-')+1));
        formatResponse.pageInfo = pageInfo;
        return formatResponse;
      });
    }

    function update(bidGroup){
      if (!bidGroup.id || !bidGroup.name) {
        return $q.reject('Missing required params');
      }
      return $http.post(baseUrl + 'update', bidGroup).then(function(response){
        return response.data.data;
      });
    }

    function deleteBidGroup(bidGroupId) {
      if (!bidGroupId) {
        return $q.reject('Missing required params');
      }
      return $http.post(baseUrl + 'delete', bidGroupId).then(function (response) {
        return response.data.data;
      });
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .service('AssetService', AssetService);

  /** @ngInject */
  function AssetService($q, $http, localStorageService, EnvironmentConfig) {

    var host = EnvironmentConfig.API_BASE;
    var resourceEnd = 'asset/';
    var baseUrl = host + resourceEnd;

    return {
      getAssetsByCompany: getAssetsByCompany,
      getAssetsByCompanyPage: getAssetsByCompanyPage,
      getAsset: getAsset,
      createAsset: createAsset,
      addPrimary: addPrimary,
      addUser: addUser,
      updateUser: updateUser,
      updateAsset: updateAsset,
      updateAssetSchedule: updateAssetSchedule,
      updateImage: updateImage,
      get: get,
      list: list,
      listAll: listAll,
      listUsers: listUsers,
      removeUser: removeUser,
      getAssetUsersList: getAssetUsersList,
      addUserPeriod: addUserPeriod,
      updateUserPeriod: updateUserPeriod,
      deletePeriod: deletePeriod,
      getAssetsByUser: getAssetsByUser,
      getAssetsByBidGroup: getAssetsByBidGroup,
      getAssetByBidRequestId: getAssetByBidRequestId,
      listByBidRequestId: listByBidRequestId,
      getAssetsWithValuationsAndUsersByCompany: getAssetsWithValuationsAndUsersByCompany,
      getAppraiserStatistic: getAppraiserStatistic,
      listForRFP: listForRFP,
      documentList: documentList,
      documentCreate: documentCreate,
      documentDelete: documentDelete,
      documentDownload: documentDownload,
      documentListByBidRequest: documentListByBidRequest,
      deleteAsset: deleteAsset,
      loadAssetsFromCsv: loadAssetsFromCsv,
      addPrimaryUserWithType: addPrimaryUserWithType,
      getAllAssetsByCompany: getAllAssetsByCompany
    };

    function createAsset(asset) {
      return $http.post(baseUrl + 'create', asset).then(function (response) {
        return response.data.data;
      });
    }

    function getAssetsByCompany(companyId, active) {
      if (!companyId) {
        return $q.reject('id required');
      }
      return $http.get(baseUrl + 'list', {params: {companyId: companyId, active: active}}).then(function (response) {
        return response.data.data;
      });
    }

    function getAssetsByCompanyPage(companyId, active, page, pageSize, searchQuery, sortKey, sortOrder) {
      if (!companyId) {
        return $q.reject('id required');
      }
      var options = {
        params: {
          companyId: companyId,
          active: active,
          page: page,
          pageSize: pageSize,
          search: searchQuery,
          sortKey: sortKey,
          sortOrder: sortOrder
        }
      };
      return $http.get(baseUrl + 'list', options).then(function (response) {
        var formatResponse = {},
        range = response.headers()['content-range'];
        formatResponse.assets = response.data.data;
        var pageInfo = {};
        pageInfo.count = parseInt(range.substring(range.indexOf('/')+1));
        pageInfo.current = range.substring(range.indexOf(' ')+1, range.indexOf('/'));
        pageInfo.currentStart = parseInt(pageInfo.current.substring(0, pageInfo.current.indexOf('-')));
        pageInfo.currentEnd = parseInt(pageInfo.current.substring(pageInfo.current.indexOf('-')+1));
        formatResponse.pageInfo = pageInfo;
        return formatResponse;
      });
    }

    function getAllAssetsByCompany(companyId, active, searchQuery, sortKey, sortOrder) {
      if (!companyId) {
        return $q.reject('id required');
      }
      var options = {
        params: {
          companyId: companyId,
          active: active,
          page: null,
          pageSize: null,
          search: searchQuery,
          sortKey: sortKey,
          sortOrder: sortOrder
        }
      };
      return $http.get(baseUrl + 'list', options).then(function (response) {
        return response.data.data;
      });
    }

    function getAsset(assetId) {
      if (!assetId) {
        return $q.reject('id required');
      }
      return $http.get(baseUrl + 'get', {params: {id: assetId}}).then(function (response) {
        return response.data.data;
      });
    }

    function updateAsset(asset) {
      if (!asset || !asset.id) {
        return $q.reject('Invalid arguments');
      }
      return $http.post(baseUrl + 'update', asset).then(function (response) {
        return response.data.data;
      });
    }

    function updateAssetSchedule(assetId, scheduleNumber, date) {
      if (!assetId || !scheduleNumber || !date) {
        return $q.reject('Invalid arguments');
      }
      var scheduleField = 'scheduleQ' + scheduleNumber;
      var assetDTO = {
        id: assetId
      };
      assetDTO[scheduleField] = Date.parse(date);
      return $http.post(baseUrl + 'update', assetDTO).then(function (response) {
        return response.data.data;
      });
    }

    function updateImage(assetId, picture) {
      if (!assetId || !picture) {
        return $q.reject('Invalid arguments');
      }

      var formData = new FormData();
      formData.append('picture', dataURItoBlob(picture));
      formData.append('id', assetId);
      formData.append('session', localStorageService.cookie.get('session_token'));
      var config = {
        transformRequest: angular.identity,
        headers: {
          'Content-Type': undefined
        }
      };
      return $http.post(baseUrl + 'update', formData, config).then(function (response) {
        return response.data.data;
      });
    }

    function dataURItoBlob(dataURI) {
      // convert base64 to raw binary data held in a string
      // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
      var byteString = atob(dataURI.split(',')[1]);

      // separate out the mime component
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

      // write the bytes of the string to an ArrayBuffer
      var ab = new ArrayBuffer(byteString.length);
      var ia = new Uint8Array(ab);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }

      // write the ArrayBuffer to a blob, and you're done
      var bb = new Blob([ab], {type: mimeString});
      return bb;
    }

    function addPrimary(assetId, userId, quarter, year) {
      if (!assetId || !userId) {
        return $q.reject('invalid parameters');
      }

      return addUser(assetId, userId).then(function (user) {
        return addUserPeriod({id: user.id, quarter: quarter, year: year, isPrimary: true});
      });
    }

    function addPrimaryUserWithType(assetId, userId, type, useExisting) {
      if (!assetId || !userId) {
        return $q.reject('invalid parameters');
      }

      return addUser(assetId, userId, type, useExisting)
      // .then(function (user) {
      //   return addUserPeriod({id: user.id, quarter: quarter, year: year, isPrimary: true});
      // });
    }

    function addUser(assetId, userId, type, useExisting) {
      if (!assetId || !userId) {
        return $q.reject('invalid parameters');
      }
      var relationship = {
        assetId: assetId,
        userId: userId
      };
      if (type) {
        relationship.type = type;
      }

      if (useExisting) {
        relationship.useExistingAssociationIfExists = useExisting
      }

      return $http.post(baseUrl + 'user/create', relationship).then(function (response) {
        return response.data.data;
      });
    }

    function updateUser(user) {
      if (!user || !user.id) {
        return $q.reject('invalid arguments');
      }
      return $http.post(baseUrl + 'user/update', user).then(function (response) {
        return response.data.data;
      });
    }

    function listUsers(assetId, activeOnly) {
      if (!assetId) {
        return $q.reject('invalid parameters');
      }

      return $http.get(baseUrl + 'user/list', {params: {assetId: assetId, activeOnly: activeOnly}}).then(function (response) {
        return response.data.data;
      });
    }

    function removeUser(relationId) {
      if (!relationId) {
        return $q.reject('invalid parameters');
      }

      return $http.post(baseUrl + 'user/delete', {id: relationId}).then(function (response) {
        return true;
      });
    }

    function get(assetId) {
      if (!assetId) {
        return $q.reject('id required');
      }
      return $http.get(baseUrl + 'get', {params: {id: assetId}}).then(function (response) {
        return response.data.data;
      });
    }

    function list(companyId, search, page, pageSize, sortKey, sortOrder, active) {
      var params = {
        params: {
          companyId: companyId,
          search: search,
          page: page,
          pageSize: pageSize,
          sortKey: sortKey,
          sortOrder: sortOrder,
          active: active
        }
      };
      return $http.get(baseUrl + 'list', params).then(function (response) {
        return response.data.data;
      });
    }

    function listAll(companyId, search, page, pageSize, sortKey, sortOrder, active) {
      var params = {
        params: {
          all: true,
          companyId: companyId,
          search: search,
          page: page,
          pageSize: pageSize,
          sortKey: sortKey,
          sortOrder: sortOrder,
          active: active
        }
      };
      return $http.get(baseUrl + 'list', params).then(function (response) {
        return response.data.data;
      });
    }

    function getAssetsByUser() {
      return $http.get(baseUrl + 'listAssigned').then(function (response) {
        return response.data.data;
      });
    }

    function getAssetsByBidGroup(bidGroupId) {
      return $http.get(baseUrl + 'list', {params: {bidGroupId: bidGroupId}}).then(function (response) {
        return response.data.data;
      });
    }

    function getAssetByBidRequestId (id, bidRequestId) {
      if(!id || !bidRequestId) {
        return $q.reject('invalid parameters');
      }
      return $http.get(baseUrl + 'getByBidrequest', {params: {id: id, bidRequestId: bidRequestId}}).then(function (response) {
        return response.data.data;
      });
    }

    function listByBidRequestId (bidRequestId) {
      if(!bidRequestId) {
        return $q.reject('invalid parameters');
      }
      return $http.get(baseUrl + 'listAssigned', {params: {bidRequestId: bidRequestId}}).then(function (response) {
        return response.data.data;
      });
    }

    function getAssetsWithValuationsAndUsersByCompany(companyId) {
      if (!companyId) {
        return $q.reject('invalid parameters');
      }
      return $http.get(baseUrl + 'listassetusersvaluations', {params: {companyId: companyId}}).then(function (response) {
        var formatted = [];
        response.data.data.forEach(function (data) {
          data.asset.valuations = data.valuations;
          data.asset.users = data.relationships;
          formatted.push(data.asset);
        });
        return formatted;
      });
    }

    function getAppraiserStatistic(appraiserId) {
      if (!appraiserId) {
        return $q.reject('id required');
      }
      return $http.get(baseUrl + 'user/getAppraiserStatistic', {params: {appraiserId: appraiserId}}).then(function (response) {
        return response.data.data;
      });
    }

    function listForRFP(companyId, bidGroupsIds, rollingOnRange, assetTypes, countries, states, active, page, pageSize, searchQuery, sortKey, sortOrder) {
      if (!companyId) {
        return $q.reject('invalid parameters');
      }
      var params = {
        companyId: companyId,
        page: page,
        pageSize: pageSize,
        search: searchQuery,
        sortKey: sortKey,
        sortOrder: sortOrder
      };
      if (bidGroupsIds && bidGroupsIds.length > 0) {
        params.bidGroupIds = bidGroupsIds.toString();
      }
      if (rollingOnRange && rollingOnRange.length > 0) {
        var parsedRanges = [];
        rollingOnRange.forEach(function (range) {
          if (range.from && range.to) {
            parsedRanges.push(range.from);
            parsedRanges.push(range.to);
          }
        });
        params.rollingOnRanges = parsedRanges.toString();
      }
      if (assetTypes) {
        params.assetTypes = assetTypes.toString();
      }
      if (countries && countries.length > 0) {
        params.countries = countries.toString();
      }
      if (states && states.length > 0) {
        params.states = states.toString();
      }
      if (active) {
        params.active = active;
      }
      return $http.get(baseUrl + 'listForBidRequest', {params: params}).then(function (response) {
        var formatResponse = {},
        range = response.headers()['content-range'];
        formatResponse.assets = response.data.data;
        var pageInfo = {};
        pageInfo.count = parseInt(range.substring(range.indexOf('/')+1));
        pageInfo.current = range.substring(range.indexOf(' ')+1, range.indexOf('/'));
        pageInfo.currentStart = parseInt(pageInfo.current.substring(0, pageInfo.current.indexOf('-')));
        pageInfo.currentEnd = parseInt(pageInfo.current.substring(pageInfo.current.indexOf('-')+1));
        formatResponse.pageInfo = pageInfo;
        return formatResponse;
      });
    }

    function getAssetUsersList(assetId, activeOnly) {
      if (!assetId) {
        return $q.reject('id required');
      }
      return $http.get(baseUrl + 'user/list', {params: {assetId: assetId, activeOnly: activeOnly}}).then(function (response) {
        return response.data.data;
      });
    }

    function addUserPeriod(period) {
      if (!period || !period.id || !period.year || !period.quarter) {
        return $q.reject('invalid arguments');
      }
      period.getExistingIfExists = true;
      return $http.post(baseUrl + 'user/addperiod', period).then(function (response) {
        return response.data.data;
      });
    }

    function updateUserPeriod(period) {
      if (!period || !period.id) {
        return $q.reject('invalid arguments');
      }
      return $http.post(baseUrl + 'user/updateperiod', period).then(function (response) {
        return response.data.data;
      });
    }

    function deletePeriod(periodId){
      if (!periodId) {
        return $q.reject('invalid arguments');
      }
      return $http.post(baseUrl + 'user/deleteperiod', {id: periodId}).then(function (response) {
        return response.data.data;
      });
    }

    function documentList(assetId) {
      if (!assetId) {
        return $q.reject('id required');
      }
      return $http.get(baseUrl + 'document/list', {params: {assetId: assetId}}).then(function (response) {
        return response.data.data;
      });
    }

    function documentListByBidRequest(assetId, bidRequestId) {
      if (!assetId || !bidRequestId) {
        return $q.reject('id required');
      }
      return $http.get(baseUrl + 'document/list', {params: {assetId: assetId, bidRequestId: bidRequestId}}).then(function (response) {
        return response.data.data;
      });
    }

    function documentCreate(assetId, file, fileName, type, status, version) {
      if (!assetId || !file) {
        return $q.reject('invalid parameters');
      }
      var formData = new FormData();
      formData.append('session', localStorageService.cookie.get('session_token'));
      formData.append('assetId', assetId);
      formData.append('name', fileName);
      formData.append('type', type);
      formData.append('status', status);
      formData.append('version', version);
      formData.append('document', file);

      var config = {
        transformRequest: angular.identity,
        headers: {
          'Content-Type': undefined
        }
      };

      return $http.post(baseUrl + 'document/create', formData, config).then(function (response) {
        return response.data.data;
      });
    }

    function documentDelete(documentId) {
      if (!documentId) {
        return $q.reject('invalid parameters');
      }
      return $http.post(baseUrl + 'document/delete', {id: documentId}).then(function () {
        return true;
      });
    }

    function documentDownload(documentId) {
      if (!documentId) {
        return $q.reject('invalid parameters');
      }
      return $http.get(baseUrl + 'document/download', {params: {id: documentId}}).then(function (response) {
        return response.data.data;
      });
    }

    function deleteAsset(assetId) {
      if (!assetId) {
        return $q.reject('Invalid parameters');
      }
      return $http.post(baseUrl + 'delete', {id: assetId}).then(function (response) {
        return response.data.data;
      });
    }

    function loadAssetsFromCsv(files, companyId) {
      if(!files || !companyId) {
        return $q.reject('Invalid parameters');
      }

      var formData = new FormData();
      formData.append('session', localStorageService.cookie.get('session_token'));
      formData.append('companyId', companyId);
      formData.append('assetsDocument', files.assetsDocument);
      formData.append('valuationsDocument', files.valuationsDocument);

      var config = {
        transformRequest: angular.identity,
        headers: {
          'Content-Type': undefined
        }
      };

      return $http.post(baseUrl + 'import', formData, config).then(function (response) {
        return response.data.data;
      });
    }

  }

})();

(function () {
  'use strict';

  angular
  .module('nvc')
  .factory('ValuationFactory', ValuationFactory);

  /**@ngInject*/
  function ValuationFactory($q, ValuationService, ValuationCommentsService) {

    return {
      loadValuation: loadValuation,
      loadAllValuationsByCompanyId: loadAllValuationsByCompanyId,
      loadDocuments: loadDocuments,
      getDocumentDownloadData: getDocumentDownloadData,
      saveValuation: saveValuation,
      addComment: addComment,
      addReplyToComment: addReplyToComment,
      loadComments: loadComments,
      removeComment: removeComment,
      updateComment: updateComment,
      updateDraftComment: updateDraftComment,
      submitComments: submitComments,
      reviewComments: reviewComments,
      loadAllValuations: loadAllValuations,
      loadSummary: loadSummary
    };


    function loadValuation(valuationId) {
      return ValuationService.getById(valuationId);
    }

    function loadAllValuationsByCompanyId(companyId) {
      return ValuationService.listValuationsByCompanyId(companyId);
    }

    function loadDocuments(valuationId) {
      return ValuationService.documentList(valuationId).then(function (documents) {
        return setDocumentUserRole(documents);
      });
    }

    function getDocumentDownloadData(document) {
      return ValuationService.documentDownload(document.id);
    }

    function saveValuation(valuation, reason) {
      return ValuationService.updateValuation(valuation, reason);//if valuation get a model return it instead
    }

    function addComment(valuation, comment) {
      comment.assetValuationId = valuation.id;
      return ValuationCommentsService.createComment(comment);
    }

    function addReplyToComment(comment, reply) {
      reply.parentCommentId = comment.id;
      return ValuationCommentsService.createReply(reply);
    }

    function loadComments(valuationId) {
      return ValuationCommentsService.listValuationComments(valuationId).then(function (comments) {
        comments.users = formatUsersComments(comments.users);
        comments.comments = formatComments(comments.comments);
        formatUsersRole(comments);
        return comments;
      });
    }

    function removeComment(comment, reason) {
      var commentToDelete = {
        id: comment.id
      };
      if (reason) {
        commentToDelete.reason = reason;
      }
      return ValuationCommentsService.deleteComment(commentToDelete);
    }

    function updateComment(comment, reason) {
      var commentToUpdate = {
        userCompanyId: comment.userCompanyId,
        amendingCommentId: comment.id,
        body: comment.body
      };
      if(reason){
        commentToUpdate.amendingReason = reason;
      }
      return ValuationCommentsService.amendComment(commentToUpdate).then(function (updatedComment) {
        updatedComment.replies = comment.replies;
        if (!updatedComment.history) {
          comment.history = [];
        }
        comment.history.push(comment);
        return updatedComment;
      });
    }

    function updateDraftComment(comment) {
      return ValuationCommentsService.updateComment(comment);
    }

    function submitComments(comments) {
      var notSubmited = [];
      var commentIdsToSubmit = getCommentsIds(comments, notSubmited);
      if (commentIdsToSubmit.length === 0) {
        return $q.reject('no comments to update');
      }

      return ValuationCommentsService.submitComments(commentIdsToSubmit.toString()).then(function (updatedComments) {
        updatedComments = updatedComments.concat(notSubmited);
        return updatedComments;
      });
    }

    function getCommentsIds(comments, notSubmited) {
      var commentIdsToSubmit = [];
      for (var i = 0; i < comments.length; i++) {
        var comment = angular.copy(comments[i]);
        if (comment) {
         if (comment.status == 'Draft' || comment.status == 'Review') {
            commentIdsToSubmit.push(comment.id);
          } else {
            notSubmited.push(comment);
          }
          if (comment.replies) {
            var newids = getCommentsIds(comment.replies, notSubmited);
            commentIdsToSubmit = commentIdsToSubmit.concat(newids);
            delete comment.replies;
          }
          if (comment.history) {
            commentIdsToSubmit = commentIdsToSubmit.concat(getCommentHistoryIds(comment.history, notSubmited));
          }
        }
      }
      return commentIdsToSubmit;
    }

    function getCommentHistoryIds(comment, notSubmited) {
      var commentIdsToSubmit = [];
      if (comment.status == 'Draft' || comment.status == 'Review') {
        commentIdsToSubmit.push(comment.id);
      } else {
        notSubmited.push(comment);
      }
      if (comment.history) {
        return commentIdsToSubmit.concat(getCommentHistoryIds(comment.history, notSubmited));
      }
      return commentIdsToSubmit;
    }

    function reviewComments(comments) {
      var commentIdsToReview = [];
      var notSubmited = [];
      for (var i = 0; i < comments.length; i++) {
        var comment = angular.copy(comments[i]);
        if (comment.status == 'Draft') {
          commentIdsToReview.push(comment.id);
        } else {
          if (comment.replies) {
            for (var j = 0; j < comment.replies.length; j++) {
              if (comment.replies[j].status == 'Draft') {
                commentIdsToReview.push(comment.replies[j].id);
              } else {
                notSubmited.push(comment.replies[j]);
              }
            }
            delete comment.replies;
          }
          notSubmited.push(comment);
        }
      }

      if (commentIdsToReview.length === 0) {
        return $q.reject('no comments to update');
      }

      return ValuationCommentsService.reviewComments(commentIdsToReview.toString()).then(function (updatedComments) {
        updatedComments = updatedComments.concat(notSubmited);
        return updatedComments;
      });
    }

    function formatComments(comments) {
      var formattedComments = [];
      var updatedComments = {};

      for (var i = 0; i < comments.length; i++) {
        var comment = comments[i];
        if (comment.amendingCommentId) {
          var amendingId = comment.amendingCommentId;
          if (comment.parentCommentId) {
            var parentId = findParentId(updatedComments, comment.parentCommentId);
            for (var j = 0; j < formattedComments.length; j++) {
              if (formattedComments[j].id === parentId) {
                for (var k = 0; k < formattedComments[j].replies.length; k++) {
                  var reply = formattedComments[j].replies[k];
                  if (reply.id === comment.amendingCommentId) {
                    updatedComments[reply.id] = amendingId;
                    comment.history = reply;
                    comment.originalUserId = reply.originalUserId || reply.userId;
                    comment.originalUserRole = reply.originalUserRole || reply.userRole;
                    comment.originalCommentTime = reply.originalCommentTime || reply.submittedOn || reply.createdOn;
                    formattedComments[j].replies.splice(k, 1);
                  }
                }
                formattedComments[j].replies.push(comment);
              }
            }
          } else {
            for (var j = 0; j < formattedComments.length; j++) {
              if (formattedComments[j].id === amendingId) {
                updatedComments[formattedComments[j].id] = comments[i].id;
                comment.history = formattedComments[j];
                comment.replies = formattedComments[j].replies;
                comment.originalUserId = formattedComments[j].originalUserId || formattedComments[j].userId;
                comment.originalUserRole = formattedComments[j].originalUserRole || formattedComments[j].userRole;
                comment.originalCommentTime = formattedComments[j].originalCommentTime || formattedComments[j].submittedOn || formattedComments[j].createdOn;
                formattedComments.push(comment);
                formattedComments.splice(j, 1);
              }
            }
          }
        } else if (comment.parentCommentId) {
          var parentId = findParentId(updatedComments, comment.parentCommentId);
          for (var j = 0; j < formattedComments.length; j++) {
            if (formattedComments[j].id === parentId) {
              if (!formattedComments[j].replies) {
                formattedComments[j].replies = [];
              }
              formattedComments[j].replies.push(comment);
            }
          }
        } else {
          formattedComments.push(comment);
        }
      }
      return formattedComments;
    }

    function findParentId(updatedCommentsId, id) {
      if (!updatedCommentsId[id]) {
        return id;
      }
      return findParentId(updatedCommentsId, updatedCommentsId[id]);
    }

    function formatUsersComments(users) {
      var formattedUsers = {};
      users.forEach(function (user) {
        formattedUsers[user.id] = user;
        if (user.userCompanyRoles.length > 1) {
          formattedUsers[user.id].type = 'Admin'
        } else {
          formattedUsers[user.id].type = user.userCompanyRoles[0];
        }
      });
      return formattedUsers;
    }

    function loadAllValuations(assetId, loggedInUserRoleName, loggedInUserCompanyId) {
      return ValuationService.listValuationsByAssetId(assetId, loggedInUserRoleName, loggedInUserCompanyId);
    }

    function formatUsersRole(comments) {
      comments.comments.forEach(function (comment) {
        if (!comment.userRole) {
          if (comment.originalUserId && comments.users[comment.originalUserId]) {
            if (comments.users[comment.originalUserId].userCompanyRoles.length > 1) {
              comment.userRole = 'Admin'
            } else {
              comment.userRole = comments.users[comment.originalUserId].userCompanyRoles[0];
            }
          } else if (comment.userId && comments.users[comment.userId]) {
            if (comments.users[comment.userId].userCompanyRoles.length > 1) {
              comment.userRole = 'Admin'
            } else {
              comment.userRole = comments.users[comment.userId].userCompanyRoles[0];
            }
          } else {
            comment.userRole = '';
          }
        }
        if (comment.replies) {
          var formattedReplies = angular.copy(comments);
          formattedReplies.comments = comment.replies;
          formatUsersRole(formattedReplies);
        }
      });
    }

    function setDocumentUserRole(documents) {
      documents.assetDocuments.forEach(function (document) {
        if (!document.userRole) {
          for (var i = 0; i < documents.users.length; i++) {
            var user = documents.users[i];
            if (user.id == document.userId) {
              if (user.userCompanyRoles.length > 1) {
                document.userRole = 'Admin';
              } else {
                document.userRole = user.userCompanyRoles[0];
              }
            }
          }
        }
      });
      return documents;
    }

    function loadSummary(companyId, page, pageSize, searchQuery, sortKey, sortOrder, myValuations, valuationFilters, futureValuations) {
      return ValuationService.listSummary(companyId, page, pageSize, searchQuery, sortKey, sortOrder, myValuations, valuationFilters, futureValuations).then(function (response) {
        var valuations = response.data.valuationSummaries;
        var users = {};
        valuations.forEach(function (valuation) {
          response.data.assetAndRelations.forEach(function (assetAndRelations) {
            if (assetAndRelations.asset.id === valuation.assetId) {
              valuation.asset = assetAndRelations.asset;
            }
            users[assetAndRelations.asset.id] = assetAndRelations.relations;
          });
          var history = response.data.statusHistory.find(function(single) {
            return single.valuationId == valuation.id
          });
          if (history) {
            valuation.formFilledDate = history.formFilledDate;
            valuation.commentsAnsweredDate = history.commentsAnsweredDate;
            valuation.managerApproveValuationDate = history.managerApproveValuationDate;
            valuation.managerCommentedDate = history.managerCommentedDate;
            valuation.reviewerApproveValuationDate = history.reviewerApproveValuationDate;
            valuation.reviewerCommentedDate = history.reviewerCommentedDate;
            valuation.submittedToAppraiserDate = history.submittedToAppraiserDate;
            valuation.valuationSignedOffDate = history.valuationSignedOffDate;
            valuation.valuationUpdatedDate = history.valuationUpdatedDate;
            valuation.finishedDate = history.finishedDate;
            valuation.finalFilesRejectedDate = history.finalFilesRejectedDate;
            valuation.finalFormFilledDate = history.finalFormFilledDate;
          }
        });

        return {valuations: valuations, users: users, pageInfo: response.pageInfo};
      });
    }
  }

})();

(function () {
  'use strict';

  angular
  .module('nvc')
  .factory('ReviewFactory', ReviewFactory);

  /**@ngInject*/
  function ReviewFactory(CONFIG, $q, $filter, SweetAlert, AssetFactory, ValuationFactory, ValuationService,
                         SessionManager, UtcDateConverter) {

    var untouchedValuation = null;

    return {
      loadReview: loadReview,
      loadAllReviewsByCompany: loadAllReviewsByCompany,
      saveDocuments: saveDocuments,
      saveReview: saveReview,
      addComment: addComment,
      addReplyToComment: addReplyToComment,
      removeComment: removeComment,
      updateComment: updateComment,
      updateDraftComment: updateDraftComment,
      submitComments: submitComments,
      reviewComments: reviewComments,
      assetToReview: assetToReview,
      copy: copy,
      loadAllAssetReviews: loadAllAssetReviews,
      invalidTransitionNotification: invalidTransitionNotification,
      loadPrevValuationsData: loadPrevValuationsData,
      setUntouchedValuation: setUntouchedValuation,
      saveDraftDueDate: saveDraftDueDate,
      saveQuarterDocuments: saveQuarterDocuments
    };

    function loadReview(assetId, valuationId) {
      return AssetFactory.loadAsset(assetId).then(function (asset) {
        return ValuationFactory.loadValuation(valuationId).then(function (valuation) {
          setUntouchedValuation(valuation);
          return ValuationFactory.loadDocuments(valuationId).then(function (documents) {
            valuation.documents = validateDocuments(documents);
            return ValuationFactory.loadComments(valuationId).then(function (comments) {
              valuation.comments = comments;
              asset.valuation = valuation;
              return createReviewFromAssetUsersAndValuation(asset, angular.copy(asset.users), valuationToReview(valuation));
            });
          });
        });
      });
    }

    function loadAllReviewsByCompany(companyId, page, pageSize, searchQuery, sortKey, sortOrder, myValuations, valuationFilters, futureValuations) {
      return ValuationFactory.loadSummary(companyId, page, pageSize, searchQuery, sortKey, sortOrder, myValuations, valuationFilters, futureValuations).then(function (response) {
        var valuations = response.valuations,
        users = response.users,
        reviews = [];
        valuations.forEach(function (valuation) {
          var asset = valuation.asset,
          usersById = {};
          users[asset.id].forEach(function (user) {
            usersById[user.user.id] = angular.copy(user);
          });
          asset.users = {};
          reviews.push(createReviewFromAssetUsersAndValuation(asset, usersById, valuationToReview(valuation)));
        });
        return {reviews: reviews, pageInfo: response.pageInfo};
      });
    }

    function createReviewFromAssetUsersAndValuation(asset, users, valuation) {
      delete asset.primaryAssetAppraiser;
      delete asset.primaryAssetManager;
      delete asset.primaryAssetReviewer;
      delete asset.primaryAssetAuditor;
      for (var i = 0; i < Object.keys(users).length; i++) {
        var user = angular.copy(users[Object.keys(users)[i]]);
        for (var j = 0; j < user.periods.length; j++) {
          var period = angular.copy(user.periods[j]);
          if (period.year == valuation.year && period.quarter == valuation.quarter) {
            user.active = period.active;
            if (period.isPrimary) {
              switch (user.userCompanyType) {
                case 'AssetManagement':
                  user.type = 'PrimaryAssetManager';
                  if (user.active) {
                    asset.primaryAssetManager = user;
                  }
                  break;
                case 'AssetAppraisal':
                  user.type = 'PrimaryAssetAppraiser';
                  if (user.active) {
                    asset.primaryAssetAppraiser = user;
                  }
                  break;
                case 'AssetReview':
                  user.type = 'PrimaryAssetReviewer';
                  if (user.active) {
                    asset.primaryAssetReviewer = user;
                  }
                  break;
                case 'Audit':
                  user.type = 'PrimaryAssetAuditor';
                  if (user.active) {
                    asset.primaryAssetAuditor = user;
                  }
              }
            } else {
              switch (user.userCompanyType) {
                case 'AssetManagement':
                  user.type = 'SecondaryAssetManager';
                  break;
                case 'AssetAppraisal':
                  user.type = 'SecondaryAssetAppraiser';
                  break;
                case 'AssetReview':
                  user.type = 'SecondaryAssetReviewer';
                  break;
              }
            }
            asset.users[user.user.id] = user;
          } 
          // else if(period.year == valuation.year && asset.requiredAppraisers == 'ExternalOnly' && user.userCompanyType == 'AssetAppraisal'){
          //   user.type = 'PrimaryAssetAppraiser';
          //   if (period.active) {
          //     asset.primaryAssetAppraiser = user;
          //   }
          // }
        }
      }
      var formattedAsset = AssetFactory.copy(asset);
      delete formattedAsset.valuations;
      return new ReviewModel(angular.merge({
        config: CONFIG
      }, {asset: formattedAsset}, valuation));
    }

    function saveDocuments(review) {
      var promises = [];
      var documents = [];
      review.documents.assetDocuments.forEach(function (file) {
        if (!file.id) {
          promises.push(ValuationService.documentCreate(file.assetValuationId, file.$document, file.name, file.type, file.status, file.version, file.$document.userCompanyId, file.premise));
          file.$document = {};
        } else {
          documents.push(file);
        }
      });
      return $q.all(promises).then(function (newDocs) {
        documents = documents.concat(newDocs);
        review.documents.assetDocuments = documents;
        return review;
      });
    }

    function saveQuarterDocuments(review, quarter, year, valuationId) {
      var promises = [];
      var documents = [];
      review.documents.assetDocuments.forEach(function (file) {
        if (!file.id) {
          promises.push(ValuationService.documentCreate(valuationId ? valuationId : file.assetValuationId, file.$document, file.name, file.type, file.status, file.version, file.$document.userCompanyId, file.premise,
            quarter, year));
          file.$document = {};
        } else {
          documents.push(file);
        }
      });
      return $q.all(promises).then(function (newDocs) {
        documents = documents.concat(newDocs);
        review.documents.assetDocuments = documents;
        return review;
      });
    }
    function saveReview(review, reason) {
      var valuation = reviewToValuation(review);
      valuation.status = review.getCurrentStatus();
      if(review.documents.assetDocuments.length > 0) {
        valuation.assetDocumentId = review.documents.assetDocuments[review.documents.assetDocuments.length - 1].id;
      }      
      validateModifiedFields(untouchedValuation, valuation);
      return ValuationFactory.saveValuation(valuation, reason).then(function (updatedValuation) {
        review.asset.valuation = updatedValuation;
        return new ReviewModel(angular.merge({
          config: review.config,
          documents: review.documents,
          comments: review.comments
        }, {asset: review.asset}, valuationToReview(updatedValuation)));
      });
    }

    function saveDraftDueDate (review) {
      var valuation = reviewToValuation(review);
      return ValuationFactory.saveValuation(valuation).then(function (updatedValuation) {
        review.asset.valuation = updatedValuation;
        return new ReviewModel(angular.merge({
          config: review.config,
          documents: review.documents,
          comments: review.comments
        }, {asset: review.asset}, valuationToReview(updatedValuation)));
      });
    }

    function addComment(review, comment) {
      return ValuationFactory.addComment(reviewToValuation(review), comment).then(function (updatedComment) {
        if (!review.comments || !review.comments.comments) {
          review.comments = {
            comments: []
          }
        }
        review.comments.comments.push(updatedComment);
        return review;
      });
    }

    function addReplyToComment(review, comment, reply) {
      return ValuationFactory.addReplyToComment(comment, reply).then(function (createdReply) {
        if (!comment.replies || comment.replies.length === 0) {
          comment.replies = []
        }
        comment.replies.push(createdReply);
        for (var i = 0; i < review.comments.comments.length; i++) {
          if (review.comments.comments[i].id === comment.id) {
            review.comments.comments[i] = comment;
            break;
          }
        }
        return review;
      });
    }

    function submitComments(review) {
      return ValuationFactory.submitComments(review.comments.comments).then(function (updatedComments) {
        return saveReview(review).then(function (updatedReview) {
          updatedReview.comments.comments = updatedComments;
          return updatedReview;
        });
      });
    }

    function reviewComments(review) {
      return ValuationFactory.reviewComments(review.comments.comments).then(function (updatedComments) {
        return saveReview(review).then(function (updatedReview) {
          updatedReview.comments.comments = updatedComments;
          return updatedReview;
        });
      });
    }

    function removeComment(review, comment, reason) {
      return ValuationFactory.removeComment(comment, reason).then(function () {
        for (var i = 0; i < review.comments.comments.length; i++) {
          if (review.comments.comments[i].id == comment.id) {
            review.comments.comments.splice(i, 1);
            break;
          }
          if (review.comments.comments[i].replies) {
            var foundedInReplies = false;
            for (var j = 0; j < review.comments.comments[i].replies.length; j++) {
              if (review.comments.comments[i].replies[j].id == comment.id) {
                review.comments.comments[i].replies.splice(j, 1);
                foundedInReplies = true;
                break;
              }
            }
            if (foundedInReplies) {
              break;
            }
          }
        }
        return review;
      });
    }

    function updateComment(review, comment, reason) {
      return ValuationFactory.updateComment(comment, reason).then(function (updatedComment) {
        for (var i = 0; i < review.comments.comments.length; i++) {
          if (review.comments.comments[i].id == comment.id) {
            review.comments.comments[i] = updatedComment;
            break;
          }
        }
        return review;
      });
    }

    function updateDraftComment(review, comment) {
      return ValuationFactory.updateDraftComment(comment).then(function (updatedComment) {
        for (var i = 0; i < review.comments.comments.length; i++) {
          if (review.comments.comments[i].id == comment.id) {
            review.comments.comments[i] = updatedComment;
            break;
          }
        }
        return review;
      });
    }

    function reviewToValuation(review) {
      var filteredObject = filterObject(review, ['id', 'type', 'status', 'statusChangedWithAction', 'statusChangedOn', 'action', 'statusChangedBy', 'year', 'yearOfCycle', 'quarter', 'quarterOfCycle',
        'nextDraftDueDate', 'appraisalPrevious', 'appraisalDraft', 'appraisalFinal', 'appraisalPeriodDelta', 'appraisalPeriodDeltaValue', 'appraisalYearlyDelta', 'appraisalYearlyDeltaValue',
        'stabilizedCapRate', 'stabilizedCapRatePeriodDelta', 'stabilizedCapRateYearlyDelta', 'terminalRate', 'terminalRatePeriodDelta', 'terminalRateYearlyDelta',
        'discountRate', 'discountRatePeriodDelta', 'discountRateYearlyDelta', 'impliedCapRate', 'impliedCapRatePeriodDelta', 'impliedCapRateYearlyDelta',
        'avgContractRent', 'avgMarketRent', 'avgRentGrowth', 'deltaDiscountRate', 'deltaTerminalCapRate', 'deltaAvgMarketRentGrowth', 'deltaMarketRents', 'deltaContractRents',
        'deltaVacancyAndCollectionLoss', 'deltaDowntimeAndRenewalProbability', 'deltaExpenses', 'deltaRealEstateTaxes',
        'deltaBuildingCapital', 'deltaLeasingCapital', 'deltaOther', 'ppValueChangeExplanation', 'yyValueChangeExplanation', 'totalChange',
        'landAndOtherAdj', 'discountedCashFlowAnalysis', 'directCapitalizationAnalysis', 'stabilizedValue', 'stabilizedValueSf',
        'salesComparisonApproach', 'costApproach', 'insurableValue', 'absorptionPeriod', 'vPeriod', 'presentValue', 'statusDescription', 'appraiserCompanyId']);

      if (filteredObject.landAndOtherAdj) {
        cleanField(filteredObject, 'landAndOtherAdj');
      }

      if (filteredObject.discountedCashFlowAnalysis) {
        cleanField(filteredObject, 'discountedCashFlowAnalysis');
      }

      if (filteredObject.directCapitalizationAnalysis) {
        cleanField(filteredObject, 'directCapitalizationAnalysis');
      }

      if (filteredObject.stabilizedValue) {
        cleanField(filteredObject, 'stabilizedValue');
      }

      if (filteredObject.stabilizedValueSf) {
        cleanField(filteredObject, 'stabilizedValueSf');
      }

      if (filteredObject.absorptionPeriod) {
        cleanField(filteredObject, 'absorptionPeriod');
      }

      if (filteredObject.salesComparisonApproach) {
        cleanField(filteredObject, 'salesComparisonApproach');
      }

      if (filteredObject.costApproach) {
        cleanField(filteredObject, 'costApproach');
      }

      if (filteredObject.insurableValue) {
        cleanField(filteredObject, 'insurableValue');
      }

      if (filteredObject.stabilizedCapRate) {
        cleanField(filteredObject, 'stabilizedCapRate');
      }

      if (filteredObject.terminalRate) {
        cleanField(filteredObject, 'terminalRate');
      }

      if (filteredObject.discountRate) {
        cleanField(filteredObject, 'discountRate');
      }

      if (filteredObject.impliedCapRate) {
        cleanField(filteredObject, 'impliedCapRate');
      }

      if (filteredObject.avgContractRent) {
        cleanField(filteredObject, 'avgContractRent');
      }

      if (filteredObject.avgMarketRent) {
        cleanField(filteredObject, 'avgMarketRent');
      }

      if (filteredObject.avgRentGrowth) {
        cleanField(filteredObject, 'avgRentGrowth');
      }

      if (filteredObject.appraisalPeriodDelta) {
        parseField(filteredObject, 'appraisalPeriodDelta', true);
      }
      if (filteredObject.appraisalPeriodDeltaValue) {
        parseField(filteredObject, 'appraisalPeriodDeltaValue');
      }
      if (filteredObject.appraisalYearlyDelta) {
        parseField(filteredObject, 'appraisalYearlyDelta', true);
      }
      if (filteredObject.appraisalYearlyDeltaValue) {
        parseField(filteredObject, 'appraisalYearlyDeltaValue');
      }
      if (filteredObject.stabilizedCapRate) {
        filteredObject.stabilizedCapRate = Math.round(filteredObject.stabilizedCapRate * 100);
      }
      if (filteredObject.stabilizedCapRatePeriodDelta) {
        parseField(filteredObject, 'stabilizedCapRatePeriodDelta');
      }
      if (filteredObject.stabilizedCapRateYearlyDelta) {
        parseField(filteredObject, 'stabilizedCapRateYearlyDelta');
      }
      if (filteredObject.terminalRate) {
        filteredObject.terminalRate = Math.round(filteredObject.terminalRate * 100);
      }
      if (filteredObject.terminalRatePeriodDelta) {
        parseField(filteredObject, 'terminalRatePeriodDelta');
      }
      if (filteredObject.terminalRateYearlyDelta) {
        parseField(filteredObject, 'terminalRateYearlyDelta');
      }
      if (filteredObject.discountRate) {
        filteredObject.discountRate = Math.round(filteredObject.discountRate * 100);
      }
      if (filteredObject.discountRatePeriodDelta) {
        parseField(filteredObject, 'discountRatePeriodDelta');
      }
      if (filteredObject.discountRateYearlyDelta) {
        parseField(filteredObject, 'discountRateYearlyDelta');
      }
      if (filteredObject.impliedCapRate) {
        filteredObject.impliedCapRate = Math.round(filteredObject.impliedCapRate * 100);
      }
      if (filteredObject.impliedCapRatePeriodDelta) {
        parseField(filteredObject, 'impliedCapRatePeriodDelta');
      }
      if (filteredObject.impliedCapRateYearlyDelta) {
        parseField(filteredObject, 'impliedCapRateYearlyDelta');
      }
      if (filteredObject.avgContractRent) {
        filteredObject.avgContractRent = Math.round(filteredObject.avgContractRent * 100);
      }
      if (filteredObject.avgMarketRent) {
        filteredObject.avgMarketRent = Math.round(filteredObject.avgMarketRent * 100);
      }
      if (filteredObject.avgRentGrowth) {
        filteredObject.avgRentGrowth = Math.round(filteredObject.avgRentGrowth * 100);
      }
      if (filteredObject.stabilizedValueSf) {
        filteredObject.stabilizedValueSf = Math.round(filteredObject.stabilizedValueSf * 100);
      }

      return filteredObject;
    }

    function valuationToReview(valuation) {
      if (valuation.appraisalPeriodDelta) {
        valuation.appraisalPeriodDelta = valuation.appraisalPeriodDelta / 100;
      }
      if (valuation.appraisalYearlyDelta) {
        valuation.appraisalYearlyDelta = valuation.appraisalYearlyDelta / 100;
      }
      if (valuation.stabilizedCapRate) {
        valuation.stabilizedCapRate = valuation.stabilizedCapRate / 100;
      }
      if (valuation.terminalRate) {
        valuation.terminalRate = valuation.terminalRate / 100;
      }
      if (valuation.discountRate) {
        valuation.discountRate = valuation.discountRate / 100;
      }
      if (valuation.impliedCapRate) {
        valuation.impliedCapRate = valuation.impliedCapRate / 100;
      }
      if (valuation.avgContractRent) {
        valuation.avgContractRent = valuation.avgContractRent / 100;
      }
      if (valuation.avgMarketRent) {
        valuation.avgMarketRent = valuation.avgMarketRent / 100;
      }
      if (valuation.avgRentGrowth) {
        valuation.avgRentGrowth = valuation.avgRentGrowth / 100;
      }
      if (valuation.stabilizedValueSf) {
        valuation.stabilizedValueSf = valuation.stabilizedValueSf / 100;
      }


      return valuation;
    }

    function assetToReview(asset) {
      var valuation = asset.getCurrentValuation();
      return new ReviewModel(angular.merge({
        config: CONFIG
      }, {asset: asset}, valuation ? valuationToReview(valuation) : valuation));
    }

    function copy(review) {
      return new ReviewModel(angular.merge({
        config: CONFIG
      }, {asset: AssetFactory.copy(review.asset)}, valuationToReview(reviewToValuation(review))));
    }

    function loadAllAssetReviews(asset, loggedInUserRoleName, loggedInUserCompanyId) {
      return ValuationFactory.loadAllValuations(asset.id, loggedInUserRoleName, loggedInUserCompanyId).then(function (valuations) {
        var promises = [];
        valuations.forEach(function (valuation) {
          promises.push(ValuationFactory.loadDocuments(valuation.id).then(function (documents) {
            valuation.documents = validateDocuments(documents);
          }));
          promises.push(ValuationFactory.loadComments(valuation.id).then(function (comments) {
            valuation.comments = comments
          }));
        });
        return $q.all(promises).then(function () {
          var reviews = [];
          console.log(valuations);
          valuations.forEach(function (valuation) {
            reviews.push(new ReviewModel(angular.merge({config: CONFIG}, {asset: asset}, valuationToReview(valuation))));
          });
          return reviews;
        });
      });
    }

    function invalidTransitionNotification() {
      SweetAlert.swal({
        title: $filter('translate')('COMMENT_STATES.SORRY'),
        text: $filter('translate')('COMMENT_STATES.INVALID_TRANSITION'),
        confirmButtonColor: '#2c3d4e',
        confirmButtonText: $filter('translate')('COMMENT_STATES.OK'),
        closeOnConfirm: true
      });
    }

    function parseField(filteredObject, field, multiply) {
      if (filteredObject[field] == 'N/A') {
        delete filteredObject[field]
      } else if (filteredObject[field] && filteredObject[field] != 'N/A') {
        if (multiply) {
          filteredObject[field] = Math.round(filteredObject[field] * 100);
        } else {
          filteredObject[field] = parseFloat(filteredObject[field]);
        }
      }
    }

    function cleanField(filteredObject, field) {
      if (filteredObject[field] == 'N/A' || filteredObject[field] == "" || isNaN(filteredObject[field])) {
        delete filteredObject[field]
      }
    }

    function validateDocuments(documents) {
      var filteredDocuments = {
        assetDocuments: [],
        users: documents.users
      };

      // if(SessionManager.getRoleName() === 'AssetAppraisal') {
      if(false) {
        var currentUserCompanyId = SessionManager.getCompanyId();
        documents.assetDocuments.forEach(function (document) {
          if (document.userRole === 'AssetAppraisal' || document.userRole === 'Appraiser') {
            documents.users.forEach(function (user) {
              if (user.id === document.userId && user.userCompanyId === currentUserCompanyId) {
                filteredDocuments.assetDocuments.push(document);
              }
            });
          } else {
            filteredDocuments.assetDocuments.push(document);
          }
        });
        return filteredDocuments;
      }
      return documents;
    }

    function validateModifiedFields(oldReview, valuation) {
      var removeDeltas = (valuation.appraisalPeriodDeltaValue && valuation.appraisalPeriodDeltaValue === 0) &&
        (valuation.totalChange && valuation.totalChange === 0) ? true : false;
      if(oldReview.appraisalPrevious === valuation.appraisalPrevious) delete valuation.appraisalPrevious;
      if(oldReview.appraisalDraft === valuation.appraisalDraft) delete valuation.appraisalDraft;
      if(oldReview.appraisalFinal === valuation.appraisalFinal || valuation.appraisalFinal === 0 || valuation.appraisalFinal === '') delete valuation.appraisalFinal;

      if(oldReview.landAndOtherAdj === valuation.landAndOtherAdj) delete valuation.landAndOtherAdj;
      if(oldReview.discountedCashFlowAnalysis === valuation.discountedCashFlowAnalysis) delete valuation.discountedCashFlowAnalysis;
      if(oldReview.directCapitalizationAnalysis === valuation.directCapitalizationAnalysis) delete valuation.directCapitalizationAnalysis;
      if(oldReview.stabilizedValue === valuation.stabilizedValue) delete valuation.stabilizedValue;
      if(oldReview.stabilizedValueSf === valuation.stabilizedValueSf) delete valuation.stabilizedValueSf;
      if(oldReview.absorptionPeriod === valuation.absorptionPeriod) delete valuation.absorptionPeriod;
      if(oldReview.salesComparisonApproach === valuation.salesComparisonApproach) delete valuation.salesComparisonApproach;
      if(oldReview.costApproach === valuation.costApproach) delete valuation.costApproach;
      if(oldReview.insurableValue === valuation.insurableValue) delete valuation.insurableValue;

      if(oldReview.appraisalPeriodDelta === valuation.appraisalPeriodDelta || valuation.appraisalPeriodDelta === '') delete valuation.appraisalPeriodDelta;
      if(oldReview.appraisalPeriodDeltaValue === valuation.appraisalPeriodDeltaValue || valuation.appraisalPeriodDeltaValue === '') delete valuation.appraisalPeriodDeltaValue;
      if(oldReview.appraisalYearlyDelta === valuation.appraisalYearlyDelta || valuation.appraisalYearlyDelta === '') delete valuation.appraisalYearlyDelta;
      if(oldReview.appraisalYearlyDeltaValue === valuation.appraisalYearlyDeltaValue || valuation.appraisalYearlyDeltaValue === '') delete valuation.appraisalYearlyDeltaValue;

      if(oldReview.stabilizedCapRate === valuation.stabilizedCapRate) delete valuation.stabilizedCapRate;
      if(oldReview.stabilizedCapRatePeriodDelta === valuation.stabilizedCapRatePeriodDelta || valuation.stabilizedCapRatePeriodDelta === '' || isNaN(valuation.stabilizedCapRatePeriodDelta)) delete valuation.stabilizedCapRatePeriodDelta;
      if(oldReview.stabilizedCapRateYearlyDelta === valuation.stabilizedCapRateYearlyDelta || valuation.stabilizedCapRateYearlyDelta === '' || isNaN(valuation.stabilizedCapRateYearlyDelta)) delete valuation.stabilizedCapRateYearlyDelta;
      if(oldReview.terminalRate === valuation.terminalRate) delete valuation.terminalRate;
      if(oldReview.terminalRatePeriodDelta === valuation.terminalRatePeriodDelta || valuation.terminalRatePeriodDelta === '' || isNaN(valuation.terminalRatePeriodDelta)) delete valuation.terminalRatePeriodDelta;
      if(oldReview.terminalRateYearlyDelta === valuation.terminalRateYearlyDelta || valuation.terminalRateYearlyDelta === '' || isNaN(valuation.terminalRateYearlyDelta)) delete valuation.terminalRateYearlyDelta;
      if(oldReview.discountRate === valuation.discountRate) delete valuation.discountRate;
      if(oldReview.discountRatePeriodDelta === valuation.discountRatePeriodDelta || valuation.discountRatePeriodDelta === '' || isNaN(valuation.discountRatePeriodDelta)) delete valuation.discountRatePeriodDelta;
      if(oldReview.discountRateYearlyDelta === valuation.discountRateYearlyDelta || valuation.discountRateYearlyDelta === '' || isNaN(valuation.discountRateYearlyDelta)) delete valuation.discountRateYearlyDelta;
      if(oldReview.impliedCapRate === valuation.impliedCapRate) delete valuation.impliedCapRate;
      if(oldReview.impliedCapRatePeriodDelta === valuation.impliedCapRatePeriodDelta || valuation.impliedCapRatePeriodDelta === '' || isNaN(valuation.impliedCapRatePeriodDelta)) delete valuation.impliedCapRatePeriodDelta;
      if(oldReview.impliedCapRateYearlyDelta === valuation.impliedCapRateYearlyDelta || valuation.impliedCapRateYearlyDelta === '' || isNaN(valuation.impliedCapRateYearlyDelta)) delete valuation.impliedCapRateYearlyDelta;

      if(oldReview.avgContractRent === valuation.avgContractRent) delete valuation.avgContractRent;
      if(oldReview.avgMarketRent === valuation.avgMarketRent) delete valuation.avgMarketRent;
      if(oldReview.avgRentGrowth === valuation.avgRentGrowth) delete valuation.avgRentGrowth;

      if(removeDeltas || oldReview.deltaDiscountRate === valuation.deltaDiscountRate) delete valuation.deltaDiscountRate;
      if(removeDeltas || oldReview.deltaTerminalCapRate === valuation.deltaTerminalCapRate) delete valuation.deltaTerminalCapRate;
      if(removeDeltas || oldReview.deltaAvgMarketRentGrowth === valuation.deltaAvgMarketRentGrowth) delete valuation.deltaAvgMarketRentGrowth;
      if(removeDeltas || oldReview.deltaMarketRents === valuation.deltaMarketRents) delete valuation.deltaMarketRents;
      if(removeDeltas || oldReview.deltaContractRents === valuation.deltaContractRents) delete valuation.deltaContractRents;
      if(removeDeltas || oldReview.deltaVacancyAndCollectionLoss === valuation.deltaVacancyAndCollectionLoss) delete valuation.deltaVacancyAndCollectionLoss;
      if(removeDeltas || oldReview.deltaDowntimeAndRenewalProbability === valuation.deltaDowntimeAndRenewalProbability) delete valuation.deltaDowntimeAndRenewalProbability;
      if(removeDeltas || oldReview.deltaExpenses === valuation.deltaExpenses) delete valuation.deltaExpenses;
      if(removeDeltas || oldReview.deltaRealEstateTaxes === valuation.deltaRealEstateTaxes) delete valuation.deltaRealEstateTaxes;
      if(removeDeltas || oldReview.deltaBuildingCapital === valuation.deltaBuildingCapital) delete valuation.deltaBuildingCapital;
      if(removeDeltas || oldReview.deltaLeasingCapital === valuation.deltaLeasingCapital) delete valuation.deltaLeasingCapital;
      if(removeDeltas || oldReview.deltaOther === valuation.deltaOther) delete valuation.deltaOther;
      if(removeDeltas || oldReview.totalChange === valuation.totalChange) delete valuation.totalChange;

      if(oldReview.ppValueChangeExplanation === valuation.ppValueChangeExplanation) delete valuation.ppValueChangeExplanation;
      if(oldReview.yyValueChangeExplanation === valuation.yyValueChangeExplanation) delete valuation.yyValueChangeExplanation;
    }

    function loadPrevValuationsData(assetId, review) {
      var loggedInUserRoleName = SessionManager.getRoleName()
      var userId = SessionManager.getUser();
      var loggedInUserCompanyId = SessionManager.getCompanyId();
      return ValuationService.listValuationsByAssetId(assetId, loggedInUserRoleName, loggedInUserCompanyId).then(function (valuations) {
        var prevValuationsObj = {
          previousQuarterlyValuation: null,
          previousYearlyValuation: null,
          valuations: valuations
        };
        if (valuations && valuations.length > 1) {
          var quarterOfCycle = review.quarterOfCycle;
          var i;

          for (var j = 0; j < valuations.length; j++) {
            if(valuations[j].id === review.id){
              i = j;
              valuations.splice(j, 1);
              break;
            }
          }

          while (i <= valuations.length - 1) {
            if(1 === quarterOfCycle && review.valuationCycle > 1) {
              if(valuations[i].valuationCycle && review.valuationCycle &&
                valuations[i].valuationCycle === review.valuationCycle -1 &&
                (valuations[i].appraisalFinal || valuations[i].appraisalDraft)) {
                prevValuationsObj.previousQuarterlyValuation = valuations[i];
                break;
              } else {
                i++;
              }
            } else if (1 !== quarterOfCycle && valuations[i].valuationCycle && review.valuationCycle &&
              valuations[i].valuationCycle === review.valuationCycle &&
              (valuations[i].appraisalFinal || valuations[i].appraisalDraft) && valuations[i].quarterOfCycle < quarterOfCycle) {
              prevValuationsObj.previousQuarterlyValuation = valuations[i];
              break;
            } else if(valuations[i].valuationCycle === review.valuationCycle && valuations[i].status !== 'Finished') {
              break;
            }else {
              i++;
            }
          }

          for (i = 0; i < valuations.length; i++) {
            if (valuations[i].year === review.year - 1 && valuations[i].quarter === review.quarter) {
              prevValuationsObj.previousYearlyValuation = valuations[i];
              if(review.asset.valuationFrequency && 'Annually' === review.asset.valuationFrequency) {
                prevValuationsObj.previousQuarterlyValuation = valuations[i];
                break;
              }
            }
          }
        }
        return prevValuationsObj;
      });
    }

    function setUntouchedValuation(valuation) {
      untouchedValuation = angular.copy(valuation);
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .factory('AssetFactory', AssetFactory);

  /**@ngInject*/
  function AssetFactory(AssetService) {
    return {
      loadAsset: loadAsset,
      loadAllAssetsByCompanyId: loadAllAssetsByCompanyId,
      save: save,
      copy: copy
    };

    function loadAsset(assetId) {
      return AssetService.getAsset(assetId).then(function (asset) {
        return AssetService.getAssetUsersList(assetId).then(function (usersArray) {
          var users = {};
          usersArray.forEach(function (user) {
            users[user.user.id] = user;
          });
          asset.users = users;
          return new AssetModel(asset);
        });
      });
    }

    function loadAllAssetsByCompanyId(companyId) {
      return AssetService.getAssetsWithValuationsAndUsersByCompany(companyId).then(function (assets) {
        var initAssets = [];
        assets.forEach(function (asset) {
          var usersArray = angular.copy(asset.users);
          asset.users = {};
          usersArray.forEach(function (user) {
            asset.users[user.user.id] = user;
          });
          initAssets.push(new AssetModel(asset));
        });
        return initAssets;
      });
    }

    function save(asset) {
      if (asset.id) {
        return AssetService.updateAsset(asset).then(function (asset) {
          return new AssetModel(asset);
        });
      } else {
        return AssetService.createAsset(asset).then(function (asset) {
          return new AssetModel(asset);
        });
      }
    }

    function copy(asset) {
      return new AssetModel(asset);
    }
  }

})();

(function () {
  'use strict';

  angular
  .module('nvc')
  .factory('NotificationFactory', NotificationFactory);

  /**@ngInject*/
  function NotificationFactory(EnvironmentConfig) {

    firebase.initializeApp(EnvironmentConfig.FIREBASE);
    var database = firebase.database();


    return {
      getDatabase: getDatabase
    };

    function getDatabase() {
      return database;
    }

  }

})();
(function () {
  'use strict';

  angular
  .module('nvc')
  .service('CommentsNotificationService', CommentsNotificationService);

  /** @ngInject */
  function CommentsNotificationService($rootScope, NotificationFactory, SessionManager) {
    var database = NotificationFactory.getDatabase();
    var starCountRef;
    var listener;
    var lastUpdatedOn;
    var stopPropagation;
    return {
      listenOnValuation: listenOnValuation
    };

    function listenOnValuation(valuationId) {
      if (starCountRef) {
        stopListening();
      }
      starCountRef = database.ref('valuations/' + valuationId);
      lastUpdatedOn = (new Date()).getTime();
      listener = starCountRef.on('value', function (snapshot) {
        var val = snapshot ? snapshot.val() : null;
        if (snapshot && val && val.commentsUpdatedOn > lastUpdatedOn) {
          if (SessionManager.getUserId() != val.triggeredByUser && SessionManager.isInAnyRole(['Admin'].concat(val.roles)) && !stopPropagation) {
            $rootScope.$broadcast('commentAdded', val);
          }
          lastUpdatedOn = val.commentsUpdatedOn;
        }
      });
    }

    function stopListening() {
      starCountRef = undefined;
      listener();
    }
  }

})();

(function(){
  'use strict';

  angular
  .module('nvc')
  .directive('reviewChecker', reviewChecker);

  /**@ngInject*/
  function reviewChecker($q, ReviewStatusHelper){
    return {
      restrict: 'A',
      scope: {
        review: '=reviewChecker',
        actions: '=',
        behaviour: '=',
        isLead: '=',
        forLead: '='
      },
      link: function(scope, element){
        scope.$watch('review', function(){
          if(scope.behaviour !== 'disable'){
            element.addClass('td-security-display-none');
          }
          var promises = [];
          for(var i = 0; i < scope.actions.length; i++){
            promises.push(ReviewStatusHelper.validateAction(scope.review, scope.actions[i]))
          }
          $q.allSettled(promises).then(function(){
            element.removeClass('td-security-display-none');
          }, function(responses){
            if(!responses || responses.indexOf(true) === -1){
              switch (scope.behaviour){
                case 'disable':
                  element.attr('disabled', '');
                  break;
                case 'delete':
                default:
                  element.remove();
              }
            }else{
              element.removeClass('td-security-display-none');
            }
          });
        }, true);
      }
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('nvc')
    .directive('nvcFullPage', nvcFullPage);

  /**@ngInject*/
  function nvcFullPage () {
    return {
      restrict: 'A',
      replace: true,
      link: function (scope, element, attr) {

        var heightValue,
          heightContainer = angular.element('#page-wrapper'),
          iboxContainer = angular.element('.ibox-content'),
          haveButton = 'single',
          paginator = Boolean(attr.paginator);

        iboxContainer.css({
          minHeight: "270px"
        });

        setTimeout(function () {
          if (angular.element('.row').hasClass('td-security-display-none') || angular.element('.row').hasClass('no-button')) {
            haveButton = 'none';
          } else if (angular.element('.row').hasClass('bottom-buttons')) {
            haveButton = 'double';
          }
        }, 300);

        var setHeight = function () {
          heightValue = parseInt(heightContainer.css('min-height'));
          var finalHeight;
          if(paginator) {
            finalHeight = heightValue - 250;
          } else if (haveButton == 'single' && !paginator) {
            finalHeight = heightValue - 180;
          } else if(haveButton == 'double') {
            finalHeight = heightValue - 240;
          } else {
            finalHeight = heightValue - 120;
          }

          iboxContainer.css('height', finalHeight);

          var removeHeight = angular.element("[remove-height]");
          for(var i = 0; i < removeHeight.length; i++){
            var element = angular.element(removeHeight[i]);
            element.css('height', finalHeight - element.attr('remove-height'));
          }
        };

        setTimeout(function () {
          setHeight();
        }, 300);

        $(window).resize(function () {
          setTimeout(function () {
            setHeight();
          }, 300);
        });

      }
    }
  }

})();
/**
 * INSPINIA - Responsive Admin Theme
 *
 * Main directives.js file
 * Define directives for used plugin
 *
 *
 * Functions (directives)
 *  - sideNavigation
 *  - iboxTools
 *  - minimalizaSidebar
 *  - vectorMap
 *  - sparkline
 *  - icheck
 *  - ionRangeSlider
 *  - dropZone
 *  - responsiveVideo
 *  - chatSlimScroll
 *  - customValid
 *  - fullScroll
 *  - closeOffCanvas
 *  - clockPicker
 *  - landingScrollspy
 *  - fitHeight
 *  - iboxToolsFullScreen
 *  - slimScroll
 *  - truncate
 *  - touchSpin
 *  - markdownEditor
 *  - resizeable
 *
 */


/**
 * pageTitle - Directive for set Page title - mata title
 */
function pageTitle($rootScope, $timeout) {
  return {
    link: function (scope, element) {
      var listener = function (event, toState, toParams, fromState, fromParams) {
        // Default title - load on Dashboard 1
        var title = 'INSPINIA | Responsive Admin Theme';
        // Create your own title pattern
        if (toState.data && toState.data.pageTitle) title = 'INSPINIA | ' + toState.data.pageTitle;
        $timeout(function () {
          element.text(title);
        });
      };
      $rootScope.$on('$stateChangeStart', listener);
    }
  }
}

/**
 * sideNavigation - Directive for run metsiMenu on sidebar navigation
 */
function sideNavigation($timeout) {
  return {
    restrict: 'A',
    link: function (scope, element) {
      // Call the metsiMenu plugin and plug it to sidebar navigation
      $timeout(function () {
        element.metisMenu();

      });
    }
  };
}

/**
 * responsibleVideo - Directive for responsive video
 */
function responsiveVideo() {
  return {
    restrict: 'A',
    link: function (scope, element) {
      var figure = element;
      var video = element.children();
      video
        .attr('data-aspectRatio', video.height() / video.width())
        .removeAttr('height')
        .removeAttr('width')

      //We can use $watch on $window.innerWidth also.
      $(window).resize(function () {
        var newWidth = figure.width();
        video
          .width(newWidth)
          .height(newWidth * video.attr('data-aspectRatio'));
      }).resize();
    }
  }
}

/**
 * iboxTools - Directive for iBox tools elements in right corner of ibox
 */
function iboxTools($timeout) {
  return {
    restrict: 'A',
    scope: true,
    templateUrl: 'views/common/ibox_tools.html',
    controller: function ($scope, $element) {
      // Function for collapse ibox
      $scope.showhide = function () {
        var ibox = $element.closest('div.ibox');
        var icon = $element.find('i:first');
        var content = ibox.find('div.ibox-content');
        content.slideToggle(200);
        // Toggle icon from up to down
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        ibox.toggleClass('').toggleClass('border-bottom');
        $timeout(function () {
          ibox.resize();
          ibox.find('[id^=map-]').resize();
        }, 50);
      };
      // Function for close ibox
      $scope.closebox = function () {
        var ibox = $element.closest('div.ibox');
        ibox.remove();
      }
    }
  };
}

/**
 * iboxTools with full screen - Directive for iBox tools elements in right corner of ibox with full screen option
 */
function iboxToolsFullScreen($timeout) {
  return {
    restrict: 'A',
    scope: true,
    templateUrl: 'views/common/ibox_tools_full_screen.html',
    controller: function ($scope, $element) {
      // Function for collapse ibox
      $scope.showhide = function () {
        var ibox = $element.closest('div.ibox');
        var icon = $element.find('i:first');
        var content = ibox.find('div.ibox-content');
        content.slideToggle(200);
        // Toggle icon from up to down
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        ibox.toggleClass('').toggleClass('border-bottom');
        $timeout(function () {
          ibox.resize();
          ibox.find('[id^=map-]').resize();
        }, 50);
      };
      // Function for close ibox
      $scope.closebox = function () {
        var ibox = $element.closest('div.ibox');
        ibox.remove();
      };
      // Function for full screen
      $scope.fullscreen = function () {
        var ibox = $element.closest('div.ibox');
        var button = $element.find('i.fa-expand');
        $('body').toggleClass('fullscreen-ibox-mode');
        button.toggleClass('fa-expand').toggleClass('fa-compress');
        ibox.toggleClass('fullscreen');
        setTimeout(function () {
          $(window).trigger('resize');
        }, 100);
      }
    }
  };
}

/**
 * minimalizaSidebar - Directive for minimalize sidebar
 */
function minimalizaSidebar($timeout) {
  return {
    restrict: 'A',
    template: '<a class="navbar-minimalize minimalize-styl-2 btn btn-primary " href="" ng-click="minimalize()"><i class="fa fa-bars"></i></a>',
    controller: function ($scope, $element) {
      $scope.minimalize = function () {

        angular.element('body').toggleClass('mini-navbar');
        angular.element('#side-menu').hide();

        if (angular.element('.overlay').is(':visible')) {
          angular.element('.overlay').fadeOut(200);
        } else {
          angular.element('.overlay').fadeIn(200);
        }

        angular.element('.overlay').click(function () {
          angular.element('body').addClass('mini-navbar');
          angular.element('#side-menu').hide();
          angular.element('.overlay').fadeOut(200);
          $timeout(function () {
            angular.element('#side-menu').fadeIn(200);
          }, 200);
        });

        $timeout(function () {
          angular.element('#side-menu').fadeIn(200);
        }, 200);

      };
      $scope.$on('$stateChangeSuccess', function () {
        if (angular.element('.overlay').is(':visible')) {
          angular.element('body').addClass('mini-navbar');
          angular.element('#side-menu').hide();
          angular.element('.overlay').fadeOut(200);
        }
        $timeout(function () {
          angular.element('#side-menu').fadeIn(200);
        }, 200);
      });
    }
  };
}


function closeOffCanvas() {
  return {
    restrict: 'A',
    template: '<a class="close-canvas-menu" ng-click="closeOffCanvas()"><i class="fa fa-times"></i></a>',
    controller: function ($scope, $element) {
      $scope.closeOffCanvas = function () {
        $("body").toggleClass("mini-navbar");
      }
    }
  };
}

/**
 * vectorMap - Directive for Vector map plugin
 */
function vectorMap() {
  return {
    restrict: 'A',
    scope: {
      myMapData: '='
    },
    link: function (scope, element, attrs) {
      var map = element.vectorMap({
        map: 'world_mill_en',
        backgroundColor: "transparent",
        regionStyle: {
          initial: {
            fill: '#e4e4e4',
            "fill-opacity": 0.9,
            stroke: 'none',
            "stroke-width": 0,
            "stroke-opacity": 0
          }
        },
        series: {
          regions: [
            {
              values: scope.myMapData,
              scale: ["#1ab394", "#22d6b1"],
              normalizeFunction: 'polynomial'
            }
          ]
        }
      });
      var destroyMap = function () {
        element.remove();
      };
      scope.$on('$destroy', function () {
        destroyMap();
      });
    }
  }
}


/**
 * sparkline - Directive for Sparkline chart
 */
function sparkline() {
  return {
    restrict: 'A',
    scope: {
      sparkData: '=',
      sparkOptions: '='
    },
    link: function (scope, element, attrs) {
      scope.$watch(scope.sparkData, function () {
        render();
      });
      scope.$watch(scope.sparkOptions, function () {
        render();
      });
      var render = function () {
        $(element).sparkline(scope.sparkData, scope.sparkOptions);
      };
    }
  }
}

/**
 * icheck - Directive for custom checkbox icheck
 */
function icheck($timeout) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function ($scope, element, $attrs, ngModel) {
      return $timeout(function () {
        var value;
        value = $attrs['value'];

        $scope.$watch($attrs['ngModel'], function (newValue) {
          $(element).iCheck('update');
        })

        return $(element).iCheck({
          checkboxClass: 'icheckbox_minimal-blue',
          radioClass: 'iradio_minimal-blue'

        }).on('ifChanged', function (event) {
          if ($(element).attr('type') === 'checkbox' && $attrs['ngModel']) {
            $scope.$apply(function () {
              return ngModel.$setViewValue(event.target.checked);
            });
          }
          if ($(element).attr('type') === 'radio' && $attrs['ngModel']) {
            return $scope.$apply(function () {
              return ngModel.$setViewValue(value);
            });
          }
        });
      });
    }
  };
}

/**
 * ionRangeSlider - Directive for Ion Range Slider
 */
function ionRangeSlider() {
  return {
    restrict: 'A',
    scope: {
      rangeOptions: '='
    },
    link: function (scope, elem, attrs) {
      elem.ionRangeSlider(scope.rangeOptions);
    }
  }
}

/**
 * dropZone - Directive for Drag and drop zone file upload plugin
 */
function dropZone() {
  return {
    restrict: 'C',
    link: function (scope, element, attrs) {

      var config = {
        url: 'http://localhost:8080/upload',
        maxFilesize: 100,
        paramName: "uploadfile",
        maxThumbnailFilesize: 10,
        parallelUploads: 1,
        autoProcessQueue: false
      };

      var eventHandlers = {
        'addedfile': function (file) {
          scope.file = file;
          if (this.files[1] != null) {
            this.removeFile(this.files[0]);
          }
          scope.$apply(function () {
            scope.fileAdded = true;
          });
        },

        'success': function (file, response) {
        }

      };

      dropzone = new Dropzone(element[0], config);

      angular.forEach(eventHandlers, function (handler, event) {
        dropzone.on(event, handler);
      });

      scope.processDropzone = function () {
        dropzone.processQueue();
      };

      scope.resetDropzone = function () {
        dropzone.removeAllFiles();
      }
    }
  }
}

/**
 * chatSlimScroll - Directive for slim scroll for small chat
 */
function chatSlimScroll($timeout) {
  return {
    restrict: 'A',
    link: function (scope, element) {
      $timeout(function () {
        element.slimscroll({
          height: '234px',
          railOpacity: 0.4
        });

      });
    }
  };
}

/**
 * customValid - Directive for custom validation example
 */
function customValid() {
  return {
    require: 'ngModel',
    link: function (scope, ele, attrs, c) {
      scope.$watch(attrs.ngModel, function () {

        // You can call a $http method here
        // Or create custom validation

        var validText = "Inspinia";

        if (scope.extras == validText) {
          c.$setValidity('cvalid', true);
        } else {
          c.$setValidity('cvalid', false);
        }

      });
    }
  }
}


/**
 * fullScroll - Directive for slimScroll with 100%
 */
function fullScroll($timeout) {
  return {
    restrict: 'A',
    link: function (scope, element) {
      $timeout(function () {
        element.slimscroll({
          height: '100%',
          railOpacity: 0.9
        });

      });
    }
  };
}

/**
 * slimScroll - Directive for slimScroll with custom height
 */
function slimScroll($timeout) {
  return {
    restrict: 'A',
    scope: {
      boxHeight: '@'
    },
    link: function (scope, element) {
      $timeout(function () {
        element.slimscroll({
          height: scope.boxHeight,
          railOpacity: 0.9
        });

      });
    }
  };
}

/**
 * clockPicker - Directive for clock picker plugin
 */
function clockPicker() {
  return {
    restrict: 'A',
    link: function (scope, element) {
      element.clockpicker();
    }
  };
}


/**
 * landingScrollspy - Directive for scrollspy in landing page
 */
function landingScrollspy() {
  return {
    restrict: 'A',
    link: function (scope, element, attrs) {
      element.scrollspy({
        target: '.navbar-fixed-top',
        offset: 80
      });
    }
  }
}

/**
 * fitHeight - Directive for set height fit to window height
 */
function fitHeight() {
  return {
    restrict: 'A',
    link: function (scope, element) {
      element.css("height", $(window).height() + "px");
      element.css("min-height", $(window).height() + "px");
    }
  };
}

/**
 * truncate - Directive for truncate string
 */
function truncate($timeout) {
  return {
    restrict: 'A',
    scope: {
      truncateOptions: '='
    },
    link: function (scope, element) {
      $timeout(function () {
        element.dotdotdot(scope.truncateOptions);

      });
    }
  };
}


/**
 * touchSpin - Directive for Bootstrap TouchSpin
 */
function touchSpin() {
  return {
    restrict: 'A',
    scope: {
      spinOptions: '='
    },
    link: function (scope, element, attrs) {
      scope.$watch(scope.spinOptions, function () {
        render();
      });
      var render = function () {
        $(element).TouchSpin(scope.spinOptions);
      };
    }
  }
}

/**
 * markdownEditor - Directive for Bootstrap Markdown
 */
function markdownEditor() {
  return {
    restrict: "A",
    require: 'ngModel',
    link: function (scope, element, attrs, ngModel) {
      $(element).markdown({
        savable: false,
        onChange: function (e) {
          ngModel.$setViewValue(e.getContent());
        }
      });
    }
  }
}

/**
 * indeterminateCheckbox - Directive for select-all checkboxes with indeterminate state
 */
function indeterminateCheckbox() {
  return {
    scope: true,
    require: '?ngModel',
    link: function (scope, element, attrs, modelCtrl) {
      var childList = attrs.childList;
      var property = attrs.property;

      // Bind the onChange event to update children
      element.bind('change', function () {
        scope.$apply(function () {
          var isChecked = element.prop('checked');

          // Set each child's selected property to the checkbox's checked property
          angular.forEach(scope.$eval(childList), function (child) {
            child[property] = isChecked;
          });
        });
      });

      // icheck handler
      $(element).on('ifChanged', function (event) {
        var isChecked = $(event.target).prop('checked');

        // Set each child's selected property to the checkbox's checked property
        angular.forEach(scope.$eval(childList), function (child) {
          child[property] = isChecked;
        });
      });

      // Watch the children for changes
      scope.$watch(childList, function (newValue) {
        var hasChecked = false;
        var hasUnchecked = false;

        // Loop through the children
        angular.forEach(newValue, function (child) {
          if (child[property]) {
            hasChecked = true;
          } else {
            hasUnchecked = true;
          }
        });

        // Determine which state to put the checkbox in
        if (hasChecked && hasUnchecked) {
          element.prop('checked', false);
          element.prop('indeterminate', true);
          element.attr('indeterminate', true);
          if (modelCtrl) {
            modelCtrl.$setViewValue(false);
          }
          if (element.next(".iCheck-helper").length) {
            $(element).iCheck('indeterminate');
          }
        } else {
          element.prop('checked', hasChecked);
          element.prop('indeterminate', false);
          if (modelCtrl) {
            modelCtrl.$setViewValue(hasChecked);
          }
          if (element.next(".iCheck-helper").length) {
            $(element).iCheck('determinate');
          }
        }

        if (element.next(".iCheck-helper").length) {
          $(element).iCheck('update');
        }
      }, true);
    }
  };
}
/* matchField - Directive for comparing two fields which need to be identical
 */
function matchField() {
  return {
    require: 'ngModel',
    link: function (scope, elem, attrs, ctrl) {
      var firstField = '[name=' + attrs.matchField + ']';
      elem.add(firstField).on('keyup', function () {
        scope.$apply(function () {
          var v = elem.val() === $(firstField).val();
          ctrl.$setValidity('match', v);
        });
      });
    }
  }
}

/**
 * fileButton - Directive for custom file upload button
 */
function fileButton() {
    return {
        link: function(scope, element, attributes) {
            var el = angular.element(element);
            var button = el.find(".btn");

            el.css({
                position: 'relative',
                overflow: 'hidden',
            });

            var fileInput = el.find("[type=file]");
            fileInput.css({
                position: 'absolute',
                top: 0,
                left: 0,
                'z-index': '2',
                width: '100%',
                height: '100%',
                opacity: '0',
                cursor: 'pointer'
            });

            el.append(fileInput);
        }
    }
};

/**
 * fileDropzone - Directive for dropping a file to upload
 */
function fileDropzone() {
  return {
    restrict: 'A',
    scope: {
      fileData: '=',
      fileName: '=',
      errorHandler: '=',
      successHandler: '='
    },
    link: function (scope, element, attrs) {
      var fileInput = element.find('input[type=file]');
      var form = element.closest('form');

      function processDragEnter(event) {
        if (event != null) {
          event.preventDefault();
        }
        event.dataTransfer.effectAllowed = 'copy';
        element.addClass(attrs.droppingClass);
        return false;
      }

      function processDragOver(event) {
        if (event != null) {
          event.preventDefault();
        }
        event.dataTransfer.dropEffect = "copy";
        return false;
      }

      function processDrop(event) {
        element.removeClass(attrs.droppingClass);
        if (event != null) {
          event.preventDefault();
        }
        handleFileSelect(event.dataTransfer.files[0]);
        return false;
      }

      function checkSize(size) {
        if (attrs.maxFileSizeMb === (void 0) || attrs.maxFileSizeMb === '' || (size / 1024) / 1024 < attrs.maxFileSizeMb) {
          scope.$apply();
          return true;
        } else {
          scope.$apply();
          return false;
        }
      }

      function isTypeValid(type) {
        if (attrs.fileTypes === (void 0) || attrs.fileTypes === '' || attrs.fileTypes.indexOf(type) > -1) {
          scope.$apply();
          return true;
        } else {
          scope.$apply();
          return false;
        }
      }

      function handleFileSelect(file) {
        var reader = new FileReader();
        reader.onload = function (evt) {
          if (checkSize(file.size) && isTypeValid(file.type)) {
            scope.$apply(function () {
              scope.fileData = evt.target.result;
              if (angular.isString(scope.fileName)) {
                scope.fileName = file.name;
              }
              if (angular.isFunction(scope.successHandler)) {
                scope.successHandler(scope.fileData);
              }
            });
          } else if (angular.isFunction(scope.errorHandler)) {
            scope.errorHandler();
          }
        };
        reader.readAsDataURL(file);
      }

      var el = element.get(0);
      el.addEventListener ('dragenter', processDragEnter);
      el.addEventListener ('dragover', processDragOver);
      el.addEventListener ('drop', processDrop);

      fileInput.bind("change", function(event) {
        if (event != null) {
          event.preventDefault();
        }
        handleFileSelect(event.currentTarget.files[0]);
        return false;
      });
    }
  };
}

function indeterminateCheckbox() {
  return {
    scope: true,
    require: '?ngModel',
    link: function (scope, element, attrs, modelCtrl) {
      var childList = attrs.childList;
      var property = attrs.property;

      // Bind the onChange event to update children
      element.bind('change', function () {
        scope.$apply(function () {
          var isChecked = element.prop('checked');

          // Set each child's selected property to the checkbox's checked property
          angular.forEach(scope.$eval(childList), function (child) {
            child[property] = isChecked;
          });
        });
      });

      // icheck handler
      $(element).on('ifChanged', function (event) {
        var isChecked = $(event.target).prop('checked');

        // Set each child's selected property to the checkbox's checked property
        angular.forEach(scope.$eval(childList), function (child) {
          child[property] = isChecked;
        });
      });

      // Watch the children for changes
      scope.$watch(childList, function (newValue) {
        var hasChecked = false;
        var hasUnchecked = false;

        // Loop through the children
        angular.forEach(newValue, function (child) {
          if (child[property]) {
            hasChecked = true;
          } else {
            hasUnchecked = true;
          }
        });

        // Determine which state to put the checkbox in
        if (hasChecked && hasUnchecked) {
          element.prop('checked', false);
          element.prop('indeterminate', true);
          element.attr('indeterminate', true);
          if (modelCtrl) {
            modelCtrl.$setViewValue(false);
          }
          if (element.next(".iCheck-helper").length) {
            $(element).iCheck('indeterminate');
          }
        } else {
          element.prop('checked', hasChecked);
          element.prop('indeterminate', false);
          if (modelCtrl) {
            modelCtrl.$setViewValue(hasChecked);
          }
          if (element.next(".iCheck-helper").length) {
            $(element).iCheck('determinate');
          }
        }

        if (element.next(".iCheck-helper").length) {
          $(element).iCheck('update');
        }
      }, true);
    }
  };
}

/**
 *
 * Pass all functions into module
 */
angular
.module('nvc')
.directive('pageTitle', pageTitle)
.directive('sideNavigation', sideNavigation)
.directive('iboxTools', iboxTools)
.directive('minimalizaSidebar', minimalizaSidebar)
.directive('vectorMap', vectorMap)
.directive('sparkline', sparkline)
.directive('icheck', icheck)
.directive('ionRangeSlider', ionRangeSlider)
.directive('dropZone', dropZone)
.directive('responsiveVideo', responsiveVideo)
.directive('chatSlimScroll', chatSlimScroll)
.directive('customValid', customValid)
.directive('fullScroll', fullScroll)
.directive('closeOffCanvas', closeOffCanvas)
.directive('clockPicker', clockPicker)
.directive('landingScrollspy', landingScrollspy)
.directive('fitHeight', fitHeight)
.directive('iboxToolsFullScreen', iboxToolsFullScreen)
.directive('slimScroll', slimScroll)
.directive('truncate', truncate)
.directive('touchSpin', touchSpin)
.directive('markdownEditor', markdownEditor)
.directive('fileButton', fileButton)
.directive('fileDropzone', fileDropzone)
.directive('indeterminateCheckbox', indeterminateCheckbox)
.directive('indeterminateCheckbox', indeterminateCheckbox)
.directive('matchField', matchField);
(function () {
  'use strict';

  angular
    .module('nvc')
    .directive('nvcBlockScroll', nvcBlockScroll);

  /**@ngInject*/
  function nvcBlockScroll() {
    return {
      restrict: 'A',
      replace: true,
      link: function (scope, element) {


        element.on("mousewheel DOMMouseScroll", function (event) {
          event.stopPropagation();
          event.preventDefault();
        });

        var htmlContainer = angular.element('body');

        element.on('mouseenter', function () {
          if (angular.element('.ps-active-y').length > 0) {
            htmlContainer.css("overflow", "hidden");
          } else {
            htmlContainer.css("overflow", "auto");
          }
        });

        element.on('mouseleave', function () {
          htmlContainer.css("overflow", "auto");
        });

      }
    }
  }

})();
(function () {
  'use strict';

  angular
    .module('nvc')
    .config(wysiwygDecorator);

  /**@ngInject*/
  function wysiwygDecorator($provide) {
    $provide.decorator('taOptions', ['$delegate', function ($delegate) {
      var taOptions = $delegate;
      taOptions.toolbar = [
        ['bold', 'italics', 'underline', 'ul', 'ol'],
        ['justifyLeft', 'justifyCenter', 'justifyRight']
      ];
      return taOptions;
    }]);
  }

})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .config(qDecorator);

  /**@ngInject*/
  function qDecorator($provide) {
    $provide.decorator('$q', ['$delegate', function ($delegate) {
      var $q = $delegate;

      // Extension for q
      $q.allSettled = $q.allSettled || function (promises) {
          var deferred = $q.defer();
          if (angular.isArray(promises)) {
            var states = [];
            var results = [];
            var didAPromiseFail = false;
            if (promises.length === 0) {
              deferred.resolve(results);
              return;
            }
            // First create an array for all promises with their state
            angular.forEach(promises, function (promise, key) {
              states[key] = false;
            });
            // Helper to check if all states are finished
            var checkStates = function (states, results, deferred, failed) {
              var allFinished = true;
              angular.forEach(states, function (state, key) {
                if (!state) {
                  allFinished = false;
                }
              });
              if (allFinished) {
                if (failed) {
                  deferred.reject(results);
                } else {
                  deferred.resolve(results);
                }
              }
            };
            // Loop through the promises
            // a second loop to be sure that checkStates is called when all states are set to false first
            angular.forEach(promises, function (promise, key) {
              $q.when(promise).then(function (result) {
                states[key] = true;
                results[key] = result;
                checkStates(states, results, deferred, didAPromiseFail);
              }, function (reason) {
                states[key] = true;
                results[key] = reason;
                didAPromiseFail = true;
                checkStates(states, results, deferred, didAPromiseFail);
              });
            });
          } else {
            throw 'allSettled can only handle an array of promises (for now)';
          }
          return deferred.promise;
        };
      return $q;
    }]);
  }

})();

(function() {
  angular.module("nvc").constant("PDF_HEADERS", {
    _documentsIcon:
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAABACAYAAABY1SR7AAAABGdBTUEAALGPC/xhBQAAA0xJREFUaAXtWs1rE0EUnzfJtir0oI3RQqFS1Ev+AKXexEIkX0168OBB715E8GA9+oEeBJWCB8GDJ0EsJpIUPevBi14apJWCnsSAthZBm2Tn+SayJa274M7MNumyA8vOvDfv4/fe29lkdoB5tFqttv+3EIm4ENxjyraSAcC2LKuRTqe/uxmGbmK5/HpIsJVLiOI8IjvUzeuXPjm8xAAeHUwm7k9MTPxy/NoAUqlUUi2bVRjDcYfZz3dgsADMyhWLpz9JPztAqtXq2HrLfouIB/rZ+X99g4+DFj+WzWZXOvW/3rQf7DwQEhYeabXFddmDvyWFC3KwQ1szzocT3EY4tUMBOG4P2OzbiTiV1KhD2XqnB+gLArgud1vnBj5GNkKltM/NDiIfjRNztxtT0oCzm6VCftaLv530ueflWXolXHCzyUHs6ouXnZtzfmkREL8RC3p+lJGgI+xXf2gyQsuventWfnGblu9hdQ1dkoItTBfzd7sovrpaQJjAMwRkzJdFr8nAXhJLGUhoSisC4lUhvaKHJiNaDzsAe4jA95rIAv3SXtTRowWkNJW/oWPcpGxoSisCYrIsTOiKMmIiiiZ1aK1a9Xp9oNFoGMlqMpkUqVSqqQpOC8ji0vI8MjyparxbbmV1bZnGh7tpfvpGounHYFBzIyBBRVZVb5QR1cgFJae1amEcLsds7rof69dh+rK28fXJr6ycrwVkOpd7p2I0CJnoGQkiqjo6o4zoRC8I2dBkRGvVmqtWj8Zt2zIR4Vgs9jOTyXxW1aUFBJv2q5ahLdOWaMst07QqkNCUVgREtQSCkgtNRrQedjqSIxjSZaABgpYeLSDTU/lxAxiMqAhNaUVAjNSDQSVRRgwG04iq0GSEDp5xZB6vAkQYkUcFjYRMU0nbZrTJQa66NImB3iNi1YXXIdHpuhk6Qjvjxe8bOrBVDjxW7xuHFB1Bzj7woT2D83Rce01RR8/F6Gvwcimbfc8nJyd/kDfXeu6RqgOcXaFEUFKoFQu5O/TN/Imqrl7JUTbulQqFp9J+B4hEVCzkz9L9Fl3tXjn2v3bJx3U66H+1VCxcdGQI1OYmNxRYyz5HK91xBJYgbmzzjN6MAJkM8Ff66/AG0HrsHO53vPkD3vLR6yC4rD8AAAAASUVORK5CYII=",
    _assetDetailsPageHeader:
      "data:image/png;base64,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",
    _assetsListHeader:
      "data:image/png;base64,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",
    _bidEngagementListHeader:
      "data:image/png;base64,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",
    _bidGroupsListHeader:
      "data:image/png;base64,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",
    _bidSummaryHeader:
      "data:image/png;base64,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",
    _executiveSummaryHeader:
      "data:image/png;base64,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",
    _requestStatusHeader:
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAACRwAAAEuCAYAAADmhUwDAAAABGdBTUEAALGPC/xhBQAAQABJREFUeAHs3QecHHX9//Hv3F3uElIJEJoQVDqCNCWACEEJ6Z3eYiFYUbGQAroKKSgif3/WWAiGZpK7SyEhCSUCmgDSFEEEkVBDkUj61Z3/+3vJJnuX3Z3v7G2bu9c8HpudnfnM9/ud58zObu772e8Yw4QAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACnU/A63y7zB4jgAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACERLwfbd+Xc/zI7RXNBUBBBBAIMICbh9MEd5Bmo4AAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAgiUvIBNKpq86MPGNB9nyvzjjO9r3jvA+OYAY/x91f7yjPvgmbji31DsGm3ziinzXjZx7xlT7j9mpo17JeO2rEQAAQQQQCCkAAlHIcEIRwABBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABBNotYBOMvrvoWNPUdJYShM4ynv9xPfdqd7kpC/De0eK/KpHpQeNXLDEzRj+XMoyFCCCAAAIIOAqQcOQIRRgCCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCQE4GW0Yxq/qXRiA7JSXlhC/HMyxoN6W49qs30MQ8ZbsUWVpB4BBBAoNMLkHDU6U8BABBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAoOACk+fP0ohGlxe83rYVet5Lun3bLaa8araZNkK3ZGNCAAEEEEAgWICEo2AjIhBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAIHcCkyt+YRpjj+c20LbVVqzRjxaZMorpptpox5vV0lsjAACCCDQ4QVIOOrwh5gdRAABBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQACBkhSYXP1vjS704ZJrm2dWmDJvmpk27qGSaxsNQgABBBAoCYGykmgFjUAAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQSiLjCl9lgzaf5KM3nBkW674v/BLa7AUb4ZZJr9B83k6mVm8vzDC1w71SGAAAIIRECAhKMIHCSaiAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACJSwQq+mn5JzfGr/5CbXyDD1/1qm1VeVKOPJ8p9hiBPn+2WrfM9q3n5hYbZ9iNIE6EUAAAQRKU4CEo9I8LrQKAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQSiIDCl+kJT7z+nW6N9zvgm0f96gYn5ifn0exEbs8Z45qH0ASWwxvcrtG9fN3Xxf2m0o9El0CKagAACCCBQAgLBH3Il0EiagAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCJSUwJSFe+v2aQtM3L9dCTl7tG6bv59pWKDRgVwm71aXqOLH+P2UUFWrpKPZJra0V/HbQwsQQAABBIopQMJRMfWpGwEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEoidwTe0ZJt74tBo+Km3j/fhladclr6jafZ5ebk5eVNLzvrnM1G15xsRW9ijpdtI4BBBAAIG8CpBwlFdeCkcAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAgQ4j4PuemVw9xTQ136d92ifjfvn+SKeRgGIDNxnPq8lYVumtfM/YdjMhgAACCHRaARKOOu2hZ8cRQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQMBZ4KdLq8yU6rt0+7Rp2qbcYbtupm7r+Q5xKs2b7RRXKkGeua1UmkI7EEAAAQSKI0DCUXHcqRUBBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABBKIiEFvW17y59T7jm3PDNdl3u63adWNWqtxXw5VdpGjPxDUi051Fqp1qEUAAAQRKRICEoxI5EDQDAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQRKUGDq4v1N3aZVxvifyKJ1p5hJCw8O3M7zfCXx/CEwriQCvPvN9HFrS6IpNAIBBBBAoGgCJBwVjZ6KEUAAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEEECgpAVsslG8/k9q42FZt9NrchvlyK+4Nes6Crmh53E7tUJ6UxcCCCBQogIkHJXogaFZCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCBQRIFY9Qdako18EzxCUcZm+hcZ3/cyhtiVM0f92xjvz4FxxQ3YanqX1xa3CdSOAAIIIFAKAiQclcJRoA0IIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIFA6ArHaPqbeX27anWykXfLNB821C0532jnPzHaKK1aQZxaYq0dtLFb11IsAAgggUDoCJByVzrGgJQgggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAgggUGyB2LOVpq65VolCR+asKU1xt9uq9amYazxvS87qzXVBnnd7roukPAQQQACBaAqQcBTN40arEUAAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAgHwL1z/9exZ6R46LHmdji3QLLtKMH+X5NYFxRArz/mv79V4SqOrasb6h4ghFAAAEEIiNAwlFkDhUNRQABBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQACBvApMrrlSCT8X5b4Ov6epbxjnVG5Z+WynuEIHeeYuc8WJjaGqrd98rZlS/dVQ2xCMAAIIIBAJARKOInGYaCQCCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCORVYGr1AOPHb8xfHb7bbdWmjX5AbXg1f+3ItuTy20JtGVvZ1Rj/UiVw3Wgm1Z4QaluCEUAAAQRKXoCEo5I/RDQQAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQTyKhCr7WPiZq7q6JLHegaaWPUHAsv3PN+UebcGxhUywPNeMjNGPxqqyvp15xjf9NWj0pj4XDPz3t6hticYAQQQQKCkBUg4KunDQ+MQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQCDvAvXNN2skngPyWo/SiEy9udSpjrKy0ko48s0cp3a3Drpi50v/Q2b9hp/vfM0cAggggEDUBUg4ivoRpP0IIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIJC9wJTqYRqFx+12Z9nXsm1L31zsVMT1Y14ynnnYKbYQQRX+HaGqmbzgSCVwndpqG9+/SLdWG9RqGS8QQAABBCIrQMJRZA8dDUcAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAgXYJ3LCwpxJjft2uMkJt7B9hJi84yWkTr2y2U1zeg7xHzPXjXwxXTfMXUsfHf2luWtUt9TqWIoAAAghESaAiSo2lrQhEUWDIkCHjm5ub7fCYh+txkOd5b/i+/1xZWdmiAQMG/CYWi8WjuF+0GQEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABBBCIvMD/mqZqH/Yv7H4029GUHg2ss3L3uabuvZ8qrntgbF4D/NtDFW8Tit5de0nqbXRrtXff+q7WTU69nqUIIIAAAlER8KLSUNqJQNQEhg0btntTU9MdSi4anKHtj3fp0uW8JUuW/CdDDKsQQAABBBBAoB0CI0eO7NnY2PgxJQAfrMTf3fXoE4/Hd1eR3TW/Xs/v6fk9Pa/T87M9evT4+7x585rbUSWbIoAAAggggAACCCCAAAIIIIAAAghEQeCaRR80TY3/NMavKmhzPbPOVB2xr4kd1RBY76TqW9U++8P24kye12RMt/3MjKHvOjdgSvUEE/dvyRDfaIx3uJk5jv6xDEisQgABBEpdIKcjHJ199tn6wDOnu+y0kjBuWLFixS9dYolBIIoCSjb6WUCykd2tE9UBesc555xzKh2bUTzKpdFmXXufVEv65rg1jTp/bSf8enW+v2+f9foFPT+h108sX758XY7rozgEEEAgZwITJ07s8uqrr47QdWuYCj2pvr7+CM233EpYzxoh299RV2I+8WxXbNA0aNCgv2g0wocrKirm33333SGHi95RPDMIIIAAAggggAACCCCAAAIIIIAAAqUs0Nz4w4InG1kPX3/Tr39+pObmB/JUlN1imlrupBEYmpcA3yw3M0MkG9lGxM0VAW3povXf0+OygDhWI4AAAgiUsEDORjjSL8f3rqure1376pTEpA7rv6vD+qMlbEPTEMhaYPDgwZ/SyAn3uRagDs0vL1u27Beu8cQhkCyghKN31VG+Z/KyAsy/rDruUUf8LUuXLn28APVRBQIIIBAooCShw/Ud8/MKvFTXxb0CN3AL8FXmEj1u1mf1/W6bEIUAAggggAACCCCAAAIIIIAAAgggUPICUxYeY+JNTyv7J2f9paH22TN3mxnjRwRu46t9k2s0EpB/UGBsPgLKyi4w08fe5Vx0i2vj3xzim41nPiKD5x1iCUEAAQQQKEEBp+Qgl3Y3NDRcqDjn8tQJdMyQIUOOu+eee55yKZ8YBKIkoPP7k2Haq/jTFU/CURg0Yost8EE14EsayetL6uB/Rh3xs/r37//rWbNmaRhUJgQQQKCwAttvYzpNtV6hz9SWkYxy2AJPZQ63DyV4PlVeXv5ZJVrqD1FMCCCAAAIIIIAAAggggAACCCCAAAKRFvAbp6r9xUk2snC+OdtMXrpX4K3KPM83k6pna4uYHoWdPLPJVHZZFK7SpqDRjRLFlWvm+3qcl1jAMwKtBG5a1c1seK+7MU09TF1ZhSlr2mwqu202Rw7ZbM71mlvF8sKYuX65ee5P3Yw5Y4uJeXFIECiEQM4+RNUB87Q6YsKOWPRT3Vbta4XYUepAoJACSsCoUX1jXOtUssYLGvHrMNd44hBIFijSCEfJTWiZ13n8d3XET1RH/KO7rGQBAgggkCcBXQMvUdE/1vfQXI1olLGlutY1qK7v9e7d+0fcDjUjFSsRQAABBBBAAAEEEEAAAQQQQACB0hW4ZuFhprnxOSX95PrHa+H2uazsKo0e9JPAjWK1B5m6uB3lKGd9u4F12gDP3KoRiCY4xdqgHy3vbtZtfFOuvdy2UTJVhX+YuX78i27xAVE2QeW/b304IKowqyv9901s3OuBlU1dvL/xG3fPGLdP1xfNlUPrM8ZEeWVs8Z6mseE0E/dP0Ul3qPF9eww/pIeSZ1JNOm88/03F/luxL5ky72lT7j1kysc80+ETbaYs3NvEmz+p/T9W14OD9V47RO/TD+i5xw4vTzc19L31Wr5OMf/TuneN5z2j5yc1fswTZsbIl/TaTyWbk2W2jZ45IGNZPXd70Uw6a33amNjC/Ux98/Fp10dpRZn/XzNt3CNKHP2QKa/oG9j0suZGc91Yl1HiAovKOmDmvb3Nxi2HuGzvPCJRpsLsSEXNzc1hk410HnsXTpw48VuMiJFJl3VRFNC5/Z46I52brlhd8JkQiLaAzuNj9FmwSrcUvEmj131H7wP3N0G0d53WIxA5AX13G6Jbf17m2PC1Sor9hmNsQcOU4Hudrj3XFLJS1Vep+mZs2LBh0IgRI4YvXrx4S9j6O4p/2P0OisclSIj1CCCAAAIIIIAAAggggAACCCCQM4Hmpq+p8724yUZ2Z/z4pfrXIeFozBozaf6Dij1Dj8JNvndbqMrWbTpfro7JRrZkJVA1l31BM98MVU+64HfePtKY+OPpVhd0eZ2xdvbHkpmneMP3lTTzuYxB79Rpv8w/M8ZEbeXkmkPV5Iv0Hhhn6uqP2tl8l64lnTe+2V/njx7mdCUq6bDr0VTzvpI67lUyzh2m6oilJnZUw85yIzw3qfYE48Uv1h4MNvHGw1v2JJkped6ubLm2+bvreWcim+8PadnONBozpXqDridPKilouZYtyP1tDZsuNs3+jdvqS/PvxvUjtWZxmrXG1DWdph1xv5Vj2oJKYEWzd59acZYpV2JYvHHltuOToV3NWjep5lwzc+y8DFH5W2Vv4zmlZp6uS2c5VPKvnCQcqcPKfhiGntRhs+err746XBvWht6YDRAobYFQt1pRYkao+NLedVrXmQV0XS/T41sacaSXnr9A0lFnPhvY91IW0He3Q/UedRqqWO/jF7QvJZVwFIvFylavXv0z7cMXi+WsugfqlsILlCQzQkmWoX5dFHX/fJnjki9ZykUAAQQQQAABBBBAAAEEEEAAgVYCdhSe9zbZzvviT7451ly74Ghz3ehnAhtTVnaLicfPCIzLVYDnrTXHjV0ZsjjX26ntLNb3P2NuWnWNueqUrTsXMtchBWJ+mWlYMF5JRt/U4+M530ff76Myz1FCxzmm/vn3zeT5fzBlFTeaaaNfy3ld+S4wtng3U98wUfsy0ZjmI/Scu2lbUuAZKvMMFTpDyUf/0mhRC5QQs8BcP/bRvI5+lLu9iF5J08Y9pGSvaUrkuTa48f6vTax6tdMoacGFhYuYUqv3p0OykWcadK5c2O7MXY1Q1EUdLheGa+XOaG07Yecr5hDoGAJlZWUL1UG7wWVvFBfX43aXWGIQiJDARI109H8Rai9NRQCBCAmsWrVqcjGTjRJUasNZGtntznPOOac8sYxnBBBAAAEEEEAAAQQQQAABBBBAAIESF1i3Wf2afs+SaWVTfIJTW3bvXq2kgI1OsTkJ8u4053p2rA236dqFx6mT+mNuwclRGonl3bfOT17CfAcTaBkxpfZiU1f9nG4H9kedJ7lPNmpLZpOPfHOlaW56yUyu/q2JLT6wbUhJvrYJkZNqrjZ1DS/LSaOf+UcUoJ2HqZ6rNSrRao1s87IStSbJa88C1Nv5qqjs+wMl6awO3nFdF+v8OcYm6RVysqNpmfg0pyo9b4qZPu7JdjfwtddeG6wK+zlVmiJIHTVDxowZk/X2KYpkEQJFF9BIB68riehrjg35ybJly/7sGEsYApER0PX9yxrpKOuE1MjsKA1FAIGCCui68lFV+L2CVpq5sjG6vVrRRlrK3DTWIoAAAggggAACCCCAAAIIIIAAAgjsKhDPfPuqXTfI7xI/fqGZ6wf/oO3bZ29WUkDhbrFTUR7udmqNTfbWaFlO/uVZbshmpS5wTc0RGtXlQSUazVFTldhS8KmLEnc+p9u2PWemzP+2ia3MyR2g8rIXU6qHmXWbnlXCx0y914uTP+H7/ZWoNUMJT68rUesPZvKCk/Kyr5210NjAJlPe5SLdzs5l4JIzTH31dwpGZZPdTPxOHf/KwDo9714zbexNNq7dCUe69cGEwAozB3TZsmULHdKZjVgbQQElEc3WSEfnqulvpGq+HQFJj2/06tXr6lTrWYZABxG4ceTIkaXzS5EOgspuINBZBbaPJPQH7X+Xdhj4+vxdq8cqlbFCj/9o3v2XWikqVoLldSTQp4BhEQIIIIAAAggggAACCCCAAAIIIFBqAnaUE9+UWgf6PubpGjvAQ/BUrtuqFWTy/mmuG/WUc1WxlT0Ue4FzfNtA3wwwsYX7tV3M6wgL2FGNJldPMU3xv+k9d1oJ7El3Ezc/NHXvPakkmiNLoD07mzDp7t3NpOq5Ju7freSo/jtXFHPOr1JbLjF+0yM6jk+YXz/enr/JF3NHSq/u60e+rFGO3H7E7JsfmJZRhwqwG+s26c41/iGBNXnmXSVMXZa49V67Eo7UsbKHKhweWGlwwITgECIQiJ6Ako7m9e7d+3C1fIw6M6fq8Xs9fqDX51dVVR26fPnym+fNm9euTs7oqdDiIgu8t/08tOdipsdctfMJPd5vT3vVCb9vQ0PDd9tTBtsigAACCYFNmzYN0nXlmMTrEM9bdc27qUuXLkfut99+u+nzdz89Tl2xYsXZenxYyb+7qawjlCj8eT2nTBQOqKuPEuj1qxMmBBBAAAEEEEAAAQQQQAABBBBAAIGSFqhvGFuS7Yur89Zlmjb2z+ro/bdLaDtj7Gg07lP9uovUUd2OHx8rOaW+cZR7hUSWtECsto+ZXLNQCSvT1M5SS1Q5Wkk0jymJI/sEuVzi21sRenXqj/PPyWWxOS3L9483a9eW2nHM6S4WvLDp4+5Qwo7LdbaL8eJ36BZ3tg8jf9Ok6vP0fv2MWwVln9Wt1NYmYts1ZJg6Vs5Xp0/wkEqJ2tI8q4yPDh069NilS5c+nSaExQhEVkAJRZvU+AXbH5HdDxreYQReVif758LsjU0u3bp16+m6Vv9Qjw+H2dbGapsrNCrJVL0XGsJuSzwCCCCQLJDlyJq/69q169RFixa9nVxW8vz269PzWvb8JZdcctc777wzWdeub+p11+S4TPOKv1i3e/uWrrHrMsWxDgEEEEAAAQQQQAABBBBAAAEEEECgqALji1p7uso9f4SxSRqxMcE/AvbNbBVzfbqi2r/c8025uSNUOeoHCBWfMtgbo8W/TLmKhdERuGbRB019gx1Z/uASbrRuHdV8h5k8/3gzY/y3i9bOKdUXmqbG32kEKOe/QxetrVSce4E+FV82/2s6VT2pH8pYuO8faurrb1bMxIxx2a6cWt3fNPu/dtrc835mZoy9Ozm2XSMcqSC3bNvkGtPMNzc3T0izisUIIIAAAkUUqK2tfU+jddVo5I+jNEKIHa2oLkxz1AnfU6OSfCrMNsQigAACbQWUuNhby0L9yknXrIVKALo8U7JR23rmzJmzWdtco21DJWeqHPsLj1Dta1s3rxFAAAEEEEAAAQQQQAABBBBAAAEE8igw897e+oXsgDzWkH3RNuGgzj/fqYCu3q0a5SjuFJtd0MNm2rhXnDedVP0xxR7nHJ8u0PfPaEm6Sree5aUvcM3Cw0xzw8NKoMltslHL+e79TwC5vWuMb76lW5n9xsT89uZMhD82k+d/Ue/i20g2Ck/XYba4etRG45VfqJGOmgL3yTeXK0FudGBc2IC5frnOw9u1me1/yTx53j9MVd9dEvSyHuFIv+A+Sp3I9gMkV9OFEydO/PasWbMac1Ug5SCAAAII5E7gnnvuqVdp1w0ePPg9jTLy8zAlK6nUfgjeE2YbYhFAAIFkgY0bNx6t755VycsC5l9WouSlShzyA+JSrlbS0R36vnuu6nROIlLsOSrslpQFshABBBBAAAEEEEAAAQQQQAABBBBAoLgC6zeepgaUF7cRGWr3/Eu19lcZIratio17XR3P9+nFoMDYbAI877ZQm3nmCiVN5GLqYhriGu3DLMlFYWnL8MwKU+YFO6ctwHFFc9mrjpEdI2zygiNNU9NK7Uy/rHfIMxuM8VYooW65npX0Vv62qax4xxw59F1zrtfckhjUsGgvU968j2mO72NM2cEmHh+m2DM1SkyYvx0nNdH/vKmv6aGyLzIxL5+JfDvrnDL/20ry+KHavHNZ2DnPsyP6L1URj5tyX/Nlb+vWW2+bit0032wTWPY0dU17qY69jKeH8T8op0/o+WRt0yNsdYWPr9L7tP6EHNc70sT972Uu07vBlJm5mWNCro1X6LxOM80Y/aiZXG3bNC1NRNJi77cmtvAxExv1ZtLC9s0+VftdJeLa627mydNgFJ53gYkNrGsbmHXCkQqyH3o5m9RBs9crr7wyVAUuzFmhOSxIv6ovnzt3bjzbTqscNsW5qCi2ORaLVegRnMXnrLBr4JAhQ6q2J07surKDL4nSvuv8rYzaLbgKcf6Wwik6YMCAX61ateoStWVAiPZ8OkRsu0JL/dzpLOdJuw5ijjcu9XMisbtRukYn2lzg5wPC1KfvbIv0eZ/+i7xDYeXl5V9oamo6W6FOQ9qqzjP1nVZP2SU5OTSpoCGckwXlzltlHMe80VIwAggggAACCCCAAAIIIIBA1ATsCDqlPPlKBJi08GAzc9S/A5vpld1i/HjuE44802D8yvmB9ScCYkt7mbot5ydetv/ZO1ll5DfhyHgvawSn2va3lRJ2CMSW7GPq65YqmSWLZCPvv0pk+INSAZeYAw582FxxYvrBSbYlBNlEG/v4mx5KTDI/N7GVPUz9usGat7flO1cJFOFyIHyNLlZf819t+1U98jtNrrlcSVJKNspqesZ4ZbXav7vN9LGPyy1TxpJNeNs16S22ssLUrTtOSTWfVOLRp1XWWYorvUTMmcPtiFb2kbtpSvUxgYWVea/J9snAuFwGVI2daeqq7XE4I2Oxvr+Hkshu1TEbFHDsMxazY+XkBacZv2nqjteZZryyb8nlH6lCwr3ZtpdgE1nWr19/caoC2y5Th8t/1fGyZ9vlaV5P0PJ2JxwNHTr0aI2msXeaOnYsVifSxqVLlz66Y8H2Ge1fjw0bNozUy7F6HKz276vXe+pX7s16vKXXNmvsNf1qfknPnj1rlRSxfvumWT9Fsc12Z13bbWM1UsB99jl50vb76Fh9Raaf0LnyodWrV+8/aNCgZsW8o9dPVVRUfG3JkiX/Sd7GZX706NF9tm7dOkDlnqpy7PP+et5d2/ZVfZWqo0mv39dye6F6WfP2PHhU9a1Sfe2+eGm0ri5KoDvdpa02RvU+kYt6bVkjR47s2djYeLL28zTtl/1itr/2s6+e7b5X6BxusPu9ff/f0Hn8mF4/UlVV9UiYW87YunIxqb371dXVjVJ7zlB5+6ot+2h+H11jeuo4bdX8O1r+tpbbLw+r9HqxzqVnNd/uqVTP33bvWJ4LUMJMXHZfVCf8U65V6bjt7xrrGlfMc8eljfos6abzeKT23X6eHKTHfvahZK0uOrff1bz9LLHXn9pevXrZz5JNet1qGjNmzB5btmw5rtXCFC/0efa2Ps+eSbGq1SJ1Op+u0am6tFqY5oWuCc9kc03QNeZ4FWmvOYGT9v013a7vX4GBjgGlfk7Y3Sj0NXrYsGFH6L2a6v13mCOrvrv63XVc0yYN9u/f/8FCjFCpdoRKOFL8atd9TBen99Vb2vfnVJY9rwMnxVXp+mi/99r3uImCfzG+MxXTpaNeBwt9bQl8MxCAAAIIIIAAAggggAACCCCAQCkKeC0d7KXYsp1tKmueoBfX7FyQZq5y9wVKsHhff7zrkyYiu8W+t8Rs6+h3275uq+0v7u4W7BAVV9IVU7QEYot3M/VbFyt5pX/Ihm/VSFM3m8puM01s6IaQ27YOjw20/Ss2UW6+uWbhD0xz441qz/DWQQGvfP8rZkr1GjN93I8DIrNfPaV2iBIFfxG6AM97SYlGU8z0MXN3bDtzx1y4mdjAJm3w1+2PH5tY9QdMvf9ZeX1Oyw4MVxjRORGwiXSx6kt0HP6m4xDQv+Z/2kytuUr1tu88jdX2UfLSbSrHIdnMW6xko5+n29esEo50Swvb6WQ7TgMndbzcog7F0/X88aBgxQwbMWLEnosXL7YZhFlPSqq4RmWdG1SA4uz9Rw9KxKlzuLcSi2aqg/gyLeuWWG6fVZ59KtOz7eyyj5PUaTte8b9Sx/FS7eP1SoLIOtstim22IK7ttrHy7ZnoULdJXXL+sba/TKYtQ9xtN7ahZXrYJJn9tX665p0SjpQEUaaO/KGK/6KSjQZre1tO4tjteLbLNFVove0QtI9DNN+SBa5O2QZ1LFbreM5SJ/iftC6r6d133+2lMu913Vjn0hmKfdA1PlWcOtAGqJyvKnnnHK1vSShQG3YJ1bJKLdxbzzYp7zBtc6YN0na+zuWV2vdfK/lhQT5HF9L7fLf6+vovqdrxqtdeG7zktibNd9O8/YJiH3Yaodcz1E57mxx7nH6o0StaOnW3rQ73bymdv+FaXvxodcI/rffKOh2PgA++bW1VXJW9xrY3QbNUzp1MR2D48OGHKOnvWl3jxiiuh/Y9VXg/LbSPY7V+jD5LtsjzdiUfXp2cfKhr2Wit/22qApKX6Vyep9cun3sLFOf0H9CGhoYLFXtncj0u82rvjxTXcl0JilfsLxTz5aC4TOujcE7Y9hfrGq3Ptavk/PlMhg7r7Gdy2s80febZz9L3HMppV4ja0DNMAfqcsImquZhskuvxrgXpc9V+R275bCpV/2J/Zyqmi66XHeo6WKxri+v7gTgEEEAAAQQQQAABBBBAAAEESkZgrl9unqo+umTak64hvn+xOrSuDRy9wt7WZsr8u9Q5/YV0RWW1POzt1IyZmFU96Tby1J9sj5W9fRZTNATq6n+thp7o3FhPNxPzNaJRV3OtsbcHzPV0/Sj7I+cRZkrtp4zffJPeI8c4VxE3PzKTap8xM8escN7GNdDecs5vmqv2hMjPaBn96Tpz0IG/zDjyk2sbUsVtOwY/0C3lrjcNC8428eYr1G2rH9L7XqpwluVJoOVWmRr9ysSrA2vw/enm2pr7zHVj/xYYmy6gPv4brQpOMPO8taaq8rPpirHLWxIyMgWkWqeOlAmplqdaps4e2wm6M9suVdDOZV3UwXnRzpd5n9O9HbdNSmAYrQ7ff6ozy34wt0o2SsSkela8TZYZo+dH1Vk8TX/0b0meSRWbo2VRbHPLrqvjvLedUWf8/uqIf1izE7f7taxP9Y/WO32hGDx48AUaHckmJi3WY6i2y+rc1naVelygc3ylzonVOp5HpmpXKS3TeXeUHn9RB9pqtd0mCDiNXpJiH+wHh70VzB91fF6V6WUpYtq1SGV7KvdiJRu9oIJsUsJJemTzgfVBHaNv6fFv7ft3CvC+M/k8f9uFWtyNnw9TvZJVd1y/wmxnY6Nw7tgOfJ3fV+lz7G9q7yVqdg/X/VT8bnpcrk74Z1WGHRGpZdI5flRinufWAlE4J2yLo3SNbi1ckq/eDNMqnSNOiW9BZSq59XHF2IQqp4e+++4RVGYx1+sa02m/MxXTPdd1c23JtSjlIYAAAggggAACCCCAAAIIdHiBvy86WB39XUt+P+2PsK+tHejUTq/8Fqc41yDdGcTs23WJa7iZWj1Af73/qHO8S6Cvv6s/XXuESygxJSAwpdb+ENqOcuU62VGNxpuZ4z6Tl2Sj5FZMH3O/qdrjBCXvhXif2CSb5lvN5KV7JRfV7vmfLlX+QNOdugY59xup+/Qh07X7YWbG2J/mLdkoecfsKDvTx9xjZo4fbcorPi63lcmrmS+AwIyxNeo1t4lAmSffVJqm+B3mplXOOS2tCpxS/Xl1vI5vtSzlC92yz/MuM7ERGQcLCp2UYW+7oPpGp6yzzUJ10KzRKDF/1a1e5rdZlfalOocmpF2Z4xWqq8rujxJLvqiia/R633ZUYUfMmaLO4SfUAdCecjI2IYptTuyQRvzoY293o874R7Xs2MTygOemTOt125L+On5L5X6HbPpnis1inR0x6Ekdz6uz2Dbvm9jkhu1te0L7fkqOK9xb+z5b5d9rjXNRtso6WI/VKneOyts/F2Vqv+1IUjeozGd1HhyeizLTlZGP8zddXVFZLvt/hmmrPhN2CxOfiI3CuWNHb1LS44M6F3+sdmf3Aa8NZbqvylioff7y9v0n4ShxIiQ9R+GciNo1Oom3ZGf1fTLUr130fhqSi53Rd9mfrlixYk/Xh0beeyAX9ea6jM78nSnXlsUsj2tLMfWpGwEEEEAAAQQQQAABBBBAINICTc3uo5wUe0eb/MucmjBtzGPqnH7OKdYpyJ9nrhxa7xRqg5qNRkLJw+T7ee3vyUOLO2eRUxfvb+LxX7nvvPeO8SoGmmnjat23aWekvX3YjHGfVfJOLERJ+xh/6+9CxAeHvll3g5KN3K9BnjfHdD38LBMbvC648DxETBv1uNzOVHLYcJVu7wDAVCiBqqqvK8kneMAH3xxp/rv2xtDNumbhYToX/5/Tdp7/Y91K7d6g2NAJRxrl4xwV6pQBrM7llkQj3XrnFW1jk0xcpmP1y2v3N5xLiRlitD/XabW9pUs2o6zsUrI6t47SY8WwYcN232VljhZEsc1219VRuIdGtrlNs87JJjqH0iYcqePsWI3q87jKy0mHom1j20nHskqPmercvqHtumK+Vps83T5ulm2bbWO+2qKyP60RV1bpPXlYe+qQ3/Eq6y8qw45olPNJZX9Yhf5Z9Xw854VvLzDX52++2lnIcjWKx//C1Ne1a9dXw8Tb2CicO/aWXhoVbInOw0+E3b908Srr/5REpy/BhoSjNkhROCd0/CJ1jW5DXLIvlYwX9hpyos6XmSW7QwVsWGf+zlRA5rxXxbUl78RUgAACCCCAAAIIIIAAAggg0KEFIpTE4vljzY+Wd3c7HGW3uMU5RJV5tg/PbYrVaoAK/zy34NBRJByFJivCBvGGH+occO0P/5ep6DLAzBjtmi+Q2x2aOe77xiuboEIb3Qr2R2gErzFusQFRUxdo0Aj/yoConas98z0l+1xqYkc17FxYpLnp45aY48d9VAkwnzfmQ2n77IvUuo5ZbWzEFp2rFyhzJfj4x/0vmck1NinMbYo9q5GRGjXSlh88QITnPWmqjpjqUnDohCP9odstq1a1K3ZeohHqmJ6bmA96VofShKCYXK1XG7+Sq7KSyvmIkjSW2E7opGU5m41im+3OKznoerV9YBgIxae8pZo6zk6S8Uqt3zNMednGqp7vqNPyu9lun+vtlABkk+Q+l+ty05S3n/b/T9kmHWm7T6ncP+nRL035uVq8h9r5gI5TqHPMtfJcnr+udZZ6nLyPCNHGTbW1tfZ2RM5TFM6diRMn2luBVmunTnXeMbdA5Vt6v1Ho/m7hnSMqCueEPRJqZ2Su0VE6czTS0N/1vlgTps26Tl2t4/GjMNt0tNjO/p2pIx1Pri0d6WiyLwgggAACCCCAAAIIIIAAAgUX8CL0t1Z726V1mx1udyPFqqrblAyQi0SAV831Yx92Pi4N8UsU2805Pkygb3Jy540wVRIbUmBq7cc1SsoFblt5b5qyLqeb60e+7Bafp6gZY281ZWWXOpfebG40LbdCc95i10D9ONnEmzSajL1Vm8NUZr5uZoz/gUNk4ULO9ZqVAPW7kkiAKtxeF7em6WOeVtLRJLdGxH9vpizc2ym27p/2B9rHOcRu1lg9F7ge81AJR8OHDz9EDXDqVFWH0CvLly9/LNFgJRHZ5CM/8Trg+SLdLqAiIKakV6uD62R1QpdMgooLVr7brPJPc2lHcozOo12+JCmhpK+SPxYoTtnTBZ2+p067EwtaY4rKNOrJebL8QopVeVuk+vbR4w7dNqo8TCXqGDtG29mRX3qG2a4dsd1V111DhgzJ7b1V1SCVm5Pztx37VoqbHhWiUWtCxNqEjUicO6+88sq3dW4MDrNvrrEqN9RntGu5UY2LyjkRpWt01M4FfSfw9bg1bLv1HfRb+u6wSp8NZ4bdNurxnf07U9SPX3L7ubYkazCPAAIIIIAAAggggAACCCCAQDYCfrR+3On7bokRsWFvqQdjWTYirbYp825X4pJrP67t8Z3YavtcvvDMB3JZHGXlQSDefKNOguAkGtvP65lzzfRRb+ehFeGLnD72Lm30E7cN/Q+ZtXVfdYtNEzW15jK9V9z6lu1t1KaPV3ISEwISmDbmZl2Tlwda+GYvE2+8JTBuUo36Mr2vB8bZgLKyK82MsS84xdpw10AbpwQatw+3bYXOTy57xYoVr6mT6JHkZRnm+z3yyCNDM6yPyqpvqKPn4Kg0dns7S6rN6nBPNcLR/2n5PoV2tZ3/GlXpZ3oO/gDNU+NGjx7dR++jm/NUfMZitd/Hb9y48aqMQUkrJ0yY0FXb3KFH3m75llRd8mw/dS7PSl5QrHnte6rzt1jNyWm99raR2r/+roXqvF3jGhuVc0edvwdon6a67hdx2QtE5ZyI0jU6+6NR3C27dOlyq64noa+tul6drGTl+/W+vV/Ja58o7l4UtPZO+52poMp5roxrS56BKR4BBBBAAAEEEEAAAQQQQKCzCEQricXzzzBTF9i/QTtMObitWnmX2x0q2hYyufpU/Ur7I87xYQN93220jrDlEp8bgck1JyuJ5jSnwjzvOxod5y9OsYUK6rrHd5R48ZBbdf5Vxt6GKptprl+u94nb4CSeedrste8V2VTDNh1UwCaAehWX6Vx9x2EPh+jWaulv2xer6Wc8f7ZTkqDx5pnpY3/vUOeOEOeEI3XUqH/Hu2THlgEz5eXlO26nlhQ6N2k+42whb6uWsSHtWCkzewFyzJJsR0U53LTU2qxzrtUIR+ooPEVtvDDMLm/vmKzV83W6td9n9Hy5HjfpYbMC3bO1t1V6kkZIyM09O8PsxPbYrVu3fkn7HybZ6n3t5/e036dVVlZ+oHfv3rupqCO0bLgeNku2lW9Qk1T3ta63Cly7du2Nig8zAk5Q9c7rVe9oJfs5X6+cCw4ZKONQviGLL2p4Y2PjDDUgTPLdGtcGR+Xc0fH9sc41+55iyrNAVM6JKF2j83zI8lb84sWLX1bhM9tRwZn6jvmwPiNe1OMHSp4Mc2vIdlRb+E07+3emwovnr0auLfmzpWQEEEAAAQQQQAABBBBAAIFOJOCbvpHaW1+DRjQ3uQ0EcdCBi/Xn+v9mvX822eG6kc+G2D7PiRHe7iHaQmjBBfyvOVXpefOVuFB6/eSxgU2ma9fzNHrM2sD98P19TcO/zg+MSxXwVM0Y9UJ/MNWqVss8s86UV441V52ytdVyXiBgRwbz/M+4QcRvMFNqdk0EtQOp1Pu3KvktOJHT814zXctCj17nfNsy/Rr8DHWsuo5m8eqSJUseU2dsq/1X0sN8/br8Ji1svaJV1LYX2naYEhv2VMdS9h+QKcoNWGSzqh7QwyZLrVF731R7u2jeZhB/Wo9LZdBLz86T4oerQ+so3V4uzAe1c/kKjGKbnfdPx6JVwoZef06mYba/v6Ki4qs6H/+ZaiMlD52uY3yL1gVf8LcXoI7KczRbk6q8Aiy7KEQdD+62226jFyxY8H6bbZ7Xa/tYov2fpf2ZK1OnxCDF9ayvrx+hbf/YpsxWL3W9OFnlfrnVQocXOr7LFLZajyf0/nteZdjjYi+Ox+hhbyUXJrljiraZo0fRprbnb9EakuOKdU0bqGMR9gPH6T0TlXNH7Txs+7UglK7Oif9pg9/r/F6hx2sqo0HL9tfzh/S4QPOflq1zMnCoyiMaHJVzYjtvyV2jTz755CueffbZL7Q9/Bqx7ms6537cdnma1y8qYTVtYs68efOa02yXl8X9+/f/vm5nOFzvlY9mW4G2tSNQXqvkyWuVmPO03nt3KjH3Ln3vfDXbMlNtV0x/7VPJfmcqpkuq4xSBZSV3bYmAGU1EAAEEEEAAAQQQQAABBBBAoLWAZ7qF/gl66xIK/8rzbMLRtMCKrzix0Uyq0QhFjokgbQv0vNvaLkr7Orasr6nfZPvJ8jd5pk/+CqfkdgnEFu5n6pvGBZbhmTplA1wZGFesAHsrwkk139Z7Jvjcj8ftbaj+ELqpvvmm2zYaBer6kfaHtkwI7CowY/xSM3n+T/X5lfn95Juuxo/fYX669GPmyqH1OwqaWvt1JRvpdmoBk2fixpRfZGKj2+YVBGxoTEVgxM6ACTtnM8+pg2O+Hrtkhdxzzz2vq1NnlbY+NXMJentrdCAlNlyguP8Lis3FerX3WdU5XolBNhGj7fSkFixUJ/v3FPdA2A4ubXOxtp/cttD2vo5im8PuszpDd3Ri2lvqaJQL5y8x8nm+X79+o+bMmbM5Xb06Jx8cOXLkyXV1df9WTI90ccnLVe7Qc845p1IdrA3Jy/M9r/fO4Tr3jnSpR21cq2SGc1IkG7XaXPv/nM5r24n1Vz1scl3gpLLPV1DGhCMdN31Ih5rWq9zP6f1X3Warl/T6PrtMSQc3aP/tB7/TvU4Ve7gSqs7UPj5gty/GlHz+FqP+fNQp01OVpDdbZQcmjibV/7iO7cqk12lno3Lu6Pxy+2VJ0p7qHH+yW7dun0rxvrTn+UN6zLajrejWjfNd3+tJxXfY2aicE6V6jY7FYvqSuOuka/+Oz9dd17ZeonPXL3RSUesWtH41a9asRr1XLtB75SG9V/ZsvTarV8eqnGP1vXOm/Z6qz887tM/z9PnxblalJW1ULP9S/85ULJekQxOZ2VK9tkQGkIYigAACCCCAAAIIIIAAAgggsFOg287ZiMz5/qG6Tc7JZsZY+0PtzFMXc4tpNG4jzySXZDuZKyvuTF6Ucb5hy2Xq+O6aMaa9K32/qr1FsH2eBOqbx6sT3yW/4Hdm+ri1eWpFbortOuZOU1d9rQo7LKDA45TwcbiZMT5VDkHqTa+pOcI0xQekXpm81PuPqep7a/IS5hHYRWDf3b5j1m45Q9feY3ZZ13rB0ebNuhu0yCbJGTOl9ljjN7vdMcLzppnpox9u2S7kP06jKCi5ooc6YoKzFbdXro6aeenaoXVz061ru1ydPRPaLsvT67/06tVrwIoVKzJeKNRhvk6/fv+02vVcmHaos/RC+YXpnHcpPoptbrtfz2jBZHl+UqMQHabb8PXWo2v37t33tK+1/EydL+sSG73zzjuHyLFn4nXQs7b9WqZko8T2ixYtelt1/TDxOuhZbeilkSE+HhSX6/WyOSREmXe7dpTqvP6b9n92iLKPzhSrTuyDVd6oTDHJ6xT7mvbthBTJRslhZtmyZf865ZRTTlb8klYrMrzQey/0KEsZimu7KtT523bjqL0eOnToPjq2f1Cykf2wOTBM+/VedHp/ReXcsddzPWwiqfOk8/bvGnFsUIpko1Zl2NHY9Hl0khY+0mpFJ30RlXPCHp6oXKM7yqlk3yv6rjBQ+/NODvfJflc7VZ8dP9e17k2df3fp2mffj5GbOvt3psgdsAwN5tqSAYdVCCCAAAIIIIAAAggggAACCIQR8DXCUSQn/zKnZl839m+Ke8opNjnI9x4wsVFvJi/KOB/+7gcZi0u50vOcfiCfclsW5lnAHxtYgWcaTFmFTXoo7Snm6ce65d93a6Q33i1ue1Rzy91ygjfxvOuNvcUbEwKZBFpGLKqwA/VszRS2bZ1/pZky/2wTW7ybRjy6U0lKlYHbeN5qU9n3B4FxaQJcMhCNkitsslH3NGW0WmyTB5YuXc2Nk0gAAEAASURBVPqonlstT7xQws58jSZzs16nDkgE6lkdusero+dolWc79vM1be7Spcul+uX+JpcK7C3e1KZP6Vf1jyretdP9QI3O8gnFZ5UVlqJdUWzzjt3QufGWHhcrgeT+HQtbz9hhvt7T44Xkxer8c/Vu2ayqquqx5O0D5n+r9c5vJHVG7h9QXs5X6/1wgGuh8v2Ha+z2uL/q+XKXbdSOjPuu9d9QOU7JjNvr+4aSo15yqVsjIjTp/XeV3n9nK97l+jVKI1j1VFLZRpfyXWKyPX9dyi5EjNq/u0ZLGB1Ul+J207E8RM+H6flQmR+pbUL/h0zbv9SzZ8+aoPrs+qicOxpZ5TQ11/l6JIM1SjY6q7a21l7XAif7eaRbil7Y0NDwtEx6BW7QgQOick7YQ6C2RuIa3ZFOFyUd/UOjrg3U94N7tF/O70lHgwod0/N07TtP18xHlPTxY30frdb7eZcRPB3LK2hYZ//OVFDsPFfGtSXPwBSPAAIIIIAAAggggAACCCDQeQTs33X8SPxpp/Ux8c25ukXO11rdIqd1xM5XZd4tJu4ft3OBw1yY26lNrjldHdiHO5TazhA/3s4C2DwfApOX7mX8Lba/O2i61Uwb/VpQUEms7zr6j6au5lr9hf+IjO3xjU04uj5jTKuVnu7YE3C9Uf+Zqdp9TqvNeIFAOoEZo5/TSFvf1Gn1i3Qh25ZrEJy4mW3qG/6kz7zg67VnNpjyLrqVWvaJby4d9rYTzS17Vnuh2JS3U0vsuDr+7S/G/6w422EbOKnDZIKCvhkYmH1ArTqs/hNmc3U4vaV9+LX2YZrrdoq1t5HLVcJRFNucoPqnOu3OtIaJBa7PGsngPzofnIaDlPfWoJFEkuvV6Dpr1aFok86cbqumEVv2Tt6+EPPap+AMxO0NUexHwrRJx+RB2f7SdRt7q5bZs2fXtY1XvZ7eG+e1XZ7utTpu7w8a2ajttjp3XlAdv1VdX2i7ru1rxZQracOORnV/23VZvs76/M2yvpxvJpMPq9DaoIIV1xKSeA6KT7Vexzeu7b/lcismxUXm3FHC4SdT7W+6Zdq3nyvZKNQoLEpufVnn+XKVqS+lnXOK0jlhj5DaW/LX6I54Jilh9TmNxHnMhg0bfqFjcGGe9nGAPiPnKXl8tR5fU8K0TdIt6amzf2cq6YMTsnFcW0KCEY4AAggggAACCCCAAAIIIIBAeoEGrXLqF01fRDHW+Lubt+rtXSXmBtbue3cYz7/RaUSLbYVtNX3KnX4wvC08fkVgG3ITYI8VU6kJlG35pGk25YHNqij7eWBMqQTYUY4mVf9MzQlq8zEmtqyviQ3ecWeetLswdcEBprkpuJ/WNze1J8kjbf2s6LgCM8b/0kzS6EXG2M+ETNM+6rQ6P1PAjnWe90Vz/ciXd7zOYibwg1UdKwepc/UM17KViDHPIdZ+KDolHOmP7BdpVJOr7cgmDuWGDlGHeFblaqSm2+rr620mY+BITbZRqidcRnGGPYlim7fvTpM6wC7NJtnIbm9vn6In+8jLJNeXdL591KVwxe3tEpfLGLXvDdXrWuQYvXd/bG9D5rKBTeJR3JdcYjPFaOQX+wG6R6aY5HW6Xnwv+bXrvLZbqs7fwISj7eWdrOdcJBy16/x13bcOFOfrnJ2ohLIFLvsUpXNHn4nHu+yTjZFBs55ud41vE+f8htd2YWLbVFOaL6N0TljBKFyjS/NIt79VSmpcr1IuUpLeEj3/WJ+V+7S/1F1LULkn6/Go6pmtWx9+Y3u9uwaWwJLO/p2pBA5BzprAtSVnlBSEAAIIIIAAAggggAACCCDQ2QV8Y++usVskGeLxS9Xu4ISjGWPfM5OrF+nPxXY0luDJ8xaaq0e53SEitnhPU9eg22kV4k/Rnj1WTKUmEDcDgpvkvWN+MObv5rrgyBKKWBbcFo0aU7/J7v/SwNjm5lMCY2xA17LgspwKIqhTCXhln1My0cd0Ld6v3fvteXPM9HF3tLecwNseqWPlElXimlTzun5p/ohDo+wtKeIOcTZk71WrVg12jC1YmEafeFX78KBrhXLMWcKRa51t44rdZnnVKrHl8bbtKqHXm0O0pWuI2FyFrnEtSOfbnnqsVKfop123yUWckoBOD1HOppNOOsnemjD0pBGZnnfdSA4OX4CCS4vA+Ru8EwWMkNdVSnj7nWuVUTp3tG/OCUfa//vsCGquDsTtFIjSObG91Wt2tj7zXLGu0ZlbFf21eq/doYRwO4rbZL1P/5enPfJ0/D6jEZUe0+3cjsxTHVEottS/M0XB0LWNa1wDuba4ShGHAAIIIIAAAggggAACCCDQSQXy9fei/HN65mwzZaHjD+H9W5wb5JnbnGPrGyeog7vKOb5dgX50j1W79rvEN/a94P42zzygX+cWIistd1gzx/1HbX4puEDPDnAQPHm+Q8KR96KJjVkTXBgRCLQRsImlZWVKQm3n+8ye830qvtym9KxeBiYcqVSbNes6ZbydWqIQ2/mqP4g/nHgd9KxOowlBMUVa/8cQ9R48cuTIniHi8xVazDaH6ZzK1/5HttwBAwY8offCa647oPfYvnrcq6SjJ/S4ZMyYMf1ct802TvWFSTh6ONuRy7p16/YfWTQ4tvMYx7igMM7fICGt13GxI/pM1nX+ZofwHSFROXf0Xuqrtvbf0fCAGXncGRDC6jQCUTknEs2PwjU60daO/Kzk6i0rVqyYqc+JD+n9N0mPF/Kxvzo/D1VSnB3taFQ+yqdMBBICXFsSEjwjgAACCCCAAAIIIIAAAggg0E4Bz7zXzhKKt7nvVxi/8SKnBhw3brn+Uv9mcKz3X9O//4rgOEX4Gt3F+Jc7xeYmKLrHKjf7X5qleP6xDg27zyGm9EI8o/dN0OS0/yrE+1hQScoVcXvvBRZEQKcUmD7mfg0X9KOs973lDmDlFzmPcBdQUcZbqumX26eqM+XggDJ2rFbni8vt1FridUukubotjWtywgglS+xRW1tbUh8w2l+HbMcdPF5DQ8N+evWvHUuKMBPFNmfDdM4553TbvHnzUTp/j9b29jZfdsSfnup47Ln9uZue247cZUdFKNlJyTlxdWzOVgOvDdNI7acdjeUP8jDa/lnNr5TDSi3/k5JCgu81GqIylXucynXawnYCDxo06HCn4DZB69fbu+eYLXpUtlm1y0u1p+8uC1mQL4G/aPSpr2gks6fDVhChc+eAMPum/fp3mHhidwpE6JxoaXQUrtE7dTv+3IIFC97XXt5gH/b7rL5zflafB+fqdY8c7r0ta67KH6IRPh/IYbkFLaojfmcqKGCeK+PakmdgikcAAQQQQAABBBBAAAEEEOg8Ar55J9I763t2gIibAvfhXP0oeFL1HMVdnTHW8/9orjixMWNMYuW1tQOVdHRo4mXen33dlouptAQm1+xh/Hjw31aryu4vrYY7tsbzlADkfylztHdQ5vXb1/rGob/Z1seEQDsEDup/jVmz5kzd5fLELEr5npkxOqu7EKWqK2PCkTpnJqTaKM2yN5S8sFodhGlWt16sW15U19fX/586fwJHWVJM5ZYtWy5QCT9rXUpxX1VUVLzV1NTk3AjtR2/n4DwFRrHNrhQjRoz4YGNj4/k6b8/VrU6OSXVuaVlLcYnn5LJTLUtenzyvWLcTPXmjHMxrxIabtm7dOkH1h0p6SFSt7Y7S/FF6/oreqzaB6W96/YDmH+jZs+dD8+bN25SIzeZZ5e7pup1iv6ZY+8j31F2dqZXat4Z8V9RZy9f5Y28ZdrU+A+x/YrKaonLuKKGqd5jrvq5Hb2cFwkb6/2v0rielfo3urKeVkoH+on3/yyWXXHLlu+++e47OLZt8dFouPFROpZKba4YNG/aJJUuW/CMXZRaijM7wnakQjoWqg2tLoaSpBwEEEEAAAQQQQAABBBBAoEMLlJlXTDzKe+h/1EypPdZMHxP8g9+KiltMU2PmhKMyz/12as3xKwoq5+lY5Xc6VJYX57cK/20zfey9+a2jgKX73kHBtXkbI3ubMK/8eRN0gfD9DwYa/Gh5d/PexuA7zlRVPB5YFgEIZBKwCaPXzL/QNJsnlXQUnAy4s6w/maqxM3e+bP9c2oQj+2tnJW3YX4I7TepwdrqdWqKwRYsWva1khwf1emBiWaZndehM0PqSSjhSm97K1OYU63qlWFbQRVFscxDQ4MGDz9B+TVMC2ymJWL1OzHaoZztigwZSmKAkhnu1j4HJepl2fvv2xynGjkr0TY0a1KT3pE0a/L2Sj/6oBJ2tmbZvu06/wK9YtWpV0ZPq2rbLvlaCSB89kRGfCicHy3T+XKZbGGX9xTlK5472NdQ53qtXr7CfEzk4ItEvIkrnRLJ2KV+jk9vZWefnzJljb4052z70WfphJQqdr/nz9LCjIbZnsomI83TeHq2HeyZ6e2rMctvO9J0pS6KS3IxrS0keFhqFAAIIIIAAAggggAACCCAQNQHfe1kjmESt1a3b68cv04LghKPrR/3LTJq/SrE7+s1aFeR5L5lp4x5ptSzdi1hNP1MfH51udX6W+zpWeZx8XyM2NTv1T2ffCu8hbZt1v0n29eZpS8/vH/j28fz/5qn2/BfbVK4+xMABv7qb2LK+JjY4/d1jNtQf5NTYffd/1ymOIAQyCVw//kUzpfqr+gX/LZnCdqzzzDpT5V1iYl5O02/TJixs3LhxtDpWnRNkdIs059upJXZK5YfZ5gT9evwjiW1L4fmkk056T8kZzSHaEqqjOkS5zqFRbHO6nVOn2UFKkKlW8s1KnUupvzSl2zjCy+1tW3TeXaRdyHWnZoUcT5PnLUo2fEO3O7tOIyDs5kr15JNP7uEaW+g4jQq1e6Hr7GT1TW3P/kbp3NH7wyavuU6b2ztqmGtFHS0uSudEW/tSvUa3bWdnf63j9JISJafpcYw+Uz+ix//T43/Zuujz83Al3X4x2+3zvV1n/c6Ub9dCls+1pZDa1IUAAggggAACCCCAAAIIINAhBcrMix1gvy4wsZVpB5NotX9lXvoOaM+4j25UZz6jRJPKVmXn+0XHOFb5Vip0+Q593F50E45mDHtfoIEZR8ZszZw70RTvG3hgPO9959sZBhZGQKcXmD5utvG8P7o5lF1uYuNed4t1j0qbcKSOE5sl6zSpg2aDHnZ0lI+Heajw15wq2B6kX6I7tylMudnG6lfsNvsrfRZjm4Jl1LPNooK/jGKbUyENHTr0RJ2jf9VjbKr1HX3ZsmXL7lKS3yidU/ZWVjmf5GoTdK7RqFH/VCflSJcK9P4M/hB1KSgPMboNVpc8FEuROwVO17V/8M6X4eaidO6EuY4rNrpfrsMdwpxHR+mcSLXzpXiNTtVOlm0T0O0gn9Xj6xqRbH99tn5ZS9/Ixkbv+ZhGCHX4j3c2pWe/TWf/zpS9XOltybWl9I4JLUIAAQQQQAABBBBAAAEEEIiQgFfx9wi1NnVTfX9v0/jekNQr2yyt7DZXndBb2izd9rLMvz3l8rYLfd8znn9528X5f+1F/1jlH6mwNXjGZYCC6I7a43m+3i/BfTrN5d0zwntNwU6+ia5Txp1nZdEEKrpc51D3s2bG2BqHuNAhKROOhg8fvr9KOsu1NCUn9NKtJB7R86NhHip/sWsdNk5lX6yOnPIw2xQg1i2TeFv7w4yGlM+mR7HNOzzs7UDUGf2Azoc9dyzshDPqdFrar1+/Q9TB+V3t/qY8ERyoEV0WKpkk871+VbmuAYXNcA+xw2qbHyK8Q4fqfHmuoqLimKCH4paFhJiu96QXcpuW8CidO9rHMMMMltrnVTaHpyjbROmcSAdUatfodO1k+U4BeytRHbdf7LfffgfrGjhdj1Df23R96Kvbkw7fWWLx5/jOVPxjkOsWcG3JtSjlIYAAAggggAACCCCAAAIIdBqB60asMcbbGPn9jXuXOu1DbOgGxVXvEuuZR429DY/LNLX20+qc/bBLaA5j1ut2b6/ksDyKyolA3CWRJjhhJydtyVchfnAiUGNjZge/LHNCUkvTHerJ1y5SbscU8H2HuyJ5DjHZ8aRMOGpsbLxYnSYp12VXTW62Upv20a2esh5FIzet2FnKxIkTu6hNzrdqUsfV+p1bF2cuim1OltItvvaU+Tw9sh4tSsfhXT2eVLmPtnnkK2kneRdyOj9nzpzNGpXhuq5du9rO0V+p8LxcLOQ9U0lH0zI1XqNCOAw1mKkE1hVCQMdyy9KlS58Jeuh4TlF7nBO1VO5xOkfOzWYfonTuhLyO75WNB9sYE6VzItPxKqVrdKZ2sq61wOzZs+v02TpVS+13zq2t12Z+pWvEqMwRhVvLd6bCWRe6Jq4thRanPgQQQAABBBBAAAEEEEAAgQ4h0DKCif9Y5PfFNyPMpLvd+iY9c8su++uHuJ1a3L9il+3zvcDzon+M8m1UjPLjDrfVK8vb4AiF2WONcRRYUbnJ/ENz3+8SWIbXARIfA3eSgM4kkDKpSB3HJXXrsuQDorZNSH5dzPk333yzX5j6Q3ZUhynaOTaKbU7eOSXD3axzIOzIRv+R/eV6fGTvvffuoU7EfnqcsGLFigHJD613HqJRsc6JGMntz9f8okWL3tY+fbGqqupQddR/U/U8oEdOE4DkPnnIkCGDMuxDcOZvho3zuUqj+QR/SchnAyJY9j333POUzvPakE2/TrdtdB5BLansyJw7MrH38XWa9J6pGj16dB+nYILaCkTmnGjb8FSvS+QanappLMsgoM/V+/Se/0KGkFSrBpfKaJx8Z0p1eDrWMq4tHet4sjcIIIAAAggggAACCCCAAAKFECj7SyFqyW8dfpXx6s53qmPa2D8pheLlHbGeRrjwdvvjjteZZmJL9tG2hf9xnW86wDHKBBvRdZ7DDzN9s0dE9y7R7OAfkfsVqW9TmCjB8x1GUfOj7pTYW54RaBHYpWNYt174mG6hdESp+qjjZ4RG0eirTqB1xW6jOnL2DtMGuTp3VIcpN0xsFNuc2D8d9+NleFHitcPzZp0vXz/55JNnKwkiLyP/OLShoCGLFy+2Xxxvsg8lB/WS11maH6bHECU/7KPn9kyeyputERMOVj27fKCedNJJ761evTquelImMratWMdmoWJfaLs8H6/Ly8tLNnkhH/ubqzKVqPU93dpqtOsxVb2HrFq16rN6nhWmDVE6d2QR6jre0NBgE1NDbRPGrqPGRumcCHMMinmNDtPOUovV5/9peu/d6doufb7cqO+JN7vGZ4rT7avmqP6YYj6YKS6xTu3sqdE47ft+bWJZMZ75zlQM9eLVybWlePbUjAACCCCAAAIIIIAAAgggEDEB3384Yi1O11w7cMQv063csdz+eH7y/Nl6/f3ty1aYGUPd+kvqtn5O2+zSj7y9nPw9VXgd5Rjlz6gYJftl6heMZ67ZN8EJO5lLKN5a3/fMlJo9dQvBzG0oi2/OHGDvdhRQhu+FHVgjc5WsRaDIArt8UCihYEKR25SxenXkVGkEF5u5+4uMgQVYqXbs3dzc7FxTZWXl/5yD8xQYxTYnUZyXNB84qw7HL6rDcY4egbEdMUAj1CTuz9tyj97hw4cfouSRU/UesklINgHJbcjNJBxts299ff0YLbo9aXHLrJK64oMGDbL3Z7UdrYGTjs+LOjbfCQwkoGgCS5Ys+YeO6Vw1wO3XEtta+l2N7jFn3rx5zrchitK5o8/IUNdxfUbYxNSCJNYV7UTJQ8VROiey3f1CX6OzbWcpbKfPHv1n1uzv2hZ9vnzINTYoTmX5ug4+rTinhCNbnr5r2QTfoiYcqX6+M9mD0Qknri2d8KCzywgggAACCCCAAAIIIIAAAu4C+3V72KzdukVJBbu5b1SCkb45yUyuOdTMGBv8t+cy71bTbGJKgvCMX3ab097E9MPyuprPByZOOBUWKmizqTjsz6G2ILgwAp6/OSiPRudLdBOOJi/po/ZXBGJWVGZOOPKUcBSUtBRlp0AgAjqjQKuRSDQiSpU6VsJ0LBfFTB1PE4pScZtK1fF8YptFmV5uOuGEE17PFFCIdVFsc8JFx/2cxHzQs85jm2g0JyiuM62/++67X9RIDbPlcpFGfeqnDtEL5PRUWANtYzPn002vplvRdrmO5/C2y3hdegI6T2I65u6ZlUoK2Lhx41ey2JNInDsHHXTQS/JoCLF/x4eIJbS1QCTOidZNzv5Vga7R2TewiFvqOvRemOr1+XJAmPigWL3n/xkUk7xe37VsomFRJ74zFZW/pCrn2lJSh4PGIIAAAggggAACCCCAAAIIFFvgyqH1SppYWexm5KR+z7GvdNq4V4znP6Dbo20yXSsWOtXdsOBsJV8c5BSb0yDvARM7Kszf37Os3ZunXw0enddHRZcJWTauNDfzy952aFh0E468Bpe2N5ojA0YI88o0wlHg1N3ctKpbYBQBCEREoFWmnjpIhquDom+pt11t/JiSo47UL3ifK2Zb1Y4LXOtXZ9VTdsQG1/h8xUWxzdZizJgx/TZv3uw8uoD2047KwpRGQOeivcXcXfah99J4vfdvl1llmvBWixV3SqsFSS90nj+g9U6JeIo7XHV/WO/jl5KKYLbEBJSk9i/dmseOaHWpa9N0bCdplKNZGuXI5YtVS7FROXdmzZrVqNFOnlGjT3D0sLeB/H+OsYUIqw9RSa8QsTkPjco5kfMdV4H5ukbno62FKLNnz55vrl+/vk51dXWs70xdgyp1DcrVHycCxsBt3SolSBX1+x7fmVofjxSvInMdTNH2di3i2tIuPjZGAAEEEEAAAQQQQAABBBDoKAJlZoHuDDUs8rvjm4tNzL/GxLzgv0X5ZbcogegNExthRxIPnuLNVwQH5SGizFuQh1J3LdIz68z0sf/YdQVL0gp4/prAEY483Sos9mxlYZLG0rY0uxWef0jg/hnvNXNuwA/0PzrqTfNUdZ3Kyvy37HfW7quG/ie7xrIVAqUl0CrhSJ3EmUYuKamW6zY1E9Sgot2OaejQocfq9lRHhEB5MkRsXkKj2OYExJYtW+yF13nq2rVr0b2dG+sQOHjw4PP1/rS3aMk4KaZ+xYoVv8wY1GalEn7mq3xP27omaXVXR27vVMkk6mRdrvem8/tSiU5fVHO+1aZJvCwxAR3XH+i4XqhmtfrMSNdMnUt9N2zY8G2tvyZdTNvlETt3nlD7nRKOZPExXXsPXbp06Qtt97kYr5XE877a5DT6iuIOLUYbE3VG6ZyIyjU6YRu1Z5s4pMTH1TonB7q0XXG9lKA0RrF/dIkPilF5HwuKSV6vc/fN5NeFnu/s35mCvKN0HeTaEnQ0WY8AAggggAACCCCAAAIIIIBAFgK+V6vRfn6p2x45/b07ixoKs4kd5buu5kxVdl9ghf32qTHvrXX78Xds4X6mrrEYd6hoNPHK2sB9IaA4Avt2fcW8uVU/zNSt+dJN9j3V9IIdtOBP6UJKdrlvPu3QtuAEIZuQNLlaA6b4me9+4Xmnqb7g8hwaRQgCxRYoSzRg5MiRtgNySOJ1qT+rs+BiJT2Ut7ed6kTql00Z6ny/IOR2toM6J1MU25yDHXdOONK50Xz88ce/k4M6S6YIHfOL9fhJ0EMN/sWIESOcR4JK7KBNOpLbhsTroGd1Zu6XKqZHjx5/1vLNqdalWqb9uUqdyINTrQuz7JJLLumucu5VYscnw2xHrJuAHYVK54d+AeE+6dh+ffvnitNGUTp3ZPG4005tD9LnhR3lKJtpj2w2yrSNjsv/Mq1vsy6rhCP59GhTTlYvo3ROyDUS1+isDsS2jXq2Y9ucbCrjB0MW9Cs7il7IbXYJ13fNbjqnQyUcqZA3dimofQvC+neW70xhXVqOQpSug53g2tK+dwZbI4AAAggggAACCCCAAAIIIJCNwIyx72mzFdlsWnLbeI53JrjqlK1m2rhHnNpf3/h5xbW7/9WpruQgzyw3M4eH+ft18tbM51vA3o7QmFcCq2mOnxUYU4oBvh/cbs8879R03/w9MM6PuyQ4BRZDAAKlILAj4aihoeFCNagiRKPuUgfMkBw/VrvWrz/A77tp06ZBrvEZ4oaqQ2pEhvW7rFJiw8dV/5d2WZF+QWNlZeU96VeHXhPFNofeyeQNNFpAl+TXmeZ1bMofe+yxMKNPmWHDhh2h7T6aqdwir3vNtf76+vqBrrGJOL2PtfsaTtNxUgLF1lShdhQKlbUo1bo0yzwtnzN8+PD906wPXKwEq93eeeedu9X+T2vUsYU6lh8J3IiA0AK6hl2vY9sQYsPuOhedRziK0rlTVVW1RBZxVwudm1/T58xxrvE2TvHjtd2nQmxj30suU5j/sJ2qduzlUmgiRp+Pl6rdH0+8DnqWY9p2R+mc0H5G4hrd5njYW2s6TTqm++hcqHIKzlOQ3ne36HSx/6l1nfpoFL0a+xnhukGqOI2UNEv7v3uqdWmWrV+yZInL+yxv/hH/zpQ3l6Tj5XJ8EuFFvQ6qEVG8tiTseEYAAQQQQAABBBBAAAEEEECghAW835Vw49yb5vtjTWxlTn4A2lJpzFe/sWcTjooxdYxjUgy5QtXpmUcdqgpO3HEopKAhU6rtDziPCqzTM255DGVecMKRcRpRKbBJBCBQCgI7Eo7UmRLqdmrl5eU/W758+bJcPtSG2WFQ1JE0IUx8uliV8zvdssDp1+vqTLUXHJs85PwBrg6y5YsXL/5vuvqzWR7FNmezn4ltlOAS6vYkSjy5ILFt0LMdhUXx8xXXPSg2sV7natpO8kRMLp91Dj3uWp5iQ4/+pY7kXtruMJc6FBc/8MADMyUnTVM5GlbRbZLlno2NjfepDae7bbEzSu/H05TU8qjKOGP70j46lveorA/sjGIuFwK6hr2qcn4TsqyJIUfcisS5s2jRojd1zt0XwqK3rtkrbGKjyzaDBg06RfGzXGKziHHLwFfB2sfd1Y4bXevQ5+hQbfML13jHuEicExG7RrfQ61i973gMbJinz+GijiC3/Rr0sxBttufwMUqor9Hod0eH2c7G2lE09RkzRbMXh9zW6T7z+fSP8nemfLokHcfIXAejeG1JcmYWAQQQQAABBBBAAAEEEEAAgdIVOOjAxcbz3i7dBjq3rLtpWDfeOToosL52qP6odkBQWB7Wv2Wq9rg7D+VSZG4FHEbJ8k8wsWV9c1ttnktzu52aMZVlq5xa4vkuiUn7mGsXhP67tVP9BCFQYIGWhCN1zh+nP/CHGd3ljaVLl7q9qULskH69XqNw5182K3aUOnDD/Oo8ZWu073upU/VBdZZ+KdMv4dXxdLwKuFfxoS6Uir8tZcXtWBjFNrdjd01FRUWmBJddilYHzXd0PANHB7G34Kqrq3tSnkfuUkjmBQUd6UEJfva90Zi5SdvWal8GakSGn7rEJmLUOTlJ2+1IQEwsT/WsuFdmzZqVti1KQnxW/vNSbZtumco8XG34k47ZbTom+6SLs8tjsViZTTSysdruIS36SHK8ln1A7+dlo0eP7pO8nPn2C+gaPV2l1LmWpGNRqc7+77vGR+zc+YPrftk4WbQk1m3/HEm56fZbA35d75+Vim/3Z1uqSlT2X1ItT7dM7bhUbf6Jki96p4vRe7a/Ym7W+87+h9A5cTNdecnLo3JOROkanfBVm9cl5h2f/18JJHPaa9B6x/a2hOkcPluJqH/XOXqPHgODttVnTIU+Xyboc/Sf2tYmvIWa5HqHywb59I/yd6Z8uiSOS5Sug/KIzPe/hC/PCCCAAAIIIIAAAggggAACCERC4IoTG41nfhWJtgY1Mh5uQInMxcWvyLw+T2s980sTGximfzhPDaHYjAK+Ce5f8E2ZqducuyS4jA3K1Ur/8sCSPO81ExuzJjDOBlw/1o4E9VZgbGPz2MAYAhCIgEDLLdTUSXhpyLZW64/1ziOYuJZtRwFSZ9BKdfCc5bKN4qo0Msr5iv2lS3xATDc5/FyjpUxTG2pV9ku6JcXr2sbT8v56HqhloUdgkdO7vXr1WhRQd7aro9jmrPZVCW5v6bg8q2NgR5gKnBRXrqAVGinkNzqOPxkwYMBL6kRssskqq1at2l/LTtVx/aI6IbMasUHHtVtgI3IYYG/Pov1fqv0a5VjslxS/W5cuXabffffdL6bbxiY46HZk31S5k9PFtF2ufZ/bdlmK1z9Q3LjtxyHF6tSLdEwu0uNctf0FRTy7/fFvldVHZdlEpIN0/M7Wcz+91lPqSeuO2rJly0J1jg+65557wtyCJ3WBLG0RsCP76D1lr7ffCEFykRJDf6hz+B+O20Ti3FHyVa0+L+y9vvdw3C8btp/OzSdk+KDmV+q8flUPX+f8/np9iN6LY7W+pw3M16TO67/ouheqeLXp60q+uFDvy2Vqr72erNWyPfW8j56PV3mnaT6fo76V/DkRwWu0fsDlrQ11IhhzhM7Vf9vzQNu9ru036rm7ltnb7t27YsWK34csL3S4EtDW6f0zUxvOCLuxztXB2mawtl+vttvvd/Zhb1dlHXbXevtd76DVq1cfpPls34dv9ujR436VEzjl0z/K35ny6ZI4KFG6Dkbx2pJw5hkBBBBAAAEEEEAAAQQQQACBkhfwu/3ceFuu1v0aupZ8WzM20DvdTK3ub6aNeyVjWNDKqQsOMM1NQ4LC8rB+q6mqyvXI+XloJkWaGWMfN1Oq39B7xvZppJ88f5Ju9ff7SCSRTakeaOK+7eMImPzagICdq20OxaRq5Qb4E3cuTDHn+VeaGxbeZK4eZf/WzoRAZAUqJk6c2GXNmjUXhtkD/aHeJeEgTJHJsbZsp4Qju5E6JiboKRcJR7Y4O9nEhs/YGXWi2ad2TSrrmnnz5m1tVyHBG0exzcF7tWuEPTe+v+vi1Etkb0fsuULH8QolqTSpk3StOhL31rLK9h5blV3QhCO7h0qSmqJRgIZqtot9HTSpjROUkGdHJ1mq94m97dirKuN1PffWY38tO1QJDhdrPtRIKtrulqC67agkqvdqxTnfjimpzC5qk00s25FcptdJq51nPymv25Rkdp4e7X8zO1fbsQO7du16g0YFs1+SnEay0bErU0LKNMU7JctF5dxRguwWnePXaP+y+fw5XR6n2/PaPhJT8nxiWa6fbSKCEi6eULknhCzbJvldWog2tm1XVM6JKF2jrfH/b+9OwOwoy0QB/9XppMMm3LAIOiqK+/KIgHjBi4pbBBIgHUCHEdEBxQ3Gq9dHkqC2Q0gyMzpelcuVGb3i4Kgg3QnrAy5XxxUVI9wZRUdm2BQEJEDYsvWp+1WSDoF096nqPufkVPLWQ3FOV/3rW8s5UN/5/5122ulfV65c+WAc09LBNZG2L7Kuv5Y3Pxfic2HMwNYnHs/J/r3rrrt+JgLg3hnlPGuCZRWfgbtG3k2fMZuXs3m/Nt9e5n04nBHf+YbLpO2Afy2/M3XAJdXtPli3e0uZ818aAgQIECBAgAABAgQIECDQFQKLj7wnzRuM5x35e7qiPRNuRJ6l4extkf3sCRdRZGw0To1/Fz/m7+ySpQhMmf2nzlaqtgkJFIE08wYj8CZ//7j58/TMtHrFyZHmi+Om64adjfxjpZrR0/ONUulGEmX5pRGYNX7AUZ5mpPvWnhFZimdoFgK1Fei5/fbbi19871WhB22ZTm2k/h133DFuVOWnVYsHQwfH6BkvGMnfTa/x4OmXhx566Be6qU3N2tLNbY5j/aVo3yPN+jDG/t7I/7RYp42xv+rmKtdM1bJHTR8j9fw6+v/pUXeOsTH62xPrrAiwOjtevxwBON+J90Px/nPxenq8Vgo2imq+fPXVV/92jOoetzmCBD4VG77+uI0d/iO8Drrhhhuq9rHDraxXdTHK0V3hem6VVsd5dnRMUXRI2Tx1OXcOOeSQfwiLX5btVxelq3Qf6YZ21+GcqNs9emNgzI+64fhWaUMRxB2B76+Oa+83VfJ1IO0lcZ4Olq2n3f5x363ld6Z2u2x2fGpzH6zbvWUzY28JECBAgAABAgQIECBAgED3C/SlRTG0wbYwS8JJk8K+uJg1pHHKpMqYSOYsrUp9U+MYWOojkF1Sqq15mh+jHPWWSru1Ei0YfFVU/Zrm1ceI+QvnVPt/6fvs+J0YNeXepmVn6YMxylHpHwU3LU8CAltBoCeCDooIwypLW6ZTG2nA0qVL742HSN8Z+bvMa4yeUbUPZYqdbJp18Yvk02s2skpXtzmma7k9DkpXRHnGOfqMyZ4gE8kf0/MNRN0/mEjeFuS5LR7yFpG2pZeYduqUaO8NpTO0MGHU+6do78zintLCYhUVAhEY+nfhW2mIx/isqTQFUh3OneL+Hg7vC5Jqc5Rt5bMoAmEvinYX99NaLXU4J+p2j44T4Ku1Ogk2NjYCMH4f37GK/xi8vhvaH9fTb+Pz5r0TaEvb/Gv+naltLiPHqG73wRreW0aovRIgQIAAAQIECBAgQIAAge4WGJj7+wg4+nx3N7JM6/LnxMgzryyTctQ0Nyyd1XSarFEzTnJjHjPYDBxzxyRLkb2TAov7/yWq+1XzKvNnpVUr3tU83VZKcf51U1Mj/V2p2rM8pl+M0Z2qLGccuTplqflUgcUoR/cP/48qRUtLoNsEiimnZldpVDzgqTZkWJXCH0t70WNvm7+LX3GfdPzxx09pnrJzKcLpnfFArFq0Y+eaN2pNdWhzPHD5ZDzY+9moHejsxqcV0xF2tsqUipEd4jjNinqv63Dd9/b29s6Nc3pllXqLaafimBUjUVxdJV8L0j4cdR4Z06b8ewvKUsQTBDYGcf3PJ2xu9uerY5Sjmc0Sjeyvy7kTI379JM61v4x2V/uyOdLRrfAagVLros3vbmObH2pHt+pwTtTtHh2jdH0tjtXN7The7S4zPo/uieDHw+Nc/nG762pS/vXRjlcV7WmSbovd7fav63emdrsUB6Ju98G63Vu2ONltIECAAAECBAgQIECAAAEC3SyQFVORZfd1cxNLtS1PxbRqE1uGG6dNLOMkcmVpRUrTw95SO4Gs5zOl2pzln0rzBw8olbbTiW659VMpZlEqUe3DKZ9+fol0WyaZFrOFFKN4NVvyxoJwOrxZMvsJdKtAMd3StAqN+0MngmgisGFZtGlthXY9ZeXKlW+okH7zpMWv4x/YfEML3s+Lh9AXtKCcsYqoY5vH6kul7fHAZU1kOCIeMJaIni1fdJQ3HOv/KpujuG5uu+22g8qmb2W6Iugn2joz1itbWe5YZUU9t0+dOvWwCN6ZUJBTHLMH4qHnrCjn78eqo8XbfxEjTRwc1+DPW1yu4jYT2GGHHYrjef9mm5q+jetmUaxZ04QbE9Tl3IlplC6MQMAPle1XmXRxvRTBfTeWSTuRNHF9XBVt/puJ5B0vT7T7x1Fu2361UIdzok736CLoIo7XB+KY1iZgbvPzb9myZffvtddeb4zz7m9j+6Ob7+vQ+28WQU8RhHn3ROprt39dvzO122XkWNXtPline8uIsVcCBAgQIECAAAECBAgQIFALgcX998boJQO1aOt4jczSCTGF1fTxkoy6b2DpvhEUUfrHwqOWMZGNefp4WjKr/oFeE+l73fPsufdXIkiv+f8TzdP0GEVoMA1cPaOrujx/6C0RbHR6qTZl2T9O+Dwd6C+MLixRz5Roz0VpwbKnlUgrCYGuEyhGOKqytHU6tZGGXHnllcUHzLdG/i75+vaS6R6XLB5SXR8BTq+JjXc9bsfE/ng0yjs9prFYMrHs5XLVsc3lelYuVTzcXxEP+F4bqeMDrSUPSVdFEMRx8Yv6M6K85h+QG5sZU0QVbdgqS2EQ66x4UPy+aEDbHrLGuXZhTGP08rgmJxX4EA89h6O9H4r2zo32/q5NaGujvR+PaVL+azyU+3Wb6lDsRoHiQX8cz09VAYnr7IAY5ej4Knnqcu7Eg+tPh8e74xx8pEr/xkh7d5T1mijrX8fYP9rmygEju+yyy1lRz+dGK2wi26K934vgwiIYsq0j5tThnKjTPTrO3cviPPjYRI55N+S58MILHw7vj0ybNu05ce59IdbhDrTrD1HHW+L73sziXjiZ+trtX5yLdfzO1G6XkWNWt/tgne4tI8ZeCRAgQIAAAQIECBAgQIBALQReNqf4Qfova9HWsRqZ57vFFFbHjLV7zO1r8lPjSVvV58VjFlduR/aLdMDc/10urVRdJ/DBQ+O5ZPbxcu3K902rHvpKGsg7fI6N0bqzhl6Q8sY/jrH38ZuLUbj6dprcKFxTYtq2LBWDaYy/5GnP1BgeTJ+9qm/8hPYS6D6BShd3PJDqxHRq65WirourcMWD7GOOPfbY3arkGUkbI7cUQUeviIdUl45sm8BrMfrLAfEg4NwJ5K2cpY5trtzJcTIUownEg76T4rgdEsl+Ok7SZru+H6P3HBBlLYtf1DfiHKgyatApkafSNdSsMVX3xwO588LgBUXQQLS9FYEO65sQZf0gyjwszue3XXbZZa0IxltfbrR3KAKCXhh/FMNzFg9sW7EUAVdfD4eDo71/XYyM0IpCldFcIB7wF8Nm3ts85eNSnB3HqPdxW0r8UYdzJ9pYDKv50rh+JjPFUzHy0CsiaK7t/3FbBO5Em8+I+t4RbX6wxGEYK8kDkf/0CDZ6fZT5UIwwVvWcGKvccbfX5JyoxT06LBcGdnFfLu6ntVyuuOKKP8RnwDvj++CL43z8Rqyr29CR38X1Mn/XXXd9fnxvuKhV5bfbv67fmdrtUhy/ut4Hw6YW95ZWXSPKIUCAAAECBAgQIECAAAECbRc4IX7E1pOdGvV04sdsbexOfnKlwge+25sajVMq5Zls4ixbl3p6Tk2FuaW+AgfMKYJ2flWyA0ekNUOf2+pBR/OGnpuGG1dGgN3OpdqdxQ91B960olTasRItPO53MYJauR/v5/nL052P/FMa+FWV2anGqrm1288aem06c+hvW1uo0rYVgSrBEh2ZTm0Edvr06ZfGw6LmEX8jGWKiz1WrVr35sT+rvYsAnlvjQdWx8SDpTVHv92Jt+kG3Mc1V8frmCKI4JB4+/aZarZNLXcc2T67HW+YOg5/GcSuCjt4a639umWLULcVIIN+P9a2R9zWbj94Tx/KKUXOMvvGZ11577YGj7+rc1uI8iAdPZ8QIBk+P9i+Imn8U69qqLYi8N0WexRFE8txweVWU+cOqZZRJXwQExbXyD095ylOeHYEJx0e9X4r1j2XybpYmjzxFUNSpUcbeUd6fh8P1m+33tgMCEYz2YByHSl8wIhjguXHdzJ5I8+pw7sS1c1OMlnZYuBwX62XRz6bXYqRrRLriup0d5/JRce3dEu87tkR9F8QUeU+P6+mjUWmVAMObI88n4/P6edHvc4sH90WjI4hzcl/AK/S8DudEXe7RxX057v8vDf7z45wsHcAaaYvAnirnTYUjXD1p9OM3cT6eEH2ZEefnUbEWAbn/Xr2k9TmKz5rfxvr5KOfQKPu5cb0sLgLrJljemNk64V/H70ydcCkOSh3vg3W5t4x50ttBgAABAgQIECBAgAABAgS6TWDR3OURGLC425pVsT1vTANX7l06z9p7ixGRyqcvXfB4CbNFadEcz3PGI6rDviJgrLcnZo7JimeuzZdG/t60eiimV7t8x+aJ25BiwbJDY9KcH0ew0TNLlZ5ly9P+cz5fKm2zRNOmLYx7y63Nkq3fn8fUiKtv/HaaN7R7qfTtTlTcT+YN/nNa1/hO+D2/3dUpv54CWT2bPX6rZ86ceVE81D5h/FQb9sZDpAviwdQ7nph29uzZe6xevfro2P+iWJ8c5e0d63C8/32k/X283hZ/XxV573xi3on8Xcc2T6Sf7c5zxBFH7LdxqrPioekecYz2jGMVL/md8bCwCGq5OUbCubQYCaHdbdma5Z900kk73XPPPf8tLA6K/u8Rbdk9DPaI97vEaxEkUkwBc3+83hF/XxfBSj+PERA6MirJaC7Rhiym2npZvL4i9u+12Vocv2Lkldvj9faR1who+F0Eu9wRf1u2c4FuP3finrRntPGoOEz7xutT4/XPYu2Ltbgf3RXbbox70mXx4HiLoLuKnwsXx+fRhINuoy3rl8Jz1qxZLxoeHn5VvH9JbCy+1M4otsdSBJXcFa93xPrtTozCtL5RFf9VtLXb7yfdfo8+/vjjd37wwQdfEPTFZ+p+cbz3i/f7xro6fP8Ufxdr8flx7T777PPzCy64YFXs6+olvtc9c926dQdGm9d/xmx8Lb7fFZ+NRYD7A/G++FwsRuwqvuctj8+a5UVgZac71in/un1n6pRLnAe1vQ92+72l09eS+ggQIECAAAECBAgQIECAQGWBYsSf1St+lPL84Mp5uyVD1vPhtLj/k6WaM2/wm9HXN5RK25JE2bVp+ozD0sDh7Zup4sylB8ZAVcWsNGMvWXZ+Wjz33WMn6PCeeYNfiOMw/khTvT0vTAv7b+xwy5pXN2/w09H2DzRPuDFFlv0s9WWz00D/3aXzTDbhvKH+lBr/HMFG00sVlaX4wWnPgXEdTfSHrFtWs2DomBhdadmWO8bYkmX/EQE+s9Li434zRor2br44n5KWD74nKilmR9h1Q2XZ5WnJ3KNLVTx/8EOpkY9/H5qSjk7nHHd5qfJalWj+4NujXV8at7ienvenRf3FNJv1Wc669Hlp3dom50p2Qxy//dvRqd52FLotlHn55Zf/Kfrxf+rUlzq2udW+8QA8bsCpWLfr5cILL3w4AK7ZuHa9RTzYLSKgl29cu769Gtg9At1+7sQ96Z7QuqB7xMZvyUbPf4tUxVrLpdvPiQK12+/RG0fw+Xk0tVi3iSW+I90cHSnWrl865V+370ydcqnzfbDb7y1df/FpIAECBAgQIECAAAECBAgQKAJhzlp6YgQGXBdBFLvVEiRvvC3aPf6D/qJjZw4+KwIwXt+5Pmb3pd6pJ7Y12KhznVHTiMA+O5yZ7nz09XG9vHhk07ivRTDf6vzaNH/pO2Okqxg1p43LwHd3TmtWzE954yNxrleY9SkCTloZbFR08Zz+S9O8S74c7Ti5VI/zfL8YFekn6cyl702Lj/16vC+eo7Z/KaZzW/Xb49PyoQ9HZcXgHhYCTQUqXFxNy5KAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAEC9RRYOCd+1J6dVHqqqO7r5UvS/MEDSjTrXTGCSodmwolgiSx/a1p4dC1+EFjCTpIRgTOOXJ2m9B6XsrRiZFPT12Jas8ZwTBs2eGWat+yFTdNXTTCQ90TZp6RV9/4uRrOZVynYKMvOjWCjL1etslT6vt1jVK3sF6XSFonWBz0OfzX68osIPHpj6XwTSTj/0idHQNTH0qobb43RoL4SlQs2mojjdppHwNF2euB1mwABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBJwgs7r8itix4wtb6/NnIilGOxl7Ov25q7HzH2AlavSebF1NDXdXqUpXXJQILj/lt6snmRNDRmkotyvMjU77u/0VAzefT/KFyIySNV8HA5TumBZfMTauGlkewzhci6d7jJd9yXzaY+vr/asvtLdoycPiqNGVK4VTMjFFleVlME3hNjEr2nRgZ6nVpw/VbJf/oaYsRoM4celP4/1PK194WgVmfiIQVzUYv2tbtS8CUatvX8dZbAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgTGE1gyd3E8iN8nAhdOHy9ZV+7LGidGUMKH02kHrR21fbfePidGMNlr1H0t39jzmbSk/29aXuzkCtwlLRh8xuSKKJl76g73pYEjV5ZMPXay4cZr0ryh/cZO0NI998YoPz+pVOI5c78fo/C8PQJjLox8UyrknRLX2Gnr1zMHb4lgnMtj+rDL07Tn/UsaeFHzAKaBK/dOq1fPjlF5jo7XmNotTY9zu0L1I0mz/5umz3hrGsgaI1va8nrOsbenBUP9MW3j1VH+TtXqyF8bI0O9Nt1yy8oYjejbMVrSValn2tXpnNl/KFXO3/94h7Tij4ekRopyGoen1SsODqveCXGVqlCi7UVAwNH2cqT1kwABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBcgJ9/R9Iq4f2imCIN5fL0CWp8rRnuuXWI6I1l43aokbjtFG3t3pjlr6WFs3572lJqwueZHl5fmIaTidOspRy2RuPzIuEkxfI03kRVFOuzsmn+l4UcXjlYpbM+VqMwDMcQTExJVcqRtGquOT7RvDL6euD/FbduDaCau6OoJq7opA/xlq8PhTrnrF/7whKKkbi2TutenS3eJ3scmkEG70lFSMQdWI5p/+HacGyN6bhdcWoX7tWrjJPT4o8/REsFIFLq1MERt4fJndFsNbdMUvi3etfNxQaVqkILNwztu2V7r5zRuTJNtWXTyQwa1NubwhsEhBwtInCGwIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECIRAMdrJwK/ellbfuEc8uH9dvUzyk6O9WwYcnXXJc9K6CQSTVO18ln0r7fuMkyMwRFRDVbs6p1805+IYiemRCI76RlwzMdrQhJepkf+pESAT6yhLq4JlsuxL6WX970wnZMOj1NK+Tecc++MYEep1KWtcE8FCu0+qojwvgq52C6/nhdf6f7Yoz1W4BYkNrRPoaV1RSiJAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgMA2IlBM69S3+7Ex0kpMYVSrZVYauDpGNHnCMpze9bhRTp6wuyV/ZumbacbOc8ac0q0llSikawUW91+ReqceGtfMLV3bxpTF0EDZ+9LiuX/Z8WCjEZQlc36RpmSHxehDvx7Z5JVAHQUEHNXxqGkzAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQLtFxg4/KE0/flHxWg9F7W/shbVkKdpac0jf/640j57VV/MqPT2x21r9R/FNGr77jsrfXjmw60uWnk1Ejj7mF+m6TsdGNdMMW1Ydy1Zuin1pEPTkrnnbfWGLey/Me35lIPC6fyt3pbxG7A2dv9k/CT2bq8CAo621yOv3wQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQINBdYP9JR/4kRGHBu88RdkiJfP63aY425Y3V/jG60x2MbWvwuS59Ni+b+hZGNWuxa1+IG3rQiRhA6KvVMOSlG8blnq3cjS6tiVKOBGLHsJXGeLt/q7RlpwAcPfTSc3p2mpOO6wmmkXcVrlq2L9Yupd9rzIkBr8ea7vCcwIiDgaETCKwECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBEYTGMgaERhweuw6K57E56Ml6aptef7ydNbQCza1KWuctul9S9+ERZbmpcXH/VUEJ3S/S0v7rrCmAovmfCX17fz8ODc+F+dJBP10eNkQNPPVNGXaCyNo5hNp4PDOt6FMl885bjCCoZ4VTh+N5A+UydK2NCOBRlOmPjfueaemhUff3La6FFx7AQFHtT+EOkCAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAQEcElhx3TgQFHB11bd2ggDKdHU5vW59s3iXPT3n+6jJZKqXJsvtjeqrZEWy0pFI+ibcvgQ2jHZ2R+nZ4ZgQdfTLWle0HyB6M6/Tc1NfznAia+YtaBM0U0zcunrswTd85Ao964prK/tR+p401ZKkR774Xx+a9Kev9M4FGHZOvfUW9te+BDhAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQKBTAov7r0hnLT0wDTe+GoE8B3eq2ur1NE5KA/mCtGrwXdXzNsmRpZ+mPJ0YgQn/2SSl3QQ2CAwc9cd48+E08N2PplX3zY6Bwt4a0/y9Mc6j6S0iejiCdK6OoJmvpz33uTIV05XVcSkCtFKMGlY4rbnv8LjHvDmc5oTTjJZ2J0sPRXk/jXUwZVOH0uJj7mpp+QrbLgQEHG0Xh1knCRAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBBomcDCOf8RAQGvjICAgdRonBnlTmlZ2a0qKE9PTWsHj4qhlVryAAAbz0lEQVQAjJMjWKE1SzHdUkpLUt+MYnqq4n33LFl+S4wMc3L3NCgtb96W7IupJ/t+83QdStHIiqCg9i4bpjX7RlTyjfTZq/rSnWsOTvm6V8WIRAfFtmdHgM1+8brDuI3IsntjfwS75TdFkNHPUk/vD9PUJ13fdefkuJ1osnPD9fWtSPWtdP5170k337p/jCj20vDZP+XZS+O6fnG83238UoopD/MHI30RxPSrONeuj7GMbki9jevT2XNvCvNW3Rkea0bW84OUGvMf2zDKu+HeG0fZ2uZNvXE9rhu/XY3s2jY3ovXF9/bdk9Y16VdP1rZgsqz1Pdr6Jc6cOfOiPM9PKNOSLMsuuOaaa95RJm0709Sxze30UDYBAgS2d4GKnwsXx2dZRLhbCBAgQIAAAQIECBAgQIAAAQIECBAgQKDjAvMHD4gH/1+MoJ79O153swqzeNCc509ulqzU/ixbnnp7T01nH/PLUuklIjARgTzP0ieW7pnWZbukRs9OKR/eKfVMWZuy4YfjXH4kTd3hvjRwZAemZZtI4zuc5+J8Slp+5ZPS9LW7pjU9T0rZuh0juOihNG3qyjR9+gPpI69f2Zagog53U3XdK2CEo+49NlpGgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgEC3CyyauzxGO3p5WnPv+1Ij+3iMuvJfuqbJLQk2yu6LkVU+nvbvPy+dkA13Td80ZNsU2DDqzt3RuWK1jCew4Xq8L5IU65ZLMfaahUAbBbbJgKOenp5PhNl5ZdxiJKT2DwtXoiF1bHOJbklCgAABAhMUqPK5EFXcM8FqZCNAgAABAgQIECBAgAABAgQIECBAgACBVghsmP7oM2ne0Fci4OhjMcrIafHa14qit14Z2eqYrurzMXXT2WlRfzGFlYUAAQIECGwS2CanVNvUO28IECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECDQaYEFy56W8nXzY5q1t8c6vdPVT6q+LK2KQKMvpb60KA3M/f2kypKZAAECBLZZAQFH2+yh1TECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBLaqwMDQXmlN/v7USMWIR3tt1bY0qzzL7opAo/NTmn5uWnykkfWbedlPgACB7VxAwNF2fgLoPgECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECbRY4/7qp6bZbjk7D6ZSUZW9Ied7b5hrLFr822vOtCDT6Ytr36Zen0w5aWzajdAQIECCwfQsIONq+j7/eEyBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECDQSYF5Q7tHdf0RdHRMytLh8bpjJ6uPuh6Oer8bgUaXpmk7DaWBN63ocP2qI0CAAIFtQEDA0TZwEHWBAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIEaCnz2qr50x6OHRfDPYSk1Xhk9eHnK05Na3JMHYgSjn6ee9KOUen6Q9u77YTrjyNUtrkNxBAgQILCdCQg42s4OuO4SIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQINDFAgNL903r1r04Dfc8O1r5jAhGenrKG3tG0NCM+Hu3CEjqS1k+bX0P8mxNjFZUBA/dn1K+ImU998SISbfF6y0RwHRT7Pu3dM7cW9en9S8CBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIFmAlk6c+jdKeU9zRLaT4AAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgd6U5Z9Led6LggABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAs0EjGzUTMh+AgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQ2CQg42kThDQECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECzQQEHDUTsp8AAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgU0CAo42UXhDgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgEAzgd6U8vNSlqY0S2g/AQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBDYZgT+P5g662tPqBpLAAAAAElFTkSuQmCC",
    _responseSummaryLandscapeHeader:
      "data:image/png;base64,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",
    _reviewFormHeader:
      "data:image/png;base64,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",
    _rolesHeader:
      "data:image/png;base64,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",
    _pdfHeader:
      "data:image/jpeg;base64,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"
  });
})();

(function () {

  angular.module('nvc')
  .constant('GROUNDLEASED', [
    'Yes',
    'No'
  ])

})();

angular.module("nvc")
.constant("EnvironmentConfig", {"API_BASE":"https://dev.crevelocity.com/v1/","API_BASE_LOCAL":"http://localhost:8080/nvc/v1/","FUTURE_VALUATIONS":true,"FIREBASE":{"apiKey":"AIzaSyCF1aN3dsxUL2f0x9T51IKCdJjWbQES0HE","authDomain":"nvc-dev.firebaseapp.com","databaseURL":"https://nvc-dev.firebaseio.com","storageBucket":"nvc-dev.appspot.com"}});

(function () {

  angular.module('nvc')
  .constant('ASSETREQUIREDAPPRAISERS', [
    'External Only',
    'Internal & External'
  ])

})();

(function () {

  angular.module('nvc')
  .constant('ASSETCOUNTRIES', [
    'United States',
    'Mexico'
  ])

})();

(function () {

  angular.module('nvc')
  .constant('VERSION', '0.23.1')
  .constant('LOCALES', {
    'locales': {
      'en': 'English',
      'es': 'Español'
    },
    'localesMap': {
      'en-AU': 'en',
      'en-BZ': 'en',
      'en-CA': 'en',
      'en-CB': 'en',
      'en-GB': 'en',
      'en-IE': 'en',
      'en-JM': 'en',
      'en-NZ': 'en',
      'en-PH': 'en',
      'en-SG': 'en',
      'en-TT': 'en',
      'en-UK': 'en',
      'en-US': 'en',
      'en-ZA': 'en',
      'en-ZW': 'en',
      'en_AU': 'en',
      'en_BZ': 'en',
      'en_CA': 'en',
      'en_CB': 'en',
      'en_GB': 'en',
      'en_IE': 'en',
      'en_JM': 'en',
      'en_NZ': 'en',
      'en_PH': 'en',
      'en_SG': 'en',
      'en_TT': 'en',
      'en_UK': 'en',
      'en_US': 'en',
      'en_ZA': 'en',
      'en_ZW': 'en',
      'es-AR': 'es',
      'es-BO': 'es',
      'es-CL': 'es',
      'es-CO': 'es',
      'es-CR': 'es',
      'es-DO': 'es',
      'es-EC': 'es',
      'es-ES': 'es',
      'es-GT': 'es',
      'es-HN': 'es',
      'es-MX': 'es',
      'es-NI': 'es',
      'es-PA': 'es',
      'es-PE': 'es',
      'es-PR': 'es',
      'es-PY': 'es',
      'es-SV': 'es',
      'es-UY': 'es',
      'es-VE': 'es',
      'es-145': 'es',
      'es_AR': 'es',
      'es_BO': 'es',
      'es_CL': 'es',
      'es_CO': 'es',
      'es_CR': 'es',
      'es_DO': 'es',
      'es_EC': 'es',
      'es_ES': 'es',
      'es_GT': 'es',
      'es_HN': 'es',
      'es_MX': 'es',
      'es_NI': 'es',
      'es_PA': 'es',
      'es_PE': 'es',
      'es_PR': 'es',
      'es_PY': 'es',
      'es_SV': 'es',
      'es_UY': 'es',
      'es_VE': 'es',
      'es_145': 'es'
    },
    'preferredLocale': 'en'
  })
  .constant('CONFIG', {
    fileVersionStarts: 1.00,
    fileVersionIncrement: 1.00
  })
  .constant('AssetRoleToUserRole', {
    AssetManager: 'AssetManagement',
    PrimaryAssetManager: 'AssetManagement',
    SecondaryAssetManager: 'AssetManagement',
    Appraiser: 'AssetAppraisal',
    PrimaryAssetAppraiser: 'AssetAppraisal',
    SecondaryAssetAppraiser: 'AssetAppraisal',
    Reviewer: 'AssetReview',
    PrimaryAssetReviewer: 'AssetReview',
    SecondaryAssetReviewer: 'AssetReview',
    PrimaryAssetAuditor: 'Audit',
    Admin: 'Admin',
    Administrator: 'Administrator'
  });

})();

(function () {

  angular
    .module('nvc')
    .run(navbarConfig);

  /** @Inject*/
  function navbarConfig(navigationHelper) {
    /**
     * add here all the states you want to appear on the sidenav
     */
    navigationHelper.init([
      {
        state: 'app.valuations',
        name: 'NAV_BAR.VALUATIONS',
        iconClass: 'icon icon-ic-valuations',
        allow: ['Admin', 'Audit', 'AssetManagement', 'AssetAppraisal', 'AssetReview', 'AssetManagerReadOnly']
      },
      {
        state: 'app.bidEngagement',
        name: 'NAV_BAR.BID_ENGAGEMENT',
        iconClass: 'icon icon-ic-bidengagement',
        allow: ['Admin'],
        children:[
          {
            state: 'app.bidEngagement.bidEngagementList',
            name: 'NAV_BAR.BID_ENGAGEMENT_LIST',
            allow: ['Admin']
          },
          {
            state: 'app.bidEngagement.addRfp.selectAssets',
            name: 'NAV_BAR.CREATE_NEW_RFP',
            allow: ['Admin']
          },
          {
            state: 'app.bidEngagement.engagementLetters',
            name: 'NAV_BAR.ENGAGEMENT_LETTERS',
            allow: ['Admin']
          }
        ]
      },
      {
        state: 'app.requests',
        name: 'NAV_BAR.REQUESTS',
        iconClass: 'icon icon-ic-requests',
        allow: ['AssetAppraisal', 'AssetManagement', 'AssetManagerReadOnly'],
        children:[
          {
            state: 'app.requests.allRequests',
            name: 'NAV_BAR.ALL_REQUESTS',
            allow: ['AssetAppraisal']
          },
          {
            state: 'app.requests.engagementLetters',
            name: 'NAV_BAR.ENGAGEMENT_LETTERS',
            allow: ['AssetAppraisal', 'AssetManagement', 'AssetManagerReadOnly']
          }
        ]
      },
      {
        state: 'app.asset.all',
        name: 'NAV_BAR.ASSETS',
        iconClass: 'icon icon-ic-assets',
        allow: ['AssetAppraisal', 'AssetReview', 'Audit', 'AssetManagerReadOnly']
      },
      {
        state: 'app.asset',
        name: 'NAV_BAR.ASSETS',
        iconClass: 'icon icon-ic-assets',
        allow: ['Admin', 'AssetManagement'],
        children:[
          {
            state: 'app.asset.all',
            name: 'NAV_BAR.ALL_ASSETS',
            allow: ['Admin', 'Audit', 'AssetManagement', 'AssetReview']
          },
          {
            state: 'app.asset.addAsset',
            name: 'NAV_BAR.ADD_NEW_ASSET',
            allow: ['Admin', 'AssetManagement']
          },
          {
            state: 'app.asset.bidGroups',
            name: 'NAV_BAR.BID_GROUPS',
            allow: ['Admin']
          }
        ]
      },
      {
        state: 'app.manage',
        name: 'NAV_BAR.MANAGE',
        iconClass: 'icon icon-ic-manage',
        allow: ['Admin', 'Audit', 'AssetManagement', 'AssetAppraisal', 'AssetReview', 'AssetManagerReadOnly'],
        children: [
          {
            state: 'app.manage.clients',
            name: 'NAV_BAR.ASSET_MANAGEMENT_FIRMS',
            allow: ['Admin', 'Audit', 'AssetManagement', 'AssetReview', 'AssetManagerReadOnly']
          },
          {
            state: 'app.manage.reviewers',
            name: 'NAV_BAR.REVIEWERS_FIRMS',
            allow: ['Admin', 'Audit', 'AssetManagement', 'AssetReview', 'AssetManagerReadOnly']
          },
          {
            state: 'app.manage.appraisers',
            name: 'NAV_BAR.APPRAISAL_FIRMS',
            allow: ['Admin', 'AssetAppraisal', 'AssetReview']
          },
          {
            state: 'app.manage.auditors',
            name: 'NAV_BAR.AUDIT_FIRMS',
            allow: ['Admin', 'Audit', 'AssetReview', 'AssetManagement', 'AssetManagerReadOnly']
          },
          {
            state: 'app.manage.users',
            name: 'NAV_BAR.USERS',
            allow: ['Admin', 'Audit', 'AssetManagement', 'AssetAppraisal', 'AssetReview', 'AssetManagerReadOnly']
          },
          {
            state: 'app.manage.roles',
            name: 'NAV_BAR.ROLES',
            allow: ['Admin']
          }
        ]
      },
      {
        state: 'app.main',
        name: 'NAV_BAR.ANALYTICS',
        iconClass: 'icon icon-ic-analytics',
        allow: ['Admin', 'Audit', 'AssetManagement', 'AssetAppraisal', 'AssetReview', 'AssetManagerReadOnly']
      }
    ]);
  }

})();

(function () {

  angular
    .module('nvc')
    .config(languageConfig);

  /** @Inject*/
  function languageConfig($translateProvider, $logProvider, LOCALES, tmhDynamicLocaleProvider) {
    // Enable log
    $logProvider.debugEnabled(true);


    //Angular translate configuration, register your new translate files
    $translateProvider.useStaticFilesLoader({
      files: [
        //COMMONS
        {
          prefix: 'app/states/valuations/lang/',
          suffix: '.json'
        },
        {
          prefix: 'app/states/main/lang/',
          suffix: '.json'
        },
        {
          prefix: 'app/states/manage/roles/lang/',
          suffix: '.json'
        },
        {
          prefix: 'app/states/assets/lang/',
          suffix: '.json'
        },
        {
          prefix: 'app/states/assets/add-asset/lang/',
          suffix: '.json'
        },
        {
          prefix: 'app/states/common-lang/',
          suffix: '.json'
        },
        {
          prefix: 'app/states/reset-password/lang/',
          suffix: '.json'
        },
        {
          prefix: 'app/states/login/lang/',
          suffix: '.json'
        },
        {
          prefix: 'app/states/forgot-password/lang/',
          suffix: '.json'
        },
        //USERS
        {
          prefix: 'app/states/manage/users/lang/',
          suffix: '.json'
        },
        {
          prefix: 'app/states/manage/users/add-user/lang/',
          suffix: '.json'
        },
        {
          prefix: 'app/states/manage/users/edit-user/lang/',
          suffix: '.json'
        },
        {
          prefix: 'app/states/manage/users/user-details/lang/',
          suffix: '.json'
        },
        //MODALS
        {
          prefix: 'app/components/commons/messages/lang/',
          suffix: '.json'
        },
        {
          prefix: 'app/states/manage/clients/new-client/lang/',
          suffix: '.json'
        },
        {
          prefix: 'app/states/manage/add-contact/lang/',
          suffix: '.json'
        },
        {
          prefix: 'app/states/manage/companies/lang/',
          suffix: '.json'
        },
        {
          prefix: 'app/states/manage/appraisers/new-appraiser/lang/',
          suffix: '.json'
        },
        {
          prefix: 'app/states/manage/auditors/new-auditor/lang/',
          suffix: '.json'
        },
        {
          prefix: 'app/states/manage/reviewers/new-reviewer/lang/',
          suffix: '.json'
        },
        {
          prefix: 'app/components/commons/navigation/lang/',
          suffix: '.json'
        },
        {
          prefix: 'app/states/assets/asset-details/lang/',
          suffix: '.json'
        },
        {
          prefix: 'app/states/valuations/review/lang/',
          suffix: '.json'
        },
        {
          prefix: 'app/states/valuations/review/discussion/comment-states/lang/',
          suffix: '.json'
        },
        {
          prefix: 'app/states/valuations/review/discussion/lang/',
          suffix: '.json'
        }, {
          prefix: 'app/components/directives/td-image-upload/lang/',
          suffix: '.json'
        },
        {
          prefix: 'app/components/directives/td-file-upload/lang/',
          suffix: '.json'
        },
        {
          prefix: 'app/states/valuations/review/documents/lang/',
          suffix: '.json'
        },
        {
          prefix: 'app/states/valuations/review/documents-upload/lang/',
          suffix: '.json'
        },
        {
          prefix: 'app/states/assets/bid-groups/lang/',
          suffix: '.json'
        },
        {
          prefix: 'app/states/assets/bid-groups/add-bid-group/lang/',
          suffix: '.json'
        },
        {
          prefix: 'app/states/valuations/review/documents-history/lang/',
          suffix: '.json'
        },
        {
          prefix: 'app/states/assets/bid-groups/edit-bid-group/lang/',
          suffix: '.json'
        },
        {
          prefix: 'app/states/bid-engagement/bid-engagement-list/lang/',
          suffix: '.json'
        },
        {
          prefix: 'app/states/bid-engagement/add-rfp/lang/',
          suffix: '.json'
        },
        {
          prefix: 'app/states/bid-engagement/bid-summary/lang/',
          suffix: '.json'
        },
        {
          prefix: 'app/states/bid-engagement/assignment-summary/lang/',
          suffix: '.json'
        },
        {
          prefix: 'app/states/requests/engagement-letters/lang/',
          suffix: '.json'
        },
        {
          prefix: 'app/states/requests/all-requests/lang/',
          suffix: '.json'
        },
        {
          prefix: 'app/states/requests/response/lang/',
          suffix: '.json'
        },
        {
          prefix: 'app/states/requests/response-summary/lang/',
          suffix: '.json'
        }
      ]
    })
      .registerAvailableLanguageKeys(['en', 'es'], LOCALES.localesMap)
      .determinePreferredLanguage() // or use $translateProvider.preferredLanguage(LOCALES.preferredLocale);
      .fallbackLanguage(LOCALES.preferredLocale);

    $translateProvider.useLocalStorage();
    $translateProvider.useSanitizeValueStrategy('escape');
    tmhDynamicLocaleProvider.localeLocationPattern('bower_components/angular-i18n/angular-locale_{{locale}}.js');
  }

})();

(function(){
  'use strict';

  angular
  .module('nvc')
  .config(httpConfig);

  /** @Inject*/
  function httpConfig ($httpProvider){

    $httpProvider.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded';
    $httpProvider.defaults.useXDomain = true;

    $httpProvider.interceptors.push('httpInterceptor');


  }


})();

/**
 * INSPINIA - Responsive Admin Theme
 * 2.5
 *
 * Custom scripts
 */

angular.element(document).ready(function ($timeout) {


  // Full height of sidebar
  function fix_height() {
    var heightWithoutNavbar = angular.element("body > #wrapper").height() - 61;
    angular.element(".sidebard-panel").css("min-height", heightWithoutNavbar + "px");

    var navbarHeigh = angular.element('nav.navbar-default').height();
    var wrapperHeigh = angular.element('#page-wrapper').height();

    if(navbarHeigh > wrapperHeigh){
      angular.element('#page-wrapper').css("min-height", navbarHeigh + "px");
    }

    if(navbarHeigh < wrapperHeigh){
      angular.element('#page-wrapper').css("min-height", angular.element(window).height()  + "px");
    }

    if (angular.element('body').hasClass('fixed-nav')) {
      if (navbarHeigh > wrapperHeigh) {
        angular.element('#page-wrapper').css("min-height", navbarHeigh - 60 + "px");
      } else {
        angular.element('#page-wrapper').css("min-height", angular.element(window).height() - 60 + "px");
      }
    }

  }

  angular.element(window).bind("load resize scroll", function() {
    if(!angular.element("body").hasClass('body-small')) {
      fix_height();
    }
  });

  // Move right sidebar top after scroll
  angular.element(window).scroll(function(){
    if (angular.element(window).scrollTop() > 0 && !angular.element('body').hasClass('fixed-nav') ) {
      angular.element('#right-sidebar').addClass('sidebar-top');
    } else {
      angular.element('#right-sidebar').removeClass('sidebar-top');
    }
  });

  $timeout(function(){
    fix_height();
  });

  // Minimalize menu when screen is less than 768px
  angular.element(window).bind("load resize", function() {
    if (angular.element(document).width() < 1025) {
      angular.element('body').addClass('body-small')
    } else {
      angular.element('body').removeClass('body-small')
    }
  })

});

(function() {
  'use strict';

  angular
    .module('nvc')
    .run(runBlock);

  /** @ngInject */

  function runBlock($rootScope, $state, UserAccountService, localStorageService) {
    $rootScope.$state = $state;

    //renew token if it only have 5 days more
    var tokenExpirationDate = localStorageService.cookie.get('refresh_data');
    if(tokenExpirationDate && Math.round((tokenExpirationDate-new Date())/(1000*60*60*24)) < 5){
      UserAccountService.refreshToken();
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('nvc')
    .config(routerConfig)
    .run(RoutesRun);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider, $locationProvider, $provide) {
    $stateProvider.state('app', {
        abstract: true,
        views: {
          'content@': {
            templateUrl: 'app/components/commons/content.html'
          },
          'navigation@': {
            templateUrl: 'app/components/commons/navigation/navigation.html',
            controller: 'NavigationController',
            controllerAs: 'navigation'
          },
          'topnavbar@': {
            templateUrl: 'app/components/commons/topnavbar/topnavbar.html',
            controller: 'TopnavbarController',
            controllerAs: "topnavbar"
          }
        }
      });

    $urlRouterProvider.otherwise('/login');
    $locationProvider.html5Mode(true);
  }

  function RoutesRun($state, $rootScope, authorization, LoaderHelper, StateTransitionValidator) {
    $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
      LoaderHelper.open(true);
      $rootScope.toState = toState;
      $rootScope.toParams = toParams;
      $rootScope.fromState = fromState;
      $rootScope.fromParams = fromParams;
      authorization.authorize();
      StateTransitionValidator.validateTransition(event, toState, toParams, fromState, fromParams);
    });

    $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
      if (error.error === 'invalidTransition') {
        $state.go(error.fallback);
      }
      LoaderHelper.close();
    });

    $rootScope.$on('$stateChangeSuccess', function (event, toState) {
      var backdrop = document.querySelector('.modal-backdrop');
      var modalOpen = document.querySelector('.modal-open');
      if (backdrop) {
        backdrop.parentNode.removeChild(backdrop);
      }
      if(modalOpen) {
        modalOpen.classList.remove('modal-open');
      }
      LoaderHelper.close();
    });

  }

})();

angular.module("nvc").run(["$templateCache", function($templateCache) {$templateCache.put("app/components/commons/content.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/commons/ibox_tools.html","<div class=\"ibox-tools\" uib-dropdown=\"\"><a ng-click=\"showhide()\"><i class=\"fa fa-chevron-up\"></i></a> <a uib-dropdown-toggle=\"\" href=\"\"><i class=\"fa fa-wrench\"></i></a><ul uib-dropdown-menu=\"\"><li><a href=\"\">Config option 1</a></li><li><a href=\"\">Config option 2</a></li></ul><a ng-click=\"closebox()\"><i class=\"fa fa-times\"></i></a></div>");
$templateCache.put("app/states/assets/assets.html","<header-section breadcrumb-title=\"assets.title\" breadcrumbs=\"assets.breadcrumbs\"></header-section><div class=\"wrapper wrapper-content assets\" nvc-full-page=\"\" paginator=\"true\"><div class=\"row\" td-security=\"[\'Admin\', \'AssetManagement\']\" action=\"display-none\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 text-right\"><div class=\"m-b-lg inline upload-assets-btn-wp\" td-security=\"[\'Admin\']\" action=\"display-none\"><span ng-if=\"assets.canBringFutureValuations\"><checkbox ng-model=\"assets.futureValuations\"></checkbox><label id=\"assetsFutureValuations\" class=\"certification\" translate=\"ASSETS.FUTURE_VALUATIONS\"></label></span><div class=\"in-line document-uploader\"><button ng-click=\"assets.openUploadModal()\" class=\"btn btn-download\">{{\"ASSETS.UPLOAD_ASSETS\" | translate}}</button></div></div><div class=\"m-b-lg inline\"><a class=\"btn btn-normal btn-w-m\" ui-sref=\"app.asset.addAsset\">{{\'ASSETS.ADD_ASSET\' | translate}}</a></div></div></div><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><div class=\"col-lg-2 col-md-2 col-sm-2 col-xs-2 no-padding\" td-security=\"[\'Admin\']\" action=\"display-none\"><h4>{{\"ASSETS.ASSETS\" | translate}}&nbsp;<span>({{assets.selectedAssets}}/{{assets.assetsCount}})</span></h4></div><div class=\"col-lg-7 col-md-7 col-sm-7 col-xs-7 no-padding\" td-security=\"[\'Audit\', \'AssetManagement\', \'AssetAppraisal\', \'AssetReview\', \'AssetManagerReadOnly\']\" action=\"display-none\"><h4>{{\"ASSETS.ASSETS\" | translate}}&nbsp;<span>({{assets.assetsCount}})</span></h4></div><div class=\"col-lg-5 col-md-5 col-sm-5 col-xs-5 no-padding action-tools\" td-security=\"[\'Admin\']\" action=\"display-none\"><span>{{ \"COMMONS.ACTIONS\" | translate }}:</span><ul><li><a translate=\"COMMONS.ACTIVATE\" ng-click=\"assets.activateAsset()\"></a></li><li><a translate=\"COMMONS.INACTIVATE\" ng-click=\"assets.inactivateAsset()\"></a></li><li><a translate=\"COMMONS.DELETE\" ng-click=\"assets.deleteAsset()\"></a></li><li><a translate=\"COMMONS.ACTIVATE_VALUATIONS\" ng-click=\"assets.futureValuations ? assets.activateValuationForFutureValuations() : assets.activateValuations()\"></a></li></ul></div><div class=\"col-lg-5 col-md-5 col-sm-5 col-xs-5 no-padding\"><div class=\"form-group no-margins ibox-search-row\"><div uib-dropdown=\"\" is-open=\"assets.dropdown.isOpen\"><button ng-disabled=\"assets.downloadLoading\" class=\"btn btn-download\" ng-class=\"{\'btn-dropdown-active\': assets.dropdown.isOpen}\" uib-dropdown-toggle=\"\"><i class=\"icon icon-ic-download\"></i> {{ \"COMMONS.DOWNLOAD\" | translate }}</button><ul class=\"dropdown-menu\" uib-dropdown-menu=\"\"><li><a href=\"#\" class=\"btn-block btn-dropdown\" ng-click=\"assets.downloadPdf()\"><img class=\"dropdown-option-icon\" src=\"/assets/images/pdf.svg\"> {{ \"COMMONS.PDF\" | translate }}</a></li><li><a href=\"#\" class=\"btn-block btn-dropdown\" ng-click=\"assets.downloadCsv()\"><img class=\"dropdown-option-icon\" src=\"/assets/images/excel.svg\"> {{ \"COMMONS.EXCEL\" | translate }}</a></li></ul></div><div class=\"icon-addon addon-md ibox-search\"><input type=\"text\" class=\"form-control\" id=\"search\" translate=\"\" translate-attr-placeholder=\"ASSETS.SEARCH\" ng-change=\"assets.searchAssets()\" ng-model=\"assets.searchQuery\" ng-model-options=\"{ debounce: { \'default\': 500, \'blur\': 0 } }\"> <label for=\"search\" class=\"fa fa-search\" rel=\"tooltip\"></label></div></div></div></div><div class=\"row no-margins fixed-header\" ng-class=\"{\'is-appraiser\': assets.isAppraiser, \'is-ro\': assets.isReadOnly, \'is-am\': assets.isAssetManager, \'is-audit\': assets.isAudit, \'is-rw\': assets.isReviewer}\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><ul><li td-security=\"[\'Admin\']\" action=\"display-none\" class=\"select-all-li\"><a ng-class=\"{\'not-selected\': !assets.assetsSort[0].selected}\"><checkbox ng-model=\"assets.selectedAll\" ng-change=\"assets.setAllSelected()\"></checkbox></a></li><li><a translate=\"ASSETS.PROPERTY_NAME\" ng-click=\"assets.sorting(assets.assetsSort[0], \'assetsSelectedSort\')\" ng-class=\"{\'asc\': assets.assetsSort[0].flag, \'desc\': !assets.assetsSort[0].flag, \'not-selected\': !assets.assetsSort[0].selected}\"></a></li><li><a translate=\"ASSETS.ID\" ng-click=\"assets.sorting(assets.assetsSort[1], \'assetsSelectedSort\')\" ng-class=\"{\'asc\': assets.assetsSort[1].flag, \'desc\': !assets.assetsSort[1].flag, \'not-selected\': !assets.assetsSort[1].selected}\"></a></li><li class=\"hidden-xs hidden-sm hidden-md hidden-mdl\"><a translate=\"ASSETS.LOCATION\" ng-click=\"assets.sorting(assets.assetsSort[2], \'assetsSelectedSort\')\" ng-class=\"{\'asc\': assets.assetsSort[2].flag, \'desc\': !assets.assetsSort[2].flag, \'not-selected\': !assets.assetsSort[2].selected}\"></a></li><li td-security=\"[\'Admin\', \'AssetManagement\', \'Audit\', \'AssetReview\', \'AssetManagerReadOnly\']\" action=\"display-none\"><a translate=\"ASSETS.ASSET_MANAGER\" ng-click=\"assets.sorting(assets.assetsSort[3], \'assetsSelectedSort\')\" ng-class=\"{\'asc\': assets.assetsSort[3].flag, \'desc\': !assets.assetsSort[3].flag, \'not-selected\': !assets.assetsSort[3].selected}\"></a></li><li class=\"hidden-xs hidden-sm hidden-md hidden-mdl\"><a translate=\"ASSETS.V_PERIOD\" ng-click=\"assets.sorting(assets.assetsSort[4], \'assetsSelectedSort\')\" ng-class=\"{\'asc\': assets.assetsSort[4].flag, \'desc\': !assets.assetsSort[4].flag, \'not-selected\': !assets.assetsSort[4].selected}\"></a></li><li class=\"hidden-xs hidden-sm hidden-md hidden-mdl\" td-security=\"[\'Admin\', \'AssetReview\', \'AssetAppraisal\', \'Audit\']\" action=\"display-none\"><a translate=\"ASSETS.BIDDING_GROUP\" ng-click=\"assets.sorting(assets.assetsSort[5], \'assetsSelectedSort\')\" ng-class=\"{\'asc\': assets.assetsSort[5].flag, \'desc\': !assets.assetsSort[5].flag, \'not-selected\': !assets.assetsSort[5].selected}\"></a></li><li><a translate=\"ASSETS.PROPERTY_TYPE\" ng-click=\"assets.sorting(assets.assetsSort[6], \'assetsSelectedSort\')\" ng-class=\"{\'asc\': assets.assetsSort[6].flag, \'desc\': !assets.assetsSort[6].flag, \'not-selected\': !assets.assetsSort[6].selected}\"></a></li><li><a translate=\"COMMONS.ACTIVE\" ng-click=\"assets.sorting(assets.assetsSort[7], \'assetsSelectedSort\')\" ng-class=\"{\'asc\': assets.assetsSort[7].flag, \'desc\': !assets.assetsSort[7].flag, \'not-selected\': !assets.assetsSort[7].selected}\"></a></li><li td-security=\"[\'Admin\', \'AssetManagement\', \'AssetReview\']\" action=\"display-none\"><a translate=\"ASSETS.EDIT_ASSET\"></a></li></ul></div></div><div class=\"ibox-content paginator-loader no-padding\"><div class=\"sk-spinner sk-spinner-circle\"><div class=\"sk-circle1 sk-circle\"></div><div class=\"sk-circle2 sk-circle\"></div><div class=\"sk-circle3 sk-circle\"></div><div class=\"sk-circle4 sk-circle\"></div><div class=\"sk-circle5 sk-circle\"></div><div class=\"sk-circle6 sk-circle\"></div><div class=\"sk-circle7 sk-circle\"></div><div class=\"sk-circle8 sk-circle\"></div><div class=\"sk-circle9 sk-circle\"></div><div class=\"sk-circle10 sk-circle\"></div><div class=\"sk-circle11 sk-circle\"></div><div class=\"sk-circle12 sk-circle\"></div></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding full-height\" ng-class=\"{\'is-appraiser\': assets.isAppraiser, \'is-ro\': assets.isReadOnly, \'is-am\': assets.isAssetManager, \'is-audit\': assets.isAudit, \'is-rw\': assets.isReviewer}\"><perfect-scrollbar class=\"scroller\" wheel-propagation=\"true\" min-scrollbar-length=\"20\"><table class=\"table footable table-stripped toggle-arrow-tiny checkbox-custom\" data-page-size=\"100000\" data-filter-timeout=\"300\"><thead><tbody><tr ng-repeat=\"asset in assets.assets\"><td td-security=\"[\'Admin\']\" action=\"display-none\"><checkbox ng-model=\"asset.selected\" ng-change=\"assets.onSelectionChange()\"></checkbox></td><td><a ui-sref=\"app.asset.assetDetails({assetId: asset.id, asset: asset})\">{{ asset.name }}</a></td><td>{{ asset.propertyRef }}</td><td class=\"hidden-xs hidden-sm hidden-md hidden-mdl\">{{ asset.address.city }}, {{ asset.address.state }}</td><td td-security=\"[\'Admin\', \'AssetManagement\', \'Audit\', \'AssetReview\', \'AssetManagerReadOnly\']\" action=\"display-none\"><a td-security=\"[\'Admin\']\" action=\"display-none\" ui-sref=\"app.manage.users.editUser({id: asset.primaryAssetManager.user.id, companyId: assets.selectedCompany})\">{{asset.primaryManagerName ? asset.primaryManagerName : asset.primaryAssetManager.user.name}}</a> <a td-security=\"[\'AssetManagement\', \'Audit\', \'AssetReview\', \'AssetManagerReadOnly\']\" action=\"display-none\" ui-sref=\"app.manage.users.details({id: asset.primaryAssetManager.user.id, companyId: assets.selectedCompany})\">{{asset.primaryAssetManager.user.name }}</a></td><td class=\"hidden-xs hidden-sm hidden-md hidden-mdl\">{{ asset.vperiod }}</td><td class=\"hidden-xs hidden-sm hidden-md hidden-mdl\" td-security=\"[\'Admin\']\" action=\"display-none\"><a ui-sref=\"app.asset.bidGroups\" ng-hide=\"!asset.bidGroupName\">{{ asset.bidGroupName }}</a> <span ng-show=\"!asset.bidGroupName\">N/A</span></td><td class=\"hidden-xs hidden-sm hidden-md hidden-mdl\" td-security=\"[\'AssetReview\', \'AssetAppraisal\', \'Audit\']\" action=\"display-none\">{{ asset.bidGroupName || \"N/A\" }}</td><td>{{ asset.type | camelCaseToHuman }}</td><td class=\"asset-active\"><i class=\"icon icon-ic-check\" ng-class=\"{\'active\': asset.active, \'inactive\': !asset.active}\"></i></td><td td-security=\"[\'Admin\', \'AssetManagement\', \'AssetReview\']\" action=\"display-none\"><a class=\"edit-asset icon icon-ic-edit\" ui-sref=\"app.asset.editAsset({assetId: asset.id, companyId: asset.companyId, asset: asset})\"></a></td></tr></tbody><tfoot><tr><td colspan=\"5\"><ul class=\"pagination pull-right\"></ul></td></tr></tfoot></thead></table></perfect-scrollbar></div></div></div><div class=\"paginator-container\"><uib-pagination total-items=\"assets.assetsCount\" ng-model=\"assets.currentPage\" class=\"pagination-sm\" max-size=\"assets.maxPaginationSize\" items-per-page=\"assets.perPage\" ng-change=\"assets.changePage()\" boundary-link-numbers=\"true\" rotate=\"false\"></uib-pagination></div></div></div></div><script type=\"text/ng-template\" id=\"upload-assets.html\"><div class=\"assets-upload-modal\"> <div class=\"modal-header\"> <h3 class=\"no-margins\">{{\"ASSETS.UPLOAD_ASSETS_TITLE\" | translate}}</h3> </div> <div class=\"modal-body\"> <div class=\"row\"> <div class=\"col-xs-6\"> <label>{{\"ASSETS.UPLOAD_ASSETS_ASSETS\" | translate}}</label> <!-- upload-box --> <td-file-upload class=\"upload-box documents\" files=\"[]\" files-to-upload=\"uploadAssetsCtrl.assetsFile\" files-to-delete=\"[]\" valid-types=\"[\'.csv\']\" max-number-files=\"1\"></td-file-upload> <!-- /upload-box --> </div> <div class=\"col-xs-6\"> <label>{{\"ASSETS.UPLOAD_ASSETS_VALUATIONS\" | translate}}</label> <!-- upload-box --> <td-file-upload class=\"upload-box documents\" files=\"[]\" files-to-upload=\"uploadAssetsCtrl.valuationsFile\" files-to-delete=\"[]\" valid-types=\"[\'.csv\']\" max-number-files=\"1\"></td-file-upload> <!-- /upload-box --> </div> </div> </div> <div class=\"modal-footer\"> <div class=\"row text-right\"> <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"> <button class=\"btn btn-w-m btn-back\" ng-click=\"uploadAssetsCtrl.cancel()\"> {{\"ASSETS.CANCEL\" | translate}} </button> <button class=\"btn btn-w-m btn-normal m-l-sm\" ng-click=\"uploadAssetsCtrl.uploadFromCsv()\"> {{\"ASSETS.UPLOAD_ASSETS\" | translate}} </button> </div> </div> </div> </div></script>");
$templateCache.put("app/states/forgot-password/forgot-password.html","<div class=\"wrapper wrapper-content\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"forgot-password-box\"><h1 class=\"forgot-password-title\" translate=\"FORGOT_PASSWORD.FORGOT_PASSWORD\"></h1><p class=\"forgot-password-description\" translate=\"FORGOT_PASSWORD.DESCRIPTION\"></p><form class=\"forgot-password-form\" name=\"fotgotPasswordForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group\"><input name=\"email\" type=\"email\" class=\"form-control\" translate=\"\" translate-attr-placeholder=\"FORGOT_PASSWORD.PLACEHOLDER\" ng-model=\"forgotPassword.formData.email\" required=\"\"><div ng-show=\"forgotPassword.submitted\" ng-messages=\"forgotPasswordForm.email.$error\"><div ng-message=\"required\" translate=\"FORGOT_PASSWORD.EMAIL_REQ\"></div><div ng-message=\"email\" translate=\"FORGOT_PASSWORD.INVALID_EMAIL\"></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group\"><button translate=\"FORGOT_PASSWORD.RESET_PASSWORD\" type=\"submit\" class=\"pull-left btn btn-w-m btn-normal\" ng-click=\"forgotPassword.submitForm()\"></button> <a translate=\"FORGOT_PASSWORD.RETURN_TO_LOGIN\" class=\"pull-right\" ui-sref=\"login\" style=\"margin-top: 8px\"></a><div class=\"clearfix\"></div></div></div></div></form></div></div></div></div>");
$templateCache.put("app/states/login/login.html","<div class=\"wrapper wrapper-content\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"login-box\"><div version=\"\" clicks=\"7\" class=\"top-logo-panel\"><img class=\"reas-logo\" src=\"/assets/images/login/reas-logo.png\"></div><h2 class=\"welcome\" translate=\"LOGIN.WELCOME\"></h2><form class=\"login-form\" name=\"loginForm\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group\"><input name=\"username\" type=\"email\" class=\"form-control\" translate=\"\" translate-attr-placeholder=\"LOGIN.USERNAME\" ng-model=\"login.formData.email\" required=\"\"></div></div></div><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group\"><input name=\"password\" type=\"password\" class=\"form-control\" translate=\"\" translate-attr-placeholder=\"LOGIN.PASSWORD\" ng-model=\"login.formData.password\" required=\"\"></div></div></div><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group\"><button translate=\"LOGIN.LOGIN\" type=\"submit\" class=\"btn btn-warning btn-block\" ng-click=\"login.submitForm()\"></button></div></div></div><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 checkbox-custom\"><div class=\"form-group\"><checkbox id=\"rememberMe\" ng-model=\"login.formData.rememberMe\"></checkbox><label for=\"rememberMe\" class=\"remember-me\" translate=\"LOGIN.KEEP_ME_LOGGED_IN\"></label></div></div></div></form><a class=\"forgot-password\" translate=\"LOGIN.FORGOT\" ui-sref=\"forgotPassword\"></a><p class=\"powered-by\" translate=\"LOGIN.POWERED\"></p><div class=\"footer-logo col-xs-10 col-xs-offset-1\"><div class=\"row row-eq-height\"><div class=\"col-xs-8\"><img class=\"img-responsive\" src=\"/assets/images/login/nvc-logo.png\"></div><div class=\"col-xs-4 line\"><img class=\"img-responsive\" src=\"/assets/images/login/hipercept-logo.png\"></div></div></div></div></div></div></div>");
$templateCache.put("app/states/minor/minor.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"text-center m-t-lg\"><h1>Simple example of second view</h1><small>Configure in app.js as index.minor state.</small></div></div></div></div>");
$templateCache.put("app/states/main/main.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Velocity</h2><ol class=\"breadcrumb\"><li class=\"active\"><a href=\"index.html\">Velocity</a></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"text-center m-t-lg\"><h1 translate=\"MAIN.WELCOME\"></h1></div></div></div></div>");
$templateCache.put("app/states/valuations/valuation-lateral-content.html","<div id=\"asset-info\" class=\"asset-info\"><div class=\"img\"><img ng-src=\"{{review.asset.picture}}\"><div class=\"img-info\"><div><span class=\"id\">{{review.asset.propertyRef || \"n/a\"}}</span> <span class=\"type\">{{ (review.asset.type | camelCaseToHuman) || \"n/a\" }}</span></div><div class=\"name\">{{review.asset.name || \"n/a\"}}</div><div class=\"address\">{{review.asset.address.address || \"n/a\"}}<br>{{review.asset.address.city || \"n/a\"}}, {{review.asset.address.state || \"n/a\"}}</div></div></div><div class=\"review-btn-container\"><a class=\"btn btn-normal btn-block btn-review\" translate=\"VALUATIONS.FILES_REVIEW_VALUATION\" ng-click=\"goToReview(review.asset.id, review.id);\"></a></div><div class=\"info\"><div class=\"row\"><div class=\"col-lg-6 col-md-12 col-sm-12 col-xs-12 m-b-lg\"><span translate=\"VALUATIONS.V_PERIOD\"></span> <span class=\"data\">{{ review.vPeriod}}</span></div><div class=\"col-lg-6 col-md-12 col-sm-12 col-xs-12 m-b-lg\"><span translate=\"VALUATIONS.CURRENT_VALUE\"></span> <span class=\"data\">{{review.presentValue | currency:undefined:0}}</span></div></div><div class=\"row\"><div class=\"col-lg-6 col-md-12 col-sm-12 col-xs-12 draft-due-container m-b-lg\"><span class=\"draft-title\">{{\"VALUATIONS.DRAFT_DUE_DATE\" | translate}} <a class=\"edit-due-btn icon icon-ic-edit\" ng-hide=\"uiDueDatePicker.uiEditDueDate\" ng-click=\"uiDueDatePicker.toggleEdit()\" td-security=\"[\'Admin\']\" action=\"display-none\"></a> <a class=\"edit-due-btn cancel-edit icon icon-ic-close\" ng-if=\"uiDueDatePicker.uiEditDueDate\" ng-click=\"uiDueDatePicker.toggleEdit()\"></a></span> <span class=\"data display-due-date\" ng-class=\"{\'hide-due-date\': uiDueDatePicker.uiEditDueDate}\">{{ draftDueDate | date:\'MMM dd\' }}</span><div class=\"form-group no-margins\"><div class=\"input-group\"><input name=\"dueDate\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"MM/dd/yyyy\" is-open=\"uiDueDatePicker.opened\" datepicker-options=\"uiDueDatePicker.options\" close-on-date-selection=\"true\" ng-model-options=\"uiDueDatePicker.modelOptions\" ng-model=\"draftDueDate\" ng-class=\"{\'hide-draft-due-input\': !uiDueDatePicker.uiEditDueDate}\" ng-change=\"saveDueDate()\" required=\"\"> <span class=\"input-group-btn\" ng-class=\"{\'hide-draft-due-input\': !uiDueDatePicker.uiEditDueDate}\"><button class=\"btn btn-default\" type=\"button\" ng-click=\"uiDueDatePicker.toggleCalendar()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div ng-messages=\"\" ng-show=\"uiDueDatePicker.error\"><div translate=\"VALUATIONS.DRAFT_DUE_DATE_ERROR\"></div></div></div><div class=\"col-lg-6 col-md-12 col-sm-12 col-xs-12 m-b-lg\"><span translate=\"VALUATIONS.CURRENT_STATUS\"></span> <span class=\"data\">{{ review.statusDescription }}</span></div></div></div></div><div id=\"people\" class=\"people\"><div td-security=\"[\'Admin\', \'AssetReview\', \'AssetAppraisal\']\" action=\"display-none\"><hr><div class=\"title m-b-lg\" translate=\"COMMONS.APPRAISER\"></div><div class=\"row m-b-lg\"><div class=\"col-lg-12\"><span translate=\"VALUATIONS.LEAD\"></span><ul><li class=\"data\" ng-hide=\"!review.asset.primaryAssetAppraiser\"><a td-security=\"[\'Admin\']\" action=\"display-none\" ui-sref=\"app.manage.users.editUser({ companyId: review.asset.primaryAssetAppraiser.userCompanyId, id: review.asset.primaryAssetAppraiser.user.id, userCompanyRelationshipId: review.asset.primaryAssetAppraiser.id})\">{{review.asset.primaryAssetAppraiser.user.name}}</a> <a td-security=\"[\'Audit\', \'AssetReview\', \'AssetAppraisal\']\" action=\"display-none\" ui-sref=\"app.manage.users.details({ companyId: review.asset.primaryAssetAppraiser.userCompanyId, id: review.asset.primaryAssetAppraiser.user.id})\">{{review.asset.primaryAssetAppraiser.user.name}}</a> <span class=\"erase\" ng-click=\"removeUser(review.asset.primaryAssetAppraiser)\" td-security=\"[\'Admin\']\" ng-if=\"review.status !=\'Finished\'\" action=\"display-none\"></span></li></ul><form name=\"addLeadAppraiserForm\" ng-hide=\"review.asset.primaryAssetAppraiser\" td-security=\"[\'Admin\']\" action=\"display-none\"><div class=\"form-group m-t\"><select name=\"lead-appraiser\" class=\"form-control\" ng-model=\"selectedPrimaryAssetAppraiser\" chosen=\"\" required=\"\" ng-options=\"appraiser as appraiser.user.name for appraiser in appraisers | filter: { companyId: secondaryAppraisers[0].userCompanyId } track by appraiser.user.id\" ng-change=\"addPrimary(review.asset.id, selectedPrimaryAssetAppraiser)\" ng-disabled=\"review.status ==\'Finished\'\"><option style=\"display:none\" value=\"\" translate=\"VALUATIONS.ENTER\"></option></select></div></form></div></div><div class=\"row\"><div class=\"col-lg-12\"><span translate=\"VALUATIONS.SECONDARY\"></span><ul><li class=\"data\" ng-repeat=\"secondaryAppraiser in secondaryAppraisers\"><a td-security=\"[\'Admin\']\" action=\"display-none\" ui-sref=\"app.manage.users.editUser({ companyId: secondaryAppraiser.userCompanyId, id: secondaryAppraiser.user.id, userCompanyRelationshipId: secondaryAppraiser.id})\">{{secondaryAppraiser.user.name}}</a> <a td-security=\"[\'AssetReview\', \'AssetAppraisal\']\" action=\"display-none\" ui-sref=\"app.manage.users.details({ companyId: secondaryAppraiser.userCompanyId, id: secondaryAppraiser.user.id})\">{{secondaryAppraiser.user.name}}</a> <span ng-hide=\"!userIsAllowed\" class=\"erase\" ng-click=\"removeUser(secondaryAppraiser)\" td-security=\"[\'Admin\',\'AssetAppraisal\']\" ng-if=\"review.status !=\'Finished\'\" action=\"display-none\"></span></li></ul><div ng-hide=\"!userIsAllowed\" class=\"text-right m-t\"><div ng-hide=\"secondaryAppraisers.length == 0 || secondaryAppraisers.length >= 3 || addingAp\" td-security=\"[\'Admin\',\'AssetAppraisal\']\" action=\"display-none\"><a class=\"btn btn-w-m btn-add\" type=\"submit\" translate=\"VALUATIONS.ADD\" ng-click=\"toggleButtonAp()\"></a></div></div><form name=\"addSecondaryAppraiserForm\" ng-show=\"(secondaryAppraisers.length == 0 || addingAp) && userIsAllowed\" td-security=\"[\'Admin\',\'AssetAppraisal\']\" action=\"display-none\"><div class=\"form-group m-t\"><select name=\"secondary-appraiser\" class=\"form-control\" ng-model=\"selectedSecondaryAppraiser\" chosen=\"\" required=\"\" ng-options=\"appraiser as appraiser.user.name for appraiser in appraisers | filter: { companyId: review.asset.primaryAssetAppraiser.userCompanyId } track by appraiser.user.id\" ng-change=\"addSecondary(review.asset.id, selectedSecondaryAppraiser)\" ng-disabled=\"!review.asset.primaryAssetAppraiser || review.status ==\'Finished\'\"><option style=\"display:none\" value=\"\" translate=\"VALUATIONS.ENTER\"></option></select></div></form></div></div></div><hr td-security=\"generalRoles\" action=\"display-none\"><div class=\"title m-b-lg\" td-security=\"generalRoles\" action=\"display-none\">{{\"COMMONS.ASSET_MANAGER\" | translate}}</div><div class=\"row m-b-lg\" td-security=\"generalRoles\" action=\"display-none\"><div class=\"col-lg-12\"><span translate=\"VALUATIONS.LEAD\"></span><ul><li class=\"data\" ng-hide=\"!review.asset.primaryAssetManager\"><a td-security=\"[\'Admin\']\" action=\"display-none\" ui-sref=\"app.manage.users.editUser({ companyId: review.asset.primaryAssetManager.userCompanyId, id: review.asset.primaryAssetManager.user.id, userCompanyRelationshipId: review.asset.primaryAssetManager.id})\">{{review.asset.primaryAssetManager.user.name}}</a> <a td-security=\"[\'Audit\', \'AssetManagement\', \'AssetReview\', \'AssetManagerReadOnly\']\" action=\"display-none\" ui-sref=\"app.manage.users.details({ companyId: review.asset.primaryAssetManager.userCompanyId, id: review.asset.primaryAssetManager.user.id})\">{{review.asset.primaryAssetManager.user.name}}</a> <span class=\"erase\" ng-click=\"removeUser(review.asset.primaryAssetManager)\" td-security=\"[\'Admin\']\" ng-if=\"review.status !=\'Finished\'\" action=\"display-none\"></span></li></ul><form name=\"addLeadAssetManagerForm\" ng-hide=\"review.asset.primaryAssetManager\" td-security=\"[\'Admin\']\" action=\"display-none\"><div class=\"form-group m-t\"><select name=\"lead-asset-manager\" class=\"form-control\" ng-model=\"selectedPrimaryAssetManager\" chosen=\"\" required=\"\" ng-options=\"assetManager as assetManager.user.name for assetManager in assetManagers | filter: { companyId: secondaryAssetManagers[0].userCompanyId } track by assetManager.user.id\" ng-change=\"addPrimary(review.asset.id, selectedPrimaryAssetManager)\" ng-disabled=\"review.status ==\'Finished\'\"><option style=\"display:none\" value=\"\" translate=\"VALUATIONS.ENTER\"></option></select></div></form></div></div><div class=\"row\" td-security=\"generalRoles\" action=\"display-none\"><div class=\"col-lg-12\"><span translate=\"VALUATIONS.SECONDARY\"></span><ul><li class=\"data\" ng-repeat=\"secondaryAssetManager in secondaryAssetManagers\"><a td-security=\"[\'Admin\']\" action=\"display-none\" ui-sref=\"app.manage.users.editUser({ companyId: secondaryAssetManager.userCompanyId, id: secondaryAssetManager.user.id, userCompanyRelationshipId: secondaryAssetManager.id})\">{{secondaryAssetManager.user.name}}</a> <a td-security=\"[\'Audit\', \'AssetManagement\', \'AssetReview\', \'AssetManagerReadOnly\']\" action=\"display-none\" ui-sref=\"app.manage.users.details({ companyId: secondaryAssetManager.userCompanyId, id: secondaryAssetManager.user.id})\">{{secondaryAssetManager.user.name}}</a> <span ng-hide=\"!userIsAllowed\" class=\"erase\" ng-click=\"removeUser(secondaryAssetManager)\" td-security=\"[\'Admin\',\'AssetManagement\']\" ng-if=\"review.status !=\'Finished\'\" action=\"display-none\"></span></li></ul><div ng-hide=\"!userIsAllowed\" class=\"text-right m-t\"><div ng-hide=\"secondaryAssetManagers.length == 0 || secondaryAssetManagers.length >= 3 || addingAm\" td-security=\"[\'Admin\',\'AssetManagement\']\" action=\"display-none\"><a class=\"btn btn-w-m btn-add\" type=\"submit\" translate=\"VALUATIONS.ADD\" ng-click=\"toggleButtonAm()\"></a></div></div><form name=\"addSecondaryAssetManagerForm\" ng-show=\"(secondaryAssetManagers.length == 0 || addingAm) && userIsAllowed\" td-security=\"[\'Admin\',\'AssetManagement\']\" action=\"display-none\"><div class=\"form-group m-t\"><select name=\"secondary-asset-manager\" class=\"form-control\" ng-model=\"selectedSecondaryAssetManager\" chosen=\"\" required=\"\" ng-options=\"assetManager as assetManager.user.name for assetManager in assetManagers | filter: { companyId: review.asset.primaryAssetManager.userCompanyId } track by assetManager.user.id\" ng-change=\"addSecondary(review.asset.id, selectedSecondaryAssetManager)\" ng-disabled=\"!review.asset.primaryAssetManager || review.status ==\'Finished\'\"><option style=\"display:none\" value=\"\" translate=\"VALUATIONS.ENTER\"></option></select></div></form></div></div><hr><div class=\"title m-b-lg\" translate=\"COMMONS.REVIEWER\"></div><div class=\"row m-b-lg\"><div class=\"col-lg-12\"><span translate=\"VALUATIONS.LEAD\"></span><ul><li class=\"data\" ng-hide=\"!review.asset.primaryAssetReviewer\"><a td-security=\"[\'Admin\']\" action=\"display-none\" ui-sref=\"app.manage.users.editUser({ companyId: review.asset.primaryAssetReviewer.userCompanyId, id: review.asset.primaryAssetReviewer.user.id, userCompanyRelationshipId: review.asset.primaryAssetReviewer.id})\">{{review.asset.primaryAssetReviewer.user.name}}</a> <a td-security=\"[\'Audit\', \'AssetManagement\', \'AssetReview\', \'AssetManagerReadOnly\', \'AssetAppraisal\']\" action=\"display-none\" ui-sref=\"app.manage.users.details({ companyId: review.asset.primaryAssetReviewer.userCompanyId, id: review.asset.primaryAssetReviewer.user.id})\">{{review.asset.primaryAssetReviewer.user.name}}</a> <span class=\"erase\" ng-click=\"removeUser(review.asset.primaryAssetReviewer)\" td-security=\"[\'Admin\']\" ng-if=\"review.status !=\'Finished\'\" action=\"display-none\"></span></li></ul><form name=\"addLeadReviewerForm\" ng-hide=\"review.asset.primaryAssetReviewer\" td-security=\"[\'Admin\']\" action=\"display-none\"><div class=\"form-group m-t\"><select name=\"lead-appraiser\" class=\"form-control\" ng-model=\"selectedPrimaryAssetReviewer\" chosen=\"\" required=\"\" ng-options=\"reviewer as reviewer.user.name for reviewer in reviewers | filter: { companyId: secondaryReviewers[0].userCompanyId } track by reviewer.user.id\" ng-change=\"addPrimary(review.asset.id, selectedPrimaryAssetReviewer)\" ng-disabled=\"review.status ==\'Finished\'\"><option style=\"display:none\" value=\"\" translate=\"VALUATIONS.ENTER\"></option></select></div></form></div></div><div class=\"row\"><div class=\"col-lg-12\"><span translate=\"VALUATIONS.SECONDARY\"></span><ul><li class=\"data\" ng-repeat=\"secondaryReviewer in secondaryReviewers\"><a td-security=\"[\'Admin\']\" action=\"display-none\" ui-sref=\"app.manage.users.editUser({ companyId: secondaryReviewer.userCompanyId, id: secondaryReviewer.user.id, userCompanyRelationshipId: secondaryReviewer.id})\">{{secondaryReviewer.user.name}}</a> <a td-security=\"[\'Audit\', \'AssetManagement\', \'AssetReview\', \'AssetManagerReadOnly\', \'AssetAppraisal\']\" action=\"display-none\" ui-sref=\"app.manage.users.details({ companyId: secondaryReviewer.userCompanyId, id: secondaryReviewer.user.id})\">{{secondaryReviewer.user.name}}</a> <span ng-hide=\"!userIsAllowed\" class=\"erase\" ng-click=\"removeUser(secondaryReviewer)\" td-security=\"[\'Admin\',\'AssetReview\']\" ng-if=\"review.status !=\'Finished\'\" action=\"display-none\"></span></li></ul><div ng-hide=\"!userIsAllowed\" class=\"text-right m-t\"><div ng-hide=\"secondaryReviewers.length == 0 || secondaryReviewers.length >= 3 || addingR\" td-security=\"[\'Admin\',\'AssetReview\']\" action=\"display-none\"><a class=\"btn btn-w-m btn-add\" type=\"submit\" translate=\"VALUATIONS.ADD\" ng-click=\"toggleButtonR()\"></a></div></div><form name=\"addSecondaryReviewerForm\" ng-show=\"(secondaryReviewers.length == 0 || addingR) && userIsAllowed\" td-security=\"[\'Admin\',\'AssetReview\']\" action=\"display-none\"><div class=\"form-group m-t\"><select name=\"secondary-reviewer\" class=\"form-control\" ng-model=\"selectedSecondaryReviewer\" chosen=\"\" required=\"\" ng-options=\"reviewer as reviewer.user.name for reviewer in reviewers | filter: { companyId: review.asset.primaryAssetReviewer.userCompanyId } track by reviewer.user.id\" ng-change=\"addSecondary(review.asset.id, selectedSecondaryReviewer)\" ng-disabled=\"!review.asset.primaryAssetReviewer || review.status ==\'Finished\'\"><option style=\"display:none\" value=\"\" translate=\"VALUATIONS.ENTER\"></option></select></div></form></div></div></div><div id=\"auditor\" class=\"auditor\" td-security=\"[\'Admin\', \'Audit\', \'AssetReview\', \'AssetManagement\', \'AssetManagerReadOnly\']\" action=\"display-none\"><hr><div class=\"title\" translate=\"COMMONS.AUDITOR\"></div><div class=\"row\"><div class=\"col-lg-12\"><ul><li class=\"data\" ng-hide=\"!review.asset.primaryAssetAuditor\"><a td-security=\"[\'Admin\']\" action=\"display-none\" ui-sref=\"app.manage.users.editUser({ companyId: review.asset.primaryAssetAuditor.userCompanyId, id: review.asset.primaryAssetAuditor.user.id, userCompanyRelationshipId: review.asset.primaryAssetAuditor.id})\">{{review.asset.primaryAssetAuditor.user.name}}</a> <a td-security=\"[\'Audit\', \'AssetManagement\', \'AssetReview\', \'AssetManagerReadOnly\']\" action=\"display-none\" ui-sref=\"app.manage.users.details({ companyId: review.asset.primaryAssetAuditor.userCompanyId, id: review.asset.primaryAssetAuditor.user.id})\">{{review.asset.primaryAssetAuditor.user.name}}</a> <span class=\"erase\" ng-click=\"removeUser(review.asset.primaryAssetAuditor)\" td-security=\"[\'Admin\']\" action=\"display-none\" ng-if=\"review.status !=\'Finished\'\"></span></li></ul><form name=\"addLeadAuditorForm\" ng-hide=\"review.asset.primaryAssetAuditor\" td-security=\"[\'Admin\']\" action=\"display-none\"><div class=\"form-group m-t\"><select name=\"lead-auditor\" class=\"form-control\" ng-model=\"selectedPrimaryAssetAuditor\" chosen=\"\" required=\"\" ng-options=\"auditor as auditor.user.name for auditor in auditors track by auditor.user.id\" ng-change=\"addPrimary(review.asset.id, selectedPrimaryAssetAuditor)\" ng-disabled=\"review.status ==\'Finished\'\"><option style=\"display:none\" value=\"\" translate=\"VALUATIONS.ENTER\"></option></select></div></form></div></div></div>");
$templateCache.put("app/states/valuations/valuations.html","<header-section breadcrumb-title=\"valuations.title\" breadcrumbs=\"valuations.breadcrumbs\"></header-section><section><div class=\"wrapper wrapper-content\"><div class=\"row widgets\"><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 overall\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content no-padding no-title\"><div class=\"row no-margins\"><div class=\"col-lg-8 col-md-7 col-sm-7 col-xs-7 bg-gray border-right\"><div class=\"row no-margins\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><h4 translate=\"VALUATIONS.OVERALL_APPRAISAL_PROGRESS\"></h4></div></div><div class=\"row no-margins\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding doughnut fixed-height\"><canvas id=\"doughnut\" class=\"chart chart-doughnut\" chart-data=\"valuations.dataOverall\" chart-labels=\"valuations.labelsOverall\" chart-options=\"valuations.optionsOverall\" chart-colors=\"valuations.colorsOverall\"></canvas><span class=\"percentage\">{{ valuations.percentageOverall | number:2}}%</span></div></div></div><div class=\"col-lg-4 col-md-5 col-sm-5 col-xs-5 status-container\"><select id=\"propertyStatus\" name=\"propertyStatus\" class=\"propertyStatus\" chosen=\"\" ng-model=\"valuations.status\" ng-options=\"status.name for status in valuations.propertyStatus\"></select></div><div class=\"col-lg-4 col-md-5 col-sm-5 col-xs-5 border-top\"><span class=\"assets-title\" translate=\"VALUATIONS.ASSETS\"></span> <span class=\"assets-number\">{{valuations.dataOverall[0]}} {{\"VALUATIONS.OF\" | translate}} {{valuations.numberOfValuations}}</span></div></div></div></div></div><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 average\" td-security=\"[\'Admin\', \'Audit\', \'AssetReview\', \'AssetManagement\', \'AssetManagerReadOnly\']\" action=\"display-none\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content no-padding no-title\"><div class=\"row no-margins\"><div class=\"col-lg-8 col-md-7 col-sm-7 col-xs-7 bg-gray border-right\"><div class=\"row no-margins\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><h4 translate=\"VALUATIONS.EXECUTIVE_HIGHLIGHTS\"></h4></div></div><div class=\"row no-margins\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding doughnut fixed-height\"><canvas id=\"bar\" class=\"chart chart-bar\" chart-data=\"valuations.companyAverages[valuations.factor.value]\" chart-labels=\"valuations.labelsAverage\" chart-options=\"valuations.optionsAverage\" chart-colors=\"valuations.colorsAverage\"></canvas></div></div></div><div class=\"col-lg-4 col-md-5 col-sm-5 col-xs-5\"><select id=\"factorValues\" name=\"factorValues\" class=\"factorValues\" chosen=\"\" ng-model=\"valuations.factor\" ng-options=\"factor.name for factor in valuations.factorValues track by factor.value\"></select></div></div></div></div></div><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 overdue\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content no-padding no-title\"><div class=\"row no-margins\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><h4 translate=\"VALUATIONS.OVERDUE_VALUATIONS\"></h4></div></div><div class=\"row no-margins\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><div class=\"fixed-header\"><ul><li><a translate=\"VALUATIONS.PROPERTY_NAME\" ng-click=\"valuations.sorting(valuations.overdueSort[0], \'overdueSelectedSort\')\" ng-class=\"{\'asc\': valuations.overdueSort[0].flag, \'desc\': !valuations.overdueSort[0].flag, \'not-selected\': !valuations.overdueSort[0].selected}\"></a></li><li><a translate=\"VALUATIONS.DUE_DATE\" ng-click=\"valuations.sorting(valuations.overdueSort[1], \'overdueSelectedSort\')\" ng-class=\"{\'asc\': valuations.overdueSort[1].flag, \'desc\': !valuations.overdueSort[1].flag, \'not-selected\': !valuations.overdueSort[1].selected}\"></a></li></ul></div></div></div><div class=\"row no-margins\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding fixed-height\"><perfect-scrollbar class=\"scroller\" wheel-propagation=\"true\" wheel-speed=\"1\" min-scrollbar-length=\"20\"><table class=\"table table-striped\"><tbody><tr ng-repeat=\"valuation in valuations.overdueValuations | orderBy: valuations.overdueSelectedSort.sort\"><td><a ui-sref=\"app.asset.assetDetails({assetId: valuation.assetId})\">{{ valuation.name || \"N/A\" }}</a></td><td>{{ valuation.nextDraftDueDate | date:\'MMM dd, yyyy\' }}</td></tr></tbody></table></perfect-scrollbar></div></div></div></div></div></div><div class=\"row no-button\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"ibox ibox-valuations float-e-margins\" style=\"overflow: unset;\"><div class=\"ibox-title assets-list\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><h4><span ng-if=\"valuations.isStatusView\">{{\"VALUATIONS.VALUATION_STATUS\" | translate}}</span> <span ng-if=\"!valuations.isStatusView\">{{\"VALUATIONS.VALUATIONS\" | translate}}</span> &nbsp;<span>(<span ng-if=\"valuations.reviewCount !== valuations.numberOfValuations\">{{valuations.reviewCount}}&nbsp;{{\"VALUATIONS.OF\" | translate}}&nbsp;</span>{{valuations.numberOfValuations}}&nbsp;{{\"VALUATIONS.RESULTS\" | translate}})</span></h4></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><div class=\"d-flex\"><div class=\"col-lg-4 no-padding ibox-search-row_wrap\"><div class=\"form-group no-margins ibox-search-row\"><div class=\"icon-addon addon-md ibox-search\"><input type=\"text\" class=\"form-control\" id=\"search\" translate=\"\" translate-attr-placeholder=\"USERS.SEARCH\" ng-change=\"valuations.searchValuations()\" ng-model=\"valuations.searchQuery\" ng-model-options=\"{ debounce: { \'default\': 500, \'blur\': 0 } }\"> <label for=\"search\" class=\"fa fa-search\" rel=\"tooltip\"></label></div><button class=\"btn btn-download\" ng-class=\"{\'btn-download-active\': valuations.isFiltersApplied}\" ng-if=\"!valuations.isStatusView\" ng-click=\"valuations.openAdvanceFilters(valuations.valuationFilters)\"><i class=\"icon fa fa-search\"></i> <span ng-if=\"!valuations.isFiltersApplied\">{{\"VALUATIONS.FILTER_RESULTS\" | translate}}</span> <span ng-if=\"valuations.isFiltersApplied\">({{valuations.numberOfFiltersApplied}}) {{\"VALUATIONS.FILTERS_APPLIED\" | translate}}</span></button></div></div><div class=\"col-lg-8 d-flex align-items-center justiify-content-end no-padding ibox-buttons-row\"><div class=\"checkbox-custom future-valuations\"><div class=\"form-group\" ng-if=\"valuations.canBringFutureValuations\"><div class=\"radio-comment-wrapper\"><checkbox ng-model=\"valuations.futureValuations\" ng-change=\"valuations.loadFutureValuations()\"></checkbox><label class=\"certification\" translate=\"VALUATIONS.FUTURE_VALUATIONS\"></label></div></div></div><div class=\"form-group no-margins text-right\" td-security=\"[\'AssetManagement\', \'AssetReview\', \'Audit\', \'AssetAppraisal\']\" action=\"display-none\"><button class=\"btn btn-w-m btn-valuations no-margins\" ng-show=\"valuations.allReviewSelected\" translate=\"VALUATIONS.MY_VALUATIONS\" ng-click=\"valuations.myValuations()\"></button> <button class=\"btn btn-w-m btn-valuations no-margins\" ng-hide=\"valuations.allReviewSelected\" translate=\"VALUATIONS.ALL_VALUATIONS\" ng-click=\"valuations.myValuations()\"></button></div><button class=\"btn btn-w-m btn-normal\" ng-click=\"valuations.toggleStatus()\">{{valuations.isStatusView ? \"VALUATIONS.VALUATIONS\" : \"VALUATIONS.VALUATION_STATUS\" | translate }}</button><div><button ng-disabled=\"valuations.downloadLoading\" id=\"valuationsDownloadButton\" class=\"btn btn-download ml-10px\" ng-click=\"valuations.toggleDownload()\"><i class=\"icon icon-ic-download\"></i> {{ \"COMMONS.DOWNLOAD\" | translate }}</button><div ng-if=\"valuations.isToggleDownloadActive\" id=\"toggleValuationsDownlaod\"><div ng-if=\"valuations.downloadLoading\" class=\"sk-spinner sk-spinner-three-bounce\"><div class=\"sk-bounce1\" style=\"width:10px;height:10px;\"></div><div class=\"sk-bounce2\" style=\"width:10px;height:10px;\"></div><div class=\"sk-bounce3\" style=\"width:10px;height:10px;\"></div></div><div ng-class=\"{\'div-disabled\' : valuations.downloadLoading}\"><span ng-click=\"valuations.downloadCsv()\">{{ \"VALUATIONS.DASHBOARD\" | translate }}</span></div><div ng-class=\"{\'div-disabled\' : valuations.downloadLoading}\"><span ng-click=\"valuations.downloadValuationConclusionsCsv()\">{{ \"VALUATIONS.VALUATION CONCLUSIONS\" | translate }}</span></div><div ng-class=\"{\'div-disabled\' : valuations.downloadLoading}\"><span ng-click=\"valuations.downloadAEModels(\'ValuationReport\')\">{{ \"VALUATIONS.PDF_REPORTS\" | translate }}</span></div><div ng-class=\"{\'div-disabled\' : valuations.downloadLoading}\"><span ng-click=\"valuations.downloadExecutiveSummaryCsv()\">{{ \"VALUATIONS.EXECUTIVE_SUMMARY_EXCEL\" | translate }}</span></div><div ng-class=\"{\'div-disabled\' : valuations.downloadLoading}\"><span ng-click=\"valuations.downloadAEModels(\'ArgusFile\')\">{{ \"VALUATIONS.AE_MODELS\" | translate }}</span></div></div></div><button ng-if=\"valuations.isFiltersApplied\" class=\"btn btn-download ml-10px\" ng-click=\"valuations.clearAllFilters()\">{{\"VALUATIONS.CLEAR_ALL\" | translate}}</button></div></div></div></div><div ng-if=\"!valuations.isStatusView\"><div class=\"row no-margins fixed-header assets-list\" ng-class=\"{\'lateral-open\': valuations.lateralBarOpen, \'is-appraiser\': valuations.isAppraiser}\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><ul><li><a translate=\"VALUATIONS.PROPERTY_NAME\" ng-click=\"valuations.sortingValuations(valuations.valuationSort[0], \'valuationSelectedSort\')\" ng-class=\"{\'asc\': valuations.valuationSort[0].flag, \'desc\': !valuations.valuationSort[0].flag, \'not-selected\': !valuations.valuationSort[0].selected}\"></a></li><li><a translate=\"VALUATIONS.LOCATION\" ng-click=\"valuations.sortingValuations(valuations.valuationSort[1], \'valuationSelectedSort\')\" ng-class=\"{\'asc\': valuations.valuationSort[1].flag, \'desc\': !valuations.valuationSort[1].flag, \'not-selected\': !valuations.valuationSort[1].selected}\"></a></li><li><a translate=\"VALUATIONS.PROPERTY_TYPE\" ng-click=\"valuations.sortingValuations(valuations.valuationSort[2], \'valuationSelectedSort\')\" ng-class=\"{\'asc\': valuations.valuationSort[2].flag, \'desc\': !valuations.valuationSort[2].flag, \'not-selected\': !valuations.valuationSort[2].selected}\"></a></li><li class=\"hide-on-open\" td-security=\"valuations.generalRoles\" action=\"display-none\"><a ng-click=\"valuations.sortingValuations(valuations.valuationSort[3], \'valuationSelectedSort\')\" ng-class=\"{\'asc\': valuations.valuationSort[3].flag, \'desc\': !valuations.valuationSort[3].flag, \'not-selected\': !valuations.valuationSort[3].selected}\">{{\"VALUATIONS.ASSET_MANAGER\" | translate}}</a></li><li class=\"hide-on-open\"><a translate=\"VALUATIONS.REVIEWER\" ng-click=\"valuations.sortingValuations(valuations.valuationSort[4], \'valuationSelectedSort\')\" ng-class=\"{\'asc\': valuations.valuationSort[4].flag, \'desc\': !valuations.valuationSort[4].flag, \'not-selected\': !valuations.valuationSort[4].selected}\"></a></li><li class=\"hide-on-open\"><a translate=\"VALUATIONS.CURRENT_VALUE\" ng-click=\"valuations.sortingValuations(valuations.valuationSort[5], \'valuationSelectedSort\')\" ng-class=\"{\'asc\': valuations.valuationSort[5].flag, \'desc\': !valuations.valuationSort[5].flag, \'not-selected\': !valuations.valuationSort[5].selected}\"></a></li><li><a translate=\"VALUATIONS.V_PERIOD\" ng-click=\"valuations.sortingValuations(valuations.valuationSort[6], \'valuationSelectedSort\')\" ng-class=\"{\'asc\': valuations.valuationSort[6].flag, \'desc\': !valuations.valuationSort[6].flag, \'not-selected\': !valuations.valuationSort[6].selected}\"></a></li><li><a translate=\"VALUATIONS.STATUS\" ng-click=\"valuations.sortingValuations(valuations.valuationSort[7], \'valuationSelectedSort\')\" ng-class=\"{\'asc\': valuations.valuationSort[7].flag, \'desc\': !valuations.valuationSort[7].flag, \'not-selected\': !valuations.valuationSort[7].selected}\"></a></li><li><a translate=\"VALUATIONS.NEXT\" ng-click=\"valuations.sortingValuations(valuations.valuationSort[8], \'valuationSelectedSort\')\" ng-class=\"{\'asc\': valuations.valuationSort[8].flag, \'desc\': !valuations.valuationSort[8].flag, \'not-selected\': !valuations.valuationSort[8].selected}\"></a></li></ul></div></div><div class=\"ibox-content paginator-loader no-padding\"><div class=\"sk-spinner sk-spinner-circle\"><div class=\"sk-circle1 sk-circle\"></div><div class=\"sk-circle2 sk-circle\"></div><div class=\"sk-circle3 sk-circle\"></div><div class=\"sk-circle4 sk-circle\"></div><div class=\"sk-circle5 sk-circle\"></div><div class=\"sk-circle6 sk-circle\"></div><div class=\"sk-circle7 sk-circle\"></div><div class=\"sk-circle8 sk-circle\"></div><div class=\"sk-circle9 sk-circle\"></div><div class=\"sk-circle10 sk-circle\"></div><div class=\"sk-circle11 sk-circle\"></div><div class=\"sk-circle12 sk-circle\"></div></div><div class=\"col-lg-8 col-md-8 col-sm-8 col-xs-8 no-padding assets-list\" ng-class=\"{\'lateral-open\': valuations.lateralBarOpen, \'is-appraiser\': valuations.isAppraiser}\"><perfect-scrollbar class=\"scroller\" wheel-propagation=\"true\" wheel-speed=\"1\" min-scrollbar-length=\"20\"><table class=\"table footable table-stripped toggle-arrow-tiny\" data-page-size=\"100000\" ng-class=\"{\'lateral-open\': valuations.lateralBarOpen}\"><tbody><tr ng-repeat=\"review in valuations.reviews\" ng-click=\"valuations.getReviewDetails(review)\" ng-class=\"{\'highlight\':review.displaying}\"><td><a ui-sref=\"app.asset.assetDetails({assetId: review.asset.id})\" target=\"_blank\">{{ review.asset.name || \"N/A\" }}</a></td><td>{{ review.asset.address.city }}, {{ review.asset.address.state }}</td><td>{{ valuations.abbrTypes(review.asset.type) || \"N/A\" }}</td><td class=\"hide-on-open\" td-security=\"valuations.generalRoles\" action=\"display-none\">{{ review.asset.primaryAssetManager.user.name || \"N/A\" }}</td><td class=\"hide-on-open\">{{ review.asset.primaryAssetReviewer.user.name || \"N/A\" }}</td><td class=\"hide-on-open\">{{ review.presentValue | currency:undefined:0}}</td><td>{{ review.vPeriod }}</td><td class=\"status\"><div class=\"action\" nvc-latest-action=\"\" review=\"review\" status=\"review.statusName\" description=\"review.statusDescription\"></div></td><td class=\"action\"><div nvc-current-action=\"\" highlight-mine=\"true\" review=\"review\" name=\"review.nextUserTakingActionName\"></div></td></tr></tbody><tfoot><tr><td colspan=\"5\"><ul class=\"pagination pull-right\"></ul></td></tr></tfoot></table></perfect-scrollbar></div><lateral-bar show=\"valuations.lateralBarOpen\" config=\"valuations.lateralBarConfig\" on-close=\"valuations.closeDetails\" content-selector=\"\'.assets-list\'\"></lateral-bar></div></div><div ng-if=\"valuations.isStatusView\"><div class=\"ibox-content paginator-loader no-padding valuation-status\"><div class=\"sk-spinner sk-spinner-circle\"><div class=\"sk-circle1 sk-circle\"></div><div class=\"sk-circle2 sk-circle\"></div><div class=\"sk-circle3 sk-circle\"></div><div class=\"sk-circle4 sk-circle\"></div><div class=\"sk-circle5 sk-circle\"></div><div class=\"sk-circle6 sk-circle\"></div><div class=\"sk-circle7 sk-circle\"></div><div class=\"sk-circle8 sk-circle\"></div><div class=\"sk-circle9 sk-circle\"></div><div class=\"sk-circle10 sk-circle\"></div><div class=\"sk-circle11 sk-circle\"></div><div class=\"sk-circle12 sk-circle\"></div></div><div class=\"col-lg-8 col-md-8 col-sm-8 col-xs-8 no-padding assets-list\" ng-class=\"{\'lateral-open\': valuations.lateralBarOpen, \'is-appraiser\': valuations.isAppraiser}\"><perfect-scrollbar class=\"scroller\" wheel-propagation=\"true\" wheel-speed=\"1\" min-scrollbar-length=\"20\"><table class=\"table valuation-status valuation-status-footable table-stripped toggle-arrow-tiny\" data-page-size=\"100000\" ng-class=\"{\'lateral-open\': valuations.lateralBarOpen}\"><thead><tr><th><div class=\"property-name\"><a translate=\"VALUATIONS.PROPERTY_NAME\" ng-click=\"valuations.sortingValuations(valuations.valuationStatusSort[0], \'valuationSelectedSort\')\" ng-class=\"{\'asc\': valuations.valuationStatusSort[0].flag, \'desc\': !valuations.valuationStatusSort[0].flag, \'not-selected\': !valuations.valuationStatusSort[0].selected}\"></a></div></th><th><div class=\"common-div\"><a translate=\"VALUATIONS.PROPERTY_TYPE\" ng-click=\"valuations.sortingValuations(valuations.valuationStatusSort[1], \'valuationSelectedSort\')\" ng-class=\"{\'asc\': valuations.valuationStatusSort[1].flag, \'desc\': !valuations.valuationStatusSort[1].flag, \'not-selected\': !valuations.valuationStatusSort[1].selected}\"></a></div></th><th><div class=\"common-div\"><a translate=\"VALUATIONS.V_PERIOD\" ng-click=\"valuations.sortingValuations(valuations.valuationStatusSort[2], \'valuationSelectedSort\')\" ng-class=\"{\'asc\': valuations.valuationStatusSort[2].flag, \'desc\': !valuations.valuationStatusSort[2].flag, \'not-selected\': !valuations.valuationStatusSort[2].selected}\"></a></div></th><th class=\"hide-on-open\"><div class=\"common-div lg\"><a translate=\"VALUATIONS.DRAFT_SUBMITTED_BY_APR\" ng-click=\"valuations.sortingValuations(valuations.valuationStatusSort[3], \'valuationSelectedSort\')\" ng-class=\"{\'asc\': valuations.valuationStatusSort[3].flag, \'desc\': !valuations.valuationStatusSort[3].flag, \'not-selected\': !valuations.valuationStatusSort[3].selected}\"></a></div></th><th class=\"hide-on-open\"><div class=\"common-div lg\"><a ng-click=\"valuations.sortingValuations(valuations.valuationStatusSort[4], \'valuationSelectedSort\')\" ng-class=\"{\'asc\': valuations.valuationStatusSort[4].flag, \'desc\': !valuations.valuationStatusSort[4].flag, \'not-selected\': !valuations.valuationStatusSort[4].selected}\">{{\"VALUATIONS.COMMENTS_SUBMITTED_BY_REV_TO_AM\" | translate}}</a></div></th><th class=\"hide-on-open\"><div class=\"common-div lg\"><a translate=\"VALUATIONS.COMMENTS_SUBMITTED_BY_AM\" ng-click=\"valuations.sortingValuations(valuations.valuationStatusSort[5], \'valuationSelectedSort\')\" ng-class=\"{\'asc\': valuations.valuationStatusSort[5].flag, \'desc\': !valuations.valuationStatusSort[5].flag, \'not-selected\': !valuations.valuationStatusSort[5].selected}\"></a></div></th><th class=\"hide-on-open\"><div class=\"common-div lg\"><a translate=\"VALUATIONS.COMMENTS_SUBMITTED_TO_APR\" ng-click=\"valuations.sortingValuations(valuations.valuationStatusSort[6], \'valuationSelectedSort\')\" ng-class=\"{\'asc\': valuations.valuationStatusSort[6].flag, \'desc\': !valuations.valuationStatusSort[6].flag, \'not-selected\': !valuations.valuationStatusSort[6].selected}\"></a></div></th><th class=\"hide-on-open\"><div class=\"common-div lg\"><a translate=\"VALUATIONS.RESPONSES_SUBMITTED_BY_APR\" ng-click=\"valuations.sortingValuations(valuations.valuationStatusSort[9], \'valuationSelectedSort\')\" ng-class=\"{\'asc\': valuations.valuationStatusSort[9].flag, \'desc\': !valuations.valuationStatusSort[9].flag, \'not-selected\': !valuations.valuationStatusSort[9].selected}\"></a></div></th><th><div class=\"common-div\"><a translate=\"VALUATIONS.VALUATION_APPROVED_BY_REV\" ng-click=\"valuations.sortingValuations(valuations.valuationStatusSort[10], \'valuationSelectedSort\')\" ng-class=\"{\'asc\': valuations.valuationStatusSort[10].flag, \'desc\': !valuations.valuationStatusSort[10].flag, \'not-selected\': !valuations.valuationStatusSort[10].selected}\"></a></div></th><th><div class=\"common-div\"><a translate=\"VALUATIONS.VALUATION_APPROVED_BY_AM\" ng-click=\"valuations.sortingValuations(valuations.valuationStatusSort[11], \'valuationSelectedSort\')\" ng-class=\"{\'asc\': valuations.valuationStatusSort[11].flag, \'desc\': !valuations.valuationStatusSort[11].flag, \'not-selected\': !valuations.valuationStatusSort[11].selected}\"></a></div></th><th><div class=\"common-div lg\"><a translate=\"VALUATIONS.VALUATION_SIGNED_OFF\" ng-click=\"valuations.sortingValuations(valuations.valuationStatusSort[12], \'valuationSelectedSort\')\" ng-class=\"{\'asc\': valuations.valuationStatusSort[12].flag, \'desc\': !valuations.valuationStatusSort[12].flag, \'not-selected\': !valuations.valuationStatusSort[12].selected}\"></a></div></th><th><div class=\"common-div lg\"><a translate=\"VALUATIONS.FINAL_DOCUMENTS_SUBMITTED\" ng-click=\"valuations.sortingValuations(valuations.valuationStatusSort[14], \'valuationSelectedSort\')\" ng-class=\"{\'asc\': valuations.valuationStatusSort[14].flag, \'desc\': !valuations.valuationStatusSort[14].flag, \'not-selected\': !valuations.valuationStatusSort[14].selected}\"></a></div></th><th><div class=\"common-div lg\"><a translate=\"VALUATIONS.FINAL_DOCUMENTS_REJECTED\" ng-click=\"valuations.sortingValuations(valuations.valuationStatusSort[16], \'valuationSelectedSort\')\" ng-class=\"{\'asc\': valuations.valuationStatusSort[16].flag, \'desc\': !valuations.valuationStatusSort[16].flag, \'not-selected\': !valuations.valuationStatusSort[16].selected}\"></a></div></th><th><div class=\"common-div\"><a translate=\"VALUATIONS.DOCUMENTS_SIGNED_OFF\" ng-click=\"valuations.sortingValuations(valuations.valuationStatusSort[15], \'valuationSelectedSort\')\" ng-class=\"{\'asc\': valuations.valuationStatusSort[15].flag, \'desc\': !valuations.valuationStatusSort[15].flag, \'not-selected\': !valuations.valuationStatusSort[15].selected}\"></a></div></th></tr></thead><tbody><tr ng-repeat=\"review in valuations.reviews\" ng-click=\"valuations.getReviewDetails(review)\" ng-class=\"{\'highlight\':review.displaying}\"><td><div class=\"property-name\">{{ review.asset.name || \"N/A\" }}</div></td><td><div class=\"common-div\">{{ valuations.abbrTypes(review.type) || \"N/A\" }}</div></td><td><div class=\"common-div\">{{ review.vPeriod }}</div></td><td class=\"hide-on-open\"><div class=\"common-div lg\">{{review.formFilledDate | date:\'MM/dd/yyyy\'}}</div></td><td class=\"hide-on-open\"><div class=\"common-div lg\">{{review.reviewerCommentedDate | date:\'MM/dd/yyyy\'}}</div></td><td class=\"hide-on-open\"><div class=\"common-div lg\">{{review.managerCommentedDate | date:\'MM/dd/yyyy\'}}</div></td><td class=\"hide-on-open\"><div class=\"common-div lg\">{{review.submittedToAppraiserDate | date:\'MM/dd/yyyy\'}}</div></td><td class=\"hide-on-open\"><div class=\"common-div lg\">{{review.valuationUpdatedDate | date:\'MM/dd/yyyy\'}}</div></td><td><div class=\"common-div\">{{review.reviewerApproveValuationDate | date:\'MM/dd/yyyy\'}}</div></td><td><div class=\"common-div\">{{review.managerApproveValuationDate | date:\'MM/dd/yyyy\'}}</div></td><td><div class=\"common-div lg\">{{review.valuationSignedOffDate | date:\'MM/dd/yyyy\'}}</div></td><td><div class=\"common-div lg\">{{review.finalFormFilledDate | date:\'MM/dd/yyyy\'}}</div></td><td><div class=\"common-div lg\">{{review.finalFilesRejectedDate | date:\'MM/dd/yyyy\'}}</div></td><td><div class=\"common-div\">{{review.finishedDate | date:\'MM/dd/yyyy\'}}</div></td></tr></tbody><tfoot><tr><td colspan=\"5\"><ul class=\"pagination pull-right\"></ul></td></tr></tfoot></table></perfect-scrollbar></div><lateral-bar show=\"valuations.lateralBarOpen\" config=\"valuations.lateralBarConfig\" on-close=\"valuations.closeDetails\" content-selector=\"\'.assets-list\'\"></lateral-bar></div></div></div><div class=\"paginator-container\"><uib-pagination total-items=\"valuations.reviewCount\" ng-model=\"valuations.currentPage\" class=\"pagination-sm\" max-size=\"valuations.maxPaginationSize\" items-per-page=\"valuations.perPage\" ng-change=\"valuations.changePage()\" boundary-link-numbers=\"true\" rotate=\"false\"></uib-pagination></div></div></div></div><script type=\"text/ng-template\" id=\"advanced-filters.html\"><div class=\"advanced-filters-wp fixed-height\"> <perfect-scrollbar class=\"scroller\" wheel-propagation=\"true\" min-scrollbar-length=\"20\"> <div class=\"modal-header\"> <h3 class=\"no-margins\">{{\"VALUATIONS.ADVANCE_FILTERS\" | translate}}</h3> </div> <div class=\"modal-body\"> <div class=\"row\"> <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\"> <div class=\"form-group block-select\"> <label translate=\"VALUATIONS.STATUS\"></label> <label class=\"clear-filter-btn\" ng-click=\"advancedFiltersCtrl.clearFilter(\'StatusFilter\')\"> {{\"VALUATIONS.CLEAR\" | translate}} </label> <div class=\"input-group\"> <select name=\"status\" class=\"form-control\" chosen multiple placeholder-text-multiple=\"\'Select Statuses\'\" ng-model=\"advancedFiltersCtrl.valuationFilters.StatusFilter\" ng-options=\"status.name for status in advancedFiltersCtrl.statusFilterOptions\"> <option value=\"\"></option> </select> </div> </div> </div> <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\"> <div class=\"form-group block-select\"> <label translate=\"VALUATIONS.QUARTER\"></label> <label class=\"clear-filter-btn\" ng-click=\"advancedFiltersCtrl.clearFilter(\'QuarterFilter\')\"> {{\"VALUATIONS.CLEAR\" | translate}} </label> <div class=\"input-group\"> <select name=\"quarter\" class=\"form-control\" chosen multiple placeholder-text-multiple=\"\'Select Quarters\'\" ng-model=\"advancedFiltersCtrl.valuationFilters.QuarterFilter\" ng-options=\"quarter.name for quarter in advancedFiltersCtrl.quartersOptions\"> <option value=\"\"></option> </select> </div> </div> </div> <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\"> <div class=\"form-group block-select\"> <label translate=\"VALUATIONS.YEAR\"></label> <label class=\"clear-filter-btn\" ng-click=\"advancedFiltersCtrl.clearFilter(\'YearFilter\')\"> {{\"VALUATIONS.CLEAR\" | translate}} </label> <div class=\"input-group\"> <select name=\"year\" class=\"form-control\" chosen multiple placeholder-text-multiple=\"\'Select Years\'\" ng-model=\"advancedFiltersCtrl.valuationFilters.YearFilter\"> <option value=\"\"></option> <option ng-repeat=\"year in advancedFiltersCtrl.yearsOptions\" [value]=\"year\">{{year}}</option> </select> </div> </div> </div> <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\"> <div class=\"form-group\"> <label translate=\"VALUATIONS.LEAD_REVIEWER\"></label> <input name=\"leadRW\" class=\"form-control\" ng-model=\"advancedFiltersCtrl.valuationFilters.LeadReviewerFilter\" translate translate-attr-placeholder=\"VALUATIONS.LEAD_REVIEWER\"> </div> </div> <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\" td-security=\"[\'Admin\', \'Audit\', \'AssetReview\', \'AssetManagement\', \'AssetManagerReadOnly\']\" action=\"display-none\"> <div class=\"form-group\"> <label translate=\"VALUATIONS.LEAD_AM\"></label> <input name=\"leadAM\" class=\"form-control\" ng-model=\"advancedFiltersCtrl.valuationFilters.LeadAMFilter\" translate translate-attr-placeholder=\"VALUATIONS.LEAD_AM\"> </div> </div> <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\" td-security=\"[\'Admin\', \'Audit\', \'AssetReview\', \'AssetAppraisal\']\" action=\"display-none\"> <div class=\"form-group\"> <label translate=\"VALUATIONS.LEAD_AP\"></label> <input name=\"leadAP\" class=\"form-control\" ng-model=\"advancedFiltersCtrl.valuationFilters.LeadAppraiserFilter\" translate translate-attr-placeholder=\"VALUATIONS.LEAD_AP\"> </div> </div> </div> <hr/> <div class=\"row\"> <div class=\"col-lg-5 col-md-5 col-sm-5 col-xs-5\"> <div class=\"form-group block-select\"> <label translate=\"VALUATIONS.PROPERTY_TYPE_FULL\"></label> <ul class=\"checkbox-filter\"> <li class=\"checkbox-li\" ng-repeat=\"type in advancedFiltersCtrl.propertyTypes\"> <checkbox ng-model=\"type.selected\"></checkbox> {{type.name}} </li> </ul> </div> </div> <div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3\"> <div class=\"form-group block-select\"> <label translate=\"VALUATIONS.PROPERTY_SUBTYPE\" ng-class=\"{\'label-disabled\': advancedFiltersCtrl.valuationFilters.PropertyTypeFilter.length==0}\"> </label> <label class=\"clear-filter-btn\" ng-class=\"{\'label-disabled\': advancedFiltersCtrl.valuationFilters.PropertyTypeFilter.length==0}\" ng-click=\"advancedFiltersCtrl.valuationFilters.PropertyTypeFilter.length!== 0 && advancedFiltersCtrl.clearFilter(\'PropertySubTypeFilter\')\"> {{\"VALUATIONS.CLEAR\" | translate}} </label> <select name=\"propSubtype\" class=\"form-control\" chosen multiple placeholder-text-multiple=\"\'Select Subtypes\'\" ng-model=\"advancedFiltersCtrl.valuationFilters.PropertySubTypeFilter\" ng-options=\"item.name for item in advancedFiltersCtrl.enabledPropertySubTypesOptions\" ng-disabled=\"advancedFiltersCtrl.valuationFilters.PropertyTypeFilter.length==0\"> <option style=\"display:none\" value=\"\" translate=\"VALUATIONS.SELECT_OPTION\"></option> </select> </div> </div> <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\"> <div class=\"form-group\"> <label translate=\"ADD_ASSET.OWNERSHIP_TYPE\"></label> <ul class=\"checkbox-filter\"> <li class=\"checkbox-li\" ng-repeat=\"type in advancedFiltersCtrl.OwnershipTypeFilterOptions\"> <checkbox ng-model=\"type.selected\"></checkbox> {{type.name}} </li> </ul> </div> </div> </div> <hr/> <div class=\"row\"> <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\"> <div class=\"form-group\"> <label translate=\"VALUATIONS.NET_RENTABLE\"></label> <slider-range min=\"{{advancedFiltersCtrl.NetRentableAreaFilterMinOptions}}\" max=\"{{advancedFiltersCtrl.NetRentableAreaFilterMaxOptions}}\" value-min=\"advancedFiltersCtrl.NetRentableAreaFilterMin\" value-max=\"advancedFiltersCtrl.NetRentableAreaFilterMax\"> </slider-range> </div> </div> <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\"> <div class=\"form-group\"> <label translate=\"VALUATIONS.VALUE\"></label> <slider-range min=\"{{advancedFiltersCtrl.ValueFilterMinOptions}}\" max=\"{{advancedFiltersCtrl.ValueFilterMaxOptions}}\" value-min=\"advancedFiltersCtrl.ValueFilterMin\" value-max=\"advancedFiltersCtrl.ValueFilterMax\" unit=\"$\"> </slider-range> </div> </div> <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\"> <div class=\"form-group\"> <label translate=\"VALUATIONS.PORTFOLIO\"></label> <input name=\"portfolio\" class=\"form-control\" ng-model=\"advancedFiltersCtrl.valuationFilters.PortfolioFilter\" translate translate-attr-placeholder=\"VALUATIONS.PORTFOLIO\"> </div> </div> <!-- <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\"> <div class=\"form-group\"> <label translate=\"VALUATIONS.LEAD_REVIEWER\"></label> <input name=\"leadRW\" class=\"form-control\" ng-model=\"advancedFiltersCtrl.valuationFilters.LeadReviewerFilter\" translate translate-attr-placeholder=\"VALUATIONS.LEAD_REVIEWER\"> </div> </div> <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\" td-security=\"[\'Admin\', \'Audit\', \'AssetReview\', \'AssetManagement\', \'AssetManagerReadOnly\']\" action=\"display-none\"> <div class=\"form-group\"> <label translate=\"VALUATIONS.LEAD_AM\"></label> <input name=\"leadAM\" class=\"form-control\" ng-model=\"advancedFiltersCtrl.valuationFilters.LeadAMFilter\" translate translate-attr-placeholder=\"VALUATIONS.LEAD_AM\"> </div> </div> <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\" td-security=\"[\'Admin\', \'Audit\', \'AssetReview\', \'AssetAppraisal\']\" action=\"display-none\"> <div class=\"form-group\"> <label translate=\"VALUATIONS.LEAD_AP\"></label> <input name=\"leadAP\" class=\"form-control\" ng-model=\"advancedFiltersCtrl.valuationFilters.LeadAppraiserFilter\" translate translate-attr-placeholder=\"VALUATIONS.LEAD_AP\"> </div> </div> --> </div> <hr/> <div class=\"row\"> <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\"> <div class=\"form-group block-select\"> <label translate=\"ADD_ASSET.COUNTRY\"></label> <ul class=\"checkbox-filter\"> <li class=\"checkbox-li\" ng-repeat=\"type in advancedFiltersCtrl.CountryFilterOptions\"> <checkbox ng-model=\"type.selected\"></checkbox> {{type.name}} </li> </ul> </div> </div> <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\"> <div class=\"form-group block-select\"> <label translate=\"ADD_ASSET.STATE\" ng-class=\"{\'label-disabled\': advancedFiltersCtrl.valuationFilters.CountryFilter.length == 0}\"> </label> <label class=\"clear-filter-btn\" ng-class=\"{\'label-disabled\': advancedFiltersCtrl.valuationFilters.CountryFilter.length == 0}\" ng-click=\"advancedFiltersCtrl.valuationFilters.CountryFilter.length !== 0 && advancedFiltersCtrl.clearFilter(\'StateFilter\')\"> {{\"VALUATIONS.CLEAR\" | translate}} </label> <select name=\"state\" class=\"form-control\" chosen multiple placeholder-text-multiple=\"\'Select States\'\" ng-model=\"advancedFiltersCtrl.valuationFilters.StateFilter\" ng-options=\"state.name for state in advancedFiltersCtrl.enabledStates\" ng-disabled=\"advancedFiltersCtrl.valuationFilters.CountryFilter.length == 0\"> <option style=\"display:none\" value=\"\" translate=\"VALUATIONS.SELECT_OPTION\"></option> </select> </div> </div> <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\"> <div class=\"form-group block-select\"> <label translate=\"ADD_ASSET.CITY\" ng-class=\"{\'label-disabled\': advancedFiltersCtrl.valuationFilters.StateFilter.length == 0}\"> </label> <label class=\"clear-filter-btn\" ng-class=\"{\'label-disabled\': advancedFiltersCtrl.valuationFilters.StateFilter.length == 0}\" ng-click=\"advancedFiltersCtrl.valuationFilters.StateFilter.length !== 0\"> </label> <input name=\"city\" class=\"form-control\" ng-model=\"advancedFiltersCtrl.valuationFilters.CityFilter\" translate translate-attr-placeholder=\"ADD_ASSET.CITY\" ng-disabled=\"advancedFiltersCtrl.valuationFilters.StateFilter.length == 0\"> </div> </div> </div> <div class=\"row\"> <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\"> <div class=\"form-group block-select\"> <label translate=\"ADD_ASSET.MSA\" ng-class=\"{\'label-disabled\': !advancedFiltersCtrl.enableMSA}\"> </label> <label class=\"clear-filter-btn\" ng-class=\"{\'label-disabled\': !advancedFiltersCtrl.enableMSA}\" ng-click=\"advancedFiltersCtrl.enableMSA && advancedFiltersCtrl.clearFilter(\'MSAFilter\')\"> {{\"VALUATIONS.CLEAR\" | translate}} </label> <select name=\"msa\" class=\"form-control\" chosen multiple placeholder-text-multiple=\"\'Select MSAs\'\" ng-model=\"advancedFiltersCtrl.valuationFilters.MSAFilter\" ng-options=\"type for type in advancedFiltersCtrl.enabledMSAOptions\" ng-disabled=\"!advancedFiltersCtrl.enableMSA\"> <option style=\"display:none\" value=\"\" translate=\"VALUATIONS.SELECT_OPTION\"></option> </select> </div> </div> <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\"> <div class=\"form-group block-select\"> <label translate=\"ADD_ASSET.NCREIF\"></label> <label class=\"clear-filter-btn\" ng-click=\"advancedFiltersCtrl.clearFilter(\'NCREIFFilter\')\"> {{\"VALUATIONS.CLEAR\" | translate}} </label> <select name=\"ncreif\" class=\"form-control\" chosen multiple placeholder-text-multiple=\"\'Select NCREIFs\'\" ng-model=\"advancedFiltersCtrl.valuationFilters.NCREIFFilter\" ng-options=\"item.name for item in advancedFiltersCtrl.NCREIFFilterOptions\"> <option style=\"display:none\" value=\"\" translate=\"VALUATIONS.SELECT_OPTION\"></option> </select> </div> </div> </div> </div> <div class=\"modal-footer\"> <div class=\"row text-right\"> <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"> <button class=\"btn btn-w-m btn-back\" ng-click=\"advancedFiltersCtrl.cancel()\"> {{\"VALUATIONS.CANCEL\" | translate}} </button> <button class=\"btn btn-w-m btn-back\" ng-click=\"advancedFiltersCtrl.clearAllFilters()\"> {{\"VALUATIONS.CLEAR_ALL\" | translate}} </button> <button class=\"btn btn-w-m btn-normal m-l-sm\" ng-click=\"advancedFiltersCtrl.applyFilters()\"> {{\"VALUATIONS.APPLY_FILTERS\" | translate}} </button> </div> </div> </div> </perfect-scrollbar> </div></script></section>");
$templateCache.put("app/states/reset-password/reset-password.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><h2 translate=\"RESET_PASSWORD.RESET_PASSWORD\"></h2></div></div><div class=\"wrapper wrapper-content\" nvc-full-page=\"\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><h4 translate=\"RESET_PASSWORD.RESET_PASSWORD\"></h4></div></div><div class=\"ibox-content\"><perfect-scrollbar class=\"scroller\" suppress-scroll-x=\"true\" wheel-propagation=\"true\" wheel-speed=\"1\" min-scrollbar-length=\"20\"><div class=\"row row-eq-height no-button\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6 side-panel right-side\"><form name=\"resetPasswordForm\" class=\"reset-password-form\" role=\"form\" ng-submit=\"resetPassword.submitForm()\" novalidate=\"\"><div class=\"row\"><div class=\"col-lg-8 col-md-8 col-sm-8 col-xs-8\"><div class=\"form-group\"><label translate=\"RESET_PASSWORD.NEW_PASSWORD\"></label> <input name=\"newPassword\" type=\"password\" class=\"form-control\" ng-model=\"resetPassword.formData.password\" ng-pattern=\"/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?!.*[#?!@$%^&*-]).{8,}$/\" required=\"\"><div ng-messages=\"resetPasswordForm.newPassword.$error\"><div ng-message=\"required\" translate=\"RESET_PASSWORD.PASSWORD_REQ\"></div><div ng-message=\"pattern\" translate=\"RESET_PASSWORD.PATTERN\"></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-8 col-md-8 col-sm-8 col-xs-8\"><div class=\"form-group\"><label translate=\"RESET_PASSWORD.CONFIRM_PASSWORD\"></label> <input name=\"confirmPassword\" type=\"password\" class=\"form-control\" ng-model=\"resetPassword.formData.confirmPassword\" match-field=\"newPassword\" required=\"\"><div ng-messages=\"resetPasswordForm.confirmPassword.$error\"><div ng-show=\"resetPassword.submitted\" ng-message=\"required\" translate=\"RESET_PASSWORD.CONFIRM_PASSWORD_REQ\"></div><div ng-show=\"resetPasswordForm.$invalid\" ng-message=\"match\" translate=\"RESET_PASSWORD.CONFIRM_PASSWORD_MATCH_PASSWORD\"></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><button translate=\"RESET_PASSWORD.CHANGE_PASSWORD\" type=\"submit\" class=\"btn btn-warning btn-block\"></button></div></div></div></form><br><div class=\"alert alert-success\" ng-if=\"resetPassword.submitted && resetPassword.successful\" translate=\"RESET_PASSWORD.SUCCESS_MESSAGE\"></div><div class=\"alert alert-danger\" ng-if=\"resetPassword.submitted && resetPassword.failed\" translate=\"RESET_PASSWORD.FAILED_MESSAGE\"></div></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6 side-panel left-side\"><h2 class=\"remember\" translate=\"RESET_PASSWORD.REMEMBER\"></h2><div class=\"notes\" translate=\"RESET_PASSWORD.NOTES\"></div></div></div></perfect-scrollbar></div></div></div></div></div>");
$templateCache.put("app/states/reset-password/topnavbar.html","<div class=\"row border-bottom\"><nav class=\"navbar navbar-fixed-top\" role=\"navigation\" style=\"margin-bottom: 0; height: 70px\"><div class=\"navbar-header\"><div class=\"logo\"><span class=\"name\">Velocity</span> <span>Management System</span></div></div></nav></div>");
$templateCache.put("app/components/commons/expand-image-modal/expand-image-modal.html","<div class=\"inmodal expand-image\"><div class=\"modal-header\"><span class=\"title\">{{asset.name}}</span></div><div class=\"modal-body\"><div class=\"img-area\"><img ng-src=\"{{asset.picture}}\" width=\"540\" alt=\"Asset picture\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-navy\" ng-click=\"close()\" translate=\"ASSET_DETAILS.CLOSE\"></button></div></div>");
$templateCache.put("app/components/commons/footer/footer.html","<div class=\"footer\"><div class=\"pull-right\">10GB of <strong>250GB</strong> Free.</div><div><strong>Copyright</strong> Example Company &copy; 2015-2016</div></div>");
$templateCache.put("app/components/commons/header-section/header-section.html","<section class=\"row wrapper border-bottom white-bg page-heading ng-scope section-header d-flex justify-contnet-between\"><div class=\"justify-space-between-div\"><div><h2 class=\"section-title\" title=\"{{breadcrumbTitle}}\" ng-bind-html=\"breadcrumbTitle\"></h2><ol class=\"breadcrumb\"><li ng-repeat=\"breadcrumb in breadcrumbs\" title=\"{{breadcrumb.label}}\" ui-sref=\"{{breadcrumb.value}}\"><a>{{breadcrumb.label}}</a></li></ol></div><div class=\"text-right right-div\"><a class=\"btn btn-w-m btn-normal\" ng-if=\"isAsset==false\" ui-sref-opts=\"{reload: true}\" ui-sref=\"app.asset.assetDetails.documentsHistory({valuationId: valuationId})\" translate=\"DOCUMENTS_HISTORY.HISTORY\"></a> <a class=\"btn btn-w-m btn-normal\" ng-if=\"isAsset==true\" ui-sref-opts=\"{reload: true}\" ui-sref=\"app.asset.assetDetails({assetId : assetId})\" translate=\"RESPONSE_SUMMARY.ASSET\"></a></div></div></section>");
$templateCache.put("app/components/commons/loader/loader-short.template.html","<div class=\"loading-short\"><div class=\"spiner-container\"><div class=\"sk-spinner sk-spinner-cube-grid\"><div class=\"sk-cube\"></div><div class=\"sk-cube\"></div><div class=\"sk-cube\"></div><div class=\"sk-cube\"></div><div class=\"sk-cube\"></div><div class=\"sk-cube\"></div><div class=\"sk-cube\"></div><div class=\"sk-cube\"></div><div class=\"sk-cube\"></div></div></div></div>");
$templateCache.put("app/components/commons/loader/loader.template.html","<div><p translate=\"COMMONS.LOADING\"></p><div class=\"spiner-container\"><div class=\"sk-spinner sk-spinner-cube-grid\"><div class=\"sk-cube\"></div><div class=\"sk-cube\"></div><div class=\"sk-cube\"></div><div class=\"sk-cube\"></div><div class=\"sk-cube\"></div><div class=\"sk-cube\"></div><div class=\"sk-cube\"></div><div class=\"sk-cube\"></div><div class=\"sk-cube\"></div></div></div></div>");
$templateCache.put("app/components/commons/topnavbar/topnavbar.html","<div class=\"row border-bottom\"><nav class=\"navbar navbar-fixed-top\" role=\"navigation\" style=\"margin-bottom: 0; height: 70px\"><div class=\"navbar-header\"><span minimaliza-sidebar=\"\"></span><div class=\"logo\"><span class=\"name\">Velocity</span> <span>Management System</span></div><div class=\"company-dropdown\" ng-if=\"topnavbar.displayCompanies\"><select ng-disabled=\"topnavbar.companiesDropdownDisabled\" name=\"companies\" class=\"form-control\" chosen=\"\" ng-model=\"topnavbar.company\" ng-options=\"company as company.name for company in topnavbar.companies | orderBy: \'name\' track by company.id\" required=\"\"></select></div></div><ul class=\"nav navbar-top-links navbar-right\"><li><a href=\"\" ng-click=\"topnavbar.logout()\" class=\"logout\"><i class=\"icon icon-ic-logout\"></i> <span>Log out</span></a></li></ul></nav></div>");
$templateCache.put("app/components/commons/navigation/navigation.html","<nav class=\"navigation navbar-default navbar-static-side\" role=\"navigation\"><div class=\"sidebar-collapse\"><ul side-navigation=\"\" class=\"nav metismenu\" id=\"side-menu\"><li class=\"nav-header\"><div class=\"dropdown profile-element\" uib-dropdown=\"\"><div class=\"avatar\" ng-class=\"\'avatar-\' + navigation.userRoleClass\">{{ navigation.userName|initials }}</div><a uib-dropdown-toggle=\"\" href=\"\"><span class=\"clear\"><span class=\"block m-t-xs\"><strong class=\"font-bold\">{{navigation.userName}}</strong></span> <span class=\"text-muted text-xs block\">{{navigation.userRole}}<b class=\"caret\"></b></span></span></a><ul class=\"dropdown-menu animated m-t-xs\" uib-dropdown-menu=\"\"><li class=\"company-option\" ng-click=\"navigation.changeRole(navigation.availableRoles[$index], navigation.companyNames[$index])\" ng-repeat-start=\"role in navigation.availableRolesTypes track by $index\"><a>{{role}}</a> <span>{{navigation.companyNames[$index]}}</span></li><li class=\"divider\" ng-repeat-end=\"\"></li><li ng-click=\"navigation.logout()\"><a>Log out</a></li></ul></div><div class=\"logo-element\"><div class=\"avatar\" ng-class=\"\'avatar-\' + navigation.userRoleClass\">{{ navigation.userName|initials }}</div></div></li><li ng-repeat=\"state in navigation.states\" class=\"navigation-list\" ui-sref-active=\"current\" td-security=\"state.allow\" action=\"display-none\" ng-class=\"{current: state.children && navigation.isChildActive(state.children)}\"><a ng-if=\"!state.children\" ui-sref=\"{{state.state}}\"><i class=\"\" ng-class=\"state.iconClass\"></i> <span class=\"nav-label\" translate=\"{{state.name}}\"></span></a> <a ng-if=\"state.children\" ng-class=\"{\'parent\':state.children}\"><i class=\"\" ng-class=\"state.iconClass\"></i> <span class=\"nav-label\" translate=\"{{state.name}}\"></span> <span class=\"fa arrow\"></span></a><ul ng-if=\"state.children\" class=\"nav nav-second-level collapse\"><li ui-sref-active=\"current\" ng-repeat=\"child in state.children\" td-security=\"child.allow\" action=\"display-none\"><a ui-sref=\"{{child.state}}\" translate=\"{{child.name}}\"></a></li></ul></li></ul></div></nav>");
$templateCache.put("app/components/directives/lateral-bar/lateral-bar.html","<div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 lateral-content full-height no-padding\"><div class=\"col-lg-1 no-padding lateral-bar full-height\" du-scroll-container=\"scroll-container\"><span class=\"icon icon-ic-draglines drag\"></span> <a ng-repeat=\"icon in icons\" class=\"icon\" ng-class=\"icon.class\" ng-href=\"#{{icon.anchor}}\" du-smooth-scroll=\"\" du-scrollspy=\"\"></a></div><div class=\"close-lateral icon icon-ic-close\" ng-click=\"close()\"></div><perfect-scrollbar class=\"scroller\" wheel-propagation=\"true\" wheel-speed=\"1\" min-scrollbar-length=\"20\" id=\"scroll-container\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 p-m full-height lateral-container\"></div></perfect-scrollbar></div>");
$templateCache.put("app/components/directives/nvc-avatar/avatar.html","<div class=\"avatar\" ng-class=\"avatarDirectiveCtrl.avatarClass\"><span>{{ avatarDirectiveCtrl.name | initials }}</span></div>");
$templateCache.put("app/components/directives/nvc-current-action/nvc-current-action.html","<div ng-if=\"currentActionCtrl.name\" class=\"avatar\" ng-class=\"currentActionCtrl.avatarClass\">{{ currentActionCtrl.name | initials }}</div>");
$templateCache.put("app/components/directives/nvc-latest-action/nvc-latest-action.html","<div class=\"latest-action\" ng-class=\"{overdue: latestActionCtrl.overdue, completed: latestActionCtrl.completed}\">{{latestActionCtrl.latestAction}}</div>");
$templateCache.put("app/components/directives/td-image-upload/td-image-upload.html","<div class=\"td-image-upload image\" style=\"background-image: url(\'{{croppedPhotoData}}\')\"><div class=\"error\"><div ng-repeat=\"error in errors\">{{error}}<br></div></div><div file-button=\"\" class=\"upload-btn\"><button class=\"btn btn-normal btn-sm\" translate=\"TD_IMAGE_UPLOAD.SELECT_FILE\"></button> <input type=\"file\" name=\"picture\" accept=\"image/*\" ng-model=\"selectedPhotoFile\" required=\"\"></div><div class=\"dropzone\"></div></div>");
$templateCache.put("app/components/directives/td-file-upload/td-file-upload.html","<div class=\"td-file-upload documents\" data-dropping-class=\"dropping\"><div class=\"file-list\"><div class=\"file-name\" ng-repeat=\"file in files\"><span style=\"width: 35%\">{{file.name}}</span> <span ng-if=\"file.name.split(\'.\').pop() === \'avux\'\"><select ng-model=\"selectedpremiseoption\" ng-change=\"premiseselection($index, selectedpremiseoption)\" ng-options=\"item.name for item in premiseoptions\"><option value=\"\" disabled=\"\" selected=\"\">Choose a premise</option></select></span> <a class=\"btn btn-back\" ng-click=\"uiDelete($index)\"><i class=\"icon icon-ic-trash-delete\"></i></a></div></div><div class=\"error\"><div class=\"error-file\" ng-repeat=\"error in errors\">{{error}}<a class=\"btn btn-back\" ng-click=\"uiDeleteError($index)\"><i class=\"icon icon-ic-trash-delete\"></i></a><br></div></div><div file-button=\"\" class=\"upload-btn\"><button class=\"btn btn-normal btn-sm\" translate=\"TD_FILE_UPLOAD.SELECT_FILE\"></button> <input type=\"file\" ng-model=\"files\" multiple=\"\"></div><div class=\"dropzone\"></div></div>");
$templateCache.put("app/states/assets/add-asset/add-asset.html","<header-section breadcrumb-title=\"addAsset.title\" breadcrumbs=\"addAsset.breadcrumbs\"></header-section><div class=\"wrapper wrapper-content\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><h4 translate=\"ADD_ASSET.INFORMATION\"></h4></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><form name=\"addAsset.addAssetForm\" class=\"add-asset-form\" role=\"form\" ng-submit=\"addAsset.submitForm()\" confirm-leave=\"\" novalidate=\"\"><div class=\"row\"><div class=\"col-lg-4 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><label translate=\"ADD_ASSET.NAME\"></label> <input name=\"name\" class=\"form-control\" ng-model=\"addAsset.asset.name\" translate=\"\" translate-attr-placeholder=\"ADD_ASSET.NAME_PH\" required=\"\"><div ng-show=\"addAsset.submitted\" ng-messages=\"addAssetForm.name.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div></div></div></div><div class=\"col-lg-2 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><label translate=\"ADD_ASSET.ID\"></label> <input name=\"id\" class=\"form-control\" ng-model=\"addAsset.asset.propertyRef\" translate=\"\" translate-attr-placeholder=\"ADD_ASSET.ID_PH\" required=\"\"><div ng-show=\"addAsset.submitted\" ng-messages=\"addAssetForm.id.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div></div><div ng-show=\"addAsset.submitted && addAsset.duplicateId\" class=\"has-error\" translate=\"ADD_ASSET.DUPLICATE_ID\"></div></div></div><div class=\"col-lg-3 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group block-select\" ng-class=\"{\'invalid-select\': addAsset.addAssetForm.type.$invalid && addAsset.addAssetForm.$submitted}\"><label translate=\"ADD_ASSET.TYPE\"></label><select name=\"type\" class=\"form-control\" chosen=\"\" ng-model=\"addAsset.asset.type\" ng-options=\"type.name for type in addAsset.propertyTypes\" required=\"\"><option style=\"display:none\" value=\"\" translate=\"ADD_ASSET.TYPE_PH\"></option></select><div ng-show=\"addAsset.submitted\" ng-messages=\"addAssetForm.type.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div></div></div></div><div class=\"col-lg-3 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group block-select\" ng-class=\"{\'invalid-select\': addAsset.addAssetForm.subtype.$invalid && addAsset.addAssetForm.$submitted}\"><label translate=\"ADD_ASSET.SUBTYPE\"></label><select name=\"subtype\" class=\"form-control\" chosen=\"\" ng-model=\"addAsset.asset.subType\" ng-options=\"item.name for item in addAsset.subtypesByPropertyTypes[addAsset.asset.type.type]\" ng-disabled=\"addAsset.asset.type==undefined\"><option style=\"display:none\" value=\"\" translate=\"ADD_ASSET.SUBTYPE_PH\"></option></select><div ng-show=\"addAsset.submitted\" ng-messages=\"addAssetForm.subtype.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-4 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group\"><label translate=\"ADD_ASSET.ADDRESS\"></label> <input name=\"address\" class=\"form-control\" ng-model=\"addAsset.asset.address\" translate=\"\" translate-attr-placeholder=\"ADD_ASSET.ADDRESS_PH\" required=\"\"><div ng-show=\"addAsset.submitted\" ng-messages=\"addAssetForm.address.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div></div></div></div><div class=\"col-lg-2 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group block-select\" ng-class=\"{\'invalid-select\': addAsset.addAssetForm.country.$invalid && addAsset.addAssetForm.$submitted}\"><label translate=\"ADD_ASSET.COUNTRY\"></label><select name=\"country\" class=\"form-control\" ng-options=\"country for country in addAsset.countries\" chosen=\"\" ng-model=\"addAsset.asset.country\" required=\"\"><option style=\"display:none\" value=\"\" translate=\"ADD_ASSET.COUNTRY_PH\"></option></select><div ng-show=\"addAsset.submitted\" ng-messages=\"addAssetForm.country.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div></div></div></div><div class=\"col-lg-2 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group block-select\" ng-class=\"{\'invalid-select\': addAsset.addAssetForm.state.$invalid && addAsset.addAssetForm.$submitted}\"><label translate=\"ADD_ASSET.STATE\"></label><select name=\"state\" class=\"form-control\" chosen=\"\" ng-options=\"item for item in addAsset.statesByCountry[addAsset.asset.country]\" ng-model=\"addAsset.asset.state\" required=\"\"><option style=\"display:none\" value=\"\" translate=\"ADD_ASSET.STATE_PH\"></option></select><div ng-show=\"addAsset.submitted\" ng-messages=\"addAssetForm.state.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div></div></div></div><div class=\"col-lg-2 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group block-select\" ng-class=\"{\'invalid-select\': addAsset.addAssetForm.city.$invalid && addAsset.addAssetForm.$submitted}\"><label translate=\"ADD_ASSET.CITY\"></label> <input name=\"city\" class=\"form-control\" ng-model=\"addAsset.asset.city\" translate=\"\" translate-attr-placeholder=\"ADD_ASSET.CITY_PH\" required=\"\"><div ng-show=\"addAsset.submitted\" ng-messages=\"addAssetForm.city.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div></div></div></div><div class=\"col-lg-2 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><label translate=\"ADD_ASSET.ZIPCODE\"></label> <input name=\"zipCode\" class=\"form-control\" ng-model=\"addAsset.asset.zip\" ng-pattern=\"/^[0-9]*$/\" maxlength=\"5\" translate=\"\" translate-attr-placeholder=\"ADD_ASSET.ZIPCODE_PH\" required=\"\"><div ng-show=\"addAsset.submitted\" ng-messages=\"addAssetForm.zipCode.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div></div></div></div></div><hr><div class=\"row\"><div class=\"col-lg-3 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group\"><label translate=\"ADD_ASSET.PHOTO\"></label><td-image-upload cropped-photo-data=\"addAsset.picture\"></td-image-upload></div></div><div class=\"col-lg-9 col-md-12 col-sm-12 col-xs-12\"><div class=\"row\" td-security=\"[\'Admin\']\" action=\"display-none\"><div class=\"col-lg-8 col-md-8 col-sm-8 col-xs-8\"><div class=\"form-group block-select\" ng-class=\"{\'invalid-select\': addAsset.addAssetForm.biddingGroup.$invalid && addAsset.addAssetForm.$submitted}\"><label translate=\"ADD_ASSET.BIDDING_GROUP\"></label><select name=\"biddingGroup\" chosen=\"\" class=\"form-control\" ng-model=\"addAsset.asset.bidGroupId\" ng-options=\"group.name for group in addAsset.biddingGroups\"><option style=\"display:none\" value=\"\" translate=\"ADD_ASSET.BIDDING_GROUP_PH\"></option></select><div ng-show=\"addAsset.submitted\" ng-messages=\"addAssetForm.biddingGroup.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div></div></div></div><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\"><div class=\"form-group\"><label>&nbsp;</label><div><button class=\"btn btn-w-all btn-normal\" ui-sref=\"app.asset.bidGroups.addBidGroup\">{{\'ADD_ASSET.CREATE_BIDDING_GROUP\' | translate}}</button></div></div></div></div><div class=\"row\"><div class=\"col-lg-5 col-md-5 col-sm-5 col-xs-5\"><div class=\"form-group block-select\" ng-class=\"{\'invalid-select\': addAsset.addAssetForm.assetPrimaryContact.$invalid && addAsset.addAssetForm.$submitted}\"><label translate=\"ADD_ASSET.LEAD_ASSET_MANAGER\"></label><select name=\"assetPrimaryContact\" class=\"form-control\" chosen=\"\" ng-model=\"addAsset.leadAssetManager\" ng-options=\"user as user.user.name for user in addAsset.assetsManagers track by user.id\"><option style=\"display:none\" value=\"\" translate=\"ADD_ASSET.LEAD_ASSET_MANAGER_PH\"></option></select><div ng-show=\"addAsset.submitted\" ng-messages=\"addAssetForm.primaryContact.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div></div></div></div><div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3\"><div class=\"form-group\"><label translate=\"ADD_ASSET.CONTACT_PHONE\"></label> <input name=\"phone\" type=\"tel\" class=\"form-control\" ng-model=\"addAsset.leadAssetManager.userAccount.officePhone\" disabled=\"\"></div></div><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\"><div class=\"form-group\"><label translate=\"ADD_ASSET.CONTACT_EMAIL\"></label> <input name=\"email\" type=\"email\" class=\"form-control\" ng-model=\"addAsset.leadAssetManager.userAccount.email\" disabled=\"\"></div></div></div><div class=\"row\" td-security=\"[\'Admin\']\" action=\"hidden\"><div class=\"col-lg-5 col-md-5 col-sm-5 col-xs-5\"><div class=\"form-group block-select\" ng-class=\"{\'invalid-select\': addAsset.addAssetForm.reviewerPrimaryContact.$invalid && addAsset.addAssetForm.$submitted}\"><label translate=\"ADD_ASSET.LEAD_REVIEWER\"></label><select name=\"reviewerPrimaryContact\" class=\"form-control\" chosen=\"\" ng-model=\"addAsset.leadReviewer\" ng-options=\"user as user.user.name for user in addAsset.reviewers track by user.id\" td-security=\"[\'Admin\']\" action=\"hidden\"><option style=\"display:none\" value=\"\" translate=\"ADD_ASSET.LEAD_REVIEWER_PH\"></option></select><div ng-show=\"addAsset.submitted\" ng-messages=\"addAssetForm.primaryContact.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div></div></div></div><div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3\"><div class=\"form-group\"><label translate=\"ADD_ASSET.CONTACT_PHONE\"></label> <input name=\"phone\" type=\"tel\" class=\"form-control\" ng-model=\"addAsset.leadReviewer.userAccount.officePhone\" disabled=\"\"><div ng-show=\"addAsset.submitted\" ng-messages=\"addAssetForm.phone.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div><div ng-message=\"tel\" translate=\"ADD_ASSET.FIELD_INVALID\"></div></div></div></div><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\"><div class=\"form-group\"><label translate=\"ADD_ASSET.CONTACT_EMAIL\"></label> <input name=\"email\" type=\"email\" class=\"form-control\" ng-model=\"addAsset.leadReviewer.userAccount.email\" disabled=\"\"><div ng-show=\"addAsset.submitted\" ng-messages=\"addAssetForm.email.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div><div ng-message=\"email\" translate=\"ADD_ASSET.FIELD_INVALID\"></div></div></div></div></div></div></div><hr><div class=\"row\"><div class=\"col-lg-2 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group block-select\" ng-class=\"{\'invalid-select\': addAsset.addAssetForm.requiredAppraisers.$invalid && addAsset.addAssetForm.$submitted}\"><label translate=\"ADD_ASSET.REQUIRED_APPRAISERS\"></label><select name=\"requiredAppraisers\" class=\"form-control\" ng-options=\"item.name for item in addAsset.requiredAppraisers\" chosen=\"\" ng-model=\"addAsset.asset.requiredAppraisers\" ng-required=\"true\"><option style=\"display:none\" value=\"\" translate=\"ADD_ASSET.REQUIRED_APPRAISERS_PH\"></option></select><div ng-show=\"addAsset.submitted\" ng-messages=\"addAssetForm.requiredAppraisers.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div></div></div></div><div class=\"col-lg-4 col-md-6 col-sm-6 col-xs-6\" ng-if=\"addAsset.asset.requiredAppraisers.value === \'InternalAndExternal\'\"><div class=\"form-group block-select\"><label translate=\"ADD_ASSET.INTERNAL_APPRAISERS\"></label><select name=\"internalAppraisers\" class=\"form-control\" chosen=\"\" multiple=\"\" placeholder-text-multiple=\"\'Select Internal Appraisers\'\" ng-model=\"addAsset.asset.internalAppraisers\" ng-options=\"user as user.user.name for user in addAsset.internalAppraisers track by user.id\" td-security=\"[\'Admin\']\" max-selected-options=\"2\"><option style=\"display:none\" value=\"\" translate=\"ADD_ASSET.INTERNAL_APPRAISERS_PH\"></option></select><div ng-show=\"addAsset.submitted\" ng-messages=\"addAssetForm.internalAppraisers.$error\"></div></div></div></div><div class=\"row\"><div class=\"col-xs-5 no-padding\"><div class=\"col-xs-5\"><div class=\"form-group inline-dropdown\"><label translate=\"ADD_ASSET.ROLLOVER_DATE\"></label><div class=\"input-group\"><input name=\"rolloverDate\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"MM/dd/yyyy\" is-open=\"addAsset.overDuePicker.opened\" datepicker-options=\"addAsset.dateOptions\" ng-model=\"addAsset.asset.rollOverDate\" ng-model-options=\"addAsset.modelOptions\" ng-class=\"{\'ng-invalid\': !addAsset.validRollOverDate || addAsset.addAssetForm.rollOverDate.$invalid && addAsset.addAssetForm.$submitted}\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" type=\"button\" ng-click=\"addAsset.openDueDatePicker()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div ng-show=\"(addAsset.submitted && !addAsset.validRollOverDate)|| !addAsset.validRollOverDate\"><div class=\"invalid-rollover-date\" translate=\"ADD_ASSET.INVALID_YEARLY_DATE\"></div></div></div><div class=\"col-xs-6\"><div class=\"form-group inline-dropdown\" ng-class=\"{\'invalid-select\': addAsset.addAssetForm.valuationFrequency.$invalid && addAsset.addAssetForm.$submitted}\"><label translate=\"ADD_ASSET.VALUATION_FREQUENCY\"></label><select name=\"valuationFrequency\" class=\"form-control\" chosen=\"\" placeholder-text-multiple=\"\'Select Frequency\'\" ng-model=\"addAsset.asset.valuationFrequency\" ng-options=\"item.name for item in addAsset.valuationFrequency\" required=\"\"><option style=\"display:none\" value=\"\" translate=\"ADD_ASSET.VALUATION_FREQUENCY\"></option></select></div></div></div><div class=\"col-xs-7\" ng-if=\"addAsset.asset.valuationFrequency.value === \'Annually\'\"><div class=\"col-xs-4\"><div class=\"form-group\"><label translate=\"ADD_ASSET.ANNUAL_DRAFT_AND_VALUATION\"></label><div class=\"input-group\"><input name=\"quarter1\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"MM/dd/yyyy\" is-open=\"addAsset.q1Picker.opened\" datepicker-options=\"addAsset.dateOptions\" ng-model=\"addAsset.asset.scheduleQ1\" placeholder=\"Select Date\" ng-model-options=\"addAsset.modelOptions\" td-month-range-validation=\"\" date-from=\"01/01\" date-to=\"12/31\" date-format=\"MM/DD/YYYY\" ignore-year=\"\" ng-required=\"addAsset.asset.valuationFrequency.value === \'Annually\'\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" type=\"button\" ng-click=\"addAsset.openQ1Picker()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-messages=\"addAsset.addAssetForm.quarter1.$error\" ng-show=\"addAsset.submitted && addAsset.asset.valuationFrequency.value === \'Annually\'\"><div ng-message=\"tdMonthRangeValidation\" translate=\"ADD_ASSET.INVALID_YEARLY_DATE\"></div></div></div></div></div><div class=\"col-xs-4 no-padding-right\" ng-if=\"addAsset.asset.valuationFrequency.value === \'SemiAnnually\'\"><div class=\"col-xs-6 no-padding-right\"><div class=\"form-group\"><label translate=\"ADD_ASSET.FIRST_DRAFT_DUE_DATE\"></label><div class=\"input-group\"><input name=\"quarter1\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"MM/dd/yyyy\" is-open=\"addAsset.q1Picker.opened\" datepicker-options=\"addAsset.dateOptions\" ng-model=\"addAsset.asset.scheduleQ1\" placeholder=\"Select Date\" ng-model-options=\"addAsset.modelOptions\" td-month-range-validation=\"\" date-from=\"01/01\" date-to=\"12/31\" date-format=\"MM/DD/YYYY\" ignore-year=\"\" ng-required=\"addAsset.asset.valuationFrequency.value === \'SemiAnnually\'\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" type=\"button\" ng-click=\"addAsset.openQ1Picker()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-messages=\"addAsset.addAssetForm.quarter1.$error\" ng-show=\"addAsset.submitted\"><div ng-message=\"tdMonthRangeValidation\" translate=\"ADD_ASSET.INVALID_SEMI_ANNUAL\"></div></div></div></div><div class=\"col-xs-6 no-padding-right\"><div class=\"form-group\"><label translate=\"ADD_ASSET.SECOND_DRAFT_DUE_DATE\"></label><div class=\"input-group\"><input name=\"quarter2\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"MM/dd/yyyy\" is-open=\"addAsset.q2Picker.opened\" datepicker-options=\"addAsset.dateOptions\" ng-model=\"addAsset.asset.scheduleQ2\" placeholder=\"Select Date\" ng-model-options=\"addAsset.modelOptions\" td-month-range-validation=\"\" date-from=\"01/01\" date-to=\"12/31\" date-format=\"MM/DD/YYYY\" ignore-year=\"\" ng-required=\"addAsset.asset.valuationFrequency.value === \'SemiAnnually\'\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" type=\"button\" ng-click=\"addAsset.openQ2Picker()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-messages=\"addAsset.addAssetForm.quarter2.$error\" ng-show=\"addAsset.submitted\"><div ng-message=\"tdMonthRangeValidation\" translate=\"ADD_ASSET.INVALID_SEMI_ANNUAL\"></div></div></div></div></div><div class=\"col-xs-7\" ng-if=\"addAsset.asset.valuationFrequency.value === \'Quarterly\'\"><div class=\"col-xs-3 no-padding-right\"><div class=\"form-group\"><label translate=\"ADD_ASSET.ANNUAL_DRAFT_AND_VALUATION\" ng-if=\"addAsset.asset.valuationFrequency.value === \'Annually\'\"></label> <label translate=\"ADD_ASSET.FIRST_DRAFT_DUE_DATE\" ng-if=\"addAsset.asset.valuationFrequency.value === \'SemiAnnually\'\"></label> <label translate=\"ADD_ASSET.Q1_DRAFT_DUE_DATE\" ng-if=\"addAsset.asset.valuationFrequency.value === \'Quarterly\'\"></label><div class=\"input-group\"><input name=\"quarter1\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"MM/dd/yyyy\" is-open=\"addAsset.q1Picker.opened\" datepicker-options=\"addAsset.dateOptions\" ng-model=\"addAsset.asset.scheduleQ1\" placeholder=\"Select Date\" ng-model-options=\"addAsset.modelOptions\" td-month-range-validation=\"\" date-from=\"01/01\" date-to=\"03/31\" date-format=\"MM/DD/YYYY\" ignore-year=\"\" required=\"\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" type=\"button\" ng-click=\"addAsset.openQ1Picker()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-messages=\"addAsset.addAssetForm.quarter1.$error\" ng-show=\"addAsset.submitted\"><div ng-message=\"tdMonthRangeValidation\" translate=\"ADD_ASSET.INVALID_Q1\"></div></div></div></div><div class=\"col-xs-3 no-padding-right\" ng-if=\"addAsset.asset.valuationFrequency.value === \'SemiAnnually\' || addAsset.asset.valuationFrequency.value === \'Quarterly\'\"><div class=\"form-group\"><label translate=\"ADD_ASSET.SECOND_DRAFT_DUE_DATE\" ng-if=\"addAsset.asset.valuationFrequency.value === \'SemiAnnually\'\"></label> <label translate=\"ADD_ASSET.Q2_DRAFT_DUE_DATE\" ng-if=\"addAsset.asset.valuationFrequency.value === \'Quarterly\'\"></label><div class=\"input-group\"><input name=\"quarter2\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"MM/dd/yyyy\" is-open=\"addAsset.q2Picker.opened\" datepicker-options=\"addAsset.dateOptions\" ng-model=\"addAsset.asset.scheduleQ2\" placeholder=\"Select Date\" ng-model-options=\"addAsset.modelOptions\" td-month-range-validation=\"\" date-from=\"04/01\" date-to=\"06/30\" date-format=\"MM/DD/YYYY\" ignore-year=\"\" ng-required=\"addAsset.asset.valuationFrequency.value !== \'Annually\'\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" type=\"button\" ng-click=\"addAsset.openQ2Picker()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-messages=\"addAsset.addAssetForm.quarter2.$error\" ng-show=\"addAsset.submitted\"><div ng-message=\"tdMonthRangeValidation\" translate=\"ADD_ASSET.INVALID_Q2\"></div></div></div></div><div class=\"col-xs-3 no-padding-right\" ng-if=\"addAsset.asset.valuationFrequency.value === \'Quarterly\'\"><div class=\"form-group\"><label translate=\"ADD_ASSET.Q3_DRAFT_DUE_DATE\" ng-if=\"addAsset.asset.valuationFrequency.value === \'Quarterly\'\"></label><div class=\"input-group\"><input name=\"quarter3\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"MM/dd/yyyy\" is-open=\"addAsset.q3Picker.opened\" datepicker-options=\"addAsset.dateOptions\" ng-model=\"addAsset.asset.scheduleQ3\" placeholder=\"Select Date\" ng-model-options=\"addAsset.modelOptions\" td-month-range-validation=\"\" date-from=\"07/01\" date-to=\"09/30\" date-format=\"MM/DD\" ignore-year=\"\" ng-required=\"addAsset.asset.valuationFrequency.value === \'Quarterly\'\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" type=\"button\" ng-click=\"addAsset.openQ3Picker()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-messages=\"addAsset.addAssetForm.quarter3.$error\" ng-show=\"addAsset.submitted\"><div ng-message=\"tdMonthRangeValidation\" translate=\"ADD_ASSET.INVALID_Q3\"></div></div></div></div><div class=\"col-xs-3 no-padding-right q4\" ng-if=\"addAsset.asset.valuationFrequency.value === \'Quarterly\'\"><div class=\"form-group\"><label translate=\"ADD_ASSET.Q4_DRAFT_DUE_DATE\" ng-if=\"addAsset.asset.valuationFrequency.value === \'Quarterly\'\"></label><div class=\"input-group\"><input name=\"quarter4\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"MM/dd/yyyy\" is-open=\"addAsset.q4Picker.opened\" datepicker-options=\"addAsset.dateOptions\" ng-model=\"addAsset.asset.scheduleQ4\" placeholder=\"Select Date\" ng-model-options=\"addAsset.modelOptions\" td-month-range-validation=\"\" date-from=\"10/01\" date-to=\"12/31\" date-format=\"MM/DD\" ignore-year=\"\" ng-required=\"addAsset.asset.valuationFrequency.value === \'Quarterly\'\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" type=\"button\" ng-click=\"addAsset.openQ4Picker()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-messages=\"addAsset.addAssetForm.quarter4.$error\" ng-show=\"addAsset.submitted\"><div ng-message=\"tdMonthRangeValidation\" translate=\"ADD_ASSET.INVALID_Q4\"></div></div></div></div></div></div><div class=\"row\" ng-if=\"addAsset.asset.valuationFrequency.value === \'SemiAnnually\' || addAsset.asset.valuationFrequency.value === \'Quarterly\'\"><div class=\"col-xs-3 col-xs-offset-2 no-padding valuation-period-title\"><label>Yearly Valuation Period</label></div><div class=\"col-xs-4 no-padding-right quarters-picker\" ng-if=\"addAsset.asset.valuationFrequency.value === \'SemiAnnually\'\"><div class=\"picker-container\"><div class=\"form-group no-margins\"><div class=\"col-xs-6\"><label class=\"m-r-sm\"><input type=\"radio\" ng-model=\"addAsset.asset.scheduleOption\" value=\"1\"> {{\"ADD_ASSET.SELECT_THIS_PERIOD\" | translate}}</label></div><div class=\"col-xs-6\"><label class=\"m-r-sm\"><input type=\"radio\" ng-model=\"addAsset.asset.scheduleOption\" value=\"2\"> {{\"ADD_ASSET.SELECT_THIS_PERIOD\" | translate}}</label></div></div></div></div><div class=\"col-xs-7 quarters-picker\" ng-if=\"addAsset.asset.valuationFrequency.value === \'Quarterly\'\"><div class=\"picker-container\"><div class=\"form-group no-margins\"><div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3\"><label class=\"m-r-sm\"><input type=\"radio\" ng-model=\"addAsset.asset.scheduleOption\" value=\"1\"> {{\"ADD_ASSET.Q1\" | translate}}</label></div><div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3\"><label class=\"m-r-sm\"><input type=\"radio\" ng-model=\"addAsset.asset.scheduleOption\" value=\"2\"> {{\"ADD_ASSET.Q2\" | translate}}</label></div><div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3\"><label class=\"m-r-sm\"><input type=\"radio\" ng-model=\"addAsset.asset.scheduleOption\" value=\"3\"> {{\"ADD_ASSET.Q3\" | translate}}</label></div><div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3\"><label class=\"m-r-sm\"><input type=\"radio\" ng-model=\"addAsset.asset.scheduleOption\" value=\"4\"> {{\"ADD_ASSET.Q4\" | translate}}</label></div></div></div></div></div><hr><div class=\"row\"><div class=\"col-lg-2 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><label translate=\"ADD_ASSET.GROSS_AREA\"></label> <input name=\"grossArea\" type=\"text\" min=\"0\" class=\"form-control\" ng-model=\"addAsset.asset.grossArea\" ui-number-mask=\"0\"><div ng-show=\"addAsset.submitted\" ng-messages=\"addAssetForm.grossArea.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div><div ng-message=\"number\" translate=\"ADD_ASSET.FIELD_INVALID\"></div></div></div></div><div class=\"col-lg-2 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><label translate=\"ADD_ASSET.LEASABLE_AREA\"></label> <input name=\"leasableArea\" type=\"text\" min=\"0\" class=\"form-control\" ng-model=\"addAsset.asset.leasableArea\" ng-required=\"addAsset.asset.type.type !== \'Land\' && addAsset.asset.type.type !== \'Other\'\" ui-number-mask=\"0\"><div ng-show=\"addAsset.submitted\" ng-messages=\"addAssetForm.leasableArea.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div><div ng-message=\"number\" translate=\"ADD_ASSET.FIELD_INVALID\"></div></div></div></div><div class=\"col-lg-2 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group inline-dropdown\" ng-class=\"{\'invalid-select\': addAsset.addAssetForm.groundLeased.$invalid && addAsset.addAssetForm.$submitted}\"><label translate=\"ADD_ASSET.GROUND_LEASED\"></label><select name=\"groundLeased\" class=\"form-control\" chosen=\"\" ng-model=\"addAsset.asset.groundLeased\" ng-options=\"groundLeased for groundLeased in addAsset.groundLeasedTypes\"><option style=\"display:none\" value=\"\" translate=\"ADD_ASSET.GROUNDLEASED_TYPE_PH\"></option></select><div ng-show=\"addAsset.submitted\" ng-messages=\"addAssetForm.groundLeased.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div><div ng-message=\"number\" translate=\"ADD_ASSET.FIELD_INVALID\"></div></div></div></div><div class=\"col-lg-2 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><label translate=\"ADD_ASSET.GARAGE_PARKING\"></label> <input name=\"garageParking\" type=\"text\" min=\"0\" class=\"form-control\" ng-model=\"addAsset.asset.garageParkingSpaces\" ui-number-mask=\"0\"><div ng-show=\"addAsset.submitted\" ng-messages=\"addAssetForm.garageParking.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div><div ng-message=\"number\" translate=\"ADD_ASSET.FIELD_INVALID\"></div></div></div></div><div class=\"col-lg-2 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><label translate=\"ADD_ASSET.SURFACE_PARKING\"></label> <input name=\"surfaceParking\" type=\"text\" min=\"0\" class=\"form-control\" ng-model=\"addAsset.asset.surfaceParkingSpaces\" ui-number-mask=\"0\"><div ng-show=\"addAsset.submitted\" ng-messages=\"addAssetForm.surfaceParking.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div><div ng-message=\"number\" translate=\"ADD_ASSET.FIELD_INVALID\"></div></div></div></div><div class=\"col-lg-2 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><label translate=\"ADD_ASSET.LANDSIZE\"></label> <input name=\"landsize\" type=\"text\" class=\"form-control\" ng-model=\"addAsset.asset.landsize\" decimal-values=\"\" format=\"number\" decimal-options=\'{\"decimals\": 3}\' ng-pattern=\"/^(?:([0-9]\\,?)+(?:\\.[0-9]{0,3})?)?$/\"><div ng-show=\"addAsset.submitted\" ng-messages=\"addAssetForm.landsize.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div><div ng-message=\"number\" translate=\"ADD_ASSET.FIELD_INVALID\"></div></div></div></div><div class=\"col-lg-2 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><label translate=\"ADD_ASSET.TENANTS\"></label> <input name=\"tenants\" type=\"text\" min=\"0\" class=\"form-control\" ng-model=\"addAsset.asset.numberOfTenants\"><div ng-show=\"addAsset.submitted\" ng-messages=\"addAssetForm.tenants.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div><div ng-message=\"number\" translate=\"ADD_ASSET.FIELD_INVALID\"></div></div></div></div><div class=\"col-lg-2 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><label translate=\"ADD_ASSET.STORIES\"></label> <input name=\"stories\" type=\"text\" min=\"0\" class=\"form-control\" ng-model=\"addAsset.asset.numberOfStories\"><div ng-show=\"addAsset.submitted\" ng-messages=\"addAssetForm.stories.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div><div ng-message=\"number\" translate=\"ADD_ASSET.FIELD_INVALID\"></div></div></div></div><div class=\"col-lg-2 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><label translate=\"ADD_ASSET.UNITS\"></label> <input name=\"units\" type=\"text\" min=\"0\" class=\"form-control\" ng-model=\"addAsset.asset.numberOfUnits\" ui-number-mask=\"0\"><div ng-show=\"addAsset.submitted\" ng-messages=\"addAssetForm.units.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div><div ng-message=\"number\" translate=\"ADD_ASSET.FIELD_INVALID\"></div></div></div></div><div class=\"col-lg-2 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><label translate=\"ADD_ASSET.NUMBER_OF_BUILDINGS\"></label> <input name=\"numberOfBuildings\" type=\"text\" min=\"0\" class=\"form-control\" ng-model=\"addAsset.asset.numberOfBuildings\" ui-number-mask=\"0\"><div ng-show=\"addAsset.submitted\" ng-messages=\"addAssetForm.numberOfBuildings.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div><div ng-message=\"number\" translate=\"ADD_ASSET.FIELD_INVALID\"></div></div></div></div></div><hr><div class=\"row\"><div class=\"col-lg-2 col-md-4 col-sm-4 col-xs-4\"><div class=\"form-group\"><label translate=\"ADD_ASSET.YEAR_BUILT\"></label> <input name=\"yearBuilt\" type=\"text\" class=\"form-control\" ng-model=\"addAsset.asset.yearBuilt\"><div ng-show=\"addAsset.submitted\" ng-messages=\"addAssetForm.yearBuilt.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div><div ng-message=\"number\" translate=\"ADD_ASSET.FIELD_INVALID\"></div></div></div></div><div class=\"col-lg-2 col-md-4 col-sm-4 col-xs-4\"><div class=\"form-group\"><label translate=\"ADD_ASSET.YEAR_RENOVATED\"></label> <input name=\"yearRenovated\" type=\"text\" class=\"form-control\" ng-class=\"{\'invalid-year\': addAsset.invalidYear}\" ng-model=\"addAsset.asset.yearRenovated\"><div ng-show=\"addAsset.submitted\" ng-messages=\"addAssetForm.yearRenovated.$error\"><div ng-message=\"number\" translate=\"ADD_ASSET.FIELD_INVALID\"></div><div ng-message=\"min\" translate=\"ADD_ASSET.YEAR_RENOVATED_SHOULD_BE_GREATER_THAN_YEAR_BUILT\"></div></div></div></div><div class=\"col-lg-2 col-md-4 col-sm-4 col-xs-4\"><div class=\"form-group\" ng-class=\"{\'invalid-select\': addAsset.addAssetForm.ownershipType.$invalid && addAsset.addAssetForm.$submitted}\"><label translate=\"ADD_ASSET.OWNERSHIP_TYPE\"></label><select name=\"ownershipType\" class=\"form-control\" chosen=\"\" ng-model=\"addAsset.asset.ownership\" ng-options=\"ownershipType.name for ownershipType in addAsset.ownershipTypes\"><option style=\"display:none\" value=\"\" translate=\"ADD_ASSET.OWNERSHIP_TYPE_PH\"></option></select><div ng-show=\"addAsset.submitted\" ng-messages=\"addAssetForm.ownershipType.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div></div></div></div><div class=\"col-lg-2 col-md-4 col-sm-4 col-xs-4\"><div class=\"form-group\"><label translate=\"ADD_ASSET.LEED_CERTIFICATION\"></label> <input name=\"leedCertification\" class=\"form-control\" ng-model=\"addAsset.asset.leedCertification\"><div ng-show=\"addAsset.submitted\" ng-messages=\"addAssetForm.leedCertification.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div></div></div></div><div class=\"col-lg-2 col-md-4 col-sm-4 col-xs-4\"><div class=\"form-group block-select\" ng-class=\"{\'invalid-select\': addAsset.addAssetForm.msa.$invalid && addAsset.addAssetForm.$submitted}\"><label translate=\"ADD_ASSET.MSA\"></label><select name=\"msa\" class=\"form-control\" chosen=\"\" ng-options=\"item for item in addAsset.msaByStates[addAsset.asset.state]\" ng-model=\"addAsset.asset.msa\"><option style=\"display:none\" value=\"\">MSA</option></select><div ng-show=\"addAsset.submitted\" ng-messages=\"addAssetForm.msa.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div></div></div></div><div class=\"col-lg-2 col-md-4 col-sm-4 col-xs-4\"><div class=\"form-group block-select\" ng-class=\"{\'invalid-select\': addAsset.addAssetForm.ncreif.$invalid && addAsset.addAssetForm.$submitted}\"><label translate=\"ADD_ASSET.NCREIF\"></label><select name=\"ncreif\" class=\"form-control\" chosen=\"\" ng-options=\"item.name for item in addAsset.ncreifs\" ng-model=\"addAsset.asset.region\" ng-disabled=\"true\"><option style=\"display:none\" value=\"\">NCREIFS</option></select><div ng-show=\"addAsset.submitted\" ng-messages=\"addAssetForm.ncreif.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div></div></div></div><div class=\"col-lg-2 col-md-4 col-sm-4 col-xs-4\"><div class=\"form-group\"><label translate=\"ADD_ASSET.PORTFOLIO_NAME\"></label> <input type=\"text\" name=\"portfolioName\" class=\"form-control\" translate=\"\" ng-model=\"addAsset.asset.portfolioName\"><div ng-show=\"addAsset.submitted\" ng-messages=\"addAssetForm.notes.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div><div ng-message=\"invalid\" translate=\"ADD_ASSET.FIELD_INVALID\"></div></div></div></div></div><hr><div class=\"row\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><label translate=\"ADD_ASSET.NOTES\"></label> <textarea name=\"notes\" class=\"form-control property-notes\" translate=\"\" translate-attr-placeholder=\"ADD_ASSET.NOTES_PH\" ng-model=\"addAsset.asset.notes\"></textarea><div ng-show=\"addAsset.submitted\" ng-messages=\"addAssetForm.notes.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div><div ng-message=\"invalid\" translate=\"ADD_ASSET.FIELD_INVALID\"></div></div></div></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><label translate=\"ADD_ASSET.DOCUMENTS\"></label><td-file-upload class=\"upload-box documents\" files=\"addAsset.documents\" files-to-upload=\"addAsset.documentsToUpload\" files-to-delete=\"addAsset.documentsToDelete\"></td-file-upload></div></div></div><br><div class=\"row text-center\"><button class=\"btn btn-w-m m-t-xl btn-normal\" type=\"submit\" ladda=\"addAsset.uiLoading\"><span class=\"ladda-label\" translate=\"ADD_ASSET.SAVE\"></span> <span class=\"ladda-spinner\"></span></button></div></form></div></div></div></div></div></div></div>");
$templateCache.put("app/states/assets/edit-asset/edit-asset.html","<header-section breadcrumb-title=\"editAsset.title\" breadcrumbs=\"editAsset.breadcrumbs\"></header-section><div class=\"wrapper wrapper-content\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><h4 translate=\"ADD_ASSET.INFORMATION\"></h4></div></div><div class=\"ibox-content\"><div class=\"roll\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><form name=\"editAsset.editAssetForm\" class=\"add-asset-form\" role=\"form\" ng-submit=\"editAsset.submitForm()\" confirm-leave=\"\" novalidate=\"\"><div class=\"row\"><div class=\"col-lg-4 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><label translate=\"ADD_ASSET.NAME\"></label> <input name=\"name\" class=\"form-control\" ng-model=\"editAsset.asset.name\" translate=\"\" translate-attr-placeholder=\"ADD_ASSET.NAME_PH\" ng-disabled=\"editAsset.isReviewer\" required=\"\"><div ng-show=\"editAsset.submitted\" ng-messages=\"editAssetForm.name.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div></div></div></div><div class=\"col-lg-2 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><label translate=\"ADD_ASSET.ID\"></label> <input name=\"id\" class=\"form-control\" ng-model=\"editAsset.asset.propertyRef\" translate=\"\" translate-attr-placeholder=\"ADD_ASSET.ID_PH\" disabled=\"\" required=\"\"><div ng-show=\"editAsset.submitted\" ng-messages=\"editAssetForm.id.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div></div><div ng-show=\"editAsset.submitted && editAsset.duplicateId\" class=\"has-error\" translate=\"ADD_ASSET.DUPLICATE_ID\"></div></div></div><div class=\"col-lg-3 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group block-select\" ng-class=\"{\'invalid-select\': editAsset.editAssetForm.type.$invalid && editAsset.editAssetForm.$submitted}\"><label translate=\"ADD_ASSET.TYPE\"></label><select name=\"type\" class=\"form-control\" chosen=\"\" ng-model=\"editAsset.asset.type\" ng-options=\"type.name for type in editAsset.propertyTypes\" ng-disabled=\"editAsset.isReviewer\" required=\"\"><option style=\"display:none\" value=\"\" translate=\"ADD_ASSET.TYPE_PH\"></option></select><div ng-show=\"editAsset.submitted\" ng-messages=\"editAssetForm.type.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div></div></div></div><div class=\"col-lg-3 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group block-select\" ng-class=\"{\'invalid-select\': editAsset.editAssetForm.subtype.$invalid && editAsset.editAssetForm.$submitted}\"><label translate=\"ADD_ASSET.SUBTYPE\"></label><select name=\"subtype\" class=\"form-control\" chosen=\"\" ng-model=\"editAsset.asset.subType\" ng-options=\"item.name for item in editAsset.subtypesByPropertyTypes[editAsset.asset.type.type] track by item.type\" ng-disabled=\"editAsset.asset.type==undefined || editAsset.isReviewer\"><option style=\"display:none\" value=\"\" translate=\"ADD_ASSET.SUBTYPE_PH\"></option></select><div ng-show=\"editAsset.submitted\" ng-messages=\"editAssetForm.subtype.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-4 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group\"><label translate=\"ADD_ASSET.ADDRESS\"></label> <input name=\"address\" class=\"form-control\" ng-model=\"editAsset.asset.address.address\" translate=\"\" translate-attr-placeholder=\"ADD_ASSET.ADDRESS_PH\" ng-disabled=\"editAsset.isReviewer\" required=\"\"><div ng-show=\"editAsset.submitted\" ng-messages=\"editAssetForm.address.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div></div></div></div><div class=\"col-lg-2 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group block-select\" ng-class=\"{\'invalid-select\': editAsset.editAssetForm.country.$invalid && editAsset.editAssetForm.$submitted}\"><label translate=\"ADD_ASSET.COUNTRY\"></label><select name=\"country\" class=\"form-control\" ng-options=\"country for country in editAsset.countries\" chosen=\"\" ng-model=\"editAsset.asset.address.country\" ng-disabled=\"editAsset.isReviewer\" required=\"\"><option style=\"display:none\" value=\"\" translate=\"ADD_ASSET.COUNTRY_PH\"></option></select><div ng-show=\"editAsset.submitted\" ng-messages=\"editAssetForm.country.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div></div></div></div><div class=\"col-lg-2 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group block-select\" ng-class=\"{\'invalid-select\': editAsset.editAssetForm.state.$invalid && editAsset.editAssetForm.$submitted}\"><label translate=\"ADD_ASSET.STATE\"></label><select name=\"state\" class=\"form-control\" chosen=\"\" ng-options=\"item for item in editAsset.statesByCountry[editAsset.asset.address.country]\" ng-model=\"editAsset.asset.address.state\" ng-disabled=\"editAsset.isReviewer\" required=\"\"><option style=\"display:none\" value=\"\" translate=\"ADD_ASSET.STATE_PH\"></option></select><div ng-show=\"editAsset.submitted\" ng-messages=\"editAssetForm.state.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div></div></div></div><div class=\"col-lg-2 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group block-select\" ng-class=\"{\'invalid-select\': editAsset.editAssetForm.city.$invalid && editAsset.editAssetForm.$submitted}\"><label translate=\"ADD_ASSET.CITY\"></label> <input name=\"city\" class=\"form-control\" ng-model=\"editAsset.asset.address.city\" translate=\"\" translate-attr-placeholder=\"ADD_ASSET.CITY_PH\" ng-disabled=\"editAsset.isReviewer\" required=\"\"><div ng-show=\"editAsset.submitted\" ng-messages=\"editAssetForm.city.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div></div></div></div><div class=\"col-lg-2 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><label translate=\"ADD_ASSET.ZIPCODE\"></label> <input name=\"zipCode\" class=\"form-control\" ng-model=\"editAsset.asset.address.zip\" ng-pattern=\"/^[0-9]*$/\" maxlength=\"5\" translate=\"\" translate-attr-placeholder=\"ADD_ASSET.ZIPCODE_PH\" ng-disabled=\"editAsset.isReviewer\" required=\"\"><div ng-show=\"editAsset.submitted\" ng-messages=\"editAssetForm.zipCode.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div></div></div></div></div><hr td-security=\"[\'Admin\', \'AssetManagement\']\" action=\"display-none\"><div class=\"row\" td-security=\"[\'Admin\', \'AssetManagement\']\" action=\"display-none\"><div class=\"col-lg-3 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group\"><label translate=\"ADD_ASSET.PHOTO\"></label><td-image-upload cropped-photo-data=\"editAsset.picture\" max-bytes-size=\"209715200\"></td-image-upload></div></div><div class=\"col-lg-9 col-md-12 col-sm-12 col-xs-12\"><div class=\"row\" td-security=\"[\'Admin\']\" action=\"display-none\"><div class=\"col-lg-8 col-md-8 col-sm-8 col-xs-8\"><div class=\"form-group block-select\" ng-class=\"{\'invalid-select\': editAsset.editAssetForm.biddingGroup.$invalid && editAsset.editAssetForm.$submitted}\"><label translate=\"ADD_ASSET.BIDDING_GROUP\"></label><select name=\"biddingGroup\" chosen=\"\" class=\"form-control\" ng-model=\"editAsset.asset.bidGroupId\" ng-options=\"group.name for group in editAsset.biddingGroups\"><option style=\"display:none\" value=\"\" translate=\"ADD_ASSET.BIDDING_GROUP_PH\"></option></select><div ng-show=\"editAsset.submitted\" ng-messages=\"editAssetForm.biddingGroup.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div></div></div></div><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\"><div class=\"form-group\"><label>&nbsp;</label><div><button class=\"btn btn-w-all btn-normal\" ui-sref=\"app.asset.bidGroups.addBidGroup\" translate=\"ADD_ASSET.CREATE_BIDDING_GROUP\"></button></div></div></div></div><div class=\"row\"><div class=\"col-lg-5 col-md-5 col-sm-5 col-xs-5\"><div class=\"form-group block-select\" ng-class=\"{\'invalid-select\': editAsset.editAssetForm.assetPrimaryContact.$invalid && editAsset.editAssetForm.$submitted}\"><label translate=\"ADD_ASSET.LEAD_ASSET_MANAGER\"></label><select name=\"assetPrimaryContact\" ng-disabled=\"editAsset.disableManager\" class=\"form-control\" chosen=\"\" ng-model=\"editAsset.leadAssetManager\" ng-options=\"user as user.user.name for user in editAsset.assetManagers track by user.id\" required=\"\"><option style=\"display:none\" value=\"\" translate=\"ADD_ASSET.LEAD_ASSET_MANAGER_PH\"></option></select><div ng-show=\"editAsset.submitted\" ng-messages=\"editAssetForm.primaryContact.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div></div></div></div><div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3\"><div class=\"form-group\"><label translate=\"ADD_ASSET.CONTACT_PHONE\"></label> <input name=\"phone\" type=\"tel\" class=\"form-control\" ng-model=\"editAsset.leadAssetManager.userAccount.officePhone\" disabled=\"\"></div></div><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\"><div class=\"form-group\"><label translate=\"ADD_ASSET.CONTACT_EMAIL\"></label> <input name=\"email\" type=\"email\" class=\"form-control\" ng-model=\"editAsset.leadAssetManager.userAccount.email\" disabled=\"\"></div></div></div><div class=\"row\" td-security=\"[\'Admin\']\" action=\"hidden\"><div class=\"col-lg-5 col-md-5 col-sm-5 col-xs-5\"><div class=\"form-group block-select\" ng-class=\"{\'invalid-select\': editAsset.editAssetForm.reviewerPrimaryContact.$invalid && editAsset.editAssetForm.$submitted}\"><label translate=\"ADD_ASSET.LEAD_REVIEWER\"></label><select name=\"reviewerPrimaryContact\" class=\"form-control\" chosen=\"\" ng-model=\"editAsset.leadReviewer\" ng-options=\"user as user.user.name for user in editAsset.reviewers track by user.id\" td-security=\"[\'Admin\']\" action=\"hidden\" required=\"\"><option style=\"display:none\" value=\"\" translate=\"ADD_ASSET.LEAD_REVIEWER_PH\"></option></select><div ng-show=\"editAsset.submitted\" ng-messages=\"editAssetForm.primaryContact.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div></div></div></div><div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3\"><div class=\"form-group\"><label translate=\"ADD_ASSET.CONTACT_PHONE\"></label> <input name=\"phone\" type=\"tel\" class=\"form-control\" ng-model=\"editAsset.leadReviewer.userAccount.officePhone\" disabled=\"\"><div ng-show=\"editAsset.submitted\" ng-messages=\"editAssetForm.phone.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div><div ng-message=\"tel\" translate=\"ADD_ASSET.FIELD_INVALID\"></div></div></div></div><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\"><div class=\"form-group\"><label translate=\"ADD_ASSET.CONTACT_EMAIL\"></label> <input name=\"email\" type=\"email\" class=\"form-control\" ng-model=\"editAsset.leadReviewer.userAccount.email\" disabled=\"\"><div ng-show=\"editAsset.submitted\" ng-messages=\"editAssetForm.email.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div><div ng-message=\"email\" translate=\"ADD_ASSET.FIELD_INVALID\"></div></div></div></div></div></div></div><hr><div class=\"row\"><div class=\"col-lg-2 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group block-select\" ng-class=\"{\'invalid-select\': editAsset.editAssetForm.requiredAppraisers.$invalid && addAsset.addAssetForm.$submitted}\"><label translate=\"ADD_ASSET.REQUIRED_APPRAISERS\"></label><select name=\"requiredAppraisers\" class=\"form-control\" ng-options=\"item.name for item in editAsset.requiredAppraisers\" chosen=\"\" ng-model=\"editAsset.asset.requiredAppraisers\" ng-disabled=\"editAsset.disableManager\" required=\"\"><option style=\"display:none\" value=\"\" translate=\"ADD_ASSET.REQUIRED_APPRAISERS_PH\"></option></select><div ng-show=\"editAsset.submitted\" ng-messages=\"editAsset.requiredAppraisers.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div></div></div></div><div class=\"col-lg-4 col-md-6 col-sm-6 col-xs-6\" ng-if=\"editAsset.asset.requiredAppraisers.value === \'InternalAndExternal\'\"><div class=\"form-group block-select\"><label translate=\"ADD_ASSET.INTERNAL_APPRAISERS\"></label><select name=\"internalAppraisers\" class=\"form-control\" chosen=\"\" multiple=\"\" placeholder-text-multiple=\"\'Select Internal Appraisers\'\" ng-model=\"editAsset.asset.internalAppraisers\" ng-options=\"user as user.user.name for user in editAsset.internalAppraisers track by user.id\" td-security=\"[\'Admin\']\" max-selected-options=\"2\"><option style=\"display:none\" value=\"\" translate=\"ADD_ASSET.INTERNAL_APPRAISERS_PH\"></option></select><div ng-show=\"editAsset.submitted\" ng-messages=\"editAssetForm.internalAppraisers.$error\"></div></div></div></div><div class=\"row\"><div class=\"col-xs-5 no-padding\"><div class=\"col-xs-5\"><div class=\"form-group inline-dropdown\"><label translate=\"ADD_ASSET.ROLLOVER_DATE\"></label><div class=\"input-group\"><input name=\"rolloverDate\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"MM/dd/yyyy\" is-open=\"editAsset.overDuePicker.opened\" datepicker-options=\"editAsset.dateOptions\" ng-model=\"editAsset.asset.rollOverDate\" ng-model-options=\"editAsset.modelOptions\" ng-disabled=\"editAsset.disableManager\" ng-class=\"{\'ng-invalid\': !editAsset.validRollOverDate || editAsset.editAssetForm.rollOverDate.$invalid && editAsset.editAssetForm.$submitted}\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" type=\"button\" ng-click=\"editAsset.openDueDatePicker()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div ng-show=\"(editAsset.submitted && !editAsset.validRollOverDate)|| !editAsset.validRollOverDate\"><div class=\"invalid-rollover-date\" translate=\"ADD_ASSET.INVALID_YEARLY_DATE\"></div></div></div><div class=\"col-xs-6\"><div class=\"form-group inline-dropdown\" ng-class=\"{\'invalid-select\': editAsset.editAssetForm.valuationFrequency.$invalid && editAsset.editAssetForm.$submitted}\"><label translate=\"ADD_ASSET.VALUATION_FREQUENCY\"></label><select name=\"valuationFrequency\" class=\"form-control\" chosen=\"\" placeholder-text-multiple=\"\'Select Frequency\'\" ng-model=\"editAsset.asset.valuationFrequency\" ng-options=\"item.name for item in editAsset.valuationFrequency\" ng-disabled=\"editAsset.disableManager\" required=\"\"><option style=\"display:none\" value=\"\" translate=\"ADD_ASSET.VALUATION_FREQUENCY\"></option></select></div></div></div><div class=\"col-xs-7\" ng-if=\"editAsset.asset.valuationFrequency.value === \'Annually\'\"><div class=\"col-xs-4\"><div class=\"form-group\"><label translate=\"ADD_ASSET.ANNUAL_DRAFT_AND_VALUATION\"></label><div class=\"input-group\"><input name=\"quarter1\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"MM/dd/yyyy\" is-open=\"editAsset.q1Picker.opened\" datepicker-options=\"editAsset.dateOptions\" ng-model=\"editAsset.asset.scheduleQ1\" placeholder=\"Select Date\" ng-model-options=\"editAsset.modelOptions\" td-month-range-validation=\"\" date-from=\"01/01\" date-to=\"12/31\" date-format=\"MM/DD/YYYY\" ignore-year=\"\" ng-required=\"editAsset.asset.valuationFrequency.value === \'Annually\'\" ng-disabled=\"editAsset.disableManager\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" type=\"button\" ng-click=\"editAsset.openQ1Picker()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-messages=\"editAsset.editAssetForm.quarter1.$error\" ng-show=\"editAsset.submitted && editAsset.asset.valuationFrequency.value === \'Annually\'\"><div ng-message=\"tdMonthRangeValidation\" translate=\"ADD_ASSET.INVALID_YEARLY_DATE\"></div></div></div></div></div><div class=\"col-xs-4 no-padding-right\" ng-if=\"editAsset.asset.valuationFrequency.value === \'SemiAnnually\'\"><div class=\"col-xs-6 no-padding-right\"><div class=\"form-group\"><label translate=\"ADD_ASSET.FIRST_DRAFT_DUE_DATE\"></label><div class=\"input-group\"><input name=\"quarter1\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"MM/dd/yyyy\" is-open=\"editAsset.q1Picker.opened\" datepicker-options=\"editAsset.dateOptions\" ng-model=\"editAsset.asset.scheduleQ1\" placeholder=\"Select Date\" ng-model-options=\"editAsset.modelOptions\" td-month-range-validation=\"\" date-from=\"01/01\" date-to=\"12/31\" date-format=\"MM/DD/YYYY\" ignore-year=\"\" ng-required=\"editAsset.asset.valuationFrequency.value === \'SemiAnnually\'\" ng-disabled=\"editAsset.disableManager\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" type=\"button\" ng-click=\"editAsset.openQ1Picker()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-messages=\"editAsset.editAssetForm.quarter1.$error\" ng-show=\"editAsset.submitted\"><div ng-message=\"tdMonthRangeValidation\" translate=\"ADD_ASSET.INVALID_SEMI_ANNUAL\"></div></div></div></div><div class=\"col-xs-6 no-padding-right\"><div class=\"form-group\"><label translate=\"ADD_ASSET.SECOND_DRAFT_DUE_DATE\"></label><div class=\"input-group\"><input name=\"quarter2\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"MM/dd/yyyy\" is-open=\"editAsset.q2Picker.opened\" datepicker-options=\"editAsset.dateOptions\" ng-model=\"editAsset.asset.scheduleQ2\" placeholder=\"Select Date\" ng-model-options=\"editAsset.modelOptions\" td-month-range-validation=\"\" date-from=\"01/01\" date-to=\"12/31\" date-format=\"MM/DD/YYYY\" ignore-year=\"\" ng-required=\"editAsset.asset.valuationFrequency.value === \'SemiAnnually\'\" ng-disabled=\"editAsset.disableManager\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" type=\"button\" ng-click=\"editAsset.openQ2Picker()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-messages=\"editAsset.editAssetForm.quarter2.$error\" ng-show=\"editAsset.submitted\"><div ng-message=\"tdMonthRangeValidation\" translate=\"ADD_ASSET.INVALID_SEMI_ANNUAL\"></div></div></div></div></div><div class=\"col-xs-7\" ng-if=\"editAsset.asset.valuationFrequency.value === \'Quarterly\'\"><div class=\"col-xs-3 no-padding-right\"><div class=\"form-group\"><label translate=\"ADD_ASSET.ANNUAL_DRAFT_AND_VALUATION\" ng-if=\"editAsset.asset.valuationFrequency.value === \'Annually\'\"></label> <label translate=\"ADD_ASSET.FIRST_DRAFT_DUE_DATE\" ng-if=\"editAsset.asset.valuationFrequency.value === \'SemiAnnually\'\"></label> <label translate=\"ADD_ASSET.Q1_DRAFT_DUE_DATE\" ng-if=\"editAsset.asset.valuationFrequency.value === \'Quarterly\'\"></label><div class=\"input-group\"><input name=\"quarter1\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"MM/dd/yyyy\" is-open=\"editAsset.q1Picker.opened\" datepicker-options=\"editAsset.dateOptions\" ng-model=\"editAsset.asset.scheduleQ1\" placeholder=\"Select Date\" ng-model-options=\"editAsset.modelOptions\" td-month-range-validation=\"\" date-from=\"01/01\" date-to=\"03/31\" date-format=\"MM/DD/YYYY\" ignore-year=\"\" ng-disabled=\"editAsset.disableManager\" required=\"\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" type=\"button\" ng-click=\"editAsset.openQ1Picker()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-messages=\"editAsset.editAssetForm.quarter1.$error\" ng-show=\"editAsset.submitted\"><div ng-message=\"tdMonthRangeValidation\" translate=\"ADD_ASSET.INVALID_Q1\"></div></div></div></div><div class=\"col-xs-3 no-padding-right\" ng-if=\"editAsset.asset.valuationFrequency.value === \'SemiAnnually\' || editAsset.asset.valuationFrequency.value === \'Quarterly\'\"><div class=\"form-group\"><label translate=\"ADD_ASSET.SECOND_DRAFT_DUE_DATE\" ng-if=\"editAsset.asset.valuationFrequency.value === \'SemiAnnually\'\"></label> <label translate=\"ADD_ASSET.Q2_DRAFT_DUE_DATE\" ng-if=\"editAsset.asset.valuationFrequency.value === \'Quarterly\'\"></label><div class=\"input-group\"><input name=\"quarter2\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"MM/dd/yyyy\" is-open=\"editAsset.q2Picker.opened\" datepicker-options=\"editAsset.dateOptions\" ng-model=\"editAsset.asset.scheduleQ2\" placeholder=\"Select Date\" ng-model-options=\"editAsset.modelOptions\" td-month-range-validation=\"\" date-from=\"04/01\" date-to=\"06/30\" date-format=\"MM/DD/YYYY\" ignore-year=\"\" ng-required=\"editAsset.asset.valuationFrequency.value !== \'Annually\'\" ng-disabled=\"editAsset.disableManager\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" type=\"button\" ng-click=\"editAsset.openQ2Picker()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-messages=\"editAsset.editAssetForm.quarter2.$error\" ng-show=\"editAsset.submitted\"><div ng-message=\"tdMonthRangeValidation\" translate=\"ADD_ASSET.INVALID_Q2\"></div></div></div></div><div class=\"col-xs-3 no-padding-right\" ng-if=\"editAsset.asset.valuationFrequency.value === \'Quarterly\'\"><div class=\"form-group\"><label translate=\"ADD_ASSET.Q3_DRAFT_DUE_DATE\" ng-if=\"editAsset.asset.valuationFrequency.value === \'Quarterly\'\"></label><div class=\"input-group\"><input name=\"quarter3\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"MM/dd/yyyy\" is-open=\"editAsset.q3Picker.opened\" datepicker-options=\"editAsset.dateOptions\" ng-model=\"editAsset.asset.scheduleQ3\" placeholder=\"Select Date\" ng-model-options=\"editAsset.modelOptions\" td-month-range-validation=\"\" date-from=\"07/01\" date-to=\"09/30\" date-format=\"MM/DD\" ignore-year=\"\" ng-required=\"editAsset.asset.valuationFrequency.value === \'Quarterly\'\" ng-disabled=\"editAsset.disableManager\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" type=\"button\" ng-click=\"editAsset.openQ3Picker()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-messages=\"editAsset.editAssetForm.quarter3.$error\" ng-show=\"editAsset.submitted\"><div ng-message=\"tdMonthRangeValidation\" translate=\"ADD_ASSET.INVALID_Q3\"></div></div></div></div><div class=\"col-xs-3 no-padding-right q4\" ng-if=\"editAsset.asset.valuationFrequency.value === \'Quarterly\'\"><div class=\"form-group\"><label translate=\"ADD_ASSET.Q4_DRAFT_DUE_DATE\" ng-if=\"editAsset.asset.valuationFrequency.value === \'Quarterly\'\"></label><div class=\"input-group\"><input name=\"quarter4\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"MM/dd/yyyy\" is-open=\"editAsset.q4Picker.opened\" datepicker-options=\"editAsset.dateOptions\" ng-model=\"editAsset.asset.scheduleQ4\" placeholder=\"Select Date\" ng-model-options=\"editAsset.modelOptions\" td-month-range-validation=\"\" date-from=\"10/01\" date-to=\"12/31\" date-format=\"MM/DD\" ignore-year=\"\" ng-required=\"editAsset.asset.valuationFrequency.value === \'Quarterly\'\" ng-disabled=\"editAsset.disableManager\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" type=\"button\" ng-click=\"editAsset.openQ4Picker()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-messages=\"editAsset.editAssetForm.quarter4.$error\" ng-show=\"editAsset.submitted\"><div ng-message=\"tdMonthRangeValidation\" translate=\"ADD_ASSET.INVALID_Q4\"></div></div></div></div></div></div><div class=\"row\" ng-if=\"editAsset.asset.valuationFrequency.value === \'SemiAnnually\' || editAsset.asset.valuationFrequency.value === \'Quarterly\'\"><div class=\"col-xs-3 col-xs-offset-2 no-padding valuation-period-title\"><label>Yearly Valuation Period</label></div><div class=\"col-xs-4 no-padding-right quarters-picker\" ng-if=\"editAsset.asset.valuationFrequency.value === \'SemiAnnually\'\"><div class=\"picker-container\"><div class=\"form-group no-margins\"><div class=\"col-xs-6\"><label class=\"m-r-sm\"><input type=\"radio\" ng-model=\"editAsset.asset.scheduleOption\" value=\"1\"> {{\"ADD_ASSET.SELECT_THIS_PERIOD\" | translate}}</label></div><div class=\"col-xs-6\"><label class=\"m-r-sm\"><input type=\"radio\" ng-model=\"editAsset.asset.scheduleOption\" value=\"2\"> {{\"ADD_ASSET.SELECT_THIS_PERIOD\" | translate}}</label></div></div></div></div><div class=\"col-xs-7 quarters-picker\" ng-if=\"editAsset.asset.valuationFrequency.value === \'Quarterly\'\"><div class=\"picker-container\"><div class=\"form-group no-margins\"><div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3\"><label class=\"m-r-sm\"><input type=\"radio\" ng-model=\"editAsset.asset.scheduleOption\" value=\"1\"> {{\"ADD_ASSET.Q1\" | translate}}</label></div><div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3\"><label class=\"m-r-sm\"><input type=\"radio\" ng-model=\"editAsset.asset.scheduleOption\" value=\"2\"> {{\"ADD_ASSET.Q2\" | translate}}</label></div><div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3\"><label class=\"m-r-sm\"><input type=\"radio\" ng-model=\"editAsset.asset.scheduleOption\" value=\"3\"> {{\"ADD_ASSET.Q3\" | translate}}</label></div><div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3\"><label class=\"m-r-sm\"><input type=\"radio\" ng-model=\"editAsset.asset.scheduleOption\" value=\"4\"> {{\"ADD_ASSET.Q4\" | translate}}</label></div></div></div></div></div><hr><div class=\"row\"><div class=\"col-lg-2 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><label translate=\"ADD_ASSET.GROSS_AREA\"></label> <input name=\"grossArea\" type=\"text\" min=\"0\" class=\"form-control\" ng-model=\"editAsset.asset.grossArea\" ui-number-mask=\"0\" ng-disabled=\"editAsset.isReviewer\"><div ng-show=\"editAsset.submitted\" ng-messages=\"editAssetForm.grossArea.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div><div ng-message=\"number\" translate=\"ADD_ASSET.FIELD_INVALID\"></div></div></div></div><div class=\"col-lg-2 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><label translate=\"ADD_ASSET.LEASABLE_AREA\"></label> <input name=\"leasableArea\" type=\"text\" min=\"0\" class=\"form-control\" ng-model=\"editAsset.asset.leasableArea\" ui-number-mask=\"0\" ng-required=\"editAsset.asset.type.type !== \'Land\' && editAsset.asset.type.type !== \'Other\'\" ng-disabled=\"editAsset.isReviewer\"><div ng-show=\"editAsset.submitted\" ng-messages=\"editAssetForm.leasableArea.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div><div ng-message=\"number\" translate=\"ADD_ASSET.FIELD_INVALID\"></div></div></div></div><div class=\"col-lg-2 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><label translate=\"ADD_ASSET.GROUND_LEASED\"></label><select ng-disabled=\"!editAsset.canUserEdit\" name=\"groundLeased\" class=\"form-control\" chosen=\"\" ng-model=\"editAsset.asset.groundLeased\" ng-options=\"groundLeased for groundLeased in editAsset.groundLeasedTypes\"><option style=\"display:none\" value=\"\" translate=\"ADD_ASSET.GROUNDLEASED_TYPE_PH\"></option></select><div ng-show=\"editAsset.submitted\" ng-messages=\"editAssetForm.groundLeased.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div><div ng-message=\"number\" translate=\"ADD_ASSET.FIELD_INVALID\"></div></div></div></div><div class=\"col-lg-2 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><label translate=\"ADD_ASSET.GARAGE_PARKING\"></label> <input name=\"garageParking\" type=\"text\" min=\"0\" class=\"form-control\" ng-model=\"editAsset.asset.garageParkingSpaces\" ui-number-mask=\"0\" ng-disabled=\"editAsset.isReviewer\"><div ng-show=\"editAsset.submitted\" ng-messages=\"editAssetForm.garageParking.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div><div ng-message=\"number\" translate=\"ADD_ASSET.FIELD_INVALID\"></div></div></div></div><div class=\"col-lg-2 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><label translate=\"ADD_ASSET.SURFACE_PARKING\"></label> <input name=\"surfaceParking\" type=\"text\" min=\"0\" class=\"form-control\" ng-model=\"editAsset.asset.surfaceParkingSpaces\" ui-number-mask=\"0\" ng-disabled=\"editAsset.isReviewer\"><div ng-show=\"editAsset.submitted\" ng-messages=\"editAssetForm.surfaceParking.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div><div ng-message=\"number\" translate=\"ADD_ASSET.FIELD_INVALID\"></div></div></div></div><div class=\"col-lg-2 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><label translate=\"ADD_ASSET.LANDSIZE\"></label> <input name=\"landsize\" type=\"text\" class=\"form-control\" ng-model=\"editAsset.asset.landsize\" ng-disabled=\"editAsset.isReviewer\" decimal-values=\"\" format=\"number\" decimal-options=\'{\"decimals\": 3}\' ng-pattern=\"/^(?:([0-9]\\,?)+(?:\\.[0-9]{0,3})?)?$/\"><div ng-show=\"editAsset.submitted\" ng-messages=\"editAssetForm.landsize.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div><div ng-message=\"number\" translate=\"ADD_ASSET.FIELD_INVALID\"></div></div></div></div><div class=\"col-lg-2 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><label translate=\"ADD_ASSET.TENANTS\"></label> <input name=\"tenants\" type=\"text\" min=\"0\" class=\"form-control\" ng-model=\"editAsset.asset.numberOfTenants\" ng-disabled=\"editAsset.isReviewer\"><div ng-show=\"editAsset.submitted\" ng-messages=\"editAssetForm.tenants.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div><div ng-message=\"number\" translate=\"ADD_ASSET.FIELD_INVALID\"></div></div></div></div><div class=\"col-lg-2 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><label translate=\"ADD_ASSET.STORIES\"></label> <input name=\"stories\" type=\"text\" min=\"0\" class=\"form-control\" ng-model=\"editAsset.asset.numberOfStories\" ng-disabled=\"editAsset.isReviewer\"><div ng-show=\"editAsset.submitted\" ng-messages=\"editAssetForm.stories.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div><div ng-message=\"number\" translate=\"ADD_ASSET.FIELD_INVALID\"></div></div></div></div><div class=\"col-lg-2 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><label translate=\"ADD_ASSET.UNITS\"></label> <input name=\"units\" type=\"text\" min=\"0\" class=\"form-control\" ng-model=\"editAsset.asset.numberOfUnits\" ui-number-mask=\"0\" ng-disabled=\"editAsset.isReviewer\"><div ng-show=\"editAsset.submitted\" ng-messages=\"editAssetForm.units.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div><div ng-message=\"number\" translate=\"ADD_ASSET.FIELD_INVALID\"></div></div></div></div><div class=\"col-lg-2 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><label translate=\"ADD_ASSET.NUMBER_OF_BUILDINGS\"></label> <input name=\"numberOfBuildings\" type=\"text\" min=\"0\" class=\"form-control\" ng-model=\"editAsset.asset.numberOfBuildings\" ui-number-mask=\"0\" ng-disabled=\"editAsset.isReviewer\"><div ng-show=\"editAsset.submitted\" ng-messages=\"editAssetForm.numberOfBuildings.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div><div ng-message=\"number\" translate=\"ADD_ASSET.FIELD_INVALID\"></div></div></div></div></div><hr><div class=\"row\"><div class=\"col-lg-2 col-md-4 col-sm-4 col-xs-4\"><div class=\"form-group\"><label translate=\"ADD_ASSET.YEAR_BUILT\"></label> <input name=\"yearBuilt\" type=\"text\" class=\"form-control\" ng-model=\"editAsset.asset.yearBuilt\" ng-disabled=\"editAsset.isReviewer\"><div ng-show=\"editAsset.submitted\" ng-messages=\"editAssetForm.yearBuilt.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div><div ng-message=\"number\" translate=\"ADD_ASSET.FIELD_INVALID\"></div></div></div></div><div class=\"col-lg-2 col-md-4 col-sm-4 col-xs-4\"><div class=\"form-group\"><label translate=\"ADD_ASSET.YEAR_RENOVATED\"></label> <input name=\"yearRenovated\" type=\"text\" class=\"form-control\" ng-model=\"editAsset.asset.yearRenovated\" ng-disabled=\"editAsset.isReviewer\"><div ng-show=\"editAsset.submitted\" ng-messages=\"editAssetForm.yearRenovated.$error\"><div ng-message=\"number\" translate=\"ADD_ASSET.FIELD_INVALID\"></div><div ng-message=\"min\" translate=\"ADD_ASSET.YEAR_RENOVATED_SHOULD_BE_GREATER_THAN_YEAR_BUILT\"></div></div></div></div><div class=\"col-lg-2 col-md-4 col-sm-4 col-xs-4\"><div class=\"form-group\" ng-class=\"{\'invalid-select\': editAsset.editAssetForm.ownershipType.$invalid && editAsset.editAssetForm.$submitted}\"><label translate=\"ADD_ASSET.OWNERSHIP_TYPE\"></label><select name=\"ownershipType\" class=\"form-control\" chosen=\"\" ng-options=\"item.name for item in editAsset.ownershipTypes track by item.type\" ng-model=\"editAsset.asset.ownership\" ng-disabled=\"editAsset.isReviewer\"><option style=\"display:none\" value=\"\" translate=\"ADD_ASSET.OWNERSHIP_TYPE_PH\"></option></select><div ng-show=\"editAsset.submitted\" ng-messages=\"editAssetForm.ownershipType.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div></div></div></div><div class=\"col-lg-2 col-md-4 col-sm-4 col-xs-4\"><div class=\"form-group\"><label translate=\"ADD_ASSET.LEED_CERTIFICATION\"></label> <input name=\"leedCertification\" class=\"form-control\" ng-model=\"editAsset.asset.leedCertification\" ng-disabled=\"editAsset.isReviewer\"><div ng-show=\"editAsset.submitted\" ng-messages=\"editAssetForm.leedCertification.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div></div></div></div><div class=\"col-lg-2 col-md-4 col-sm-4 col-xs-4\"><div class=\"form-group block-select\" ng-class=\"{\'invalid-select\': editAsset.editAssetForm.msa.$invalid && editAsset.editAssetForm.$submitted}\"><label translate=\"ADD_ASSET.MSA\"></label><select name=\"msa\" class=\"form-control\" chosen=\"\" ng-options=\"item for item in editAsset.msaByStates[editAsset.asset.address.state]\" ng-model=\"editAsset.asset.msa\" ng-disabled=\"editAsset.isReviewer\"><option style=\"display:none\" value=\"\">MSA</option></select><div ng-show=\"editAsset.submitted\" ng-messages=\"editAssetForm.msa.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div></div></div></div><div class=\"col-lg-2 col-md-4 col-sm-4 col-xs-4\"><div class=\"form-group block-select\" ng-class=\"{\'invalid-select\': editAsset.editAssetForm.ncreif.$invalid && editAsset.editAssetForm.$submitted}\"><label translate=\"ADD_ASSET.NCREIF\"></label><select name=\"ncreif\" class=\"form-control\" chosen=\"\" ng-options=\"item.name for item in editAsset.ncreifs\" ng-model=\"editAsset.asset.region\" ng-disabled=\"true\"><option style=\"display:none\" value=\"\">NCREIFS</option></select><div ng-show=\"editAsset.submitted\" ng-messages=\"editAssetForm.ncreif.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div></div></div></div><div class=\"col-lg-2 col-md-4 col-sm-4 col-xs-4\"><div class=\"form-group block-select\"><label translate=\"ADD_ASSET.PORTFOLIO_NAME\"></label> <input ng-disabled=\"!editAsset.canUserEdit\" name=\"portfolioName\" class=\"form-control\" ng-model=\"editAsset.asset.portfolioName\"><div ng-show=\"editAsset.submitted\" ng-messages=\"editAssetForm.portfolioName.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div></div></div></div></div><hr><div class=\"row\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><label translate=\"ADD_ASSET.NOTES\"></label> <textarea name=\"notes\" class=\"form-control property-notes\" translate=\"\" translate-attr-placeholder=\"ADD_ASSET.NOTES_PH\" ng-model=\"editAsset.asset.notes\" ng-disabled=\"editAsset.isReviewer\"></textarea><div ng-show=\"editAsset.submitted\" ng-messages=\"editAssetForm.notes.$error\"><div ng-message=\"required\" translate=\"ADD_ASSET.FIELD_REQ\"></div><div ng-message=\"invalid\" translate=\"ADD_ASSET.FIELD_INVALID\"></div></div></div></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><label translate=\"ADD_ASSET.DOCUMENTS\"></label><td-file-upload class=\"upload-box documents\" files=\"[]\" files-to-upload=\"editAsset.documentsToUpload\"></td-file-upload></div></div></div><br><div class=\"row text-center\"><button class=\"btn btn-w-m m-t-xl btn-normal\" type=\"submit\" ladda=\"editAsset.uiLoading\"><span class=\"ladda-label\" translate=\"ADD_ASSET.SAVE\"></span> <span class=\"ladda-spinner\"></span></button></div></form></div></div></div></div></div></div></div>");
$templateCache.put("app/states/assets/asset-details/asset-details-bidding.html","<div class=\"wrapper wrapper-content propertyInfo bidding-property\" ng-class=\"{\'no-padding-top\': assetDetailsCtrl.noPadding, \'less-margin\':assetDetailsCtrl.noPadding}\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content no-padding\" ng-class=\"{\'padding-content\': assetDetailsCtrl.noPadding}\"><div class=\"col-lg-4 col-md-12 col-sm-12 col-xs-12\"><div class=\"row\"><div class=\"img-container\" ng-class=\"{\'hide-image\': hovering}\" ng-mouseenter=\"hovering=true\" ng-mouseleave=\"hovering=false\"><img class=\"asset-image\" ng-src=\"{{assetDetailsCtrl.asset.picture}}\" alt=\"Asset image\"><div class=\"img-info\" ng-class=\"{\'hide-info\': hovering}\"><div><span class=\"id\">{{assetDetailsCtrl.asset.propertyRef || \"N/A\"}}</span></div><div class=\"name\">{{assetDetailsCtrl.asset.name || \"N/A\"}} <span ng-show=\"!assetDetailsCtrl.asset.active\">({{\"COMMONS.INACTIVATED\" | translate}})</span></div><div class=\"address\">{{assetDetailsCtrl.asset.address.address}}, {{assetDetailsCtrl.asset.address.city}}, {{assetDetailsCtrl.asset.address.state}} {{assetDetailsCtrl.asset.address.zip}}, {{assetDetailsCtrl.asset.address.country}}</div></div><div class=\"view-image\" ng-class=\"{\'hidden-controls\': assetDetailsCtrl.asset.picture, \'show-controls\': hovering}\" ng-mouseenter=\"hovering=true\" ng-mouseleave=\"hovering=false\" ng-click=\"assetDetailsCtrl.expandImage(assetDetailsCtrl.asset.picture)\"><div class=\"controls\"><i class=\"expand-icon icon icon-ic-arrow-expand-image\"></i> <span class=\"view-image-txt\" translate=\"ASSET_DETAILS.VIEW_IMAGE\"></span></div></div></div></div><div class=\"row notes-section\"><div class=\"row top-marginal-row\"><div class=\"col-lg-12\"><span translate=\"ASSET_DETAILS.NOTES\"></span></div></div><div class=\"row\"><div class=\"col-lg-12\"><span class=\"notes-text\">{{assetDetailsCtrl.asset.notes}}</span></div></div></div></div><div class=\"col-lg-8 col-md-12 col-sm-12 col-xs-12\"><div class=\"row right-section\"><div class=\"row top-marginal-row\"><div class=\"col-lg-3 col-md-6 col-sm-6 col-xs-6\"><div class=\"element-wrapper m-b-md\"><span translate=\"ASSET_DETAILS.BID_GROUP\"></span> <span class=\"big\">{{assetDetailsCtrl.asset.bidGroup.name || \"N/A\"}}</span></div></div><div class=\"col-lg-3 col-md-6 col-sm-6 col-xs-6\"><div class=\"element-wrapper m-b-md\"><span translate=\"ASSET_DETAILS.ROLLING_OVER_DATE\"></span> <span class=\"big\">{{assetDetailsCtrl.asset.rollOverDate | formatDate: \'MMM DD\'}}</span></div></div><div class=\"col-lg-3 col-md-6 col-sm-6 col-xs-6\"><div class=\"element-wrapper m-b-md\"><span translate=\"ASSET_DETAILS.TYPE_SUBTYPE\"></span> <span class=\"big\">{{assetDetailsCtrl.asset.typeName}} / {{assetDetailsCtrl.asset.subType}}</span></div></div><div class=\"col-lg-3 col-md-6 col-sm-6 col-xs-6\"><div class=\"element-wrapper m-b-md\"><span translate=\"ADD_ASSET.NUMBER_OF_BUILDINGS\"></span> <span class=\"big\">{{assetDetailsCtrl.asset.numberOfBuildings | number}}</span></div></div></div><div class=\"row\"><div class=\"col-lg-3 col-md-6 col-sm-6 col-xs-6\"><div class=\"element-wrapper m-b-md\"><span translate=\"ADD_ASSET.UNITS\"></span> <span class=\"big\">{{assetDetailsCtrl.asset.numberOfUnits | number}}</span></div></div><div class=\"col-lg-3 col-md-6 col-sm-6 col-xs-6\"><div class=\"element-wrapper m-b-md\"><span translate=\"ADD_ASSET.TENANTS\"></span> <span class=\"big\">{{assetDetailsCtrl.asset.numberOfTenants | number}}</span></div></div><div class=\"col-lg-3 col-md-6 col-sm-6 col-xs-6\"><div class=\"element-wrapper m-b-md\"><span translate=\"ADD_ASSET.STORIES\"></span> <span class=\"big\">{{assetDetailsCtrl.asset.numberOfStories | number}}</span></div></div><div class=\"col-lg-3 col-md-6 col-sm-6 col-xs-6\"><div class=\"element-wrapper m-b-md\"><span translate=\"ADD_ASSET.LANDSIZE\"></span> <span class=\"big\">{{assetDetailsCtrl.asset.landsize | number}} Acres</span></div></div></div><div class=\"row\"><div class=\"col-lg-3 col-md-6 col-sm-6 col-xs-6\"><div class=\"element-wrapper m-b-md\"><span translate=\"ADD_ASSET.GROSS_AREA\"></span> <span class=\"big\">{{assetDetailsCtrl.asset.grossArea | number}} SF</span></div></div><div class=\"col-lg-3 col-md-6 col-sm-6 col-xs-6\"><div class=\"element-wrapper m-b-md\"><span translate=\"ADD_ASSET.LEASABLE_AREA\"></span> <span class=\"big\">{{assetDetailsCtrl.asset.leasableArea | number}} SF</span></div></div><div class=\"col-lg-3 col-md-6 col-sm-6 col-xs-6\"><div class=\"element-wrapper m-b-md\"><span translate=\"ADD_ASSET.GROUND_LEASED\"></span> <span class=\"big\">{{assetDetailsCtrl.asset.groundLeased | number}} SF</span></div></div><div class=\"col-lg-3 col-md-6 col-sm-6 col-xs-6\"><div class=\"element-wrapper m-b-md\"><span translate=\"ADD_ASSET.OWNERSHIP_TYPE\"></span> <span class=\"big\">{{assetDetailsCtrl.asset.ownership}}</span></div></div></div><div class=\"row\"><div class=\"col-lg-3 col-md-6 col-sm-6 col-xs-6\"><div class=\"element-wrapper m-b-md\"><span translate=\"ADD_ASSET.YEAR_RENOVATED\"></span> <span class=\"big\">{{assetDetailsCtrl.asset.yearRenovated}}</span></div></div><div class=\"col-lg-3 col-md-6 col-sm-6 col-xs-6\"><div class=\"element-wrapper m-b-md\"><span translate=\"ADD_ASSET.YEAR_BUILT\"></span> <span class=\"big\">{{assetDetailsCtrl.asset.yearBuilt}}</span></div></div><div class=\"col-lg-3 col-md-6 col-sm-6 col-xs-6\"><div class=\"element-wrapper m-b-md\"><span translate=\"ASSET_DETAILS.GARAGE_PARKING\"></span> <span class=\"big\">{{assetDetailsCtrl.asset.garageParkingSpaces | number}}</span></div></div><div class=\"col-lg-3 col-md-6 col-sm-6 col-xs-6\"><div class=\"element-wrapper m-b-md\"><span translate=\"ADD_ASSET.SURFACE_PARKING\"></span> <span class=\"big\">{{assetDetailsCtrl.asset.surfaceParkingSpaces | number}}</span></div></div></div><div class=\"row\"><div class=\"col-lg-3 col-md-6 col-sm-6 col-xs-6\"><div class=\"element-wrapper m-b-md\"><span translate=\"ADD_ASSET.LEED_CERTIFICATION\"></span> <span class=\"big\">{{assetDetailsCtrl.asset.leedCertification}}</span></div></div><div class=\"col-lg-3 col-md-6 col-sm-6 col-xs-6\"><div class=\"element-wrapper m-b-md\"><span translate=\"ADD_ASSET.MSA\"></span> <span class=\"big\">{{assetDetailsCtrl.asset.msa}}</span></div></div><div class=\"col-lg-3 col-md-6 col-sm-6 col-xs-6\"><div class=\"element-wrapper m-b-md\"><span translate=\"ADD_ASSET.NCREIF\"></span> <span class=\"big\">{{assetDetailsCtrl.asset.region}}</span></div></div></div></div><hr><div class=\"row right-section schedule-section\"><div class=\"col-lg-5 col-md-6 col-sm-6 col-xs-6 no-padding\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><span class=\"big title\" translate=\"ASSET_DETAILS.DUE_DATE_SCHEDULED\"></span></div></div><div class=\"row top-marginal-row\" ng-hide=\"true\"><div class=\"col-lg-5 col-xs-6 schedule-margin\"><div class=\"element-wrapper\"><span>Valuation Frequency</span> <span class=\"big\">{{assetDetailsCtrl.asset.valuationFrequency}}</span></div></div></div><div class=\"row top-marginal-row\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6 schedule-margin\" ng-hide=\"(assetDetailsCtrl.isExternalAppraiser && assetDetailsCtrl.asset.requiredAppraisers === \'InternalAndExternal\' && assetDetailsCtrl.asset.valuationFrequency !== \'Annually\' && assetDetailsCtrl.asset.scheduleOption != 1) || (!assetDetailsCtrl.isExternalAppraiser && assetDetailsCtrl.asset.requiredAppraisers === \'InternalAndExternal\' && assetDetailsCtrl.asset.valuationFrequency !== \'Annually\' && assetDetailsCtrl.asset.scheduleOption == 1)\"><div class=\"element-wrapper\"><span translate=\"ADD_ASSET.DRAFT_DUE_DATE\" ng-if=\"assetDetailsCtrl.asset.valuationFrequency === \'Annual\'\"></span> <span translate=\"ADD_ASSET.DRAFT_DUE_DATE\" ng-if=\"assetDetailsCtrl.asset.valuationFrequency === \'Semi-Annual\'\"></span> <span translate=\"ADD_ASSET.DRAFT_DUE_DATE\" ng-if=\"assetDetailsCtrl.asset.valuationFrequency === \'Quarterly\'\"></span> <span class=\"big\">{{assetDetailsCtrl.asset.scheduleQ1 | formatDate: \'MMM DD\'}}</span></div></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6 schedule-margin\" ng-if=\"assetDetailsCtrl.asset.valuationFrequency === \'Semi-Annual\' || assetDetailsCtrl.asset.valuationFrequency === \'Quarterly\'\" ng-hide=\"(assetDetailsCtrl.isExternalAppraiser && assetDetailsCtrl.asset.requiredAppraisers === \'InternalAndExternal\' && assetDetailsCtrl.asset.valuationFrequency !== \'Annually\' && assetDetailsCtrl.asset.scheduleOption != 2) || (!assetDetailsCtrl.isExternalAppraiser && assetDetailsCtrl.asset.requiredAppraisers === \'InternalAndExternal\' && assetDetailsCtrl.asset.valuationFrequency !== \'Annually\' && assetDetailsCtrl.asset.scheduleOption == 2)\"><div class=\"element-wrapper\"><span translate=\"ADD_ASSET.DRAFT_DUE_DATE\" ng-if=\"assetDetailsCtrl.asset.valuationFrequency === \'Semi-Annual\'\"></span> <span translate=\"ADD_ASSET.DRAFT_DUE_DATE\" ng-if=\"assetDetailsCtrl.asset.valuationFrequency === \'Quarterly\'\"></span> <span class=\"big\">{{assetDetailsCtrl.asset.scheduleQ2 | formatDate: \'MMM DD\'}}</span></div></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6 schedule-margin\" ng-if=\"assetDetailsCtrl.asset.valuationFrequency === \'Quarterly\'\" ng-hide=\"(assetDetailsCtrl.isExternalAppraiser && assetDetailsCtrl.asset.requiredAppraisers === \'InternalAndExternal\' && assetDetailsCtrl.asset.valuationFrequency !== \'Annually\' && assetDetailsCtrl.asset.scheduleOption != 3) || (!assetDetailsCtrl.isExternalAppraiser && assetDetailsCtrl.asset.requiredAppraisers === \'InternalAndExternal\' && assetDetailsCtrl.asset.valuationFrequency !== \'Annually\' && assetDetailsCtrl.asset.scheduleOption == 3)\"><div class=\"element-wrapper\"><span translate=\"ADD_ASSET.DRAFT_DUE_DATE\"></span> <span class=\"big\">{{assetDetailsCtrl.asset.scheduleQ3 | formatDate: \'MMM DD\'}}</span></div></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6 schedule-margin\" ng-if=\"assetDetailsCtrl.asset.valuationFrequency === \'Quarterly\'\" ng-hide=\"(assetDetailsCtrl.isExternalAppraiser && assetDetailsCtrl.asset.requiredAppraisers === \'InternalAndExternal\' && assetDetailsCtrl.asset.valuationFrequency !== \'Annually\' && assetDetailsCtrl.asset.scheduleOption != 4) || (!assetDetailsCtrl.isExternalAppraiser && assetDetailsCtrl.asset.requiredAppraisers === \'InternalAndExternal\' && assetDetailsCtrl.asset.valuationFrequency !== \'Annually\' && assetDetailsCtrl.asset.scheduleOption == 4)\"><div class=\"element-wrapper\"><span translate=\"ADD_ASSET.DRAFT_DUE_DATE\"></span> <span class=\"big\">{{assetDetailsCtrl.asset.scheduleQ4 | formatDate: \'MMM DD\'}}</span></div></div></div></div><div class=\"col-lg-7 col-md-6 col-sm-6 col-xs-6 border-left documents\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><span class=\"big title m-b-md\">{{ \"ASSET_DETAILS.DOCUMENTS\" | translate }}&nbsp;<p ng-hide=\"assetDetailsCtrl.documents.length == 0\">({{ assetDetailsCtrl.documents.length }})</p></span><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding fixed-height\"><perfect-scrollbar class=\"scroller\" wheel-propagation=\"true\" wheel-speed=\"1\" min-scrollbar-length=\"20\"><ul><li ng-repeat=\"document in assetDetailsCtrl.documents\">{{ document.name }}<div class=\"doc-tools\"><a class=\"btn btn-back\" ng-click=\"assetDetailsCtrl.downloadAssetDocument(document)\"><i class=\"icon icon-ic-download\"></i></a></div></li></ul></perfect-scrollbar></div></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/states/assets/asset-details/asset-details-view.html","<header-section breadcrumb-title=\"assetDetailsCtrl.title\" breadcrumbs=\"assetDetailsCtrl.breadcrumbs\" asset-id=\"assetDetailsCtrl.asset.id\" valuation-id=\"assetDetailsCtrl.asset.review.id\" is-asset=\"assetDetailsCtrl.isAsset\"></header-section><div ui-view=\"\"></div>");
$templateCache.put("app/states/assets/asset-details/asset-details.html","<div class=\"wrapper wrapper-content propertyInfo\" ng-class=\"{\'no-padding-top\': assetDetailsCtrl.noPadding, \'less-margin\':assetDetailsCtrl.noPadding}\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content no-padding\" ng-class=\"{\'padding-content\': assetDetailsCtrl.noPadding}\"><div class=\"col-lg-4 col-md-12 col-sm-12 col-xs-12\"><div class=\"row\"><div class=\"img-container\" ng-class=\"{\'hide-image\': hovering}\" ng-mouseenter=\"hovering=true\" ng-mouseleave=\"hovering=false\"><img class=\"asset-image\" ng-src=\"{{assetDetailsCtrl.asset.picture}}\" alt=\"Asset image\"><div class=\"img-info\" ng-class=\"{\'hide-info\': hovering}\"><div><span class=\"id\">{{assetDetailsCtrl.asset.propertyRef || \"N/A\"}}</span></div><div class=\"name\">{{assetDetailsCtrl.asset.name || \"N/A\"}} <span ng-show=\"!assetDetailsCtrl.asset.active\">({{\"COMMONS.INACTIVATED\" | translate}})</span></div><div class=\"address\">{{assetDetailsCtrl.asset.address.address}}, {{assetDetailsCtrl.asset.address.city}}, {{assetDetailsCtrl.asset.address.state}} {{assetDetailsCtrl.asset.address.zip}}, {{assetDetailsCtrl.asset.address.country}}</div></div><div class=\"view-image\" ng-class=\"{\'hidden-controls\': assetDetailsCtrl.asset.picture, \'show-controls\': hovering}\" ng-mouseenter=\"hovering=true\" ng-mouseleave=\"hovering=false\" ng-click=\"assetDetailsCtrl.expandImage(assetDetailsCtrl.asset.picture)\"><div class=\"controls\"><i class=\"expand-icon icon icon-ic-arrow-expand-image\"></i> <span class=\"view-image-txt\" translate=\"ASSET_DETAILS.VIEW_IMAGE\"></span></div></div></div></div><div class=\"row notes-section\"><div class=\"row top-marginal-row\"><div class=\"col-lg-12\"><span translate=\"ASSET_DETAILS.NOTES\"></span></div></div><div class=\"row\"><div class=\"col-lg-12\"><span class=\"notes-text\">{{assetDetailsCtrl.asset.notes}}</span></div></div></div></div><div class=\"col-lg-8 col-md-12 col-sm-12 col-xs-12\"><div class=\"row top-marginal-row text-right\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"element-wrapper m-b-md\"><button ng-disabled=\"assetDetailsCtrl.downloadLoading\" style=\"position:absolute;top:-15px;right:25px;\" class=\"btn btn-download\" ng-click=\"assetDetailsCtrl.downloadPdf()\"><i class=\"icon icon-ic-download\"></i> {{ \"COMMONS.DOWNLOAD\" | translate }}</button></div></div></div><div class=\"row right-section\"><div class=\"row top-marginal-row\"><div class=\"col-lg-3 col-md-6 col-sm-6 col-xs-6\"><div class=\"element-wrapper m-b-md\"><span translate=\"ASSET_DETAILS.BID_GROUP\"></span> <span class=\"big\">{{assetDetailsCtrl.asset.bidGroup.name || \"N/A\"}}</span></div></div><div class=\"col-lg-3 col-md-6 col-sm-6 col-xs-6\"><div class=\"element-wrapper m-b-md\"><span translate=\"ASSET_DETAILS.CURRENT_VALUATION\"></span> <span class=\"big\"><a ui-sref=\"app.review({assetId: assetDetailsCtrl.asset.id, valuationId: assetDetailsCtrl.asset.valuation.id})\" ui-sref-opts=\"{reload: true}\" ng-hide=\"assetDetailsCtrl.currentValuation == \'N/A\'\">{{ assetDetailsCtrl.asset.vperiod}}</a> <span class=\"big\" ng-show=\"assetDetailsCtrl.currentValuation == \'N/A\'\">{{ assetDetailsCtrl.asset.vperiod}}</span></span></div></div><div class=\"col-lg-3 col-md-6 col-sm-6 col-xs-6\"><div class=\"element-wrapper m-b-md\"><span translate=\"ASSET_DETAILS.CURRENT_STATUS\"></span> <span class=\"big\"><a ui-sref=\"app.review({assetId: assetDetailsCtrl.asset.id, valuationId: assetDetailsCtrl.asset.valuation.id})\" ui-sref-opts=\"{reload: true}\" nvc-latest-action=\"\" review=\"assetDetailsCtrl.asset.review\" ng-hide=\"!assetDetailsCtrl.asset.review.status\"></a> <span class=\"big\" ng-show=\"!assetDetailsCtrl.asset.review.status\" nvc-latest-action=\"\" review=\"assetDetailsCtrl.asset.review\"></span></span></div></div><div class=\"col-lg-3 col-md-6 col-sm-6 col-xs-6\"><div class=\"element-wrapper m-b-md\"><span translate=\"ASSET_DETAILS.DRAFT_DUE_DATE\"></span> <span class=\"big\" ng-hide=\"!assetDetailsCtrl.asset.review.getDraftDueDate()\">{{ assetDetailsCtrl.nextDraftDueDateExternal ? (assetDetailsCtrl.nextDraftDueDateExternal | formatDate: \'MMM DD\') : (assetDetailsCtrl.asset.review.getDraftDueDateCurrentQuarter() | date:\'MMM dd\') }}</span> <span class=\"big\" ng-show=\"!assetDetailsCtrl.asset.review.getDraftDueDate()\">{{ \"N/A\" }}</span></div></div></div><div class=\"row\"><div class=\"col-lg-3 col-md-6 col-sm-6 col-xs-6\" td-security=\"[\'Admin\']\" action=\"display-none\"><div class=\"element-wrapper m-b-md\"><span translate=\"ASSET_DETAILS.PRIMARY_ASSET_MANAGER\"></span> <span class=\"big\"><a ui-sref=\"app.manage.users.editUser({id: assetDetailsCtrl.leadAssetManager.user.id, companyId: assetDetailsCtrl.leadAssetManager.companyId})\" ng-hide=\"!assetDetailsCtrl.leadAssetManager.user.name\">{{assetDetailsCtrl.leadAssetManager.user.name}}</a> <span class=\"big\" ng-show=\"!assetDetailsCtrl.leadAssetManager.user.name\">{{\"N/A\"}}</span></span></div></div><div class=\"col-lg-3 col-md-6 col-sm-6 col-xs-6\" td-security=\"[\'Audit\', \'AssetManagement\', \'AssetReview\', \'AssetManagerReadOnly\']\" action=\"display-none\"><div class=\"element-wrapper m-b-md\"><span translate=\"ASSET_DETAILS.PRIMARY_ASSET_MANAGER\"></span> <span class=\"big\"><a ui-sref=\"app.manage.users.details({id: assetDetailsCtrl.leadAssetManager.user.id, companyId: assetDetailsCtrl.leadAssetManager.companyId})\" ng-hide=\"!assetDetailsCtrl.leadAssetManager.user.name\">{{assetDetailsCtrl.leadAssetManager.user.name}}</a> <span class=\"big\" ng-show=\"!assetDetailsCtrl.leadAssetManager.user.name\">{{\"N/A\"}}</span></span></div></div><div class=\"col-lg-3 col-md-6 col-sm-6 col-xs-6\" td-security=\"[\'Admin\']\" action=\"display-none\"><div class=\"element-wrapper m-b-md\"><span translate=\"ASSET_DETAILS.PRIMARY_REVIEWER\"></span> <span class=\"big\"><a ui-sref=\"app.manage.users.editUser({id: assetDetailsCtrl.leadReviewer.user.id, companyId: assetDetailsCtrl.leadReviewer.companyId})\" ng-hide=\"!assetDetailsCtrl.leadReviewer.user.name\">{{assetDetailsCtrl.leadReviewer.user.name}}</a> <span class=\"big\" ng-show=\"!assetDetailsCtrl.leadReviewer.user.name\">{{\"N/A\"}}</span></span></div></div><div class=\"col-lg-3 col-md-6 col-sm-6 col-xs-6\" td-security=\"[\'AssetReview\', \'AssetManagement\', \'AssetAppraisal\', \'Audit\', \'AssetManagerReadOnly\']\" action=\"display-none\"><div class=\"element-wrapper m-b-md\"><span translate=\"ASSET_DETAILS.PRIMARY_REVIEWER\"></span> <span class=\"big\"><a ui-sref=\"app.manage.users.details({id: assetDetailsCtrl.leadReviewer.user.id, companyId: assetDetailsCtrl.leadReviewer.companyId})\" ng-hide=\"!assetDetailsCtrl.leadReviewer.user.name\">{{assetDetailsCtrl.leadReviewer.user.name}}</a> <span class=\"big\" ng-show=\"!assetDetailsCtrl.leadReviewer.user.name\">{{\"N/A\"}}</span></span></div></div><div class=\"col-lg-3 col-md-6 col-sm-6 col-xs-6\"><div class=\"element-wrapper m-b-md\"><span translate=\"ASSET_DETAILS.ROLLING_OVER_DATE\"></span> <span class=\"big\">{{assetDetailsCtrl.asset.rollOverDate | formatDate: \'MMM DD\'}}</span></div></div><div class=\"col-lg-3 col-md-6 col-sm-6 col-xs-6\"><div class=\"element-wrapper m-b-md\"><span translate=\"ASSET_DETAILS.TYPE_SUBTYPE\"></span> <span class=\"big\">{{assetDetailsCtrl.asset.typeName}} / {{assetDetailsCtrl.asset.subType}}</span></div></div></div><div class=\"row\"><div class=\"col-lg-3 col-md-6 col-sm-6 col-xs-6\"><div class=\"element-wrapper m-b-md\"><span translate=\"ADD_ASSET.NUMBER_OF_BUILDINGS\"></span> <span class=\"big\">{{assetDetailsCtrl.asset.numberOfBuildings | number}}</span></div></div><div class=\"col-lg-3 col-md-6 col-sm-6 col-xs-6\"><div class=\"element-wrapper m-b-md\"><span translate=\"ADD_ASSET.UNITS\"></span> <span class=\"big\">{{assetDetailsCtrl.asset.numberOfUnits | number}}</span></div></div><div class=\"col-lg-3 col-md-6 col-sm-6 col-xs-6\"><div class=\"element-wrapper m-b-md\"><span translate=\"ADD_ASSET.TENANTS\"></span> <span class=\"big\">{{assetDetailsCtrl.asset.numberOfTenants}}</span></div></div><div class=\"col-lg-3 col-md-6 col-sm-6 col-xs-6\"><div class=\"element-wrapper m-b-md\"><span translate=\"ADD_ASSET.STORIES\"></span> <span class=\"big\">{{assetDetailsCtrl.asset.numberOfStories}}</span></div></div></div><div class=\"row\"><div class=\"col-lg-3 col-md-6 col-sm-6 col-xs-6\"><div class=\"element-wrapper m-b-md\"><span translate=\"ASSET_DETAILS.LAND_SIZE\"></span> <span class=\"big\">{{assetDetailsCtrl.asset.landsize | number}} Acres</span></div></div><div class=\"col-lg-3 col-md-6 col-sm-6 col-xs-6\"><div class=\"element-wrapper m-b-md\"><span translate=\"ADD_ASSET.GROSS_AREA\"></span> <span class=\"big\">{{assetDetailsCtrl.asset.grossArea | number}} SF</span></div></div><div class=\"col-lg-3 col-md-6 col-sm-6 col-xs-6\"><div class=\"element-wrapper m-b-md\"><span translate=\"ADD_ASSET.LEASABLE_AREA\"></span> <span class=\"big\">{{assetDetailsCtrl.asset.leasableArea | number}} SF</span></div></div><div class=\"col-lg-3 col-md-6 col-sm-6 col-xs-6\"><div class=\"element-wrapper m-b-md\"><span translate=\"ADD_ASSET.GROUND_LEASED\"></span> <span class=\"big\">{{assetDetailsCtrl.asset.groundLeased}}</span></div></div></div><div class=\"row\"><div class=\"col-lg-3 col-md-6 col-sm-6 col-xs-6\"><div class=\"element-wrapper m-b-md\"><span translate=\"ADD_ASSET.OWNERSHIP_TYPE\"></span> <span class=\"big\">{{assetDetailsCtrl.asset.ownership}}</span></div></div><div class=\"col-lg-3 col-md-6 col-sm-6 col-xs-6\"><div class=\"element-wrapper m-b-md\"><span translate=\"ADD_ASSET.YEAR_RENOVATED\"></span> <span class=\"big\">{{assetDetailsCtrl.asset.yearRenovated}}</span></div></div><div class=\"col-lg-3 col-md-6 col-sm-6 col-xs-6\"><div class=\"element-wrapper m-b-md\"><span translate=\"ADD_ASSET.YEAR_BUILT\"></span> <span class=\"big\">{{assetDetailsCtrl.asset.yearBuilt}}</span></div></div><div class=\"col-lg-3 col-md-6 col-sm-6 col-xs-6\"><div class=\"element-wrapper m-b-md\"><span translate=\"ASSET_DETAILS.GARAGE_PARKING\"></span> <span class=\"big\">{{assetDetailsCtrl.asset.garageParkingSpaces | number}}</span></div></div></div><div class=\"row\"><div class=\"col-lg-3 col-md-6 col-sm-6 col-xs-6\"><div class=\"element-wrapper m-b-md\"><span translate=\"ADD_ASSET.SURFACE_PARKING\"></span> <span class=\"big\">{{assetDetailsCtrl.asset.surfaceParkingSpaces | number}}</span></div></div><div class=\"col-lg-3 col-md-6 col-sm-6 col-xs-6\"><div class=\"element-wrapper m-b-md\"><span translate=\"ADD_ASSET.LEED_CERTIFICATION\"></span> <span class=\"big\">{{assetDetailsCtrl.asset.leedCertification}}</span></div></div><div class=\"col-lg-3 col-md-6 col-sm-6 col-xs-6\"><div class=\"element-wrapper m-b-md\"><span translate=\"ADD_ASSET.MSA\"></span> <span class=\"big\">{{assetDetailsCtrl.asset.msa}}</span></div></div><div class=\"col-lg-3 col-md-6 col-sm-6 col-xs-6\"><div class=\"element-wrapper m-b-md\"><span translate=\"ADD_ASSET.NCREIF\"></span> <span class=\"big\">{{assetDetailsCtrl.asset.region}}</span></div></div><div class=\"col-lg-3 col-md-6 col-sm-6 col-xs-6\"><div class=\"element-wrapper m-b-md\"><span translate=\"ADD_ASSET.PORTFOLIO_NAME\"></span> <span class=\"big\">{{assetDetailsCtrl.asset.portfolioName || \'N/A\'}}</span></div></div></div></div><hr><div class=\"row right-section schedule-section\"><div class=\"col-lg-5 col-md-6 col-sm-6 col-xs-6 no-padding\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><span class=\"big title\" translate=\"ASSET_DETAILS.DUE_DATE_SCHEDULED\"></span></div></div><div class=\"row top-marginal-row\" ng-hide=\"assetDetailsCtrl.isExternalAppraiser\"><div class=\"col-lg-5 col-xs-6\"><div class=\"element-wrapper\"><span>Valuation Frequency</span> <span class=\"big\">{{assetDetailsCtrl.asset.valuationFrequency}}</span></div></div></div><div class=\"row top-marginal-row\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6 schedule-margin\" ng-hide=\"assetDetailsCtrl.isDraftDueHidden(1)\"><div class=\"element-wrapper\"><span translate=\"ADD_ASSET.DRAFT_DUE_DATE\" ng-if=\"assetDetailsCtrl.asset.valuationFrequency === \'Annual\'\"></span> <span translate=\"ADD_ASSET.DRAFT_DUE_DATE\" ng-if=\"assetDetailsCtrl.asset.valuationFrequency === \'Semi-Annual\'\"></span> <span translate=\"ADD_ASSET.DRAFT_DUE_DATE\" ng-if=\"assetDetailsCtrl.asset.valuationFrequency === \'Quarterly\'\"></span> <span class=\"big\">{{assetDetailsCtrl.asset.scheduleQ1 | formatDate: \'MMM DD\'}}</span></div></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6 schedule-margin\" ng-if=\"assetDetailsCtrl.asset.valuationFrequency === \'Semi-Annual\' || assetDetailsCtrl.asset.valuationFrequency === \'Quarterly\'\" ng-hide=\"assetDetailsCtrl.isDraftDueHidden(2)\"><div class=\"element-wrapper\"><span translate=\"ADD_ASSET.DRAFT_DUE_DATE\" ng-if=\"assetDetailsCtrl.asset.valuationFrequency === \'Semi-Annual\'\"></span> <span translate=\"ADD_ASSET.DRAFT_DUE_DATE\" ng-if=\"assetDetailsCtrl.asset.valuationFrequency === \'Quarterly\'\"></span> <span class=\"big\">{{assetDetailsCtrl.asset.scheduleQ2 | formatDate: \'MMM DD\'}}</span></div></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6 schedule-margin\" ng-if=\"assetDetailsCtrl.asset.valuationFrequency === \'Quarterly\'\" ng-hide=\"assetDetailsCtrl.isDraftDueHidden(3)\"><div class=\"element-wrapper\"><span translate=\"ADD_ASSET.DRAFT_DUE_DATE\"></span> <span class=\"big\">{{assetDetailsCtrl.asset.scheduleQ3 | formatDate: \'MMM DD\'}}</span></div></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6 schedule-margin\" ng-if=\"assetDetailsCtrl.asset.valuationFrequency === \'Quarterly\'\" ng-hide=\"assetDetailsCtrl.isDraftDueHidden(4)\"><div class=\"element-wrapper\"><span translate=\"ADD_ASSET.DRAFT_DUE_DATE\"></span> <span class=\"big\">{{assetDetailsCtrl.asset.scheduleQ4 | formatDate: \'MMM DD\'}}</span></div></div></div></div><div class=\"col-lg-7 col-md-6 col-sm-6 col-xs-6 border-left documents\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><span class=\"big title m-b-md\">{{ \"ASSET_DETAILS.DOCUMENTS\" | translate }}&nbsp;<p ng-hide=\"assetDetailsCtrl.documents.length == 0\">({{ assetDetailsCtrl.documents.length }})</p></span><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding fixed-height\"><perfect-scrollbar class=\"scroller\" wheel-propagation=\"true\" wheel-speed=\"1\" min-scrollbar-length=\"20\"><ul><li ng-repeat=\"document in assetDetailsCtrl.documents\">{{ document.name }}<div class=\"doc-tools\"><a class=\"btn btn-back\" ng-click=\"assetDetailsCtrl.downloadAssetDocument(document)\"><i class=\"icon icon-ic-download\"></i></a> <a class=\"btn btn-back\" ng-if=\"assetDetailsCtrl.isAdmin\" ng-click=\"assetDetailsCtrl.deleteDocument(document)\"><i class=\"icon icon-ic-trash-delete\"></i></a></div></li></ul></perfect-scrollbar></div></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/states/assets/bid-groups/bid-groups-lateral-content.html","<div id=\"asset-list\" class=\"asset-list\"><div class=\"asset-tools\"><h4>{{\"BID_GROUPS.ASSETS\" | translate}} <span>({{group.assets.length}})</span></h4><div class=\"actions\"><a class=\"btn btn-back m-l-lg\" ui-sref=\"app.asset.bidGroups.editBidGroup({id: group.id, companyId: group.companyId, bidGroup: group})\"><span class=\"icon icon-ic-edit-comment\"></span></a> <a class=\"btn btn-back m-l-xs\" ng-click=\"deleteBidGroup(group)\"><span class=\"icon icon-ic-trash-delete\"></span></a></div></div><div class=\"hr-line-dashed\"></div><ul><li ng-repeat=\"asset in group.assets\"><a ui-sref=\"app.asset.assetDetails({assetId: asset.id, asset: asset})\">{{asset.name}}</a></li></ul></div>");
$templateCache.put("app/states/assets/bid-groups/bid-groups.html","<header-section breadcrumb-title=\"bidGroupsCtrl.title\" breadcrumbs=\"bidGroupsCtrl.breadcrumbs\"></header-section><div class=\"wrapper wrapper-content\" nvc-full-page=\"\" paginator=\"true\"><div class=\"row\" td-security=\"[\'Admin\']\" action=\"display-none\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"text-right m-b-lg\"><a class=\"btn btn-normal btn-w-m\" ui-sref=\"app.asset.bidGroups.addBidGroup\">{{\'BID_GROUPS.CREATE_NEW\' | translate}}</a></div></div></div><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bid-groups-list\"><div class=\"row no-margins\"><div class=\"col-lg-7 col-md-7 col-sm-7 col-xs-7 no-padding\"><h4 class=\"no-margins\">{{\"BID_GROUPS.TITLE\" | translate}}&nbsp;<span>({{bidGroupsCtrl.bidGroupsCount}})</span></h4></div><div class=\"col-lg-5 col-md-5 col-sm-5 col-xs-5 no-padding\"><div class=\"form-group no-margins ibox-search-row\"><div uib-dropdown=\"\" is-open=\"bidGroupsCtrl.dropdown.isOpen\"><button ng-disabled=\"bidGroupsCtrl.downloadLoading\" class=\"btn btn-download\" ng-class=\"{\'btn-dropdown-active\': bidGroupsCtrl.dropdown.isOpen}\" uib-dropdown-toggle=\"\"><i class=\"icon icon-ic-download\"></i> {{ \"COMMONS.DOWNLOAD\" | translate }}</button><ul class=\"dropdown-menu\" uib-dropdown-menu=\"\"><li><a href=\"#\" class=\"btn-block btn-dropdown\" ng-click=\"bidGroupsCtrl.downloadPdf()\"><img class=\"dropdown-option-icon\" src=\"/assets/images/pdf.svg\"> {{ \"COMMONS.PDF\" | translate }}</a></li><li><a href=\"#\" class=\"btn-block btn-dropdown\" ng-click=\"bidGroupsCtrl.downloadCsv()\"><img class=\"dropdown-option-icon\" src=\"/assets/images/excel.svg\"> {{ \"COMMONS.EXCEL\" | translate }}</a></li></ul></div><div class=\"icon-addon addon-md ibox-search\"><input type=\"text\" class=\"form-control\" id=\"search\" translate=\"\" translate-attr-placeholder=\"ASSETS.SEARCH\" ng-change=\"bidGroupsCtrl.searchBidGroups()\" ng-model=\"bidGroupsCtrl.searchQuery\" ng-model-options=\"{ debounce: { \'default\': 300, \'blur\': 0 } }\"> <label for=\"search\" class=\"fa fa-search\" rel=\"tooltip\"></label></div></div></div></div></div><div class=\"row no-margins fixed-header bid-groups-list\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><ul><li><a translate=\"BID_GROUPS.NAME\" ng-click=\"bidGroupsCtrl.sorting(bidGroupsCtrl.bidGroupsSort[0], \'bidGroupsSelectedSort\')\" ng-class=\"{\'asc\': bidGroupsCtrl.bidGroupsSort[0].flag, \'desc\': !bidGroupsCtrl.bidGroupsSort[0].flag, \'not-selected\': !bidGroupsCtrl.bidGroupsSort[0].selected}\"></a></li><li><a translate=\"BID_GROUPS.ASSETS\" ng-click=\"bidGroupsCtrl.sorting(bidGroupsCtrl.bidGroupsSort[1], \'bidGroupsSelectedSort\')\" ng-class=\"{\'asc\': bidGroupsCtrl.bidGroupsSort[1].flag, \'desc\': !bidGroupsCtrl.bidGroupsSort[1].flag, \'not-selected\': !bidGroupsCtrl.bidGroupsSort[1].selected}\"></a></li></ul></div></div><div class=\"ibox-content no-padding paginator-loader\"><div class=\"sk-spinner sk-spinner-circle\"><div class=\"sk-circle1 sk-circle\"></div><div class=\"sk-circle2 sk-circle\"></div><div class=\"sk-circle3 sk-circle\"></div><div class=\"sk-circle4 sk-circle\"></div><div class=\"sk-circle5 sk-circle\"></div><div class=\"sk-circle6 sk-circle\"></div><div class=\"sk-circle7 sk-circle\"></div><div class=\"sk-circle8 sk-circle\"></div><div class=\"sk-circle9 sk-circle\"></div><div class=\"sk-circle10 sk-circle\"></div><div class=\"sk-circle11 sk-circle\"></div><div class=\"sk-circle12 sk-circle\"></div></div><div class=\"col-lg-8 col-md-8 col-sm-8 col-xs-8 no-padding full-height bid-groups-list\"><perfect-scrollbar class=\"scroller\" wheel-propagation=\"true\" min-scrollbar-length=\"20\"><table class=\"table footable table-stripped toggle-arrow-tiny\" data-page-size=\"100000\" data-filter-timeout=\"300\"><tbody><tr ng-repeat=\"group in bidGroupsCtrl.bidGroups | orderBy: bidGroupsCtrl.bidGroupsSelectedSort.sort\" ng-class=\"{\'highlight\':group.displaying}\" ng-click=\"bidGroupsCtrl.getBidGroupDetails(group)\"><td>{{ group.name }}</td><td>{{ group.numberOfAssets}}</td></tr></tbody><tfoot><tr><td colspan=\"5\"><ul class=\"pagination pull-right\"></ul></td></tr></tfoot></table></perfect-scrollbar></div><lateral-bar show=\"bidGroupsCtrl.showDetails\" config=\"bidGroupsCtrl.lateralBarConfig\" on-close=\"bidGroupsCtrl.closeDetails\" content-selector=\"\'.bid-groups-list\'\"></lateral-bar></div></div><div class=\"paginator-container\"><uib-pagination total-items=\"bidGroupsCtrl.bidGroupsCount\" ng-model=\"bidGroupsCtrl.currentPage\" class=\"pagination-sm\" max-size=\"bidGroupsCtrl.maxPaginationSize\" items-per-page=\"bidGroupsCtrl.perPage\" ng-change=\"bidGroupsCtrl.changePage()\" boundary-link-numbers=\"true\" rotate=\"false\"></uib-pagination></div></div></div></div>");
$templateCache.put("app/states/bid-engagement/add-rfp/add-rfp.html","<header-section breadcrumb-title=\"addRfpCtrl.title\" breadcrumbs=\"addRfpCtrl.breadcrumbs\"></header-section><div class=\"wrapper wrapper-content add-rfp\"><div class=\"row m-b-lg\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 wizard-buttons\"><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 no-padding\"><button translate=\"ADD_RFP.SELECT_ASSETS\" ui-sref=\"app.bidEngagement.addRfp.selectAssets(addRfpCtrl.params)\" ui-sref-active=\"current\" ng-class=\"{\'passed\': addRfpCtrl.state == \'app.bidEngagement.addRfp.bidAssignments\' || addRfpCtrl.state == \'app.bidEngagement.addRfp.selectAppraisers\'}\"></button></div><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 no-padding\"><button translate=\"ADD_RFP.SELECT_APPRAISERS\" ui-sref=\"app.bidEngagement.addRfp.selectAppraisers(addRfpCtrl.params)\" ui-sref-active=\"current\" ng-class=\"{\'passed\': addRfpCtrl.state == \'app.bidEngagement.addRfp.bidAssignments\'}\" ng-disabled=\"addRfpCtrl.state === \'app.bidEngagement.addRfp.selectAssets\'\"></button></div><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 no-padding\"><button translate=\"ADD_RFP.BID_ASSIGNMENT\" ui-sref=\"app.bidEngagement.addRfp.bidAssignments\" ui-sref-active=\"current\" disabled=\"\"></button></div></div></div><div ui-view=\"rfpWizard\"></div></div>");
$templateCache.put("app/states/bid-engagement/engagement-letters/admin-engagement-letters.html","<header-section breadcrumb-title=\"adminEngagementLettersCtrl.title\" breadcrumbs=\"adminEngagementLettersCtrl.breadcrumbs\"></header-section><section><div class=\"wrapper wrapper-content\"><div class=\"row filter\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content no-title no-padding-right no-padding-left\"><div class=\"row no-margins summary\" ng-hide=\"adminEngagementLettersCtrl.showFilters\"><div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3\"><span translate=\"ENGAGEMENT_LETTERS.PROPERTY_TYPE\"></span> <span class=\"big\">{{adminEngagementLettersCtrl.arrayToFormattedString(adminEngagementLettersCtrl.selectedPropertyTypes, \', \')}}</span></div><div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3\"><span translate=\"ENGAGEMENT_LETTERS.APPRAISER\"></span> <span class=\"big\">{{adminEngagementLettersCtrl.userArrayToFormattedString(adminEngagementLettersCtrl.selectedAppraisers, \', \')}}</span></div><div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3\"><span translate=\"ENGAGEMENT_LETTERS.DATE\"></span> <span class=\"big\" ng-if=\"adminEngagementLettersCtrl.filterDate\">{{adminEngagementLettersCtrl.filterDate | formatDate:\'MMM, YYYY\'}}</span></div></div><div class=\"row no-margins filters\" ng-show=\"adminEngagementLettersCtrl.showFilters\"><div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3 border-right\"><div class=\"row no-margins\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><span class=\"title\" translate=\"ENGAGEMENT_LETTERS.PROPERTY_TYPE\"></span></div></div><div class=\"row no-margins\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding fixed-height checkbox-custom\"><perfect-scrollbar class=\"scroller\" wheel-propagation=\"true\" min-scrollbar-length=\"20\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><div class=\"form-group\"><div class=\"icon-addon addon-md\"><input type=\"text\" class=\"form-control\" id=\"searchFilter\" translate=\"\" translate-attr-placeholder=\"ASSETS.SEARCH\" ng-model=\"adminEngagementLettersCtrl.searchQueryPropertyType\" ng-model-options=\"{ debounce: { \'default\': 300, \'blur\': 0 } }\"> <label class=\"fa fa-search\" rel=\"tooltip\"></label></div></div></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><table class=\"table footable table-stripped toggle-arrow-tiny\" data-page-size=\"100000\" data-filter=\"#searchFilter\" data-filter-timeout=\"300\"><tbody><tr><td><checkbox ng-model=\"adminEngagementLettersCtrl.allPropertyTypesSelected\"></checkbox>{{\"ADD_RFP.ALL\" | translate}}</td></tr><tr ng-repeat=\"propertyType in adminEngagementLettersCtrl.propertyTypes\"><td><checkbox ng-model=\"propertyType.selected\"></checkbox>{{ propertyType.name }}</td></tr></tbody></table></div></perfect-scrollbar></div></div></div><div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3 border-right appraisers-filter\"><span class=\"title\" translate=\"ENGAGEMENT_LETTERS.APPRAISER\"></span><select name=\"appraiser\" class=\"form-control\" chosen=\"\" ng-model=\"adminEngagementLettersCtrl.appraiser\" ng-options=\"appraiser.user.name for appraiser in adminEngagementLettersCtrl.appraisers\" required=\"\"><option style=\"display:none\" value=\"\" translate=\"ENGAGEMENT_LETTERS.SELECT_APPRAISER\"></option></select><ul><li class=\"data\" ng-repeat=\"selectedAppraiser in adminEngagementLettersCtrl.selectedAppraisers\">{{selectedAppraiser.user.name}} <span class=\"erase\" ng-click=\"adminEngagementLettersCtrl.deselectAppraiser(selectedAppraiser)\" action=\"display-none\"></span></li></ul></div><div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3\"><span class=\"title\" translate=\"ENGAGEMENT_LETTERS.DATE\"></span><div class=\"input-group\"><input name=\"date\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"MMM/yyyy\" is-open=\"adminEngagementLettersCtrl.filterPicker.opened\" datepicker-options=\"adminEngagementLettersCtrl.filterDateOptions\" ng-model=\"adminEngagementLettersCtrl.filterDate\" ng-model-options=\"adminEngagementLettersCtrl.filterModelOptions\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" type=\"button\" ng-click=\"adminEngagementLettersCtrl.openFilterPicker()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div></div></div></div><div class=\"row m-b-lg\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 text-right\" ng-hide=\"adminEngagementLettersCtrl.showFilters\"><button class=\"btn btn-w-m btn-normal m-l-sm m-t-xs\" translate=\"ENGAGEMENT_LETTERS.CHANGE\" ng-click=\"adminEngagementLettersCtrl.showFilters = true\"></button></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 text-right\" ng-show=\"adminEngagementLettersCtrl.showFilters\"><button class=\"btn btn-w-m btn-back m-t-xs\" translate=\"ENGAGEMENT_LETTERS.CLEAR_FILTERS\" ng-click=\"adminEngagementLettersCtrl.clearFilters()\"></button> <button class=\"btn btn-w-m btn-normal m-l-sm m-t-xs\" translate=\"COMMONS.SEARCH\" ng-click=\"adminEngagementLettersCtrl.search()\"></button></div></div><div class=\"row results admin-letters\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 fixed-height\" ng-hide=\"adminEngagementLettersCtrl.searched\"><div class=\"empty-assets\"><i class=\"icon icon-ic-magnifier\"></i><br>{{\"ENGAGEMENT_LETTERS.PLEASE_SEARCH\"| translate}}</div></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 fixed-height\" ng-show=\"adminEngagementLettersCtrl.searched && adminEngagementLettersCtrl.letter.length == 0\"><div class=\"empty-assets\"><i class=\"icon icon-ic-magnifier\"></i><br>{{\"ADD_RFP.NO_ASSETS_FOUND\"| translate}}</div></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" ng-show=\"adminEngagementLettersCtrl.searched && adminEngagementLettersCtrl.letter.length != 0\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><div class=\"col-lg-7 col-sm-7 col-md-7 col-xs-7 no-padding\"><h4>{{\"ENGAGEMENT_LETTERS.ENGAGEMENT_LETTERS\" | translate}} <span ng-show=\"adminEngagementLettersCtrl.letters.length > 0\">({{adminEngagementLettersCtrl.letters.length}})</span></h4></div><div class=\"col-lg-5 col-sm-5 col-md-5 col-xs-5 no-padding\"><div class=\"form-group no-margins\"><div class=\"icon-addon addon-md\"><input type=\"text\" class=\"form-control\" id=\"search\" translate=\"\" translate-attr-placeholder=\"USERS.SEARCH\" ng-change=\"adminEngagementLettersCtrl.searchLetters()\" ng-model=\"adminEngagementLettersCtrl.searchQuery\" ng-model-options=\"{ debounce: { \'default\': 300, \'blur\': 0 } }\"> <label for=\"search\" class=\"fa fa-search\" rel=\"tooltip\"></label></div></div></div></div><div class=\"row no-margins fixed-header\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><ul><li><a translate=\"ENGAGEMENT_LETTERS.DOCUMENT\" ng-click=\"adminEngagementLettersCtrl.sorting(adminEngagementLettersCtrl.lettersSort[0], \'lettersSelectedSort\')\" ng-class=\"{\'asc\': adminEngagementLettersCtrl.lettersSort[0].flag, \'desc\': !adminEngagementLettersCtrl.lettersSort[0].flag, \'not-selected\': !adminEngagementLettersCtrl.lettersSort[0].selected}\"></a></li><li><a translate=\"ENGAGEMENT_LETTERS.RFP_NAME\"></a></li><li><a translate=\"ENGAGEMENT_LETTERS.APPRAISER\"></a></li><li><a translate=\"ENGAGEMENT_LETTERS.OWNER\"></a></li><li><a translate=\"ENGAGEMENT_LETTERS.DATE\"></a></li><li></li></ul></div></div><div class=\"ibox-content no-padding\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding fixed-height\"><perfect-scrollbar class=\"scroller\" wheel-propagation=\"true\" min-scrollbar-length=\"20\"><table class=\"table footable table-stripped toggle-arrow-tiny\" data-page-size=\"100000\" data-filter=\"#search\" data-filter-timeout=\"300\"><tbody><tr ng-repeat=\"letter in adminEngagementLettersCtrl.letters | orderBy: adminEngagementLettersCtrl.lettersSelectedSort.sort\"><td>{{ letter.fileName || \"N/A\" }}</td><td>{{ letter.bidRequest.name || \"N/A\" }}</td><td><div class=\"m-r-xs avatar-container\" avatar=\"letter.appraiser.user.name\" role=\"letter.appraiser.role\"></div>{{letter.appraiser.user.name}}</td><td><div class=\"m-r-xs avatar-container\" avatar=\"letter.owner.user.name\" role=\"letter.owner.role\"></div>{{letter.owner.user.name}}</td><td>{{ letter.createdOn | date:\'MMM dd, yyyy\' }}</td><td class=\"tools\"><button class=\"btn btn-back\" type=\"button\" ng-click=\"adminEngagementLettersCtrl.downloadLetter(letter)\"><i class=\"icon icon-ic-download\"></i></button></td></tr></tbody></table></perfect-scrollbar></div></div></div></div></div></div></section>");
$templateCache.put("app/states/bid-engagement/bid-summary/bid-summary.html","<header-section breadcrumb-title=\"bidSummaryCtrl.title\" breadcrumbs=\"bidSummaryCtrl.breadcrumbs\"></header-section><div class=\"wrapper wrapper-content\" nvc-full-page=\"\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><div class=\"row no-margins\"><div class=\"col-lg-7 col-md-7 col-sm-7 col-xs-7 no-padding\"><h4>{{bidSummaryCtrl.bid.name}}</h4><span>{{ \"BID_SUMMARY.ASSETS_AWARDED\" | translate }} ({{ bidSummaryCtrl.bid.awarded }}/{{ bidSummaryCtrl.bid.assets.length }})</span><br><span>{{ \"BID_SUMMARY.APPRAISERS_RESPONSES\" | translate }} ({{ bidSummaryCtrl.bid.responses }}/{{ bidSummaryCtrl.bid.appraisers.length }})</span></div><div class=\"col-lg-5 col-md-5 col-sm-5 col-xs-5 no-padding\"><div class=\"form-group no-margins ibox-search-row\"><div uib-dropdown=\"\" is-open=\"bidSummaryCtrl.dropdown.isOpen\"><button ng-disabled=\"bidSummaryCtrl.downloadLoading\" class=\"btn btn-download\" ng-class=\"{\'btn-dropdown-active\': bidSummaryCtrl.dropdown.isOpen}\" uib-dropdown-toggle=\"\"><i class=\"icon icon-ic-download\"></i> {{ \"COMMONS.DOWNLOAD\" | translate }}</button><ul class=\"dropdown-menu\" uib-dropdown-menu=\"\"><li><a href=\"#\" class=\"btn-block btn-dropdown\" ng-click=\"bidSummaryCtrl.downloadPdf()\"><img class=\"dropdown-option-icon\" src=\"/assets/images/pdf.svg\"> {{ \"COMMONS.PDF\" | translate }}</a></li><li><a href=\"#\" class=\"btn-block btn-dropdown\" ng-click=\"bidSummaryCtrl.downloadCsv()\"><img class=\"dropdown-option-icon\" src=\"/assets/images/excel.svg\"> {{ \"COMMONS.EXCEL\" | translate }}</a></li></ul></div><div class=\"icon-addon addon-md ibox-search\"><input type=\"text\" class=\"form-control\" id=\"search\" translate=\"\" translate-attr-placeholder=\"COMMONS.SEARCH_IN_TABLE\" ng-model=\"bidSummaryCtrl.searchQuery\"> <label for=\"search\" class=\"fa fa-search\" rel=\"tooltip\"></label></div></div></div></div></div><div class=\"row no-margins fixed-header\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><ul ng-class=\"{\'hidden-quarterly\': !bidSummaryCtrl.showQuarterly}\"><li><a translate=\"BID_SUMMARY.ASSET\" ng-click=\"bidSummaryCtrl.assetsSort()\" ng-class=\"{\'asc\': bidSummaryCtrl.assetSort.flag, \'desc\': !bidSummaryCtrl.assetSort.flag, \'not-selected\': !bidSummaryCtrl.assetSort.selected}\"></a></li><li><a translate=\"BID_SUMMARY.YEAR_1\" ng-click=\"bidSummaryCtrl.sorting(bidSummaryCtrl.summarySort[0], \'summarySelectedSort\')\" ng-class=\"{\'asc\': bidSummaryCtrl.summarySort[0].flag, \'desc\': !bidSummaryCtrl.summarySort[0].flag, \'not-selected\': !bidSummaryCtrl.summarySort[0].selected}\"></a></li><li><a translate=\"BID_SUMMARY.YEAR_2&3\" ng-click=\"bidSummaryCtrl.sorting(bidSummaryCtrl.summarySort[2], \'summarySelectedSort\')\" ng-class=\"{\'asc\': bidSummaryCtrl.summarySort[2].flag, \'desc\': !bidSummaryCtrl.summarySort[2].flag, \'not-selected\': !bidSummaryCtrl.summarySort[2].selected}\"></a></li><li ng-if=\"bidSummaryCtrl.showQuarterly\"><a translate=\"BID_SUMMARY.UPDATE\" ng-click=\"bidSummaryCtrl.sorting(bidSummaryCtrl.summarySort[4], \'summarySelectedSort\')\" ng-class=\"{\'asc\': bidSummaryCtrl.summarySort[4].flag, \'desc\': !bidSummaryCtrl.summarySort[4].flag, \'not-selected\': !bidSummaryCtrl.summarySort[4].selected}\"></a></li><li><a translate=\"BID_SUMMARY.TOTAL_FEE\" ng-click=\"bidSummaryCtrl.sorting(bidSummaryCtrl.summarySort[6], \'summarySelectedSort\')\" ng-class=\"{\'asc\': bidSummaryCtrl.summarySort[6].flag, \'desc\': !bidSummaryCtrl.summarySort[6].flag, \'not-selected\': !bidSummaryCtrl.summarySort[6].selected}\"></a></li><li><a translate=\"BID_SUMMARY.BID_NOTES\"></a></li></ul></div></div><div class=\"ibox-content no-padding\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding full-height\"><perfect-scrollbar class=\"scroller\" wheel-propagation=\"true\" min-scrollbar-length=\"20\"><div class=\"row no-margins\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><table class=\"table\"><tbody><tr ng-repeat-start=\"asset in bidSummaryCtrl.bid.assets | filter:bidSummaryCtrl.search\"><td class=\"asset-name\" colspan=\"10\"><a ui-sref=\"app.asset.assetDetails({assetId: asset.id, asset: asset})\">{{asset.name}}</a></td></tr><tr ng-repeat-end=\"\"><td colspan=\"10\" class=\"no-padding appraisers-list\"><table class=\"table checkbox-custom\"><tbody><tr ng-repeat=\"bidResponse in asset.bidResponses | orderBy:bidSummaryCtrl.summarySelectedSort.sort\" ng-class=\"{\'disable\': asset.awarded || bidSummaryCtrl.bid.isCancelled}\"><td ng-class=\"{\'hidden-quarterly\': !bidSummaryCtrl.showQuarterly}\">{{bidResponse.appraiser.user.name}}</td><td ng-if=\"bidResponse.yearOneOld && bidResponse.isValueSynced == false\" ng-class=\"{\'hidden-quarterly\': !bidSummaryCtrl.showQuarterly}\">{{bidResponse.yearOneOld | currency:undefined:0}}</td><td ng-if=\"(bidResponse.isValueSynced || bidResponse.isValueSynced == undefined || bidResponse.isValueSynced == null)\" ng-class=\"{\'hidden-quarterly\': !bidSummaryCtrl.showQuarterly}\">{{bidResponse.yearOne | currency:undefined:0}}</td><td ng-if=\"bidResponse.yearsTwoThreeOld && bidResponse.isValueSynced == false\" ng-class=\"{\'hidden-quarterly\': !bidSummaryCtrl.showQuarterly}\">{{bidResponse.yearsTwoThreeOld | currency:undefined:0}}</td><td ng-if=\"(bidResponse.isValueSynced || bidResponse.isValueSynced == undefined || bidResponse.isValueSynced == null)\" ng-class=\"{\'hidden-quarterly\': !bidSummaryCtrl.showQuarterly}\">{{bidResponse.yearsTwoThree | currency:undefined:0}}</td><td ng-if=\"bidResponse.isValueSynced == false && bidSummaryCtrl.showQuarterly\" ng-class=\"{\'hidden-quarterly\': !bidSummaryCtrl.showQuarterly}\">{{bidResponse.quarterlyOld ? (bidResponse.quarterlyOld | currency:undefined:0) : \'N/A\'}}</td><td ng-if=\"(bidResponse.isValueSynced || bidResponse.isValueSynced == undefined || bidResponse.isValueSynced == null) && bidSummaryCtrl.showQuarterly\" ng-class=\"{\'hidden-quarterly\': !bidSummaryCtrl.showQuarterly}\">{{bidResponse.quarterly ? (bidResponse.quarterly | currency:undefined:0) : \'N/A\'}}</td><td ng-class=\"{\'hidden-quarterly\': !bidSummaryCtrl.showQuarterly}\"><checkbox ng-model=\"bidResponse.isSelectedFee\" ng-click=\"bidSummaryCtrl.selectFee(asset, bidResponse)\" ng-disabled=\"asset.awarded || bidSummaryCtrl.bid.isCancelled\"></checkbox>{{bidResponse.totalFee | currency:undefined:0}}</td><td ng-class=\"{\'hidden-quarterly\': !bidSummaryCtrl.showQuarterly}\" class=\"bid-notes\"><span class=\"icon icon-ic-comment-text appraiser-notes m-r-xs\" ng-class=\"{\'visible\': bidResponse.bidNotes}\" ng-click=\"bidSummaryCtrl.openAppNotes(bidResponse)\"><div class=\"appraiser-notes-container notes-container\" ng-show=\"bidResponse.openedAppNotes\"><i class=\"icon icon-ic-close\" ng-click=\"bidSummaryCtrl.closeAppNotes($event, bidResponse)\"></i><div class=\"col-lg-2 col-md-2 col-sm-2 col-xs-2 no-padding text-center\"><span class=\"avatar\"></span></div><div class=\"col-lg-10 col-md-10 col-sm-10 col-xs-10 no-padding\"><p ng-if=\"bidResponse.isValueSynced == false\">{{bidResponse.bidNotesOld}}</p><p ng-if=\"(bidResponse.isValueSynced || bidResponse.isValueSynced == undefined || bidResponse.isValueSynced == null)\">{{bidResponse.bidNotes}}</p></div></div></span> <span class=\"icon icon-ic-comment-text admin-notes m-r-xs\" ng-hide=\"!bidResponse.bidNotesAdmin\" ng-click=\"bidSummaryCtrl.openAdminNotes(bidResponse)\"><div class=\"admin-notes-container notes-container\" ng-show=\"bidResponse.openedAdminNotes\"><i class=\"icon icon-ic-close\" ng-click=\"bidSummaryCtrl.closeAdminNotes($event, bidResponse)\"></i><div class=\"col-lg-2 col-md-2 col-sm-2 col-xs-2 no-padding text-center\"><span class=\"avatar\"></span></div><div class=\"col-lg-10 col-md-10 col-sm-10 col-xs-10 no-padding word-break\"><p>{{bidResponse.bidNotesAdmin}}</p></div></div></span> <span class=\"icon icon-ic-comment-plus-outline admin-notes-add\" ng-class=\"{\'visible\': bidResponse.openedAddNotes}\" ng-hide=\"bidResponse.bidNotesAdmin\" ng-click=\"bidSummaryCtrl.openAddNotes(bidResponse)\"><div class=\"add-notes-container notes-container\" ng-show=\"bidResponse.openedAddNotes\"><i class=\"icon icon-ic-close\" ng-click=\"bidSummaryCtrl.closeAddNotes($event, bidResponse)\"></i> <span class=\"title\" translate=\"BID_SUMMARY.POST_NOTES\"></span><form role=\"form\" name=\"bidSummaryCtrl.addNewNote\" novalidate=\"\"><div class=\"form-group m-t-sm no-margin-bottom\"><textarea class=\"form-control\" maxlength=\"600\" ng-model=\"bidSummaryCtrl.addBidNote\" required=\"\"></textarea></div><div class=\"counter text-right m-b-sm\"><span>{{bidSummaryCtrl.addBidNote.length || 0}}/600</span></div><div class=\"text-right\"><button class=\"btn btn-w-m btn-normal no-margins\" type=\"button\" translate=\"BID_SUMMARY.POST\" ng-click=\"bidSummaryCtrl.addNewNote.$valid && bidSummaryCtrl.saveNotes(bidResponse, asset.id)\"></button></div></form></div></span></td></tr></tbody></table></td></tr></tbody></table></div></div></perfect-scrollbar></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><button class=\"btn btn-w-m btn-normal\" type=\"button\" translate=\"COMMONS.SAVE\" ng-click=\"bidSummaryCtrl.saveProgress()\" ng-hide=\"bidSummaryCtrl.bid.awarded == bidSummaryCtrl.bid.assets.length\"></button></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right\"><button class=\"btn btn-w-m btn-back\" translate=\"COMMONS.CANCEL\" ui-sref=\"app.bidEngagement.bidEngagementList\" ng-hide=\"bidSummaryCtrl.bid.awarded == bidSummaryCtrl.bid.assets.length\"></button> <button class=\"btn btn-w-m btn-back\" translate=\"COMMONS.BACK\" ui-sref=\"app.bidEngagement.bidEngagementList\" ng-show=\"bidSummaryCtrl.bid.awarded == bidSummaryCtrl.bid.assets.length\"></button> <button class=\"btn btn-w-m btn-normal m-l-xs\" translate=\"COMMONS.SUBMIT\" ng-click=\"bidSummaryCtrl.submitBidSummary()\" ng-hide=\"bidSummaryCtrl.bid.awarded == bidSummaryCtrl.bid.assets.length || bidSummaryCtrl.bid.isCancelled\"></button></div></div></div>");
$templateCache.put("app/states/bid-engagement/bid-engagement-list/bid-engagement-list.html","<header-section breadcrumb-title=\"bidEngagementListCtrl.title\" breadcrumbs=\"bidEngagementListCtrl.breadcrumbs\"></header-section><section><div class=\"wrapper wrapper-content\" nvc-full-page=\"\" paginator=\"true\"><div class=\"row\" td-security=\"[\'Admin\']\" action=\"display-none\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"m-b-lg text-right\"><a class=\"btn btn-w-m btn-normal\" ui-sref=\"app.bidEngagement.addRfp.selectAssets\" translate=\"BID_ENGAGEMENT_LIST.CREATE_NEW_RFP\"></a></div></div></div><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bids-list\"><div class=\"col-lg-7 col-sm-7 col-md-7 col-xs-7 no-padding\"><h4>{{\"BID_ENGAGEMENT_LIST.RFP_SENT\" | translate}}&nbsp;<span>({{bidEngagementListCtrl.bidsCount}})</span></h4></div><div class=\"col-lg-5 col-sm-5 col-md-5 col-xs-5 no-padding\"><div class=\"form-group no-margins ibox-search-row\"><div uib-dropdown=\"\" is-open=\"bidEngagementListCtrl.dropdown.isOpen\"><button ng-disabled=\"bidEngagementListCtrl.downloadLoading\" class=\"btn btn-download\" ng-class=\"{\'btn-dropdown-active\': bidEngagementListCtrl.dropdown.isOpen}\" uib-dropdown-toggle=\"\"><i class=\"icon icon-ic-download\"></i> {{ \"COMMONS.DOWNLOAD\" | translate }}</button><ul class=\"dropdown-menu\" uib-dropdown-menu=\"\"><li><a href=\"#\" class=\"btn-block btn-dropdown\" ng-click=\"bidEngagementListCtrl.downloadPdf()\"><img class=\"dropdown-option-icon\" src=\"/assets/images/pdf.svg\"> {{ \"COMMONS.PDF\" | translate }}</a></li><li><a href=\"#\" class=\"btn-block btn-dropdown\" ng-click=\"bidEngagementListCtrl.downloadCsv()\"><img class=\"dropdown-option-icon\" src=\"/assets/images/excel.svg\"> {{ \"COMMONS.EXCEL\" | translate }}</a></li></ul></div><div class=\"icon-addon addon-md ibox-search\"><input type=\"text\" class=\"form-control\" id=\"search\" translate=\"\" translate-attr-placeholder=\"COMMONS.SEARCH_IN_TABLE\" ng-change=\"bidEngagementListCtrl.searchBids()\" ng-model=\"bidEngagementListCtrl.searchQuery\" ng-model-options=\"{ debounce: { \'default\': 500, \'blur\': 0 } }\"> <label for=\"search\" class=\"fa fa-search\" rel=\"tooltip\"></label></div></div></div></div><div class=\"row no-margins fixed-header bids-list\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><ul><li><a translate=\"BID_ENGAGEMENT_LIST.RFP_NAME\" ng-click=\"bidEngagementListCtrl.sorting(bidEngagementListCtrl.bidSort[0], \'bidSelectedSort\')\" ng-class=\"{\'asc\': bidEngagementListCtrl.bidSort[0].flag, \'desc\': !bidEngagementListCtrl.bidSort[0].flag, \'not-selected\': !bidEngagementListCtrl.bidSort[0].selected}\"></a></li><li><a translate=\"BID_ENGAGEMENT_LIST.ASSETS_AWARDED\" ng-click=\"bidEngagementListCtrl.sorting(bidEngagementListCtrl.bidSort[1], \'bidSelectedSort\')\" ng-class=\"{\'asc\': bidEngagementListCtrl.bidSort[1].flag, \'desc\': !bidEngagementListCtrl.bidSort[1].flag, \'not-selected\': !bidEngagementListCtrl.bidSort[1].selected}\"></a></li><li><a translate=\"BID_ENGAGEMENT_LIST.RESPONSES\" ng-click=\"bidEngagementListCtrl.sorting(bidEngagementListCtrl.bidSort[2], \'bidSelectedSort\')\" ng-class=\"{\'asc\': bidEngagementListCtrl.bidSort[2].flag, \'desc\': !bidEngagementListCtrl.bidSort[2].flag, \'not-selected\': !bidEngagementListCtrl.bidSort[2].selected}\"></a></li><li><a translate=\"BID_ENGAGEMENT_LIST.BID_DUE_DATE\" ng-click=\"bidEngagementListCtrl.sorting(bidEngagementListCtrl.bidSort[3], \'bidSelectedSort\')\" ng-class=\"{\'asc\': bidEngagementListCtrl.bidSort[3].flag, \'desc\': !bidEngagementListCtrl.bidSort[3].flag, \'not-selected\': !bidEngagementListCtrl.bidSort[3].selected}\"></a></li></ul></div></div><div class=\"ibox-content no-padding paginator-loader\"><div class=\"sk-spinner sk-spinner-circle\"><div class=\"sk-circle1 sk-circle\"></div><div class=\"sk-circle2 sk-circle\"></div><div class=\"sk-circle3 sk-circle\"></div><div class=\"sk-circle4 sk-circle\"></div><div class=\"sk-circle5 sk-circle\"></div><div class=\"sk-circle6 sk-circle\"></div><div class=\"sk-circle7 sk-circle\"></div><div class=\"sk-circle8 sk-circle\"></div><div class=\"sk-circle9 sk-circle\"></div><div class=\"sk-circle10 sk-circle\"></div><div class=\"sk-circle11 sk-circle\"></div><div class=\"sk-circle12 sk-circle\"></div></div><div class=\"col-lg-8 col-md-8 col-sm-8 col-xs-8 no-padding bids-list full-height\"><perfect-scrollbar class=\"scroller\" wheel-propagation=\"false\" wheel-speed=\"1\" min-scrollbar-length=\"20\"><table class=\"table footable table-stripped toggle-arrow-tiny\" data-page-size=\"100000\" data-filter-timeout=\"300\"><tbody><tr ng-repeat=\"bid in bidEngagementListCtrl.bidList\" ng-click=\"bidEngagementListCtrl.getBidDetails(bid)\" ng-class=\"{\'highlight\':bid.displaying}\"><td>{{ bid.name }} <span class=\"cancelled-text\" ng-if=\"bid.isCancelled\">- {{\'BID_ENGAGEMENT_LIST.CANCELLED\' | translate}}</span></td><td>{{ bid.awarded || 0 }}/{{ bid.assets.length || 0 }}</td><td>{{ bid.responses || 0 }}/{{ bid.appraisers.length || 0 }}</td><td>{{ bid.dueDate | date:\'MMM dd, yyyy\' }}</td></tr></tbody><tfoot><tr><td colspan=\"5\"><ul class=\"pagination pull-right\"></ul></td></tr></tfoot></table></perfect-scrollbar></div><lateral-bar show=\"bidEngagementListCtrl.showDetails\" config=\"bidEngagementListCtrl.lateralBarConfig\" on-close=\"bidEngagementListCtrl.closeDetails\" content-selector=\"\'.bids-list\'\"></lateral-bar></div></div><div class=\"paginator-container\"><uib-pagination total-items=\"bidEngagementListCtrl.bidsCount\" ng-model=\"bidEngagementListCtrl.currentPage\" class=\"pagination-sm\" max-size=\"bidEngagementListCtrl.maxPaginationSize\" items-per-page=\"bidEngagementListCtrl.perPage\" ng-change=\"bidEngagementListCtrl.changePage()\" boundary-link-numbers=\"true\" rotate=\"false\"></uib-pagination></div></div></div></div></section>");
$templateCache.put("app/states/bid-engagement/bid-engagement-list/big-engagement-list-lateral-content.html","<div id=\"bid-info\" class=\"bid-info\"><div class=\"row no-margins\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><h4>{{ bid.name }} <span ng-if=\"bid.isCancelled\" class=\"cancelled-text font-weight-500\">- {{\"BID_ENGAGEMENT_LIST.CANCELLED\" | translate }}</span></h4><div class=\"d-flex justify-content-between\"><a class=\"btn btn-w-m btn-normal\" ui-sref=\"app.bidEngagement.bidSummary({bidId:bid.id})\" translate=\"BID_ENGAGEMENT_LIST.VIEW_RESPONSES\" ng-show=\"bid.responses\"></a> <button class=\"btn btn-w-m btn-normal btn-bg-danger\" [td-security]=\"[\'Admin\']\" ng-click=\"onCancelRFP()\" ng-if=\"!bid.isCancelled && bid.awarded == 0\" translate=\"BID_ENGAGEMENT_LIST.CANCEL_RFP\"></button></div></div></div><hr><div class=\"row no-margins\" ng-hide=\"!bid.responses\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><h5 class=\"m-b-md\">{{ \"BID_ENGAGEMENT_LIST.RESPONSES\" | translate }} ({{ bid.responses }}/{{ bid.appraisers.length }})</h5><div class=\"row no-margin-left no-margin-right response-list m-b-xs\" ng-repeat=\"appraiser in bid.appraisers | filter:{\'responseBid\': true} | orderBy:\'-responseBid\'\" ng-class=\"{\'response-app\': appraiser.responseBid}\"><div class=\"col-lg-5 col-md-5 col-sm-5 col-xs-5\">{{appraiser.user.name}}</div><div class=\"col-lg-7 col-md-7 col-sm-7 col-xs-7\">{{appraiser.companyName}}</div></div></div></div><hr ng-hide=\"!bid.responses\"><div class=\"row no-margins\" ng-hide=\"!bid.pending\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><h5 class=\"pending m-b-md\">{{ \"BID_ENGAGEMENT_LIST.PENDING\" | translate }} ({{ bid.pending }}/{{ bid.appraisers.length }})</h5><div class=\"row no-margin-left no-margin-right response-list m-b-xs\" ng-repeat=\"appraiser in bid.appraisers | filter:{\'responseBid\': false, \'declineBid\': false}\"><div class=\"col-lg-5 col-md-5 col-sm-5 col-xs-5\">{{appraiser.user.name}}</div><div class=\"col-lg-7 col-md-7 col-sm-7 col-xs-7\">{{appraiser.companyName}}</div></div></div></div><hr ng-hide=\"!bid.pending\"><div class=\"row no-margins\" ng-hide=\"!bid.declines\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><h5 class=\"declined m-b-md\">{{ \"BID_ENGAGEMENT_LIST.DECLINED\" | translate }} ({{ bid.declines }}/{{ bid.appraisers.length }})</h5><div class=\"row no-margin-left no-margin-right declined-list m-b-xs\" ng-repeat=\"appraiser in bid.appraisers | filter:{\'declineBid\': true}\"><div class=\"col-lg-5 col-md-5 col-sm-5 col-xs-5\">{{appraiser.user.name}}</div><div class=\"col-lg-7 col-md-7 col-sm-7 col-xs-7\">{{appraiser.companyName}}</div></div></div></div><hr ng-hide=\"!bid.declines\"></div><div id=\"bid-assets-list\" class=\"bid-assets-list\"><div class=\"row no-margins\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><h5 class=\"m-b-md\">{{ \"BID_ENGAGEMENT_LIST.ASSETS_AWARDED\" | translate }} ({{ bid.awarded }}/{{ bid.assets.length }})</h5><div class=\"row no-margin-left no-margin-right assets-list m-b-xs\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><ul><li ng-repeat=\"asset in bid.assets | orderBy:\'-awarded\'\" ng-class=\"{\'awarded\': asset.awarded}\"><a ui-sref=\"app.asset.assetDetails({assetId: asset.id, asset: asset})\">{{asset.name}}</a></li></ul></div></div></div></div></div>");
$templateCache.put("app/states/bid-engagement/assignment-summary/assignment-summary.html","<header-section breadcrumb-title=\"assignmentSummaryCtrl.title\" breadcrumbs=\"assignmentSummaryCtrl.breadcrumbs\"></header-section><div class=\"wrapper wrapper-content\" nvc-full-page=\"\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"row no-margins\"><div class=\"col-lg-4 col-md-12 col-sm-12 col-xs-12 no-padding appraisers-awarded-table\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><h4>{{ \"ASSIGNMENT_SUMMARY.APPRAISERS_AWARDED\" | translate }} ({{ assignmentSummaryCtrl.bid.appraisers.length }})</h4></div></div><div class=\"row no-margins fixed-header\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><ul><li><a translate=\"ASSIGNMENT_SUMMARY.NAME\" ng-click=\"assignmentSummaryCtrl.sorting(assignmentSummaryCtrl.appraisersSort[0], \'appraisersSelectedSort\')\" ng-class=\"{\'asc\': assignmentSummaryCtrl.appraisersSort[0].flag, \'desc\': !assignmentSummaryCtrl.appraisersSort[0].flag, \'not-selected\': !assignmentSummaryCtrl.appraisersSort[0].selected}\"></a></li><li><a translate=\"ASSIGNMENT_SUMMARY.ASSETS_ASSIGNED\" ng-click=\"assignmentSummaryCtrl.sorting(assignmentSummaryCtrl.appraisersSort[1], \'appraisersSelectedSort\')\" ng-class=\"{\'asc\': assignmentSummaryCtrl.appraisersSort[1].flag, \'desc\': !assignmentSummaryCtrl.appraisersSort[1].flag, \'not-selected\': !assignmentSummaryCtrl.appraisersSort[1].selected}\"></a></li></ul></div></div><div class=\"ibox-content no-padding\"><div class=\"row no-margins\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding full-height\"><perfect-scrollbar nvc-block-scroll=\"\" class=\"scroller\" wheel-propagation=\"true\" min-scrollbar-length=\"20\"><table class=\"table table-striped\"><tbody><tr ng-repeat=\"appraiser in assignmentSummaryCtrl.bid.appraisers | orderBy:assignmentSummaryCtrl.appraisersSelectedSort.sort\" ng-click=\"assignmentSummaryCtrl.getAppraiserDetail(appraiser)\" ng-class=\"{\'highlight\':appraiser.displaying}\"><td>{{ appraiser.user.name }}</td><td>{{ appraiser.assetsAssigned }}</td></tr></tbody></table></perfect-scrollbar></div></div></div></div></div><div class=\"col-lg-8 col-md-12 col-sm-12 col-xs-12 no-padding appraisers-info\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content no-padding no-title\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding full-height\"><perfect-scrollbar nvc-block-scroll=\"\" class=\"scroller\" wheel-propagation=\"true\" min-scrollbar-length=\"20\"><div class=\"row no-margins\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"appraiser-title m-t-lg\"><span class=\"name\">{{ assignmentSummaryCtrl.selectedAppraiser.user.name }}</span> <span class=\"company\">{{ assignmentSummaryCtrl.selectedAppraiser.companyName }}</span><div class=\"appraiser-specialties\"><div class=\"specialties\"><span class=\"specialties\">{{assignmentSummaryCtrl.arrayToFormattedString(assignmentSummaryCtrl.selectedAppraiser.user.assetTypeSpecialties, \', \') | camelCaseToHuman}} / {{assignmentSummaryCtrl.arrayToFormattedString(assignmentSummaryCtrl.selectedAppraiser.user.workedOnStates, \', \')}}</span></div></div></div></div></div><div class=\"row no-margins\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><hr></div></div><div class=\"row asset-assigned-title\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><h4>{{ \"ASSIGNMENT_SUMMARY.ASSETS_ASSIGNED\" | translate }} ({{ assignmentSummaryCtrl.selectedAppraiser.assets.length }})</h4></div></div><div class=\"row no-margins assets-table-container\"><div class=\"row no-margins fixed-header assets-header\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><ul><li title=\"{{\'ASSIGNMENT_SUMMARY.ASSET\' | translate}}\"><a translate=\"ASSIGNMENT_SUMMARY.ASSET\" ng-click=\"assignmentSummaryCtrl.sortingAssets(assignmentSummaryCtrl.assetsSort[0], \'assetsSelectedSort\')\" ng-class=\"{\'asc\': assignmentSummaryCtrl.assetsSort[0].flag, \'desc\': !assignmentSummaryCtrl.assetsSort[0].flag, \'not-selected\': !assignmentSummaryCtrl.assetsSort[0].selected}\"></a></li><li title=\"{{\'ASSIGNMENT_SUMMARY.YEAR_1\' | translate}}\"><a translate=\"ASSIGNMENT_SUMMARY.YEAR_1\" ng-click=\"assignmentSummaryCtrl.sortingAssets(assignmentSummaryCtrl.assetsSort[1], \'assetsSelectedSort\')\" ng-class=\"{\'asc\': assignmentSummaryCtrl.assetsSort[1].flag, \'desc\': !assignmentSummaryCtrl.assetsSort[1].flag, \'not-selected\': !assignmentSummaryCtrl.assetsSort[1].selected}\"></a></li><li title=\"{{\'ASSIGNMENT_SUMMARY.YEAR\' | translate}} 2&3\"><a translate=\"ASSIGNMENT_SUMMARY.YEAR_2_3\" ng-click=\"assignmentSummaryCtrl.sortingAssets(assignmentSummaryCtrl.assetsSort[2], \'assetsSelectedSort\')\" ng-class=\"{\'asc\': assignmentSummaryCtrl.assetsSort[2].flag, \'desc\': !assignmentSummaryCtrl.assetsSort[2].flag, \'not-selected\': !assignmentSummaryCtrl.assetsSort[2].selected}\"></a></li><li title=\"{{\'ASSIGNMENT_SUMMARY.UPDATE\' | translate}}\"><a translate=\"ASSIGNMENT_SUMMARY.UPDATE\" ng-click=\"assignmentSummaryCtrl.sortingAssets(assignmentSummaryCtrl.assetsSort[3], \'assetsSelectedSort\')\" ng-class=\"{\'asc\': assignmentSummaryCtrl.assetsSort[3].flag, \'desc\': !assignmentSummaryCtrl.assetsSort[3].flag, \'not-selected\': !assignmentSummaryCtrl.assetsSort[3].selected}\"></a></li><li title=\"{{\'ASSIGNMENT_SUMMARY.TOTAL_FEE\' | translate}}\"><a translate=\"ASSIGNMENT_SUMMARY.TOTAL_FEE\" ng-click=\"assignmentSummaryCtrl.sortingAssets(assignmentSummaryCtrl.assetsSort[4], \'assetsSelectedSort\')\" ng-class=\"{\'asc\': assignmentSummaryCtrl.assetsSort[4].flag, \'desc\': !assignmentSummaryCtrl.assetsSort[4].flag, \'not-selected\': !assignmentSummaryCtrl.assetsSort[4].selected}\"></a></li><li title=\"{{\'ASSIGNMENT_SUMMARY.ROLL_OVER_DATE\' | translate}}\"><a translate=\"ASSIGNMENT_SUMMARY.ROLL_OVER_DATE\" ng-click=\"assignmentSummaryCtrl.sortingAssets(assignmentSummaryCtrl.assetsSort[5], \'assetsSelectedSort\')\" ng-class=\"{\'selected\': assignmentSummaryCtrl.assetsSort[5].selected}\"></a></li><li><a ng-click=\"assignmentSummaryCtrl.sortingAssets(assignmentSummaryCtrl.assetsSort[5], \'assetsSelectedSort\')\" ng-class=\"{\'asc\': assignmentSummaryCtrl.assetsSort[5].flag, \'desc\': !assignmentSummaryCtrl.assetsSort[5].flag, \'not-selected\': !assignmentSummaryCtrl.assetsSort[5].selected}\">&nbsp;</a></li></ul></div></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 m-b-xl\"><table class=\"table assets-table\"><tbody><tr ng-repeat=\"asset in assignmentSummaryCtrl.selectedAppraiser.assets | orderBy:assignmentSummaryCtrl.assetsSelectedSort.sort\" ng-class=\"{\'not-updated\': asset.notUpdated}\"><td><a ui-sref=\"app.asset.assetDetails({assetId: asset.id, asset: asset})\">{{ asset.name }}</a></td><td>{{ asset.bidResponse.yearOneSelected | currency:undefined:0 }}</td><td>{{ asset.bidResponse.yearsTwoThreeSelected | currency:undefined:0 }}</td><td>{{ asset.bidResponse.quarterlySelected ? (asset.bidResponse.quarterlySelected | currency:undefined:0) : \'N/A\' }}</td><td>{{ asset.bidResponse.totalSelected | currency:undefined:0 }}</td><td ng-hide=\"asset.editingDate\">{{ asset.rollOverDate | date:\'MMM dd, yyyy\' }}</td><td class=\"datepicker\" ng-show=\"asset.editingDate\"><div class=\"form-group no-margins\"><div class=\"input-group\"><input name=\"rolloverDate\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"MM/dd/yyyy\" is-open=\"asset.datePickerOpened\" datepicker-options=\"assignmentSummaryCtrl.dateOptions\" ng-model=\"asset.rollOverDate\" ng-model-options=\"assignmentSummaryCtrl.modelOptions\" ng-change=\"assignmentSummaryCtrl.setRollOver(asset)\" ng-class=\"{\'ng-invalid\': !assignmentSummaryCtrl.validRollOverDate}\" required=\"\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" type=\"button\" ng-click=\"assignmentSummaryCtrl.openDueDatePicker(asset)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div ng-show=\"!assignmentSummaryCtrl.validRollOverDate\"><div class=\"invalid-rollover-date\" translate=\"ADD_ASSET.INVALID_YEARLY_DATE\"></div></div></td><td class=\"edit-roll no-padding-left no-padding-right\"><a class=\"btn btn-back\" ng-hide=\"asset.editingDate\" ng-click=\"assignmentSummaryCtrl.setRollOver(asset)\"><i class=\"icon icon-ic-edit-comment\"></i></a></td></tr></tbody></table></div></div><div class=\"row no-margins\"><div class=\"col-lg-7 col-md-7 col-sm-7 col-xs-7\"><h4 class=\"invites-title\" translate=\"ASSIGNMENT_SUMMARY.APPRAISER_ASSIGNMENTS_AND_INVITES\"></h4><div class=\"row no-margins fixed-header invites-header\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><ul><li><a translate=\"ASSIGNMENT_SUMMARY.QUARTER\" ng-click=\"assignmentSummaryCtrl.sortingAssets(assignmentSummaryCtrl.invitesSort[0], \'invitesSelectedSort\')\" ng-class=\"{\'asc\': assignmentSummaryCtrl.invitesSort[0].flag, \'desc\': !assignmentSummaryCtrl.invitesSort[0].flag, \'not-selected\': !assignmentSummaryCtrl.invitesSort[0].selected}\"></a></li><li><a translate=\"ASSIGNMENT_SUMMARY.INVITES\"></a></li><li><a translate=\"ASSIGNMENT_SUMMARY.ASSIGNMENTS\"></a></li></ul></div></div><table class=\"table footable table-stripped toggle-arrow-tiny invites\" data-page-size=\"100000\" data-filter-timeout=\"300\"><tbody><tr ng-repeat=\"statistic in assignmentSummaryCtrl.selectedAppraiser.statistics | orderBy:assignmentSummaryCtrl.invitesSelectedSort.sort\"><td>{{ statistic.year }} - Q{{ statistic.quarter }}</td><td>{{ statistic.invites }}</td><td>{{ statistic.assignments }}</td></tr></tbody></table></div><div class=\"col-lg-5 col-md-5 col-sm-5 col-xs-5\"><h4 class=\"m-b-lg\" translate=\"ASSIGNMENT_SUMMARY.ENGAGEMENT_LETTER\"></h4><div class=\"form-group\"><td-file-upload class=\"upload-box documents\" files=\"assignmentSummaryCtrl.selectedAppraiser.letters\" files-to-upload=\"[]\" reset=\"assignmentSummaryCtrl.selectedAppraiser.reset\"></td-file-upload></div></div></div></perfect-scrollbar></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 text-right\"><a class=\"btn btn-w-m btn-back\" translate=\"COMMONS.BACK\" ui-sref=\"app.bidEngagement.bidSummary({bidId:assignmentSummaryCtrl.bid.id})\"></a> <button class=\"btn btn-w-m btn-normal m-l-xs\" translate=\"COMMONS.SUBMIT\" ng-click=\"assignmentSummaryCtrl.assignBid()\" ng-disabled=\"!assignmentSummaryCtrl.canSubmit\"></button></div></div></div></div></div>");
$templateCache.put("app/states/requests/engagement-letters/engagement-letters.html","<header-section breadcrumb-title=\"engagementLettersCtrl.title\" breadcrumbs=\"engagementLettersCtrl.breadcrumbs\"></header-section><section><div class=\"wrapper wrapper-content\"><div class=\"row filter\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content no-title no-padding-right no-padding-left\"><div class=\"row no-margins summary\" ng-hide=\"engagementLettersCtrl.showFilters\"><div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3\"><span translate=\"ENGAGEMENT_LETTERS.PROPERTY_TYPE\"></span> <span class=\"big\">{{engagementLettersCtrl.arrayToFormattedString(engagementLettersCtrl.selectedPropertyTypes, \', \')}}</span></div><div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3\"><span translate=\"ENGAGEMENT_LETTERS.DATE\"></span> <span class=\"big\" ng-if=\"engagementLettersCtrl.filterDate\">{{engagementLettersCtrl.filterDate | formatDate:\'MMM, YYYY\'}}</span></div></div><div class=\"row no-margins filters\" ng-show=\"engagementLettersCtrl.showFilters\"><div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3 border-right\"><div class=\"row no-margins\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><span class=\"title\" translate=\"ENGAGEMENT_LETTERS.PROPERTY_TYPE\"></span></div></div><div class=\"row no-margins\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding fixed-height checkbox-custom\"><perfect-scrollbar class=\"scroller\" wheel-propagation=\"true\" min-scrollbar-length=\"20\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><div class=\"form-group\"><div class=\"icon-addon addon-md\"><input type=\"text\" class=\"form-control\" id=\"searchFilter\" translate=\"\" translate-attr-placeholder=\"ASSETS.SEARCH\" ng-model=\"engagementLettersCtrl.searchQueryPropertyType\" ng-model-options=\"{ debounce: { \'default\': 300, \'blur\': 0 } }\"> <label class=\"fa fa-search\" rel=\"tooltip\"></label></div></div></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><table class=\"table footable table-stripped toggle-arrow-tiny\" data-page-size=\"100000\" data-filter=\"#searchFilter\" data-filter-timeout=\"300\"><tbody><tr><td><checkbox ng-model=\"engagementLettersCtrl.allPropertyTypesSelected\"></checkbox>{{\"ADD_RFP.ALL\" | translate}}</td></tr><tr ng-repeat=\"propertyType in engagementLettersCtrl.propertyTypes\"><td><checkbox ng-model=\"propertyType.selected\"></checkbox>{{ propertyType.name }}</td></tr></tbody></table></div></perfect-scrollbar></div></div></div><div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3\"><span class=\"title\" translate=\"ENGAGEMENT_LETTERS.DATE\"></span><div class=\"input-group\"><input name=\"date\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"MM/yyyy\" is-open=\"engagementLettersCtrl.filterPicker.opened\" datepicker-options=\"engagementLettersCtrl.filterDateOptions\" ng-model=\"engagementLettersCtrl.filterDate\" ng-model-options=\"engagementLettersCtrl.filterModelOptions\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" type=\"button\" ng-click=\"engagementLettersCtrl.openFilterPicker()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div></div></div></div><div class=\"row m-b-lg\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 text-right\" ng-hide=\"engagementLettersCtrl.showFilters\"><button class=\"btn btn-w-m btn-normal m-l-sm m-t-xs\" translate=\"ENGAGEMENT_LETTERS.CHANGE\" ng-click=\"engagementLettersCtrl.showFilters = true\"></button></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 text-right\" ng-show=\"engagementLettersCtrl.showFilters\"><button class=\"btn btn-w-m btn-back m-t-xs\" translate=\"ENGAGEMENT_LETTERS.CLEAR_FILTERS\" ng-click=\"engagementLettersCtrl.clearFilters()\"></button> <button class=\"btn btn-w-m btn-normal m-l-sm m-t-xs\" translate=\"COMMONS.SEARCH\" ng-click=\"engagementLettersCtrl.search()\"></button></div></div><div class=\"row results\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 fixed-height\" ng-hide=\"engagementLettersCtrl.searched\"><div class=\"empty-assets\"><i class=\"icon icon-ic-magnifier\"></i><br>{{\"ENGAGEMENT_LETTERS.PLEASE_SEARCH\"| translate}}</div></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 fixed-height\" ng-show=\"engagementLettersCtrl.searched && engagementLettersCtrl.letters.length == 0\"><div class=\"empty-assets\"><i class=\"icon icon-ic-magnifier\"></i><br>{{\"ADD_RFP.NO_ASSETS_FOUND\"| translate}}</div></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" ng-show=\"engagementLettersCtrl.searched && engagementLettersCtrl.letters.length != 0\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><div class=\"col-lg-7 col-sm-7 col-md-7 col-xs-7 no-padding\"><h4>{{\"ENGAGEMENT_LETTERS.ENGAGEMENT_LETTERS\" | translate}} <span ng-show=\"engagementLettersCtrl.letters.length > 0\">({{engagementLettersCtrl.letters.length}})</span></h4></div><div class=\"col-lg-5 col-sm-5 col-md-5 col-xs-5 no-padding\"><div class=\"form-group no-margins\"><div class=\"icon-addon addon-md\"><input type=\"text\" class=\"form-control\" id=\"search\" translate=\"\" translate-attr-placeholder=\"USERS.SEARCH\" ng-change=\"engagementLettersCtrl.searchLetters()\" ng-model=\"engagementLettersCtrl.searchQuery\" ng-model-options=\"{ debounce: { \'default\': 300, \'blur\': 0 } }\"> <label for=\"search\" class=\"fa fa-search\" rel=\"tooltip\"></label></div></div></div></div><div class=\"row no-margins fixed-header\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><ul><li><a translate=\"ENGAGEMENT_LETTERS.DOCUMENT\" ng-click=\"engagementLettersCtrl.sorting(engagementLettersCtrl.lettersSort[0], \'lettersSelectedSort\')\" ng-class=\"{\'asc\': engagementLettersCtrl.lettersSort[0].flag, \'desc\': !engagementLettersCtrl.lettersSort[0].flag, \'not-selected\': !engagementLettersCtrl.lettersSort[0].selected}\"></a></li><li><a translate=\"ENGAGEMENT_LETTERS.RFP_NAME\"></a></li><li><a translate=\"ENGAGEMENT_LETTERS.ASSETS\"></a></li><li><a translate=\"ENGAGEMENT_LETTERS.DATE\"></a></li><li></li></ul></div></div><div class=\"ibox-content no-padding\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding fixed-height\"><perfect-scrollbar class=\"scroller\" wheel-propagation=\"true\" min-scrollbar-length=\"20\"><table class=\"table footable table-stripped toggle-arrow-tiny\" data-page-size=\"100000\" data-filter=\"#search\" data-filter-timeout=\"300\"><tbody><tr ng-repeat=\"letter in engagementLettersCtrl.letters | orderBy: engagementLettersCtrl.lettersSelectedSort.sort\"><td>{{ letter.fileName || \"N/A\" }}</td><td>{{ letter.bidRequest.name || \"N/A\" }}</td><td>{{ letter.bidRequest.assets.length || \"N/A\" }}</td><td>{{ letter.createdOn | date:\'MMM dd, yyyy\' }}</td><td class=\"tools\"><button class=\"btn btn-back\" type=\"button\" ng-click=\"engagementLettersCtrl.downloadLetter(letter)\"><i class=\"icon icon-ic-download\"></i></button></td></tr></tbody></table></perfect-scrollbar></div></div></div></div></div></div></section>");
$templateCache.put("app/states/requests/all-requests/all-requests-lateral-content.html","<div id=\"rfp-info\" class=\"rfp-info\"><div class=\"row no-margins\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding m-b-md\" ng-if=\"RFP.isCancelled\"><span class=\"status-not-awarded\">{{ \"ALL_REQUESTS.NOT_AWARDED\" | translate }} (0/{{RFP.assets.length}})</span></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding m-b-md\" ng-if=\"!RFP.isCancelled\"><span class=\"status-awarded\" ng-show=\"RFP.status == \'Awarded\'\">{{ \"ALL_REQUESTS.AWARDED\" | translate }} ({{RFP.statusCounters.assetsAwarded}}/{{RFP.assets.length}})</span> <span class=\"status-responded\" ng-show=\"RFP.status == \'Responded\'\">{{ \"ALL_REQUESTS.RESPONDED\" | translate }} ({{RFP.statusCounters.assetsResponded}}/{{RFP.assets.length}})</span> <span class=\"status-not-awarded\" ng-show=\"RFP.status == \'NotAwarded\'\">{{ \"ALL_REQUESTS.NOT_AWARDED\" | translate }} (0/{{RFP.assets.length}})</span> <span class=\"status-needs-response\" ng-show=\"RFP.status == \'NeedsResponse\'\">{{ \"ALL_REQUESTS.NEEDS_RESPONSE\" | translate }}</span></div></div><div class=\"row no-margins\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><h4 class=\"no-margins\">{{ RFP.name }} <span ng-if=\"RFP.isCancelled\" class=\"cancelled-text font-weight-500\">- {{\"ALL_REQUESTS.CANCELLED\" | translate}}</span></h4><span class=\"bid-due-date m-b-xs\">{{ \"ALL_REQUESTS.BID_DUE_DATE\" | translate }}: {{ RFP.dueDate | date:\'MMM dd, yyyy\' }}</span> <a class=\"btn btn-w-m btn-normal m-r-sm\" translate=\"ALL_REQUESTS.VIEW_SUMMARY\" ng-show=\"RFP.status == \'Awarded\' || RFP.status == \'Responded\' || isBidded()\" ui-sref=\"app.requests.responseSummary({rfpId: RFP.id})\"></a> <a class=\"btn btn-w-m btn-normal m-r-sm\" translate=\"ALL_REQUESTS.SEND_RESPONSE\" ng-show=\"RFP.status == \'NeedsResponse\' && !isBidded() && !RFP.isCancelled\" ui-sref=\"app.requests.response({assetId: RFP.assets[0].id, rfpId: RFP.id})\" ui-sref-opts=\"{reload: true}\"></a> <a class=\"btn btn-w-m btn-back\" translate=\"ALL_REQUESTS.DECLINE_RFP\" ng-show=\"RFP.status == \'NeedsResponse\' && !RFP.isCancelled\" ng-click=\"declineBidRequest(RFP)\"></a></div></div><hr ng-show=\"RFP.status == \'Awarded\'\"><div class=\"row no-margins\" ng-show=\"RFP.status == \'Awarded\'\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><h5 translate=\"ALL_REQUESTS.ENGAGEMENT_LETTER\"></h5><ul><li ng-repeat=\"document in documents\"><div class=\"in-line document-name\">{{document.fileName}}</div><div class=\"doc-tools in-line text-right\"><a class=\"btn btn-back download-button download\" ng-click=\"downloadLetter(document.id)\"><i class=\"icon icon-ic-download\"></i></a> <a class=\"btn btn-back download-button download\" ng-click=\"deleteLetter(document.id)\"><i class=\"icon icon-ic-trash-delete\"></i></a></div></li></ul><div class=\"text-right\"><input type=\"file\" name=\"file\" id=\"file\" class=\"input-file\" file-read=\"uploadDocument\"> <label class=\"btn btn-w-m btn-back\" for=\"file\" translate=\"ALL_REQUESTS.UPLOAD_FILE\"></label></div></div></div><hr><div class=\"row no-margins\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><h5>{{ \"ALL_REQUESTS.ASSETS_INCLUDED\" | translate }} ({{ RFP.assets.length }})</h5><ul class=\"asset-list\"><li ng-repeat=\"asset in RFP.assets | orderBy: \'name\'\"><a ui-sref=\"app.requests.response-details({assetId: asset.id, bidRequestId: RFP.id, bidResponseId: asset.bidResponseId, status: asset.status})\" ng-if=\"asset.status != \'NotAwarded\'\">{{ asset.name }}</a> <a ng-if=\"asset.status == \'NotAwarded\'\" ui-sref=\"app.requests.response-details({assetId: asset.id, bidRequestId: RFP.id, bidResponseId: asset.bidResponseId, status: asset.status})\" ng-class=\"{\'appraiser-not-awarded\': asset.status == \'NotAwarded\'}\">{{ asset.name }}</a></li></ul></div></div></div>");
$templateCache.put("app/states/requests/all-requests/all-requests.html","<header-section breadcrumb-title=\"allRequestsCtrl.title\" breadcrumbs=\"allRequestsCtrl.breadcrumbs\"></header-section><section><div class=\"wrapper wrapper-content\" nvc-full-page=\"\"><div class=\"row no-button\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title request-list\"><div class=\"col-lg-7 col-sm-7 col-md-7 col-xs-7 no-padding\"><h4>{{\"ALL_REQUESTS.REQUESTS\" | translate }}&nbsp;<span>({{allRequestsCtrl.requestsCount}})</span></h4></div><div class=\"col-lg-5 col-sm-5 col-md-5 col-xs-5 no-padding\"><div class=\"form-group no-margins ibox-search-row\"><div uib-dropdown=\"\" is-open=\"allRequestsCtrl.dropdown.isOpen\"><button ng-disabled=\"allRequestsCtrl.downloadLoading\" class=\"btn btn-download\" ng-class=\"{\'btn-dropdown-active\': allRequestsCtrl.dropdown.isOpen}\" uib-dropdown-toggle=\"\"><i class=\"icon icon-ic-download\"></i> {{ \"COMMONS.DOWNLOAD\" | translate }}</button><ul class=\"dropdown-menu\" uib-dropdown-menu=\"\"><li><a href=\"#\" class=\"btn-block btn-dropdown\" ng-click=\"allRequestsCtrl.downloadPdf()\"><img class=\"dropdown-option-icon\" ng-hide=\"allRequestsCtrl.downloadLoading\" src=\"/assets/images/pdf.svg\"> {{ \"COMMONS.PDF\" | translate }}</a></li><li><a href=\"#\" class=\"btn-block btn-dropdown\" ng-click=\"allRequestsCtrl.downloadCsv()\"><img class=\"dropdown-option-icon\" src=\"/assets/images/excel.svg\"> {{ \"COMMONS.EXCEL\" | translate }}</a></li></ul></div><div class=\"icon-addon addon-md ibox-search\"><input type=\"text\" class=\"form-control\" id=\"search\" translate=\"\" translate-attr-placeholder=\"USERS.SEARCH\" ng-change=\"allRequestsCtrl.searchRequests()\" ng-model=\"allRequestsCtrl.searchQuery\" ng-model-options=\"{ debounce: { \'default\': 300, \'blur\': 0 } }\"> <label for=\"search\" class=\"fa fa-search\" rel=\"tooltip\"></label></div></div></div></div><div class=\"row no-margins fixed-header request-list\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><ul><li><a translate=\"ALL_REQUESTS.RFP_NAME\" ng-click=\"allRequestsCtrl.sorting(allRequestsCtrl.allRequestSort[0], \'allRequestSelectedSort\')\" ng-class=\"{\'asc\': allRequestsCtrl.allRequestSort[0].flag, \'desc\': !allRequestsCtrl.allRequestSort[0].flag, \'not-selected\': !allRequestsCtrl.allRequestSort[0].selected}\"></a></li><li><a translate=\"ALL_REQUESTS.ASSETS\" ng-click=\"allRequestsCtrl.sorting(allRequestsCtrl.allRequestSort[1], \'allRequestSelectedSort\')\" ng-class=\"{\'asc\': allRequestsCtrl.allRequestSort[1].flag, \'desc\': !allRequestsCtrl.allRequestSort[1].flag, \'not-selected\': !allRequestsCtrl.allRequestSort[1].selected}\"></a></li><li><a translate=\"ALL_REQUESTS.BID_DUE_DATE\" ng-click=\"allRequestsCtrl.sorting(allRequestsCtrl.allRequestSort[2], \'allRequestSelectedSort\')\" ng-class=\"{\'asc\': allRequestsCtrl.allRequestSort[2].flag, \'desc\': !allRequestsCtrl.allRequestSort[2].flag, \'not-selected\': !allRequestsCtrl.allRequestSort[2].selected}\"></a></li><li><a translate=\"ALL_REQUESTS.STATUS\" ng-click=\"allRequestsCtrl.sorting(allRequestsCtrl.allRequestSort[3], \'allRequestSelectedSort\')\" ng-class=\"{\'asc\': allRequestsCtrl.allRequestSort[3].flag, \'desc\': !allRequestsCtrl.allRequestSort[3].flag, \'not-selected\': !allRequestsCtrl.allRequestSort[3].selected}\"></a></li></ul></div></div><div class=\"ibox-content paginator-loader no-padding\"><div class=\"sk-spinner sk-spinner-circle\"><div class=\"sk-circle1 sk-circle\"></div><div class=\"sk-circle2 sk-circle\"></div><div class=\"sk-circle3 sk-circle\"></div><div class=\"sk-circle4 sk-circle\"></div><div class=\"sk-circle5 sk-circle\"></div><div class=\"sk-circle6 sk-circle\"></div><div class=\"sk-circle7 sk-circle\"></div><div class=\"sk-circle8 sk-circle\"></div><div class=\"sk-circle9 sk-circle\"></div><div class=\"sk-circle10 sk-circle\"></div><div class=\"sk-circle11 sk-circle\"></div><div class=\"sk-circle12 sk-circle\"></div></div><div class=\"col-lg-8 col-md-8 col-sm-8 col-xs-8 no-padding full-height request-list\"><perfect-scrollbar class=\"scroller\" wheel-propagation=\"true\" wheel-speed=\"1\" min-scrollbar-length=\"20\"><div class=\"col-lg-12 no-padding\"><table class=\"table footable table-stripped toggle-arrow-tiny\" data-page-size=\"100000\" data-filter-timeout=\"300\"><tbody><tr ng-repeat=\"RFP in allRequestsCtrl.bidList\" ng-if=\"RFP.status != \'Declined\'\" ng-click=\"allRequestsCtrl.getDetails(RFP)\" ng-class=\"{\'highlight\':RFP.displaying, \'rfp-needs-response\':RFP.status == \'NeedsResponse\' && !RFP.isCancelled}\"><td>{{ RFP.name }} <span class=\"cancelled-text\" ng-if=\"RFP.isCancelled\">- {{\"ALL_REQUESTS.CANCELLED\" | translate}}</span></td><td>{{ RFP.assets.length }}</td><td>{{ RFP.dueDate | date:\'MMM dd, yyyy\' }}</td><td ng-if=\"!RFP.isCancelled\"><span class=\"status-awarded\" ng-show=\"RFP.status == \'Awarded\'\">{{ \"ALL_REQUESTS.AWARDED\" | translate }} ({{RFP.statusCounters.assetsAwarded}}/{{RFP.assets.length}})</span> <span class=\"status-responded\" ng-show=\"RFP.status == \'Responded\'\">{{ \"ALL_REQUESTS.RESPONDED\" | translate }} ({{RFP.statusCounters.assetsResponded}}/{{RFP.assets.length}})</span> <span class=\"status-not-awarded\" ng-show=\"RFP.status == \'NotAwarded\'\">{{ \"ALL_REQUESTS.NOT_AWARDED\" | translate }} (0/{{RFP.assets.length}})</span> <span class=\"status-needs-response\" ng-show=\"RFP.status == \'NeedsResponse\'\">{{ \"ALL_REQUESTS.NEEDS_RESPONSE\" | translate }}</span></td><td ng-if=\"RFP.isCancelled\"><span class=\"status-not-awarded\">{{ \"ALL_REQUESTS.NOT_AWARDED\" | translate }} (0/{{RFP.assets.length}})</span></td></tr></tbody><tfoot><tr><td colspan=\"5\"><ul class=\"pagination pull-right\"></ul></td></tr></tfoot></table></div></perfect-scrollbar></div><lateral-bar show=\"allRequestsCtrl.openDetails\" config=\"allRequestsCtrl.lateralBarConfig\" on-close=\"allRequestsCtrl.closeDetails\" content-selector=\"\'.request-list\'\"></lateral-bar></div></div><div class=\"paginator-container\"><uib-pagination total-items=\"allRequestsCtrl.requestsCount\" ng-model=\"allRequestsCtrl.currentPage\" class=\"pagination-sm\" max-size=\"allRequestsCtrl.maxPaginationSize\" items-per-page=\"allRequestsCtrl.perPage\" ng-change=\"allRequestsCtrl.changePage()\" boundary-link-numbers=\"true\" rotate=\"false\"></uib-pagination></div></div></div></div></section>");
$templateCache.put("app/states/manage/add-contact/add-contact.html","<header-section breadcrumb-title=\"addContact.title\" breadcrumbs=\"addContact.breadcrumbs\"></header-section><section><div class=\"wrapper wrapper-content\" nvc-full-page=\"\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><h4 translate=\"ADD_CONTACT.CONTACT_INFO\"></h4></div></div><div class=\"ibox-content\"><perfect-scrollbar class=\"scroller\" suppress-scroll-x=\"true\" wheel-propagation=\"true\" wheel-speed=\"1\" min-scrollbar-length=\"20\"><form class=\"\" role=\"form\" name=\"addContact.addNewContact\" ng-submit=\"addContact.addNewContact.$valid && addContact.createContact()\" confirm-leave=\"\" novalidate=\"\"><div class=\"row no-button\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group\"><label translate=\"ADD_CONTACT.NAME\"></label> <input class=\"form-control\" ng-model=\"addContact.contact.name\" type=\"text\" translate=\"\" translate-attr-placeholder=\"ADD_CONTACT.ENTER_NAME\" ng-pattern=\"/^([ña-zÑA-Z\\s]*[áéíóúüÁÉÍÓÚÜ]*)*$/\" required=\"\"></div></div></div><div class=\"hr-line-dashed\"></div><div class=\"row\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><label translate=\"ADD_CONTACT.EMAIL\"></label> <input class=\"form-control\" ng-model=\"addContact.contact.email\" type=\"email\" translate=\"\" translate-attr-placeholder=\"ADD_CONTACT.ENTER_EMAIL\" required=\"\"></div></div><div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3\"><div class=\"form-group\"><label translate=\"ADD_CONTACT.OFFICE_PHONE\"></label> <input class=\"form-control\" ng-model=\"addContact.contact.officePhone\" type=\"tel\" translate=\"\" translate-attr-placeholder=\"ADD_CONTACT.ENTER_PHONE\" maxlength=\"14\" ui-us-phone-number=\"\" required=\"\"></div></div><div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3\"><div class=\"form-group\"><label translate=\"ADD_CONTACT.MOBILE_PHONE\"></label> <input class=\"form-control\" ng-model=\"addContact.contact.mobilePhone\" type=\"tel\" translate=\"\" translate-attr-placeholder=\"ADD_CONTACT.ENTER_PHONE\" maxlength=\"14\" ui-us-phone-number=\"\"></div></div></div><div class=\"hr-line-dashed\"></div><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group text-center\"><button class=\"btn btn-normal btn-w-m m-t-xl\" type=\"submit\" translate=\"COMMONS.SAVE\"></button></div></div></div></form></perfect-scrollbar></div></div></div></div></div></section>");
$templateCache.put("app/states/requests/response-details/response-details-index.html","<header-section breadcrumb-title=\"responseDetailsCtrl.title\" breadcrumbs=\"responseDetailsCtrl.breadcrumbs\"></header-section><div ui-view=\"asset-details\"></div><div ng-if=\"responseDetailsCtrl.assetStatus != \'NotAwarded\'\" ui-view=\"response-details\"></div>");
$templateCache.put("app/states/requests/response-details/response-details.html","<div class=\"bid-section\"><section><div class=\"wrapper wrapper-content\"><form><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 response-fee\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><h4 translate=\"ASSET_DETAILS.BID_SECTION.APPRAISAL_FEE\"></h4></div></div><div class=\"ibox-content no-padding-left no-padding-right\"><div class=\"row no-margins\"><div class=\"col-lg-8 col-md-12 col-sm-12 col-xs-12 no-padding\"><div class=\"row no-margins\"><div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3\"><div class=\"form-group\"><label translate=\"ASSET_DETAILS.BID_SECTION.YEAR_1\"></label> <input type=\"number\" class=\"form-control\" ng-model=\"responseDetailsCtrl.bidResponse.yearOne\" disabled=\"\"></div></div><div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3\"><div class=\"form-group\"><label translate=\"ASSET_DETAILS.BID_SECTION.YEAR_1_DISCOUNT\"></label> <input type=\"number\" class=\"form-control\" ng-model=\"responseDetailsCtrl.bidResponse.yearOneDiscount\" disabled=\"\"></div></div><div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3\"><div class=\"form-group\"><label translate=\"ASSET_DETAILS.BID_SECTION.YEAR_2_3\"></label> <input type=\"number\" class=\"form-control\" ng-model=\"responseDetailsCtrl.bidResponse.yearsTwoThree\" disabled=\"\"></div></div><div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3\"><div class=\"form-group\"><label translate=\"ASSET_DETAILS.BID_SECTION.YEAR_2_3_DISCOUNT\"></label> <input type=\"number\" class=\"form-control\" ng-model=\"responseDetailsCtrl.bidResponse.yearsTwoThreeDiscount\" disabled=\"\"></div></div></div><div class=\"row no-margins\"><div ng-if=\"responseDetailsCtrl.asset.valuationFrequency !== \'Annual\' && responseDetailsCtrl.asset.requiredAppraisers !== \'InternalAndExternal\'\" class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3\"><div class=\"form-group\"><label>{{responseDetailsCtrl.labels.update}}</label> <input type=\"number\" class=\"form-control\" ng-model=\"responseDetailsCtrl.bidResponse.quarterly\" disabled=\"\"></div></div><div ng-if=\"responseDetailsCtrl.asset.valuationFrequency !== \'Annual\' && responseDetailsCtrl.asset.requiredAppraisers !== \'InternalAndExternal\'\" class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3\"><div class=\"form-group\"><label>{{responseDetailsCtrl.labels.updateDiscount}}</label> <input type=\"number\" class=\"form-control\" ng-model=\"responseDetailsCtrl.bidResponse.quarterlyDiscount\" disabled=\"\"></div></div><div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3\"><div class=\"form-group\"><label translate=\"ASSET_DETAILS.BID_SECTION.TOTAL_FEE\"></label> <input type=\"number\" class=\"form-control\" ng-model=\"responseDetailsCtrl.bidResponse.totalFee\" disabled=\"\"></div></div><div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3\"><div class=\"form-group\"><label translate=\"ASSET_DETAILS.BID_SECTION.TOTAL_FEE_DISCOUNT\"></label> <input type=\"number\" class=\"form-control\" ng-model=\"responseDetailsCtrl.bidResponse.totalFeeDiscount\" disabled=\"\"></div></div></div></div><div class=\"col-lg-4 col-md-12 col-sm-12 col-xs-12 no-padding\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group\"><label translate=\"ASSET_DETAILS.BID_SECTION.BID_NOTES\"></label> <textarea ng-model=\"responseDetailsCtrl.bidResponse.bidNotes\" class=\"form-control bid-notes\" disabled=\"\"></textarea></div></div></div></div></div></div></div></div></form></div></section></div>");
$templateCache.put("app/states/requests/response-summary/response-summary.html","<header-section breadcrumb-title=\"responseSummaryCtrl.title\" breadcrumbs=\"responseSummaryCtrl.breadcrumbs\"></header-section><section><div class=\"wrapper wrapper-content\" nvc-full-page=\"\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><div class=\"col-lg-7 col-sm-7 col-md-7 col-xs-7 no-padding\"><h4>{{ responseSummaryCtrl.rfp.name }}</h4></div><div class=\"col-lg-5 col-sm-5 col-md-5 col-xs-5 no-padding\"><div class=\"form-group no-margins ibox-search-row\" style=\"justify-content: flex-end;\"><div uib-dropdown=\"\" is-open=\"responseSummaryCtrl.dropdown.isOpen\"><button ng-disabled=\"responseSummaryCtrl.downloadLoading\" class=\"btn btn-download\" ng-class=\"{\'btn-dropdown-active\': responseSummaryCtrl.dropdown.isOpen}\" uib-dropdown-toggle=\"\"><i class=\"icon icon-ic-download\"></i> {{ \"COMMONS.DOWNLOAD\" | translate }}</button><ul class=\"dropdown-menu\" uib-dropdown-menu=\"\"><li><a href=\"#\" class=\"btn-block btn-dropdown\" ng-click=\"responseSummaryCtrl.downloadPdf()\"><img class=\"dropdown-option-icon\" src=\"/assets/images/pdf.svg\"> {{ \"COMMONS.PDF\" | translate }}</a></li><li><a href=\"#\" class=\"btn-block btn-dropdown\" ng-click=\"responseSummaryCtrl.downloadCsv()\"><img class=\"dropdown-option-icon\" src=\"/assets/images/excel.svg\"> {{ \"COMMONS.EXCEL\" | translate }}</a></li></ul></div></div></div></div><div class=\"row no-margins fixed-header\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><ul><li><a translate=\"RESPONSE_SUMMARY.ASSET\" ng-click=\"responseSummaryCtrl.sorting(responseSummaryCtrl.summarySort[0], \'summarySelectedSort\')\" ng-class=\"{\'asc\': responseSummaryCtrl.summarySort[0].flag, \'desc\': !responseSummaryCtrl.summarySort[0].flag, \'not-selected\': !responseSummaryCtrl.summarySort[0].selected}\"></a></li><li><a translate=\"RESPONSE_SUMMARY.YEAR_1\" ng-click=\"responseSummaryCtrl.sorting(responseSummaryCtrl.summarySort[1], \'summarySelectedSort\')\" ng-class=\"{\'asc\': responseSummaryCtrl.summarySort[1].flag, \'desc\': !responseSummaryCtrl.summarySort[1].flag, \'not-selected\': !responseSummaryCtrl.summarySort[1].selected}\"></a></li><li><a translate=\"RESPONSE_SUMMARY.YEAR_2_3\" ng-click=\"responseSummaryCtrl.sorting(responseSummaryCtrl.summarySort[3], \'summarySelectedSort\')\" ng-class=\"{\'asc\': responseSummaryCtrl.summarySort[3].flag, \'desc\': !responseSummaryCtrl.summarySort[3].flag, \'not-selected\': !responseSummaryCtrl.summarySort[3].selected}\"></a></li><li ng-if=\"responseSummaryCtrl.showQuarterly\"><a translate=\"RESPONSE_SUMMARY.UPDATE\" ng-click=\"responseSummaryCtrl.sorting(responseSummaryCtrl.summarySort[5], \'summarySelectedSort\')\" ng-class=\"{\'asc\': responseSummaryCtrl.summarySort[5].flag, \'desc\': !responseSummaryCtrl.summarySort[5].flag, \'not-selected\': !responseSummaryCtrl.summarySort[5].selected}\"></a></li><li><a translate=\"RESPONSE_SUMMARY.TOTAL_FEE\" ng-click=\"responseSummaryCtrl.sorting(responseSummaryCtrl.summarySort[7], \'summarySelectedSort\')\" ng-class=\"{\'asc\': responseSummaryCtrl.summarySort[7].flag, \'desc\': !responseSummaryCtrl.summarySort[7].flag, \'not-selected\': !responseSummaryCtrl.summarySort[7].selected}\"></a></li><li ng-class=\"{\'hidden-quarterly\': !responseSummaryCtrl.showQuarterly}\"><a translate=\"RESPONSE_SUMMARY.BID_NOTES\"></a></li><li></li></ul></div></div><div class=\"ibox-content no-padding\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding full-height\"><perfect-scrollbar class=\"scroller\" wheel-propagation=\"true\" wheel-speed=\"1\" min-scrollbar-length=\"20\"><table class=\"table table-striped\"><tbody><tr ng-repeat=\"asset in responseSummaryCtrl.rfpAssets | orderBy:responseSummaryCtrl.summarySelectedSort.sort\"><td>{{ asset.name }}</td><td>{{ asset.response.yearOne | currency:undefined:0 }}</td><td>{{ asset.response.yearsTwoThree | currency:undefined:0 }}</td><td ng-if=\"responseSummaryCtrl.showQuarterly\">{{ asset.response.quarterly ? (asset.response.quarterly | currency:undefined:0) : \'N/A\' }}</td><td ng-class=\"{\'hidden-quarterly\': !responseSummaryCtrl.showQuarterly}\">{{ asset.response.totalFee | currency:undefined:0 }}</td><td ng-class=\"{\'hidden-quarterly\': !responseSummaryCtrl.showQuarterly}\" class=\"bid-note\"><span class=\"icon icon-ic-comment-text appraiser-notes\" ng-class=\"{\'visible\': asset.response.bidNotes}\" ng-click=\"responseSummaryCtrl.openAppNotes(asset)\"><div class=\"appraiser-notes-container notes-container\" ng-show=\"asset.openedAppNotes\" ng-class=\"{\'notes-add\': responseSummaryCtrl.editBidNote}\"><i class=\"icon icon-ic-close\" ng-click=\"responseSummaryCtrl.closeAppNotes($event, asset)\"></i> <i class=\"icon icon-ic-edit-comment\" ng-click=\"responseSummaryCtrl.editNotes(asset)\" ng-hide=\"asset.response.isSubmittedToAdmin\"></i><div ng-hide=\"responseSummaryCtrl.editBidNote\"><div class=\"col-lg-2 col-md-2 col-sm-2 col-xs-2 no-padding text-center\"><span class=\"avatar\"></span></div><div class=\"col-lg-10 col-md-10 col-sm-10 col-xs-10 no-padding word-break\"><p>{{asset.response.bidNotes}}</p></div></div><div ng-show=\"responseSummaryCtrl.editBidNote\"><span class=\"title\" translate=\"BID_SUMMARY.POST_NOTES\"></span><form role=\"form\" name=\"editNote\" novalidate=\"\"><div class=\"form-group m-t-sm no-margin-bottom\"><textarea class=\"form-control\" maxlength=\"600\" ng-model=\"responseSummaryCtrl.bidNotes\" required=\"\"></textarea></div><div class=\"counter text-right m-b-sm\"><span>{{responseSummaryCtrl.bidNotes.length || 0}}/600</span></div><div class=\"text-right\"><button class=\"btn btn-w-m btn-normal no-margins\" type=\"button\" translate=\"BID_SUMMARY.POST\" ng-click=\"editNote.$valid && responseSummaryCtrl.saveNotes(asset)\"></button></div></form></div></div></span></td><td class=\"tools\" ng-class=\"{\'hidden-quarterly\': !responseSummaryCtrl.showQuarterly}\"><button class=\"btn btn-primary\" style=\"visibility: visible;\" ng-click=\"responseSummaryCtrl.editResponse(asset)\" ng-hide=\"responseSummaryCtrl.isAwarded() || responseSummaryCtrl.rfp.isCancelled\">{{ asset.response && asset.response.totalFee ? \'Edit Bid\' : \'Enter Bid\' }}</button></td></tr><tr class=\"total-table\"><td translate=\"RESPONSE_SUMMARY.TOTAL\"></td><td>{{ responseSummaryCtrl.totals[0] | currency:undefined:0 }}</td><td>{{ responseSummaryCtrl.totals[2] | currency:undefined:0 }}</td><td ng-if=\"responseSummaryCtrl.showQuarterly\">{{ responseSummaryCtrl.totals[4] | currency:undefined:0 }}</td><td ng-class=\"{\'hidden-quarterly\': !responseSummaryCtrl.showQuarterly}\">{{ responseSummaryCtrl.totals[6] | currency:undefined:0 }}</td><td ng-class=\"{\'hidden-quarterly\': !responseSummaryCtrl.showQuarterly}\">&nbsp;</td><td ng-class=\"{\'hidden-quarterly\': !responseSummaryCtrl.showQuarterly}\">&nbsp;</td></tr></tbody></table></perfect-scrollbar></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 text-right\"><button class=\"btn btn-w-m btn-back\" translate=\"COMMONS.BACK\" ui-sref=\"app.requests.allRequests\"></button> <button class=\"btn btn-w-m btn-normal m-l-sm\" translate=\"RESPONSE_SUMMARY.SUBMIT_RESPONSE\" ng-click=\"responseSummaryCtrl.submitResponse(responseSummaryCtrl.rfp.id)\" ng-hide=\"responseSummaryCtrl.isSubmitted()\"></button></div></div></div></section>");
$templateCache.put("app/states/requests/response/response-fee.html","<section><div class=\"wrapper wrapper-content\"><form role=\"form\" name=\"responseCtrl.assetFee\" novalidate=\"\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 response-fee\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><h4 translate=\"RESPONSE.APPRAISAL_FEE\"></h4></div></div><div class=\"ibox-content no-padding-left no-padding-right\"><div class=\"row no-margins\"><div class=\"col-lg-8 col-md-12 col-sm-12 col-xs-12 no-padding\"><div class=\"row no-margins\"><div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3\"><div class=\"form-group\"><label translate=\"RESPONSE.YEAR_1\"></label> <input type=\"text\" currency-values=\"\" format=\"currency\" ng-pattern=\"/^[\\-]?\\$?(?:([0-9]\\,?)+(?:\\.[0-9]{0,2})?)?$/\" class=\"form-control\" ng-model=\"responseCtrl.asset.response.yearOne\" translate=\"\" translate-attr-placeholder=\"RESPONSE.ENTER_VALUE\" ng-required=\"responseCtrl.isRequired\"></div></div><div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3\"><div class=\"form-group\"><label translate=\"RESPONSE.YEAR_2_3\"></label> <input type=\"text\" currency-values=\"\" format=\"currency\" ng-pattern=\"/^[\\-]?\\$?(?:([0-9]\\,?)+(?:\\.[0-9]{0,2})?)?$/\" class=\"form-control\" ng-model=\"responseCtrl.asset.response.yearsTwoThree\" translate=\"\" translate-attr-placeholder=\"RESPONSE.ENTER_VALUE\" ng-required=\"responseCtrl.isRequired\"></div></div><div ng-if=\"responseCtrl.asset.valuationFrequency !== \'Annual\' && responseCtrl.asset.requiredAppraisers !==\'InternalAndExternal\'\" class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3\"><div class=\"form-group\"><label>{{responseCtrl.labels.update}}</label> <input type=\"text\" currency-values=\"\" format=\"currency\" ng-pattern=\"/^[\\-]?\\$?(?:([0-9]\\,?)+(?:\\.[0-9]{0,2})?)?$/\" class=\"form-control\" ng-model=\"responseCtrl.asset.response.quarterly\" translate=\"\" translate-attr-placeholder=\"RESPONSE.ENTER_VALUE\" ng-required=\"responseCtrl.isRequired\"></div></div></div><div class=\"row no-margins\"><div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3\"><div class=\"form-group\"><label translate=\"RESPONSE.TOTAL_FEE\"></label> <input type=\"text\" currency-values=\"\" format=\"currency\" ng-pattern=\"/^[\\-]?\\$?(?:([0-9]\\,?)+(?:\\.[0-9]{0,2})?)?$/\" class=\"form-control\" ng-model=\"responseCtrl.totalFee\" disabled=\"\"></div></div></div></div><div class=\"col-lg-4 col-md-12 col-sm-12 col-xs-12 no-padding\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group\"><label translate=\"RESPONSE.BID_NOTES\"></label> <textarea ng-model=\"responseCtrl.asset.response.bidNotes\" class=\"form-control bid-notes\" maxlength=\"600\"></textarea></div></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6 m-b-lg\"><button class=\"btn btn-w-m btn-back\" translate=\"COMMONS.CANCEL\" ng-click=\"responseCtrl.cancelResponse()\"></button> <button class=\"btn btn-w-m btn-normal m-l-sm\" translate=\"COMMONS.SAVE\" ng-click=\"responseCtrl.saveResponse(responseCtrl.asset.id)\"></button></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right m-b-lg\"><button class=\"btn btn-w-m btn-back\" translate=\"COMMONS.BACK\" ng-disabled=\"responseCtrl.getIndex(responseCtrl.asset.id) == 1\" ng-click=\"responseCtrl.previousAsset(responseCtrl.asset.id)\"></button> <button class=\"btn btn-w-m btn-normal m-l-sm\" translate=\"COMMONS.NEXT\" ng-click=\"responseCtrl.nextAsset(responseCtrl.asset.id)\" ng-disabled=\"responseCtrl.getIndex(responseCtrl.asset.id) == responseCtrl.rfpAssets.length\"></button></div></div></form></div></section>");
$templateCache.put("app/states/requests/response/response-index.html","<section><div class=\"wrapper wrapper-content\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 response-index\"><strong>{{ responseCtrl.rfp.name }}</strong> {{responseCtrl.getIndex(responseCtrl.asset.id)}}/{{ responseCtrl.rfpAssets.length }}</div></div></div></section>");
$templateCache.put("app/states/requests/response/response.html","<header-section breadcrumb-title=\"responseCtrl.title\" breadcrumbs=\"responseCtrl.breadcrumbs\"></header-section><div ui-view=\"assetCounter\"></div><div ui-view=\"assetDetails\" class=\"assetDetails response-details\"></div><div ui-view=\"assetFee\"></div>");
$templateCache.put("app/states/manage/edit-contact/edit-contact.html","<header-section breadcrumb-title=\"EditContactCtrl.title\" breadcrumbs=\"EditContactCtrl.breadcrumbs\"></header-section><section><div class=\"wrapper wrapper-content\" nvc-full-page=\"\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><h4 translate=\"ADD_CONTACT.CONTACT_INFO\"></h4></div></div><div class=\"ibox-content\"><perfect-scrollbar class=\"scroller\" suppress-scroll-x=\"true\" wheel-propagation=\"true\" wheel-speed=\"1\" min-scrollbar-length=\"20\"><form class=\"\" role=\"form\" name=\"EditContactCtrl.editContact\" ng-submit=\"EditContactCtrl.editContact.$valid && EditContactCtrl.updateContact(EditContactCtrl.contact)\" confirm-leave=\"\" novalidate=\"\"><div class=\"row no-button\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group\"><label translate=\"ADD_CONTACT.NAME\"></label> <input class=\"form-control\" ng-model=\"EditContactCtrl.contact.name\" type=\"text\" translate=\"\" translate-attr-placeholder=\"ADD_CONTACT.ENTER_NAME\" ng-pattern=\"/^([ña-zÑA-Z\\s]*[áéíóúüÁÉÍÓÚÜ]*)*$/\" required=\"\"></div></div></div><div class=\"hr-line-dashed\"></div><div class=\"row\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><label translate=\"ADD_CONTACT.EMAIL\"></label> <input class=\"form-control\" ng-model=\"EditContactCtrl.contact.email\" type=\"email\" translate=\"\" translate-attr-placeholder=\"ADD_CONTACT.ENTER_EMAIL\" required=\"\"></div></div><div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3\"><div class=\"form-group\"><label translate=\"ADD_CONTACT.OFFICE_PHONE\"></label> <input class=\"form-control\" ng-model=\"EditContactCtrl.contact.officePhone\" type=\"tel\" translate=\"\" translate-attr-placeholder=\"ADD_CONTACT.ENTER_PHONE\" maxlength=\"14\" ui-us-phone-number=\"\" required=\"\"></div></div><div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3\"><div class=\"form-group\"><label translate=\"ADD_CONTACT.MOBILE_PHONE\"></label> <input class=\"form-control\" ng-model=\"EditContactCtrl.contact.mobilePhone\" type=\"tel\" translate=\"\" translate-attr-placeholder=\"ADD_CONTACT.ENTER_PHONE\" maxlength=\"14\" ui-us-phone-number=\"\"></div></div></div><div class=\"hr-line-dashed\"></div><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group text-center\"><button class=\"btn btn-normal btn-w-m m-t-xl\" type=\"submit\" translate=\"COMMONS.SAVE\"></button></div></div></div></form></perfect-scrollbar></div></div></div></div></div></section>");
$templateCache.put("app/states/manage/companies/companies.html","<header-section breadcrumb-title=\"companies.title\" breadcrumbs=\"companies.breadcrumbs\"></header-section><section><div class=\"wrapper wrapper-content\" nvc-full-page=\"\" paginator=\"true\"><div class=\"row\" td-security=\"[\'Admin\']\" action=\"display-none\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"margin text-right\"><a class=\"btn btn-w-m btn-normal\" ui-sref=\"{{companies.newCompany}}\">{{companies.newCompanies}}</a></div></div></div><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title companies-list\"><div class=\"col-lg-7 col-md-7 col-sm-7 col-xs-7 no-padding\"><h4>{{companies.title}}&nbsp;<span>({{companies.companiesCount}})</span></h4></div><div class=\"col-lg-5 col-md-5 col-sm-5 col-xs-5 no-padding\"><div class=\"form-group no-margins\"><div class=\"icon-addon addon-md\"><input type=\"text\" class=\"form-control\" id=\"search\" translate=\"\" translate-attr-placeholder=\"COMMONS.SEARCH_IN_TABLE\" ng-change=\"companies.searchCompanies()\" ng-model=\"companies.searchQuery\" ng-model-options=\"{ debounce: { \'default\': 500, \'blur\': 0 } }\"> <label for=\"search\" class=\"fa fa-search\" rel=\"tooltip\"></label></div></div></div></div><div class=\"ibox-content paginator-loader no-padding\"><div class=\"sk-spinner sk-spinner-circle\"><div class=\"sk-circle1 sk-circle\"></div><div class=\"sk-circle2 sk-circle\"></div><div class=\"sk-circle3 sk-circle\"></div><div class=\"sk-circle4 sk-circle\"></div><div class=\"sk-circle5 sk-circle\"></div><div class=\"sk-circle6 sk-circle\"></div><div class=\"sk-circle7 sk-circle\"></div><div class=\"sk-circle8 sk-circle\"></div><div class=\"sk-circle9 sk-circle\"></div><div class=\"sk-circle10 sk-circle\"></div><div class=\"sk-circle11 sk-circle\"></div><div class=\"sk-circle12 sk-circle\"></div></div><div class=\"col-lg-8 col-md-8 col-sm-8 col-xs-8 no-padding full-height companies-list\"><perfect-scrollbar class=\"scroller\" wheel-propagation=\"true\" wheel-speed=\"1\" min-scrollbar-length=\"20\"><table class=\"table\"><tbody><tr class=\"company-box\" ng-class=\"{\'inactive\': !company.active}\" ng-repeat-start=\"company in companies.companies | orderBy:\'name\'\"><td ng-class=\"{\'highlight\':company.displaying}\" class=\"company-name\"><div class=\"action-tools\" td-security=\"[\'Admin\']\" action=\"display-none\"><a class=\"menu\" ng-click=\"companies.showTools(company)\"><i class=\"icon icon-ic-ellipsis\"></i></a><ul class=\"menu-content\" ng-show=\"company.tools\"><li><a translate=\"COMMONS.ACTIVATE\" ng-show=\"!company.active\" ng-click=\"companies.activateCompany(company)\"></a></li><li><a translate=\"COMMONS.INACTIVATE\" ng-hide=\"!company.active\" ng-click=\"companies.inactivateCompany(company)\"></a></li><li><a translate=\"COMMONS.DELETE\" ng-click=\"companies.deleteCompany(company)\"></a></li></ul></div><span class=\"company\">{{company.name}} <span ng-show=\"!company.active\">({{\"COMPANIES.INACTIVE\" | translate}})</span></span><div class=\"company-tools\" ng-hide=\"!company.active\"><ul><li><a ng-hide=\"company.displaying\" class=\"view-detail\" translate=\"COMMONS.VIEW_DETAILS\" ng-click=\"companies.getCompanyDetails(company)\"></a> <a ng-show=\"company.displaying\" class=\"view-detail\" translate=\"COMMONS.HIDE_DETAILS\" ng-click=\"companies.closeDetails(company)\"></a></li><li td-security=\"[\'Admin\']\" action=\"display-none\"><a ui-sref=\"{{companies.editCompany}}\" translate=\"COMPANIES.EDIT\"></a></li></ul></div><div class=\"text-right right-tool\"><div class=\"company-tools\" ng-hide=\"!company.active\"><ul><li td-security=\"[\'Admin\']\" action=\"display-none\"><a ui-sref=\"{{companies.newContact}}\" translate=\"COMPANIES.ADD_CONTACT\"></a></li></ul></div></div></td></tr><tr ng-repeat-end=\"\" class=\"row-container\" ng-class=\"{\'inactive\': !company.active}\"><td class=\"contact-container\"><table class=\"table company-contacts\"><tbody><tr ng-repeat=\"contact in company.contacts\"><td><div class=\"contact-wrapper\"><span class=\"contact-name\">{{contact.name}}</span> <span class=\"contact-lead icon\" ng-click=\"companies.userRole == \'Admin\' && companies.toggleLead(contact)\" ng-class=\"{\'icon-ic-lead\': contact.type == \'PrimaryContact\', \'icon-ic-lead-outline\': contact.type != \'PrimaryContact\'}\" ng-hide=\"!company.active\"></span> <span class=\"contact-edit\" td-security=\"[\'Admin\']\" action=\"display-none\" ng-hide=\"!company.active\"><a ui-sref=\"app.manage.editContact({contactId: contact.id, company: company, companyId: company.id})\" class=\"edit-btn\" translate=\"COMPANIES.EDIT\"></a></span> <span class=\"contact-email hidden-xs hidden-sm hidden-md hidden-mdl\">{{contact.email}}</span> <span ng-if=\"companies.showPhones\" class=\"contact-number hidden-xs hidden-sm hidden-md hidden-mdl\" ng-hide=\"!company.active\">{{contact.officePhone | bcTelephone:\'format\'}} &lpar;{{\'COMPANIES.OFFICE\' | translate}}&rpar;</span> <span ng-if=\"companies.showPhones\" class=\"contact-number hidden-xs hidden-sm hidden-md hidden-mdl\" ng-hide=\"!company.active\">{{contact.mobilePhone | bcTelephone:\'format\'}} &lpar;{{\'COMPANIES.MOBILE\' | translate}}&rpar;</span></div></td></tr></tbody><tfoot><tr><td colspan=\"5\"><ul class=\"pagination pull-right\"></ul></td></tr></tfoot></table></td></tr></tbody></table></perfect-scrollbar></div><lateral-bar show=\"companies.showDetails\" config=\"companies.config\" on-close=\"companies.closeDetails\" content-selector=\"\'.companies-list\'\"></lateral-bar></div></div><div class=\"paginator-container\"><uib-pagination total-items=\"companies.companiesCount\" ng-model=\"companies.currentPage\" class=\"pagination-sm\" max-size=\"companies.maxPaginationSize\" items-per-page=\"companies.perPage\" ng-change=\"companies.changePage()\" boundary-link-numbers=\"true\" rotate=\"false\"></uib-pagination></div></div></div></div></section>");
$templateCache.put("app/states/manage/companies/company-lateral-content.html","<div id=\"content\"><div class=\"address-title\" translate=\"COMPANIES.ADDRESS\"></div><div class=\"address\">{{company.address.address}}</div><hr><div class=\"assets-title\" translate=\"COMPANIES.ASSETS\" ng-if=\"company.type == \'AssetManagement\'\"></div><span class=\"total-users\" ng-hide=\"!company.assets.length\">({{company.assets.length}})</span><div class=\"asset-name\" ng-repeat=\"asset in company.assets\"><a ui-sref=\"app.asset.assetDetails({assetId: asset.id, asset: asset})\">{{asset.name}}</a></div></div>");
$templateCache.put("app/states/manage/roles/roles.html","<header-section breadcrumb-title=\"roles.title\" breadcrumbs=\"roles.breadcrumbs\"></header-section><div class=\"wrapper wrapper-content\" nvc-full-page=\"\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><div class=\"row no-margins\"><div class=\"col-lg-11 col-md-11 col-sm-11 col-xs-11 no-padding\"><h4 translate=\"ROLES.ROLES\"></h4></div><div class=\"col-lg-1 col-md-1 col-sm-1 col-xs-1 no-padding ibox-search-row text-right\"><div uib-dropdown=\"\" is-open=\"roles.dropdown.isOpen\"><button ng-disabled=\"vm.downloadLoading\" class=\"btn btn-download\" ng-class=\"{\'btn-dropdown-active\': roles.dropdown.isOpen}\" uib-dropdown-toggle=\"\"><i class=\"icon icon-ic-download\"></i> {{ \"COMMONS.DOWNLOAD\" | translate }}</button><ul class=\"dropdown-menu\" uib-dropdown-menu=\"\"><li><a href=\"#\" class=\"btn-block btn-dropdown\" ng-click=\"roles.downloadPdf()\"><img class=\"dropdown-option-icon\" src=\"/assets/images/pdf.svg\"> {{ \"COMMONS.PDF\" | translate }}</a></li><li><a href=\"#\" class=\"btn-block btn-dropdown\" ng-click=\"roles.downloadCsv()\"><img class=\"dropdown-option-icon\" src=\"/assets/images/excel.svg\"> {{ \"COMMONS.EXCEL\" | translate }}</a></li></ul></div></div></div></div><div class=\"row no-margins fixed-header\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><ul><li ng-repeat=\"header in roles.tableHeaders\"><a translate=\"{{header}}\"></a></li></ul></div></div><div class=\"ibox-content no-padding\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding full-height\"><perfect-scrollbar class=\"scroller\" wheel-propagation=\"true\" min-scrollbar-length=\"20\"><div class=\"row no-margins no-button\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><table class=\"table table-striped\"><tbody><tr ng-repeat=\"row in roles.tableRows\"><td ng-repeat=\"col in row track by $index\"><span translate=\"{{col}}\" ng-if=\"col !== true && col !== false\"></span> <span ng-if=\"col === true\"><i class=\"text-green fa fa-check\"></i></span> <span ng-if=\"col === false\"><i class=\"text-danger fa fa-remove\"></i></span></td></tr></tbody></table></div></div></perfect-scrollbar></div></div></div></div></div></div>");
$templateCache.put("app/states/manage/users/users.html","<header-section breadcrumb-title=\"users.title\" breadcrumbs=\"users.breadcrumbs\"></header-section><div class=\"wrapper wrapper-content\" nvc-full-page=\"\" paginator=\"true\"><div class=\"row\" td-security=\"[\'Admin\']\" action=\"display-none\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"text-right m-b-lg\"><a class=\"btn btn-normal btn-w-m\" ui-sref=\"app.manage.users.addUser\" translate=\"USERS.ADD_USER\"></a></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><div class=\"col-lg-2 col-md-2 col-sm-2 col-xs-2 no-padding\" td-security=\"[\'Admin\']\" action=\"display-none\"><h4>{{\"USERS.USERS\" | translate}}&nbsp;<span>({{users.selectedUsers}}/{{users.usersCount}})</span></h4></div><div class=\"col-lg-7 col-md-7 col-sm-7 col-xs-7 no-padding\" td-security=\"[\'Audit\', \'AssetManagement\', \'AssetAppraisal\', \'AssetReview\', \'AssetManagerReadOnly\']\" action=\"display-none\"><h4>{{\"USERS.USERS\" | translate}}&nbsp;<span>({{users.usersCount}})</span></h4></div><div class=\"col-lg-5 col-md-5 col-sm-5 col-xs-5 no-padding action-tools\" td-security=\"[\'Admin\']\" action=\"display-none\"><span>{{ \"COMMONS.ACTIONS\" | translate }}:</span><ul><li><a translate=\"COMMONS.ACTIVATE\" ng-click=\"users.activateUser()\"></a></li><li><a translate=\"COMMONS.INACTIVATE\" ng-click=\"users.inactivateUser()\"></a></li><li><a translate=\"COMMONS.DELETE\" ng-click=\"users.deleteUser()\"></a></li></ul></div><div class=\"col-lg-5 col-md-5 col-sm-5 col-xs-5 no-padding\"><div class=\"form-group no-margins ibox-search-row\"><button ng-disabled=\"users.downloadLoading\" ng-click=\"users.downloadCsv()\" class=\"btn btn-download\"><i class=\"icon icon-ic-download\"></i> {{ \"COMMONS.DOWNLOAD\" | translate }}</button><div class=\"icon-addon addon-md ibox-search\"><input type=\"text\" class=\"form-control\" id=\"search\" translate=\"\" translate-attr-placeholder=\"USERS.SEARCH\" ng-change=\"users.searchUsers()\" ng-model=\"users.searchQuery\" ng-model-options=\"{ debounce: { \'default\': 500, \'blur\': 0 } }\"> <label for=\"search\" class=\"fa fa-search\" rel=\"tooltip\"></label></div></div></div></div><div class=\"row no-margins fixed-header\" ng-class=\"{\'is-not-admin\': !users.isAdmin}\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><ul><li td-security=\"[\'Admin\']\" action=\"display-none\"><a ng-class=\"{\'not-selected\': !users.usersSort[0].selected}\">&nbsp;</a></li><li><a translate=\"USERS.USER_NAME\" ng-click=\"users.sorting(users.usersSort[0], \'usersSelectedSort\')\" ng-class=\"{\'asc\': users.usersSort[0].flag, \'desc\': !users.usersSort[0].flag, \'not-selected\': !users.usersSort[0].selected}\"></a></li><li><a translate=\"USERS.EMAIL_ADDRESS\" ng-click=\"users.sorting(users.usersSort[1], \'usersSelectedSort\')\" ng-class=\"{\'asc\': users.usersSort[1].flag, \'desc\': !users.usersSort[1].flag, \'not-selected\': !users.usersSort[1].selected}\"></a></li><li><a translate=\"USERS.USER_OFFICE_NUMBER\"></a></li><li><a translate=\"USERS.USER_MOBILE_NUMBER\"></a></li><li><a translate=\"USERS.ACTIVE\"></a></li></ul></div></div><div class=\"ibox-content paginator-loader no-padding\"><div class=\"sk-spinner sk-spinner-circle\"><div class=\"sk-circle1 sk-circle\"></div><div class=\"sk-circle2 sk-circle\"></div><div class=\"sk-circle3 sk-circle\"></div><div class=\"sk-circle4 sk-circle\"></div><div class=\"sk-circle5 sk-circle\"></div><div class=\"sk-circle6 sk-circle\"></div><div class=\"sk-circle7 sk-circle\"></div><div class=\"sk-circle8 sk-circle\"></div><div class=\"sk-circle9 sk-circle\"></div><div class=\"sk-circle10 sk-circle\"></div><div class=\"sk-circle11 sk-circle\"></div><div class=\"sk-circle12 sk-circle\"></div></div><perfect-scrollbar class=\"scroller\" wheel-propagation=\"true\" min-scrollbar-length=\"20\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\" ng-class=\"{\'is-not-admin\': !users.isAdmin}\"><table class=\"table footable table-stripped toggle-arrow-tiny checkbox-custom\" data-page-size=\"100000\" data-filter-timeout=\"300\"><tbody><tr ng-repeat=\"user in users.users\"><td td-security=\"[\'Admin\']\" action=\"display-none\"><checkbox ng-model=\"user.user.selected\"></checkbox></td><td><a td-security=\"[\'Admin\']\" action=\"display-none\" ui-sref=\"app.manage.users.editUser({companyId: user.companyId, id: user.user.id, userCompanyRelationshipId: user.id})\" ui-sref-opts=\"{reload: true}\">{{ user.user.name}}</a> <a td-security=\"[\'Audit\', \'AssetManagement\', \'AssetAppraisal\', \'AssetReview\', \'AssetManagerReadOnly\']\" action=\"display-none\" ui-sref=\"app.manage.users.details({companyId: user.companyId, id: user.user.id})\">{{ user.user.name}}</a></td><td>{{ user.userAccount.email}}</td><td>{{user.userAccount.officePhone | bcTelephone:\'format\'}}</td><td>{{user.userAccount.mobilePhone | bcTelephone:\'format\'}}</td><td class=\"user-active\"><i class=\"icon icon-ic-check\" ng-class=\"{\'active\': user.active, \'inactive\': !user.active}\"></i></td></tr></tbody><tfoot><tr><td colspan=\"5\"><ul class=\"pagination pull-right\"></ul></td></tr></tfoot></table></div></perfect-scrollbar></div></div><div class=\"paginator-container\"><uib-pagination total-items=\"users.usersCount\" ng-model=\"users.currentPage\" class=\"pagination-sm\" max-size=\"users.maxPaginationSize\" items-per-page=\"users.perPage\" ng-change=\"users.changePage()\" boundary-link-numbers=\"true\" rotate=\"false\"></uib-pagination></div></div></div></div>");
$templateCache.put("app/states/valuations/advanced-filters/advanced-filters.html","<script type=\"text/ng-template\" id=\"advanced-filters.html\"><div class=\"advanced-filters-wp fixed-height\"> <perfect-scrollbar class=\"scroller\" wheel-propagation=\"true\" min-scrollbar-length=\"20\"> <div class=\"modal-header\"> <h3 class=\"no-margins\">{{\"VALUATIONS.ADVANCE_FILTERS\" | translate}}</h3> </div> <div class=\"modal-body\"> <div class=\"row\"> <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\"> <div class=\"form-group block-select\"> <label translate=\"VALUATIONS.STATUS\"></label> <label class=\"clear-filter-btn\" ng-click=\"advancedFiltersCtrl.clearFilter(\'StatusFilter\')\"> {{\"VALUATIONS.CLEAR\" | translate}} </label> <div class=\"input-group\"> <select name=\"status\" class=\"form-control\" chosen multiple placeholder-text-multiple=\"\'Select Statuses\'\" ng-model=\"advancedFiltersCtrl.valuationFilters.StatusFilter\" ng-options=\"status.name for status in advancedFiltersCtrl.statusFilterOptions\"> <option value=\"\"></option> </select> </div> </div> </div> <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\"> <div class=\"form-group\"> <label translate=\"VALUATIONS.NET_RENTABLE\"></label> <slider-range min=\"{{advancedFiltersCtrl.NetRentableAreaFilterMinOptions}}\" max=\"{{advancedFiltersCtrl.NetRentableAreaFilterMaxOptions}}\" value-min=\"advancedFiltersCtrl.NetRentableAreaFilterMin\" value-max=\"advancedFiltersCtrl.NetRentableAreaFilterMax\"> </slider-range> </div> </div> <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\"> <div class=\"form-group\"> <label translate=\"VALUATIONS.VALUE\"></label> <slider-range min=\"{{advancedFiltersCtrl.ValueFilterMinOptions}}\" max=\"{{advancedFiltersCtrl.ValueFilterMaxOptions}}\" value-min=\"advancedFiltersCtrl.ValueFilterMin\" value-max=\"advancedFiltersCtrl.ValueFilterMax\" unit=\"$\"> </slider-range> </div> </div> </div> <hr/> <div class=\"row\"> <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\"> <div class=\"form-group block-select\"> <label translate=\"VALUATIONS.PROPERTY_TYPE_FULL\"></label> <ul class=\"checkbox-filter\"> <li class=\"checkbox-li\" ng-repeat=\"type in advancedFiltersCtrl.propertyTypes\"> <checkbox ng-model=\"type.selected\"></checkbox> {{type.name}} </li> </ul> </div> </div> <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\"> <div class=\"form-group block-select\"> <label translate=\"VALUATIONS.PROPERTY_SUBTYPE\" ng-class=\"{\'label-disabled\': advancedFiltersCtrl.valuationFilters.PropertyTypeFilter.length==0}\"> </label> <label class=\"clear-filter-btn\" ng-class=\"{\'label-disabled\': advancedFiltersCtrl.valuationFilters.PropertyTypeFilter.length==0}\" ng-click=\"advancedFiltersCtrl.valuationFilters.PropertyTypeFilter.length!== 0 && advancedFiltersCtrl.clearFilter(\'PropertySubTypeFilter\')\"> {{\"VALUATIONS.CLEAR\" | translate}} </label> <select name=\"propSubtype\" class=\"form-control\" chosen multiple placeholder-text-multiple=\"\'Select Subtypes\'\" ng-model=\"advancedFiltersCtrl.valuationFilters.PropertySubTypeFilter\" ng-options=\"item.name for item in advancedFiltersCtrl.enabledPropertySubTypesOptions\" ng-disabled=\"advancedFiltersCtrl.valuationFilters.PropertyTypeFilter.length==0\"> <option style=\"display:none\" value=\"\" translate=\"VALUATIONS.SELECT_OPTION\"></option> </select> </div> </div> <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\"> <div class=\"form-group\"> <label translate=\"ADD_ASSET.OWNERSHIP_TYPE\"></label> <ul class=\"checkbox-filter\"> <li class=\"checkbox-li\" ng-repeat=\"type in advancedFiltersCtrl.OwnershipTypeFilterOptions\"> <checkbox ng-model=\"type.selected\"></checkbox> {{type.name}} </li> </ul> </div> </div> </div> <hr/> <div class=\"row\"> <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\"> <div class=\"form-group\"> <label translate=\"VALUATIONS.LEAD_REVIEWER\"></label> <input name=\"leadRW\" class=\"form-control\" ng-model=\"advancedFiltersCtrl.valuationFilters.LeadReviewerFilter\" translate translate-attr-placeholder=\"VALUATIONS.LEAD_REVIEWER\"> </div> </div> <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\" td-security=\"[\'Admin\', \'Audit\', \'AssetReview\', \'AssetManagement\', \'AssetManagerReadOnly\']\" action=\"display-none\"> <div class=\"form-group\"> <label translate=\"VALUATIONS.LEAD_AM\"></label> <input name=\"leadAM\" class=\"form-control\" ng-model=\"advancedFiltersCtrl.valuationFilters.LeadAMFilter\" translate translate-attr-placeholder=\"VALUATIONS.LEAD_AM\"> </div> </div> <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\" td-security=\"[\'Admin\', \'Audit\', \'AssetReview\', \'AssetAppraisal\']\" action=\"display-none\"> <div class=\"form-group\"> <label translate=\"VALUATIONS.LEAD_AP\"></label> <input name=\"leadAP\" class=\"form-control\" ng-model=\"advancedFiltersCtrl.valuationFilters.LeadAppraiserFilter\" translate translate-attr-placeholder=\"VALUATIONS.LEAD_AP\"> </div> </div> </div> <hr/> <div class=\"row\"> <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\"> <div class=\"form-group block-select\"> <label translate=\"ADD_ASSET.COUNTRY\"></label> <ul class=\"checkbox-filter\"> <li class=\"checkbox-li\" ng-repeat=\"type in advancedFiltersCtrl.CountryFilterOptions\"> <checkbox ng-model=\"type.selected\"></checkbox> {{type.name}} </li> </ul> </div> </div> <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\"> <div class=\"form-group block-select\"> <label translate=\"ADD_ASSET.STATE\" ng-class=\"{\'label-disabled\': advancedFiltersCtrl.valuationFilters.CountryFilter.length == 0}\"> </label> <label class=\"clear-filter-btn\" ng-class=\"{\'label-disabled\': advancedFiltersCtrl.valuationFilters.CountryFilter.length == 0}\" ng-click=\"advancedFiltersCtrl.valuationFilters.CountryFilter.length !== 0 && advancedFiltersCtrl.clearFilter(\'StateFilter\')\"> {{\"VALUATIONS.CLEAR\" | translate}} </label> <select name=\"state\" class=\"form-control\" chosen multiple placeholder-text-multiple=\"\'Select States\'\" ng-model=\"advancedFiltersCtrl.valuationFilters.StateFilter\" ng-options=\"state.name for state in advancedFiltersCtrl.enabledStates\" ng-disabled=\"advancedFiltersCtrl.valuationFilters.CountryFilter.length == 0\"> <option style=\"display:none\" value=\"\" translate=\"VALUATIONS.SELECT_OPTION\"></option> </select> </div> </div> <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\"> <div class=\"form-group block-select\"> <label translate=\"ADD_ASSET.CITY\" ng-class=\"{\'label-disabled\': advancedFiltersCtrl.valuationFilters.StateFilter.length == 0}\"> </label> <label class=\"clear-filter-btn\" ng-class=\"{\'label-disabled\': advancedFiltersCtrl.valuationFilters.StateFilter.length == 0}\" ng-click=\"advancedFiltersCtrl.valuationFilters.StateFilter.length !== 0\"> </label> <input name=\"city\" class=\"form-control\" ng-model=\"advancedFiltersCtrl.valuationFilters.CityFilter\" translate translate-attr-placeholder=\"ADD_ASSET.CITY\" ng-disabled=\"advancedFiltersCtrl.valuationFilters.StateFilter.length == 0\"> </div> </div> </div> <hr/> <div class=\"row\"> <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\"> <div class=\"form-group\"> <label translate=\"VALUATIONS.PORTFOLIO\"></label> <input name=\"portfolio\" class=\"form-control\" ng-model=\"advancedFiltersCtrl.valuationFilters.PortfolioFilter\" translate translate-attr-placeholder=\"VALUATIONS.PORTFOLIO\"> </div> </div> <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\"> <div class=\"form-group block-select\"> <label translate=\"ADD_ASSET.MSA\" ng-class=\"{\'label-disabled\': !advancedFiltersCtrl.enableMSA}\"> </label> <label class=\"clear-filter-btn\" ng-class=\"{\'label-disabled\': !advancedFiltersCtrl.enableMSA}\" ng-click=\"advancedFiltersCtrl.enableMSA && advancedFiltersCtrl.clearFilter(\'MSAFilter\')\"> {{\"VALUATIONS.CLEAR\" | translate}} </label> <select name=\"msa\" class=\"form-control\" chosen multiple placeholder-text-multiple=\"\'Select MSAs\'\" ng-model=\"advancedFiltersCtrl.valuationFilters.MSAFilter\" ng-options=\"type for type in advancedFiltersCtrl.enabledMSAOptions\" ng-disabled=\"!advancedFiltersCtrl.enableMSA\"> <option style=\"display:none\" value=\"\" translate=\"VALUATIONS.SELECT_OPTION\"></option> </select> </div> </div> <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\"> <div class=\"form-group block-select\"> <label translate=\"ADD_ASSET.NCREIF\"></label> <label class=\"clear-filter-btn\" ng-click=\"advancedFiltersCtrl.clearFilter(\'NCREIFFilter\')\"> {{\"VALUATIONS.CLEAR\" | translate}} </label> <select name=\"ncreif\" class=\"form-control\" chosen multiple placeholder-text-multiple=\"\'Select NCREIFs\'\" ng-model=\"advancedFiltersCtrl.valuationFilters.NCREIFFilter\" ng-options=\"item.name for item in advancedFiltersCtrl.NCREIFFilterOptions\"> <option style=\"display:none\" value=\"\" translate=\"VALUATIONS.SELECT_OPTION\"></option> </select> </div> </div> </div> </div> <div class=\"modal-footer\"> <div class=\"row text-right\"> <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"> <button class=\"btn btn-w-m btn-back\" ng-click=\"advancedFiltersCtrl.cancel()\"> {{\"VALUATIONS.CANCEL\" | translate}} </button> <button class=\"btn btn-w-m btn-back\" ng-click=\"advancedFiltersCtrl.clearAllFilters()\"> {{\"VALUATIONS.CLEAR_ALL\" | translate}} </button> <button class=\"btn btn-w-m btn-normal m-l-sm\" ng-click=\"advancedFiltersCtrl.applyFilters()\"> {{\"VALUATIONS.APPLY_FILTERS\" | translate}} </button> </div> </div> </div> </perfect-scrollbar> </div></script>");
$templateCache.put("app/states/valuations/review/review.html","<header-section breadcrumb-title=\"reviewCtrl.title\" breadcrumbs=\"reviewCtrl.breadcrumbs\"></header-section><section class=\"review\"><div class=\"wrapper wrapper-content\"><ul class=\"tabs\"><li ui-sref-active=\"active\"><a ui-sref=\"app.review.discussion\" translate=\"REVIEW.REVIEW\"></a></li><li ui-sref-active=\"active\" td-security=\"[\'Admin\']\" action=\"display-none\"><a ui-sref=\"app.review.documentsUpload\" review-checker=\"reviewCtrl.review\" actions=\"[\'AP_UploadDocuments\', \'AP_UploadFinalDocuments\', \'RW_UploadDocuments\']\">{{\'REVIEW.UPLOADS\' | translate}}</a> <a ui-sref=\"app.review.documents\" review-checker=\"reviewCtrl.review\" actions=\"[\'AP_Submit\', \'AP_FillFinalForm\']\" ng-hide=\"reviewCtrl.review.status === \'CommentsAnswered\' || reviewCtrl.review.status === \'ValuationSignedOff\'\">{{\'REVIEW.UPLOADS\' | translate}}</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.review.documentsHistory\" translate=\"REVIEW.DOCUMENTS\"></a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.review.property\" translate=\"REVIEW.PROPERTY\"></a></li></ul></div><div ui-view=\"\"></div></section>");
$templateCache.put("app/components/commons/messages/fe-notifications/fe-notifications.html","<div class=\"cg-notify-message inspinia-notify\" ng-class=\"$classes\"><div class=\"p-lg\"><div ng-show=\"!$messageTemplate\">{{$message}}</div><div ng-show=\"$messageTemplate\" class=\"cg-notify-message-template\"></div><button type=\"button\" class=\"cg-notify-close\" ng-click=\"$close()\"><span aria-hidden=\"true\">&times;</span> <span class=\"cg-notify-sr-only\">Close</span></button></div></div>");
$templateCache.put("app/components/directives/td-image-upload/crop-image-modal/crop-image-modal.html","<div class=\"inmodal\"><div class=\"modal-header\" translate=\"ADD_ASSET.DRAG_TO_CROP\"></div><div class=\"modal-body\"><div class=\"crop-area\"><img-crop area-type=\"square\" image=\"selectedPhoto\" result-image=\"croppedPhoto\"></img-crop></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\" translate=\"ADD_ASSET.CANCEL\"></button> <button type=\"button\" class=\"btn btn-navy\" ng-click=\"selectCroppedImage()\" translate=\"ADD_ASSET.SAVE\"></button></div></div>");
$templateCache.put("app/states/assets/bid-groups/edit-bid-group/edit-bid-group.html","<header-section breadcrumb-title=\"editBidGroupCtrl.title\" breadcrumbs=\"editBidGroupCtrl.breadcrumbs\"></header-section><div class=\"wrapper wrapper-content\" nvc-full-page=\"\"><form name=\"editBidGroupCtrl.addBidGroupForm\" class=\"add-asset-form\" role=\"form\" ng-submit=\"editBidGroupCtrl.addBidGroupForm.$valid && editBidGroupCtrl.bidGroup.assets.length > 0 && editBidGroupCtrl.submitForm(editBidGroupCtrl.bidGroup)\" confirm-leave=\"\" novalidate=\"\"><div class=\"row\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6 assets-picker\"><div class=\"ibox float-e-margins\" ng-class=\"{\'hover\':editBidGroupCtrl.isHoverList}\"><div class=\"dropzone\" ng-hide=\"editBidGroupCtrl.hideList\" drop=\"editBidGroupCtrl.moveToList\" enter=\"editBidGroupCtrl.hoverList\"></div><div class=\"ibox-title\"><div class=\"row no-margins\"><div class=\"col-lg-7 col-md-7 col-sm-7 col-xs-7 no-padding\"><h4 class=\"no-margins\">{{\"ADD_BID_GROUP.ASSETS\" | translate}} <span ng-hide=\"!editBidGroupCtrl.assets.length\">({{editBidGroupCtrl.assets.length}})</span></h4></div><div class=\"col-lg-5 col-md-5 col-sm-5 col-xs-5 no-padding\"><div class=\"form-group no-margins\"><div class=\"icon-addon addon-md\"><input type=\"text\" class=\"form-control\" id=\"search\" translate=\"\" translate-attr-placeholder=\"ASSETS.SEARCH\" ng-change=\"editBidGroupCtrl.searchAssets()\" ng-model=\"editBidGroupCtrl.searchQuery\" ng-model-options=\"{ debounce: { \'default\': 300, \'blur\': 0 } }\"> <label for=\"search\" class=\"fa fa-search\" rel=\"tooltip\"></label></div></div></div></div></div><div class=\"row no-margins fixed-header\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><ul><li><a translate=\"ADD_BID_GROUP.PROPERTY_NAME\" ng-click=\"editBidGroupCtrl.sorting(editBidGroupCtrl.assetSort[0], \'assetSelectedSort\')\" ng-class=\"{\'asc\': editBidGroupCtrl.assetSort[0].flag, \'desc\': !editBidGroupCtrl.assetSort[0].flag, \'not-selected\': !editBidGroupCtrl.assetSort[0].selected}\"></a></li><li><a translate=\"ADD_BID_GROUP.ID\"></a></li><li><a translate=\"ADD_BID_GROUP.LOCATION\"></a></li><li><a translate=\"ADD_BID_GROUP.PROPERTY_TYPE\"></a></li><li><a translate=\"ADD_BID_GROUP.PROPERTY_SUBTYPE\"></a></li><li></li></ul></div></div><div class=\"ibox-content no-padding\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding full-height\"><perfect-scrollbar class=\"scroller\" wheel-propagation=\"true\" min-scrollbar-length=\"20\"><table class=\"table footable table-stripped toggle-arrow-tiny\" data-page-size=\"100000\" data-filter=\"#search\" data-filter-timeout=\"300\"><tbody><tr ng-repeat=\"asset in editBidGroupCtrl.assets | orderBy: editBidGroupCtrl.assetSelectedSort.sort\" ng-class=\"{\'highlight\':asset.displaying}\" drag=\"\" ng-model=\"asset\" start=\"editBidGroupCtrl.showDropZoneBid\"><td><a ui-sref=\"app.asset.assetDetails({assetId: asset.id})\">{{asset.name}}</a></td><td>{{asset.propertyRef}}</td><td>{{asset.address.city}}, {{asset.address.state}}</td><td>{{asset.type}}</td><td>{{asset.subType}}</td><td><a class=\"btn-add\" ng-click=\"editBidGroupCtrl.addBidGroupAsset(asset)\"></a></td></tr></tbody></table></perfect-scrollbar></div></div></div></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6 bid-group-assets\"><div class=\"ibox float-e-margins empty\" ng-hide=\"editBidGroupCtrl.bidGroup.assets.length > 0\" ng-class=\"{\'hover\':editBidGroupCtrl.isHoverBid}\"><div class=\"dropzone\" ng-hide=\"editBidGroupCtrl.hideBid\" drop=\"editBidGroupCtrl.moveToBid\" enter=\"editBidGroupCtrl.hoverBid\"></div><div class=\"ibox-content no-padding\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 full-height\"><div class=\"empty-message\" translate=\"ADD_BID_GROUP.PLEASE_ADD_ASSET\"></div></div></div></div><div class=\"ibox float-e-margins\" ng-show=\"editBidGroupCtrl.bidGroup.assets.length > 0\" ng-class=\"{\'hover\':editBidGroupCtrl.isHoverBid}\"><div class=\"dropzone\" ng-hide=\"editBidGroupCtrl.hideBid\" drop=\"editBidGroupCtrl.moveToBid\" enter=\"editBidGroupCtrl.hoverBid\"></div><div class=\"ibox-title\"><div class=\"row no-margins\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><h4 class=\"no-margins\" translate=\"EDIT_BID_GROUP.TITLE\"></h4></div></div></div><div class=\"row no-margins fixed-header\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><ul><li><a translate=\"ADD_BID_GROUP.PROPERTY_NAME\" ng-click=\"editBidGroupCtrl.sortingBidGroupAssets(editBidGroupCtrl.bidGroupAssetSort[0], \'bidGroupAssetSelectedSort\')\" ng-class=\"{\'asc\': editBidGroupCtrl.bidGroupAssetSort[0].flag, \'desc\': !editBidGroupCtrl.bidGroupAssetSort[0].flag, \'not-selected\': !editBidGroupCtrl.bidGroupAssetSort[0].selected}\"></a></li><li><a translate=\"ADD_BID_GROUP.ID\"></a></li><li><a translate=\"ADD_BID_GROUP.LOCATION\"></a></li><li><a translate=\"ADD_BID_GROUP.PROPERTY_TYPE\"></a></li><li><a translate=\"ADD_BID_GROUP.PROPERTY_SUBTYPE\"></a></li><li></li></ul></div></div><div class=\"ibox-content no-padding\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding full-height\"><div class=\"row no-margins\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 m-t-md\"><h5 translate=\"ADD_BID_GROUP.NAME\"></h5><div class=\"form-group\"><input class=\"form-control\" type=\"text\" translate=\"\" ng-pattern=\"/^([ña-zÑ0-9A-Z\\s]*[áéíóúüÁÉÍÓÚÜ\',&.]*)*$/\" ng-model=\"editBidGroupCtrl.bidGroup.name\" translate-attr-placeholder=\"ADD_BID_GROUP.ENTER_BIDDING_GROUP_NAME\" required=\"\"></div></div></div><div class=\"hr-line-dashed\"></div><div class=\"row no-margins\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><h5>{{\"ADD_BID_GROUP.ASSETS_INCLUDED\" | translate}} <span ng-hide=\"!editBidGroupCtrl.bidGroup.assets.length\">({{editBidGroupCtrl.bidGroup.assets.length}})</span></h5></div></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding fixed-height\" remove-height=\"240\"><perfect-scrollbar class=\"scroller\" wheel-propagation=\"true\" min-scrollbar-length=\"20\"><div class=\"row no-margins\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><table class=\"table footable table-stripped toggle-arrow-tiny\" data-page-size=\"100000\"><tbody><tr ng-repeat=\"asset in editBidGroupCtrl.bidGroup.assets | orderBy: editBidGroupCtrl.bidGroupAssetSelectedSort.sort\" ng-class=\"{\'highlight\':asset.displaying}\" drag=\"\" ng-model=\"asset\" start=\"editBidGroupCtrl.showDropZoneList\"><td><a ui-sref=\"app.asset.assetDetails({assetId: asset.id})\">{{asset.name}}</a></td><td>{{asset.propertyRef}}</td><td>{{asset.address.city}}, {{asset.address.state}}</td><td>{{asset.type}}</td><td>{{asset.subType}}</td><td><a class=\"btn-remove\" ng-click=\"editBidGroupCtrl.removeBidGroupAsset(asset)\"></a></td></tr></tbody></table></div></div></perfect-scrollbar></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 text-right\"><button class=\"btn btn-w-m btn-back\" type=\"button\" translate=\"COMMONS.DISCARD\" ui-sref=\"app.asset.bidGroups\"></button> <button class=\"btn btn-w-m btn-normal m-l-sm\" type=\"submit\" translate=\"COMMONS.SAVE\" ng-disabled=\"editBidGroupCtrl.bidGroup.assets.length == 0\"></button></div></div></form></div>");
$templateCache.put("app/states/assets/bid-groups/add-bid-group/add-bid-group.html","<header-section breadcrumb-title=\"addBidGroupCtrl.title\" breadcrumbs=\"addBidGroupCtrl.breadcrumbs\"></header-section><div class=\"wrapper wrapper-content\" nvc-full-page=\"\"><form name=\"addBidGroupCtrl.addBidGroupForm\" class=\"add-asset-form\" role=\"form\" ng-submit=\"addBidGroupCtrl.addBidGroupForm.$valid && addBidGroupCtrl.bidGroupAssets.length > 0 && addBidGroupCtrl.submitForm(addBidGroupCtrl.newBidGroup)\" confirm-leave=\"\" novalidate=\"\"><div class=\"row\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6 assets-picker\"><div class=\"ibox float-e-margins\" ng-class=\"{\'hover\':addBidGroupCtrl.isHoverList}\"><div class=\"dropzone\" ng-hide=\"addBidGroupCtrl.hideList\" drop=\"addBidGroupCtrl.moveToList\" enter=\"addBidGroupCtrl.hoverList\"></div><div class=\"ibox-title\"><div class=\"row no-margins\"><div class=\"col-lg-7 col-md-7 col-sm-7 col-xs-7 no-padding\"><h4 class=\"no-margins\">{{\"ADD_BID_GROUP.ASSETS\" | translate}} <span ng-hide=\"!addBidGroupCtrl.assets.length\">({{addBidGroupCtrl.assets.length}})</span></h4></div><div class=\"col-lg-5 col-md-5 col-sm-5 col-xs-5 no-padding\"><div class=\"form-group no-margins\"><div class=\"icon-addon addon-md\"><input type=\"text\" class=\"form-control\" id=\"search\" translate=\"\" translate-attr-placeholder=\"ASSETS.SEARCH\" ng-change=\"addBidGroupCtrl.searchAssets()\" ng-model=\"addBidGroupCtrl.searchQuery\" ng-model-options=\"{ debounce: { \'default\': 300, \'blur\': 0 } }\"> <label for=\"search\" class=\"fa fa-search\" rel=\"tooltip\"></label></div></div></div></div></div><div class=\"row no-margins fixed-header\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><ul><li><a translate=\"ADD_BID_GROUP.PROPERTY_NAME\" ng-click=\"addBidGroupCtrl.sorting(addBidGroupCtrl.assetSort[0], \'assetSelectedSort\')\" ng-class=\"{\'asc\': addBidGroupCtrl.assetSort[0].flag, \'desc\': !addBidGroupCtrl.assetSort[0].flag, \'not-selected\': !addBidGroupCtrl.assetSort[0].selected}\"></a></li><li><a translate=\"ADD_BID_GROUP.ID\"></a></li><li><a translate=\"ADD_BID_GROUP.LOCATION\"></a></li><li><a translate=\"ADD_BID_GROUP.PROPERTY_TYPE\"></a></li><li><a translate=\"ADD_BID_GROUP.PROPERTY_SUBTYPE\"></a></li><li></li></ul></div></div><div class=\"ibox-content no-padding\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding full-height\"><perfect-scrollbar class=\"scroller\" wheel-propagation=\"true\" min-scrollbar-length=\"20\"><table class=\"table footable table-stripped toggle-arrow-tiny\" data-page-size=\"100000\" data-filter=\"#search\" data-filter-timeout=\"300\"><tbody><tr ng-repeat=\"asset in addBidGroupCtrl.assets | orderBy: addBidGroupCtrl.assetSelectedSort.sort\" ng-class=\"{\'highlight\':asset.displaying}\" drag=\"\" ng-model=\"asset\" start=\"addBidGroupCtrl.showDropZoneBid\"><td><a ui-sref=\"app.asset.assetDetails({assetId: asset.id})\">{{asset.name}}</a></td><td>{{asset.propertyRef}}</td><td>{{asset.address.city}}, {{asset.address.state}}</td><td>{{asset.type}}</td><td>{{asset.subType}}</td><td><a class=\"btn-add\" ng-click=\"addBidGroupCtrl.addBidGroupAsset(asset)\"></a></td></tr></tbody></table></perfect-scrollbar></div></div></div></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6 bid-group-assets\"><div class=\"ibox float-e-margins empty\" ng-hide=\"addBidGroupCtrl.bidGroupAssets.length > 0\" ng-class=\"{\'hover\':addBidGroupCtrl.isHoverBid}\"><div class=\"dropzone\" ng-hide=\"addBidGroupCtrl.hideBid\" drop=\"addBidGroupCtrl.moveToBid\" enter=\"addBidGroupCtrl.hoverBid\"></div><div class=\"ibox-content no-padding\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 full-height\"><div class=\"empty-message\" translate=\"ADD_BID_GROUP.PLEASE_ADD_ASSET\"></div></div></div></div><div class=\"ibox float-e-margins\" ng-show=\"addBidGroupCtrl.bidGroupAssets.length > 0\" ng-class=\"{\'hover\':addBidGroupCtrl.isHoverBid}\"><div class=\"dropzone\" ng-hide=\"addBidGroupCtrl.hideBid\" drop=\"addBidGroupCtrl.moveToBid\" enter=\"addBidGroupCtrl.hoverBid\"></div><div class=\"ibox-title\"><div class=\"row no-margins\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><h4 class=\"no-margins\" translate=\"ADD_BID_GROUP.TITLE\"></h4></div></div></div><div class=\"row no-margins fixed-header\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><ul><li><a translate=\"ADD_BID_GROUP.PROPERTY_NAME\" ng-click=\"addBidGroupCtrl.sortingBidGroupAssets(addBidGroupCtrl.bidGroupAssetSort[0], \'bidGroupAssetSelectedSort\')\" ng-class=\"{\'asc\': addBidGroupCtrl.bidGroupAssetSort[0].flag, \'desc\': !addBidGroupCtrl.bidGroupAssetSort[0].flag, \'not-selected\': !addBidGroupCtrl.bidGroupAssetSort[0].selected}\"></a></li><li><a translate=\"ADD_BID_GROUP.ID\"></a></li><li><a translate=\"ADD_BID_GROUP.LOCATION\"></a></li><li><a translate=\"ADD_BID_GROUP.PROPERTY_TYPE\"></a></li><li><a translate=\"ADD_BID_GROUP.PROPERTY_SUBTYPE\"></a></li><li></li></ul></div></div><div class=\"ibox-content no-padding\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding full-height\"><div class=\"row no-margins\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 m-t-md\"><h5 translate=\"ADD_BID_GROUP.NAME\"></h5><div class=\"form-group\"><input class=\"form-control\" type=\"text\" translate=\"\" ng-pattern=\"/^([ña-zÑ0-9A-Z\\s]*[áéíóúüÁÉÍÓÚÜ\',&.]*)*$/\" ng-model=\"addBidGroupCtrl.newBidGroup.name\" translate-attr-placeholder=\"ADD_BID_GROUP.ENTER_BIDDING_GROUP_NAME\" required=\"\"></div></div></div><div class=\"hr-line-dashed\"></div><div class=\"row no-margins\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><h5>{{\"ADD_BID_GROUP.ASSETS_INCLUDED\" | translate}} <span ng-hide=\"!addBidGroupCtrl.bidGroupAssets.length\">({{addBidGroupCtrl.bidGroupAssets.length}})</span></h5></div></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding fixed-height\" remove-height=\"240\"><perfect-scrollbar class=\"scroller\" wheel-propagation=\"true\" min-scrollbar-length=\"20\"><div class=\"row no-margins\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><table class=\"table footable table-stripped toggle-arrow-tiny\" data-page-size=\"100000\"><tbody><tr ng-repeat=\"asset in addBidGroupCtrl.bidGroupAssets | orderBy: addBidGroupCtrl.bidGroupAssetSelectedSort.sort\" ng-class=\"{\'highlight\':asset.displaying}\" drag=\"\" ng-model=\"asset\" start=\"addBidGroupCtrl.showDropZoneList\"><td><a ui-sref=\"app.asset.assetDetails({assetId: asset.id})\">{{asset.name}}</a></td><td>{{asset.propertyRef}}</td><td>{{asset.address.city}}, {{asset.address.state}}</td><td>{{asset.type}}</td><td>{{asset.subType}}</td><td><a class=\"btn-remove\" ng-click=\"addBidGroupCtrl.removeBidGroupAsset(asset)\"></a></td></tr></tbody></table></div></div></perfect-scrollbar></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 text-right\"><button class=\"btn btn-w-m btn-back\" type=\"button\" translate=\"COMMONS.DISCARD\" ui-sref=\"app.asset.bidGroups\"></button> <button class=\"btn btn-w-m btn-normal m-l-sm\" type=\"submit\" translate=\"COMMONS.SAVE\" ng-disabled=\"addBidGroupCtrl.bidGroupAssets.length == 0\"></button></div></div></form></div>");
$templateCache.put("app/states/bid-engagement/add-rfp/bid-assignment/bid-assignment.html","<form name=\"bidAssignmentsCtrl.requestForm\" ng-submit=\"bidAssignmentsCtrl.saveRFP()\" novalidate=\"\"><div class=\"row filter\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"row no-margins\"><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 no-padding assets-table\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content no-title no-padding-left no-padding-right no-padding-bottom\"><div class=\"row no-margins\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><div class=\"row no-margins\"><div class=\"col-lg-7 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group\"><label translate=\"ADD_RFP.RFP_NAME\"></label> <input type=\"text\" class=\"form-control\" ng-model=\"bidAssignmentsCtrl.requestName\" required=\"\"></div></div><div class=\"col-lg-5 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group\"><label translate=\"ADD_RFP.BID_DUE_DATE\"></label><div class=\"input-group\"><input name=\"bidDueDate\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"MM/dd/yyyy\" is-open=\"bidAssignmentsCtrl.bidDuePicker.opened\" datepicker-options=\"bidAssignmentsCtrl.dateOptions\" ng-model=\"bidAssignmentsCtrl.bidOverDate\" ng-model-options=\"bidAssignmentsCtrl.modelOptions\" required=\"\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" type=\"button\" ng-click=\"bidAssignmentsCtrl.openBidDuePicker()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><div class=\"row no-margins\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><h4>{{\"ADD_RFP.ASSETS\" | translate}} ({{bidAssignmentsCtrl.assets.length}})</h4></div></div><hr><div class=\"row no-margins fixed-header\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><ul><li><a translate=\"ADD_RFP.NAME\" ng-click=\"bidAssignmentsCtrl.sorting(bidAssignmentsCtrl.appraisersSort[0], \'appraisersSelectedSort\')\" ng-class=\"{\'asc\': bidAssignmentsCtrl.appraisersSort[0].flag, \'desc\': !bidAssignmentsCtrl.appraisersSort[0].flag, \'not-selected\': !bidAssignmentsCtrl.appraisersSort[0].selected}\"></a></li><li><a translate=\"ADD_RFP.APPRAISERS\"></a></li></ul></div></div><div class=\"row no-margins\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding fixed-height\"><perfect-scrollbar class=\"scroller\" wheel-propagation=\"true\" min-scrollbar-length=\"20\"><table class=\"table footable table-stripped toggle-arrow-tiny\" data-page-size=\"100000\" data-filter=\"#searchFilter\" data-filter-timeout=\"300\"><tbody><tr ng-repeat=\"asset in bidAssignmentsCtrl.assets | orderBy: bidAssignmentsCtrl.appraisersSelectedSort.sort\" ng-click=\"bidAssignmentsCtrl.getAssetDetail(asset)\" ng-class=\"{\'highlight\':asset.displaying}\"><td>{{ asset.name }}</td><td>{{ bidAssignmentsCtrl.selectedUsersByAsset[asset.id].count }}/{{bidAssignmentsCtrl.appraisers.length}}</td></tr></tbody></table></perfect-scrollbar></div></div></div></div></div></div></div><div class=\"col-lg-8 col-md-8 col-sm-8 col-xs-8 no-padding checkbox-custom appraisers-table\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><div class=\"row no-margins\"><div class=\"col-lg-7 col-md-7 col-sm-7 col-xs-7 no-padding\"><h4 class=\"no-margins\">{{bidAssignmentsCtrl.selectedAsset.name}}</h4><span>{{\"ADD_RFP.APPRAISERS_SELECTED\" | translate}} ({{bidAssignmentsCtrl.selectedUsersByAsset[bidAssignmentsCtrl.selectedAsset.id].count}}/{{bidAssignmentsCtrl.appraisers.length}})</span></div></div></div><div class=\"row no-margins fixed-header\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><ul><li><a translate=\"ADD_RFP.NAME\"></a></li><li><a translate=\"ADD_RFP.APPRAISED\"></a></li><li><a translate=\"ADD_RFP.COMPANY\"></a></li><li><a translate=\"ADD_RFP.STATE\"></a></li><li><a translate=\"ADD_RFP.SPECIALTIES\"></a></li><li><a translate=\"ADD_RFP.SELECT_ALL\" ng-click=\"bidAssignmentsCtrl.selectAllUsersForAsset(bidAssignmentsCtrl.selectedAsset)\"></a></li></ul></div></div><div class=\"ibox-content no-padding\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding fixed-height\"><perfect-scrollbar class=\"scroller\" wheel-propagation=\"true\" min-scrollbar-length=\"20\"><table class=\"table footable table-stripped toggle-arrow-tiny\" data-page-size=\"100000\" data-filter=\"#searchFilter\" data-filter-timeout=\"300\"><tbody><tr ng-class=\"{\'disabled\':appraiser.assetRelation[bidAssignmentsCtrl.selectedAsset.id].workedLastQuarter}\" ng-repeat=\"appraiser in bidAssignmentsCtrl.appraisers\"><td>{{appraiser.user.name}}</td><td><span class=\"glyphicon glyphicon-ok\" ng-class=\"{\'appraised\':appraiser.assetRelation[bidAssignmentsCtrl.selectedAsset.id].workedInAsset}\"></span></td><td>{{appraiser.companyName}}</td><td title=\"{{appraiser.user.states || \'N/A\'}}\">{{appraiser.user.states || \"N/A\"}}</td><td title=\"{{appraiser.user.specialties}}\">{{appraiser.user.specialties}}</td><td class=\"text-center\"><span class=\"counter\">{{bidAssignmentsCtrl.userSelectedCount[appraiser.id].length}}/{{bidAssignmentsCtrl.assets.length}}</span><checkbox ng-model=\"bidAssignmentsCtrl.selectedUsersByAsset[bidAssignmentsCtrl.selectedAsset.id].usersIds[appraiser.user.id]\" ng-change=\"bidAssignmentsCtrl.userSelectedForAssetChanged(appraiser)\"></checkbox></td></tr></tbody></table></perfect-scrollbar></div></div></div></div></div></div></div><div class=\"row bottom-buttons\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 text-right\"><button class=\"btn btn-w-m btn-back m-b-lg\" type=\"button\" translate=\"ADD_RFP.BACK\" ui-sref=\"app.bidEngagement.addRfp.selectAppraisers(addRfpCtrl.params)\"></button> <button class=\"btn btn-w-m btn-normal m-l-sm m-b-lg\" type=\"submit\" translate=\"ADD_RFP.SEND\"></button></div></div></form>");
$templateCache.put("app/states/bid-engagement/add-rfp/select-assets/select-assets.html","<div class=\"row checkbox-custom filter\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content no-title\"><div class=\"row no-margins summary\" ng-hide=\"selectAssetsCtrl.showFilters\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><div class=\"row no-margins\"><div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3\"><span class=\"title\" translate=\"ADD_RFP.BID_GROUP\"></span> <span class=\"big\" title=\"{{selectAssetsCtrl.arrayToFormattedString(selectAssetsCtrl.selectedBidGroups, \', \')}}\">{{selectAssetsCtrl.arrayToFormattedString(selectAssetsCtrl.selectedBidGroups, \', \')}}</span></div><div class=\"col-lg-2 col-md-2 col-sm-2 col-xs-2\"><span class=\"title\" translate=\"ADD_RFP.ROLLING_ON\"></span> <span class=\"big\" title=\"{{selectAssetsCtrl.arrayToFormattedString(selectAssetsCtrl.selectedYears, \', \')}} - {{selectAssetsCtrl.arrayToFormattedString(selectAssetsCtrl.selectedQuarters.list, \' / \')}}\">{{selectAssetsCtrl.arrayToFormattedString(selectAssetsCtrl.selectedYears, \', \')}} <span ng-if=\"selectAssetsCtrl.selectedYears.length > 0 && selectAssetsCtrl.selectedQuarters.list.length > 0\">-</span> {{selectAssetsCtrl.arrayToFormattedString(selectAssetsCtrl.selectedQuarters.list, \' / \')}}</span></div><div class=\"col-lg-2 col-md-2 col-sm-2 col-xs-2\"><span class=\"title\" translate=\"ADD_RFP.PROPERTY_TYPE\"></span> <span class=\"big\" title=\"{{selectAssetsCtrl.arrayToFormattedString(selectAssetsCtrl.selectedPropertyTypes, \', \')}}\">{{selectAssetsCtrl.arrayToFormattedString(selectAssetsCtrl.selectedPropertyTypes, \', \')}}</span></div><div class=\"col-lg-2 col-md-2 col-sm-2 col-xs-2\"><span class=\"title\" translate=\"ADD_RFP.COUNTRY\"></span> <span class=\"big\" title=\"{{selectAssetsCtrl.arrayToFormattedString(selectAssetsCtrl.selectedCountries, \', \')}}\">{{selectAssetsCtrl.arrayToFormattedString(selectAssetsCtrl.selectedCountries, \', \')}}</span></div><div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3\"><span class=\"title\" translate=\"ADD_RFP.STATE\"></span> <span class=\"big\" title=\"{{selectAssetsCtrl.getSelectedStates()}}\">{{selectAssetsCtrl.getSelectedStates()}}</span></div></div></div></div><div class=\"row no-margins\" ng-show=\"selectAssetsCtrl.showFilters\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><div class=\"row no-margins\"><div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3 no-padding border-right\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><span class=\"title\" translate=\"ADD_RFP.BID_GROUP\"></span></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding fixed-height\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group\"><div class=\"icon-addon addon-md\"><input type=\"text\" class=\"form-control\" id=\"searchFilter\" translate=\"\" translate-attr-placeholder=\"ASSETS.SEARCH\" ng-model=\"selectAssetsCtrl.searchQueryFilter\" ng-model-options=\"{ debounce: { \'default\': 300, \'blur\': 0 } }\"> <label for=\"searchFilter\" class=\"fa fa-search\" rel=\"tooltip\"></label></div></div></div><perfect-scrollbar class=\"scroller\" wheel-propagation=\"true\" min-scrollbar-length=\"20\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><table class=\"table footable table-stripped toggle-arrow-tiny\" data-page-size=\"100000\" data-filter=\"#searchFilter\" data-filter-timeout=\"300\"><tbody><tr ng-repeat=\"group in selectAssetsCtrl.bidGroups\"><td><checkbox ng-model=\"group.selected\"></checkbox>{{ group.name }}</td></tr></tbody></table></div></perfect-scrollbar></div></div><div class=\"col-lg-2 col-md-2 col-sm-2 col-xs-2 no-padding border-right\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><span class=\"title\" translate=\"ADD_RFP.ROLLING_ON\"></span></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding fixed-height\"><perfect-scrollbar class=\"scroller\" wheel-propagation=\"true\" min-scrollbar-length=\"20\"><div class=\"row no-margins\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><span class=\"subtitle m-b-lg\" translate=\"ADD_RFP.QUARTER\"></span><ul class=\"quarters\"><li><checkbox ng-model=\"selectAssetsCtrl.selectedQuarters.all\"></checkbox>{{\"ADD_RFP.ALL\" | translate}}</li><li><checkbox ng-model=\"selectAssetsCtrl.selectedQuarters.quarters.q1\"></checkbox>{{\"ADD_RFP.Q1\" | translate}}</li><li><checkbox ng-model=\"selectAssetsCtrl.selectedQuarters.quarters.q2\"></checkbox>{{\"ADD_RFP.Q2\" | translate}}</li><li><checkbox ng-model=\"selectAssetsCtrl.selectedQuarters.quarters.q3\"></checkbox>{{\"ADD_RFP.Q3\" | translate}}</li><li><checkbox ng-model=\"selectAssetsCtrl.selectedQuarters.quarters.q4\"></checkbox>{{\"ADD_RFP.Q4\" | translate}}</li></ul></div></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><hr></div><div class=\"row no-margins\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><span class=\"subtitle m-b-lg\" translate=\"ADD_RFP.YEAR\"></span><ul class=\"quarters\"><li ng-repeat=\"year in selectAssetsCtrl.years\"><checkbox ng-model=\"year.selected\"></checkbox>{{year.year}}</li></ul></div></div></perfect-scrollbar></div></div><div class=\"col-lg-2 col-md-2 col-sm-2 col-xs-2 no-padding border-right\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><span class=\"title\" translate=\"ADD_RFP.PROPERTY_TYPE\"></span></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding fixed-height\"><perfect-scrollbar class=\"scroller\" wheel-propagation=\"true\" min-scrollbar-length=\"20\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><table class=\"table\"><tbody><tr><td><checkbox ng-model=\"selectAssetsCtrl.allPropertyTypesSelected\"></checkbox>{{\"ADD_RFP.ALL\" | translate}}</td></tr><tr ng-repeat=\"propertyType in selectAssetsCtrl.propertyTypes\"><td><checkbox ng-model=\"propertyType.selected\"></checkbox>{{ propertyType.name }}</td></tr></tbody></table></div></perfect-scrollbar></div></div><div class=\"col-lg-2 col-md-2 col-sm-2 col-xs-2 no-padding border-right\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><span class=\"title\" translate=\"ADD_RFP.COUNTRY\"></span></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding fixed-height\"><perfect-scrollbar class=\"scroller\" wheel-propagation=\"true\" min-scrollbar-length=\"20\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><table class=\"table\"><tbody><tr><td><checkbox ng-model=\"selectAssetsCtrl.allCountriesSelected\"></checkbox>{{\"ADD_RFP.ALL\" | translate}}</td></tr><tr ng-repeat=\"country in selectAssetsCtrl.countries\"><td><checkbox ng-model=\"country.selected\"></checkbox>{{ country.name }}</td></tr></tbody></table></div></perfect-scrollbar></div></div><div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3 no-padding\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><span class=\"title\" translate=\"ADD_RFP.STATES\"></span></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding fixed-height\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" ng-show=\"selectAssetsCtrl.selectedCountries.length > 0\"><div class=\"form-group\"><div class=\"icon-addon addon-md\"><input type=\"text\" class=\"form-control\" id=\"searchStates\" translate=\"\" translate-attr-placeholder=\"ASSETS.SEARCH\" ng-model=\"selectAssetsCtrl.searchQueryStates\" ng-model-options=\"{ debounce: { \'default\': 300, \'blur\': 0 } }\"> <label for=\"searchStates\" class=\"fa fa-search\" rel=\"tooltip\"></label></div></div></div><perfect-scrollbar class=\"scroller\" wheel-propagation=\"true\" min-scrollbar-length=\"20\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" ng-show=\"selectAssetsCtrl.selectedCountries.length > 0\"><table class=\"table footable table-stripped toggle-arrow-tiny\" data-page-size=\"100000\" data-filter=\"#searchStates\" data-filter-timeout=\"300\"><tbody><tr><td class=\"countries\"><checkbox ng-model=\"selectAssetsCtrl.allStatesSelected\"></checkbox>{{\"ADD_RFP.ALL\" | translate}}</td></tr></tbody><tbody ng-repeat=\"country in selectAssetsCtrl.selectedCountries\"><tr><td><span class=\"title no-margin-bottom m-t-lg\">{{country}}</span></td></tr><tr ng-repeat=\"state in selectAssetsCtrl.statesByCountry[country]\"><td><checkbox ng-model=\"state.selected\"></checkbox>{{ state.name }}</td></tr></tbody></table></div></perfect-scrollbar></div></div></div></div></div></div></div></div></div><div class=\"row filter\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 text-right m-b-lg\" ng-hide=\"selectAssetsCtrl.showFilters\"><span class=\"results m-r-lg\">{{selectAssetsCtrl.assets.length}} {{\'ADD_RFP.MATCHING_RESULTS\'| translate}}</span> <button class=\"btn btn-w-m btn-normal no-margin-right\" type=\"button\" translate=\"ADD_RFP.CHANGE\" ng-click=\"selectAssetsCtrl.changeFilter()\"></button></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 text-right m-b-lg\" ng-show=\"selectAssetsCtrl.showFilters\"><span ng-if=\"selectAssetsCtrl.errorMessage\" class=\"has-error m-r-lg\">{{selectAssetsCtrl.errorMessage | translate}}</span> <button class=\"btn btn-w-m btn-back\" type=\"button\" translate=\"ADD_RFP.CLEAR_FILTERS\" ng-click=\"selectAssetsCtrl.clearFilters()\"></button> <button class=\"btn btn-w-m btn-normal m-l-sm\" type=\"submit\" translate=\"ADD_RFP.SEARCH\" ng-click=\"selectAssetsCtrl.search()\"></button></div></div><div class=\"row checkbox-custom assets\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 fixed-height\" ng-show=\"selectAssetsCtrl.assets.length == 0 && !selectAssetsCtrl.searched\"><div class=\"empty-assets\"><i class=\"icon icon-ic-magnifier\"></i><br>{{\"ADD_RFP.PLEASE_SEARCH\"| translate}}</div></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" ng-show=\"selectAssetsCtrl.searched\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><div class=\"col-lg-7 col-sm-7 col-md-7 col-xs-7 no-padding\"><h4>{{\"ADD_RFP.ASSETS\" | translate}}&nbsp;<span>({{selectAssetsCtrl.assetsCount}})</span></h4></div><div class=\"col-lg-5 col-sm-5 col-md-5 col-xs-5 no-padding\"><div class=\"form-group no-margins\"><div class=\"icon-addon addon-md\"><input type=\"text\" class=\"form-control\" id=\"search\" translate=\"\" translate-attr-placeholder=\"USERS.SEARCH\" ng-change=\"selectAssetsCtrl.searchAssets()\" ng-model=\"selectAssetsCtrl.searchQuery\" ng-model-options=\"{ debounce: { \'default\': 500, \'blur\': 0 } }\"> <label for=\"search\" class=\"fa fa-search\" rel=\"tooltip\"></label></div></div></div></div><div class=\"row no-margins fixed-header\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><ul><li class=\"hidden-xs hidden-sm hidden-md hidden-mdl\"><a translate=\"ADD_RFP.ID\" ng-click=\"selectAssetsCtrl.sorting(selectAssetsCtrl.selectAssetsSort[0], \'selectAssetsSelectedSort\')\" ng-class=\"{\'asc\': selectAssetsCtrl.selectAssetsSort[0].flag, \'desc\': !selectAssetsCtrl.selectAssetsSort[0].flag, \'not-selected\': !selectAssetsCtrl.selectAssetsSort[0].selected}\"></a></li><li><a translate=\"ADD_RFP.NAME\" ng-click=\"selectAssetsCtrl.sorting(selectAssetsCtrl.selectAssetsSort[1], \'selectAssetsSelectedSort\')\" ng-class=\"{\'asc\': selectAssetsCtrl.selectAssetsSort[1].flag, \'desc\': !selectAssetsCtrl.selectAssetsSort[1].flag, \'not-selected\': !selectAssetsCtrl.selectAssetsSort[1].selected}\"></a></li><li><a translate=\"ADD_RFP.LOCATION\" ng-click=\"selectAssetsCtrl.sorting(selectAssetsCtrl.selectAssetsSort[2], \'selectAssetsSelectedSort\')\" ng-class=\"{\'asc\': selectAssetsCtrl.selectAssetsSort[2].flag, \'desc\': !selectAssetsCtrl.selectAssetsSort[2].flag, \'not-selected\': !selectAssetsCtrl.selectAssetsSort[2].selected}\"></a></li><li><a translate=\"ADD_RFP.TYPE\" ng-click=\"selectAssetsCtrl.sorting(selectAssetsCtrl.selectAssetsSort[3], \'selectAssetsSelectedSort\')\" ng-class=\"{\'asc\': selectAssetsCtrl.selectAssetsSort[3].flag, \'desc\': !selectAssetsCtrl.selectAssetsSort[3].flag, \'not-selected\': !selectAssetsCtrl.selectAssetsSort[3].selected}\"></a></li><li><a translate=\"ADD_RFP.SUBTYPE\" ng-click=\"selectAssetsCtrl.sorting(selectAssetsCtrl.selectAssetsSort[4], \'selectAssetsSelectedSort\')\" ng-class=\"{\'asc\': selectAssetsCtrl.selectAssetsSort[4].flag, \'desc\': !selectAssetsCtrl.selectAssetsSort[4].flag, \'not-selected\': !selectAssetsCtrl.selectAssetsSort[4].selected}\"></a></li><li class=\"hidden-xs hidden-sm hidden-md hidden-mdl\"><a translate=\"ADD_RFP.GMV\" ng-click=\"selectAssetsCtrl.sorting(selectAssetsCtrl.selectAssetsSort[5], \'selectAssetsSelectedSort\')\" ng-class=\"{\'asc\': selectAssetsCtrl.selectAssetsSort[5].flag, \'desc\': !selectAssetsCtrl.selectAssetsSort[5].flag, \'not-selected\': !selectAssetsCtrl.selectAssetsSort[5].selected}\"></a></li><li class=\"hidden-xs hidden-sm hidden-md hidden-mdl\"><a translate=\"ADD_RFP.CYCLE\" ng-click=\"selectAssetsCtrl.sorting(selectAssetsCtrl.selectAssetsSort[6], \'selectAssetsSelectedSort\')\" ng-class=\"{\'asc\': selectAssetsCtrl.selectAssetsSort[6].flag, \'desc\': !selectAssetsCtrl.selectAssetsSort[6].flag, \'not-selected\': !selectAssetsCtrl.selectAssetsSort[6].selected}\"></a></li><li><a translate=\"ADD_RFP.ROLLING\" ng-click=\"selectAssetsCtrl.sorting(selectAssetsCtrl.selectAssetsSort[7], \'selectAssetsSelectedSort\')\" ng-class=\"{\'asc\': selectAssetsCtrl.selectAssetsSort[7].flag, \'desc\': !selectAssetsCtrl.selectAssetsSort[7].flag, \'not-selected\': !selectAssetsCtrl.selectAssetsSort[7].selected}\"></a></li><li class=\"text-center\"><a translate=\"ADD_RFP.SELECT_ALL\" ng-click=\"selectAssetsCtrl.selectAllAssets()\"></a></li></ul></div></div><div class=\"ibox-content paginator-loader no-padding\"><div class=\"sk-spinner sk-spinner-circle\"><div class=\"sk-circle1 sk-circle\"></div><div class=\"sk-circle2 sk-circle\"></div><div class=\"sk-circle3 sk-circle\"></div><div class=\"sk-circle4 sk-circle\"></div><div class=\"sk-circle5 sk-circle\"></div><div class=\"sk-circle6 sk-circle\"></div><div class=\"sk-circle7 sk-circle\"></div><div class=\"sk-circle8 sk-circle\"></div><div class=\"sk-circle9 sk-circle\"></div><div class=\"sk-circle10 sk-circle\"></div><div class=\"sk-circle11 sk-circle\"></div><div class=\"sk-circle12 sk-circle\"></div></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding fixed-height\"><perfect-scrollbar class=\"scroller\" wheel-propagation=\"true\" min-scrollbar-length=\"20\"><table class=\"table footable table-stripped toggle-arrow-tiny\" data-page-size=\"100000\"><tbody><tr ng-repeat=\"asset in selectAssetsCtrl.assets | orderBy: selectAssetsCtrl.selectAssetsSelectedSort.sort\"><td class=\"hidden-xs hidden-sm hidden-md hidden-mdl\">{{ asset.propertyRef || \"N/A\" }}</td><td><a ui-sref=\"app.asset.assetDetails({assetId: asset.id})\">{{ asset.name || \"N/A\" }}</a></td><td>{{ asset.address.city || \"N/A\" }}, {{ asset.address.state || \"N/A\" }}</td><td>{{ asset.type || \"N/A\" }}</td><td>{{ asset.subType }}</td><td class=\"hidden-xs hidden-sm hidden-md hidden-mdl\">{{asset.valuation.appraisalFinal | currency:undefined:0}}</td><td class=\"hidden-xs hidden-sm hidden-md hidden-mdl\">{{ selectAssetsCtrl.frequenciesByValues[asset.valuationFrequency] || \'N/A\'}}</td><td>{{ asset.rollOverDate | date:\'MMM dd, yyyy\'}}</td><td class=\"text-center\"><checkbox ng-model=\"asset.selected\" ng-change=\"selectAssetsCtrl.assetSelectedToggle(asset)\"></checkbox></td></tr></tbody></table></perfect-scrollbar></div></div></div></div></div><div class=\"row bottom-buttons\" ng-show=\"selectAssetsCtrl.assets.length > 0\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6 text-left\"><uib-pagination total-items=\"selectAssetsCtrl.assetsCount\" ng-model=\"selectAssetsCtrl.currentPage\" class=\"pagination-sm less-margin-top\" max-size=\"selectAssetsCtrl.maxPaginationSize\" items-per-page=\"selectAssetsCtrl.perPage\" ng-change=\"selectAssetsCtrl.changePage()\" boundary-link-numbers=\"true\" rotate=\"false\"></uib-pagination></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right\"><button class=\"btn btn-w-m btn-back m-b-lg\" type=\"button\" translate=\"ADD_RFP.CANCEL\" ui-sref=\"app.bidEngagement.bidEngagementList\"></button> <button class=\"btn btn-w-m btn-normal m-l-sm m-b-lg\" type=\"submit\" translate=\"ADD_RFP.NEXT\" ng-click=\"selectAssetsCtrl.next()\" ng-disabled=\"selectAssetsCtrl.canContinue()\"></button></div></div>");
$templateCache.put("app/states/bid-engagement/add-rfp/select-appraisers/select-appraisers.html","<div class=\"row preview\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"ibox float-e-margins\" ng-click=\"selectAppraisersCtrl.previewOpened = !selectAppraisersCtrl.previewOpened\"><div class=\"ibox-content no-title\"><div class=\"row no-margins\"><div class=\"preview-container\"><span class=\"title\" translate=\"ADD_RFP.BID_GROUP\"></span><div ng-class=\"{\'expanded\': selectAppraisersCtrl.previewOpened, \'collapsed\': !selectAppraisersCtrl.previewOpened}\"><span class=\"big\" ng-repeat=\"bidGroupName in selectAppraisersCtrl.searchCriteria.bidGroups\">{{bidGroupName}}</span></div></div><div class=\"preview-container\"><span class=\"title\" translate=\"ADD_RFP.LOCATION\"></span><div ng-class=\"{\'expanded\': selectAppraisersCtrl.previewOpened, \'collapsed\': !selectAppraisersCtrl.previewOpened}\"><span class=\"big\" ng-repeat=\"state in selectAppraisersCtrl.searchCriteria.statesArray\">{{state}}</span></div></div><div class=\"preview-container\"><span class=\"title\" translate=\"ADD_RFP.PROPERTY_TYPE\"></span><div ng-class=\"{\'expanded\': selectAppraisersCtrl.previewOpened, \'collapsed\': !selectAppraisersCtrl.previewOpened}\"><span class=\"big\" ng-repeat=\"type in selectAppraisersCtrl.searchCriteria.typesArray\">{{type}}</span></div></div><div class=\"preview-container assets-included\"><span class=\"title\" translate=\"ADD_RFP.ASSETS_INCLUDED\"></span><div class=\"row-list\"><span class=\"big\">{{selectAppraisersCtrl.assets.length}}</span></div></div><div class=\"preview-container btn-arrow-container text-right\"><a class=\"btn btn-summary btn-arrow\"><span class=\"fa chevron\" ng-class=\"{\'fa-chevron-up\': selectAppraisersCtrl.previewOpened, \'fa-chevron-down\': !selectAppraisersCtrl.previewOpened}\"></span></a></div></div></div></div></div></div><div class=\"row appraisers\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6 appraisers-picker\"><div class=\"ibox float-e-margins\" ng-class=\"{\'hover\':selectAppraisersCtrl.isHoverList}\"><div class=\"dropzone\" ng-hide=\"selectAppraisersCtrl.hideList\" drop=\"selectAppraisersCtrl.moveToList\"></div><div class=\"ibox-title\"><div class=\"row no-margins\"><div class=\"col-lg-7 col-md-7 col-sm-7 col-xs-7 no-padding\"><h4 class=\"no-margins\">{{\"ADD_RFP.APPRAISERS\" | translate}} <span ng-hide=\"!selectAppraisersCtrl.appraisers.length\">({{selectAppraisersCtrl.appraisers.length}})</span></h4><a ng-click=\"selectAppraisersCtrl.addAll()\" translate=\"ADD_RFP.SELECT_ALL\"></a></div><div class=\"col-lg-5 col-md-5 col-sm-5 col-xs-5 no-padding\"><div class=\"form-group no-margins\"><div class=\"icon-addon addon-md\"><input type=\"text\" class=\"form-control\" id=\"search\" translate=\"\" translate-attr-placeholder=\"ASSETS.SEARCH\" ng-change=\"selectAppraisersCtrl.searchAppraisers()\" ng-model=\"selectAppraisersCtrl.searchQuery\" ng-model-options=\"{ debounce: { \'default\': 300, \'blur\': 0 } }\"> <label for=\"search\" class=\"fa fa-search\" rel=\"tooltip\"></label></div></div></div></div></div><div class=\"row no-margins fixed-header\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><ul><li><a translate=\"ADD_RFP.NAME\" ng-click=\"selectAppraisersCtrl.shiftAppraiserSort(selectAppraisersCtrl.appraisersSort[0], \'appraisersSelectedSort\')\" ng-class=\"{\'asc\': selectAppraisersCtrl.appraisersSort[0].flag, \'desc\': !selectAppraisersCtrl.appraisersSort[0].flag, \'not-selected\': !selectAppraisersCtrl.appraisersSort[0].selected}\"></a></li><li><a translate=\"ADD_RFP.COMPANY\" ng-click=\"selectAppraisersCtrl.shiftAppraiserSort(selectAppraisersCtrl.appraisersSort[1], \'appraisersSelectedSort\')\" ng-class=\"{\'asc\': selectAppraisersCtrl.appraisersSort[1].flag, \'desc\': !selectAppraisersCtrl.appraisersSort[1].flag, \'not-selected\': !selectAppraisersCtrl.appraisersSort[1].selected}\"></a></li><li><a translate=\"ADD_RFP.STATE\" ng-click=\"selectAppraisersCtrl.shiftAppraiserSort(selectAppraisersCtrl.appraisersSort[2], \'appraisersSelectedSort\')\" ng-class=\"{\'asc\': selectAppraisersCtrl.appraisersSort[2].flag, \'desc\': !selectAppraisersCtrl.appraisersSort[2].flag, \'not-selected\': !selectAppraisersCtrl.appraisersSort[2].selected}\"></a></li><li><a translate=\"ADD_RFP.SPECIALTIES\" ng-click=\"selectAppraisersCtrl.shiftAppraiserSort(selectAppraisersCtrl.appraisersSort[3], \'appraisersSelectedSort\')\" ng-class=\"{\'asc\': selectAppraisersCtrl.appraisersSort[3].flag, \'desc\': !selectAppraisersCtrl.appraisersSort[3].flag, \'not-selected\': !selectAppraisersCtrl.appraisersSort[3].selected}\"></a></li><li><a translate=\"ADD_RFP.MATCHING\" ng-click=\"selectAppraisersCtrl.shiftAppraiserSort(selectAppraisersCtrl.appraisersSort[4], \'appraisersSelectedSort\')\" ng-class=\"{\'asc\': selectAppraisersCtrl.appraisersSort[4].flag, \'desc\': !selectAppraisersCtrl.appraisersSort[4].flag, \'not-selected\': !selectAppraisersCtrl.appraisersSort[4].selected}\"></a></li></ul></div></div><div class=\"ibox-content no-padding\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding fixed-height\"><perfect-scrollbar class=\"scroller\" wheel-propagation=\"false\" min-scrollbar-length=\"20\"><table class=\"table footable table-stripped toggle-arrow-tiny\" data-page-size=\"100000\" data-filter=\"#search\" data-filter-timeout=\"300\"><tbody><tr ng-repeat=\"appraiser in selectAppraisersCtrl.appraisers | orderBy: selectAppraisersCtrl.appraisersSelectedSort.tag: false: selectAppraisersCtrl.orderComparator(selectAppraisersCtrl.appraisersSelectedSort.tag, selectAppraisersCtrl.appraisersSelectedSort.flag, selectAppraisersCtrl.appraisers)\" ng-class=\"{\'highlight\':appraiser.displaying}\" drag=\"\" ng-model=\"appraiser\" start=\"selectAppraisersCtrl.showDropZoneApp\"><td><a ui-sref=\"app.manage.users.editUser({companyId: appraiser.companyId, id: appraiser.user.id})\">{{appraiser.user.name}}</a></td><td>{{appraiser.companyName}}</td><td title=\"{{appraiser.user.states || \'N/A\'}}\">{{appraiser.user.states || \"N/A\"}}</td><td title=\"{{appraiser.user.specialties}}\">{{appraiser.user.specialties}}</td><td><span class=\"glyphicon glyphicon-ok\" ng-class=\"{\'matching\':appraiser.matching}\"></span> <a class=\"btn-add m-l-sm\" ng-click=\"selectAppraisersCtrl.addAppraiser(appraiser)\"></a></td></tr></tbody></table></perfect-scrollbar></div></div></div></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6 appraiser-group\"><div class=\"ibox float-e-margins empty\" ng-hide=\"selectAppraisersCtrl.appraisersSelected.length > 0\" ng-class=\"{\'hover\':selectAppraisersCtrl.isHoverApp}\"><div class=\"dropzone\" ng-hide=\"selectAppraisersCtrl.hideApp\" drop=\"selectAppraisersCtrl.moveToApp\"></div><div class=\"ibox-content no-padding\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 fixed-height-empty\"><div class=\"empty-message\" translate=\"ADD_RFP.PLEASE_ADD\"></div></div></div></div><div class=\"ibox float-e-margins\" ng-show=\"selectAppraisersCtrl.appraisersSelected.length > 0\" ng-class=\"{\'hover\':selectAppraisersCtrl.isHoverApp}\"><div class=\"dropzone\" ng-hide=\"selectAppraisersCtrl.hideApp\" drop=\"selectAppraisersCtrl.moveToApp\"></div><div class=\"ibox-title\"><div class=\"row no-margins\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><h4 class=\"no-margins\">{{\"ADD_RFP.APPRAISERS_SELECTED\" | translate}} ({{selectAppraisersCtrl.appraisersSelected.length}})</h4><a ng-click=\"selectAppraisersCtrl.removeAll()\" translate=\"ADD_RFP.REMOVE_ALL\"></a></div></div></div><div class=\"row no-margins fixed-header\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><ul><li><a translate=\"ADD_RFP.NAME\" ng-click=\"selectAppraisersCtrl.shiftAppraiserAddedSort(selectAppraisersCtrl.appraisersAddedSort[0], \'appraisersAddedSelectedSort\')\" ng-class=\"{\'asc\': selectAppraisersCtrl.appraisersAddedSort[0].flag, \'desc\': !selectAppraisersCtrl.appraisersAddedSort[0].flag, \'not-selected\': !selectAppraisersCtrl.appraisersAddedSort[0].selected}\"></a></li><li><a translate=\"ADD_RFP.COMPANY\" ng-click=\"selectAppraisersCtrl.shiftAppraiserAddedSort(selectAppraisersCtrl.appraisersAddedSort[1], \'appraisersAddedSelectedSort\')\" ng-class=\"{\'asc\': selectAppraisersCtrl.appraisersAddedSort[1].flag, \'desc\': !selectAppraisersCtrl.appraisersAddedSort[1].flag, \'not-selected\': !selectAppraisersCtrl.appraisersAddedSort[1].selected}\"></a></li><li><a translate=\"ADD_RFP.STATE\" ng-click=\"selectAppraisersCtrl.shiftAppraiserAddedSort(selectAppraisersCtrl.appraisersAddedSort[2], \'appraisersAddedSelectedSort\')\" ng-class=\"{\'asc\': selectAppraisersCtrl.appraisersAddedSort[2].flag, \'desc\': !selectAppraisersCtrl.appraisersAddedSort[2].flag, \'not-selected\': !selectAppraisersCtrl.appraisersAddedSort[2].selected}\"></a></li><li><a translate=\"ADD_RFP.SPECIALTIES\" ng-click=\"selectAppraisersCtrl.shiftAppraiserAddedSort(selectAppraisersCtrl.appraisersAddedSort[3], \'appraisersAddedSelectedSort\')\" ng-class=\"{\'asc\': selectAppraisersCtrl.appraisersAddedSort[3].flag, \'desc\': !selectAppraisersCtrl.appraisersAddedSort[3].flag, \'not-selected\': !selectAppraisersCtrl.appraisersAddedSort[3].selected}\"></a></li><li><a translate=\"ADD_RFP.MATCHING\" ng-click=\"selectAppraisersCtrl.shiftAppraiserAddedSort(selectAppraisersCtrl.appraisersAddedSort[4], \'appraisersAddedSelectedSort\')\" ng-class=\"{\'asc\': selectAppraisersCtrl.appraisersAddedSort[4].flag, \'desc\': !selectAppraisersCtrl.appraisersAddedSort[4].flag, \'not-selected\': !selectAppraisersCtrl.appraisersAddedSort[4].selected}\"></a></li></ul></div></div><div class=\"ibox-content no-padding\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding fixed-height\"><perfect-scrollbar class=\"scroller\" wheel-propagation=\"false\" min-scrollbar-length=\"20\"><div class=\"row no-margins\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><table class=\"table footable table-stripped toggle-arrow-tiny\" data-page-size=\"100000\"><tbody><tr ng-repeat=\"appraiser in selectAppraisersCtrl.appraisersSelected | orderBy: selectAppraisersCtrl.appraisersAddedSelectedSort.tag: false: selectAppraisersCtrl.orderComparator(selectAppraisersCtrl.appraisersAddedSelectedSort.tag, selectAppraisersCtrl.appraisersAddedSelectedSort.flag, selectAppraisersCtrl.appraisersSelected)\" ng-class=\"{\'highlight\':appraiser.displaying}\" drag=\"\" ng-model=\"appraiser\" start=\"selectAppraisersCtrl.showDropZoneList\"><td><a ui-sref=\"app.manage.users.editUser({companyId: appraiser.companyId, id: appraiser.user.id})\">{{appraiser.user.name}}</a></td><td>{{appraiser.companyName}}</td><td title=\"{{appraiser.user.states || \'N/A\'}}\">{{appraiser.user.states || \"N/A\"}}</td><td title=\"{{appraiser.user.specialties}}\">{{appraiser.user.specialties}}</td><td><span class=\"glyphicon glyphicon-ok\" ng-class=\"{\'matching\':appraiser.matching}\"></span> <a class=\"btn-remove m-l-sm\" ng-click=\"selectAppraisersCtrl.removeAppraiser(appraiser, $index)\"></a></td></tr></tbody></table></div></div></perfect-scrollbar></div></div></div></div></div><div class=\"row bottom-buttons\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 text-right\"><button class=\"btn btn-w-m btn-back m-b-lg\" type=\"button\" translate=\"ADD_RFP.BACK\" ui-sref=\"app.bidEngagement.addRfp.selectAssets(addRfpCtrl.params)\"></button> <button class=\"btn btn-w-m btn-normal m-l-sm m-b-lg\" type=\"submit\" translate=\"ADD_RFP.NEXT\" ng-click=\"selectAppraisersCtrl.next()\" ng-disabled=\"selectAppraisersCtrl.appraisersSelected.length == 0\"></button></div></div>");
$templateCache.put("app/states/manage/appraisers/edit-appraiser/edit-appraiser.html","<header-section breadcrumb-title=\"editAppraiserCtrl.title\" breadcrumbs=\"editAppraiserCtrl.breadcrumbs\"></header-section><section><div class=\"wrapper wrapper-content\" nvc-full-page=\"\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h4 translate=\"NEW_APPRAISAL_FIRM.SUBTITLE\"></h4></div><div class=\"ibox-content\"><perfect-scrollbar class=\"scroller\" suppress-scroll-x=\"true\" wheel-propagation=\"true\" wheel-speed=\"1\" min-scrollbar-length=\"20\"><form class=\"\" role=\"form\" name=\"editAppraiserCtrl.editAppraiser\" ng-submit=\"editAppraiserCtrl.editAppraiser.$valid && editAppraiserCtrl.updateAppraiser(editAppraiserCtrl.appraiserCompany)\" confirm-leave=\"\" novalidate=\"\"><div class=\"row no-button\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group\"><label translate=\"NEW_CLIENT.NAME\"></label> <input class=\"form-control\" ng-model=\"editAppraiserCtrl.appraiserCompany.name\" type=\"text\" placeholder=\"{{NEW_CLIENT.ENTER_CLIENT|translate}}\" required=\"\"></div></div></div><div class=\"hr-line-dashed\"></div><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group\"><label translate=\"NEW_CLIENT.ADDRESS\"></label> <input class=\"form-control\" ng-model=\"editAppraiserCtrl.appraiserCompany.address.address\" type=\"text\" translate=\"\" translate-attr-placeholder=\"NEW_CLIENT.ENTER_ADDRESS\" required=\"\"></div></div></div><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group text-center\"><button class=\"btn btn-normal btn-w-m m-t-xl\" type=\"submit\" translate=\"COMMONS.SAVE\"></button></div></div></div></form></perfect-scrollbar></div></div></div></div></div></section>");
$templateCache.put("app/states/manage/appraisers/new-appraiser/new-appraiser.html","<header-section breadcrumb-title=\"addAppraiser.title\" breadcrumbs=\"addAppraiser.breadcrumbs\"></header-section><section><div class=\"wrapper wrapper-content\" nvc-full-page=\"\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h4 translate=\"NEW_APPRAISAL_FIRM.SUBTITLE\"></h4></div><div class=\"ibox-content\"><perfect-scrollbar class=\"scroller\" suppress-scroll-x=\"true\" wheel-propagation=\"true\" wheel-speed=\"1\" min-scrollbar-length=\"20\"><form class=\"\" role=\"form\" name=\"addAppraiser.addNewAppraiser\" ng-submit=\"addAppraiser.addNewAppraiser.$valid && addAppraiser.createAppraiser()\" confirm-leave=\"\" novalidate=\"\"><div class=\"row no-button\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group\"><label translate=\"NEW_APPRAISAL_FIRM.NAME\"></label> <input class=\"form-control\" ng-model=\"addAppraiser.appraiser.name\" type=\"text\" translate=\"\" translate-attr-placeholder=\"NEW_APPRAISAL_FIRM.ENTER_APPRAISER\" required=\"\"></div></div></div><div class=\"hr-line-dashed\"></div><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group\"><label translate=\"NEW_APPRAISAL_FIRM.ADDRESS\"></label> <input class=\"form-control\" ng-model=\"addAppraiser.appraiser.address\" type=\"text\" translate=\"\" translate-attr-placeholder=\"NEW_APPRAISAL_FIRM.ENTER_ADDRESS\" required=\"\"></div></div></div><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group text-center\"><button class=\"btn btn-normal btn-w-m m-t-xl\" ng-click=\"addAppraiser.open()\" type=\"submit\" translate=\"COMMONS.SAVE\"></button></div></div></div></form></perfect-scrollbar></div></div></div></div></div></section>");
$templateCache.put("app/states/manage/auditors/edit-auditor/edit-auditor.html","<header-section breadcrumb-title=\"editAuditorCtrl.title\" breadcrumbs=\"editAuditorCtrl.breadcrumbs\"></header-section><section><div class=\"wrapper wrapper-content\" nvc-full-page=\"\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h4 translate=\"NEW_AUDITOR.SUBTITLE\"></h4></div><div class=\"ibox-content\"><perfect-scrollbar class=\"scroller\" suppress-scroll-x=\"true\" wheel-propagation=\"true\" wheel-speed=\"1\" min-scrollbar-length=\"20\"><form class=\"\" role=\"form\" name=\"editAuditorCtrl.editAuditor\" ng-submit=\"editAuditorCtrl.editAuditor.$valid && editAuditorCtrl.updateAuditor(editAuditorCtrl.auditorCompany)\" confirm-leave=\"\" novalidate=\"\"><div class=\"row no-button\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group\"><label translate=\"NEW_CLIENT.NAME\"></label> <input class=\"form-control\" ng-model=\"editAuditorCtrl.auditorCompany.name\" type=\"text\" placeholder=\"{{NEW_CLIENT.ENTER_CLIENT|translate}}\" required=\"\"></div></div></div><div class=\"hr-line-dashed\"></div><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group\"><label translate=\"NEW_CLIENT.ADDRESS\"></label> <input class=\"form-control\" ng-model=\"editAuditorCtrl.auditorCompany.address.address\" type=\"text\" translate=\"\" translate-attr-placeholder=\"NEW_CLIENT.ENTER_ADDRESS\" required=\"\"></div></div></div><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group text-center\"><button class=\"btn btn-normal btn-w-m m-t-xl\" type=\"submit\" translate=\"COMMONS.SAVE\"></button></div></div></div></form></perfect-scrollbar></div></div></div></div></div></section>");
$templateCache.put("app/states/manage/auditors/new-auditor/new-auditor.html","<header-section breadcrumb-title=\"newAuditorCtrl.title\" breadcrumbs=\"newAuditorCtrl.breadcrumbs\"></header-section><section><div class=\"wrapper wrapper-content\" nvc-full-page=\"\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><h4 translate=\"NEW_AUDITOR.SUBTITLE\"></h4></div></div><div class=\"ibox-content\"><perfect-scrollbar class=\"scroller\" suppress-scroll-x=\"true\" wheel-propagation=\"true\" wheel-speed=\"1\" min-scrollbar-length=\"20\"><form class=\"\" role=\"form\" name=\"newAuditorCtrl.newAuditorForm\" ng-submit=\"newAuditorCtrl.newAuditorForm.$valid && newAuditorCtrl.createAuditor(newAuditorCtrl.auditor)\" confirm-leave=\"\" novalidate=\"\"><div class=\"row no-button\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group\"><label translate=\"NEW_AUDITOR.NAME\"></label> <input class=\"form-control\" ng-model=\"newAuditorCtrl.auditor.name\" type=\"text\" translate=\"\" translate-attr-placeholder=\"NEW_AUDITOR.ENTER_AUDITOR\" required=\"\"></div></div></div><div class=\"hr-line-dashed\"></div><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group\"><label translate=\"NEW_AUDITOR.ADDRESS\"></label> <input class=\"form-control\" ng-model=\"newAuditorCtrl.auditor.address\" type=\"text\" translate=\"\" translate-attr-placeholder=\"NEW_AUDITOR.ENTER_ADDRESS\" required=\"\"></div></div></div><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group text-center\"><button class=\"btn btn-normal btn-w-m m-t-xl\" type=\"submit\" translate=\"COMMONS.SAVE\"></button></div></div></div></form></perfect-scrollbar></div></div></div></div></div></section>");
$templateCache.put("app/states/manage/clients/edit-client/edit-client.html","<header-section breadcrumb-title=\"editClientCtrl.title\" breadcrumbs=\"editClientCtrl.breadcrumbs\"></header-section><section><div class=\"wrapper wrapper-content\" nvc-full-page=\"\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><h4 translate=\"NEW_CLIENT.SUBTITLE\"></h4></div></div><div class=\"ibox-content\"><perfect-scrollbar class=\"scroller\" suppress-scroll-x=\"true\" wheel-propagation=\"true\" wheel-speed=\"1\" min-scrollbar-length=\"20\"><form class=\"\" role=\"form\" name=\"editClientCtrl.editClient\" ng-submit=\"editClientCtrl.editClient.$valid && editClientCtrl.updateClient(editClientCtrl.clientCompany)\" confirm-leave=\"\" novalidate=\"\"><div class=\"row no-button\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group\"><label translate=\"NEW_CLIENT.NAME\"></label> <input class=\"form-control\" ng-model=\"editClientCtrl.clientCompany.name\" type=\"text\" translate=\"\" translate-attr-placeholder=\"NEW_CLIENT.ENTER_CLIENT\" required=\"\"></div></div></div><div class=\"hr-line-dashed\"></div><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group\"><label translate=\"NEW_CLIENT.ADDRESS\"></label> <input class=\"form-control\" ng-model=\"editClientCtrl.clientCompany.address.address\" type=\"text\" translate=\"\" translate-attr-placeholder=\"NEW_CLIENT.ENTER_ADDRESS\" required=\"\"></div></div></div><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group text-center\"><button class=\"btn btn-normal btn-w-m m-t-xl\" type=\"submit\" translate=\"COMMONS.SAVE\"></button></div></div></div></form></perfect-scrollbar></div></div></div></div></div></section>");
$templateCache.put("app/states/manage/clients/new-client/new-client.html","<header-section breadcrumb-title=\"addClient.title\" breadcrumbs=\"addClient.breadcrumbs\"></header-section><section><div class=\"wrapper wrapper-content\" nvc-full-page=\"\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><h4 translate=\"NEW_CLIENT.SUBTITLE\"></h4></div></div><div class=\"ibox-content\"><perfect-scrollbar class=\"scroller\" suppress-scroll-x=\"true\" wheel-propagation=\"true\" wheel-speed=\"1\" min-scrollbar-length=\"20\"><form class=\"\" role=\"form\" name=\"addClient.addNewClient\" ng-submit=\"addClient.addNewClient.$valid && addClient.createClient()\" confirm-leave=\"\" novalidate=\"\"><div class=\"row no-button\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group\"><label translate=\"NEW_CLIENT.NAME\"></label> <input class=\"form-control\" ng-model=\"addClient.client.name\" type=\"text\" translate=\"\" translate-attr-placeholder=\"NEW_CLIENT.ENTER_CLIENT\" ng-required=\"true\"></div></div></div><div class=\"hr-line-dashed\"></div><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group\"><label translate=\"NEW_CLIENT.ADDRESS\"></label> <input class=\"form-control\" ng-model=\"addClient.client.address\" type=\"text\" translate=\"\" translate-attr-placeholder=\"NEW_CLIENT.ENTER_ADDRESS\" required=\"\"></div></div></div><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group text-center\"><button class=\"btn btn-normal btn-w-m m-t-xl\" type=\"submit\" translate=\"COMMONS.SAVE\"></button></div></div></div></form></perfect-scrollbar></div></div></div></div></div></section>");
$templateCache.put("app/states/manage/reviewers/edit-reviewer/edit-reviewer.html","<header-section breadcrumb-title=\"editReviewerCtrl.title\" breadcrumbs=\"editReviewerCtrl.breadcrumbs\"></header-section><section><div class=\"wrapper wrapper-content\" nvc-full-page=\"\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><h4 translate=\"NEW_REVIEWER.SUBTITLE\"></h4></div></div><div class=\"ibox-content\"><perfect-scrollbar class=\"scroller\" suppress-scroll-x=\"true\" wheel-propagation=\"true\" wheel-speed=\"1\" min-scrollbar-length=\"20\"><form class=\"\" role=\"form\" name=\"editReviewerCtrl.editReviewer\" ng-submit=\"editReviewerCtrl.editReviewer.$valid && editReviewerCtrl.updateReviewer(editReviewerCtrl.reviewerCompany)\" confirm-leave=\"\" novalidate=\"\"><div class=\"row no-button\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group\"><label translate=\"NEW_REVIEWER.NAME\"></label> <input class=\"form-control\" ng-model=\"editReviewerCtrl.reviewerCompany.name\" type=\"text\" translate=\"\" translate-attr-placeholder=\"NEW_REVIEWER.ENTER_REVIEWER\" required=\"\"></div></div></div><div class=\"hr-line-dashed\"></div><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group\"><label translate=\"NEW_REVIEWER.ADDRESS\"></label> <input class=\"form-control\" ng-model=\"editReviewerCtrl.reviewerCompany.address.address\" type=\"text\" translate=\"\" translate-attr-placeholder=\"NEW_REVIEWER.ENTER_ADDRESS\" required=\"\"></div></div></div><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group text-center\"><button class=\"btn btn-normal btn-w-m m-t-xl\" type=\"submit\" translate=\"COMMONS.SAVE\"></button></div></div></div></form></perfect-scrollbar></div></div></div></div></div></section>");
$templateCache.put("app/states/manage/reviewers/new-reviewer/new-reviewer.html","<header-section breadcrumb-title=\"addReviewerCtrl.title\" breadcrumbs=\"addReviewerCtrl.breadcrumbs\"></header-section><section><div class=\"wrapper wrapper-content\" nvc-full-page=\"\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><h4 translate=\"NEW_REVIEWER.SUBTITLE\"></h4></div></div><div class=\"ibox-content\"><perfect-scrollbar class=\"scroller\" suppress-scroll-x=\"true\" wheel-propagation=\"true\" wheel-speed=\"1\" min-scrollbar-length=\"20\"><form class=\"\" role=\"form\" name=\"addReviewerCtrl.addNewReviewer\" ng-submit=\"addReviewerCtrl.addNewReviewer.$valid && addReviewerCtrl.createReviewer()\" confirm-leave=\"\" novalidate=\"\"><div class=\"row no-button\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group\"><label translate=\"NEW_REVIEWER.NAME\"></label> <input class=\"form-control\" ng-model=\"addReviewerCtrl.reviewer.name\" type=\"text\" translate=\"\" translate-attr-placeholder=\"NEW_REVIEWER.ENTER_REVIEWER\" ng-required=\"true\"></div></div></div><div class=\"hr-line-dashed\"></div><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group\"><label translate=\"NEW_REVIEWER.ADDRESS\"></label> <input class=\"form-control\" ng-model=\"addReviewerCtrl.reviewer.address\" type=\"text\" translate=\"\" translate-attr-placeholder=\"NEW_REVIEWER.ENTER_ADDRESS\" required=\"\"></div></div></div><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group text-center\"><button class=\"btn btn-normal btn-w-m m-t-xl\" type=\"submit\" translate=\"COMMONS.SAVE\"></button></div></div></div></form></perfect-scrollbar></div></div></div></div></div></section>");
$templateCache.put("app/states/manage/users/add-user/add-user.html","<header-section breadcrumb-title=\"addUserCtrl.title\" breadcrumbs=\"addUserCtrl.breadcrumbs\"></header-section><section class=\"wrapper wrapper-content\" nvc-full-page=\"\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><h4 translate=\"NEW_USER.USER_INFORMATION\"></h4></div></div><div class=\"ibox-content no-padding\"><perfect-scrollbar class=\"scroller\" suppress-scroll-x=\"true\" wheel-propagation=\"true\" wheel-speed=\"1\" min-scrollbar-length=\"20\"><form role=\"form\" name=\"addUserCtrl.addUserForm\" confirm-leave=\"\" ng-submit=\"addUserCtrl.addUserForm.$valid && addUserCtrl.createUser(addUserCtrl.newUser)\" novalidate=\"\"><div class=\"row no-margins padding-top no-button\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><label translate=\"NEW_USER.USER_NAME\"></label> <input class=\"form-control\" name=\"userName\" type=\"text\" translate=\"\" translate-attr-placeholder=\"NEW_USER.USER_NAME_PH\" ng-model=\"addUserCtrl.newUser.name\" ng-pattern=\"/^([ña-zÑA-Z\\s]*[áéíóúüÁÉÍÓÚÜ]*)*$/\" required=\"\"></div></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\" ng-class=\"{\'invalid-select\': addUserCtrl.newUser.companyId == null && addUserCtrl.addUserForm.$submitted}\"><label translate=\"NEW_USER.USER_COMPANY\"></label><select name=\"company\" class=\"form-control\" chosen=\"\" ng-model=\"addUserCtrl.newUser.companyId\" ng-options=\"company.name for company in addUserCtrl.companies\" required=\"\"><option style=\"display:none\" value=\"\" translate=\"NEW_USER.USER_COMPANY_PH\"></option></select></div></div></div><div class=\"hr-line-dashed\"></div><div class=\"row no-margins\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><label translate=\"NEW_USER.USER_EMAIL\"></label> <input class=\"form-control\" name=\"email\" type=\"email\" translate=\"\" translate-attr-placeholder=\"NEW_USER.USER_EMAIL_PH\" ng-model=\"addUserCtrl.newUser.email\" required=\"\"></div></div><div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3\"><div class=\"form-group\"><label translate=\"NEW_USER.OFFICE_PHONE_NUMBER\"></label> <input class=\"form-control\" name=\"officePhone\" type=\"text\" translate=\"\" translate-attr-placeholder=\"NEW_USER.OFFICE_PHONE_NUMBER_PH\" ng-model=\"addUserCtrl.newUser.officePhone\" maxlength=\"14\" ui-us-phone-number=\"\" required=\"\"></div></div><div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3\"><div class=\"form-group\"><label translate=\"NEW_USER.MOBILE_PHONE_NUMBER\"></label> <input class=\"form-control\" name=\"mobilePhone\" type=\"text\" translate=\"\" translate-attr-placeholder=\"NEW_USER.OFFICE_PHONE_NUMBER_PH\" ng-model=\"addUserCtrl.newUser.mobilePhone\" maxlength=\"14\" ui-us-phone-number=\"\"></div></div></div><div class=\"hr-line-dashed\"></div><div class=\"row no-margins\" ng-if=\"addUserCtrl.newUser.companyId && addUserCtrl.newUser.companyId.type === \'AssetAppraisal\'\"><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=\"form-group block-select\" ng-class=\"{\'invalid-select\': addUserCtrl.addUserForm.country.$invalid && addUserCtrl.addUserForm.$submitted}\"><label translate=\"NEW_USER.COUNTRY\"></label><select name=\"country\" class=\"form-control\" ng-options=\"country for country in addUserCtrl.countries\" chosen=\"\" ng-model=\"addUserCtrl.selectedCountry\" required=\"\"><option style=\"display:none\" value=\"\" translate=\"NEW_USER.COUNTRY_PH\"></option></select></div></div><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=\"form-group block-select\" ng-class=\"{\'invalid-select\': addUserCtrl.addUserForm.state.$invalid && addUserCtrl.addUserForm.$submitted}\"><label translate=\"NEW_USER.STATES\"></label><div class=\"input-group\"><select name=\"state\" class=\"form-control\" chosen=\"\" multiple=\"\" ng-model=\"addUserCtrl.newUser.workedOnStates\" ng-options=\"item for item in addUserCtrl.statesByCountry[addUserCtrl.selectedCountry]\" required=\"\"><option style=\"display:none\" value=\"\" translate=\"ADD_ASSET.STATE_PH\"></option></select></div></div></div></div><div class=\"hr-line-dashed\" ng-if=\"addUserCtrl.newUser.companyId && addUserCtrl.newUser.companyId.type === \'AssetAppraisal\'\"></div><div class=\"row no-margins\"><div class=\"col-lg-6 col-md-12 col-sm-12 col-xs-12\" ng-if=\"addUserCtrl.newUser.companyId && addUserCtrl.newUser.companyId.type === \'AssetAppraisal\'\"><div class=\"form-group block-select specialty-dropdown\" ng-class=\"{\'invalid-select\': addUserCtrl.addUserForm.type.$invalid && addUserCtrl.addUserForm.$submitted}\"><label translate=\"NEW_USER.PROPERTY_SPECIALTY\"></label><div class=\"input-group\"><select name=\"type\" class=\"form-control\" chosen=\"\" multiple=\"\" ng-model=\"addUserCtrl.newUser.assetTypeSpecialties\" ng-options=\"type.name for type in addUserCtrl.propertyTypes\" required=\"\"><option style=\"display:none\" value=\"\" translate=\"ADD_ASSET.TYPE_PH\"></option></select></div></div></div><div class=\"col-lg-6 col-md-12 col-sm-12 col-xs-12 m-b-sm\" ng-if=\"addUserCtrl.newUser.companyId && addUserCtrl.newUser.companyId.type === \'AssetAppraisal\'\"><label translate=\"NEW_USER.CERTIFICATIONS\"></label></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 m-b-sm\" ng-if=\"addUserCtrl.newUser.companyId && addUserCtrl.newUser.companyId.type === \'AssetReview\'\"><label translate=\"NEW_USER.CERTIFICATIONS\"></label></div><div class=\"col-lg-6 col-md-12 col-sm-12 col-xs-12 checkbox-custom\" ng-if=\"addUserCtrl.newUser.companyId && (addUserCtrl.newUser.companyId.type === \'AssetAppraisal\' || addUserCtrl.newUser.companyId.type === \'AssetReview\')\"><div class=\"form-group user-certifications\"><div class=\"radio-comment-wrapper\"><checkbox ng-model=\"addUserCtrl.certifications.mai\"></checkbox><label class=\"certification\" translate=\"NEW_USER.MAI\"></label></div></div><div class=\"form-group user-certifications\"><div class=\"radio-comment-wrapper\"><checkbox ng-model=\"addUserCtrl.certifications.cre\"></checkbox><label class=\"certification\" translate=\"NEW_USER.CRE\"></label></div></div><div class=\"form-group user-certifications\"><div class=\"radio-comment-wrapper\"><checkbox ng-model=\"addUserCtrl.certifications.frics\"></checkbox><label class=\"certification\" translate=\"NEW_USER.FRICS\"></label></div></div><div class=\"form-group user-certifications\"><div class=\"radio-comment-wrapper\"><checkbox ng-model=\"addUserCtrl.certifications.cpa\"></checkbox><label class=\"certification\" translate=\"NEW_USER.CPA\"></label></div></div><div class=\"form-group user-certifications\"><div class=\"radio-comment-wrapper\"><checkbox ng-model=\"addUserCtrl.certifications.cfa\"></checkbox><label class=\"certification\" translate=\"NEW_USER.CFA\"></label></div></div><div class=\"form-group user-certifications\"><div class=\"radio-comment-wrapper\"><checkbox ng-model=\"addUserCtrl.certifications.mrics\"></checkbox><label class=\"certification\" translate=\"NEW_USER.MRICS\"></label></div></div></div></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 m-b-sm\" ng-if=\"addUserCtrl.newUser.companyId && addUserCtrl.newUser.companyId.type === \'AssetManagement\'\"><label translate=\"NEW_USER.READ_ONLY_AM\"></label></div><div class=\"col-lg-6 col-md-12 col-sm-12 col-xs-12 checkbox-custom\" ng-if=\"addUserCtrl.newUser.companyId && addUserCtrl.newUser.companyId.type === \'AssetManagement\'\"><div class=\"form-group user-certifications\"><div class=\"radio-comment-wrapper\"><checkbox ng-model=\"addUserCtrl.newUser.readOnlyAssetManager\"></checkbox><label class=\"certification\" translate=\"NEW_USER.READ_ONLY\"></label></div></div></div><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group text-center\"><button class=\"btn btn-w-m m-t-xl btn-normal\" type=\"submit\" translate=\"NEW_USER.SAVE\"></button></div></div></div></form></perfect-scrollbar></div></div></div></div></section>");
$templateCache.put("app/states/manage/users/edit-user/edit-user.html","<header-section breadcrumb-title=\"editUser.title\" breadcrumbs=\"editUser.breadcrumbs\"></header-section><section class=\"wrapper wrapper-content\" nvc-full-page=\"\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><h4 translate=\"EDIT_USER.EDIT_USER_TITLE\"></h4></div></div><div class=\"ibox-content no-padding\"><perfect-scrollbar class=\"scroller\" suppress-scroll-x=\"true\" wheel-propagation=\"true\" wheel-speed=\"1\" min-scrollbar-length=\"20\"><form role=\"form\" name=\"editUser.editUserForm\" ng-submit=\"editUser.editUserForm.$valid && editUser.saveUser(editUser.user)\" confirm-leave=\"\" novalidate=\"\"><div class=\"row no-margins padding-top no-button\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><label translate=\"NEW_USER.USER_NAME\"></label> <input class=\"form-control\" type=\"text\" translate=\"\" translate-attr-placeholder=\"NEW_USER.USER_NAME_PH\" ng-model=\"editUser.user.user.name\" ng-pattern=\"/^([ña-zÑA-Z\\s]*[áéíóúüÁÉÍÓÚÜ]*)*$/\" required=\"\"></div></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><label translate=\"NEW_USER.USER_COMPANY\"></label><select name=\"company\" class=\"form-control\" chosen=\"\" ng-model=\"editUser.user.companyId\" ng-disabled=\"editUser.editUserView\"><option style=\"display:none\" value=\"\">{{editUser.user.company.name}}</option></select></div></div></div><div class=\"hr-line-dashed\"></div><div class=\"row no-margins\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><label translate=\"NEW_USER.USER_EMAIL\"></label> <input class=\"form-control\" type=\"email\" translate=\"\" translate-attr-placeholder=\"NEW_USER.USER_EMAIL_PH\" ng-model=\"editUser.user.account.email\" disabled=\"\" required=\"\"></div></div><div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3\"><div class=\"form-group\"><label translate=\"NEW_USER.OFFICE_PHONE_NUMBER\"></label> <input class=\"form-control\" type=\"text\" translate=\"\" translate-attr-placeholder=\"NEW_USER.OFFICE_PHONE_NUMBER_PH\" ng-model=\"editUser.user.account.officePhone\" maxlength=\"14\" ui-us-phone-number=\"\" required=\"\"></div></div><div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3\"><div class=\"form-group\"><label translate=\"NEW_USER.MOBILE_PHONE_NUMBER\"></label> <input class=\"form-control\" type=\"text\" translate=\"\" translate-attr-placeholder=\"NEW_USER.OFFICE_PHONE_NUMBER_PH\" ng-model=\"editUser.user.account.mobilePhone\" maxlength=\"14\" ui-us-phone-number=\"\"></div></div></div><div class=\"hr-line-dashed\"></div><div class=\"row no-margins\" ng-if=\"editUser.user.company.id && editUser.user.company.type === \'AssetAppraisal\'\"><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=\"form-group block-select\" ng-class=\"{\'invalid-select\': editUser.editUserForm.country.$invalid && editUser.editUserForm.$submitted}\"><label translate=\"NEW_USER.COUNTRY\"></label><select name=\"country\" class=\"form-control\" ng-options=\"country for country in editUser.countries\" chosen=\"\" ng-model=\"editUser.selectedCountry\" required=\"\"><option style=\"display:none\" value=\"\" translate=\"NEW_USER.COUNTRY_PH\"></option></select></div></div><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=\"form-group block-select\" ng-class=\"{\'invalid-select\': editUser.editUserForm.state.$invalid && editUser.editUserForm.$submitted}\"><label translate=\"NEW_USER.STATES\"></label><div class=\"input-group\"><select name=\"state\" class=\"form-control\" chosen=\"\" multiple=\"\" ng-options=\"item for item in editUser.statesByCountry[editUser.selectedCountry]\" ng-model=\"editUser.user.user.workedOnStates\" required=\"\"><option style=\"display:none\" value=\"\" translate=\"NEW_USER.STATE_PH\"></option></select></div></div></div></div><div class=\"hr-line-dashed\" ng-if=\"editUser.user.company.id && editUser.user.company.type === \'AssetAppraisal\'\"></div><div class=\"row no-margins\"><div class=\"col-lg-6 col-md-12 col-sm-12 col-xs-12\" ng-if=\"editUser.user.company.id && editUser.user.company.type === \'AssetAppraisal\'\"><div class=\"form-group block-select specialty-dropdown\" ng-class=\"{\'invalid-select\': editUser.editUserForm.type.$invalid && editUser.editUserForm.$submitted}\"><label translate=\"NEW_USER.PROPERTY_SPECIALTY\"></label><div class=\"input-group\"><select name=\"type\" class=\"form-control\" chosen=\"\" multiple=\"\" ng-model=\"editUser.user.user.assetTypeSpecialties\" ng-options=\"type.name for type in editUser.propertyTypes\" required=\"\"><option style=\"display:none\" value=\"\" translate=\"ADD_ASSET.TYPE_PH\"></option></select></div></div></div><div class=\"col-lg-6 col-md-12 col-sm-12 col-xs-12 m-b-sm\" ng-if=\"editUser.user.company.id && editUser.user.company.type === \'AssetAppraisal\'\"><label translate=\"NEW_USER.CERTIFICATIONS\"></label></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 m-b-sm\" ng-if=\"editUser.user.company.id && editUser.user.company.type === \'AssetReview\'\"><label translate=\"NEW_USER.CERTIFICATIONS\"></label></div><div class=\"col-lg-6 col-md-12 col-sm-12 col-xs-12 checkbox-custom\" ng-if=\"editUser.user.company.id && (editUser.user.company.type === \'AssetAppraisal\' || editUser.user.company.type === \'AssetReview\')\"><div class=\"form-group user-certifications\"><div class=\"radio-comment-wrapper\"><checkbox ng-model=\"editUser.certifications.mai\"></checkbox><label class=\"certification\" translate=\"NEW_USER.MAI\"></label></div></div><div class=\"form-group user-certifications\"><div class=\"radio-comment-wrapper\"><checkbox ng-model=\"editUser.certifications.cre\"></checkbox><label class=\"certification\" translate=\"NEW_USER.CRE\"></label></div></div><div class=\"form-group user-certifications\"><div class=\"radio-comment-wrapper\"><checkbox ng-model=\"editUser.certifications.frics\"></checkbox><label class=\"certification\" translate=\"NEW_USER.FRICS\"></label></div></div><div class=\"form-group user-certifications\"><div class=\"radio-comment-wrapper\"><checkbox ng-model=\"editUser.certifications.cpa\"></checkbox><label class=\"certification\" translate=\"NEW_USER.CPA\"></label></div></div><div class=\"form-group user-certifications\"><div class=\"radio-comment-wrapper\"><checkbox ng-model=\"editUser.certifications.cfa\"></checkbox><label class=\"certification\" translate=\"NEW_USER.CFA\"></label></div></div><div class=\"form-group user-certifications\"><div class=\"radio-comment-wrapper\"><checkbox ng-model=\"editUser.certifications.mrics\"></checkbox><label class=\"certification\" translate=\"NEW_USER.MRICS\"></label></div></div></div></div><div class=\"hr-line-dashed\" ng-if=\"editUser.user.company.id && editUser.user.company.type === \'AssetAppraisal\'\"></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 m-b-sm\" ng-if=\"editUser.user.company.id && editUser.user.company.type === \'AssetManagement\'\"><label translate=\"NEW_USER.READ_ONLY_AM\"></label></div><div class=\"col-lg-6 col-md-12 col-sm-12 col-xs-12 checkbox-custom\" ng-if=\"editUser.user.company.id && editUser.user.company.type === \'AssetManagement\'\"><div class=\"form-group user-certifications\"><div class=\"radio-comment-wrapper\"><checkbox ng-model=\"editUser.user.user.readOnlyAssetManager\"></checkbox><label class=\"certification\" translate=\"NEW_USER.READ_ONLY\"></label></div></div></div><div class=\"row no-margins\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group text-center\"><button class=\"btn btn-normal m-t-xl\" type=\"submit\" translate=\"NEW_USER.SAVE\"></button> <span ng-show=\"editUser.user.account.userNotOnboardedYet\" td-security=\"[\'Admin\']\" action=\"display-none\"><button class=\"btn btn-normal m-t-xl\" type=\"button\" translate=\"NEW_USER.RESEND_ONBOARD_EMAIL\" ng-click=\"editUser.resendOnboardingEmail(editUser.user)\"></button><span></span></span></div></div></div></form></perfect-scrollbar></div></div></div></div></section>");
$templateCache.put("app/states/manage/users/user-details/user-details.html","<header-section breadcrumb-title=\"userDetailsCtrl.title\" breadcrumbs=\"userDetailsCtrl.breadcrumbs\"></header-section><section class=\"wrapper wrapper-content\" nvc-full-page=\"\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><h4 translate=\"USER_DETAIL.USER_TITLE\"></h4></div></div><div class=\"ibox-content no-padding\"><perfect-scrollbar class=\"scroller\" suppress-scroll-x=\"true\" wheel-propagation=\"true\" wheel-speed=\"1\" min-scrollbar-length=\"20\"><div class=\"row no-margins no-button padding-top\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><label translate=\"NEW_USER.USER_NAME\"></label> <input class=\"form-control\" type=\"text\" translate=\"\" translate-attr-placeholder=\"NEW_USER.USER_NAME_PH\" ng-model=\"userDetailsCtrl.user.user.name\" ng-pattern=\"/^([ña-zÑA-Z\\s]*[áéíóúüÁÉÍÓÚÜ]*)*$/\" disabled=\"\"></div></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><label translate=\"NEW_USER.USER_COMPANY\"></label><select name=\"company\" class=\"form-control\" chosen=\"\" ng-disabled=\"userDetailsCtrl.editUserView\"><option style=\"display:none\" value=\"\">{{userDetailsCtrl.user.company.name}}</option></select></div></div></div><div class=\"hr-line-dashed\"></div><div class=\"row no-margins\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><label translate=\"NEW_USER.USER_EMAIL\"></label> <input class=\"form-control\" type=\"email\" translate=\"\" translate-attr-placeholder=\"NEW_USER.USER_EMAIL_PH\" ng-model=\"userDetailsCtrl.user.account.email\" disabled=\"\"></div></div><div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3\"><div class=\"form-group\"><label translate=\"NEW_USER.OFFICE_PHONE_NUMBER\"></label> <input class=\"form-control\" type=\"text\" translate=\"\" translate-attr-placeholder=\"NEW_USER.OFFICE_PHONE_NUMBER_PH\" ng-model=\"userDetailsCtrl.user.account.officePhone\" maxlength=\"14\" ui-us-phone-number=\"\" disabled=\"\"></div></div><div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3\"><div class=\"form-group\"><label translate=\"NEW_USER.MOBILE_PHONE_NUMBER\"></label> <input class=\"form-control\" type=\"text\" translate=\"\" translate-attr-placeholder=\"NEW_USER.OFFICE_PHONE_NUMBER_PH\" ng-model=\"userDetailsCtrl.user.account.mobilePhone\" maxlength=\"14\" ui-us-phone-number=\"\" disabled=\"\"></div></div></div><div class=\"hr-line-dashed\"></div><div class=\"row no-margins\" ng-if=\"userDetailsCtrl.user.company.id && userDetailsCtrl.user.company.type === \'AssetAppraisal\'\"><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=\"form-group block-select\" ng-class=\"{\'invalid-select\': userDetailsCtrl.editUserForm.user.country.$invalid && userDetailsCtrl.editUserForm.$submitted}\"><label translate=\"NEW_USER.COUNTRY\"></label><select name=\"country\" class=\"form-control\" ng-options=\"country for country in userDetailsCtrl.countries\" chosen=\"\" ng-model=\"userDetailsCtrl.user.user.workedOnCountries[0]\" disabled=\"\"><option style=\"display:none\" value=\"\" translate=\"NEW_USER.COUNTRY_PH\"></option></select></div></div><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12 user-detail-states\"><div class=\"form-group block-select\" ng-class=\"{\'invalid-select\': userDetailsCtrl.editUserForm.user.state.$invalid && userDetailsCtrl.editUserForm.$submitted}\"><label translate=\"NEW_USER.STATES\"></label><select name=\"state\" class=\"form-control\" chosen=\"\" multiple=\"\" ng-options=\"item for item in userDetailsCtrl.statesByCountry[userDetailsCtrl.user.user.workedOnCountries[0]]\" ng-model=\"userDetailsCtrl.user.user.workedOnStates\" disabled=\"\"><option style=\"display:none\" value=\"\" translate=\"NEW_USER.STATE_PH\"></option></select></div></div></div><div class=\"hr-line-dashed\" ng-if=\"userDetailsCtrl.user.company.id && userDetailsCtrl.user.company.type === \'AssetAppraisal\'\"></div><div class=\"row no-margins\"><div class=\"col-lg-6 col-md-12 col-sm-12 col-xs-12\" ng-if=\"userDetailsCtrl.user.company.type === \'AssetAppraisal\'\"><div class=\"form-group block-select specialty-dropdown\" ng-class=\"{\'invalid-select\': userDetailsCtrl.editUserForm.type.$invalid && userDetailsCtrl.editUserForm.$submitted}\"><label translate=\"NEW_USER.PROPERTY_SPECIALTY\"></label><div class=\"input-group\"><select name=\"type\" class=\"form-control\" chosen=\"\" multiple=\"\" ng-model=\"userDetailsCtrl.user.user.assetTypeSpecialties\" ng-options=\"type.name for type in userDetailsCtrl.propertyTypes\" disabled=\"\"><option style=\"display:none\" value=\"\" translate=\"ADD_ASSET.TYPE_PH\"></option></select></div></div></div><div class=\"col-lg-6 col-md-12 col-sm-12 col-xs-12 m-b-sm\" ng-if=\"userDetailsCtrl.user.company.type === \'AssetAppraisal\'\"><label translate=\"NEW_USER.CERTIFICATIONS\"></label></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 m-b-sm\" ng-if=\"userDetailsCtrl.user.company.type === \'AssetReview\'\"><label translate=\"NEW_USER.CERTIFICATIONS\"></label></div><div class=\"col-lg-6 col-md-12 col-sm-12 col-xs-12 checkbox-custom\" ng-if=\"userDetailsCtrl.user.company.type === \'AssetAppraisal\' || userDetailsCtrl.user.company.type === \'AssetReview\'\"><div class=\"form-group user-certifications\"><div class=\"radio-comment-wrapper\"><checkbox ng-model=\"userDetailsCtrl.certifications.mai\" disabled=\"\"></checkbox><label class=\"certification\" translate=\"NEW_USER.MAI\"></label></div></div><div class=\"form-group user-certifications\"><div class=\"radio-comment-wrapper\"><checkbox ng-model=\"userDetailsCtrl.certifications.cre\" disabled=\"\"></checkbox><label class=\"certification\" translate=\"NEW_USER.CRE\"></label></div></div><div class=\"form-group user-certifications\"><div class=\"radio-comment-wrapper\"><checkbox ng-model=\"userDetailsCtrl.certifications.frics\" disabled=\"\"></checkbox><label class=\"certification\" translate=\"NEW_USER.FRICS\"></label></div></div><div class=\"form-group user-certifications\"><div class=\"radio-comment-wrapper\"><checkbox ng-model=\"userDetailsCtrl.certifications.cpa\" disabled=\"\"></checkbox><label class=\"certification\" translate=\"NEW_USER.CPA\"></label></div></div><div class=\"form-group user-certifications\"><div class=\"radio-comment-wrapper\"><checkbox ng-model=\"userDetailsCtrl.certifications.cfa\" disabled=\"\"></checkbox><label class=\"certification\" translate=\"NEW_USER.CFA\"></label></div></div><div class=\"form-group user-certifications\"><div class=\"radio-comment-wrapper\"><checkbox ng-model=\"userDetailsCtrl.certifications.mrics\" disabled=\"\"></checkbox><label class=\"certification\" translate=\"NEW_USER.MRICS\"></label></div></div></div></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 m-b-sm\" ng-if=\"userDetailsCtrl.user.company.id && userDetailsCtrl.user.company.type === \'AssetManagement\'\"><label translate=\"NEW_USER.READ_ONLY_AM\"></label></div><div class=\"col-lg-6 col-md-12 col-sm-12 col-xs-12 checkbox-custom\" ng-if=\"userDetailsCtrl.user.company.id && userDetailsCtrl.user.company.type === \'AssetManagement\'\"><div class=\"form-group user-certifications\"><div class=\"radio-comment-wrapper\"><checkbox ng-model=\"userDetailsCtrl.user.user.readOnlyAssetManager\" disabled=\"\"></checkbox><label class=\"certification\" translate=\"NEW_USER.READ_ONLY\"></label></div></div></div></perfect-scrollbar></div></div></div></div></section>");
$templateCache.put("app/states/valuations/review/discussion/comments.html","<div class=\"wrapper wrapper-content no-padding-top less-margin summary\"><div class=\"row\"><div class=\"col-lg-3 col-md-4 col-sm-4 col-xs-4 comments-sidebar\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content fixed-height\"><div class=\"add m-b\" ng-if=\"!reviewCtrl.readOnly\"><div td-security=\"[\'Admin\', \'AssetReview\', \'AssetManagement\',\'AssetManagerReadOnly\']\" action=\"display-none\"><a class=\"btn btn-warning btn-w-all\" ui-sref=\"app.review.discussion.newComment\" review-checker=\"commentsCtrl.review\" actions=\"[\'AM_Comment\', \'RW_Comment\', \'RW_Submit\', \'LRW_Comment\']\" behaviour=\"\'disable\'\">{{\'DISCUSSION.LATERAL_BAR.ADD_NEX_COMMENT\' | translate}}</a></div></div><div class=\"comment-filter\"><h4 translate=\"DISCUSSION.LATERAL_BAR.COMMENTS\"></h4><ul><li ng-class=\"{active: !commentsCtrl.filter}\"><a ui-sref=\"app.review.discussion.comments\" ng-click=\"commentsCtrl.filter = \'\'\"><span translate=\"DISCUSSION.LATERAL_BAR.ALL_COMMENTS\"></span> <span ng-hide=\"commentsCtrl.review.comments.comments.length == 0\">({{commentsCtrl.review.comments.comments.length}})</span></a></li><li ng-class=\"{active: commentsCtrl.filter === \'General\'}\"><a ui-sref=\"app.review.discussion.comments\" ng-click=\"commentsCtrl.filter = \'General\'\"><span translate=\"DISCUSSION.LATERAL_BAR.GENERAL\"></span> <span ng-hide=\"(commentsCtrl.review.comments.comments | filter:{\'type\': \'General\'}).length == 0\">({{(commentsCtrl.review.comments.comments | filter:{\'type\': \'General\'}).length}})</span></a></li><li ng-class=\"{active: commentsCtrl.filter === \'Argus\'}\"><a ui-sref=\"app.review.discussion.comments\" ng-click=\"commentsCtrl.filter = \'Argus\'\"><span translate=\"DISCUSSION.LATERAL_BAR.ARGUS\"></span> <span ng-hide=\"(commentsCtrl.review.comments.comments | filter:{\'type\': \'Argus\'}).length == 0\">({{(commentsCtrl.review.comments.comments | filter:{\'type\': \'Argus\'}).length}})</span></a></li><li ng-class=\"{active: commentsCtrl.filter === \'ValuationReport\'}\"><a ui-sref=\"app.review.discussion.comments\" ng-click=\"commentsCtrl.filter = \'ValuationReport\'\"><span translate=\"DISCUSSION.LATERAL_BAR.VALUATION_REPORT\"></span> <span ng-hide=\"(commentsCtrl.review.comments.comments | filter:{\'type\': \'ValuationReport\'}).length == 0\">({{(commentsCtrl.review.comments.comments | filter:{\'type\': \'ValuationReport\'}).length}})</span></a></li><li ng-class=\"{active: commentsCtrl.filter === \'ExecutiveSummary\'}\"><a ui-sref=\"app.review.discussion.comments\" ng-click=\"commentsCtrl.filter = \'ExecutiveSummary\'\"><span translate=\"DISCUSSION.LATERAL_BAR.EXECUTIVE_SUMMARY\"></span> <span ng-hide=\"(commentsCtrl.review.comments.comments | filter:{\'type\': \'ExecutiveSummary\'}).length == 0\">({{(commentsCtrl.review.comments.comments | filter:{\'type\': \'ExecutiveSummary\'}).length}})</span></a></li></ul></div></div></div></div><div ui-view=\"commentState\"></div></div></div>");
$templateCache.put("app/states/valuations/review/discussion/discussion.html","<div ui-view=\"summary\"></div><div ui-view=\"comments\"></div>");
$templateCache.put("app/states/valuations/review/discussion/summary.html","<div class=\"wrapper wrapper-content no-padding-top less-margin summary\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"current-status\"><div class=\"date\">{{summaryCtrl.review.nms | formatDate:\'MMM DD\'}}</div><div class=\"status\"><div class=\"action\" nvc-latest-action=\"\" review=\"summaryCtrl.review\"></div></div></div><div class=\"ibox float-e-margins\"><div class=\"ibox-content no-padding-left no-padding-right\"><div ng-if=\"summaryCtrl.review.status != \'Created\' && summaryCtrl.review.status != \'DocumentsUploaded\'\"><div class=\"col-lg-7 col-md-7 col-sm-7 col-xs-7 no-padding\"><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 separator text-center\"><div class=\"summary-container\"><div class=\"first-row\" td-security=\"[\'Admin\', \'AssetReview\', \'Audit\', \'AssetAppraisal\']\" action=\"display-none\"><span translate=\"DISCUSSION.SUMMARY.FROM\"></span> <span class=\"big\">{{summaryCtrl.review.asset.primaryAssetAppraiser.user.name}}</span></div><div class=\"last-row no-margins\"><span translate=\"DISCUSSION.SUMMARY.TO\"></span> <span class=\"big\">{{summaryCtrl.review.asset.primaryAssetReviewer.user.name}}</span></div></div></div><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 separator text-center\"><div class=\"summary-container\"><div class=\"first-row\"><span translate=\"DISCUSSION.SUMMARY.PREVIOUS_VALUE\"></span> <span class=\"big bigger\" ng-if=\"summaryCtrl.role !== \'AssetAppraisal\' || !summaryCtrl.applyAdminRwModifiedValuesSecurity || -1 === summaryCtrl.modifiedByAdminOrReviewerFields.indexOf(\'appraisalPrevious\')\">{{summaryCtrl.review.appraisalPrevious | currency:undefined:0}}</span> <span class=\"big bigger\" ng-if=\"summaryCtrl.role === \'AssetAppraisal\' && summaryCtrl.applyAdminRwModifiedValuesSecurity && -1 !== summaryCtrl.modifiedByAdminOrReviewerFields.indexOf(\'appraisalPrevious\')\"></span></div><div class=\"last-row no-margins\"><span translate=\"DISCUSSION.SUMMARY.DRAFT_VALUE\"></span> <span class=\"big bigger\" ng-if=\"summaryCtrl.role !== \'AssetAppraisal\' || !summaryCtrl.applyAdminRwModifiedValuesSecurity || -1 === summaryCtrl.modifiedByAdminOrReviewerFields.indexOf(\'appraisalDraft\')\">{{summaryCtrl.review.appraisalDraft | currency:undefined:0}}</span> <span class=\"big bigger\" ng-if=\"summaryCtrl.role === \'AssetAppraisal\' && summaryCtrl.applyAdminRwModifiedValuesSecurity && -1 !== summaryCtrl.modifiedByAdminOrReviewerFields.indexOf(\'appraisalDraft\')\"></span></div></div></div><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 separator text-center\"><div class=\"summary-container\"><div class=\"first-row\"><span translate=\"DISCUSSION.SUMMARY.FINAL_VALUE\"></span> <span class=\"big bigger\" ng-if=\"summaryCtrl.review.appraisalFinal != 0 && (summaryCtrl.role !== \'AssetAppraisal\' || !summaryCtrl.applyAdminRwModifiedValuesSecurity || -1 === summaryCtrl.modifiedByAdminOrReviewerFields.indexOf(\'appraisalFinal\'))\">{{summaryCtrl.review.appraisalFinal | currency:undefined:0}}</span> <span class=\"big bigger\" ng-if=\"summaryCtrl.review.appraisalFinal == 0\"></span></div><div class=\"last-row no-margins\"><span translate=\"DISCUSSION.SUMMARY.DATE_OF_SUBMITTED_REVIEW\"></span> <span class=\"big bigger\">{{summaryCtrl.review.nms | formatDate:\'MMM DD\'}}</span></div></div></div></div><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 text-center no-padding\"><div class=\"summary-container buttons\"><a class=\"btn btn-w-m btn-summary m-r\" ng-click=\"summaryCtrl.downloadValuation()\"><span class=\"icon icon-ic-eye m-r\"></span>{{\"DISCUSSION.SUMMARY.VALUATION_REPORT\" | translate}}</a> <a class=\"btn btn-w-m btn-summary\" ui-sref=\"app.review.documents\" ui-sref-opts=\"{reload: true}\"><span class=\"icon icon-ic-eye m-r\"></span>{{\"DISCUSSION.SUMMARY.EXECUTIVE_SUMMARY\" | translate}}</a></div></div><div class=\"col-lg-1 col-md-1 col-sm-1 col-xs-1 text-right\"><div class=\"summary-container buttons btn-arrow-container\"><a class=\"btn btn-summary btn-arrow\" ng-click=\"summaryCtrl.superSummeryOpened = !summaryCtrl.superSummeryOpened\"><span class=\"fa chevron\" ng-class=\"{\'fa-chevron-up\': summaryCtrl.superSummeryOpened, \'fa-chevron-down\': !summaryCtrl.superSummeryOpened}\"></span></a></div></div><div class=\"super-summary\" ng-show=\"summaryCtrl.superSummeryOpened\"><hr><div class=\"rows p-h-xs\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"title m-b\" translate=\"DISCUSSION.SUMMARY.VALUE_CONCLUSION\"></div></div><div class=\"col-lg-2 col-md-3 col-sm-3 col-xs-3 m-b\"><span>{{\"DISCUSSION.SUMMARY.LAND\" | translate}} & {{\"DISCUSSION.SUMMARY.OTHER_ADJ\" | translate}}</span> <span class=\"big\" ng-if=\"summaryCtrl.role !== \'AssetAppraisal\' || !summaryCtrl.applyAdminRwModifiedValuesSecurity || -1 === summaryCtrl.modifiedByAdminOrReviewerFields.indexOf(\'landAndOtherAdj\')\">{{summaryCtrl.review.landAndOtherAdj === \'N/A\' ? summaryCtrl.review.landAndOtherAdj : (summaryCtrl.review.landAndOtherAdj | currency:undefined:0)}}</span></div><div class=\"col-lg-2 col-md-3 col-sm-3 col-xs-3 m-b\"><span translate=\"DISCUSSION.SUMMARY.DISCOUNTED_CASH_FLOW\"></span> <span class=\"big\" ng-if=\"summaryCtrl.role !== \'AssetAppraisal\' || !summaryCtrl.applyAdminRwModifiedValuesSecurity || -1 === summaryCtrl.modifiedByAdminOrReviewerFields.indexOf(\'discountedCashFlowAnalysis\')\">{{summaryCtrl.review.discountedCashFlowAnalysis === \'N/A\' ? summaryCtrl.review.discountedCashFlowAnalysis : (summaryCtrl.review.discountedCashFlowAnalysis | currency:undefined:0)}}</span></div><div class=\"col-lg-2 col-md-3 col-sm-3 col-xs-3 m-b\"><span translate=\"DISCUSSION.SUMMARY.DIRECT_CAPITALIZATION\"></span> <span class=\"big\" ng-if=\"summaryCtrl.role !== \'AssetAppraisal\' || !summaryCtrl.applyAdminRwModifiedValuesSecurity || -1 === summaryCtrl.modifiedByAdminOrReviewerFields.indexOf(\'directCapitalizationAnalysis\')\">{{summaryCtrl.review.directCapitalizationAnalysis === \'N/A\' ? summaryCtrl.review.directCapitalizationAnalysis : (summaryCtrl.review.directCapitalizationAnalysis | currency:undefined:0)}}</span></div><div class=\"col-lg-2 col-md-3 col-sm-3 col-xs-3 m-b\"><span translate=\"DISCUSSION.SUMMARY.STABILIZED_VALUE\"></span> <span class=\"big\" ng-if=\"summaryCtrl.role !== \'AssetAppraisal\' || !summaryCtrl.applyAdminRwModifiedValuesSecurity || -1 === summaryCtrl.modifiedByAdminOrReviewerFields.indexOf(\'stabilizedValue\')\">{{summaryCtrl.review.stabilizedValue === \'N/A\' ? summaryCtrl.review.stabilizedValue : (summaryCtrl.review.stabilizedValue | currency:undefined:0)}}</span></div><div class=\"col-lg-2 col-md-3 col-sm-3 col-xs-3 m-b\"><span translate=\"DISCUSSION.SUMMARY.STABILIZED_VALUE_SF\"></span> <span class=\"big\" ng-if=\"summaryCtrl.role !== \'AssetAppraisal\' || !summaryCtrl.applyAdminRwModifiedValuesSecurity || -1 === summaryCtrl.modifiedByAdminOrReviewerFields.indexOf(\'stabilizedValueSf\')\">{{summaryCtrl.review.stabilizedValueSf === \'N/A\' ? summaryCtrl.review.stabilizedValueSf : (summaryCtrl.review.stabilizedValueSf | currency:undefined:2)}}</span></div><div class=\"col-lg-2 col-md-3 col-sm-3 col-xs-3 m-b\"><span translate=\"DISCUSSION.SUMMARY.SALES_COMPARISON_APPROACH\"></span> <span class=\"big\" ng-if=\"summaryCtrl.role !== \'AssetAppraisal\' || !summaryCtrl.applyAdminRwModifiedValuesSecurity || -1 === summaryCtrl.modifiedByAdminOrReviewerFields.indexOf(\'salesComparisonApproach\')\">{{summaryCtrl.review.salesComparisonApproach === \'N/A\' ? summaryCtrl.review.salesComparisonApproach : (summaryCtrl.review.salesComparisonApproach | currency:undefined:0)}}</span></div><div class=\"col-lg-2 col-md-3 col-sm-3 col-xs-3 m-b\"><span translate=\"DISCUSSION.SUMMARY.COST_APPROACH\"></span> <span class=\"big\" ng-if=\"summaryCtrl.role !== \'AssetAppraisal\' || !summaryCtrl.applyAdminRwModifiedValuesSecurity || -1 === summaryCtrl.modifiedByAdminOrReviewerFields.indexOf(\'costApproach\')\">{{summaryCtrl.review.costApproach === \'N/A\' ? summaryCtrl.review.costApproach : (summaryCtrl.review.costApproach | currency:undefined:0)}}</span></div><div class=\"col-lg-2 col-md-3 col-sm-3 col-xs-3 m-b\"><span translate=\"DISCUSSION.SUMMARY.ABSORPTION_PERIOD\"></span> <span class=\"big\" ng-if=\"summaryCtrl.role !== \'AssetAppraisal\' || !summaryCtrl.applyAdminRwModifiedValuesSecurity || -1 === summaryCtrl.modifiedByAdminOrReviewerFields.indexOf(\'absorptionPeriod\')\">{{summaryCtrl.review.absorptionPeriod}}</span></div><div class=\"col-lg-2 col-md-3 col-sm-3 col-xs-3 m-b\"><span translate=\"DISCUSSION.SUMMARY.INSURABLE_VALUE\"></span> <span class=\"big\" ng-if=\"summaryCtrl.role !== \'AssetAppraisal\' || !summaryCtrl.applyAdminRwModifiedValuesSecurity || -1 === summaryCtrl.modifiedByAdminOrReviewerFields.indexOf(\'insurableValue\')\">{{summaryCtrl.review.insurableValue === \'N/A\' ? summaryCtrl.review.insurableValue : (summaryCtrl.review.insurableValue | currency:undefined:0)}}</span></div></div></div><hr><div class=\"rows p-h-xs\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6 no-padding separator\"><div class=\"col-lg-6 col-md-12 col-sm-12 col-xs-6\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"title m-b\" translate=\"DISCUSSION.SUMMARY.PRIOR_PERIOD_VALUE_TO_CURRENT_VALUE\"></div></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6 m-b\"><span translate=\"DISCUSSION.SUMMARY.PERCENTAGE_CHANGE\"></span> <span class=\"big\" ng-if=\"summaryCtrl.role !== \'AssetAppraisal\' || !summaryCtrl.applyAdminRwModifiedValuesSecurity || -1 === summaryCtrl.modifiedByAdminOrReviewerFields.indexOf(\'appraisalPeriodDelta\')\">{{(summaryCtrl.review.appraisalPeriodDelta | number:2 | percentage:undefined:2) || \'N/A\'}}</span></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><span translate=\"DISCUSSION.SUMMARY.ACTUAL_DOLLAR_CHANGE\"></span> <span class=\"big\" ng-if=\"summaryCtrl.role !== \'AssetAppraisal\' || !summaryCtrl.applyAdminRwModifiedValuesSecurity || -1 === summaryCtrl.modifiedByAdminOrReviewerFields.indexOf(\'appraisalPeriodDeltaValue\')\">{{(summaryCtrl.review.appraisalPeriodDeltaValue | currency:undefined:0) || \'N/A\'}}</span></div></div><div class=\"col-lg-6 col-md-12 col-sm-12 col-xs-6\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"title m-b\" translate=\"DISCUSSION.SUMMARY.PRIOR_YEAR_VALUE_TO_CURRENT_VALUE\"></div></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><span translate=\"DISCUSSION.SUMMARY.PERCENTAGE_CHANGE\"></span> <span class=\"big\" ng-if=\"summaryCtrl.role !== \'AssetAppraisal\' || !summaryCtrl.applyAdminRwModifiedValuesSecurity || -1 === summaryCtrl.modifiedByAdminOrReviewerFields.indexOf(\'appraisalYearlyDelta\')\">{{(summaryCtrl.review.appraisalYearlyDelta | number:2 | percentage:undefined:2) || \'N/A\'}}</span></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><span translate=\"DISCUSSION.SUMMARY.ACTUAL_DOLLAR_CHANGE\"></span> <span class=\"big\" ng-if=\"summaryCtrl.role !== \'AssetAppraisal\' || !summaryCtrl.applyAdminRwModifiedValuesSecurity || -1 === summaryCtrl.modifiedByAdminOrReviewerFields.indexOf(\'appraisalYearlyDeltaValue\')\">{{(summaryCtrl.review.appraisalYearlyDeltaValue | currency:undefined:0) || \'N/A\'}}</span></div></div></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6 no-padding\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"title m-b\">&nbsp;</div></div><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 location\"><span translate=\"DISCUSSION.SUMMARY.LOCATION\"></span> <span class=\"big\">{{summaryCtrl.review.asset.address.address}}<br>{{summaryCtrl.review.asset.address.city}}, {{summaryCtrl.review.asset.address.state}}</span></div><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\"><span translate=\"DISCUSSION.SUMMARY.PROPERTY_TYPE\"></span> <span class=\"big\">{{summaryCtrl.review.asset.type}}</span></div><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\"><span translate=\"DISCUSSION.SUMMARY.PROPERTY_SUBTYPE\"></span> <span class=\"big\">{{summaryCtrl.review.asset.subType}}</span></div></div></div></div><hr><div class=\"rows p-h-xs\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6 no-padding separator\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><table class=\"table table-striped\"><thead class=\"table-rates-head\"><tr class=\"header-row\"><th></th><th><span translate=\"DISCUSSION.SUMMARY.STABILIZED_CAP_RATE\"></span></th><th><span translate=\"DISCUSSION.SUMMARY.TERMINAL_RATE\"></span></th><th><span translate=\"DISCUSSION.SUMMARY.DISCOUNT_RATE\"></span></th><th><span translate=\"DISCUSSION.SUMMARY.IMPLIED_CAP_RATE\"></span></th></tr></thead><tbody><tr><td><span translate=\"DISCUSSION.SUMMARY.CURRENT_RATE\"></span></td><td><span class=\"big\" ng-if=\"summaryCtrl.role !== \'AssetAppraisal\' || !summaryCtrl.applyAdminRwModifiedValuesSecurity || -1 === summaryCtrl.modifiedByAdminOrReviewerFields.indexOf(\'stabilizedCapRate\')\">{{summaryCtrl.review.stabilizedCapRate | number:2 | percentage:undefined:2}}</span></td><td><span class=\"big\" ng-if=\"summaryCtrl.role !== \'AssetAppraisal\' || !summaryCtrl.applyAdminRwModifiedValuesSecurity || -1 === summaryCtrl.modifiedByAdminOrReviewerFields.indexOf(\'terminalRate\')\">{{summaryCtrl.review.terminalRate | number:2 | percentage:undefined:2}}</span></td><td><span class=\"big\" ng-if=\"summaryCtrl.role !== \'AssetAppraisal\' || !summaryCtrl.applyAdminRwModifiedValuesSecurity || -1 === summaryCtrl.modifiedByAdminOrReviewerFields.indexOf(\'discountRate\')\">{{summaryCtrl.review.discountRate | number:2 | percentage:undefined:2}}</span></td><td><span class=\"big\" ng-if=\"summaryCtrl.role !== \'AssetAppraisal\' || !summaryCtrl.applyAdminRwModifiedValuesSecurity || -1 === summaryCtrl.modifiedByAdminOrReviewerFields.indexOf(\'impliedCapRate\')\">{{summaryCtrl.review.impliedCapRate | number:2 | percentage:undefined:2}}</span></td></tr><tr><td><span translate=\"DISCUSSION.SUMMARY.P_P\"></span></td><td><span class=\"big\" ng-if=\"summaryCtrl.role !== \'AssetAppraisal\' || !summaryCtrl.applyAdminRwModifiedValuesSecurity || -1 === summaryCtrl.modifiedByAdminOrReviewerFields.indexOf(\'stabilizedCapRatePeriodDelta\')\">{{summaryCtrl.review.stabilizedCapRatePeriodDelta || \'N/A\'}}</span></td><td><span class=\"big\" ng-if=\"summaryCtrl.role !== \'AssetAppraisal\' || !summaryCtrl.applyAdminRwModifiedValuesSecurity || -1 === summaryCtrl.modifiedByAdminOrReviewerFields.indexOf(\'terminalRatePeriodDelta\')\">{{summaryCtrl.review.terminalRatePeriodDelta || \'N/A\'}}</span></td><td><span class=\"big\" ng-if=\"summaryCtrl.role !== \'AssetAppraisal\' || !summaryCtrl.applyAdminRwModifiedValuesSecurity || -1 === summaryCtrl.modifiedByAdminOrReviewerFields.indexOf(\'discountRatePeriodDelta\')\">{{summaryCtrl.review.discountRatePeriodDelta || \'N/A\'}}</span></td><td><span class=\"big\" ng-if=\"summaryCtrl.role !== \'AssetAppraisal\' || !summaryCtrl.applyAdminRwModifiedValuesSecurity || -1 === summaryCtrl.modifiedByAdminOrReviewerFields.indexOf(\'impliedCapRatePeriodDelta\')\">{{summaryCtrl.review.impliedCapRatePeriodDelta || \'N/A\'}}</span></td></tr><tr><td><span translate=\"DISCUSSION.SUMMARY.Y_Y\"></span></td><td><span class=\"big\" ng-if=\"summaryCtrl.role !== \'AssetAppraisal\' || !summaryCtrl.applyAdminRwModifiedValuesSecurity || -1 === summaryCtrl.modifiedByAdminOrReviewerFields.indexOf(\'stabilizedCapRateYearlyDelta\')\">{{summaryCtrl.review.stabilizedCapRateYearlyDelta || \'N/A\'}}</span></td><td><span class=\"big\" ng-if=\"summaryCtrl.role !== \'AssetAppraisal\' || !summaryCtrl.applyAdminRwModifiedValuesSecurity || -1 === summaryCtrl.modifiedByAdminOrReviewerFields.indexOf(\'terminalRateYearlyDelta\')\">{{summaryCtrl.review.terminalRateYearlyDelta || \'N/A\'}}</span></td><td><span class=\"big\" ng-if=\"summaryCtrl.role !== \'AssetAppraisal\' || !summaryCtrl.applyAdminRwModifiedValuesSecurity || -1 === summaryCtrl.modifiedByAdminOrReviewerFields.indexOf(\'discountRateYearlyDelta\')\">{{summaryCtrl.review.discountRateYearlyDelta || \'N/A\'}}</span></td><td><span class=\"big\" ng-if=\"summaryCtrl.role !== \'AssetAppraisal\' || !summaryCtrl.applyAdminRwModifiedValuesSecurity || -1 === summaryCtrl.modifiedByAdminOrReviewerFields.indexOf(\'impliedCapRateYearlyDelta\')\">{{summaryCtrl.review.impliedCapRateYearlyDelta || \'N/A\'}}</span></td></tr></tbody></table></div></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6 no-padding\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\"><span translate=\"DISCUSSION.SUMMARY.AVERAGE_CONTRACT_RENT\"></span> <span class=\"big\" ng-if=\"summaryCtrl.role !== \'AssetAppraisal\' || !summaryCtrl.applyAdminRwModifiedValuesSecurity || -1 === summaryCtrl.modifiedByAdminOrReviewerFields.indexOf(\'avgContractRent\')\">{{summaryCtrl.review.avgContractRent === \'N/A\' ? summaryCtrl.review.avgContractRent : (summaryCtrl.review.avgContractRent | currency:undefined:2)}}</span></div><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\"><span translate=\"DISCUSSION.SUMMARY.AVERAGE_MARKET_RENT\"></span> <span class=\"big\" ng-if=\"summaryCtrl.role !== \'AssetAppraisal\' || !summaryCtrl.applyAdminRwModifiedValuesSecurity || -1 === summaryCtrl.modifiedByAdminOrReviewerFields.indexOf(\'avgMarketRent\')\">{{summaryCtrl.review.avgMarketRent === \'N/A\' ? summaryCtrl.review.avgMarketRent : (summaryCtrl.review.avgMarketRent | currency:undefined:2)}}</span></div><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\"><span translate=\"DISCUSSION.SUMMARY.AVERAGE_RENT_GROWTH\"></span> <span class=\"big\" ng-if=\"summaryCtrl.role !== \'AssetAppraisal\' || !summaryCtrl.applyAdminRwModifiedValuesSecurity || -1 === summaryCtrl.modifiedByAdminOrReviewerFields.indexOf(\'avgRentGrowth\')\">{{summaryCtrl.review.avgRentGrowth === \'N/A\' ? summaryCtrl.review.avgRentGrowth : (summaryCtrl.review.avgRentGrowth | number:2 | percentage:undefined:2)}}</span></div></div></div></div><hr><div class=\"rows p-h-xs\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"title m-b\" translate=\"DISCUSSION.SUMMARY.FACTORS_FOR_VALUE_FROM_PRIOR_PERIOD\"></div></div><div class=\"col-lg-2 col-md-3 col-sm-3 col-xs-3 m-b\"><span translate=\"DISCUSSION.SUMMARY.DISCOUNT_RATE\"></span> <span class=\"big\" ng-if=\"summaryCtrl.role !== \'AssetAppraisal\' || !summaryCtrl.applyAdminRwModifiedValuesSecurity || -1 === summaryCtrl.modifiedByAdminOrReviewerFields.indexOf(\'deltaDiscountRate\')\">{{summaryCtrl.review.deltaDiscountRate | currency:undefined:0}}</span></div><div class=\"col-lg-2 col-md-3 col-sm-3 col-xs-3 m-b\"><span translate=\"DISCUSSION.SUMMARY.TERMINAL_CAP_RATE\"></span> <span class=\"big\" ng-if=\"summaryCtrl.role !== \'AssetAppraisal\' || !summaryCtrl.applyAdminRwModifiedValuesSecurity || -1 === summaryCtrl.modifiedByAdminOrReviewerFields.indexOf(\'deltaTerminalCapRate\')\">{{summaryCtrl.review.deltaTerminalCapRate | currency:undefined:0}}</span></div><div class=\"col-lg-2 col-md-3 col-sm-3 col-xs-3 m-b\"><span translate=\"DISCUSSION.SUMMARY.AVERAGE_MARKET_RENT_GROWTH\"></span> <span class=\"big\" ng-if=\"summaryCtrl.role !== \'AssetAppraisal\' || !summaryCtrl.applyAdminRwModifiedValuesSecurity || -1 === summaryCtrl.modifiedByAdminOrReviewerFields.indexOf(\'deltaAvgMarketRentGrowth\')\">{{summaryCtrl.review.deltaAvgMarketRentGrowth | currency:undefined:0}}</span></div><div class=\"col-lg-2 col-md-3 col-sm-3 col-xs-3 m-b\"><span translate=\"DISCUSSION.SUMMARY.DOWNTIME_RENEWAL_PROBABILITY\"></span> <span class=\"big\" ng-if=\"summaryCtrl.role !== \'AssetAppraisal\' || !summaryCtrl.applyAdminRwModifiedValuesSecurity || -1 === summaryCtrl.modifiedByAdminOrReviewerFields.indexOf(\'deltaDowntimeAndRenewalProbability\')\">{{summaryCtrl.review.deltaDowntimeAndRenewalProbability | currency:undefined:0}}</span></div><div class=\"col-lg-2 col-md-3 col-sm-3 col-xs-3 m-b\"><span translate=\"DISCUSSION.SUMMARY.REAL_ESTATE_TAXES\"></span> <span class=\"big\" ng-if=\"summaryCtrl.role !== \'AssetAppraisal\' || !summaryCtrl.applyAdminRwModifiedValuesSecurity || -1 === summaryCtrl.modifiedByAdminOrReviewerFields.indexOf(\'deltaRealEstateTaxes\')\">{{summaryCtrl.review.deltaRealEstateTaxes | currency:undefined:0}}</span></div><div class=\"col-lg-2 col-md-3 col-sm-3 col-xs-3 m-b\"><span translate=\"DISCUSSION.SUMMARY.LEASING_CAPITAL\"></span> <span class=\"big\" ng-if=\"summaryCtrl.role !== \'AssetAppraisal\' || !summaryCtrl.applyAdminRwModifiedValuesSecurity || -1 === summaryCtrl.modifiedByAdminOrReviewerFields.indexOf(\'deltaLeasingCapital\')\">{{summaryCtrl.review.deltaLeasingCapital | currency:undefined:0}}</span></div><div class=\"col-lg-2 col-md-3 col-sm-3 col-xs-3 m-b\"><span translate=\"DISCUSSION.SUMMARY.MARKET_RENTS\"></span> <span class=\"big\" ng-if=\"summaryCtrl.role !== \'AssetAppraisal\' || !summaryCtrl.applyAdminRwModifiedValuesSecurity || -1 === summaryCtrl.modifiedByAdminOrReviewerFields.indexOf(\'deltaMarketRents\')\">{{summaryCtrl.review.deltaMarketRents | currency:undefined:0}}</span></div><div class=\"col-lg-2 col-md-3 col-sm-3 col-xs-3 m-b\"><span translate=\"DISCUSSION.SUMMARY.CONTRACT_RENTS\"></span> <span class=\"big\" ng-if=\"summaryCtrl.role !== \'AssetAppraisal\' || !summaryCtrl.applyAdminRwModifiedValuesSecurity || -1 === summaryCtrl.modifiedByAdminOrReviewerFields.indexOf(\'deltaContractRents\')\">{{summaryCtrl.review.deltaContractRents | currency:undefined:0}}</span></div><div class=\"col-lg-2 col-md-3 col-sm-3 col-xs-3 m-b\"><span translate=\"DISCUSSION.SUMMARY.VACANCY_COLLECTION_LOSS\"></span> <span class=\"big\" ng-if=\"summaryCtrl.role !== \'AssetAppraisal\' || !summaryCtrl.applyAdminRwModifiedValuesSecurity || -1 === summaryCtrl.modifiedByAdminOrReviewerFields.indexOf(\'deltaVacancyAndCollectionLoss\')\">{{summaryCtrl.review.deltaVacancyAndCollectionLoss | currency:undefined:0}}</span></div><div class=\"col-lg-2 col-md-3 col-sm-3 col-xs-3 m-b\"><span translate=\"DISCUSSION.SUMMARY.EXPENSES\"></span> <span class=\"big\" ng-if=\"summaryCtrl.role !== \'AssetAppraisal\' || !summaryCtrl.applyAdminRwModifiedValuesSecurity || -1 === summaryCtrl.modifiedByAdminOrReviewerFields.indexOf(\'deltaExpenses\')\">{{summaryCtrl.review.deltaExpenses | currency:undefined:0}}</span></div><div class=\"col-lg-2 col-md-3 col-sm-3 col-xs-3 m-b\"><span translate=\"DISCUSSION.SUMMARY.BUILDING_CAPITAL\"></span> <span class=\"big\" ng-if=\"summaryCtrl.role !== \'AssetAppraisal\' || !summaryCtrl.applyAdminRwModifiedValuesSecurity || -1 === summaryCtrl.modifiedByAdminOrReviewerFields.indexOf(\'deltaBuildingCapital\')\">{{summaryCtrl.review.deltaBuildingCapital | currency:undefined:0}}</span></div><div class=\"col-lg-2 col-md-3 col-sm-3 col-xs-3 m-b\"><span translate=\"DISCUSSION.SUMMARY.OTHER\"></span> <span class=\"big\" ng-if=\"summaryCtrl.role !== \'AssetAppraisal\' || !summaryCtrl.applyAdminRwModifiedValuesSecurity || -1 === summaryCtrl.modifiedByAdminOrReviewerFields.indexOf(\'deltaOther\')\">{{summaryCtrl.review.deltaOther | currency:undefined:0}}</span></div></div></div><hr><div class=\"rows p-h-xs\"><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12 padding-left\"><div class=\"title m-b\">P/P {{\'DOCUMENTS.VALUE_CHANGE_EXPLANATION\' | translate}}</div><div class=\"separator pp-explanation\"><p ng-if=\"summaryCtrl.role !== \'AssetAppraisal\' || !summaryCtrl.applyAdminRwModifiedValuesSecurity || -1 === summaryCtrl.modifiedByAdminOrReviewerFields.indexOf(\'ppValueChangeExplanation\')\">{{summaryCtrl.review.ppValueChangeExplanation}}</p></div></div><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12 yy-container\"><div class=\"title m-b\">Y/Y {{\'DOCUMENTS.VALUE_CHANGE_EXPLANATION\' | translate}}</div><div class=\"yy-explanation\"><p ng-if=\"summaryCtrl.role !== \'AssetAppraisal\' || !summaryCtrl.applyAdminRwModifiedValuesSecurity || -1 === summaryCtrl.modifiedByAdminOrReviewerFields.indexOf(\'yyValueChangeExplanation\')\">{{summaryCtrl.review.yyValueChangeExplanation}}</p></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/states/valuations/review/documents-upload/documents-upload.html","<div class=\"wrapper wrapper-content no-padding-top less-margin\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 m-t-xl m-b-xl\"><p translate=\"DOCUMENTS_UPLOAD.UPLOAD_DRAFT_VERSION\" ng-if=\"documentsUploadCtrl.review.status != \'ValuationSignedOff\' && documentsUploadCtrl.review.status != \'FinalDocumentsUploaded\' && documentsUploadCtrl.review.status != \'FinalFormFilled\' && documentsUploadCtrl.review.status != \'Finished\'\"></p><p translate=\"DOCUMENTS_UPLOAD.UPLOAD_FINAL_VERSION\" ng-if=\"documentsUploadCtrl.review.status == \'ValuationSignedOff\' || documentsUploadCtrl.review.status == \'FinalDocumentsUploaded\' || documentsUploadCtrl.review.status == \'FinalFormFilled\' || documentsUploadCtrl.review.status == \'Finished\'\"></p></div><form name=\"documentsUploadCtrl.documentsUploadForm\" class=\"\" role=\"form\" novalidate=\"\"><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 m-b-xl\"><div class=\"form-group\" ng-class=\"{\'missing-file\' : documentsUploadCtrl.submittedFiles && (documentsUploadCtrl.missingpremise || documentsUploadCtrl.duplicatepremise)}\"><label translate=\"DOCUMENTS_UPLOAD.AS_IS_ARGUS_FILE\"></label><td-file-upload class=\"upload-box documents\" files=\"[]\" files-to-upload=\"documentsUploadCtrl.argusFile\" files-to-delete=\"[]\" valid-types=\"[\'.avux\', \'.SF\', \'.sf\']\" premiseoptions=\"documentsUploadCtrl.premiseoptions\" selectedpremiseoptions=\"documentsUploadCtrl.selectedpremiseoptions\" max-number-files=\"6\"></td-file-upload></div></div><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 m-b-xl\"><div class=\"form-group\" ng-class=\"{\'missing-file\' : documentsUploadCtrl.submittedFiles && documentsUploadCtrl.valuationReportFile.length != 1}\"><label translate=\"DOCUMENTS_UPLOAD.VALUATION_REPORT\"></label><td-file-upload class=\"upload-box documents\" files=\"[]\" files-to-upload=\"documentsUploadCtrl.valuationReportFile\" valid-types=\"[\'application/pdf\']\" max-number-files=\"1\"></td-file-upload></div></div><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 m-b-xl\"><div class=\"form-group\"><label translate=\"DOCUMENTS_UPLOAD.OTHER_DOCUMENTS\"></label><td-file-upload class=\"upload-box documents\" files=\"[]\" files-to-upload=\"documentsUploadCtrl.otherFiles\"></td-file-upload></div></div></form></div></div></div></div><div class=\"row\" actions=\"[\'AP_UploadDocuments\']\" ng-if=\"(documentsUploadCtrl.review.status === \'Created\' || documentsUploadCtrl.review.status === \'FormFilled\' || documentsUploadCtrl.review.status === \'ManagerCommented\' || documentsUploadCtrl.review.status === \'FinalFormFilled\' || documentsUploadCtrl.review.status === \'ReviewerCommented\' || documentsUploadCtrl.review.status === \'SubmittedToAppraiser\' || documentsUploadCtrl.review.status === \'ValuationUpdated\' || documentsUploadCtrl.review.status === \'ReviewerApproveValuation\' || documentsUploadCtrl.review.status === \'DocumentsUploaded\' || documentsUploadCtrl.review.status === \'DocumentsUpdated\' || documentsUploadCtrl.review.status === \'ManagerApproveValuation\') && !reviewCtrl.readOnly && !documentsUploadCtrl.isAdmin && (documentsUploadCtrl.roleName == \'AssetReview\' || documentsUploadCtrl.roleName == \'AssetAppraisal\')\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"text-right m-b-lg\"><button class=\"btn btn-w-m btn-normal\" translate=\"DOCUMENTS_UPLOAD.SUBMIT_FILES\" ng-click=\"documentsUploadCtrl.updateDocument(\'Draft\')\"></button></div></div></div><div class=\"row\" review-checker=\"documentsUploadCtrl.review\" actions=\"[\'AP_UploadDocuments\']\" ng-if=\"documentsUploadCtrl.review.status === \'Created\' && !reviewCtrl.readOnly && documentsUploadCtrl.roleName !== \'AssetAppraisal\' && documentsUploadCtrl.roleName !== \'AssetReview\'\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"text-right m-b-lg\"><button class=\"btn btn-w-m btn-normal\" translate=\"DOCUMENTS_UPLOAD.SUBMIT_FILES\" ng-click=\"documentsUploadCtrl.upload()\"></button></div></div></div><div class=\"row\" review-checker=\"documentsUploadCtrl.review\" actions=\"[\'AP_Submit\', \'RW_Submit\']\" ng-if=\"documentsUploadCtrl.review.status === \'CommentsAnswered\' && !reviewCtrl.readOnly\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"text-right m-b-lg\"><button class=\"btn btn-w-m btn-normal\" translate=\"DOCUMENTS_UPLOAD.SUBMIT_FILES\" ng-click=\"documentsUploadCtrl.updateDocuments()\"></button></div></div></div><div class=\"row\" review-checker=\"documentsUploadCtrl.review\" actions=\"[\'AP_UploadFinalDocuments\']\" ng-if=\"!reviewCtrl.readOnly && documentsUploadCtrl.review.status !== \'Finished\'\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"text-right m-b-lg\"><button class=\"btn btn-w-m btn-normal\" translate=\"DOCUMENTS_UPLOAD.SUBMIT_FILES\" ng-click=\"documentsUploadCtrl.uploadFinalDocuments()\"></button></div></div></div><div class=\"row\" ng-if=\"documentsUploadCtrl.review.status === \'FinalDocumentsUploaded\' && !reviewCtrl.readOnly\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"text-right m-b-lg\"><button class=\"btn btn-w-m btn-normal\" translate=\"DOCUMENTS_UPLOAD.SUBMIT_FILES\" ng-click=\"documentsUploadCtrl.amendUpdate(\'Final\')\"></button></div></div></div><div class=\"row\" td-security=\"[\'Admin\']\" ng-if=\"documentsUploadCtrl.review.status !== \'Created\' && documentsUploadCtrl.review.status !== \'DocumentsUploaded\' && documentsUploadCtrl.review.status !== \'CommentsAnswered\' && documentsUploadCtrl.review.status !== \'DocumentsUpdated\' && documentsUploadCtrl.review.status !== \'ManagerApproveValuation\' && documentsUploadCtrl.review.status !== \'ValuationSignedOff\' && documentsUploadCtrl.review.status !== \'FinalDocumentsUploaded\'\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"text-right m-b-lg\"><button class=\"btn btn-w-m btn-normal\" translate=\"DOCUMENTS_UPLOAD.UPDATE_FILES\" ng-click=\"documentsUploadCtrl.updateDocument()\"></button></div></div></div><div class=\"row\" td-security=\"[\'Admin\']\" ng-if=\"documentsUploadCtrl.review.status == \'ManagerApproveValuation\'\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"text-right m-b-lg\"><button class=\"btn btn-w-m btn-normal\" translate=\"DOCUMENTS_UPLOAD.SUBMIT_FILES\" ng-click=\"documentsUploadCtrl.upload()\"></button></div></div></div></div>");
$templateCache.put("app/states/valuations/review/documents/documents.html","<div class=\"wrapper wrapper-content no-padding-top less-margin documents-form\"><form name=\"documentsCtrl.executiveSummaryForm\" class=\"executive-summary-form form-horizontal\" role=\"form\" confirm-leave=\"\" extra-check=\"documentsCtrl.newDocuments\" novalidate=\"\" ng-submit=\"documentsCtrl.executiveSummaryForm.$valid && !documentsCtrl.invalidTotalChange && documentsCtrl.validPPNotes && documentsCtrl.validYYNotes && documentsCtrl.submitReview()\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><h3 class=\"asset-name m-b\" translate=\"DOCUMENTS.EXECUTIVE_SUMMARY\"></h3></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 m-b\"><span class=\"big m-r-xs\" translate=\"DOCUMENTS.VALUE_CONCLUSION\"></span> <span class=\"date\">{{documentsCtrl.review.createdOn | formatDate: \'MMM DD-YYYY\'}}</span></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"row\"><div class=\"col-lg-4 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><label><span translate=\"DOCUMENTS.PREVIOUS_VALUE\"></span></label></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><input class=\"form-control\" type=\"text\" ng-model=\"documentsCtrl.review.appraisalPrevious\" currency-values=\"\" format=\"currency\" ng-pattern=\"/^[\\-]?\\$?(?:([0-9]\\,?)+(?:\\.[0-9]{0,2})?)?$/\" review-checker=\"documentsCtrl.review\" actions=\"[\'AP_Submit\', \'AP_FillFinalForm\', \'RW_Comment\', \'RW_Submit\', \'LRW_Comment\', \'LRW_Approve\', \'RW_ArchiveDocuments\', \'LRW_Reject\', \'ADMIN_UpdateDocuments\']\" behaviour=\"\'disable\'\" ng-disabled=\"(documentsCtrl.applyAdminRwModifiedValuesSecurity && (-1 !== documentsCtrl.AdminRwModifiedFields.indexOf(\'appraisalPrevious\'))) || !documentsCtrl.appraisalPreviousInitialValue || documentsCtrl.applyAppraiserPrevValuesSecurity || (documentsCtrl.role == \'AssetManagement\' && documentsCtrl.review.status == \'ManagerCommented\') || (documentsCtrl.role == \'AssetAppraisal\' && (documentsCtrl.review.status == \'ValuationSignedOff\' || documentsCtrl.review.status == \'FinalDocumentsUploaded\' || documentsCtrl.review.status == \'FinalFormFilled\'))\" ng-required=\"(documentsCtrl.review.quarterOfCycle > 1 && documentsCtrl.previousValuation && !documentsCtrl.applyAppraiserPrevValuesSecurity) && ((documentsCtrl.role !== \'AssetAppraisal\') || (documentsCtrl.role === \'AssetAppraisal\' && (-1 === documentsCtrl.AdminRwModifiedFields.indexOf(\'appraisalPrevious\'))))\"></div></div></div><div class=\"col-lg-4 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-4\"><label><span translate=\"DOCUMENTS.DRAFT_VALUE\"></span></label></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><input class=\"form-control\" type=\"text\" ng-model=\"documentsCtrl.review.appraisalDraft\" currency-values=\"\" format=\"currency\" ng-pattern=\"/^[\\-]?\\$?(?:([0-9]\\,?)+(?:\\.[0-9]{0,2})?)$/\" review-checker=\"documentsCtrl.review\" actions=\"[\'AP_Submit\', \'AP_FillFinalForm\', \'RW_Comment\', \'RW_Submit\', \'LRW_Comment\', \'LRW_Approve\', \'RW_ArchiveDocuments\', \'LRW_Reject\', \'ADMIN_UpdateDocuments\']\" behaviour=\"\'disable\'\" ng-disabled=\"(documentsCtrl.applyAdminRwModifiedValuesSecurity && (-1 !== documentsCtrl.AdminRwModifiedFields.indexOf(\'appraisalDraft\'))) || (documentsCtrl.role == \'AssetManagement\' && documentsCtrl.review.status == \'ManagerCommented\') || (documentsCtrl.role == \'AssetAppraisal\' && (documentsCtrl.review.status == \'ValuationSignedOff\' || documentsCtrl.review.status == \'FinalDocumentsUploaded\' || documentsCtrl.review.status == \'FinalFormFilled\'))\" ng-required=\"(documentsCtrl.role !== \'AssetAppraisal\') || (documentsCtrl.role === \'AssetAppraisal\' && (-1 === documentsCtrl.AdminRwModifiedFields.indexOf(\'appraisalDraft\')))\"></div></div></div><div class=\"col-lg-4 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><label><span translate=\"DOCUMENTS.FINAL_VALUE\"></span></label></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><input class=\"form-control\" type=\"text\" ng-model=\"documentsCtrl.review.appraisalFinal\" currency-values=\"\" format=\"currency\" ng-pattern=\"/^[\\-]?\\$?(?:([0-9]\\,?)+(?:\\.[0-9]{0,2})?)?$/\" review-checker=\"documentsCtrl.review\" actions=\"[\'AP_Submit\', \'AP_FillFinalForm\', \'RW_Comment\', \'RW_Submit\', \'LRW_Comment\', \'LRW_Approve\', \'RW_ArchiveDocuments\', \'LRW_Reject\', \'ADMIN_UpdateDocuments\']\" behaviour=\"\'disable\'\" ng-disabled=\"(documentsCtrl.role == \'AssetManagement\' && documentsCtrl.review.status == \'ManagerCommented\') || (documentsCtrl.role == \'AssetAppraisal\' || documentsCtrl.role == \'AssetReview\')\" ng-required=\"documentsCtrl.role !== \'AssetAppraisal\' && (documentsCtrl.review.status == \'FinalDocumentsUploaded\'|| documentsCtrl.review.status == \'Finished\')\"></div></div></div></div><div class=\"row\"><div class=\"col-lg-4 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><label><span>{{\"DOCUMENTS.LAND\" | translate}} & {{\"DOCUMENTS.OTHER_ADJ\" | translate}}</span></label></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><input class=\"form-control\" type=\"text\" ng-model=\"documentsCtrl.review.landAndOtherAdj\" currency-values=\"\" format=\"currency\" currency-options=\'{\"negatives\": true}\' ng-pattern=\"/^(([\\-]?\\$?(?:([0-9]\\,?)+(?:\\.[0-9]{0,2})?))|(N\\/\\A))?$/\" review-checker=\"documentsCtrl.review\" actions=\"[\'AP_Submit\', \'AP_FillFinalForm\', \'RW_Comment\', \'RW_Submit\', \'LRW_Comment\', \'LRW_Approve\', \'RW_ArchiveDocuments\', \'LRW_Reject\', \'ADMIN_UpdateDocuments\']\" behaviour=\"\'disable\'\" ng-disabled=\"(documentsCtrl.applyAdminRwModifiedValuesSecurity && (-1 !== documentsCtrl.AdminRwModifiedFields.indexOf(\'landAndOtherAdj\'))) || (documentsCtrl.role == \'AssetManagement\' && documentsCtrl.review.status == \'ManagerCommented\') || (documentsCtrl.role == \'AssetAppraisal\' && (documentsCtrl.review.status == \'ValuationSignedOff\' || documentsCtrl.review.status == \'FinalDocumentsUploaded\' || documentsCtrl.review.status == \'FinalFormFilled\'))\" ng-required=\"(documentsCtrl.role !== \'AssetAppraisal\') || (documentsCtrl.role === \'AssetAppraisal\' && (-1 === documentsCtrl.AdminRwModifiedFields.indexOf(\'landAndOtherAdj\')))\"></div></div></div><div class=\"col-lg-4 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><label><span translate=\"DOCUMENTS.DISCOUNTED_CASH_FLOW\"></span></label></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><input class=\"form-control\" type=\"text\" ng-model=\"documentsCtrl.review.discountedCashFlowAnalysis\" currency-values=\"\" format=\"currency\" currency-options=\'{\"negatives\": true}\' ng-pattern=\"/^(([\\-]?\\$?(?:([0-9]\\,?)+(?:\\.[0-9]{0,2})?))|(N\\/\\A))?$/\" review-checker=\"documentsCtrl.review\" actions=\"[\'AP_Submit\', \'AP_FillFinalForm\', \'RW_Comment\', \'RW_Submit\', \'LRW_Comment\', \'LRW_Approve\', \'RW_ArchiveDocuments\', \'LRW_Reject\', \'ADMIN_UpdateDocuments\']\" behaviour=\"\'disable\'\" ng-disabled=\"(documentsCtrl.applyAdminRwModifiedValuesSecurity && (-1 !== documentsCtrl.AdminRwModifiedFields.indexOf(\'discountedCashFlowAnalysis\'))) || (documentsCtrl.role == \'AssetManagement\' && documentsCtrl.review.status == \'ManagerCommented\') || (documentsCtrl.role == \'AssetAppraisal\' && (documentsCtrl.review.status == \'ValuationSignedOff\' || documentsCtrl.review.status == \'FinalDocumentsUploaded\' || documentsCtrl.review.status == \'FinalFormFilled\'))\" ng-required=\"(documentsCtrl.role !== \'AssetAppraisal\') || (documentsCtrl.role === \'AssetAppraisal\' && (-1 === documentsCtrl.AdminRwModifiedFields.indexOf(\'discountedCashFlowAnalysis\')))\"></div></div></div><div class=\"col-lg-4 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><label><span translate=\"DOCUMENTS.DIRECT_CAPITALIZATION\"></span></label></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><input class=\"form-control\" type=\"text\" ng-model=\"documentsCtrl.review.directCapitalizationAnalysis\" currency-values=\"\" format=\"currency\" currency-options=\'{\"negatives\": true}\' ng-pattern=\"/^(([\\-]?\\$?(?:([0-9]\\,?)+(?:\\.[0-9]{0,2})?))|(N\\/\\A))?$/\" review-checker=\"documentsCtrl.review\" actions=\"[\'AP_Submit\', \'AP_FillFinalForm\', \'RW_Comment\', \'RW_Submit\', \'LRW_Comment\', \'LRW_Approve\', \'RW_ArchiveDocuments\', \'LRW_Reject\', \'ADMIN_UpdateDocuments\']\" behaviour=\"\'disable\'\" ng-disabled=\"(documentsCtrl.applyAdminRwModifiedValuesSecurity && (-1 !== documentsCtrl.AdminRwModifiedFields.indexOf(\'directCapitalizationAnalysis\'))) || (documentsCtrl.role == \'AssetManagement\' && documentsCtrl.review.status == \'ManagerCommented\') || (documentsCtrl.role == \'AssetAppraisal\' && (documentsCtrl.review.status == \'ValuationSignedOff\' || documentsCtrl.review.status == \'FinalDocumentsUploaded\' || documentsCtrl.review.status == \'FinalFormFilled\'))\" ng-required=\"(documentsCtrl.role !== \'AssetAppraisal\') || (documentsCtrl.role === \'AssetAppraisal\' && (-1 === documentsCtrl.AdminRwModifiedFields.indexOf(\'directCapitalizationAnalysis\')))\"></div></div></div><div class=\"col-lg-4 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><label><span translate=\"DOCUMENTS.STABILIZED_VALUE\"></span></label></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><input class=\"form-control\" type=\"text\" ng-model=\"documentsCtrl.review.stabilizedValue\" currency-values=\"\" format=\"currency\" currency-options=\'{\"negatives\": true}\' ng-pattern=\"/^(([\\-]?\\$?(?:([0-9]\\,?)+(?:\\.[0-9]{0,2})?))|(N\\/\\A))?$/\" review-checker=\"documentsCtrl.review\" actions=\"[\'AP_Submit\', \'AP_FillFinalForm\', \'RW_Comment\', \'RW_Submit\', \'LRW_Comment\', \'LRW_Approve\', \'RW_ArchiveDocuments\', \'LRW_Reject\', \'ADMIN_UpdateDocuments\']\" behaviour=\"\'disable\'\" ng-disabled=\"(documentsCtrl.applyAdminRwModifiedValuesSecurity && (-1 !== documentsCtrl.AdminRwModifiedFields.indexOf(\'stabilizedValue\'))) || (documentsCtrl.role == \'AssetManagement\' && documentsCtrl.review.status == \'ManagerCommented\') || (documentsCtrl.role == \'AssetAppraisal\' && (documentsCtrl.review.status == \'ValuationSignedOff\' || documentsCtrl.review.status == \'FinalDocumentsUploaded\' || documentsCtrl.review.status == \'FinalFormFilled\'))\" ng-required=\"(documentsCtrl.role !== \'AssetAppraisal\') || (documentsCtrl.role === \'AssetAppraisal\' && (-1 === documentsCtrl.AdminRwModifiedFields.indexOf(\'stabilizedValue\')))\"></div></div></div><div class=\"col-lg-4 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><label><span translate=\"DOCUMENTS.STABILIZED_VALUE_SF\"></span></label></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><input class=\"form-control\" type=\"text\" ng-model=\"documentsCtrl.review.stabilizedValueSf\" currency-values=\"\" format=\"currency\" currency-options=\'{\"negatives\": true, \"decimals\": true}\' ng-pattern=\"/^(([\\-]?\\$?(?:([0-9]\\,?)+(?:\\.[0-9]{0,2})?))|(N\\/\\A))?$/\" review-checker=\"documentsCtrl.review\" actions=\"[\'AP_Submit\', \'AP_FillFinalForm\', \'RW_Comment\', \'RW_Submit\', \'LRW_Comment\', \'LRW_Approve\', \'RW_ArchiveDocuments\', \'LRW_Reject\', \'ADMIN_UpdateDocuments\']\" behaviour=\"\'disable\'\" ng-disabled=\"documentsCtrl.disableStabilizedValueSf || (documentsCtrl.applyAdminRwModifiedValuesSecurity && (-1 !== documentsCtrl.AdminRwModifiedFields.indexOf(\'stabilizedValueSf\'))) || (documentsCtrl.role == \'AssetManagement\' && documentsCtrl.review.status == \'ManagerCommented\') || documentsCtrl.role != \'Admin\'\" ng-required=\"(documentsCtrl.role !== \'AssetAppraisal\') || (documentsCtrl.role === \'AssetAppraisal\' && (-1 === documentsCtrl.AdminRwModifiedFields.indexOf(\'stabilizedValueSf\')))\"></div></div></div><div class=\"col-lg-4 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><label><span translate=\"DOCUMENTS.ABSORPTION_PERIOD\"></span></label></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><input class=\"form-control\" type=\"text\" ng-model=\"documentsCtrl.review.absorptionPeriod\" ng-pattern=\"/^((\\d*)|(N\\/\\A))$/\" review-checker=\"documentsCtrl.review\" actions=\"[\'AP_Submit\', \'AP_FillFinalForm\', \'RW_Comment\', \'RW_Submit\', \'LRW_Comment\', \'LRW_Approve\', \'RW_ArchiveDocuments\', \'LRW_Reject\', \'ADMIN_UpdateDocuments\']\" behaviour=\"\'disable\'\" ng-disabled=\"(documentsCtrl.applyAdminRwModifiedValuesSecurity && (-1 !== documentsCtrl.AdminRwModifiedFields.indexOf(\'absorptionPeriod\'))) || (documentsCtrl.role == \'AssetManagement\' && documentsCtrl.review.status == \'ManagerCommented\') || (documentsCtrl.role == \'AssetAppraisal\' && (documentsCtrl.review.status == \'ValuationSignedOff\' || documentsCtrl.review.status == \'FinalDocumentsUploaded\' || documentsCtrl.review.status == \'FinalFormFilled\'))\" ng-required=\"(documentsCtrl.role !== \'AssetAppraisal\') || (documentsCtrl.role === \'AssetAppraisal\' && (-1 === documentsCtrl.AdminRwModifiedFields.indexOf(\'absorptionPeriod\')))\"></div></div></div><div class=\"col-lg-4 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><label><span translate=\"DOCUMENTS.SALES_COMPARISON_APPROACH\"></span></label></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><input class=\"form-control\" type=\"text\" ng-model=\"documentsCtrl.review.salesComparisonApproach\" currency-values=\"\" format=\"currency\" currency-options=\'{\"negatives\": true}\' ng-pattern=\"/^(([\\-]?\\$?(?:([0-9]\\,?)+(?:\\.[0-9]{0,2})?))|(N\\/\\A))?$/\" review-checker=\"documentsCtrl.review\" actions=\"[\'AP_Submit\', \'AP_FillFinalForm\', \'RW_Comment\', \'RW_Submit\', \'LRW_Comment\', \'LRW_Approve\', \'RW_ArchiveDocuments\', \'LRW_Reject\', \'ADMIN_UpdateDocuments\']\" behaviour=\"\'disable\'\" ng-disabled=\"(documentsCtrl.applyAdminRwModifiedValuesSecurity && (-1 !== documentsCtrl.AdminRwModifiedFields.indexOf(\'salesComparisonApproach\'))) || (documentsCtrl.role == \'AssetManagement\' && documentsCtrl.review.status == \'ManagerCommented\') || (documentsCtrl.role == \'AssetAppraisal\' && (documentsCtrl.review.status == \'ValuationSignedOff\' || documentsCtrl.review.status == \'FinalDocumentsUploaded\' || documentsCtrl.review.status == \'FinalFormFilled\'))\" ng-required=\"(documentsCtrl.role !== \'AssetAppraisal\') || (documentsCtrl.role === \'AssetAppraisal\' && (-1 === documentsCtrl.AdminRwModifiedFields.indexOf(\'salesComparisonApproach\')))\"></div></div></div><div class=\"col-lg-4 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><label><span translate=\"DOCUMENTS.COST_APPROACH\"></span></label></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><input class=\"form-control\" type=\"text\" ng-model=\"documentsCtrl.review.costApproach\" currency-values=\"\" format=\"currency\" currency-options=\'{\"negatives\": true}\' ng-pattern=\"/^(([\\-]?\\$?(?:([0-9]\\,?)+(?:\\.[0-9]{0,2})?))|(N\\/\\A))?$/\" review-checker=\"documentsCtrl.review\" actions=\"[\'AP_Submit\', \'AP_FillFinalForm\', \'RW_Comment\', \'RW_Submit\', \'LRW_Comment\', \'LRW_Approve\', \'RW_ArchiveDocuments\', \'LRW_Reject\', \'ADMIN_UpdateDocuments\']\" behaviour=\"\'disable\'\" ng-disabled=\"(documentsCtrl.applyAdminRwModifiedValuesSecurity && (-1 !== documentsCtrl.AdminRwModifiedFields.indexOf(\'costApproach\'))) || (documentsCtrl.role == \'AssetManagement\' && documentsCtrl.review.status == \'ManagerCommented\') || (documentsCtrl.role == \'AssetAppraisal\' && (documentsCtrl.review.status == \'ValuationSignedOff\' || documentsCtrl.review.status == \'FinalDocumentsUploaded\' || documentsCtrl.review.status == \'FinalFormFilled\'))\" ng-required=\"(documentsCtrl.role !== \'AssetAppraisal\') || (documentsCtrl.role === \'AssetAppraisal\' && (-1 === documentsCtrl.AdminRwModifiedFields.indexOf(\'costApproach\')))\"></div></div></div><div class=\"col-lg-4 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\" ng-show=\"( documentsCtrl.review && documentsCtrl.review.asset && documentsCtrl.review.asset.valuationFrequency && ( documentsCtrl.review.asset.valuationFrequency === \'Annually\' || ( (documentsCtrl.review.asset.scheduleOption && documentsCtrl.review.asset.valuation && documentsCtrl.review.asset.valuation.quarter && ((documentsCtrl.review.asset.valuationFrequency === \'Quarterly\' && documentsCtrl.review.asset.scheduleOption === documentsCtrl.review.asset.valuation.quarter) || (documentsCtrl.review.asset.valuationFrequency === \'SemiAnnually\' && ((documentsCtrl.review.asset.scheduleOption === 1 && (documentsCtrl.review.asset.valuation.quarter === 1 || documentsCtrl.review.asset.valuation.quarter === 2)) || (documentsCtrl.review.asset.scheduleOption === 2 && (documentsCtrl.review.asset.valuation.quarter === 3 || documentsCtrl.review.asset.valuation.quarter === 4))))) ) ) ) )\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><label><span translate=\"DOCUMENTS.INSURABLE_VALUE\"></span></label></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><input class=\"form-control\" type=\"text\" ng-model=\"documentsCtrl.review.insurableValue\" currency-values=\"\" format=\"currency\" currency-options=\'{\"negatives\": true}\' ng-pattern=\"/^(([\\-]?\\$?(?:([0-9]\\,?)+(?:\\.[0-9]{0,2})?))|(N\\/\\A))?$/\" review-checker=\"documentsCtrl.review\" actions=\"[\'AP_Submit\', \'AP_FillFinalForm\', \'RW_Comment\', \'RW_Submit\', \'LRW_Comment\', \'LRW_Approve\', \'RW_ArchiveDocuments\', \'LRW_Reject\', \'ADMIN_UpdateDocuments\']\" behaviour=\"\'disable\'\" ng-disabled=\"(documentsCtrl.applyAdminRwModifiedValuesSecurity && (-1 !== documentsCtrl.AdminRwModifiedFields.indexOf(\'insurableValue\'))) || (documentsCtrl.role == \'AssetManagement\' && documentsCtrl.review.status == \'ManagerCommented\') || (documentsCtrl.role == \'AssetAppraisal\' && (documentsCtrl.review.status == \'ValuationSignedOff\' || documentsCtrl.review.status == \'FinalDocumentsUploaded\' || documentsCtrl.review.status == \'FinalFormFilled\'))\" ng-required=\"(documentsCtrl.role !== \'AssetAppraisal\') || (documentsCtrl.role === \'AssetAppraisal\' && (-1 === documentsCtrl.AdminRwModifiedFields.indexOf(\'insurableValue\')))\"></div></div></div></div><hr><div class=\"row\"><div class=\"col-lg-3 col-md-6 col-sm-6 col-xs-6\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding m-b-sm\"><span class=\"big\" translate=\"DOCUMENTS.PRIOR_PERIOD_TO_CURRENT\"></span></div><div class=\"form-group\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><label><span translate=\"DOCUMENTS.PERCENTAGE_CHANGE\"></span></label></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><input class=\"form-control\" type=\"text\" ng-model=\"documentsCtrl.review.appraisalPeriodDelta\" percentage-values=\"\" format=\"percentage\" maxlength=\"8\" percentage-options=\'{\"negatives\": true, \"nullable\": true}\' ng-pattern=\"/^([\\-]?(?:[0-9]+(?:\\.[0-9]{0,2})?)?[\\%]?)|(N/\\A)$/\" review-checker=\"documentsCtrl.review\" actions=\"[\'AP_Submit\', \'AP_FillFinalForm\', \'RW_Comment\', \'RW_Submit\', \'LRW_Comment\', \'LRW_Approve\', \'RW_ArchiveDocuments\', \'LRW_Reject\', \'ADMIN_UpdateDocuments\']\" behaviour=\"\'disable\'\" ng-disabled=\"documentsCtrl.applyAppraiserPrevValuesSecurity || (documentsCtrl.role == \'AssetManagement\' && documentsCtrl.review.status == \'ManagerCommented\') || (documentsCtrl.role != \'Admin\')\"></div></div><div class=\"form-group no-margin-bottom\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><label><span translate=\"DOCUMENTS.ACTUAL_DOLLAR_CHANGE\"></span></label></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><input class=\"form-control\" type=\"text\" ng-model=\"documentsCtrl.review.appraisalPeriodDeltaValue\" currency-values=\"\" format=\"currency\" currency-options=\'{\"negatives\": true, \"nullable\": true}\' ng-pattern=\"/^([\\-]?\\$?(?:([0-9]\\,?)+(?:\\.[0-9]{0,2})?)?)|(N/\\A)$/\" review-checker=\"documentsCtrl.review\" actions=\"[\'AP_Submit\', \'AP_FillFinalForm\', \'RW_Comment\', \'RW_Submit\', \'LRW_Comment\', \'LRW_Approve\', \'RW_ArchiveDocuments\', \'LRW_Reject\', \'ADMIN_UpdateDocuments\']\" behaviour=\"\'disable\'\" ng-disabled=\"documentsCtrl.applyAppraiserPrevValuesSecurity || (documentsCtrl.role == \'AssetManagement\' && documentsCtrl.review.status == \'ManagerCommented\') || (documentsCtrl.role != \'Admin\')\"></div></div></div><div class=\"col-lg-3 col-md-6 col-sm-6 col-xs-6\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding m-b-sm\"><span class=\"big\" translate=\"DOCUMENTS.PRIOR_YEAR_TO_CURRENT\"></span></div><div class=\"form-group\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><label><span translate=\"DOCUMENTS.PERCENTAGE_CHANGE\"></span></label></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><input class=\"form-control\" type=\"text\" ng-model=\"documentsCtrl.review.appraisalYearlyDelta\" percentage-values=\"\" format=\"percentage\" maxlength=\"8\" percentage-options=\'{\"negatives\": true, \"nullable\": true}\' ng-pattern=\"/^([\\-]?(?:[0-9]+(?:\\.[0-9]{0,2})?)?[\\%]?)|(N/\\A)$/\" review-checker=\"documentsCtrl.review\" actions=\"[\'AP_Submit\', \'AP_FillFinalForm\', \'RW_Comment\', \'RW_Submit\', \'LRW_Comment\', \'LRW_Approve\', \'RW_ArchiveDocuments\', \'LRW_Reject\', \'ADMIN_UpdateDocuments\']\" behaviour=\"\'disable\'\" ng-disabled=\"documentsCtrl.applyAppraiserPrevValuesSecurity || (documentsCtrl.role == \'AssetManagement\' && documentsCtrl.review.status == \'ManagerCommented\') || (documentsCtrl.role != \'Admin\')\" ng-required=\"((documentsCtrl.review.asset.valuationFrequency === \'Annually\' && documentsCtrl.review.quarterOfCycle > 1) || (documentsCtrl.review.asset.valuationFrequency !== \'Annually\' && documentsCtrl.review.quarterOfCycle > 4)) && documentsCtrl.previousYearlyValuation && (documentsCtrl.role !== \'AssetAppraisal\' || (documentsCtrl.role === \'AssetAppraisal\' && (-1 === documentsCtrl.AdminRwModifiedFields.indexOf(\'appraisalYearlyDelta\'))))\"></div></div><div class=\"form-group no-margin-bottom\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><label><span translate=\"DOCUMENTS.ACTUAL_DOLLAR_CHANGE\"></span></label></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><input class=\"form-control\" type=\"text\" ng-model=\"documentsCtrl.review.appraisalYearlyDeltaValue\" currency-values=\"\" format=\"currency\" currency-options=\'{\"negatives\": true, \"nullable\": true}\' ng-pattern=\"/^([\\-]?\\$?(?:([0-9]\\,?)+(?:\\.[0-9]{0,2})?)?)|(N/\\A)$/\" review-checker=\"documentsCtrl.review\" actions=\"[\'AP_Submit\', \'AP_FillFinalForm\', \'RW_Comment\', \'RW_Submit\', \'LRW_Comment\', \'LRW_Approve\', \'RW_ArchiveDocuments\', \'LRW_Reject\', \'ADMIN_UpdateDocuments\']\" behaviour=\"\'disable\'\" ng-disabled=\"documentsCtrl.applyAppraiserPrevValuesSecurity || (documentsCtrl.role == \'AssetManagement\' && documentsCtrl.review.status == \'ManagerCommented\') || (documentsCtrl.role != \'Admin\')\" ng-required=\"((documentsCtrl.review.asset.valuationFrequency === \'Annually\' && documentsCtrl.review.quarterOfCycle > 1) || (documentsCtrl.review.asset.valuationFrequency !== \'Annually\' && documentsCtrl.review.quarterOfCycle > 4)) && documentsCtrl.previousYearlyValuation && (documentsCtrl.role !== \'AssetAppraisal\' || (documentsCtrl.role === \'AssetAppraisal\' && (-1 === documentsCtrl.AdminRwModifiedFields.indexOf(\'appraisalYearlyDeltaValue\'))))\"></div></div></div></div><hr><div class=\"row\"><div class=\"col-lg-2 col-md-4 col-sm-4 col-xs-4\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding m-b-sm\"><span class=\"big\" translate=\"DOCUMENTS.STABILIZED_CAP_RATE\"></span></div><div class=\"form-group\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><label><span translate=\"DOCUMENTS.CURRENT_RATE\"></span></label></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><input class=\"form-control\" type=\"text\" ng-model=\"documentsCtrl.review.stabilizedCapRate\" percentage-values=\"\" format=\"percentage\" maxlength=\"8\" ng-pattern=\"/^(([\\-]?(?:[0-9]+(?:\\.[0-9]{0,2})?)[\\%]?)|(N\\/\\A))$/\" review-checker=\"documentsCtrl.review\" actions=\"[\'AP_Submit\', \'AP_FillFinalForm\', \'RW_Comment\', \'RW_Submit\', \'LRW_Comment\', \'LRW_Approve\', \'RW_ArchiveDocuments\', \'LRW_Reject\', \'ADMIN_UpdateDocuments\']\" behaviour=\"\'disable\'\" ng-disabled=\"(documentsCtrl.applyAdminRwModifiedValuesSecurity && (-1 !== documentsCtrl.AdminRwModifiedFields.indexOf(\'stabilizedCapRate\'))) || (documentsCtrl.role == \'AssetManagement\' && documentsCtrl.review.status == \'ManagerCommented\') || (documentsCtrl.role == \'AssetAppraisal\' && (documentsCtrl.review.status == \'ValuationSignedOff\' || documentsCtrl.review.status == \'FinalDocumentsUploaded\' || documentsCtrl.review.status == \'FinalFormFilled\'))\" ng-required=\"(documentsCtrl.role !== \'AssetAppraisal\') || (documentsCtrl.role === \'AssetAppraisal\' && (-1 === documentsCtrl.AdminRwModifiedFields.indexOf(\'stabilizedCapRate\')))\"></div></div><div class=\"form-group\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><label><span>P/P Δ</span></label></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><input class=\"form-control\" type=\"text\" ng-model=\"documentsCtrl.review.stabilizedCapRatePeriodDelta\" percentage-values=\"\" format=\"number\" percentage-options=\'{\"negatives\": true, \"nullable\": true, \"integer\": true}\' ng-pattern=\"/^(\\-?\\d*)|(N/\\A)$/\" review-checker=\"documentsCtrl.review\" actions=\"[\'AP_Submit\', \'AP_FillFinalForm\', \'RW_Comment\', \'RW_Submit\', \'LRW_Comment\', \'LRW_Approve\', \'RW_ArchiveDocuments\', \'LRW_Reject\', \'ADMIN_UpdateDocuments\']\" behaviour=\"\'disable\'\" ng-disabled=\"documentsCtrl.applyAppraiserPrevValuesSecurity || (documentsCtrl.role == \'AssetManagement\' && documentsCtrl.review.status == \'ManagerCommented\') || (documentsCtrl.role != \'Admin\')\"></div></div><div class=\"form-group no-margin-bottom\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><label><span>Y/Y Δ</span></label></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><input class=\"form-control\" type=\"text\" ng-model=\"documentsCtrl.review.stabilizedCapRateYearlyDelta\" percentage-values=\"\" format=\"number\" percentage-options=\'{\"negatives\": true, \"nullable\": true, \"integer\": true}\' ng-pattern=\"/^(\\-?\\d*)|(N/\\A)$/\" review-checker=\"documentsCtrl.review\" actions=\"[\'AP_Submit\', \'AP_FillFinalForm\', \'RW_Comment\', \'RW_Submit\', \'LRW_Comment\', \'LRW_Approve\', \'RW_ArchiveDocuments\', \'LRW_Reject\', \'ADMIN_UpdateDocuments\']\" behaviour=\"\'disable\'\" ng-disabled=\"documentsCtrl.applyAppraiserPrevValuesSecurity || (documentsCtrl.role == \'AssetManagement\' && documentsCtrl.review.status == \'ManagerCommented\') || (documentsCtrl.role != \'Admin\')\" ng-required=\"((documentsCtrl.review.asset.valuationFrequency === \'Annually\' && documentsCtrl.review.quarterOfCycle > 1) || (documentsCtrl.review.asset.valuationFrequency !== \'Annually\' && documentsCtrl.review.quarterOfCycle > 4)) && documentsCtrl.previousYearlyValuation && (documentsCtrl.role !== \'AssetAppraisal\' || (documentsCtrl.role === \'AssetAppraisal\' && (-1 === documentsCtrl.AdminRwModifiedFields.indexOf(\'stabilizedCapRateYearlyDelta\'))))\"></div></div></div><div class=\"col-lg-2 col-md-4 col-sm-4 col-xs-4\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding m-b-sm\"><span class=\"big\" translate=\"DOCUMENTS.TERMINAL_RATE\"></span></div><div class=\"form-group\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><label><span translate=\"DOCUMENTS.CURRENT_RATE\"></span></label></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><input class=\"form-control\" type=\"text\" ng-model=\"documentsCtrl.review.terminalRate\" percentage-values=\"\" format=\"percentage\" maxlength=\"8\" ng-pattern=\"/((^[\\-]?(?:[0-9]+(?:\\.[0-9]{0,2})?)[\\%]?)|(N\\/\\A))$/\" review-checker=\"documentsCtrl.review\" actions=\"[\'AP_Submit\', \'AP_FillFinalForm\', \'RW_Comment\', \'RW_Submit\', \'LRW_Comment\', \'LRW_Approve\', \'RW_ArchiveDocuments\', \'LRW_Reject\', \'ADMIN_UpdateDocuments\']\" behaviour=\"\'disable\'\" ng-disabled=\"(documentsCtrl.applyAdminRwModifiedValuesSecurity && (-1 !== documentsCtrl.AdminRwModifiedFields.indexOf(\'terminalRate\'))) || (documentsCtrl.role == \'AssetManagement\' && documentsCtrl.review.status == \'ManagerCommented\') || (documentsCtrl.role == \'AssetAppraisal\' && (documentsCtrl.review.status == \'ValuationSignedOff\' || documentsCtrl.review.status == \'FinalDocumentsUploaded\' || documentsCtrl.review.status == \'FinalFormFilled\'))\" ng-required=\"(documentsCtrl.role !== \'AssetAppraisal\') || (documentsCtrl.role === \'AssetAppraisal\' && (-1 === documentsCtrl.AdminRwModifiedFields.indexOf(\'terminalRate\')))\"></div></div><div class=\"form-group\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><label><span>P/P Δ</span></label></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><input class=\"form-control\" type=\"text\" ng-model=\"documentsCtrl.review.terminalRatePeriodDelta\" percentage-values=\"\" format=\"number\" percentage-options=\'{\"negatives\": true, \"nullable\": true, \"integer\": true}\' ng-pattern=\"/^(\\-?\\d*)|(N/\\A)$/\" review-checker=\"documentsCtrl.review\" actions=\"[\'AP_Submit\', \'AP_FillFinalForm\', \'RW_Comment\', \'RW_Submit\', \'LRW_Comment\', \'LRW_Approve\', \'RW_ArchiveDocuments\', \'LRW_Reject\', \'ADMIN_UpdateDocuments\']\" behaviour=\"\'disable\'\" ng-disabled=\"documentsCtrl.applyAppraiserPrevValuesSecurity || (documentsCtrl.role == \'AssetManagement\' && documentsCtrl.review.status == \'ManagerCommented\') || (documentsCtrl.role != \'Admin\')\"></div></div><div class=\"form-group no-margin-bottom\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><label><span>Y/Y Δ</span></label></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><input class=\"form-control\" type=\"text\" ng-model=\"documentsCtrl.review.terminalRateYearlyDelta\" percentage-values=\"\" format=\"number\" percentage-options=\'{\"negatives\": true, \"nullable\": true, \"integer\": true}\' ng-pattern=\"/^(\\-?\\d*)|(N/\\A)$/\" review-checker=\"documentsCtrl.review\" actions=\"[\'AP_Submit\', \'AP_FillFinalForm\', \'RW_Comment\', \'RW_Submit\', \'LRW_Comment\', \'LRW_Approve\', \'RW_ArchiveDocuments\', \'LRW_Reject\', \'ADMIN_UpdateDocuments\']\" behaviour=\"\'disable\'\" ng-disabled=\"documentsCtrl.applyAppraiserPrevValuesSecurity || (documentsCtrl.role == \'AssetManagement\' && documentsCtrl.review.status == \'ManagerCommented\') || (documentsCtrl.role != \'Admin\')\" ng-required=\"((documentsCtrl.review.asset.valuationFrequency === \'Annually\' && documentsCtrl.review.quarterOfCycle > 1) || (documentsCtrl.review.asset.valuationFrequency !== \'Annually\' && documentsCtrl.review.quarterOfCycle > 4)) && documentsCtrl.previousYearlyValuation && (documentsCtrl.role !== \'AssetAppraisal\' || (documentsCtrl.role === \'AssetAppraisal\' && (-1 === documentsCtrl.AdminRwModifiedFields.indexOf(\'terminalRateYearlyDelta\'))))\"></div></div></div><div class=\"col-lg-2 col-md-4 col-sm-4 col-xs-4\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding m-b-sm\"><span class=\"big\" translate=\"DOCUMENTS.DISCOUNT_RATE\"></span></div><div class=\"form-group\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><label><span translate=\"DOCUMENTS.CURRENT_RATE\"></span></label></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><input class=\"form-control\" type=\"text\" ng-model=\"documentsCtrl.review.discountRate\" percentage-values=\"\" format=\"percentage\" maxlength=\"8\" ng-pattern=\"/^(([\\-]?(?:[0-9]+(?:\\.[0-9]{0,2})?)[\\%]?)|(N\\/\\A))$/\" review-checker=\"documentsCtrl.review\" actions=\"[\'AP_Submit\', \'AP_FillFinalForm\', \'RW_Comment\', \'RW_Submit\', \'LRW_Comment\', \'LRW_Approve\', \'RW_ArchiveDocuments\', \'LRW_Reject\', \'ADMIN_UpdateDocuments\']\" behaviour=\"\'disable\'\" ng-disabled=\"(documentsCtrl.applyAdminRwModifiedValuesSecurity && (-1 !== documentsCtrl.AdminRwModifiedFields.indexOf(\'discountRate\'))) || (documentsCtrl.role == \'AssetManagement\' && documentsCtrl.review.status == \'ManagerCommented\') || (documentsCtrl.role == \'AssetAppraisal\' && (documentsCtrl.review.status == \'ValuationSignedOff\' || documentsCtrl.review.status == \'FinalDocumentsUploaded\' || documentsCtrl.review.status == \'FinalFormFilled\'))\" ng-required=\"(documentsCtrl.role !== \'AssetAppraisal\') || (documentsCtrl.role === \'AssetAppraisal\' && (-1 === documentsCtrl.AdminRwModifiedFields.indexOf(\'discountRate\')))\"></div></div><div class=\"form-group\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><label><span>P/P Δ</span></label></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><input class=\"form-control\" type=\"text\" ng-model=\"documentsCtrl.review.discountRatePeriodDelta\" percentage-values=\"\" format=\"number\" percentage-options=\'{\"negatives\": true, \"nullable\": true, \"integer\": true}\' ng-pattern=\"/^(\\-?\\d*)|(N/\\A)$/\" review-checker=\"documentsCtrl.review\" actions=\"[\'AP_Submit\', \'AP_FillFinalForm\', \'RW_Comment\', \'RW_Submit\', \'LRW_Comment\', \'LRW_Approve\', \'RW_ArchiveDocuments\', \'LRW_Reject\', \'ADMIN_UpdateDocuments\']\" behaviour=\"\'disable\'\" ng-disabled=\"documentsCtrl.applyAppraiserPrevValuesSecurity || (documentsCtrl.role == \'AssetManagement\' && documentsCtrl.review.status == \'ManagerCommented\') || (documentsCtrl.role != \'Admin\')\"></div></div><div class=\"form-group no-margin-bottom\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><label><span>Y/Y Δ</span></label></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><input class=\"form-control\" type=\"text\" ng-model=\"documentsCtrl.review.discountRateYearlyDelta\" percentage-values=\"\" format=\"number\" percentage-options=\'{\"negatives\": true, \"nullable\": true, \"integer\": true}\' ng-pattern=\"/^(\\-?\\d*)|(N/\\A)$/\" review-checker=\"documentsCtrl.review\" actions=\"[\'AP_Submit\', \'AP_FillFinalForm\', \'RW_Comment\', \'RW_Submit\', \'LRW_Comment\', \'LRW_Approve\', \'RW_ArchiveDocuments\', \'LRW_Reject\', \'ADMIN_UpdateDocuments\']\" behaviour=\"\'disable\'\" ng-disabled=\"documentsCtrl.applyAppraiserPrevValuesSecurity || (documentsCtrl.role == \'AssetManagement\' && documentsCtrl.review.status == \'ManagerCommented\') || (documentsCtrl.role != \'Admin\')\" ng-required=\"((documentsCtrl.review.asset.valuationFrequency === \'Annually\' && documentsCtrl.review.quarterOfCycle > 1) || (documentsCtrl.review.asset.valuationFrequency !== \'Annually\' && documentsCtrl.review.quarterOfCycle > 4)) && documentsCtrl.previousYearlyValuation && (documentsCtrl.role !== \'AssetAppraisal\' || (documentsCtrl.role === \'AssetAppraisal\' && (-1 === documentsCtrl.AdminRwModifiedFields.indexOf(\'discountRateYearlyDelta\'))))\"></div></div></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 small-screen\"><hr></div><div class=\"col-lg-2 col-md-6 col-sm-6 col-xs-6\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding m-b-sm\"><span class=\"big\" translate=\"DOCUMENTS.IMPLIED_CAP_RATE\"></span></div><div class=\"form-group\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><label><span translate=\"DOCUMENTS.CURRENT_RATE\"></span></label></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><input class=\"form-control\" type=\"text\" ng-model=\"documentsCtrl.review.impliedCapRate\" percentage-values=\"\" format=\"percentage\" maxlength=\"8\" ng-pattern=\"/^(([\\-]?(?:[0-9]+(?:\\.[0-9]{0,2})?)[\\%]?)|(N\\/\\A))$/\" review-checker=\"documentsCtrl.review\" actions=\"[\'AP_Submit\', \'AP_FillFinalForm\', \'RW_Comment\', \'RW_Submit\', \'LRW_Comment\', \'LRW_Approve\', \'RW_ArchiveDocuments\', \'LRW_Reject\', \'ADMIN_UpdateDocuments\']\" behaviour=\"\'disable\'\" ng-disabled=\"(documentsCtrl.applyAdminRwModifiedValuesSecurity && (-1 !== documentsCtrl.AdminRwModifiedFields.indexOf(\'impliedCapRate\'))) || (documentsCtrl.role == \'AssetManagement\' && documentsCtrl.review.status == \'ManagerCommented\') || (documentsCtrl.role == \'AssetAppraisal\' && (documentsCtrl.review.status == \'ValuationSignedOff\' || documentsCtrl.review.status == \'FinalDocumentsUploaded\' || documentsCtrl.review.status == \'FinalFormFilled\'))\" ng-required=\"(documentsCtrl.role !== \'AssetAppraisal\') || (documentsCtrl.role === \'AssetAppraisal\' && (-1 === documentsCtrl.AdminRwModifiedFields.indexOf(\'discountRate\')))\"></div></div><div class=\"form-group\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><label><span>P/P Δ</span></label></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><input class=\"form-control\" type=\"text\" ng-model=\"documentsCtrl.review.impliedCapRatePeriodDelta\" percentage-values=\"\" format=\"number\" percentage-options=\'{\"negatives\": true, \"nullable\": true, \"integer\": true}\' ng-pattern=\"/^(\\-?\\d*)|(N/\\A)$/\" review-checker=\"documentsCtrl.review\" actions=\"[\'AP_Submit\', \'AP_FillFinalForm\', \'RW_Comment\', \'RW_Submit\', \'LRW_Comment\', \'LRW_Approve\', \'RW_ArchiveDocuments\', \'LRW_Reject\', \'ADMIN_UpdateDocuments\']\" behaviour=\"\'disable\'\" ng-disabled=\"documentsCtrl.applyAppraiserPrevValuesSecurity || (documentsCtrl.role == \'AssetManagement\' && documentsCtrl.review.status == \'ManagerCommented\') || (documentsCtrl.role != \'Admin\')\"></div></div><div class=\"form-group no-margin-bottom\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><label><span>Y/Y Δ</span></label></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><input class=\"form-control\" type=\"text\" ng-model=\"documentsCtrl.review.impliedCapRateYearlyDelta\" percentage-values=\"\" format=\"number\" percentage-options=\'{\"negatives\": true, \"nullable\": true, \"integer\": true}\' ng-pattern=\"/^(\\-?\\d*)|(N/\\A)$/\" review-checker=\"documentsCtrl.review\" actions=\"[\'AP_Submit\', \'AP_FillFinalForm\', \'RW_Comment\', \'RW_Submit\', \'LRW_Comment\', \'LRW_Approve\', \'RW_ArchiveDocuments\', \'LRW_Reject\', \'ADMIN_UpdateDocuments\']\" behaviour=\"\'disable\'\" ng-disabled=\"documentsCtrl.applyAppraiserPrevValuesSecurity || (documentsCtrl.role == \'AssetManagement\' && documentsCtrl.review.status == \'ManagerCommented\') || (documentsCtrl.role != \'Admin\')\" ng-required=\"((documentsCtrl.review.asset.valuationFrequency === \'Annually\' && documentsCtrl.review.quarterOfCycle > 1) || (documentsCtrl.review.asset.valuationFrequency !== \'Annually\' && documentsCtrl.review.quarterOfCycle > 4)) && documentsCtrl.previousYearlyValuation && (documentsCtrl.role !== \'AssetAppraisal\' || (documentsCtrl.role === \'AssetAppraisal\' && (-1 === documentsCtrl.AdminRwModifiedFields.indexOf(\'impliedCapRateYearlyDelta\'))))\"></div></div></div><div class=\"col-lg-3 col-md-6 col-sm-6 col-xs-6\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding m-b-sm\"><span class=\"big\">&nbsp;</span></div><div class=\"form-group\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><label><span translate=\"DOCUMENTS.AVERAGE_CONTRACT_RENT\"></span></label></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><input class=\"form-control\" type=\"text\" ng-model=\"documentsCtrl.review.avgContractRent\" currency-values=\"\" format=\"currency\" currency-options=\'{\"decimals\": true}\' ng-pattern=\"/^(([\\-]?\\$?(?:([0-9]\\,?)+(?:\\.[0-9]{0,2})?))|(N\\/\\A))$/\" review-checker=\"documentsCtrl.review\" actions=\"[\'AP_Submit\', \'AP_FillFinalForm\', \'RW_Comment\', \'RW_Submit\', \'LRW_Comment\', \'LRW_Approve\', \'RW_ArchiveDocuments\', \'LRW_Reject\', \'ADMIN_UpdateDocuments\']\" behaviour=\"\'disable\'\" ng-disabled=\"(documentsCtrl.applyAdminRwModifiedValuesSecurity && (-1 !== documentsCtrl.AdminRwModifiedFields.indexOf(\'avgContractRent\'))) || (documentsCtrl.role == \'AssetManagement\' && documentsCtrl.review.status == \'ManagerCommented\') || (documentsCtrl.role == \'AssetAppraisal\' && (documentsCtrl.review.status == \'ValuationSignedOff\' || documentsCtrl.review.status == \'FinalDocumentsUploaded\' || documentsCtrl.review.status == \'FinalFormFilled\'))\" ng-required=\"(documentsCtrl.role !== \'AssetAppraisal\') || (documentsCtrl.role === \'AssetAppraisal\' && (-1 === documentsCtrl.AdminRwModifiedFields.indexOf(\'avgContractRent\')))\"></div></div><div class=\"form-group\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><label><span translate=\"DOCUMENTS.AVERAGE_MARKET_RENT\"></span></label></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><input class=\"form-control\" type=\"text\" ng-model=\"documentsCtrl.review.avgMarketRent\" currency-values=\"\" format=\"currency\" currency-options=\'{\"decimals\": true}\' ng-pattern=\"/^(([\\-]?\\$?(?:([0-9]\\,?)+(?:\\.[0-9]{0,2})?))|(N\\/\\A))$/\" review-checker=\"documentsCtrl.review\" actions=\"[\'AP_Submit\', \'AP_FillFinalForm\', \'RW_Comment\', \'RW_Submit\', \'LRW_Comment\', \'LRW_Approve\', \'RW_ArchiveDocuments\', \'LRW_Reject\', \'ADMIN_UpdateDocuments\']\" behaviour=\"\'disable\'\" ng-disabled=\"(documentsCtrl.applyAdminRwModifiedValuesSecurity && (-1 !== documentsCtrl.AdminRwModifiedFields.indexOf(\'avgMarketRent\'))) || (documentsCtrl.role == \'AssetManagement\' && documentsCtrl.review.status == \'ManagerCommented\') || (documentsCtrl.role == \'AssetAppraisal\' && (documentsCtrl.review.status == \'ValuationSignedOff\' || documentsCtrl.review.status == \'FinalDocumentsUploaded\' || documentsCtrl.review.status == \'FinalFormFilled\'))\" ng-required=\"(documentsCtrl.role !== \'AssetAppraisal\') || (documentsCtrl.role === \'AssetAppraisal\' && (-1 === documentsCtrl.AdminRwModifiedFields.indexOf(\'avgMarketRent\')))\"></div></div><div class=\"form-group no-margin-bottom\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><label><span translate=\"DOCUMENTS.AVERAGE_RENT_GROWTH\"></span></label></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><input class=\"form-control\" type=\"text\" ng-model=\"documentsCtrl.review.avgRentGrowth\" percentage-values=\"\" format=\"percentage\" maxlength=\"8\" percentage-options=\'{\"negatives\": true}\' ng-pattern=\"/^(([\\-]?(?:[0-9]+(?:\\.[0-9]{0,2})?)[\\%]?)|(N\\/\\A))$/\" review-checker=\"documentsCtrl.review\" actions=\"[\'AP_Submit\', \'AP_FillFinalForm\', \'RW_Comment\', \'RW_Submit\', \'LRW_Comment\', \'LRW_Approve\', \'RW_ArchiveDocuments\', \'LRW_Reject\', \'ADMIN_UpdateDocuments\']\" behaviour=\"\'disable\'\" ng-disabled=\"(documentsCtrl.applyAdminRwModifiedValuesSecurity && (-1 !== documentsCtrl.AdminRwModifiedFields.indexOf(\'avgRentGrowth\'))) || (documentsCtrl.role == \'AssetManagement\' && documentsCtrl.review.status == \'ManagerCommented\') || (documentsCtrl.role == \'AssetAppraisal\' && (documentsCtrl.review.status == \'ValuationSignedOff\' || documentsCtrl.review.status == \'FinalDocumentsUploaded\' || documentsCtrl.review.status == \'FinalFormFilled\'))\" ng-required=\"(documentsCtrl.role !== \'AssetAppraisal\') || (documentsCtrl.role === \'AssetAppraisal\' && (-1 === documentsCtrl.AdminRwModifiedFields.indexOf(\'avgRentGrowth\')))\"></div></div></div></div><hr><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 m-b-sm\"><span class=\"big\" translate=\"DOCUMENTS.FACTOR_FOR_VALUE_CHANGE\"></span></div></div><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"row\"><div class=\"col-lg-4 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><label><span translate=\"DOCUMENTS.DISCOUNT_RATE\"></span></label></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><input class=\"form-control\" type=\"text\" ng-model=\"documentsCtrl.factorValues.deltaDiscountRate\" currency-values=\"\" format=\"currency\" currency-options=\'{\"negatives\": true, \"cleanable\": true}\' ng-pattern=\"/^[\\-]?\\$?(?:([0-9]\\,?)+(?:\\.[0-9]{0,2})?)$/\" review-checker=\"documentsCtrl.review\" actions=\"[\'AP_Submit\', \'AP_FillFinalForm\', \'RW_Comment\', \'RW_Submit\', \'LRW_Comment\', \'LRW_Approve\', \'RW_ArchiveDocuments\', \'LRW_Reject\', \'ADMIN_UpdateDocuments\']\" behaviour=\"\'disable\'\" ng-disabled=\"(documentsCtrl.applyAdminRwModifiedValuesSecurity && (-1 !== documentsCtrl.AdminRwModifiedFields.indexOf(\'deltaDiscountRate\'))) || documentsCtrl.applyAppraiserPrevValuesSecurity || !documentsCtrl.isPreviousValue || (documentsCtrl.role == \'AssetManagement\' && documentsCtrl.review.status == \'ManagerCommented\') || (documentsCtrl.role == \'AssetAppraisal\' && (documentsCtrl.review.status == \'ValuationSignedOff\' || documentsCtrl.review.status == \'FinalDocumentsUploaded\' || documentsCtrl.review.status == \'FinalFormFilled\'))\" ng-required=\"(documentsCtrl.role !== \'AssetAppraisal\') || (documentsCtrl.role === \'AssetAppraisal\' && (-1 === documentsCtrl.AdminRwModifiedFields.indexOf(\'deltaDiscountRate\')))\"></div></div></div><div class=\"col-lg-4 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><label><span translate=\"DOCUMENTS.TERMINAL_CAP_RATE\"></span></label></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><input class=\"form-control\" type=\"text\" ng-model=\"documentsCtrl.factorValues.deltaTerminalCapRate\" currency-values=\"\" format=\"currency\" currency-options=\'{\"negatives\": true, \"cleanable\": true}\' ng-pattern=\"/^[\\-]?\\$?(?:([0-9]\\,?)+(?:\\.[0-9]{0,2})?)$/\" review-checker=\"documentsCtrl.review\" actions=\"[\'AP_Submit\', \'AP_FillFinalForm\', \'RW_Comment\', \'RW_Submit\', \'LRW_Comment\', \'LRW_Approve\', \'RW_ArchiveDocuments\', \'LRW_Reject\', \'ADMIN_UpdateDocuments\']\" behaviour=\"\'disable\'\" ng-disabled=\"(documentsCtrl.applyAdminRwModifiedValuesSecurity && (-1 !== documentsCtrl.AdminRwModifiedFields.indexOf(\'deltaTerminalCapRate\'))) || documentsCtrl.applyAppraiserPrevValuesSecurity || !documentsCtrl.isPreviousValue || (documentsCtrl.role == \'AssetManagement\' && documentsCtrl.review.status == \'ManagerCommented\') || (documentsCtrl.role == \'AssetAppraisal\' && (documentsCtrl.review.status == \'ValuationSignedOff\' || documentsCtrl.review.status == \'FinalDocumentsUploaded\' || documentsCtrl.review.status == \'FinalFormFilled\'))\" ng-required=\"(documentsCtrl.role !== \'AssetAppraisal\') || (documentsCtrl.role === \'AssetAppraisal\' && (-1 === documentsCtrl.AdminRwModifiedFields.indexOf(\'deltaTerminalCapRate\')))\"></div></div></div><div class=\"col-lg-4 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><label><span translate=\"DOCUMENTS.AVERAGE_MARKET_RENT_GROWTH\"></span></label></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><input class=\"form-control\" type=\"text\" ng-model=\"documentsCtrl.factorValues.deltaAvgMarketRentGrowth\" currency-values=\"\" format=\"currency\" currency-options=\'{\"negatives\": true, \"cleanable\": true}\' ng-pattern=\"/^[\\-]?\\$?(?:([0-9]\\,?)+(?:\\.[0-9]{0,2})?)$/\" review-checker=\"documentsCtrl.review\" actions=\"[\'AP_Submit\', \'AP_FillFinalForm\', \'RW_Comment\', \'RW_Submit\', \'LRW_Comment\', \'LRW_Approve\', \'RW_ArchiveDocuments\', \'LRW_Reject\', \'ADMIN_UpdateDocuments\']\" behaviour=\"\'disable\'\" ng-disabled=\"(documentsCtrl.applyAdminRwModifiedValuesSecurity && (-1 !== documentsCtrl.AdminRwModifiedFields.indexOf(\'deltaAvgMarketRentGrowth\'))) || documentsCtrl.applyAppraiserPrevValuesSecurity || !documentsCtrl.isPreviousValue || (documentsCtrl.role == \'AssetManagement\' && documentsCtrl.review.status == \'ManagerCommented\') || (documentsCtrl.role == \'AssetAppraisal\' && (documentsCtrl.review.status == \'ValuationSignedOff\' || documentsCtrl.review.status == \'FinalDocumentsUploaded\' || documentsCtrl.review.status == \'FinalFormFilled\'))\" ng-required=\"(documentsCtrl.role !== \'AssetAppraisal\') || (documentsCtrl.role === \'AssetAppraisal\' && (-1 === documentsCtrl.AdminRwModifiedFields.indexOf(\'deltaAvgMarketRentGrowth\')))\"></div></div></div><div class=\"col-lg-4 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><label><span translate=\"DOCUMENTS.MARKET_RENTS\"></span></label></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><input class=\"form-control\" type=\"text\" ng-model=\"documentsCtrl.factorValues.deltaMarketRents\" currency-values=\"\" format=\"currency\" currency-options=\'{\"negatives\": true, \"cleanable\": true}\' ng-pattern=\"/^[\\-]?\\$?(?:([0-9]\\,?)+(?:\\.[0-9]{0,2})?)$/\" review-checker=\"documentsCtrl.review\" actions=\"[\'AP_Submit\', \'AP_FillFinalForm\', \'RW_Comment\', \'RW_Submit\', \'LRW_Comment\', \'LRW_Approve\', \'RW_ArchiveDocuments\', \'LRW_Reject\', \'ADMIN_UpdateDocuments\']\" behaviour=\"\'disable\'\" ng-disabled=\"(documentsCtrl.applyAdminRwModifiedValuesSecurity && (-1 !== documentsCtrl.AdminRwModifiedFields.indexOf(\'deltaMarketRents\'))) || documentsCtrl.applyAppraiserPrevValuesSecurity || !documentsCtrl.isPreviousValue || (documentsCtrl.role == \'AssetManagement\' && documentsCtrl.review.status == \'ManagerCommented\') || (documentsCtrl.role == \'AssetAppraisal\' && (documentsCtrl.review.status == \'ValuationSignedOff\' || documentsCtrl.review.status == \'FinalDocumentsUploaded\' || documentsCtrl.review.status == \'FinalFormFilled\'))\" ng-required=\"(documentsCtrl.role !== \'AssetAppraisal\') || (documentsCtrl.role === \'AssetAppraisal\' && (-1 === documentsCtrl.AdminRwModifiedFields.indexOf(\'deltaMarketRents\')))\"></div></div></div><div class=\"col-lg-4 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><label><span translate=\"DOCUMENTS.CONTRACT_RENTS\"></span></label></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><input class=\"form-control\" type=\"text\" ng-model=\"documentsCtrl.factorValues.deltaContractRents\" currency-values=\"\" format=\"currency\" currency-options=\'{\"negatives\": true, \"cleanable\": true}\' ng-pattern=\"/^[\\-]?\\$?(?:([0-9]\\,?)+(?:\\.[0-9]{0,2})?)$/\" review-checker=\"documentsCtrl.review\" actions=\"[\'AP_Submit\', \'AP_FillFinalForm\', \'RW_Comment\', \'RW_Submit\', \'LRW_Comment\', \'LRW_Approve\', \'RW_ArchiveDocuments\', \'LRW_Reject\', \'ADMIN_UpdateDocuments\']\" behaviour=\"\'disable\'\" ng-disabled=\"(documentsCtrl.applyAdminRwModifiedValuesSecurity && (-1 !== documentsCtrl.AdminRwModifiedFields.indexOf(\'deltaContractRents\'))) || documentsCtrl.applyAppraiserPrevValuesSecurity || !documentsCtrl.isPreviousValue || (documentsCtrl.role == \'AssetManagement\' && documentsCtrl.review.status == \'ManagerCommented\') || (documentsCtrl.role == \'AssetAppraisal\' && (documentsCtrl.review.status == \'ValuationSignedOff\' || documentsCtrl.review.status == \'FinalDocumentsUploaded\' || documentsCtrl.review.status == \'FinalFormFilled\'))\" ng-required=\"(documentsCtrl.role !== \'AssetAppraisal\') || (documentsCtrl.role === \'AssetAppraisal\' && (-1 === documentsCtrl.AdminRwModifiedFields.indexOf(\'deltaContractRents\')))\"></div></div></div><div class=\"col-lg-4 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><label><span translate=\"DOCUMENTS.VACANCY_AND_COLLECTION_LOSS\"></span></label></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><input class=\"form-control\" type=\"text\" ng-model=\"documentsCtrl.factorValues.deltaVacancyAndCollectionLoss\" currency-values=\"\" format=\"currency\" currency-options=\'{\"negatives\": true, \"cleanable\": true}\' ng-pattern=\"/^[\\-]?\\$?(?:([0-9]\\,?)+(?:\\.[0-9]{0,2})?)$/\" review-checker=\"documentsCtrl.review\" actions=\"[\'AP_Submit\', \'AP_FillFinalForm\', \'RW_Comment\', \'RW_Submit\', \'LRW_Comment\', \'LRW_Approve\', \'RW_ArchiveDocuments\', \'LRW_Reject\', \'ADMIN_UpdateDocuments\']\" behaviour=\"\'disable\'\" ng-disabled=\"(documentsCtrl.applyAdminRwModifiedValuesSecurity && (-1 !== documentsCtrl.AdminRwModifiedFields.indexOf(\'deltaVacancyAndCollectionLoss\'))) || documentsCtrl.applyAppraiserPrevValuesSecurity || !documentsCtrl.isPreviousValue || (documentsCtrl.role == \'AssetManagement\' && documentsCtrl.review.status == \'ManagerCommented\') || (documentsCtrl.role == \'AssetAppraisal\' && (documentsCtrl.review.status == \'ValuationSignedOff\' || documentsCtrl.review.status == \'FinalDocumentsUploaded\' || documentsCtrl.review.status == \'FinalFormFilled\'))\" ng-required=\"(documentsCtrl.role !== \'AssetAppraisal\') || (documentsCtrl.role === \'AssetAppraisal\' && (-1 === documentsCtrl.AdminRwModifiedFields.indexOf(\'deltaVacancyAndCollectionLoss\')))\"></div></div></div><div class=\"col-lg-4 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><label><span translate=\"DOCUMENTS.DOWNTIME_AND_RENEWAL\"></span></label></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><input class=\"form-control\" type=\"text\" ng-model=\"documentsCtrl.factorValues.deltaDowntimeAndRenewalProbability\" currency-values=\"\" format=\"currency\" currency-options=\'{\"negatives\": true, \"cleanable\": true}\' ng-pattern=\"/^[\\-]?\\$?(?:([0-9]\\,?)+(?:\\.[0-9]{0,2})?)$/\" review-checker=\"documentsCtrl.review\" actions=\"[\'AP_Submit\', \'AP_FillFinalForm\', \'RW_Comment\', \'RW_Submit\', \'LRW_Comment\', \'LRW_Approve\', \'RW_ArchiveDocuments\', \'LRW_Reject\', \'ADMIN_UpdateDocuments\']\" behaviour=\"\'disable\'\" ng-disabled=\"(documentsCtrl.applyAdminRwModifiedValuesSecurity && (-1 !== documentsCtrl.AdminRwModifiedFields.indexOf(\'deltaDowntimeAndRenewalProbability\'))) || documentsCtrl.applyAppraiserPrevValuesSecurity || !documentsCtrl.isPreviousValue || (documentsCtrl.role == \'AssetManagement\' && documentsCtrl.review.status == \'ManagerCommented\') || (documentsCtrl.role == \'AssetAppraisal\' && (documentsCtrl.review.status == \'ValuationSignedOff\' || documentsCtrl.review.status == \'FinalDocumentsUploaded\' || documentsCtrl.review.status == \'FinalFormFilled\'))\" ng-required=\"(documentsCtrl.role !== \'AssetAppraisal\') || (documentsCtrl.role === \'AssetAppraisal\' && (-1 === documentsCtrl.AdminRwModifiedFields.indexOf(\'deltaDowntimeAndRenewalProbability\')))\"></div></div></div><div class=\"col-lg-4 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><label><span translate=\"DOCUMENTS.EXPENSES\"></span></label></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><input class=\"form-control\" type=\"text\" ng-model=\"documentsCtrl.factorValues.deltaExpenses\" currency-values=\"\" format=\"currency\" currency-options=\'{\"negatives\": true, \"cleanable\": true}\' ng-pattern=\"/^[\\-]?\\$?(?:([0-9]\\,?)+(?:\\.[0-9]{0,2})?)$/\" review-checker=\"documentsCtrl.review\" actions=\"[\'AP_Submit\', \'AP_FillFinalForm\', \'RW_Comment\', \'RW_Submit\', \'LRW_Comment\', \'LRW_Approve\', \'RW_ArchiveDocuments\', \'LRW_Reject\', \'ADMIN_UpdateDocuments\']\" behaviour=\"\'disable\'\" ng-disabled=\"(documentsCtrl.applyAdminRwModifiedValuesSecurity && (-1 !== documentsCtrl.AdminRwModifiedFields.indexOf(\'deltaExpenses\'))) || documentsCtrl.applyAppraiserPrevValuesSecurity || !documentsCtrl.isPreviousValue || (documentsCtrl.role == \'AssetManagement\' && documentsCtrl.review.status == \'ManagerCommented\') || (documentsCtrl.role == \'AssetAppraisal\' && (documentsCtrl.review.status == \'ValuationSignedOff\' || documentsCtrl.review.status == \'FinalDocumentsUploaded\' || documentsCtrl.review.status == \'FinalFormFilled\'))\" ng-required=\"(documentsCtrl.role !== \'AssetAppraisal\') || (documentsCtrl.role === \'AssetAppraisal\' && (-1 === documentsCtrl.AdminRwModifiedFields.indexOf(\'deltaExpenses\')))\"></div></div></div><div class=\"col-lg-4 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><label><span translate=\"DOCUMENTS.REAL_ESTATE_TAXES\"></span></label></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><input class=\"form-control\" type=\"text\" ng-model=\"documentsCtrl.factorValues.deltaRealEstateTaxes\" currency-values=\"\" format=\"currency\" currency-options=\'{\"negatives\": true, \"cleanable\": true}\' ng-pattern=\"/^[\\-]?\\$?(?:([0-9]\\,?)+(?:\\.[0-9]{0,2})?)$/\" review-checker=\"documentsCtrl.review\" actions=\"[\'AP_Submit\', \'AP_FillFinalForm\', \'RW_Comment\', \'RW_Submit\', \'LRW_Comment\', \'LRW_Approve\', \'RW_ArchiveDocuments\', \'LRW_Reject\', \'ADMIN_UpdateDocuments\']\" behaviour=\"\'disable\'\" ng-disabled=\"(documentsCtrl.applyAdminRwModifiedValuesSecurity && (-1 !== documentsCtrl.AdminRwModifiedFields.indexOf(\'deltaRealEstateTaxes\'))) || documentsCtrl.applyAppraiserPrevValuesSecurity || !documentsCtrl.isPreviousValue || (documentsCtrl.role == \'AssetManagement\' && documentsCtrl.review.status == \'ManagerCommented\') || (documentsCtrl.role == \'AssetAppraisal\' && (documentsCtrl.review.status == \'ValuationSignedOff\' || documentsCtrl.review.status == \'FinalDocumentsUploaded\' || documentsCtrl.review.status == \'FinalFormFilled\'))\" ng-required=\"(documentsCtrl.role !== \'AssetAppraisal\') || (documentsCtrl.role === \'AssetAppraisal\' && (-1 === documentsCtrl.AdminRwModifiedFields.indexOf(\'deltaRealEstateTaxes\')))\"></div></div></div><div class=\"col-lg-4 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><label><span translate=\"DOCUMENTS.BUILDING_CAPITAL\"></span></label></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><input class=\"form-control\" type=\"text\" ng-model=\"documentsCtrl.factorValues.deltaBuildingCapital\" currency-values=\"\" format=\"currency\" currency-options=\'{\"negatives\": true, \"cleanable\": true}\' ng-pattern=\"/^[\\-]?\\$?(?:([0-9]\\,?)+(?:\\.[0-9]{0,2})?)$/\" review-checker=\"documentsCtrl.review\" actions=\"[\'AP_Submit\', \'AP_FillFinalForm\', \'RW_Comment\', \'RW_Submit\', \'LRW_Comment\', \'LRW_Approve\', \'RW_ArchiveDocuments\', \'LRW_Reject\', \'ADMIN_UpdateDocuments\']\" behaviour=\"\'disable\'\" ng-disabled=\"(documentsCtrl.applyAdminRwModifiedValuesSecurity && (-1 !== documentsCtrl.AdminRwModifiedFields.indexOf(\'deltaBuildingCapital\'))) || documentsCtrl.applyAppraiserPrevValuesSecurity || !documentsCtrl.isPreviousValue || (documentsCtrl.role == \'AssetManagement\' && documentsCtrl.review.status == \'ManagerCommented\') || (documentsCtrl.role == \'AssetAppraisal\' && (documentsCtrl.review.status == \'ValuationSignedOff\' || documentsCtrl.review.status == \'FinalDocumentsUploaded\' || documentsCtrl.review.status == \'FinalFormFilled\'))\" ng-required=\"(documentsCtrl.role !== \'AssetAppraisal\') || (documentsCtrl.role === \'AssetAppraisal\' && (-1 === documentsCtrl.AdminRwModifiedFields.indexOf(\'deltaBuildingCapital\')))\"></div></div></div><div class=\"col-lg-4 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><label><span translate=\"DOCUMENTS.LEASING_CAPITAL\"></span></label></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><input class=\"form-control\" type=\"text\" ng-model=\"documentsCtrl.factorValues.deltaLeasingCapital\" currency-values=\"\" format=\"currency\" currency-options=\'{\"negatives\": true, \"cleanable\": true}\' ng-pattern=\"/^[\\-]?\\$?(?:([0-9]\\,?)+(?:\\.[0-9]{0,2})?)$/\" review-checker=\"documentsCtrl.review\" actions=\"[\'AP_Submit\', \'AP_FillFinalForm\', \'RW_Comment\', \'RW_Submit\', \'LRW_Comment\', \'LRW_Approve\', \'RW_ArchiveDocuments\', \'LRW_Reject\', \'ADMIN_UpdateDocuments\']\" behaviour=\"\'disable\'\" ng-disabled=\"(documentsCtrl.applyAdminRwModifiedValuesSecurity && (-1 !== documentsCtrl.AdminRwModifiedFields.indexOf(\'deltaLeasingCapital\'))) || documentsCtrl.applyAppraiserPrevValuesSecurity || !documentsCtrl.isPreviousValue || (documentsCtrl.role == \'AssetManagement\' && documentsCtrl.review.status == \'ManagerCommented\') || (documentsCtrl.role == \'AssetAppraisal\' && (documentsCtrl.review.status == \'ValuationSignedOff\' || documentsCtrl.review.status == \'FinalDocumentsUploaded\' || documentsCtrl.review.status == \'FinalFormFilled\'))\" ng-required=\"(documentsCtrl.role !== \'AssetAppraisal\') || (documentsCtrl.role === \'AssetAppraisal\' && (-1 === documentsCtrl.AdminRwModifiedFields.indexOf(\'deltaLeasingCapital\')))\"></div></div></div><div class=\"col-lg-4 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><label><span translate=\"DOCUMENTS.OTHER\"></span></label></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><input class=\"form-control\" type=\"text\" ng-model=\"documentsCtrl.factorValues.deltaOther\" currency-values=\"\" format=\"currency\" currency-options=\'{\"negatives\": true, \"cleanable\": true}\' ng-pattern=\"/^[\\-]?\\$?(?:([0-9]\\,?)+(?:\\.[0-9]{0,2})?)$/\" review-checker=\"documentsCtrl.review\" actions=\"[\'AP_Submit\', \'AP_FillFinalForm\', \'RW_Comment\', \'RW_Submit\', \'LRW_Comment\', \'LRW_Approve\', \'RW_ArchiveDocuments\', \'LRW_Reject\', \'ADMIN_UpdateDocuments\']\" behaviour=\"\'disable\'\" ng-disabled=\"(documentsCtrl.applyAdminRwModifiedValuesSecurity && (-1 !== documentsCtrl.AdminRwModifiedFields.indexOf(\'deltaOther\'))) || documentsCtrl.applyAppraiserPrevValuesSecurity || !documentsCtrl.isPreviousValue || (documentsCtrl.role == \'AssetManagement\' && documentsCtrl.review.status == \'ManagerCommented\') || (documentsCtrl.role == \'AssetAppraisal\' && (documentsCtrl.review.status == \'ValuationSignedOff\' || documentsCtrl.review.status == \'FinalDocumentsUploaded\' || documentsCtrl.review.status == \'FinalFormFilled\'))\" ng-required=\"(documentsCtrl.role !== \'AssetAppraisal\') || (documentsCtrl.role === \'AssetAppraisal\' && (-1 === documentsCtrl.AdminRwModifiedFields.indexOf(\'deltaOther\')))\"></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-4 col-md-6 col-sm-6 col-xs-6\"><div class=\"form-group\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><label><span translate=\"DOCUMENTS.TOTAL_CHANGE\"></span></label></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><input class=\"form-control\" type=\"text\" ng-model=\"documentsCtrl.review.totalChange\" ng-class=\"{\'invalid-field\': documentsCtrl.invalidTotalChange}\" currency-values=\"\" format=\"currency\" currency-options=\'{\"negatives\": true}\' ng-pattern=\"/^[\\-]?\\$?(?:([0-9]\\,?)+(?:\\.[0-9]{0,2})?)?$/\" ng-disabled=\"true\"><div ng-show=\"documentsCtrl.invalidTotalChange\"><p class=\"invalid-text\" translate=\"DOCUMENTS.TOTAL_CHANGE_ERROR\"></p></div></div></div></div></div><hr><div class=\"row\"><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12 m-b-sm\"><span class=\"big\">P/P {{\'DOCUMENTS.VALUE_CHANGE_EXPLANATION\' | translate}}</span><div class=\"form-group margins-form\"><textarea name=\"notes\" rows=\"4\" class=\"form-control property-notes\" ng-class=\"{\'invalid-field\': ((!documentsCtrl.applyAppraiserPrevValuesSecurity && !documentsCtrl.validPPNotes) || (!documentsCtrl.validPPNotes && documentsCtrl.applyAdminRwModifiedValuesSecurity && (-1 !== documentsCtrl.AdminRwModifiedFields.indexOf(\'ppValueChangeExplanation\')))) && (documentsCtrl.executiveSummaryForm.$submitted || documentsCtrl.touchedPPNotes)}\" ng-trim=\"false\" ng-model=\"documentsCtrl.review.ppValueChangeExplanation\" review-checker=\"documentsCtrl.review\" actions=\"[\'AP_Submit\', \'AP_FillFinalForm\', \'RW_Comment\', \'RW_Submit\', \'LRW_Comment\', \'LRW_Approve\', \'RW_ArchiveDocuments\', \'LRW_Reject\', \'ADMIN_UpdateDocuments\']\" behaviour=\"\'disable\'\" ng-disabled=\"(documentsCtrl.applyAdminRwModifiedValuesSecurity && (-1 !== documentsCtrl.AdminRwModifiedFields.indexOf(\'ppValueChangeExplanation\'))) || documentsCtrl.applyAppraiserPrevValuesSecurity || (documentsCtrl.role == \'AssetManagement\' && documentsCtrl.review.status == \'ManagerCommented\') || (documentsCtrl.role == \'AssetAppraisal\' && (documentsCtrl.review.status == \'ValuationSignedOff\' || documentsCtrl.review.status == \'FinalDocumentsUploaded\' || documentsCtrl.review.status == \'FinalFormFilled\'))\" ng-required=\"!documentsCtrl.applyAppraiserPrevValuesSecurity || (documentsCtrl.role === \'AssetAppraisal\' && (!documentsCtrl.applyAppraiserPrevValuesSecurity && -1 === documentsCtrl.AdminRwModifiedFields.indexOf(\'ppValueChangeExplanation\')))\"></textarea> <span class=\"f-r\">{{documentsCtrl.review.ppValueChangeExplanation.length || 0}}/800</span></div></div><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12 m-b-sm\"><span class=\"big\">Y/Y {{\'DOCUMENTS.VALUE_CHANGE_EXPLANATION\' | translate}}</span><div class=\"form-group margins-form\"><textarea name=\"notes\" rows=\"4\" class=\"form-control property-notes\" ng-class=\"{\'invalid-field\': !documentsCtrl.applyAppraiserPrevValuesSecurity && !documentsCtrl.validYYNotes && (documentsCtrl.executiveSummaryForm.$submitted || documentsCtrl.touchedYYNotes)}\" ng-trim=\"false\" ng-model=\"documentsCtrl.review.yyValueChangeExplanation\" review-checker=\"documentsCtrl.review\" actions=\"[\'AP_Submit\', \'AP_FillFinalForm\', \'RW_Comment\', \'RW_Submit\', \'LRW_Comment\', \'LRW_Approve\', \'RW_ArchiveDocuments\', \'LRW_Reject\', \'ADMIN_UpdateDocuments\']\" behaviour=\"\'disable\'\" ng-disabled=\"(documentsCtrl.applyAdminRwModifiedValuesSecurity && (-1 !== documentsCtrl.AdminRwModifiedFields.indexOf(\'yyValueChangeExplanation\'))) || documentsCtrl.applyAppraiserPrevValuesSecurity || (documentsCtrl.role == \'AssetManagement\' && documentsCtrl.review.status == \'ManagerCommented\') || (documentsCtrl.role == \'AssetAppraisal\' && (documentsCtrl.review.status == \'ValuationSignedOff\' || documentsCtrl.review.status == \'FinalDocumentsUploaded\' || documentsCtrl.review.status == \'FinalFormFilled\'))\" ng-required=\"!documentsCtrl.applyAppraiserPrevValuesSecurity || (documentsCtrl.role === \'AssetAppraisal\' && (!documentsCtrl.applyAppraiserPrevValuesSecurity && -1 === documentsCtrl.AdminRwModifiedFields.indexOf(\'yyValueChangeExplanation\')))\"></textarea> <span class=\"f-r\">{{documentsCtrl.review.yyValueChangeExplanation.length || 0}}/800</span></div></div></div></div></div></div></div></div><div class=\"row\" ng-if=\"!reviewCtrl.readOnly\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"text-right m-b-lg action-button\" review-checker=\"documentsCtrl.review\" actions=\"[\'AP_Submit\', \'AP_FillFinalForm\', \'RW_Comment\', \'RW_Submit\', \'LRW_Comment\', \'LRW_Approve\', \'RW_ArchiveDocuments\', \'LRW_Reject\', \'ADMIN_UpdateDocuments\']\"><button type=\"submit\" class=\"btn btn-w-m btn-normal\" translate=\"DOCUMENTS.SUBMIT\" ng-hide=\"documentsCtrl.role == \'AssetManagement\'\" ng-if=\"documentsCtrl.role == \'Admin\' || (documentsCtrl.role == \'AssetAppraisal\' && (documentsCtrl.review.status != \'ValuationSignedOff\' || documentsCtrl.review.status != \'FinalDocumentsUploaded\' || documentsCtrl.review.status != \'FinalFormFilled\'))\"></button></div><div class=\"text-right m-b-lg action-button\" review-checker=\"documentsCtrl.review\" actions=\"[\'RW_Comment\', \'RW_Submit\', \'LRW_Comment\', \'LRW_Approve\', \'RW_ArchiveDocuments\', \'LRW_Reject\']\"><button type=\"submit\" class=\"btn btn-w-m btn-normal\" translate=\"DOCUMENTS.SUBMIT\" ng-if=\"documentsCtrl.role == \'AssetReview\' && (documentsCtrl.review.status == \'Created\' || documentsCtrl.review.status == \'FormFilled\' || documentsCtrl.review.status == \'DocumentsUpdated\' || documentsCtrl.review.status == \'ValuationUpdated\' || documentsCtrl.review.status == \'FinalFormFilled\' || documentsCtrl.review.status == \'ManagerCommented\' || documentsCtrl.review.status == \'ManagerApproveValuation\' || documentsCtrl.review.status == \'ReviewerCommented\' || documentsCtrl.review.status == \'SubmittedToAppraiser\' || documentsCtrl.review.status == \'ReviewerApproveValuation\')\"></button></div><div class=\"text-right m-b-lg action-button\"><button type=\"button\" class=\"btn btn-w-m btn-back m-r\" translate=\"DOCUMENTS.BACK\" ng-if=\"(documentsCtrl.review.status == \'DocumentsUploaded\' || documentsCtrl.review.status == \'DocumentsUpdated\' || documentsCtrl.review.status == \'FinalDocumentsUploaded\') && (documentsCtrl.role == \'AssetAppraisal\' || documentsCtrl.role == \'Admin\')\" ng-click=\"documentsCtrl.goBack(documentsCtrl.review)\"></button></div><div class=\"text-right m-b-lg\"><button class=\"btn btn-w-m btn-back m-r\" type=\"button\" translate=\"DOCUMENTS.BACK\" ng-if=\"(documentsCtrl.review.status != \'DocumentsUploaded\' && documentsCtrl.review.status != \'DocumentsUpdated\' && documentsCtrl.review.status != \'FinalDocumentsUploaded\') || (documentsCtrl.role != \'AssetAppraisal\' && documentsCtrl.role != \'Admin\')\" ng-click=\"documentsCtrl.goBack(documentsCtrl.review)\"></button></div></div></div><div class=\"row\" ng-if=\"documentsCtrl.role == \'AssetManagerReadOnly\'\"><div class=\"text-right m-b-lg\"><button class=\"btn btn-w-m btn-back m-r\" type=\"button\" translate=\"DOCUMENTS.BACK\" ng-click=\"documentsCtrl.goBack(documentsCtrl.review)\"></button></div></div></form></div>");
$templateCache.put("app/states/valuations/review/documents-history/documents-history.html","<div class=\"wrapper wrapper-content no-padding-top less-margin\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" ng-style=\"documentsHistoryCtrl.isFromHistory == true && {\'margin-top\':\'25px\'}\"><div class=\"current-status\" ng-if=\"!documentsHistoryCtrl.isFromHistory\"><div class=\"date\">{{documentsHistoryCtrl.review.nms | formatDate:\'MMM DD\'}}</div><div class=\"status\" nvc-latest-action=\"\" review=\"documentsHistoryCtrl.review\"></div></div><div ng-if=\"documentsHistoryCtrl.review.status !== \'Finished\' && !documentsHistoryCtrl.isFromHistory\" class=\"ibox float-e-margins\"><div class=\"ibox-content no-padding-left no-padding-right\"><div class=\"row no-margins\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 title m-b-lg\"><h3 translate=\"DOCUMENTS_HISTORY.CURRENT\"></h3></div></div><div class=\"row no-margin-left no-margin-right m-b-xl\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 documents first\"><h4 translate=\"DOCUMENTS_HISTORY.VALUATION_DOCUMENTS\"></h4><table class=\"table table-striped\"><thead><tr><th translate=\"DOCUMENTS_HISTORY.TYPE\" style=\"width: 20%\"></th><th translate=\"DOCUMENTS_HISTORY.DOCUMENT\" style=\"width: 35%\"></th><th translate=\"DOCUMENTS_HISTORY.OWNER\" style=\"width: 10%\"></th><th translate=\"DOCUMENTS_HISTORY.DATE\" style=\"width: 15%\"></th><th translate=\"DOCUMENTS_HISTORY.VERSION\" style=\"width: 10%\"></th><th style=\"width: 10%\">&nbsp;</th></tr></thead><tbody ng-hide=\"documentsHistoryCtrl.review.status == \'Created\'\"><tr ng-repeat-start=\"document in documentsHistoryCtrl.mainDocuments\"><td ng-style=\"{\'width\': \'20%\', \'padding-left\': document.typePadding}\" ng-if=\"document.last\"><strong>{{document.name}}</strong></td><td style=\"width: 35%\" ng-if=\"document.last\">{{document.last.name}}</td><td style=\"width: 10%\" ng-if=\"document.last && document.last.createdOn\"><span class=\"user\" avatar=\"documentsHistoryCtrl.review.asset.users[document.last.userId].user.name\" role=\"document.last.userRole\"></span></td><td style=\"width: 15%\" ng-if=\"document.last && document.last.createdOn\">{{document.last.createdOn | formatDate: \'MMM DD, YYYY - h:mm a\'}}</td><td style=\"width: 10%\" ng-if=\"document.last && document.last.version\">{{document.last.version + \'.0\'}} <span class=\"fa m-l-xs\" ng-if=\"document.old.length > 0\" ng-click=\"document.opened = !document.opened\" ng-class=\"{\'fa-chevron-up\': document.opened, \'fa-chevron-down\': !document.opened}\"></span></td><td style=\"width: 10%\" class=\"tools\" ng-if=\"document.last && document.last.version\"><a class=\"btn btn-back\" ng-click=\"documentsHistoryCtrl.downloadValuationDocument(document.last)\"><i class=\"icon icon-ic-download\"></i></a></td></tr><tr></tr><tr ng-repeat-end=\"\"><td style=\"width: 100%\" class=\"no-padding\" colspan=\"6\" ng-show=\"document.opened\"><table class=\"table versions-table\"><tbody><tr ng-repeat=\"old in document.old | orderBy: \'-version\'\"><td style=\"width: 20%\">&nbsp;</td><td style=\"width: 35%\">{{old.name}}</td><td style=\"width: 10%\"><span class=\"user\" avatar=\"documentsHistoryCtrl.review.asset.users[old.userId].user.name\" role=\"old.userRole\"></span></td><td style=\"width: 15%\">{{old.createdOn | formatDate: \'MMM DD, YYYY - h:mm a\'}}</td><td style=\"width: 10%\">{{old.version + \'.0\'}}</td><td class=\"tools\" style=\"width: 10%\"><a class=\"btn btn-back\" ng-click=\"documentsHistoryCtrl.downloadValuationDocument(old)\"><i class=\"icon icon-ic-download\"></i></a></td></tr></tbody></table></td></tr><tr><td style=\"width: 20%\"><strong translate=\"DOCUMENTS_HISTORY.REVIEW_FORM\"></strong></td><td style=\"width: 35%\">{{documentsHistoryCtrl.review.asset.propertyRef + \'_\' + documentsHistoryCtrl.sanitizedAssetName(documentsHistoryCtrl.review.asset.name) + \'_\' + documentsHistoryCtrl.review.quarter + \'Q\' + documentsHistoryCtrl.review.year + \'_\' + \'ReviewForm.pdf\'}}</td><td style=\"width: 10%\"></td><td style=\"width: 15%\"></td><td style=\"width: 10%\"></td><td style=\"width: 10%\" class=\"tools\"><a class=\"btn btn-back\" ng-click=\"documentsHistoryCtrl.exportReviewForm(documentsHistoryCtrl.review)\"><i class=\"icon icon-ic-download\"></i></a></td></tr><tr><td style=\"width: 20%\"><strong translate=\"DOCUMENTS_HISTORY.EXECUTIVE_SUMMARY\"></strong></td><td style=\"width: 35%\">{{documentsHistoryCtrl.review.asset.propertyRef + \'_\' + documentsHistoryCtrl.sanitizedAssetName(documentsHistoryCtrl.review.asset.name) + \'_\' + documentsHistoryCtrl.review.quarter + \'Q\' + documentsHistoryCtrl.review.year + \'_\' + \'ExecutiveSummary.pdf\'}}</td><td style=\"width: 10%\"></td><td style=\"width: 15%\"></td><td style=\"width: 10%\"></td><td style=\"width: 10%\" class=\"tools\"><a class=\"btn btn-back\" ng-click=\"documentsHistoryCtrl.exportExecutiveSummary(documentsHistoryCtrl.review)\"><i class=\"icon icon-ic-download\"></i></a></td></tr></tbody></table></div></div><div class=\"hr-line-dashed\"></div><div class=\"row no-margin-left no-margin-right m-b-xl\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 documents\"><div class=\"in-line\"><h4 translate=\"DOCUMENTS_HISTORY.SOURCE_DOCUMENTS\"></h4></div><div class=\"in-line document-uploader\" td-security=\"[\'Admin\', \'AssetManagement\', \'AssetAppraisal\', \'AssetReview\']\"><input type=\"file\" name=\"file\" id=\"file\" class=\"input-file\" file-read=\"documentsHistoryCtrl.uploadSourceDocument\" multiple=\"true\"> <label class=\"btn btn-w-m btn-back m-l-sm\" for=\"file\" translate=\"DOCUMENTS_HISTORY.UPLOAD_SOURCE_DOCUMENT\"></label></div><table class=\"table table-striped\"><thead><tr><th translate=\"DOCUMENTS_HISTORY.DOCUMENT\" style=\"width: 45%\"></th><th style=\"width: 10%\">&nbsp;</th><th translate=\"DOCUMENTS_HISTORY.OWNER\" style=\"width: 10%\"></th><th translate=\"DOCUMENTS_HISTORY.DATE\" style=\"width: 15%\"></th><th style=\"width: 10%\">{{\'DOCUMENTS_HISTORY.VERSION\' | translate}}</th><th style=\"width: 10%\">&nbsp;</th></tr></thead><tbody><tr ng-repeat-start=\"document in documentsHistoryCtrl.lastSourceDocuments\"><td style=\"width: 45%\">{{document.name}}</td><td style=\"width: 10%\">&nbsp;</td><td style=\"width: 10%\"><span class=\"user\" avatar=\"documentsHistoryCtrl.review.asset.users[document.userId].user.name\" role=\"document.userRole\"></span></td><td style=\"width: 15%\">{{document.createdOn | formatDate: \'MMM DD, YYYY - h:mm a\'}}</td><td style=\"width: 10%\">{{document.version + \'.0\'}} <span class=\"fa m-l-xs\" ng-if=\"documentsHistoryCtrl.oldSourceDocumentsByName[document.name]\" ng-click=\"document.opened = !document.opened\" ng-class=\"{\'fa-chevron-up\': document.opened, \'fa-chevron-down\': !document.opened}\"></span></td><td style=\"width: 10%\" class=\"tools\"><a class=\"btn btn-back\"><i class=\"icon icon-ic-download\" ng-click=\"documentsHistoryCtrl.downloadValuationDocument(document)\"></i></a></td></tr><tr></tr><tr ng-repeat-end=\"\"><td style=\"width: 100%\" class=\"no-padding\" colspan=\"6\" ng-show=\"document.opened\"><table class=\"table versions-table\"><tbody><tr ng-repeat=\"old in documentsHistoryCtrl.oldSourceDocumentsByName[document.name] | orderBy: \'-version\'\"><td style=\"width: 45%\">{{old.name}}</td><td style=\"width: 10%\"></td><td style=\"width: 10%\"><span class=\"user\" avatar=\"documentsHistoryCtrl.review.asset.users[old.userId].user.name\" role=\"old.userRole\"></span></td><td style=\"width: 15%\">{{old.createdOn | formatDate: \'MMM DD, YYYY - h:mm a\'}}</td><td style=\"width: 10%\">{{old.version + \'.0\'}}</td><td class=\"tools\" style=\"width: 10%\"><a class=\"btn btn-back\"><i class=\"icon icon-ic-download\" ng-click=\"documentsHistoryCtrl.downloadValuationDocument(old)\"></i></a></td></tr></tbody></table></td></tr></tbody></table></div></div><div class=\"hr-line-dashed\"></div><div class=\"row no-margins\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 documents\"><h4 translate=\"DOCUMENTS_HISTORY.OTHER_DOCUMENTS\"></h4><table class=\"table table-striped\"><thead><tr><th translate=\"DOCUMENTS_HISTORY.DOCUMENT\" style=\"width: 45%\"></th><th style=\"width: 10%\">&nbsp;</th><th translate=\"DOCUMENTS_HISTORY.OWNER\" style=\"width: 10%\"></th><th translate=\"DOCUMENTS_HISTORY.DATE\" style=\"width: 15%\"></th><th translate=\"DOCUMENTS_HISTORY.VERSION\" style=\"width: 10%\"></th><th style=\"width: 10%\">&nbsp;</th></tr></thead><tbody><tr ng-repeat-start=\"document in documentsHistoryCtrl.lastOtherDocuments\"><td style=\"width: 45%\">{{document.name}}</td><td style=\"width: 10%\">&nbsp;</td><td style=\"width: 10%\"><span class=\"user\" avatar=\"documentsHistoryCtrl.review.asset.users[document.userId].user.name\" role=\"document.userRole\"></span></td><td style=\"width: 15%\">{{document.createdOn | formatDate: \'MMM DD, YYYY - h:mm a\'}}</td><td style=\"width: 10%\">{{document.version + \'.0\'}} <span class=\"fa m-l-xs\" ng-if=\"documentsHistoryCtrl.oldOtherDocumentsByName[document.name]\" ng-click=\"document.opened = !document.opened\" ng-class=\"{\'fa-chevron-up\': document.opened, \'fa-chevron-down\': !document.opened}\"></span></td><td style=\"width: 10%\" class=\"tools\"><a class=\"btn btn-back\"><i class=\"icon icon-ic-download\" ng-click=\"documentsHistoryCtrl.downloadValuationDocument(document)\"></i></a></td></tr><tr></tr><tr ng-repeat-end=\"\"><td style=\"width: 100%\" class=\"no-padding\" colspan=\"6\" ng-show=\"document.opened\"><table class=\"table versions-table\"><tbody><tr ng-repeat=\"old in documentsHistoryCtrl.oldOtherDocumentsByName[document.name] | orderBy: \'-version\'\"><td style=\"width: 45%\">{{old.name}}</td><td style=\"width: 10%\"></td><td style=\"width: 10%\"><span class=\"user\" avatar=\"documentsHistoryCtrl.review.asset.users[old.userId].user.name\" role=\"old.userRole\"></span></td><td style=\"width: 15%\">{{old.createdOn | formatDate: \'MMM DD, YYYY - h:mm a\'}}</td><td style=\"width: 10%\">{{old.version + \'.0\'}}</td><td class=\"tools\" style=\"width: 10%\"><a class=\"btn btn-back\"><i class=\"icon icon-ic-download\" ng-click=\"documentsHistoryCtrl.downloadValuationDocument(old)\"></i></a></td></tr></tbody></table></td></tr></tbody></table></div></div><div class=\"row no-margins\" ng-if=\"!reviewCtrl.readOnly\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 text-right\" td-security=\"[\'AssetReview\', \'Admin\']\" ng-if=\"documentsHistoryCtrl.review.status === \'ValuationSignedOff\' || documentsHistoryCtrl.review.status === \'FinalDocumentsUploaded\' || documentsHistoryCtrl.review.status === \'FinalFormFilled\'\"><button class=\"btn btn-w-m btn-back m-t-xl m-r-sm\" ng-click=\"documentsHistoryCtrl.reject()\" review-checker=\"documentsHistoryCtrl.review\" actions=\"[\'RW_Reject\']\" behaviour=\"\'disable\'\">{{\'DOCUMENTS_HISTORY.REJECT\' | translate}}</button> <button class=\"btn btn-w-m btn-normal m-t-xl\" ng-click=\"documentsHistoryCtrl.archive()\" review-checker=\"documentsHistoryCtrl.review\" actions=\"[\'RW_ArchiveDocuments\']\" behaviour=\"\'disable\'\">{{\'DOCUMENTS_HISTORY.ARCHIVE\' | translate}}</button></div></div></div></div><div class=\"ibox float-e-margins\"><div class=\"ibox-content no-padding-left no-padding-right\" data-ng-attr-style=\"{{ documentsHistoryCtrl.isFromHistory == true && \'padding-top: 20px !important\' }}\"><div class=\"row no-margins\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 title m-b-lg\"><h3 translate=\"DOCUMENTS_HISTORY.HISTORY\"></h3></div></div><div class=\"row no-margins\"><div class=\"col-lg-8 col-md-12 col-sm-12 col-xs-12 no-margins search\"><div class=\"row no-margins\"><div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3 search-field\"><select name=\"years\" class=\"form-control\" chosen=\"\" ng-model=\"documentsHistoryCtrl.showHistory.year\" ng-options=\"k as k for (k,v) in documentsHistoryCtrl.reviewHistory\" required=\"\"><option style=\"display:none\" value=\"\" translate=\"DOCUMENTS_HISTORY.TYPE_YEAR\"></option></select></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><span ng-if=\"\'Annually\' === documentsHistoryCtrl.valuationFrequency || \'Annual\' === documentsHistoryCtrl.valuationFrequency\" translate=\"DOCUMENTS_HISTORY.QUARTER\"></span> <span ng-if=\"\'SemiAnnually\' === documentsHistoryCtrl.valuationFrequency || \'Semi-Annual\' === documentsHistoryCtrl.valuationFrequency\" translate=\"DOCUMENTS_HISTORY.QUARTER\"></span> <span ng-if=\"\'Quarterly\' === documentsHistoryCtrl.valuationFrequency\" translate=\"DOCUMENTS_HISTORY.QUARTER\"></span></div></div><div class=\"row\"><div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3\" ng-if=\"documentsHistoryCtrl.isQuarterVisible(documentsHistoryCtrl.reviewHistory[documentsHistoryCtrl.showHistory.year][1])\"><input type=\"radio\" value=\"1\" id=\"Q1\" name=\"quarter\" ng-disabled=\"!documentsHistoryCtrl.reviewHistory[documentsHistoryCtrl.showHistory.year][1] || documentsHistoryCtrl.isHistoricValuationDisabled(1)\" ng-model=\"documentsHistoryCtrl.showHistory.quarter\"><label class=\"quarter-label\" for=\"Q1\" ng-if=\"true || \'Annually\' === documentsHistoryCtrl.valuationFrequency || \'Quarterly\' === documentsHistoryCtrl.valuationFrequency\">Q1</label></div><div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3\" ng-if=\"documentsHistoryCtrl.isQuarterVisible(documentsHistoryCtrl.reviewHistory[documentsHistoryCtrl.showHistory.year][2])\"><input type=\"radio\" value=\"2\" id=\"Q2\" name=\"quarter\" ng-disabled=\"!documentsHistoryCtrl.reviewHistory[documentsHistoryCtrl.showHistory.year][2] || documentsHistoryCtrl.isHistoricValuationDisabled(2)\" ng-model=\"documentsHistoryCtrl.showHistory.quarter\"><label class=\"quarter-label\" for=\"Q2\" ng-if=\"true || \'Annually\' === documentsHistoryCtrl.valuationFrequency || \'Quarterly\' === documentsHistoryCtrl.valuationFrequency\">Q2</label></div><div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3\" ng-if=\"documentsHistoryCtrl.isQuarterVisible(documentsHistoryCtrl.reviewHistory[documentsHistoryCtrl.showHistory.year][3])\"><input type=\"radio\" value=\"3\" id=\"Q3\" name=\"quarter\" ng-disabled=\"!documentsHistoryCtrl.reviewHistory[documentsHistoryCtrl.showHistory.year][3] || documentsHistoryCtrl.isHistoricValuationDisabled(3)\" ng-model=\"documentsHistoryCtrl.showHistory.quarter\"><label class=\"quarter-label\" for=\"Q3\" ng-if=\"true || \'Annually\' === documentsHistoryCtrl.valuationFrequency || \'Quarterly\' === documentsHistoryCtrl.valuationFrequency\">Q3</label></div><div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-3\" ng-if=\"documentsHistoryCtrl.isQuarterVisible(documentsHistoryCtrl.reviewHistory[documentsHistoryCtrl.showHistory.year][4])\"><input type=\"radio\" value=\"4\" id=\"Q4\" name=\"quarter\" ng-disabled=\"!documentsHistoryCtrl.reviewHistory[documentsHistoryCtrl.showHistory.year][4] || documentsHistoryCtrl.isHistoricValuationDisabled(4)\" ng-model=\"documentsHistoryCtrl.showHistory.quarter\"><label class=\"quarter-label\" for=\"Q4\" ng-if=\"true || \'Annually\' === documentsHistoryCtrl.valuationFrequency || \'Quarterly\' === documentsHistoryCtrl.valuationFrequency\">Q4</label></div></div></div></div></div></div><hr><div class=\"search-results fixed-height\"><perfect-scrollbar class=\"scroller\" wheel-propagation=\"true\" wheel-speed=\"1\" min-scrollbar-length=\"20\"><div class=\"result\"><div class=\"row no-margins\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 m-t-xl valuation-documents\"><h4 class=\"no-margins\">{{documentsHistoryCtrl.showHistory.year + \' Q\' + documentsHistoryCtrl.showHistory.quarter}} - Valuation Documents</h4><div class=\"in-line\" td-security=\"[\'Admin\', \'AssetAppraisal\', \'AssetReview\']\"><button class=\"btn btn-back btn-w-m m-l-sm\" translate=\"DOCUMENTS_HISTORY.UPDATE_DOCUMENTS\" ng-disabled=\"((documentsHistoryCtrl.reviewHistory[documentsHistoryCtrl.showHistory.year][documentsHistoryCtrl.showHistory.quarter].review.status === \'FinalDocumentsUploaded\'|| documentsHistoryCtrl.reviewHistory[documentsHistoryCtrl.showHistory.year][documentsHistoryCtrl.showHistory.quarter].review.status === \'FinalFilesRejected\' || documentsHistoryCtrl.reviewHistory[documentsHistoryCtrl.showHistory.year][documentsHistoryCtrl.showHistory.quarter].review.status === \'ValuationSignedOff\' || documentsHistoryCtrl.reviewHistory[documentsHistoryCtrl.showHistory.year][documentsHistoryCtrl.showHistory.quarter].review.status === \'FinalFormFilled\' || documentsHistoryCtrl.reviewHistory[documentsHistoryCtrl.showHistory.year][documentsHistoryCtrl.showHistory.quarter].review.status === \'Finished\' ) && documentsHistoryCtrl.role !== \'Admin\')\" ng-click=\"documentsHistoryCtrl.gotoUpload(documentsHistoryCtrl.showHistory.quarter, documentsHistoryCtrl.showHistory.year)\"></button></div></div></div><hr><div class=\"row no-margins\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 documents\"><table class=\"table table-striped\"><thead><tr><th translate=\"DOCUMENTS_HISTORY.TYPE\" style=\"width: 20%\"></th><th translate=\"DOCUMENTS_HISTORY.DOCUMENT\" style=\"width: 35%\"></th><th translate=\"DOCUMENTS_HISTORY.OWNER\" style=\"width: 10%\"></th><th translate=\"DOCUMENTS_HISTORY.DATE\" style=\"width: 15%\"></th><th style=\"width: 10%\"><span class=\"version\" td-security=\"[\'Admin\']\">{{\'DOCUMENTS_HISTORY.VERSION\' | translate}}</span></th><th style=\"width: 10%\">&nbsp;</th></tr></thead><tbody><tr ng-if=\"document.last\" ng-repeat-start=\"document in documentsHistoryCtrl.reviewHistory[documentsHistoryCtrl.showHistory.year][documentsHistoryCtrl.showHistory.quarter].mainFiles\"><td ng-style=\"{\'width\': \'20%\', \'padding-left\': document.typePadding}\"><strong>{{document.name}}</strong></td><td style=\"width: 35%\" ng-if=\"document.last\">{{document.last.name}}</td><td style=\"width: 10%\" ng-if=\"document.last && document.last.createdOn\"><span class=\"user\" avatar=\"documentsHistoryCtrl.review.asset.users[document.last.userId].user.name\" role=\"document.last.userRole\"></span> <span class=\"m-l-xs\" ng-show=\"documentsHistoryCtrl.displayNames(document.last.userRole)\">{{documentsHistoryCtrl.review.asset.users[document.last.userId].user.name}}</span></td><td style=\"width: 15%\" ng-if=\"document.last && document.last.createdOn\">{{document.last.createdOn | formatDate: \'MMM DD, YYYY - h:mm a\'}}</td><td style=\"width: 10%\" ng-if=\"document.last && document.last.version\" td-security=\"[\'Admin\', \'AssetAppraisal\', \'AssetReview\']\">{{document.last.version + \'.0\'}} <span class=\"fa m-l-xs\" ng-if=\"document.old.length > 0\" ng-click=\"document.opened = !document.opened\" ng-class=\"{\'fa-chevron-up\': document.opened, \'fa-chevron-down\': !document.opened}\"></span></td><td style=\"width: 10%\" class=\"tools\" ng-if=\"document.last && document.last.version\"><a class=\"btn btn-back\" ng-click=\"documentsHistoryCtrl.downloadValuationDocument(document.last)\"><i class=\"icon icon-ic-download\"></i></a></td></tr><tr></tr><tr ng-repeat-end=\"\"><td style=\"width: 100%\" class=\"no-padding\" colspan=\"6\" ng-show=\"document.opened\"><table class=\"table versions-table\"><tbody><tr ng-repeat=\"old in document.old | orderBy: \'-version\'\"><td style=\"width: 20%\">&nbsp;</td><td style=\"width: 35%\">{{old.name}}</td><td style=\"width: 10%\"><span class=\"user\" avatar=\"documentsHistoryCtrl.review.asset.users[old.userId].user.name\" role=\"old.userRole\"></span> <span class=\"m-l-xs\" ng-show=\"documentsHistoryCtrl.displayNames(old.userRole)\">{{documentsHistoryCtrl.review.asset.users[old.userId].user.name}}</span></td><td style=\"width: 15%\">{{old.createdOn | formatDate: \'MMM DD, YYYY - h:mm a\'}}</td><td style=\"width: 10%\">{{old.version + \'.0\'}}</td><td class=\"tools\" style=\"width: 10%\"><a class=\"btn btn-back\" ng-click=\"documentsHistoryCtrl.downloadValuationDocument(old)\"><i class=\"icon icon-ic-download\"></i></a></td></tr></tbody></table></td></tr><tr ng-if=\"documentsHistoryCtrl.reviewHistory[documentsHistoryCtrl.showHistory.year][documentsHistoryCtrl.showHistory.quarter].mainFiles[0].last\"><td style=\"width: 20%\"><strong translate=\"DOCUMENTS_HISTORY.REVIEW_FORM\"></strong></td><td style=\"width: 35%\">{{documentsHistoryCtrl.reviewHistory[documentsHistoryCtrl.showHistory.year][documentsHistoryCtrl.showHistory.quarter].review.asset.propertyRef + \'_\' + documentsHistoryCtrl.sanitizedAssetName(documentsHistoryCtrl.reviewHistory[documentsHistoryCtrl.showHistory.year][documentsHistoryCtrl.showHistory.quarter].review.asset.name) + \'_\' + documentsHistoryCtrl.reviewHistory[documentsHistoryCtrl.showHistory.year][documentsHistoryCtrl.showHistory.quarter].review.quarter + \'Q\' + documentsHistoryCtrl.reviewHistory[documentsHistoryCtrl.showHistory.year][documentsHistoryCtrl.showHistory.quarter].review.year + \'_\' + \'ReviewForm.pdf\'}}</td><td style=\"width: 10%\"></td><td style=\"width: 15%\"></td><td style=\"width: 10%\"></td><td style=\"width: 10%\" class=\"tools\"><a class=\"btn btn-back\" ng-click=\"documentsHistoryCtrl.exportReviewForm(documentsHistoryCtrl.reviewHistory[documentsHistoryCtrl.showHistory.year][documentsHistoryCtrl.showHistory.quarter].review)\"><i class=\"icon icon-ic-download\"></i></a></td></tr><tr ng-if=\"documentsHistoryCtrl.reviewHistory[documentsHistoryCtrl.showHistory.year][documentsHistoryCtrl.showHistory.quarter].mainFiles[0].last\"><td style=\"width: 20%\"><strong translate=\"DOCUMENTS_HISTORY.EXECUTIVE_SUMMARY\"></strong></td><td style=\"width: 35%\">{{documentsHistoryCtrl.reviewHistory[documentsHistoryCtrl.showHistory.year][documentsHistoryCtrl.showHistory.quarter].review.asset.propertyRef + \'_\' + documentsHistoryCtrl.sanitizedAssetName(documentsHistoryCtrl.reviewHistory[documentsHistoryCtrl.showHistory.year][documentsHistoryCtrl.showHistory.quarter].review.asset.name) + \'_\' + documentsHistoryCtrl.reviewHistory[documentsHistoryCtrl.showHistory.year][documentsHistoryCtrl.showHistory.quarter].review.quarter + \'Q\' + documentsHistoryCtrl.reviewHistory[documentsHistoryCtrl.showHistory.year][documentsHistoryCtrl.showHistory.quarter].review.year + \'_\' + \'ExecutiveSummary.pdf\'}}</td><td style=\"width: 10%\"></td><td style=\"width: 15%\"></td><td style=\"width: 10%\"></td><td style=\"width: 10%\" class=\"tools\"><a class=\"btn btn-back\" ng-click=\"documentsHistoryCtrl.exportExecutiveSummary(documentsHistoryCtrl.reviewHistory[documentsHistoryCtrl.showHistory.year][documentsHistoryCtrl.showHistory.quarter].review)\"><i class=\"icon icon-ic-download\"></i></a></td></tr></tbody></table></div></div></div><div class=\"result\"><div class=\"row no-margins\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 m-t-xl\"><div class=\"in-line\"><h4 class=\"no-margins\">{{documentsHistoryCtrl.showHistory.year + \' Q\' + documentsHistoryCtrl.showHistory.quarter}} - Source Documents</h4></div><div class=\"in-line document-uploader\" td-security=\"[\'Admin\', \'AssetManagement\', \'AssetAppraisal\', \'AssetReview\']\" ng-if=\"documentsHistoryCtrl.reviewHistory[documentsHistoryCtrl.showHistory.year][documentsHistoryCtrl.showHistory.quarter].review.status != \'Finished\' || (documentsHistoryCtrl.reviewHistory[documentsHistoryCtrl.showHistory.year][documentsHistoryCtrl.showHistory.quarter].review.status == \'Finished\' && documentsHistoryCtrl.role == \'Admin\')\"><input type=\"file\" name=\"file\" id=\"historicalFile\" class=\"input-file\" file-read=\"documentsHistoryCtrl.uploadHistorySourceDocument\" multiple=\"true\"> <label class=\"btn btn-w-m btn-back m-l-sm\" for=\"historicalFile\" translate=\"DOCUMENTS_HISTORY.UPLOAD_SOURCE_DOCUMENT\"></label></div></div></div><hr><div class=\"row no-margins\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 documents\"><table class=\"table table-striped\"><thead><tr><th translate=\"DOCUMENTS_HISTORY.DOCUMENT\" style=\"width: 45%\"></th><th style=\"width: 10%\">&nbsp;</th><th translate=\"DOCUMENTS_HISTORY.OWNER\" style=\"width: 10%\"></th><th translate=\"DOCUMENTS_HISTORY.DATE\" style=\"width: 15%\"></th><th style=\"width: 10%\" ng-if=\"documentsHistoryCtrl.reviewHistory[documentsHistoryCtrl.showHistory.year][documentsHistoryCtrl.showHistory.quarter].review.status != \'Finished\' || (documentsHistoryCtrl.reviewHistory[documentsHistoryCtrl.showHistory.year][documentsHistoryCtrl.showHistory.quarter].review.status == \'Finished\' && documentsHistoryCtrl.role == \'Admin\')\">{{\'DOCUMENTS_HISTORY.VERSION\' | translate}}</th><th style=\"width: 10%\" ng-if=\"documentsHistoryCtrl.reviewHistory[documentsHistoryCtrl.showHistory.year][documentsHistoryCtrl.showHistory.quarter].review.status == \'Finished\' && documentsHistoryCtrl.role != \'Admin\'\">&nbsp;</th><th style=\"width: 10%\">&nbsp;</th></tr></thead><tbody><tr ng-repeat-start=\"document in documentsHistoryCtrl.reviewHistory[documentsHistoryCtrl.showHistory.year][documentsHistoryCtrl.showHistory.quarter].sourceFiles.last\"><td style=\"width: 45%\">{{document.name}}</td><td style=\"width: 10%\">&nbsp;</td><td style=\"width: 10%\"><span class=\"user\" avatar=\"documentsHistoryCtrl.review.asset.users[document.userId].user.name\" role=\"document.userRole\"></span> <span class=\"m-l-xs\" ng-show=\"documentsHistoryCtrl.displayNames(document.userRole)\">{{documentsHistoryCtrl.review.asset.users[document.userId].user.name}}</span></td><td style=\"width: 15%\">{{document.createdOn | formatDate: \'MMM DD, YYYY - h:mm a\'}}</td><td style=\"width: 10%\" ng-if=\"documentsHistoryCtrl.reviewHistory[documentsHistoryCtrl.showHistory.year][documentsHistoryCtrl.showHistory.quarter].review.status != \'Finished\' || (documentsHistoryCtrl.reviewHistory[documentsHistoryCtrl.showHistory.year][documentsHistoryCtrl.showHistory.quarter].review.status == \'Finished\' && documentsHistoryCtrl.role == \'Admin\')\">{{document.version + \'.0\'}} <span class=\"fa m-l-xs\" td-security=\"[\'Admin\', \'AssetAppraisal\', \'AssetReview\']\" ng-if=\"documentsHistoryCtrl.reviewHistory[documentsHistoryCtrl.showHistory.year][documentsHistoryCtrl.showHistory.quarter].sourceFiles.old[document.name].length > 0\" ng-click=\"document.opened = !document.opened\" ng-class=\"{\'fa-chevron-up\': document.opened, \'fa-chevron-down\': !document.opened}\"></span></td><td style=\"width: 10%\" class=\"tools\"><a class=\"btn btn-back\"><i class=\"icon icon-ic-download\" ng-click=\"documentsHistoryCtrl.downloadValuationDocument(document)\"></i></a></td></tr><tr>&nbsp;</tr><tr ng-repeat-end=\"\"><td style=\"width: 100%\" class=\"no-padding\" colspan=\"6\" ng-show=\"document.opened\"><table class=\"table versions-table\"><tbody><tr ng-repeat=\"old in documentsHistoryCtrl.reviewHistory[documentsHistoryCtrl.showHistory.year][documentsHistoryCtrl.showHistory.quarter].sourceFiles.old[document.name] | orderBy: \'-version\'\"><td style=\"width: 45%\">{{old.name}}</td><td style=\"width: 10%\"></td><td style=\"width: 10%\"><span class=\"user\" avatar=\"documentsHistoryCtrl.review.asset.users[old.userId].user.name\" role=\"old.userRole\"></span> <span class=\"m-l-xs\" ng-show=\"documentsHistoryCtrl.displayNames(old.userRole)\">{{documentsHistoryCtrl.review.asset.users[old.userId].user.name}}</span></td><td style=\"width: 15%\">{{old.createdOn | formatDate: \'MMM DD, YYYY - h:mm a\'}}</td><td style=\"width: 10%\">{{old.version + \'.0\'}}</td><td class=\"tools\" style=\"width: 10%\"><a class=\"btn btn-back\"><i class=\"icon icon-ic-download\" ng-click=\"documentsHistoryCtrl.downloadValuationDocument(old)\"></i></a></td></tr></tbody></table></td></tr></tbody></table></div></div></div><div class=\"result\"><div class=\"row no-margins\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 m-t-xl\"><h4 class=\"no-margins\">{{documentsHistoryCtrl.showHistory.year + \' Q\' + documentsHistoryCtrl.showHistory.quarter}} - Other Documents & Assignment Invoice</h4></div></div><hr><div class=\"row no-margins\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 documents\"><table class=\"table table-striped\"><thead><tr><th translate=\"DOCUMENTS_HISTORY.DOCUMENT\" style=\"width: 45%\"></th><th style=\"width: 10%\">&nbsp;</th><th translate=\"DOCUMENTS_HISTORY.OWNER\" style=\"width: 10%\"></th><th translate=\"DOCUMENTS_HISTORY.DATE\" style=\"width: 15%\"></th><th style=\"width: 10%\"><span class=\"version\" td-security=\"[\'Admin\']\">{{\'DOCUMENTS_HISTORY.VERSION\' | translate}}</span></th><th style=\"width: 10%\">&nbsp;</th></tr></thead><tbody><tr ng-repeat-start=\"document in documentsHistoryCtrl.reviewHistory[documentsHistoryCtrl.showHistory.year][documentsHistoryCtrl.showHistory.quarter].otherFiles.last\"><td style=\"width: 45%\">{{document.name}}</td><td style=\"width: 10%\">&nbsp;</td><td style=\"width: 10%\"><span class=\"user\" avatar=\"documentsHistoryCtrl.review.asset.users[document.userId].user.name\" role=\"document.userRole\"></span> <span class=\"m-l-xs\" ng-show=\"documentsHistoryCtrl.displayNames(document.userRole)\">{{documentsHistoryCtrl.review.asset.users[document.userId].user.name}}</span></td><td style=\"width: 15%\">{{document.createdOn | formatDate: \'MMM DD, YYYY - h:mm a\'}}</td><td style=\"width: 10%\" td-security=\"[\'Admin\', \'AssetAppraisal\', \'AssetReview\']\">{{document.version + \'.0\'}} <span class=\"fa m-l-xs\" ng-if=\"documentsHistoryCtrl.reviewHistory[documentsHistoryCtrl.showHistory.year][documentsHistoryCtrl.showHistory.quarter].otherFiles.old[document.name].length > 0\" ng-click=\"document.opened = !document.opened\" ng-class=\"{\'fa-chevron-up\': document.opened, \'fa-chevron-down\': !document.opened}\"></span></td><td style=\"width: 10%\" class=\"tools\"><a class=\"btn btn-back\"><i class=\"icon icon-ic-download\" ng-click=\"documentsHistoryCtrl.downloadValuationDocument(document)\"></i></a></td></tr><tr>&nbsp;</tr><tr ng-repeat-end=\"\"><td style=\"width: 100%\" class=\"no-padding\" colspan=\"6\" ng-show=\"document.opened\"><table class=\"table versions-table\"><tbody><tr ng-repeat=\"old in documentsHistoryCtrl.reviewHistory[documentsHistoryCtrl.showHistory.year][documentsHistoryCtrl.showHistory.quarter].otherFiles.old[document.name] | orderBy: \'-version\'\"><td style=\"width: 45%\">{{old.name}}</td><td style=\"width: 10%\"></td><td style=\"width: 10%\"><span class=\"user\" avatar=\"documentsHistoryCtrl.review.asset.users[old.userId].user.name\" role=\"old.userRole\"></span> <span class=\"m-l-xs\" ng-show=\"documentsHistoryCtrl.displayNames(old.userRole)\">{{documentsHistoryCtrl.review.asset.users[old.userId].user.name}}</span></td><td style=\"width: 15%\">{{old.createdOn | formatDate: \'MMM DD, YYYY - h:mm a\'}}</td><td style=\"width: 10%\">{{old.version + \'.0\'}}</td><td class=\"tools\" style=\"width: 10%\"><a class=\"btn btn-back\"><i class=\"icon icon-ic-download\" ng-click=\"documentsHistoryCtrl.downloadValuationDocument(old)\"></i></a></td></tr></tbody></table></td></tr></tbody></table></div></div></div></perfect-scrollbar></div></div></div></div></div></div>");
$templateCache.put("app/components/commons/messages/pop-up/general-error/general-error-pop-up.html","<div class=\"inmodal\"><div class=\"modal-header\"><h4 class=\"modal-title\" translate=\"GENERAL_ERROR.MAIN_TITLE\"></h4></div><div class=\"modal-body\"><p class=\"text-center\" translate=\"GENERAL_ERROR.MESSAGE\"></p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-normal\" ng-click=\"closePopUpGeneralError()\" translate=\"GENERAL_ERROR.CLOSE\"></button></div></div>");
$templateCache.put("app/states/valuations/review/discussion/comment-states/all-comments/all-comments.html","<div class=\"col-lg-9 col-md-8 col-sm-8 col-xs-8 comments\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content fixed-height no-padding\" ng-if=\"allCommentsCtrl.review.status != \'Created\' && allCommentsCtrl.review.status != \'DocumentsUploaded\' && allCommentsCtrl.review.comments.comments && allCommentsCtrl.review.comments.comments.length > 0\"><perfect-scrollbar class=\"scroller\" wheel-propagation=\"true\" wheel-speed=\"1\" min-scrollbar-length=\"20\"><div class=\"all-comments\"><div class=\"row no-margins\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><h3 class=\"m-b-xl p-h-lg\">{{allCommentsCtrl.commentsTitle[commentsCtrl.filter]}}</h3></div></div><div class=\"comment\" ng-repeat=\"comment in allCommentsCtrl.review.comments.comments | filter:{\'type\': commentsCtrl.filter} | orderBy:\'-nms\'\"><div class=\"row no-margins\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 comment-info\" ui-sref=\"app.review.discussion.viewComment ({commentId: comment.id, comment: comment})\"><div class=\"row no-margins\"><div class=\"comment-submitter text-right m-l-md f-l no-padding\"><span ng-if=\"comment.originalUserId && allCommentsCtrl.displayNames(allCommentsCtrl.review.comments.users[comment.originalUserId].name, comment.userRole)\" class=\"user\" avatar=\"allCommentsCtrl.review.comments.users[comment.originalUserId].name\" role=\"comment.originalUserRole\"></span> <span ng-if=\"!comment.originalUserId && allCommentsCtrl.displayNames(allCommentsCtrl.review.comments.users[comment.userId].name, comment.userRole)\" class=\"user\" avatar=\"allCommentsCtrl.review.comments.users[comment.userId].name\" role=\"comment.userRole\"></span> <span ng-if=\"!allCommentsCtrl.displayNames(allCommentsCtrl.review.comments.users[comment.userId].name, comment.userRole) && !allCommentsCtrl.displayNames(allCommentsCtrl.review.comments.users[comment.originalUserId].name, comment.userRole)\" class=\"user\" avatar=\"allCommentsCtrl.review.comments.users[comment.userId].name\" role=\"comment.userRole\"></span></div><div class=\"col-lg-9 col-md-8 col-sm-8 col-xs-8\"><span class=\"comment-title m-b-xs\">{{comment.title}}</span><div class=\"m-b-sm\"><span class=\"comment-name m-r-sm\" ng-if=\"!comment.originalUserId && allCommentsCtrl.displayNames(allCommentsCtrl.review.comments.users[comment.userId].name, comment.userRole)\">{{allCommentsCtrl.review.comments.users[comment.userId].name}}</span> <span class=\"comment-name m-r-sm\" ng-if=\"comment.originalUserId && allCommentsCtrl.displayNames(allCommentsCtrl.review.comments.users[comment.originalUserId].name, allCommentsCtrl.review.comments.users[comment.originalUserId].type)\">{{allCommentsCtrl.review.comments.users[comment.originalUserId].name}}</span> <span class=\"date\">{{(comment.originalCommentTime || comment.submittedOn || comment.nms)| formatDate: \'MMM DD - h:mm a\'}}</span> <span ng-show=\"comment.status == \'Draft\'\" class=\"saved-comment m-l-sm\" translate=\"COMMENT_STATES.SAVED_COMMENT\"></span></div><div class=\"comment-message\"><p ng-bind-html=\"comment.body\"></p></div></div><div class=\"col-lg-2 col-md-3 col-sm-3 col-xs-3 comment-tools\"><div class=\"tools-buttons\"><div review-checker=\"allCommentsCtrl.review\" actions=\"[\'AM_Comment\', \'AP_Reply\']\" class=\"in-line\"><button class=\"btn btn-back btn-edit m-r-xs\" ng-if=\"comment.status == \'Draft\' && !reviewCtrl.readOnly\" td-security=\"[\'AssetManagement\', \'AssetAppraisal\',\'AssetManagerReadOnly\']\" ng-click=\"allCommentsCtrl.editComment($event, comment)\"><i class=\"icon icon-ic-edit-comment\"></i></button></div><div review-checker=\"allCommentsCtrl.review\" actions=\"[\'RW_Comment\', \'RW_Submit\', \'LRW_Comment\']\" class=\"in-line\"><button class=\"btn btn-back btn-edit m-r-xs\" ng-if=\"!reviewCtrl.readOnly\" td-security=\"[\'AssetReview\']\" action=\"display-none\" ng-click=\"allCommentsCtrl.editComment($event, comment)\"><i class=\"icon icon-ic-edit-comment\"></i></button></div><div review-checker=\"allCommentsCtrl.review\" actions=\"[\'RW_Comment\', \'RW_Submit\', \'LRW_Comment\', \'AM_Comment\', \'AP_Reply\']\" class=\"in-line\"><button class=\"btn btn-back btn-edit m-r-xs\" td-security=\"[\'Admin\']\" action=\"display-none\" ng-click=\"allCommentsCtrl.editComment($event, comment)\" ng-if=\"comment.status == \'Draft\' && !reviewCtrl.readOnly\"><i class=\"icon icon-ic-edit-comment\"></i></button></div><div review-checker=\"allCommentsCtrl.review\" actions=\"[\'RW_Comment\', \'RW_Submit\', \'LRW_Comment\']\" class=\"in-line\"><button class=\"btn btn-back btn-edit m-r-xs\" td-security=\"[\'Admin\']\" action=\"display-none\" ng-click=\"allCommentsCtrl.editComment($event, comment)\" ng-if=\"comment.status != \'Draft\' && !reviewCtrl.readOnly\"><i class=\"icon icon-ic-edit-comment\"></i></button></div><div review-checker=\"allCommentsCtrl.review\" actions=\"[\'RW_Comment\', \'RW_Submit\', \'AM_Comment\', \'AP_Reply\', \'LRW_Comment\']\" class=\"in-line\"><button class=\"btn btn-back btn-delete\" td-security=\"[\'AssetReview\', \'Admin\']\" action=\"display-none\" ng-click=\"allCommentsCtrl.deleteDraftComment($event, comment)\" ng-if=\"!reviewCtrl.readOnly && !(allCommentsCtrl.currentRole === \'Administrator\' && comment.status != \'Draft\' && (allCommentsCtrl.review.status == \'ReviewerCommented\' || allCommentsCtrl.review.status == \'SubmittedToAppraiser\' || allCommentsCtrl.review.status == \'ReviewerApproveValuation\')) && (comment.originalUserId == allCommentsCtrl.currentUserId || (!comment.originalUserId && comment.userId == allCommentsCtrl.currentUserId) || comment.originalUserRole == allCommentsCtrl.currentRole || (!comment.originalUserRole && comment.userRole == allCommentsCtrl.currentRole))\"><i class=\"icon icon-ic-trash-delete\"></i></button> <button class=\"btn btn-back btn-delete\" ng-if=\"comment.status == \'Draft\' && !reviewCtrl.readOnly\" td-security=\"[\'AssetManagement\',\'AssetManagerReadOnly\']\" action=\"display-none\" ng-click=\"allCommentsCtrl.deleteDraftComment($event, comment)\"><i class=\"icon icon-ic-trash-delete\"></i></button></div><div review-checker=\"allCommentsCtrl.review\" actions=\"[\'RW_Comment\', \'RW_Submit\', \'LRW_Comment\']\" class=\"in-line\"><button class=\"btn btn-back btn-delete\" ng-click=\"allCommentsCtrl.deleteComment($event, comment)\" ng-if=\"!reviewCtrl.readOnly && ((comment.originalUserId != allCommentsCtrl.currentUserId && !(!comment.originalUserId && comment.userId == allCommentsCtrl.currentUserId)) && comment.originalUserRole != allCommentsCtrl.currentRole && !(!comment.originalUserRole && comment.userRole == allCommentsCtrl.currentRole))\" td-security=\"[\'Admin\', \'AssetReview\']\" action=\"display-none\"><i class=\"icon icon-ic-trash-delete\"></i></button></div><br><button class=\"btn btn-primary btn-reply no-margins\" review-checker=\"allCommentsCtrl.review\" actions=\"[\'AM_Comment\', \'RW_Comment\', \'RW_Submit\', \'AP_Reply\', \'LRW_Comment\']\" ng-if=\"(comment.status == \'Submitted\' || comment.status == \'Review\') && !reviewCtrl.readOnly\" ng-click=\"allCommentsCtrl.reply($event, comment)\"><i class=\"icon icon-ic-replyarrow m-r-xs\"></i>{{\'COMMENT_STATES.REPLY\' | translate}}</button></div></div></div></div></div><div class=\"row no-margins\" ng-repeat=\"reply in comment.replies | orderBy:allCommentsCtrl.sortReplies\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 comment-replies no-padding\" ui-sref=\"app.review.discussion.viewComment ({commentId: comment.id, comment: comment})\"><div class=\"row no-margins reply\"><div class=\"comment-submitter text-right m-l-md f-l no-padding\"><span ng-if=\"reply.originalUserId\" class=\"user\" avatar=\"allCommentsCtrl.review.comments.users[reply.originalUserId].name\" role=\"reply.originalUserRole\"></span> <span ng-if=\"!reply.originalUserId\" class=\"user\" avatar=\"allCommentsCtrl.review.comments.users[reply.userId].name\" role=\"reply.userRole\"></span></div><div class=\"col-lg-9 col-md-8 col-sm-8 col-xs-8 reply-content\"><div class=\"m-b-xs\"><span class=\"comment-name m-r-sm\" ng-if=\"!reply.originalUserId && allCommentsCtrl.displayNames(allCommentsCtrl.review.comments.users[reply.userId].name, reply.userRole)\">{{allCommentsCtrl.review.comments.users[reply.userId].name}}</span> <span class=\"comment-name m-r-sm\" ng-if=\"reply.originalUserId && allCommentsCtrl.displayNames(allCommentsCtrl.review.comments.users[reply.originalUserId].name, allCommentsCtrl.review.comments.users[reply.originalUserId].type)\">{{allCommentsCtrl.review.comments.users[reply.originalUserId].name}}</span> <span class=\"date m-r-sm\">{{(reply.originalCommentTime || reply.submittedOn || reply.createdOn) | formatDate: \'MMM DD - h:mm a\'}}</span> <span ng-show=\"reply.status == \'Draft\'\" class=\"saved-reply\" translate=\"COMMENT_STATES.SAVED_REPLY\"></span></div><p ng-bind-html=\"reply.body\"></p></div><div class=\"col-lg-2 col-md-3 col-sm-3 col-xs-3 comment-tools\"><div class=\"tools-buttons\"><div review-checker=\"allCommentsCtrl.review\" actions=\"[\'AM_Comment\', \'AP_Reply\', \'RW_Comment\', \'RW_Submit\', \'LRW_Comment\']\" class=\"in-line\"><button class=\"btn btn-back btn-edit m-r-xs\" ng-if=\"reply.status == \'Draft\' && !reviewCtrl.readOnly\" td-security=\"[\'AssetManagement\', \'AssetAppraisal\', \'Admin\', \'AssetReview\', \'AssetManagerReadOnly\']\" ng-click=\"allCommentsCtrl.editComment($event, reply)\"><i class=\"icon icon-ic-edit-comment\"></i></button></div><div review-checker=\"allCommentsCtrl.review\" actions=\"[\'RW_Comment\', \'RW_Submit\', \'LRW_Comment\']\" class=\"in-line\"><button class=\"btn btn-back btn-edit m-r-xs\" ng-if=\"reply.status != \'Draft\' && !reviewCtrl.readOnly\" td-security=\"[\'Admin\', \'AssetReview\']\" action=\"display-none\" ng-click=\"allCommentsCtrl.editComment($event, reply)\"><i class=\"icon icon-ic-edit-comment\"></i></button></div><div review-checker=\"allCommentsCtrl.review\" actions=\"[\'RW_Comment\', \'RW_Submit\', \'AM_Comment\', \'AP_Reply\', \'LRW_Comment\']\" class=\"in-line\"><button class=\"btn btn-back btn-delete\" ng-click=\"allCommentsCtrl.deleteDraftComment($event, reply)\" ng-if=\"!reviewCtrl.readOnly && !(allCommentsCtrl.currentRole === \'Administrator\' && reply.status != \'Draft\' && (allCommentsCtrl.review.status == \'ReviewerCommented\' || allCommentsCtrl.review.status == \'SubmittedToAppraiser\' || allCommentsCtrl.review.status == \'ReviewerApproveValuation\')) && (reply.originalUserId == allCommentsCtrl.currentUserId || (!reply.originalUserId && reply.userId == allCommentsCtrl.currentUserId) || reply.originalUserRole == allCommentsCtrl.currentRole || (!reply.originalUserRole && reply.userRole == allCommentsCtrl.currentRole)) && allCommentsCtrl.currentRole != \'Appraiser\' && allCommentsCtrl.currentRole != \'Asset Manager\'\"><i class=\"icon icon-ic-trash-delete\"></i></button> <button class=\"btn btn-back btn-delete\" ng-if=\"reply.status == \'Draft\' && !reviewCtrl.readOnly\" td-security=\"[\'AssetManagement\', \'AssetAppraisal\', \'AssetManagerReadOnly\']\" action=\"display-none\" ng-click=\"allCommentsCtrl.deleteDraftComment($event, reply)\"><i class=\"icon icon-ic-trash-delete\"></i></button></div><div review-checker=\"allCommentsCtrl.review\" actions=\"[\'RW_Comment\', \'RW_Submit\', \'LRW_Comment\']\" class=\"in-line\"><button class=\"btn btn-back btn-delete\" ng-click=\"allCommentsCtrl.deleteComment($event, reply)\" ng-if=\"!reviewCtrl.readOnly && ((reply.originalUserId != allCommentsCtrl.currentUserId && !(!reply.originalUserId && reply.userId == allCommentsCtrl.currentUserId)) && (reply.originalUserRole != allCommentsCtrl.currentRole && !(!reply.originalUserRole && reply.userRole == allCommentsCtrl.currentRole)))\" td-security=\"[\'Admin\', \'AssetReview\']\" action=\"display-none\"><i class=\"icon icon-ic-trash-delete\"></i></button></div><br></div></div></div></div></div></div></div></perfect-scrollbar></div><div class=\"ibox-content fixed-height\" ng-if=\"allCommentsCtrl.review.status != \'Created\' && allCommentsCtrl.review.status != \'DocumentsUploaded\' && (!allCommentsCtrl.review.comments.comments || allCommentsCtrl.review.comments.comments.length == 0)\" td-security=\"[\'Admin\', \'Audit\', \'AssetManagement\', \'AssetReview\', \'AssetManagerReadOnly\']\" action=\"display-none\"><div class=\"first-comment empty-comment\" translate=\"COMMENT_STATES.EMPTY_COMMENT.NO_COMMENTS\"></div></div><div class=\"ibox-content fixed-height\" ng-if=\"allCommentsCtrl.review.status == \'Created\' || allCommentsCtrl.review.status == \'DocumentsUploaded\'\"><div class=\"first-comment empty-comment\" translate=\"COMMENT_STATES.EMPTY_COMMENT.NO_COMMENTS\"></div></div><div class=\"ibox-content fixed-height\" ng-if=\"allCommentsCtrl.review.status != \'Created\' && allCommentsCtrl.review.status != \'DocumentsUploaded\' && (!allCommentsCtrl.review.comments.comments || allCommentsCtrl.review.comments.comments.length == 0)\" td-security=\"[\'AssetAppraisal\']\" action=\"display-none\"><div class=\"first-comment empty-comment\" translate=\"COMMENT_STATES.EMPTY_COMMENT.NO_COMMENTS\"></div></div></div><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 text-right\"><div class=\"m-b-lg in-line\" td-security=\"[\'Admin\', \'AssetManagement\', \'AssetManagerReadOnly\']\" action=\"display-none\"><button ng-show=\"allCommentsCtrl.commentsInDraft || allCommentsCtrl.repliesInDraft\" class=\"btn btn-w-m btn-normal m-l-sm\" review-checker=\"allCommentsCtrl.review\" actions=\"[\'AM_Comment\']\" ng-click=\"allCommentsCtrl.managerSubmitToReviewer()\" ng-if=\"!reviewCtrl.readOnly\">{{\'DISCUSSION.BUTTONS.SUBMIT_TO_REVIEWER\' | translate}}</button> <button class=\"btn btn-w-m btn-green m-l-sm\" review-checker=\"allCommentsCtrl.review\" actions=\"[\'AM_Comment\']\" ng-show=\"!allCommentsCtrl.commentsInDraft && !allCommentsCtrl.repliesInDraft && ((allCommentsCtrl.review.statusChangedFrom == \'FormFilled\' && allCommentsCtrl.commentsInReview) || allCommentsCtrl.review.status == \'FormFilled\' || allCommentsCtrl.review.statusChangedFrom == \'DocumentsUploaded\')\" ng-click=\"allCommentsCtrl.managerAcknowledgeToReviewer()\" ng-if=\"!reviewCtrl.readOnly\">{{\'DISCUSSION.BUTTONS.ACKNOWLEDGE\' | translate}}</button> <button class=\"btn btn-w-m btn-green m-l-sm\" ng-click=\"allCommentsCtrl.managerApprove()\" review-checker=\"allCommentsCtrl.review\" actions=\"[\'AM_Approve\']\" ng-hide=\"allCommentsCtrl.repliesInDraft || allCommentsCtrl.commentsInDraft\" ng-if=\"!reviewCtrl.readOnly\"><i class=\"glyphicon glyphicon-ok m-r-sm\"></i> {{\'DISCUSSION.BUTTONS.APPROVE\' | translate}}</button></div><div class=\"m-b-lg in-line\" td-security=\"[\'Admin\', \'AssetReview\']\" action=\"display-none\"><button class=\"btn btn-w-m btn-normal m-l-sm\" review-checker=\"allCommentsCtrl.review\" actions=\"[\'RW_Comment\']\" ng-show=\"(allCommentsCtrl.review.status === \'FormFilled\' || allCommentsCtrl.review.status === \'ReviewerCommented\') && allCommentsCtrl.commentsInDraft\" ng-click=\"allCommentsCtrl.reviewerSubmitToManager()\" ng-if=\"!reviewCtrl.readOnly\">{{\'DISCUSSION.BUTTONS.SUBMIT_TO_ASSET_MANAGER\' | translate}}</button> <button class=\"btn btn-w-m btn-normal m-l-sm\" review-checker=\"allCommentsCtrl.review\" actions=\"[\'RW_SubmitToAppraiser\']\" ng-if=\"allCommentsCtrl.review.status == \'ManagerCommented\' && !allCommentsCtrl.rwCanApprove && (allCommentsCtrl.repliesInDraft || allCommentsCtrl.commentsInDraft || allCommentsCtrl.commentsInReview || allCommentsCtrl.repliesInReview) && !reviewCtrl.readOnly\" ng-hide=\"allCommentsCtrl.review.statusChangedBy.type === \'SecondaryAssetAppraiser\' || allCommentsCtrl.review.statusChangedBy.type === \'PrimaryAssetAppraiser\'\" ng-click=\"allCommentsCtrl.reviewerSubmitToAppraiser(true)\">{{\'DISCUSSION.BUTTONS.ACKNOWLEDGE_SUBMIT_TO_APPRAISER\' | translate}}</button> <button class=\"btn btn-w-m btn-normal m-l-sm\" review-checker=\"allCommentsCtrl.review\" actions=\"[\'RW_SubmitToAppraiser\']\" ng-if=\"allCommentsCtrl.review.status === \'ValuationUpdated\' && allCommentsCtrl.review.statusChangedWithAction == \'RW_Retract\' && !reviewCtrl.readOnly\" ng-show=\"!allCommentsCtrl.repliesInDraft && !allCommentsCtrl.commentsInDraft\" ng-click=\"allCommentsCtrl.reviewerReSubmitToAppraiser()\">{{\'DISCUSSION.BUTTONS.SUBMIT_TO_APPRAISER\' | translate}}</button> <button class=\"btn btn-w-m btn-normal m-l-sm\" review-checker=\"allCommentsCtrl.review\" actions=\"[\'RW_SubmitToAppraiser\']\" ng-if=\"allCommentsCtrl.review.status === \'ValuationUpdated\' && !reviewCtrl.readOnly\" ng-show=\"(allCommentsCtrl.repliesInDraft || allCommentsCtrl.commentsInDraft || !allCommentsCtrl.rwCanApprove) && !(allCommentsCtrl.review.statusChangedWithAction == \'RW_Retract\' && !allCommentsCtrl.repliesInDraft && !allCommentsCtrl.commentsInDraft )\" ng-click=\"allCommentsCtrl.reviewerSubmitToAppraiser(true)\">{{\'DISCUSSION.BUTTONS.SUBMIT_TO_APPRAISER\' | translate}}</button> <button class=\"btn btn-w-m btn-normal m-l-sm\" review-checker=\"allCommentsCtrl.review\" actions=\"[\'RW_Retract\']\" ng-click=\"allCommentsCtrl.reviewerRetract()\" ng-if=\"!reviewCtrl.readOnly\" ng-hide=\"(allCommentsCtrl.repliesInDraft || allCommentsCtrl.commentsInDraft)\">{{\'DISCUSSION.BUTTONS.RETRACT\' | translate}}</button> <button class=\"btn btn-w-m btn-normal m-l-sm\" review-checker=\"allCommentsCtrl.review\" actions=\"[\'LRW_Comment\']\" ng-show=\"allCommentsCtrl.repliesInDraft || allCommentsCtrl.commentsInDraft\" ng-click=\"allCommentsCtrl.leadReviewerSubmitToAppraiser()\" ng-if=\"!reviewCtrl.readOnly\">{{\'DISCUSSION.BUTTONS.SUBMIT_TO_APPRAISER\' | translate}}</button> <button class=\"btn btn-w-m btn-green m-l-sm\" ng-click=\"allCommentsCtrl.reviewerApprove()\" review-checker=\"allCommentsCtrl.review\" actions=\"[\'RW_Approve\']\" ng-hide=\"allCommentsCtrl.repliesInDraft || allCommentsCtrl.commentsInDraft\" ng-if=\"((allCommentsCtrl.review.status == \'ValuationUpdated\' || allCommentsCtrl.review.status == \'FormFilled\' || allCommentsCtrl.review.status == \'ManagerCommented\') && allCommentsCtrl.rwCanApprove) && allCommentsCtrl.review.statusChangedWithAction != \'RW_Retract\' && !reviewCtrl.readOnly\"><i class=\"glyphicon glyphicon-ok m-r-sm\"></i> {{\'DISCUSSION.BUTTONS.APPROVE\' | translate}}</button> <button class=\"btn btn-w-m btn-normal m-l-sm\" ng-click=\"allCommentsCtrl.leadReviewerSignOff()\" review-checker=\"allCommentsCtrl.review\" actions=\"[\'LRW_Approve\']\" ng-hide=\"allCommentsCtrl.repliesInDraft || allCommentsCtrl.commentsInDraft\" ng-if=\"!reviewCtrl.readOnly\">{{\'DISCUSSION.BUTTONS.SIGN_OFF\' | translate}}</button></div><div class=\"m-b-lg in-line\" td-security=\"[\'Admin\', \'AssetAppraisal\']\" action=\"display-none\"><button ng-if=\"(allCommentsCtrl.repliesInDraft || !allCommentsCtrl.review.comments.comments.length)&& !reviewCtrl.readOnly\" class=\"btn btn-w-m btn-normal m-l-sm\" review-checker=\"allCommentsCtrl.review\" actions=\"[\'AP_Reply\']\" ng-click=\"allCommentsCtrl.appraiserSubmitToReviewer()\">{{\'DISCUSSION.BUTTONS.SUBMIT_TO_REVIEWER\' | translate}}</button> <button ng-if=\"(allCommentsCtrl.repliesInDraft || !allCommentsCtrl.review.comments.comments.length)&& reviewCtrl.review.status === \'CommentsAnswered\' && !reviewCtrl.readOnly\" class=\"btn btn-w-m btn-normal m-l-sm\" review-checker=\"allCommentsCtrl.review\" actions=\"[\'AP_Submit\']\" ng-click=\"allCommentsCtrl.appraiserReSubmitToReviewer()\">{{\'DISCUSSION.BUTTONS.SUBMIT_TO_REVIEWER\' | translate}}</button></div></div></div></div>");
$templateCache.put("app/states/valuations/review/discussion/comment-states/create-new-comment/create-new-comment.html","<div class=\"col-lg-9 col-md-8 col-sm-8 col-xs-8 comments\"><form role=\"form\" name=\"addCommentCtrl.createCommentForm\" ng-submit=\"addCommentCtrl.createCommentForm.$valid && addCommentCtrl.validComment && addCommentCtrl.createComment(addCommentCtrl.comment)\" confirm-leave=\"\" novalidate=\"\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content fixed-height no-padding-left no-padding-right\"><div class=\"row no-margins\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><h3 class=\"m-b-xl\" translate=\"COMMENT_STATES.NEW_COMMENT.ADD_NEW_COMMENT\"></h3></div></div><hr><div class=\"row no-margins\"><div class=\"comment-type-wrapper col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div><span class=\"comment-type-title\" translate=\"COMMENT_STATES.NEW_COMMENT.COMMENT_TYPE\"></span></div><div class=\"comment-type\"><div class=\"btn-group\"><div class=\"radio-comment-wrapper\" ng-class=\"{\'invalid-option\': addCommentCtrl.comment.type == null && addCommentCtrl.createCommentForm.$submitted}\"><input type=\"radio\" ng-model=\"addCommentCtrl.comment.type\" value=\"General\" id=\"general\" name=\"general\" required=\"\"> <label class=\"comment-type\" for=\"general\" translate=\"COMMENT_STATES.NEW_COMMENT.GENERAL\"></label></div><div class=\"radio-comment-wrapper\" ng-class=\"{\'invalid-option\': addCommentCtrl.comment.type == null && addCommentCtrl.createCommentForm.$submitted}\"><input type=\"radio\" ng-model=\"addCommentCtrl.comment.type\" value=\"Argus\" id=\"argurs\" name=\"argus\" required=\"\"> <label class=\"comment-type\" for=\"argurs\" translate=\"COMMENT_STATES.NEW_COMMENT.ARGUS\"></label></div><div class=\"radio-comment-wrapper\" ng-class=\"{\'invalid-option\': addCommentCtrl.comment.type == null && addCommentCtrl.createCommentForm.$submitted}\"><input type=\"radio\" ng-model=\"addCommentCtrl.comment.type\" value=\"ValuationReport\" id=\"valuation\" name=\"valuation\" required=\"\"> <label class=\"comment-type\" for=\"valuation\" translate=\"COMMENT_STATES.NEW_COMMENT.VALUATION_REPORT\"></label></div><div class=\"radio-comment-wrapper\" ng-class=\"{\'invalid-option\': addCommentCtrl.comment.type == null && addCommentCtrl.createCommentForm.$submitted}\"><input type=\"radio\" ng-model=\"addCommentCtrl.comment.type\" value=\"ExecutiveSummary\" id=\"executive\" name=\"executive\" required=\"\"> <label class=\"comment-type\" for=\"executive\" translate=\"COMMENT_STATES.NEW_COMMENT.EXECUTIVE_SUMMARY\"></label></div></div></div></div></div><div class=\"row no-margins\"><div class=\"title-comment-wrapper col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div><span class=\"comment-title\" translate=\"COMMENT_STATES.NEW_COMMENT.TITLE\"></span></div><input class=\"comment-title-input form-control\" type=\"text\" ng-model=\"addCommentCtrl.comment.title\" translate=\"\" translate-attr-placeholder=\"COMMENT_STATES.NEW_COMMENT.ENTER_COMMENT_TITLE\" required=\"\"></div></div><div class=\"row no-margins\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding\"><text-angular ng-model=\"addCommentCtrl.comment.body\" ng-class=\"{\'invalid-field\': !addCommentCtrl.validComment && (addCommentCtrl.createCommentForm.$submitted || addCommentCtrl.touchedComment)}\"></text-angular></div></div></div></div><div class=\"row no-margins\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"text-right m-b-lg\"><button class=\"btn btn-w-m btn-back m-r\" translate=\"COMMONS.DISCARD\" ui-sref=\"app.review.discussion.comments\"></button> <button class=\"btn btn-w-m btn-normal\" type=\"submit\" translate=\"COMMENT_STATES.NEW_COMMENT.ADD_COMMENT\"></button></div></div></div></form></div>");
$templateCache.put("app/states/valuations/review/discussion/comment-states/edit-comment/edit-comment.html","<div class=\"col-lg-9 col-md-8 col-sm-8 col-xs-8 comments\"><form role=\"form\" name=\"editCommentCtrl.editCommentForm\" ng-submit=\"editCommentCtrl.editCommentForm.$valid && editCommentCtrl.validComment && editCommentCtrl.editComment(editCommentCtrl.comment, editCommentCtrl.reason)\" confirm-leave=\"\" novalidate=\"\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content fixed-height no-padding-left no-padding-right\"><div class=\"edit-comment\"><div class=\"row no-margins\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><h3 class=\"p-h-xs\">{{editCommentCtrl.commentsTitle[editCommentCtrl.comment.type]}} {{\'COMMENT_STATES.EDIT_COMMENT.COMMENT\' | translate}}</h3></div></div><div class=\"row no-margins\" ng-if=\"editCommentCtrl.comment.title\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 m-b-sm\"><span class=\"title\">{{\'COMMENT_STATES.TITLE\' | translate}}<strong>{{editCommentCtrl.comment.title}}</strong></span></div></div><div class=\"row no-margins\"><div class=\"col-lg-8 col-md-8 col-sm-8 col-xs-8 comment-submitter\"><span ng-if=\"editCommentCtrl.comment.originalUserId\" class=\"user m-r\" avatar=\"editCommentCtrl.users[editCommentCtrl.comment.originalUserId].name\" role=\"editCommentCtrl.comment.originalUserRole\"></span> <span ng-if=\"!editCommentCtrl.comment.originalUserId\" class=\"user m-r\" avatar=\"editCommentCtrl.users[editCommentCtrl.comment.userId].name\" role=\"editCommentCtrl.comment.userRole\"></span> <span ng-if=\"editCommentCtrl.comment.originalUserId\" class=\"name\">{{editCommentCtrl.users[editCommentCtrl.comment.originalUserId].name}}</span> <span ng-if=\"!editCommentCtrl.comment.originalUserId\" class=\"name\">{{editCommentCtrl.users[editCommentCtrl.comment.userId].name}}</span></div><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 text-right\"><div class=\"date\">{{(editCommentCtrl.comment.originalCommentTime || editCommentCtrl.comment.createdOn) | formatDate : \'MMM DD - h:mm a\'}}</div></div></div><hr><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><text-angular ng-model=\"editCommentCtrl.comment.body\" ng-class=\"{\'invalid-field\': !editCommentCtrl.validComment && (editCommentCtrl.editCommentForm.$submitted || editCommentCtrl.touchedComment)}\"></text-angular></div></div><div class=\"row no-margins edit-reason-wp\" ng-if=\"editCommentCtrl.needReason\" td-security=\"[\'Admin\', \'AssetReview\']\" action=\"display-none\"><div class=\"col-lg-10 col-md-10 col-sm-12 col-xs-12\"><span class=\"edit-reason-title\" translate=\"COMMENT_STATES.EDIT_COMMENT.PROVIDE_REASON\"></span> <input type=\"text\" class=\"edit-reason\" ng-model=\"editCommentCtrl.reason\" translate=\"\" ng-class=\"{\'invalid-field\': !editCommentCtrl.reason && editCommentCtrl.editCommentForm.$submitted}\" data-translate-attr-placeholder=\"COMMENT_STATES.EDIT_COMMENT.EDIT_REASON\" required=\"\"></div></div><div class=\"row no-margins\" ng-if=\"!reviewCtrl.readOnly && (editCommentCtrl.comment.originalUserId == editCommentCtrl.currentUserId || (!editCommentCtrl.comment.originalUserId && editCommentCtrl.comment.userId == editCommentCtrl.currentUserId) || editCommentCtrl.comment.originalUserRole == editCommentCtrl.allCommentsCtrl.currentRole || (!editCommentCtrl.comment.originalUserRole && editCommentCtrl.comment.userRole == editCommentCtrl.currentRole))\"><span class=\"delete-comment-btn\" ng-click=\"editCommentCtrl.deleteDraftComment(editCommentCtrl.comment)\" translate=\"COMMENT_STATES.EDIT_COMMENT.DELETE_COMMENT\"></span></div><div class=\"row no-margins\" ng-if=\"!reviewCtrl.readOnly && ((editCommentCtrl.comment.originalUserId != editCommentCtrl.currentUserId && !(!editCommentCtrl.comment.originalUserId && editCommentCtrl.comment.userId == editCommentCtrl.currentUserId)) && editCommentCtrl.comment.originalUserRole != editCommentCtrl.currentRole && !(!editCommentCtrl.comment.originalUserRole && editCommentCtrl.comment.userRole == editCommentCtrl.currentRole))\" td-security=\"[\'Admin\', \'AssetReview\']\" action=\"display-none\"><span class=\"delete-comment-btn\" ng-click=\"editCommentCtrl.deleteComment(editCommentCtrl.comment)\" translate=\"COMMENT_STATES.EDIT_COMMENT.DELETE_COMMENT\"></span></div></div></div></div><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"text-right m-b-lg\"><button class=\"btn btn-w-m btn-back m-r\" type=\"button\" translate=\"COMMONS.DISCARD\" ui-sref=\"app.review.discussion.comments\"></button> <button class=\"btn btn-w-m btn-normal\" type=\"submit\" translate=\"COMMONS.SAVE\"></button></div></div></div></form></div>");
$templateCache.put("app/states/valuations/review/discussion/comment-states/reply-comment/reply-comment.html","<div class=\"col-lg-9 col-md-8 col-sm-8 col-xs-8 comments\"><form role=\"form\" name=\"replyCommentCtrl.replyCommentForm\" ng-submit=\"replyCommentCtrl.replyCommentForm.$valid && replyCommentCtrl.validComment && replyCommentCtrl.replyComment(replyCommentCtrl.comment, replyCommentCtrl.reply)\" confirm-leave=\"\" novalidate=\"\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content fixed-height no-padding-bottom no-padding-left no-padding-right\"><perfect-scrollbar class=\"scroller\" wheel-propagation=\"true\" wheel-speed=\"1\" min-scrollbar-length=\"20\"><div class=\"reply-comment\"><div class=\"row no-margins\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><h3 class=\"p-h-xs\">{{replyCommentCtrl.commentsTitle[replyCommentCtrl.comment.type] + \' \' + (\'COMMENT_STATES.COMMENT\' | translate)}}</h3></div></div><div class=\"row no-margins\"><div class=\"col-lg-8 col-md-8 col-sm-8 col-xs-8 m-b-sm\"><span class=\"title\">{{\'COMMENT_STATES.TITLE\' | translate}} <strong>{{replyCommentCtrl.comment.title}}</strong></span></div></div><div class=\"row no-margins\"><div class=\"col-lg-8 col-md-8 col-sm-8 col-xs-8 comment-submitter\"><span ng-if=\"replyCommentCtrl.comment.originalUserId\" class=\"user m-r\" avatar=\"replyCommentCtrl.users[replyCommentCtrl.comment.originalUserId].name\" role=\"replyCommentCtrl.comment.originalUserRole\"></span> <span ng-if=\"!replyCommentCtrl.comment.originalUserId\" class=\"user m-r\" avatar=\"replyCommentCtrl.users[replyCommentCtrl.comment.userId].name\" role=\"replyCommentCtrl.comment.userRole\"></span> <span td-security=\"[\'Admin\', \'AssetReview\', \'AssetManagement\']\" ng-if=\"replyCommentCtrl.comment.originalUserId\" class=\"name\">{{replyCommentCtrl.users[replyCommentCtrl.comment.originalUserId].name}}</span> <span td-security=\"[\'Admin\', \'AssetReview\', \'AssetManagement\']\" ng-if=\"!replyCommentCtrl.comment.originalUserId\" class=\"name\">{{replyCommentCtrl.users[replyCommentCtrl.comment.userId].name}}</span></div><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 text-right\"><div class=\"date\">{{(replyCommentCtrl.comment.originalCommentTime || replyCommentCtrl.comment.submittedOn || replyCommentCtrl.comment.nms) | formatDate : \'MMM DD - h:mm a\'}}</div></div></div><hr><div class=\"comment-container\"><div class=\"row no-margins\"><div class=\"col-lg-10 col-md-10 col-sm-10 col-xs-10 comment-message\"><p ng-bind-html=\"replyCommentCtrl.comment.body\"></p></div></div><div class=\"row no-margins comment-reply\" ng-repeat=\"reply in replyCommentCtrl.comment.replies | orderBy:replyCommentCtrl.sortReplies\"><div class=\"col-lg-12\"><hr></div><div class=\"comment-submitter text-right f-l no-padding\"><span class=\"user\" ng-if=\"reply.originalUserId\" avatar=\"replyCommentCtrl.users[reply.originalUserId].name\" role=\"reply.originalUserRole\"></span> <span class=\"user\" ng-if=\"!reply.originalUserId\" avatar=\"replyCommentCtrl.users[reply.userId].name\" role=\"reply.userRole\"></span></div><div class=\"col-lg-9 col-md-9 col-sm-9 col-xs-9 no-padding\"><span ng-if=\"reply.originalUserId && replyCommentCtrl.displayNames(replyCommentCtrl.users[reply.originalUserId].name, replyCommentCtrl.users[replyCommentCtrl.reply.originalUserId].type)\">{{replyCommentCtrl.users[reply.originalUserId].name}}</span> <span ng-if=\"!reply.originalUserId && replyCommentCtrl.displayNames(replyCommentCtrl.users[reply.userId].name, reply.userRole)\">{{replyCommentCtrl.users[reply.userId].name}}</span> <span class=\"date\"><i class=\"icon icon-ic-clock\"></i> {{(reply.originalCommentTime || reply.submittedOn || reply.createdOn) | formatDate: \'MMM DD - h:mm a\'}}</span><p ng-bind-html=\"reply.body\"></p></div></div></div><div class=\"row no-margins\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 m-t-xl m-b-xl no-padding\"><text-angular ng-model=\"replyCommentCtrl.reply.body\" ng-class=\"{\'invalid-field\': !replyCommentCtrl.validComment && (replyCommentCtrl.replyCommentForm.$submitted || replyCommentCtrl.touchedComment)}\"></text-angular></div></div></div></perfect-scrollbar></div></div><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"text-right m-b-lg\"><button class=\"btn btn-w-m btn-back m-r\" type=\"button\" translate=\"COMMONS.DISCARD\" ui-sref=\"app.review.discussion.comments\"></button> <button class=\"btn btn-w-m btn-normal\" type=\"submit\" translate=\"COMMONS.SAVE\"></button></div></div></div></form></div>");
$templateCache.put("app/states/valuations/review/discussion/comment-states/view-comment/view-comment.html","<div class=\"col-lg-9 col-md-8 col-sm-8 col-xs-8 comments\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content fixed-height no-padding-bottom no-padding-left no-padding-right\"><perfect-scrollbar class=\"scroller\" wheel-propagation=\"true\" wheel-speed=\"1\" min-scrollbar-length=\"20\"><div class=\"view-comment\"><div class=\"back-btn-container\"><a class=\"btn btn-back\" ui-sref=\"app.review.discussion.comments\"><i class=\"icon icon-ic-icon-backburger\"></i>{{\'COMMONS.BACK\' | translate}}</a></div><div class=\"row no-margins\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><h3 class=\"p-h-xs\">{{viewCommentCtrl.commentsTitle[viewCommentCtrl.comment.type] + \' \' + (\'COMMENT_STATES.COMMENT\' | translate)}}</h3></div></div><div class=\"row no-margins\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 m-b-sm\"><span class=\"title\">{{\'COMMENT_STATES.VIEW_COMMENT.TITLE\' | translate}} <strong>{{viewCommentCtrl.comment.title}}</strong></span></div></div><div class=\"row no-margins\"><div class=\"col-lg-8 col-md-8 col-sm-8 col-xs-8 comment-submitter\"><span ng-if=\"viewCommentCtrl.comment.originalUserId\" class=\"user\" avatar=\"viewCommentCtrl.users[viewCommentCtrl.comment.originalUserId].name\" role=\"viewCommentCtrl.comment.originalUserRole\"></span> <span ng-if=\"!viewCommentCtrl.comment.originalUserId\" class=\"user\" avatar=\"viewCommentCtrl.users[viewCommentCtrl.comment.userId].name\" role=\"viewCommentCtrl.comment.userRole\"></span> <span td-security=\"[\'Admin\', \'AssetReview\', \'AssetManagement\', \'AssetManagerReadOnly\']\" ng-if=\"viewCommentCtrl.comment.originalUserId\" class=\"name\">{{viewCommentCtrl.users[viewCommentCtrl.comment.originalUserId].name}}</span> <span td-security=\"[\'Admin\', \'AssetReview\', \'AssetManagement\', \'AssetManagerReadOnly\']\" ng-if=\"!viewCommentCtrl.comment.originalUserId\" class=\"name\">{{viewCommentCtrl.users[viewCommentCtrl.comment.userId].name}}</span></div><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 text-right\"><div class=\"date\">{{( viewCommentCtrl.comment.originalCommentTime || viewCommentCtrl.comment.submittedOn || viewCommentCtrl.comment.nms) | formatDate: \'MMM DD - h:mm a\'}}</div></div></div><hr><div class=\"comment-container\"><div class=\"row no-margins\"><div class=\"col-lg-10 col-md-10 col-sm-10 col-xs-10 comment-message\"><p ng-bind-html=\"viewCommentCtrl.comment.body\"></p></div></div><div class=\"row no-margins comment-reply\" ng-repeat=\"reply in viewCommentCtrl.comment.replies | orderBy:viewCommentCtrl.sortReplies\"><div class=\"col-lg-12\"><hr></div><div class=\"comment-submitter text-right f-l no-padding\"><span ng-if=\"reply.originalUserId\" class=\"user\" avatar=\"viewCommentCtrl.users[reply.originalUserId].name\" role=\"reply.originalUserRole\"></span> <span ng-if=\"!reply.originalUserId\" class=\"user\" avatar=\"viewCommentCtrl.users[reply.userId].name\" role=\"reply.userRole\"></span></div><div class=\"col-lg-9 col-md-9 col-sm-9 col-xs-9 no-padding\"><span ng-if=\"reply.originalUserId && viewCommentCtrl.displayNames(viewCommentCtrl.users[reply.originalUserId].name, viewCommentCtrl.users[reply.originalUserId].type)\">{{viewCommentCtrl.users[reply.originalUserId].name}}</span> <span ng-if=\"!reply.originalUserId && viewCommentCtrl.displayNames(viewCommentCtrl.users[reply.userId].name, reply.userRole)\">{{viewCommentCtrl.users[reply.userId].name}}</span> <span class=\"date\"><i class=\"icon icon-ic-clock\"></i> {{(reply.originalCommentTime || reply.submittedOn || reply.createdOn) | formatDate: \'MMM DD - h:mm a\'}}</span><p ng-bind-html=\"reply.body\"></p></div></div></div><div class=\"row no-margins\" td-security=\"[\'Admin\', \'AssetManagement\', \'AssetReview\', \'AssetManagerReadOnly\']\" action=\"display-none\" ng-if=\"viewCommentCtrl.history.length > 0 || viewCommentCtrl.versions\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 m-b-sm\"><div class=\"title-versions\" translate=\"COMMENT_STATES.VIEW_COMMENT.VERSIONS\"></div></div></div><div class=\"version\" ng-repeat=\"version in viewCommentCtrl.history\" td-security=\"[\'Admin\', \'AssetManagement\', \'AssetReview\', \'AssetManagerReadOnly\']\" action=\"display-none\"><div class=\"row no-margins p-h-sm version-info\"><div class=\"col-lg-1 col-md-1 col-sm-1 col-xs-1 text-right\"><i class=\"icon icon-ic-clock\"></i></div><div class=\"col-lg-10 col-md-10 col-sm-10 col-xs-10\"><div class=\"title\">Comment modified {{version.modifiedDate | formatDate: \'MMM DD - h:mm a\'}}, by {{viewCommentCtrl.users[version.byUserId].name}}</div><div class=\"reason\"><span>Reason: {{version.amendingReason}}</span></div></div><div class=\"col-lg-1 col-md-1 col-sm-1 col-xs-1 text-center arrow-container\"><div class=\"arrow-content\"><span class=\"fa chevron\" ng-click=\"ViewCommentCtrl.versionExpanded = !ViewCommentCtrl.versionExpanded\" ng-class=\"{\'fa-chevron-up\': ViewCommentCtrl.versionExpanded, \'fa-chevron-down\': !ViewCommentCtrl.versionExpanded}\"></span></div></div></div><div class=\"row no-margins p-h-sm version-expanded\" ng-show=\"ViewCommentCtrl.versionExpanded\"><div class=\"col-lg-10 col-md-10 col-sm-10 col-xs-10 col-lg-offset-1 col-md-offset-1 col-sm-offset-1 col-xs-offset-1\"><p ng-bind-html=\"version.body\"></p></div></div></div><div class=\"replies-version\" ng-repeat=\"reply in viewCommentCtrl.comment.replies\" td-security=\"[\'Admin\', \'AssetManagement\', \'AssetReview\', \'AssetManagerReadOnly\']\" action=\"display-none\" ng-if=\"reply.repliesHistory\"><div class=\"row no-margins p-h-sm version-info\"><div class=\"col-lg-1 col-md-1 col-sm-1 col-xs-1 text-right\"><i class=\"icon icon-ic-reply-modified\"></i></div><div class=\"col-lg-11 col-md-11 col-sm-11 col-xs-11\"><div class=\"title\">Reply modified {{reply.createdOn | formatDate: \'MMM DD - h:mm a\'}}, by {{viewCommentCtrl.users[reply.userId].name}}</div><span>Reason: {{reply.amendingReason}}</span><div class=\"col-lg-1 col-md-1 col-sm-1 col-xs-1 text-center arrow-container\"><div class=\"arrow-content\"><span class=\"fa chevron\" ng-click=\"ViewCommentCtrl.versionExpanded = !ViewCommentCtrl.versionExpanded\" ng-class=\"{\'fa-chevron-up\': ViewCommentCtrl.versionExpanded, \'fa-chevron-down\': !ViewCommentCtrl.versionExpanded}\"></span></div></div></div><div class=\"row no-margins p-h-sm version-expanded\" ng-show=\"ViewCommentCtrl.versionExpanded\"><div class=\"col-lg-11 col-md-11 col-sm-11 col-xs-11 col-lg-offset-1 col-md-offset-1 col-sm-offset-1 col-xs-offset-1 version-padding-top\"><p ng-bind-html=\"reply.body\"></p></div><div class=\"col-lg-11 col-md-11 col-sm-11 col-xs-11 col-lg-offset-1 col-md-offset-1 col-sm-offset-1 col-xs-offset-1\"><hr class=\"reply-version-separator\"></div><div class=\"col-lg-11 col-md-11 col-sm-11 col-xs-11 col-lg-offset-1 col-md-offset-1 col-sm-offset-1 col-xs-offset-1 version-padding-top replies-body\" ng-repeat=\"version in reply.repliesHistory\"><p class=\"previous-version\" ng-bind-html=\"version.body\"></p></div></div></div></div></div></perfect-scrollbar></div></div></div>");}]);